/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://dy6157c944y9c.cloudfront.net/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var modules;
	
	__webpack_require__(5);
	
	__webpack_require__(1);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(33);
	
	__webpack_require__(35);
	
	__webpack_require__(37);
	
	__webpack_require__(39);
	
	__webpack_require__(58);
	
	__webpack_require__(68);
	
	__webpack_require__(269);
	
	__webpack_require__(308);
	
	__webpack_require__(320);
	
	__webpack_require__(327);
	
	__webpack_require__(350);
	
	__webpack_require__(443);
	
	__webpack_require__(452);
	
	__webpack_require__(517);
	
	__webpack_require__(534);
	
	__webpack_require__(547);
	
	__webpack_require__(487);
	
	__webpack_require__(571);
	
	__webpack_require__(534);
	
	__webpack_require__(547);
	
	__webpack_require__(487);
	
	__webpack_require__(603);
	
	__webpack_require__(613);
	
	__webpack_require__(624);
	
	__webpack_require__(626);
	
	__webpack_require__(632);
	
	__webpack_require__(637);
	
	__webpack_require__(647);
	
	__webpack_require__(681);
	
	__webpack_require__(394);
	
	__webpack_require__(844);
	
	modules = ['ngRoute', 'ngCookies', 'placeholderShim', 'gnp-translation', 'gnp-browser', 'gnp-app-title', 'gnp-analyze-access', 'gnp-app-session', 'gnp-app-paid-introduction', 'gnp-app-password', 'gnp-app-setting', 'gnp-app-registration', 'gnp-app-term', 'gnp-app-history', 'gnp-app-score-registration', 'gnp-app-dashboard', 'gnp-app-analysis', 'gnp-app-analysis-event', 'gnp-app-goal-settings', 'gnp-app-round-detail', 'gnp-app-friend', 'gnp-app-contact', 'gnp-app-policy', 'gnp-app-legal', 'gnp-app-email-confirmation', 'gnp-app-club', 'gnp-app-group', 'gnp-app-profile', 'gnp-truncate'];
	
	angular.module('gnp-app', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.otherwise({
	      redirectTo: '/'
	    });
	  }
	]).config([
	  '$httpProvider', function($httpProvider) {
	    return $httpProvider.defaults.headers.common['X-CSRF-Token'] = $('meta[name=csrf-token]').attr('content');
	  }
	]).config([
	  '$locationProvider', function($locationProvider) {
	    return $locationProvider.html5Mode(true);
	  }
	]).config([
	  '$cookiesProvider', function($cookiesProvider) {
	    return $cookiesProvider.defaults.secure = true;
	  }
	]);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["window"]["$"] = __webpack_require__(3);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["window"]["jQuery"] = __webpack_require__(4);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.6.4
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2023-03-08T15:28Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket trac-14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.6.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.10
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2023-02-14
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Make sure the the `:has()` argument is parsed unforgivingly.
		// We include `*` in the test to detect buggy implementations that are
		// _selectively_ forgiving (specifically when the list includes at least
		// one valid selector).
		// Note that we treat complete lack of support for `:has()` as if it were
		// spec-compliant support, which is fine because use of `:has()` in such
		// environments will fail in the qSA path and fall back to jQuery traversal
		// anyway.
		support.cssHas = assert( function() {
			try {
				document.querySelector( ":has(*,:jqfake)" );
				return false;
			} catch ( e ) {
				return true;
			}
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		if ( !support.cssHas ) {
	
			// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
			// Our regular `try-catch` mechanism fails to detect natively-unsupported
			// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
			// in browsers that parse the `:has()` argument as a forgiving selector list.
			// https://drafts.csswg.org/selectors/#relational now requires the argument
			// to be parsed unforgivingly, but browsers have not yet fully adjusted.
			rbuggyQSA.push( ":has" );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
	
				// Support: IE <9 only
				// IE doesn't have `contains` on `document` so we need to check for
				// `documentElement` presence.
				// We need to fall back to `a` when `documentElement` is missing
				// as `ownerDocument` of elements within `<template/>` may have
				// a null one - a default behavior of all modern browsers.
				var adown = a.nodeType === 9 && a.documentElement || a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE <10 only
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
		// Strict HTML recognition (trac-11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							// Support: Chrome 86+
							// In Chrome, if an element having a focusout handler is blurred by
							// clicking outside of it, it invokes the handler synchronously. If
							// that handler calls `.remove()` on the element, the data is cleared,
							// leaving `result` undefined. We need to guard against this.
							return result && result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function( event ) {
				return dataPriv.get( event.target, type );
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	
		rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
	
								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var rcustomProp = /^--/;
	
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	var whitespace = "[\\x20\\t\\r\\n\\f]";
	
	
	var rtrimCSS = new RegExp(
		"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
		"g"
	);
	
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is display: block
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			isCustomProp = rcustomProp.test( name ),
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if ( computed ) {
	
			// Support: IE <=9 - 11+
			// IE only supports `"float"` in `getPropertyValue`; in computed styles
			// it's only available as `"cssFloat"`. We no longer modify properties
			// sent to `.css()` apart from camelCasing, so we need to check both.
			// Normally, this would create difference in behavior: if
			// `getPropertyValue` returns an empty string, the value returned
			// by `.css()` would be `undefined`. This is usually the case for
			// disconnected elements. However, in IE even disconnected elements
			// with no styles return `"none"` for `getPropertyValue( "float" )`
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( isCustomProp && ret ) {
	
				// Support: Firefox 105+, Chrome <=105+
				// Spec requires trimming whitespace for custom properties (gh-4926).
				// Firefox only trims leading whitespace. Chrome just collapses
				// both leading & trailing whitespace to a single space.
				//
				// Fall back to `undefined` if empty string returned.
				// This collapses a missing definition with property defined
				// and set to an empty string but there's no standard API
				// allowing us to differentiate them without a performance penalty
				// and returning `undefined` aligns with older jQuery.
				//
				// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace( rtrimCSS, "$1" ) || undefined;
			}
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug trac-9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (trac-7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
							if ( cur.indexOf( " " + className + " " ) < 0 ) {
								cur += className + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
	
					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
	
							// Remove *all* instances
							while ( cur.indexOf( " " + className + " " ) > -1 ) {
								cur = cur.replace( " " + className + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var classNames, className, i, self,
				type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			classNames = classesToArray( value );
	
			return this.each( function() {
				if ( isValidValue ) {
	
					// Toggle individual class names
					self = jQuery( this );
	
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (trac-14686, trac-14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// trac-7653, trac-8125, trac-8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes trac-9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// trac-1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see trac-8605, trac-14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	// Require that the "whitespace run" starts from a non-whitespace
	// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "$1" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (trac-13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(6);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/app.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/app.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "/*!\n * Bootstrap v4.6.2 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Copyright 2011-2022 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */:root{--blue:#007bff;--indigo:#6610f2;--purple:#6f42c1;--pink:#e83e8c;--red:#dc3545;--orange:#fd7e14;--yellow:#ffc107;--green:#28a745;--teal:#20c997;--cyan:#17a2b8;--white:#fff;--gray:#6c757d;--gray-dark:#343a40;--primary:#007bff;--secondary:#6c757d;--success:#28a745;--info:#17a2b8;--warning:#ffc107;--danger:#dc3545;--light:#f8f9fa;--dark:#343a40;--breakpoint-xs:0;--breakpoint-sm:576px;--breakpoint-md:768px;--breakpoint-lg:992px;--breakpoint-xl:1200px;--font-family-sans-serif:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}*,*::before,*::after{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}article,aside,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-weight:400;line-height:1.5;text-align:left;background-color:#fff}[tabindex=\"-1\"]:focus:not(:focus-visible){outline:0!important}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6,p{margin-top:0}p{margin-bottom:1rem}abbr[title],abbr[data-original-title]{text-decoration:underline dotted;cursor:help;border-bottom:0;text-decoration-skip-ink:none}address{margin-bottom:1rem;font-style:normal;line-height:inherit}ol,ul,dl{margin-top:0;margin-bottom:1rem}ol ol,ul ul,ol ul,ul ol{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}b,strong{font-weight:bolder}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#007bff;text-decoration:none;background-color:transparent}a:hover{color:#0056b3;text-decoration:underline}a:not([href]):not([class]){color:inherit;text-decoration:none}a:not([href]):not([class]):hover{color:inherit;text-decoration:none}pre,code,kbd,samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}samp{font-size:1em}pre{margin-top:0;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}figure{margin:0 0 1rem}img{border-style:none}img,svg{vertical-align:middle}svg{overflow:hidden}table{border-collapse:collapse}caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}th{text-align:inherit;text-align:-webkit-match-parent}label{display:inline-block;margin-bottom:.5rem}button{border-radius:0}button:focus:not(:focus-visible){outline:0}input,button,select,optgroup,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[role=\"button\"]{cursor:pointer}select{word-wrap:normal}button,[type=\"button\"],[type=\"reset\"],[type=\"submit\"]{-webkit-appearance:button}button:not(:disabled),[type=\"button\"]:not(:disabled),[type=\"reset\"]:not(:disabled),[type=\"submit\"]:not(:disabled){cursor:pointer}button::-moz-focus-inner,[type=\"button\"]::-moz-focus-inner,[type=\"reset\"]::-moz-focus-inner,[type=\"submit\"]::-moz-focus-inner{padding:0;border-style:none}input[type=\"radio\"],input[type=\"checkbox\"]{box-sizing:border-box;padding:0}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=\"number\"]::-webkit-inner-spin-button,[type=\"number\"]::-webkit-outer-spin-button{height:auto}[type=\"search\"]{outline-offset:-2px;-webkit-appearance:none}[type=\"search\"]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}h1,h2,h3,h4,h5,h6,.h1,.h2,.h3,.h4,.h5,.h6{margin-bottom:.5rem;font-weight:500;line-height:1.2}h1,.h1{font-size:2.5rem}h2,.h2{font-size:2rem}h3,.h3{font-size:1.75rem}h4,.h4{font-size:1.5rem}h5,.h5{font-size:1.25rem}h6,.h6{font-size:1rem}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:6rem}.display-1,.display-2{font-weight:300;line-height:1.2}.display-2{font-size:5.5rem}.display-3{font-size:4.5rem}.display-3,.display-4{font-weight:300;line-height:1.2}.display-4{font-size:3.5rem}hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}small,.small{font-size:.875em;font-weight:400}mark,.mark{padding:.2em;background-color:#fcf8e3}.list-unstyled,.list-inline{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:.5rem}.initialism{font-size:90%;text-transform:uppercase}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote-footer{display:block;font-size:.875em;color:#6c757d}.blockquote-footer::before{content:\"\\2014\\00A0\"}.img-fluid,.img-thumbnail{max-width:100%;height:auto}.img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#6c757d}code{font-size:87.5%;color:#e83e8c;word-wrap:break-word}a>code{color:inherit}kbd{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd{padding:0;font-size:100%;font-weight:700}pre{display:block;font-size:87.5%;color:#212529}pre code{font-size:inherit;color:inherit;word-break:normal}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{width:100%;margin-right:auto;margin-left:auto}.container-fluid,.container-sm,.container-md,.container-lg,.container-xl{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container,.container-sm{max-width:540px}}@media (min-width:768px){.container,.container-sm,.container-md{max-width:720px}}@media (min-width:992px){.container,.container-sm,.container-md,.container-lg{max-width:960px}}@media (min-width:1200px){.container,.container-sm,.container-md,.container-lg,.container-xl{max-width:1140px}}.row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=\"col-\"]{padding-right:0;padding-left:0}.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col,.col-auto,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm,.col-sm-auto,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md,.col-md-auto,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg,.col-lg-auto,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl,.col-xl-auto{position:relative;width:100%;padding-right:15px;padding-left:15px}.col{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-3>*{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.row-cols-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-6>*{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.col-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-1{-ms-flex:0 0 8.33333%;flex:0 0 8.33333%;max-width:8.33333%}.col-2{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.col-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-4{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.col-5{-ms-flex:0 0 41.66667%;flex:0 0 41.66667%;max-width:41.66667%}.col-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-7{-ms-flex:0 0 58.33333%;flex:0 0 58.33333%;max-width:58.33333%}.col-8{-ms-flex:0 0 66.66667%;flex:0 0 66.66667%;max-width:66.66667%}.col-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-10{-ms-flex:0 0 83.33333%;flex:0 0 83.33333%;max-width:83.33333%}.col-11{-ms-flex:0 0 91.66667%;flex:0 0 91.66667%;max-width:91.66667%}.col-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-first{-ms-flex-order:-1;order:-1}.order-last{-ms-flex-order:13;order:13}.order-0{-ms-flex-order:0;order:0}.order-1{-ms-flex-order:1;order:1}.order-2{-ms-flex-order:2;order:2}.order-3{-ms-flex-order:3;order:3}.order-4{-ms-flex-order:4;order:4}.order-5{-ms-flex-order:5;order:5}.order-6{-ms-flex-order:6;order:6}.order-7{-ms-flex-order:7;order:7}.order-8{-ms-flex-order:8;order:8}.order-9{-ms-flex-order:9;order:9}.order-10{-ms-flex-order:10;order:10}.order-11{-ms-flex-order:11;order:11}.order-12{-ms-flex-order:12;order:12}.offset-1{margin-left:8.33333%}.offset-2{margin-left:16.66667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.33333%}.offset-5{margin-left:41.66667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.33333%}.offset-8{margin-left:66.66667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.33333%}.offset-11{margin-left:91.66667%}@media (min-width:576px){.col-sm{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-sm-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-sm-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-sm-3>*{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.row-cols-sm-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-sm-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-sm-6>*{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.col-sm-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-sm-1{-ms-flex:0 0 8.33333%;flex:0 0 8.33333%;max-width:8.33333%}.col-sm-2{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.col-sm-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-sm-4{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.col-sm-5{-ms-flex:0 0 41.66667%;flex:0 0 41.66667%;max-width:41.66667%}.col-sm-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-sm-7{-ms-flex:0 0 58.33333%;flex:0 0 58.33333%;max-width:58.33333%}.col-sm-8{-ms-flex:0 0 66.66667%;flex:0 0 66.66667%;max-width:66.66667%}.col-sm-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-sm-10{-ms-flex:0 0 83.33333%;flex:0 0 83.33333%;max-width:83.33333%}.col-sm-11{-ms-flex:0 0 91.66667%;flex:0 0 91.66667%;max-width:91.66667%}.col-sm-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-sm-first{-ms-flex-order:-1;order:-1}.order-sm-last{-ms-flex-order:13;order:13}.order-sm-0{-ms-flex-order:0;order:0}.order-sm-1{-ms-flex-order:1;order:1}.order-sm-2{-ms-flex-order:2;order:2}.order-sm-3{-ms-flex-order:3;order:3}.order-sm-4{-ms-flex-order:4;order:4}.order-sm-5{-ms-flex-order:5;order:5}.order-sm-6{-ms-flex-order:6;order:6}.order-sm-7{-ms-flex-order:7;order:7}.order-sm-8{-ms-flex-order:8;order:8}.order-sm-9{-ms-flex-order:9;order:9}.order-sm-10{-ms-flex-order:10;order:10}.order-sm-11{-ms-flex-order:11;order:11}.order-sm-12{-ms-flex-order:12;order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.33333%}.offset-sm-2{margin-left:16.66667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.33333%}.offset-sm-5{margin-left:41.66667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.33333%}.offset-sm-8{margin-left:66.66667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.33333%}.offset-sm-11{margin-left:91.66667%}}@media (min-width:768px){.col-md{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-md-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-md-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-md-3>*{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.row-cols-md-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-md-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-md-6>*{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.col-md-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-md-1{-ms-flex:0 0 8.33333%;flex:0 0 8.33333%;max-width:8.33333%}.col-md-2{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.col-md-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-md-4{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.col-md-5{-ms-flex:0 0 41.66667%;flex:0 0 41.66667%;max-width:41.66667%}.col-md-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-md-7{-ms-flex:0 0 58.33333%;flex:0 0 58.33333%;max-width:58.33333%}.col-md-8{-ms-flex:0 0 66.66667%;flex:0 0 66.66667%;max-width:66.66667%}.col-md-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-md-10{-ms-flex:0 0 83.33333%;flex:0 0 83.33333%;max-width:83.33333%}.col-md-11{-ms-flex:0 0 91.66667%;flex:0 0 91.66667%;max-width:91.66667%}.col-md-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-md-first{-ms-flex-order:-1;order:-1}.order-md-last{-ms-flex-order:13;order:13}.order-md-0{-ms-flex-order:0;order:0}.order-md-1{-ms-flex-order:1;order:1}.order-md-2{-ms-flex-order:2;order:2}.order-md-3{-ms-flex-order:3;order:3}.order-md-4{-ms-flex-order:4;order:4}.order-md-5{-ms-flex-order:5;order:5}.order-md-6{-ms-flex-order:6;order:6}.order-md-7{-ms-flex-order:7;order:7}.order-md-8{-ms-flex-order:8;order:8}.order-md-9{-ms-flex-order:9;order:9}.order-md-10{-ms-flex-order:10;order:10}.order-md-11{-ms-flex-order:11;order:11}.order-md-12{-ms-flex-order:12;order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.33333%}.offset-md-2{margin-left:16.66667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.33333%}.offset-md-5{margin-left:41.66667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.33333%}.offset-md-8{margin-left:66.66667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.33333%}.offset-md-11{margin-left:91.66667%}}@media (min-width:992px){.col-lg{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-lg-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-lg-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-lg-3>*{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.row-cols-lg-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-lg-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-lg-6>*{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.col-lg-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-lg-1{-ms-flex:0 0 8.33333%;flex:0 0 8.33333%;max-width:8.33333%}.col-lg-2{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.col-lg-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-lg-4{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.col-lg-5{-ms-flex:0 0 41.66667%;flex:0 0 41.66667%;max-width:41.66667%}.col-lg-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-lg-7{-ms-flex:0 0 58.33333%;flex:0 0 58.33333%;max-width:58.33333%}.col-lg-8{-ms-flex:0 0 66.66667%;flex:0 0 66.66667%;max-width:66.66667%}.col-lg-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-lg-10{-ms-flex:0 0 83.33333%;flex:0 0 83.33333%;max-width:83.33333%}.col-lg-11{-ms-flex:0 0 91.66667%;flex:0 0 91.66667%;max-width:91.66667%}.col-lg-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-lg-first{-ms-flex-order:-1;order:-1}.order-lg-last{-ms-flex-order:13;order:13}.order-lg-0{-ms-flex-order:0;order:0}.order-lg-1{-ms-flex-order:1;order:1}.order-lg-2{-ms-flex-order:2;order:2}.order-lg-3{-ms-flex-order:3;order:3}.order-lg-4{-ms-flex-order:4;order:4}.order-lg-5{-ms-flex-order:5;order:5}.order-lg-6{-ms-flex-order:6;order:6}.order-lg-7{-ms-flex-order:7;order:7}.order-lg-8{-ms-flex-order:8;order:8}.order-lg-9{-ms-flex-order:9;order:9}.order-lg-10{-ms-flex-order:10;order:10}.order-lg-11{-ms-flex-order:11;order:11}.order-lg-12{-ms-flex-order:12;order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.33333%}.offset-lg-2{margin-left:16.66667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.33333%}.offset-lg-5{margin-left:41.66667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.33333%}.offset-lg-8{margin-left:66.66667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.33333%}.offset-lg-11{margin-left:91.66667%}}@media (min-width:1200px){.col-xl{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-xl-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-xl-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-xl-3>*{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.row-cols-xl-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-xl-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-xl-6>*{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.col-xl-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-xl-1{-ms-flex:0 0 8.33333%;flex:0 0 8.33333%;max-width:8.33333%}.col-xl-2{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.col-xl-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-xl-4{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.col-xl-5{-ms-flex:0 0 41.66667%;flex:0 0 41.66667%;max-width:41.66667%}.col-xl-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-xl-7{-ms-flex:0 0 58.33333%;flex:0 0 58.33333%;max-width:58.33333%}.col-xl-8{-ms-flex:0 0 66.66667%;flex:0 0 66.66667%;max-width:66.66667%}.col-xl-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-xl-10{-ms-flex:0 0 83.33333%;flex:0 0 83.33333%;max-width:83.33333%}.col-xl-11{-ms-flex:0 0 91.66667%;flex:0 0 91.66667%;max-width:91.66667%}.col-xl-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-xl-first{-ms-flex-order:-1;order:-1}.order-xl-last{-ms-flex-order:13;order:13}.order-xl-0{-ms-flex-order:0;order:0}.order-xl-1{-ms-flex-order:1;order:1}.order-xl-2{-ms-flex-order:2;order:2}.order-xl-3{-ms-flex-order:3;order:3}.order-xl-4{-ms-flex-order:4;order:4}.order-xl-5{-ms-flex-order:5;order:5}.order-xl-6{-ms-flex-order:6;order:6}.order-xl-7{-ms-flex-order:7;order:7}.order-xl-8{-ms-flex-order:8;order:8}.order-xl-9{-ms-flex-order:9;order:9}.order-xl-10{-ms-flex-order:10;order:10}.order-xl-11{-ms-flex-order:11;order:11}.order-xl-12{-ms-flex-order:12;order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.33333%}.offset-xl-2{margin-left:16.66667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.33333%}.offset-xl-5{margin-left:41.66667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.33333%}.offset-xl-8{margin-left:66.66667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.33333%}.offset-xl-11{margin-left:91.66667%}}.table{width:100%;margin-bottom:1rem;color:#212529}.table th,.table td{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table-sm th,.table-sm td{padding:.3rem}.table-bordered,.table-bordered th,.table-bordered td{border:1px solid #dee2e6}.table-bordered thead th,.table-bordered thead td{border-bottom-width:2px}.table-borderless th,.table-borderless td,.table-borderless thead th,.table-borderless tbody+tbody{border:0}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-hover tbody tr:hover{color:#212529;background-color:rgba(0,0,0,.075)}.table-primary,.table-primary>th,.table-primary>td{background-color:#b8daff}.table-primary th,.table-primary td,.table-primary thead th,.table-primary tbody+tbody{border-color:#7abaff}.table-hover .table-primary:hover,.table-hover .table-primary:hover>td,.table-hover .table-primary:hover>th{background-color:#9fcdff}.table-secondary,.table-secondary>th,.table-secondary>td{background-color:#d6d8db}.table-secondary th,.table-secondary td,.table-secondary thead th,.table-secondary tbody+tbody{border-color:#b3b7bb}.table-hover .table-secondary:hover,.table-hover .table-secondary:hover>td,.table-hover .table-secondary:hover>th{background-color:#c8cbcf}.table-success,.table-success>th,.table-success>td{background-color:#c3e6cb}.table-success th,.table-success td,.table-success thead th,.table-success tbody+tbody{border-color:#8fd19e}.table-hover .table-success:hover,.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#b1dfbb}.table-info,.table-info>th,.table-info>td{background-color:#bee5eb}.table-info th,.table-info td,.table-info thead th,.table-info tbody+tbody{border-color:#86cfda}.table-hover .table-info:hover,.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#abdde5}.table-warning,.table-warning>th,.table-warning>td{background-color:#ffeeba}.table-warning th,.table-warning td,.table-warning thead th,.table-warning tbody+tbody{border-color:#ffdf7e}.table-hover .table-warning:hover,.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#ffe8a1}.table-danger,.table-danger>th,.table-danger>td{background-color:#f5c6cb}.table-danger th,.table-danger td,.table-danger thead th,.table-danger tbody+tbody{border-color:#ed969e}.table-hover .table-danger:hover,.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#f1b0b7}.table-light,.table-light>th,.table-light>td{background-color:#fdfdfe}.table-light th,.table-light td,.table-light thead th,.table-light tbody+tbody{border-color:#fbfcfc}.table-hover .table-light:hover,.table-hover .table-light:hover>td,.table-hover .table-light:hover>th{background-color:#ececf6}.table-dark,.table-dark>th,.table-dark>td{background-color:#c6c8ca}.table-dark tbody+tbody{border-color:#95999c}.table-hover .table-dark:hover,.table-hover .table-dark:hover>td,.table-hover .table-dark:hover>th{background-color:#b9bbbe}.table-active,.table-active>th,.table-active>td{background-color:rgba(0,0,0,.075)}.table-hover .table-active:hover,.table-hover .table-active:hover>td,.table-hover .table-active:hover>th{background-color:rgba(0,0,0,.075)}.table .thead-dark th{color:#fff;background-color:#343a40;border-color:#454d55}.table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark{color:#fff;background-color:#343a40}.table-dark th,.table-dark td,.table-dark thead th{border-color:#454d55}.table-dark.table-bordered{border:0}.table-dark.table-striped tbody tr:nth-of-type(odd){background-color:rgba(255,255,255,.05)}.table-dark.table-hover tbody tr:hover{color:#fff;background-color:rgba(255,255,255,.075)}@media (max-width:575.98px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-sm>.table-bordered{border:0}}@media (max-width:767.98px){.table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-md>.table-bordered{border:0}}@media (max-width:991.98px){.table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-lg>.table-bordered{border:0}}@media (max-width:1199.98px){.table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-xl>.table-bordered{border:0}}.table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive>.table-bordered{border:0}.form-control{display:block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control{transition:none}}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.form-control::-webkit-input-placeholder{color:#6c757d;opacity:1}.form-control:-ms-input-placeholder{color:#6c757d;opacity:1}.form-control::placeholder{color:#6c757d;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#e9ecef;opacity:1}input[type=\"date\"].form-control,input[type=\"time\"].form-control,input[type=\"datetime-local\"].form-control,input[type=\"month\"].form-control{-webkit-appearance:none;-moz-appearance:none;appearance:none}select.form-control:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.form-control-file,.form-control-range{display:block;width:100%}.col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.form-control-plaintext{display:block;width:100%;padding:.375rem 0;margin-bottom:0;font-size:1rem;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-sm,.form-control-plaintext.form-control-lg{padding-right:0;padding-left:0}.form-control-sm{height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.form-control-lg{height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}select.form-control[size],select.form-control[multiple],textarea.form-control{height:auto}.form-group{margin-bottom:1rem}.form-text{display:block;margin-top:.25rem}.form-row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.form-row>.col,.form-row>[class*=\"col-\"]{padding-right:5px;padding-left:5px}.form-check{position:relative;display:block;padding-left:1.25rem}.form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.form-check-input[disabled]~.form-check-label,.form-check-input:disabled~.form-check-label{color:#6c757d}.form-check-label{margin-bottom:0}.form-check-inline{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;padding-left:0;margin-right:.75rem}.form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#28a745}.valid-tooltip{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(40,167,69,.9);border-radius:.25rem}.form-row>.col>.valid-tooltip,.form-row>[class*=\"col-\"]>.valid-tooltip{left:5px}.was-validated :valid~.valid-feedback,.was-validated :valid~.valid-tooltip,.is-valid~.valid-feedback,.is-valid~.valid-tooltip{display:block}.was-validated .form-control:valid,.form-control.is-valid{border-color:#28a745;padding-right:calc(1.5em + .75rem)!important;background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem)center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.was-validated .form-control:valid:focus,.form-control.is-valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.was-validated select.form-control:valid,select.form-control.is-valid{padding-right:3rem!important;background-position:right 1.5rem center}.was-validated textarea.form-control:valid,textarea.form-control.is-valid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem)right calc(.375em + .1875rem)}.was-validated .custom-select:valid,.custom-select.is-valid{border-color:#28a745;padding-right:calc(.75em + 2.3125rem)!important;background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat,#fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem)no-repeat}.was-validated .custom-select:valid:focus,.custom-select.is-valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.was-validated .form-check-input:valid~.form-check-label,.form-check-input.is-valid~.form-check-label{color:#28a745}.was-validated .form-check-input:valid~.valid-feedback,.was-validated .form-check-input:valid~.valid-tooltip,.form-check-input.is-valid~.valid-feedback,.form-check-input.is-valid~.valid-tooltip{display:block}.was-validated .custom-control-input:valid~.custom-control-label,.custom-control-input.is-valid~.custom-control-label{color:#28a745}.was-validated .custom-control-input:valid~.custom-control-label::before,.custom-control-input.is-valid~.custom-control-label::before{border-color:#28a745}.was-validated .custom-control-input:valid:checked~.custom-control-label::before,.custom-control-input.is-valid:checked~.custom-control-label::before{border-color:#34ce57;background-color:#34ce57}.was-validated .custom-control-input:valid:focus~.custom-control-label::before,.custom-control-input.is-valid:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.was-validated .custom-control-input:valid:focus:not(:checked)~.custom-control-label::before,.custom-control-input.is-valid:focus:not(:checked)~.custom-control-label::before{border-color:#28a745}.was-validated .custom-file-input:valid~.custom-file-label,.custom-file-input.is-valid~.custom-file-label{border-color:#28a745}.was-validated .custom-file-input:valid:focus~.custom-file-label,.custom-file-input.is-valid:focus~.custom-file-label{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545}.invalid-tooltip{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.form-row>.col>.invalid-tooltip,.form-row>[class*=\"col-\"]>.invalid-tooltip{left:5px}.was-validated :invalid~.invalid-feedback,.was-validated :invalid~.invalid-tooltip,.is-invalid~.invalid-feedback,.is-invalid~.invalid-tooltip{display:block}.was-validated .form-control:invalid,.form-control.is-invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem)!important;background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem)center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.was-validated .form-control:invalid:focus,.form-control.is-invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.was-validated select.form-control:invalid,select.form-control.is-invalid{padding-right:3rem!important;background-position:right 1.5rem center}.was-validated textarea.form-control:invalid,textarea.form-control.is-invalid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem)right calc(.375em + .1875rem)}.was-validated .custom-select:invalid,.custom-select.is-invalid{border-color:#dc3545;padding-right:calc(.75em + 2.3125rem)!important;background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat,#fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem)no-repeat}.was-validated .custom-select:invalid:focus,.custom-select.is-invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.was-validated .form-check-input:invalid~.form-check-label,.form-check-input.is-invalid~.form-check-label{color:#dc3545}.was-validated .form-check-input:invalid~.invalid-feedback,.was-validated .form-check-input:invalid~.invalid-tooltip,.form-check-input.is-invalid~.invalid-feedback,.form-check-input.is-invalid~.invalid-tooltip{display:block}.was-validated .custom-control-input:invalid~.custom-control-label,.custom-control-input.is-invalid~.custom-control-label{color:#dc3545}.was-validated .custom-control-input:invalid~.custom-control-label::before,.custom-control-input.is-invalid~.custom-control-label::before{border-color:#dc3545}.was-validated .custom-control-input:invalid:checked~.custom-control-label::before,.custom-control-input.is-invalid:checked~.custom-control-label::before{border-color:#e4606d;background-color:#e4606d}.was-validated .custom-control-input:invalid:focus~.custom-control-label::before,.custom-control-input.is-invalid:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.was-validated .custom-control-input:invalid:focus:not(:checked)~.custom-control-label::before,.custom-control-input.is-invalid:focus:not(:checked)~.custom-control-label::before{border-color:#dc3545}.was-validated .custom-file-input:invalid~.custom-file-label,.custom-file-input.is-invalid~.custom-file-label{border-color:#dc3545}.was-validated .custom-file-input:invalid:focus~.custom-file-label,.custom-file-input.is-invalid:focus~.custom-file-label{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-inline{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center}.form-inline .form-check{width:100%}@media (min-width:576px){.form-inline label{-ms-flex-pack:center;justify-content:center}.form-inline label,.form-inline .form-group{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin-bottom:0}.form-inline .form-group{-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-flow:row wrap;flex-flow:row wrap}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-plaintext{display:inline-block}.form-inline .input-group,.form-inline .custom-select{width:auto}.form-inline .form-check{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-left:0}.form-inline .form-check-input{position:relative;-ms-flex-negative:0;flex-shrink:0;margin-top:0;margin-right:.25rem;margin-left:0}.form-inline .custom-control{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.form-inline .custom-control-label{margin-bottom:0}}.btn{display:inline-block;font-weight:400;color:#212529;text-align:center;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn{transition:none}}.btn:hover{color:#212529;text-decoration:none}.btn:focus,.btn.focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.btn.disabled,.btn:disabled{opacity:.65}.btn:not(:disabled):not(.disabled){cursor:pointer}a.btn.disabled,fieldset:disabled a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}.btn-primary:focus,.btn-primary.focus{color:#fff;background-color:#0069d9;border-color:#0062cc;box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.btn-primary.disabled,.btn-primary:disabled{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:not(:disabled):not(.disabled):active,.btn-primary:not(:disabled):not(.disabled).active,.show>.btn-primary.dropdown-toggle{color:#fff;background-color:#0062cc;border-color:#005cbf}.btn-primary:not(:disabled):not(.disabled):active:focus,.btn-primary:not(:disabled):not(.disabled).active:focus,.show>.btn-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.btn-secondary{background-color:#6c757d}.btn-secondary:hover{color:#fff;background-color:#5a6268;border-color:#545b62}.btn-secondary:focus,.btn-secondary.focus{background-color:#5a6268;box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.btn-secondary.disabled,.btn-secondary:disabled{background-color:#6c757d}.btn-secondary:not(:disabled):not(.disabled):active,.btn-secondary:not(:disabled):not(.disabled).active,.show>.btn-secondary.dropdown-toggle{background-color:#545b62}.btn-secondary:not(:disabled):not(.disabled):active:focus,.btn-secondary:not(:disabled):not(.disabled).active:focus,.show>.btn-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.btn-success{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:hover{color:#fff;background-color:#218838;border-color:#1e7e34}.btn-success:focus,.btn-success.focus{color:#fff;background-color:#218838;border-color:#1e7e34;box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.btn-success.disabled,.btn-success:disabled{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:not(:disabled):not(.disabled):active,.btn-success:not(:disabled):not(.disabled).active,.show>.btn-success.dropdown-toggle{color:#fff;background-color:#1e7e34;border-color:#1c7430}.btn-success:not(:disabled):not(.disabled):active:focus,.btn-success:not(:disabled):not(.disabled).active:focus,.show>.btn-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.btn-info{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:hover{color:#fff;background-color:#138496;border-color:#117a8b}.btn-info:focus,.btn-info.focus{color:#fff;background-color:#138496;border-color:#117a8b;box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.btn-info.disabled,.btn-info:disabled{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:not(:disabled):not(.disabled):active,.btn-info:not(:disabled):not(.disabled).active,.show>.btn-info.dropdown-toggle{color:#fff;background-color:#117a8b;border-color:#10707f}.btn-info:not(:disabled):not(.disabled):active:focus,.btn-info:not(:disabled):not(.disabled).active:focus,.show>.btn-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.btn-warning{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:hover{color:#212529;background-color:#e0a800;border-color:#d39e00}.btn-warning:focus,.btn-warning.focus{color:#212529;background-color:#e0a800;border-color:#d39e00;box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.btn-warning.disabled,.btn-warning:disabled{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:not(:disabled):not(.disabled):active,.btn-warning:not(:disabled):not(.disabled).active,.show>.btn-warning.dropdown-toggle{color:#212529;background-color:#d39e00;border-color:#c69500}.btn-warning:not(:disabled):not(.disabled):active:focus,.btn-warning:not(:disabled):not(.disabled).active:focus,.show>.btn-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:hover{color:#fff;background-color:#c82333;border-color:#bd2130}.btn-danger:focus,.btn-danger.focus{color:#fff;background-color:#c82333;border-color:#bd2130;box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.btn-danger.disabled,.btn-danger:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:not(:disabled):not(.disabled):active,.btn-danger:not(:disabled):not(.disabled).active,.show>.btn-danger.dropdown-toggle{color:#fff;background-color:#bd2130;border-color:#b21f2d}.btn-danger:not(:disabled):not(.disabled):active:focus,.btn-danger:not(:disabled):not(.disabled).active:focus,.show>.btn-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.btn-light{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:hover{color:#212529;background-color:#e2e6ea;border-color:#dae0e5}.btn-light:focus,.btn-light.focus{color:#212529;background-color:#e2e6ea;border-color:#dae0e5;box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.btn-light.disabled,.btn-light:disabled{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:not(:disabled):not(.disabled):active,.btn-light:not(:disabled):not(.disabled).active,.show>.btn-light.dropdown-toggle{color:#212529;background-color:#dae0e5;border-color:#d3d9df}.btn-light:not(:disabled):not(.disabled):active:focus,.btn-light:not(:disabled):not(.disabled).active:focus,.show>.btn-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.btn-dark:focus,.btn-dark.focus{color:#fff;background-color:#23272b;border-color:#1d2124;box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.btn-dark.disabled,.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:not(:disabled):not(.disabled):active,.btn-dark:not(:disabled):not(.disabled).active,.show>.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.btn-dark:not(:disabled):not(.disabled):active:focus,.btn-dark:not(:disabled):not(.disabled).active:focus,.show>.btn-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.btn-outline-primary{color:#007bff;border-color:#007bff}.btn-outline-primary:hover{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary:focus,.btn-outline-primary.focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-primary.disabled,.btn-outline-primary:disabled{color:#007bff;background-color:transparent}.btn-outline-primary:not(:disabled):not(.disabled):active,.btn-outline-primary:not(:disabled):not(.disabled).active,.show>.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.show>.btn-outline-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-secondary{color:#6c757d;border-color:#6c757d}.btn-outline-secondary:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary:focus,.btn-outline-secondary.focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.btn-outline-secondary.disabled,.btn-outline-secondary:disabled{color:#6c757d;background-color:transparent}.btn-outline-secondary:not(:disabled):not(.disabled):active,.btn-outline-secondary:not(:disabled):not(.disabled).active,.show>.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.show>.btn-outline-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.btn-outline-success{color:#28a745;border-color:#28a745}.btn-outline-success:hover{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success:focus,.btn-outline-success.focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-success.disabled,.btn-outline-success:disabled{color:#28a745;background-color:transparent}.btn-outline-success:not(:disabled):not(.disabled):active,.btn-outline-success:not(:disabled):not(.disabled).active,.show>.btn-outline-success.dropdown-toggle{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success:not(:disabled):not(.disabled):active:focus,.btn-outline-success:not(:disabled):not(.disabled).active:focus,.show>.btn-outline-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-info{color:#17a2b8;border-color:#17a2b8}.btn-outline-info:hover{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info:focus,.btn-outline-info.focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-info.disabled,.btn-outline-info:disabled{color:#17a2b8;background-color:transparent}.btn-outline-info:not(:disabled):not(.disabled):active,.btn-outline-info:not(:disabled):not(.disabled).active,.show>.btn-outline-info.dropdown-toggle{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info:not(:disabled):not(.disabled):active:focus,.btn-outline-info:not(:disabled):not(.disabled).active:focus,.show>.btn-outline-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-warning{color:#ffc107;border-color:#ffc107}.btn-outline-warning:hover{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning:focus,.btn-outline-warning.focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-warning.disabled,.btn-outline-warning:disabled{color:#ffc107;background-color:transparent}.btn-outline-warning:not(:disabled):not(.disabled):active,.btn-outline-warning:not(:disabled):not(.disabled).active,.show>.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.show>.btn-outline-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-danger{color:#dc3545;border-color:#dc3545}.btn-outline-danger:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger:focus,.btn-outline-danger.focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-danger.disabled,.btn-outline-danger:disabled{color:#dc3545;background-color:transparent}.btn-outline-danger:not(:disabled):not(.disabled):active,.btn-outline-danger:not(:disabled):not(.disabled).active,.show>.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.show>.btn-outline-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-light{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:hover{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:focus,.btn-outline-light.focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-light.disabled,.btn-outline-light:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-light:not(:disabled):not(.disabled):active,.btn-outline-light:not(:disabled):not(.disabled).active,.show>.btn-outline-light.dropdown-toggle{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:not(:disabled):not(.disabled):active:focus,.btn-outline-light:not(:disabled):not(.disabled).active:focus,.show>.btn-outline-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-dark{color:#343a40;border-color:#343a40}.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark:focus,.btn-outline-dark.focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-dark.disabled,.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.btn-outline-dark:not(:disabled):not(.disabled):active,.btn-outline-dark:not(:disabled):not(.disabled).active,.show>.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.show>.btn-outline-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-link{font-weight:400;color:#007bff;text-decoration:none}.btn-link:hover{color:#0056b3;text-decoration:underline}.btn-link:focus,.btn-link.focus{text-decoration:underline}.btn-link:disabled,.btn-link.disabled{color:#6c757d;pointer-events:none}.btn-lg,.btn-group-lg>.btn{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.btn-sm,.btn-group-sm>.btn{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:.5rem}input[type=\"submit\"].btn-block,input[type=\"reset\"].btn-block,input[type=\"button\"].btn-block{width:100%}.fade{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade{transition:none}}.fade:not(.show){opacity:0}.collapse:not(.show){display:none}.collapsing{position:relative;height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing{transition:none}}.collapsing.width{width:0;height:auto;transition:width .35s ease}@media (prefers-reduced-motion:reduce){.collapsing.width{transition:none}}.dropup,.dropright,.dropdown,.dropleft{position:relative}.dropdown-toggle{white-space:nowrap}.dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty::after{margin-left:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu-left{right:auto;left:0}.dropdown-menu-right{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-left{right:auto;left:0}.dropdown-menu-sm-right{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-left{right:auto;left:0}.dropdown-menu-md-right{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-left{right:auto;left:0}.dropdown-menu-lg-right{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-left{right:auto;left:0}.dropdown-menu-xl-right{right:0;left:auto}}.dropup .dropdown-menu{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty::after{margin-left:0}.dropright .dropdown-menu{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropright .dropdown-toggle::after{display:inline-block;margin-left:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropright .dropdown-toggle:empty::after{margin-left:0}.dropright .dropdown-toggle::after{vertical-align:0}.dropleft .dropdown-menu{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropleft .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropleft .dropdown-toggle::before{display:inline-block;margin-right:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropleft .dropdown-toggle:empty::after{margin-left:0}.dropleft .dropdown-toggle::before{vertical-align:0}.dropdown-menu[x-placement^=\"top\"],.dropdown-menu[x-placement^=\"right\"],.dropdown-menu[x-placement^=\"bottom\"],.dropdown-menu[x-placement^=\"left\"]{right:auto;bottom:auto}.dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item:hover,.dropdown-item:focus{color:#16181b;text-decoration:none;background-color:#e9ecef}.dropdown-item.active,.dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled,.dropdown-item:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text{display:block;padding:.25rem 1.5rem;color:#212529}.btn-group,.btn-group-vertical{position:relative;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.btn-group>.btn,.btn-group-vertical>.btn{position:relative;-ms-flex:1 1 auto;flex:1 1 auto}.btn-group>.btn:hover,.btn-group-vertical>.btn:hover{z-index:1}.btn-group>.btn:focus,.btn-group>.btn:active,.btn-group>.btn.active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn.active{z-index:1}.btn-toolbar{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:start;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.btn:not(:first-child),.btn-group>.btn-group:not(:first-child){margin-left:-1px}.btn-group>.btn:not(:last-child):not(.dropdown-toggle),.btn-group>.btn-group:not(:last-child)>.btn{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:not(:first-child),.btn-group>.btn-group:not(:first-child)>.btn{border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split::after,.dropup .dropdown-toggle-split::after,.dropright .dropdown-toggle-split::after{margin-left:0}.dropleft .dropdown-toggle-split::before{margin-right:0}.btn-sm+.dropdown-toggle-split,.btn-group-sm>.btn+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-lg+.dropdown-toggle-split,.btn-group-lg>.btn+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:center;justify-content:center}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group{width:100%}.btn-group-vertical>.btn:not(:first-child),.btn-group-vertical>.btn-group:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),.btn-group-vertical>.btn-group:not(:last-child)>.btn{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:not(:first-child),.btn-group-vertical>.btn-group:not(:first-child)>.btn{border-top-left-radius:0;border-top-right-radius:0}.btn-group-toggle>.btn,.btn-group-toggle>.btn-group>.btn{margin-bottom:0}.btn-group-toggle>.btn input[type=\"radio\"],.btn-group-toggle>.btn input[type=\"checkbox\"],.btn-group-toggle>.btn-group>.btn input[type=\"radio\"],.btn-group-toggle>.btn-group>.btn input[type=\"checkbox\"]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:stretch;align-items:stretch;width:100%}.input-group>.form-control,.input-group>.form-control-plaintext,.input-group>.custom-select,.input-group>.custom-file{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0}.input-group>.form-control+.form-control,.input-group>.form-control+.custom-select,.input-group>.form-control+.custom-file,.input-group>.form-control-plaintext+.form-control,.input-group>.form-control-plaintext+.custom-select,.input-group>.form-control-plaintext+.custom-file,.input-group>.custom-select+.form-control,.input-group>.custom-select+.custom-select,.input-group>.custom-select+.custom-file,.input-group>.custom-file+.form-control,.input-group>.custom-file+.custom-select,.input-group>.custom-file+.custom-file{margin-left:-1px}.input-group>.form-control:focus,.input-group>.custom-select:focus,.input-group>.custom-file .custom-file-input:focus~.custom-file-label{z-index:3}.input-group>.custom-file .custom-file-input:focus{z-index:4}.input-group>.form-control:not(:first-child),.input-group>.custom-select:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group>.custom-file{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.input-group>.custom-file:not(:last-child) .custom-file-label,.input-group>.custom-file:not(:last-child) .custom-file-label::after{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.custom-file:not(:first-child) .custom-file-label{border-top-left-radius:0;border-bottom-left-radius:0}.input-group:not(.has-validation)>.form-control:not(:last-child),.input-group:not(.has-validation)>.custom-select:not(:last-child),.input-group:not(.has-validation)>.custom-file:not(:last-child) .custom-file-label,.input-group:not(.has-validation)>.custom-file:not(:last-child) .custom-file-label::after{border-top-right-radius:0;border-bottom-right-radius:0}.input-group.has-validation>.form-control:nth-last-child(n+3),.input-group.has-validation>.custom-select:nth-last-child(n+3),.input-group.has-validation>.custom-file:nth-last-child(n+3) .custom-file-label,.input-group.has-validation>.custom-file:nth-last-child(n+3) .custom-file-label::after{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-prepend,.input-group-append{display:-ms-flexbox;display:flex}.input-group-prepend .btn,.input-group-append .btn{position:relative;z-index:2}.input-group-prepend .btn:focus,.input-group-append .btn:focus{z-index:3}.input-group-prepend .btn+.btn,.input-group-prepend .btn+.input-group-text,.input-group-prepend .input-group-text+.input-group-text,.input-group-prepend .input-group-text+.btn,.input-group-append .btn+.btn,.input-group-append .btn+.input-group-text,.input-group-append .input-group-text+.input-group-text,.input-group-append .input-group-text+.btn{margin-left:-1px}.input-group-prepend{margin-right:-1px}.input-group-append{margin-left:-1px}.input-group-text{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-text input[type=\"radio\"],.input-group-text input[type=\"checkbox\"]{margin-top:0}.input-group-lg>.form-control:not(textarea),.input-group-lg>.custom-select{height:calc(1.5em + 1rem + 2px)}.input-group-lg>.form-control{padding:.5rem 1rem}.input-group-lg>.form-control,.input-group-lg>.custom-select{font-size:1.25rem;line-height:1.5;border-radius:.3rem}.input-group-lg>.input-group-prepend>.input-group-text,.input-group-lg>.input-group-append>.input-group-text,.input-group-lg>.input-group-prepend>.btn,.input-group-lg>.input-group-append>.btn{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.input-group-sm>.form-control:not(textarea),.input-group-sm>.custom-select{height:calc(1.5em + .5rem + 2px)}.input-group-sm>.form-control{padding:.25rem .5rem}.input-group-sm>.form-control,.input-group-sm>.custom-select{font-size:.875rem;line-height:1.5;border-radius:.2rem}.input-group-sm>.input-group-prepend>.input-group-text,.input-group-sm>.input-group-append>.input-group-text,.input-group-sm>.input-group-prepend>.btn,.input-group-sm>.input-group-append>.btn{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.input-group-lg>.custom-select{padding:.5rem 1.75rem .5rem 1rem}.input-group-sm>.custom-select{padding:.25rem 1.75rem .25rem .5rem}.input-group>.input-group-prepend>.btn,.input-group>.input-group-prepend>.input-group-text,.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.btn,.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.input-group-text,.input-group.has-validation>.input-group-append:nth-last-child(n+3)>.btn,.input-group.has-validation>.input-group-append:nth-last-child(n+3)>.input-group-text,.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group>.input-group-append:last-child>.input-group-text:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.input-group-append>.btn,.input-group>.input-group-append>.input-group-text,.input-group>.input-group-prepend:not(:first-child)>.btn,.input-group>.input-group-prepend:not(:first-child)>.input-group-text,.input-group>.input-group-prepend:first-child>.btn:not(:first-child),.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.custom-control{position:relative;z-index:1;display:block;min-height:1.5rem;padding-left:1.5rem;print-color-adjust:exact}.custom-control-inline{display:-ms-inline-flexbox;display:inline-flex;margin-right:1rem}.custom-control-input{position:absolute;left:0;z-index:-1;width:1rem;height:1.25rem;opacity:0}.custom-control-input:checked~.custom-control-label::before{color:#fff;border-color:#007bff;background-color:#007bff}.custom-control-input:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-control-input:focus:not(:checked)~.custom-control-label::before{border-color:#80bdff}.custom-control-input:not(:disabled):active~.custom-control-label::before{color:#fff;background-color:#b3d7ff;border-color:#b3d7ff}.custom-control-input[disabled]~.custom-control-label,.custom-control-input:disabled~.custom-control-label{color:#6c757d}.custom-control-input[disabled]~.custom-control-label::before,.custom-control-input:disabled~.custom-control-label::before{background-color:#e9ecef}.custom-control-label{position:relative;margin-bottom:0;vertical-align:top}.custom-control-label::before{pointer-events:none;background-color:#fff;border:1px solid #adb5bd}.custom-control-label::before,.custom-control-label::after{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;content:\"\"}.custom-control-label::after{background:50%/50% 50% no-repeat}.custom-checkbox .custom-control-label::before{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before{border-color:#007bff;background-color:#007bff}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-radio .custom-control-label::before{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-switch{padding-left:2.25rem}.custom-switch .custom-control-label::before{left:-2.25rem;width:1.75rem;pointer-events:all;border-radius:.5rem}.custom-switch .custom-control-label::after{top:calc(.25rem + 2px);left:calc(-2.25rem + 2px);width:calc(1rem - 4px);height:calc(1rem - 4px);background-color:#adb5bd;border-radius:.5rem;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-switch .custom-control-label::after{transition:none}}.custom-switch .custom-control-input:checked~.custom-control-label::after{background-color:#fff;transform:translateX(.75rem)}.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-select{display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem 1.75rem .375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;vertical-align:middle;background:#fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-select:focus{border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-select:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple],.custom-select[size]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.custom-select:disabled{color:#6c757d;background-color:#e9ecef}.custom-select::-ms-expand{display:none}.custom-select:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.custom-select-sm{height:calc(1.5em + .5rem + 2px);padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem}.custom-select-lg{height:calc(1.5em + 1rem + 2px);padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem}.custom-file{display:inline-block;margin-bottom:0}.custom-file,.custom-file-input{position:relative;width:100%;height:calc(1.5em + .75rem + 2px)}.custom-file-input{z-index:2;margin:0;overflow:hidden;opacity:0}.custom-file-input:focus~.custom-file-label{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-file-input[disabled]~.custom-file-label,.custom-file-input:disabled~.custom-file-label{background-color:#e9ecef}.custom-file-input:lang(en)~.custom-file-label::after{content:\"Browse\"}.custom-file-input~.custom-file-label[data-browse]::after{content:attr(data-browse)}.custom-file-label{left:0;z-index:1;height:calc(1.5em + .75rem + 2px);overflow:hidden;font-weight:400;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.custom-file-label,.custom-file-label::after{position:absolute;top:0;right:0;padding:.375rem .75rem;line-height:1.5;color:#495057}.custom-file-label::after{bottom:0;z-index:3;display:block;height:calc(1.5em + .75rem);content:\"Browse\";background-color:#e9ecef;border-left:inherit;border-radius:0 .25rem .25rem 0}.custom-range{width:100%;height:1.4rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-range:focus{outline:0}.custom-range:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-ms-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range::-moz-focus-outer{border:0}.custom-range::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#007bff;border:0;border-radius:1rem;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-webkit-slider-thumb{transition:none}}.custom-range::-webkit-slider-thumb:active{background-color:#b3d7ff}.custom-range::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-moz-range-thumb{width:1rem;height:1rem;background-color:#007bff;border:0;border-radius:1rem;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-moz-range-thumb{transition:none}}.custom-range::-moz-range-thumb:active{background-color:#b3d7ff}.custom-range::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-ms-thumb{width:1rem;height:1rem;margin-top:0;margin-right:.2rem;margin-left:.2rem;background-color:#007bff;border:0;border-radius:1rem;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-ms-thumb{transition:none}}.custom-range::-ms-thumb:active{background-color:#b3d7ff}.custom-range::-ms-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:transparent;border-color:transparent;border-width:.5rem}.custom-range::-ms-fill-lower{background-color:#dee2e6;border-radius:1rem}.custom-range::-ms-fill-upper{margin-right:15px;background-color:#dee2e6;border-radius:1rem}.custom-range:disabled::-webkit-slider-thumb{background-color:#adb5bd}.custom-range:disabled::-webkit-slider-runnable-track{cursor:default}.custom-range:disabled::-moz-range-thumb{background-color:#adb5bd}.custom-range:disabled::-moz-range-track{cursor:default}.custom-range:disabled::-ms-thumb{background-color:#adb5bd}.custom-control-label::before,.custom-file-label,.custom-select{transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-control-label::before,.custom-file-label,.custom-select{transition:none}}.nav{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:.5rem 1rem}.nav-link:hover,.nav-link:focus{text-decoration:none}.nav-link.disabled{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs{border-bottom:1px solid #dee2e6}.nav-tabs .nav-link{margin-bottom:-1px;background-color:transparent;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link:hover,.nav-tabs .nav-link:focus{isolation:isolate;border-color:#e9ecef #e9ecef #dee2e6}.nav-tabs .nav-link.disabled{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-link.active,.nav-tabs .nav-item.show .nav-link{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link{background:0 0;border:0;border-radius:.25rem}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.nav-fill>.nav-link,.nav-fill .nav-item{-ms-flex:1 1 auto;flex:1 1 auto;text-align:center}.nav-justified>.nav-link,.nav-justified .nav-item{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;text-align:center}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;padding:.5rem 1rem}.navbar,.navbar .container,.navbar .container-fluid,.navbar .container-sm,.navbar .container-md,.navbar .container-lg,.navbar .container-xl{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.navbar-brand:hover,.navbar-brand:focus{text-decoration:none}.navbar-nav{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu{position:static;float:none}.navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse{-ms-flex-preferred-size:100%;flex-basis:100%;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center}.navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:hover,.navbar-toggler:focus{text-decoration:none}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:50%/100% 100% no-repeat}.navbar-nav-scroll{max-height:75vh;overflow-y:auto}@media (max-width:575.98px){.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid,.navbar-expand-sm>.container-sm,.navbar-expand-sm>.container-md,.navbar-expand-sm>.container-lg,.navbar-expand-sm>.container-xl{padding-right:0;padding-left:0}}@media (min-width:576px){.navbar-expand-sm{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-sm .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid,.navbar-expand-sm>.container-sm,.navbar-expand-sm>.container-md,.navbar-expand-sm>.container-lg,.navbar-expand-sm>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-sm .navbar-nav-scroll{overflow:visible}.navbar-expand-sm .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}}@media (max-width:767.98px){.navbar-expand-md>.container,.navbar-expand-md>.container-fluid,.navbar-expand-md>.container-sm,.navbar-expand-md>.container-md,.navbar-expand-md>.container-lg,.navbar-expand-md>.container-xl{padding-right:0;padding-left:0}}@media (min-width:768px){.navbar-expand-md{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-md .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md>.container,.navbar-expand-md>.container-fluid,.navbar-expand-md>.container-sm,.navbar-expand-md>.container-md,.navbar-expand-md>.container-lg,.navbar-expand-md>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-md .navbar-nav-scroll{overflow:visible}.navbar-expand-md .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}}@media (max-width:991.98px){.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid,.navbar-expand-lg>.container-sm,.navbar-expand-lg>.container-md,.navbar-expand-lg>.container-lg,.navbar-expand-lg>.container-xl{padding-right:0;padding-left:0}}@media (min-width:992px){.navbar-expand-lg{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-lg .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid,.navbar-expand-lg>.container-sm,.navbar-expand-lg>.container-md,.navbar-expand-lg>.container-lg,.navbar-expand-lg>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-lg .navbar-nav-scroll{overflow:visible}.navbar-expand-lg .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}}@media (max-width:1199.98px){.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid,.navbar-expand-xl>.container-sm,.navbar-expand-xl>.container-md,.navbar-expand-xl>.container-lg,.navbar-expand-xl>.container-xl{padding-right:0;padding-left:0}}@media (min-width:1200px){.navbar-expand-xl{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-xl .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid,.navbar-expand-xl>.container-sm,.navbar-expand-xl>.container-md,.navbar-expand-xl>.container-lg,.navbar-expand-xl>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-xl .navbar-nav-scroll{overflow:visible}.navbar-expand-xl .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}}.navbar-expand{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand>.container,.navbar-expand>.container-fluid,.navbar-expand>.container-sm,.navbar-expand>.container-md,.navbar-expand>.container-lg,.navbar-expand>.container-xl{padding-right:0;padding-left:0}.navbar-expand .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand>.container,.navbar-expand>.container-fluid,.navbar-expand>.container-sm,.navbar-expand>.container-md,.navbar-expand>.container-lg,.navbar-expand>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand .navbar-nav-scroll{overflow:visible}.navbar-expand .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-light .navbar-brand{color:rgba(0,0,0,.9)}.navbar-light .navbar-brand:hover,.navbar-light .navbar-brand:focus{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.5)}.navbar-light .navbar-nav .nav-link:hover,.navbar-light .navbar-nav .nav-link:focus{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .show>.nav-link,.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .nav-link.show,.navbar-light .navbar-nav .nav-link.active{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280,0,0,0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-light .navbar-text{color:rgba(0,0,0,.5)}.navbar-light .navbar-text a{color:rgba(0,0,0,.9)}.navbar-light .navbar-text a:hover,.navbar-light .navbar-text a:focus{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand{color:#fff}.navbar-dark .navbar-brand:hover,.navbar-dark .navbar-brand:focus{color:#fff}.navbar-dark .navbar-nav .nav-link{color:rgba(255,255,255,.5)}.navbar-dark .navbar-nav .nav-link:hover,.navbar-dark .navbar-nav .nav-link:focus{color:rgba(255,255,255,.75)}.navbar-dark .navbar-nav .nav-link.disabled{color:rgba(255,255,255,.25)}.navbar-dark .navbar-nav .show>.nav-link,.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .nav-link.show,.navbar-dark .navbar-nav .nav-link.active{color:#fff}.navbar-dark .navbar-toggler{color:rgba(255,255,255,.5);border-color:rgba(255,255,255,.1)}.navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255,255,255,0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-dark .navbar-text{color:rgba(255,255,255,.5)}.navbar-dark .navbar-text a{color:#fff}.navbar-dark .navbar-text a:hover,.navbar-dark .navbar-text a:focus{color:#fff}.card{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr{margin-right:0;margin-left:0}.card>.list-group{border-top:inherit;border-bottom:inherit}.card>.list-group:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card>.list-group:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card>.card-header+.list-group,.card>.list-group+.card-footer{border-top:0}.card-body{-ms-flex:1 1 auto;flex:1 1 auto;min-height:1px;padding:1.25rem}.card-title{margin-bottom:.75rem}.card-subtitle{margin-top:-.375rem;margin-bottom:0}.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:1.25rem}.card-header{padding:.75rem 1.25rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px)0 0}.card-footer{padding:.75rem 1.25rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs{margin-bottom:-.75rem;border-bottom:0}.card-header-tabs,.card-header-pills{margin-right:-.625rem;margin-left:-.625rem}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem;border-radius:calc(.25rem - 1px)}.card-img,.card-img-top,.card-img-bottom{-ms-flex-negative:0;flex-shrink:0;width:100%}.card-img,.card-img-top{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img,.card-img-bottom{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-deck .card{margin-bottom:15px}@media (min-width:576px){.card-deck{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.card-deck .card{-ms-flex:1 0 0%;flex:1 0 0%;margin-right:15px;margin-bottom:0;margin-left:15px}}.card-group>.card{margin-bottom:15px}@media (min-width:576px){.card-group{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.card-group>.card{-ms-flex:1 0 0%;flex:1 0 0%;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-img-top,.card-group>.card:not(:last-child) .card-header{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-img-bottom,.card-group>.card:not(:last-child) .card-footer{border-bottom-right-radius:0}.card-group>.card:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-img-top,.card-group>.card:not(:first-child) .card-header{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-img-bottom,.card-group>.card:not(:first-child) .card-footer{border-bottom-left-radius:0}}.card-columns .card{margin-bottom:.75rem}@media (min-width:576px){.card-columns{column-count:3;column-gap:1.25rem;orphans:1;widows:1}.card-columns .card{display:inline-block;width:100%}}.accordion{overflow-anchor:none}.accordion>.card{overflow:hidden}.accordion>.card:not(:last-of-type){border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.accordion>.card:not(:first-of-type){border-top-left-radius:0;border-top-right-radius:0}.accordion>.card>.card-header{border-radius:0;margin-bottom:-1px}.breadcrumb{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.breadcrumb-item+.breadcrumb-item{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item::before{float:left;padding-right:.5rem;color:#6c757d;content:\"/\"}.breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:none}.breadcrumb-item.active{color:#6c757d}.pagination{display:-ms-flexbox;display:flex;padding-left:0;list-style:none;border-radius:.25rem}.page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.page-link:hover{z-index:2;color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.page-link:focus{z-index:3;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.page-item:first-child .page-link{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.page-item.active .page-link{z-index:3;color:#fff;background-color:#007bff;border-color:#007bff}.page-item.disabled .page-link{color:#6c757d;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.pagination-lg .page-item:first-child .page-link{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.pagination-sm .page-item:first-child .page-link{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.badge{transition:none}}a.badge:hover,a.badge:focus{text-decoration:none}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.badge-primary{color:#fff;background-color:#007bff}a.badge-primary:hover,a.badge-primary:focus{color:#fff;background-color:#0062cc}a.badge-primary:focus,a.badge-primary.focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.badge-secondary{color:#fff;background-color:#6c757d}a.badge-secondary:hover,a.badge-secondary:focus{color:#fff;background-color:#545b62}a.badge-secondary:focus,a.badge-secondary.focus{outline:0;box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.badge-success{color:#fff;background-color:#28a745}a.badge-success:hover,a.badge-success:focus{color:#fff;background-color:#1e7e34}a.badge-success:focus,a.badge-success.focus{outline:0;box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.badge-info{color:#fff;background-color:#17a2b8}a.badge-info:hover,a.badge-info:focus{color:#fff;background-color:#117a8b}a.badge-info:focus,a.badge-info.focus{outline:0;box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.badge-warning{color:#212529;background-color:#ffc107}a.badge-warning:hover,a.badge-warning:focus{color:#212529;background-color:#d39e00}a.badge-warning:focus,a.badge-warning.focus{outline:0;box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.badge-danger{color:#fff;background-color:#dc3545}a.badge-danger:hover,a.badge-danger:focus{color:#fff;background-color:#bd2130}a.badge-danger:focus,a.badge-danger.focus{outline:0;box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.badge-light{color:#212529;background-color:#f8f9fa}a.badge-light:hover,a.badge-light:focus{color:#212529;background-color:#dae0e5}a.badge-light:focus,a.badge-light.focus{outline:0;box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.badge-dark{color:#fff;background-color:#343a40}a.badge-dark:hover,a.badge-dark:focus{color:#fff;background-color:#1d2124}a.badge-dark:focus,a.badge-dark.focus{outline:0;box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width:576px){.jumbotron{padding:4rem 2rem}}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:4rem}.alert-dismissible .close{position:absolute;top:0;right:0;z-index:2;padding:.75rem 1.25rem;color:inherit}.alert-primary{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert-primary hr{border-top-color:#9fcdff}.alert-primary .alert-link{color:#002752}.alert-secondary{color:#383d41;background-color:#e2e3e5;border-color:#d6d8db}.alert-secondary hr{border-top-color:#c8cbcf}.alert-secondary .alert-link{color:#202326}.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert-success hr{border-top-color:#b1dfbb}.alert-success .alert-link{color:#0b2e13}.alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.alert-info hr{border-top-color:#abdde5}.alert-info .alert-link{color:#062c33}.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.alert-warning hr{border-top-color:#ffe8a1}.alert-warning .alert-link{color:#533f03}.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert-danger hr{border-top-color:#f1b0b7}.alert-danger .alert-link{color:#491217}.alert-light{color:#818182;background-color:#fefefe;border-color:#fdfdfe}.alert-light hr{border-top-color:#ececf6}.alert-light .alert-link{color:#686868}.alert-dark{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.alert-dark hr{border-top-color:#b9bbbe}.alert-dark .alert-link{color:#040505}@keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}.progress{height:1rem;line-height:0;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress,.progress-bar{display:-ms-flexbox;display:flex;overflow:hidden}.progress-bar{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;color:#fff;text-align:center;white-space:nowrap;background-color:#007bff;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar{transition:none}}.progress-bar-striped{background-image:linear-gradient(45deg,rgba(255,255,255,.15)25%,transparent 25%,transparent 50%,rgba(255,255,255,.15)50%,rgba(255,255,255,.15)75%,transparent 75%,transparent);background-size:1rem 1rem}.progress-bar-animated{animation:1s linear infinite progress-bar-stripes}@media (prefers-reduced-motion:reduce){.progress-bar-animated{animation:none}}.media{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.media-body{-ms-flex:1;flex:1}.list-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.list-group-item-action{width:100%;color:#495057;text-align:inherit}.list-group-item-action:hover,.list-group-item-action:focus{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action:active{color:#212529;background-color:#e9ecef}.list-group-item{position:relative;display:block;padding:.75rem 1.25rem;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled,.list-group-item:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.list-group-item+.list-group-item{border-top-width:0}.list-group-item+.list-group-item.active{margin-top:-1px;border-top-width:1px}.list-group-horizontal{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-sm>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-md>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-lg>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-xl>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}.list-group-flush{border-radius:0}.list-group-flush>.list-group-item{border-width:0 0 1px}.list-group-flush>.list-group-item:last-child{border-bottom-width:0}.list-group-item-primary{color:#004085;background-color:#b8daff}.list-group-item-primary.list-group-item-action:hover,.list-group-item-primary.list-group-item-action:focus{color:#004085;background-color:#9fcdff}.list-group-item-primary.list-group-item-action.active{color:#fff;background-color:#004085;border-color:#004085}.list-group-item-secondary{color:#383d41;background-color:#d6d8db}.list-group-item-secondary.list-group-item-action:hover,.list-group-item-secondary.list-group-item-action:focus{color:#383d41;background-color:#c8cbcf}.list-group-item-secondary.list-group-item-action.active{color:#fff;background-color:#383d41;border-color:#383d41}.list-group-item-success{color:#155724;background-color:#c3e6cb}.list-group-item-success.list-group-item-action:hover,.list-group-item-success.list-group-item-action:focus{color:#155724;background-color:#b1dfbb}.list-group-item-success.list-group-item-action.active{color:#fff;background-color:#155724;border-color:#155724}.list-group-item-info{color:#0c5460;background-color:#bee5eb}.list-group-item-info.list-group-item-action:hover,.list-group-item-info.list-group-item-action:focus{color:#0c5460;background-color:#abdde5}.list-group-item-info.list-group-item-action.active{color:#fff;background-color:#0c5460;border-color:#0c5460}.list-group-item-warning{color:#856404;background-color:#ffeeba}.list-group-item-warning.list-group-item-action:hover,.list-group-item-warning.list-group-item-action:focus{color:#856404;background-color:#ffe8a1}.list-group-item-warning.list-group-item-action.active{color:#fff;background-color:#856404;border-color:#856404}.list-group-item-danger{color:#721c24;background-color:#f5c6cb}.list-group-item-danger.list-group-item-action:hover,.list-group-item-danger.list-group-item-action:focus{color:#721c24;background-color:#f1b0b7}.list-group-item-danger.list-group-item-action.active{color:#fff;background-color:#721c24;border-color:#721c24}.list-group-item-light{color:#818182;background-color:#fdfdfe}.list-group-item-light.list-group-item-action:hover,.list-group-item-light.list-group-item-action:focus{color:#818182;background-color:#ececf6}.list-group-item-light.list-group-item-action.active{color:#fff;background-color:#818182;border-color:#818182}.list-group-item-dark{color:#1b1e21;background-color:#c6c8ca}.list-group-item-dark.list-group-item-action:hover,.list-group-item-dark.list-group-item-action:focus{color:#1b1e21;background-color:#b9bbbe}.list-group-item-dark.list-group-item-action.active{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close:hover{color:#000;text-decoration:none}.close:not(:disabled):not(.disabled):hover,.close:not(:disabled):not(.disabled):focus{opacity:.75}button.close{padding:0;background-color:transparent;border:0}a.close.disabled{pointer-events:none}.toast{-ms-flex-preferred-size:350px;flex-basis:350px;max-width:350px;background-color:rgba(255,255,255,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .25rem .75rem rgba(0,0,0,.1);opacity:0;border-radius:.25rem}.toast:not(:last-child){margin-bottom:.75rem}.toast.showing{opacity:1}.toast.show{display:block;opacity:1}.toast.hide{display:none}.toast-header{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:.25rem .75rem;color:#6c757d;background-color:rgba(255,255,255,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.toast-body{padding:.75rem}.modal-open{overflow:hidden}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal{position:fixed;top:0;left:0;z-index:1050;display:none;width:100%;height:100%;overflow:hidden;outline:0}.modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog{transition:transform .3s ease-out;transform:translate(0,-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog{transition:none}}.modal.show .modal-dialog{transform:none}.modal.modal-static .modal-dialog{transform:scale(1.02)}.modal-dialog-scrollable{display:-ms-flexbox;display:flex;max-height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content{max-height:calc(100vh - 1rem);overflow:hidden}.modal-dialog-scrollable .modal-header,.modal-dialog-scrollable .modal-footer{-ms-flex-negative:0;flex-shrink:0}.modal-dialog-scrollable .modal-body{overflow-y:auto}.modal-dialog-centered{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;min-height:calc(100% - 1rem)}.modal-dialog-centered::before{display:block;height:calc(100vh - 1rem);height:-webkit-min-content;height:-moz-min-content;height:min-content;content:\"\"}.modal-dialog-centered.modal-dialog-scrollable{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.modal-dialog-centered.modal-dialog-scrollable .modal-content{max-height:none}.modal-dialog-centered.modal-dialog-scrollable::before{content:none}.modal-content{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:.5}.modal-header{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:justify;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .close{padding:1rem;margin:-1rem -1rem -1rem auto}.modal-title{margin-bottom:0;line-height:1.5}.modal-body{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;padding:1rem}.modal-footer{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>*{margin:.25rem}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.modal-dialog{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable{max-height:calc(100% - 3.5rem)}.modal-dialog-scrollable .modal-content{max-height:calc(100vh - 3.5rem)}.modal-dialog-centered{min-height:calc(100% - 3.5rem)}.modal-dialog-centered::before{height:calc(100vh - 3.5rem);height:-webkit-min-content;height:-moz-min-content;height:min-content}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg,.modal-xl{max-width:800px}}@media (min-width:1200px){.modal-xl{max-width:1140px}}.tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;white-space:normal;word-spacing:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show{opacity:.9}.tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .arrow::before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-top,.bs-tooltip-auto[x-placement^=\"top\"]{padding:.4rem 0}.bs-tooltip-top .arrow,.bs-tooltip-auto[x-placement^=\"top\"] .arrow{bottom:0}.bs-tooltip-top .arrow::before,.bs-tooltip-auto[x-placement^=\"top\"] .arrow::before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-right,.bs-tooltip-auto[x-placement^=\"right\"]{padding:0 .4rem}.bs-tooltip-right .arrow,.bs-tooltip-auto[x-placement^=\"right\"] .arrow{left:0;width:.4rem;height:.8rem}.bs-tooltip-right .arrow::before,.bs-tooltip-auto[x-placement^=\"right\"] .arrow::before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-bottom,.bs-tooltip-auto[x-placement^=\"bottom\"]{padding:.4rem 0}.bs-tooltip-bottom .arrow,.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow{top:0}.bs-tooltip-bottom .arrow::before,.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-left,.bs-tooltip-auto[x-placement^=\"left\"]{padding:0 .4rem}.bs-tooltip-left .arrow,.bs-tooltip-auto[x-placement^=\"left\"] .arrow{right:0;width:.4rem;height:.8rem}.bs-tooltip-left .arrow::before,.bs-tooltip-auto[x-placement^=\"left\"] .arrow::before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover{top:0;left:0;z-index:1060;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;white-space:normal;word-spacing:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover,.popover .arrow{position:absolute;display:block}.popover .arrow{width:1rem;height:.5rem;margin:0 .3rem}.popover .arrow::before,.popover .arrow::after{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-top,.bs-popover-auto[x-placement^=\"top\"]{margin-bottom:.5rem}.bs-popover-top>.arrow,.bs-popover-auto[x-placement^=\"top\"]>.arrow{bottom:calc(-.5rem - 1px)}.bs-popover-top>.arrow::before,.bs-popover-auto[x-placement^=\"top\"]>.arrow::before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-top>.arrow::after,.bs-popover-auto[x-placement^=\"top\"]>.arrow::after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-right,.bs-popover-auto[x-placement^=\"right\"]{margin-left:.5rem}.bs-popover-right>.arrow,.bs-popover-auto[x-placement^=\"right\"]>.arrow{left:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-right>.arrow::before,.bs-popover-auto[x-placement^=\"right\"]>.arrow::before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-right>.arrow::after,.bs-popover-auto[x-placement^=\"right\"]>.arrow::after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-bottom,.bs-popover-auto[x-placement^=\"bottom\"]{margin-top:.5rem}.bs-popover-bottom>.arrow,.bs-popover-auto[x-placement^=\"bottom\"]>.arrow{top:calc(-.5rem - 1px)}.bs-popover-bottom>.arrow::before,.bs-popover-auto[x-placement^=\"bottom\"]>.arrow::before{top:0;border-width:0 .5rem .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-bottom>.arrow::after,.bs-popover-auto[x-placement^=\"bottom\"]>.arrow::after{top:1px;border-width:0 .5rem .5rem .5rem;border-bottom-color:#fff}.bs-popover-bottom .popover-header::before,.bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.bs-popover-left,.bs-popover-auto[x-placement^=\"left\"]{margin-right:.5rem}.bs-popover-left>.arrow,.bs-popover-auto[x-placement^=\"left\"]>.arrow{right:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-left>.arrow::before,.bs-popover-auto[x-placement^=\"left\"]>.arrow::before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-left>.arrow::after,.bs-popover-auto[x-placement^=\"left\"]>.arrow::after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header:empty{display:none}.popover-body{padding:.5rem .75rem;color:#212529}.carousel{position:relative}.carousel.pointer-event{-ms-touch-action:pan-y;touch-action:pan-y}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-inner::after{display:block;clear:both;content:\"\"}.carousel-item{position:relative;display:none;float:left;width:100%;margin-right:-100%;backface-visibility:hidden;transition:transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item{transition:none}}.carousel-item.active,.carousel-item-next,.carousel-item-prev{display:block}.carousel-item-next:not(.carousel-item-left),.active.carousel-item-right{transform:translateX(100%)}.carousel-item-prev:not(.carousel-item-right),.active.carousel-item-left{transform:translateX(-100%)}.carousel-fade .carousel-item{opacity:0;transition-property:opacity;transform:none}.carousel-fade .carousel-item.active,.carousel-fade .carousel-item-next.carousel-item-left,.carousel-fade .carousel-item-prev.carousel-item-right{z-index:1;opacity:1}.carousel-fade .active.carousel-item-left,.carousel-fade .active.carousel-item-right{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-left,.carousel-fade .active.carousel-item-right{transition:none}}.carousel-control-prev,.carousel-control-next{position:absolute;top:0;bottom:0;z-index:1;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:15%;padding:0;color:#fff;text-align:center;background:0 0;border:0;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-prev,.carousel-control-next{transition:none}}.carousel-control-prev:hover,.carousel-control-prev:focus,.carousel-control-next:hover,.carousel-control-next:focus{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-prev-icon,.carousel-control-next-icon{display:inline-block;width:20px;height:20px;background:50%/100% 100% no-repeat}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\")}.carousel-indicators{position:absolute;right:0;bottom:0;left:0;z-index:15;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.carousel-indicators li{box-sizing:content-box;-ms-flex:0 1 auto;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators li{transition:none}}.carousel-indicators .active{opacity:1}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}@keyframes spinner-border{to{transform:rotate(360deg)}}.spinner-border{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;border:.25em solid currentcolor;border-right-color:transparent;border-radius:50%;animation:.75s linear infinite spinner-border}.spinner-border-sm{width:1rem;height:1rem;border-width:.2em}@keyframes spinner-grow{0%{transform:scale(0)}50%{opacity:1;transform:none}}.spinner-grow{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;background-color:currentcolor;border-radius:50%;opacity:0;animation:.75s linear infinite spinner-grow}.spinner-grow-sm{width:1rem;height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border,.spinner-grow{animation-duration:1.5s}}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.bg-primary{background-color:#007bff!important}a.bg-primary:hover,a.bg-primary:focus,button.bg-primary:hover,button.bg-primary:focus{background-color:#0062cc!important}.bg-secondary{background-color:#6c757d!important}a.bg-secondary:hover,a.bg-secondary:focus,button.bg-secondary:hover,button.bg-secondary:focus{background-color:#545b62!important}.bg-success{background-color:#28a745!important}a.bg-success:hover,a.bg-success:focus,button.bg-success:hover,button.bg-success:focus{background-color:#1e7e34!important}.bg-info{background-color:#17a2b8!important}a.bg-info:hover,a.bg-info:focus,button.bg-info:hover,button.bg-info:focus{background-color:#117a8b!important}.bg-warning{background-color:#ffc107!important}a.bg-warning:hover,a.bg-warning:focus,button.bg-warning:hover,button.bg-warning:focus{background-color:#d39e00!important}.bg-danger{background-color:#dc3545!important}a.bg-danger:hover,a.bg-danger:focus,button.bg-danger:hover,button.bg-danger:focus{background-color:#bd2130!important}.bg-light{background-color:#f8f9fa!important}a.bg-light:hover,a.bg-light:focus,button.bg-light:hover,button.bg-light:focus{background-color:#dae0e5!important}.bg-dark{background-color:#343a40!important}a.bg-dark:hover,a.bg-dark:focus,button.bg-dark:hover,button.bg-dark:focus{background-color:#1d2124!important}.bg-white{background-color:#fff!important}.bg-transparent{background-color:transparent!important}.border{border:1px solid #dee2e6!important}.border-top{border-top:1px solid #dee2e6!important}.border-right{border-right:1px solid #dee2e6!important}.border-bottom{border-bottom:1px solid #dee2e6!important}.border-left{border-left:1px solid #dee2e6!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary{border-color:#007bff!important}.border-secondary{border-color:#6c757d!important}.border-success{border-color:#28a745!important}.border-info{border-color:#17a2b8!important}.border-warning{border-color:#ffc107!important}.border-danger{border-color:#dc3545!important}.border-light{border-color:#f8f9fa!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded-sm{border-radius:.2rem!important}.rounded{border-radius:.25rem!important}.rounded-top{border-top-left-radius:.25rem!important}.rounded-top,.rounded-right{border-top-right-radius:.25rem!important}.rounded-right,.rounded-bottom{border-bottom-right-radius:.25rem!important}.rounded-bottom,.rounded-left{border-bottom-left-radius:.25rem!important}.rounded-left{border-top-left-radius:.25rem!important}.rounded-lg{border-radius:.3rem!important}.rounded-circle{border-radius:50%!important}.rounded-pill{border-radius:50rem!important}.rounded-0{border-radius:0!important}.clearfix::after{display:block;clear:both;content:\"\"}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:-ms-flexbox!important;display:flex!important}.d-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:-ms-flexbox!important;display:flex!important}.d-sm-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:-ms-flexbox!important;display:flex!important}.d-md-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:-ms-flexbox!important;display:flex!important}.d-lg-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:-ms-flexbox!important;display:flex!important}.d-xl-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media print{.d-print-none{display:none!important}.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:-ms-flexbox!important;display:flex!important}.d-print-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}.embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.embed-responsive::before{display:block;content:\"\"}.embed-responsive .embed-responsive-item,.embed-responsive iframe,.embed-responsive embed,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9::before{padding-top:42.85714%}.embed-responsive-16by9::before{padding-top:56.25%}.embed-responsive-4by3::before{padding-top:75%}.embed-responsive-1by1::before{padding-top:100%}.flex-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-center{-ms-flex-align:center!important;align-items:center!important}.align-items-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}@media (min-width:576px){.flex-sm-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-sm-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-sm-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-sm-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-sm-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-sm-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-sm-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-sm-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-sm-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-sm-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-sm-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-sm-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-sm-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-sm-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-sm-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-sm-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-sm-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-sm-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-sm-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-sm-center{-ms-flex-align:center!important;align-items:center!important}.align-items-sm-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-sm-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-sm-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-sm-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-sm-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-sm-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-sm-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-sm-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-sm-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-sm-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-sm-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-sm-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-sm-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-sm-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:768px){.flex-md-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-md-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-md-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-md-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-md-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-md-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-md-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-md-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-md-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-md-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-md-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-md-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-md-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-md-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-md-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-md-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-md-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-md-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-md-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-md-center{-ms-flex-align:center!important;align-items:center!important}.align-items-md-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-md-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-md-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-md-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-md-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-md-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-md-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-md-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-md-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-md-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-md-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-md-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-md-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-md-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:992px){.flex-lg-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-lg-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-lg-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-lg-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-lg-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-lg-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-lg-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-lg-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-lg-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-lg-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-lg-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-lg-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-lg-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-lg-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-lg-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-lg-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-lg-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-lg-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-lg-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-lg-center{-ms-flex-align:center!important;align-items:center!important}.align-items-lg-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-lg-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-lg-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-lg-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-lg-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-lg-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-lg-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-lg-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-lg-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-lg-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-lg-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-lg-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-lg-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-lg-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:1200px){.flex-xl-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-xl-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-xl-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-xl-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-xl-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-xl-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-xl-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-xl-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-xl-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-xl-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-xl-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-xl-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-xl-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-xl-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-xl-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-xl-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-xl-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-xl-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-xl-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-xl-center{-ms-flex-align:center!important;align-items:center!important}.align-items-xl-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-xl-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-xl-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-xl-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-xl-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-xl-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-xl-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-xl-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-xl-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-xl-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-xl-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-xl-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-xl-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-xl-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}@media (min-width:576px){.float-sm-left{float:left!important}.float-sm-right{float:right!important}.float-sm-none{float:none!important}}@media (min-width:768px){.float-md-left{float:left!important}.float-md-right{float:right!important}.float-md-none{float:none!important}}@media (min-width:992px){.float-lg-left{float:left!important}.float-lg-right{float:right!important}.float-lg-none{float:none!important}}@media (min-width:1200px){.float-xl-left{float:left!important}.float-xl-right{float:right!important}.float-xl-none{float:none!important}}.user-select-all{-webkit-user-select:all!important;-moz-user-select:all!important;-ms-user-select:all!important;user-select:all!important}.user-select-auto{-webkit-user-select:auto!important;-moz-user-select:auto!important;-ms-user-select:auto!important;user-select:auto!important}.user-select-none{-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.overflow-auto{overflow:auto!important}.overflow-hidden{overflow:hidden!important}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:-webkit-sticky!important;position:sticky!important}.fixed-top{top:0}.fixed-top,.fixed-bottom{position:fixed;right:0;left:0;z-index:1030}.fixed-bottom{bottom:0}@supports ((position:-webkit-sticky)or (position:sticky)){.sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal}.shadow-sm{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-lg{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none{box-shadow:none!important}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.w-auto{width:auto!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.h-auto{height:auto!important}.mw-100{max-width:100%!important}.mh-100{max-height:100%!important}.min-vw-100{min-width:100vw!important}.min-vh-100{min-height:100vh!important}.vw-100{width:100vw!important}.vh-100{height:100vh!important}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:.25rem!important}.mt-1,.my-1{margin-top:.25rem!important}.mr-1,.mx-1{margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:.25rem!important}.m-2{margin:.5rem!important}.mt-2,.my-2{margin-top:.5rem!important}.mr-2,.mx-2{margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:.5rem!important}.m-3{margin:1rem!important}.mt-3,.my-3{margin-top:1rem!important}.mr-3,.mx-3{margin-right:1rem!important}.mb-3,.my-3{margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:1rem!important}.m-4{margin:1.5rem!important}.mt-4,.my-4{margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:1.5rem!important}.m-5{margin:3rem!important}.mt-5,.my-5{margin-top:3rem!important}.mr-5,.mx-5{margin-right:3rem!important}.mb-5,.my-5{margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1{padding:.25rem!important}.pt-1,.py-1{padding-top:.25rem!important}.pr-1,.px-1{padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:.25rem!important}.p-2{padding:.5rem!important}.pt-2,.py-2{padding-top:.5rem!important}.pr-2,.px-2{padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:.5rem!important}.p-3{padding:1rem!important}.pt-3,.py-3{padding-top:1rem!important}.pr-3,.px-3{padding-right:1rem!important}.pb-3,.py-3{padding-bottom:1rem!important}.pl-3,.px-3{padding-left:1rem!important}.p-4{padding:1.5rem!important}.pt-4,.py-4{padding-top:1.5rem!important}.pr-4,.px-4{padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:1.5rem!important}.p-5{padding:3rem!important}.pt-5,.py-5{padding-top:3rem!important}.pr-5,.px-5{padding-right:3rem!important}.pb-5,.py-5{padding-bottom:3rem!important}.pl-5,.px-5{padding-left:3rem!important}.m-n1{margin:-.25rem!important}.mt-n1,.my-n1{margin-top:-.25rem!important}.mr-n1,.mx-n1{margin-right:-.25rem!important}.mb-n1,.my-n1{margin-bottom:-.25rem!important}.ml-n1,.mx-n1{margin-left:-.25rem!important}.m-n2{margin:-.5rem!important}.mt-n2,.my-n2{margin-top:-.5rem!important}.mr-n2,.mx-n2{margin-right:-.5rem!important}.mb-n2,.my-n2{margin-bottom:-.5rem!important}.ml-n2,.mx-n2{margin-left:-.5rem!important}.m-n3{margin:-1rem!important}.mt-n3,.my-n3{margin-top:-1rem!important}.mr-n3,.mx-n3{margin-right:-1rem!important}.mb-n3,.my-n3{margin-bottom:-1rem!important}.ml-n3,.mx-n3{margin-left:-1rem!important}.m-n4{margin:-1.5rem!important}.mt-n4,.my-n4{margin-top:-1.5rem!important}.mr-n4,.mx-n4{margin-right:-1.5rem!important}.mb-n4,.my-n4{margin-bottom:-1.5rem!important}.ml-n4,.mx-n4{margin-left:-1.5rem!important}.m-n5{margin:-3rem!important}.mt-n5,.my-n5{margin-top:-3rem!important}.mr-n5,.mx-n5{margin-right:-3rem!important}.mb-n5,.my-n5{margin-bottom:-3rem!important}.ml-n5,.mx-n5{margin-left:-3rem!important}.m-auto{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}@media (min-width:576px){.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-n1{margin:-.25rem!important}.mt-sm-n1,.my-sm-n1{margin-top:-.25rem!important}.mr-sm-n1,.mx-sm-n1{margin-right:-.25rem!important}.mb-sm-n1,.my-sm-n1{margin-bottom:-.25rem!important}.ml-sm-n1,.mx-sm-n1{margin-left:-.25rem!important}.m-sm-n2{margin:-.5rem!important}.mt-sm-n2,.my-sm-n2{margin-top:-.5rem!important}.mr-sm-n2,.mx-sm-n2{margin-right:-.5rem!important}.mb-sm-n2,.my-sm-n2{margin-bottom:-.5rem!important}.ml-sm-n2,.mx-sm-n2{margin-left:-.5rem!important}.m-sm-n3{margin:-1rem!important}.mt-sm-n3,.my-sm-n3{margin-top:-1rem!important}.mr-sm-n3,.mx-sm-n3{margin-right:-1rem!important}.mb-sm-n3,.my-sm-n3{margin-bottom:-1rem!important}.ml-sm-n3,.mx-sm-n3{margin-left:-1rem!important}.m-sm-n4{margin:-1.5rem!important}.mt-sm-n4,.my-sm-n4{margin-top:-1.5rem!important}.mr-sm-n4,.mx-sm-n4{margin-right:-1.5rem!important}.mb-sm-n4,.my-sm-n4{margin-bottom:-1.5rem!important}.ml-sm-n4,.mx-sm-n4{margin-left:-1.5rem!important}.m-sm-n5{margin:-3rem!important}.mt-sm-n5,.my-sm-n5{margin-top:-3rem!important}.mr-sm-n5,.mx-sm-n5{margin-right:-3rem!important}.mb-sm-n5,.my-sm-n5{margin-bottom:-3rem!important}.ml-sm-n5,.mx-sm-n5{margin-left:-3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}}@media (min-width:768px){.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-n1{margin:-.25rem!important}.mt-md-n1,.my-md-n1{margin-top:-.25rem!important}.mr-md-n1,.mx-md-n1{margin-right:-.25rem!important}.mb-md-n1,.my-md-n1{margin-bottom:-.25rem!important}.ml-md-n1,.mx-md-n1{margin-left:-.25rem!important}.m-md-n2{margin:-.5rem!important}.mt-md-n2,.my-md-n2{margin-top:-.5rem!important}.mr-md-n2,.mx-md-n2{margin-right:-.5rem!important}.mb-md-n2,.my-md-n2{margin-bottom:-.5rem!important}.ml-md-n2,.mx-md-n2{margin-left:-.5rem!important}.m-md-n3{margin:-1rem!important}.mt-md-n3,.my-md-n3{margin-top:-1rem!important}.mr-md-n3,.mx-md-n3{margin-right:-1rem!important}.mb-md-n3,.my-md-n3{margin-bottom:-1rem!important}.ml-md-n3,.mx-md-n3{margin-left:-1rem!important}.m-md-n4{margin:-1.5rem!important}.mt-md-n4,.my-md-n4{margin-top:-1.5rem!important}.mr-md-n4,.mx-md-n4{margin-right:-1.5rem!important}.mb-md-n4,.my-md-n4{margin-bottom:-1.5rem!important}.ml-md-n4,.mx-md-n4{margin-left:-1.5rem!important}.m-md-n5{margin:-3rem!important}.mt-md-n5,.my-md-n5{margin-top:-3rem!important}.mr-md-n5,.mx-md-n5{margin-right:-3rem!important}.mb-md-n5,.my-md-n5{margin-bottom:-3rem!important}.ml-md-n5,.mx-md-n5{margin-left:-3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}}@media (min-width:992px){.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-n1{margin:-.25rem!important}.mt-lg-n1,.my-lg-n1{margin-top:-.25rem!important}.mr-lg-n1,.mx-lg-n1{margin-right:-.25rem!important}.mb-lg-n1,.my-lg-n1{margin-bottom:-.25rem!important}.ml-lg-n1,.mx-lg-n1{margin-left:-.25rem!important}.m-lg-n2{margin:-.5rem!important}.mt-lg-n2,.my-lg-n2{margin-top:-.5rem!important}.mr-lg-n2,.mx-lg-n2{margin-right:-.5rem!important}.mb-lg-n2,.my-lg-n2{margin-bottom:-.5rem!important}.ml-lg-n2,.mx-lg-n2{margin-left:-.5rem!important}.m-lg-n3{margin:-1rem!important}.mt-lg-n3,.my-lg-n3{margin-top:-1rem!important}.mr-lg-n3,.mx-lg-n3{margin-right:-1rem!important}.mb-lg-n3,.my-lg-n3{margin-bottom:-1rem!important}.ml-lg-n3,.mx-lg-n3{margin-left:-1rem!important}.m-lg-n4{margin:-1.5rem!important}.mt-lg-n4,.my-lg-n4{margin-top:-1.5rem!important}.mr-lg-n4,.mx-lg-n4{margin-right:-1.5rem!important}.mb-lg-n4,.my-lg-n4{margin-bottom:-1.5rem!important}.ml-lg-n4,.mx-lg-n4{margin-left:-1.5rem!important}.m-lg-n5{margin:-3rem!important}.mt-lg-n5,.my-lg-n5{margin-top:-3rem!important}.mr-lg-n5,.mx-lg-n5{margin-right:-3rem!important}.mb-lg-n5,.my-lg-n5{margin-bottom:-3rem!important}.ml-lg-n5,.mx-lg-n5{margin-left:-3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-n1{margin:-.25rem!important}.mt-xl-n1,.my-xl-n1{margin-top:-.25rem!important}.mr-xl-n1,.mx-xl-n1{margin-right:-.25rem!important}.mb-xl-n1,.my-xl-n1{margin-bottom:-.25rem!important}.ml-xl-n1,.mx-xl-n1{margin-left:-.25rem!important}.m-xl-n2{margin:-.5rem!important}.mt-xl-n2,.my-xl-n2{margin-top:-.5rem!important}.mr-xl-n2,.mx-xl-n2{margin-right:-.5rem!important}.mb-xl-n2,.my-xl-n2{margin-bottom:-.5rem!important}.ml-xl-n2,.mx-xl-n2{margin-left:-.5rem!important}.m-xl-n3{margin:-1rem!important}.mt-xl-n3,.my-xl-n3{margin-top:-1rem!important}.mr-xl-n3,.mx-xl-n3{margin-right:-1rem!important}.mb-xl-n3,.my-xl-n3{margin-bottom:-1rem!important}.ml-xl-n3,.mx-xl-n3{margin-left:-1rem!important}.m-xl-n4{margin:-1.5rem!important}.mt-xl-n4,.my-xl-n4{margin-top:-1.5rem!important}.mr-xl-n4,.mx-xl-n4{margin-right:-1.5rem!important}.mb-xl-n4,.my-xl-n4{margin-bottom:-1.5rem!important}.ml-xl-n4,.mx-xl-n4{margin-left:-1.5rem!important}.m-xl-n5{margin:-3rem!important}.mt-xl-n5,.my-xl-n5{margin-top:-3rem!important}.mr-xl-n5,.mx-xl-n5{margin-right:-3rem!important}.mb-xl-n5,.my-xl-n5{margin-bottom:-3rem!important}.ml-xl-n5,.mx-xl-n5{margin-left:-3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}}.stretched-link::after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;pointer-events:auto;content:\"\";background-color:transparent}.text-monospace{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace!important}.text-justify{text-align:justify!important}.text-wrap{white-space:normal!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-center{text-align:center!important}@media (min-width:576px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-light{font-weight:300!important}.font-weight-lighter{font-weight:lighter!important}.font-weight-normal{font-weight:400!important}.font-weight-bold{font-weight:700!important}.font-weight-bolder{font-weight:bolder!important}.font-italic{font-style:italic!important}.text-white{color:#fff!important}.text-primary{color:#007bff!important}a.text-primary:hover,a.text-primary:focus{color:#0056b3!important}.text-secondary{color:#6c757d!important}a.text-secondary:hover,a.text-secondary:focus{color:#494f54!important}.text-success{color:#28a745!important}a.text-success:hover,a.text-success:focus{color:#19692c!important}.text-info{color:#17a2b8!important}a.text-info:hover,a.text-info:focus{color:#0f6674!important}.text-warning{color:#ffc107!important}a.text-warning:hover,a.text-warning:focus{color:#ba8b00!important}.text-danger{color:#dc3545!important}a.text-danger:hover,a.text-danger:focus{color:#a71d2a!important}.text-light{color:#f8f9fa!important}a.text-light:hover,a.text-light:focus{color:#cbd3da!important}.text-dark{color:#343a40!important}a.text-dark:hover,a.text-dark:focus{color:#121416!important}.text-body{color:#212529!important}.text-muted{color:#6c757d!important}.text-black-50{color:rgba(0,0,0,.5)!important}.text-white-50{color:rgba(255,255,255,.5)!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.text-decoration-none{text-decoration:none!important}.text-break{word-break:break-word!important;word-wrap:break-word!important}.text-reset{color:inherit!important}.visible{visibility:visible!important}.invisible{visibility:hidden!important}@media print{*,*::before,*::after{text-shadow:none!important;box-shadow:none!important}a:not(.btn){text-decoration:underline}abbr[title]::after{content:\" (\" attr(title)\")\"}pre{white-space:pre-wrap!important}pre,blockquote{border:1px solid #adb5bd}pre,blockquote,tr,img{page-break-inside:avoid}p,h2,h3{orphans:3;widows:3}h2,h3{page-break-after:avoid}@page{size:a3}body,.container{min-width:992px!important}.navbar{display:none}.badge{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered th,.table-bordered td{border:1px solid #dee2e6!important}.table-dark{color:inherit}.table-dark th,.table-dark td,.table-dark thead th,.table-dark tbody+tbody{border-color:#dee2e6}.table .thead-dark th{color:inherit;border-color:#dee2e6}}.btn-secondary{color:#333;background-color:#fff;border-color:#ccc}.btn-secondary:hover,.btn-secondary:focus,.btn-secondary.focus{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-secondary:not(:disabled):not(.disabled):active,.btn-secondary:not(:disabled):not(.disabled).active,.show>.btn-secondary.dropdown-toggle{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-secondary:disabled,.btn-secondary.disabled{color:#333;background-color:#fff;border-color:#ccc;opacity:1}#gnp-header .subMobile.navbar-light{background-color:#333;border-color:transparent}#group-list-page .row.content .card.search-panel,.daterangepicker{background-color:#fff;border-radius:4px}.daterangepicker{position:absolute;color:inherit;border:1px solid #ddd;width:278px;max-width:none;padding:0;margin-top:7px;top:100px;left:20px;z-index:3001;display:none;font-family:arial;font-size:15px;line-height:1em}.daterangepicker:before,.daterangepicker:after{position:absolute;display:inline-block;border-bottom-color:rgba(0,0,0,.2);content:''}.daterangepicker:before{top:-7px;border-right:7px solid transparent;border-left:7px solid transparent;border-bottom:7px solid #ccc}.daterangepicker:after{top:-6px;border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent}.daterangepicker.opensleft:before{right:9px}.daterangepicker.opensleft:after{right:10px}.daterangepicker.openscenter:before,.daterangepicker.openscenter:after{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.daterangepicker.opensright:before{left:9px}.daterangepicker.opensright:after{left:10px}.daterangepicker.drop-up{margin-top:-7px}.daterangepicker.drop-up:before{top:initial;bottom:-7px;border-bottom:initial;border-top:7px solid #ccc}.daterangepicker.drop-up:after{top:initial;bottom:-6px;border-bottom:initial;border-top:6px solid #fff}.daterangepicker.single .daterangepicker .ranges,.daterangepicker.single .drp-calendar{float:none}.daterangepicker.single .drp-selected{display:none}.daterangepicker.show-calendar .drp-calendar,.daterangepicker.show-calendar .drp-buttons{display:block}.daterangepicker.auto-apply .drp-buttons{display:none}.daterangepicker .drp-calendar{display:none;max-width:270px}.daterangepicker .drp-calendar.left{padding:8px 0 8px 8px}.daterangepicker .drp-calendar.right{padding:8px}.daterangepicker .drp-calendar.single .calendar-table{border:none}.daterangepicker .calendar-table .next span,.daterangepicker .calendar-table .prev span{color:#fff;border:solid #000;border-width:0 2px 2px 0;border-radius:0;display:inline-block;padding:3px}.daterangepicker .calendar-table .next span{transform:rotate(-45deg);-webkit-transform:rotate(-45deg)}.daterangepicker .calendar-table .prev span{transform:rotate(135deg);-webkit-transform:rotate(135deg)}.daterangepicker .calendar-table th,.daterangepicker .calendar-table td{text-align:center;vertical-align:middle;min-width:32px;width:32px;height:24px;line-height:24px;font-size:12px;border-radius:4px;border:1px solid transparent;white-space:nowrap;cursor:pointer}.daterangepicker .calendar-table{border:1px solid #fff;border-radius:4px;background-color:#fff}.daterangepicker .calendar-table table{width:100%;margin:0;border-spacing:0;border-collapse:collapse}.daterangepicker td.available:hover,.daterangepicker th.available:hover{background-color:#eee;border-color:transparent;color:inherit}.daterangepicker td.week,.daterangepicker th.week{font-size:80%;color:#ccc}.daterangepicker td.off,.daterangepicker td.off.in-range,.daterangepicker td.off.start-date,.daterangepicker td.off.end-date{background-color:#fff;border-color:transparent;color:#999}.daterangepicker td.in-range{background-color:#ebf4f8;border-color:transparent;color:#000;border-radius:0}.daterangepicker td.start-date{border-radius:4px 0 0 4px}.daterangepicker td.end-date{border-radius:0 4px 4px 0}.daterangepicker td.start-date.end-date{border-radius:4px}.daterangepicker td.active,.daterangepicker td.active:hover{background-color:#357ebd;border-color:transparent;color:#fff}.daterangepicker th.month{width:auto}.daterangepicker td.disabled,.daterangepicker option.disabled{color:#999;cursor:not-allowed;text-decoration:line-through}.daterangepicker select.monthselect,.daterangepicker select.yearselect{font-size:12px;padding:1px;height:auto;cursor:default}.daterangepicker select.yearselect{margin:0}.daterangepicker select.monthselect{margin:0 2% 0 0;width:56%}.daterangepicker select.yearselect{width:40%}.daterangepicker select.hourselect,.daterangepicker select.minuteselect,.daterangepicker select.secondselect,.daterangepicker select.ampmselect{width:50px;margin:0 auto;background:#eee;border:1px solid #eee;padding:2px;outline:0;font-size:12px}.daterangepicker .calendar-time{text-align:center;margin:4px auto 0;line-height:30px;position:relative}.daterangepicker .calendar-time select.disabled{color:#ccc;cursor:not-allowed}.daterangepicker .drp-buttons{clear:both;text-align:right;padding:8px;border-top:1px solid #ddd;display:none;line-height:12px;vertical-align:middle}.daterangepicker .drp-selected{display:inline-block;font-size:12px;padding-right:8px}.daterangepicker .drp-buttons .btn{margin-left:8px;font-size:12px;font-weight:700;padding:4px 8px}.daterangepicker.show-ranges.single.rtl .drp-calendar.left{border-right:1px solid #ddd}.daterangepicker.show-ranges.single.ltr .drp-calendar.left{border-left:1px solid #ddd}.daterangepicker.show-ranges.rtl .drp-calendar.right{border-right:1px solid #ddd}.daterangepicker.show-ranges.ltr .drp-calendar.left{border-left:1px solid #ddd}.daterangepicker .ranges{float:none;text-align:left;margin:0}.daterangepicker.show-calendar .ranges{margin-top:8px}.daterangepicker .ranges ul{list-style:none;margin:0 auto;padding:0;width:100%}.daterangepicker .ranges li{font-size:12px;padding:8px 12px;cursor:pointer}.daterangepicker .ranges li:hover{background-color:#eee}.daterangepicker .ranges li.active{background-color:#08c;color:#fff}@media (min-width:564px){.daterangepicker{width:auto}.daterangepicker .ranges ul{width:140px}.daterangepicker.single .ranges ul{width:100%}.daterangepicker.single .drp-calendar.left{clear:none}.daterangepicker.single .ranges,.daterangepicker.single .drp-calendar{float:left}.daterangepicker{direction:ltr;text-align:left}.daterangepicker .drp-calendar.left{clear:left;margin-right:0}.daterangepicker .drp-calendar.left .calendar-table{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}.daterangepicker .drp-calendar.right{margin-left:0}.daterangepicker .drp-calendar.right .calendar-table{border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.daterangepicker .drp-calendar.left .calendar-table{padding-right:8px}.daterangepicker .ranges,.daterangepicker .drp-calendar{float:left}}@media (min-width:730px){.daterangepicker .ranges{width:auto;float:left}.daterangepicker.rtl .ranges{float:right}.daterangepicker .drp-calendar.left{clear:none!important}}.toast-title{font-weight:700}.toast-message{-ms-word-wrap:break-word;word-wrap:break-word}.toast-message a,.toast-message label{color:#fff}.toast-message a:hover{color:#ccc;text-decoration:none}.toast-close-button{position:relative;right:-.3em;top:-.3em;float:right;font-size:20px;font-weight:700;color:#fff;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80)}.toast-close-button:hover,.toast-close-button:focus{color:#000;text-decoration:none;cursor:pointer;opacity:.4;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);filter:alpha(opacity=40)}button.toast-close-button{padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.toast-top-center{top:0;right:0;width:100%}.toast-bottom-center{bottom:0;right:0;width:100%}.toast-top-full-width{top:0;right:0;width:100%}.toast-bottom-full-width{bottom:0;right:0;width:100%}.toast-top-left{top:12px;left:12px}.toast-top-right{top:12px;right:12px}.toast-bottom-right{right:12px;bottom:12px}.toast-bottom-left{bottom:12px;left:12px}#toast-container{position:fixed;z-index:999999}#toast-container *{box-sizing:border-box}#toast-container>div{position:relative;overflow:hidden;margin:0 0 6px;padding:15px 15px 15px 50px;width:300px;border-radius:3px 3px 3px 3px;background-position:15px center;background-repeat:no-repeat;box-shadow:0 0 12px #999;color:#fff;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80)}#toast-container>:hover{box-shadow:0 0 12px #000;opacity:1;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);filter:alpha(opacity=100);cursor:pointer}#toast-container>.toast-info{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=\") !important}#toast-container>.toast-error{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=\") !important}#toast-container>.toast-success{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==\") !important}#toast-container>.toast-warning{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=\") !important}#toast-container.toast-top-center>div,#toast-container.toast-bottom-center>div{width:300px;margin:auto}#toast-container.toast-top-full-width>div,#toast-container.toast-bottom-full-width>div{width:96%;margin:auto}.toast{background-color:#030303;font-size:12px;max-width:none}.toast-success{background-color:#51a351}.toast-error{background-color:#bd362f}.toast-info{background-color:#2f96b4}.toast-warning{background-color:#f89406}.toast-progress{position:absolute;left:0;bottom:0;height:4px;background-color:#000;opacity:.4;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);filter:alpha(opacity=40)}@media all and (max-width:240px){#toast-container>div{padding:8px 8px 8px 50px;width:11em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media all and (min-width:241px) and (max-width:480px){#toast-container>div{padding:8px 8px 8px 50px;width:18em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media all and (min-width:481px) and (max-width:768px){#toast-container>div{padding:15px 15px 15px 50px;width:25em}}@keyframes ng-confirm-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}body[class*=ng-confirm-no-scroll-]{overflow:hidden!important}.ng-confirm{z-index:99999999;font-family:inherit;overflow:hidden}.ng-confirm,.ng-confirm .ng-confirm-bg{position:fixed;top:0;left:0;right:0;bottom:0}.ng-confirm .ng-confirm-bg{transition:opacity .4s,background .4s}.ng-confirm .ng-confirm-bg.ng-confirm-bg-h{opacity:0!important}.ng-confirm .ng-confirm-scrollpane{position:fixed;top:0;left:0;right:0;bottom:0;overflow-y:auto;perspective:500px;perspective-origin:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-confirm .ng-confirm-box{background:#fff;border-radius:4px;position:relative;outline:0;padding:15px 15px 0;overflow:hidden;margin-left:auto;margin-right:auto}.ng-confirm .ng-confirm-box.ng-confirm-loading{min-height:120px}.ng-confirm .ng-confirm-box.ng-confirm-loading:before{content:'';position:absolute;left:0;background:#fff;right:0;top:0;bottom:0;border-radius:10px;z-index:1}.ng-confirm .ng-confirm-box.ng-confirm-loading:after{opacity:.6;content:'';height:30px;width:30px;border:solid 3px transparent;position:absolute;left:50%;margin-left:-15px;border-radius:50%;animation:ng-confirm-spin 1s infinite linear;border-bottom-color:dodgerblue;top:50%;margin-top:-15px;z-index:2}.ng-confirm .ng-confirm-box div.ng-confirm-closeIcon{height:20px;width:20px;position:absolute;top:5px;right:5px;cursor:pointer;opacity:.6;text-align:center;transition:opacity .3s ease-in;font-size:27px!important;line-height:14px;font-family:Arial,\"Helvetica Neue\",Helvetica,sans-serif}.ng-confirm .ng-confirm-box div.ng-confirm-closeIcon:empty{display:none}.ng-confirm .ng-confirm-box div.ng-confirm-closeIcon .fa,.ng-confirm .ng-confirm-box div.ng-confirm-closeIcon .glyphicon,.ng-confirm .ng-confirm-box div.ng-confirm-closeIcon .zmdi{font-size:16px;line-height:25px;vertical-align:bottom}.ng-confirm .ng-confirm-box div.ng-confirm-closeIcon:hover{opacity:1}.ng-confirm .ng-confirm-box div.ng-confirm-title-c{display:block;font-size:22px;line-height:20px;padding-bottom:15px}.ng-confirm .ng-confirm-box div.ng-confirm-title-c .ng-confirm-icon-c{font-size:inherit;display:inline-block;vertical-align:top}.ng-confirm .ng-confirm-box div.ng-confirm-title-c .ng-confirm-icon-c i{vertical-align:middle}.ng-confirm .ng-confirm-box div.ng-confirm-title-c .ng-confirm-icon-c:empty{display:none}.ng-confirm .ng-confirm-box div.ng-confirm-title-c .ng-confirm-title{font-size:inherit;font-family:inherit;display:inline-block;vertical-align:middle;-webkit-user-select:initial;-moz-user-select:initial;-ms-user-select:initial;user-select:initial}.ng-confirm .ng-confirm-box div.ng-confirm-title-c .ng-confirm-title:empty{display:none}.ng-confirm .ng-confirm-box div.ng-confirm-content-pane{margin-bottom:15px;height:0;display:inline-block;width:100%;position:relative;overflow:hidden}.ng-confirm .ng-confirm-box div.ng-confirm-content-pane .ng-confirm-content{width:100%;height:auto;-webkit-user-select:initial;-moz-user-select:initial;-ms-user-select:initial;user-select:initial}.ng-confirm .ng-confirm-box div.ng-confirm-content-pane .ng-confirm-content img{width:100%;height:auto}.ng-confirm .ng-confirm-box div.ng-confirm-content-pane .ng-confirm-content:empty{display:none}.ng-confirm .ng-confirm-box .ng-confirm-buttons{padding-bottom:11px}.ng-confirm .ng-confirm-box .ng-confirm-buttons>button{margin-bottom:4px;margin-left:2px;margin-right:2px}.ng-confirm .ng-confirm-box .ng-confirm-buttons button{display:inline-block;padding:6px 12px;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-radius:4px;min-height:1em;outline:0;transition:opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease;-webkit-tap-highlight-color:transparent;border:0;background-image:none}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-blue{background-color:#3498db;color:#FFF;text-shadow:none;transition:background .2s}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-blue:hover{background-color:#2980b9;color:#FFF}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-green{background-color:#2ecc71;color:#FFF;text-shadow:none;transition:background .2s}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-green:hover{background-color:#27ae60;color:#FFF}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-red{background-color:#e74c3c;color:#FFF;text-shadow:none;transition:background .2s}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-red:hover{background-color:#c0392b;color:#FFF}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-orange{background-color:#f1c40f;color:#FFF;text-shadow:none;transition:background .2s}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-orange:hover{background-color:#f39c12;color:#FFF}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-default{background-color:#ecf0f1;color:#000;text-shadow:none;transition:background .2s}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-default:hover{background-color:#bdc3c7;color:#000}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-purple{background-color:#9b59b6;color:#FFF;text-shadow:none;transition:background .2s}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-purple:hover{background-color:#8e44ad;color:#FFF}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-dark{background-color:#34495e;color:#FFF;text-shadow:none;transition:background .2s}.ng-confirm .ng-confirm-box .ng-confirm-buttons button.btn-dark:hover{background-color:#2c3e50;color:#FFF}@keyframes type-blue{1%,100%{border-color:#3498db}50%{border-color:#5faee3}}@keyframes type-green{1%,100%{border-color:#2ecc71}50%{border-color:#54d98c}}@keyframes type-red{1%,100%{border-color:#e74c3c}50%{border-color:#ed7669}}@keyframes type-orange{1%,100%{border-color:#f1c40f}50%{border-color:#f4d03f}}@keyframes type-purple{1%,100%{border-color:#9b59b6}50%{border-color:#b07cc6}}@keyframes type-dark{1%,100%{border-color:#34495e}50%{border-color:#46627f}}.ng-confirm.ng-confirm-type-animated .ng-confirm-box{animation-duration:2s;animation-iteration-count:infinite}.ng-confirm.ng-confirm-type-blue .ng-confirm-box{border-top:solid 7px #3498db;animation-name:type-blue}.ng-confirm.ng-confirm-type-green .ng-confirm-box{border-top:solid 7px #2ecc71;animation-name:type-green}.ng-confirm.ng-confirm-type-red .ng-confirm-box{border-top:solid 7px #e74c3c;animation-name:type-red}.ng-confirm.ng-confirm-type-orange .ng-confirm-box{border-top:solid 7px #f1c40f;animation-name:type-orange}.ng-confirm.ng-confirm-type-purple .ng-confirm-box{border-top:solid 7px #9b59b6;animation-name:type-purple}.ng-confirm.ng-confirm-type-dark .ng-confirm-box{border-top:solid 7px #34495e;animation-name:type-dark}.ng-confirm .ng-confirm-clear{clear:both}.ng-confirm.ng-confirm-rtl{direction:rtl}.ng-confirm .ng-confirm-box.ng-confirm-hilight.ng-confirm-hilight-shake{animation:shake .82s cubic-bezier(.36,.07,.19,.97)both;transform:translate3d(0,0,0)}.ng-confirm .ng-confirm-box.ng-confirm-hilight.ng-confirm-hilight-glow{animation:glow .82s cubic-bezier(.36,.07,.19,.97)both;transform:translate3d(0,0,0)}@keyframes shake{10%,90%{transform:translate3d(-2px,0,0)}20%,80%{transform:translate3d(4px,0,0)}30%,50%,70%{transform:translate3d(-8px,0,0)}40%,60%{transform:translate3d(8px,0,0)}}@keyframes glow{0%,100%{box-shadow:0 0 3px red}50%{box-shadow:0 0 30px red}}.ng-confirm{perspective:400px}.ng-confirm .ng-confirm-box{opacity:1}.ng-confirm .ng-confirm-box.ng-confirm-animation-top,.ng-confirm .ng-confirm-box.ng-confirm-animation-left,.ng-confirm .ng-confirm-box.ng-confirm-animation-right,.ng-confirm .ng-confirm-box.ng-confirm-animation-bottom,.ng-confirm .ng-confirm-box.ng-confirm-animation-opacity,.ng-confirm .ng-confirm-box.ng-confirm-animation-zoom,.ng-confirm .ng-confirm-box.ng-confirm-animation-scale,.ng-confirm .ng-confirm-box.ng-confirm-animation-none,.ng-confirm .ng-confirm-box.ng-confirm-animation-rotate,.ng-confirm .ng-confirm-box.ng-confirm-animation-rotatex,.ng-confirm .ng-confirm-box.ng-confirm-animation-rotatey,.ng-confirm .ng-confirm-box.ng-confirm-animation-scaley,.ng-confirm .ng-confirm-box.ng-confirm-animation-scalex{opacity:0}.ng-confirm .ng-confirm-box.ng-confirm-animation-rotate{transform:rotate(90deg)}.ng-confirm .ng-confirm-box.ng-confirm-animation-rotatex{transform:rotateX(90deg);transform-origin:center}.ng-confirm .ng-confirm-box.ng-confirm-animation-rotatexr{transform:rotateX(-90deg);transform-origin:center}.ng-confirm .ng-confirm-box.ng-confirm-animation-rotatey{transform:rotatey(90deg);transform-origin:center}.ng-confirm .ng-confirm-box.ng-confirm-animation-rotateyr{transform:rotatey(-90deg);transform-origin:center}.ng-confirm .ng-confirm-box.ng-confirm-animation-scaley{transform:scaley(1.5);transform-origin:center}.ng-confirm .ng-confirm-box.ng-confirm-animation-scalex{transform:scalex(1.5);transform-origin:center}.ng-confirm .ng-confirm-box.ng-confirm-animation-top{transform:translate(0,-100px)}.ng-confirm .ng-confirm-box.ng-confirm-animation-left{transform:translate(-100px,0)}.ng-confirm .ng-confirm-box.ng-confirm-animation-right{transform:translate(100px,0)}.ng-confirm .ng-confirm-box.ng-confirm-animation-bottom{transform:translate(0,100px)}.ng-confirm .ng-confirm-box.ng-confirm-animation-zoom{transform:scale(1.2)}.ng-confirm .ng-confirm-box.ng-confirm-animation-scale{transform:scale(.5)}.ng-confirm .ng-confirm-box.ng-confirm-animation-none{visibility:hidden}.ng-confirm.ng-confirm-light .ng-confirm-bg,.ng-confirm.ng-confirm-white .ng-confirm-bg{background-color:#444;opacity:.2}.ng-confirm.ng-confirm-light .ng-confirm-icon-c,.ng-confirm.ng-confirm-white .ng-confirm-icon-c{margin-right:8px}.ng-confirm.ng-confirm-light.ng-confirm-rtl .ng-confirm-closeIcon,.ng-confirm.ng-confirm-white.ng-confirm-rtl .ng-confirm-closeIcon{left:5px!important;right:auto!important}.ng-confirm.ng-confirm-light.ng-confirm-rtl .ng-confirm-icon-c,.ng-confirm.ng-confirm-white.ng-confirm-rtl .ng-confirm-icon-c{margin-right:0;margin-left:8px}.ng-confirm.ng-confirm-light .ng-confirm-box,.ng-confirm.ng-confirm-white .ng-confirm-box{box-shadow:0 2px 6px rgba(0,0,0,.2);border-radius:5px}.ng-confirm.ng-confirm-light .ng-confirm-box .ng-confirm-closeIcon,.ng-confirm.ng-confirm-white .ng-confirm-box .ng-confirm-closeIcon{line-height:20px}.ng-confirm.ng-confirm-light .ng-confirm-box .ng-confirm-buttons,.ng-confirm.ng-confirm-white .ng-confirm-box .ng-confirm-buttons{float:right}.ng-confirm.ng-confirm-light .ng-confirm-box .ng-confirm-buttons button,.ng-confirm.ng-confirm-white .ng-confirm-box .ng-confirm-buttons button{border:0;background-image:none;text-transform:uppercase;font-size:14px;font-weight:700;text-shadow:none;transition:background .1s;color:#fff}.ng-confirm.ng-confirm-light .ng-confirm-box .ng-confirm-buttons button.btn-default,.ng-confirm.ng-confirm-white .ng-confirm-box .ng-confirm-buttons button.btn-default{box-shadow:none;color:#333}.ng-confirm.ng-confirm-light .ng-confirm-box .ng-confirm-buttons button.btn-default:hover,.ng-confirm.ng-confirm-white .ng-confirm-box .ng-confirm-buttons button.btn-default:hover{background:#ddd}.ng-confirm.ng-confirm-dark .ng-confirm-bg,.ng-confirm.ng-confirm-black .ng-confirm-bg{background-color:darkslategray;opacity:.4}.ng-confirm.ng-confirm-dark .ng-confirm-icon-c,.ng-confirm.ng-confirm-black .ng-confirm-icon-c{margin-right:8px}.ng-confirm.ng-confirm-dark.ng-confirm-rtl .ng-confirm-closeIcon,.ng-confirm.ng-confirm-black.ng-confirm-rtl .ng-confirm-closeIcon{left:5px!important;right:auto!important}.ng-confirm.ng-confirm-dark.ng-confirm-rtl .ng-confirm-icon-c,.ng-confirm.ng-confirm-black.ng-confirm-rtl .ng-confirm-icon-c{margin-right:0;margin-left:8px}.ng-confirm.ng-confirm-dark .ng-confirm-box,.ng-confirm.ng-confirm-black .ng-confirm-box{box-shadow:0 2px 6px rgba(0,0,0,.2);background:#444;border-radius:5px}.ng-confirm.ng-confirm-dark .ng-confirm-box .ng-confirm-closeIcon,.ng-confirm.ng-confirm-black .ng-confirm-box .ng-confirm-closeIcon{line-height:20px}.ng-confirm.ng-confirm-dark .ng-confirm-box.ng-confirm-loading:before,.ng-confirm.ng-confirm-black .ng-confirm-box.ng-confirm-loading:before{background:#444}.ng-confirm.ng-confirm-dark .ng-confirm-box.ng-confirm-loading:after,.ng-confirm.ng-confirm-black .ng-confirm-box.ng-confirm-loading:after{border-bottom-color:deepskyblue}.ng-confirm.ng-confirm-dark .ng-confirm-box *:not(input):not(textarea):not(select):not(option),.ng-confirm.ng-confirm-black .ng-confirm-box *:not(input):not(textarea):not(select):not(option){color:#fff}.ng-confirm.ng-confirm-dark .ng-confirm-box input,.ng-confirm.ng-confirm-black .ng-confirm-box input,.ng-confirm.ng-confirm-dark .ng-confirm-box textarea,.ng-confirm.ng-confirm-black .ng-confirm-box textarea,.ng-confirm.ng-confirm-dark .ng-confirm-box select,.ng-confirm.ng-confirm-black .ng-confirm-box select,.ng-confirm.ng-confirm-dark .ng-confirm-box option,.ng-confirm.ng-confirm-black .ng-confirm-box option{color:initial}.ng-confirm.ng-confirm-dark .ng-confirm-box .ng-confirm-buttons,.ng-confirm.ng-confirm-black .ng-confirm-box .ng-confirm-buttons{float:right}.ng-confirm.ng-confirm-dark .ng-confirm-box .ng-confirm-buttons button,.ng-confirm.ng-confirm-black .ng-confirm-box .ng-confirm-buttons button{border:0;background-image:none;text-transform:uppercase;font-size:14px;font-weight:700;text-shadow:none;transition:background .1s;color:#fff}.ng-confirm.ng-confirm-dark .ng-confirm-box .ng-confirm-buttons button.btn-default,.ng-confirm.ng-confirm-black .ng-confirm-box .ng-confirm-buttons button.btn-default{box-shadow:none;color:#fff;background:0}.ng-confirm.ng-confirm-dark .ng-confirm-box .ng-confirm-buttons button.btn-default:hover,.ng-confirm.ng-confirm-black .ng-confirm-box .ng-confirm-buttons button.btn-default:hover{background:#666}.ng-confirm.ng-confirm-supervan .ng-confirm-bg{background:#36465d;opacity:.99}.ng-confirm.ng-confirm-supervan.ng-confirm-type-blue .ng-confirm-box{border:0}.ng-confirm.ng-confirm-supervan.ng-confirm-type-blue .ng-confirm-bg{background:#217dbb}.ng-confirm.ng-confirm-supervan.ng-confirm-type-green .ng-confirm-box{border:0}.ng-confirm.ng-confirm-supervan.ng-confirm-type-green .ng-confirm-bg{background:#25a25a}.ng-confirm.ng-confirm-supervan.ng-confirm-type-red .ng-confirm-box{border:0}.ng-confirm.ng-confirm-supervan.ng-confirm-type-red .ng-confirm-bg{background:#d62c1a}.ng-confirm.ng-confirm-supervan.ng-confirm-type-orange .ng-confirm-box{border:0}.ng-confirm.ng-confirm-supervan.ng-confirm-type-orange .ng-confirm-bg{background:#c29d0b}.ng-confirm.ng-confirm-supervan.ng-confirm-type-purple .ng-confirm-box{border:0}.ng-confirm.ng-confirm-supervan.ng-confirm-type-purple .ng-confirm-bg{background:#804399}.ng-confirm.ng-confirm-supervan.ng-confirm-type-dark .ng-confirm-box{border:0}.ng-confirm.ng-confirm-supervan.ng-confirm-type-dark .ng-confirm-bg{background:#222f3d}.ng-confirm.ng-confirm-supervan .ng-confirm-box{background-color:transparent}.ng-confirm.ng-confirm-supervan .ng-confirm-box.ng-confirm-loading:before{background:0 0}.ng-confirm.ng-confirm-supervan .ng-confirm-box.ng-confirm-loading:after{border-bottom-color:transparent}.ng-confirm.ng-confirm-supervan .ng-confirm-box div.ng-confirm-closeIcon{border-radius:50px;height:26px;width:26px;line-height:26px;top:2px;right:2px;box-shadow:0 0 0 2px #ddd}.ng-confirm.ng-confirm-supervan .ng-confirm-box *:not(input):not(textarea):not(select):not(option){color:#fff}.ng-confirm.ng-confirm-supervan .ng-confirm-box input,.ng-confirm.ng-confirm-supervan .ng-confirm-box textarea,.ng-confirm.ng-confirm-supervan .ng-confirm-box select,.ng-confirm.ng-confirm-supervan .ng-confirm-box option{color:initial}.ng-confirm.ng-confirm-supervan .ng-confirm-box div.ng-confirm-closeIcon{color:#fff}.ng-confirm.ng-confirm-supervan .ng-confirm-box div.ng-confirm-title-c{text-align:center;font-size:28px;font-weight:400;padding-bottom:25px}.ng-confirm.ng-confirm-supervan .ng-confirm-box div.ng-confirm-title-c>*{display:block}.ng-confirm.ng-confirm-supervan .ng-confirm-box div.ng-confirm-title-c .ng-confirm-icon-c{margin:0 0 20px;font-size:50px}.ng-confirm.ng-confirm-supervan .ng-confirm-box div.ng-confirm-content-pane{margin-bottom:25px}.ng-confirm.ng-confirm-supervan .ng-confirm-box div.ng-confirm-content,.ng-confirm.ng-confirm-supervan .ng-confirm-box .ng-confirm-buttons{text-align:center}.ng-confirm.ng-confirm-supervan .ng-confirm-box .ng-confirm-buttons button{font-size:16px;border-radius:2px;text-shadow:none;border:0;color:#fff;padding:10px;min-width:100px}.ng-confirm.ng-confirm-supervan .ng-confirm-box .ng-confirm-buttons button.btn-default{background:#303f53}.ng-confirm.ng-confirm-supervan .ng-confirm-box .ng-confirm-buttons button.btn-default:hover{background:#2f3c50;color:#fff}.ng-confirm.ng-confirm-material .ng-confirm-bg{background:dimgray;opacity:.6}.ng-confirm.ng-confirm-material .ng-confirm-icon-c{margin-right:8px}.ng-confirm.ng-confirm-material .ng-confirm-box{background-color:#fff;box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 13px 19px 2px rgba(0,0,0,.14),0 5px 24px 4px rgba(0,0,0,.12);padding:30px 25px 10px}.ng-confirm.ng-confirm-material .ng-confirm-box div.ng-confirm-closeIcon{color:rgba(0,0,0,.87);line-height:20px;top:15px;right:15px}.ng-confirm.ng-confirm-material .ng-confirm-box div.ng-confirm-title-c{color:rgba(0,0,0,.87);font-size:22px;font-weight:700}.ng-confirm.ng-confirm-material .ng-confirm-box div.ng-confirm-content{text-align:left;color:rgba(0,0,0,.87)}.ng-confirm.ng-confirm-material .ng-confirm-box .ng-confirm-buttons{text-align:right}.ng-confirm.ng-confirm-material .ng-confirm-box .ng-confirm-buttons button{text-transform:uppercase;font-weight:500}.ng-confirm.ng-confirm-material.ng-confirm-rtl .ng-confirm-closeIcon{left:15px!important;right:auto!important}.ng-confirm.ng-confirm-material.ng-confirm-rtl .ng-confirm-icon-c{margin-right:0;margin-left:8px}.ng-confirm.ng-confirm-bootstrap .ng-confirm-bg{background-color:rgba(0,0,0,.21)}.ng-confirm.ng-confirm-bootstrap .ng-confirm-icon-c{margin-right:8px}.ng-confirm.ng-confirm-bootstrap .ng-confirm-box{background-color:#fff;box-shadow:0 3px 8px 0 rgba(0,0,0,.2);border:solid 1px rgba(0,0,0,.4);padding:15px 0 0;border-radius:6px}.ng-confirm.ng-confirm-bootstrap .ng-confirm-box div.ng-confirm-closeIcon{color:rgba(0,0,0,.87);line-height:20px}.ng-confirm.ng-confirm-bootstrap .ng-confirm-box div.ng-confirm-title-c{color:rgba(0,0,0,.87);font-size:22px;font-weight:700;padding-left:15px;padding-right:15px}.ng-confirm.ng-confirm-bootstrap .ng-confirm-box div.ng-confirm-content{text-align:left;color:rgba(0,0,0,.87);padding:0 15px}.ng-confirm.ng-confirm-bootstrap .ng-confirm-box .ng-confirm-buttons{text-align:right;padding:15px;margin:-5px 0 0;border-top:solid 1px #ddd;overflow:hidden;border-radius:0 0 4px 4px}.ng-confirm.ng-confirm-bootstrap .ng-confirm-box .ng-confirm-buttons button{font-weight:500;border-radius:0;margin:0}.ng-confirm.ng-confirm-bootstrap .ng-confirm-box .ng-confirm-buttons button:first-child{border-radius:4px 0 0 4px}.ng-confirm.ng-confirm-bootstrap .ng-confirm-box .ng-confirm-buttons button:last-child{border-radius:0 4px 4px 0}.ng-confirm.ng-confirm-bootstrap.ng-confirm-rtl .ng-confirm-closeIcon{left:5px!important;right:auto!important}.ng-confirm.ng-confirm-bootstrap.ng-confirm-rtl .ng-confirm-icon-c{margin-right:0;margin-left:8px}.ng-confirm.ng-confirm-modern .ng-confirm-bg{background-color:slategray;opacity:.6}.ng-confirm.ng-confirm-modern .ng-confirm-icon-c{margin-right:8px}.ng-confirm.ng-confirm-modern .ng-confirm-box{background-color:#fff;box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 13px 19px 2px rgba(0,0,0,.14),0 5px 24px 4px rgba(0,0,0,.12);padding:25px 25px 10px}.ng-confirm.ng-confirm-modern .ng-confirm-box div.ng-confirm-closeIcon{color:rgba(0,0,0,.87);border-radius:50px;height:25px;width:25px;line-height:25px!important;top:10px;right:10px;box-shadow:0 0 0 2px #ddd}.ng-confirm.ng-confirm-modern .ng-confirm-box div.ng-confirm-title-c{color:rgba(0,0,0,.87);font-size:24px;font-weight:700;text-align:center;margin-bottom:10px}.ng-confirm.ng-confirm-modern .ng-confirm-box div.ng-confirm-title-c .ng-confirm-icon-c{display:block;margin-right:0;margin-left:0;margin-bottom:10px;font-size:69px;color:#aaa}.ng-confirm.ng-confirm-modern .ng-confirm-box div.ng-confirm-content{font-size:15px;color:#777;margin-bottom:25px}.ng-confirm.ng-confirm-modern .ng-confirm-box .ng-confirm-buttons{text-align:center}.ng-confirm.ng-confirm-modern .ng-confirm-box .ng-confirm-buttons button{font-weight:700;text-transform:uppercase;transition:background .1s}.ng-confirm.ng-confirm-modern .ng-confirm-box .ng-confirm-buttons button+button{margin-left:4px}.ng-confirm.ng-confirm-seamless .ng-confirm-bg{background-color:rgba(255,255,255,.5)}.ng-confirm.ng-confirm-seamless .ng-confirm-bg:before{border-bottom-color:dodgerblue}.ng-confirm.ng-confirm-seamless .ng-confirm-icon-c{margin-right:8px}.ng-confirm.ng-confirm-seamless .ng-confirm-box{background-color:#fff;box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 13px 19px 2px rgba(0,0,0,.14),0 5px 24px 4px rgba(0,0,0,.12);padding:20px 0 10px}.ng-confirm.ng-confirm-seamless .ng-confirm-box div.ng-confirm-closeIcon{color:rgba(0,0,0,.87);border-radius:50px;height:25px;width:25px;line-height:25px!important;top:10px;right:10px;box-shadow:0 0 0 2px #ddd}.ng-confirm.ng-confirm-seamless .ng-confirm-box div.ng-confirm-title-c{color:rgba(0,0,0,.87);font-size:24px;text-align:center}.ng-confirm.ng-confirm-seamless .ng-confirm-box div.ng-confirm-title-c .ng-confirm-icon-c{color:#aaa}.ng-confirm.ng-confirm-seamless .ng-confirm-box div.ng-confirm-title-c .ng-confirm-title{font-weight:700}.ng-confirm.ng-confirm-seamless .ng-confirm-box div.ng-confirm-content{text-align:center;font-size:15px;color:#464646;margin-bottom:25px}.ng-confirm.ng-confirm-seamless .ng-confirm-box .ng-confirm-buttons{text-align:center}.ng-confirm.ng-confirm-seamless .ng-confirm-box .ng-confirm-buttons button{font-size:16px;font-weight:700}.ng-confirm.ng-confirm-seamless .ng-confirm-box .ng-confirm-buttons button+button{margin-left:4px}.ng-confirm-el-hide{display:none!important}body{background-color:#e5e5e5;background-repeat:repeat;color:#555;font-size:12px}body .modal-dialog{margin-top:100px}body .fade:not(.show){opacity:inherit}body .fade.in,body .fade.show{opacity:1}body .modal-backdrop.fade.in,body .modal-backdrop.fade.show{opacity:.5}body .fade{transition:opacity .15s linear}body .modal.fade.in .modal-dialog,body .modal.fade.show .modal-dialog{transform:translate3d(0,0,0)}body .modal .modal-content .modal-header button{margin:0}body .dropdown-toggle::after{display:none}body .dropdown-menu{margin:2px 0 0}body .dropdown-menu>li>a,body .dropdown-menu .dropdown-item{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857;color:#333;white-space:nowrap}body button{color:inherit}body .btn{font-size:14px;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;line-height:1.42857;border-radius:4px;background-color:#efefef}body .form-control{font-size:14px;height:34px}body label{font-weight:700}body .card-title{margin-top:0;margin-bottom:0;font-size:16px}body .caret{width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent}body .nav-tabs>li>a{margin-right:2px;line-height:1.42857;border:1px solid transparent;border-radius:4px 4px 0 0;padding:10px 15px}body .col-form-label{text-align:right;margin-bottom:0;padding-top:7px}body h5,body .h5{font-size:14px}body h4,body .h4,body h5,body .h5,body h6,body .h6{margin-top:10px;margin-bottom:10px}body a{color:#428bca}body .panel-title{margin-top:0;margin-bottom:0;font-size:16px}body p{margin:0 0 10px}body h6,body .h6{font-size:12px}body a:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px;color:#428bca;text-decoration:underline}body .label{font-weight:700}body .dropdown-menu>.active>a,body .dropdown-menu>.active>a:hover,body .dropdown-menu>.active>a:focus{color:#fff;text-decoration:none;outline:0;background-color:#428bca}body .dropdown-menu>li>a:hover,body .dropdown-menu>li>a:focus{text-decoration:none;color:#262626;background-color:#f5f5f5}@media (min-width:1080px){body{min-width:1048px}}@media (max-width:1079px){body{min-width:unset}}.hide-header{display:none!important}.inactive{pointer-events:none;cursor:default}input.ng-invalid.ng-dirty{border:1px solid red}input[type=number]{-moz-appearance:textfield;ime-mode:disabled}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.fade:not(.in):not(.show){opacity:1!important}#gnp-header{position:relative;width:100%;height:74px}#gnp-header.with-submenu{height:150px;background-color:#333}#gnp-header.dark-gray{background-color:#c2cccc}#gnp-header .fixed-bg{position:fixed;z-index:99999;background-color:#1a1a1a;width:100%;height:70px;box-shadow:0 5px 5px #000}#gnp-header .fixed-bg-white{position:fixed;z-index:99999;background-color:#fff;width:100%;height:70px;box-shadow:0 3px 3px rgba(0,0,0,.5)}#gnp-header .club-header-title-large{font-size:24px}#gnp-header .club-header-title-large,#gnp-header .club-header-title-small{font-weight:500;line-height:1.1;margin-top:10px;margin-left:10px;color:#3EBCA6}#gnp-header .club-header-title-small{font-size:18px}#gnp-header .smallMenu{padding-left:15px;padding-right:5px;width:100%}#gnp-header .smallMenu a.small-logo{float:left;background-size:60px;background-image:url("+__webpack_require__(8)+")}#gnp-header .smallMenu a.small-logo,#gnp-header .smallMenu button.rightMenu{position:relative;background-repeat:no-repeat;background-position:center;width:70px;height:70px}#gnp-header .smallMenu button.rightMenu{float:right;background-image:url("+__webpack_require__(9)+");background-size:30px;background-color:#fff;border-color:transparent}#gnp-header .smallMenu .popUpMenu{position:absolute;top:70px;right:0;width:320px;min-height:200px;background-color:#fff;border:1px solid gray;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}#gnp-header .smallMenu .popUpMenu .item{padding:5px;font-size:15px;width:100%;text-align:center}#gnp-header .smallMenu .popUpMenu .item:hover{cursor:pointer;opacity:.7}#gnp-header .smallMenu .popUpMenu .item.nameContainer{font-size:18px;font-weight:700}#gnp-header .container{position:relative;height:100%}#gnp-header .container .logo{position:absolute;height:70px;width:100px;background-size:80px;background-image:url("+__webpack_require__(10)+");background-position:center;background-repeat:no-repeat}#gnp-header .container .ad{position:absolute;top:7px;left:130px;width:468px;height:60px;background-color:#fff}#gnp-header .container .btn-section{position:absolute;top:17px;right:50px}#gnp-header .container .btn-section .link-button{background-color:#d9d9d9;box-shadow:0 1px 1px #d9d9d9;border:1px solid #d9d9d9;padding:0 8px;height:37px;line-height:37px;text-align:center;cursor:pointer;text-decoration:none;display:inline-block;color:#1badac}#gnp-header .container .btn-section .link-button:focus{color:#428bca}#gnp-header .container .btn-section .myscore{margin-right:12px}#gnp-header .container .user{position:absolute;top:17px;right:0;width:36px;height:36px;background-image:url("+__webpack_require__(11)+")}#gnp-header .container .user.hide-background{background-image:unset}#gnp-header .container .help{position:absolute;top:17px;right:0;width:36px;height:36px;background-image:url("+__webpack_require__(12)+")}#gnp-header .tooltip-help{position:absolute;top:52px;left:50%;margin-left:335px;width:154px;height:102px;background-image:url("+__webpack_require__(13)+");z-index:99999}#gnp-header .tooltip-help.signin{width:312px;height:232px;background-image:url("+__webpack_require__(14)+")}#gnp-header .tooltip-help ul{position:absolute;top:30px;left:10px;font-size:12px;font-weight:700;list-style-type:none;line-height:25px}#gnp-header .tooltip-help ul a{color:#FF5D00;text-decoration:none}#gnp-header .tooltip-help ul a:hover{color:#FF5D00;text-decoration:underline}#gnp-header .tooltip-help2{position:absolute;top:52px;left:50%;margin-left:176px;width:312px;height:232px;background-image:url("+__webpack_require__(14)+");z-index:99999}#gnp-header .tooltip-help2 .avatar{position:absolute;width:80px;height:80px;left:20px;top:40px}#gnp-header .tooltip-help2 .avatar img{width:100%;height:100%}#gnp-header .tooltip-help2 .popup-name{position:absolute;margin-top:25px;margin-left:115px}#gnp-header .tooltip-help2 .popup-name .name-space{position:relative;width:170px;height:65px;display:table-cell;vertical-align:middle}#gnp-header .tooltip-help2 .popup-name .name-space .name{position:relative;color:#000;font-size:16px;font-weight:700}#gnp-header .tooltip-help2 .group-link{position:absolute;top:80px;left:115px;width:180px;height:60px;font-size:12px;font-weight:700}#gnp-header .tooltip-help2 .group-link a{color:#FF5D00;text-decoration:none}#gnp-header .tooltip-help2 .group-link a:hover{color:#FF5D00;text-decoration:underline}#gnp-header .tooltip-help2 .group-link .link1{position:absolute}#gnp-header .tooltip-help2 .group-link .link2{position:absolute;left:80px}#gnp-header .tooltip-help2 .group-link .link3{position:absolute;top:30px}#gnp-header .tooltip-help2 .group-link .link4{position:absolute;top:30px;left:80px}#gnp-header .tooltip-help2 .btn-account-setting,#gnp-header .tooltip-help2 .btn-sign-out{position:absolute;bottom:25px;height:30px;line-height:30px;text-align:center;font-size:12px;color:#8D8D8D;background-color:#D9D9D9;cursor:pointer}#gnp-header .tooltip-help2 .btn-account-setting{width:120px;left:30px}#gnp-header .tooltip-help2 .btn-sign-out{width:100px;right:30px}#gnp-header .submenu{position:absolute;top:80px;width:100%;height:70px}#gnp-header .submenu .btn-add-group{background-image:url("+__webpack_require__(15)+");font-size:11px}#gnp-header .submenu .btn-add-group,#gnp-header .submenu .btn-add-score{position:absolute;left:0;bottom:0;width:100px;height:54px;text-align:center;color:#fff;line-height:75px;text-decoration:none}#gnp-header .submenu .btn-add-score{background-image:url("+__webpack_require__(16)+");font-size:12px}#gnp-header .submenu .btn-add-score.free{opacity:.2}#gnp-header .submenu .menu{position:absolute;top:0;left:50%;width:140px;height:70px;overflow:hidden;background:url("+__webpack_require__(17)+") no-repeat;font-size:14px;text-align:center;color:#929292;line-height:105px;text-decoration:none}#gnp-header .submenu .menu.dashboard{margin-left:-210px}#gnp-header .submenu .menu.dashboard.active{background-position:0 -70px;color:#00B1AF}#gnp-header .submenu .menu.history{margin-left:-70px;background-position:-140px 0}#gnp-header .submenu .menu.history.active{background-position:-140px -70px;color:#00B1AF}#gnp-header .submenu .menu.analysis{margin-left:70px;background-position:-280px 0}#gnp-header .submenu .menu.analysis.active{background-position:-280px -70px;color:#00B1AF}#gnp-header .submenu .menu.groups{margin-left:210px;background-position:-420px 0}#gnp-header .submenu .menu.groups.active{background-position:-420px -70px;color:#00B1AF}#gnp-header .submenu .help-circle.header{position:absolute;width:42px;height:42px;left:75px;top:0;background-image:url("+__webpack_require__(18)+")}#gnp-header .subMobile{top:72px;background-color:#333;border-bottom:0;z-index:99;position:fixed;width:100%;padding:0;margin-bottom:20px}#gnp-header .subMobile .container-fluid,#gnp-header .subMobile .container-sm,#gnp-header .subMobile .container-md,#gnp-header .subMobile .container-lg,#gnp-header .subMobile .container-xl{padding:0}#gnp-header .subMobile .nav{width:100%}#gnp-header .subMobile .nav-pills>li{width:25%;height:77px;background-repeat:no-repeat;background-position:center;background-size:30px;background-position-y:15px}#gnp-header .subMobile .nav-pills>li+li{margin-left:0}#gnp-header .subMobile .nav-pills>li>a{width:100%;height:100%;background-color:transparent;padding:0}#gnp-header .subMobile .nav-pills>li>a>span{text-align:center;position:absolute;bottom:0;width:100%;color:#929292}@media (max-width:340px){#gnp-header .subMobile .nav-pills>li>a>span{font-size:11px}}#gnp-header .subMobile li.dashboard{background-image:url("+__webpack_require__(19)+")}#gnp-header .subMobile li.dashboard.activeTab{background-image:url("+__webpack_require__(20)+")}#gnp-header .subMobile li.history{background-image:url("+__webpack_require__(21)+")}#gnp-header .subMobile li.history.activeTab{background-image:url("+__webpack_require__(22)+")}#gnp-header .subMobile li.analysis{background-image:url("+__webpack_require__(23)+")}#gnp-header .subMobile li.analysis.activeTab{background-image:url("+__webpack_require__(24)+")}#gnp-header .subMobile li.groups{background-position-y:10px;background-size:40px;background-image:url("+__webpack_require__(25)+")}#gnp-header .subMobile li.groups.activeTab{background-image:url("+__webpack_require__(26)+")}#gnp-header .subMobile .activeTab{background-color:#1a1a1a;border-bottom:3px solid #00B1AF;margin-top:1px}#gnp-header .subMobile .activeTab a>span{color:#00B1AF!important}#terms_of_use-modal .modal-body{font-weight:400}#terms_of_use-modal .modal-body .content{padding:15px}#terms_of_use-modal .modal-body .content a{color:#555}#terms_of_use-modal .modal-body .content .custom-checkbox-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;width:20px;height:20px;border:1px solid #333;border-radius:5px;position:relative}#terms_of_use-modal .modal-body .content .custom-checkbox-term:checked::before{font-family:'Arial','Segoe UI Symbol',sans-serif;content:\"✔\";font-size:15px;color:#fff;background-color:#10A6A6;position:absolute;left:-1px;top:-1px;width:21px;text-align:center;border-radius:5px;border:1px solid #10A6A6}#terms_of_use-modal .modal-body .content h6 span{margin-left:5px;position:relative;top:-5px}#terms_of_use-modal .modal-footer{border-top:none;text-align:center;display:block}#terms_of_use-modal .modal-footer .btn-secondary{background-color:#0FBCA6;color:#fff;padding:6px 30px;border-radius:8px}#terms_of_use-modal .modal-footer .btn-secondary:disabled{background-color:#ccc}.avatarContainer{position:relative;text-align:center}.avatarContainer .avatar-image{width:20%}.avatarContainer .avatar-image.is-full{width:100%}.avatarContainer .avatar-image-text{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);color:#fff;font-size:20px;white-space:nowrap}.avatarContainer .avatar-image-text.is-small{font-size:20px}.avatarContainer .avatar-image-text.is-small.two-characters{font-size:12px}.avatarContainer .avatar-image-text.two-characters{font-size:20px}.avatarContainer .avatar-image-text.one-character{font-size:40px}@media (max-width:414px){.avatarContainer .avatar-image-text.two-characters{font-size:15px}.avatarContainer .avatar-image-text.one-character{font-size:30px}}@media (min-width:768px){#gnp-footer .container.gnp-footer-container{width:750px}}@media (min-width:992px){#gnp-footer .container.gnp-footer-container{width:970px}}@media (min-width:1200px){#gnp-footer .container.gnp-footer-container{width:1170px}}#gnp-footer{width:100%;background-color:#333;margin-top:20px}#gnp-footer .ads-wrap{padding-top:20px}#gnp-footer .ad{margin-top:20px;text-align:center}#gnp-footer .ad .ad-footer{margin-top:10px}#gnp-footer .sitemap{height:30px;margin-top:40px}#gnp-footer .sitemap a,#gnp-footer .sitemap a:hover{color:#fff;text-decoration:none;font-size:9px}#gnp-footer .sitemap .separator{margin:0 5px}#gnp-footer .copyright{position:relative;margin-top:40px;height:30px;color:#fff;font-size:9px;text-align:right}.content-message{margin-top:10px;margin-bottom:10px}.content-message .message{position:relative;border-radius:10px}.content-message .message ul,.content-message .message ol{margin:0}#toast-container{line-height:20px}#toast-container>div{opacity:1!important}.ellipsis{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#contents{margin:0 auto;padding:10px 0 50px;width:100%;height:700px;background-color:#e2e296}#pay_modal-main .container{min-height:600px;width:798px}#pay_modal-main .container .content{position:absolute;margin:-300px 0 0 -399px;top:50%;left:50%;min-height:600px;width:798px;background-color:#fff;z-index:5}#pay_modal-main .container .content .blank{height:55px;padding:0;opacity:0}#pay_modal-main .container .content .row{padding:0;margin:0}#pay_modal-main .container .content .paragraph{padding-top:10px;padding-bottom:10px}#pay_modal-main .container .content .note{color:red;text-decoration:underline}#pay_modal-main .container .content .x{top:10px;left:2px}#pay_modal-main .container .content .title1{min-height:32px;line-height:32px;text-align:center;font-size:14px;color:#000;background-color:#fa0;font-weight:700}#pay_modal-main .container .content .title2{padding:0;font-size:19px;color:#000;font-weight:700}#pay_modal-main .container .content .title3{padding:0;font-size:14px;color:#000}#pay_modal-main .container .content .title4{padding:0;text-align:center;font-size:28px;color:#00adad}#pay_modal-main .container .content .title5{padding:23px 0 20px;text-align:center;font-size:14px;font-weight:700;color:#000}#pay_modal-main .container .content .title6{padding:15px;font-size:14px;color:#fff;background-color:#00adad}#pay_modal-main .container .content .img{margin-top:-5px}#pay_modal-main .container .content .img.map,#pay_modal-main .container .content .map{padding-left:43px}#pay_modal-main .container .content .content1{text-align:center;padding:20px 0 0;font-size:16px;font-weight:700;color:#00adad}#pay_modal-main .container .content .content2{font-size:13px;color:#000}#pay_modal-main .container .content .content2.a{padding:0}#pay_modal-main .container .content .content2.b{padding:0 33px}#pay_modal-main .container .content .content2.c{padding:0}#pay_modal-main .container .content .l-btn{text-align:right}#pay_modal-main .container .content .r-btm{text-align:left}#pay_modal-main .container .content .btn-more,#pay_modal-main .container .content .submit-btn{margin-top:40px;font-size:14px;color:#fff;background-color:#00adad;width:200px;height:45px;border-radius:5px;border-color:#00adad;border-width:2px;border-style:solid}#pay_modal-main .container .content .submit-btn{position:relative;left:50%;margin-left:-100px}#pay_modal-main .container .content .btn-hint{display:block;margin:20px auto;height:54px}#pay_modal-main .container .content .btn-hint p.hint{color:#000;font-weight:700}@media (max-width:768px){#pay_modal-main .container{width:100%}#pay_modal-main .container .content{width:100%;margin-left:0;top:48%;left:0}#pay_modal-main .container .content img{width:100%}#pay_modal-main .container .content .btn-hint{margin:30px auto}#pay_modal-main .container .content .hidden-overflow{overflow:hidden}}@media (max-width:414px){#pay_modal-main .container .content{top:50%}#pay_modal-main .container .content .blank{height:50px}#pay_modal-main .container .content .btn-hint{margin:20px auto}#pay_modal-main .container .content .title1,#pay_modal-main .container .content .title3,#pay_modal-main .container .content .title5,#pay_modal-main .container .content .title6,#pay_modal-main .container .content .content2{font-size:12px}#pay_modal-main .container .content .title2{font-size:16px}#pay_modal-main .container .content .title4{font-size:24px}#pay_modal-main .container .content .content1{font-size:14px}}.highcharts-tooltip span{background-color:#008b8b;z-index:9999!important;width:50px;height:50px;border-radius:50%;line-height:50px;text-align:center;color:#fff!important;font-weight:700;font-size:16px}", ""]);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = function() {
		var list = [];
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
		return list;
	}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA5BAMAAAB+Np62AAAAGFBMVEUAAABCQkL///9CQkJCQkJCQkJCQkJCQkLjEth9AAAAB3RSTlMAAAAOjdHmjRymqwAAAEtJREFUOMtjYKAZEHYrxwHKnBUYTMtxglIDBnfcsuUODOl4ZBMY8EiWFxDQi99e/G7G719BHEAJCEZlqSc7mupGU91oqhvYVEczAAAP+5SYja0uGwAAAABJRU5ErkJggg=="

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAABhlBMVEWZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmampqZmZmampqZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiXl5eZmZmPj4+RkZGSkpKTk5OUlJSVlZWWlpaXl5eYmJiZmZmampqbm5ucnJyenp6goKChoaGioqKjo6OkpKSlpaWmpqanp6eqqqqrq6usrKyurq6vr6+xsbGysrKzs7O1tbW2tra3t7e6urq8vLy+vr6/v7/AwMDBwcHCwsLDw8PExMTFxcXGxsbHx8fIyMjJycnKysrLy8vMzMzNzc3Ozs7Pz8/Q0NDR0dHS0tLT09PU1NTV1dXX19fY2Nja2tqEC5BsAAAARHRSTlMAAQIDBBMXGiouMEFCSEtMTVdYWltdXl9wcnOPkpeam5+gpKXCw8TExcXHyMnKy8zO0tTW19jZ2+Dh4+Tr7u/w+/z9/Vb4G7wAAAI4SURBVDjLbZT5QxJBFMfHzFC7DwuzQ027yA6zUrOoxJ2ZnR2kLCmTirYAaaEo9mBmofrP2wV2ZqT9/rS8+TDvnAeAovHJ6dRqOr2amp4cA7EaOju/ToWezU3EMMcX6YDuHRtkLtAYTe1DEtdprK4mJHPooXpiKN/3RwR0V5xjBDWMSFZQqYi51DdkCc5tf/pqmSizIbiLPeZo9C9CPjddxn1eKn7Mksh6OGQOPop+aoV2y7EDsc6fohZZl4YD6LQMaM+3+/IrSMR/MoDuCG/UakUQq+jC300AxkQi+mZNQlVDQHQUJCWUq3uxUBJckRCVN/EylDWdBQviG39wnQjyGnksDhbAikjO+CGSs5ttC4urlsFTCdWYgGxeJwJakxBF5Y5gnPYX6W5Nuguy+8ZFdkUss1tWAs9u5Ox+VB0LYjkJt5USUArzv7qVajW3oGKeVYoZtvhVSLluXlOtSaUtYYa6FYTFvlOiWkeVBoc91sMy8CpSRzhoMDgT3UJ0mNnx3CCkBs1gWaZTcugQNHLbpt0LvLbzkmJN7x48GI7Gl6A3ZvWny91mr0ysWS8VNrspHukN+eWgJWarw0JXUcW9lt9u7OriIQRPihjWb0n0e+z93dONlPI4CSky7qiMw1nRIEsjyjO/ocN3NZ+L21zOrbdQv5bYvzAMzditOIzxQIw5lfdEM6YG18qJRaLh1wWzVK6UzMIW1sj/qweAA+fmXyCIuoLo+dzEUPyyGz8/c2vlSfrx4Dr8B4ndXFqq92hsAAAAAElFTkSuQmCC"

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAABFFBMVEUzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzM0NDQ1NTU2NjY3Nzc4ODg5OTk7Ozs9PT0+Pj4/Pz9AQEBBQUFCQkJDQ0NFRUVGRkZHR0dISEhJSUlKSkpLS0tMTExNTU1OTk5PT09QUFBTU1NUVFRVVVVWVlZZWVlaWlpcXFxdXV1fX19gYGBiYmJkZGRlZWVmZmZ2z7weAAAAM3RSTlMAAgMECAoVFyEjQ0RFRkdYWVpnaGlqmZqbnp+kpabExcbIycrMzc7P1tfY2ers7ff5+v7L94k0AAABgUlEQVQYGYXBC1sSQRgG0BeEdSWL8EIXhEBBcRWVfRFCCqTSzMroogjf//8fTerMzuDydA5s/upGrXF01KgVVn3ESubKIY2wlE3gkeVdzqhn4ErlGSOfgmWxylhbHgxvj3MEHh6kK5yrksa9VzSOTz9/vRh2GHmBO09pnN/KP9MfXRoZKAsBtW+i3fao1RMActTeS+S6RS0LoExtJCLjd+xcidKnVgKWQmpjEflAsj0RkXNqoY81ai1R3lK5EZELGiso0mgrVHqiDGkUsMNZJzciMm7RqOKAM84mIjLpM7KPJl3fRRn3aDlEk45Povzs0HaIAzpGIjKiax87dPwSkT5dNRTp6A0Gg2O6Cljnf61giY72l6uPdIU+UKbtt4hc0lECkKOlK8o1HVkACwEjnamI/KGtnoDyjJZLkekpbRnceU3LybBL20vcS29yrkoaD7w9zhF4MBarjLXlwZLOM0Y+BddywBm7T/BIMldmJHzzPIlY/npxu9FsNrY31nxY/gJmhdvMh5/yiwAAAABJRU5ErkJggg=="

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJoAAABmCAMAAAAEcXhHAAAA5FBMVEUAAAD///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABJSUkAAAAAAABgYGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKCgoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACKioo5OTkAAACUlJQAAABBQUEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACzs7O8vLzu7u7v7+/Nzc3R0dHu7u7u7u7c3Nzf39/x8fHx8fH29vb29vb9/f39/f35+fn7+/v+/v7+/v7///////////+AOsi0AAAAS3RSTlMAAAECAwQFBgcICQoLDA0ODg8QEBESExQVFxgZGRobHB0eHyAhIiMjJCUmJycoKSssLzEzNEBES1FlaXZ7jJCfpMXJ2dzj5fDy/P0s8MmrAAACP0lEQVRo3u3bwYoTQRAG4P+v7klQw4KLKwoe9gE8+QI+u4+yR1E8eBCSSf+/h5kkIJugB2f6UH2aZgLzUZ2unoEqYrUR5ys9e583Zv918PI0Az5fXUZdLWgEwZnj535QVooaCQbj0/uv5JXn1rVChmDw5c4v9oYFupeokRGllI+v6t030uxnQUlGKfXDQ6C2X1f+a7HWJohSNm8LUN9tSgleTx7LCkmWUrePbwhA35/2x9Zs/5Hn6uSadwmXi1ndbnYEgNhVA5AviSQATVsFBEmQy2W0GIb6+Hqe/3g6jqM8wQzbMISKAEkGSS4VNXIo5X53mu7ufrKMNmDYtmw4VKftEhERjKVowaHeD6fp5uFwHKsMWJZECTCIYESUz+hnfGmSrBokowwdyTAAJqICjN5osm0EQMZQeqKVIXjKHBG1J1qNIDhHLaInWsQctSmtdUUjZxoQvdEm1XRKsSfafDDF4t8rf/UKvOb72j99DCYtaUlLWtKSlrSkJS1pSUta0pKWtKQlLWlJS1rSkpa0pCUtaUlLWtKSlrSkJS1pSUta0pK2OM09mXyiTdXqXdGmsv4AAFk90WZOTMjOaLZnmtQXTbIBBkup22G72ZbV63Ntu+0P+3F/bM0VsDXGARqirF2e66bxeGijbKACFtsIt3GqCl81apKObWySgaqABWhosX69tW1pbE22VQFYgLVg2811mixJkjEtKCBbCzYr3TgH5mYle50Wr9tLem7xItZojLt1ek7tv+q0gH46AH4DKZvwfPLeKUsAAAAASUVORK5CYII="

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAToAAADoCAMAAABIHdj+AAAA6lBMVEUAAAD///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABJSUkAAAAAAABgYGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKCgoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACKioo5OTkAAACUlJQAAABBQUEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACzs7O8vLzu7u7v7+/Nzc3R0dHu7u7u7u7c3Nzf39/x8fHx8fH29vb29vb9/f39/f35+fn7+/v+/v7+/v7////////Z2dny8vL///+zv4/QAAAAS3RSTlMAAAECAwQFBgcICQoLDA0ODg8QEBESExQVFxgZGRobHB0eHyAhIiMjJCUmJycoKSssLzEzNEBES1FlaXZ7jJCfpMXJ2dzj5fDy/P0s8MmrAAADVklEQVR42u3csW7jRhSF4XPvDKVdQ07hYBcbIIUfIFXeIE+eZ3G5SKoUASSK92xBSgYWVkS6SbH/31iEXH2YS82wYIhulNdP9eb38R9XP3TxqmHJ10+vdZBu2oVi4fJb/9BYdW/DhSIjf//la8QNF1bdrXHNyHg4+OPRcinMqlu76DJba789Do9/RTgY2PVyka31Xz81tenfG/e6xOltvGxt93mQdl92rWXcvtch+N2ia63tnx8k6eH55WjJ9nUq60qX110MA3tdc32/OzRJ6oduSeXXjUpKNf+UKBQRCuCuO7ochv7883L998t5HMsznGVbVqkrFRGRERGsusvADq09HS6Xh5/+iTbakmXbZctZff45yczMSOiWeY2hP+0vlx8+nc5jL0suV1VUSVYoIzPbH4Ct7s+pqlw9IyLbAMj6Bsmh7FIkdNvoyraVUkQODZD1tSHjsjPJ5CnAhnpmKJZVl5wmNpS5rLp5WwfIBrqIhU5K6LbRzWrzKYy98LanA8u9Tpz7t55x58WHxLvnFgLooIMOOoIOOuigg46ggw466Ag66KCDDjqCDjrooCPooIMOOugIOuigg46ggw466KAj6KCDDjqCDjrooIOOoIMOOugIOuiggw46gg466KAj6KCDDjroCDrooIOOoIMOOuigI+iggw46gg466KCDjqCDDjrooIMAOuigg46ggw466KAj6KCDDjqCDjrooIOOoIMOOugIOuiggw46gg466KAj6KCDDjroCDrooIOOoIMOOuigI+iggw46gg66/7W+/C0o3ksXUDCw0EEHHUEHHXTQQUfQQQcddAQddNBBBx1BBx100BF00EEHHXQEHXTQQUfQQQcddNARdNBBBx1BBx100EFH0EEHHXQEHXTQQQcdraIzEuvzhc6yDd0WOtvyvOrKvFxnQwtXzojQbaKzvdBVQbeFrsqWIqO1vh/2u32LCF7tdO8mNx1Px/F4niZ3ya4xT6ohG3J37KYaz6dpLFvqkiumUZ7GTFbdnVVXVedpnKos9Uq5pBqmZF5XTGzVOE1lu7okl+TKjITuDl25qqrKmgdWKrsighcA3j1H2PayOQkpFYoIMa6rRlbzWaIU87Y45ldOgnf/9Op5Tq9YPEDZtCeWJH0DEFDu0p73NLwAAAAASUVORK5CYII="

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA2AQMAAAALaq7rAAAABlBMVEX/sRn/9eLYQonzAAAAGklEQVQoz2NgGBCQQA0e/3/cPOrYMAqGIwAA1QYF3QBhZOgAAAAASUVORK5CYII="

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA2AQMAAAALaq7rAAAABlBMVEXnAAD///+umLTnAAAAGklEQVQoz2NgGBCQQA0e/3/cPOrYMAqGIwAA1QYF3QBhZOgAAAAASUVORK5CYII="

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAMAAADyHTlpAAABoVBMVEUAAAD/qgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABNMwAAAAAAAAAAAAAAAAAAAAAAAAB4UAAAAAAcEwAoGwAAAAB0TQAAAAAAAAAAAAAAAACnbwAAAACibAAAAAAAAAAAAAAAAADSjAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACWZAAAAAANCQCYZQANCQAAAAAAAAAAAAAAAAAAAAAjFwAAAAAAAADhlgAAAAAKBwAaEQAdEwAAAABsSAAAAADRiwA/KgBAKwDsnQBRNgDWjwDvnwCUYwCVYwDYkACIWwCtcwDBgQCeaQCfagCscwD1owDxoQD3pQDqnADilwDXjwDilwDRiwDXjwDXjwD6pwD1owD1owD5pgD6pwD7pwDsnQDsnQD0owD0owDomwDqnAD7pwDxoQD5pgD5pgD6pwDrnQDrnQDyoQDxoQDvnwD+qQD7pwD6pwD7pwD4pQD/qgD+qQD9qQD/qgD/qgD/sBH/tSL/uzP/wUT/xlX/zGb/0nf/14j/3Zn/46r/6Lv/7sz/9N3/+e7///8h+SZRAAAAe3RSTlMAAAECAwQFBgcICQoKCwwNDhARERISExUWGBoeICAhISIkJScoKSwuLzM1Nzg4OTk5Ojw+QENGSEpMTU5OTk5QUFFTVVhgaGpvdXZ8gYOLkJCdn6Sps7m6uru7xcnMzc3O0NTV19ja2trb29zc3eDj5ebt8PHx8/n6/P7NR6V3AAACqklEQVQYGYXBTY8UVRSA4fecc6u6pxsaWwScCETRhW5MNJHEnQtNXPm33bkwkRAzIYoow3wEM3TX973HKmG6uscZfB5hILwhgooA7gl33nB6gZGI2L1Prl1fZrQvX60O/ojuzoYwEHqqk6/v3BfO+dMXP9Yp0XN6wkBANHz5+U12nf78U5ccnJ4xENRufPfVjAtmHy0PW5x/GQNRe//7B1zi1v5xgTMwBhb2f7jFpRYf/lW40zN6Fpbf3uYK03f/bHDAALXpNw+40mL2e8TBAMsffsFbvJeepwQKFuafskWyyWRibPnsWjAwCNOHHzPK53kIIQ/JOTf15xFXzPLbjPI9YRDmysad3ARFsv17bOgepHLdgkzYuHs3E1Qt3Bc2MmDddEWCjA35IJiqaD5jFCAmIIEwmuUqgWDvMKoEB8QgMbphoQlqsmAUGchcoGG0FNMgYhkX2FygqRmZiQQR46KZQFWzzUQUpWNXrlDWbIsoCqzZJRAbdqwAJfGSXd51HbtOSQT3WLCrabioiu7BPZ65sG1qsGabn0V39eiHh+ywEAI7Xhx6dPUuxmP+x1GMnaunpn664q1Wz9omublYZmmfLW1d12z75aismmgIFup8ydUOnpRlFd1wUdNyMeMqJ49XZdkkNxAQ2mXO5daPT9ZlFRMGjgSty8WEy5w9Oqyqso1g9ByR+iwu+a8nv55UZVEnBwNc3JF2tVpk7CoePTuriqKOCTB6TnKIzdFKZsLG8W8Hf6+qsqi6SE8YiIbJXjabTsL1+ezm1IjVabF+1dVV0ZZ1l5yeMBBUs8neJM+mqhaU1MWUqrapy7pNCacXeC25p9jkeW0aguBdl2Lb9LrkvCZsmFpuuYkZEKPHJjYxRc4JIxUxDSaiJPfYpeie2BB2qAwAHyS2/QNgfELGaZxtqwAAAABJRU5ErkJggg=="

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAS1BMVEUAAAClpaX///+lpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaUsgugaAAAAGHRSTlMAAAAyQENNYGKAiJygsMPLzNjg5u7w8vOD0ysqAAAAiUlEQVQ4y+2VRwrEMBAEp53knEP//6U+iIVVADNg8EV1U1EHSQyMiIb6pM9WAuUW6LOWiyETMEX0JWRbuPRcgZW9p1tSSAOXxsaNPWU/TIpT/F7cGZfBxoOnO1L2yJSPwBjRu1TL4TPnQD4HeqkED2R/6GLVNVQPVH1dmroUfxErFpBqtamWpoYbM3o/JSsd5P8AAAAASUVORK5CYII="

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAS1BMVEUAAAAbraz///8brawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawjnrxkAAAAGHRSTlMAAAAyQENNYGKAiJygsMPLzNjg5u7w8vOD0ysqAAAAiUlEQVQ4y+2VRwrEMBAEp53knEP//6U+iIVVADNg8EV1U1EHSQyMiIb6pM9WAuUW6LOWiyETMEX0JWRbuPRcgZW9p1tSSAOXxsaNPWU/TIpT/F7cGZfBxoOnO1L2yJSPwBjRu1TL4TPnQD4HeqkED2R/6GLVNVQPVH1dmroUfxErFpBqtamWpoYbM3o/JSsd5P8AAAAASUVORK5CYII="

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAABwlBMVEUAAAClpaX///+lpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaUMOvoeAAAAlXRSTlMAAAABAgMEBggJCgwNDg8QERITFBUWFxkaHB4gISIjJCYnKCstLzAyMzY5OjxAQUJDRkpLTE1OT1JVV1hZW11eX2BiZGVmZ2lqa3Byc3l6foSFiIyQkZKTlZeZm5yen6Cio6anq6ytsLGytba4vMDBwsXGzM7P0tXW19na3+Di4+Xn6err7O3u8PHy8/T1+Pn6+/z9/jmFT5MAAAIfSURBVDjLzdXpV1JBGMfx+wyUBSZp0UZKC2JZWrbYYpbZYlS0Ulliu6WSLZplRUkCBm1C+P1/e3EvFxS48KZz+r2aec7nzJk555kZTftnkZK4e8OTiSzEp8L9G0QVZTm2dUdyFLI4cdReEe+fNtTP+ZQxetdVHtcPAWTGAm1OEXH4z4/+BnhYXwZvnQFSQXdRqTGYBD56S7AvDgy5RERk460+o7pmEEj4lmFvDL4fNib3YYc+UurgN0i0LMHO95Bozc+eQ0ceK18CPjQU42FI+6UsVjvT8KAI7wOOSAWsDgBdJrZNwz2piNUgTNvy+BCk1lpg1zx053EErogFVkEYN3BTjgW3JV6XIefW8UkYF0usxqBXx3chUAUHIKzjSdhVBbfBG22Lx+PxJGGPv71jtwV2QEJ7UdTqV00cgZFQKBQKha5vNvQPstq2jGljDhNHCyuMG3gONLlhlvsKe54o4McGToEmzphRfWsv4JUXBk7rOe7Q7SpIaiI9Bu6Ucskf0AdTmojtFQCjYonPwrAmIr4/QHa7NR6BM5qIyG3gjljihl8sbtJERFxxUk3W+BK8NLqun8tiiR1focfA9id11vgmzKwwr5VY4s4cdJc+jGWxdw6eqdpw82eINtaG98Yh7VO14NXXcpBuVzVgx8AXYLZVVcN2z4lHaYDR9aoKdr9e0Jsxeqzin2LmnE6nTtWp6rh5NvPp6cWWpb/V/5G/DYHrJ8t360cAAAAASUVORK5CYII="

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAABwlBMVEUAAAAbraz///8brawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawfH8FSAAAAlXRSTlMAAAABAgMEBggJCgwNDg8QERITFBUWFxkaHB4gISIjJCYnKCstLzAyMzY5OjxAQUJDRkpLTE1OT1JVV1hZW11eX2BiZGVmZ2lqa3Byc3l6foSFiIyQkZKTlZeZm5yen6Cio6anq6ytsLGytba4vMDBwsXGzM7P0tXW19na3+Di4+Xn6err7O3u8PHy8/T1+Pn6+/z9/jmFT5MAAAIfSURBVDjLzdXpV1JBGMfx+wyUBSZp0UZKC2JZWrbYYpbZYlS0Ulliu6WSLZplRUkCBm1C+P1/e3EvFxS48KZz+r2aec7nzJk555kZTftnkZK4e8OTiSzEp8L9G0QVZTm2dUdyFLI4cdReEe+fNtTP+ZQxetdVHtcPAWTGAm1OEXH4z4/+BnhYXwZvnQFSQXdRqTGYBD56S7AvDgy5RERk460+o7pmEEj4lmFvDL4fNib3YYc+UurgN0i0LMHO95Bozc+eQ0ceK18CPjQU42FI+6UsVjvT8KAI7wOOSAWsDgBdJrZNwz2piNUgTNvy+BCk1lpg1zx053EErogFVkEYN3BTjgW3JV6XIefW8UkYF0usxqBXx3chUAUHIKzjSdhVBbfBG22Lx+PxJGGPv71jtwV2QEJ7UdTqV00cgZFQKBQKha5vNvQPstq2jGljDhNHCyuMG3gONLlhlvsKe54o4McGToEmzphRfWsv4JUXBk7rOe7Q7SpIaiI9Bu6Ucskf0AdTmojtFQCjYonPwrAmIr4/QHa7NR6BM5qIyG3gjljihl8sbtJERFxxUk3W+BK8NLqun8tiiR1focfA9id11vgmzKwwr5VY4s4cdJc+jGWxdw6eqdpw82eINtaG98Yh7VO14NXXcpBuVzVgx8AXYLZVVcN2z4lHaYDR9aoKdr9e0Jsxeqzin2LmnE6nTtWp6rh5NvPp6cWWpb/V/5G/DYHrJ8t360cAAAAASUVORK5CYII="

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAABNVBMVEWlpaX///+lpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaVCuZsJAAAAZnRSTlMAAAECAwUGBwgKDxAYHR4fISIlKSwwMTY3Oj4/QkNERUhMTlRYWlxeYWNkZ2lsbnBydHh6fn+Ag4SKjJCSm6Cio6qwsbW3uLu8vsDEx8nKzM3O1tnb3N3g5+vt7u/w8/T2+fr7/P1TZEvpAAACaUlEQVRIx5XW11YiQRSF4V0oo6Jizs4YMIcxYJZgRsesmAVpGP73f4S5EFGgW2r2XXevb1XXWbVOHckzUZyn8/h8R+lbY7yFHnhPcrXZnhyGY5d5IBttsSVrkgKhvRxkwv7vSF3nyMRM2weRFIw4cBb0IL6Bras8wNUXIrUfw0ufGwksf2yZhxIi31KOzHAF8S+ngOfduf6mjXIiDaXJ9JWRnhvgYNQvSWuVRL1pXoIlZCELie7CgxvRUI4z/yepicDrePGrK9EShIvEF4PrVlUhvmMyLR9kE04CqkbU7hAtkDE4bVB1ogjZZiNJbWmSjbIhwRyrRpIOcLpkRbRH0kgahRVZkhB0SLrgvt6WBPLMS4MwLVuiS+LSDo8/7EmMc9W/sSV7EuZJP6HHi/xZq8ghjtZJ1bqTO9yjfY7kTn7fPbglqlu2PYh7jFGKxf8lMOVG/rr901VbgUxWkgWPnc9IxshhtpI0LFSWd20DJiRj9ERYdmmCEckYnROzJP3QKRmjOJeWZI58nWSM5skH7Mgu1+9F7oCQlfA/s1Xolkn2rMgoDBTIKrmgDTngwVcgzVkiFqIbloudP4rTXp0kSAWKpCVDwldNjBcWKfTkMCxVEa2v3Pi/EP8ZuaFvReCabE/JXRl8Id37jWg4gYWyG7kvQ9p7ncZTPotavJKGM+SWPGrQlYRYTeWo0PcCCbda1684sOlzmy6CZ+BEys/Bj+l7SI95zDD+cAZye6HPc13bs/UIHLR5T0ot0SyQv4yFZyenFrePUgAXo98PV82ryZL28LYz6NKUytMxHz9/ciB1u7/+q96tj/0D1inSdRYCgqIAAAAASUVORK5CYII="

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAABNVBMVEUbraz///8brawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawLfDYxAAAAZnRSTlMAAAECAwUGBwgKDxAYHR4fISIlKSwwMTY3Oj4/QkNERUhMTlRYWlxeYWNkZ2lsbnBydHh6fn+Ag4SKjJCSm6Cio6qwsbW3uLu8vsDEx8nKzM3O1tnb3N3g5+vt7u/w8/T2+fr7/P1TZEvpAAACaUlEQVRIx5XW11YiQRSF4V0oo6Jizs4YMIcxYJZgRsesmAVpGP73f4S5EFGgW2r2XXevb1XXWbVOHckzUZyn8/h8R+lbY7yFHnhPcrXZnhyGY5d5IBttsSVrkgKhvRxkwv7vSF3nyMRM2weRFIw4cBb0IL6Bras8wNUXIrUfw0ufGwksf2yZhxIi31KOzHAF8S+ngOfduf6mjXIiDaXJ9JWRnhvgYNQvSWuVRL1pXoIlZCELie7CgxvRUI4z/yepicDrePGrK9EShIvEF4PrVlUhvmMyLR9kE04CqkbU7hAtkDE4bVB1ogjZZiNJbWmSjbIhwRyrRpIOcLpkRbRH0kgahRVZkhB0SLrgvt6WBPLMS4MwLVuiS+LSDo8/7EmMc9W/sSV7EuZJP6HHi/xZq8ghjtZJ1bqTO9yjfY7kTn7fPbglqlu2PYh7jFGKxf8lMOVG/rr901VbgUxWkgWPnc9IxshhtpI0LFSWd20DJiRj9ERYdmmCEckYnROzJP3QKRmjOJeWZI58nWSM5skH7Mgu1+9F7oCQlfA/s1Xolkn2rMgoDBTIKrmgDTngwVcgzVkiFqIbloudP4rTXp0kSAWKpCVDwldNjBcWKfTkMCxVEa2v3Pi/EP8ZuaFvReCabE/JXRl8Id37jWg4gYWyG7kvQ9p7ncZTPotavJKGM+SWPGrQlYRYTeWo0PcCCbda1684sOlzmy6CZ+BEys/Bj+l7SI95zDD+cAZye6HPc13bs/UIHLR5T0ot0SyQv4yFZyenFrePUgAXo98PV82ryZL28LYz6NKUytMxHz9/ciB1u7/+q96tj/0D1inSdRYCgqIAAAAASUVORK5CYII="

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAABFCAMAAAArU9sbAAACH1BMVEUAAAAbraz///8brawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbray39ReJAAAAtHRSTlMAAAABAgMEBQYICQoLDA0ODxAREhMUFRYZHB0eHyAiJCYnKCkrLC0uLzAzNDU2Nzs8P0BCQ0RFRkhKS01OUFFTVFZXWFlcXl9gYmRma2xtbm9xdHd5e3x9fn+AgoeIiYqMjY+QkZKTlZaXmZucnqCjpqeoqqusrbCxsrO0tba3uLq7vMDCw8bIysvMzc7Q0dLT1NbX2Nnc3uDh4uPk5ebp6uvs7e7v8PHy8/T19vf4+vv8/f4cOcXiAAAELUlEQVQYGe3B+V/MeRwH8M/rPdOxo6Ei5YpW5JhEuy0RUo5xH1Gulsh9VEQUSyVRtO0IHWaFJqTM0esP3PnO/W1mPPZnj55PNW3atJ8LfmhV7T9OOntrVyEe0Sj8wIJmBjUvQGyiUYivcISe26U5aTmltz0cKURMolGIa804O5fDb3knx9cgFtEoxJM6xJZkBCW3cCgVMYhGIZ4zfJWCsJRXPIMYRKMQh3mMGxFpI8fMiCYaBZ+ZB1rfDr+8aEFIGW3Qs7EMIZaLL4ffth6YCdEoaMrf068hHQEXWA29al5AQHoD/d6Xi0bB6wjZdzB/aUmdm70Z8HvIndDbyYfwy+ilu65kaf6hPvKIeCkAReSfidBY7PwLfu3cBL1NbIffI9ot0CSeIYtERAHGXl5CwLJvLIZPM63Qs7IZPsX8tgwBl/m3UUQBhfxgRtApPoDPOdZAr4bn4POApxBk/sBCEQWc5iWELOREEjRb+MaASIY33AJN0gQXIuQST4so4BZ3I+wD50FjcrAMkcroMEEzj8MI281bIgpoYjnC7MyBz3EOpCMsfYDH4ZNDO8LK2SSigCusREiKi2b4mF6zIxVBqR18bYKPma4UhFTyiogCdrAbIWXsQUDuKPvWwW9dH0dzEdDDMoR0c4eIAtK/sBQBJhsrELTiHdm+v+DXgv3t5LsVCKqg7RcElPJLuogCUMVRC3ySG2k3I2TOdTf93NfnIMT8LxuT4WMZZZWIKABJHZyomgskFL2g8zdEWlTZNjg62Fa5CJF+d/JFkRGYWzXBjiQRUfCa1UJ6+rocpKMY/0exg3R09XnIllnipaAxlD6n16faTOjN+ONQ9fnqQ0UzoJd54RO9npcaRKMQkLV2Q14CdAwb7zvp57xfbIBOQt6GtVkARKMQkJa3MjsBkSxdJPvvnj159m4/yS4LIiVkr8xLAyAaBU3GCRu9PjeuR5DhmIdjNbnwy60Zo+eYAUHrGz/Ty3YiQzQKgOHgV5IjdhfJ1vnwSbhJNmQiLLOBvJkAn/mtJF32EZJfDxpERAGJdWSPdTZgLLjs5PBqaK7StQd6e1y8Cs3qYTovFxiB2dYesi5RRAHX6NxnhN+Sbn5cDGAvPZsx1WYP9wJY/JHdS+Bn3OfkNRGFbXSXICTlKZ8ZsXCchxHtMMcXwPiMT1MQUuLmNlHJg6xEhCwHd6GebQZEM7SxHrvoyEKYVHIwWW3nkAmRKtid7Z7MRSy5k+7sblYggpiGuF3d4UnopLlYy3uI7R5r6UpDBJGTvKMGmA+9J+znVsS2lf18gkgi+RxQk8yA3g1OumcitlnuSd5AJJEMTioSU5wnbYjHRp5HJBEhFWmd4jHZgnhayMfWKUjFWBoQTwNjUUebonSyPi2eenY2RTmqEM3KH7FCRzQK0fK/M77v+dARjZo2bdpP5T/w3uEZsbx5IQAAAABJRU5ErkJggg=="

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {};
	
	module.exports = function(list) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
		var styles = listToStyles(list);
		addStylesToDom(styles);
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j]));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j]));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			// var sourceMap = item[3];
			var part = {css: css, media: media/*, sourceMap: sourceMap*/};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function addStyle(obj) {
		var styleElement = document.createElement("style");
		var head = document.head || document.getElementsByTagName("head")[0];
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		applyToTag(styleElement, obj);
		return function(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media /*&& newObj.sourceMap === obj.sourceMap*/)
					return;
				applyToTag(styleElement, obj = newObj);
			} else {
				head.removeChild(styleElement);
			}
		};
	};
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		// var sourceMap = obj.sourceMap;
	
		// No browser support
		// if(sourceMap && typeof btoa === "function") {
			// try {
				// css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(JSON.stringify(sourceMap)) + " */";
			// } catch(e) {}
		// }
		if(media) {
			styleElement.setAttribute("media", media)
		}
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	
	}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(29);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["angular"] = __webpack_require__(30);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/* exported
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth
	*/
	
	var minErrConfig = {
	  objectMaxDepth: 5,
	  urlErrorParamsEnabled: true
	};
	
	/**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 *
	 * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies whether the generated error url will
	 *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
	 *   generated error url is very long.
	 *
	 *   Default: true. When used without argument, it returns the current value.
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	    if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) {
	      minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * AngularJS. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace'). Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	
	  var url = 'https://errors.angularjs.org/1.8.3/';
	  var regex = url.replace('.', '\\.') + '[\\s\\S]*';
	  var errRegExp = new RegExp(regex, 'g');
	
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    // A minErr message has two parts: the message itself and the url that contains the
	    // encoded message.
	    // The message's parameters can contain other error messages which also include error urls.
	    // To prevent the messages from getting too long, we strip the error urls from the parameters.
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index].replace(errRegExp, '');
	      }
	
	      return match;
	    });
	
	    message += '\n' + url + (module ? module + '/' : '') + code;
	
	    if (minErrConfig.urlErrorParamsEnabled) {
	      for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	        message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	      }
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isError,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  addDateMinutes,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	  UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) && (length >= 0 && (length - 1) in obj || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (key !== '__proto__') {
	            if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	            baseExtend(dst[key], [src], true);
	          }
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @deprecated
	* sinceVersion="1.6.5"
	* This function is deprecated, but will not be removed in the 1.x lifecycle.
	* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
	* supported by this function. We suggest using another, similar library for all-purpose merging,
	* such as [lodash's merge()](https://lodash.com/docs/4.17.4#merge).
	*
	* @knownIssue
	* This is a list of (known) object types that are not handled correctly by this function:
	* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
	* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
	* - AngularJS {@link $rootScope.Scope scopes};
	*
	* `angular.merge` also does not support merging objects with circular references.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	function isArray(arr) {
	  return Array.isArray(arr) || arr instanceof Array;
	}
	
	/**
	 * @description
	 * Determines if a reference is an `Error`.
	 * Loosely based on https://www.npmjs.com/package/iserror
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Error`.
	 */
	function isError(value) {
	  var tag = toString.call(value);
	  switch (tag) {
	    case '[object Error]': return true;
	    case '[object Exception]': return true;
	    case '[object DOMException]': return true;
	    default: return value instanceof Error;
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array. This functions is used
	 * internally, mostly in the change-detection code. It is not intended as an all-purpose copy
	 * function, and has several limitations (see below).
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 *
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 *   `angular.copy` does not check if destination and source are of the same type. It's the
	 *   developer's responsibility to make sure they are compatible.
	 * </div>
	 *
	 * @knownIssue
	 * This is a non-exhaustive list of object types / features that are not handled correctly by
	 * `angular.copy`. Note that since this functions is used by the change detection code, this
	 * means binding or watching objects of these types (or that include these types) might not work
	 * correctly.
	 * - [`File`](https://developer.mozilla.org/docs/Web/API/File)
	 * - [`Map`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Map)
	 * - [`ImageData`](https://developer.mozilla.org/docs/Web/API/ImageData)
	 * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	 * - [`Set`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Set)
	 * - [`WeakMap`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/WeakMap)
	 * - [`getter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get)/
	 *   [`setter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set)
	 *
	 * @param {*} source The source that will be used to make a copy. Can be any type, including
	 *     primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If provided,
	 *     must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>leader = {{leader | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.leader = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.leader);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.leader);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since AngularJS uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-15+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone().empty();
	  var elemHtml = jqLite('<div></div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // Support: IE 9-11 only
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for banned URL schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * @example
	 *
	 * ### Simple Usage
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * @example
	 *
	 * ### With `ngStrictDi`
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up AngularJS application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of AngularJS try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of AngularJS on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? __webpack_provided_window_dot_jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	  } else {
	    jqLite = JQLite;
	  }
	
	  // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
	  // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
	  // the $destroy event on all removed nodes.
	  originalCleanData = jqLite.cleanData;
	  jqLite.cleanData = function(elems) {
	    var events;
	    for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	      events = (jqLite._data(elem) || {}).events;
	      if (events && events.$destroy) {
	        jqLite(elem).triggerHandler('$destroy');
	      }
	    }
	    originalCleanData(elems);
	  };
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Restores the pre-1.8 behavior of jqLite that turns XHTML-like strings like
	 * `<div /><span />` to `<div></div><span></span>` instead of `<div><span></span></div>`.
	 * The new behavior is a security fix. Thus, if you need to call this function, please try to adjust
	 * your code for this change and remove your use of this function as soon as possible.
	
	 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
	 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
	 * about the workarounds.
	 */
	function UNSAFE_restoreLegacyJqLiteXHTMLReplacement() {
	  JQLite.legacyXHTMLReplacement = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring AngularJS {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
	     * modules.
	     * All modules (AngularJS core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	           *    or an object map of components where the keys are the names and the values are the component definition objects.
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to configure services by injecting their
	           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
	           * {@link ngRoute.$routeProvider $routeProvider}.
	           *
	           * Note that you can only inject {@link angular.Module#provider `providers`} and
	           * {@link angular.Module#constant `constants`} into this function.
	           *
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* exported toDebugString */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    // This file is also included in `angular-loader`, so `copy()` might not always be available in
	    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
	    obj = angular.copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  hiddenInputBrowserCacheDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRefDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $$IntervalFactoryProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $$TaskTrackerFactoryProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.8.3',
	  major: 1,
	  minor: 8,
	  dot: 3,
	  codeName: 'ultimate-farewell'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    'UNSAFE_restoreLegacyJqLiteXHTMLReplacement': UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$lowercase': lowercase,
	    '$$stringify': stringify,
	    '$$uppercase': uppercase
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRef: ngRefDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective,
	          input: hiddenInputBrowserCacheDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $$intervalFactory: $$IntervalFactoryProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.8.3' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## AngularJS's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
	 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * jqLite also provides a method restoring pre-1.8 insecure treatment of XHTML-like tags.
	 * This legacy behavior turns input like `<div /><span />` to `<div></div><span></span>`
	 * instead of `<div><span></span></div>` like version 1.8 & newer do. To restore it, invoke:
	 * ```js
	 * angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement();
	 * ```
	 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
	 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
	 * about the workarounds.
	 *
	 * ## jQuery/jqLite Extras
	 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	// Table parts need to be wrapped with `<table>` or they're
	// stripped to their contents when put in a div.
	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do, so we cannot shorten
	// this by omitting <tbody> or other required elements.
	var wrapMap = {
	  thead: ['table'],
	  col: ['colgroup', 'table'],
	  tr: ['tbody', 'table'],
	  td: ['tr', 'tbody', 'table']
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <10 only
	// IE 9 requires an option wrapper & it needs to have the whole table structure
	// set up in advance; assigning `"<td></td>"` to `tr.innerHTML` doesn't work, etc.
	var wrapMapIE9 = {
	  option: [1, '<select multiple="multiple">', '</select>'],
	  _default: [0, '', '']
	};
	
	for (var key in wrapMap) {
	  var wrapMapValueClosing = wrapMap[key];
	  var wrapMapValue = wrapMapValueClosing.slice().reverse();
	  wrapMapIE9[key] = [wrapMapValue.length, '<' + wrapMapValue.join('><') + '>', '</' + wrapMapValueClosing.join('></') + '>'];
	}
	
	wrapMapIE9.optgroup = wrapMapIE9.option;
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap, finalHtml,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    finalHtml = JQLite.legacyXHTMLReplacement ?
	      html.replace(XHTML_TAG_REGEXP, '<$1></$2>') :
	      html;
	
	    if (msie < 10) {
	      wrap = wrapMapIE9[tag] || wrapMapIE9._default;
	      tmp.innerHTML = wrap[1] + finalHtml + wrap[2];
	
	      // Descend through wrappers to the right content
	      i = wrap[0];
	      while (i--) {
	        tmp = tmp.firstChild;
	      }
	    } else {
	      wrap = wrapMap[tag] || [];
	
	      // Create wrappers & descend into them
	      i = wrap.length;
	      while (--i > -1) {
	        tmp.appendChild(window.document.createElement(wrap[i]));
	        tmp = tmp.firstChild;
	      }
	
	      tmp.innerHTML = finalHtml;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function isEmptyObject(obj) {
	  var name;
	
	  for (name in obj) {
	    return false;
	  }
	  return true;
	}
	
	function removeIfEmptyData(element) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  var events = expandoStore && expandoStore.events;
	  var data = expandoStore && expandoStore.data;
	
	  if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	
	  removeIfEmptyData(element);
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	    } else {
	      expandoStore.data = {};
	    }
	
	    removeIfEmptyData(element);
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        newClasses += cssClass + ' ';
	      }
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	      jqLiteOff(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key !== this._lastKey) {
	      this._lastKey = key;
	      this._lastIndex = this._keys.indexOf(key);
	    }
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  has: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    return idx !== -1;
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running AngularJS app
	 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * ## Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ### Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ### `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ### Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * #### Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * #### The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * #### The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	/**
	 * @ngdoc method
	 * @name $injector#loadNewModules
	 *
	 * @description
	 *
	 * **This is a dangerous API, which you use at your own risk!**
	 *
	 * Add the specified modules to the current injector.
	 *
	 * This method will add each of the injectables to the injector and execute all of the config and run
	 * blocks for each module passed to the method.
	 *
	 * If a module has already been loaded into the injector then it will not be loaded again.
	 *
	 * * The application developer is responsible for loading the code containing the modules; and for
	 * ensuring that lazy scripts are not downloaded and executed more often that desired.
	 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
	 * * Modules cannot be unloaded.
	 *
	 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
	 * into the injector, which may indicate whether the script has been executed already.
	 *
	 * @example
	 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
	 *
	 * ```javascript
	 * app.factory('loadModule', function($injector) {
	 *   return function loadModule(moduleName, bundleUrl) {
	 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
	 *   };
	 * })
	 * ```
	 *
	 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * It is possible to inject other providers into the provider function,
	 * but the injected provider must have been defined before the one that requires it.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  instanceInjector.loadNewModules = function(mods) {
	    forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
	  };
	
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	  var customFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#customFilter
	   *
	   * @description
	   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
	   * determine if an animation is allowed or not. When no filter is specified (the default), no
	   * animation will be blocked. Setting the `customFilter` value will only allow animations for
	   * which the filter function's return value is truthy.
	   *
	   * This allows to easily create arbitrarily complex rules for filtering animations, such as
	   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
	   * Filtering animations can also boost performance for low-powered devices, as well as
	   * applications containing a lot of structural operations.
	   *
	   * <div class="alert alert-success">
	   *   **Best Practice:**
	   *   Keep the filtering function as lean as possible, because it will be called for each DOM
	   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
	   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
	   *   directives that support animations.
	   *   Performing computationally expensive or time-consuming operations on each call of the
	   *   filtering function can make your animations sluggish.
	   * </div>
	   *
	   * **Note:** If present, `customFilter` will be checked before
	   * {@link $animateProvider#classNameFilter classNameFilter}.
	   *
	   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
	   *   If a falsy value is returned, no animation will be performed. The function will be called
	   *   with the following arguments:
	   *   - **node** `{DOMElement}` - The DOM element to be animated.
	   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
	   *     etc).
	   *   - **options** `{Object}` - A collection of options/styles used for the animation.
	   * @return {Function} The current filter function or `null` if there is none set.
	   */
	  this.customFilter = function(filterFn) {
	    if (arguments.length === 1) {
	      customFilter = isFunction(filterFn) ? filterFn : null;
	    }
	
	    return customFilter;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   *
	   * **Note:** If present, `classNameFilter` will be checked after
	   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
	   * false, `classNameFilter` will not be checked.
	   *
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * <div class="alert alert-warning">
	       * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
	       * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
	       * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
	       * However, there are two exceptions:
	       *
	       * <ul>
	       *   <li>if both an {@link ng.$animate#addClass addClass()} and a
	       *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
	       *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
	       *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
	       *   the `setClass` event, but if it either removes or adds classes,
	       *   it will fire `animate` instead.</li>
	       * </ul>
	       *
	       * </div>
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered.
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       * * `data` - an object with these properties:
	       *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
	       *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
	       *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
	       *     * to - `{Object|null}` - CSS properties & values at the end of the animation
	       *
	       * Note that the callback does not trigger a scope digest. Wrap your call into a
	       * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation and applies the end state of the animation.
	       * Note that this does not cancel the underlying operation, e.g. the setting of classes or
	       * adding the element to the DOM.
	       *
	       * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
	       *
	       * @example
	        <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
	          <file name="app.js">
	            angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
	              templateUrl: 'template.html',
	              controller: function($element, $animate) {
	                this.runner = null;
	
	                this.addClass = function() {
	                  this.runner = $animate.addClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.removeClass = function() {
	                  this.runner = $animate.removeClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.cancel = function() {
	                  $animate.cancel(this.runner);
	                };
	              }
	            });
	          </file>
	          <file name="template.html">
	            <p>
	              <button id="add" ng-click="$ctrl.addClass()">Add</button>
	              <button ng-click="$ctrl.removeClass()">Remove</button>
	              <br>
	              <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
	              <br>
	              <div id="target">CSS-Animated Text</div>
	            </p>
	          </file>
	          <file name="index.html">
	            <cancel-example></cancel-example>
	          </file>
	          <file name="style.css">
	            .red-add, .red-remove {
	              transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
	            }
	
	            .red,
	            .red-add.red-add-active {
	              color: #FF0000;
	              font-size: 40px;
	            }
	
	            .red-remove.red-remove-active {
	              font-size: 10px;
	              color: black;
	            }
	
	          </file>
	        </example>
	       */
	      cancel: function(runner) {
	        if (runner.cancel) {
	          runner.cancel();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} animationRunner the animation runner
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global getHash: true, stripHash: false */
	
	function getHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? '' : url.substr(index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/#$/, '');
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer, $$taskTrackerFactory) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {},
	      taskTracker = $$taskTrackerFactory($log);
	
	  self.isMock = false;
	
	  //////////////////////////////////////////////////////////////
	  // Task-tracking API
	  //////////////////////////////////////////////////////////////
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = taskTracker.completeTask;
	  self.$$incOutstandingRequestCount = taskTracker.incTaskCount;
	
	  // TODO(vojta): prefix this method with $$ ?
	  self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of `location.href` (with a
	   * trailing `#` stripped of if the hash is empty).
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
	   * `location.href`/`location.replace` is used.
	   * Returns its own instance to allow chaining.
	   *
	   * NOTE: this api is intended for use only by the `$location` service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state State object to use with `pushState`/`replaceState`
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Normalize the inputted URL
	      url = urlResolve(url).href;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      return trimEmptyHash(pendingLocation || location.href);
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of AngularJS:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of AngularJS.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay, taskType) {
	    var timeoutId;
	
	    delay = delay || 0;
	    taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;
	
	    taskTracker.incTaskCount(taskType);
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      taskTracker.completeTask(fn, taskType);
	    }, delay);
	    pendingDeferIds[timeoutId] = taskType;
	
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds.hasOwnProperty(deferId)) {
	      var taskType = pendingDeferIds[deferId];
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      taskTracker.completeTask(noop, taskType);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document', '$$taskTrackerFactory',
	       function($window,   $log,   $sniffer,   $document,   $$taskTrackerFactory) {
	    return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
	       * directive to cache templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
	 * {@link ng.$cacheFactory $cacheFactory}.
	 *
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
	 * or by consuming the `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
	 * element with {@link ngApp} attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with life-cycle hooks in the new Angular
	 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
	 *
	 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
	 *   `ngDoCheck` in Angular.
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance.)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
	 *   isn't  optional and doesn't exist, an exception
	 *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
	 *   to the local value, since it will be impossible to sync them back to the parent scope.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr`
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   It's also possible to watch the evaluated value shallowly with
	 *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
	 * The marker must come after the mode and before the attribute name.
	 * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
	 * This is useful to refine the interface directives provide.
	 * One subtle difference between optional and non-optional happens **when the binding attribute is not
	 * set**:
	 * - the binding is optional: the property will not be defined
	 * - the binding is not optional: the property is defined
	 *
	 * ```js
	 *app.directive('testDir', function() {
	    return {
	      scope: {
	        notoptional: '=',
	        optional: '=?',
	      },
	      bindToController: true,
	      controller: function() {
	        this.$onInit = function() {
	          console.log(this.hasOwnProperty('notoptional')) // true
	          console.log(this.hasOwnProperty('optional')) // false
	        }
	      }
	    }
	  })
	 *```
	 *
	 *
	 * ##### Combining directives with different scope defintions
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}.
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace`
	 * <div class="alert alert-danger">
	 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
	 * </div>
	 *
	 * Specifies what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using `$compile` in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that are defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Multi-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}.
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like `ngBind` can be expressed in many ways:
	 *   `ng:bind`, `data-ng-bind`, or `x-ng-bind`. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // Configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects '$compile'.
	        $compileProvider.directive('compile', function($compile) {
	          // The directive factory creates a link function.
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                // Watch the 'compile' expression for changes.
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // When the 'compile' expression changes
	                // assign it into the current DOM.
	                element.html(value);
	
	                // Compile the new DOM and link it to the current scope.
	                // NOTE: we only compile '.childNodes' so that we
	                // don't get into an infinite loop compiling ourselves.
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'AngularJS';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello AngularJS'.
	       expect(output.getText()).toBe('Hello AngularJS');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('AngularJS!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non HTML
	 *        elements (e.g. SVG elements). See also the `directive.controller` property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to `$digest`, which typically is done by
	 * AngularJS automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = angular.element('<p>{{total}}</p>');
	 *     $compile(element)(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone either via the `cloneAttachFn` or the value returned by the
	 *   linking function:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>');
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       // Attach the clone to DOM document at the right place.
	 *     });
	 *
	 *     // Now we have reference to the cloned DOM via `clonedElement`.
	 *     // NOTE: The `clonedElement` returned by the linking function is the same as the
	 *     //       `clonedElement` passed to `cloneAttachFn`.
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	
	 * @knownIssue
	
	   ### Issues with `replace: true`
	 *
	 * <div class="alert alert-danger">
	 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
	 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
	 * </div>
	 *
	 * #### Attribute values are not merged
	 *
	 * When a `replace` directive encounters the same attribute on the original and the replace node,
	 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
	 * the `style` attribute.
	 * ```html
	 * Original Node: <span class="original" style="color: red;"></span>
	 * Replace Template: <span class="replaced" style="background: blue;"></span>
	 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
	 * ```
	 *
	 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
	 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
	 *
	 * ```html
	 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
	 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
	 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
	 * ```
	 *
	 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
	 *
	 * #### Directives are not deduplicated before compilation
	 *
	 * When the original node and the replace template declare the same directive(s), they will be
	 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
	 * does not deduplicate them. In many cases, this is not noticeable, but e.g. {@link ngModel} will
	 * attach `$formatters` and `$parsers` twice.
	 *
	 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
	 *
	 * #### `transclude: element` in the replace template root can have unexpected effects
	 *
	 * When the replace template has a directive at the root node that uses
	 * {@link $compile#-transclude- `transclude: element`}, e.g.
	 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
	 * See the following issues:
	 *
	 * - Incorrect scope on replaced element:
	 * [#9837](https://github.com/angular/angular.js/issues/9837)
	 * - Different DOM between `template` and `templateUrl`:
	 * [#10612](https://github.com/angular/angular.js/issues/14326)
	 *
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngProp
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-prop-propname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "propName"):
	 *
	 *
	 * ```html
	 * <ANY ng-prop-prop_name="expression">
	 * </ANY>
	 * ```
	 *
	 *
	 * @description
	 * The `ngProp` directive binds an expression to a DOM element property.
	 * `ngProp` allows writing to arbitrary properties by including
	 * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
	 * the `value` property.
	 *
	 * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
	 * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
	 *
	 * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
	 * often use custom properties to hold data, and `ngProp` can be used to provide input to these
	 * custom elements.
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
	 * example, and for binding HTML {@link ngBindHtml} should be used.
	 *
	 * ## Security
	 *
	 * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
	 * can insert potentially dangerous HTML into the application, e.g. script tags that execute
	 * malicious code.
	 * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
	 * This means vulnerable properties require their content to be "trusted", based on the
	 * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
	 * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
	 * this property are trusted as a `RESOURCE_URL`.
	 *
	 * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
	 * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
	 * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
	 *
	 * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
	 *
	 * Based on the context, other options may exist to mark a value as trusted / configure the behavior
	 * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
	 * the {@link $sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList()}
	 * and {@link $sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList()}.
	 *
	 * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
	 *
	 * ### HTML Sanitization
	 *
	 * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
	 * content.
	 * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
	 * potentially dangerous HTML, e.g. strip non-trusted tags and attributes when binding to
	 * `innerHTML`.
	 *
	 * @example
	 * ### Binding to different contexts
	 *
	 * <example name="ngProp" module="exampleNgProp">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         Binding to a property without security context:
	 *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerText</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... so that actually dangerous content cannot be executed:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Binding to innerHTML with ngSanitize
	 *
	 * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', ['ngSanitize'])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         "Safe" content will be sanitized ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... as will dangerous content:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... and content that has been trusted explicitly works the same as without ngSanitize:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 */
	
	/** @ngdoc directive
	 * @name ngOn
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-on-eventname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "eventName"):
	 *
	 *
	 * ```html
	 * <ANY ng-on-event_name="expression">
	 * </ANY>
	 * ```
	 *
	 * @description
	 * The `ngOn` directive adds an event listener to a DOM element via
	 * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
	 * fired.
	 * `ngOn` allows adding listeners for arbitrary events by including
	 * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
	 * when the `drop` event is fired.
	 *
	 * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
	 * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
	 * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
	 * standards.
	 *
	 * Another use-case for `ngOn` is listening to
	 * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
	 * fired by
	 * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `myEvent` must be written as `ng-on-my_event="expression"`.
	 *
	 * @example
	 * ### Bind to built-in DOM events
	 *
	 * <example name="ngOn" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.clickCount = 0;
	 *           this.mouseoverCount = 0;
	 *
	 *           this.loadingState = 0;
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       This is equivalent to `ngClick` and `ngMouseover`:<br>
	 *       <button
	 *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
	 *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
	 *       clickCount: {{$ctrl.clickCount}}<br>
	 *       mouseover: {{$ctrl.mouseoverCount}}
	 *
	 *       <hr>
	 *
	 *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
	 *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
	 *       <div ng-switch="$ctrl.loadingState">
	 *         <span ng-switch-when="0">Image is loading</span>
	 *         <span ng-switch-when="-1">Image load error</span>
	 *         <span ng-switch-when="1">Image loaded successfully</span>
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Bind to custom DOM events
	 *
	 * <example name="ngOnCustom" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.eventLog = '';
	 *
	 *           this.listener = function($event) {
	 *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
	 *           };
	 *         }
	 *       })
	 *       .component('childComponent', {
	 *         templateUrl: 'child.html',
	 *         controller: function($element) {
	 *           this.fireEvent = function() {
	 *             var event = new CustomEvent('customtype', { detail: new Date()});
	 *
	 *             $element[0].dispatchEvent(event);
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
	 *     <span>Event log: {{$ctrl.eventLog}}</span>
	 *   </file>
	 *   <file name="child.html">
	      <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      definition = definition.trim();
	
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. `ngBind` which will match
	   *    as `ng-bind`), or an object map of directives where the keys are the names and the values
	   *    are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	   *    or an object map of components where the keys are the names and the values are the component definition objects.
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    if (!isString(name)) {
	      forEach(name, reverseParams(bind(this, registerComponent)));
	      return this;
	    }
	
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationTrustedUrlList
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationTrustedUrlList`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $compileProvider#aHrefSanitizationTrustedUrlList
	   * aHrefSanitizationTrustedUrlList} instead.
	   */
	  Object.defineProperty(this, 'aHrefSanitizationWhitelist', {
	    get: function() {
	      return this.aHrefSanitizationTrustedUrlList;
	    },
	    set: function(value) {
	      this.aHrefSanitizationTrustedUrlList = value;
	    }
	  });
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationTrustedUrlList
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationTrustedUrlList`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $compileProvider#imgSrcSanitizationTrustedUrlList
	   * imgSrcSanitizationTrustedUrlList} instead.
	   */
	  Object.defineProperty(this, 'imgSrcSanitizationWhitelist', {
	    get: function() {
	      return this.imgSrcSanitizationTrustedUrlList;
	    },
	    set: function(value) {
	      this.imgSrcSanitizationTrustedUrlList = value;
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `ng-scope` and `ng-isolated-scope` CSS classes
	   * * `$binding` data property containing an array of the binding expressions
	   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
	   *   the element's scope.
	   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
	   *   E.g. `<!-- ngIf: shouldShow() -->`.
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#strictComponentBindingsEnabled
	   *
	   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
	   * otherwise return the current strictComponentBindingsEnabled state.
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable / disable the strict component bindings check. If enabled, the
	   * compiler will enforce that all scope / controller bindings of a
	   * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
	   * that are not set as optional with `?`, must be provided when the directive is instantiated.
	   * If not provided, the compiler will throw the
	   * {@link error/$compile/missingattr $compile:missingattr error}.
	   *
	   * The default value is false.
	   */
	  var strictComponentBindingsEnabled = false;
	  this.strictComponentBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      strictComponentBindingsEnabled = enabled;
	      return this;
	    }
	    return strictComponentBindingsEnabled;
	  };
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	
	  /**
	   * The security context of DOM Properties.
	   * @private
	   */
	  var PROP_CONTEXTS = createMap();
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#addPropertySecurityContext
	   * @description
	   *
	   * Defines the security context for DOM properties bound by ng-prop-*.
	   *
	   * @param {string} elementName The element name or '*' to match any element.
	   * @param {string} propertyName The DOM property name.
	   * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
	   * @returns {object} `this` for chaining
	   */
	  this.addPropertySecurityContext = function(elementName, propertyName, ctx) {
	    var key = (elementName.toLowerCase() + '|' + propertyName.toLowerCase());
	
	    if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) {
	      throw $compileMinErr('ctxoverride', 'Property context \'{0}.{1}\' already set to \'{2}\', cannot override to \'{3}\'.', elementName, propertyName, PROP_CONTEXTS[key], ctx);
	    }
	
	    PROP_CONTEXTS[key] = ctx;
	    return this;
	  };
	
	  /* Default property contexts.
	   *
	   * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
	   * Changing:
	   * - SecurityContext.* => SCE_CONTEXTS/$sce.*
	   * - STYLE => CSS
	   * - various URL => MEDIA_URL
	   * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
	   */
	  (function registerNativePropertyContexts() {
	    function registerContext(ctx, values) {
	      forEach(values, function(v) { PROP_CONTEXTS[v.toLowerCase()] = ctx; });
	    }
	
	    registerContext(SCE_CONTEXTS.HTML, [
	      'iframe|srcdoc',
	      '*|innerHTML',
	      '*|outerHTML'
	    ]);
	    registerContext(SCE_CONTEXTS.CSS, ['*|style']);
	    registerContext(SCE_CONTEXTS.URL, [
	      'area|href',       'area|ping',
	      'a|href',          'a|ping',
	      'blockquote|cite',
	      'body|background',
	      'del|cite',
	      'input|src',
	      'ins|cite',
	      'q|cite'
	    ]);
	    registerContext(SCE_CONTEXTS.MEDIA_URL, [
	      'audio|src',
	      'img|src',    'img|srcset',
	      'source|src', 'source|srcset',
	      'track|src',
	      'video|src',  'video|poster'
	    ]);
	    registerContext(SCE_CONTEXTS.RESOURCE_URL, [
	      '*|formAction',
	      'applet|code',      'applet|codebase',
	      'base|href',
	      'embed|src',
	      'frame|src',
	      'form|action',
	      'head|profile',
	      'html|manifest',
	      'iframe|src',
	      'link|href',
	      'media|src',
	      'object|codebase',  'object|data',
	      'script|src'
	    ]);
	  })();
	
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function sanitizeSrcset(value, invokeType) {
	      if (!value) {
	        return value;
	      }
	      if (!isString(value)) {
	        throw $compileMinErr('srcset', 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
	      }
	
	      // Such values are a bit too complex to handle automatically inside $sce.
	      // Instead, we sanitize each of the URIs individually, which works, even dynamically.
	
	      // It's not possible to work around this using `$sce.trustAsMediaUrl`.
	      // If you want to programmatically set explicitly trusted unsafe URLs, you should use
	      // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
	      // `ng-bind-html` directive.
	
	      var result = '';
	
	      // first check if there are spaces because it's not the same pattern
	      var trimmedSrcset = trim(value);
	      //                (   999x   ,|   999w   ,|   ,|,   )
	      var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	      var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	      // split srcset into tuple of uri and descriptor except for the last item
	      var rawUris = trimmedSrcset.split(pattern);
	
	      // for each tuples
	      var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	      for (var i = 0; i < nbrUrisWith2parts; i++) {
	        var innerIdx = i * 2;
	        // sanitize the uri
	        result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
	        // add the descriptor
	        result += ' ' + trim(rawUris[innerIdx + 1]);
	      }
	
	      // split the last item into uri and descriptor
	      var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	      // sanitize the last uri
	      result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));
	
	      // and add the last descriptor if any
	      if (lastTuple.length === 2) {
	        result += (' ' + trim(lastTuple[1]));
	      }
	      return result;
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        // is set through this function since it may cause $updateClass to
	        // become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        // Sanitize img[srcset] values.
	        if (nodeName === 'img' && key === 'srcset') {
	          this[key] = value = sanitizeSrcset(value, '$set(\'srcset\', value)');
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              // jQuery skips special boolean attrs treatment in XML nodes for
	              // historical reasons and hence AngularJS cannot freely call
	              // `.attr(attrName, false) with such attributes. To avoid issues
	              // in XHTML, call `removeAttr` in such cases instead.
	              // See https://github.com/jquery/jquery/issues/4249
	              if (booleanKey && value === false) {
	                this.$$element.removeAttr(attrName);
	              } else {
	                this.$$element.attr(attrName, value);
	              }
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div></div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            var isNgAttr = false, isNgProp = false, isNgEvent = false;
	            var multiElementMatch;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            nName = directiveNormalize(name.toLowerCase());
	
	            // Support ng-attr-*, ng-prop-* and ng-on-*
	            if ((ngPrefixMatch = nName.match(NG_PREFIX_BINDING))) {
	              isNgAttr = ngPrefixMatch[1] === 'Attr';
	              isNgProp = ngPrefixMatch[1] === 'Prop';
	              isNgEvent = ngPrefixMatch[1] === 'On';
	
	              // Normalize the non-prefixed name
	              name = name.replace(PREFIX_REGEXP, '')
	                .toLowerCase()
	                .substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	
	            // Support *-start / *-end multi element directives
	            } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            if (isNgProp || isNgEvent) {
	              attrs[nName] = value;
	              attrsMap[nName] = attr.name;
	
	              if (isNgProp) {
	                addPropertyDirective(node, directives, nName, name);
	              } else {
	                addEventDirective(directives, nName, name);
	              }
	            } else {
	              // Update nName for cases where a prefix was removed
	              // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
	              nName = directiveNormalize(name.toLowerCase());
	              attrsMap[nName] = name;
	
	              if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	              }
	
	              addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	              addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                            attrEndName);
	            }
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = window.document.createDocumentFragment();
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || window.document.createDocumentFragment();
	                  slots[slotName].appendChild(node);
	                } else {
	                  $template.appendChild(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  var slotCompileNodes = jqLite(slots[slotName].childNodes);
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
	                }
	              }
	
	              $template = jqLite($template.childNodes);
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          controller.instance = controller();
	          $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	          controller.bindingInfo =
	            initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	
	          if (inheritType === '^^' && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) {
	            // inheritedData() uses the documentElement when it finds the document, so we would
	            // require from the element itself.
	            value = null;
	          } else {
	            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	          }
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (isError(error)) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedAttrContext(nodeName, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      // All nodes with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media nodes, which require the MEDIA_URL context.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(nodeName) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	        return $sce.MEDIA_URL;
	      } else if (attrNormalizedName === 'xlinkHref') {
	        // Some xlink:href are okay, most aren't
	        if (nodeName === 'image') return $sce.MEDIA_URL;
	        if (nodeName === 'a') return $sce.URL;
	        return $sce.RESOURCE_URL;
	      } else if (
	          // Formaction
	          (nodeName === 'form' && attrNormalizedName === 'action') ||
	          // If relative URLs can go where they are not expected to, then
	          // all sorts of trust issues can arise.
	          (nodeName === 'base' && attrNormalizedName === 'href') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (nodeName === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      } else if (nodeName === 'a' && (attrNormalizedName === 'href' ||
	                                 attrNormalizedName === 'ngHref')) {
	        return $sce.URL;
	      }
	    }
	
	    function getTrustedPropContext(nodeName, propNormalizedName) {
	      var prop = propNormalizedName.toLowerCase();
	      return PROP_CONTEXTS[nodeName + '|' + prop] || PROP_CONTEXTS['*|' + prop];
	    }
	
	    function sanitizeSrcsetPropertyValue(value) {
	      return sanitizeSrcset($sce.valueOf(value), 'ng-prop-srcset');
	    }
	    function addPropertyDirective(node, directives, attrName, propName) {
	      if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) {
	        throw $compileMinErr('nodomevents', 'Property bindings for HTML DOM event properties are disallowed');
	      }
	
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedPropContext(nodeName, propName);
	
	      var sanitizer = identity;
	      // Sanitize img[srcset] + source[srcset] values.
	      if (propName === 'srcset' && (nodeName === 'img' || nodeName === 'source')) {
	        sanitizer = sanitizeSrcsetPropertyValue;
	      } else if (trustedContext) {
	        sanitizer = $sce.getTrusted.bind($sce, trustedContext);
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function ngPropCompileFn(_, attr) {
	          var ngPropGetter = $parse(attr[attrName]);
	          var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
	            // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	            return $sce.valueOf(val);
	          });
	
	          return {
	            pre: function ngPropPreLinkFn(scope, $element) {
	              function applyPropValue() {
	                var propValue = ngPropGetter(scope);
	                $element[0][propName] = sanitizer(propValue);
	              }
	
	              applyPropValue();
	              scope.$watch(ngPropWatch, applyPropValue);
	            }
	          };
	        }
	      });
	    }
	
	    function addEventDirective(directives, attrName, eventName) {
	      directives.push(
	        createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/false)
	      );
	    }
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedAttrContext(nodeName, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	    function strictBindingsCheck(attrName, directiveName) {
	      if (strictComponentBindingsEnabled) {
	        throw $compileMinErr('missingattr',
	          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
	          attrName, directiveName);
	      }
	    }
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	              destination[scopeName] = attrs[attrName] = undefined;
	
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var isLiteral = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope[definition.collection ? '$watchCollection' : '$watch'](parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (isLiteral && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            });
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	            }
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in AngularJS:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by AngularJS to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {};
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in AngularJS expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value) || isFunction(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          if (isFunction(toSerialize)) {
	            toSerialize = toSerialize();
	          }
	          parts.push(encodeUriQuery(prefix) + '=' +
	              (toSerialize == null ? '' : encodeUriQuery(serializeValue(toSerialize))));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);
	
	      if (hasJsonContentType || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          if (!hasJsonContentType) {
	            return data;
	          }
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.transformRequest`** -
	   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
	   * An array of functions (or a single function) which are applied to the request data.
	   * By default, this is an array with one request transformation function:
	   *
	   *   - If the `data` property of the request configuration object contains an object, serialize it
	   *     into JSON format.
	   *
	   * - **`defaults.transformResponse`** -
	   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
	   * An array of functions (or a single function) which are applied to the response data. By default,
	   * this is an array which applies one response transformation function that does two things:
	   *
	   *  - If XSRF prefix is detected, strip it
	   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
	   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *    deserialize it using a JSON parser.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   */
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   */
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   */
	  var interceptorFactories = this.interceptors = [];
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#xsrfTrustedOrigins
	   * @description
	   *
	   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
	   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
	   * XSRF.
	   *
	   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
	   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
	   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
	   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
	   * Examples: `http://example.com`, `https://api.example.com:9876`
	   *
	   * <div class="alert alert-warning">
	   *   It is not possible to trust specific URLs/paths. The `path`, `query` and `fragment` parts
	   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
	   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
	   *   `https://foo.com/` will include the XSRF token.
	   * </div>
	   *
	   * @example
	   *
	   * ```js
	   * // App served from `https://example.com/`.
	   * angular.
	   *   module('xsrfTrustedOriginsExample', []).
	   *   config(['$httpProvider', function($httpProvider) {
	   *     $httpProvider.xsrfTrustedOrigins.push('https://api.example.com');
	   *   }]).
	   *   run(['$http', function($http) {
	   *     // The XSRF token will be sent.
	   *     $http.get('https://api.example.com/preferences').then(...);
	   *
	   *     // The XSRF token will NOT be sent.
	   *     $http.get('https://stats.example.com/activity').then(...);
	   *   }]);
	   * ```
	   */
	  var xsrfTrustedOrigins = this.xsrfTrustedOrigins = [];
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#xsrfWhitelistedOrigins
	   * @description
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This property is deprecated. Use {@link $httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}
	   * instead.
	   */
	  Object.defineProperty(this, 'xsrfWhitelistedOrigins', {
	    get: function() {
	      return this.xsrfTrustedOrigins;
	    },
	    set: function(origins) {
	      this.xsrfTrustedOrigins = origins;
	    }
	  });
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * A function to check request URLs against a list of allowed origins.
	     */
	    var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfTrustedOrigins);
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core AngularJS service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
	     * resolved (request success) or rejected (request failure) with a
	     * {@link ng.$http#$http-returns response} object.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * AngularJS provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
	     * an array with one function that does the following:
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
	     * an array with one function that does the following:
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *      deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * AngularJS will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * AngularJS will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
	     * the cookie, your server can be assured that the XHR came from JavaScript running on your
	     * domain.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
	     * sure that only JavaScript running on your domain could have sent the request. The token must
	     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
	     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
	     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
	     * want to, you can trust additional origins to also receive the XSRF token, by adding them
	     * to {@link ng.$httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}. This might be
	     * useful, for example, if your application, served from `example.com`, needs to access your API
	     * at `api.example.com`.
	     * See {@link ng.$httpProvider#xsrfTrustedOrigins $httpProvider.xsrfTrustedOrigins} for
	     * more details.
	     *
	     * <div class="alert alert-danger">
	     *   **Warning**<br />
	     *   Only trusted origins that you have control over and make sure you understand the
	     *   implications of doing so.
	     * </div>
	     *
	     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
	     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
	     * `$http.defaults` at run-time, or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple AngularJS apps share the
	     * same domain or subdomain, we recommend that each application uses a unique cookie name.
	     *
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *
	     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
	     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
	     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
	     *
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
	     *   or rejected (request failure) with a response object.
	     *
	     *   The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with
	     *     the transform functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used
	     *     to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
	     *     (`complete`, `error`, `timeout` or `abort`).
	     *
	     *
	     *   A response status code between 200 and 299 is considered a success status
	     *   and will result in the success callback being called. Any response status
	     *   code outside of that range is considered an error status and will result
	     *   in the error callback being called.
	     *   Also, status codes less than -1 are normalized to zero. -1 usually means
	     *   the request was aborted, e.g. using a `config.timeout`. More information
	     *   about the status might be available in the `xhrStatus` property.
	     *
	     *   Note that if the response is a redirect, XMLHttpRequest will transparently
	     *   follow it, meaning that the outcome (success or error) will be determined
	     *   by the final response status code.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must add the JSONP endpoint that we are using to the trusted list to show that we trust it
	      $sceDelegateProvider.trustedResourceUrlList([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount('$http');
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop, '$http');
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the trusted resource URL list via
	     * {@link $sceDelegateProvider#trustedResourceUrlList  `$sceDelegateProvider.trustedResourceUrlList`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * You should avoid generating the URL for the JSONP request from user provided data.
	     * Provide additional query parameters via `params` property of the `config` parameter, rather than
	     * modifying the URL itself.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	      * See {@link ng.$http#$http-returns `$http()` return value}.
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsAllowedOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText, xhrStatus) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText, xhrStatus);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText, xhrStatus) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText,
	          xhrStatus: xhrStatus
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, cbKey) {
	      var parts = url.split('?');
	      if (parts.length > 2) {
	        // Throw if the url contains more than one `?` query indicator
	        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
	      }
	      var params = parseKeyValue(parts[1]);
	      forEach(params, function(value, key) {
	        if (value === 'JSON_CALLBACK') {
	          // Throw if the url already contains a reference to JSON_CALLBACK
	          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	        }
	        if (key === cbKey) {
	          // Throw if the callback param was already provided
	          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
	        }
	      });
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text, 'complete');
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	      var abortedByTimeout = false;
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText,
	            'complete');
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'error');
	      };
	
	      var requestAborted = function() {
	        completeRequest(callback, -1, null, null, '', abortedByTimeout ? 'timeout' : 'abort');
	      };
	
	      var requestTimeout = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'timeout');
	      };
	
	      xhr.onerror = requestError;
	      xhr.ontimeout = requestTimeout;
	      xhr.onabort = requestAborted;
	
	      forEach(eventHandlers, function(value, key) {
	        xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    // Since we are using xhr.abort() when a request times out, we have to set a flag that
	    // indicates to requestAborted if the request timed out or was aborted.
	    //
	    // http.timeout = numerical timeout   timeout
	    // http.timeout = $timeout            timeout
	    // http.timeout = promise             abort
	    // xhr.abort()                        abort (The xhr object is normally inaccessible, but
	    //                                    can be exposed with the xhrFactory)
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(function() {
	        timeoutRequest('timeout');
	      }, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(function() {
	        timeoutRequest(isDefined(timeout.$$timeoutId) ? 'timeout' : 'abort');
	      });
	    }
	
	    function timeoutRequest(reason) {
	      abortedByTimeout = reason === 'timeout';
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText, xhrStatus);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    }
	    return startSymbol;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    }
	    return endSymbol;
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'AngularJS';
	     *   expect(exp(context)).toEqual('Hello AngularJS!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;
	
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        if (mustHaveExpression) return;
	
	        var unescapedText = unescapeText(text);
	        if (contextAllowsConcatenation) {
	          unescapedText = $sce.getTrusted(trustedContext, unescapedText);
	        }
	        var constantInterp = valueFn(unescapedText);
	        constantInterp.exp = text;
	        constantInterp.expressions = [];
	        constantInterp.$$watchDelegate = constantWatchDelegate;
	
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns,
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [],
	          singleExpression;
	
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push(''); // Placeholder that will get replaced with the evaluated expression.
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      singleExpression = concat.length === 1 && expressionPositions.length === 1;
	      // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
	      // objects rather than simple strings
	      // (we don't modify the expression if the input consists of only a single trusted input)
	      var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
	      parseFns = expressions.map(function(exp) { return $parse(exp, interceptor); });
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
	      // we ensure that the value that's used is assigned or constructed by some JS code somewhere
	      // that is more testable or make it obvious that you bound the value to some user controlled
	      // value.  This helps reduce the load when auditing for XSS issues.
	
	      // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
	      // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
	      // or on the overall concatenated string (losing trusted types used in the mix, by design).
	      // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
	      // only used in srcdoc attributes, this would not be very useful.
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	
	          if (contextAllowsConcatenation) {
	            // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
	            return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(''));
	          } else if (trustedContext && concat.length > 1) {
	            // This context does not allow more than one part, e.g. expr + string or exp + exp.
	            $interpolateMinErr.throwNoconcat(text);
	          }
	          // In an unprivileged context or only one part: just concatenate and return.
	          return concat.join('');
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
	          // parts of a full URL. We don't care about losing the trustedness here.
	          // In non-concatenable contexts, where there is only one expression, this interceptor is
	          // not applied to the expression.
	          value = (trustedContext && !contextAllowsConcatenation) ?
	                    $sce.getTrusted(trustedContext, value) :
	                    $sce.valueOf(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	var $intervalMinErr = minErr('$interval');
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$$intervalFactory', '$window',
	       function($$intervalFactory,   $window) {
	    var intervals = {};
	    var setIntervalFn = function(tick, delay, deferred) {
	      var id = $window.setInterval(tick, delay);
	      intervals[id] = deferred;
	      return id;
	    };
	    var clearIntervalFn = function(id) {
	      $window.clearInterval(id);
	      delete intervals[id];
	    };
	
	    /**
	     * @ngdoc service
	     * @name $interval
	     *
	     * @description
	     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	     * milliseconds.
	     *
	     * The return value of registering an interval function is a promise. This promise will be
	     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	     * run indefinitely if `count` is not defined. The value of the notification will be the
	     * number of iterations that have run.
	     * To cancel an interval, call `$interval.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	     * time.
	     *
	     * <div class="alert alert-warning">
	     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	     * with them.  In particular they are not automatically destroyed when a controller's scope or a
	     * directive's element are destroyed.
	     * You should take this into consideration and make sure to always cancel the interval at the
	     * appropriate moment.  See the example below for more details on how and when to do this.
	     * </div>
	     *
	     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	     *   are passed (see below), the function is called with the current iteration count.
	     * @param {number} delay Number of milliseconds between each function call.
	     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	     *   indefinitely.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	     *
	     * @example
	     * <example module="intervalExample" name="interval-service">
	     * <file name="index.html">
	     *   <script>
	     *     angular.module('intervalExample', [])
	     *       .controller('ExampleController', ['$scope', '$interval',
	     *         function($scope, $interval) {
	     *           $scope.format = 'M/d/yy h:mm:ss a';
	     *           $scope.blood_1 = 100;
	     *           $scope.blood_2 = 120;
	     *
	     *           var stop;
	     *           $scope.fight = function() {
	     *             // Don't start a new fight if we are already fighting
	     *             if ( angular.isDefined(stop) ) return;
	     *
	     *             stop = $interval(function() {
	     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	     *                 $scope.blood_1 = $scope.blood_1 - 3;
	     *                 $scope.blood_2 = $scope.blood_2 - 4;
	     *               } else {
	     *                 $scope.stopFight();
	     *               }
	     *             }, 100);
	     *           };
	     *
	     *           $scope.stopFight = function() {
	     *             if (angular.isDefined(stop)) {
	     *               $interval.cancel(stop);
	     *               stop = undefined;
	     *             }
	     *           };
	     *
	     *           $scope.resetFight = function() {
	     *             $scope.blood_1 = 100;
	     *             $scope.blood_2 = 120;
	     *           };
	     *
	     *           $scope.$on('$destroy', function() {
	     *             // Make sure that the interval is destroyed too
	     *             $scope.stopFight();
	     *           });
	     *         }])
	     *       // Register the 'myCurrentTime' directive factory method.
	     *       // We inject $interval and dateFilter service since the factory method is DI.
	     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	     *         function($interval, dateFilter) {
	     *           // return the directive link function. (compile function not needed)
	     *           return function(scope, element, attrs) {
	     *             var format,  // date format
	     *                 stopTime; // so that we can cancel the time updates
	     *
	     *             // used to update the UI
	     *             function updateTime() {
	     *               element.text(dateFilter(new Date(), format));
	     *             }
	     *
	     *             // watch the expression, and update the UI on change.
	     *             scope.$watch(attrs.myCurrentTime, function(value) {
	     *               format = value;
	     *               updateTime();
	     *             });
	     *
	     *             stopTime = $interval(updateTime, 1000);
	     *
	     *             // listen on DOM destroy (removal) event, and cancel the next UI update
	     *             // to prevent updating time after the DOM element was removed.
	     *             element.on('$destroy', function() {
	     *               $interval.cancel(stopTime);
	     *             });
	     *           }
	     *         }]);
	     *   </script>
	     *
	     *   <div>
	     *     <div ng-controller="ExampleController">
	     *       <label>Date format: <input ng-model="format"></label> <hr/>
	     *       Current time is: <span my-current-time="format"></span>
	     *       <hr/>
	     *       Blood 1 : <font color='red'>{{blood_1}}</font>
	     *       Blood 2 : <font color='red'>{{blood_2}}</font>
	     *       <button type="button" data-ng-click="fight()">Fight</button>
	     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	     *     </div>
	     *   </div>
	     *
	     * </file>
	     * </example>
	     */
	    var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);
	
	    /**
	     * @ngdoc method
	     * @name $interval#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`.
	     *
	     * @param {Promise=} promise returned by the `$interval` function.
	     * @returns {boolean} Returns `true` if the task was successfully canceled.
	     */
	    interval.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$intervalId')) {
	        throw $intervalMinErr('badprom',
	            '`$interval.cancel()` called with a promise that was not generated by `$interval()`.');
	      }
	
	      if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;
	
	      var id = promise.$$intervalId;
	      var deferred = intervals[id];
	
	      // Interval cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      clearIntervalFn(id);
	
	      return true;
	    };
	
	    return interval;
	  }];
	}
	
	/** @this */
	function $$IntervalFactoryProvider() {
	  this.$get = ['$browser', '$q', '$$q', '$rootScope',
	       function($browser,   $q,   $$q,   $rootScope) {
	    return function intervalFactory(setIntervalFn, clearIntervalFn) {
	      return function intervalFn(fn, delay, count, invokeApply) {
	        var hasParams = arguments.length > 4,
	            args = hasParams ? sliceArgs(arguments, 4) : [],
	            iteration = 0,
	            skipApply = isDefined(invokeApply) && !invokeApply,
	            deferred = (skipApply ? $$q : $q).defer(),
	            promise = deferred.promise;
	
	        count = isDefined(count) ? count : 0;
	
	        function callback() {
	          if (!hasParams) {
	            fn(iteration);
	          } else {
	            fn.apply(null, args);
	          }
	        }
	
	        function tick() {
	          if (skipApply) {
	            $browser.defer(callback);
	          } else {
	            $rootScope.$evalAsync(callback);
	          }
	          deferred.notify(iteration++);
	
	          if (count > 0 && iteration >= count) {
	            deferred.resolve(iteration);
	            clearIntervalFn(promise.$$intervalId);
	          }
	
	          if (!skipApply) $rootScope.$apply();
	        }
	
	        promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);
	
	        return promise;
	      };
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various AngularJS components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	/* global stripHash: true */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    // decode forward slashes to prevent them from being double encoded
	    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
	  }
	
	  return segments.join('/');
	}
	
	function decodePath(path, html5Mode) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = decodeURIComponent(segments[i]);
	    if (html5Mode) {
	      // encode forward slashes to prevent them from being mistaken for path separators
	      segments[i] = segments[i].replace(/\//g, '%2F');
	    }
	  }
	
	  return segments.join('/');
	}
	
	function normalizePath(pathValue, searchValue, hashValue) {
	  var search = toKeyValue(searchValue),
	    hash = hashValue ? '#' + encodeUriSegment(hashValue) : '',
	    path = encodePath(pathValue);
	
	  return path + (search ? '?' + search : '') + hash;
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj, html5Mode) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
	  locationObj.$$path = decodePath(path, html5Mode);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this, true);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBaseNoFile + url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this, false);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of AngularJS, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBase + (url ? hashPrefix + url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$normalizeUrl = function(url) {
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    return appBase + hashPrefix + url;
	  };
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * Compose url and update `url` and `absUrl` property
	   * @private
	   */
	  $$compose: function() {
	    this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
	    this.$$absUrl = this.$$normalizeUrl(this.$$url);
	    this.$$urlUpdatedByLocation = true;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    // Determine if two URLs are equal despite potentially having different encoding/normalizing
	    //  such as $location.absUrl() vs $browser.url()
	    // See https://github.com/angular/angular.js/issues/16592
	    function urlsEqual(a, b) {
	      return a === b || urlResolve(a).href === urlResolve(b).href;
	    }
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the AngularJS application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if ($location.absUrl() !== initialUrl) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = $browser.url();
	        var newUrl = $location.absUrl();
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * To reveal the location of the calls to `$log` in the JavaScript console,
	 * you can "blackbox" the AngularJS source in your browser:
	 *
	 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
	 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
	 *
	 * Note: Not all browsers support blackboxing.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (isError(arg)) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop;
	
	      return function() {
	        var args = [];
	        forEach(arguments, function(arg) {
	          args.push(formatError(arg));
	        });
	        // Support: IE 9 only
	        // console methods don't inherit from Function.prototype in IE 9 so we can't
	        // call `logFn.apply(console, args)` directly.
	        return Function.prototype.apply.call(logFn, console, args);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing AngularJS Expressions
	// ------------------------------
	// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following AngularJS expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	var PURITY_ABSOLUTE = 1;
	var PURITY_RELATIVE = 2;
	
	// Detect nodes which could depend on non-shallow state of objects
	function isPure(node, parentIsPure) {
	  switch (node.type) {
	    // Computed members might invoke a stateful toString()
	    case AST.MemberExpression:
	      if (node.computed) {
	        return false;
	      }
	      break;
	
	    // Unary always convert to primative
	    case AST.UnaryExpression:
	      return PURITY_ABSOLUTE;
	
	    // The binary + operator can invoke a stateful toString().
	    case AST.BinaryExpression:
	      return node.operator !== '+' ? PURITY_ABSOLUTE : false;
	
	    // Functions / filters probably read state from within objects
	    case AST.CallExpression:
	      return false;
	  }
	
	  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
	}
	
	function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	
	  var astIsPure = ast.isPure = isPure(ast, parentIsPure);
	
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
	      allConstants = allConstants && property.value.constant;
	      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      if (property.computed) {
	        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
	        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
	        allConstants = allConstants && property.key.constant;
	        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var inputs = this.state.inputs;
	    var self = this;
	    forEach(inputs, function(input) {
	      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
	      if (input.isPure) {
	        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
	      }
	    });
	    if (inputs.length) {
	      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        input.isPure = watch.isPure;
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.getAst(text);
	    var fn = this.astCompiler.compile(ast.ast);
	    fn.literal = isLiteral(ast.ast);
	    fn.constant = isConstant(ast.ast);
	    fn.oneTime = ast.oneTime;
	    return fn;
	  },
	
	  getAst: function(exp) {
	    var oneTime = false;
	    exp = exp.trim();
	
	    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	      oneTime = true;
	      exp = exp.substring(2);
	    }
	    return {
	      ast: this.ast.ast(exp),
	      oneTime: oneTime
	    };
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts AngularJS {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'AngularJS'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('AngularJS');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    $parse.$$getAst = $$getAst;
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	
	            cache[cacheKey] = addWatchDelegate(parsedExpression);
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function $$getAst(exp) {
	      var lexer = new Lexer($parseOptions);
	      var parser = new Parser(lexer, $filter, $parseOptions);
	      return parser.getAst(exp).ast;
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
	      var unwatch, lastValue;
	
	      var exp = parsedExpression.$$intercepted || parsedExpression;
	      var post = parsedExpression.$$interceptor || identity;
	
	      var useInputs = parsedExpression.inputs && !exp.inputs;
	
	      // Propagate the literal/inputs/constant attributes
	      // ... but not oneTime since we are handling it
	      oneTimeWatch.literal = parsedExpression.literal;
	      oneTimeWatch.constant = parsedExpression.constant;
	      oneTimeWatch.inputs = parsedExpression.inputs;
	
	      // Allow other delegates to run on this wrapped expression
	      addWatchDelegate(oneTimeWatch);
	
	      unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);
	
	      return unwatch;
	
	      function unwatchIfDone() {
	        if (isDone(lastValue)) {
	          unwatch();
	        }
	      }
	
	      function oneTimeWatch(scope, locals, assign, inputs) {
	        lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
	        if (isDone(lastValue)) {
	          scope.$$postDigest(unwatchIfDone);
	        }
	        return post(lastValue);
	      }
	    }
	
	    function isAllDefined(value) {
	      var allDefined = true;
	      forEach(value, function(val) {
	        if (!isDefined(val)) allDefined = false;
	      });
	      return allDefined;
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addWatchDelegate(parsedExpression) {
	      if (parsedExpression.constant) {
	        parsedExpression.$$watchDelegate = constantWatchDelegate;
	      } else if (parsedExpression.oneTime) {
	        parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
	      } else if (parsedExpression.inputs) {
	        parsedExpression.$$watchDelegate = inputsWatchDelegate;
	      }
	
	      return parsedExpression;
	    }
	
	    function chainInterceptors(first, second) {
	      function chainedInterceptor(value) {
	        return second(first(value));
	      }
	      chainedInterceptor.$stateful = first.$stateful || second.$stateful;
	      chainedInterceptor.$$pure = first.$$pure && second.$$pure;
	
	      return chainedInterceptor;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	
	      // Extract any existing interceptors out of the parsedExpression
	      // to ensure the original parsedExpression is always the $$intercepted
	      if (parsedExpression.$$interceptor) {
	        interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
	        parsedExpression = parsedExpression.$$intercepted;
	      }
	
	      var useInputs = false;
	
	      var fn = function interceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value);
	      };
	
	      // Maintain references to the interceptor/intercepted
	      fn.$$intercepted = parsedExpression;
	      fn.$$interceptor = interceptorFn;
	
	      // Propagate the literal/oneTime/constant attributes
	      fn.literal = parsedExpression.literal;
	      fn.oneTime = parsedExpression.oneTime;
	      fn.constant = parsedExpression.constant;
	
	      // Treat the interceptor like filters.
	      // If it is not $stateful then only watch its inputs.
	      // If the expression itself has no inputs then use the full expression as an input.
	      if (!interceptorFn.$stateful) {
	        useInputs = !parsedExpression.inputs;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	
	        if (!interceptorFn.$$pure) {
	          fn.inputs = fn.inputs.map(function(e) {
	              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
	              // non-pure interceptor function.
	              if (e.isPure === PURITY_RELATIVE) {
	                return function depurifier(s) { return e(s); };
	              }
	              return e;
	            });
	        }
	      }
	
	      return addWatchDelegate(fn);
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * ## $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * ## The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * ## The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * ## Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * ## Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * ## Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        markQStateExceptionHandled(state);
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	          // This error is explicitly marked for being passed to the $exceptionHandler
	          if (e && e.$$passToExceptionHandler === true) {
	            exceptionHandler(e);
	          }
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!isStateExceptionHandled(toCheck)) {
	        markQStateExceptionHandled(toCheck);
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (isError(toCheck.value)) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function isStateExceptionHandled(state) {
	  return !!state.pur;
	}
	function markQStateExceptionHandled(state) {
	  state.pur = true;
	}
	function markQExceptionHandled(q) {
	  // Built-in `$q` promises will always have a `$$state` property. This check is to allow
	  // overwriting `$q` with a different promise library (e.g. Bluebird + angular-bluebird-promises).
	  // (Currently, this is the only method that might be called with a promise, even if it is not
	  // created by the built-in `$q`.)
	  if (q.$$state) {
	    markQStateExceptionHandled(q.$$state);
	  }
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	      this.$$suspended = false;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * ## Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$suspended = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are (or contain)
	       *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * @example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	        var fn = isFunction(listener) ? listener : noop;
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: fn,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
	            newValues[i] = value;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          try {
	            if (firstRun) {
	              firstRun = false;
	              listener(newValues, newValues, self);
	            } else {
	              listener(newValues, oldValues, self);
	            }
	          } finally {
	            for (var i = 0; i < watchExpressions.length; i++) {
	              oldValues[i] = newValues[i];
	            }
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * @example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        // Mark the interceptor as
	        // ... $$pure when literal since the instance will change when any input changes
	        $watchCollectionInterceptor.$$pure = $parse(obj).literal;
	        // ... $stateful when non-literal since we must read the state of the collection
	        $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * @example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = asyncQueue.length ? $rootScope : this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = !current.$$suspended && current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            // (though it differs due to having the extra check for $$suspended and does not
	            // check $$listenerCount)
	            if (!(next = ((!current.$$suspended && current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$suspend
	       * @kind function
	       *
	       * @description
	       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
	       *
	       * This can be used to optimize your application when you know that running those watchers
	       * is redundant.
	       *
	       * **Warning**
	       *
	       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
	       * Only use this approach if you are confident that you know what you are doing and have
	       * ample tests to ensure that bindings get updated as you expect.
	       *
	       * Some of the things to consider are:
	       *
	       * * Any external event on a directive/component will not trigger a digest while the hosting
	       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
	       * * Transcluded content exists on a scope that inherits from outside a directive but exists
	       *   as a child of the directive's containing scope. If the containing scope is suspended the
	       *   transcluded scope will also be suspended, even if the scope from which the transcluded
	       *   scope inherits is not suspended.
	       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
	       *    * A call to `$suspend()` on an already suspended scope is a no-op.
	       *    * A call to `$resume()` on a non-suspended scope is a no-op.
	       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
	       *      longer be suspended. This could result in the other directive believing a scope to be
	       *      suspended when it is not.
	       * * If a parent scope is suspended then all its descendants will be also excluded from future
	       *   digests whether or not they have been suspended themselves. Note that this also applies to
	       *   isolate child scopes.
	       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
	       *   for that scope and its descendants. When digesting we only check whether the current scope is
	       *   locally suspended, rather than checking whether it has a suspended ancestor.
	       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
	       *   included in future digests until all its ancestors have been resumed.
	       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
	       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
	       *   initiated by a component that lives on a suspended scope.
	       */
	      $suspend: function() {
	        this.$$suspended = true;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$isSuspended
	       * @kind function
	       *
	       * @description
	       * Call this method to determine if this scope has been explicitly suspended. It will not
	       * tell you whether an ancestor has been suspended.
	       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
	       * for example, you must check all its ancestors:
	       *
	       * ```
	       * function isExcludedFromDigest(scope) {
	       *   while(scope) {
	       *     if (scope.$isSuspended()) return true;
	       *     scope = scope.$parent;
	       *   }
	       *   return false;
	       * ```
	       *
	       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
	       * even if `$isSuspended()` returns false.
	       *
	       * @returns true if the current scope has been suspended.
	       */
	      $isSuspended: function() {
	        return this.$$suspended;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$resume
	       * @kind function
	       *
	       * @description
	       * Resume watchers of this scope subtree in case it was suspended.
	       *
	       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
	       */
	      $resume: function() {
	        this.$$suspended = false;
	      },
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
	       * expressions.
	       *
	       * @example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          }, null, '$evalAsync');
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the AngularJS framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * **Life cycle: Pseudo-Code of `$apply()`**
	       *
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            // Use delete in the hope of the browser deallocating the memory for the array entry,
	            // while not shifting the array indexes of other listeners.
	            // See issue https://github.com/angular/angular.js/issues/16135
	            delete namedListeners[indexOfListener];
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            break;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount and
	          // does not check $$suspended)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        }, null, '$applyAsync');
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of AngularJS application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	
	  var aHrefSanitizationTrustedUrlList = /^\s*(https?|s?ftp|mailto|tel|file):/,
	    imgSrcSanitizationTrustedUrlList = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
	   *
	   * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
	   * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
	   * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
	   *
	   * If the URL matches the `aHrefSanitizationTrustedUrlList` regular expression, it is returned unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationTrustedUrlList = regexp;
	      return this;
	    }
	    return aHrefSanitizationTrustedUrlList;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
	   *
	   * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
	   * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
	   * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
	   * the potentially malicious URL.
	   *
	   * If the URL matches the `imgSrcSanitizationTrustedUrlList` regular expression, it is returned
	   * unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationTrustedUrlList = regexp;
	      return this;
	    }
	    return imgSrcSanitizationTrustedUrlList;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isMediaUrl) {
	      // if (!uri) return uri;
	      var regex = isMediaUrl ? imgSrcSanitizationTrustedUrlList : aHrefSanitizationTrustedUrlList;
	      var normalizedVal = urlResolve(uri && uri.trim()).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it refers to the source of media, which are not expected to be run
	  // as scripts, such as an image, audio, video, etc.
	  MEDIA_URL: 'mediaUrl',
	
	  // An URL used in a context where it does not refer to a resource that loads code.
	  // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own trusted and banned resource lists for trusting URLs used for loading AngularJS resources
	 * such as templates.  Refer {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * $sceDelegateProvider.trustedResourceUrlList} and {@link
	 * ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the `trustedResourceUrlList` and
	 * `bannedResourceUrlList` used to ensure that the URLs used for sourcing AngularJS templates and
	 * other script-running URLs are safe (all places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * $sceDelegateProvider.trustedResourceUrlList} and
	 * {@link ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList},
	 *
	 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.trustedResourceUrlList([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The banned resource URL list overrides the trusted resource URL list so the open redirect
	 *    // here is blocked.
	 *    $sceDelegateProvider.bannedResourceUrlList([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty trusted resource URL list will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from the trusted resource URL lsit. This helps to mitigate the security impact of certain types
	 * of issues, like for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var trustedResourceUrlList = ['self'],
	      bannedResourceUrlList = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#trustedResourceUrlList
	   * @kind function
	   *
	   * @param {Array=} trustedResourceUrlList When provided, replaces the trustedResourceUrlList with
	   *     the value provided.  This must be an array or null.  A snapshot of this array is used so
	   *     further changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set trusted resource URL array.
	   *
	   * @description
	   * Sets/Gets the list trusted of resource URLs.
	   *
	   * The **default value** when no `trustedResourceUrlList` has been explicitly set is `['self']`
	   * allowing only same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default `trustedResourceUrlList` of 'self' is not recommended if your app shares
	   * its origin with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.trustedResourceUrlList = function(value) {
	    if (arguments.length) {
	      trustedResourceUrlList = adjustMatchers(value);
	    }
	    return trustedResourceUrlList;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $sceDelegateProvider#trustedResourceUrlList
	   * trustedResourceUrlList} instead.
	   */
	  Object.defineProperty(this, 'resourceUrlWhitelist', {
	    get: function() {
	      return this.trustedResourceUrlList;
	    },
	    set: function(value) {
	      this.trustedResourceUrlList = value;
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#bannedResourceUrlList
	   * @kind function
	   *
	   * @param {Array=} bannedResourceUrlList When provided, replaces the `bannedResourceUrlList` with
	   *     the value provided. This must be an array or null. A snapshot of this array is used so
	   *     further changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the `bannedResourceUrlList` is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the banned resource URL list overrides the trusted resource URL list** and has
	   *     the final say.
	   *
	   * @return {Array} The currently set `bannedResourceUrlList` array.
	   *
	   * @description
	   * Sets/Gets the `bannedResourceUrlList` of trusted resource URLs.
	   *
	   * The **default value** when no trusted resource URL list has been explicitly set is the empty
	   * array (i.e. there is no `bannedResourceUrlList`.)
	   */
	  this.bannedResourceUrlList = function(value) {
	    if (arguments.length) {
	      bannedResourceUrlList = adjustMatchers(value);
	    }
	    return bannedResourceUrlList;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $sceDelegateProvider#bannedResourceUrlList
	   * bannedResourceUrlList} instead.
	   */
	  Object.defineProperty(this, 'resourceUrlBlacklist', {
	    get: function() {
	      return this.bannedResourceUrlList;
	    },
	    set: function(value) {
	      this.bannedResourceUrlList = value;
	    }
	  });
	
	  this.$get = ['$injector', '$$sanitizeUri', function($injector, $$sanitizeUri) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the trusted resource URL list allows this url.
	      for (i = 0, n = trustedResourceUrlList.length; i < n; i++) {
	        if (matchUrl(trustedResourceUrlList[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the banned resource URL list has blocked this url.
	        for (i = 0, n = bannedResourceUrlList.length; i < n; i++) {
	          if (matchUrl(bannedResourceUrlList[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Given an object and a security context in which to assign it, returns a value that's safe to
	     * use in this context, which was represented by the parameter. To do so, this function either
	     * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
	     * the context and sanitizer availablility.
	     *
	     * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
	     * by default, and the third one relies on the `$sanitize` service (which may be loaded through
	     * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
	     * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#trustedResourceUrlList
	     * `$sceDelegateProvider.trustedResourceUrlList`} and {@link ng.$sceDelegateProvider#bannedResourceUrlList
	     * `$sceDelegateProvider.bannedResourceUrlList`} accepts that resource.
	     *
	     * This function will throw if the safe type isn't appropriate for this context, or if the
	     * value given cannot be accepted in the context (which might be caused by sanitization not
	     * being available, or the value not being recognized as safe).
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If maybeTrusted is a trusted class instance but not of the correct trusted type
	      // then unwrap it and allow it to pass through to the rest of the checks
	      if (isFunction(maybeTrusted.$$unwrapTrustedValue)) {
	        maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If we get here, then we will either sanitize the value or throw an exception.
	      if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) {
	        // we attempt to sanitize non-resource URLs
	        return $$sanitizeUri(maybeTrusted.toString(), type === SCE_CONTEXTS.MEDIA_URL);
	      } else if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * ## Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ### Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, trusted URL resource, depending on context), or throw
	 * when it cannot guarantee the security of the result. That behavior depends strongly on contexts:
	 * HTML can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ### In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ### How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ### Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, AngularJS only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either add them to the {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * trustedResourceUrlList} or {@link ng.$sce#trustAsResourceUrl wrap them} into trusted values.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ### This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
	 * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
	 * when binding untrusted values to `$sce.HTML` context.
	 * AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#trustedResourceUrlList trusted resource URL list} and {@link
	 * ng.$sceDelegateProvider#bannedResourceUrlList banned resource URL list} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ### What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#trustedResourceUrlList $sceDelegateProvider#trustedResourceUrlList()} and {@link $sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider#bannedResourceUrlList()} can be used to restrict trusted origins for `RESOURCE_URL` |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 *
	 * <div class="alert alert-warning">
	 * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
	 * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
	 *
	 * **As of 1.7.0, this is no longer the case.**
	 *
	 * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
	 * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
	 * service evaluates the expressions.
	 * </div>
	 *
	 * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
	 * functions aren't useful yet. This might evolve.
	 *
	 * ### Format of items in {@link ng.$sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList}/{@link ng.$sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      for matching resource URL lists.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ### Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $$taskTrackerFactory
	 * @description
	 * A function to create `TaskTracker` instances.
	 *
	 * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
	 * parties when all pending tasks (or tasks of a specific type) have been completed.
	 *
	 * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
	 *     execution.
	 *
	 * @this
	 */
	function $$TaskTrackerFactoryProvider() {
	  this.$get = valueFn(function(log) { return new TaskTracker(log); });
	}
	
	function TaskTracker(log) {
	  var self = this;
	  var taskCounts = {};
	  var taskCallbacks = [];
	
	  var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = '$$all$$';
	  var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = '$$default$$';
	
	  /**
	   * Execute the specified function and decrement the appropriate `taskCounts` counter.
	   * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
	   *
	   * @param {Function} fn - The function to execute.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
	   */
	  self.completeTask = completeTask;
	
	  /**
	   * Increase the task count for the specified task type (or the default task type if non is
	   * specified).
	   *
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
	   */
	  self.incTaskCount = incTaskCount;
	
	  /**
	   * Execute the specified callback when all pending tasks have been completed.
	   *
	   * If there are no pending tasks, the callback is executed immediately. You can optionally limit
	   * the tasks that will be waited for to a specific type, by passing a `taskType`.
	   *
	   * @param {function} callback - The function to call when there are no pending tasks.
	   * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
	   */
	  self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;
	
	  function completeTask(fn, taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	
	    try {
	      fn();
	    } finally {
	      decTaskCount(taskType);
	
	      var countForType = taskCounts[taskType];
	      var countForAll = taskCounts[ALL_TASKS_TYPE];
	
	      // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
	      if (!countForAll || !countForType) {
	        var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
	        var nextCb;
	
	        while ((nextCb = getNextCallback(taskType))) {
	          try {
	            nextCb();
	          } catch (e) {
	            log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function decTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    if (taskCounts[taskType]) {
	      taskCounts[taskType]--;
	      taskCounts[ALL_TASKS_TYPE]--;
	    }
	  }
	
	  function getLastCallback() {
	    var cbInfo = taskCallbacks.pop();
	    return cbInfo && cbInfo.cb;
	  }
	
	  function getLastCallbackForType(taskType) {
	    for (var i = taskCallbacks.length - 1; i >= 0; --i) {
	      var cbInfo = taskCallbacks[i];
	      if (cbInfo.type === taskType) {
	        taskCallbacks.splice(i, 1);
	        return cbInfo.cb;
	      }
	    }
	  }
	
	  function incTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
	    taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
	  }
	
	  function notifyWhenNoPendingTasks(callback, taskType) {
	    taskType = taskType || ALL_TASKS_TYPE;
	    if (!taskCounts[taskType]) {
	      callback();
	    } else {
	      taskCallbacks.push({type: taskType, cb: callback});
	    }
	  }
	}
	
	var $templateRequestMinErr = minErr('$templateRequest');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
	   * as {@link ngInclude} to download and cache templates.
	   *
	   * 3rd party modules should use `$templateRequest` if their services or directives are loading
	   * templates.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through adding the template again to the trusted
	        // resources for keys that already are included in there. This also makes
	        // AngularJS accept any script directive, no matter its name. However, we
	        // still need to unwrap trusted types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            return $templateCache.put(tpl, response.data);
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when all pending tasks are completed.
	     *
	     * Types of tasks waited for include:
	     * - Pending timeouts (via {@link $timeout}).
	     * - Pending HTTP requests (via {@link $http}).
	     * - In-progress route transitions (via {@link $route}).
	     * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
	     * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
	     *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	var $timeoutMinErr = minErr('$timeout');
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	    /**
	     * @ngdoc service
	     * @name $timeout
	     *
	     * @description
	     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	     * block and delegates any exceptions to
	     * {@link ng.$exceptionHandler $exceptionHandler} service.
	     *
	     * The return value of calling `$timeout` is a promise, which will be resolved when
	     * the delay has passed and the timeout function, if provided, is executed.
	     *
	     * To cancel a timeout request, call `$timeout.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	     * synchronously flush the queue of deferred functions.
	     *
	     * If you only want a promise that will be resolved after some specified delay
	     * then you can call `$timeout` without the `fn` function.
	     *
	     * @param {function()=} fn A function, whose execution should be delayed.
	     * @param {number=} [delay=0] Delay in milliseconds.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	     *   will be resolved with the return value of the `fn` function.
	     *
	     */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay, '$timeout');
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $timeout#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`. As a result of this, the promise will be
	     * resolved with a rejection.
	     *
	     * @param {Promise=} promise Promise returned by the `$timeout` function.
	     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	     *   canceled.
	     */
	    timeout.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$timeoutId')) {
	        throw $timeoutMinErr('badprom',
	            '`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.');
	      }
	
	      if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;
	
	      var id = promise.$$timeoutId;
	      var deferred = deferreds[id];
	
	      // Timeout cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      delete deferreds[id];
	
	      return $browser.defer.cancel(id);
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	var baseUrlParsingNode;
	
	urlParsingNode.href = 'http://[::1]';
	
	// Support: IE 9-11 only, Edge 16-17 only (fixed in 18 Preview)
	// IE/Edge don't wrap IPv6 addresses' hostnames in square brackets
	// when parsed out of an anchor element.
	var ipv6InBrackets = urlParsingNode.hostname === '[::1]';
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
	 *     unchanged.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description                                                            |
	 *   |---------------|------------------------------------------------------------------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol without the trailing colon                                |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol                                 |
	 *   | hostname      | The hostname                                                           |
	 *   | port          | The port, without ":"                                                  |
	 *   | pathname      | The pathname, beginning with "/"                                       |
	 *
	 */
	function urlResolve(url) {
	  if (!isString(url)) return url;
	
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  var hostname = urlParsingNode.hostname;
	
	  if (!ipv6InBrackets && hostname.indexOf(':') > -1) {
	    hostname = '[' + hostname + ']';
	  }
	
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application
	 * document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, originUrl);
	}
	
	/**
	 * Parse a request URL and determine whether it is same-origin as the current document base URL.
	 *
	 * Note: The base URL is usually the same as the document location (`location.href`) but can
	 * be overriden by using the `<base>` tag.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the URL is same-origin as the document base URL.
	 */
	function urlIsSameOriginAsBaseUrl(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, getBaseUrl());
	}
	
	/**
	 * Create a function that can check a URL's origin against a list of allowed/trusted origins.
	 * The current location's origin is implicitly trusted.
	 *
	 * @param {string[]} trustedOriginUrls - A list of URLs (strings), whose origins are trusted.
	 *
	 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
	 *     whether it is of an allowed origin.
	 */
	function urlIsAllowedOriginFactory(trustedOriginUrls) {
	  var parsedAllowedOriginUrls = [originUrl].concat(trustedOriginUrls.map(urlResolve));
	
	  /**
	   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
	   * based on a list of trusted-origin URLs. The current location's origin is implicitly
	   * trusted.
	   *
	   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
	   *     resolved or a parsed URL object).
	   *
	   * @returns {boolean} - Whether the specified URL is of an allowed origin.
	   */
	  return function urlIsAllowedOrigin(requestUrl) {
	    var parsedUrl = urlResolve(requestUrl);
	    return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
	  };
	}
	
	/**
	 * Determine if two URLs share the same origin.
	 *
	 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
	 *     a dictionary object returned by `urlResolve()`.
	 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
	 *     of a dictionary object returned by `urlResolve()`.
	 *
	 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
	 */
	function urlsAreSameOrigin(url1, url2) {
	  url1 = urlResolve(url1);
	  url2 = urlResolve(url2);
	
	  return (url1.protocol === url2.protocol &&
	          url1.host === url2.host);
	}
	
	/**
	 * Returns the current document base URL.
	 * @returns {string}
	 */
	function getBaseUrl() {
	  if (window.document.baseURI) {
	    return window.document.baseURI;
	  }
	
	  // `document.baseURI` is available everywhere except IE
	  if (!baseUrlParsingNode) {
	    baseUrlParsingNode = window.document.createElement('a');
	    baseUrlParsingNode.href = '.';
	
	    // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
	    // suitable here because we need to track changes to the base URL.
	    baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
	  }
	  return baseUrlParsingNode.href;
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In AngularJS we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how AngularJS filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the AngularJS Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services. AngularJS comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // If the currency symbol is empty, trim whitespace around the symbol
	    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(currencySymbolRe, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 *
	 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
	 *
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @example
	   <example module="uppercaseFilterExample" name="filter-uppercase">
	     <file name="index.html">
	       <script>
	         angular.module('uppercaseFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.title = 'This is a title';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <!-- This title should be formatted normally -->
	         <h1>{{title}}</h1>
	         <!-- This title should be capitalized -->
	         <h1>{{title | uppercase}}</h1>
	       </div>
	     </file>
	   </example>
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 *    **Note:** `null` values use `'null'` as their type.
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * If a custom comparator still can't distinguish between two items, then they will be sorted based
	 * on their index using the built-in comparator.
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, sorts values of different types by type and puts
	 * `undefined` and `null` values at the end of the sorted list.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types:
	 *    - If one of the values is undefined, consider it "greater than" the other.
	 *    - Else if one of the values is null, consider it "greater than" the other.
	 *    - Else compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
	 *           any other value (with undefined "greater than" null). This effectively means that `null`
	 *           and `undefined` values end up at the end of a list sorted in ascending order.
	 * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = (type1 === 'undefined') ? 1 :
	        (type2 === 'undefined') ? -1 :
	        (type1 === 'null') ? 1 :
	        (type2 === 'null') ? -1 :
	        (type1 < type2) ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * AngularJS has a chance to replace the `{{hash}}` markup with its
	 * value. Until AngularJS replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
	        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
	          element(by.model('leader')).click();
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Internet Explorer and Edge do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>List</summary>
	            <ul>
	              <li>Apple</li>
	              <li>Orange</li>
	              <li>Durian</li>
	            </ul>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = ['$sce', function($sce) {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        // We need to sanitize the url at least once, in case it is a constant
	        // non-interpolated attribute.
	        attr.$set(normalized, $sce.getTrustedMediaUrl(attr[normalized]));
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set might have sanitized the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  }];
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $getControls: valueFn([]),
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop,
	  $$setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $pending An object hash, containing references to controls or forms with
	 *  pending validators, where:
	 *
	 *  - keys are validations tokens (error names).
	 *  - values are arrays of controls or forms that have a pending validator for the given error name.
	 *
	 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
	 *
	 * @property {Object} $error An object hash, containing references to controls or forms with failing
	 *  validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for the given error name.
	 *
	 *  Built-in validation tokens:
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$getControls
	   * @returns {Array} the controls that are currently part of this form
	   *
	   * @description
	   * This method returns a **shallow copy** of the controls that are currently part of this form.
	   * The controls can be instances of {@link form.FormController `FormController`}
	   * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
	   * If you need access to the controls of child-forms, you have to call `$getControls()`
	   * recursively on them.
	   * This can be used for example to iterate over all controls to validate them.
	   *
	   * The controls can be accessed normally, but adding to, or removing controls from the array has
	   * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
	   * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
	   * Likewise, adding a control to, or removing a control from the form is not reflected
	   * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
	   * you need access to the controls.
	   */
	  $getControls: function() {
	    return shallowCopy(this.$$controls);
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
	   * parent forms of the form.
	   */
	  $setSubmitted: function() {
	    var rootForm = this;
	    while (rootForm.$$parentForm && (rootForm.$$parentForm !== nullFormCtrl)) {
	      rootForm = rootForm.$$parentForm;
	    }
	    rootForm.$$setSubmitted();
	  },
	
	  $$setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    forEach(this.$$controls, function(control) {
	      if (control.$$setSubmitted) {
	        control.$$setSubmitted();
	      }
	    });
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Change the validity state of the form, and notify the parent form (if any).
	 *
	 * Application developers will rarely need to call this method directly. It is used internally, by
	 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
	 * control's validity state to the parent `FormController`.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
	 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
	 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
	 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
	 *        class name. Example: `myError` will result in `ng-valid-my-error` and
	 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
	 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
	 *        `$asyncValidators` do not run because any of the `$validators` failed.
	 * @param {NgModelController | FormController} controller - The controller whose validity state is
	 *        triggering the change.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Helper directive that makes it possible to create control groups inside a
	 * {@link ng.directive:form `form`} directive.
	 * These "child forms" can be used, for example, to determine the validity of a sub-group of
	 * controls.
	 *
	 * <div class="alert alert-danger">
	 * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
	 * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
	 * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
	 * you cannot send data to the server with `ngForm`, or integrate it with
	 * {@link ng.directive:ngSubmit `ngSubmit`}.
	 * </div>
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will
	 *                              be published into the related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * ## Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * ## CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * ## Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side AngularJS applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * @animations
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise AngularJS will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * The format of the displayed time can be adjusted with the
	    * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	    * and `timeStripZeroSeconds`.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
	   * this is the timezone of the browser.
	   *
	   * The format of the displayed time can be adjusted with the
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	   * and `timeStripZeroSeconds`.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
	    * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
	    * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise AngularJS will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   *
	   *
	   * @knownIssue
	   *
	   * ### HTML5 constraint validation and `allowInvalid`
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   * @knownIssue
	   *
	   * ### Large numbers and `step` validation
	   *
	   * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
	   * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
	   * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
	   * {@link guide/forms#modifying-built-in-validators overwriting the validators}
	   * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
	   * to an `input[text]` element. The source for `input[number]` type can be used as a starting
	   * point for both implementations.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium, which may not fulfill your app's requirements.
	   * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
	   * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
	   * modify the built-in validators (see the {@link guide/forms Forms guide}).
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * **Note:**<br>
	   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
	   * value of their `name` attribute to determine the property under which their
	   * {@link ngModel.NgModelController NgModelController} will be published on the parent
	   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
	   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
	   * published on the parent `FormController` under that name. The rest of the controllers will
	   * continue to work as expected, but you won't be able to access them as properties on the parent
	   * `FormController`.
	   *
	   * <div class="alert alert-info">
	   *   <p>
	   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
	   *     that the browser can manage their state (checked/unchecked) based on the state of other
	   *     inputs in the same group.
	   *   </p>
	   *   <p>
	   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
	   *     value of the underlying model data.
	   *   </p>
	   * </div>
	   *
	   * <div class="alert alert-success">
	   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
	   *   unique name.
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for AngularJS:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, AngularJS will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
	   *                      to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    // Support: IE9+
	    element.on('compositionupdate', function(ev) {
	      // End composition when ev.data is empty string on 'compositionupdate' event.
	      // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
	      // instead of 'compositionend'.
	      if (isUndefined(ev.data) || ev.data === '') {
	        composing = false;
	      }
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut drop', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, previousDate) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (previousDate) {
	          map = {
	            yyyy: previousDate.getFullYear(),
	            MM: previousDate.getMonth() + 1,
	            dd: previousDate.getDate(),
	            HH: previousDate.getHours(),
	            mm: previousDate.getMinutes(),
	            ss: previousDate.getSeconds(),
	            sss: previousDate.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	
	        var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	        if (map.yyyy < 100) {
	          // In the constructor, 2-digit years map to 1900-1999.
	          // Use `setFullYear()` to set the correct year.
	          date.setFullYear(map.yyyy);
	        }
	
	        return date;
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	    badInputChecker(scope, element, attr, ctrl, type);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	    var isTimeType = type === 'time' || type === 'datetimelocal';
	    var previousDate;
	    var previousTimezone;
	
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        return parseDateAndConvertTimeZoneToLocal(value, previousDate);
	      }
	      ctrl.$$parserName = type;
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        var timezone = ctrl.$options.getOption('timezone');
	
	        if (timezone) {
	          previousTimezone = timezone;
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	
	        return formatter(value, timezone);
	      } else {
	        previousDate = null;
	        previousTimezone = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal = attr.min || $parse(attr.ngMin)(scope);
	      var parsedMinVal = parseObservedDateValue(minVal);
	
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMinVal) || parseDate(value) >= parsedMinVal;
	      };
	      attr.$observe('min', function(val) {
	        if (val !== minVal) {
	          parsedMinVal = parseObservedDateValue(val);
	          minVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal = attr.max || $parse(attr.ngMax)(scope);
	      var parsedMaxVal = parseObservedDateValue(maxVal);
	
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMaxVal) || parseDate(value) <= parsedMaxVal;
	      };
	      attr.$observe('max', function(val) {
	        if (val !== maxVal) {
	          parsedMaxVal = parseObservedDateValue(val);
	          maxVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
	    }
	
	    function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
	      var timezone = ctrl.$options.getOption('timezone');
	
	      if (previousTimezone && previousTimezone !== timezone) {
	        // If the timezone has changed, adjust the previousDate to the default timezone
	        // so that the new date is converted with the correct timezone offset
	        previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
	      }
	
	      var parsedDate = parseDate(value, previousDate);
	
	      if (!isNaN(parsedDate) && timezone) {
	        parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	      }
	      return parsedDate;
	    }
	
	    function formatter(value, timezone) {
	      var targetFormat = format;
	
	      if (isTimeType && isString(ctrl.$options.getOption('timeSecondsFormat'))) {
	        targetFormat = format
	          .replace('ss.sss', ctrl.$options.getOption('timeSecondsFormat'))
	          .replace(/:$/, '');
	      }
	
	      var formatted =  $filter('date')(value, targetFormat, timezone);
	
	      if (isTimeType && ctrl.$options.getOption('timeStripZeroSeconds')) {
	        formatted = formatted.replace(/(?::00)?(?:\.000)?$/, '');
	      }
	
	      return formatted;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl, parserName) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      if (validity.badInput || validity.typeMismatch) {
	        ctrl.$$parserName = parserName;
	        return undefined;
	      }
	
	      return value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	
	    ctrl.$$parserName = 'number';
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  badInputChecker(scope, element, attr, ctrl, 'number');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var parsedMinVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal = attr.min || $parse(attr.ngMin)(scope);
	    parsedMinVal = parseNumberAttrVal(minVal);
	
	    ctrl.$validators.min = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMinVal) || viewValue >= parsedMinVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (val !== minVal) {
	        parsedMinVal = parseNumberAttrVal(val);
	        minVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal = attr.max || $parse(attr.ngMax)(scope);
	    var parsedMaxVal = parseNumberAttrVal(maxVal);
	
	    ctrl.$validators.max = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMaxVal) || viewValue <= parsedMaxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (val !== maxVal) {
	        parsedMaxVal = parseNumberAttrVal(val);
	        maxVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal = attr.step || $parse(attr.ngStep)(scope);
	    var parsedStepVal = parseNumberAttrVal(stepVal);
	
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedStepVal) ||
	        isValidForStep(viewValue, parsedMinVal || 0, parsedStepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      if (val !== stepVal) {
	        parsedStepVal = parseNumberAttrVal(val);
	        stepVal = val;
	        ctrl.$validate();
	      }
	
	    });
	
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl, 'range');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    minVal = parseNumberAttrVal(attr.min);
	
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    maxVal = parseNumberAttrVal(attr.max);
	
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    stepVal = parseNumberAttrVal(attr.step);
	
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    var oldVal = attr[htmlAttrName];
	    attr.$observe(htmlAttrName, function wrappedObserver(val) {
	      if (val !== oldVal) {
	        oldVal = val;
	        changeFn(val);
	      }
	    });
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (!supportsRange) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    } else if (ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	var hiddenInputBrowserCacheDirective = function() {
	  var valueProperty = {
	    configurable: true,
	    enumerable: false,
	    get: function() {
	      return this.getAttribute('value') || '';
	    },
	    set: function(val) {
	      this.setAttribute('value', val);
	    }
	  };
	
	  return {
	    restrict: 'E',
	    priority: 200,
	    compile: function(_, attr) {
	      if (lowercase(attr.type) !== 'hidden') {
	        return;
	      }
	
	      return {
	        pre: function(scope, element, attr, ctrls) {
	          var node = element[0];
	
	          // Support: Edge
	          // Moving the DOM around prevents autofillling
	          if (node.parentNode) {
	            node.parentNode.insertBefore(node, node.nextSibling);
	          }
	
	          // Support: FF, IE
	          // Avoiding direct assignment to .value prevents autofillling
	          if (Object.defineProperty) {
	            Object.defineProperty(node, 'value', valueProperty);
	          }
	        }
	      };
	    }
	  };
	};
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element ANY
	 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 * @restrict A
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element ANY
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClassWatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClassWatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassWatchAction(newClassString) {
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    if (!classValue) return classValue;
	
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    } else if (!isString(classValue)) {
	      classString = classValue + '';
	    }
	
	    return classString;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 * @element ANY
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
	 *
	 * ### ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 *
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example
	 * ### Basic
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   @example
	   ### Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassOdd`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-odd="'odd'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .odd {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .odd-add, .odd-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add odd class to odd entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassEven`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-even="'even'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .even {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .even-add, .even-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add even class to even entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the AngularJS community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * AngularJS has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect AngularJS:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related AngularJS features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 *
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	
	  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	  <example name="example.csp" module="cspExample" ng-csp="true">
	    <file name="index.html">
	      <div ng-controller="MainController as ctrl">
	        <div>
	          <button ng-click="ctrl.inc()" id="inc">Increment</button>
	          <span id="counter">
	            {{ctrl.counter}}
	          </span>
	        </div>
	
	        <div>
	          <button ng-click="ctrl.evil()" id="evil">Evil</button>
	          <span id="evilError">
	            {{ctrl.evilError}}
	          </span>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	       angular.module('cspExample', [])
	         .controller('MainController', function MainController() {
	            this.counter = 0;
	            this.inc = function() {
	              this.counter++;
	            };
	            this.evil = function() {
	              try {
	                eval('1+2'); // eslint-disable-line no-eval
	              } catch (e) {
	                this.evilError = e.message;
	              }
	            };
	          });
	    </file>
	    <file name="protractor.js" type="protractor">
	      var util, webdriver;
	
	      var incBtn = element(by.id('inc'));
	      var counter = element(by.id('counter'));
	      var evilBtn = element(by.id('evil'));
	      var evilError = element(by.id('evilError'));
	
	      function getAndClearSevereErrors() {
	        return browser.manage().logs().get('browser').then(function(browserLog) {
	          return browserLog.filter(function(logEntry) {
	            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	          });
	        });
	      }
	
	      function clearErrors() {
	        getAndClearSevereErrors();
	      }
	
	      function expectNoErrors() {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          expect(filteredLog.length).toEqual(0);
	          if (filteredLog.length) {
	            console.log('browser console errors: ' + util.inspect(filteredLog));
	          }
	        });
	      }
	
	      function expectError(regex) {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          var found = false;
	          filteredLog.forEach(function(log) {
	            if (log.message.match(regex)) {
	              found = true;
	            }
	          });
	          if (!found) {
	            throw new Error('expected an error that matches ' + regex);
	          }
	        });
	      }
	
	      beforeEach(function() {
	        util = require('util');
	        webdriver = require('selenium-webdriver');
	      });
	
	      // For now, we only test on Chrome,
	      // as Safari does not load the page with Protractor's injected scripts,
	      // and Firefox webdriver always disables content security policy (#6358)
	      if (browser.params.browser !== 'chrome') {
	        return;
	      }
	
	      it('should not report errors when the page is loaded', function() {
	        // clear errors so we are not dependent on previous tests
	        clearErrors();
	        // Need to reload the page as the page is already loaded when
	        // we come here
	        browser.driver.getCurrentUrl().then(function(url) {
	          browser.get(url);
	        });
	        expectNoErrors();
	      });
	
	      it('should evaluate expressions', function() {
	        expect(counter.getText()).toEqual('0');
	        incBtn.click();
	        expect(counter.getText()).toEqual('1');
	        expectNoErrors();
	      });
	
	      it('should throw and report an error when using "eval"', function() {
	        evilBtn.click();
	        expect(evilError.getText()).toMatch(/Content Security Policy/);
	        expectError(/Content Security Policy/);
	      });
	    </file>
	  </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * AngularJS expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', '$exceptionHandler', function($parse, $rootScope, $exceptionHandler) {
	      return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
	    }];
	  }
	);
	
	function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
	  return {
	    restrict: 'A',
	    compile: function($element, attr) {
	      // NOTE:
	      // We expose the powerful `$event` object on the scope that provides access to the Window,
	      // etc. This is OK, because expressions are not sandboxed any more (and the expression
	      // sandbox was never meant to be a security feature anyway).
	      var fn = $parse(attr[directiveName]);
	      return function ngEventHandler(scope, element) {
	        element.on(eventName, function(event) {
	          var callback = function() {
	            fn(scope, {$event: event});
	          };
	
	          if (!$rootScope.$$phase) {
	            scope.$apply(callback);
	          } else if (forceAsync) {
	            scope.$evalAsync(callback);
	          } else {
	            try {
	              callback();
	            } catch (error) {
	              $exceptionHandler(error);
	            }
	          }
	        });
	      };
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 * @restrict A
	 * @element ANY
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 * @restrict A
	 * @element form
	 * @priority 0
	 *
	 * @description
	 * Enables binding AngularJS expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 * @scope
	 * @priority -400
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either add them to your {@link ng.$sceDelegateProvider#trustedResourceUrlList trusted
	 * resource URL list} or {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to
	 * AngularJS's {@link ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 * @priority 450
	 * @element ANY
	 *
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`:
	 * <ul>
	 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
	 *     as seen in the demo below.</li>
	 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
	 *   <li>injecting data via server side scripting.</li>
	 * </ul>
	 *
	 * Besides these few cases, you should use {@link guide/component Components} or
	 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 * @restrict A
	 * @priority 100
	 *
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * @example
	 * ### Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Splitting on newline
	 *
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
	 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
	 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
	 *     It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * AngularJS provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	  this.$$updateEvents = '';
	  // Attach the correct context to the event handler function for updateOn
	  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	  this.$$parserName = 'parse';
	
	  this.$$currentValidationRunId = 0;
	
	  this.$$scope = $scope;
	  this.$$rootScope = $scope.$root;
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * @example
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName;
	
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    // Reset any previous parse error
	    this.$setValidity(this.$$parserName, null);
	    this.$$parserName = 'parse';
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default']) &&
	      this.$options.getOption('updateOn').indexOf(trigger) === -1
	    ) {
	      debounceDelay = debounceDelay['default'];
	    } else if (isNumber(debounceDelay['*'])) {
	      debounceDelay = debounceDelay['*'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$rootScope.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** this function only affects the options set on the `ngModelController`,
	   * and not the options on the {@link ngModelOptions} directive from which they might have been
	   * obtained initially.
	   * </div>
	   *
	   * <div class="alert alert-danger">
	   * **Note:** it is not possible to override the `getterSetter` option.
	   * </div>
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	    this.$$setUpdateOnEvents();
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name  ngModel.NgModelController#$processModelValue
	
	   * @description
	   *
	   * Runs the model -> view pipeline on the current
	   * {@link ngModel.NgModelController#$modelValue $modelValue}.
	   *
	   * The following actions are performed by this method:
	   *
	   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
	   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
	   * - the `ng-empty` or `ng-not-empty` class is set on the element
	   * - if the `$viewValue` has changed:
	   *   - {@link ngModel.NgModelController#$render $render} is called on the control
	   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
	   *   the validation status is set.
	   *
	   * This method is called by ngModel internally when the bound scope value changes.
	   * Application developers usually do not have to call this function themselves.
	   *
	   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
	   * formatted and the `$modelValue` must be run through the `$formatters` again.
	   *
	   * @example
	   * Consider a text input with an autocomplete list (for fruit), where the items are
	   * objects with a name and an id.
	   * A user enters `ap` and then selects `Apricot` from the list.
	   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
	   * but the rendered value will still be `ap`.
	   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
	   * pipeline again, which formats the object to the string `Apricot`,
	   * then updates the `$viewValue`, and finally renders it in the DOM.
	   *
	   * <example module="inputExample" name="ng-model-process">
	     <file name="index.html">
	      <div ng-controller="inputController" style="display: flex;">
	        <div style="margin-right: 30px;">
	          Search Fruit:
	          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
	        </div>
	        <div>
	          Model:<br>
	          <pre>{{selectedFruit | json}}</pre>
	        </div>
	      </div>
	     </file>
	     <file name="app.js">
	      angular.module('inputExample', [])
	        .controller('inputController', function($scope) {
	          $scope.items = [
	            {name: 'Apricot', id: 443},
	            {name: 'Clementine', id: 972},
	            {name: 'Durian', id: 169},
	            {name: 'Jackfruit', id: 982},
	            {name: 'Strawberry', id: 863}
	          ];
	        })
	        .component('basicAutocomplete', {
	          bindings: {
	            items: '<',
	            onSelect: '&'
	          },
	          templateUrl: 'autocomplete.html',
	          controller: function($element, $scope) {
	            var that = this;
	            var ngModel;
	
	            that.$postLink = function() {
	              ngModel = $element.find('input').controller('ngModel');
	
	              ngModel.$formatters.push(function(value) {
	                return (value && value.name) || value;
	              });
	
	              ngModel.$parsers.push(function(value) {
	                var match = value;
	                for (var i = 0; i < that.items.length; i++) {
	                  if (that.items[i].name === value) {
	                    match = that.items[i];
	                    break;
	                  }
	                }
	
	                return match;
	              });
	            };
	
	            that.selectItem = function(item) {
	              ngModel.$setViewValue(item);
	              ngModel.$processModelValue();
	              that.onSelect({item: item});
	            };
	          }
	        });
	     </file>
	     <file name="autocomplete.html">
	       <div>
	         <input type="search" ng-model="$ctrl.searchTerm" />
	         <ul>
	           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
	             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
	           </li>
	         </ul>
	       </div>
	     </file>
	   * </example>
	   *
	   */
	  $processModelValue: function() {
	    var viewValue = this.$$format();
	
	    if (this.$viewValue !== viewValue) {
	      this.$$updateEmptyClasses(viewValue);
	      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
	      this.$render();
	      // It is possible that model and view value have been updated during render
	      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
	    }
	  },
	
	  /**
	   * This method is called internally to run the $formatters on the $modelValue
	   */
	  $$format: function() {
	    var formatters = this.$formatters,
	        idx = formatters.length;
	
	    var viewValue = this.$modelValue;
	    while (idx--) {
	      viewValue = formatters[idx](viewValue);
	    }
	
	    return viewValue;
	  },
	
	  /**
	   * This method is called internally when the bound scope value changes.
	   */
	  $$setModelValue: function(modelValue) {
	    this.$modelValue = this.$$rawModelValue = modelValue;
	    this.$$parserValid = undefined;
	    this.$processModelValue();
	  },
	
	  $$setUpdateOnEvents: function() {
	    if (this.$$updateEvents) {
	      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
	    }
	
	    this.$$updateEvents = this.$options.getOption('updateOn');
	    if (this.$$updateEvents) {
	      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
	    }
	  },
	
	  $$updateEventHandler: function(ev) {
	    this.$$debounceViewValueCommit(ev && ev.type);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // This cannot be moved to the action function, because it would not catch the
	    // case where the model is changed in the ngChange function or the model setter
	    if (modelValue !== ctrl.$modelValue &&
	      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	      // eslint-disable-next-line no-self-compare
	      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$$setModelValue(modelValue);
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 * @restrict A
	 * @priority 1
	 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * ## CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * @animations
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * ### Basic Usage
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * @example
	 * ### Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          modelCtrl.$$setUpdateOnEvents();
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /** @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 * @restrict A
	 * @priority 10
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ### Overriding immediate updates
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Debouncing updates
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 * ### Default events, extra triggers, and catch-all debounce values
	 *
	 * This example shows the relationship between "default" update events and
	 * additional `updateOn` triggers.
	 *
	 * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
	 * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
	 * in `updateOn` is considered a "default" event, since different control types have different
	 * default events.
	 *
	 * The control in this example updates by "default", "click", and "blur", with different `debounce`
	 * values. You can see that "click" doesn't have an individual `debounce` value -
	 * therefore it uses the `*` debounce value.
	 *
	 * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
	 * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
	 * it is considered a "default" event and will update the
	 * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
	 * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
	 *
	 * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
	 * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
	 *
	  <example name="ngModelOptions-advanced" module="optionsExample">
	    <file name="index.html">
	       <model-update-demo></model-update-demo>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .component('modelUpdateDemo', {
	          templateUrl: 'template.html',
	          controller: function() {
	            this.name = 'Chinua';
	
	            this.options = {
	              updateOn: 'default blur click',
	              debounce: {
	                default: 2000,
	                blur: 0,
	                '*': 1000
	              }
	            };
	
	            this.updateEvents = function() {
	              var eventList = this.options.updateOn.split(' ');
	              eventList.push('*');
	              var events = {};
	
	              for (var i = 0; i < eventList.length; i++) {
	                events[eventList[i]] = this.options.debounce[eventList[i]];
	              }
	
	              this.events = events;
	            };
	
	            this.updateOptions = function() {
	              var options = angular.extend(this.options, {
	                updateOn: Object.keys(this.events).join(' ').replace('*', ''),
	                debounce: this.events
	              });
	
	              this.form.input.$overrideModelOptions(options);
	            };
	
	            // Initialize the event form
	            this.updateEvents();
	          }
	        });
	    </file>
	    <file name="template.html">
	      <form name="$ctrl.form">
	        Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
	      </form>
	      Model: <tt>{{$ctrl.name}}</tt>
	      <hr>
	      <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>
	
	      <hr>
	      <form ng-submit="$ctrl.updateOptions()">
	        <b>updateOn</b><br>
	        <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">
	
	        <table>
	          <tr>
	            <th>Option</th>
	            <th>Debounce value</th>
	          </tr>
	          <tr ng-repeat="(key, value) in $ctrl.events">
	            <td>{{key}}</td>
	            <td><input type="number" ng-model="$ctrl.events[key]" /></td>
	          </tr>
	        </table>
	
	        <br>
	        <input type="submit" value="Update options">
	      </form>
	    </file>
	  </example>
	 *
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Programmatically changing options
	 *
	 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
	 * watched for changes. However, it is possible to override the options on a single
	 * {@link ngModel.NgModelController} instance with
	 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
	 * See also the example for
	 * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
	 * Default events, extra triggers, and catch-all debounce values}.
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 *
	 * ## Formatting the value of `time` and `datetime-local`
	 *
	 * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
	 * that is displayed in the control. Note that browsers may apply their own formatting
	 * in the user interface.
	 *
	   <example name="ngModelOptions-time-format" module="timeExample">
	     <file name="index.html">
	       <time-example></time-example>
	     </file>
	     <file name="script.js">
	        angular.module('timeExample', [])
	          .component('timeExample', {
	            templateUrl: 'timeExample.html',
	            controller: function() {
	              this.time = new Date(1970, 0, 1, 14, 57, 0);
	
	              this.options = {
	                timeSecondsFormat: 'ss',
	                timeStripZeroSeconds: true
	              };
	
	              this.optionChange = function() {
	                this.timeForm.timeFormatted.$overrideModelOptions(this.options);
	                this.time = new Date(this.time);
	              };
	            }
	          });
	     </file>
	     <file name="timeExample.html">
	       <form name="$ctrl.timeForm">
	         <strong>Default</strong>:
	         <input type="time" ng-model="$ctrl.time" step="any" /><br>
	         <strong>With options</strong>:
	         <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
	         <br>
	
	         Options:<br>
	         <code>timeSecondsFormat</code>:
	         <input
	           type="text"
	           ng-model="$ctrl.options.timeSecondsFormat"
	           ng-change="$ctrl.optionChange()">
	         <br>
	         <code>timeStripZeroSeconds</code>:
	         <input
	           type="checkbox"
	           ng-model="$ctrl.options.timeStripZeroSeconds"
	           ng-change="$ctrl.optionChange()">
	        </form>
	      </file>
	 *  </example>
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents.
	 *
	 * **General options**:
	 *
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control. These are the events that are bound to
	 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
	 *
	 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
	 *     since different control types use different default events.
	 *
	 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
	 *     Triggering and debouncing model updates}.
	 *
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *     You can use the `*` key to specify a debounce value that applies to all events that are not
	 *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur mouseup',
	 *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
	 *     }"
	 *     ```
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *
	 *
	 *  **Input-type specific options**:
	 *
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *     Note that changing the timezone will have no effect on the current date, and is only applied after
	 *     the next input / model change.
	 *
	 *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
	 *     milliseconds. The option follows the format string of {@link date date filter}.
	 *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
	 *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
	 *     seconds and milliseconds.
	 *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
	 *     part of the time string, and may show the value differently in the user interface.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
	 *     seconds and milliseconds from the formatted value if they are zero. This option is applied
	 *     after `timeSecondsFormat`.
	 *     This option can be used to make the formatting consistent over different browsers, as some
	 *     browsers with support for `time` will natively hide the milliseconds and
	 *     seconds if they are zero, but others won't, and browsers that don't implement these input
	 *     types will always show the full string.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 * @element ANY
	 *
	 * @description
	 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
	 * DOM element, including directives on the element itself that have a lower priority than
	 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
	 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
	 * that displays snippets of code, for instance.
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	  <example name="ng-non-bindable">
	    <file name="index.html">
	      <div>Normal: {{1 + 2}}</div>
	      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	    </file>
	    <file name="protractor.js" type="protractor">
	     it('should check ng-non-bindable', function() {
	       expect(element(by.binding('1 + 2')).getText()).toContain('3');
	       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	     });
	    </file>
	  </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      // The empty option will be compiled and rendered before we first generate the options
	      selectElement.empty();
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            selectCtrl.selectUnknownOrEmptyOption(value);
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        selectElement.prepend(selectCtrl.emptyOption);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                var needsRerender = selectCtrl.$isEmptyOptionSelected();
	
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	
	                if (needsRerender) ngModelCtrl.$render();
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // Support: IE 11 only, Edge 12-13 only
	        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * ## Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in AngularJS's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * ## Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * AngularJS expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * ## Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRef
	 * @restrict A
	 *
	 * @description
	 * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
	 * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
	 * element to the scope.
	 *
	 * If the element with `ngRef` is destroyed `null` is assigned to the property.
	 *
	 * Note that if you want to assign from a child into the parent scope, you must initialize the
	 * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
	 * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
	 * {@link ngRepeat}. See the second example below.
	 *
	 *
	 * @element ANY
	 * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
	 *                       controller or jqlite-wrapped DOM element will be bound.
	 * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
	 *                            or the special string `$element`. If a name is provided, `ngRef` will
	 *                            assign the matching controller. If `$element` is provided, the element
	 *                            itself is assigned (even if a controller is available).
	 *
	 *
	 * @example
	 * ### Simple toggle
	 * This example shows how the controller of the component toggle
	 * is reused in the template through the scope to use its logic.
	 * <example name="ng-ref-component" module="myApp">
	 *   <file name="index.html">
	 *     <my-toggle ng-ref="myToggle"></my-toggle>
	 *     <button ng-click="myToggle.toggle()">Toggle</button>
	 *     <div ng-show="myToggle.isOpen()">
	 *       You are using a component in the same template to show it.
	 *     </div>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myToggle', {
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should publish the toggle into the scope', function() {
	 *        var toggle = element(by.buttonText('Toggle'));
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
	 *        toggle.click();
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### ngRef inside scopes
	 * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
	 * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
	 * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
	 * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
	 * because the target property has not been initialized on the `myRoot` component controller.
	 *
	 * <example name="ng-ref-scopes" module="myApp">
	 *   <file name="index.html">
	 *     <my-root></my-root>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myRoot', {
	 *       templateUrl: 'root.html',
	 *       controller: function() {
	 *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
	 *       }
	 *     })
	 *     .component('myToggle', {
	 *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
	 *       transclude: true,
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     })
	 *     .component('myWrapper', {
	 *       transclude: true,
	 *       template: '<strong>myWrapper</strong>' +
	 *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
	 *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
	 *     });
	 *   </file>
	 *   <file name="root.html">
	 *     <strong>myRoot</strong>
	 *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
	 *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     <div><em>wrappers assigned to root</em><br>
	 *     <div ng-repeat="wrapper in $ctrl.wrappers">
	 *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
	 *     </div>
	 *
	 *     <ul>
	 *       <li ng-repeat="(index, value) in [1,2,3]">
	 *         <strong>ngRepeat</strong>
	 *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
	 *       </li>
	 *     </ul>
	 *
	 *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
	 *       assigned to the child scope created by ngIf.
	 *     </div>
	 *     <div ng-if="true">
	          <strong>ngIf</strong>
	 *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
	 *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
	 *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     </div>
	 *   </file>
	 *   <file name="styles.css">
	 *     ul {
	 *       list-style: none;
	 *       padding-left: 0;
	 *     }
	 *
	 *     li[ng-repeat] {
	 *       background: lightgreen;
	 *       padding: 8px;
	 *       margin: 8px;
	 *     }
	 *
	 *     [ng-if] {
	 *       background: lightgrey;
	 *       padding: 8px;
	 *     }
	 *
	 *     my-root {
	 *       background: lightgoldenrodyellow;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-wrapper {
	 *       background: lightsalmon;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-toggle {
	 *       background: lightblue;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      var OuterToggle = function() {
	 *        this.toggle = function() {
	 *          element(by.buttonText('Outer Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
	 *        };
	 *      };
	 *      var NgRepeatToggle = function(i) {
	 *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *      var NgRepeatToggles = function() {
	 *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
	 *        this.forEach = function(fn) {
	 *          toggles.forEach(fn);
	 *        };
	 *        this.isOuterOpen = function(i) {
	 *          return toggles[i - 1].isOuterOpen();
	 *        };
	 *      };
	 *      var NgIfToggle = function() {
	 *        var parent = element(by.css('[ng-if]'));
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngIf Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return by.binding('ngIfToggle.isOpen() | json').getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *
	 *      it('should toggle the outer toggle', function() {
	 *        var outerToggle = new OuterToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle all outer toggles', function() {
	 *        var outerToggle = new OuterToggle();
	 *        var repeatToggles = new NgRepeatToggles();
	 *        var ifToggle = new NgIfToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle each repeat iteration separately', function() {
	 *        var repeatToggles = new NgRepeatToggles();
	 *
	 *        repeatToggles.forEach(function(repeatToggle) {
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *          repeatToggle.toggle();
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        });
	 *      });
	 *   </file>
	 * </example>
	 *
	 */
	
	var ngRefMinErr = minErr('ngRef');
	
	var ngRefDirective = ['$parse', function($parse) {
	  return {
	    priority: -1, // Needed for compatibility with element transclusion on the same element
	    restrict: 'A',
	    compile: function(tElement, tAttrs) {
	      // Get the expected controller name, converts <data-some-thing> into "someThing"
	      var controllerName = directiveNormalize(nodeName_(tElement));
	
	      // Get the expression for value binding
	      var getter = $parse(tAttrs.ngRef);
	      var setter = getter.assign || function() {
	        throw ngRefMinErr('nonassign', 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
	      };
	
	      return function(scope, element, attrs) {
	        var refValue;
	
	        if (attrs.hasOwnProperty('ngRefRead')) {
	          if (attrs.ngRefRead === '$element') {
	            refValue = element;
	          } else {
	            refValue = element.data('$' + attrs.ngRefRead + 'Controller');
	
	            if (!refValue) {
	              throw ngRefMinErr(
	                'noctrl',
	                'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"',
	                attrs.ngRefRead,
	                tAttrs.ngRef
	              );
	            }
	          }
	        } else {
	          refValue = element.data('$' + controllerName + 'Controller');
	        }
	
	        refValue = refValue || element;
	
	        setter(scope, refValue);
	
	        // when the element is removed, remove it (nullify it)
	        element.on('$destroy', function() {
	          // only remove it if value has not changed,
	          // because animations (and other procedures) may duplicate elements
	          if (getter(scope) === refValue) {
	            setter(scope, null);
	          }
	        });
	      };
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * ## Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so AngularJS relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * ## Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * All different types of tracking functions, their syntax, and their support for duplicate
	 * items in collections can be found in the
	 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** If you are working with objects that have a unique identifier property, you
	 * should track by this identifier instead of the object instance,
	 * e.g. `item in items track by item.id`.
	 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
	 * it has already rendered, even if the JavaScript objects in the collection have been substituted
	 * for new ones. For large collections, this significantly improves rendering performance.
	 * </div>
	 *
	 * ### Effects of DOM Element re-use
	 *
	 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
	 * automatically update any active bindings on the template. However, other
	 * functionality will not be updated, because the element is not re-created:
	 *
	 * - Directives are not re-compiled
	 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
	 * updated if they have stabilized.
	 *
	 * The above affects all kinds of element re-use due to tracking, but may be especially visible
	 * when tracking by `$index` due to the way ngRepeat re-uses elements.
	 *
	 * The following example shows the effects of different actions with tracking:
	
	  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        var friends = [
	          {name:'John', age:25},
	          {name:'Mary', age:40},
	          {name:'Peter', age:85}
	        ];
	
	        $scope.removeFirst = function() {
	          $scope.friends.shift();
	        };
	
	        $scope.updateAge = function() {
	          $scope.friends.forEach(function(el) {
	            el.age = el.age + 5;
	          });
	        };
	
	        $scope.copy = function() {
	          $scope.friends = angular.copy($scope.friends);
	        };
	
	        $scope.reset = function() {
	          $scope.friends = angular.copy(friends);
	        };
	
	        $scope.reset();
	      });
	    </file>
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        <ol>
	          <li>When you click "Update Age", only the first list updates the age, because all others have
	          a one-time binding on the age property. If you then click "Copy", the current friend list
	          is copied, and now the second list updates the age, because the identity of the collection items
	          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
	          items are already known according to their tracking functions.
	          </li>
	          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
	          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
	          DOM element for the new first collection item, and so on. Since the age property is one-time
	          bound, the value remains from the collection item which was previously at this index.
	          </li>
	        </ol>
	
	        <button ng-click="removeFirst()">Remove First</button>
	        <button ng-click="updateAge()">Update Age</button>
	        <button ng-click="copy()">Copy</button>
	        <br><button ng-click="reset()">Reset List</button>
	        <br>
	        <code>track by $id(friend)</code> (default):
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $id(friend)</code> (default), with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by friend.name</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
	            {{friend.name}}  is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $index</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	  </example>
	
	 *
	 * ## Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
	 *     This implies that the DOM elements will be associated by item identity in the collection.
	 *
	 *     The built-in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the collection by identity. Moving the same object would move
	 *     the DOM element in the same way in the DOM.
	 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
	 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
	 *
	 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
	 *     id, for example with a function, or using a property on the collection items.
	 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
	 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
	 *     equivalent as long as their `id` property is same.
	 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
	 *
	 *     *$index*: This special property tracks the collection items by their index, and
	 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
	 *     be used for a performance improvement if no unique identfier is available and the identity of
	 *     the collection items cannot be easily computed. It also allows duplicates.
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
	 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
	 *       more info.
	 *     </div>
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
	 *       `item in items | filter:searchText as results  track by item.id`
	 *     </div>
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name]` is not an operator but rather a part of ngRepeat
	 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	  var trackByIdArrayFn = function($scope, key, value) {
	    return hashKey(value);
	  };
	
	  var trackByIdObjFn = function($scope, key) {
	    return key;
	  };
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByIdExpFn;
	
	      if (trackByExp) {
	        var hashFnLocals = {$id: hashKey};
	        var trackByExpGetter = $parse(trackByExp);
	
	        trackByIdExpFn = function($scope, key, value, index) {
	          // assign key, value, and $index to the locals so that they can be used in hash functions
	          if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	          hashFnLocals[valueIdentifier] = value;
	          hashFnLocals.$index = index;
	          return trackByExpGetter($scope, hashFnLocals);
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - clone: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn($scope, key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // Clear the value property from the hashFnLocals object to prevent a reference to the last value
	          // being leaked into the ngRepeatCompile function scope
	          if (hashFnLocals) {
	            hashFnLocals[valueIdentifier] = undefined;
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngShow to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngHide to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(255, 0, 0, 1\)|rgb\(255, 0, 0\)/);
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, ''); });
	    }
	    if (newStyles) element.css(newStyles);
	  });
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value);
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 *
	 * @description
	 * The controller for the {@link ng.select select} directive. The controller exposes
	 * a few utility methods that can be used to augment the behavior of a regular or an
	 * {@link ng.ngOptions ngOptions} select element.
	 *
	 * @example
	 * ### Set a custom error when the unknown option is selected
	 *
	 * This example sets a custom error "unknownValue" on the ngModelController
	 * when the select element's unknown option is selected, i.e. when the model is set to a value
	 * that is not matched by any option.
	 *
	 * <example name="select-unknown-value-error" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Single select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-error>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
	 *       Error: The current model doesn't match any option</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueError', function() {
	 *     return {
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
	 *           if (selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return true;
	 *         };
	 *       }
	 *
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 * @example
	 * ### Set the "required" error when the unknown option is selected.
	 *
	 * By default, the "required" error on the ngModelController is only set on a required select
	 * when the empty option is selected. This example adds a custom directive that also sets the
	 * error when the unknown option is selected.
	 *
	 * <example name="select-unknown-value-required" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Select: </label><br>
	 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueRequired', function() {
	 *     return {
	 *       priority: 1, // This directive must run after the required directive has added its validator
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
	 *
	 *         ngModelCtrl.$validators.required = function() {
	 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return originalRequiredValidator.apply(this, arguments);
	 *         };
	 *       }
	 *     };
	 *   });
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 *  it('should show the error message when the unknown option is selected', function() {
	
	      var error = element(by.className('error'));
	
	      expect(error.getText()).toBe('Error: Please select a value');
	
	      element(by.cssContainingText('option', 'Option 1')).click();
	
	      expect(error.isPresent()).toBe(false);
	
	      element(by.tagName('button')).click();
	
	      expect(error.getText()).toBe('Error: Please select a value');
	    });
	 * </file>
	 *</example>
	 *
	 *
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that the application developer can
	  // provide inside the select. It is always selectable and indicates that a "null" selection has
	  // been made by the user.
	  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
	  // the empty option is selected.
	  // If the model is set to a different unmatched value, the unknown option is rendered and
	  // selected, i.e both are present, because a "null" selection and an unknown value are different.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      setOptionSelectedStatus(self.emptyOption, false);
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      self.selectUnknownOrEmptyOption(value);
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$hasEmptyOption
	   *
	   * @description
	   *
	   * Returns `true` if the select element currently has an empty option
	   * element, i.e. an option that signifies that the select is empty / the selection is null.
	   *
	   */
	  self.$hasEmptyOption = function() {
	    return self.hasEmptyOption;
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isUnknownOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element's unknown option is selected. The unknown option is added
	   * and automatically selected whenever the select model doesn't match any option.
	   *
	   */
	  self.$isUnknownOptionSelected = function() {
	    // Presence of the unknown option means it is selected
	    return $element[0].options[0] === self.unknownOption[0];
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isEmptyOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element has an empty option and this empty option is currently
	   * selected. Returns `false` if the select element has no empty option or it is not selected.
	   *
	   */
	  self.$isEmptyOptionSelected = function() {
	    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
	  };
	
	  self.selectUnknownOrEmptyOption = function(value) {
	    if (value == null && self.emptyOption) {
	      self.removeUnknownOption();
	      self.selectEmptyOption();
	    } else if (self.unknownOption.parent().length) {
	      self.updateUnknownOption(value);
	    } else {
	      self.renderUnknownOption(value);
	    }
	  };
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with AngularJS data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * The {@link select.SelectController select controller} exposes utility functions that can be used
	 * to manipulate the select's behavior.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // Support: IE 9-11 only, Edge 12-15+
	            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if necessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
	 *                                `required` attribute to the element and adds the `required`
	 *                                {@link ngModel.NgModelController#$validators `validator`}.
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the AngularJS expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      // For boolean attributes like required, presence means true
	      var value = attr.hasOwnProperty('required') || $parse(attr.ngRequired)(scope);
	
	      if (!attr.ngRequired) {
	        // force truthy in case we are on non input element
	        // (input elements do this automatically for boolean attributes like required)
	        attr.required = true;
	      }
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !value || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function(newVal) {
	
	        if (value !== newVal) {
	          value = newVal;
	          ctrl.$validate();
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 * @restrict A
	 *
	 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
	 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
	 *                                      more details.
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
	 * - the value is an AngularJS expression:
	 *   - If the expression evaluates to a RegExp object, then this is used directly.
	 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    compile: function(tElm, tAttr) {
	      var patternExp;
	      var parseFn;
	
	      if (tAttr.ngPattern) {
	        patternExp = tAttr.ngPattern;
	
	        // ngPattern might be a scope expression, or an inlined regex, which is not parsable.
	        // We get value of the attribute here, so we can compare the old and the new value
	        // in the observer to avoid unnecessary validations
	        if (tAttr.ngPattern.charAt(0) === '/' && REGEX_STRING_REGEXP.test(tAttr.ngPattern)) {
	          parseFn = function() { return tAttr.ngPattern; };
	        } else {
	          parseFn = $parse(tAttr.ngPattern);
	        }
	      }
	
	      return function(scope, elm, attr, ctrl) {
	        if (!ctrl) return;
	
	        var attrVal = attr.pattern;
	
	        if (attr.ngPattern) {
	          attrVal = parseFn(scope);
	        } else {
	          patternExp = attr.pattern;
	        }
	
	        var regexp = parsePatternAttr(attrVal, patternExp, elm);
	
	        attr.$observe('pattern', function(newVal) {
	          var oldRegexp = regexp;
	
	          regexp = parsePatternAttr(newVal, patternExp, elm);
	
	          if ((oldRegexp && oldRegexp.toString()) !== (regexp && regexp.toString())) {
	            ctrl.$validate();
	          }
	        });
	
	        ctrl.$validators.pattern = function(modelValue, viewValue) {
	          // HTML5 pattern constraint validates the input value, so we validate the viewValue
	          return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	        };
	      };
	    }
	
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 * @restrict A
	 *
	 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `maxlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = attr.maxlength || $parse(attr.ngMaxlength)(scope);
	      var maxlengthParsed = parseLength(maxlength);
	
	      attr.$observe('maxlength', function(value) {
	        if (maxlength !== value) {
	          maxlengthParsed = parseLength(value);
	          maxlength = value;
	          ctrl.$validate();
	        }
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlengthParsed < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlengthParsed);
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 * @restrict A
	 *
	 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `minlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = attr.minlength || $parse(attr.ngMinlength)(scope);
	      var minlengthParsed = parseLength(minlength) || -1;
	
	      attr.$observe('minlength', function(value) {
	        if (minlength !== value) {
	          minlengthParsed = parseLength(value) || -1;
	          minlength = value;
	          ctrl.$validate();
	        }
	
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlengthParsed;
	      };
	    }
	  };
	}];
	
	
	function parsePatternAttr(regex, patternExp, elm) {
	  if (!regex) return undefined;
	
	  if (isString(regex)) {
	    regex = new RegExp('^' + regex + '$');
	  }
	
	  if (!regex.test) {
	    throw minErr('ngPattern')('noregexp',
	      'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	      regex, startingTag(elm));
	  }
	
	  return regex;
	}
	
	function parseLength(val) {
	  var intVal = toInt(val);
	  return isNumberNaN(intVal) ? -1 : intVal;
	}
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load AngularJS more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend(window.angular.element('<style>').text('@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}'));
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = window.angular;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(32);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var angular = __webpack_require__(28);
	
	/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* global routeToRegExp: true */
	
	/**
	 * @param {string} path - The path to parse. (It is assumed to have query and hash stripped off.)
	 * @param {Object} opts - Options.
	 * @return {Object} - An object containing an array of path parameter names (`keys`) and a regular
	 *     expression (`regexp`) that can be used to identify a matching URL and extract the path
	 *     parameter values.
	 *
	 * @description
	 * Parses the given path, extracting path parameter names and a regular expression to match URLs.
	 *
	 * Originally inspired by `pathRexp` in `visionmedia/express/lib/utils.js`.
	 */
	function routeToRegExp(path, opts) {
	  var keys = [];
	
	  var pattern = path
	    .replace(/([().])/g, '\\$1')
	    .replace(/(\/)?:(\w+)(\*\?|[?*])?/g, function(_, slash, key, option) {
	      var optional = option === '?' || option === '*?';
	      var star = option === '*' || option === '*?';
	      keys.push({name: key, optional: optional});
	      slash = slash || '';
	      return (
	        (optional ? '(?:' + slash : slash + '(?:') +
	        (star ? '(.+?)' : '([^/]+)') +
	        (optional ? '?)?' : ')')
	      );
	    })
	    .replace(/([/$*])/g, '\\$1');
	
	  if (opts.ignoreTrailingSlashes) {
	    pattern = pattern.replace(/\/+$/, '') + '/*';
	  }
	
	  return {
	    keys: keys,
	    regexp: new RegExp(
	      '^' + pattern + '(?:[?#]|$)',
	      opts.caseInsensitiveMatch ? 'i' : ''
	    )
	  };
	}
	
	/* global routeToRegExp: false */
	/* global shallowCopy: false */
	
	// `isArray` and `isObject` are necessary for `shallowCopy()` (included via `src/shallowCopy.js`).
	// They are initialized inside the `$RouteProvider`, to ensure `window.angular` is available.
	var isArray;
	var isObject;
	var isDefined;
	var noop;
	
	/**
	 * @ngdoc module
	 * @name ngRoute
	 * @description
	 *
	 * The `ngRoute` module provides routing and deeplinking services and directives for AngularJS apps.
	 *
	 * ## Example
	 * See {@link ngRoute.$route#examples $route} for an example of configuring and using `ngRoute`.
	 *
	 */
	/* global -ngRouteModule */
	var ngRouteModule = angular.
	  module('ngRoute', []).
	  info({ angularVersion: '1.8.3' }).
	  provider('$route', $RouteProvider).
	  // Ensure `$route` will be instantiated in time to capture the initial `$locationChangeSuccess`
	  // event (unless explicitly disabled). This is necessary in case `ngView` is included in an
	  // asynchronously loaded template.
	  run(instantiateRoute);
	var $routeMinErr = angular.$$minErr('ngRoute');
	var isEagerInstantiationEnabled;
	
	
	/**
	 * @ngdoc provider
	 * @name $routeProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring routes.
	 *
	 * ## Example
	 * See {@link ngRoute.$route#examples $route} for an example of configuring and using `ngRoute`.
	 *
	 * ## Dependencies
	 * Requires the {@link ngRoute `ngRoute`} module to be installed.
	 */
	function $RouteProvider() {
	  isArray = angular.isArray;
	  isObject = angular.isObject;
	  isDefined = angular.isDefined;
	  noop = angular.noop;
	
	  function inherit(parent, extra) {
	    return angular.extend(Object.create(parent), extra);
	  }
	
	  var routes = {};
	
	  /**
	   * @ngdoc method
	   * @name $routeProvider#when
	   *
	   * @param {string} path Route path (matched against `$location.path`). If `$location.path`
	   *    contains redundant trailing slash or is missing one, the route will still match and the
	   *    `$location.path` will be updated to add or drop the trailing slash to exactly match the
	   *    route definition.
	   *
	   *    * `path` can contain named groups starting with a colon: e.g. `:name`. All characters up
	   *        to the next slash are matched and stored in `$routeParams` under the given `name`
	   *        when the route matches.
	   *    * `path` can contain named groups starting with a colon and ending with a star:
	   *        e.g.`:name*`. All characters are eagerly stored in `$routeParams` under the given `name`
	   *        when the route matches.
	   *    * `path` can contain optional named groups with a question mark: e.g.`:name?`.
	   *
	   *    For example, routes like `/color/:color/largecode/:largecode*\/edit` will match
	   *    `/color/brown/largecode/code/with/slashes/edit` and extract:
	   *
	   *    * `color: brown`
	   *    * `largecode: code/with/slashes`.
	   *
	   *
	   * @param {Object} route Mapping information to be assigned to `$route.current` on route
	   *    match.
	   *
	   *    Object properties:
	   *
	   *    - `controller` – `{(string|Function)=}` – Controller fn that should be associated with
	   *      newly created scope or the name of a {@link angular.Module#controller registered
	   *      controller} if passed as a string.
	   *    - `controllerAs` – `{string=}` – An identifier name for a reference to the controller.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *    - `template` – `{(string|Function)=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used by {@link
	   *      ngRoute.directive:ngView ngView} or {@link ng.directive:ngInclude ngInclude} directives.
	   *      This property takes precedence over `templateUrl`.
	   *
	   *      If `template` is a function, it will be called with the following parameters:
	   *
	   *      - `{Array.<Object>}` - route parameters extracted from the current
	   *        `$location.path()` by applying the current route
	   *
	   *      One of `template` or `templateUrl` is required.
	   *
	   *    - `templateUrl` – `{(string|Function)=}` – path or function that returns a path to an html
	   *      template that should be used by {@link ngRoute.directive:ngView ngView}.
	   *
	   *      If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *      - `{Array.<Object>}` - route parameters extracted from the current
	   *        `$location.path()` by applying the current route
	   *
	   *      One of `templateUrl` or `template` is required.
	   *
	   *    - `resolve` - `{Object.<string, Function>=}` - An optional map of dependencies which should
	   *      be injected into the controller. If any of these dependencies are promises, the router
	   *      will wait for them all to be resolved or one to be rejected before the controller is
	   *      instantiated.
	   *      If all the promises are resolved successfully, the values of the resolved promises are
	   *      injected and {@link ngRoute.$route#$routeChangeSuccess $routeChangeSuccess} event is
	   *      fired. If any of the promises are rejected the
	   *      {@link ngRoute.$route#$routeChangeError $routeChangeError} event is fired.
	   *      For easier access to the resolved dependencies from the template, the `resolve` map will
	   *      be available on the scope of the route, under `$resolve` (by default) or a custom name
	   *      specified by the `resolveAs` property (see below). This can be particularly useful, when
	   *      working with {@link angular.Module#component components} as route templates.<br />
	   *      <div class="alert alert-warning">
	   *        **Note:** If your scope already contains a property with this name, it will be hidden
	   *        or overwritten. Make sure, you specify an appropriate name for this property, that
	   *        does not collide with other properties on the scope.
	   *      </div>
	   *      The map object is:
	   *
	   *      - `key` – `{string}`: a name of a dependency to be injected into the controller.
	   *      - `factory` - `{string|Function}`: If `string` then it is an alias for a service.
	   *        Otherwise if function, then it is {@link auto.$injector#invoke injected}
	   *        and the return value is treated as the dependency. If the result is a promise, it is
	   *        resolved before its value is injected into the controller. Be aware that
	   *        `ngRoute.$routeParams` will still refer to the previous route within these resolve
	   *        functions.  Use `$route.current.params` to access the new route parameters, instead.
	   *
	   *    - `resolveAs` - `{string=}` - The name under which the `resolve` map will be available on
	   *      the scope of the route. If omitted, defaults to `$resolve`.
	   *
	   *    - `redirectTo` – `{(string|Function)=}` – value to update
	   *      {@link ng.$location $location} path with and trigger route redirection.
	   *
	   *      If `redirectTo` is a function, it will be called with the following parameters:
	   *
	   *      - `{Object.<string>}` - route parameters extracted from the current
	   *        `$location.path()` by applying the current route templateUrl.
	   *      - `{string}` - current `$location.path()`
	   *      - `{Object}` - current `$location.search()`
	   *
	   *      The custom `redirectTo` function is expected to return a string which will be used
	   *      to update `$location.url()`. If the function throws an error, no further processing will
	   *      take place and the {@link ngRoute.$route#$routeChangeError $routeChangeError} event will
	   *      be fired.
	   *
	   *      Routes that specify `redirectTo` will not have their controllers, template functions
	   *      or resolves called, the `$location` will be changed to the redirect url and route
	   *      processing will stop. The exception to this is if the `redirectTo` is a function that
	   *      returns `undefined`. In this case the route transition occurs as though there was no
	   *      redirection.
	   *
	   *    - `resolveRedirectTo` – `{Function=}` – a function that will (eventually) return the value
	   *      to update {@link ng.$location $location} URL with and trigger route redirection. In
	   *      contrast to `redirectTo`, dependencies can be injected into `resolveRedirectTo` and the
	   *      return value can be either a string or a promise that will be resolved to a string.
	   *
	   *      Similar to `redirectTo`, if the return value is `undefined` (or a promise that gets
	   *      resolved to `undefined`), no redirection takes place and the route transition occurs as
	   *      though there was no redirection.
	   *
	   *      If the function throws an error or the returned promise gets rejected, no further
	   *      processing will take place and the
	   *      {@link ngRoute.$route#$routeChangeError $routeChangeError} event will be fired.
	   *
	   *      `redirectTo` takes precedence over `resolveRedirectTo`, so specifying both on the same
	   *      route definition, will cause the latter to be ignored.
	   *
	   *    - `[reloadOnUrl=true]` - `{boolean=}` - reload route when any part of the URL changes
	   *      (including the path) even if the new URL maps to the same route.
	   *
	   *      If the option is set to `false` and the URL in the browser changes, but the new URL maps
	   *      to the same route, then a `$routeUpdate` event is broadcasted on the root scope (without
	   *      reloading the route).
	   *
	   *    - `[reloadOnSearch=true]` - `{boolean=}` - reload route when only `$location.search()`
	   *      or `$location.hash()` changes.
	   *
	   *      If the option is set to `false` and the URL in the browser changes, then a `$routeUpdate`
	   *      event is broadcasted on the root scope (without reloading the route).
	   *
	   *      <div class="alert alert-warning">
	   *        **Note:** This option has no effect if `reloadOnUrl` is set to `false`.
	   *      </div>
	   *
	   *    - `[caseInsensitiveMatch=false]` - `{boolean=}` - match routes without being case sensitive
	   *
	   *      If the option is set to `true`, then the particular route can be matched without being
	   *      case sensitive
	   *
	   * @returns {Object} self
	   *
	   * @description
	   * Adds a new route definition to the `$route` service.
	   */
	  this.when = function(path, route) {
	    //copy original route object to preserve params inherited from proto chain
	    var routeCopy = shallowCopy(route);
	    if (angular.isUndefined(routeCopy.reloadOnUrl)) {
	      routeCopy.reloadOnUrl = true;
	    }
	    if (angular.isUndefined(routeCopy.reloadOnSearch)) {
	      routeCopy.reloadOnSearch = true;
	    }
	    if (angular.isUndefined(routeCopy.caseInsensitiveMatch)) {
	      routeCopy.caseInsensitiveMatch = this.caseInsensitiveMatch;
	    }
	    routes[path] = angular.extend(
	      routeCopy,
	      {originalPath: path},
	      path && routeToRegExp(path, routeCopy)
	    );
	
	    // create redirection for trailing slashes
	    if (path) {
	      var redirectPath = (path[path.length - 1] === '/')
	            ? path.substr(0, path.length - 1)
	            : path + '/';
	
	      routes[redirectPath] = angular.extend(
	        {originalPath: path, redirectTo: path},
	        routeToRegExp(redirectPath, routeCopy)
	      );
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $routeProvider#caseInsensitiveMatch
	   * @description
	   *
	   * A boolean property indicating if routes defined
	   * using this provider should be matched using a case insensitive
	   * algorithm. Defaults to `false`.
	   */
	  this.caseInsensitiveMatch = false;
	
	  /**
	   * @ngdoc method
	   * @name $routeProvider#otherwise
	   *
	   * @description
	   * Sets route definition that will be used on route change when no other route definition
	   * is matched.
	   *
	   * @param {Object|string} params Mapping information to be assigned to `$route.current`.
	   * If called with a string, the value maps to `redirectTo`.
	   * @returns {Object} self
	   */
	  this.otherwise = function(params) {
	    if (typeof params === 'string') {
	      params = {redirectTo: params};
	    }
	    this.when(null, params);
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $routeProvider#eagerInstantiationEnabled
	   * @kind function
	   *
	   * @description
	   * Call this method as a setter to enable/disable eager instantiation of the
	   * {@link ngRoute.$route $route} service upon application bootstrap. You can also call it as a
	   * getter (i.e. without any arguments) to get the current value of the
	   * `eagerInstantiationEnabled` flag.
	   *
	   * Instantiating `$route` early is necessary for capturing the initial
	   * {@link ng.$location#$locationChangeStart $locationChangeStart} event and navigating to the
	   * appropriate route. Usually, `$route` is instantiated in time by the
	   * {@link ngRoute.ngView ngView} directive. Yet, in cases where `ngView` is included in an
	   * asynchronously loaded template (e.g. in another directive's template), the directive factory
	   * might not be called soon enough for `$route` to be instantiated _before_ the initial
	   * `$locationChangeSuccess` event is fired. Eager instantiation ensures that `$route` is always
	   * instantiated in time, regardless of when `ngView` will be loaded.
	   *
	   * The default value is true.
	   *
	   * **Note**:<br />
	   * You may want to disable the default behavior when unit-testing modules that depend on
	   * `ngRoute`, in order to avoid an unexpected request for the default route's template.
	   *
	   * @param {boolean=} enabled - If provided, update the internal `eagerInstantiationEnabled` flag.
	   *
	   * @returns {*} The current value of the `eagerInstantiationEnabled` flag if used as a getter or
	   *     itself (for chaining) if used as a setter.
	   */
	  isEagerInstantiationEnabled = true;
	  this.eagerInstantiationEnabled = function eagerInstantiationEnabled(enabled) {
	    if (isDefined(enabled)) {
	      isEagerInstantiationEnabled = enabled;
	      return this;
	    }
	
	    return isEagerInstantiationEnabled;
	  };
	
	
	  this.$get = ['$rootScope',
	               '$location',
	               '$routeParams',
	               '$q',
	               '$injector',
	               '$templateRequest',
	               '$sce',
	               '$browser',
	      function($rootScope, $location, $routeParams, $q, $injector, $templateRequest, $sce, $browser) {
	
	    /**
	     * @ngdoc service
	     * @name $route
	     * @requires $location
	     * @requires $routeParams
	     *
	     * @property {Object} current Reference to the current route definition.
	     * The route definition contains:
	     *
	     *   - `controller`: The controller constructor as defined in the route definition.
	     *   - `locals`: A map of locals which is used by {@link ng.$controller $controller} service for
	     *     controller instantiation. The `locals` contain
	     *     the resolved values of the `resolve` map. Additionally the `locals` also contain:
	     *
	     *     - `$scope` - The current route scope.
	     *     - `$template` - The current route template HTML.
	     *
	     *     The `locals` will be assigned to the route scope's `$resolve` property. You can override
	     *     the property name, using `resolveAs` in the route definition. See
	     *     {@link ngRoute.$routeProvider $routeProvider} for more info.
	     *
	     * @property {Object} routes Object with all route configuration Objects as its properties.
	     *
	     * @description
	     * `$route` is used for deep-linking URLs to controllers and views (HTML partials).
	     * It watches `$location.url()` and tries to map the path to an existing route definition.
	     *
	     * Requires the {@link ngRoute `ngRoute`} module to be installed.
	     *
	     * You can define routes through {@link ngRoute.$routeProvider $routeProvider}'s API.
	     *
	     * The `$route` service is typically used in conjunction with the
	     * {@link ngRoute.directive:ngView `ngView`} directive and the
	     * {@link ngRoute.$routeParams `$routeParams`} service.
	     *
	     * @example
	     * This example shows how changing the URL hash causes the `$route` to match a route against the
	     * URL, and the `ngView` pulls in the partial.
	     *
	     * <example name="$route-service" module="ngRouteExample"
	     *          deps="angular-route.js" fixBase="true">
	     *   <file name="index.html">
	     *     <div ng-controller="MainController">
	     *       Choose:
	     *       <a href="Book/Moby">Moby</a> |
	     *       <a href="Book/Moby/ch/1">Moby: Ch1</a> |
	     *       <a href="Book/Gatsby">Gatsby</a> |
	     *       <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
	     *       <a href="Book/Scarlet">Scarlet Letter</a><br/>
	     *
	     *       <div ng-view></div>
	     *
	     *       <hr />
	     *
	     *       <pre>$location.path() = {{$location.path()}}</pre>
	     *       <pre>$route.current.templateUrl = {{$route.current.templateUrl}}</pre>
	     *       <pre>$route.current.params = {{$route.current.params}}</pre>
	     *       <pre>$route.current.scope.name = {{$route.current.scope.name}}</pre>
	     *       <pre>$routeParams = {{$routeParams}}</pre>
	     *     </div>
	     *   </file>
	     *
	     *   <file name="book.html">
	     *     controller: {{name}}<br />
	     *     Book Id: {{params.bookId}}<br />
	     *   </file>
	     *
	     *   <file name="chapter.html">
	     *     controller: {{name}}<br />
	     *     Book Id: {{params.bookId}}<br />
	     *     Chapter Id: {{params.chapterId}}
	     *   </file>
	     *
	     *   <file name="script.js">
	     *     angular.module('ngRouteExample', ['ngRoute'])
	     *
	     *      .controller('MainController', function($scope, $route, $routeParams, $location) {
	     *          $scope.$route = $route;
	     *          $scope.$location = $location;
	     *          $scope.$routeParams = $routeParams;
	     *      })
	     *
	     *      .controller('BookController', function($scope, $routeParams) {
	     *          $scope.name = 'BookController';
	     *          $scope.params = $routeParams;
	     *      })
	     *
	     *      .controller('ChapterController', function($scope, $routeParams) {
	     *          $scope.name = 'ChapterController';
	     *          $scope.params = $routeParams;
	     *      })
	     *
	     *     .config(function($routeProvider, $locationProvider) {
	     *       $routeProvider
	     *        .when('/Book/:bookId', {
	     *         templateUrl: 'book.html',
	     *         controller: 'BookController',
	     *         resolve: {
	     *           // I will cause a 1 second delay
	     *           delay: function($q, $timeout) {
	     *             var delay = $q.defer();
	     *             $timeout(delay.resolve, 1000);
	     *             return delay.promise;
	     *           }
	     *         }
	     *       })
	     *       .when('/Book/:bookId/ch/:chapterId', {
	     *         templateUrl: 'chapter.html',
	     *         controller: 'ChapterController'
	     *       });
	     *
	     *       // configure html5 to get links working on jsfiddle
	     *       $locationProvider.html5Mode(true);
	     *     });
	     *
	     *   </file>
	     *
	     *   <file name="protractor.js" type="protractor">
	     *     it('should load and compile correct template', function() {
	     *       element(by.linkText('Moby: Ch1')).click();
	     *       var content = element(by.css('[ng-view]')).getText();
	     *       expect(content).toMatch(/controller: ChapterController/);
	     *       expect(content).toMatch(/Book Id: Moby/);
	     *       expect(content).toMatch(/Chapter Id: 1/);
	     *
	     *       element(by.partialLinkText('Scarlet')).click();
	     *
	     *       content = element(by.css('[ng-view]')).getText();
	     *       expect(content).toMatch(/controller: BookController/);
	     *       expect(content).toMatch(/Book Id: Scarlet/);
	     *     });
	     *   </file>
	     * </example>
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeChangeStart
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted before a route change. At this  point the route services starts
	     * resolving all of the dependencies needed for the route change to occur.
	     * Typically this involves fetching the view template as well as any dependencies
	     * defined in `resolve` route property. Once  all of the dependencies are resolved
	     * `$routeChangeSuccess` is fired.
	     *
	     * The route change (and the `$location` change that triggered it) can be prevented
	     * by calling `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on}
	     * for more details about event object.
	     *
	     * @param {Object} angularEvent Synthetic event object.
	     * @param {Route} next Future route information.
	     * @param {Route} current Current route information.
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeChangeSuccess
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted after a route change has happened successfully.
	     * The `resolve` dependencies are now available in the `current.locals` property.
	     *
	     * {@link ngRoute.directive:ngView ngView} listens for the directive
	     * to instantiate the controller and render the view.
	     *
	     * @param {Object} angularEvent Synthetic event object.
	     * @param {Route} current Current route information.
	     * @param {Route|Undefined} previous Previous route information, or undefined if current is
	     * first route entered.
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeChangeError
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted if a redirection function fails or any redirection or resolve promises are
	     * rejected.
	     *
	     * @param {Object} angularEvent Synthetic event object
	     * @param {Route} current Current route information.
	     * @param {Route} previous Previous route information.
	     * @param {Route} rejection The thrown error or the rejection reason of the promise. Usually
	     * the rejection reason is the error that caused the promise to get rejected.
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeUpdate
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted if the same instance of a route (including template, controller instance,
	     * resolved dependencies, etc.) is being reused. This can happen if either `reloadOnSearch` or
	     * `reloadOnUrl` has been set to `false`.
	     *
	     * @param {Object} angularEvent Synthetic event object
	     * @param {Route} current Current/previous route information.
	     */
	
	    var forceReload = false,
	        preparedRoute,
	        preparedRouteIsUpdateOnly,
	        $route = {
	          routes: routes,
	
	          /**
	           * @ngdoc method
	           * @name $route#reload
	           *
	           * @description
	           * Causes `$route` service to reload the current route even if
	           * {@link ng.$location $location} hasn't changed.
	           *
	           * As a result of that, {@link ngRoute.directive:ngView ngView}
	           * creates new scope and reinstantiates the controller.
	           */
	          reload: function() {
	            forceReload = true;
	
	            var fakeLocationEvent = {
	              defaultPrevented: false,
	              preventDefault: function fakePreventDefault() {
	                this.defaultPrevented = true;
	                forceReload = false;
	              }
	            };
	
	            $rootScope.$evalAsync(function() {
	              prepareRoute(fakeLocationEvent);
	              if (!fakeLocationEvent.defaultPrevented) commitRoute();
	            });
	          },
	
	          /**
	           * @ngdoc method
	           * @name $route#updateParams
	           *
	           * @description
	           * Causes `$route` service to update the current URL, replacing
	           * current route parameters with those specified in `newParams`.
	           * Provided property names that match the route's path segment
	           * definitions will be interpolated into the location's path, while
	           * remaining properties will be treated as query params.
	           *
	           * @param {!Object<string, string>} newParams mapping of URL parameter names to values
	           */
	          updateParams: function(newParams) {
	            if (this.current && this.current.$$route) {
	              newParams = angular.extend({}, this.current.params, newParams);
	              $location.path(interpolate(this.current.$$route.originalPath, newParams));
	              // interpolate modifies newParams, only query params are left
	              $location.search(newParams);
	            } else {
	              throw $routeMinErr('norout', 'Tried updating route with no current route');
	            }
	          }
	        };
	
	    $rootScope.$on('$locationChangeStart', prepareRoute);
	    $rootScope.$on('$locationChangeSuccess', commitRoute);
	
	    return $route;
	
	    /////////////////////////////////////////////////////
	
	    /**
	     * @param on {string} current url
	     * @param route {Object} route regexp to match the url against
	     * @return {?Object}
	     *
	     * @description
	     * Check if the route matches the current url.
	     *
	     * Inspired by match in
	     * visionmedia/express/lib/router/router.js.
	     */
	    function switchRouteMatcher(on, route) {
	      var keys = route.keys,
	          params = {};
	
	      if (!route.regexp) return null;
	
	      var m = route.regexp.exec(on);
	      if (!m) return null;
	
	      for (var i = 1, len = m.length; i < len; ++i) {
	        var key = keys[i - 1];
	
	        var val = m[i];
	
	        if (key && val) {
	          params[key.name] = val;
	        }
	      }
	      return params;
	    }
	
	    function prepareRoute($locationEvent) {
	      var lastRoute = $route.current;
	
	      preparedRoute = parseRoute();
	      preparedRouteIsUpdateOnly = isNavigationUpdateOnly(preparedRoute, lastRoute);
	
	      if (!preparedRouteIsUpdateOnly && (lastRoute || preparedRoute)) {
	        if ($rootScope.$broadcast('$routeChangeStart', preparedRoute, lastRoute).defaultPrevented) {
	          if ($locationEvent) {
	            $locationEvent.preventDefault();
	          }
	        }
	      }
	    }
	
	    function commitRoute() {
	      var lastRoute = $route.current;
	      var nextRoute = preparedRoute;
	
	      if (preparedRouteIsUpdateOnly) {
	        lastRoute.params = nextRoute.params;
	        angular.copy(lastRoute.params, $routeParams);
	        $rootScope.$broadcast('$routeUpdate', lastRoute);
	      } else if (nextRoute || lastRoute) {
	        forceReload = false;
	        $route.current = nextRoute;
	
	        var nextRoutePromise = $q.resolve(nextRoute);
	
	        $browser.$$incOutstandingRequestCount('$route');
	
	        nextRoutePromise.
	          then(getRedirectionData).
	          then(handlePossibleRedirection).
	          then(function(keepProcessingRoute) {
	            return keepProcessingRoute && nextRoutePromise.
	              then(resolveLocals).
	              then(function(locals) {
	                // after route change
	                if (nextRoute === $route.current) {
	                  if (nextRoute) {
	                    nextRoute.locals = locals;
	                    angular.copy(nextRoute.params, $routeParams);
	                  }
	                  $rootScope.$broadcast('$routeChangeSuccess', nextRoute, lastRoute);
	                }
	              });
	          }).catch(function(error) {
	            if (nextRoute === $route.current) {
	              $rootScope.$broadcast('$routeChangeError', nextRoute, lastRoute, error);
	            }
	          }).finally(function() {
	            // Because `commitRoute()` is called from a `$rootScope.$evalAsync` block (see
	            // `$locationWatch`), this `$$completeOutstandingRequest()` call will not cause
	            // `outstandingRequestCount` to hit zero.  This is important in case we are redirecting
	            // to a new route which also requires some asynchronous work.
	
	            $browser.$$completeOutstandingRequest(noop, '$route');
	          });
	      }
	    }
	
	    function getRedirectionData(route) {
	      var data = {
	        route: route,
	        hasRedirection: false
	      };
	
	      if (route) {
	        if (route.redirectTo) {
	          if (angular.isString(route.redirectTo)) {
	            data.path = interpolate(route.redirectTo, route.params);
	            data.search = route.params;
	            data.hasRedirection = true;
	          } else {
	            var oldPath = $location.path();
	            var oldSearch = $location.search();
	            var newUrl = route.redirectTo(route.pathParams, oldPath, oldSearch);
	
	            if (angular.isDefined(newUrl)) {
	              data.url = newUrl;
	              data.hasRedirection = true;
	            }
	          }
	        } else if (route.resolveRedirectTo) {
	          return $q.
	            resolve($injector.invoke(route.resolveRedirectTo)).
	            then(function(newUrl) {
	              if (angular.isDefined(newUrl)) {
	                data.url = newUrl;
	                data.hasRedirection = true;
	              }
	
	              return data;
	            });
	        }
	      }
	
	      return data;
	    }
	
	    function handlePossibleRedirection(data) {
	      var keepProcessingRoute = true;
	
	      if (data.route !== $route.current) {
	        keepProcessingRoute = false;
	      } else if (data.hasRedirection) {
	        var oldUrl = $location.url();
	        var newUrl = data.url;
	
	        if (newUrl) {
	          $location.
	            url(newUrl).
	            replace();
	        } else {
	          newUrl = $location.
	            path(data.path).
	            search(data.search).
	            replace().
	            url();
	        }
	
	        if (newUrl !== oldUrl) {
	          // Exit out and don't process current next value,
	          // wait for next location change from redirect
	          keepProcessingRoute = false;
	        }
	      }
	
	      return keepProcessingRoute;
	    }
	
	    function resolveLocals(route) {
	      if (route) {
	        var locals = angular.extend({}, route.resolve);
	        angular.forEach(locals, function(value, key) {
	          locals[key] = angular.isString(value) ?
	              $injector.get(value) :
	              $injector.invoke(value, null, null, key);
	        });
	        var template = getTemplateFor(route);
	        if (angular.isDefined(template)) {
	          locals['$template'] = template;
	        }
	        return $q.all(locals);
	      }
	    }
	
	    function getTemplateFor(route) {
	      var template, templateUrl;
	      if (angular.isDefined(template = route.template)) {
	        if (angular.isFunction(template)) {
	          template = template(route.params);
	        }
	      } else if (angular.isDefined(templateUrl = route.templateUrl)) {
	        if (angular.isFunction(templateUrl)) {
	          templateUrl = templateUrl(route.params);
	        }
	        if (angular.isDefined(templateUrl)) {
	          route.loadedTemplateUrl = $sce.valueOf(templateUrl);
	          template = $templateRequest(templateUrl);
	        }
	      }
	      return template;
	    }
	
	    /**
	     * @returns {Object} the current active route, by matching it against the URL
	     */
	    function parseRoute() {
	      // Match a route
	      var params, match;
	      angular.forEach(routes, function(route, path) {
	        if (!match && (params = switchRouteMatcher($location.path(), route))) {
	          match = inherit(route, {
	            params: angular.extend({}, $location.search(), params),
	            pathParams: params});
	          match.$$route = route;
	        }
	      });
	      // No route matched; fallback to "otherwise" route
	      return match || routes[null] && inherit(routes[null], {params: {}, pathParams:{}});
	    }
	
	    /**
	     * @param {Object} newRoute - The new route configuration (as returned by `parseRoute()`).
	     * @param {Object} oldRoute - The previous route configuration (as returned by `parseRoute()`).
	     * @returns {boolean} Whether this is an "update-only" navigation, i.e. the URL maps to the same
	     *                    route and it can be reused (based on the config and the type of change).
	     */
	    function isNavigationUpdateOnly(newRoute, oldRoute) {
	      // IF this is not a forced reload
	      return !forceReload
	          // AND both `newRoute`/`oldRoute` are defined
	          && newRoute && oldRoute
	          // AND they map to the same Route Definition Object
	          && (newRoute.$$route === oldRoute.$$route)
	          // AND `reloadOnUrl` is disabled
	          && (!newRoute.reloadOnUrl
	              // OR `reloadOnSearch` is disabled
	              || (!newRoute.reloadOnSearch
	                  // AND both routes have the same path params
	                  && angular.equals(newRoute.pathParams, oldRoute.pathParams)
	              )
	          );
	    }
	
	    /**
	     * @returns {string} interpolation of the redirect path with the parameters
	     */
	    function interpolate(string, params) {
	      var result = [];
	      angular.forEach((string || '').split(':'), function(segment, i) {
	        if (i === 0) {
	          result.push(segment);
	        } else {
	          var segmentMatch = segment.match(/(\w+)(?:[?*])?(.*)/);
	          var key = segmentMatch[1];
	          result.push(params[key]);
	          result.push(segmentMatch[2] || '');
	          delete params[key];
	        }
	      });
	      return result.join('');
	    }
	  }];
	}
	
	instantiateRoute.$inject = ['$injector'];
	function instantiateRoute($injector) {
	  if (isEagerInstantiationEnabled) {
	    // Instantiate `$route`
	    $injector.get('$route');
	  }
	}
	
	ngRouteModule.provider('$routeParams', $RouteParamsProvider);
	
	
	/**
	 * @ngdoc service
	 * @name $routeParams
	 * @requires $route
	 * @this
	 *
	 * @description
	 * The `$routeParams` service allows you to retrieve the current set of route parameters.
	 *
	 * Requires the {@link ngRoute `ngRoute`} module to be installed.
	 *
	 * The route parameters are a combination of {@link ng.$location `$location`}'s
	 * {@link ng.$location#search `search()`} and {@link ng.$location#path `path()`}.
	 * The `path` parameters are extracted when the {@link ngRoute.$route `$route`} path is matched.
	 *
	 * In case of parameter name collision, `path` params take precedence over `search` params.
	 *
	 * The service guarantees that the identity of the `$routeParams` object will remain unchanged
	 * (but its properties will likely change) even when a route change occurs.
	 *
	 * Note that the `$routeParams` are only updated *after* a route change completes successfully.
	 * This means that you cannot rely on `$routeParams` being correct in route resolve functions.
	 * Instead you can use `$route.current.params` to access the new route's parameters.
	 *
	 * @example
	 * ```js
	 *  // Given:
	 *  // URL: http://server.com/index.html#/Chapter/1/Section/2?search=moby
	 *  // Route: /Chapter/:chapterId/Section/:sectionId
	 *  //
	 *  // Then
	 *  $routeParams ==> {chapterId:'1', sectionId:'2', search:'moby'}
	 * ```
	 */
	function $RouteParamsProvider() {
	  this.$get = function() { return {}; };
	}
	
	ngRouteModule.directive('ngView', ngViewFactory);
	ngRouteModule.directive('ngView', ngViewFillContentFactory);
	
	
	/**
	 * @ngdoc directive
	 * @name ngView
	 * @restrict ECA
	 *
	 * @description
	 * `ngView` is a directive that complements the {@link ngRoute.$route $route} service by
	 * including the rendered template of the current route into the main layout (`index.html`) file.
	 * Every time the current route changes, the included view changes with it according to the
	 * configuration of the `$route` service.
	 *
	 * Requires the {@link ngRoute `ngRoute`} module to be installed.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM |
	 * | {@link ng.$animate#leave leave}  | when the old element is removed from to the DOM  |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 *
	 * @param {string=} autoscroll Whether `ngView` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the view is updated.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the `autoscroll` attribute value evaluated
	 *                    as an expression yields a truthy value.
	 * @example
	    <example name="ngView-directive" module="ngViewExample"
	             deps="angular-route.js;angular-animate.js"
	             animations="true" fixBase="true">
	      <file name="index.html">
	        <div ng-controller="MainCtrl as main">
	          Choose:
	          <a href="Book/Moby">Moby</a> |
	          <a href="Book/Moby/ch/1">Moby: Ch1</a> |
	          <a href="Book/Gatsby">Gatsby</a> |
	          <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
	          <a href="Book/Scarlet">Scarlet Letter</a><br/>
	
	          <div class="view-animate-container">
	            <div ng-view class="view-animate"></div>
	          </div>
	          <hr />
	
	          <pre>$location.path() = {{main.$location.path()}}</pre>
	          <pre>$route.current.templateUrl = {{main.$route.current.templateUrl}}</pre>
	          <pre>$route.current.params = {{main.$route.current.params}}</pre>
	          <pre>$routeParams = {{main.$routeParams}}</pre>
	        </div>
	      </file>
	
	      <file name="book.html">
	        <div>
	          controller: {{book.name}}<br />
	          Book Id: {{book.params.bookId}}<br />
	        </div>
	      </file>
	
	      <file name="chapter.html">
	        <div>
	          controller: {{chapter.name}}<br />
	          Book Id: {{chapter.params.bookId}}<br />
	          Chapter Id: {{chapter.params.chapterId}}
	        </div>
	      </file>
	
	      <file name="animations.css">
	        .view-animate-container {
	          position:relative;
	          height:100px!important;
	          background:white;
	          border:1px solid black;
	          height:40px;
	          overflow:hidden;
	        }
	
	        .view-animate {
	          padding:10px;
	        }
	
	        .view-animate.ng-enter, .view-animate.ng-leave {
	          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 1.5s;
	
	          display:block;
	          width:100%;
	          border-left:1px solid black;
	
	          position:absolute;
	          top:0;
	          left:0;
	          right:0;
	          bottom:0;
	          padding:10px;
	        }
	
	        .view-animate.ng-enter {
	          left:100%;
	        }
	        .view-animate.ng-enter.ng-enter-active {
	          left:0;
	        }
	        .view-animate.ng-leave.ng-leave-active {
	          left:-100%;
	        }
	      </file>
	
	      <file name="script.js">
	        angular.module('ngViewExample', ['ngRoute', 'ngAnimate'])
	          .config(['$routeProvider', '$locationProvider',
	            function($routeProvider, $locationProvider) {
	              $routeProvider
	                .when('/Book/:bookId', {
	                  templateUrl: 'book.html',
	                  controller: 'BookCtrl',
	                  controllerAs: 'book'
	                })
	                .when('/Book/:bookId/ch/:chapterId', {
	                  templateUrl: 'chapter.html',
	                  controller: 'ChapterCtrl',
	                  controllerAs: 'chapter'
	                });
	
	              $locationProvider.html5Mode(true);
	          }])
	          .controller('MainCtrl', ['$route', '$routeParams', '$location',
	            function MainCtrl($route, $routeParams, $location) {
	              this.$route = $route;
	              this.$location = $location;
	              this.$routeParams = $routeParams;
	          }])
	          .controller('BookCtrl', ['$routeParams', function BookCtrl($routeParams) {
	            this.name = 'BookCtrl';
	            this.params = $routeParams;
	          }])
	          .controller('ChapterCtrl', ['$routeParams', function ChapterCtrl($routeParams) {
	            this.name = 'ChapterCtrl';
	            this.params = $routeParams;
	          }]);
	
	      </file>
	
	      <file name="protractor.js" type="protractor">
	        it('should load and compile correct template', function() {
	          element(by.linkText('Moby: Ch1')).click();
	          var content = element(by.css('[ng-view]')).getText();
	          expect(content).toMatch(/controller: ChapterCtrl/);
	          expect(content).toMatch(/Book Id: Moby/);
	          expect(content).toMatch(/Chapter Id: 1/);
	
	          element(by.partialLinkText('Scarlet')).click();
	
	          content = element(by.css('[ng-view]')).getText();
	          expect(content).toMatch(/controller: BookCtrl/);
	          expect(content).toMatch(/Book Id: Scarlet/);
	        });
	      </file>
	    </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngView#$viewContentLoaded
	 * @eventType emit on the current ngView scope
	 * @description
	 * Emitted every time the ngView content is reloaded.
	 */
	ngViewFactory.$inject = ['$route', '$anchorScroll', '$animate'];
	function ngViewFactory($route, $anchorScroll, $animate) {
	  return {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    link: function(scope, $element, attr, ctrl, $transclude) {
	        var currentScope,
	            currentElement,
	            previousLeaveAnimation,
	            autoScrollExp = attr.autoscroll,
	            onloadExp = attr.onload || '';
	
	        scope.$on('$routeChangeSuccess', update);
	        update();
	
	        function cleanupLastView() {
	          if (previousLeaveAnimation) {
	            $animate.cancel(previousLeaveAnimation);
	            previousLeaveAnimation = null;
	          }
	
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            previousLeaveAnimation = $animate.leave(currentElement);
	            previousLeaveAnimation.done(function(response) {
	              if (response !== false) previousLeaveAnimation = null;
	            });
	            currentElement = null;
	          }
	        }
	
	        function update() {
	          var locals = $route.current && $route.current.locals,
	              template = locals && locals.$template;
	
	          if (angular.isDefined(template)) {
	            var newScope = scope.$new();
	            var current = $route.current;
	
	            // Note: This will also link all children of ng-view that were contained in the original
	            // html. If that content contains controllers, ... they could pollute/change the scope.
	            // However, using ng-view on an element with additional content does not make sense...
	            // Note: We can't remove them in the cloneAttchFn of $transclude as that
	            // function is called before linking the content, which would apply child
	            // directives to non existing elements.
	            var clone = $transclude(newScope, function(clone) {
	              $animate.enter(clone, null, currentElement || $element).done(function onNgViewEnter(response) {
	                if (response !== false && angular.isDefined(autoScrollExp)
	                  && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                  $anchorScroll();
	                }
	              });
	              cleanupLastView();
	            });
	
	            currentElement = clone;
	            currentScope = current.scope = newScope;
	            currentScope.$emit('$viewContentLoaded');
	            currentScope.$eval(onloadExp);
	          } else {
	            cleanupLastView();
	          }
	        }
	    }
	  };
	}
	
	// This directive is called during the $transclude call of the first `ngView` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngView
	// is called.
	ngViewFillContentFactory.$inject = ['$compile', '$controller', '$route'];
	function ngViewFillContentFactory($compile, $controller, $route) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    link: function(scope, $element) {
	      var current = $route.current,
	          locals = current.locals;
	
	      $element.html(locals.$template);
	
	      var link = $compile($element.contents());
	
	      if (current.controller) {
	        locals.$scope = scope;
	        var controller = $controller(current.controller, locals);
	        if (current.controllerAs) {
	          scope[current.controllerAs] = controller;
	        }
	        $element.data('$ngControllerController', controller);
	        $element.children().data('$ngControllerController', controller);
	      }
	      scope[current.resolveAs || '$resolve'] = locals;
	
	      link(scope);
	    }
	  };
	}
	
	
	})(window, window.angular);
	


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(34);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var angular = __webpack_require__(28);
	
	/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 * See {@link ngCookies.$cookies `$cookies`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  info({ angularVersion: '1.8.3' }).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	   provider('$cookies', [/** @this */function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For security reasons the user agent will not accept the cookie
	     *   if the current domain is not a sub-domain of this domain or equal to it.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
	     *   secured connection.
	     * - **samesite** - `{string}` - prevents the browser from sending the cookie along with cross-site requests.
	     *   Accepts the values `lax` and `strict`. See the [OWASP Wiki](https://www.owasp.org/index.php/SameSite)
	     *   for more info. Note that as of May 2018, not all browsers support `SameSite`,
	     *   so it cannot be used as a single measure against Cross-Site-Request-Forgery (CSRF) attacks.
	     *
	     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
	     * This is important so that cookies will be visible for all routes when html5mode is enabled.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesProviderExample', ['ngCookies'])
	     *   .config(['$cookiesProvider', function($cookiesProvider) {
	     *     // Setting default options
	     *     $cookiesProvider.defaults.domain = 'foo.com';
	     *     $cookiesProvider.defaults.secure = true;
	     *   }]);
	     * ```
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until AngularJS 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	/**
	 * @name $$cookieWriter
	 * @requires $document
	 *
	 * @description
	 * This is a private service for writing cookies
	 *
	 * @param {string} name Cookie name
	 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	 * @param {Object=} options Object with options that need to be stored for the cookie.
	 */
	function $$CookieWriter($document, $log, $browser) {
	  var cookiePath = $browser.baseHref();
	  var rawDocument = $document[0];
	
	  function buildCookieString(name, value, options) {
	    var path, expires;
	    options = options || {};
	    expires = options.expires;
	    path = angular.isDefined(options.path) ? options.path : cookiePath;
	    if (angular.isUndefined(value)) {
	      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	      value = '';
	    }
	    if (angular.isString(expires)) {
	      expires = new Date(expires);
	    }
	
	    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    str += path ? ';path=' + path : '';
	    str += options.domain ? ';domain=' + options.domain : '';
	    str += expires ? ';expires=' + expires.toUTCString() : '';
	    str += options.secure ? ';secure' : '';
	    str += options.samesite ? ';samesite=' + options.samesite : '';
	
	    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	    // - 300 cookies
	    // - 20 cookies per unique domain
	    // - 4096 bytes per cookie
	    var cookieLength = str.length + 1;
	    if (cookieLength > 4096) {
	      $log.warn('Cookie \'' + name +
	        '\' possibly not set or overflowed because it was too large (' +
	        cookieLength + ' > 4096 bytes)!');
	    }
	
	    return str;
	  }
	
	  return function(name, value, options) {
	    rawDocument.cookie = buildCookieString(name, value, options);
	  };
	}
	
	$$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	angular.module('ngCookies').provider('$$cookieWriter', /** @this */ function $$CookieWriterProvider() {
	  this.$get = $$CookieWriter;
	});
	
	
	})(window, window.angular);
	


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(36);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {(function($) {
	  // @todo Document this.
	  $.extend($,{ placeholder: {
	      browser_supported: function() {
	        return this._supported !== undefined ?
	          this._supported :
	          ( this._supported = !!('placeholder' in $('<input type="text">')[0]) );
	      },
	      shim: function(opts) {
	        var config = {
	          color: '#888',
	          cls: 'placeholder',
	          selector: 'input[placeholder], textarea[placeholder]'
	        };
	        $.extend(config,opts);
	        return !this.browser_supported() && $(config.selector)._placeholder_shim(config);
	      }
	  }});
	
	  $.extend($.fn,{
	    _placeholder_shim: function(config) {
	      function calcPositionCss(target)
	      {
	        var op = $(target).offsetParent().offset();
	        var ot = $(target).offset();
	
	        return {
	          top: ot.top - op.top,
	          left: ot.left - op.left,
	          width: $(target).width()
	        };
	      }
	      function adjustToResizing(label) {
	      	var $target = label.data('target');
	      	if(typeof $target !== "undefined") {
	          label.css(calcPositionCss($target));
	          $(window).one("resize", function () { adjustToResizing(label); });
	        }
	      }
	      return this.each(function() {
	        var $this = $(this);
	
	        if( $this.is(':visible') ) {
	
	          if( $this.data('placeholder') ) {
	            var $ol = $this.data('placeholder');
	            $ol.css(calcPositionCss($this));
	            return true;
	          }
	
	          var possible_line_height = {};
	          if( !$this.is('textarea') && $this.css('height') != 'auto') {
	            possible_line_height = { lineHeight: $this.css('height'), whiteSpace: 'nowrap' };
	          }
	
	          var isBorderBox = ($this.css('box-sizing') === 'border-box');
	          var isTextarea = $this.is('textarea');
	
	          var ol = $('<label />')
	            .text($this.attr('placeholder'))
	            .addClass(config.cls)
	            .css($.extend({
	              position:'absolute',
	              display: 'inline',
	              'float':'none',
	              overflow:'hidden',
	              textAlign: 'left',
	              color: config.color,
	              cursor: 'text',
	              paddingTop: !isTextarea && isBorderBox ? '0' : $this.css('padding-top'),
	              paddingRight: $this.css('padding-right'),
	              paddingBottom: !isTextarea && isBorderBox ? '0' : $this.css('padding-bottom'),
	              paddingLeft: $this.css('padding-left'),
	              fontSize: $this.css('font-size'),
	              fontFamily: $this.css('font-family'),
	              fontStyle: $this.css('font-style'),
	              fontWeight: $this.css('font-weight'),
	              textTransform: $this.css('text-transform'),
	              backgroundColor: 'transparent',
	              zIndex: 99
	            }, possible_line_height))
	            .css(calcPositionCss(this))
	            .attr('for', this.id)
	            .data('target',$this)
	            .click(function(){
	                if (!$(this).data('target').is(':disabled')) {
	                    $(this).data('target').focus();
	                }
	            })
	            .insertBefore(this);
	            $this
	                .data('placeholder', ol)
	                .on('keydown', function () {
	                    ol.hide();
	                })
	                .on('blur change', function () {
	                    ol[$this.val().length ? 'hide' : 'show']();
	                })
	                .triggerHandler('blur');
	          $(window).one("resize", function () { adjustToResizing(ol); });
	        }
	      });
	    }
	  });
	})(jQuery);
	
	jQuery(document).add(window).bind('ready load', function() {
	  if (jQuery.placeholder) {
	    jQuery.placeholder.shim();
	  }
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(38);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*** IMPORTS FROM imports-loader ***/
	var angular = __webpack_require__(28);
	
	/* angular-placeholder-shim version 0.3.1
	 * License: MIT.
	 * Copyright (C) 2013, Uri Shaked.
	 */
	
	'use strict';
	
	angular.module('placeholderShim', [])
		.directive('placeholder', ['$interpolate', '$timeout', function ($interpolate, $timeout) {
			if (jQuery.placeholder.browser_supported()) {
				return {};
			}
	
			return function (scope, element) {
				var config = {
					color: '#888',
					cls: 'placeholder'
				};
	
				var interpolatedPlaceholder = $interpolate(element.attr('placeholder'));
				var placeholderText = null;
	
				var overlay = null;
				var pendingTimer = null;
	
				function addPlaceholder() {
					pendingTimer = $timeout(function () {
						element._placeholder_shim(config);
						overlay = element.data('placeholder');
						pendingTimer = null;
					});
				}
	
				if (element.is(':visible')) {
					addPlaceholder();
				}
	
				// The following code accounts for value changes from within the code
				// and for dynamic changes in placeholder text
				scope.$watch(function () {
					if (!overlay && element.is(':visible') && !pendingTimer) {
						addPlaceholder();
					}
					if (overlay && (element.get(0) !== document.activeElement)) {
						if (element.val().length) {
							overlay.hide();
						} else {
							overlay.show();
						}
					}
					if (overlay) {
						var newText = interpolatedPlaceholder(scope);
						if (newText !== placeholderText) {
							placeholderText = newText;
							overlay.text(placeholderText);
						}
					}
				});
	
				scope.$on('$destroy', function() {
					if (pendingTimer) {
						$timeout.cancel(pendingTimer);
						pendingTimer = null;
					}
				});
			};
		}]);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var modules;
	
	__webpack_require__(40);
	
	__webpack_require__(47);
	
	__webpack_require__(50);
	
	modules = ['angulartics', 'angulartics.google.analytics', 'angulartics.mixpanel'];
	
	angular.module('gnp-analyze-access', modules);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(41);
	module.exports = __webpack_require__(42);
	module.exports = __webpack_require__(43);
	module.exports = __webpack_require__(44);
	module.exports = __webpack_require__(45);
	module.exports = __webpack_require__(46);
	module.exports = __webpack_require__(47);
	module.exports = __webpack_require__(48);
	module.exports = __webpack_require__(49);
	module.exports = __webpack_require__(50);
	module.exports = __webpack_require__(51);
	module.exports = __webpack_require__(52);
	module.exports = __webpack_require__(53);
	module.exports = __webpack_require__(54);
	module.exports = __webpack_require__(55);
	module.exports = __webpack_require__(56);
	module.exports = __webpack_require__(57);

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * License: MIT
	 */
	(function(angular, analytics) {
	'use strict';
	
	var angulartics = window.angulartics || (window.angulartics = {});
	angulartics.waitForVendorCount = 0;
	angulartics.waitForVendorApi = function (objectName, delay, containsField, registerFn, onTimeout) {
	  if (!onTimeout) { angulartics.waitForVendorCount++; }
	  if (!registerFn) { registerFn = containsField; containsField = undefined; }
	  if (!Object.prototype.hasOwnProperty.call(window, objectName) || (containsField !== undefined && window[objectName][containsField] === undefined)) {
	    setTimeout(function () { angulartics.waitForVendorApi(objectName, delay, containsField, registerFn, true); }, delay);
	  }
	  else {
	    angulartics.waitForVendorCount--;
	    registerFn(window[objectName]);
	  }
	};
	
	/**
	 * @ngdoc overview
	 * @name angulartics
	 */
	angular.module('angulartics', [])
	.provider('$analytics', function () {
	  var settings = {
	    pageTracking: {
	      autoTrackFirstPage: true,
	      autoTrackVirtualPages: true,
	      trackRelativePath: false,
	      autoBasePath: false,
	      basePath: ''
	    },
	    eventTracking: {},
	    bufferFlushDelay: 1000, // Support only one configuration for buffer flush delay to simplify buffering
	    developerMode: false // Prevent sending data in local/development environment
	  };
	
	  // List of known handlers that plugins can register themselves for
	  var knownHandlers = [
	    'pageTrack',
	    'eventTrack',
	    'setAlias',
	    'setUsername',
	    'setAlias',
	    'setUserProperties',
	    'setUserPropertiesOnce',
	    'setSuperProperties',
	    'setSuperPropertiesOnce'
	  ];
	  // Cache and handler properties will match values in 'knownHandlers' as the buffering functons are installed.
	  var cache = {};
	  var handlers = {};
	
	  // General buffering handler
	  var bufferedHandler = function(handlerName){
	    return function(){
	      if(angulartics.waitForVendorCount){
	        if(!cache[handlerName]){ cache[handlerName] = []; }
	        cache[handlerName].push(arguments);
	      }
	    };
	  };
	
	  // As handlers are installed by plugins, they get pushed into a list and invoked in order.
	  var updateHandlers = function(handlerName, fn){
	    if(!handlers[handlerName]){
	      handlers[handlerName] = [];
	    }
	    handlers[handlerName].push(fn);
	    return function(){
	      var handlerArgs = arguments;
	      angular.forEach(handlers[handlerName], function(handler){
	        handler.apply(this, handlerArgs);
	      }, this);
	    };
	  };
	
	  // The api (returned by this provider) gets populated with handlers below.
	  var api = {
	    settings: settings
	  };
	
	  // Will run setTimeout if delay is > 0
	  // Runs immediately if no delay to make sure cache/buffer is flushed before anything else.
	  // Plugins should take care to register handlers by order of precedence.
	  var onTimeout = function(fn, delay){
	    if(delay){
	      setTimeout(fn, delay);
	    } else {
	      fn();
	    }
	  };
	
	  var provider = {
	    $get: function() { return api; },
	    api: api,
	    settings: settings,
	    virtualPageviews: function (value) { this.settings.pageTracking.autoTrackVirtualPages = value; },
	    firstPageview: function (value) { this.settings.pageTracking.autoTrackFirstPage = value; },
	    withBase: function (value) { this.settings.pageTracking.basePath = (value) ? angular.element('base').attr('href').slice(0, -1) : ''; },
	    withAutoBase: function (value) { this.settings.pageTracking.autoBasePath = value; },
	    developerMode: function(value) { this.settings.developerMode = value; }
	  };
	
	  // General function to register plugin handlers. Flushes buffers immediately upon registration according to the specified delay.
	  var register = function(handlerName, fn){
	    api[handlerName] = updateHandlers(handlerName, fn);
	    var handlerSettings = settings[handlerName];
	    var handlerDelay = (handlerSettings) ? handlerSettings.bufferFlushDelay : null;
	    var delay = (handlerDelay !== null) ? handlerDelay : settings.bufferFlushDelay;
	    angular.forEach(cache[handlerName], function (args, index) {
	      onTimeout(function () { fn.apply(this, args); }, index * delay);
	    });
	  };
	
	  var capitalize = function (input) {
	      return input.replace(/^./, function (match) {
	          return match.toUpperCase();
	      });
	  };
	
	  // Adds to the provider a 'register#{handlerName}' function that manages multiple plugins and buffer flushing.
	  var installHandlerRegisterFunction = function(handlerName){
	    var registerName = 'register'+capitalize(handlerName);
	    provider[registerName] = function(fn){
	      register(handlerName, fn);
	    };
	    api[handlerName] = updateHandlers(handlerName, bufferedHandler(handlerName));
	  };
	
	  // Set up register functions for each known handler
	  angular.forEach(knownHandlers, installHandlerRegisterFunction);
	  return provider;
	})
	
	.run(['$rootScope', '$window', '$analytics', '$injector', function ($rootScope, $window, $analytics, $injector) {
	  if ($analytics.settings.pageTracking.autoTrackFirstPage) {
	    $injector.invoke(['$location', function ($location) {
	      /* Only track the 'first page' if there are no routes or states on the page */
	      var noRoutesOrStates = true;
	      if ($injector.has('$route')) {
	         var $route = $injector.get('$route');
	         for (var route in $route.routes) {
	           noRoutesOrStates = false;
	           break;
	         }
	      } else if ($injector.has('$state')) {
	        var $state = $injector.get('$state');
	        for (var state in $state.get()) {
	          noRoutesOrStates = false;
	          break;
	        }
	      }
	      if (noRoutesOrStates) {
	        if ($analytics.settings.pageTracking.autoBasePath) {
	          $analytics.settings.pageTracking.basePath = $window.location.pathname;
	        }
	        if ($analytics.settings.trackRelativePath) {
	          var url = $analytics.settings.pageTracking.basePath + $location.url();
	          $analytics.pageTrack(url, $location);
	        } else {
	          $analytics.pageTrack($location.absUrl(), $location);
	        }
	      }
	    }]);
	  }
	
	  if ($analytics.settings.pageTracking.autoTrackVirtualPages) {
	    $injector.invoke(['$location', function ($location) {
	      if ($analytics.settings.pageTracking.autoBasePath) {
	        /* Add the full route to the base. */
	        $analytics.settings.pageTracking.basePath = $window.location.pathname + "#";
	      }
	      if ($injector.has('$route')) {
	        $rootScope.$on('$routeChangeSuccess', function (event, current) {
	          if (current && (current.$$route||current).redirectTo) return;
	          var url = $analytics.settings.pageTracking.basePath + $location.url();
	          $analytics.pageTrack(url, $location);
	        });
	      }
	      if ($injector.has('$state')) {
	        $rootScope.$on('$stateChangeSuccess', function (event, current) {
	          var url = $analytics.settings.pageTracking.basePath + $location.url();
	          $analytics.pageTrack(url, $location);
	        });
	      }
	    }]);
	  }
	  if ($analytics.settings.developerMode) {
	    angular.forEach($analytics, function(attr, name) {
	      if (typeof attr === 'function') {
	        $analytics[name] = function(){};
	      }
	    });
	  }
	}])
	
	.directive('analyticsOn', ['$analytics', function ($analytics) {
	  function isCommand(element) {
	    return ['a:','button:','button:button','button:submit','input:button','input:submit'].indexOf(
	      element.tagName.toLowerCase()+':'+(element.type||'')) >= 0;
	  }
	
	  function inferEventType(element) {
	    if (isCommand(element)) return 'click';
	    return 'click';
	  }
	
	  function inferEventName(element) {
	    if (isCommand(element)) return element.innerText || element.value;
	    return element.id || element.name || element.tagName;
	  }
	
	  function isProperty(name) {
	    return name.substr(0, 9) === 'analytics' && ['On', 'Event', 'If', 'Properties', 'EventType'].indexOf(name.substr(9)) === -1;
	  }
	
	  function propertyName(name) {
	    var s = name.slice(9); // slice off the 'analytics' prefix
	    if (typeof s !== 'undefined' && s!==null && s.length > 0) {
	      return s.substring(0, 1).toLowerCase() + s.substring(1);
	    }
	    else {
	      return s;
	    }
	  }
	
	  return {
	    restrict: 'A',
	    link: function ($scope, $element, $attrs) {
	      var eventType = $attrs.analyticsOn || inferEventType($element[0]);
	      var trackingData = {};
	
	      angular.forEach($attrs.$attr, function(attr, name) {
	        if (isProperty(name)) {
	          trackingData[propertyName(name)] = $attrs[name];
	          $attrs.$observe(name, function(value){
	            trackingData[propertyName(name)] = value;
	          });
	        }
	      });
	
	      angular.element($element[0]).bind(eventType, function ($event) {
	        var eventName = $attrs.analyticsEvent || inferEventName($element[0]);
	        trackingData.eventType = $event.type;
	
	        if($attrs.analyticsIf){
	          if(! $scope.$eval($attrs.analyticsIf)){
	            return; // Cancel this event if we don't pass the analytics-if condition
	          }
	        }
	        // Allow components to pass through an expression that gets merged on to the event properties
	        // eg. analytics-properites='myComponentScope.someConfigExpression.$analyticsProperties'
	        if($attrs.analyticsProperties){
	          angular.extend(trackingData, $scope.$eval($attrs.analyticsProperties));
	        }
	        $analytics.eventTrack(eventName, trackingData);
	      });
	    }
	  };
	}]);
	})(angular);


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2014 Luis Farzati http://luisfarzati.github.io/angulartics
	 * Adobe analytics(Omniture) update contributed by http://github.com/ajayk
	 * License: MIT
	 */
	(function(angular) {
	'use strict';
	
	/**
	 * @ngdoc overview
	 * @name angulartics.adobe.analytics
	 * Enables analytics support for Adobe Analytics (http://adobe.com/analytics)
	 */
	angular.module('angulartics.adobe.analytics', ['angulartics'])
	.config(['$analyticsProvider', function ($analyticsProvider) {
	
	  $analyticsProvider.settings.trackRelativePath = true;
	
	  $analyticsProvider.registerPageTrack(function (path) {
	    if (window.s) s.t([path]);
	  });
	
	  /**
	   * Track Event in Adobe Analytics
	   * @name eventTrack
	   *
	   * @param {string} action Required 'action' (string) associated with the event
	   *
	   *
	   */
	  $analyticsProvider.registerEventTrack(function (action) {
	    if (window.s) {
	      if(action) {
	        if(action.toUpperCase() === "DOWNLOAD")
	          s.tl(this,'d',action);
	        else if(action.toUpperCase() === "EXIT")
	          s.tl(this,'e',action);
	        else
	          s.tl(this,'o',action);
	      }
	    }
	  });
	
	}]);
	})(angular);


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * Contributed by http://github.com/chechoacosta
	 * License: MIT
	 */
	(function(angular) {
	'use strict';
	
	/**
	 * @ngdoc overview
	 * @name angulartics.chartbeat
	 * Enables analytics support for Chartbeat (http://chartbeat.com)
	 */
	angular.module('angulartics.chartbeat', ['angulartics'])
	.config(['$analyticsProvider', function ($analyticsProvider) {
	
	  angulartics.waitForVendorApi('pSUPERFLY', 500, function (pSUPERFLY) {
	    $analyticsProvider.registerPageTrack(function (path) {
	      pSUPERFLY.virtualPage(path);
	    });
	  });
	
	  $analyticsProvider.registerEventTrack(function () {
	    console.warn('Chartbeat doesn\'t support event tracking -- silently ignored.');
	  });
	
	}]);
	})(angular);


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	(function(angular) {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name angulartics.cnzz
	   * Enables analytics support for CNZZ (http://www.cnzz.com)
	   */
	  angular.module('angulartics.cnzz', ['angulartics'])
	    .config(['$analyticsProvider', function ($analyticsProvider) {
	      window._czc = _czc || [];
	      _czc.push(['_setAutoPageview', false]);
	
	      $analyticsProvider.registerPageTrack(function (path) {
	        _czc.push(['_trackPageview', path]);
	      });
	
	      $analyticsProvider.registerEventTrack(function (action, prop) {
	        _czc.push([
	          '_trackEvent',
	          prop.category,
	          action,
	          prop.label,
	          prop.value,
	          prop.nodeid
	        ]);
	      });
	    }]);
	})(angular);


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * Contributed by http://github.com/samanbarghi
	 * License: MIT
	 */
	
	(function(angular) {
	'use strict';
	
	/**
	 * @ngdoc overview
	 * @name angulartics.flurry
	 * Enables analytics support for flurry (http://flurry.com)
	 */
	angular.module('angulartics.flurry', ['angulartics'])
	.config(['$analyticsProvider', function ($analyticsProvider) {
	
	
	  $analyticsProvider.registerPageTrack(function (path) {
	    //No separate track page functionality
	  });
	
	  $analyticsProvider.registerEventTrack(function (action, properties) {
	    FlurryAgent.logEvent(action, properties);
	  });
	
	}]);
	})(angular);


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * License: MIT
	 */
	(function(angular) {
	'use strict';
	
	/**
	 * @ngdoc overview
	 * @name angulartics.google.analytics
	 * Enables analytics support for Google Analytics (http://google.com/analytics)
	 */
	angular.module('angulartics.google.analytics.cordova', ['angulartics'])
	
	.provider('googleAnalyticsCordova', function () {
	  var GoogleAnalyticsCordova = [
	  '$q', '$log', 'ready', 'debug', 'trackingId', 'period',
	  function ($q, $log, ready, debug, trackingId, period) {
	    var deferred = $q.defer();
	    var deviceReady = false;
	
	    window.addEventListener('deviceReady', function () {
	      deviceReady = true;
	      deferred.resolve();
	    });
	
	    setTimeout(function () {
	      if (!deviceReady) {
	        deferred.resolve();
	      }
	    }, 3000);
	
	    function success() {
	      if (debug) {
	        $log.info(arguments);
	      }
	    }
	
	    function failure(err) {
	      if (debug) {
	        $log.error(err);
	      }
	    }
	
	    this.init = function () {
	      return deferred.promise.then(function () {
	        var analytics = window.plugins && window.plugins.gaPlugin;
	        if (analytics) {
	          analytics.init(function onInit() {
	            ready(analytics, success, failure);
	          }, failure, trackingId, period || 10);
	        } else if (debug) {
	          $log.error('Google Analytics for Cordova is not available');
	        }
	      });
	    };
	  }];
	
	  return {
	    $get: ['$injector', function ($injector) {
	      return $injector.instantiate(GoogleAnalyticsCordova, {
	        ready: this._ready || angular.noop,
	        debug: this.debug,
	        trackingId: this.trackingId,
	        period: this.period
	      });
	    }],
	    ready: function (fn) {
	      this._ready = fn;
	    }
	  };
	})
	
	.config(['$analyticsProvider', 'googleAnalyticsCordovaProvider', function ($analyticsProvider, googleAnalyticsCordovaProvider) {
	  googleAnalyticsCordovaProvider.ready(function (analytics, success, failure) {
	    $analyticsProvider.registerPageTrack(function (path) {
	      analytics.trackPage(success, failure, path);
	    });
	
	    $analyticsProvider.registerEventTrack(function (action, properties) {
	      analytics.trackEvent(success, failure, properties.category, action, properties.label, properties.value);
	    });
	  });
	}])
	
	.run(['googleAnalyticsCordova', function (googleAnalyticsCordova) {
	  googleAnalyticsCordova.init();
	}]);
	
	})(angular);


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * Universal Analytics update contributed by http://github.com/willmcclellan
	 * License: MIT
	 */
	(function(angular) {
	'use strict';
	
	/**
	 * @ngdoc overview
	 * @name angulartics.google.analytics
	 * Enables analytics support for Google Analytics (http://google.com/analytics)
	 */
	angular.module('angulartics.google.analytics', ['angulartics'])
	.config(['$analyticsProvider', function ($analyticsProvider) {
	
	  // GA already supports buffered invocations so we don't need
	  // to wrap these inside angulartics.waitForVendorApi
	
	  $analyticsProvider.settings.trackRelativePath = true;
	  
	  // Set the default settings for this module
	  $analyticsProvider.settings.ga = {
	    // array of additional account names (only works for analyticsjs)
	    additionalAccountNames: undefined
	  };
	
	  $analyticsProvider.registerPageTrack(function (path) {
	    if (window._gaq) _gaq.push(['_trackPageview', path]);
	    if (window.ga) {
	      ga('send', 'pageview', path);
	      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
	        ga(accountName +'.send', 'pageview', path);
	      });
	    }
	  });
	
	  /**
	   * Track Event in GA
	   * @name eventTrack
	   *
	   * @param {string} action Required 'action' (string) associated with the event
	   * @param {object} properties Comprised of the mandatory field 'category' (string) and optional  fields 'label' (string), 'value' (integer) and 'noninteraction' (boolean)
	   *
	   * @link https://developers.google.com/analytics/devguides/collection/gajs/eventTrackerGuide#SettingUpEventTracking
	   *
	   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/events
	   */
	  $analyticsProvider.registerEventTrack(function (action, properties) {
	
	    // do nothing if there is no category (it's required by GA)
	    if (!properties || !properties.category) { 
			return; 
		}
	    // GA requires that eventValue be an integer, see:
	    // https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#eventValue
	    // https://github.com/luisfarzati/angulartics/issues/81
	    if (properties.value) {
	      var parsed = parseInt(properties.value, 10);
	      properties.value = isNaN(parsed) ? 0 : parsed;
	    }
	
	    if (window.ga) {
	
	      var eventOptions = {
	        eventCategory: properties.category || null,
	        eventAction: action || null,
	        eventLabel: properties.label ||  null,
	        eventValue: properties.value || null,
	        nonInteraction: properties.noninteraction || null
	      };
	
	      // add custom dimensions and metrics
	      for(var idx = 1; idx<=20;idx++) {
	      if (properties['dimension' +idx.toString()]) {
	        eventOptions['dimension' +idx.toString()] = properties['dimension' +idx.toString()];
	      }
	      if (properties['metric' +idx.toString()]) {
	        eventOptions['metric' +idx.toString()] = properties['metric' +idx.toString()];
	        }
	      }
	      ga('send', 'event', eventOptions);
	      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
	        ga(accountName +'.send', 'event', eventOptions);
	      });
	    }
	
	    else if (window._gaq) {
	      _gaq.push(['_trackEvent', properties.category, action, properties.label, properties.value, properties.noninteraction]);
	    }
	
	  });
	
	}]);
	})(angular);


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * Google Tag Manager Plugin Contributed by http://github.com/danrowe49
	 * License: MIT
	 */
	
	(function(angular){
	'use strict';
	
	
	/**
	 * @ngdoc overview
	 * @name angulartics.google.analytics
	 * Enables analytics support for Google Tag Manager (http://google.com/tagmanager)
	 */
	
	angular.module('angulartics.google.tagmanager', ['angulartics'])
	.config(['$analyticsProvider', function($analyticsProvider){
	
		/**
		* Send content views to the dataLayer
		*
		* @param {string} path Required 'content name' (string) describes the content loaded
		*/
	
		$analyticsProvider.registerPageTrack(function(path){
			var dataLayer = window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				'event': 'content-view',
				'content-name': path
			});
		});
	
		/**
	   * Send interactions to the dataLayer, i.e. for event tracking in Google Analytics
	   * @name eventTrack
	   *
	   * @param {string} action Required 'action' (string) associated with the event
	   * @param {object} properties Comprised of the mandatory field 'category' (string) and optional  fields 'label' (string), 'value' (integer) and 'noninteraction' (boolean)
	   */
	
		$analyticsProvider.registerEventTrack(function(action, properties){
			var dataLayer = window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				'event': 'interaction',
				'target': properties.category,
				'action': action,
				'target-properties': properties.label,
				'value': properties.value,
				'interaction-type': properties.noninteraction
			});
	
		});
	}]);
	
	})(angular);


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * License: MIT
	 */
	(function(angular) {
	'use strict';
	
	/**
	 * @ngdoc overview
	 * @name angulartics.kissmetrics
	 * Enables analytics support for KISSmetrics (http://kissmetrics.com)
	 */
	angular.module('angulartics.kissmetrics', ['angulartics'])
	.config(['$analyticsProvider', function ($analyticsProvider) {
	
	  // KM already supports buffered invocations so we don't need
	  // to wrap these inside angulartics.waitForVendorApi
	
	  // Creates the _kqm array if it doesn't exist already
	  // Useful if you want to load angulartics before kissmetrics
	
	  if (typeof(_kmq) == "undefined") {
	    window._kmq = [];
	  } else {
	    window._kmq = _kmq;
	  }
	
	  $analyticsProvider.registerPageTrack(function (path) {
	    window._kmq.push(['record', 'Pageview', { 'Page': path }]);
	  });
	
	  $analyticsProvider.registerEventTrack(function (action, properties) {
	    window._kmq.push(['record', action, properties]);
	  });
	
	  $analyticsProvider.registerSetUsername(function (uuid) {
	    window._kmq.push(['identify', uuid]);
	  });
	
	  $analyticsProvider.registerSetUserProperties(function (properties) {
	    window._kmq.push(['set', properties]);
	  });
	
	}]);
	})(angular);


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * Contributed by http://github.com/L42y
	 * License: MIT
	 */
	(function(angular) {
	'use strict';
	
	/**
	 * @ngdoc overview
	 * @name angulartics.mixpanel
	 * Enables analytics support for Mixpanel (http://mixpanel.com)
	 */
	angular.module('angulartics.mixpanel', ['angulartics'])
	.config(['$analyticsProvider', function ($analyticsProvider) {
	
	  angulartics.waitForVendorApi('mixpanel', 500, '__loaded', function (mixpanel) {
	    $analyticsProvider.registerSetUsername(function (userId) {
	      mixpanel.identify(userId);
	    });
	  });
	  
	  angulartics.waitForVendorApi('mixpanel', 500, '__loaded', function (mixpanel) {
	    $analyticsProvider.registerSetAlias(function (userId) {
	      mixpanel.alias(userId);
	    });
	  });
	
	  angulartics.waitForVendorApi('mixpanel', 500, '__loaded', function (mixpanel) {
	    $analyticsProvider.registerSetSuperPropertiesOnce(function (properties) {
	      mixpanel.register_once(properties);
	    });
	  });
	
	  angulartics.waitForVendorApi('mixpanel', 500, '__loaded', function (mixpanel) {
	    $analyticsProvider.registerSetSuperProperties(function (properties) {
	      mixpanel.register(properties);
	    });
	  });
	
	  angulartics.waitForVendorApi('mixpanel', 500, '__loaded', function (mixpanel) {
	    $analyticsProvider.registerSetUserPropertiesOnce(function (properties) {
	      mixpanel.people.set_once(properties);
	    });
	  });
	
	  angulartics.waitForVendorApi('mixpanel', 500, '__loaded', function (mixpanel) {
	    $analyticsProvider.registerSetUserProperties(function (properties) {
	      mixpanel.people.set(properties);
	    });
	  });
	
	  angulartics.waitForVendorApi('mixpanel', 500, '__loaded', function (mixpanel) {
	    $analyticsProvider.registerPageTrack(function (path) {
	      mixpanel.track( "Page Viewed", { "page": path } );
	    });
	  });
	
	  angulartics.waitForVendorApi('mixpanel', 500, '__loaded', function (mixpanel) {
	    $analyticsProvider.registerEventTrack(function (action, properties) {
	      mixpanel.track(action, properties);
	    });
	  });
	
	}]);
	})(angular);


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * Piwik 2.1.x update contributed by http://github.com/highskillz
	 * License: MIT
	 */
	(function(angular) {
	    'use strict';
	
	    /**
	     * @ngdoc overview
	     * @name angulartics.piwik
	     * Enables analytics support for Piwik (http://piwik.org/docs/tracking-api/)
	     */
	    angular.module('angulartics.piwik', ['angulartics'])
	        .config(['$analyticsProvider',
	            function($analyticsProvider) {
	
	                // Piwik seems to suppors buffered invocations so we don't need
	                // to wrap these inside angulartics.waitForVendorApi
	
	                $analyticsProvider.settings.trackRelativePath = true;
	
	                $analyticsProvider.registerPageTrack(function(path) {
	                    if (window._paq) {
	                        _paq.push(['setCustomUrl', path]);
	                        _paq.push(['trackPageView']);
	                    }
	                });
	
	                $analyticsProvider.registerEventTrack(function(action, properties) {
	                    // PAQ requires that eventValue be an integer, see:
	                    // http://piwik.org/docs/event-tracking/
	                    if(properties.value) {
	                        var parsed = parseInt(properties.value, 10);
	                        properties.value = isNaN(parsed) ? 0 : parsed;
	                    }
	
	                    if (window._paq) {
	                        _paq.push(['trackEvent', properties.category, action, properties.label, properties.value]);
	                    }
	                });
	
	            }
	        ]);
	})(angular);


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * License: MIT
	 */
	(function (angular) {
	'use strict';
	
	/**
	 * @ngdoc overview
	 * @name angulartics.scroll
	 * Provides an implementation of jQuery Waypoints (http://imakewebthings.com/jquery-waypoints/)
	 * for use as a valid DOM event in analytics-on.
	 */
	angular.module('angulartics.scroll', ['angulartics'])
	.directive('analyticsOn', ['$analytics', function ($analytics) {
	  function isProperty(name) {
	    return name.substr(0, 8) === 'scrollby';
	  }
	  function cast(value) {
	    if (['', 'true', 'false'].indexOf(value) > -1) {
	      return value.replace('', 'true') === 'true';
	    }
	    return value;
	  }
	
	  return {
	    restrict: 'A',
	    priority: 5,
	    scope: false,
	    link: function ($scope, $element, $attrs) {
	      if ($attrs.analyticsOn !== 'scrollby') return;
	
	      var properties = { continuous: false, triggerOnce: true };
	      angular.forEach($attrs.$attr, function(attr, name) {
	        if (isProperty(attr)) {
	          properties[name.slice(8,9).toLowerCase()+name.slice(9)] = cast($attrs[name]);
	        }
	      });
	
	      $element.waypoint(function () {
	        $element.triggerHandler('scrollby');
	      }, properties);
	    }
	  };
	}]);
	})(angular);


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * License: MIT
	 */
	(function(angular) {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name angulartics.segment.io
	   * Enables analytics support for Segment.io (http://segment.io)
	   */
	  angular.module('angulartics.segment.io', ['angulartics'])
	    .config(['$analyticsProvider', function ($analyticsProvider) {
	
	      // https://segment.com/docs/libraries/analytics.js/#page
	      // analytics.page([category], [name], [properties], [options], [callback]);
	      // TODO : Support optional parameters where the parameter order and type changes their meaning
	      // e.g.
	      // (string) is (name)
	      // (string, string) is (category, name)
	      // (string, object) is (name, properties)
	      $analyticsProvider.registerPageTrack(function (path) {
	        try {
	          analytics.page(path);
	        } catch (e) {
	          if (!(e instanceof ReferenceError)) {
	            throw e;
	          }
	        }
	      });
	
	      // https://segment.com/docs/libraries/analytics.js/#track
	      // analytics.track(event, [properties], [options], [callback]);
	      $analyticsProvider.registerEventTrack(function (event, properties, options, callback) {
	        try {
	          analytics.track(event, properties, options, callback);
	        } catch (e) {
	          if (!(e instanceof ReferenceError)) {
	            throw e;
	          }
	        }
	      });
	
	      // Segment Identify Method
	      // https://segment.com/docs/libraries/analytics.js/#identify
	      // analytics.identify([userId], [traits], [options], [callback]);
	      $analyticsProvider.registerSetUserProperties(function (userId, traits, options, callback) {
	        try {
	          analytics.identify(userId, traits, options, callback);
	        } catch (e) {
	          if (!(e instanceof ReferenceError)) {
	            throw e;
	          }
	        }
	      });
	
	      // Segment Identify Method
	      // https://segment.com/docs/libraries/analytics.js/#identify
	      // analytics.identify([userId], [traits], [options], [callback]);
	      $analyticsProvider.registerSetUserPropertiesOnce(function (userId, traits, options, callback) {
	        try {
	          analytics.identify(userId, traits, options, callback);
	        } catch (e) {
	          if (!(e instanceof ReferenceError)) {
	            throw e;
	          }
	        }
	      });
	
	    }]);
	})(angular);


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * License: MIT
	 */
	(function (angular) {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name angulartics.splunk
	   * Enables analytics support for with custom collection backend API
	   * using (sp.js as described in http://blogs.splunk.com/2013/10/17/still-using-3rd-party-web-analytics-providers-build-your-own-using-splunk/)
	   */
	  angular.module('angulartics.splunk', ['angulartics'])
	  .config(['$analyticsProvider', function ($analyticsProvider) {
	
	    var errorFunction = function(){
	      throw "Define sp ";
	    };
	
	    var _getSp = function () {
	        return window.sp || { pageview: errorFunction, track: errorFunction };
	    };
	
	    $analyticsProvider.registerPageTrack(function (path) {
	        _getSp().pageview(path);
	    });
	
	    $analyticsProvider.registerEventTrack(function (action, properties) {
	        _getSp().track(action, properties);
	    });
	
	  }]);
	})(angular);
	


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * License: MIT
	 */
	(function(angular) {
	'use strict';
	
	/**
	 * @ngdoc overview
	 * @name angulartics.woopra
	 * Enables analytics support for Woopra (http://www.woopra.com)
	 */
	angular.module('angulartics.woopra', ['angulartics'])
	.config(['$analyticsProvider', function ($analyticsProvider) {
	  $analyticsProvider.registerPageTrack(function (path) {
	    woopra.track('pv', {
	      url: path
	    });
	  });
	
	  $analyticsProvider.registerEventTrack(function (action, properties) {
	    woopra.track(action, properties);
	  });
	}]);
	})(angular);


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.17.2
	 * (c) 2014 Carl Thorner http://luisfarzati.github.io/angulartics
	 * Contributed by http://github.com/L42y
	 * License: MIT
	 */
	(function(angular) {
	'use strict';
	
	/**
	 * @ngdoc overview
	 * @name angulartics.marketo
	 * Enables analytics support for Marketo (http://www.marketo.com)
	 *
	 * Will not be considered loaded until the sKey attribute is set on the Munckin object, like so:
	 *
	 * Munckin.skey = 'my-secret-key';
	 *
	 * for event tracking email is a required attribute
	 */
	angular.module('angulartics.marketo', ['angulartics'])
	.config(['$analyticsProvider', function ($analyticsProvider) {
	  angulartics.waitForVendorApi('Munchkin', 500, 'sKey', function (Munchkin) {
	    $analyticsProvider.registerPageTrack(function (path) {
	      Munchkin.munchkinFunction("visitWebPage", {url: path} );
	    });
	  });
	
	  // If a path is set as a property we do a page tracking event.
	  angulartics.waitForVendorApi('Munchkin', 500, 'sKey', function (Munchkin) {
	   $analyticsProvider.registerEventTrack(function (action, properties) {
	    if(properties.path !== undefined) {
	     var params = [];
	     for(var prop in properties){
	      if(prop !== 'path') {
	       params.push(prop + "=" + properties[prop]);
	      }
	     }
	     if(action.toUpperCase() == 'CLICK'){
	      Munchkin.munchkinFunction('clickLink', {
	       href: properties.path
	      });
	     }
	     Munchkin.munchkinFunction("visitWebPage", {url: properties.path, params: params.join("&")});
	    }
	   });
	  });
	
	  var associateLead = function(properties){
	    if(properties.email !== undefined) {
	      email = properties.email;
	      email_sha = sha1(Munckin.sKey + email);
	      properties.Email = properties.email;
	      Munchkin.munchkinFunction('associateLead', properties, email_sha);
	    }
	  };
	
	  angulartics.waitForVendorApi('Munchkin', 500, function (Munchkin) {
	    $analyticsProvider.registerSetUsername(function (userId) {
	      if(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/.test(userId)){
	       associateLead({'Email': userId});
	      }
	    });
	  });
	
	  angulartics.waitForVendorApi('Munchkin', 500, function (Munchkin) {
	    $analyticsProvider.registerSetUserProperties(function (properties) {
	     associateLead(properties);
	    });
	  });
	
	  angulartics.waitForVendorApi('Munchkin', 500, function (Munchkin) {
	    $analyticsProvider.registerSetUserPropertiesOnce(function (properties) {
	     associateLead(properties);
	    });
	  });
	}]);
	})(angular);


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics v0.15.20
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * Universal Analytics update contributed by http://github.com/willmcclellan
	 * License: MIT
	 */
	(function(angular) {
	'use strict';
	
	/**
	 * @ngdoc overview
	 * @name angulartics.intercom
	 * Enables analytics support for Intercom (https://www.intercom.io/)
	 */
	angular.module('angulartics.intercom', ['angulartics'])
	.config(['$analyticsProvider', function ($analyticsProvider) {
	
	  $analyticsProvider.registerSetUsername(function (userId) {
	    if(window.Intercom) {
	      window.Intercom('update', { user_id: userId });
	    }
	  });
	
	  /**
	   * Track Event in Intercom
	   * @name eventTrack
	   *
	   * @param {string} action Required 'action' (string) associated with the event
	   * @param {object} properties = metadata
	   *
	   * @link http://doc.intercom.io/api/?javascript#submitting-events
	   *
	   * @example
	   *   Intercom('trackEvent', 'invited-friend');
	   */
	  $analyticsProvider.registerEventTrack(function (action, properties) {
	    if(window.Intercom) {
	      window.Intercom('trackEvent', action, properties);
	    }
	  });
	
	}]);
	})(angular);
	


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var BrowserInterceptor, BrowserService;
	
	__webpack_require__(28);
	
	__webpack_require__(59);
	
	BrowserService = __webpack_require__(64);
	
	BrowserInterceptor = __webpack_require__(65);
	
	angular.module('gnp-browser', ['gnp-translation']).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(66)).translations('ja', __webpack_require__(67));
	  }
	]).factory('BrowserService', BrowserService).run(BrowserInterceptor);


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(60);
	
	angular.module('gnp-translation', ['pascalprecht.translate']).config([
	  '$translateProvider', function($translateProvider) {
	    $translateProvider.determinePreferredLanguage();
	    return $translateProvider.translations('en', __webpack_require__(62)).translations('ja', __webpack_require__(63));
	  }
	]).run([
	  '$translate', function($translate) {
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      return $translate.use('ja');
	    } else {
	      return $translate.use('en');
	    }
	  }
	]);


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(61);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
	var angular = __webpack_require__(28);
	
	/*!
	 * angular-translate - v2.18.4 - 2021-01-14
	 * 
	 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	/**
	 * @ngdoc overview
	 * @name pascalprecht.translate
	 *
	 * @description
	 * The main module which holds everything together.
	 */
	runTranslate.$inject = ['$translate'];
	$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
	$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
	translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
	translateAttrDirective.$inject = ['$translate', '$rootScope'];
	translateCloakDirective.$inject = ['$translate', '$rootScope'];
	translateFilterFactory.$inject = ['$parse', '$translate'];
	$translationCache.$inject = ['$cacheFactory'];
	angular.module('pascalprecht.translate', ['ng'])
	  .run(runTranslate);
	
	function runTranslate($translate) {
	
	  'use strict';
	
	  var key = $translate.storageKey(),
	    storage = $translate.storage();
	
	  var fallbackFromIncorrectStorageValue = function () {
	    var preferred = $translate.preferredLanguage();
	    if (angular.isString(preferred)) {
	      $translate.use(preferred);
	      // $translate.use() will also remember the language.
	      // So, we don't need to call storage.put() here.
	    } else {
	      storage.put(key, $translate.use());
	    }
	  };
	
	  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';
	
	  if (storage) {
	    if (!storage.get(key)) {
	      fallbackFromIncorrectStorageValue();
	    } else {
	      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
	    }
	  } else if (angular.isString($translate.preferredLanguage())) {
	    $translate.use($translate.preferredLanguage());
	  }
	}
	
	runTranslate.displayName = 'runTranslate';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateSanitizationProvider
	 *
	 * @description
	 *
	 * Configurations for $translateSanitization
	 */
	angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);
	
	function $translateSanitizationProvider () {
	
	  'use strict';
	
	  var $sanitize,
	      $sce,
	      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
	      hasConfiguredStrategy = false,
	      hasShownNoStrategyConfiguredWarning = false,
	      strategies;
	
	  /**
	   * Definition of a sanitization strategy function
	   * @callback StrategyFunction
	   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
	   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
	   * @return {string|object}
	   */
	
	  /**
	   * @ngdoc property
	   * @name strategies
	   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Following strategies are built-in:
	   * <dl>
	   *   <dt>sanitize</dt>
	   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
	   *   <dt>escape</dt>
	   *   <dd>Escapes HTML in the translation</dd>
	   *   <dt>sanitizeParameters</dt>
	   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
	   *   <dt>escapeParameters</dt>
	   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
	   *   <dt>escaped</dt>
	   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
	   * </dl>
	   *
	   */
	
	  strategies = {
	    sanitize: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlSanitizeValue(value);
	      }
	      return value;
	    },
	    escape: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlEscapeValue(value);
	      }
	      return value;
	    },
	    sanitizeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlSanitizeValue);
	      }
	      return value;
	    },
	    escapeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlEscapeValue);
	      }
	      return value;
	    },
	    sce: function (value, mode, context) {
	      if (mode === 'text') {
	        value = htmlTrustValue(value);
	      } else if (mode === 'params') {
	        if (context !== 'filter') {
	          // do html escape in filter context #1101
	          value = mapInterpolationParameters(value, htmlEscapeValue);
	        }
	      }
	      return value;
	    },
	    sceParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlTrustValue);
	      }
	      return value;
	    }
	  };
	  // Support legacy strategy name 'escaped' for backwards compatibility.
	  // TODO should be removed in 3.0
	  strategies.escaped = strategies.escapeParameters;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Adds a sanitization strategy to the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @param {StrategyFunction} strategyFunction - strategy function
	   * @returns {object} this
	   */
	  this.addStrategy = function (strategyName, strategyFunction) {
	    strategies[strategyName] = strategyFunction;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Removes a sanitization strategy from the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @returns {object} this
	   */
	  this.removeStrategy = function (strategyName) {
	    delete strategies[strategyName];
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	   *
	   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	   * @returns {object} this
	   */
	  this.useStrategy = function (strategy) {
	    hasConfiguredStrategy = true;
	    currentStrategy = strategy;
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateSanitization
	   * @requires $injector
	   * @requires $log
	   *
	   * @description
	   * Sanitizes interpolation parameters and translated texts.
	   *
	   */
	  this.$get = ['$injector', '$log', function ($injector, $log) {
	
	    var cachedStrategyMap = {};
	
	    var applyStrategies = function (value, mode, context, selectedStrategies) {
	      angular.forEach(selectedStrategies, function (selectedStrategy) {
	        if (angular.isFunction(selectedStrategy)) {
	          value = selectedStrategy(value, mode, context);
	        } else if (angular.isFunction(strategies[selectedStrategy])) {
	          value = strategies[selectedStrategy](value, mode, context);
	        } else if (angular.isString(strategies[selectedStrategy])) {
	          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
	            try {
	              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
	            } catch (e) {
	              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
	              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	            }
	          }
	          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
	        } else {
	          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	        }
	      });
	      return value;
	    };
	
	    // TODO: should be removed in 3.0
	    var showNoStrategyConfiguredWarning = function () {
	      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
	        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
	        hasShownNoStrategyConfiguredWarning = true;
	      }
	    };
	
	    if ($injector.has('$sanitize')) {
	      $sanitize = $injector.get('$sanitize');
	    }
	    if ($injector.has('$sce')) {
	      $sce = $injector.get('$sce');
	    }
	
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#useStrategy
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	       *
	       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	       */
	      useStrategy: (function (self) {
	        return function (strategy) {
	          self.useStrategy(strategy);
	        };
	      })(this),
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#sanitize
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Sanitizes a value.
	       *
	       * @param {string|object} value The value which should be sanitized.
	       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
	       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
	       * @param {string} [context] The context of this call: filter, service. Default is service
	       * @returns {string|object} sanitized value
	       */
	      sanitize: function (value, mode, strategy, context) {
	        if (!currentStrategy) {
	          showNoStrategyConfiguredWarning();
	        }
	
	        if (!strategy && strategy !== null) {
	          strategy = currentStrategy;
	        }
	
	        if (!strategy) {
	          return value;
	        }
	
	        if (!context) {
	          context = 'service';
	        }
	
	        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
	        return applyStrategies(value, mode, context, selectedStrategies);
	      }
	    };
	  }];
	
	  var htmlEscapeValue = function (value) {
	    var element = angular.element('<div></div>');
	    element.text(value); // not chainable, see #1044
	    return element.html();
	  };
	
	  var htmlSanitizeValue = function (value) {
	    if (!$sanitize) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
	    }
	    return $sanitize(value);
	  };
	
	  var htmlTrustValue = function (value) {
	    if (!$sce) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
	    }
	    return $sce.trustAsHtml(value);
	  };
	
	  var mapInterpolationParameters = function (value, iteratee, stack) {
	    if (angular.isDate(value)) {
	      return value;
	    } else if (angular.isObject(value)) {
	      var result = angular.isArray(value) ? [] : {};
	
	      if (!stack) {
	        stack = [];
	      } else {
	        if (stack.indexOf(value) > -1) {
	          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
	        }
	      }
	
	      stack.push(value);
	      angular.forEach(value, function (propertyValue, propertyKey) {
	
	        /* Skipping function properties. */
	        if (angular.isFunction(propertyValue)) {
	          return;
	        }
	
	        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
	      });
	      stack.splice(-1, 1); // remove last
	
	      return result;
	    } else if (angular.isNumber(value)) {
	      return value;
	    } else if (value === true || value === false) {
	      return value;
	    } else if (!angular.isUndefined(value) && value !== null) {
	      return iteratee(value);
	    } else {
	      return value;
	    }
	  };
	}
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateProvider
	 * @description
	 *
	 * $translateProvider allows developers to register translation-tables, asynchronous loaders
	 * and similar to configure translation behavior directly inside of a module.
	 *
	 */
	angular.module('pascalprecht.translate')
	  .constant('pascalprechtTranslateOverrider', {})
	  .provider('$translate', $translate);
	
	function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {
	
	  'use strict';
	
	  var $translationTable = {},
	    $preferredLanguage,
	    $availableLanguageKeys = [],
	    $languageKeyAliases,
	    $fallbackLanguage,
	    $fallbackWasString,
	    $uses,
	    $nextLang,
	    $storageFactory,
	    $storageKey = $STORAGE_KEY,
	    $storagePrefix,
	    $missingTranslationHandlerFactory,
	    $interpolationFactory,
	    $interpolatorFactories = [],
	    $loaderFactory,
	    $cloakClassName = 'translate-cloak',
	    $loaderOptions,
	    $notFoundIndicatorLeft,
	    $notFoundIndicatorRight,
	    $postCompilingEnabled = false,
	    $forceAsyncReloadEnabled = false,
	    $nestedObjectDelimeter = '.',
	    $isReady = false,
	    $keepContent = false,
	    loaderCache,
	    directivePriority = 0,
	    statefulFilter = true,
	    postProcessFn,
	    uniformLanguageTagResolver = 'default',
	    languageTagResolver = {
	      'default' : function (tag) {
	        return (tag || '').split('-').join('_');
	      },
	      java : function (tag) {
	        var temp = (tag || '').split('-').join('_');
	        var parts = temp.split('_');
	        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
	      },
	      bcp47 : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	
	        switch (parts.length) {
	          case 1: // language only
	            parts[0] = parts[0].toLowerCase();
	            break;
	          case 2: // language-script or language-region
	            parts[0] = parts[0].toLowerCase();
	            if (parts[1].length === 4) { // parts[1] is script
	              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            } else { // parts[1] is region
	              parts[1] = parts[1].toUpperCase();
	            }
	            break;
	          case 3: // language-script-region
	            parts[0] = parts[0].toLowerCase();
	            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            parts[2] = parts[2].toUpperCase();
	            break;
	          default:
	            return temp;
	        }
	
	        return parts.join('-');
	      },
	      'iso639-1' : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	        return parts[0].toLowerCase();
	      }
	    };
	
	  var version = '2.18.4';
	
	  // tries to determine the browsers language
	  var getFirstBrowserLanguage = function () {
	
	    // internal purpose only
	    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
	      return pascalprechtTranslateOverrider.getLocale();
	    }
	
	    var nav = $windowProvider.$get().navigator,
	      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
	      i,
	      language;
	
	    // support for HTML 5.1 "navigator.languages"
	    if (angular.isArray(nav.languages)) {
	      for (i = 0; i < nav.languages.length; i++) {
	        language = nav.languages[i];
	        if (language && language.length) {
	          return language;
	        }
	      }
	    }
	
	    // support for other well known properties in browsers
	    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
	      language = nav[browserLanguagePropertyKeys[i]];
	      if (language && language.length) {
	        return language;
	      }
	    }
	
	    return null;
	  };
	  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';
	
	  // tries to determine the browsers locale
	  var getLocale = function () {
	    var locale = getFirstBrowserLanguage() || '';
	    if (languageTagResolver[uniformLanguageTagResolver]) {
	      locale = languageTagResolver[uniformLanguageTagResolver](locale);
	    }
	    return locale;
	  };
	  getLocale.displayName = 'angular-translate/service: getLocale';
	
	  /**
	   * @name indexOf
	   * @private
	   *
	   * @description
	   * indexOf polyfill. Kinda sorta.
	   *
	   * @param {array} array Array to search in.
	   * @param {string} searchElement Element to search for.
	   *
	   * @returns {int} Index of search element.
	   */
	  var indexOf = function (array, searchElement) {
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === searchElement) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function () {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  var negotiateLocale = function (preferred) {
	    if (!preferred) {
	      return;
	    }
	
	    var avail = [],
	      locale = lowercase(preferred),
	      i = 0,
	      n = $availableLanguageKeys.length;
	
	    for (; i < n; i++) {
	      avail.push(lowercase($availableLanguageKeys[i]));
	    }
	
	    // Check for an exact match in our list of available keys
	    i = indexOf(avail, locale);
	    if (i > -1) {
	      return $availableLanguageKeys[i];
	    }
	
	    if ($languageKeyAliases) {
	      var alias;
	      for (var langKeyAlias in $languageKeyAliases) {
	        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
	          var hasWildcardKey = false;
	          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
	            lowercase(langKeyAlias) === lowercase(preferred);
	
	          if (langKeyAlias.slice(-1) === '*') {
	            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
	          }
	          if (hasExactKey || hasWildcardKey) {
	            alias = $languageKeyAliases[langKeyAlias];
	            if (indexOf(avail, lowercase(alias)) > -1) {
	              return alias;
	            }
	          }
	        }
	      }
	    }
	
	    // Check for a language code without region
	    var parts = preferred.split('_');
	
	    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
	      return parts[0];
	    }
	
	    // If everything fails, return undefined.
	    return;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translations
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a new translation table for specific language key.
	   *
	   * To register a translation table for specific language, pass a defined language
	   * key as first parameter.
	   *
	   * <pre>
	   *  // register translation table for language: 'de_DE'
	   *  $translateProvider.translations('de_DE', {
	   *    'GREETING': 'Hallo Welt!'
	   *  });
	   *
	   *  // register another one
	   *  $translateProvider.translations('en_US', {
	   *    'GREETING': 'Hello world!'
	   *  });
	   * </pre>
	   *
	   * When registering multiple translation tables for for the same language key,
	   * the actual translation table gets extended. This allows you to define module
	   * specific translation which only get added, once a specific module is loaded in
	   * your app.
	   *
	   * Invoking this method with no arguments returns the translation table which was
	   * registered with no language key. Invoking it with a language key returns the
	   * related translation table.
	   *
	   * @param {string} langKey A language key.
	   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	   *
	   */
	  var translations = function (langKey, translationTable) {
	
	    if (!langKey && !translationTable) {
	      return $translationTable;
	    }
	
	    if (langKey && !translationTable) {
	      if (angular.isString(langKey)) {
	        return $translationTable[langKey];
	      }
	    } else {
	      if (!angular.isObject($translationTable[langKey])) {
	        $translationTable[langKey] = {};
	      }
	      angular.extend($translationTable[langKey], flatObject(translationTable));
	    }
	    return this;
	  };
	
	  this.translations = translations;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#cloakClassName
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the class name for `translate-cloak` directive.
	   * Default class name is `translate-cloak`.
	   *
	   * @param {string} name translate-cloak class name
	   */
	  this.cloakClassName = function (name) {
	    if (!name) {
	      return $cloakClassName;
	    }
	    $cloakClassName = name;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the delimiter for namespaced translations.
	   * Default delimiter is `.`.
	   *
	   * @param {string} delimiter namespace separator
	   */
	  this.nestedObjectDelimeter = function (delimiter) {
	    if (!delimiter) {
	      return $nestedObjectDelimeter;
	    }
	    $nestedObjectDelimeter = delimiter;
	    return this;
	  };
	
	  /**
	   * @name flatObject
	   * @private
	   *
	   * @description
	   * Flats an object. This function is used to flatten given translation data with
	   * namespaces, so they are later accessible via dot notation.
	   */
	  var flatObject = function (data, path, result, prevKey) {
	    var key, keyWithPath, keyWithShortPath, val;
	
	    if (!path) {
	      path = [];
	    }
	    if (!result) {
	      result = {};
	    }
	    for (key in data) {
	      if (!Object.prototype.hasOwnProperty.call(data, key)) {
	        continue;
	      }
	      val = data[key];
	      if (angular.isObject(val)) {
	        flatObject(val, path.concat(key), result, key);
	      } else {
	        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
	        if (path.length && key === prevKey) {
	          // Create shortcut path (foo.bar == foo.bar.bar)
	          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
	          // Link it to original path
	          result[keyWithShortPath] = '@:' + keyWithPath;
	        }
	        result[keyWithPath] = val;
	      }
	    }
	    return result;
	  };
	  flatObject.displayName = 'flatObject';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#addInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Adds interpolation services to angular-translate, so it can manage them.
	   *
	   * @param {object} factory Interpolation service factory
	   */
	  this.addInterpolation = function (factory) {
	    $interpolatorFactories.push(factory);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use interpolation functionality of messageformat.js.
	   * This is useful when having high level pluralization and gender selection.
	   */
	  this.useMessageFormatInterpolation = function () {
	    return this.useInterpolation('$translateMessageFormatInterpolation');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which interpolation style to use as default, application-wide.
	   * Simply pass a factory/service name. The interpolation service has to implement
	   * the correct interface.
	   *
	   * @param {string} factory Interpolation service name.
	   */
	  this.useInterpolation = function (factory) {
	    $interpolationFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Simply sets a sanitation strategy type.
	   *
	   * @param {string} value Strategy type.
	   */
	  this.useSanitizeValueStrategy = function (value) {
	    $translateSanitizationProvider.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#preferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use for translation
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **prefer**.
	   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.preferredLanguage = function (langKey) {
	    if (langKey) {
	      setupPreferredLanguage(langKey);
	      return this;
	    }
	    return $preferredLanguage;
	  };
	  var setupPreferredLanguage = function (langKey) {
	    if (langKey) {
	      $preferredLanguage = langKey;
	    }
	    return $preferredLanguage;
	  };
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found. E.g. when
	   * setting the indicator as 'X' and one tries to translate a translation id
	   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	   *
	   * Internally this methods sets a left indicator and a right indicator using
	   * `$translateProvider.translationNotFoundIndicatorLeft()` and
	   * `$translateProvider.translationNotFoundIndicatorRight()`.
	   *
	   * **Note**: These methods automatically add a whitespace between the indicators
	   * and the translation id.
	   *
	   * @param {string} indicator An indicator, could be any string.
	   */
	  this.translationNotFoundIndicator = function (indicator) {
	    this.translationNotFoundIndicatorLeft(indicator);
	    this.translationNotFoundIndicatorRight(indicator);
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found left to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorLeft = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorLeft;
	    }
	    $notFoundIndicatorLeft = indicator;
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found right to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorRight = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorRight;
	    }
	    $notFoundIndicatorRight = indicator;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use when missing translations
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **fallback**.
	   *
	   * @param {string||array} langKey A language key.
	   *
	   */
	  this.fallbackLanguage = function (langKey) {
	    fallbackStack(langKey);
	    return this;
	  };
	
	  var fallbackStack = function (langKey) {
	    if (langKey) {
	      if (angular.isString(langKey)) {
	        $fallbackWasString = true;
	        $fallbackLanguage = [langKey];
	      } else if (angular.isArray(langKey)) {
	        $fallbackWasString = false;
	        $fallbackLanguage = langKey;
	      }
	      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	        $fallbackLanguage.push($preferredLanguage);
	      }
	
	      return this;
	    } else {
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#use
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Set which translation table to use for translation by given language key. When
	   * trying to 'use' a language which isn't provided, it'll throw an error.
	   *
	   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	   * does the job too.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.use = function (langKey) {
	    if (langKey) {
	      if (!$translationTable[langKey] && (!$loaderFactory)) {
	        // only throw an error, when not loading translation data asynchronously
	        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
	      }
	      $uses = langKey;
	      return this;
	    }
	    return $uses;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	   *
	   * @returns {string} the current client/browser language key
	   */
	  this.resolveClientLocale = function () {
	    return getLocale();
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storageKey
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which key must represent the choosed language by a user in the storage.
	   *
	   * @param {string} key A key for the storage.
	   */
	  var storageKey = function (key) {
	    if (!key) {
	      if ($storagePrefix) {
	        return $storagePrefix + $storageKey;
	      }
	      return $storageKey;
	    }
	    $storageKey = key;
	    return this;
	  };
	
	  this.storageKey = storageKey;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useUrlLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	   *
	   * @param {string} url Url
	   * @param {Object=} options Optional configuration object
	   */
	  this.useUrlLoader = function (url, options) {
	    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	   *
	   * @param {Object=} options Optional configuration object
	   */
	  this.useStaticFilesLoader = function (options) {
	    return this.useLoader('$translateStaticFilesLoader', options);
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use any other service as loader.
	   *
	   * @param {string} loaderFactory Factory name to use
	   * @param {Object=} options Optional configuration object
	   */
	  this.useLoader = function (loaderFactory, options) {
	    $loaderFactory = loaderFactory;
	    $loaderOptions = options || {};
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLocalStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	   *
	   */
	  this.useLocalStorage = function () {
	    return this.useStorage('$translateLocalStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useCookieStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	   */
	  this.useCookieStorage = function () {
	    return this.useStorage('$translateCookieStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use custom service as storage layer.
	   */
	  this.useStorage = function (storageFactory) {
	    $storageFactory = storageFactory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storagePrefix
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets prefix for storage key.
	   *
	   * @param {string} prefix Storage key prefix
	   */
	  this.storagePrefix = function (prefix) {
	    if (!prefix) {
	      return prefix;
	    }
	    $storagePrefix = prefix;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use built-in log handler when trying to translate
	   * a translation Id which doesn't exist.
	   *
	   * This is actually a shortcut method for `useMissingTranslationHandler()`.
	   *
	   */
	  this.useMissingTranslationHandlerLog = function () {
	    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Expects a factory name which later gets instantiated with `$injector`.
	   * This method can be used to tell angular-translate to use a custom
	   * missingTranslationHandler. Just build a factory which returns a function
	   * and expects a translation id as argument.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.useMissingTranslationHandler('customHandler');
	   *  });
	   *
	   *  app.factory('customHandler', function (dep1, dep2) {
	   *    return function (translationId) {
	   *      // something with translationId and dep1 and dep2
	   *    };
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.useMissingTranslationHandler = function (factory) {
	    $missingTranslationHandlerFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#usePostCompiling
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If post compiling is enabled, all translated values will be processed
	   * again with AngularJS' $compile.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.usePostCompiling(true);
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.usePostCompiling = function (value) {
	    $postCompilingEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If force async reload is enabled, async loader will always be called
	   * even if $translationTable already contains the language key, adding
	   * possible new entries to the $translationTable.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.forceAsyncReload(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.forceAsyncReload = function (value) {
	    $forceAsyncReloadEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which language tag should be used as a result when determining
	   * the current browser language.
	   *
	   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
	   *
	   * <pre>
	   * $translateProvider
	   *   .uniformLanguageTag('bcp47')
	   *   .determinePreferredLanguage()
	   * </pre>
	   *
	   * The resolver currently supports:
	   * * default
	   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_us
	   * * java
	   *     like default, but the second part will be always in uppercase
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_US
	   * * BCP 47 (RFC 4646 & 4647)
	   *     EN => en
	   *     en-US => en-US
	   *     en_US => en-US
	   *     en-us => en-US
	   *     sr-latn => sr-Latn
	   *     sr-latn-rs => sr-Latn-RS
	   *
	   * See also:
	   * * http://en.wikipedia.org/wiki/IETF_language_tag
	   * * http://www.w3.org/International/core/langtags/
	   * * http://tools.ietf.org/html/bcp47
	   *
	   * @param {string|object} options - options (or standard)
	   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
	   */
	  this.uniformLanguageTag = function (options) {
	
	    if (!options) {
	      options = {};
	    } else if (angular.isString(options)) {
	      options = {
	        standard : options
	      };
	    }
	
	    uniformLanguageTagResolver = options.standard;
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to try to determine on its own which language key
	   * to set as preferred language. When `fn` is given, angular-translate uses it
	   * to determine a language key, otherwise it uses the built-in `getLocale()`
	   * method.
	   *
	   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	   * `[lang]` depending on what the browser provides.
	   *
	   * Use this method at your own risk, since not all browsers return a valid
	   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
	   *
	   * @param {Function=} fn Function to determine a browser's locale
	   */
	  this.determinePreferredLanguage = function (fn) {
	
	    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();
	
	    if (!$availableLanguageKeys.length) {
	      $preferredLanguage = locale;
	    } else {
	      $preferredLanguage = negotiateLocale(locale) || locale;
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a set of language keys the app will work with. Use this method in
	   * combination with
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When available languages keys are registered, angular-translate
	   * tries to find the best fitting language key depending on the browsers locale,
	   * considering your language key convention.
	   *
	   * @param {object} languageKeys Array of language keys the your app will use
	   * @param {object=} aliases Alias map.
	   */
	  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
	    if (languageKeys) {
	      $availableLanguageKeys = languageKeys;
	      if (aliases) {
	        $languageKeyAliases = aliases;
	      }
	      return this;
	    }
	    return $availableLanguageKeys;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoaderCache
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a cache for internal $http based loaders.
	   * {@link pascalprecht.translate.$translationCache $translationCache}.
	   * When false the cache will be disabled (default). When true or undefined
	   * the cache will be a default (see $cacheFactory). When an object it will
	   * be treat as a cache object itself: the usage is $http({cache: cache})
	   *
	   * @param {object} cache boolean, string or cache-object
	   */
	  this.useLoaderCache = function (cache) {
	    if (cache === false) {
	      // disable cache
	      loaderCache = undefined;
	    } else if (cache === true) {
	      // enable cache using AJS defaults
	      loaderCache = true;
	    } else if (typeof(cache) === 'undefined') {
	      // enable cache using default
	      loaderCache = '$translationCache';
	    } else if (cache) {
	      // enable cache using given one (see $cacheFactory)
	      loaderCache = cache;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#directivePriority
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets the default priority of the translate directive. The standard value is `0`.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {number} priority for the translate-directive
	   */
	  this.directivePriority = function (priority) {
	    if (priority === undefined) {
	      // getter
	      return directivePriority;
	    } else {
	      // setter with chaining
	      directivePriority = priority;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#statefulFilter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	   * have to explicit define this behavior.
	   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
	   * meaning being stateful.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {boolean} state - defines the state of the filter
	   */
	  this.statefulFilter = function (state) {
	    if (state === undefined) {
	      // getter
	      return statefulFilter;
	    } else {
	      // setter with chaining
	      statefulFilter = state;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#postProcess
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * The post processor will be intercept right after the translation result. It can modify the result.
	   *
	   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
	   */
	  this.postProcess = function (fn) {
	    if (fn) {
	      postProcessFn = fn;
	    } else {
	      postProcessFn = undefined;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#keepContent
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If keepContent is set to true than translate directive will always use innerHTML
	   * as a default translation
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.keepContent(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.keepContent = function (value) {
	    $keepContent = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translate
	   * @requires $interpolate
	   * @requires $log
	   * @requires $rootScope
	   * @requires $q
	   *
	   * @description
	   * The `$translate` service is the actual core of angular-translate. It expects a translation id
	   * and optional interpolate parameters to translate contents.
	   *
	   * <pre>
	   *  $translate('HEADLINE_TEXT').then(function (translation) {
	   *    $scope.translatedText = translation;
	   *  });
	   * </pre>
	   *
	   * @param {string|array} translationId A token which represents a translation id
	   *                                     This can be optionally an array of translation ids which
	   *                                     results that the function returns an object where each key
	   *                                     is the translation id and the value the translation.
	   * @param {object=} [interpolateParams={}] An object hash for dynamic values
	   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
	   *                                        as default text in case it is not found in any configured language
	   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	   * @returns {object} promise
	   */
	  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {
	
	    var Storage,
	      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
	      pendingLoader = false,
	      interpolatorHashMap = {},
	      langPromises = {},
	      fallbackIndex,
	      startFallbackIteration;
	
	    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
	      if (!$uses && $preferredLanguage) {
	        $uses = $preferredLanguage;
	      }
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        // Inspired by Q.allSettled by Kris Kowal
	        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	        // This transforms all promises regardless resolved or rejected
	        var translateAll = function (translationIds) {
	          var results = {}; // storing the actual results
	          var promises = []; // promises to wait for
	          // Wraps the promise a) being always resolved and b) storing the link id->value
	          var translate = function (translationId) {
	            var deferred = $q.defer();
	            var regardless = function (value) {
	              results[translationId] = value;
	              deferred.resolve([translationId, value]);
	            };
	            // we don't care whether the promise was resolved or rejected; just store the values
	            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
	            return deferred.promise;
	          };
	          for (var i = 0, c = translationIds.length; i < c; i++) {
	            promises.push(translate(translationIds[i]));
	          }
	          // wait for all (including storing to results)
	          return $q.all(promises).then(function () {
	            // return the results
	            return results;
	          });
	        };
	        return translateAll(translationId);
	      }
	
	      var deferred = $q.defer();
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      } else {
	        throw new TypeError('translationId must be a not empty string');
	      }
	
	      var promiseToWaitFor = (function () {
	        var promise = langPromises[uses] || langPromises[$preferredLanguage];
	
	        fallbackIndex = 0;
	
	        if ($storageFactory && !promise) {
	          // looks like there's no pending promise for $preferredLanguage or
	          // $uses. Maybe there's one pending for a language that comes from
	          // storage.
	          var langKey = Storage.get($storageKey);
	          promise = langPromises[langKey];
	
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            var index = indexOf($fallbackLanguage, langKey);
	            // maybe the language from storage is also defined as fallback language
	            // we increase the fallback language index to not search in that language
	            // as fallback, since it's probably the first used language
	            // in that case the index starts after the first element
	            fallbackIndex = (index === 0) ? 1 : 0;
	
	            // but we can make sure to ALWAYS fallback to preferred language at least
	            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	              $fallbackLanguage.push($preferredLanguage);
	            }
	          }
	        }
	        return promise;
	      }());
	
	      if (!promiseToWaitFor) {
	        // no promise to wait for? okay. Then there's no loader registered
	        // nor is a one pending for language that comes from storage.
	        // We can just translate.
	        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	      } else {
	        var promiseResolved = function () {
	          // $uses may have changed while waiting
	          if (!forceLanguage) {
	            uses = $uses;
	          }
	          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	        };
	        promiseResolved.displayName = 'promiseResolved';
	
	        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name applyNotFoundIndicators
	     * @private
	     *
	     * @description
	     * Applies not fount indicators to given translation id, if needed.
	     * This function gets only executed, if a translation id doesn't exist,
	     * which is why a translation id is expected as argument.
	     *
	     * @param {string} translationId Translation id.
	     * @returns {string} Same as given translation id but applied with not found
	     * indicators.
	     */
	    var applyNotFoundIndicators = function (translationId) {
	      // applying notFoundIndicators
	      if ($notFoundIndicatorLeft) {
	        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
	      }
	      if ($notFoundIndicatorRight) {
	        translationId = [translationId, $notFoundIndicatorRight].join(' ');
	      }
	      return translationId;
	    };
	
	    /**
	     * @name useLanguage
	     * @private
	     *
	     * @description
	     * Makes actual use of a language by setting a given language key as used
	     * language and informs registered interpolators to also use the given
	     * key as locale.
	     *
	     * @param {string} key Locale key.
	     */
	    var useLanguage = function (key) {
	      $uses = key;
	
	      // make sure to store new language key before triggering success event
	      if ($storageFactory) {
	        Storage.put($translate.storageKey(), $uses);
	      }
	
	      $rootScope.$emit('$translateChangeSuccess', {language : key});
	
	      // inform default interpolator
	      defaultInterpolator.setLocale($uses);
	
	      var eachInterpolator = function (interpolator, id) {
	        interpolatorHashMap[id].setLocale($uses);
	      };
	      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';
	
	      // inform all others too!
	      angular.forEach(interpolatorHashMap, eachInterpolator);
	      $rootScope.$emit('$translateChangeEnd', {language : key});
	    };
	
	    /**
	     * @name loadAsync
	     * @private
	     *
	     * @description
	     * Kicks off registered async loader using `$injector` and applies existing
	     * loader options. When resolved, it updates translation tables accordingly
	     * or rejects with given language key.
	     *
	     * @param {string} key Language key.
	     * @return {Promise} A promise.
	     */
	    var loadAsync = function (key) {
	      if (!key) {
	        throw 'No language key specified for loading.';
	      }
	
	      var deferred = $q.defer();
	
	      $rootScope.$emit('$translateLoadingStart', {language : key});
	      pendingLoader = true;
	
	      var cache = loaderCache;
	      if (typeof(cache) === 'string') {
	        // getting on-demand instance of loader
	        cache = $injector.get(cache);
	      }
	
	      var loaderOptions = angular.extend({}, $loaderOptions, {
	        key : key,
	        $http : angular.extend({}, {
	          cache : cache
	        }, $loaderOptions.$http)
	      });
	
	      var onLoaderSuccess = function (data) {
	        var translationTable = {};
	        $rootScope.$emit('$translateLoadingSuccess', {language : key});
	
	        if (angular.isArray(data)) {
	          angular.forEach(data, function (table) {
	            angular.extend(translationTable, flatObject(table));
	          });
	        } else {
	          angular.extend(translationTable, flatObject(data));
	        }
	        pendingLoader = false;
	        deferred.resolve({
	          key : key,
	          table : translationTable
	        });
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderSuccess.displayName = 'onLoaderSuccess';
	
	      var onLoaderError = function (key) {
	        $rootScope.$emit('$translateLoadingError', {language : key});
	        deferred.reject(key);
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderError.displayName = 'onLoaderError';
	
	      $injector.get($loaderFactory)(loaderOptions)
	        .then(onLoaderSuccess, onLoaderError);
	
	      return deferred.promise;
	    };
	
	    if ($storageFactory) {
	      Storage = $injector.get($storageFactory);
	
	      if (!Storage.get || !Storage.put) {
	        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
	      }
	    }
	
	    // if we have additional interpolations that were added via
	    // $translateProvider.addInterpolation(), we have to map'em
	    if ($interpolatorFactories.length) {
	      var eachInterpolationFactory = function (interpolatorFactory) {
	        var interpolator = $injector.get(interpolatorFactory);
	        // setting initial locale for each interpolation service
	        interpolator.setLocale($preferredLanguage || $uses);
	        // make'em recognizable through id
	        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
	      };
	      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';
	
	      angular.forEach($interpolatorFactories, eachInterpolationFactory);
	    }
	
	    /**
	     * @name getTranslationTable
	     * @private
	     *
	     * @description
	     * Returns a promise that resolves to the translation table
	     * or is rejected if an error occurred.
	     *
	     * @param langKey
	     * @returns {Q.promise}
	     */
	    var getTranslationTable = function (langKey) {
	      var deferred = $q.defer();
	      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
	        deferred.resolve($translationTable[langKey]);
	      } else if (langPromises[langKey]) {
	        var onResolve = function (data) {
	          translations(data.key, data.table);
	          deferred.resolve(data.table);
	        };
	        onResolve.displayName = 'translationTableResolver';
	        langPromises[langKey].then(onResolve, deferred.reject);
	      } else {
	        deferred.reject();
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslation
	     * @private
	     *
	     * @description
	     * Returns a promise that will resolve to the translation
	     * or be rejected if no translation was found for the language.
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {Q.promise}
	     */
	    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      var onResolve = function (translationTable) {
	        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	          Interpolator.setLocale(langKey);
	          var translation = translationTable[translationId];
	          if (translation.substr(0, 2) === '@:') {
	            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
	              .then(deferred.resolve, deferred.reject);
	          } else {
	            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
	            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);
	
	            deferred.resolve(interpolatedValue);
	
	          }
	          Interpolator.setLocale($uses);
	        } else {
	          deferred.reject();
	        }
	      };
	      onResolve.displayName = 'fallbackTranslationResolver';
	
	      getTranslationTable(langKey).then(onResolve, deferred.reject);
	
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslationInstant
	     * @private
	     *
	     * @description
	     * Returns a translation
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns {string} translation
	     */
	    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result, translationTable = $translationTable[langKey];
	
	      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	        Interpolator.setLocale(langKey);
	        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
	        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
	        // workaround for TrustedValueHolderType
	        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
	          var result2 = result.$$unwrapTrustedValue();
	          if (result2.substr(0, 2) === '@:') {
	            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	          }
	        } else if (result.substr(0, 2) === '@:') {
	          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	        }
	        Interpolator.setLocale($uses);
	      }
	
	      return result;
	    };
	
	
	    /**
	     * @name translateByHandler
	     * @private
	     *
	     * Translate by missing translation handler.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param defaultTranslationText
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	     * absent
	     */
	    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
	      // If we have a handler factory - we might also call it here to determine if it provides
	      // a default text for a translationid that can't be found anywhere in our tables
	      if ($missingTranslationHandlerFactory) {
	        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
	      } else {
	        return translationId;
	      }
	    };
	
	    /**
	     * @name resolveForFallbackLanguage
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise that will resolve to the translation.
	     */
	    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
	          function (data) {
	            deferred.resolve(data);
	          },
	          function () {
	            // Look in the next fallback language for a translation.
	            // It delays the resolving by passing another promise to resolve.
	            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	          }
	        );
	      } else {
	        // No translation found in any fallback language
	        // if a default translation text is set in the directive, then return this as a result
	        if (defaultTranslationText) {
	          deferred.resolve(defaultTranslationText);
	        } else {
	          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	
	          // if no default translation is set and an error handler is defined, send it to the handler
	          // and then return the result if it isn't undefined
	          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name resolveForFallbackLanguageInstant
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {string} translation
	     */
	    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result;
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        if (!result && result !== '') {
	          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
	        }
	      }
	      return result;
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise, that resolves to the translation.
	     */
	    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {String} translation
	     */
	    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
	    };
	
	    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {
	
	      var deferred = $q.defer();
	
	      var table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	
	          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
	            .then(deferred.resolve, deferred.reject);
	        } else {
	          //
	          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
	          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
	          deferred.resolve(resolvedTranslation);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
	            .then(function (translation) {
	              deferred.resolve(translation);
	            }, function (_translationId) {
	              deferred.reject(applyNotFoundIndicators(_translationId));
	            });
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          }
	        } else {
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {
	
	      var result, table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = defaultInterpolator;
	
	      // if the interpolation id exists use custom interpolator
	      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
	        Interpolator = interpolatorHashMap[interpolationId];
	      }
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
	        } else {
	          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
	          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackIndex = 0;
	          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          result = missingTranslationHandlerTranslation;
	        } else {
	          result = applyNotFoundIndicators(translationId);
	        }
	      }
	
	      return result;
	    };
	
	    var clearNextLangAndPromise = function (key) {
	      if ($nextLang === key) {
	        $nextLang = undefined;
	      }
	      langPromises[key] = undefined;
	    };
	
	    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
	      var fn = postProcessFn;
	
	      if (fn) {
	
	        if (typeof(fn) === 'string') {
	          // getting on-demand instance
	          fn = $injector.get(fn);
	        }
	        if (fn) {
	          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
	        }
	      }
	
	      return resolvedTranslation;
	    };
	
	    var loadTranslationsIfMissing = function (key) {
	      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          return translation;
	        });
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#preferredLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the preferred language.
	     *
	     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	     *
	     * @return {string} preferred language key
	     */
	    $translate.preferredLanguage = function (langKey) {
	      if (langKey) {
	        setupPreferredLanguage(langKey);
	      }
	      return $preferredLanguage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#cloakClassName
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured class name for `translate-cloak` directive.
	     *
	     * @return {string} cloakClassName
	     */
	    $translate.cloakClassName = function () {
	      return $cloakClassName;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured delimiter for nested namespaces.
	     *
	     * @return {string} nestedObjectDelimeter
	     */
	    $translate.nestedObjectDelimeter = function () {
	      return $nestedObjectDelimeter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#fallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the fallback languages or sets a new fallback stack.
	     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
	     *
	     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	     *
	     * @return {string||array} fallback language key
	     */
	    $translate.fallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        fallbackStack(langKey);
	
	        // as we might have an async loader initiated and a new translation language might have been defined
	        // we need to add the promise to the stack also. So - iterate.
	        if ($loaderFactory) {
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	              if (!langPromises[$fallbackLanguage[i]]) {
	                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
	              }
	            }
	          }
	        }
	        $translate.use($translate.use());
	      }
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#useFallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Sets the first key of the fallback language stack to be used for translation.
	     * Therefore all languages in the fallback array BEFORE this key will be skipped!
	     *
	     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	     * get back to the whole stack
	     */
	    $translate.useFallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        if (!langKey) {
	          startFallbackIteration = 0;
	        } else {
	          var langKeyPosition = indexOf($fallbackLanguage, langKey);
	          if (langKeyPosition > -1) {
	            startFallbackIteration = langKeyPosition;
	          }
	        }
	
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#proposedLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key of language that is currently loaded asynchronously.
	     *
	     * @return {string} language key
	     */
	    $translate.proposedLanguage = function () {
	      return $nextLang;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns registered storage.
	     *
	     * @return {object} Storage
	     */
	    $translate.storage = function () {
	      return Storage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#negotiateLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a language key based on available languages and language aliases. If a
	     * language key cannot be resolved, returns undefined.
	     *
	     * If no or a falsy key is given, returns undefined.
	     *
	     * @param {string} [key] Language key
	     * @return {string|undefined} Language key or undefined if no language key is found.
	     */
	    $translate.negotiateLocale = negotiateLocale;
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#use
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Tells angular-translate which language to use by given language key. This method is
	     * used to change language at runtime. It also takes care of storing the language
	     * key in a configured store to let your app remember the choosed language.
	     *
	     * When trying to 'use' a language which isn't available it tries to load it
	     * asynchronously with registered loaders.
	     *
	     * Returns promise object with loaded language file data or string of the currently used language.
	     *
	     * If no or a falsy key is given it returns the currently used language key.
	     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
	     * @example
	     * $translate.use("en_US").then(function(data){
	       *   $scope.text = $translate("HELLO");
	       * });
	     *
	     * @param {string=} key Language key
	     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
	     */
	    $translate.use = function (key) {
	      if (!key) {
	        return $uses;
	      }
	
	      var deferred = $q.defer();
	      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"
	
	      $rootScope.$emit('$translateChangeStart', {language : key});
	
	      // Try to get the aliased language key
	      var aliasedKey = negotiateLocale(key);
	      // Ensure only registered language keys will be loaded
	      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
	        return $q.reject(key);
	      }
	
	      if (aliasedKey) {
	        key = aliasedKey;
	      }
	
	      // if there isn't a translation table for the language we've requested,
	      // we load it asynchronously
	      $nextLang = key;
	      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          deferred.resolve(translation.key);
	          if ($nextLang === key) {
	            useLanguage(translation.key);
	          }
	          return translation;
	        }, function (key) {
	          $rootScope.$emit('$translateChangeError', {language : key});
	          deferred.reject(key);
	          $rootScope.$emit('$translateChangeEnd', {language : key});
	          return $q.reject(key);
	        });
	        langPromises[key]['finally'](function () {
	          clearNextLangAndPromise(key);
	        })['catch'](angular.noop); // we don't care about errors (clearing)
	      } else if (langPromises[key]) {
	        // we are already loading this asynchronously
	        // resolve our new deferred when the old langPromise is resolved
	        langPromises[key].then(function (translation) {
	          if ($nextLang === translation.key) {
	            useLanguage(translation.key);
	          }
	          deferred.resolve(translation.key);
	          return translation;
	        }, function (key) {
	          // find first available fallback language if that request has failed
	          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
	            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
	          } else {
	            return deferred.reject(key);
	          }
	        });
	      } else {
	        deferred.resolve(key);
	        useLanguage(key);
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#resolveClientLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	     *
	     * @returns {string} the current client/browser language key
	     */
	    $translate.resolveClientLocale = function () {
	      return getLocale();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storageKey
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the key for the storage.
	     *
	     * @return {string} storage key
	     */
	    $translate.storageKey = function () {
	      return storageKey();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether post compiling is enabled or not
	     *
	     * @return {bool} storage key
	     */
	    $translate.isPostCompilingEnabled = function () {
	      return $postCompilingEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether force async reload is enabled or not
	     *
	     * @return {boolean} forceAsyncReload value
	     */
	    $translate.isForceAsyncReloadEnabled = function () {
	      return $forceAsyncReloadEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isKeepContent
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether keepContent or not
	     *
	     * @return {boolean} keepContent value
	     */
	    $translate.isKeepContent = function () {
	      return $keepContent;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#refresh
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	     * the module will drop all existent translation tables and load new version of those which
	     * are currently in use.
	     *
	     * Refresh means that the module will drop target translation table and try to load it again.
	     *
	     * In case there are no loaders registered the refresh() method will throw an Error.
	     *
	     * If the module is able to refresh translation tables refresh() method will broadcast
	     * $translateRefreshStart and $translateRefreshEnd events.
	     *
	     * @example
	     * // this will drop all currently existent translation tables and reload those which are
	     * // currently in use
	     * $translate.refresh();
	     * // this will refresh a translation table for the en_US language
	     * $translate.refresh('en_US');
	     *
	     * @param {string} langKey A language key of the table, which has to be refreshed
	     *
	     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	     * process is finished successfully, and reject if not.
	     */
	    $translate.refresh = function (langKey) {
	      if (!$loaderFactory) {
	        throw new Error('Couldn\'t refresh translation table, no loader registered!');
	      }
	
	      $rootScope.$emit('$translateRefreshStart', {language : langKey});
	
	      var deferred = $q.defer(), updatedLanguages = {};
	
	      //private helper
	      function loadNewData(languageKey) {
	        var promise = loadAsync(languageKey);
	        //update the load promise cache for this language
	        langPromises[languageKey] = promise;
	        //register a data handler for the promise
	        promise.then(function (data) {
	            //clear the cache for this language
	            $translationTable[languageKey] = {};
	            //add the new data for this language
	            translations(languageKey, data.table);
	            //track that we updated this language
	            updatedLanguages[languageKey] = true;
	          },
	          //handle rejection to appease the $q validation
	          angular.noop);
	        return promise;
	      }
	
	      //set up post-processing
	      deferred.promise.then(
	        function () {
	          for (var key in $translationTable) {
	            if ($translationTable.hasOwnProperty(key)) {
	              //delete cache entries that were not updated
	              if (!(key in updatedLanguages)) {
	                delete $translationTable[key];
	              }
	            }
	          }
	          if ($uses) {
	            useLanguage($uses);
	          }
	        },
	        //handle rejection to appease the $q validation
	        angular.noop
	      )['finally'](
	        function () {
	          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
	        }
	      );
	
	      if (!langKey) {
	        // if there's no language key specified we refresh ALL THE THINGS!
	        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
	        if ($uses && languagesToReload.indexOf($uses) === -1) {
	          languagesToReload.push($uses);
	        }
	        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);
	
	      } else if ($translationTable[langKey]) {
	        //just refresh the specified language cache
	        loadNewData(langKey).then(deferred.resolve, deferred.reject);
	
	      } else {
	        deferred.reject();
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#instant
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a translation instantly from the internal state of loaded translation. All rules
	     * regarding the current language, the preferred language of even fallback languages will be
	     * used except any promise handling. If a language was not found, an asynchronous loading
	     * will be invoked in the background.
	     *
	     * @param {string|array} translationId A token which represents a translation id
	     *                                     This can be optionally an array of translation ids which
	     *                                     results that the function's promise returns an object where
	     *                                     each key is the translation id and the value the translation.
	     * @param {object=} [interpolateParams={}] Params
	     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	     *
	     * @return {string|object} translation
	     */
	    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {
	
	      // we don't want to re-negotiate $uses
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Detect undefined and null values to shorten the execution and prevent exceptions
	      if (translationId === null || angular.isUndefined(translationId)) {
	        return translationId;
	      }
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        var results = {};
	        for (var i = 0, c = translationId.length; i < c; i++) {
	          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
	        }
	        return results;
	      }
	
	      // We discarded unacceptable values. So we just need to verify if translationId is empty String
	      if (angular.isString(translationId) && translationId.length < 1) {
	        return translationId;
	      }
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      }
	
	      var result, possibleLangKeys = [];
	      if ($preferredLanguage) {
	        possibleLangKeys.push($preferredLanguage);
	      }
	      if (uses) {
	        possibleLangKeys.push(uses);
	      }
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
	      }
	      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
	        var possibleLangKey = possibleLangKeys[j];
	        if ($translationTable[possibleLangKey]) {
	          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
	            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
	          }
	        }
	        if (typeof result !== 'undefined') {
	          break;
	        }
	      }
	
	      if (!result && result !== '') {
	        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
	          result = applyNotFoundIndicators(translationId);
	        } else {
	          // Return translation of default interpolator if not found anything.
	          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);
	
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          var missingTranslationHandlerTranslation;
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	          }
	
	          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            result = missingTranslationHandlerTranslation;
	          }
	        }
	      }
	
	      return result;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#versionInfo
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the current version information for the angular-translate library
	     *
	     * @return {string} angular-translate version
	     */
	    $translate.versionInfo = function () {
	      return version;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#loaderCache
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the defined loaderCache.
	     *
	     * @return {boolean|string|object} current value of loaderCache
	     */
	    $translate.loaderCache = function () {
	      return loaderCache;
	    };
	
	    // internal purpose only
	    $translate.directivePriority = function () {
	      return directivePriority;
	    };
	
	    // internal purpose only
	    $translate.statefulFilter = function () {
	      return statefulFilter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
	     *
	     * @return {boolean} current value of ready
	     */
	    $translate.isReady = function () {
	      return $isReady;
	    };
	
	    var $onReadyDeferred = $q.defer();
	    $onReadyDeferred.promise.then(function () {
	      $isReady = true;
	    });
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#onReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
	     *
	     * @param {Function=} fn Function to invoke when service is ready
	     * @return {object} Promise resolved when service is ready
	     */
	    $translate.onReady = function (fn) {
	      var deferred = $q.defer();
	      if (angular.isFunction(fn)) {
	        deferred.promise.then(fn);
	      }
	      if ($isReady) {
	        deferred.resolve();
	      } else {
	        $onReadyDeferred.promise.then(deferred.resolve);
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This function simply returns the registered language keys being defined before in the config phase
	     * With this, an application can use the array to provide a language selection dropdown or similar
	     * without any additional effort
	     *
	     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
	     */
	    $translate.getAvailableLanguageKeys = function () {
	      if ($availableLanguageKeys.length > 0) {
	        return $availableLanguageKeys;
	      }
	      return null;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getTranslationTable
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns translation table by the given language key.
	     *
	     * Unless a language is provided it returns a translation table of the current one.
	     * Note: If translation dictionary is currently downloading or in progress
	     * it will return null.
	     *
	     * @param {string} langKey A token which represents a translation id
	     *
	     * @return {object} a copy of angular-translate $translationTable
	     */
	    $translate.getTranslationTable = function (langKey) {
	      langKey = langKey || $translate.use();
	      if (langKey && $translationTable[langKey]) {
	        return angular.copy($translationTable[langKey]);
	      }
	      return null;
	    };
	
	    // Whenever $translateReady is being fired, this will ensure the state of $isReady
	    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
	      $onReadyDeferred.resolve();
	      globalOnReadyListener(); // one time only
	      globalOnReadyListener = null;
	    });
	    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
	      $onReadyDeferred.resolve();
	      globalOnChangeListener(); // one time only
	      globalOnChangeListener = null;
	    });
	
	    if ($loaderFactory) {
	
	      // If at least one async loader is defined and there are no
	      // (default) translations available we should try to load them.
	      if (angular.equals($translationTable, {})) {
	        if ($translate.use()) {
	          $translate.use($translate.use());
	        }
	      }
	
	      // Also, if there are any fallback language registered, we start
	      // loading them asynchronously as soon as we can.
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        var processAsyncResult = function (translation) {
	          translations(translation.key, translation.table);
	          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
	          return translation;
	        };
	        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	          var fallbackLanguageId = $fallbackLanguage[i];
	          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
	            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
	          }
	        }
	      }
	    } else {
	      $rootScope.$emit('$translateReady', {language : $translate.use()});
	    }
	
	    return $translate;
	  }];
	}
	
	$translate.displayName = 'displayName';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateDefaultInterpolation
	 * @requires $interpolate
	 *
	 * @description
	 * Uses angular's `$interpolate` services to interpolate strings against some values.
	 *
	 * Be aware to configure a proper sanitization strategy.
	 *
	 * See also:
	 * * {@link pascalprecht.translate.$translateSanitization}
	 *
	 * @return {object} $translateDefaultInterpolation Interpolator service
	 */
	angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);
	
	function $translateDefaultInterpolation ($interpolate, $translateSanitization) {
	
	  'use strict';
	
	  var $translateInterpolator = {},
	      $locale,
	      $identifier = 'default';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */
	  $translateInterpolator.setLocale = function (locale) {
	    $locale = locale;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */
	  $translateInterpolator.getInterpolationIdentifier = function () {
	    return $identifier;
	  };
	
	  /**
	   * @deprecated will be removed in 3.0
	   * @see {@link pascalprecht.translate.$translateSanitization}
	   */
	  $translateInterpolator.useSanitizeValueStrategy = function (value) {
	    $translateSanitization.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Interpolates given value agains given interpolate params using angulars
	   * `$interpolate` service.
	   *
	   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
	   *
	   * @param {string} value translation
	   * @param {object} [interpolationParams={}] interpolation params
	   * @param {string} [context=undefined] current context (filter, directive, service)
	   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
	   * @param {string} translationId current translationId
	   *
	   * @returns {string} interpolated string
	   */
	  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
	    interpolationParams = interpolationParams || {};
	    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);
	
	    var interpolatedText;
	    if (angular.isNumber(value)) {
	      // numbers are safe
	      interpolatedText = '' + value;
	    } else if (angular.isString(value)) {
	      // strings must be interpolated (that's the job here)
	      interpolatedText = $interpolate(value)(interpolationParams);
	      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
	    } else {
	      // neither a number or a string, cant interpolate => empty string
	      interpolatedText = '';
	    }
	
	    return interpolatedText;
	  };
	
	  return $translateInterpolator;
	}
	
	$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';
	
	angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate
	 * @requires $interpolate,
	 * @requires $compile,
	 * @requires $parse,
	 * @requires $rootScope
	 * @restrict AE
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses $translate service to translate the translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate Translation id which could be either string or interpolated string.
	 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	 * @param {string=} translate-default will be used unless translation was successful
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
	 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre translate="TRANSLATION_ID"></pre>
	        <pre translate>TRANSLATION_ID</pre>
	        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	        <pre translate="{{translationId}}"></pre>
	        <pre translate>{{translationId}}</pre>
	        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('title')).toBe('Hello there!');
	
	          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translate', translateDirective);
	function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {
	
	  'use strict';
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  return {
	    restrict: 'AE',
	    scope: true,
	    priority: $translate.directivePriority(),
	    compile: function (tElement, tAttr) {
	
	      var translateValuesExist = (tAttr.translateValues) ?
	        tAttr.translateValues : undefined;
	
	      var translateInterpolation = (tAttr.translateInterpolation) ?
	        tAttr.translateInterpolation : undefined;
	
	      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
	        tAttr.translateSanitizeStrategy : undefined;
	
	      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
	
	      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
	          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';
	
	      return function linkFn(scope, iElement, iAttr) {
	
	        scope.interpolateParams = {};
	        scope.preText = '';
	        scope.postText = '';
	        scope.translateNamespace = getTranslateNamespace(scope);
	        var translationIds = {};
	
	        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
	          // initial setup
	          if (iAttr.translateValues) {
	            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
	          }
	          // initially fetch all attributes if existing and fill the params
	          if (translateValueExist) {
	            for (var attr in tAttr) {
	              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
	                interpolateParams[attributeName] = tAttr[attr];
	              }
	            }
	          }
	        };
	
	        // Ensures any change of the attribute "translate" containing the id will
	        // be re-stored to the scope's "translationId".
	        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	        var observeElementTranslation = function (translationId) {
	
	          // Remove any old watcher
	          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
	            observeElementTranslation._unwatchOld();
	            observeElementTranslation._unwatchOld = undefined;
	          }
	
	          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
	            var iElementText = trim.apply(iElement.text()).replace(/\n/g, ' ');
	
	            // Resolve translation id by inner html if required
	            var interpolateMatches = iElementText.match(interpolateRegExp);
	            // Interpolate translation id if required
	            if (angular.isArray(interpolateMatches)) {
	              scope.preText = interpolateMatches[1];
	              scope.postText = interpolateMatches[3];
	              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
	              var watcherMatches = iElementText.match(watcherRegExp);
	              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
	                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
	                  translationIds.translate = newValue;
	                  updateTranslations();
	                });
	              }
	            } else {
	              // do not assigne the translation id if it is empty.
	              translationIds.translate = !iElementText ? undefined : iElementText;
	            }
	          } else {
	            translationIds.translate = translationId;
	          }
	          updateTranslations();
	        };
	
	        var observeAttributeTranslation = function (translateAttr) {
	          iAttr.$observe(translateAttr, function (translationId) {
	            translationIds[translateAttr] = translationId;
	            updateTranslations();
	          });
	        };
	
	        // initial setup with values
	        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);
	
	        var firstAttributeChangedEvent = true;
	        iAttr.$observe('translate', function (translationId) {
	          if (typeof translationId === 'undefined') {
	            // case of element "<translate>xyz</translate>"
	            observeElementTranslation('');
	          } else {
	            // case of regular attribute
	            if (translationId !== '' || !firstAttributeChangedEvent) {
	              translationIds.translate = translationId;
	              updateTranslations();
	            }
	          }
	          firstAttributeChangedEvent = false;
	        });
	
	        for (var translateAttr in iAttr) {
	          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
	            observeAttributeTranslation(translateAttr);
	          }
	        }
	
	        iAttr.$observe('translateDefault', function (value) {
	          scope.defaultText = value;
	          updateTranslations();
	        });
	
	        if (translateSanitizeStrategyExist) {
	          iAttr.$observe('translateSanitizeStrategy', function (value) {
	            scope.sanitizeStrategy = $parse(value)(scope.$parent);
	            updateTranslations();
	          });
	        }
	
	        if (translateValuesExist) {
	          iAttr.$observe('translateValues', function (interpolateParams) {
	            if (interpolateParams) {
	              scope.$parent.$watch(function () {
	                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
	              });
	            }
	          });
	        }
	
	        if (translateValueExist) {
	          var observeValueAttribute = function (attrName) {
	            iAttr.$observe(attrName, function (value) {
	              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
	              scope.interpolateParams[attributeName] = value;
	            });
	          };
	          for (var attr in iAttr) {
	            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	              observeValueAttribute(attr);
	            }
	          }
	        }
	
	        // Master update function
	        var updateTranslations = function () {
	          for (var key in translationIds) {
	            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
	              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
	            }
	          }
	        };
	
	        // Put translation processing function outside loop
	        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
	          if (translationId) {
	            // if translation id starts with '.' and translateNamespace given, prepend namespace
	            if (translateNamespace && translationId.charAt(0) === '.') {
	              translationId = translateNamespace + translationId;
	            }
	
	            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
	              .then(function (translation) {
	                applyTranslation(translation, scope, true, translateAttr);
	              }, function (translationId) {
	                applyTranslation(translationId, scope, false, translateAttr);
	              });
	          } else {
	            // as an empty string cannot be translated, we can solve this using successful=false
	            applyTranslation(translationId, scope, false, translateAttr);
	          }
	        };
	
	        var applyTranslation = function (value, scope, successful, translateAttr) {
	          if (!successful) {
	            if (typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	          }
	          if (translateAttr === 'translate') {
	            // default translate into innerHTML
	            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
	              iElement.empty().append(scope.preText + value + scope.postText);
	            }
	            var globallyEnabled = $translate.isPostCompilingEnabled();
	            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
	            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
	            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
	              $compile(iElement.contents())(scope);
	            }
	          } else {
	            // translate attribute
	            var attributeName = iAttr.$attr[translateAttr];
	            if (attributeName.substr(0, 5) === 'data-') {
	              // ensure html5 data prefix is stripped
	              attributeName = attributeName.substr(5);
	            }
	            attributeName = attributeName.substr(15);
	            iElement.attr(attributeName, value);
	          }
	        };
	
	        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
	          scope.$watch('interpolateParams', updateTranslations, true);
	        }
	
	        // Replaced watcher on translateLanguage with event listener
	        scope.$on('translateLanguageChanged', updateTranslations);
	
	        // Ensures the text will be refreshed after the current language was changed
	        // w/ $translate.use(...)
	        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        // ensure translation will be looked up at least one
	        if (iElement.text().length) {
	          if (iAttr.translate) {
	            observeElementTranslation(iAttr.translate);
	          } else {
	            observeElementTranslation('');
	          }
	        } else if (iAttr.translate) {
	          // ensure attribute will be not skipped
	          observeElementTranslation(iAttr.translate);
	        }
	        updateTranslations();
	        scope.$on('$destroy', unbind);
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateDirective.displayName = 'translateDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate-attr
	 * @restrict A
	 *
	 * @description
	 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
	 * Internally it uses `translate` service to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
	 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('placeholder)).toBe('Hello there!');
	          expect(element.attr('title)).toBe('The following value is dynamic: 5');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translateAttr', translateAttrDirective);
	function translateAttrDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    priority: $translate.directivePriority(),
	    link: function linkFn(scope, element, attr) {
	
	      var translateAttr,
	          translateValues,
	          translateSanitizeStrategy,
	          previousAttributes = {};
	
	      // Main update translations function
	      var updateTranslations = function () {
	        angular.forEach(translateAttr, function (translationId, attributeName) {
	          if (!translationId) {
	            return;
	          }
	          previousAttributes[attributeName] = true;
	
	          // if translation id starts with '.' and translateNamespace given, prepend namespace
	          if (scope.translateNamespace && translationId.charAt(0) === '.') {
	            translationId = scope.translateNamespace + translationId;
	          }
	          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
	            .then(function (translation) {
	              element.attr(attributeName, translation);
	            }, function (translationId) {
	              element.attr(attributeName, translationId);
	            });
	        });
	
	        // Removing unused attributes that were previously used
	        angular.forEach(previousAttributes, function (flag, attributeName) {
	          if (!translateAttr[attributeName]) {
	            element.removeAttr(attributeName);
	            delete previousAttributes[attributeName];
	          }
	        });
	      };
	
	      // Watch for attribute changes
	      watchAttribute(
	        scope,
	        attr.translateAttr,
	        function (newValue) { translateAttr = newValue; },
	        updateTranslations
	      );
	      // Watch for value changes
	      watchAttribute(
	        scope,
	        attr.translateValues,
	        function (newValue) { translateValues = newValue; },
	        updateTranslations
	      );
	      // Watch for sanitize strategy changes
	      watchAttribute(
	        scope,
	        attr.translateSanitizeStrategy,
	        function (newValue) { translateSanitizeStrategy = newValue; },
	        updateTranslations
	      );
	
	      if (attr.translateValues) {
	        scope.$watch(attr.translateValues, updateTranslations, true);
	      }
	
	      // Replaced watcher on translateLanguage with event listener
	      scope.$on('translateLanguageChanged', updateTranslations);
	
	      // Ensures the text will be refreshed after the current language was changed
	      // w/ $translate.use(...)
	      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	      updateTranslations();
	      scope.$on('$destroy', unbind);
	    }
	  };
	}
	
	function watchAttribute(scope, attribute, valueCallback, changeCallback) {
	  'use strict';
	  if (!attribute) {
	    return;
	  }
	  if (attribute.substr(0, 2) === '::') {
	    attribute = attribute.substr(2);
	  } else {
	    scope.$watch(attribute, function(newValue) {
	      valueCallback(newValue);
	      changeCallback();
	    }, true);
	  }
	  valueCallback(scope.$eval(attribute));
	}
	
	translateAttrDirective.displayName = 'translateAttrDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateCloak
	 * @requires $translate
	 * @restrict A
	 *
	 * $description
	 * Adds a `translate-cloak` class name to the given element where this directive
	 * is applied initially and removes it, once a loader has finished loading.
	 *
	 * This directive can be used to prevent initial flickering when loading translation
	 * data asynchronously.
	 *
	 * The class name is defined in
	 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	 *
	 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	 *                                  or hiding the cloak. Basically it relies on the translation
	 *                                  resolve.
	 */
	.directive('translateCloak', translateCloakDirective);
	
	function translateCloakDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    compile : function (tElement) {
	      var applyCloak = function (element) {
	          element.addClass($translate.cloakClassName());
	        },
	        removeCloak = function (element) {
	          element.removeClass($translate.cloakClassName());
	        };
	      applyCloak(tElement);
	
	      return function linkFn(scope, iElement, iAttr) {
	        //Create bound functions that incorporate the active DOM element.
	        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
	        if (iAttr.translateCloak && iAttr.translateCloak.length) {
	          // Register a watcher for the defined translation allowing a fine tuned cloak
	          iAttr.$observe('translateCloak', function (translationId) {
	            $translate(translationId).then(iRemoveCloak, iApplyCloak);
	          });
	          $rootScope.$on('$translateChangeSuccess', function () {
	            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
	          });
	        } else {
	          $translate.onReady(iRemoveCloak);
	        }
	      };
	    }
	  };
	}
	
	translateCloakDirective.displayName = 'translateCloakDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateNamespace
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It is possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate namespace name which could be either string or interpolated string.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div translate-namespace="CONTENT">
	
	        <div>
	            <h1 translate>.HEADERS.TITLE</h1>
	            <h1 translate>.HEADERS.WELCOME</h1>
	        </div>
	
	        <div translate-namespace=".HEADERS">
	            <h1 translate>.TITLE</h1>
	            <h1 translate>.WELCOME</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'CONTENT': {
	            'HEADERS': {
	                TITLE: 'Title'
	            }
	          },
	          'CONTENT.HEADERS.WELCOME': 'Welcome'
	        }).preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateNamespace', translateNamespaceDirective);
	
	function translateNamespaceDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return {
	        pre: function (scope, iElement, iAttrs) {
	          scope.translateNamespace = _getTranslateNamespace(scope);
	
	          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
	            scope.translateNamespace += iAttrs.translateNamespace;
	          } else {
	            scope.translateNamespace = iAttrs.translateNamespace;
	          }
	        }
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function _getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return _getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateNamespaceDirective.displayName = 'translateNamespaceDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateLanguage
	 * @restrict A
	 *
	 * @description
	 * Forces the language to the directives in the underlying scope.
	 *
	 * @param {string=} translate language that will be negotiated.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div>
	
	        <div>
	            <h1 translate>HELLO</h1>
	        </div>
	
	        <div translate-language="de">
	            <h1 translate>HELLO</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider
	          .translations('en',{
	            'HELLO': 'Hello world!'
	          })
	          .translations('de',{
	            'HELLO': 'Hallo Welt!'
	          })
	          .preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateLanguage', translateLanguageDirective);
	
	function translateLanguageDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return function linkFn(scope, iElement, iAttrs) {
	
	        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
	          scope.translateLanguage = newTranslateLanguage;
	        });
	
	        scope.$watch('translateLanguage', function(){
	          scope.$broadcast('translateLanguageChanged');
	        });
	      };
	    }
	  };
	}
	
	translateLanguageDirective.displayName = 'translateLanguageDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc filter
	 * @name pascalprecht.translate.filter:translate
	 * @requires $parse
	 * @requires pascalprecht.translate.$translate
	 * @function
	 *
	 * @description
	 * Uses `$translate` service to translate contents. Accepts interpolate parameters
	 * to pass dynamized values though translation.
	 *
	 * @param {string} translationId A translation id to be translated.
	 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	 *
	 * @returns {string} Translated text.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	        <pre>{{ translationId | translate }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en', {
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        });
	        $translateProvider.preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	   </example>
	 */
	.filter('translate', translateFilterFactory);
	
	function translateFilterFactory($parse, $translate) {
	
	  'use strict';
	
	  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
	    if (!angular.isObject(interpolateParams)) {
	      var ctx = this || {
	        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
	        };
	      interpolateParams = $parse(interpolateParams)(ctx);
	    }
	
	    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
	  };
	
	  if ($translate.statefulFilter()) {
	    translateFilter.$stateful = true;
	  }
	
	  return translateFilter;
	}
	
	translateFilterFactory.displayName = 'translateFilterFactory';
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translationCache
	 * @requires $cacheFactory
	 *
	 * @description
	 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
	 * can load translation tables directly into the cache by consuming the
	 * `$translationCache` service directly.
	 *
	 * @return {object} $cacheFactory object.
	 */
	  .factory('$translationCache', $translationCache);
	
	function $translationCache($cacheFactory) {
	
	  'use strict';
	
	  return $cacheFactory('translations');
	}
	
	$translationCache.displayName = '$translationCache';
	return 'pascalprecht.translate';
	
	}));
	


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	module.exports = {
	  'UPDATE': 'Update',
	  'SAVE': 'Save',
	  'EDIT': 'Edit',
	  'SEND': 'Send',
	  'CLOSE': 'Close',
	  'CANCEL': 'Cancel',
	  'UNSUBSCRIBE': 'Unsubscribe',
	  'PROCESSING': 'Processing...',
	  'SHOW_MORE': 'More',
	  'CONFIRMATION_MSG': 'Are you sure?',
	  'OK': 'OK',
	  'SCORE': 'Score',
	  'PUTTS': 'Putts',
	  'YEAR': 'Year',
	  'MONTH': 'Month',
	  'DAY': 'Day',
	  'VALIDATION': {
	    'REQUIRED': 'This field is required.',
	    'MATCH': 'Confirmation does not match.',
	    'EMAIL': 'This email address is invalid.',
	    'MIN_LENGTH': "This field must at least {{ n }} characters and contain at least three of uppercase, lowercase, numbers, symbols.",
	    'MAX_LENGTH': "This field must be shorter than {{ n }} chars.",
	    'DATE': "Input valid date.",
	    'NUMERIC': "This field must be numeric.",
	    'MIN_VALUE': "This field must be greater than {{ n }}.",
	    'MAX_VALUE': "This field must be less than {{ n }}.",
	    'STRENGTH': "This field must at least 10 characters and contain at least three of uppercase, lowercase, numbers, symbols."
	  },
	  'API_SUCCESS': 'Your change was successfully saved',
	  'API_ERROR': 'Failed to save your changes. Please check inputs and try again.',
	  'EMAIL_DUPLICATED': 'This email address has already taken by another user. Please try another one.',
	  'NAME_DUPLICATED': 'This name is already registered. Please input another name.',
	  'CURRENT_PASSWORD_ERROR': 'The password you entered is wrong.',
	  'NO_ROUND': {
	    'LETS_CREATE': "Let's create your first scorecard!",
	    'CREATE_NOW': 'Create it now.'
	  },
	  'AGENCY_DENINED': "Agency request is in progress. So, you can't edit this scorecard."
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = {
	  'UPDATE': '更新',
	  'SAVE': '保存する',
	  'EDIT': '編集',
	  'SEND': '送信',
	  'CLOSE': '閉じる',
	  'CANCEL': 'キャンセル',
	  'UNSUBSCRIBE': '解約する',
	  'PROCESSING': '処理中...',
	  'SHOW_MORE': 'もっと見る',
	  'CONFIRMATION_MSG': '本当によろしいですか?',
	  'OK': 'OK',
	  'SCORE': 'スコア',
	  'PUTTS': 'パット',
	  'YEAR': '年',
	  'MONTH': '月',
	  'DAY': '日',
	  'VALIDATION': {
	    'REQUIRED': '入力必須です。',
	    'MATCH': '入力内容が一致しません。',
	    'EMAIL': '正しい email address を入力して下さい。',
	    'MIN_LENGTH': "英大文字・英小文字・数字・記号のうち3種以上かつ{{ n }} 桁以上(半角)で入力して下さい。",
	    'MAX_LENGTH': "{{ n }} 文字以下で入力して下さい。",
	    'DATE': "正しい日付を入力して下さい。",
	    'NUMERIC': "数値を入力して下さい。",
	    'MIN_VALUE': "{{ n }} より大きい値を入力して下さい。",
	    'MAX_VALUE': "{{ n }} より小さい値を入力して下さい。",
	    'STRENGTH': "英大文字・英小文字・数字・記号のうち3種以上かつ10桁以上(半角)で入力して下さい。"
	  },
	  'API_SUCCESS': '変更内容を保存しました。',
	  'API_ERROR': '変更内容の保存に失敗しました。入力内容を確認して再度お試し下さい。',
	  'EMAIL_DUPLICATED': '指定したメールアドレスは既に使われています。別のメールアドレスをご利用下さい。',
	  'NAME_DUPLICATED': 'その名前は既に登録されています。別の名前を入力してください。',
	  'CURRENT_PASSWORD_ERROR': '入力されたパスワードは間違っています。',
	  'NO_ROUND': {
	    'LETS_CREATE': 'ラウンド情報を登録しよう！',
	    'CREATE_NOW': 'スコア登録はコチラ'
	  },
	  'AGENCY_DENINED': "入力代行依頼中のため編集できません."
	};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	var BrowserService;
	
	BrowserService = function() {
	  return {
	    isSupportLocalStorage: function() {
	      var error, testKey;
	      testKey = 'localStorageTest';
	      try {
	        localStorage.setItem(testKey, testKey);
	        localStorage.removeItem(testKey);
	        return true;
	      } catch (error1) {
	        error = error1;
	        return false;
	      }
	    },
	    isSupportCookie: function() {
	      var cookieEnabled;
	      cookieEnabled = navigator.cookieEnabled ? true : false;
	      if (typeof navigator.cookieEnabled === 'undefined' && !cookieEnabled) {
	        document.cookie = 'testcookie';
	        cookieEnabled = document.cookie.indexOf('testcookie') !== -1 ? true : false;
	      }
	      return cookieEnabled;
	    }
	  };
	};
	
	module.exports = BrowserService;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	var BrowserInterceptor;
	
	BrowserInterceptor = function($filter, flash, BrowserService) {
	  var options;
	  options = {
	    timeOut: "0"
	  };
	  if (!BrowserService.isSupportCookie()) {
	    return flash.error($filter('translate')('_BROWSER.BLOCK_COOKIE_ALERT_MESSAGE'), options);
	  }
	  if (!BrowserService.isSupportLocalStorage()) {
	    return flash.error($filter('translate')('_BROWSER.PRIVATE_MODE_ALERT_MESSAGE'), options);
	  }
	};
	
	BrowserInterceptor.$inject = ['$filter', 'flash', 'BrowserService'];
	
	module.exports = BrowserInterceptor;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports = {
	  "_BROWSER": {
	    "PRIVATE_MODE_ALERT_MESSAGE": "This site doesn't support the private mode browsing. Please turn off the private mode and try again.",
	    "BLOCK_COOKIE_ALERT_MESSAGE": "You can't browse this site without cookie. Please allow using cookie on browser's privacy setting."
	  }
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = {
	  "_BROWSER": {
	    "PRIVATE_MODE_ALERT_MESSAGE": "本サイトはプライベートモードによるブラウジングをサポートしていません。お手数ですが、プライベートモードを無効にして再度お試し下さい。",
	    "BLOCK_COOKIE_ALERT_MESSAGE": "cookie が無効になっているためサイトを表示できません。お手数ですが「設定 > Safari > プライバシーとセキュリティ」から cookie を許可して、再度お試し下さい。"
	  }
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var SessionNewCtrl, modules;
	
	__webpack_require__(69);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(72);
	
	__webpack_require__(76);
	
	__webpack_require__(82);
	
	__webpack_require__(108);
	
	__webpack_require__(112);
	
	__webpack_require__(263);
	
	SessionNewCtrl = __webpack_require__(266);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-flash', 'gnp-auth', 'gnp-form', 'gnp-common-wrapper', 'gnp-error-handler'];
	
	angular.module("gnp-app-session", modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/session/new', {
	      templateUrl: 'web/session/new.jade',
	      controller: 'SessionNewCtrl',
	      title: '_SESSION.NEW.TITLE'
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(267)).translations('ja', __webpack_require__(268));
	  }
	]).controller('SessionNewCtrl', SessionNewCtrl);


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"new-main\" gnp-common-wrapper-b=\"\"><div class=\"bg-img\"><div class=\"container session\"><div class=\"row mx-0\"><div class=\"area col-12 col-md-7\"><div class=\"title-tag\"><img src=\"" + __webpack_require__(70) + "\"/></div><div class=\"display-image\"><img src=\"" + __webpack_require__(71) + "\"/></div></div><div class=\"frame col-12 col-md-5\"><div class=\"content-message\"></div><form name=\"newForm\" gnp-submit=\"submit(user)\" novalidate=\"\" class=\"newform\"><div class=\"row mx-0\"><div class=\"col-12 cell1\"><input type=\"email\" name=\"email\" ng-model=\"user.email\" placeholder=\"{{ ::'_SESSION.NEW.EMAIL_ADDR' | translate }}\" gnp-custom-email-validator=\"\" required=\"\" tabindex=\"1\"/><div ng-show=\"newForm.email.$invalid &amp;&amp; !newForm.email.$pristine\" class=\"error\"><span ng-show=\"newForm.email.$error.required\">{{ ::\"VALIDATION.REQUIRED\" | translate }}</span><span ng-show=\"newForm.email.$error.email\">{{ ::\"VALIDATION.EMAIL\" | translate }}</span></div></div></div><div class=\"row mx-0\"><div class=\"col-12 cell1\"><input type=\"password\" name=\"password\" ng-model=\"user.password\" placeholder=\"{{ ::'_SESSION.NEW.PASSWORD' | translate }}\" required=\"\" tabindex=\"2\"/><div ng-show=\"newForm.password.$invalid &amp;&amp; !newForm.password.$pristine\" class=\"error\"><span ng-show=\"newForm.password.$error.required\">{{ ::\"VALIDATION.REQUIRED\" | translate }}</span></div></div></div><button type=\"submit\" ng-model=\"locked\" gnp-submitting-button=\"isSubmitting\" gnp-button-diable=\"isDisable\" ng-disabled=\"locked == true\" analytics-on=\"click\" analytics-event=\"Login\" tabindex=\"3\" class=\"btn round-btn\">{{ ::'_SESSION.NEW.SIGN_IN' | translate }}</button><br/><p translate=\"_SESSION.NEW.LOGIN_GUIDE\" class=\"loggin-guide\"></p><p translate=\"_SESSION.NEW.LOGIN_GUIDE_TINY\" class=\"loggin-guide-tiny\"></p><a href=\"/password/new\" tabindex=\"4\" class=\"forgot\">{{ ::'_SESSION.NEW.FORGOT_PASSWORD' | translate }}</a><div class=\"sign_up\"><a href=\"/registration/email\" analytics-on=\"click\" analytics-event=\"Login_New_Id\" tabindex=\"5\" class=\"btn sign_up-btn\">{{ ::'_REGISTRATION.NEW.TITLE' | translate }}</a><p translate=\"_SESSION.NEW.SIGN_UP_SUP\" class=\"sign-up\"></p><p translate=\"_SESSION.NEW.SIGN_UP_SUP_TINY\" class=\"sign-up-tiny\"></p></div></form></div></div></div></div></div><script>$(document.body).css('min-width', 0)</script>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/session/new.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2d36fc092a54d57fda4636f2139785bd.png";

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var FlashService, modules;
	
	__webpack_require__(28);
	
	FlashService = __webpack_require__(73);
	
	modules = [];
	
	angular.module('gnp-flash', modules).factory('flash', FlashService);


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var FlashService, toastr;
	
	toastr = __webpack_require__(74);
	
	FlashService = function() {
	  toastr.options = {
	    closeButton: true,
	    positionClass: "toast-top-full-width",
	    showDuration: "300",
	    hideDuration: "1000",
	    timeOut: "5000",
	    extendedTimeOut: "1000",
	    preventDuplicates: true
	  };
	  return {
	    error: function(text, options) {
	      if (!options) {
	        toastr.error(text);
	      }
	      if (options) {
	        return toastr.error(text, '', options);
	      }
	    },
	    success: function(text) {
	      return toastr.success(text);
	    },
	    warning: function(text, options) {
	      if (!options) {
	        toastr.warning(text);
	      }
	      if (options) {
	        return toastr.warning(text, '', options);
	      }
	    }
	  };
	};
	
	module.exports = FlashService;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Toastr
	 * Copyright 2012-2015
	 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
	 * All Rights Reserved.
	 * Use, reproduction, distribution, and modification of this code is subject to the terms and
	 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
	 *
	 * ARIA Support: Greta Krafsig
	 *
	 * Project: https://github.com/CodeSeven/toastr
	 */
	/* global define */
	; (function (define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	        return (function () {
	            var $container;
	            var listener;
	            var toastId = 0;
	            var toastType = {
	                error: 'error',
	                info: 'info',
	                success: 'success',
	                warning: 'warning'
	            };
	
	            var toastr = {
	                clear: clear,
	                remove: remove,
	                error: error,
	                getContainer: getContainer,
	                info: info,
	                options: {},
	                subscribe: subscribe,
	                success: success,
	                version: '2.1.2',
	                warning: warning
	            };
	
	            var previousToast;
	
	            return toastr;
	
	            ////////////////
	
	            function error(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.error,
	                    iconClass: getOptions().iconClasses.error,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function getContainer(options, create) {
	                if (!options) { options = getOptions(); }
	                $container = $('#' + options.containerId);
	                if ($container.length) {
	                    return $container;
	                }
	                if (create) {
	                    $container = createContainer(options);
	                }
	                return $container;
	            }
	
	            function info(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.info,
	                    iconClass: getOptions().iconClasses.info,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function subscribe(callback) {
	                listener = callback;
	            }
	
	            function success(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.success,
	                    iconClass: getOptions().iconClasses.success,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function warning(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.warning,
	                    iconClass: getOptions().iconClasses.warning,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function clear($toastElement, clearOptions) {
	                var options = getOptions();
	                if (!$container) { getContainer(options); }
	                if (!clearToast($toastElement, options, clearOptions)) {
	                    clearContainer(options);
	                }
	            }
	
	            function remove($toastElement) {
	                var options = getOptions();
	                if (!$container) { getContainer(options); }
	                if ($toastElement && $(':focus', $toastElement).length === 0) {
	                    removeToast($toastElement);
	                    return;
	                }
	                if ($container.children().length) {
	                    $container.remove();
	                }
	            }
	
	            // internal functions
	
	            function clearContainer (options) {
	                var toastsToClear = $container.children();
	                for (var i = toastsToClear.length - 1; i >= 0; i--) {
	                    clearToast($(toastsToClear[i]), options);
	                }
	            }
	
	            function clearToast ($toastElement, options, clearOptions) {
	                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
	                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
	                    $toastElement[options.hideMethod]({
	                        duration: options.hideDuration,
	                        easing: options.hideEasing,
	                        complete: function () { removeToast($toastElement); }
	                    });
	                    return true;
	                }
	                return false;
	            }
	
	            function createContainer(options) {
	                $container = $('<div/>')
	                    .attr('id', options.containerId)
	                    .addClass(options.positionClass)
	                    .attr('aria-live', 'polite')
	                    .attr('role', 'alert');
	
	                $container.appendTo($(options.target));
	                return $container;
	            }
	
	            function getDefaults() {
	                return {
	                    tapToDismiss: true,
	                    toastClass: 'toast',
	                    containerId: 'toast-container',
	                    debug: false,
	
	                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
	                    showDuration: 300,
	                    showEasing: 'swing', //swing and linear are built into jQuery
	                    onShown: undefined,
	                    hideMethod: 'fadeOut',
	                    hideDuration: 1000,
	                    hideEasing: 'swing',
	                    onHidden: undefined,
	                    closeMethod: false,
	                    closeDuration: false,
	                    closeEasing: false,
	
	                    extendedTimeOut: 1000,
	                    iconClasses: {
	                        error: 'toast-error',
	                        info: 'toast-info',
	                        success: 'toast-success',
	                        warning: 'toast-warning'
	                    },
	                    iconClass: 'toast-info',
	                    positionClass: 'toast-top-right',
	                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
	                    titleClass: 'toast-title',
	                    messageClass: 'toast-message',
	                    escapeHtml: false,
	                    target: 'body',
	                    closeHtml: '<button type="button">&times;</button>',
	                    newestOnTop: true,
	                    preventDuplicates: false,
	                    progressBar: false
	                };
	            }
	
	            function publish(args) {
	                if (!listener) { return; }
	                listener(args);
	            }
	
	            function notify(map) {
	                var options = getOptions();
	                var iconClass = map.iconClass || options.iconClass;
	
	                if (typeof (map.optionsOverride) !== 'undefined') {
	                    options = $.extend(options, map.optionsOverride);
	                    iconClass = map.optionsOverride.iconClass || iconClass;
	                }
	
	                if (shouldExit(options, map)) { return; }
	
	                toastId++;
	
	                $container = getContainer(options, true);
	
	                var intervalId = null;
	                var $toastElement = $('<div/>');
	                var $titleElement = $('<div/>');
	                var $messageElement = $('<div/>');
	                var $progressElement = $('<div/>');
	                var $closeElement = $(options.closeHtml);
	                var progressBar = {
	                    intervalId: null,
	                    hideEta: null,
	                    maxHideTime: null
	                };
	                var response = {
	                    toastId: toastId,
	                    state: 'visible',
	                    startTime: new Date(),
	                    options: options,
	                    map: map
	                };
	
	                personalizeToast();
	
	                displayToast();
	
	                handleEvents();
	
	                publish(response);
	
	                if (options.debug && console) {
	                    console.log(response);
	                }
	
	                return $toastElement;
	
	                function escapeHtml(source) {
	                    if (source == null)
	                        source = "";
	
	                    return new String(source)
	                        .replace(/&/g, '&amp;')
	                        .replace(/"/g, '&quot;')
	                        .replace(/'/g, '&#39;')
	                        .replace(/</g, '&lt;')
	                        .replace(/>/g, '&gt;');
	                }
	
	                function personalizeToast() {
	                    setIcon();
	                    setTitle();
	                    setMessage();
	                    setCloseButton();
	                    setProgressBar();
	                    setSequence();
	                }
	
	                function handleEvents() {
	                    $toastElement.hover(stickAround, delayedHideToast);
	                    if (!options.onclick && options.tapToDismiss) {
	                        $toastElement.click(hideToast);
	                    }
	
	                    if (options.closeButton && $closeElement) {
	                        $closeElement.click(function (event) {
	                            if (event.stopPropagation) {
	                                event.stopPropagation();
	                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
	                                event.cancelBubble = true;
	                            }
	                            hideToast(true);
	                        });
	                    }
	
	                    if (options.onclick) {
	                        $toastElement.click(function (event) {
	                            options.onclick(event);
	                            hideToast();
	                        });
	                    }
	                }
	
	                function displayToast() {
	                    $toastElement.hide();
	
	                    $toastElement[options.showMethod](
	                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
	                    );
	
	                    if (options.timeOut > 0) {
	                        intervalId = setTimeout(hideToast, options.timeOut);
	                        progressBar.maxHideTime = parseFloat(options.timeOut);
	                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
	                        if (options.progressBar) {
	                            progressBar.intervalId = setInterval(updateProgress, 10);
	                        }
	                    }
	                }
	
	                function setIcon() {
	                    if (map.iconClass) {
	                        $toastElement.addClass(options.toastClass).addClass(iconClass);
	                    }
	                }
	
	                function setSequence() {
	                    if (options.newestOnTop) {
	                        $container.prepend($toastElement);
	                    } else {
	                        $container.append($toastElement);
	                    }
	                }
	
	                function setTitle() {
	                    if (map.title) {
	                        $titleElement.append(!options.escapeHtml ? map.title : escapeHtml(map.title)).addClass(options.titleClass);
	                        $toastElement.append($titleElement);
	                    }
	                }
	
	                function setMessage() {
	                    if (map.message) {
	                        $messageElement.append(!options.escapeHtml ? map.message : escapeHtml(map.message)).addClass(options.messageClass);
	                        $toastElement.append($messageElement);
	                    }
	                }
	
	                function setCloseButton() {
	                    if (options.closeButton) {
	                        $closeElement.addClass('toast-close-button').attr('role', 'button');
	                        $toastElement.prepend($closeElement);
	                    }
	                }
	
	                function setProgressBar() {
	                    if (options.progressBar) {
	                        $progressElement.addClass('toast-progress');
	                        $toastElement.prepend($progressElement);
	                    }
	                }
	
	                function shouldExit(options, map) {
	                    if (options.preventDuplicates) {
	                        /* original code
	                        if (map.message === previousToast) {
	                            return true;
	                        } else {
	                            previousToast = map.message;
	                        }*/
	                        var exists = false;
	                        $('.toast .toast-message').each(function(i, el) {
	                           var prev = $(el).html();
	                           if (prev === map.message) {
	                              exists = true;
	                           }
	                        });
	                        return exists;
	                    }
	                    return false;
	                }
	
	                function hideToast(override) {
	                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
	                    var duration = override && options.closeDuration !== false ?
	                        options.closeDuration : options.hideDuration;
	                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
	                    if ($(':focus', $toastElement).length && !override) {
	                        return;
	                    }
	                    clearTimeout(progressBar.intervalId);
	                    return $toastElement[method]({
	                        duration: duration,
	                        easing: easing,
	                        complete: function () {
	                            removeToast($toastElement);
	                            if (options.onHidden && response.state !== 'hidden') {
	                                options.onHidden();
	                            }
	                            response.state = 'hidden';
	                            response.endTime = new Date();
	                            publish(response);
	                        }
	                    });
	                }
	
	                function delayedHideToast() {
	                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
	                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
	                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
	                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
	                    }
	                }
	
	                function stickAround() {
	                    clearTimeout(intervalId);
	                    progressBar.hideEta = 0;
	                    $toastElement.stop(true, true)[options.showMethod](
	                        {duration: options.showDuration, easing: options.showEasing}
	                    );
	                }
	
	                function updateProgress() {
	                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
	                    $progressElement.width(percentage + '%');
	                }
	            }
	
	            function getOptions() {
	                return $.extend({}, getDefaults(), toastr.options);
	            }
	
	            function removeToast($toastElement) {
	                if (!$container) { $container = getContainer(); }
	                if ($toastElement.is(':visible')) {
	                    return;
	                }
	                $toastElement.remove();
	                $toastElement = null;
	                if ($container.children().length === 0) {
	                    $container.remove();
	                    previousToast = undefined;
	                }
	            }
	
	        })();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(75)));


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var AuthInterceptor, AuthLocationInterceptor, AuthService, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(72);
	
	__webpack_require__(77);
	
	AuthInterceptor = __webpack_require__(79);
	
	AuthLocationInterceptor = __webpack_require__(80);
	
	AuthService = __webpack_require__(81);
	
	modules = ['gnp-flash', 'gnp-session', 'ngCookies'];
	
	angular.module('gnp-auth', modules).config([
	  '$httpProvider', function($httpProvider) {
	    return $httpProvider.interceptors.push('AuthInterceptor');
	  }
	]).factory('AuthInterceptor', AuthInterceptor).factory('AuthService', AuthService).value('returnUrl', {
	  url: '/',
	  external: false
	}).run(AuthLocationInterceptor);


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var SessionService;
	
	__webpack_require__(28);
	
	SessionService = __webpack_require__(78);
	
	angular.module('gnp-session', []).factory('SessionService', SessionService);


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	var SessionService;
	
	SessionService = function($http) {
	  return {
	    create: function(email, password) {
	      return $http.post('/api/users/sign_in.json', {
	        email: email,
	        password: password
	      });
	    },
	    destroy: function() {
	      return $http["delete"]('/api/users/sign_out.json');
	    }
	  };
	};
	
	SessionService.$inject = ['$http'];
	
	module.exports = SessionService;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	var AuthInterceptor;
	
	AuthInterceptor = function($q, $location, flash, returnUrl) {
	  var saveReturnUrl;
	  saveReturnUrl = function() {
	    if ($location.path() === '/session/new') {
	      return returnUrl.url = '/';
	    } else {
	      return returnUrl.url = $location.path();
	    }
	  };
	  return {
	    response: function(response) {
	      return response || $q.when(response);
	    },
	    responseError: function(rejection) {
	      switch (false) {
	        case rejection.status !== 401:
	          saveReturnUrl();
	          localStorage.removeItem("isSignedIn");
	          $location.path('/session/new');
	          return rejection;
	      }
	      return $q.reject(rejection);
	    }
	  };
	};
	
	AuthInterceptor.$inject = ['$q', '$location', 'flash', 'returnUrl'];
	
	module.exports = AuthInterceptor;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	var AuthLocationInterceptor;
	
	AuthLocationInterceptor = function($rootScope, $location, returnUrl, AuthService) {
	  var signInRequired;
	  signInRequired = function(route) {
	    var ref, ref1;
	    return route != null ? (ref = route.$$route) != null ? (ref1 = ref.permission) != null ? ref1.signInRequired : void 0 : void 0 : void 0;
	  };
	  return $rootScope.$on("$routeChangeStart", function(event, next, current) {
	    if (AuthService.isSignedIn()) {
	      return;
	    }
	    if (!signInRequired(next)) {
	      return;
	    }
	    returnUrl.url = $location.path();
	    event.preventDefault();
	    return $location.path('/session/new');
	  });
	};
	
	AuthLocationInterceptor.$inject = ['$rootScope', '$location', 'returnUrl', 'AuthService'];
	
	module.exports = AuthLocationInterceptor;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	var AuthService;
	
	AuthService = function($rootScope, $location, $window, returnUrl, $cookies, SessionService, $q) {
	  var afterSignedIn;
	  afterSignedIn = function() {
	    $rootScope.$broadcast("signedIn.gnp.authService");
	    localStorage.setItem("isSignedIn", true);
	    return $cookies.remove('loginAttempt');
	  };
	  return {
	    signIn: function(email, password) {
	      return SessionService.create(email, password).then(function() {
	        afterSignedIn();
	        if (returnUrl.external) {
	          return $window.location = returnUrl.url;
	        } else {
	          $location.path(returnUrl.url);
	          return returnUrl.url = '/';
	        }
	      });
	    },
	    signInBypass: function() {
	      return afterSignedIn();
	    },
	    signOut: function() {
	      return SessionService.destroy().then(function() {
	        localStorage.clear();
	        $rootScope.$broadcast("signedOut.gnp.authService");
	        return $location.path('/session/new');
	      });
	    },
	    isSignedIn: function() {
	      return localStorage.getItem("isSignedIn");
	    }
	  };
	};
	
	AuthService.$inject = ['$rootScope', '$location', '$window', 'returnUrl', '$cookies', 'SessionService', '$q'];
	
	module.exports = AuthService;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var CommonWrapperADirective, CommonWrapperBDirective, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(72);
	
	__webpack_require__(83);
	
	__webpack_require__(99);
	
	CommonWrapperADirective = __webpack_require__(104);
	
	CommonWrapperBDirective = __webpack_require__(106);
	
	modules = ['gnp-flash', 'gnp-common-header', 'gnp-common-footer'];
	
	angular.module('gnp-common-wrapper', modules).directive('gnpCommonWrapperA', CommonWrapperADirective).directive('gnpCommonWrapperB', CommonWrapperBDirective);


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var CommonHeaderDirective, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(76);
	
	__webpack_require__(59);
	
	__webpack_require__(84);
	
	__webpack_require__(89);
	
	__webpack_require__(90);
	
	CommonHeaderDirective = __webpack_require__(94);
	
	modules = ['gnp-auth', 'gnp-navigation-header', 'gnp-account'];
	
	angular.module('gnp-common-header', modules).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(97)).translations('ja', __webpack_require__(98));
	  }
	]).directive('gnpCommonHeader', CommonHeaderDirective);


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var NavigationHeaderDirective, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(59);
	
	__webpack_require__(76);
	
	__webpack_require__(83);
	
	NavigationHeaderDirective = __webpack_require__(85);
	
	modules = ['gnp-auth', 'gnp-translation'];
	
	angular.module('gnp-navigation-header', modules).directive('gnpNavigationHeader', NavigationHeaderDirective);


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var GROUP_PATH_REGEX, NavigationHeaderDirective, _, pathsToShow;
	
	__webpack_require__(86);
	
	_ = __webpack_require__(87);
	
	pathsToShow = ['/', '/history', '/analysis', '/groups'];
	
	GROUP_PATH_REGEX = /^\/groups\/.*|\/group-event\/.*|\/analysis-event\/.*$/;
	
	NavigationHeaderDirective = function($location) {
	  return {
	    restrict: 'A',
	    replace: false,
	    templateUrl: 'components/navigation-header/navigation-header.jade',
	    require: '^gnp-common-header',
	    link: function(scope, element, attrs, commonHeaderCtrl) {
	      var haveGroup, path, showNavigation;
	      path = $location.path();
	      showNavigation = _.includes(pathsToShow, path);
	      haveGroup = GROUP_PATH_REGEX.test(path);
	      if (haveGroup) {
	        showNavigation = haveGroup;
	      }
	      commonHeaderCtrl.includeNavigation(showNavigation);
	      scope.mixPanelEventPrefix = path === '/' ? 'DSB' : path === '/history' ? 'HST' : path === '/groups' ? 'GRP' : 'ANL';
	      scope.showNavigation = showNavigation;
	      scope.canHighlight = function(path) {
	        return $location.path() === path || (path === '/groups' && GROUP_PATH_REGEX.test($location.path()));
	      };
	      return scope.showRegisGroup = function() {
	        return scope.canHighlight('/groups');
	      };
	    }
	  };
	};
	
	NavigationHeaderDirective.$inject = ["$location"];
	
	module.exports = NavigationHeaderDirective;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	var v1="<div ng-if=\"showNavigation &amp;&amp; canHighlight('/groups')\" class=\"submenu\"><div class=\"d-none d-sm-block\"><a ng-if=\"!canHighlight('/groups')\" href=\"/score-registration\" ng-class=\"{'free': !$root.paid}\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_ScoreEntry'}}\" class=\"btn-add-score\">{{:: '_SCORE_REGISTRATION.TITLE' | translate }}</a><a ng-if=\"showRegisGroup()\" href=\"/groups/registration\" class=\"btn-add-group\">{{:: '_GROUP.CREATE_GROUP' | translate }}</a><a href=\"/\" ng-class=\"{'active': canHighlight('/')}\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_Dashboard'}}\" class=\"menu dashboard\">{{:: '_DASHBOARD.TITLE' | translate }}</a><a href=\"/history{{getUserId()}}\" ng-class=\"{'active': canHighlight('/history')}\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_History'}}\" class=\"menu history\">{{:: '_HISTORY.TITLE' | translate }}</a><a href=\"/analysis{{getUserId()}}\" ng-class=\"{'active': canHighlight('/analysis')}\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_Analytics'}}\" class=\"menu analysis\">{{:: '_ANALYSIS.TITLE' | translate }}</a><a href=\"/groups\" ng-class=\"{'active': canHighlight('/groups')}\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_Group'}}\" class=\"menu groups\">{{:: '_GROUP.TITLE' | translate }}</a><a href=\"/score-registration/index\" ng-hide=\"$root.paid || canHighlight('/groups')\" class=\"help-circle header\"></a></div><div class=\"d-block d-sm-none\"><nav class=\"navbar navbar-light fixed-top subMobile\"><div class=\"container-fluid\"><ul class=\"nav nav-pills\"><li ng-class=\"{'activeTab': canHighlight('/')}\" class=\"dashboard\"><a href=\"/\"><span>{{:: '_DASHBOARD.TITLE' | translate }}</span></a></li><li ng-class=\"{'activeTab': canHighlight('/history')}\" class=\"history\"><a href=\"/history{{getUserId()}}\"><span>{{:: '_HISTORY.TITLE' | translate }}</span></a></li><li ng-class=\"{'activeTab': canHighlight('/analysis')}\" class=\"analysis\"><a href=\"/analysis{{getUserId()}}\"><span>{{:: '_ANALYSIS.TITLE' | translate }}</span></a></li><li ng-class=\"{'activeTab': canHighlight('/groups')}\" class=\"groups\"><a href=\"/groups\"><span>{{:: '_GROUP.TITLE' | translate }}</span></a></li></ul></div></nav></div></div><div ng-if=\"showNavigation &amp;&amp; !canHighlight('/groups')\" class=\"submenu\"><div class=\"d-none d-sm-block\"><a href=\"/score-registration\" ng-class=\"{'free': !$root.paid}\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_ScoreEntry'}}\" class=\"btn-add-score\">{{:: '_SCORE_REGISTRATION.TITLE' | translate }}</a><a href=\"/\" ng-class=\"{'active': canHighlight('/')}\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_Dashboard'}}\" class=\"menu dashboard\">{{:: '_DASHBOARD.TITLE' | translate }}</a><a href=\"/history{{getUserId()}}\" ng-class=\"{'active': canHighlight('/history')}\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_History'}}\" class=\"menu history\">{{:: '_HISTORY.TITLE' | translate }}</a><a href=\"/analysis{{getUserId()}}\" ng-class=\"{'active': canHighlight('/analysis')}\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_Analytics'}}\" class=\"menu analysis\">{{:: '_ANALYSIS.TITLE' | translate }}</a><a href=\"/groups\" ng-class=\"{'active': canHighlight('/groups')}\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_Group'}}\" class=\"menu groups\">{{:: '_GROUP.TITLE' | translate }}</a><a href=\"/score-registration/index\" ng-hide=\"$root.paid\" class=\"help-circle header\"></a></div><div class=\"d-block d-sm-none\"><nav class=\"navbar navbar-light fixed-top subMobile\"><div class=\"container-fluid\"><ul class=\"nav nav-pills\"><li ng-class=\"{'activeTab': canHighlight('/')}\" class=\"col-3 no-padding dashboard\"><a href=\"/\"><span>{{:: '_DASHBOARD.TITLE' | translate }}</span></a></li><li ng-class=\"{'activeTab': canHighlight('/history')}\" class=\"col-3 no-padding history\"><a href=\"/history{{getUserId()}}\"><span>{{:: '_HISTORY.TITLE' | translate }}</span></a></li><li ng-class=\"{'activeTab': canHighlight('/analysis')}\" class=\"col-3 no-padding analysis\"><a href=\"/analysis{{getUserId()}}\"><span>{{:: '_ANALYSIS.TITLE' | translate }}</span></a></li><li ng-class=\"{'activeTab': canHighlight('/groups')}\" class=\"col-3 no-padding groups\"><a href=\"/groups\"><span>{{:: '_GROUP.TITLE' | translate }}</span></a></li></ul></div></nav></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/navigation-header/navigation-header.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(88)(module)))

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28);
	
	angular.module('gnp-cache', []).factory('cache', [
	  '$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('gnp-data');
	  }
	]);


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var AccountService, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(89);
	
	__webpack_require__(59);
	
	AccountService = __webpack_require__(91);
	
	modules = ['gnp-translation', 'gnp-cache'];
	
	angular.module('gnp-account', modules).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(92)).translations('ja', __webpack_require__(93));
	  }
	]).factory('AccountService', AccountService);


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var AccountService, _;
	
	_ = __webpack_require__(87);
	
	AccountService = function($rootScope, $http, $q, $location, $filter, $translate, cache, flash) {
	  var acceptTerms, getFullName, getUserInfo, removeUserInfo, setConfirmationStatus, showConfirmationWarning;
	  $rootScope.$on('signedIn.gnp.authService', function() {
	    return getUserInfo();
	  });
	  $rootScope.$on('signedOut.gnp.authService', function() {
	    return removeUserInfo();
	  });
	  $rootScope.$on('accountUpdated.gnp.AccountService', function() {
	    removeUserInfo();
	    return getUserInfo();
	  });
	  getFullName = function(data) {
	    if (!data.last_name) {
	      return $filter('translate')('ACCOUNT.NO_NAME');
	    }
	    if (!data.first_name) {
	      return $filter('translate')('ACCOUNT.NO_NAME');
	    }
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      return data.last_name + " " + data.first_name;
	    } else {
	      return data.first_name + " " + data.last_name;
	    }
	  };
	  removeUserInfo = function() {
	    return cache.remove('userInfo');
	  };
	  getUserInfo = function() {
	    var delay, userInfo;
	    userInfo = cache.get('userInfo');
	    delay = $q.defer();
	    if (!userInfo) {
	      $http.get('/api/settings/account.json').then(function(resp) {
	        var mergedData;
	        mergedData = _.merge(resp.data, {
	          name: getFullName(resp.data)
	        });
	        cache.put('userInfo', mergedData);
	        delay.resolve(mergedData);
	        return $rootScope.$broadcast('accountLoaded.gnp.AccountService', mergedData);
	      }, function(error) {
	        return delay.resolve(null);
	      });
	    } else {
	      delay.resolve(userInfo);
	    }
	    return delay.promise;
	  };
	  acceptTerms = function() {
	    var delay;
	    delay = $q.defer();
	    $http.put('/api/settings/account/terms_of_use.json').success(function(data) {
	      var userInfo;
	      userInfo = cache.get('userInfo');
	      userInfo.has_accept_terms_of_use = true;
	      cache.put('userInfo', userInfo);
	      return delay.resolve(null);
	    }).error(function(data) {
	      return delay.resolve(null);
	    });
	    return delay.promise;
	  };
	  setConfirmationStatus = function() {
	    var userInfo;
	    userInfo = cache.get('userInfo');
	    if (userInfo) {
	      userInfo.email_confirmed = true;
	      return cache.put('userInfo', userInfo);
	    }
	  };
	  showConfirmationWarning = function() {
	    var notDisplayPaths, notShowed, options, userInfo;
	    notDisplayPaths = ['/email_confirmation/new', '/email_confirmation/edit'];
	    notShowed = _.remove(notDisplayPaths, function(n) {
	      return $location.path().indexOf(n) !== -1;
	    }).length > 0;
	    if (notShowed) {
	      return;
	    }
	    userInfo = cache.get('userInfo');
	    if (userInfo != null ? userInfo.email_confirmed : void 0) {
	      return;
	    }
	    options = {
	      timeOut: '0',
	      extendedTimeOut: '0',
	      tapToDismiss: false,
	      onShown: function() {
	        var $this;
	        $this = angular.element(this);
	        return $this.on('click', function() {
	          $location.path('/email_confirmation/new');
	          return $this.remove();
	        });
	      }
	    };
	    return flash.warning("<a href=\"/email_confirmation/new\">\n" + ($filter('translate')('_CONFIRMATION.NOTIFICATION.TEXT')) + "\n</a>", options);
	  };
	  return {
	    getUserInfo: getUserInfo,
	    showConfirmationWarning: showConfirmationWarning,
	    setConfirmationStatus: setConfirmationStatus,
	    acceptTerms: acceptTerms
	  };
	};
	
	AccountService.$inject = ['$rootScope', '$http', '$q', '$location', '$filter', '$translate', 'cache', 'flash'];
	
	module.exports = AccountService;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	module.exports = {
	  'ACCOUNT': {
	    'NO_NAME': 'No Name'
	  }
	};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = {
	  'ACCOUNT': {
	    'NO_NAME': '名前未設定'
	  }
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var $, CommonHeaderDirective, ICON_USER, MENU_TOOLTIP, sampleUserAvatar;
	
	__webpack_require__(95);
	
	sampleUserAvatar = __webpack_require__(96);
	
	$ = __webpack_require__(1);
	
	ICON_USER = '.user';
	
	MENU_TOOLTIP = '.tooltip-help2';
	
	CommonHeaderDirective = function($location, AuthService, AccountService, $filter) {
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "components/common-header/common-header.jade",
	    controller: [
	      '$scope', function($scope) {
	        $scope.hasAcceptedTerms = false;
	        this.includeNavigation = function(showNavigation) {
	          return $scope.showNavigation = showNavigation;
	        };
	      }
	    ],
	    link: function(scope) {
	      var currentPath, isMenuElement;
	      scope.sampleUserAvatar = sampleUserAvatar;
	      scope.isSignedIn = AuthService.isSignedIn();
	      scope.userInfo = void 0;
	      scope.showMenu = false;
	      scope.admin = false;
	      scope.smallMenu = false;
	      scope.toggleMenu = function() {
	        return scope.showMenu = !scope.showMenu;
	      };
	      scope.showSmallMenu = function() {
	        var itemFade;
	        scope.smallMenu = !scope.smallMenu;
	        if (scope.smallMenu) {
	          itemFade = '<div id="fadeBackground" ';
	          itemFade += 'style = "top: 0; left: 0; ';
	          itemFade += 'position : absolute ; background-color:white; opacity : 0.6 ; z-index: 100; ';
	          itemFade += 'width: ' + $(document).width() + "px ; ";
	          itemFade += 'height: ' + $(document).height() + "px ; ";
	          itemFade += '" ></div>';
	          $("body").append(itemFade);
	          $("body").css("overflow", "hidden");
	          return true;
	        } else {
	          $("#fadeBackground").remove();
	          $("body").css("overflow", "auto");
	          return true;
	        }
	      };
	      scope.signOut = function() {
	        return AuthService.signOut();
	      };
	      scope.editAccount = function() {
	        return $location.path("/registration/edit");
	      };
	      scope.getFullName = function() {
	        var ref;
	        if (scope.userInfo) {
	          return (ref = scope.userInfo) != null ? ref.name : void 0;
	        } else {
	          return "";
	        }
	      };
	      scope.getUserId = function() {
	        var ref;
	        if (scope.userInfo) {
	          return '?user_id=' + ((ref = scope.userInfo) != null ? ref.user_id : void 0);
	        } else {
	          return "";
	        }
	      };
	      scope.submitTerms = function() {
	        return AccountService.acceptTerms().then(function(data) {
	          scope.hasAcceptedTerms = false;
	          return $('#terms_of_use-modal').modal('hide');
	        });
	      };
	      scope.getTextOfAvatar = function() {
	        if (!scope.userInfo) {
	          return;
	        }
	        $(document).ready(function() {
	          var $avatarElement, ref;
	          $avatarElement = $(".avatar-for-" + scope.userInfo.user_id + " .avatar-image-text:not(.is-small)");
	          if (((ref = scope.userInfo.display_text_avatar) != null ? ref.length : void 0) === 1) {
	            $avatarElement.removeClass('two-characters');
	            return $avatarElement.addClass('one-character');
	          } else {
	            $avatarElement.removeClass('one-character');
	            $avatarElement.addClass('two-characters');
	            return $(".avatar-image-text.is-small").addClass('two-characters');
	          }
	        });
	        return scope.userInfo.display_text_avatar;
	      };
	      scope.isAvatarColor = function() {
	        var ref;
	        if (!scope.userInfo) {
	          return;
	        }
	        return ((ref = scope.userInfo.avatar_image_path) != null ? ref.indexOf('avatar_color') : void 0) > -1;
	      };
	      if (scope.isSignedIn) {
	        AccountService.getUserInfo().then(function(data) {
	          scope.userInfo = data;
	          if (!data.has_accept_terms_of_use) {
	            $('#terms_of_use-modal').modal({
	              backdrop: 'static',
	              keyboard: false,
	              show: true
	            });
	          }
	          scope.admin = data.admin;
	          if (!data.email_confirmed) {
	            return AccountService.showConfirmationWarning(data.email);
	          }
	        });
	      }
	      scope.$on("accountLoaded.gnp.AccountService", function(e, userInfo) {
	        return scope.userInfo = userInfo;
	      });
	      isMenuElement = function($target) {
	        return $target.is(ICON_USER) || $target.parents(MENU_TOOLTIP).length || $target.is(MENU_TOOLTIP);
	      };
	      scope.$on('$destroy', function() {
	        $("#fadeBackground").remove();
	        $("body").css("overflow", "auto");
	        return scope.showMenu = false;
	      });
	      angular.element(window).bind('resize', function() {
	        if (window.innerWidth > 768) {
	          $("#fadeBackground").remove();
	          $("body").css("overflow", "auto");
	          return scope.$apply(function() {
	            return scope.smallMenu = false;
	          });
	        }
	      });
	      angular.element(document).ready(function() {
	        return document.body.scrollTop = document.documentElement.scrollTop = 0;
	      });
	      if (localStorage.getItem("TRANSITION_FROM_ANALYSIS")) {
	        currentPath = $location.absUrl();
	        if (currentPath.indexOf('/analysis') === -1 && currentPath.indexOf('/round-detail') === -1) {
	          return localStorage.removeItem("TRANSITION_FROM_ANALYSIS");
	        }
	      }
	    }
	  };
	};
	
	CommonHeaderDirective.$inject = ["$location", "AuthService", "AccountService", "$filter"];
	
	module.exports = CommonHeaderDirective;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	var v1="<div id=\"main-main\"><div id=\"gnp-header\" ng-class=\"{'with-submenu': showNavigation}\" class=\"{{ (hideHeader || clubHeader) ? 'hide-header' : ''}}\"><div class=\"fixed-bg-white d-none d-md-block\"><div class=\"container dashboard-container\"><a href=\"/\" analytics-on=\"click\" analytics-event=\"HDR_Logo\"><div class=\"logo\"></div></a><div class=\"ad d-none d-md-block\"><div id=\"div-gpt-ad-1415762440441-0\" style=\"width:468px; height:60px\"><script type=\"text/javascript\">googletag.cmd.push(function() { googletag.display('div-gpt-ad-1415762440441-0'); });</script></div></div><div class=\"btn-section\"><a href=\"/\" ng-if=\"isSignedIn\" analytics-on=\"click\" analytics-event=\"HDR_Myscorebook\" class=\"myscore link-button\">{{:: 'COMMONHEADER.MYSCOREBOOK' | translate }}</a><a href=\"http://www.golfnetwork.co.jp/magazine/\" target=\"_blank\" analytics-on=\"click\" analytics-event=\"HDR_Magazine\" class=\"link-button\">{{:: 'COMMONHEADER.NEWS' | translate }}</a></div><div ng-if=\"isSignedIn\" ng-click=\"toggleMenu()\" class=\"user avatarContainer {{userInfo.avatar_image_path ? 'hide-background' : ''}} avatar-for-{{userInfo.user_id}}\"><img ng-src=\"{{::userInfo.avatar_image_path}}\" class=\"rounded-circle avatar-image is-full\"/><span ng-if=\"isAvatarColor()\" class=\"avatar-image-text is-small\">{{:: getTextOfAvatar() }}</span></div></div><div ng-if=\"!isSignedIn\" ng-show=\"showMenu\" class=\"tooltip-help\"><ul><li><a href=\"/contact\">{{:: '_CONTACT.TITLE' | translate }}</a></li><li><a href=\"javascript:void(0)\">{{:: 'COMMONHEADER.FAQ' | translate }}</a></li></ul></div><div ng-if=\"isSignedIn\" ng-show=\"showMenu\" class=\"tooltip-help2\"><div ng-if=\"isSignedIn\" class=\"avatar avatarContainer avatar-for-{{userInfo.user_id}}\"><img ng-src=\"{{::userInfo.avatar_image_path}}\" class=\"rounded-circle avatar-image\"/><span ng-if=\"isAvatarColor()\" class=\"avatar-image-text\">{{:: getTextOfAvatar() }}</span></div><div ng-if=\"isSignedIn\" class=\"popup-name\"><div class=\"name-space\"><div class=\"name\">{{getFullName()}}</div></div></div><div class=\"group-link\"><a ng-if=\"isSignedIn\" href=\"/setting/app\" class=\"link1\">{{:: '_SETTING.TITLE' | translate }}</a><a ng-if=\"isSignedIn\" href=\"/friend\" class=\"link2\">{{:: '_FRIEND.TITLE' | translate }}</a><a href=\"/contact\" class=\"link3\">{{:: '_CONTACT.TITLE' | translate }}</a><a href=\"javascript:void(0)\" class=\"link4\">{{:: 'COMMONHEADER.FAQ' | translate }}</a></div><div ng-if=\"isSignedIn\" ng-click=\"editAccount()\" class=\"btn-account-setting\">{{:: '_REGISTRATION.EDIT.TITLE' | translate }}</div><div ng-if=\"isSignedIn\" ng-click=\"signOut()\" class=\"btn-sign-out\">{{:: 'COMMONHEADER.LOGOUT' | translate }}</div></div></div><div class=\"fixed-bg-white d-md-none\"><div class=\"smallMenu\"><a href=\"/\" analytics-on=\"click\" analytics-event=\"HDR_Logo\" class=\"small-logo\"></a><button ng-click=\"showSmallMenu()\" class=\"rightMenu\"></button><div ng-show=\"smallMenu\" class=\"popUpMenu\"><div ng-if=\"isSignedIn\" class=\"item avatarContainer avatar-for-{{userInfo.user_id}}\"><img ng-src=\"{{::userInfo.avatar_image_path}}\" class=\"rounded-circle avatar-image\"/><span ng-if=\"isAvatarColor()\" class=\"avatar-image-text\">{{:: getTextOfAvatar() }}</span></div><div ng-if=\"isSignedIn\" class=\"item nameContainer\">{{getFullName()}}</div><a ng-if=\"isSignedIn\" href=\"/setting/app\" class=\"item settingContainer\">{{:: '_SETTING.TITLE' | translate }}</a><a ng-if=\"isSignedIn\" href=\"/friend\" class=\"item friendContainer\">{{:: '_FRIEND.TITLE' | translate }}</a><a href=\"/contact\" class=\"item contactContainer\">{{:: '_CONTACT.TITLE' | translate }}</a><a href=\"javascript:void(0)\" class=\"item faqContainer\">{{:: 'COMMONHEADER.FAQ' | translate }}</a><a ng-if=\"isSignedIn\" ng-click=\"editAccount()\" class=\"item accountContainer\">{{:: '_REGISTRATION.EDIT.TITLE' | translate }}</a><a ng-if=\"isSignedIn\" ng-click=\"signOut()\" class=\"item signOutContainer\">{{:: 'COMMONHEADER.LOGOUT' | translate }}</a></div></div></div><div class=\"container dashboard-container\"><div gnp-navigation-header=\"\"></div></div></div></div><div id=\"terms_of_use-modal\" tabindex=\"-1\" aria-labelledby=\"termsOfUseLabel\" aria-hidden=\"true\" class=\"modal fade\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body container container_fix\"><div class=\"content content_fix\"><h5><b>{{:: 'TERMS_OF_USE.TITLE' | translate }}</b></h5><p>{{:: 'TERMS_OF_USE.BODY_1' | translate }}</p><p>{{:: 'TERMS_OF_USE.BODY_2' | translate }}</p><p>{{:: 'TERMS_OF_USE.BODY_3' | translate }}</p><p><a href=\"https://tv.golfnetwork.co.jp/kiyaku\">{{:: 'TERMS_OF_USE.LINK_TERMS' | translate }}</a></p><p><a href=\"https://www.golfnetwork.plus/privacy.html\">{{:: 'TERMS_OF_USE.LINK_PRIVACY' | translate }}</a></p><p><h6><input id=\"check-term\" type=\"checkbox\" ng-model=\"hasAcceptedTerms\" class=\"custom-checkbox-term\"/><span>{{:: 'TERMS_OF_USE.CHECKBOX' | translate }}</span></h6></p></div></div><div class=\"modal-footer\"><button id=\"submit-terms\" type=\"button\" ng-disabled=\"!hasAcceptedTerms\" ng-click=\"submitTerms()\" class=\"btn btn-secondary\">{{:: 'TERMS_OF_USE.BUTTON' | translate }}</button></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/common-header/common-header.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAABwlBMVEWZmZn///+ZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmampqbm5ucnJydnZ2enp6fn5+goKChoaGioqKjo6OkpKSlpaWmpqanp6eoqKipqamqqqqrq6usrKytra2urq6vr6+wsLCysrKzs7O0tLS1tbW2tra3t7e5ubm6urq7u7u8vLy/v7/AwMDBwcHCwsLDw8PExMTFxcXGxsbHx8fIyMjJycnKysrLy8vMzMwtFX55AAAAZnRSTlMAAAECAwYHDA0ODxASGBshJCUoMTM0PD1TVFVWWltdXl9gY2RtcXJ0dXZ8fX5/gYKHi42QkZOkpaanqKmqq7GyucHCw8XGyMrLzM3T1NfZ29zd3uHj5Onq6+zt7u/x8vP09fb6/P6eg/eMAAADHUlEQVRYw6WX+V8SQRjGh6u8LaPC7LC71Ci10rLMbi0prSxTsuwYUYQAK0U88ERFBGL3/41loYWdZ5bl4/PjvO98P7M777wHMRgIVE19c0fv0BilY+96O5psNYrFUCACAdb2V1QlR6tVL6DssoNC9V8q0wGotI9SrkZaKosAjOeGqabeNxq1AIef0KJ6VMsHNHyiOuS0cQCmdqpTbSYEsNylunXPwgIsPbQEdVvUAHM3LUm3jSrALVqibhQCGrmO0wEXNpzMB9R9QS5T85FoShTjPyHg8yEFYH7GmCdCW0kxq6QPEh4a/wMusNaImCchLqQiU4zP6RygaoSxhURGm+y7qMgC7OwB4ixAYH9mkwwodzIWnwjkZdyGD2YAV9gDBBEgwPpdlACmQdawgAC/Wb+XEuAYuKElBJgDjkfSgJtgPYwA88CxNQ3oB+srCBACjg4Dqf4B1tf0Amg1OUH1AmaRpw1FEaWrOq+RUju5gy4hiQAR9Ka6yAt20S1ixQDgOXlL9QWyJPZB0gHiLAHgAZWKfGcXPTzANOv7FQEmBLz/7wQCgE+gW3B/KoiKLfqJdGoNnGHbg+JgAF0jjCTBDR17YSClz5BQA1ZwdejCoUypP6UKIk55sePHJBEK8mrCw3GzkWpeTZtcV/bv8fannzNMKOqADPJ8HJyUlpFXAfzi+Ugp7TjPmPcofTwfKama3vAKuwLgXIGc1g1XOdY5JYh5B8gUFkOFE99CTDnBH7z/o1zayHVkDMTy3yEmtOTKu7o7dgUWd1SRHF30u7jlvaDBcAfXd3E+EHY3QgUp5QxocfwRUVvbc6jFIXXj8tqyWFxRL9tkEXKWXxLZzObPOJ8CjeZMQg8gMQMazWyr648W37/jg60uOdDDr4r5Ws24PbBw2/35Pa3tMflh37doDByuFYG3PRWWK0ObWXvk8YZhdU6GPdojjzR0Pc0m5YVNplFdmJRtj2s1x77zubHPPbu0Ed1LCmIqHt1Yms0V5g/aY19aVfsbPCWV72/0zeho+2sm/7ZZS5jepfG/4Vpn3+DoNzo+1NfZXM8d//8B8xmxkzmwGgcAAAAASUVORK5CYII="

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	module.exports = {
	  'COMMONHEADER': {
	    'NEWS': 'Magazine',
	    'LOGOUT': 'Log out',
	    'MYSCOREBOOK': 'My ScoreBook',
	    'FAQ': 'FAQ'
	  },
	  'TERMS_OF_USE': {
	    'TITLE': 'Request for Agreement to Terms of Use and Privacy Policy',
	    'BODY_1': 'The contents of the Terms of Use and Privacy Policy have been updated.',
	    'BODY_2': 'Please review and agree to the updated terms before continuing to use the service.',
	    'BODY_3': '※Please make sure to click the links below and review the contents on the linked pages.',
	    'LINK_TERMS': 'Terms of Use',
	    'LINK_PRIVACY': 'Privacy Policy',
	    'CHECKBOX': 'I agree to the separate consent items regarding the use of personal information',
	    'BUTTON': 'Continue using the service'
	  }
	};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports = {
	  'COMMONHEADER': {
	    'NEWS': 'GN+ マガジン',
	    'LOGOUT': 'ログアウト',
	    'MYSCOREBOOK': 'マイスコアブック',
	    'FAQ': 'FAQ（準備中)'
	  },
	  'TERMS_OF_USE': {
	    'TITLE': '利用規約およびプライバシーポリシーへのご同意依頼',
	    'BODY_1': '利用規約およびプライバシーポリシーの内容が更新されました。',
	    'BODY_2': '内容をご確認、ご同意の上、引き続きサービスをご利用ください。',
	    'BODY_3': '※必ず下記のリンクをクリックし、リンク先のページの内容をご確認ください。',
	    'LINK_TERMS': '利用規格',
	    'LINK_PRIVACY': 'プライバシーポリシー',
	    'CHECKBOX': '個人情報の利用に関する個別同意事項に同意する',
	    'BUTTON': '引き続きサービスを利用する'
	  }
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var CommonFooterDirective, angular, modules;
	
	angular = __webpack_require__(28);
	
	__webpack_require__(59);
	
	CommonFooterDirective = __webpack_require__(100);
	
	modules = ['gnp-translation'];
	
	angular.module('gnp-common-footer', modules).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(102)).translations('ja', __webpack_require__(103));
	  }
	]).directive('gnpCommonFooter', CommonFooterDirective);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var CommonFooterDirective;
	
	__webpack_require__(101);
	
	CommonFooterDirective = function() {
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "components/common-footer/common-footer.jade"
	  };
	};
	
	module.exports = CommonFooterDirective;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	var v1="<div id=\"gnp-footer\"><div class=\"container gnp-footer-container\"><div class=\"row text-center ads-wrap\"><div class=\"col-lg-4 col-12 ad cell\"><div id=\"div-gpt-ad-1415761152283-0\" style=\"height:60px\"><script type=\"text/javascript\">googletag.cmd.push(function() { googletag.display('div-gpt-ad-1415761152283-0'); });</script></div></div><div class=\"col-lg-4 col-12 ad cell\"><div id=\"div-gpt-ad-1415761632340-0\" style=\"height:60px\"><script type=\"text/javascript\">googletag.cmd.push(function() { googletag.display('div-gpt-ad-1415761632340-0'); });</script></div></div><div class=\"col-lg-4 col-12 ad cell\"><div id=\"div-gpt-ad-1415761705303-0\" style=\"height:60px\"><script type=\"text/javascript\">googletag.cmd.push(function() { googletag.display('div-gpt-ad-1415761705303-0'); });</script></div></div></div><div class=\"row col-12\"><div class=\"col-md-7 sitemap\"><a href=\"/contact\">{{:: '_CONTACT.TITLE' | translate }}</a><span class=\"separator\">|</span><a href=\"https://tv.golfnetwork.co.jp/kiyaku\">{{:: '_COMMON_FOOTER.TERM_OF_SERVICE' | translate }}</a><span class=\"separator\">|</span><a href=\"https://www.golfnetwork.plus/privacy.html\">{{:: '_COMMON_FOOTER.PRIVACY_POLICY' | translate }}</a><span class=\"separator\">|</span><a href=\"https://www.golfnetwork.plus/legal.html\">{{:: '_COMMON_FOOTER.LEGAL' | translate }}</a></div><div class=\"col-md-5 copyright\">©GOLF NETWORK PLUS INC. All Rights Reserved.</div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/common-footer/common-footer.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	module.exports = {
	  '_COMMON_FOOTER': {
	    'TERM_OF_SERVICE': 'Terms of Service',
	    'PRIVACY_POLICY': 'Privacy Policy',
	    'LEGAL': 'Legal Information'
	  }
	};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	module.exports = {
	  '_COMMON_FOOTER': {
	    'TERM_OF_SERVICE': '利用規約',
	    'PRIVACY_POLICY': '個人情報保護ポリシー',
	    'LEGAL': '特定商取引法に基づく表示'
	  }
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var CommonWrapperADirective;
	
	__webpack_require__(105);
	
	CommonWrapperADirective = function() {
	  return {
	    restrict: "A",
	    transclude: true,
	    templateUrl: "components/common-wrapper/common-wrapper-a.jade"
	  };
	};
	
	module.exports = CommonWrapperADirective;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	var v1="<div><div gnp-common-header=\"\"></div><div ng-transclude=\"\"></div><div gnp-common-footer=\"\"></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/common-wrapper/common-wrapper-a.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var CommonWrapperBDirective;
	
	__webpack_require__(107);
	
	CommonWrapperBDirective = function() {
	  return {
	    restrict: "A",
	    transclude: true,
	    templateUrl: "components/common-wrapper/common-wrapper-b.jade"
	  };
	};
	
	module.exports = CommonWrapperBDirective;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	var v1="<div><div gnp-common-header=\"\"></div><div ng-transclude=\"\"></div><div gnp-common-footer=\"\"></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/common-wrapper/common-wrapper-b.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var UnexpectedErrorHandlerInterceptor, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(72);
	
	__webpack_require__(59);
	
	UnexpectedErrorHandlerInterceptor = __webpack_require__(109);
	
	modules = ['gnp-flash', 'gnp-translation'];
	
	angular.module('gnp-error-handler', modules).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(110)).translations('ja', __webpack_require__(111));
	  }
	]).config([
	  '$httpProvider', function($httpProvider) {
	    return $httpProvider.interceptors.push('UnexpectedErrorHandlerInterceptor');
	  }
	]).factory('UnexpectedErrorHandlerInterceptor', UnexpectedErrorHandlerInterceptor).run(UnexpectedErrorHandlerInterceptor);


/***/ }),
/* 109 */
/***/ (function(module, exports) {

	var UnexpectedErrorHandlerInterceptor;
	
	UnexpectedErrorHandlerInterceptor = function($q, $filter, $timeout, flash) {
	  return {
	    response: function(response) {
	      return response || $q.when(response);
	    },
	    responseError: function(rejection) {
	      switch (false) {
	        case rejection.status !== 500:
	          $timeout(function() {
	            return flash.error($filter('translate')('_ERROR_HANDLER.UNEXPECTED_ERROR_MSG'));
	          }, 100);
	      }
	      return $q.reject(rejection);
	    }
	  };
	};
	
	UnexpectedErrorHandlerInterceptor.$inject = ['$q', '$filter', '$timeout', 'flash'];
	
	module.exports = UnexpectedErrorHandlerInterceptor;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	module.exports = {
	  '_ERROR_HANDLER': {
	    'UNEXPECTED_ERROR_MSG': 'Something bad heppened. Sorry for your inconvenie. We are appreciate your patience.'
	  }
	};


/***/ }),
/* 111 */
/***/ (function(module, exports) {

	module.exports = {
	  '_ERROR_HANDLER': {
	    'UNEXPECTED_ERROR_MSG': '予期せぬエラーが発生しました。ご不便をおかけして申し訳ございません。しばらくしてから再度お試し下さい。'
	  }
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var $, CustomEmailValidatorDirective, CustomSelectDirective, CustomValidateDirective, DateInputDirective, DisableAllDirective, FormCopyService, FormDecorator, FormDialogService, FormFileReaderService, FormatStringFilter, MatchValidateDirective, PlayerHdcpDirective, PositionCalculator, SubmitDirective, SubmittingButtonDirective, TrustedTextFilter, modules;
	
	$ = __webpack_require__(1);
	
	PositionCalculator = __webpack_require__(113);
	
	__webpack_require__(28);
	
	__webpack_require__(115);
	
	__webpack_require__(117);
	
	__webpack_require__(59);
	
	__webpack_require__(120);
	
	__webpack_require__(121);
	
	__webpack_require__(122);
	
	MatchValidateDirective = __webpack_require__(123);
	
	DateInputDirective = __webpack_require__(124);
	
	SubmitDirective = __webpack_require__(244);
	
	CustomValidateDirective = __webpack_require__(245);
	
	PlayerHdcpDirective = __webpack_require__(246);
	
	FormDecorator = __webpack_require__(248);
	
	CustomSelectDirective = __webpack_require__(249);
	
	CustomEmailValidatorDirective = __webpack_require__(253);
	
	DisableAllDirective = __webpack_require__(254);
	
	SubmittingButtonDirective = __webpack_require__(255);
	
	TrustedTextFilter = __webpack_require__(256);
	
	FormDialogService = __webpack_require__(257);
	
	FormFileReaderService = __webpack_require__(258);
	
	FormCopyService = __webpack_require__(261);
	
	FormatStringFilter = __webpack_require__(262);
	
	modules = ['gnp-translation', 'gnp-hdcp', 'ui.bootstrap', 'cp.ngConfirm', 'infinite-scroll', 'angularLazyImg'];
	
	angular.module('gnp-form', modules).config(FormDecorator).directive('gnpMatchValidate', MatchValidateDirective).directive('gnpDateInput', DateInputDirective).directive('gnpSubmit', SubmitDirective).directive('gnpPlayerHdcp', PlayerHdcpDirective).directive('gnpCustomValidate', CustomValidateDirective).directive('gnpCustomSelect', CustomSelectDirective).directive('gnpCustomEmailValidator', CustomEmailValidatorDirective).directive('gnpDisableAll', DisableAllDirective).directive('gnpSubmittingButton', SubmittingButtonDirective).factory('formDialogService', FormDialogService).factory('formFileReaderService', FormFileReaderService).factory('formCopyService', FormCopyService).filter('trustedText', TrustedTextFilter).filter('formatString', FormatStringFilter).run(function() {
	  return $(document).on("shown.bs.dropdown.position-calculator", function(event, data) {
	    var $item, calculator, posResult, target;
	    $item = $(".dropdown-menu", event.target);
	    if (!$item.data("placement")) {
	      return;
	    }
	    target = data.relatedTarget;
	    $item.css({
	      top: 0,
	      left: 0
	    });
	    calculator = new PositionCalculator({
	      item: $item,
	      target: target,
	      itemAt: "top left",
	      itemOffset: {
	        y: 3,
	        x: 0,
	        mirror: true
	      },
	      targetAt: "bottom left",
	      flip: "both"
	    });
	    posResult = calculator.calculate();
	    $item.css({
	      top: posResult.moveBy.y + "px",
	      left: posResult.moveBy.x + "px"
	    });
	  });
	});


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(114);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery.PositionCalculator
	 * https://github.com/tlindig/position-calculator
	 *
	 * v1.1.2 - 2014-07-01
	 *
	 * Copyright (c) 2014 Tobias Lindig
	 * http://tlindig.de
	 *
	 * License: MIT
	 *
	 * Author: Tobias Lindig <dev@tlindig.de>
	 */
	
	!function(a){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):jQuery.PositionCalculator=a(jQuery)}(function(a){"use strict";function b(a){return"string"==typeof a&&("window"===a?a=q:"document"===a&&(a=r)),a}function c(a){var b=a.split(" ");return{y:t.test(b[0])?b[0]:"top",x:u.test(b[1])?b[1]:"left"}}function d(a,b){return a===b?!0:a&&b?a.top===b.top&&a.left===b.left&&a.height===b.height&&a.width===b.width:!1}function e(b){var c=b[0];if(9===c.nodeType)return{width:b.outerWidth(),height:b.outerHeight(),top:0,left:0};if(a.isWindow(c))return{width:b.outerWidth(),height:b.outerHeight(),top:b.scrollTop(),left:b.scrollLeft()};if(c.preventDefault)return{width:0,height:0,top:c.pageY,left:c.pageX};var d=b.offset();return{width:b.outerWidth(),height:b.outerHeight(),top:d.top,left:d.left}}function f(b,c){var d=b[0];if(9!==d.nodeType){if(a.isWindow(d)&&(c.top=b.scrollTop(),c.left=b.scrollLeft()),d.preventDefault)return c.top=d.pageY,void(c.left=d.pageX);var e=b.offset();c.top=e.top,c.left=e.left}}function g(b){var c,d=b[0];return 9===d.nodeType?(d=s,c={top:0,left:0}):a.isWindow(d)?(d=s,c={top:b.scrollTop(),left:b.scrollLeft()}):c=b.offset(),{width:d.clientWidth,height:d.clientHeight,top:c.top+d.clientTop,left:c.left+d.clientLeft}}function h(b,c){var d,e=b[0];9===e.nodeType?(e=s,d={top:0,left:0}):a.isWindow(e)?(e=s,d={top:b.scrollTop(),left:b.scrollLeft()}):d=b.offset(),c.top=d.top+e.clientTop,c.left=d.left+e.clientLeft}function i(a,b){return{y:parseFloat(a.y)*(v.test(a.y)?b.height/100:1),x:parseFloat(a.x)*(v.test(a.x)?b.width/100:1),mirror:a.mirror}}function j(a,b,c){var d={top:0,left:0,middle:.5*a.height,center:.5*a.width,bottom:a.height,right:a.width};return 0!==b.y&&(d.middle+=b.y,b.mirror?(d.top+="top"!==c.y?-1*b.y:b.y,d.bottom+="bottom"!==c.y?-1*b.y:b.y):(d.top+=b.y,d.bottom+=b.y)),0!==b.x&&(d.center+=b.x,b.mirror?(d.left+="left"!==c.x?-1*b.x:b.x,d.right+="right"!==c.x?-1*b.x:b.x):(d.left+=b.x,d.right+=b.x)),d}function k(a){var b=[];return a.top>0&&b.push("top"),a.left>0&&b.push("left"),a.bottom<0&&b.push("bottom"),a.right<0&&b.push("right"),a.overflow=b.length?b:null,a}function l(a,b){var c={top:a.top-b.top,left:a.left-b.left,bottom:a.top+a.height-(b.top+b.height),right:a.left+a.width-(b.left+b.width),overflow:[]};return k(c)}function m(a,b,c,d){var e,f,g,h={y:b.y,x:b.x},i={y:c.y,x:c.x};if(-1!==d.overflow.indexOf("top")&&(e="top"),-1!==d.overflow.indexOf("bottom")&&(e=e?null:"bottom"),-1!==d.overflow.indexOf("left")&&(f="left"),-1!==d.overflow.indexOf("right")&&(f=f?null:"right"),!e&&!f)return null;switch(a=a===!0?"both":a,g=0,a){case"item":g=1;break;case"target":g=2;break;case"both":g=3}return 1&g&&(e&&(h.y=w[h.y]),f&&(h.x=w[h.x])),2&g&&(e&&(i.y=w[i.y]),f&&(i.x=w[i.x])),{item_at:h,tar_at:i}}function n(a,b,c){var d,e,f,g,h;return h=c?["top","bottom"]:["left","right"],d=a[h[0]],f=b[h[0]],e=-1*a[h[1]],g=-1*b[h[1]],0>d&&(d=0),0>e&&(e=0),0>f&&(f=0),0>g&&(g=0),0>d&&0>e?!0:0>f&&0>g?!1:f+g>d+e}function o(a,b){"all"===b&&(b=!0);var c=a.distance.overflow;if(!c.length)return a;for(var d,e,f=!1,g=!1,h=c.length-1;h>=0;h--)switch(d=c[h]){case"top":case"bottom":(!g&&b===!0||-1!==b.indexOf(d))&&(e=a.distance[d],a.moveBy.y+=e,a.distance.top-=e,a.distance.bottom-=e,g=!0);break;case"left":case"right":(!f&&b===!0||-1!==b.indexOf(d))&&(e=a.distance[d],a.moveBy.x+=e,a.distance.left-=e,a.distance.right-=e,f=!0)}return k(a.distance),a}function p(a){return this instanceof p?(this.options=this.$itm=this.$trg=this.$bnd=this.itmAt=this.trgAt=this.itmPos=this.trgPos=this.bndPos=this.itmOffset=this.trgOffset=null,void this._init(a)):new p(a)}var q=window,r=document,s=r.documentElement,t=/top|middle|bottom/,u=/left|center|right/,v=/%$/,w={left:"right",center:"center",right:"left",top:"bottom",middle:"middle",bottom:"top"};return p.prototype._init=function(d){var e=this.options=a.extend({},p.defaults,d);return e.item?(this.$itm=e.item.jquery?e.item:a(e.item),0===this.$itm.length?null:(this.$trg=e.target&&e.target.jquery?e.target:a(b(e.target)),this.$bnd=e.boundary&&e.boundary.jquery?e.boundary:a(b(e.boundary)),this.itmAt=c(e.itemAt),this.trgAt=c(e.targetAt),this.resize(),this)):null},p.prototype.resize=function(){var a=this.options,b=e(this.$itm),c=this.$trg.length?e(this.$trg):null;if(this.bndPos=this.$bnd.length?g(this.$bnd):null,!this.itmPos||!d(b,this.itmPos)){this.itmPos=b;var f=i(a.itemOffset,b);f.x=-1*f.x,f.y=-1*f.y,this.itmOffset=j(b,f,this.itmAt)}return this.trgPos&&d(c,this.trgPos)||(this.trgPos=c,c&&(this.trgOffset=j(c,i(a.targetOffset,c),this.trgAt))),this},p.prototype.calcVariant=function(a,b){var c={moveBy:null,distance:null,itemAt:null,targetAt:null};if(this.trgPos&&a&&b){var d={top:this.trgPos.top+this.trgOffset[b.y],left:this.trgPos.left+this.trgOffset[b.x]},e={top:d.top-this.itmOffset[a.y],left:d.left-this.itmOffset[a.x],height:this.itmPos.height,width:this.itmPos.width};c.moveBy={y:e.top-this.itmPos.top,x:e.left-this.itmPos.left},c.distance=this.bndPos?l(this.bndPos,e):null,c.itemAt=a.y+" "+a.x,c.targetAt=b.y+" "+b.x}else c.moveBy={y:0,x:0},c.distance=this.bndPos?l(this.bndPos,this.itmPos):null;return c},p.prototype.calculate=function(){if(null===this.itmPos)return null;var a=this.options;f(this.$itm,this.itmPos),this.trgPos&&f(this.$trg,this.trgPos),this.bndPos&&h(this.$bnd,this.bndPos);var b=this.calcVariant(this.itmAt,this.trgAt);if(!b.distance||!b.distance.overflow)return b;if(a.flip&&"none"!==a.flip&&this.trgPos){var c,d=m(a.flip,this.itmAt,this.trgAt,b.distance);if(d){if(c=this.calcVariant(d.item_at,d.tar_at),!c.distance.overflow)return c;var e={y:!1,x:!1};if(e.y=n(c.distance,b.distance,!0),e.x=n(c.distance,b.distance,!1),e.y!==e.x){if(b=this.calcVariant({y:e.y?d.item_at.y:this.itmAt.y,x:e.x?d.item_at.x:this.itmAt.x},{y:e.y?d.tar_at.y:this.trgAt.y,x:e.x?d.tar_at.x:this.trgAt.x}),!b.distance.overflow)return b}else e.y&&e.x&&(b=c)}}return a.stick&&"none"!==a.stick?o(b,a.stick):b},p.defaults={item:null,target:null,boundary:window,itemAt:"top left",targetAt:"top left",itemOffset:{y:0,x:0,mirror:!0},targetOffset:{y:0,x:0,mirror:!0},flip:"none",stick:"none"},p});
	//# sourceMappingURL=position-calculator.min.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(116);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var angular = __webpack_require__(28);
	
	/*
	 * angular-ui-bootstrap
	 * http://angular-ui.github.io/bootstrap/
	
	 * Version: 0.12.1 - 2015-02-20
	 * License: MIT
	 */
	angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.transition","ui.bootstrap.collapse","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.bindHtml","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.position","ui.bootstrap.datepicker","ui.bootstrap.dropdown","ui.bootstrap.modal","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
	angular.module("ui.bootstrap.tpls", ["template/accordion/accordion-group.html","template/accordion/accordion.html","template/alert/alert.html","template/carousel/carousel.html","template/carousel/slide.html","template/datepicker/datepicker.html","template/datepicker/day.html","template/datepicker/month.html","template/datepicker/popup.html","template/datepicker/year.html","template/modal/backdrop.html","template/modal/window.html","template/pagination/pager.html","template/pagination/pagination.html","template/tooltip/tooltip-html-unsafe-popup.html","template/tooltip/tooltip-popup.html","template/popover/popover.html","template/progressbar/bar.html","template/progressbar/progress.html","template/progressbar/progressbar.html","template/rating/rating.html","template/tabs/tab.html","template/tabs/tabset.html","template/timepicker/timepicker.html","template/typeahead/typeahead-match.html","template/typeahead/typeahead-popup.html"]);
	angular.module('ui.bootstrap.transition', [])
	
	/**
	 * $transition service provides a consistent interface to trigger CSS 3 transitions and to be informed when they complete.
	 * @param  {DOMElement} element  The DOMElement that will be animated.
	 * @param  {string|object|function} trigger  The thing that will cause the transition to start:
	 *   - As a string, it represents the css class to be added to the element.
	 *   - As an object, it represents a hash of style attributes to be applied to the element.
	 *   - As a function, it represents a function to be called that will cause the transition to occur.
	 * @return {Promise}  A promise that is resolved when the transition finishes.
	 */
	.factory('$transition', ['$q', '$timeout', '$rootScope', function($q, $timeout, $rootScope) {
	
	  var $transition = function(element, trigger, options) {
	    options = options || {};
	    var deferred = $q.defer();
	    var endEventName = $transition[options.animation ? 'animationEndEventName' : 'transitionEndEventName'];
	
	    var transitionEndHandler = function(event) {
	      $rootScope.$apply(function() {
	        element.unbind(endEventName, transitionEndHandler);
	        deferred.resolve(element);
	      });
	    };
	
	    if (endEventName) {
	      element.bind(endEventName, transitionEndHandler);
	    }
	
	    // Wrap in a timeout to allow the browser time to update the DOM before the transition is to occur
	    $timeout(function() {
	      if ( angular.isString(trigger) ) {
	        element.addClass(trigger);
	      } else if ( angular.isFunction(trigger) ) {
	        trigger(element);
	      } else if ( angular.isObject(trigger) ) {
	        element.css(trigger);
	      }
	      //If browser does not support transitions, instantly resolve
	      if ( !endEventName ) {
	        deferred.resolve(element);
	      }
	    });
	
	    // Add our custom cancel function to the promise that is returned
	    // We can call this if we are about to run a new transition, which we know will prevent this transition from ending,
	    // i.e. it will therefore never raise a transitionEnd event for that transition
	    deferred.promise.cancel = function() {
	      if ( endEventName ) {
	        element.unbind(endEventName, transitionEndHandler);
	      }
	      deferred.reject('Transition cancelled');
	    };
	
	    return deferred.promise;
	  };
	
	  // Work out the name of the transitionEnd event
	  var transElement = document.createElement('trans');
	  var transitionEndEventNames = {
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'transitionend',
	    'OTransition': 'oTransitionEnd',
	    'transition': 'transitionend'
	  };
	  var animationEndEventNames = {
	    'WebkitTransition': 'webkitAnimationEnd',
	    'MozTransition': 'animationend',
	    'OTransition': 'oAnimationEnd',
	    'transition': 'animationend'
	  };
	  function findEndEventName(endEventNames) {
	    for (var name in endEventNames){
	      if (transElement.style[name] !== undefined) {
	        return endEventNames[name];
	      }
	    }
	  }
	  $transition.transitionEndEventName = findEndEventName(transitionEndEventNames);
	  $transition.animationEndEventName = findEndEventName(animationEndEventNames);
	  return $transition;
	}]);
	
	angular.module('ui.bootstrap.collapse', ['ui.bootstrap.transition'])
	
	  .directive('collapse', ['$transition', function ($transition) {
	
	    return {
	      link: function (scope, element, attrs) {
	
	        var initialAnimSkip = true;
	        var currentTransition;
	
	        function doTransition(change) {
	          var newTransition = $transition(element, change);
	          if (currentTransition) {
	            currentTransition.cancel();
	          }
	          currentTransition = newTransition;
	          newTransition.then(newTransitionDone, newTransitionDone);
	          return newTransition;
	
	          function newTransitionDone() {
	            // Make sure it's this transition, otherwise, leave it alone.
	            if (currentTransition === newTransition) {
	              currentTransition = undefined;
	            }
	          }
	        }
	
	        function expand() {
	          if (initialAnimSkip) {
	            initialAnimSkip = false;
	            expandDone();
	          } else {
	            element.removeClass('collapse').addClass('collapsing');
	            doTransition({ height: element[0].scrollHeight + 'px' }).then(expandDone);
	          }
	        }
	
	        function expandDone() {
	          element.removeClass('collapsing');
	          element.addClass('collapse in');
	          element.css({height: 'auto'});
	        }
	
	        function collapse() {
	          if (initialAnimSkip) {
	            initialAnimSkip = false;
	            collapseDone();
	            element.css({height: 0});
	          } else {
	            // CSS transitions don't work with height: auto, so we have to manually change the height to a specific value
	            element.css({ height: element[0].scrollHeight + 'px' });
	            //trigger reflow so a browser realizes that height was updated from auto to a specific value
	            var x = element[0].offsetWidth;
	
	            element.removeClass('collapse in').addClass('collapsing');
	
	            doTransition({ height: 0 }).then(collapseDone);
	          }
	        }
	
	        function collapseDone() {
	          element.removeClass('collapsing');
	          element.addClass('collapse');
	        }
	
	        scope.$watch(attrs.collapse, function (shouldCollapse) {
	          if (shouldCollapse) {
	            collapse();
	          } else {
	            expand();
	          }
	        });
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse'])
	
	.constant('accordionConfig', {
	  closeOthers: true
	})
	
	.controller('AccordionController', ['$scope', '$attrs', 'accordionConfig', function ($scope, $attrs, accordionConfig) {
	
	  // This array keeps track of the accordion groups
	  this.groups = [];
	
	  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	  this.closeOthers = function(openGroup) {
	    var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	    if ( closeOthers ) {
	      angular.forEach(this.groups, function (group) {
	        if ( group !== openGroup ) {
	          group.isOpen = false;
	        }
	      });
	    }
	  };
	
	  // This is called from the accordion-group directive to add itself to the accordion
	  this.addGroup = function(groupScope) {
	    var that = this;
	    this.groups.push(groupScope);
	
	    groupScope.$on('$destroy', function (event) {
	      that.removeGroup(groupScope);
	    });
	  };
	
	  // This is called from the accordion-group directive when to remove itself
	  this.removeGroup = function(group) {
	    var index = this.groups.indexOf(group);
	    if ( index !== -1 ) {
	      this.groups.splice(index, 1);
	    }
	  };
	
	}])
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('accordion', function () {
	  return {
	    restrict:'EA',
	    controller:'AccordionController',
	    transclude: true,
	    replace: false,
	    templateUrl: 'template/accordion/accordion.html'
	  };
	})
	
	// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('accordionGroup', function() {
	  return {
	    require:'^accordion',         // We need this directive to be inside an accordion
	    restrict:'EA',
	    transclude:true,              // It transcludes the contents of the directive into the template
	    replace: true,                // The element containing the directive will be replaced with the template
	    templateUrl:'template/accordion/accordion-group.html',
	    scope: {
	      heading: '@',               // Interpolate the heading attribute onto this scope
	      isOpen: '=?',
	      isDisabled: '=?'
	    },
	    controller: function() {
	      this.setHeading = function(element) {
	        this.heading = element;
	      };
	    },
	    link: function(scope, element, attrs, accordionCtrl) {
	      accordionCtrl.addGroup(scope);
	
	      scope.$watch('isOpen', function(value) {
	        if ( value ) {
	          accordionCtrl.closeOthers(scope);
	        }
	      });
	
	      scope.toggleOpen = function() {
	        if ( !scope.isDisabled ) {
	          scope.isOpen = !scope.isOpen;
	        }
	      };
	    }
	  };
	})
	
	// Use accordion-heading below an accordion-group to provide a heading containing HTML
	// <accordion-group>
	//   <accordion-heading>Heading containing HTML - <img src="..."></accordion-heading>
	// </accordion-group>
	.directive('accordionHeading', function() {
	  return {
	    restrict: 'EA',
	    transclude: true,   // Grab the contents to be used as the heading
	    template: '',       // In effect remove this element!
	    replace: true,
	    require: '^accordionGroup',
	    link: function(scope, element, attr, accordionGroupCtrl, transclude) {
	      // Pass the heading to the accordion-group controller
	      // so that it can be transcluded into the right place in the template
	      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	      accordionGroupCtrl.setHeading(transclude(scope, function() {}));
	    }
	  };
	})
	
	// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	// <div class="accordion-group">
	//   <div class="accordion-heading" ><a ... accordion-transclude="heading">...</a></div>
	//   ...
	// </div>
	.directive('accordionTransclude', function() {
	  return {
	    require: '^accordionGroup',
	    link: function(scope, element, attr, controller) {
	      scope.$watch(function() { return controller[attr.accordionTransclude]; }, function(heading) {
	        if ( heading ) {
	          element.html('');
	          element.append(heading);
	        }
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.alert', [])
	
	.controller('AlertController', ['$scope', '$attrs', function ($scope, $attrs) {
	  $scope.closeable = 'close' in $attrs;
	  this.close = $scope.close;
	}])
	
	.directive('alert', function () {
	  return {
	    restrict:'EA',
	    controller:'AlertController',
	    templateUrl:'template/alert/alert.html',
	    transclude:true,
	    replace:true,
	    scope: {
	      type: '@',
	      close: '&'
	    }
	  };
	})
	
	.directive('dismissOnTimeout', ['$timeout', function($timeout) {
	  return {
	    require: 'alert',
	    link: function(scope, element, attrs, alertCtrl) {
	      $timeout(function(){
	        alertCtrl.close();
	      }, parseInt(attrs.dismissOnTimeout, 10));
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.bindHtml', [])
	
	  .directive('bindHtmlUnsafe', function () {
	    return function (scope, element, attr) {
	      element.addClass('ng-binding').data('$binding', attr.bindHtmlUnsafe);
	      scope.$watch(attr.bindHtmlUnsafe, function bindHtmlUnsafeWatchAction(value) {
	        element.html(value || '');
	      });
	    };
	  });
	angular.module('ui.bootstrap.buttons', [])
	
	.constant('buttonConfig', {
	  activeClass: 'active',
	  toggleEvent: 'click'
	})
	
	.controller('ButtonsController', ['buttonConfig', function(buttonConfig) {
	  this.activeClass = buttonConfig.activeClass || 'active';
	  this.toggleEvent = buttonConfig.toggleEvent || 'click';
	}])
	
	.directive('btnRadio', function () {
	  return {
	    require: ['btnRadio', 'ngModel'],
	    controller: 'ButtonsController',
	    link: function (scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      //model -> UI
	      ngModelCtrl.$render = function () {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.btnRadio)));
	      };
	
	      //ui->model
	      element.bind(buttonsCtrl.toggleEvent, function () {
	        var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	        if (!isActive || angular.isDefined(attrs.uncheckable)) {
	          scope.$apply(function () {
	            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.btnRadio));
	            ngModelCtrl.$render();
	          });
	        }
	      });
	    }
	  };
	})
	
	.directive('btnCheckbox', function () {
	  return {
	    require: ['btnCheckbox', 'ngModel'],
	    controller: 'ButtonsController',
	    link: function (scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      function getTrueValue() {
	        return getCheckboxValue(attrs.btnCheckboxTrue, true);
	      }
	
	      function getFalseValue() {
	        return getCheckboxValue(attrs.btnCheckboxFalse, false);
	      }
	
	      function getCheckboxValue(attributeValue, defaultValue) {
	        var val = scope.$eval(attributeValue);
	        return angular.isDefined(val) ? val : defaultValue;
	      }
	
	      //model -> UI
	      ngModelCtrl.$render = function () {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	      };
	
	      //ui->model
	      element.bind(buttonsCtrl.toggleEvent, function () {
	        scope.$apply(function () {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	    }
	  };
	});
	
	/**
	* @ngdoc overview
	* @name ui.bootstrap.carousel
	*
	* @description
	* AngularJS version of an image carousel.
	*
	*/
	angular.module('ui.bootstrap.carousel', ['ui.bootstrap.transition'])
	.controller('CarouselController', ['$scope', '$timeout', '$interval', '$transition', function ($scope, $timeout, $interval, $transition) {
	  var self = this,
	    slides = self.slides = $scope.slides = [],
	    currentIndex = -1,
	    currentInterval, isPlaying;
	  self.currentSlide = null;
	
	  var destroyed = false;
	  /* direction: "prev" or "next" */
	  self.select = $scope.select = function(nextSlide, direction) {
	    var nextIndex = slides.indexOf(nextSlide);
	    //Decide direction if it's not given
	    if (direction === undefined) {
	      direction = nextIndex > currentIndex ? 'next' : 'prev';
	    }
	    if (nextSlide && nextSlide !== self.currentSlide) {
	      if ($scope.$currentTransition) {
	        $scope.$currentTransition.cancel();
	        //Timeout so ng-class in template has time to fix classes for finished slide
	        $timeout(goNext);
	      } else {
	        goNext();
	      }
	    }
	    function goNext() {
	      // Scope has been destroyed, stop here.
	      if (destroyed) { return; }
	      //If we have a slide to transition from and we have a transition type and we're allowed, go
	      if (self.currentSlide && angular.isString(direction) && !$scope.noTransition && nextSlide.$element) {
	        //We shouldn't do class manip in here, but it's the same weird thing bootstrap does. need to fix sometime
	        nextSlide.$element.addClass(direction);
	        var reflow = nextSlide.$element[0].offsetWidth; //force reflow
	
	        //Set all other slides to stop doing their stuff for the new transition
	        angular.forEach(slides, function(slide) {
	          angular.extend(slide, {direction: '', entering: false, leaving: false, active: false});
	        });
	        angular.extend(nextSlide, {direction: direction, active: true, entering: true});
	        angular.extend(self.currentSlide||{}, {direction: direction, leaving: true});
	
	        $scope.$currentTransition = $transition(nextSlide.$element, {});
	        //We have to create new pointers inside a closure since next & current will change
	        (function(next,current) {
	          $scope.$currentTransition.then(
	            function(){ transitionDone(next, current); },
	            function(){ transitionDone(next, current); }
	          );
	        }(nextSlide, self.currentSlide));
	      } else {
	        transitionDone(nextSlide, self.currentSlide);
	      }
	      self.currentSlide = nextSlide;
	      currentIndex = nextIndex;
	      //every time you change slides, reset the timer
	      restartTimer();
	    }
	    function transitionDone(next, current) {
	      angular.extend(next, {direction: '', active: true, leaving: false, entering: false});
	      angular.extend(current||{}, {direction: '', active: false, leaving: false, entering: false});
	      $scope.$currentTransition = null;
	    }
	  };
	  $scope.$on('$destroy', function () {
	    destroyed = true;
	  });
	
	  /* Allow outside people to call indexOf on slides array */
	  self.indexOfSlide = function(slide) {
	    return slides.indexOf(slide);
	  };
	
	  $scope.next = function() {
	    var newIndex = (currentIndex + 1) % slides.length;
	
	    //Prevent this user-triggered transition from occurring if there is already one in progress
	    if (!$scope.$currentTransition) {
	      return self.select(slides[newIndex], 'next');
	    }
	  };
	
	  $scope.prev = function() {
	    var newIndex = currentIndex - 1 < 0 ? slides.length - 1 : currentIndex - 1;
	
	    //Prevent this user-triggered transition from occurring if there is already one in progress
	    if (!$scope.$currentTransition) {
	      return self.select(slides[newIndex], 'prev');
	    }
	  };
	
	  $scope.isActive = function(slide) {
	     return self.currentSlide === slide;
	  };
	
	  $scope.$watch('interval', restartTimer);
	  $scope.$on('$destroy', resetTimer);
	
	  function restartTimer() {
	    resetTimer();
	    var interval = +$scope.interval;
	    if (!isNaN(interval) && interval > 0) {
	      currentInterval = $interval(timerFn, interval);
	    }
	  }
	
	  function resetTimer() {
	    if (currentInterval) {
	      $interval.cancel(currentInterval);
	      currentInterval = null;
	    }
	  }
	
	  function timerFn() {
	    var interval = +$scope.interval;
	    if (isPlaying && !isNaN(interval) && interval > 0) {
	      $scope.next();
	    } else {
	      $scope.pause();
	    }
	  }
	
	  $scope.play = function() {
	    if (!isPlaying) {
	      isPlaying = true;
	      restartTimer();
	    }
	  };
	  $scope.pause = function() {
	    if (!$scope.noPause) {
	      isPlaying = false;
	      resetTimer();
	    }
	  };
	
	  self.addSlide = function(slide, element) {
	    slide.$element = element;
	    slides.push(slide);
	    //if this is the first slide or the slide is set to active, select it
	    if(slides.length === 1 || slide.active) {
	      self.select(slides[slides.length-1]);
	      if (slides.length == 1) {
	        $scope.play();
	      }
	    } else {
	      slide.active = false;
	    }
	  };
	
	  self.removeSlide = function(slide) {
	    //get the index of the slide inside the carousel
	    var index = slides.indexOf(slide);
	    slides.splice(index, 1);
	    if (slides.length > 0 && slide.active) {
	      if (index >= slides.length) {
	        self.select(slides[index-1]);
	      } else {
	        self.select(slides[index]);
	      }
	    } else if (currentIndex > index) {
	      currentIndex--;
	    }
	  };
	
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.carousel.directive:carousel
	 * @restrict EA
	 *
	 * @description
	 * Carousel is the outer container for a set of image 'slides' to showcase.
	 *
	 * @param {number=} interval The time, in milliseconds, that it will take the carousel to go to the next slide.
	 * @param {boolean=} noTransition Whether to disable transitions on the carousel.
	 * @param {boolean=} noPause Whether to disable pausing on the carousel (by default, the carousel interval pauses on hover).
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <carousel>
	      <slide>
	        <img src="http://placekitten.com/150/150" style="margin:auto;">
	        <div class="carousel-caption">
	          <p>Beautiful!</p>
	        </div>
	      </slide>
	      <slide>
	        <img src="http://placekitten.com/100/150" style="margin:auto;">
	        <div class="carousel-caption">
	          <p>D'aww!</p>
	        </div>
	      </slide>
	    </carousel>
	  </file>
	  <file name="demo.css">
	    .carousel-indicators {
	      top: auto;
	      bottom: 15px;
	    }
	  </file>
	</example>
	 */
	.directive('carousel', [function() {
	  return {
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    controller: 'CarouselController',
	    require: 'carousel',
	    templateUrl: 'template/carousel/carousel.html',
	    scope: {
	      interval: '=',
	      noTransition: '=',
	      noPause: '='
	    }
	  };
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.carousel.directive:slide
	 * @restrict EA
	 *
	 * @description
	 * Creates a slide inside a {@link ui.bootstrap.carousel.directive:carousel carousel}.  Must be placed as a child of a carousel element.
	 *
	 * @param {boolean=} active Model binding, whether or not this slide is currently active.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	<div ng-controller="CarouselDemoCtrl">
	  <carousel>
	    <slide ng-repeat="slide in slides" active="slide.active">
	      <img ng-src="{{slide.image}}" style="margin:auto;">
	      <div class="carousel-caption">
	        <h4>Slide {{$index}}</h4>
	        <p>{{slide.text}}</p>
	      </div>
	    </slide>
	  </carousel>
	  Interval, in milliseconds: <input type="number" ng-model="myInterval">
	  <br />Enter a negative number to stop the interval.
	</div>
	  </file>
	  <file name="script.js">
	function CarouselDemoCtrl($scope) {
	  $scope.myInterval = 5000;
	}
	  </file>
	  <file name="demo.css">
	    .carousel-indicators {
	      top: auto;
	      bottom: 15px;
	    }
	  </file>
	</example>
	*/
	
	.directive('slide', function() {
	  return {
	    require: '^carousel',
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    templateUrl: 'template/carousel/slide.html',
	    scope: {
	      active: '=?'
	    },
	    link: function (scope, element, attrs, carouselCtrl) {
	      carouselCtrl.addSlide(scope, element);
	      //when the scope is destroyed then remove the slide from the current slides array
	      scope.$on('$destroy', function() {
	        carouselCtrl.removeSlide(scope);
	      });
	
	      scope.$watch('active', function(active) {
	        if (active) {
	          carouselCtrl.select(scope);
	        }
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.dateparser', [])
	
	.service('dateParser', ['$locale', 'orderByFilter', function($locale, orderByFilter) {
	
	  this.parsers = {};
	
	  var formatCodeToRegex = {
	    'yyyy': {
	      regex: '\\d{4}',
	      apply: function(value) { this.year = +value; }
	    },
	    'yy': {
	      regex: '\\d{2}',
	      apply: function(value) { this.year = +value + 2000; }
	    },
	    'y': {
	      regex: '\\d{1,4}',
	      apply: function(value) { this.year = +value; }
	    },
	    'MMMM': {
	      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	      apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); }
	    },
	    'MMM': {
	      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	      apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); }
	    },
	    'MM': {
	      regex: '0[1-9]|1[0-2]',
	      apply: function(value) { this.month = value - 1; }
	    },
	    'M': {
	      regex: '[1-9]|1[0-2]',
	      apply: function(value) { this.month = value - 1; }
	    },
	    'dd': {
	      regex: '[0-2][0-9]{1}|3[0-1]{1}',
	      apply: function(value) { this.date = +value; }
	    },
	    'd': {
	      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	      apply: function(value) { this.date = +value; }
	    },
	    'EEEE': {
	      regex: $locale.DATETIME_FORMATS.DAY.join('|')
	    },
	    'EEE': {
	      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|')
	    }
	  };
	
	  function createParser(format) {
	    var map = [], regex = format.split('');
	
	    angular.forEach(formatCodeToRegex, function(data, code) {
	      var index = format.indexOf(code);
	
	      if (index > -1) {
	        format = format.split('');
	
	        regex[index] = '(' + data.regex + ')';
	        format[index] = '$'; // Custom symbol to define consumed part of format
	        for (var i = index + 1, n = index + code.length; i < n; i++) {
	          regex[i] = '';
	          format[i] = '$';
	        }
	        format = format.join('');
	
	        map.push({ index: index, apply: data.apply });
	      }
	    });
	
	    return {
	      regex: new RegExp('^' + regex.join('') + '$'),
	      map: orderByFilter(map, 'index')
	    };
	  }
	
	  this.parse = function(input, format) {
	    if ( !angular.isString(input) || !format ) {
	      return input;
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	
	    if ( !this.parsers[format] ) {
	      this.parsers[format] = createParser(format);
	    }
	
	    var parser = this.parsers[format],
	        regex = parser.regex,
	        map = parser.map,
	        results = input.match(regex);
	
	    if ( results && results.length ) {
	      var fields = { year: 1900, month: 0, date: 1, hours: 0 }, dt;
	
	      for( var i = 1, n = results.length; i < n; i++ ) {
	        var mapper = map[i-1];
	        if ( mapper.apply ) {
	          mapper.apply.call(fields, results[i]);
	        }
	      }
	
	      if ( isValid(fields.year, fields.month, fields.date) ) {
	        dt = new Date( fields.year, fields.month, fields.date, fields.hours);
	      }
	
	      return dt;
	    }
	  };
	
	  // Check if date is valid for specific month (and year for February).
	  // Month: 0 = Jan, 1 = Feb, etc
	  function isValid(year, month, date) {
	    if ( month === 1 && date > 28) {
	        return date === 29 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
	    }
	
	    if ( month === 3 || month === 5 || month === 8 || month === 10) {
	        return date < 31;
	    }
	
	    return true;
	  }
	}]);
	
	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods that can be use to retrieve position of DOM elements.
	 * It is meant to be used where we need to absolute-position DOM elements in
	 * relation to other, existing elements (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	  .factory('$position', ['$document', '$window', function ($document, $window) {
	
	    function getStyle(el, cssprop) {
	      if (el.currentStyle) { //IE
	        return el.currentStyle[cssprop];
	      } else if ($window.getComputedStyle) {
	        return $window.getComputedStyle(el)[cssprop];
	      }
	      // finally try and get inline style
	      return el.style[cssprop];
	    }
	
	    /**
	     * Checks if a given element is statically positioned
	     * @param element - raw DOM element
	     */
	    function isStaticPositioned(element) {
	      return (getStyle(element, 'position') || 'static' ) === 'static';
	    }
	
	    /**
	     * returns the closest, non-statically positioned parentOffset of a given element
	     * @param element
	     */
	    var parentOffsetEl = function (element) {
	      var docDomEl = $document[0];
	      var offsetParent = element.offsetParent || docDomEl;
	      while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
	        offsetParent = offsetParent.offsetParent;
	      }
	      return offsetParent || docDomEl;
	    };
	
	    return {
	      /**
	       * Provides read-only equivalent of jQuery's position function:
	       * http://api.jquery.com/position/
	       */
	      position: function (element) {
	        var elBCR = this.offset(element);
	        var offsetParentBCR = { top: 0, left: 0 };
	        var offsetParentEl = parentOffsetEl(element[0]);
	        if (offsetParentEl != $document[0]) {
	          offsetParentBCR = this.offset(angular.element(offsetParentEl));
	          offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
	          offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
	        }
	
	        var boundingClientRect = element[0].getBoundingClientRect();
	        return {
	          width: boundingClientRect.width || element.prop('offsetWidth'),
	          height: boundingClientRect.height || element.prop('offsetHeight'),
	          top: elBCR.top - offsetParentBCR.top,
	          left: elBCR.left - offsetParentBCR.left
	        };
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's offset function:
	       * http://api.jquery.com/offset/
	       */
	      offset: function (element) {
	        var boundingClientRect = element[0].getBoundingClientRect();
	        return {
	          width: boundingClientRect.width || element.prop('offsetWidth'),
	          height: boundingClientRect.height || element.prop('offsetHeight'),
	          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	        };
	      },
	
	      /**
	       * Provides coordinates for the targetEl in relation to hostEl
	       */
	      positionElements: function (hostEl, targetEl, positionStr, appendToBody) {
	
	        var positionStrParts = positionStr.split('-');
	        var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || 'center';
	
	        var hostElPos,
	          targetElWidth,
	          targetElHeight,
	          targetElPos;
	
	        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);
	
	        targetElWidth = targetEl.prop('offsetWidth');
	        targetElHeight = targetEl.prop('offsetHeight');
	
	        var shiftWidth = {
	          center: function () {
	            return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
	          },
	          left: function () {
	            return hostElPos.left;
	          },
	          right: function () {
	            return hostElPos.left + hostElPos.width;
	          }
	        };
	
	        var shiftHeight = {
	          center: function () {
	            return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
	          },
	          top: function () {
	            return hostElPos.top;
	          },
	          bottom: function () {
	            return hostElPos.top + hostElPos.height;
	          }
	        };
	
	        switch (pos0) {
	          case 'right':
	            targetElPos = {
	              top: shiftHeight[pos1](),
	              left: shiftWidth[pos0]()
	            };
	            break;
	          case 'left':
	            targetElPos = {
	              top: shiftHeight[pos1](),
	              left: hostElPos.left - targetElWidth
	            };
	            break;
	          case 'bottom':
	            targetElPos = {
	              top: shiftHeight[pos0](),
	              left: shiftWidth[pos1]()
	            };
	            break;
	          default:
	            targetElPos = {
	              top: hostElPos.top - targetElHeight,
	              left: shiftWidth[pos1]()
	            };
	            break;
	        }
	
	        return targetElPos;
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position'])
	
	.constant('datepickerConfig', {
	  formatDay: 'dd',
	  formatMonth: 'MMMM',
	  formatYear: 'yyyy',
	  formatDayHeader: 'EEE',
	  formatDayTitle: 'MMMM yyyy',
	  formatMonthTitle: 'yyyy',
	  datepickerMode: 'day',
	  minMode: 'day',
	  maxMode: 'year',
	  showWeeks: true,
	  startingDay: 0,
	  yearRange: 20,
	  minDate: null,
	  maxDate: null
	})
	
	.controller('DatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$timeout', '$log', 'dateFilter', 'datepickerConfig', function($scope, $attrs, $parse, $interpolate, $timeout, $log, dateFilter, datepickerConfig) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;
	
	  // Modes chain
	  this.modes = ['day', 'month', 'year'];
	
	  // Configuration attributes
	  angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
	                   'minMode', 'maxMode', 'showWeeks', 'startingDay', 'yearRange'], function( key, index ) {
	    self[key] = angular.isDefined($attrs[key]) ? (index < 8 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
	  });
	
	  // Watchable date attributes
	  angular.forEach(['minDate', 'maxDate'], function( key ) {
	    if ( $attrs[key] ) {
	      $scope.$parent.$watch($parse($attrs[key]), function(value) {
	        self[key] = value ? new Date(value) : null;
	        self.refreshView();
	      });
	    } else {
	      self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
	    }
	  });
	
	  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	  this.activeDate = angular.isDefined($attrs.initDate) ? $scope.$parent.$eval($attrs.initDate) : new Date();
	
	  $scope.isActive = function(dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function( ngModelCtrl_ ) {
	    ngModelCtrl = ngModelCtrl_;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	  };
	
	  this.render = function() {
	    if ( ngModelCtrl.$modelValue ) {
	      var date = new Date( ngModelCtrl.$modelValue ),
	          isValid = !isNaN(date);
	
	      if ( isValid ) {
	        this.activeDate = date;
	      } else {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	      }
	      ngModelCtrl.$setValidity('date', isValid);
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function() {
	    if ( this.element ) {
	      this._refreshView();
	
	      var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : null;
	      ngModelCtrl.$setValidity('date-disabled', !date || (this.element && !this.isDisabled(date)));
	    }
	  };
	
	  this.createDateObject = function(date, format) {
	    var model = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : null;
	    return {
	      date: date,
	      label: dateFilter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      current: this.compare(date, new Date()) === 0
	    };
	  };
	
	  this.isDisabled = function( date ) {
	    return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode})));
	  };
	
	  // Split array into smaller arrays
	  this.split = function(arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  $scope.select = function( date ) {
	    if ( $scope.datepickerMode === self.minMode ) {
	      var dt = ngModelCtrl.$modelValue ? new Date( ngModelCtrl.$modelValue ) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear( date.getFullYear(), date.getMonth(), date.getDate() );
	      ngModelCtrl.$setViewValue( dt );
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      $scope.datepickerMode = self.modes[ self.modes.indexOf( $scope.datepickerMode ) - 1 ];
	    }
	  };
	
	  $scope.move = function( direction ) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function( direction ) {
	    direction = direction || 1;
	
	    if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
	      return;
	    }
	
	    $scope.datepickerMode = self.modes[ self.modes.indexOf( $scope.datepickerMode ) + direction ];
	  };
	
	  // Key event mapper
	  $scope.keys = { 13:'enter', 32:'space', 33:'pageup', 34:'pagedown', 35:'end', 36:'home', 37:'left', 38:'up', 39:'right', 40:'down' };
	
	  var focusElement = function() {
	    $timeout(function() {
	      self.element[0].focus();
	    }, 0 , false);
	  };
	
	  // Listen for focus requests from popup directive
	  $scope.$on('datepicker.focus', focusElement);
	
	  $scope.keydown = function( evt ) {
	    var key = $scope.keys[evt.which];
	
	    if ( !key || evt.shiftKey || evt.altKey ) {
	      return;
	    }
	
	    evt.preventDefault();
	    evt.stopPropagation();
	
	    if (key === 'enter' || key === 'space') {
	      if ( self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	      focusElement();
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	      focusElement();
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	}])
	
	.directive( 'datepicker', function () {
	  return {
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/datepicker/datepicker.html',
	    scope: {
	      datepickerMode: '=?',
	      dateDisabled: '&'
	    },
	    require: ['datepicker', '?^ngModel'],
	    controller: 'DatepickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if ( ngModelCtrl ) {
	        datepickerCtrl.init( ngModelCtrl );
	      }
	    }
	  };
	})
	
	.directive('daypicker', ['dateFilter', function (dateFilter) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/datepicker/day.html',
	    require: '^datepicker',
	    link: function(scope, element, attrs, ctrl) {
	      scope.showWeeks = ctrl.showWeeks;
	
	      ctrl.step = { months: 1 };
	      ctrl.element = element;
	
	      var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	      function getDaysInMonth( year, month ) {
	        return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
	      }
	
	      function getDates(startDate, n) {
	        var dates = new Array(n), current = new Date(startDate), i = 0;
	        current.setHours(12); // Prevent repeated dates because of timezone bug
	        while ( i < n ) {
	          dates[i++] = new Date(current);
	          current.setDate( current.getDate() + 1 );
	        }
	        return dates;
	      }
	
	      ctrl._refreshView = function() {
	        var year = ctrl.activeDate.getFullYear(),
	          month = ctrl.activeDate.getMonth(),
	          firstDayOfMonth = new Date(year, month, 1),
	          difference = ctrl.startingDay - firstDayOfMonth.getDay(),
	          numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : - difference,
	          firstDate = new Date(firstDayOfMonth);
	
	        if ( numDisplayedFromPreviousMonth > 0 ) {
	          firstDate.setDate( - numDisplayedFromPreviousMonth + 1 );
	        }
	
	        // 42 is the number of days on a six-month calendar
	        var days = getDates(firstDate, 42);
	        for (var i = 0; i < 42; i ++) {
	          days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {
	            secondary: days[i].getMonth() !== month,
	            uid: scope.uniqueId + '-' + i
	          });
	        }
	
	        scope.labels = new Array(7);
	        for (var j = 0; j < 7; j++) {
	          scope.labels[j] = {
	            abbr: dateFilter(days[j].date, ctrl.formatDayHeader),
	            full: dateFilter(days[j].date, 'EEEE')
	          };
	        }
	
	        scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);
	        scope.rows = ctrl.split(days, 7);
	
	        if ( scope.showWeeks ) {
	          scope.weekNumbers = [];
	          var weekNumber = getISO8601WeekNumber( scope.rows[0][0].date ),
	              numWeeks = scope.rows.length;
	          while( scope.weekNumbers.push(weekNumber++) < numWeeks ) {}
	        }
	      };
	
	      ctrl.compare = function(date1, date2) {
	        return (new Date( date1.getFullYear(), date1.getMonth(), date1.getDate() ) - new Date( date2.getFullYear(), date2.getMonth(), date2.getDate() ) );
	      };
	
	      function getISO8601WeekNumber(date) {
	        var checkDate = new Date(date);
	        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	        var time = checkDate.getTime();
	        checkDate.setMonth(0); // Compare with Jan 1
	        checkDate.setDate(1);
	        return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	      }
	
	      ctrl.handleKeyDown = function( key, evt ) {
	        var date = ctrl.activeDate.getDate();
	
	        if (key === 'left') {
	          date = date - 1;   // up
	        } else if (key === 'up') {
	          date = date - 7;   // down
	        } else if (key === 'right') {
	          date = date + 1;   // down
	        } else if (key === 'down') {
	          date = date + 7;
	        } else if (key === 'pageup' || key === 'pagedown') {
	          var month = ctrl.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
	          ctrl.activeDate.setMonth(month, 1);
	          date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
	        } else if (key === 'home') {
	          date = 1;
	        } else if (key === 'end') {
	          date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
	        }
	        ctrl.activeDate.setDate(date);
	      };
	
	      ctrl.refreshView();
	    }
	  };
	}])
	
	.directive('monthpicker', ['dateFilter', function (dateFilter) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/datepicker/month.html',
	    require: '^datepicker',
	    link: function(scope, element, attrs, ctrl) {
	      ctrl.step = { years: 1 };
	      ctrl.element = element;
	
	      ctrl._refreshView = function() {
	        var months = new Array(12),
	            year = ctrl.activeDate.getFullYear();
	
	        for ( var i = 0; i < 12; i++ ) {
	          months[i] = angular.extend(ctrl.createDateObject(new Date(year, i, 1), ctrl.formatMonth), {
	            uid: scope.uniqueId + '-' + i
	          });
	        }
	
	        scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
	        scope.rows = ctrl.split(months, 3);
	      };
	
	      ctrl.compare = function(date1, date2) {
	        return new Date( date1.getFullYear(), date1.getMonth() ) - new Date( date2.getFullYear(), date2.getMonth() );
	      };
	
	      ctrl.handleKeyDown = function( key, evt ) {
	        var date = ctrl.activeDate.getMonth();
	
	        if (key === 'left') {
	          date = date - 1;   // up
	        } else if (key === 'up') {
	          date = date - 3;   // down
	        } else if (key === 'right') {
	          date = date + 1;   // down
	        } else if (key === 'down') {
	          date = date + 3;
	        } else if (key === 'pageup' || key === 'pagedown') {
	          var year = ctrl.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
	          ctrl.activeDate.setFullYear(year);
	        } else if (key === 'home') {
	          date = 0;
	        } else if (key === 'end') {
	          date = 11;
	        }
	        ctrl.activeDate.setMonth(date);
	      };
	
	      ctrl.refreshView();
	    }
	  };
	}])
	
	.directive('yearpicker', ['dateFilter', function (dateFilter) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/datepicker/year.html',
	    require: '^datepicker',
	    link: function(scope, element, attrs, ctrl) {
	      var range = ctrl.yearRange;
	
	      ctrl.step = { years: range };
	      ctrl.element = element;
	
	      function getStartingYear( year ) {
	        return parseInt((year - 1) / range, 10) * range + 1;
	      }
	
	      ctrl._refreshView = function() {
	        var years = new Array(range);
	
	        for ( var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++ ) {
	          years[i] = angular.extend(ctrl.createDateObject(new Date(start + i, 0, 1), ctrl.formatYear), {
	            uid: scope.uniqueId + '-' + i
	          });
	        }
	
	        scope.title = [years[0].label, years[range - 1].label].join(' - ');
	        scope.rows = ctrl.split(years, 5);
	      };
	
	      ctrl.compare = function(date1, date2) {
	        return date1.getFullYear() - date2.getFullYear();
	      };
	
	      ctrl.handleKeyDown = function( key, evt ) {
	        var date = ctrl.activeDate.getFullYear();
	
	        if (key === 'left') {
	          date = date - 1;   // up
	        } else if (key === 'up') {
	          date = date - 5;   // down
	        } else if (key === 'right') {
	          date = date + 1;   // down
	        } else if (key === 'down') {
	          date = date + 5;
	        } else if (key === 'pageup' || key === 'pagedown') {
	          date += (key === 'pageup' ? - 1 : 1) * ctrl.step.years;
	        } else if (key === 'home') {
	          date = getStartingYear( ctrl.activeDate.getFullYear() );
	        } else if (key === 'end') {
	          date = getStartingYear( ctrl.activeDate.getFullYear() ) + range - 1;
	        }
	        ctrl.activeDate.setFullYear(date);
	      };
	
	      ctrl.refreshView();
	    }
	  };
	}])
	
	.constant('datepickerPopupConfig', {
	  datepickerPopup: 'yyyy-MM-dd',
	  currentText: 'Today',
	  clearText: 'Clear',
	  closeText: 'Done',
	  closeOnDateSelection: true,
	  appendToBody: false,
	  showButtonBar: true
	})
	
	.directive('datepickerPopup', ['$compile', '$parse', '$document', '$position', 'dateFilter', 'dateParser', 'datepickerPopupConfig',
	function ($compile, $parse, $document, $position, dateFilter, dateParser, datepickerPopupConfig) {
	  return {
	    restrict: 'EA',
	    require: 'ngModel',
	    scope: {
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@',
	      dateDisabled: '&'
	    },
	    link: function(scope, element, attrs, ngModel) {
	      var dateFormat,
	          closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection,
	          appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;
	
	      scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;
	
	      scope.getText = function( key ) {
	        return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	      };
	
	      attrs.$observe('datepickerPopup', function(value) {
	          dateFormat = value || datepickerPopupConfig.datepickerPopup;
	          ngModel.$render();
	      });
	
	      // popup element used to display calendar
	      var popupEl = angular.element('<div datepicker-popup-wrap><div datepicker></div></div>');
	      popupEl.attr({
	        'ng-model': 'date',
	        'ng-change': 'dateSelection()'
	      });
	
	      function cameltoDash( string ){
	        return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
	      }
	
	      // datepicker element
	      var datepickerEl = angular.element(popupEl.children()[0]);
	      if ( attrs.datepickerOptions ) {
	        angular.forEach(scope.$parent.$eval(attrs.datepickerOptions), function( value, option ) {
	          datepickerEl.attr( cameltoDash(option), value );
	        });
	      }
	
	      scope.watchData = {};
	      angular.forEach(['minDate', 'maxDate', 'datepickerMode'], function( key ) {
	        if ( attrs[key] ) {
	          var getAttribute = $parse(attrs[key]);
	          scope.$parent.$watch(getAttribute, function(value){
	            scope.watchData[key] = value;
	          });
	          datepickerEl.attr(cameltoDash(key), 'watchData.' + key);
	
	          // Propagate changes from datepicker to outside
	          if ( key === 'datepickerMode' ) {
	            var setAttribute = getAttribute.assign;
	            scope.$watch('watchData.' + key, function(value, oldvalue) {
	              if ( value !== oldvalue ) {
	                setAttribute(scope.$parent, value);
	              }
	            });
	          }
	        }
	      });
	      if (attrs.dateDisabled) {
	        datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
	      }
	
	      function parseDate(viewValue) {
	        if (!viewValue) {
	          ngModel.$setValidity('date', true);
	          return null;
	        } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	          ngModel.$setValidity('date', true);
	          return viewValue;
	        } else if (angular.isString(viewValue)) {
	          var date = dateParser.parse(viewValue, dateFormat) || new Date(viewValue);
	          if (isNaN(date)) {
	            ngModel.$setValidity('date', false);
	            return undefined;
	          } else {
	            ngModel.$setValidity('date', true);
	            return date;
	          }
	        } else {
	          ngModel.$setValidity('date', false);
	          return undefined;
	        }
	      }
	      ngModel.$parsers.unshift(parseDate);
	
	      // Inner change
	      scope.dateSelection = function(dt) {
	        if (angular.isDefined(dt)) {
	          scope.date = dt;
	        }
	        ngModel.$setViewValue(scope.date);
	        ngModel.$render();
	
	        if ( closeOnDateSelection ) {
	          scope.isOpen = false;
	          element[0].focus();
	        }
	      };
	
	      element.bind('input change keyup', function() {
	        scope.$apply(function() {
	          scope.date = ngModel.$modelValue;
	        });
	      });
	
	      // Outter change
	      ngModel.$render = function() {
	        var date = ngModel.$viewValue ? dateFilter(ngModel.$viewValue, dateFormat) : '';
	        element.val(date);
	        scope.date = parseDate( ngModel.$modelValue );
	      };
	
	      var documentClickBind = function(event) {
	        if (scope.isOpen && event.target !== element[0]) {
	          scope.$apply(function() {
	            scope.isOpen = false;
	          });
	        }
	      };
	
	      var keydown = function(evt, noApply) {
	        scope.keydown(evt);
	      };
	      element.bind('keydown', keydown);
	
	      scope.keydown = function(evt) {
	        if (evt.which === 27) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          scope.close();
	        } else if (evt.which === 40 && !scope.isOpen) {
	          scope.isOpen = true;
	        }
	      };
	
	      scope.$watch('isOpen', function(value) {
	        if (value) {
	          scope.$broadcast('datepicker.focus');
	          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	          scope.position.top = scope.position.top + element.prop('offsetHeight');
	
	          $document.bind('click', documentClickBind);
	        } else {
	          $document.unbind('click', documentClickBind);
	        }
	      });
	
	      scope.select = function( date ) {
	        if (date === 'today') {
	          var today = new Date();
	          if (angular.isDate(ngModel.$modelValue)) {
	            date = new Date(ngModel.$modelValue);
	            date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	          } else {
	            date = new Date(today.setHours(0, 0, 0, 0));
	          }
	        }
	        scope.dateSelection( date );
	      };
	
	      scope.close = function() {
	        scope.isOpen = false;
	        element[0].focus();
	      };
	
	      var $popup = $compile(popupEl)(scope);
	      // Prevent jQuery cache memory leak (template is now redundant after linking)
	      popupEl.remove();
	
	      if ( appendToBody ) {
	        $document.find('body').append($popup);
	      } else {
	        element.after($popup);
	      }
	
	      scope.$on('$destroy', function() {
	        $popup.remove();
	        element.unbind('keydown', keydown);
	        $document.unbind('click', documentClickBind);
	      });
	    }
	  };
	}])
	
	.directive('datepickerPopupWrap', function() {
	  return {
	    restrict:'EA',
	    replace: true,
	    transclude: true,
	    templateUrl: 'template/datepicker/popup.html',
	    link:function (scope, element, attrs) {
	      element.bind('click', function(event) {
	        event.preventDefault();
	        event.stopPropagation();
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.dropdown', [])
	
	.constant('dropdownConfig', {
	  openClass: 'open'
	})
	
	.service('dropdownService', ['$document', function($document) {
	  var openScope = null;
	
	  this.open = function( dropdownScope ) {
	    if ( !openScope ) {
	      $document.bind('click', closeDropdown);
	      $document.bind('keydown', escapeKeyBind);
	    }
	
	    if ( openScope && openScope !== dropdownScope ) {
	        openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	  };
	
	  this.close = function( dropdownScope ) {
	    if ( openScope === dropdownScope ) {
	      openScope = null;
	      $document.unbind('click', closeDropdown);
	      $document.unbind('keydown', escapeKeyBind);
	    }
	  };
	
	  var closeDropdown = function( evt ) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope) { return; }
	
	    var toggleElement = openScope.getToggleElement();
	    if ( evt && toggleElement && toggleElement[0].contains(evt.target) ) {
	        return;
	    }
	
	    openScope.$apply(function() {
	      openScope.isOpen = false;
	    });
	  };
	
	  var escapeKeyBind = function( evt ) {
	    if ( evt.which === 27 ) {
	      openScope.focusToggleElement();
	      closeDropdown();
	    }
	  };
	}])
	
	.controller('DropdownController', ['$scope', '$attrs', '$parse', 'dropdownConfig', 'dropdownService', '$animate', function($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate) {
	  var self = this,
	      scope = $scope.$new(), // create a child scope so we are not polluting original one
	      openClass = dropdownConfig.openClass,
	      getIsOpen,
	      setIsOpen = angular.noop,
	      toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop;
	
	  this.init = function( element ) {
	    self.$element = element;
	
	    if ( $attrs.isOpen ) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function(value) {
	        scope.isOpen = !!value;
	      });
	    }
	  };
	
	  this.toggle = function( open ) {
	    return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function() {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function() {
	    return self.toggleElement;
	  };
	
	  scope.focusToggleElement = function() {
	    if ( self.toggleElement ) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  scope.$watch('isOpen', function( isOpen, wasOpen ) {
	    $animate[isOpen ? 'addClass' : 'removeClass'](self.$element, openClass);
	
	    if ( isOpen ) {
	      scope.focusToggleElement();
	      dropdownService.open( scope );
	    } else {
	      dropdownService.close( scope );
	    }
	
	    setIsOpen($scope, isOpen);
	    if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	      toggleInvoker($scope, { open: !!isOpen });
	    }
	  });
	
	  $scope.$on('$locationChangeSuccess', function() {
	    scope.isOpen = false;
	  });
	
	  $scope.$on('$destroy', function() {
	    scope.$destroy();
	  });
	}])
	
	.directive('dropdown', function() {
	  return {
	    controller: 'DropdownController',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init( element );
	    }
	  };
	})
	
	.directive('dropdownToggle', function() {
	  return {
	    require: '?^dropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if ( !dropdownCtrl ) {
	        return;
	      }
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function(event) {
	        event.preventDefault();
	
	        if ( !element.hasClass('disabled') && !attrs.disabled ) {
	          scope.$apply(function() {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.bind('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function( isOpen ) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function() {
	        element.unbind('click', toggleDropdown);
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.modal', ['ui.bootstrap.transition'])
	
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	  .factory('$$stackedMap', function () {
	    return {
	      createNew: function () {
	        var stack = [];
	
	        return {
	          add: function (key, value) {
	            stack.push({
	              key: key,
	              value: value
	            });
	          },
	          get: function (key) {
	            for (var i = 0; i < stack.length; i++) {
	              if (key == stack[i].key) {
	                return stack[i];
	              }
	            }
	          },
	          keys: function() {
	            var keys = [];
	            for (var i = 0; i < stack.length; i++) {
	              keys.push(stack[i].key);
	            }
	            return keys;
	          },
	          top: function () {
	            return stack[stack.length - 1];
	          },
	          remove: function (key) {
	            var idx = -1;
	            for (var i = 0; i < stack.length; i++) {
	              if (key == stack[i].key) {
	                idx = i;
	                break;
	              }
	            }
	            return stack.splice(idx, 1)[0];
	          },
	          removeTop: function () {
	            return stack.splice(stack.length - 1, 1)[0];
	          },
	          length: function () {
	            return stack.length;
	          }
	        };
	      }
	    };
	  })
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	  .directive('modalBackdrop', ['$timeout', function ($timeout) {
	    return {
	      restrict: 'EA',
	      replace: true,
	      templateUrl: 'template/modal/backdrop.html',
	      link: function (scope, element, attrs) {
	        scope.backdropClass = attrs.backdropClass || '';
	
	        scope.animate = false;
	
	        //trigger CSS transitions
	        $timeout(function () {
	          scope.animate = true;
	        });
	      }
	    };
	  }])
	
	  .directive('modalWindow', ['$modalStack', '$timeout', function ($modalStack, $timeout) {
	    return {
	      restrict: 'EA',
	      scope: {
	        index: '@',
	        animate: '='
	      },
	      replace: true,
	      transclude: true,
	      templateUrl: function(tElement, tAttrs) {
	        return tAttrs.templateUrl || 'template/modal/window.html';
	      },
	      link: function (scope, element, attrs) {
	        element.addClass(attrs.windowClass || '');
	        scope.size = attrs.size;
	
	        $timeout(function () {
	          // trigger CSS transitions
	          scope.animate = true;
	
	          /**
	           * Auto-focusing of a freshly-opened modal element causes any child elements
	           * with the autofocus attribute to lose focus. This is an issue on touch
	           * based devices which will show and then hide the onscreen keyboard.
	           * Attempts to refocus the autofocus element via JavaScript will not reopen
	           * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	           * the modal element if the modal does not contain an autofocus element.
	           */
	          if (!element[0].querySelectorAll('[autofocus]').length) {
	            element[0].focus();
	          }
	        });
	
	        scope.close = function (evt) {
	          var modal = $modalStack.getTop();
	          if (modal && modal.value.backdrop && modal.value.backdrop != 'static' && (evt.target === evt.currentTarget)) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            $modalStack.dismiss(modal.key, 'backdrop click');
	          }
	        };
	      }
	    };
	  }])
	
	  .directive('modalTransclude', function () {
	    return {
	      link: function($scope, $element, $attrs, controller, $transclude) {
	        $transclude($scope.$parent, function(clone) {
	          $element.empty();
	          $element.append(clone);
	        });
	      }
	    };
	  })
	
	  .factory('$modalStack', ['$transition', '$timeout', '$document', '$compile', '$rootScope', '$$stackedMap',
	    function ($transition, $timeout, $document, $compile, $rootScope, $$stackedMap) {
	
	      var OPENED_MODAL_CLASS = 'modal-open';
	
	      var backdropDomEl, backdropScope;
	      var openedWindows = $$stackedMap.createNew();
	      var $modalStack = {};
	
	      function backdropIndex() {
	        var topBackdropIndex = -1;
	        var opened = openedWindows.keys();
	        for (var i = 0; i < opened.length; i++) {
	          if (openedWindows.get(opened[i]).value.backdrop) {
	            topBackdropIndex = i;
	          }
	        }
	        return topBackdropIndex;
	      }
	
	      $rootScope.$watch(backdropIndex, function(newBackdropIndex){
	        if (backdropScope) {
	          backdropScope.index = newBackdropIndex;
	        }
	      });
	
	      function removeModalWindow(modalInstance) {
	
	        var body = $document.find('body').eq(0);
	        var modalWindow = openedWindows.get(modalInstance).value;
	
	        //clean up the stack
	        openedWindows.remove(modalInstance);
	
	        //remove window DOM element
	        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, 300, function() {
	          modalWindow.modalScope.$destroy();
	          body.toggleClass(OPENED_MODAL_CLASS, openedWindows.length() > 0);
	          checkRemoveBackdrop();
	        });
	      }
	
	      function checkRemoveBackdrop() {
	          //remove backdrop if no longer needed
	          if (backdropDomEl && backdropIndex() == -1) {
	            var backdropScopeRef = backdropScope;
	            removeAfterAnimate(backdropDomEl, backdropScope, 150, function () {
	              backdropScopeRef.$destroy();
	              backdropScopeRef = null;
	            });
	            backdropDomEl = undefined;
	            backdropScope = undefined;
	          }
	      }
	
	      function removeAfterAnimate(domEl, scope, emulateTime, done) {
	        // Closing animation
	        scope.animate = false;
	
	        var transitionEndEventName = $transition.transitionEndEventName;
	        if (transitionEndEventName) {
	          // transition out
	          var timeout = $timeout(afterAnimating, emulateTime);
	
	          domEl.bind(transitionEndEventName, function () {
	            $timeout.cancel(timeout);
	            afterAnimating();
	            scope.$apply();
	          });
	        } else {
	          // Ensure this call is async
	          $timeout(afterAnimating);
	        }
	
	        function afterAnimating() {
	          if (afterAnimating.done) {
	            return;
	          }
	          afterAnimating.done = true;
	
	          domEl.remove();
	          if (done) {
	            done();
	          }
	        }
	      }
	
	      $document.bind('keydown', function (evt) {
	        var modal;
	
	        if (evt.which === 27) {
	          modal = openedWindows.top();
	          if (modal && modal.value.keyboard) {
	            evt.preventDefault();
	            $rootScope.$apply(function () {
	              $modalStack.dismiss(modal.key, 'escape key press');
	            });
	          }
	        }
	      });
	
	      $modalStack.open = function (modalInstance, modal) {
	
	        openedWindows.add(modalInstance, {
	          deferred: modal.deferred,
	          modalScope: modal.scope,
	          backdrop: modal.backdrop,
	          keyboard: modal.keyboard
	        });
	
	        var body = $document.find('body').eq(0),
	            currBackdropIndex = backdropIndex();
	
	        if (currBackdropIndex >= 0 && !backdropDomEl) {
	          backdropScope = $rootScope.$new(true);
	          backdropScope.index = currBackdropIndex;
	          var angularBackgroundDomEl = angular.element('<div modal-backdrop></div>');
	          angularBackgroundDomEl.attr('backdrop-class', modal.backdropClass);
	          backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);
	          body.append(backdropDomEl);
	        }
	
	        var angularDomEl = angular.element('<div modal-window></div>');
	        angularDomEl.attr({
	          'template-url': modal.windowTemplateUrl,
	          'window-class': modal.windowClass,
	          'size': modal.size,
	          'index': openedWindows.length() - 1,
	          'animate': 'animate'
	        }).html(modal.content);
	
	        var modalDomEl = $compile(angularDomEl)(modal.scope);
	        openedWindows.top().value.modalDomEl = modalDomEl;
	        body.append(modalDomEl);
	        body.addClass(OPENED_MODAL_CLASS);
	      };
	
	      $modalStack.close = function (modalInstance, result) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.deferred.resolve(result);
	          removeModalWindow(modalInstance);
	        }
	      };
	
	      $modalStack.dismiss = function (modalInstance, reason) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.deferred.reject(reason);
	          removeModalWindow(modalInstance);
	        }
	      };
	
	      $modalStack.dismissAll = function (reason) {
	        var topModal = this.getTop();
	        while (topModal) {
	          this.dismiss(topModal.key, reason);
	          topModal = this.getTop();
	        }
	      };
	
	      $modalStack.getTop = function () {
	        return openedWindows.top();
	      };
	
	      return $modalStack;
	    }])
	
	  .provider('$modal', function () {
	
	    var $modalProvider = {
	      options: {
	        backdrop: true, //can be also false or 'static'
	        keyboard: true
	      },
	      $get: ['$injector', '$rootScope', '$q', '$http', '$templateCache', '$controller', '$modalStack',
	        function ($injector, $rootScope, $q, $http, $templateCache, $controller, $modalStack) {
	
	          var $modal = {};
	
	          function getTemplatePromise(options) {
	            return options.template ? $q.when(options.template) :
	              $http.get(angular.isFunction(options.templateUrl) ? (options.templateUrl)() : options.templateUrl,
	                {cache: $templateCache}).then(function (result) {
	                  return result.data;
	              });
	          }
	
	          function getResolvePromises(resolves) {
	            var promisesArr = [];
	            angular.forEach(resolves, function (value) {
	              if (angular.isFunction(value) || angular.isArray(value)) {
	                promisesArr.push($q.when($injector.invoke(value)));
	              }
	            });
	            return promisesArr;
	          }
	
	          $modal.open = function (modalOptions) {
	
	            var modalResultDeferred = $q.defer();
	            var modalOpenedDeferred = $q.defer();
	
	            //prepare an instance of a modal to be injected into controllers and returned to a caller
	            var modalInstance = {
	              result: modalResultDeferred.promise,
	              opened: modalOpenedDeferred.promise,
	              close: function (result) {
	                $modalStack.close(modalInstance, result);
	              },
	              dismiss: function (reason) {
	                $modalStack.dismiss(modalInstance, reason);
	              }
	            };
	
	            //merge and clean up options
	            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	            modalOptions.resolve = modalOptions.resolve || {};
	
	            //verify options
	            if (!modalOptions.template && !modalOptions.templateUrl) {
	              throw new Error('One of template or templateUrl options is required.');
	            }
	
	            var templateAndResolvePromise =
	              $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));
	
	
	            templateAndResolvePromise.then(function resolveSuccess(tplAndVars) {
	
	              var modalScope = (modalOptions.scope || $rootScope).$new();
	              modalScope.$close = modalInstance.close;
	              modalScope.$dismiss = modalInstance.dismiss;
	
	              var ctrlInstance, ctrlLocals = {};
	              var resolveIter = 1;
	
	              //controllers
	              if (modalOptions.controller) {
	                ctrlLocals.$scope = modalScope;
	                ctrlLocals.$modalInstance = modalInstance;
	                angular.forEach(modalOptions.resolve, function (value, key) {
	                  ctrlLocals[key] = tplAndVars[resolveIter++];
	                });
	
	                ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
	                if (modalOptions.controllerAs) {
	                  modalScope[modalOptions.controllerAs] = ctrlInstance;
	                }
	              }
	
	              $modalStack.open(modalInstance, {
	                scope: modalScope,
	                deferred: modalResultDeferred,
	                content: tplAndVars[0],
	                backdrop: modalOptions.backdrop,
	                keyboard: modalOptions.keyboard,
	                backdropClass: modalOptions.backdropClass,
	                windowClass: modalOptions.windowClass,
	                windowTemplateUrl: modalOptions.windowTemplateUrl,
	                size: modalOptions.size
	              });
	
	            }, function resolveError(reason) {
	              modalResultDeferred.reject(reason);
	            });
	
	            templateAndResolvePromise.then(function () {
	              modalOpenedDeferred.resolve(true);
	            }, function () {
	              modalOpenedDeferred.reject(false);
	            });
	
	            return modalInstance;
	          };
	
	          return $modal;
	        }]
	    };
	
	    return $modalProvider;
	  });
	
	angular.module('ui.bootstrap.pagination', [])
	
	.controller('PaginationController', ['$scope', '$attrs', '$parse', function ($scope, $attrs, $parse) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	      setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	
	  this.init = function(ngModelCtrl_, config) {
	    ngModelCtrl = ngModelCtrl_;
	    this.config = config;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	
	    if ($attrs.itemsPerPage) {
	      $scope.$parent.$watch($parse($attrs.itemsPerPage), function(value) {
	        self.itemsPerPage = parseInt(value, 10);
	        $scope.totalPages = self.calculateTotalPages();
	      });
	    } else {
	      this.itemsPerPage = config.itemsPerPage;
	    }
	  };
	
	  this.calculateTotalPages = function() {
	    var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
	    return Math.max(totalPages || 0, 1);
	  };
	
	  this.render = function() {
	    $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
	  };
	
	  $scope.selectPage = function(page) {
	    if ( $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	      ngModelCtrl.$setViewValue(page);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.getText = function( key ) {
	    return $scope[key + 'Text'] || self.config[key + 'Text'];
	  };
	  $scope.noPrevious = function() {
	    return $scope.page === 1;
	  };
	  $scope.noNext = function() {
	    return $scope.page === $scope.totalPages;
	  };
	
	  $scope.$watch('totalItems', function() {
	    $scope.totalPages = self.calculateTotalPages();
	  });
	
	  $scope.$watch('totalPages', function(value) {
	    setNumPages($scope.$parent, value); // Readonly variable
	
	    if ( $scope.page > value ) {
	      $scope.selectPage(value);
	    } else {
	      ngModelCtrl.$render();
	    }
	  });
	}])
	
	.constant('paginationConfig', {
	  itemsPerPage: 10,
	  boundaryLinks: false,
	  directionLinks: true,
	  firstText: 'First',
	  previousText: 'Previous',
	  nextText: 'Next',
	  lastText: 'Last',
	  rotate: true
	})
	
	.directive('pagination', ['$parse', 'paginationConfig', function($parse, paginationConfig) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@'
	    },
	    require: ['pagination', '?ngModel'],
	    controller: 'PaginationController',
	    templateUrl: 'template/pagination/pagination.html',
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      // Setup configuration parameters
	      var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize,
	          rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
	      scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
	      scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;
	
	      paginationCtrl.init(ngModelCtrl, paginationConfig);
	
	      if (attrs.maxSize) {
	        scope.$parent.$watch($parse(attrs.maxSize), function(value) {
	          maxSize = parseInt(value, 10);
	          paginationCtrl.render();
	        });
	      }
	
	      // Create page object used in template
	      function makePage(number, text, isActive) {
	        return {
	          number: number,
	          text: text,
	          active: isActive
	        };
	      }
	
	      function getPages(currentPage, totalPages) {
	        var pages = [];
	
	        // Default page limits
	        var startPage = 1, endPage = totalPages;
	        var isMaxSized = ( angular.isDefined(maxSize) && maxSize < totalPages );
	
	        // recompute if maxSize
	        if ( isMaxSized ) {
	          if ( rotate ) {
	            // Current page is displayed in the middle of the visible ones
	            startPage = Math.max(currentPage - Math.floor(maxSize/2), 1);
	            endPage   = startPage + maxSize - 1;
	
	            // Adjust if limit is exceeded
	            if (endPage > totalPages) {
	              endPage   = totalPages;
	              startPage = endPage - maxSize + 1;
	            }
	          } else {
	            // Visible pages are paginated with maxSize
	            startPage = ((Math.ceil(currentPage / maxSize) - 1) * maxSize) + 1;
	
	            // Adjust last page if limit is exceeded
	            endPage = Math.min(startPage + maxSize - 1, totalPages);
	          }
	        }
	
	        // Add page number links
	        for (var number = startPage; number <= endPage; number++) {
	          var page = makePage(number, number, number === currentPage);
	          pages.push(page);
	        }
	
	        // Add links to move between page sets
	        if ( isMaxSized && ! rotate ) {
	          if ( startPage > 1 ) {
	            var previousPageSet = makePage(startPage - 1, '...', false);
	            pages.unshift(previousPageSet);
	          }
	
	          if ( endPage < totalPages ) {
	            var nextPageSet = makePage(endPage + 1, '...', false);
	            pages.push(nextPageSet);
	          }
	        }
	
	        return pages;
	      }
	
	      var originalRender = paginationCtrl.render;
	      paginationCtrl.render = function() {
	        originalRender();
	        if (scope.page > 0 && scope.page <= scope.totalPages) {
	          scope.pages = getPages(scope.page, scope.totalPages);
	        }
	      };
	    }
	  };
	}])
	
	.constant('pagerConfig', {
	  itemsPerPage: 10,
	  previousText: '« Previous',
	  nextText: 'Next »',
	  align: true
	})
	
	.directive('pager', ['pagerConfig', function(pagerConfig) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      previousText: '@',
	      nextText: '@'
	    },
	    require: ['pager', '?ngModel'],
	    controller: 'PaginationController',
	    templateUrl: 'template/pagination/pager.html',
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      scope.align = angular.isDefined(attrs.align) ? scope.$parent.$eval(attrs.align) : pagerConfig.align;
	      paginationCtrl.init(ngModelCtrl, pagerConfig);
	    }
	  };
	}]);
	
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module( 'ui.bootstrap.tooltip', [ 'ui.bootstrap.position', 'ui.bootstrap.bindHtml' ] )
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider( '$tooltip', function () {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    animation: true,
	    popupDelay: 0
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'focus': 'blur'
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
		this.options = function( value ) {
			angular.extend( globalOptions, value );
		};
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
	   */
	  this.setTriggers = function setTriggers ( triggers ) {
	    angular.extend( triggerMap, triggers );
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake-case.
	   */
	  function snake_case(name){
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function(letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = [ '$window', '$compile', '$timeout', '$document', '$position', '$interpolate', function ( $window, $compile, $timeout, $document, $position, $interpolate ) {
	    return function $tooltip ( type, prefix, defaultTriggerShow ) {
	      var options = angular.extend( {}, defaultOptions, globalOptions );
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers ( trigger ) {
	        var show = trigger || options.trigger || defaultTriggerShow;
	        var hide = triggerMap[show] || show;
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case( type );
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template =
	        '<div '+ directiveName +'-popup '+
	          'title="'+startSym+'title'+endSym+'" '+
	          'content="'+startSym+'content'+endSym+'" '+
	          'placement="'+startSym+'placement'+endSym+'" '+
	          'animation="animation" '+
	          'is-open="isOpen"'+
	          '>'+
	        '</div>';
	
	      return {
	        restrict: 'EA',
	        compile: function (tElem, tAttrs) {
	          var tooltipLinker = $compile( template );
	
	          return function link ( scope, element, attrs ) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var popupTimeout;
	            var appendToBody = angular.isDefined( options.appendToBody ) ? options.appendToBody : false;
	            var triggers = getTriggers( undefined );
	            var hasEnableExp = angular.isDefined(attrs[prefix+'Enable']);
	            var ttScope = scope.$new(true);
	
	            var positionTooltip = function () {
	
	              var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	              ttPosition.top += 'px';
	              ttPosition.left += 'px';
	
	              // Now set the calculated positioning.
	              tooltip.css( ttPosition );
	            };
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	
	            function toggleTooltipBind () {
	              if ( ! ttScope.isOpen ) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if(hasEnableExp && !scope.$eval(attrs[prefix+'Enable'])) {
	                return;
	              }
	
	              prepareTooltip();
	
	              if ( ttScope.popupDelay ) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!popupTimeout) {
	                  popupTimeout = $timeout( show, ttScope.popupDelay, false );
	                  popupTimeout.then(function(reposition){reposition();});
	                }
	              } else {
	                show()();
	              }
	            }
	
	            function hideTooltipBind () {
	              scope.$apply(function () {
	                hide();
	              });
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	
	              popupTimeout = null;
	
	              // If there is a pending remove transition, we must cancel it, lest the
	              // tooltip be mysteriously removed.
	              if ( transitionTimeout ) {
	                $timeout.cancel( transitionTimeout );
	                transitionTimeout = null;
	              }
	
	              // Don't show empty tooltips.
	              if ( ! ttScope.content ) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // Set the initial positioning.
	              tooltip.css({ top: 0, left: 0, display: 'block' });
	              ttScope.$digest();
	
	              positionTooltip();
	
	              // And show the tooltip.
	              ttScope.isOpen = true;
	              ttScope.$digest(); // digest required as $apply is not called
	
	              // Return positioning function as promise callback for correct
	              // positioning after draw.
	              return positionTooltip;
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              // First things first: we don't show it anymore.
	              ttScope.isOpen = false;
	
	              //if tooltip is going to be shown after delay, we must cancel this
	              $timeout.cancel( popupTimeout );
	              popupTimeout = null;
	
	              // And now we remove it from the DOM. However, if we have animation, we
	              // need to wait for it to expire beforehand.
	              // FIXME: this is a placeholder for a port of the transitions library.
	              if ( ttScope.animation ) {
	                if (!transitionTimeout) {
	                  transitionTimeout = $timeout(removeTooltip, 500);
	                }
	              } else {
	                removeTooltip();
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                removeTooltip();
	              }
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
	                if ( appendToBody ) {
	                  $document.find( 'body' ).append( tooltip );
	                } else {
	                  element.after( tooltip );
	                }
	              });
	            }
	
	            function removeTooltip() {
	              transitionTimeout = null;
	              if (tooltip) {
	                tooltip.remove();
	                tooltip = null;
	              }
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            function prepareTooltip() {
	              prepPlacement();
	              prepPopupDelay();
	            }
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe( type, function ( val ) {
	              ttScope.content = val;
	
	              if (!val && ttScope.isOpen ) {
	                hide();
	              }
	            });
	
	            attrs.$observe( prefix+'Title', function ( val ) {
	              ttScope.title = val;
	            });
	
	            function prepPlacement() {
	              var val = attrs[ prefix + 'Placement' ];
	              ttScope.placement = angular.isDefined( val ) ? val : options.placement;
	            }
	
	            function prepPopupDelay() {
	              var val = attrs[ prefix + 'PopupDelay' ];
	              var delay = parseInt( val, 10 );
	              ttScope.popupDelay = ! isNaN(delay) ? delay : options.popupDelay;
	            }
	
	            var unregisterTriggers = function () {
	              element.unbind(triggers.show, showTooltipBind);
	              element.unbind(triggers.hide, hideTooltipBind);
	            };
	
	            function prepTriggers() {
	              var val = attrs[ prefix + 'Trigger' ];
	              unregisterTriggers();
	
	              triggers = getTriggers( val );
	
	              if ( triggers.show === triggers.hide ) {
	                element.bind( triggers.show, toggleTooltipBind );
	              } else {
	                element.bind( triggers.show, showTooltipBind );
	                element.bind( triggers.hide, hideTooltipBind );
	              }
	            }
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal = scope.$eval(attrs[prefix + 'AppendToBody']);
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // if a tooltip is attached to <body> we need to remove it on
	            // location change as its parent scope will probably not be destroyed
	            // by the change.
	            if ( appendToBody ) {
	              scope.$on('$locationChangeSuccess', function closeTooltipOnLocationChangeSuccess () {
	              if ( ttScope.isOpen ) {
	                hide();
	              }
	            });
	            }
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              $timeout.cancel( transitionTimeout );
	              $timeout.cancel( popupTimeout );
	              unregisterTriggers();
	              removeTooltip();
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	.directive( 'tooltipPopup', function () {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { content: '@', placement: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-popup.html'
	  };
	})
	
	.directive( 'tooltip', [ '$tooltip', function ( $tooltip ) {
	  return $tooltip( 'tooltip', 'tooltip', 'mouseenter' );
	}])
	
	.directive( 'tooltipHtmlUnsafePopup', function () {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { content: '@', placement: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-html-unsafe-popup.html'
	  };
	})
	
	.directive( 'tooltipHtmlUnsafe', [ '$tooltip', function ( $tooltip ) {
	  return $tooltip( 'tooltipHtmlUnsafe', 'tooltip', 'mouseenter' );
	}]);
	
	/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html popovers, and selector delegatation.
	 */
	angular.module( 'ui.bootstrap.popover', [ 'ui.bootstrap.tooltip' ] )
	
	.directive( 'popoverPopup', function () {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { title: '@', content: '@', placement: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/popover/popover.html'
	  };
	})
	
	.directive( 'popover', [ '$tooltip', function ( $tooltip ) {
	  return $tooltip( 'popover', 'popover', 'click' );
	}]);
	
	angular.module('ui.bootstrap.progressbar', [])
	
	.constant('progressConfig', {
	  animate: true,
	  max: 100
	})
	
	.controller('ProgressController', ['$scope', '$attrs', 'progressConfig', function($scope, $attrs, progressConfig) {
	    var self = this,
	        animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	    this.bars = [];
	    $scope.max = angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : progressConfig.max;
	
	    this.addBar = function(bar, element) {
	        if ( !animate ) {
	            element.css({'transition': 'none'});
	        }
	
	        this.bars.push(bar);
	
	        bar.$watch('value', function( value ) {
	            bar.percent = +(100 * value / $scope.max).toFixed(2);
	        });
	
	        bar.$on('$destroy', function() {
	            element = null;
	            self.removeBar(bar);
	        });
	    };
	
	    this.removeBar = function(bar) {
	        this.bars.splice(this.bars.indexOf(bar), 1);
	    };
	}])
	
	.directive('progress', function() {
	    return {
	        restrict: 'EA',
	        replace: true,
	        transclude: true,
	        controller: 'ProgressController',
	        require: 'progress',
	        scope: {},
	        templateUrl: 'template/progressbar/progress.html'
	    };
	})
	
	.directive('bar', function() {
	    return {
	        restrict: 'EA',
	        replace: true,
	        transclude: true,
	        require: '^progress',
	        scope: {
	            value: '=',
	            type: '@'
	        },
	        templateUrl: 'template/progressbar/bar.html',
	        link: function(scope, element, attrs, progressCtrl) {
	            progressCtrl.addBar(scope, element);
	        }
	    };
	})
	
	.directive('progressbar', function() {
	    return {
	        restrict: 'EA',
	        replace: true,
	        transclude: true,
	        controller: 'ProgressController',
	        scope: {
	            value: '=',
	            type: '@'
	        },
	        templateUrl: 'template/progressbar/progressbar.html',
	        link: function(scope, element, attrs, progressCtrl) {
	            progressCtrl.addBar(scope, angular.element(element.children()[0]));
	        }
	    };
	});
	angular.module('ui.bootstrap.rating', [])
	
	.constant('ratingConfig', {
	  max: 5,
	  stateOn: null,
	  stateOff: null
	})
	
	.controller('RatingController', ['$scope', '$attrs', 'ratingConfig', function($scope, $attrs, ratingConfig) {
	  var ngModelCtrl  = { $setViewValue: angular.noop };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
	    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
	
	    var ratingStates = angular.isDefined($attrs.ratingStates) ? $scope.$parent.$eval($attrs.ratingStates) :
	                        new Array( angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max );
	    $scope.range = this.buildTemplateObjects(ratingStates);
	  };
	
	  this.buildTemplateObjects = function(states) {
	    for (var i = 0, n = states.length; i < n; i++) {
	      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff }, states[i]);
	    }
	    return states;
	  };
	
	  $scope.rate = function(value) {
	    if ( !$scope.readonly && value >= 0 && value <= $scope.range.length ) {
	      ngModelCtrl.$setViewValue(value);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.enter = function(value) {
	    if ( !$scope.readonly ) {
	      $scope.value = value;
	    }
	    $scope.onHover({value: value});
	  };
	
	  $scope.reset = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.onLeave();
	  };
	
	  $scope.onKeydown = function(evt) {
	    if (/(37|38|39|40)/.test(evt.which)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.rate( $scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1) );
	    }
	  };
	
	  this.render = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	  };
	}])
	
	.directive('rating', function() {
	  return {
	    restrict: 'EA',
	    require: ['rating', 'ngModel'],
	    scope: {
	      readonly: '=?',
	      onHover: '&',
	      onLeave: '&'
	    },
	    controller: 'RatingController',
	    templateUrl: 'template/rating/rating.html',
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if ( ngModelCtrl ) {
	        ratingCtrl.init( ngModelCtrl );
	      }
	    }
	  };
	});
	
	/**
	 * @ngdoc overview
	 * @name ui.bootstrap.tabs
	 *
	 * @description
	 * AngularJS version of the tabs directive.
	 */
	
	angular.module('ui.bootstrap.tabs', [])
	
	.controller('TabsetController', ['$scope', function TabsetCtrl($scope) {
	  var ctrl = this,
	      tabs = ctrl.tabs = $scope.tabs = [];
	
	  ctrl.select = function(selectedTab) {
	    angular.forEach(tabs, function(tab) {
	      if (tab.active && tab !== selectedTab) {
	        tab.active = false;
	        tab.onDeselect();
	      }
	    });
	    selectedTab.active = true;
	    selectedTab.onSelect();
	  };
	
	  ctrl.addTab = function addTab(tab) {
	    tabs.push(tab);
	    // we can't run the select function on the first tab
	    // since that would select it twice
	    if (tabs.length === 1) {
	      tab.active = true;
	    } else if (tab.active) {
	      ctrl.select(tab);
	    }
	  };
	
	  ctrl.removeTab = function removeTab(tab) {
	    var index = tabs.indexOf(tab);
	    //Select a new tab if the tab to be removed is selected and not destroyed
	    if (tab.active && tabs.length > 1 && !destroyed) {
	      //If this is the last tab, select the previous tab. else, the next tab.
	      var newActiveIndex = index == tabs.length - 1 ? index - 1 : index + 1;
	      ctrl.select(tabs[newActiveIndex]);
	    }
	    tabs.splice(index, 1);
	  };
	
	  var destroyed;
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	  });
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tabset
	 * @restrict EA
	 *
	 * @description
	 * Tabset is the outer container for the tabs directive
	 *
	 * @param {boolean=} vertical Whether or not to use vertical styling for the tabs.
	 * @param {boolean=} justified Whether or not to use justified styling for the tabs.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <tabset>
	      <tab heading="Tab 1"><b>First</b> Content!</tab>
	      <tab heading="Tab 2"><i>Second</i> Content!</tab>
	    </tabset>
	    <hr />
	    <tabset vertical="true">
	      <tab heading="Vertical Tab 1"><b>First</b> Vertical Content!</tab>
	      <tab heading="Vertical Tab 2"><i>Second</i> Vertical Content!</tab>
	    </tabset>
	    <tabset justified="true">
	      <tab heading="Justified Tab 1"><b>First</b> Justified Content!</tab>
	      <tab heading="Justified Tab 2"><i>Second</i> Justified Content!</tab>
	    </tabset>
	  </file>
	</example>
	 */
	.directive('tabset', function() {
	  return {
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    scope: {
	      type: '@'
	    },
	    controller: 'TabsetController',
	    templateUrl: 'template/tabs/tabset.html',
	    link: function(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
	    }
	  };
	})
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tab
	 * @restrict EA
	 *
	 * @param {string=} heading The visible heading, or title, of the tab. Set HTML headings with {@link ui.bootstrap.tabs.directive:tabHeading tabHeading}.
	 * @param {string=} select An expression to evaluate when the tab is selected.
	 * @param {boolean=} active A binding, telling whether or not this tab is selected.
	 * @param {boolean=} disabled A binding, telling whether or not this tab is disabled.
	 *
	 * @description
	 * Creates a tab with a heading and content. Must be placed within a {@link ui.bootstrap.tabs.directive:tabset tabset}.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <div ng-controller="TabsDemoCtrl">
	      <button class="btn btn-small" ng-click="items[0].active = true">
	        Select item 1, using active binding
	      </button>
	      <button class="btn btn-small" ng-click="items[1].disabled = !items[1].disabled">
	        Enable/disable item 2, using disabled binding
	      </button>
	      <br />
	      <tabset>
	        <tab heading="Tab 1">First Tab</tab>
	        <tab select="alertMe()">
	          <tab-heading><i class="icon-bell"></i> Alert me!</tab-heading>
	          Second Tab, with alert callback and html heading!
	        </tab>
	        <tab ng-repeat="item in items"
	          heading="{{item.title}}"
	          disabled="item.disabled"
	          active="item.active">
	          {{item.content}}
	        </tab>
	      </tabset>
	    </div>
	  </file>
	  <file name="script.js">
	    function TabsDemoCtrl($scope) {
	      $scope.items = [
	        { title:"Dynamic Title 1", content:"Dynamic Item 0" },
	        { title:"Dynamic Title 2", content:"Dynamic Item 1", disabled: true }
	      ];
	
	      $scope.alertMe = function() {
	        setTimeout(function() {
	          alert("You've selected the alert tab!");
	        });
	      };
	    };
	  </file>
	</example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tabHeading
	 * @restrict EA
	 *
	 * @description
	 * Creates an HTML heading for a {@link ui.bootstrap.tabs.directive:tab tab}. Must be placed as a child of a tab element.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <tabset>
	      <tab>
	        <tab-heading><b>HTML</b> in my titles?!</tab-heading>
	        And some content, too!
	      </tab>
	      <tab>
	        <tab-heading><i class="icon-heart"></i> Icon heading?!?</tab-heading>
	        That's right.
	      </tab>
	    </tabset>
	  </file>
	</example>
	 */
	.directive('tab', ['$parse', function($parse) {
	  return {
	    require: '^tabset',
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/tabs/tab.html',
	    transclude: true,
	    scope: {
	      active: '=?',
	      heading: '@',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	                          //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    compile: function(elm, attrs, transclude) {
	      return function postLink(scope, elm, attrs, tabsetCtrl) {
	        scope.$watch('active', function(active) {
	          if (active) {
	            tabsetCtrl.select(scope);
	          }
	        });
	
	        scope.disabled = false;
	        if ( attrs.disabled ) {
	          scope.$parent.$watch($parse(attrs.disabled), function(value) {
	            scope.disabled = !! value;
	          });
	        }
	
	        scope.select = function() {
	          if ( !scope.disabled ) {
	            scope.active = true;
	          }
	        };
	
	        tabsetCtrl.addTab(scope);
	        scope.$on('$destroy', function() {
	          tabsetCtrl.removeTab(scope);
	        });
	
	        //We need to transclude later, once the content container is ready.
	        //when this link happens, we're inside a tab heading.
	        scope.$transcludeFn = transclude;
	      };
	    }
	  };
	}])
	
	.directive('tabHeadingTransclude', [function() {
	  return {
	    restrict: 'A',
	    require: '^tab',
	    link: function(scope, elm, attrs, tabCtrl) {
	      scope.$watch('headingElement', function updateHeadingElement(heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	}])
	
	.directive('tabContentTransclude', function() {
	  return {
	    restrict: 'A',
	    require: '^tabset',
	    link: function(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.tabContentTransclude);
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function(contents) {
	        angular.forEach(contents, function(node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	  function isTabHeading(node) {
	    return node.tagName &&  (
	      node.hasAttribute('tab-heading') ||
	      node.hasAttribute('data-tab-heading') ||
	      node.tagName.toLowerCase() === 'tab-heading' ||
	      node.tagName.toLowerCase() === 'data-tab-heading'
	    );
	  }
	})
	
	;
	
	angular.module('ui.bootstrap.timepicker', [])
	
	.constant('timepickerConfig', {
	  hourStep: 1,
	  minuteStep: 1,
	  showMeridian: true,
	  meridians: null,
	  readonlyInput: false,
	  mousewheel: true
	})
	
	.controller('TimepickerController', ['$scope', '$attrs', '$parse', '$log', '$locale', 'timepickerConfig', function($scope, $attrs, $parse, $log, $locale, timepickerConfig) {
	  var selected = new Date(),
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	      meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;
	
	  this.init = function( ngModelCtrl_, inputs ) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    var hoursInputEl = inputs.eq(0),
	        minutesInputEl = inputs.eq(1);
	
	    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
	    if ( mousewheel ) {
	      this.setupMousewheelEvents( hoursInputEl, minutesInputEl );
	    }
	
	    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	    this.setupInputEvents( hoursInputEl, minutesInputEl );
	  };
	
	  var hourStep = timepickerConfig.hourStep;
	  if ($attrs.hourStep) {
	    $scope.$parent.$watch($parse($attrs.hourStep), function(value) {
	      hourStep = parseInt(value, 10);
	    });
	  }
	
	  var minuteStep = timepickerConfig.minuteStep;
	  if ($attrs.minuteStep) {
	    $scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
	      minuteStep = parseInt(value, 10);
	    });
	  }
	
	  // 12H / 24H mode
	  $scope.showMeridian = timepickerConfig.showMeridian;
	  if ($attrs.showMeridian) {
	    $scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
	      $scope.showMeridian = !!value;
	
	      if ( ngModelCtrl.$error.time ) {
	        // Evaluate from template
	        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
	        if (angular.isDefined( hours ) && angular.isDefined( minutes )) {
	          selected.setHours( hours );
	          refresh();
	        }
	      } else {
	        updateTemplate();
	      }
	    });
	  }
	
	  // Get $scope.hours in 24H mode if valid
	  function getHoursFromTemplate ( ) {
	    var hours = parseInt( $scope.hours, 10 );
	    var valid = ( $scope.showMeridian ) ? (hours > 0 && hours < 13) : (hours >= 0 && hours < 24);
	    if ( !valid ) {
	      return undefined;
	    }
	
	    if ( $scope.showMeridian ) {
	      if ( hours === 12 ) {
	        hours = 0;
	      }
	      if ( $scope.meridian === meridians[1] ) {
	        hours = hours + 12;
	      }
	    }
	    return hours;
	  }
	
	  function getMinutesFromTemplate() {
	    var minutes = parseInt($scope.minutes, 10);
	    return ( minutes >= 0 && minutes < 60 ) ? minutes : undefined;
	  }
	
	  function pad( value ) {
	    return ( angular.isDefined(value) && value.toString().length < 2 ) ? '0' + value : value;
	  }
	
	  // Respond on mousewheel spin
	  this.setupMousewheelEvents = function( hoursInputEl, minutesInputEl ) {
	    var isScrollingUp = function(e) {
	      if (e.originalEvent) {
	        e = e.originalEvent;
	      }
	      //pick correct delta variable depending on event
	      var delta = (e.wheelDelta) ? e.wheelDelta : -e.deltaY;
	      return (e.detail || delta > 0);
	    };
	
	    hoursInputEl.bind('mousewheel wheel', function(e) {
	      $scope.$apply( (isScrollingUp(e)) ? $scope.incrementHours() : $scope.decrementHours() );
	      e.preventDefault();
	    });
	
	    minutesInputEl.bind('mousewheel wheel', function(e) {
	      $scope.$apply( (isScrollingUp(e)) ? $scope.incrementMinutes() : $scope.decrementMinutes() );
	      e.preventDefault();
	    });
	
	  };
	
	  this.setupInputEvents = function( hoursInputEl, minutesInputEl ) {
	    if ( $scope.readonlyInput ) {
	      $scope.updateHours = angular.noop;
	      $scope.updateMinutes = angular.noop;
	      return;
	    }
	
	    var invalidate = function(invalidHours, invalidMinutes) {
	      ngModelCtrl.$setViewValue( null );
	      ngModelCtrl.$setValidity('time', false);
	      if (angular.isDefined(invalidHours)) {
	        $scope.invalidHours = invalidHours;
	      }
	      if (angular.isDefined(invalidMinutes)) {
	        $scope.invalidMinutes = invalidMinutes;
	      }
	    };
	
	    $scope.updateHours = function() {
	      var hours = getHoursFromTemplate();
	
	      if ( angular.isDefined(hours) ) {
	        selected.setHours( hours );
	        refresh( 'h' );
	      } else {
	        invalidate(true);
	      }
	    };
	
	    hoursInputEl.bind('blur', function(e) {
	      if ( !$scope.invalidHours && $scope.hours < 10) {
	        $scope.$apply( function() {
	          $scope.hours = pad( $scope.hours );
	        });
	      }
	    });
	
	    $scope.updateMinutes = function() {
	      var minutes = getMinutesFromTemplate();
	
	      if ( angular.isDefined(minutes) ) {
	        selected.setMinutes( minutes );
	        refresh( 'm' );
	      } else {
	        invalidate(undefined, true);
	      }
	    };
	
	    minutesInputEl.bind('blur', function(e) {
	      if ( !$scope.invalidMinutes && $scope.minutes < 10 ) {
	        $scope.$apply( function() {
	          $scope.minutes = pad( $scope.minutes );
	        });
	      }
	    });
	
	  };
	
	  this.render = function() {
	    var date = ngModelCtrl.$modelValue ? new Date( ngModelCtrl.$modelValue ) : null;
	
	    if ( isNaN(date) ) {
	      ngModelCtrl.$setValidity('time', false);
	      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	    } else {
	      if ( date ) {
	        selected = date;
	      }
	      makeValid();
	      updateTemplate();
	    }
	  };
	
	  // Call internally when we know that model is valid.
	  function refresh( keyboardChange ) {
	    makeValid();
	    ngModelCtrl.$setViewValue( new Date(selected) );
	    updateTemplate( keyboardChange );
	  }
	
	  function makeValid() {
	    ngModelCtrl.$setValidity('time', true);
	    $scope.invalidHours = false;
	    $scope.invalidMinutes = false;
	  }
	
	  function updateTemplate( keyboardChange ) {
	    var hours = selected.getHours(), minutes = selected.getMinutes();
	
	    if ( $scope.showMeridian ) {
	      hours = ( hours === 0 || hours === 12 ) ? 12 : hours % 12; // Convert 24 to 12 hour system
	    }
	
	    $scope.hours = keyboardChange === 'h' ? hours : pad(hours);
	    $scope.minutes = keyboardChange === 'm' ? minutes : pad(minutes);
	    $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	  }
	
	  function addMinutes( minutes ) {
	    var dt = new Date( selected.getTime() + minutes * 60000 );
	    selected.setHours( dt.getHours(), dt.getMinutes() );
	    refresh();
	  }
	
	  $scope.incrementHours = function() {
	    addMinutes( hourStep * 60 );
	  };
	  $scope.decrementHours = function() {
	    addMinutes( - hourStep * 60 );
	  };
	  $scope.incrementMinutes = function() {
	    addMinutes( minuteStep );
	  };
	  $scope.decrementMinutes = function() {
	    addMinutes( - minuteStep );
	  };
	  $scope.toggleMeridian = function() {
	    addMinutes( 12 * 60 * (( selected.getHours() < 12 ) ? 1 : -1) );
	  };
	}])
	
	.directive('timepicker', function () {
	  return {
	    restrict: 'EA',
	    require: ['timepicker', '?^ngModel'],
	    controller:'TimepickerController',
	    replace: true,
	    scope: {},
	    templateUrl: 'template/timepicker/timepicker.html',
	    link: function(scope, element, attrs, ctrls) {
	      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if ( ngModelCtrl ) {
	        timepickerCtrl.init( ngModelCtrl, element.find('input') );
	      }
	    }
	  };
	});
	
	angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.position', 'ui.bootstrap.bindHtml'])
	
	/**
	 * A helper service that can parse typeahead's syntax (string provided by users)
	 * Extracted to a separate service for ease of unit testing
	 */
	  .factory('typeaheadParser', ['$parse', function ($parse) {
	
	  //                      00000111000000000000022200000000000000003333333333333330000000000044000
	  var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
	
	  return {
	    parse:function (input) {
	
	      var match = input.match(TYPEAHEAD_REGEXP);
	      if (!match) {
	        throw new Error(
	          'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
	            ' but got "' + input + '".');
	      }
	
	      return {
	        itemName:match[3],
	        source:$parse(match[4]),
	        viewMapper:$parse(match[2] || match[1]),
	        modelMapper:$parse(match[1])
	      };
	    }
	  };
	}])
	
	  .directive('typeahead', ['$compile', '$parse', '$q', '$timeout', '$document', '$position', 'typeaheadParser',
	    function ($compile, $parse, $q, $timeout, $document, $position, typeaheadParser) {
	
	  var HOT_KEYS = [9, 13, 27, 38, 40];
	
	  return {
	    require:'ngModel',
	    link:function (originalScope, element, attrs, modelCtrl) {
	
	      //SUPPORTED ATTRIBUTES (OPTIONS)
	
	      //minimal no of characters that needs to be entered before typeahead kicks-in
	      var minSearch = originalScope.$eval(attrs.typeaheadMinLength) || 1;
	
	      //minimal wait time after last character typed before typehead kicks-in
	      var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
	
	      //should it restrict model values to the ones selected from the popup only?
	      var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
	
	      //binding to a variable that indicates if matches are being retrieved asynchronously
	      var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
	
	      //a callback executed when a match is selected
	      var onSelectCallback = $parse(attrs.typeaheadOnSelect);
	
	      var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
	
	      var appendToBody =  attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
	
	      var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
	
	      //INTERNAL VARIABLES
	
	      //model setter executed upon match selection
	      var $setModelValue = $parse(attrs.ngModel).assign;
	
	      //expressions used by typeahead
	      var parserResult = typeaheadParser.parse(attrs.typeahead);
	
	      var hasFocus;
	
	      //create a child scope for the typeahead directive so we are not polluting original scope
	      //with typeahead-specific data (matches, query etc.)
	      var scope = originalScope.$new();
	      originalScope.$on('$destroy', function(){
	        scope.$destroy();
	      });
	
	      // WAI-ARIA
	      var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	      element.attr({
	        'aria-autocomplete': 'list',
	        'aria-expanded': false,
	        'aria-owns': popupId
	      });
	
	      //pop-up element used to display matches
	      var popUpEl = angular.element('<div typeahead-popup></div>');
	      popUpEl.attr({
	        id: popupId,
	        matches: 'matches',
	        active: 'activeIdx',
	        select: 'select(activeIdx)',
	        query: 'query',
	        position: 'position'
	      });
	      //custom item template
	      if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
	        popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
	      }
	
	      var resetMatches = function() {
	        scope.matches = [];
	        scope.activeIdx = -1;
	        element.attr('aria-expanded', false);
	      };
	
	      var getMatchId = function(index) {
	        return popupId + '-option-' + index;
	      };
	
	      // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	      // This attribute is added or removed automatically when the `activeIdx` changes.
	      scope.$watch('activeIdx', function(index) {
	        if (index < 0) {
	          element.removeAttr('aria-activedescendant');
	        } else {
	          element.attr('aria-activedescendant', getMatchId(index));
	        }
	      });
	
	      var getMatchesAsync = function(inputValue) {
	
	        var locals = {$viewValue: inputValue};
	        isLoadingSetter(originalScope, true);
	        $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
	
	          //it might happen that several async queries were in progress if a user were typing fast
	          //but we are interested only in responses that correspond to the current view value
	          var onCurrentRequest = (inputValue === modelCtrl.$viewValue);
	          if (onCurrentRequest && hasFocus) {
	            if (matches.length > 0) {
	
	              scope.activeIdx = focusFirst ? 0 : -1;
	              scope.matches.length = 0;
	
	              //transform labels
	              for(var i=0; i<matches.length; i++) {
	                locals[parserResult.itemName] = matches[i];
	                scope.matches.push({
	                  id: getMatchId(i),
	                  label: parserResult.viewMapper(scope, locals),
	                  model: matches[i]
	                });
	              }
	
	              scope.query = inputValue;
	              //position pop-up with matches - we need to re-calculate its position each time we are opening a window
	              //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	              //due to other elements being rendered
	              scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	              scope.position.top = scope.position.top + element.prop('offsetHeight');
	
	              element.attr('aria-expanded', true);
	            } else {
	              resetMatches();
	            }
	          }
	          if (onCurrentRequest) {
	            isLoadingSetter(originalScope, false);
	          }
	        }, function(){
	          resetMatches();
	          isLoadingSetter(originalScope, false);
	        });
	      };
	
	      resetMatches();
	
	      //we need to propagate user's query so we can higlight matches
	      scope.query = undefined;
	
	      //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later 
	      var timeoutPromise;
	
	      var scheduleSearchWithTimeout = function(inputValue) {
	        timeoutPromise = $timeout(function () {
	          getMatchesAsync(inputValue);
	        }, waitTime);
	      };
	
	      var cancelPreviousTimeout = function() {
	        if (timeoutPromise) {
	          $timeout.cancel(timeoutPromise);
	        }
	      };
	
	      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	      modelCtrl.$parsers.unshift(function (inputValue) {
	
	        hasFocus = true;
	
	        if (inputValue && inputValue.length >= minSearch) {
	          if (waitTime > 0) {
	            cancelPreviousTimeout();
	            scheduleSearchWithTimeout(inputValue);
	          } else {
	            getMatchesAsync(inputValue);
	          }
	        } else {
	          isLoadingSetter(originalScope, false);
	          cancelPreviousTimeout();
	          resetMatches();
	        }
	
	        if (isEditable) {
	          return inputValue;
	        } else {
	          if (!inputValue) {
	            // Reset in case user had typed something previously.
	            modelCtrl.$setValidity('editable', true);
	            return inputValue;
	          } else {
	            modelCtrl.$setValidity('editable', false);
	            return undefined;
	          }
	        }
	      });
	
	      modelCtrl.$formatters.push(function (modelValue) {
	
	        var candidateViewValue, emptyViewValue;
	        var locals = {};
	
	        if (inputFormatter) {
	
	          locals.$model = modelValue;
	          return inputFormatter(originalScope, locals);
	
	        } else {
	
	          //it might happen that we don't have enough info to properly render input value
	          //we need to check for this situation and simply return model value if we can't apply custom formatting
	          locals[parserResult.itemName] = modelValue;
	          candidateViewValue = parserResult.viewMapper(originalScope, locals);
	          locals[parserResult.itemName] = undefined;
	          emptyViewValue = parserResult.viewMapper(originalScope, locals);
	
	          return candidateViewValue!== emptyViewValue ? candidateViewValue : modelValue;
	        }
	      });
	
	      scope.select = function (activeIdx) {
	        //called from within the $digest() cycle
	        var locals = {};
	        var model, item;
	
	        locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
	        model = parserResult.modelMapper(originalScope, locals);
	        $setModelValue(originalScope, model);
	        modelCtrl.$setValidity('editable', true);
	
	        onSelectCallback(originalScope, {
	          $item: item,
	          $model: model,
	          $label: parserResult.viewMapper(originalScope, locals)
	        });
	
	        resetMatches();
	
	        //return focus to the input element if a match was selected via a mouse click event
	        // use timeout to avoid $rootScope:inprog error
	        $timeout(function() { element[0].focus(); }, 0, false);
	      };
	
	      //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	      element.bind('keydown', function (evt) {
	
	        //typeahead is open and an "interesting" key was pressed
	        if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
	          return;
	        }
	
	        // if there's nothing selected (i.e. focusFirst) and enter is hit, don't do anything
	        if (scope.activeIdx == -1 && (evt.which === 13 || evt.which === 9)) {
	          return;
	        }
	
	        evt.preventDefault();
	
	        if (evt.which === 40) {
	          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
	          scope.$digest();
	
	        } else if (evt.which === 38) {
	          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
	          scope.$digest();
	
	        } else if (evt.which === 13 || evt.which === 9) {
	          scope.$apply(function () {
	            scope.select(scope.activeIdx);
	          });
	
	        } else if (evt.which === 27) {
	          evt.stopPropagation();
	
	          resetMatches();
	          scope.$digest();
	        }
	      });
	
	      element.bind('blur', function (evt) {
	        hasFocus = false;
	      });
	
	      // Keep reference to click handler to unbind it.
	      var dismissClickHandler = function (evt) {
	        if (element[0] !== evt.target) {
	          resetMatches();
	          scope.$digest();
	        }
	      };
	
	      $document.bind('click', dismissClickHandler);
	
	      originalScope.$on('$destroy', function(){
	        $document.unbind('click', dismissClickHandler);
	        if (appendToBody) {
	          $popup.remove();
	        }
	      });
	
	      var $popup = $compile(popUpEl)(scope);
	      if (appendToBody) {
	        $document.find('body').append($popup);
	      } else {
	        element.after($popup);
	      }
	    }
	  };
	
	}])
	
	  .directive('typeaheadPopup', function () {
	    return {
	      restrict:'EA',
	      scope:{
	        matches:'=',
	        query:'=',
	        active:'=',
	        position:'=',
	        select:'&'
	      },
	      replace:true,
	      templateUrl:'template/typeahead/typeahead-popup.html',
	      link:function (scope, element, attrs) {
	
	        scope.templateUrl = attrs.templateUrl;
	
	        scope.isOpen = function () {
	          return scope.matches.length > 0;
	        };
	
	        scope.isActive = function (matchIdx) {
	          return scope.active == matchIdx;
	        };
	
	        scope.selectActive = function (matchIdx) {
	          scope.active = matchIdx;
	        };
	
	        scope.selectMatch = function (activeIdx) {
	          scope.select({activeIdx:activeIdx});
	        };
	      }
	    };
	  })
	
	  .directive('typeaheadMatch', ['$http', '$templateCache', '$compile', '$parse', function ($http, $templateCache, $compile, $parse) {
	    return {
	      restrict:'EA',
	      scope:{
	        index:'=',
	        match:'=',
	        query:'='
	      },
	      link:function (scope, element, attrs) {
	        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'template/typeahead/typeahead-match.html';
	        $http.get(tplUrl, {cache: $templateCache}).success(function(tplContent){
	           element.replaceWith($compile(tplContent.trim())(scope));
	        });
	      }
	    };
	  }])
	
	  .filter('typeaheadHighlight', function() {
	
	    function escapeRegexp(queryToEscape) {
	      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    return function(matchItem, query) {
	      return query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem;
	    };
	  });
	
	angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/accordion/accordion-group.html",
	    "<div class=\"panel panel-default\">\n" +
	    "  <div class=\"panel-heading\">\n" +
	    "    <h4 class=\"panel-title\">\n" +
	    "      <a href class=\"accordion-toggle\" ng-click=\"toggleOpen()\" accordion-transclude=\"heading\"><span ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
	    "    </h4>\n" +
	    "  </div>\n" +
	    "  <div class=\"panel-collapse\" collapse=\"!isOpen\">\n" +
	    "	  <div class=\"panel-body\" ng-transclude></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/accordion/accordion.html",
	    "<div class=\"panel-group\" ng-transclude></div>");
	}]);
	
	angular.module("template/alert/alert.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/alert/alert.html",
	    "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissable' : null]\" role=\"alert\">\n" +
	    "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close()\">\n" +
	    "        <span aria-hidden=\"true\">&times;</span>\n" +
	    "        <span class=\"sr-only\">Close</span>\n" +
	    "    </button>\n" +
	    "    <div ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/carousel/carousel.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/carousel/carousel.html",
	    "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" +
	    "    <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
	    "        <li ng-repeat=\"slide in slides track by $index\" ng-class=\"{active: isActive(slide)}\" ng-click=\"select(slide)\"></li>\n" +
	    "    </ol>\n" +
	    "    <div class=\"carousel-inner\" ng-transclude></div>\n" +
	    "    <a class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-left\"></span></a>\n" +
	    "    <a class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-right\"></span></a>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/carousel/slide.html",
	    "<div ng-class=\"{\n" +
	    "    'active': leaving || (active && !entering),\n" +
	    "    'prev': (next || active) && direction=='prev',\n" +
	    "    'next': (next || active) && direction=='next',\n" +
	    "    'right': direction=='prev',\n" +
	    "    'left': direction=='next'\n" +
	    "  }\" class=\"item text-center\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/datepicker.html",
	    "<div ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
	    "  <daypicker ng-switch-when=\"day\" tabindex=\"0\"></daypicker>\n" +
	    "  <monthpicker ng-switch-when=\"month\" tabindex=\"0\"></monthpicker>\n" +
	    "  <yearpicker ng-switch-when=\"year\" tabindex=\"0\"></yearpicker>\n" +
	    "</div>");
	}]);
	
	angular.module("template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/day.html",
	    "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th colspan=\"{{5 + showWeeks}}\"><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <th ng-show=\"showWeeks\" class=\"text-center\"></th>\n" +
	    "      <th ng-repeat=\"label in labels track by $index\" class=\"text-center\"><small aria-label=\"{{label.full}}\">{{label.abbr}}</small></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-show=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" +
	    "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-muted': dt.secondary, 'text-info': dt.current}\">{{dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/month.html",
	    "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" +
	    "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-info': dt.current}\">{{dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/popup.html",
	    "<ul class=\"dropdown-menu\" ng-style=\"{display: (isOpen && 'block') || 'none', top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\">\n" +
	    "	<li ng-transclude></li>\n" +
	    "	<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
	    "		<span class=\"btn-group pull-left\">\n" +
	    "			<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\">{{ getText('current') }}</button>\n" +
	    "			<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" +
	    "		</span>\n" +
	    "		<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" +
	    "	</li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/year.html",
	    "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th colspan=\"3\"><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" +
	    "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-info': dt.current}\">{{dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/modal/backdrop.html",
	    "<div class=\"modal-backdrop fade {{ backdropClass }}\"\n" +
	    "     ng-class=\"{in: animate}\"\n" +
	    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
	    "></div>\n" +
	    "");
	}]);
	
	angular.module("template/modal/window.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/modal/window.html",
	    "<div tabindex=\"-1\" role=\"dialog\" class=\"modal fade\" ng-class=\"{in: animate}\" ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" ng-click=\"close($event)\">\n" +
	    "    <div class=\"modal-dialog\" ng-class=\"{'modal-sm': size == 'sm', 'modal-lg': size == 'lg'}\"><div class=\"modal-content\" modal-transclude></div></div>\n" +
	    "</div>");
	}]);
	
	angular.module("template/pagination/pager.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/pagination/pager.html",
	    "<ul class=\"pager\">\n" +
	    "  <li ng-class=\"{disabled: noPrevious(), previous: align}\"><a href ng-click=\"selectPage(page - 1)\">{{getText('previous')}}</a></li>\n" +
	    "  <li ng-class=\"{disabled: noNext(), next: align}\"><a href ng-click=\"selectPage(page + 1)\">{{getText('next')}}</a></li>\n" +
	    "</ul>");
	}]);
	
	angular.module("template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/pagination/pagination.html",
	    "<ul class=\"pagination\">\n" +
	    "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(1)\">{{getText('first')}}</a></li>\n" +
	    "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(page - 1)\">{{getText('previous')}}</a></li>\n" +
	    "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active}\"><a href ng-click=\"selectPage(page.number)\">{{page.text}}</a></li>\n" +
	    "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(page + 1)\">{{getText('next')}}</a></li>\n" +
	    "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(totalPages)\">{{getText('last')}}</a></li>\n" +
	    "</ul>");
	}]);
	
	angular.module("template/tooltip/tooltip-html-unsafe-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-html-unsafe-popup.html",
	    "<div class=\"tooltip {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\" bind-html-unsafe=\"content\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-popup.html",
	    "<div class=\"tooltip {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/popover/popover.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/popover/popover.html",
	    "<div class=\"popover {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-show=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/progressbar/bar.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/bar.html",
	    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: percent + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" ng-transclude></div>");
	}]);
	
	angular.module("template/progressbar/progress.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/progress.html",
	    "<div class=\"progress\" ng-transclude></div>");
	}]);
	
	angular.module("template/progressbar/progressbar.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/progressbar.html",
	    "<div class=\"progress\">\n" +
	    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: percent + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" ng-transclude></div>\n" +
	    "</div>");
	}]);
	
	angular.module("template/rating/rating.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/rating/rating.html",
	    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">\n" +
	    "    <i ng-repeat=\"r in range track by $index\" ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\">\n" +
	    "        <span class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
	    "    </i>\n" +
	    "</span>");
	}]);
	
	angular.module("template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tabs/tab.html",
	    "<li ng-class=\"{active: active, disabled: disabled}\">\n" +
	    "  <a href ng-click=\"select()\" tab-heading-transclude>{{heading}}</a>\n" +
	    "</li>\n" +
	    "");
	}]);
	
	angular.module("template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tabs/tabset.html",
	    "<div>\n" +
	    "  <ul class=\"nav nav-{{type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
	    "  <div class=\"tab-content\">\n" +
	    "    <div class=\"tab-pane\" \n" +
	    "         ng-repeat=\"tab in tabs\" \n" +
	    "         ng-class=\"{active: tab.active}\"\n" +
	    "         tab-content-transclude=\"tab\">\n" +
	    "    </div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/timepicker/timepicker.html",
	    "<table>\n" +
	    "	<tbody>\n" +
	    "		<tr class=\"text-center\">\n" +
	    "			<td><a ng-click=\"incrementHours()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "			<td>&nbsp;</td>\n" +
	    "			<td><a ng-click=\"incrementMinutes()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "			<td ng-show=\"showMeridian\"></td>\n" +
	    "		</tr>\n" +
	    "		<tr>\n" +
	    "			<td style=\"width:50px;\" class=\"form-group\" ng-class=\"{'has-error': invalidHours}\">\n" +
	    "				<input type=\"text\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-mousewheel=\"incrementHours()\" ng-readonly=\"readonlyInput\" maxlength=\"2\">\n" +
	    "			</td>\n" +
	    "			<td>:</td>\n" +
	    "			<td style=\"width:50px;\" class=\"form-group\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
	    "				<input type=\"text\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\">\n" +
	    "			</td>\n" +
	    "			<td ng-show=\"showMeridian\"><button type=\"button\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\">{{meridian}}</button></td>\n" +
	    "		</tr>\n" +
	    "		<tr class=\"text-center\">\n" +
	    "			<td><a ng-click=\"decrementHours()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "			<td>&nbsp;</td>\n" +
	    "			<td><a ng-click=\"decrementMinutes()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "			<td ng-show=\"showMeridian\"></td>\n" +
	    "		</tr>\n" +
	    "	</tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/typeahead/typeahead-match.html",
	    "<a tabindex=\"-1\" bind-html-unsafe=\"match.label | typeaheadHighlight:query\"></a>");
	}]);
	
	angular.module("template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/typeahead/typeahead-popup.html",
	    "<ul class=\"dropdown-menu\" ng-show=\"isOpen()\" ng-style=\"{top: position.top+'px', left: position.left+'px'}\" style=\"display: block;\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
	    "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{match.id}}\">\n" +
	    "        <div typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
	    "    </li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var HdcpService, hdcpToLabel;
	
	__webpack_require__(28);
	
	HdcpService = __webpack_require__(118);
	
	hdcpToLabel = __webpack_require__(119);
	
	angular.module('gnp-hdcp', []).factory('HdcpService', HdcpService).filter('hdcpToLabel', hdcpToLabel);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var HdcpService, _, floats, integers, j, results;
	
	_ = __webpack_require__(87);
	
	integers = [].concat(_.map([6, 5, 4, 3, 2, 1], function(i) {
	  return {
	    text: "+" + i,
	    value: -i
	  };
	}), [
	  {
	    text: "0",
	    value: 0
	  }
	], [
	  {
	    text: "-",
	    value: null
	  }
	], _.map((function() {
	  results = [];
	  for (j = 1; j <= 40; j++){ results.push(j); }
	  return results;
	}).apply(this), function(i) {
	  return {
	    text: "" + i,
	    value: i
	  };
	}));
	
	floats = [].concat([
	  {
	    text: "-",
	    value: null
	  }
	], _.map([0, 1, 2, 3, 4, 5, 6, 7, 8, 9], function(i) {
	  return {
	    text: i,
	    value: "." + i
	  };
	}));
	
	HdcpService = function() {
	  return {
	    getAvailableHdcpList: function() {
	      return {
	        integers: integers,
	        floats: floats
	      };
	    },
	    getHdcpObject: function(value) {
	      var _float, _val, hdcp;
	      hdcp = {};
	      _val = value || null;
	      if (value === 0) {
	        _val = 0;
	      }
	      if (_val === null) {
	        hdcp.integer = hdcp.float = null;
	      } else {
	        hdcp.integer = value >= 0 ? Math.floor(value) : Math.ceil(value);
	        _float = value.toString().split('.')[1];
	        hdcp.float = '.' + (_float ? _float : 0);
	      }
	      return hdcp;
	    },
	    getHdcpValue: function(_int, _float) {
	      var float_item, int_item;
	      int_item = _.find(integers, function(i) {
	        return i.value === _int;
	      });
	      float_item = _.find(floats, function(f) {
	        return f.value === _float;
	      });
	      if (int_item === void 0 || float_item === void 0 || int_item.value === null || float_item.value === null) {
	        return null;
	      } else {
	        return int_item.value + float_item.value;
	      }
	    }
	  };
	};
	
	module.exports = HdcpService;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var _, hdcpToLabel;
	
	_ = __webpack_require__(87);
	
	hdcpToLabel = function(HdcpService) {
	  return function(input) {
	    var hdcpObj;
	    hdcpObj = HdcpService.getHdcpObject(input);
	    if (hdcpObj.integer === null || hdcpObj.float === null) {
	      return '_';
	    } else {
	      return (input < 0 ? '+' : '') + Math.abs(hdcpObj.integer) + hdcpObj.float;
	    }
	  };
	};
	
	hdcpToLabel.$inject = ['HdcpService'];
	
	module.exports = hdcpToLabel;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, $) {/*!
	 * angular-confirm v1.1.0 (http://craftpip.github.io/angular-confirm/)
	 * Author: Boniface Pereira
	 * Website: www.craftpip.com
	 * Contact: hey@craftpip.com
	 *
	 * Copyright 2016-2017 angular-confirm
	 * Licensed under MIT (https://github.com/craftpip/angular-confirm/blob/master/LICENSE)
	 */"use strict";if("undefined"==typeof jQuery)throw new Error("angular-confirm requires jQuery");if("undefined"==typeof angular)throw new Error("angular-confirm requires Angular");angular.module("cp.ngConfirm",[]).service("$ngConfirmTemplate",function(){this.default='<div class="ng-confirm"><div class="ng-confirm-bg ng-confirm-bg-h"></div><div class="ng-confirm-scrollpane"><div class="ng-bs3-container"><div class="ng-bs3-row"><div class="ng-confirm-box-p"><div class="ng-confirm-box" role="dialog" aria-labelledby="labelled" tabindex="-1"><div class="ng-confirm-closeIcon"></div><div class="ng-confirm-title-c"><span class="ng-confirm-icon-c"><i></i></span><span class="ng-confirm-title"></span></div><div class="ng-confirm-content-pane"><div class="ng-confirm-content"></div></div><div class="ng-confirm-buttons"></div><div class="ng-confirm-clear"></div></div></div></div></div></div></div>'}).service("$ngConfirmDefaults",function(){return{title:"Hello",titleClass:"",type:"default",typeAnimated:!0,content:"Are you sure to continue?",contentUrl:!1,defaultButtons:{ok:function(){}},icon:"",theme:"white",bgOpacity:null,animation:"zoom",closeAnimation:"scale",animationSpeed:400,animationBounce:1.2,scope:!1,escapeKey:!1,rtl:!1,buttons:{},container:"body",containerFluid:!1,backgroundDismiss:!1,backgroundDismissAnimation:"shake",alignMiddle:!0,offsetTop:50,offsetBottom:50,autoClose:!1,closeIcon:null,closeIconClass:!1,columnClass:"small",boxWidth:"50%",useBootstrap:!0,bootstrapClasses:{container:"container",containerFluid:"container-fluid",row:"row"},onScopeReady:function(){},onReady:function(){},onOpenBefore:function(){},onOpen:function(){},onClose:function(){},onDestroy:function(){},onAction:function(){}}}).service("$ngConfirm",["$rootScope","$ngConfirmDefaults","$ngConfirmBase",function(a,b,c){return function(a,d,e){return"string"==typeof a&&(a={content:a,buttons:b.defaultButtons},"string"==typeof d?a.title=d||!1:a.title=!1,"object"==typeof d&&(a.scope=d),"object"==typeof e&&(a.scope=e)),"undefined"==typeof a&&(a={}),a=angular.extend({},b,a),new c(a)}}]).factory("$ngConfirmBase",["$rootScope","$ngConfirmDefaults","$timeout","$compile","$ngConfirmTemplate","$interval","$templateRequest","$log","$q",function(a,b,c,d,e,f,g,h,i){var j=function(a){angular.extend(this,a),this._init()};return j.prototype={_init:function(){this._lastFocused=angular.element("body").find(":focus"),this._id=Math.round(999999*Math.random()),this.open()},_providedScope:!1,_prepare:function(){var b=this;this.$el=angular.element(e.default),b.scope?this._providedScope=!0:(this._providedScope=!1,b.scope=a.$new()),"function"==typeof this.onScopeReady&&this.onScopeReady.apply(this,[this.scope]),this.$confirmBox=this.$el.find(".ng-confirm-box"),this.$confirmBoxParent=this.$el.find(".ng-confirm-box-p"),this.$titleContainer=this.$el.find(".ng-confirm-title-c"),this.$title=this.$el.find(".ng-confirm-title"),this.$icon=this.$el.find(".ng-confirm-icon-c"),this.$content=this.$el.find(".ng-confirm-content"),this.$confirmBg=this.$el.find(".ng-confirm-bg"),this.$contentPane=this.$el.find(".ng-confirm-content-pane"),this.$closeIcon=this.$el.find(".ng-confirm-closeIcon"),this.$bs3Container=this.$el.find(".ng-bs3-container"),this.$buttonContainer=this.$el.find(".ng-confirm-buttons"),this.$scrollPane=this.$el.find(".ng-confirm-scrollpane");var c="ng-confirm-box"+this._id;if(this.$confirmBox.attr("aria-labelledby",c),this.$content.attr("id",c),this._setAnimationClass(this.animation),this.setDismissAnimation(this.backgroundDismissAnimation),this.setTheme(this.theme),this.setType(this.type),this._setButtons(this.buttons),this.setCloseIcon(this.closeIcon),this.setCloseIconClass(this.closeIconClass),this.setTypeAnimated(this.typeAnimated),this.useBootstrap?(this.setColumnClass(this.columnClass),this.$el.find(".ng-bs3-row").addClass(this.bootstrapClasses.row).addClass("justify-content-md-center justify-content-sm-center justify-content-xs-center justify-content-lg-center"),this.setContainerFluid(this.containerFluid)):this.setBoxWidth(this.boxWidth),this.setTitleClass(this.titleClass),this.setTitle(this.title),this.setIcon(this.icon),this.setBgOpacity(this.bgOpacity),this.setRtl(this.rtl),this._contentReady=i.defer(),this._modalReady=i.defer(),i.all([this._contentReady.promise,this._modalReady.promise]).then(function(){b.isAjax&&(b.setContent(b.content),b.loading(!1)),"function"==typeof b.onReady&&b.onReady.apply(b,[b.scope])}),this.contentUrl){this.loading(!0),this.isAjax=!0;var d=this.contentUrl;"function"==typeof this.contentUrl&&(d=this.contentUrl()),this.isAjaxLoading=!0,g(d).then(function(a){b.content=a,b._contentReady.resolve(),b.isAjaxLoading=!1},function(){b.content="",b._contentReady.resolve(),b.isAjaxLoading=!1})}else{var f=this.content;"function"==typeof this.content&&(f=this.content()),this.content=f,this.setContent(this.content),this._contentReady.resolve()}"none"==this.animation&&(this.animationSpeed=1,this.animationBounce=1),this.$confirmBg.css(this._getCSS(this.animationSpeed,1))},isAjax:!1,isAjaxLoading:!1,isLoading:!1,_hideClass:"ng-confirm-el-hide",_loadingClass:"ng-confirm-loading",loading:function(a){this.isLoading=a,a?this.$confirmBox.addClass(this._loadingClass):this.$confirmBox.removeClass(this._loadingClass)},setContent:function(a){if(!this.$content)return void h.error("Attempted to set content before $content is defined");a="<div>"+a+"</div>";var b=d(a)(this.scope);this.$content.append(b)},_typeList:["default","blue","green","red","orange","purple","dark"],_typePrefix:"ng-confirm-type-",_pSetType:"",setType:function(a){if(this._typeList.indexOf(a.toLowerCase())==-1)return h.warn("Invalid dialog type: "+a),!1;var b=this._typePrefix+a;this.$el.removeClass(this._pSetType).addClass(b),this._pSetType=b},_setTypeAnimatedClass:"ng-confirm-type-animated",setTypeAnimated:function(a){a?this.$confirmBox.addClass(this._setTypeAnimatedClass):this.$confirmBox.removeClass(this._setTypeAnimatedClass)},_pTitleClass:"",setTitleClass:function(a){this.$titleContainer.removeClass(this._pTitleClass).addClass(a),this._pTitleClass=a},setBoxWidth:function(a){return this.useBootstrap?void h.warn("Cannot set boxWidth as useBootstrap is set to true. use columnClass instead."):void this.$confirmBox.css("width",a)},setContainerFluid:function(a){return this.useBootstrap?(a?this.$bs3Container.removeClass(this.bootstrapClasses.container).addClass(this.bootstrapClasses.containerFluid):this.$bs3Container.removeClass(this.bootstrapClasses.containerFluid).addClass(this.bootstrapClasses.container),void(this.containerFluid=a)):void h.warn("Cannot set containerFluid as useBootstrap is set to false.")},_pSetColumnClass:"",setColumnClass:function(a){if(!this.useBootstrap)return void h.warn("Cannot set columnClass as useBootstrap is set to false, use bixWidth instead");a=a.toLowerCase();var b;switch(a){case"xl":case"xlarge":b="col-md-12";break;case"l":case"large":b="col-md-8 col-md-offset-2";break;case"m":case"medium":b="col-md-6 col-md-offset-3";break;case"s":case"small":b="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1";break;case"xs":case"xsmall":b="col-md-2 col-md-offset-5";break;default:b=a}this.$confirmBoxParent.removeClass(this._pSetColumnClass).addClass(b),this._pSetColumnClass=b},setIcon:function(a){"function"==typeof a&&(a=a()),a?(this.$icon.html(angular.element("<i></i>").addClass(a)),this.$icon.removeClass(this._hideClass)):this.$icon.addClass(this._hideClass),this.icon||this.title?this.$titleContainer.removeClass(this._hideClass):this.$titleContainer.addClass(this._hideClass),this.icon=a},setTitle:function(a){"function"==typeof a&&(a=a()),a?(this.$title.html(a),this.$title.removeClass(this._hideClass)):this.$title.addClass(this._hideClass),this.icon||this.title?this.$titleContainer.removeClass(this._hideClass):this.$titleContainer.addClass(this._hideClass),this.title=a},setCloseIcon:function(a){0==this._buttonCount&&null==a&&(a=!0),a?this.$closeIcon.removeClass(this._hideClass):this.$closeIcon.addClass(this._hideClass),this.closeIcon=a},setCloseIconClass:function(a){var b;b=a?angular.element("<i></i>").addClass(this.closeIconClass):angular.element("<span>&times;</span>").addClass(this.closeIconClass),this.$closeIcon.html(b),this.closeIconClass=a},_animationPrefix:"ng-confirm-animation-",_pSetAnimation:"",_setAnimationClass:function(a){var b=this._prefixThis(a,this._animationPrefix);this.$confirmBox.removeClass(this._pSetAnimation).addClass(b),this._pSetAnimation=b},_removeAnimationClass:function(){this.$confirmBox.removeClass(this._pSetAnimation),this._pSetAnimation=""},_bgDismissPrefix:"ng-confirm-hilight-",_pSetDismissAnimation:"",setDismissAnimation:function(a){var b=this._prefixThis(a,this._bgDismissPrefix);this.$confirmBox.removeClass(this._pSetDismissAnimation).addClass(b),this._pSetDismissAnimation=b},_prefixThis:function(a,b){return a=a.split(","),angular.forEach(a,function(c,d){c.indexOf(b)==-1&&(a[d]=b+c.trim())}),a.join(" ").toLowerCase()},_setButtons:function(a){var b=this;"object"!=typeof a&&(a={}),angular.forEach(a,function(c,d){"function"==typeof c&&(a[d]=c={action:c}),a[d].text=c.text||d,a[d].btnClass=c.btnClass||"btn-default",a[d].action=c.action||angular.noop,a[d].keys=c.keys||[],a[d].disabled=c.disabled||!1,"undefined"==typeof c.show&&(c.show=!0),a[d].show=c.show,angular.forEach(a[d].keys,function(b,c){a[d].keys[c]=b.toLowerCase()});var e=angular.element('<button type="button" class="btn"><span class="ng-confirm-btn-text"></span></button>');a[d].setText=function(a){e.find(".ng-confirm-btn-text").html(a)},a[d].setBtnClass=function(b){e.removeClass(a[d].btnClass).addClass(b),a[d].btnClass=b},a[d].setDisabled=function(b){b?e.attr("disabled","disabled"):e.removeAttr("disabled"),a[d].disabled=b},a[d].setShow=function(c){c?e.removeClass(b._hideClass):e.addClass(b._hideClass),a[d].show=c},a[d].setText(a[d].text),a[d].setBtnClass(a[d].btnClass),a[d].setDisabled(a[d].disabled),a[d].setShow(a[d].show),e.click(function(a){a.preventDefault(),b.triggerButton(d)}),a[d].el=e,b.$buttonContainer.append(e)}),this.buttons=a,this._buttonCount=Object.keys(a).length},_buttonCount:0,_themePrefix:"ng-confirm-",_pSetTheme:"",setTheme:function(a){var b=this._prefixThis(a,this._themePrefix);this.$el.removeClass(this._pSetTheme).addClass(b),this._pSetTheme=b},_rtlClass:"ng-confirm-rtl",setRtl:function(a){a?this.$el.addClass(this._rtlClass):this.$el.removeClass(this._rtlClass),this.rtl=a},setBgOpacity:function(a){this.$confirmBg.css("opacity",a),this.bgOpacity=a},_cubic_bezier:"0.36, 0.55, 0.19",_getCSS:function(a,b){return{"-webkit-transition-duration":a/1e3+"s","transition-duration":a/1e3+"s","-webkit-transition-timing-function":"cubic-bezier("+this._cubic_bezier+", "+b+")","transition-timing-function":"cubic-bezier("+this._cubic_bezier+", "+b+")"}},_hash:function(a){var b=a.toString(),c=0;if(0==b.length)return c;for(var d=0;d<b.length;d++){var e=b.toString().charCodeAt(d);c=(c<<5)-c+e,c&=c}return c},_digestWatchUnRegister:!1,_bindEvents:function(){var a=this;this._digestWatchUnRegister=this.scope.$watch(function(){a.setDialogCenter("Digest watcher")}),this.$closeIcon.on("click."+a._id,function(){a._closeClick()}),angular.element(window).on("resize."+a._id,function(){a.setDialogCenter("Window Resize")}),angular.element(window).on("keyup."+a._id,function(b){a._reactOnKey(b)}),this.$scrollPane.on("click",function(){a._scrollPaneClick()}),this.$confirmBox.on("click",function(){a.boxClicked=!0})},_unBindEvents:function(){angular.element(window).off("resize."+this._id),angular.element(window).off("keyup."+this._id),this.$closeIcon.off("click."+this._id),this._digestWatchUnRegister&&this._digestWatchUnRegister()},_reactOnKey:function(a){var b=this,c=angular.element(".ng-confirm");if(c.eq(c.length-1)[0]!==this.$el[0])return!1;var d=a.which;if(!$(this.$el).find(":input").is(":focus")||!/13|32/.test(d)){var e=this._getKey(d);if("esc"===e&&this.escapeKey)if(1==this.escapeKey)this._scrollPaneClick();else if("string"==typeof this.escapeKey||"function"==typeof this.escapeKey){var f=!1;f="function"==typeof this.escapeKey?this.escapeKey():this.escapeKey,f&&(angular.isDefined(this.buttons[f])?this._buttonClick(f):h.warn("Invalid escapeKey, no buttons found with name "+f))}angular.forEach(this.buttons,function(a,c){a.keys.indexOf(e)!=-1&&b._buttonClick(c)})}},_scrollPaneClick:function(){if(this.boxClicked)return this.boxClicked=!1,!1;var c,a=!1,b=!1;if(c="function"==typeof this.backgroundDismiss?this.backgroundDismiss():this.backgroundDismiss,"string"==typeof c&&angular.isDefined(this.buttons[c])?(a=c,b=!1):b="undefined"==typeof c||1==!!c,a){var d=this.buttons[a].action.apply(this,[this.scope,this.buttons[a]]);b="undefined"==typeof d||!!d}b?this.close():this.hiLightModal()},_closeClick:function(){var c,a=!1,b=!1;if(c="function"==typeof this.closeIcon?this.closeIcon():this.closeIcon,"string"==typeof c&&angular.isDefined(this.buttons[c])?(a=c,b=!1):b="undefined"==typeof c||1==!!c,a){var d=this.buttons[a].action.apply(this,[this.scope,this.buttons[a]]);b="undefined"==typeof d||1==!!d}b&&this.close()},_hilightAnimating:!1,_hilightClass:"ng-confirm-hilight",hiLightModal:function(){var a=this;this._hilightAnimating||(this._hilightAnimating=!0,this.$confirmBox.addClass(this._hilightClass),setTimeout(function(){a._hilightAnimating=!1,a.$confirmBox.removeClass(a._hilightClass)},this.animationSpeed))},_buttonClick:function(a){var b=this.buttons[a].action.apply(this,[this.scope,this.buttons[a]]);return"function"==typeof this.onAction&&this.onAction.apply(this,[this.scope,a]),"undefined"==typeof b||b?this.close():this.scope.$apply(),b},triggerButton:function(a){return this._buttonClick(a)},setDialogCenter:function(a){a=a||"n/a";var b=this.$content,c=b.outerHeight(),d=this.$contentPane.outerHeight(),e=b.children();if(0!=e.length){var f=parseInt(e.eq(0).css("margin-top"));f&&(c+=f)}var g=angular.element(window).height(),h=this.$confirmBox.outerHeight();if(0!=h){var k,i=h-d+c,j=this.offsetTop+this.offsetBottom;i>g-j||!this.alignMiddle?(k={"margin-top":this.offsetTop,"margin-bottom":this.offsetBottom},angular.element("body").addClass("ng-confirm-no-scroll-"+this._id)):(k={"margin-top":(g-i)/2,"margin-bottom":0},angular.element("body").removeClass("ng-confirm-no-scroll-"+this._id)),this.$contentPane.css({height:c}).scrollTop(0),this.$confirmBox.css(k)}},_getKey:function(a){switch(a){case 192:return"tilde";case 13:return"enter";case 16:return"shift";case 9:return"tab";case 20:return"capslock";case 17:return"ctrl";case 91:return"win";case 18:return"alt";case 27:return"esc"}var b=String.fromCharCode(a);return!!/^[A-z0-9]+$/.test(b)&&b.toLowerCase()},open:function(){var a=this;return this._prepare(),c(function(){a._open()},100),!0},_open:function(){var a=this;"function"==typeof this.onOpenBefore&&this.onOpenBefore.apply(this,[this.scope]),angular.element(this.container).append(this.$el),a.setDialogCenter("_open"),setTimeout(function(){a.$contentPane.css(a._getCSS(a.animationSpeed,1)),a.$confirmBox.css(a._getCSS(a.animationSpeed,a.animationBounce)),a._removeAnimationClass(),a.$confirmBg.removeClass("ng-confirm-bg-h"),a.$confirmBox.focus(),setTimeout(function(){a._bindEvents(),a.$confirmBox.css(a._getCSS(a.animationSpeed,1)),a._modalReady.resolve(),"function"==typeof a.onOpen&&a.onOpen.apply(a,[a.scope]),a._startCountDown()},a.animationSpeed)},100)},_autoCloseKey:!1,_autoCloseInterval:0,_startCountDown:function(){var a=this;if("string"==typeof this.autoClose){var b=this.autoClose.split("|");if(2!=b.length)return void h.error("Invalid option for autoClose. example 'close|10000'");this._autoCloseKey=b[0];var c=b[1],d=c/1e3;if(!angular.isDefined(this.buttons[this._autoCloseKey]))return void h.error('Auto close button "'+a._autoCloseKey+'" not defined.');var e=angular.element('<span class="ng-confirm-timer"></span>');this.buttons[this._autoCloseKey].el.append(e),this._autoCloseInterval=setInterval(function(){var b=d?" ("+--d+")":"";e.html(b),d<1&&(a._stopCountDown(),a._buttonClick(a._autoCloseKey))},1e3)}},_stopCountDown:function(){this._autoCloseInterval&&clearInterval(this._autoCloseInterval)},closed:!1,isClosed:function(){return this.closed},isOpen:function(){return!this.closed},close:function(){var a=this;"function"==typeof this.onClose&&this.onClose.apply(this,[this.scope]),this._unBindEvents(),this._stopCountDown(),this._setAnimationClass(this.closeAnimation),this.$confirmBg.addClass("ng-confirm-bg-h");var b=.4*this.animationSpeed;return setTimeout(function(){a.$el.remove(),a.closed=!0,a._providedScope||a.scope.$destroy(),"function"==typeof a.onDestroy&&a.onDestroy.apply(a,[a.scope]),angular.element("body").removeClass("ng-confirm-no-scroll-"+a._id),a._lastFocused.focus(),a=void 0},b),!0}},j}]);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var angular = __webpack_require__(28);
	
	/* ng-infinite-scroll - v1.0.0 - 2013-02-23 */
	var mod;mod=angular.module("infinite-scroll",[]),mod.directive("infiniteScroll",["$rootScope","$window","$timeout",function(i,n,e){return{link:function(t,l,o){var r,c,f,a;return n=angular.element(n),f=0,null!=o.infiniteScrollDistance&&t.$watch(o.infiniteScrollDistance,function(i){return f=parseInt(i,10)}),a=!0,r=!1,null!=o.infiniteScrollDisabled&&t.$watch(o.infiniteScrollDisabled,function(i){return a=!i,a&&r?(r=!1,c()):void 0}),c=function(){var e,c,u,d;return d=n.height()+n.scrollTop(),e=l.offset().top+l.height(),c=e-d,u=n.height()*f>=c,u&&a?i.$$phase?t.$eval(o.infiniteScroll):t.$apply(o.infiniteScroll):u?r=!0:void 0},n.on("scroll",c),t.$on("$destroy",function(){return n.off("scroll",c)}),e(function(){return o.infiniteScrollImmediateCheck?t.$eval(o.infiniteScrollImmediateCheck)?c():void 0:c()},0)}}}]);
	


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	angular.module("angularLazyImg",[]),angular.module("angularLazyImg").factory("LazyImgMagic",["$window","$rootScope","lazyImgConfig","lazyImgHelpers",function(n,e,t,o){"use strict";function r(){for(var n=y.length-1;n>=0;n--){var e=y[n];e&&o.isElementInView(e.$elem[0],p.offset,m)&&(u(e),y.splice(n,1))}y.length||s()}function i(n){z.forEach(function(e){e[n]("scroll",I),e[n]("touchmove",I)}),f[n]("resize",I),f[n]("resize",d)}function a(){h=!0,setTimeout(function(){r(),i("on")},1)}function s(){h=!1,i("off")}function c(n){var e=y.indexOf(n);-1!==e&&y.splice(e,1)}function u(n){var t=new Image;t.onerror=function(){p.errorClass&&n.$elem.addClass(p.errorClass),n.errorSrc&&l(n.$elem,n.errorSrc),e.$apply(function(){e.$emit("lazyImg:error",n),p.onError(n)})},t.onload=function(){l(n.$elem,n.src),p.successClass&&n.$elem.addClass(p.successClass),e.$apply(function(){e.$emit("lazyImg:success",n),p.onSuccess(n)})},t.src=n.src}function l(n,e){"img"===n[0].nodeName.toLowerCase()?n[0].src=e:n.css("background-image",'url("'+e+'")')}function g(n){this.$elem=n}var m,f,y,h,p,I,d,z;return y=[],h=!1,p=t.getOptions(),f=angular.element(n),m=o.getWinDimensions(),d=o.throttle(function(){m=o.getWinDimensions()},60),p.container=p.containers||p.container,z=p.container?[].concat(p.container):[f],I=o.throttle(r,30),g.prototype.setSource=function(n){this.src=n,y.unshift(this),a()},g.prototype.setErrorSource=function(n){this.errorSrc=n},g.prototype.removeImage=function(){c(this),y.length||s()},g.prototype.checkImages=r,g.addContainer=function(n){s(),z.push(n),a()},g.removeContainer=function(n){s(),z.splice(z.indexOf(n),1),a()},g}]),angular.module("angularLazyImg").provider("lazyImgConfig",function(){"use strict";this.options={offset:100,errorClass:null,successClass:null,onError:function(){},onSuccess:function(){}},this.$get=function(){var n=this.options;return{getOptions:function(){return n}}},this.setOptions=function(n){angular.extend(this.options,n)}}),angular.module("angularLazyImg").factory("lazyImgHelpers",["$window",function(n){"use strict";return{isElementInView:function(n,e,t){var o=n.getBoundingClientRect();return o.left<=t.width+e&&o.right>=0-e&&o.top<=t.height+e&&o.bottom>=0-e},getWinDimensions:function(){return{height:n.innerHeight,width:n.innerWidth}},throttle:function(n,e,t){var o,r;return function(){var i=t||this,a=+new Date,s=arguments;o&&a<o+e?(clearTimeout(r),r=setTimeout(function(){o=a,n.apply(i,s)},e)):(o=a,n.apply(i,s))}}}}]),angular.module("angularLazyImg").directive("lazyImg",["$rootScope","$log","LazyImgMagic",function(n,e,t){"use strict";return{link:function(e,o,r){e.lazyImage=new t(o),e.lazyImage.setErrorSource(r.lazyImgError);var i=r.$observe("lazyImg",function(n){n&&(i(),e.lazyImage.setSource(n))}),a=n.$on("lazyImg:refresh",function(){e.lazyImage.checkImages()});e.$on("$destroy",function(){e.lazyImage.removeImage(),a()})},restrict:"A"}}]).directive("lazyImgContainer",["LazyImgMagic",function(n){"use strict";return{link:function(e,t){n.addContainer(t),e.$on("$destroy",function(){n.removeContainer(t)})},restrict:"A"}}]);


/***/ }),
/* 123 */
/***/ (function(module, exports) {

	var MatchValidateDirective;
	
	MatchValidateDirective = function() {
	  return {
	    require: 'ngModel',
	    restrict: 'A',
	    scope: {
	      matchValidate: '=gnpMatchValidate'
	    },
	    link: function(scope, elem, attrs, ctrl) {
	      return scope.$watch(function() {
	        return (ctrl.$pristine && angular.isUndefined(ctrl.$modelValue)) || (scope.matchValidate === ctrl.$modelValue);
	      }, function(currentValue) {
	        return ctrl.$setValidity('matchValidate', currentValue);
	      });
	    }
	  };
	};
	
	module.exports = MatchValidateDirective;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var DateInputDirective, moment;
	
	__webpack_require__(125);
	
	moment = __webpack_require__(126);
	
	DateInputDirective = function() {
	  return {
	    restrict: 'A',
	    templateUrl: 'components/form/date-input.jade',
	    require: 'ngModel',
	    replace: true,
	    scope: {
	      date: '=dateInputDate',
	      tindex: '=tIndex'
	    },
	    link: function(scope, elem, attr, ctrl) {
	      var $year, isValidYear, refreshDate;
	      elem.attr("name", ctrl.$name);
	      $year = elem.find('[name=year]');
	      isValidYear = function() {
	        return $year.val().length === 4;
	      };
	      refreshDate = function() {
	        var m;
	        if (!scope.year && !scope.month && !scope.day) {
	          ctrl.$setValidity('dateValidate', true);
	          ctrl.$setValidity('dateRequired', false);
	          return;
	        }
	        ctrl.$setValidity('dateRequired', true);
	        if (scope.year && scope.month && scope.day) {
	          m = moment([scope.year, scope.month - 1, scope.day]);
	          scope.date = m.isValid() ? m : void 0;
	          return ctrl.$setValidity('dateValidate', m.isValid() && isValidYear());
	        } else {
	          scope.date = void 0;
	          return ctrl.$setValidity('dateValidate', false);
	        }
	      };
	      scope.$watch('year + month + day', function() {
	        return refreshDate();
	      });
	      return scope.$watch('date', function() {
	        if (scope.date) {
	          scope.date = (typeof scope.date === "string" ? moment(scope.date) : scope.date);
	          scope.year = scope.date.year();
	          scope.month = scope.date.month() + 1;
	          return scope.day = scope.date.date();
	        }
	      });
	    }
	  };
	};
	
	module.exports = DateInputDirective;


/***/ }),
/* 125 */
/***/ (function(module, exports) {

	var v1="<div class=\"gnp-date-input\"><div class=\"row row-date\"><div class=\"col-4\"><input type=\"number\" name=\"year\" ng-model=\"year\" max=\"9999\" placeholder=\"{{ 'YEAR' | translate }}\" tabindex=\"{{tindex}}\"/></div><div class=\"col-4\"><input type=\"number\" name=\"month\" ng-model=\"month\" placeholder=\"{{ 'MONTH' | translate }}\" tabindex=\"{{tindex + 1}}\"/></div><div class=\"col-4\"><input type=\"number\" name=\"day\" ng-model=\"day\" placeholder=\"{{ 'DAY' | translate }}\" tabindex=\"{{tindex + 2}}\"/></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/form/date-input.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(127);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(128)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)(module)))

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 129,
		"./af.js": 129,
		"./ar": 130,
		"./ar-dz": 131,
		"./ar-dz.js": 131,
		"./ar-kw": 132,
		"./ar-kw.js": 132,
		"./ar-ly": 133,
		"./ar-ly.js": 133,
		"./ar-ma": 134,
		"./ar-ma.js": 134,
		"./ar-sa": 135,
		"./ar-sa.js": 135,
		"./ar-tn": 136,
		"./ar-tn.js": 136,
		"./ar.js": 130,
		"./az": 137,
		"./az.js": 137,
		"./be": 138,
		"./be.js": 138,
		"./bg": 139,
		"./bg.js": 139,
		"./bn": 140,
		"./bn.js": 140,
		"./bo": 141,
		"./bo.js": 141,
		"./br": 142,
		"./br.js": 142,
		"./bs": 143,
		"./bs.js": 143,
		"./ca": 144,
		"./ca.js": 144,
		"./cs": 145,
		"./cs.js": 145,
		"./cv": 146,
		"./cv.js": 146,
		"./cy": 147,
		"./cy.js": 147,
		"./da": 148,
		"./da.js": 148,
		"./de": 149,
		"./de-at": 150,
		"./de-at.js": 150,
		"./de-ch": 151,
		"./de-ch.js": 151,
		"./de.js": 149,
		"./dv": 152,
		"./dv.js": 152,
		"./el": 153,
		"./el.js": 153,
		"./en-au": 154,
		"./en-au.js": 154,
		"./en-ca": 155,
		"./en-ca.js": 155,
		"./en-gb": 156,
		"./en-gb.js": 156,
		"./en-ie": 157,
		"./en-ie.js": 157,
		"./en-nz": 158,
		"./en-nz.js": 158,
		"./eo": 159,
		"./eo.js": 159,
		"./es": 160,
		"./es-do": 161,
		"./es-do.js": 161,
		"./es.js": 160,
		"./et": 162,
		"./et.js": 162,
		"./eu": 163,
		"./eu.js": 163,
		"./fa": 164,
		"./fa.js": 164,
		"./fi": 165,
		"./fi.js": 165,
		"./fo": 166,
		"./fo.js": 166,
		"./fr": 167,
		"./fr-ca": 168,
		"./fr-ca.js": 168,
		"./fr-ch": 169,
		"./fr-ch.js": 169,
		"./fr.js": 167,
		"./fy": 170,
		"./fy.js": 170,
		"./gd": 171,
		"./gd.js": 171,
		"./gl": 172,
		"./gl.js": 172,
		"./gom-latn": 173,
		"./gom-latn.js": 173,
		"./he": 174,
		"./he.js": 174,
		"./hi": 175,
		"./hi.js": 175,
		"./hr": 176,
		"./hr.js": 176,
		"./hu": 177,
		"./hu.js": 177,
		"./hy-am": 178,
		"./hy-am.js": 178,
		"./id": 179,
		"./id.js": 179,
		"./is": 180,
		"./is.js": 180,
		"./it": 181,
		"./it.js": 181,
		"./ja": 182,
		"./ja.js": 182,
		"./jv": 183,
		"./jv.js": 183,
		"./ka": 184,
		"./ka.js": 184,
		"./kk": 185,
		"./kk.js": 185,
		"./km": 186,
		"./km.js": 186,
		"./kn": 187,
		"./kn.js": 187,
		"./ko": 188,
		"./ko.js": 188,
		"./ky": 189,
		"./ky.js": 189,
		"./lb": 190,
		"./lb.js": 190,
		"./lo": 191,
		"./lo.js": 191,
		"./lt": 192,
		"./lt.js": 192,
		"./lv": 193,
		"./lv.js": 193,
		"./me": 194,
		"./me.js": 194,
		"./mi": 195,
		"./mi.js": 195,
		"./mk": 196,
		"./mk.js": 196,
		"./ml": 197,
		"./ml.js": 197,
		"./mr": 198,
		"./mr.js": 198,
		"./ms": 199,
		"./ms-my": 200,
		"./ms-my.js": 200,
		"./ms.js": 199,
		"./my": 201,
		"./my.js": 201,
		"./nb": 202,
		"./nb.js": 202,
		"./ne": 203,
		"./ne.js": 203,
		"./nl": 204,
		"./nl-be": 205,
		"./nl-be.js": 205,
		"./nl.js": 204,
		"./nn": 206,
		"./nn.js": 206,
		"./pa-in": 207,
		"./pa-in.js": 207,
		"./pl": 208,
		"./pl.js": 208,
		"./pt": 209,
		"./pt-br": 210,
		"./pt-br.js": 210,
		"./pt.js": 209,
		"./ro": 211,
		"./ro.js": 211,
		"./ru": 212,
		"./ru.js": 212,
		"./sd": 213,
		"./sd.js": 213,
		"./se": 214,
		"./se.js": 214,
		"./si": 215,
		"./si.js": 215,
		"./sk": 216,
		"./sk.js": 216,
		"./sl": 217,
		"./sl.js": 217,
		"./sq": 218,
		"./sq.js": 218,
		"./sr": 219,
		"./sr-cyrl": 220,
		"./sr-cyrl.js": 220,
		"./sr.js": 219,
		"./ss": 221,
		"./ss.js": 221,
		"./sv": 222,
		"./sv.js": 222,
		"./sw": 223,
		"./sw.js": 223,
		"./ta": 224,
		"./ta.js": 224,
		"./te": 225,
		"./te.js": 225,
		"./tet": 226,
		"./tet.js": 226,
		"./th": 227,
		"./th.js": 227,
		"./tl-ph": 228,
		"./tl-ph.js": 228,
		"./tlh": 229,
		"./tlh.js": 229,
		"./tr": 230,
		"./tr.js": 230,
		"./tzl": 231,
		"./tzl.js": 231,
		"./tzm": 232,
		"./tzm-latn": 233,
		"./tzm-latn.js": 233,
		"./tzm.js": 232,
		"./uk": 234,
		"./uk.js": 234,
		"./ur": 235,
		"./ur.js": 235,
		"./uz": 236,
		"./uz-latn": 237,
		"./uz-latn.js": 237,
		"./uz.js": 236,
		"./vi": 238,
		"./vi.js": 238,
		"./x-pseudo": 239,
		"./x-pseudo.js": 239,
		"./yo": 240,
		"./yo.js": 240,
		"./zh-cn": 241,
		"./zh-cn.js": 241,
		"./zh-hk": 242,
		"./zh-hk.js": 242,
		"./zh-tw": 243,
		"./zh-tw.js": 243
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 128;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(127)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var $, SubmitDirective;
	
	$ = __webpack_require__(1);
	
	SubmitDirective = function() {
	  return {
	    require: '^form',
	    restrict: "A",
	    priority: 1,
	    link: function(scope, element, attributes, form) {
	      scope.showError = false;
	      scope.$watch(attributes.name + ".$dirty", function(dirty) {
	        if (dirty) {
	          form.isDirty = true;
	        }
	        if (!form.submitted) {
	          return form.$setPristine();
	        }
	      });
	      form.clearForm = function() {
	        form.$setPristine();
	        form.isDirty = false;
	        return form.submitted = false;
	      };
	      return element.bind("submit", function(e) {
	        var fields;
	        e.preventDefault();
	        form.submitted = true;
	        scope.showError = true;
	        fields = element.find("input:not([type=checkbox]):not([type=radio]), textarea, .gnp-date-input, .gnp-player-hdcp, select");
	        angular.forEach(fields, function(f) {
	          var fieldElement, fieldName;
	          f = $(f);
	          fieldName = f.attr("name");
	          fieldElement = form[fieldName];
	          if (!f.attr("typeahead") && !f.is("select") && !f.hasClass("gnp-player-hdcp")) {
	            fieldElement.$setViewValue(f.val());
	          }
	          fieldElement.$pristine = false;
	          return fieldElement.$dirty = true;
	        });
	        if (!form.$invalid) {
	          scope.$eval(attributes.gnpSubmit);
	        }
	        if (form.$invalid && attributes.onFormError) {
	          scope.$eval(attributes.onFormError);
	        }
	        scope.$apply();
	        return form.$invalid;
	      });
	    }
	  };
	};
	
	module.exports = SubmitDirective;


/***/ }),
/* 245 */
/***/ (function(module, exports) {

	var CustomValidateDirective;
	
	CustomValidateDirective = function() {
	  return {
	    require: 'ngModel',
	    restrict: 'A',
	    scope: {
	      customValidate: '&gnpCustomValidate'
	    },
	    link: function(scope, elem, attrs, ctrl) {
	      return scope.$watch(function() {
	        return ctrl.$modelValue;
	      }, function(newValue) {
	        var valid;
	        if (newValue) {
	          valid = scope.customValidate({
	            value: newValue
	          });
	          return ctrl.$setValidity("customValidate", valid);
	        } else {
	          return ctrl.$setValidity("customValidate", true);
	        }
	      });
	    }
	  };
	};
	
	module.exports = CustomValidateDirective;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var PlayerHdcpDirective, _;
	
	__webpack_require__(247);
	
	_ = __webpack_require__(87);
	
	PlayerHdcpDirective = function(HdcpService) {
	  return {
	    restrict: 'A',
	    templateUrl: 'components/form/player-hdcp.jade',
	    require: 'ngModel',
	    replace: true,
	    link: function(scope, elem, attrs, ctrl) {
	      var hdcp_values, old_floats, old_integers;
	      elem.attr("name", ctrl.$name);
	      hdcp_values = HdcpService.getAvailableHdcpList();
	      scope.integers = old_integers = hdcp_values.integers;
	      scope.floats = old_floats = hdcp_values.floats;
	      scope.updateModel = function() {
	        var hdcpValue;
	        if ((scope.integer === null || scope.float === null) && scope.integer !== scope.float) {
	          return ctrl.$setValidity('hdcp', false);
	        } else {
	          ctrl.$setValidity('hdcp', true);
	          hdcpValue = HdcpService.getHdcpValue(scope.integer, scope.float);
	          return ctrl.$setViewValue(hdcpValue);
	        }
	      };
	      scope.updateInt = function(newInt) {
	        scope.integer = newInt;
	        if (newInt === null) {
	          scope.float = null;
	        } else if (newInt !== null && scope.float === null) {
	          scope.float = '.0';
	        }
	        return scope.updateModel();
	      };
	      scope.updateFloat = function(newFloat) {
	        scope.float = newFloat;
	        if (newFloat === null) {
	          scope.integer = null;
	        } else if (newFloat !== null && scope.integer === null) {
	          scope.integer = 0;
	        }
	        return scope.updateModel();
	      };
	      ctrl.$render = function() {
	        var hdcpObj;
	        hdcpObj = HdcpService.getHdcpObject(ctrl.$modelValue);
	        scope.integer = hdcpObj.integer;
	        return scope.float = hdcpObj.float;
	      };
	      return ctrl.$render();
	    }
	  };
	};
	
	PlayerHdcpDirective.$inject = ['HdcpService'];
	
	module.exports = PlayerHdcpDirective;


/***/ }),
/* 247 */
/***/ (function(module, exports) {

	var v1="<span class=\"gnp-player-hdcp\"><span class=\"column-input col-2\"><span ng-change=\"updateInt(integer)\" gnp-custom-select=\"\" ng-model=\"integer\" options=\"integers\" class=\"input gray\"></span></span><span class=\"dots\">.</span><span class=\"column-input\"><span ng-change=\"updateFloat(float)\" gnp-custom-select=\"\" ng-model=\"float\" options=\"floats\" class=\"input gray\"></span></span></span>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/form/player-hdcp.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	var FormDecorator;
	
	FormDecorator = function($provide) {
	  $provide.decorator("ngModelDirective", [
	    '$delegate', function($delegate) {
	      var ngModel, originalCompile;
	      ngModel = $delegate[0];
	      originalCompile = ngModel.compile;
	      ngModel.compile = function(element, attrs) {
	        var nameAttr;
	        nameAttr = attrs.name;
	        if ((nameAttr != null ? nameAttr.indexOf('{{') : void 0) >= 0) {
	          return {
	            pre: function(scope, elem, attrs) {
	              return scope.$watch(nameAttr, function(newVal) {
	                if (newVal != null) {
	                  return attrs.$set("name", newVal.toString());
	                }
	              });
	            }
	          };
	        }
	        if (angular.isFunction(originalCompile)) {
	          return originalCompile(element, attrs);
	        }
	        return originalCompile;
	      };
	      return $delegate;
	    }
	  ]);
	  return $provide.decorator("formDirective", [
	    '$delegate', function($delegate) {
	      var form, originalCompile;
	      form = $delegate[0];
	      originalCompile = form.compile;
	      form.compile = function(element, attrs) {
	        var nameAttr;
	        nameAttr = attrs.name || attrs.ngForm;
	        if ((nameAttr != null ? nameAttr.indexOf('{{') : void 0) >= 0) {
	          return {
	            pre: function(scope, elem, attrs) {
	              return scope.$watch(nameAttr, function(newVal) {
	                if (newVal != null) {
	                  return attrs.$set("name", newVal.toString());
	                }
	              });
	            }
	          };
	        }
	        if (angular.isFunction(originalCompile)) {
	          return originalCompile(element, attrs);
	        }
	        return originalCompile;
	      };
	      return $delegate;
	    }
	  ]);
	};
	
	FormDecorator.$inject = ['$provide'];
	
	module.exports = FormDecorator;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var $, CustomSelectDirective, _;
	
	__webpack_require__(250);
	
	$ = __webpack_require__(1);
	
	__webpack_require__(113);
	
	_ = __webpack_require__(87);
	
	__webpack_require__(251);
	
	CustomSelectDirective = function() {
	  return {
	    restrict: 'A',
	    templateUrl: 'components/form/custom-select.jade',
	    require: 'ngModel',
	    scope: {
	      options: '=options',
	      emptyValue: '=?',
	      disable: '=?'
	    },
	    replace: true,
	    link: function(scope, elem, attrs, ctrl) {
	      var $value, displayProperty, id;
	      displayProperty = attrs.displayProperty || 'text';
	      id = String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now();
	      elem.find(".dropdown").attr("id", id);
	      $value = elem.find('button span.score');
	      ctrl.$render = function() {
	        var item;
	        item = _.find(scope.options, function(i) {
	          return i.value === ctrl.$modelValue;
	        });
	        return $value.html((item != null ? item[displayProperty].toString() : void 0) || "");
	      };
	      scope.updateModel = function(item) {
	        var value;
	        value = item ? item.value : void 0;
	        ctrl.$setViewValue(value);
	        ctrl.$render();
	      };
	      scope.isSelected = function(item) {
	        return item.value === ctrl.$modelValue;
	      };
	      return scope.$on('dropdownListClose', function(e) {
	        return elem.children('.dropdown').removeClass('open');
	      });
	    }
	  };
	};
	
	module.exports = CustomSelectDirective;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

	var v1="<span><span class=\"dropdown\"><button type=\"button\" data-toggle=\"dropdown\" ng-disabled=\"disable\" class=\"dropdown-toggle\"><span class=\"score\"></span></button><ul role=\"menu\" data-placement=\"auto\" class=\"dropdown-menu scrollable\"><li ng-if=\"emptyValue\" ng-click=\"updateModel()\"><a><div class=\"empty\"></div></a></li><li ng-class=\"{'active': isSelected(item)}\" ng-repeat=\"item in options\" ng-click=\"updateModel(item)\"><a ng-bind-html=\"item.text | trustedText\"></a></li></ul></span></span>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/form/custom-select.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * Bootstrap v4.6.2 (https://getbootstrap.com/)
	  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
	  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
	  */
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(1), __webpack_require__(252)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'jquery', 'popper.js'], factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.bootstrap = {}, global.jQuery, global.Popper));
	})(this, (function (exports, $, Popper) { 'use strict';
	
	  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	  var $__default = /*#__PURE__*/_interopDefaultLegacy($);
	  var Popper__default = /*#__PURE__*/_interopDefaultLegacy(Popper);
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    Object.defineProperty(Constructor, "prototype", {
	      writable: false
	    });
	    return Constructor;
	  }
	
	  function _extends() {
	    _extends = Object.assign ? Object.assign.bind() : function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	    return _extends.apply(this, arguments);
	  }
	
	  function _inheritsLoose(subClass, superClass) {
	    subClass.prototype = Object.create(superClass.prototype);
	    subClass.prototype.constructor = subClass;
	
	    _setPrototypeOf(subClass, superClass);
	  }
	
	  function _setPrototypeOf(o, p) {
	    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };
	    return _setPrototypeOf(o, p);
	  }
	
	  /**
	   * --------------------------------------------------------------------------
	   * Bootstrap (v4.6.2): util.js
	   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
	   * --------------------------------------------------------------------------
	   */
	  /**
	   * Private TransitionEnd Helpers
	   */
	
	  var TRANSITION_END = 'transitionend';
	  var MAX_UID = 1000000;
	  var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)
	
	  function toType(obj) {
	    if (obj === null || typeof obj === 'undefined') {
	      return "" + obj;
	    }
	
	    return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
	  }
	
	  function getSpecialTransitionEndEvent() {
	    return {
	      bindType: TRANSITION_END,
	      delegateType: TRANSITION_END,
	      handle: function handle(event) {
	        if ($__default["default"](event.target).is(this)) {
	          return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
	        }
	
	        return undefined;
	      }
	    };
	  }
	
	  function transitionEndEmulator(duration) {
	    var _this = this;
	
	    var called = false;
	    $__default["default"](this).one(Util.TRANSITION_END, function () {
	      called = true;
	    });
	    setTimeout(function () {
	      if (!called) {
	        Util.triggerTransitionEnd(_this);
	      }
	    }, duration);
	    return this;
	  }
	
	  function setTransitionEndSupport() {
	    $__default["default"].fn.emulateTransitionEnd = transitionEndEmulator;
	    $__default["default"].event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
	  }
	  /**
	   * Public Util API
	   */
	
	
	  var Util = {
	    TRANSITION_END: 'bsTransitionEnd',
	    getUID: function getUID(prefix) {
	      do {
	        // eslint-disable-next-line no-bitwise
	        prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
	      } while (document.getElementById(prefix));
	
	      return prefix;
	    },
	    getSelectorFromElement: function getSelectorFromElement(element) {
	      var selector = element.getAttribute('data-target');
	
	      if (!selector || selector === '#') {
	        var hrefAttr = element.getAttribute('href');
	        selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : '';
	      }
	
	      try {
	        return document.querySelector(selector) ? selector : null;
	      } catch (_) {
	        return null;
	      }
	    },
	    getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
	      if (!element) {
	        return 0;
	      } // Get transition-duration of the element
	
	
	      var transitionDuration = $__default["default"](element).css('transition-duration');
	      var transitionDelay = $__default["default"](element).css('transition-delay');
	      var floatTransitionDuration = parseFloat(transitionDuration);
	      var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found
	
	      if (!floatTransitionDuration && !floatTransitionDelay) {
	        return 0;
	      } // If multiple durations are defined, take the first
	
	
	      transitionDuration = transitionDuration.split(',')[0];
	      transitionDelay = transitionDelay.split(',')[0];
	      return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
	    },
	    reflow: function reflow(element) {
	      return element.offsetHeight;
	    },
	    triggerTransitionEnd: function triggerTransitionEnd(element) {
	      $__default["default"](element).trigger(TRANSITION_END);
	    },
	    supportsTransitionEnd: function supportsTransitionEnd() {
	      return Boolean(TRANSITION_END);
	    },
	    isElement: function isElement(obj) {
	      return (obj[0] || obj).nodeType;
	    },
	    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
	      for (var property in configTypes) {
	        if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
	          var expectedTypes = configTypes[property];
	          var value = config[property];
	          var valueType = value && Util.isElement(value) ? 'element' : toType(value);
	
	          if (!new RegExp(expectedTypes).test(valueType)) {
	            throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
	          }
	        }
	      }
	    },
	    findShadowRoot: function findShadowRoot(element) {
	      if (!document.documentElement.attachShadow) {
	        return null;
	      } // Can find the shadow root otherwise it'll return the document
	
	
	      if (typeof element.getRootNode === 'function') {
	        var root = element.getRootNode();
	        return root instanceof ShadowRoot ? root : null;
	      }
	
	      if (element instanceof ShadowRoot) {
	        return element;
	      } // when we don't find a shadow root
	
	
	      if (!element.parentNode) {
	        return null;
	      }
	
	      return Util.findShadowRoot(element.parentNode);
	    },
	    jQueryDetection: function jQueryDetection() {
	      if (typeof $__default["default"] === 'undefined') {
	        throw new TypeError('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.');
	      }
	
	      var version = $__default["default"].fn.jquery.split(' ')[0].split('.');
	      var minMajor = 1;
	      var ltMajor = 2;
	      var minMinor = 9;
	      var minPatch = 1;
	      var maxMajor = 4;
	
	      if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) {
	        throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0');
	      }
	    }
	  };
	  Util.jQueryDetection();
	  setTransitionEndSupport();
	
	  /**
	   * Constants
	   */
	
	  var NAME$a = 'alert';
	  var VERSION$a = '4.6.2';
	  var DATA_KEY$a = 'bs.alert';
	  var EVENT_KEY$a = "." + DATA_KEY$a;
	  var DATA_API_KEY$7 = '.data-api';
	  var JQUERY_NO_CONFLICT$a = $__default["default"].fn[NAME$a];
	  var CLASS_NAME_ALERT = 'alert';
	  var CLASS_NAME_FADE$5 = 'fade';
	  var CLASS_NAME_SHOW$7 = 'show';
	  var EVENT_CLOSE = "close" + EVENT_KEY$a;
	  var EVENT_CLOSED = "closed" + EVENT_KEY$a;
	  var EVENT_CLICK_DATA_API$6 = "click" + EVENT_KEY$a + DATA_API_KEY$7;
	  var SELECTOR_DISMISS = '[data-dismiss="alert"]';
	  /**
	   * Class definition
	   */
	
	  var Alert = /*#__PURE__*/function () {
	    function Alert(element) {
	      this._element = element;
	    } // Getters
	
	
	    var _proto = Alert.prototype;
	
	    // Public
	    _proto.close = function close(element) {
	      var rootElement = this._element;
	
	      if (element) {
	        rootElement = this._getRootElement(element);
	      }
	
	      var customEvent = this._triggerCloseEvent(rootElement);
	
	      if (customEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      this._removeElement(rootElement);
	    };
	
	    _proto.dispose = function dispose() {
	      $__default["default"].removeData(this._element, DATA_KEY$a);
	      this._element = null;
	    } // Private
	    ;
	
	    _proto._getRootElement = function _getRootElement(element) {
	      var selector = Util.getSelectorFromElement(element);
	      var parent = false;
	
	      if (selector) {
	        parent = document.querySelector(selector);
	      }
	
	      if (!parent) {
	        parent = $__default["default"](element).closest("." + CLASS_NAME_ALERT)[0];
	      }
	
	      return parent;
	    };
	
	    _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
	      var closeEvent = $__default["default"].Event(EVENT_CLOSE);
	      $__default["default"](element).trigger(closeEvent);
	      return closeEvent;
	    };
	
	    _proto._removeElement = function _removeElement(element) {
	      var _this = this;
	
	      $__default["default"](element).removeClass(CLASS_NAME_SHOW$7);
	
	      if (!$__default["default"](element).hasClass(CLASS_NAME_FADE$5)) {
	        this._destroyElement(element);
	
	        return;
	      }
	
	      var transitionDuration = Util.getTransitionDurationFromElement(element);
	      $__default["default"](element).one(Util.TRANSITION_END, function (event) {
	        return _this._destroyElement(element, event);
	      }).emulateTransitionEnd(transitionDuration);
	    };
	
	    _proto._destroyElement = function _destroyElement(element) {
	      $__default["default"](element).detach().trigger(EVENT_CLOSED).remove();
	    } // Static
	    ;
	
	    Alert._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var $element = $__default["default"](this);
	        var data = $element.data(DATA_KEY$a);
	
	        if (!data) {
	          data = new Alert(this);
	          $element.data(DATA_KEY$a, data);
	        }
	
	        if (config === 'close') {
	          data[config](this);
	        }
	      });
	    };
	
	    Alert._handleDismiss = function _handleDismiss(alertInstance) {
	      return function (event) {
	        if (event) {
	          event.preventDefault();
	        }
	
	        alertInstance.close(this);
	      };
	    };
	
	    _createClass(Alert, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$a;
	      }
	    }]);
	
	    return Alert;
	  }();
	  /**
	   * Data API implementation
	   */
	
	
	  $__default["default"](document).on(EVENT_CLICK_DATA_API$6, SELECTOR_DISMISS, Alert._handleDismiss(new Alert()));
	  /**
	   * jQuery
	   */
	
	  $__default["default"].fn[NAME$a] = Alert._jQueryInterface;
	  $__default["default"].fn[NAME$a].Constructor = Alert;
	
	  $__default["default"].fn[NAME$a].noConflict = function () {
	    $__default["default"].fn[NAME$a] = JQUERY_NO_CONFLICT$a;
	    return Alert._jQueryInterface;
	  };
	
	  /**
	   * Constants
	   */
	
	  var NAME$9 = 'button';
	  var VERSION$9 = '4.6.2';
	  var DATA_KEY$9 = 'bs.button';
	  var EVENT_KEY$9 = "." + DATA_KEY$9;
	  var DATA_API_KEY$6 = '.data-api';
	  var JQUERY_NO_CONFLICT$9 = $__default["default"].fn[NAME$9];
	  var CLASS_NAME_ACTIVE$3 = 'active';
	  var CLASS_NAME_BUTTON = 'btn';
	  var CLASS_NAME_FOCUS = 'focus';
	  var EVENT_CLICK_DATA_API$5 = "click" + EVENT_KEY$9 + DATA_API_KEY$6;
	  var EVENT_FOCUS_BLUR_DATA_API = "focus" + EVENT_KEY$9 + DATA_API_KEY$6 + " " + ("blur" + EVENT_KEY$9 + DATA_API_KEY$6);
	  var EVENT_LOAD_DATA_API$2 = "load" + EVENT_KEY$9 + DATA_API_KEY$6;
	  var SELECTOR_DATA_TOGGLE_CARROT = '[data-toggle^="button"]';
	  var SELECTOR_DATA_TOGGLES = '[data-toggle="buttons"]';
	  var SELECTOR_DATA_TOGGLE$4 = '[data-toggle="button"]';
	  var SELECTOR_DATA_TOGGLES_BUTTONS = '[data-toggle="buttons"] .btn';
	  var SELECTOR_INPUT = 'input:not([type="hidden"])';
	  var SELECTOR_ACTIVE$2 = '.active';
	  var SELECTOR_BUTTON = '.btn';
	  /**
	   * Class definition
	   */
	
	  var Button = /*#__PURE__*/function () {
	    function Button(element) {
	      this._element = element;
	      this.shouldAvoidTriggerChange = false;
	    } // Getters
	
	
	    var _proto = Button.prototype;
	
	    // Public
	    _proto.toggle = function toggle() {
	      var triggerChangeEvent = true;
	      var addAriaPressed = true;
	      var rootElement = $__default["default"](this._element).closest(SELECTOR_DATA_TOGGLES)[0];
	
	      if (rootElement) {
	        var input = this._element.querySelector(SELECTOR_INPUT);
	
	        if (input) {
	          if (input.type === 'radio') {
	            if (input.checked && this._element.classList.contains(CLASS_NAME_ACTIVE$3)) {
	              triggerChangeEvent = false;
	            } else {
	              var activeElement = rootElement.querySelector(SELECTOR_ACTIVE$2);
	
	              if (activeElement) {
	                $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$3);
	              }
	            }
	          }
	
	          if (triggerChangeEvent) {
	            // if it's not a radio button or checkbox don't add a pointless/invalid checked property to the input
	            if (input.type === 'checkbox' || input.type === 'radio') {
	              input.checked = !this._element.classList.contains(CLASS_NAME_ACTIVE$3);
	            }
	
	            if (!this.shouldAvoidTriggerChange) {
	              $__default["default"](input).trigger('change');
	            }
	          }
	
	          input.focus();
	          addAriaPressed = false;
	        }
	      }
	
	      if (!(this._element.hasAttribute('disabled') || this._element.classList.contains('disabled'))) {
	        if (addAriaPressed) {
	          this._element.setAttribute('aria-pressed', !this._element.classList.contains(CLASS_NAME_ACTIVE$3));
	        }
	
	        if (triggerChangeEvent) {
	          $__default["default"](this._element).toggleClass(CLASS_NAME_ACTIVE$3);
	        }
	      }
	    };
	
	    _proto.dispose = function dispose() {
	      $__default["default"].removeData(this._element, DATA_KEY$9);
	      this._element = null;
	    } // Static
	    ;
	
	    Button._jQueryInterface = function _jQueryInterface(config, avoidTriggerChange) {
	      return this.each(function () {
	        var $element = $__default["default"](this);
	        var data = $element.data(DATA_KEY$9);
	
	        if (!data) {
	          data = new Button(this);
	          $element.data(DATA_KEY$9, data);
	        }
	
	        data.shouldAvoidTriggerChange = avoidTriggerChange;
	
	        if (config === 'toggle') {
	          data[config]();
	        }
	      });
	    };
	
	    _createClass(Button, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$9;
	      }
	    }]);
	
	    return Button;
	  }();
	  /**
	   * Data API implementation
	   */
	
	
	  $__default["default"](document).on(EVENT_CLICK_DATA_API$5, SELECTOR_DATA_TOGGLE_CARROT, function (event) {
	    var button = event.target;
	    var initialButton = button;
	
	    if (!$__default["default"](button).hasClass(CLASS_NAME_BUTTON)) {
	      button = $__default["default"](button).closest(SELECTOR_BUTTON)[0];
	    }
	
	    if (!button || button.hasAttribute('disabled') || button.classList.contains('disabled')) {
	      event.preventDefault(); // work around Firefox bug #1540995
	    } else {
	      var inputBtn = button.querySelector(SELECTOR_INPUT);
	
	      if (inputBtn && (inputBtn.hasAttribute('disabled') || inputBtn.classList.contains('disabled'))) {
	        event.preventDefault(); // work around Firefox bug #1540995
	
	        return;
	      }
	
	      if (initialButton.tagName === 'INPUT' || button.tagName !== 'LABEL') {
	        Button._jQueryInterface.call($__default["default"](button), 'toggle', initialButton.tagName === 'INPUT');
	      }
	    }
	  }).on(EVENT_FOCUS_BLUR_DATA_API, SELECTOR_DATA_TOGGLE_CARROT, function (event) {
	    var button = $__default["default"](event.target).closest(SELECTOR_BUTTON)[0];
	    $__default["default"](button).toggleClass(CLASS_NAME_FOCUS, /^focus(in)?$/.test(event.type));
	  });
	  $__default["default"](window).on(EVENT_LOAD_DATA_API$2, function () {
	    // ensure correct active class is set to match the controls' actual values/states
	    // find all checkboxes/readio buttons inside data-toggle groups
	    var buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLES_BUTTONS));
	
	    for (var i = 0, len = buttons.length; i < len; i++) {
	      var button = buttons[i];
	      var input = button.querySelector(SELECTOR_INPUT);
	
	      if (input.checked || input.hasAttribute('checked')) {
	        button.classList.add(CLASS_NAME_ACTIVE$3);
	      } else {
	        button.classList.remove(CLASS_NAME_ACTIVE$3);
	      }
	    } // find all button toggles
	
	
	    buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$4));
	
	    for (var _i = 0, _len = buttons.length; _i < _len; _i++) {
	      var _button = buttons[_i];
	
	      if (_button.getAttribute('aria-pressed') === 'true') {
	        _button.classList.add(CLASS_NAME_ACTIVE$3);
	      } else {
	        _button.classList.remove(CLASS_NAME_ACTIVE$3);
	      }
	    }
	  });
	  /**
	   * jQuery
	   */
	
	  $__default["default"].fn[NAME$9] = Button._jQueryInterface;
	  $__default["default"].fn[NAME$9].Constructor = Button;
	
	  $__default["default"].fn[NAME$9].noConflict = function () {
	    $__default["default"].fn[NAME$9] = JQUERY_NO_CONFLICT$9;
	    return Button._jQueryInterface;
	  };
	
	  /**
	   * Constants
	   */
	
	  var NAME$8 = 'carousel';
	  var VERSION$8 = '4.6.2';
	  var DATA_KEY$8 = 'bs.carousel';
	  var EVENT_KEY$8 = "." + DATA_KEY$8;
	  var DATA_API_KEY$5 = '.data-api';
	  var JQUERY_NO_CONFLICT$8 = $__default["default"].fn[NAME$8];
	  var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key
	
	  var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key
	
	  var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
	
	  var SWIPE_THRESHOLD = 40;
	  var CLASS_NAME_CAROUSEL = 'carousel';
	  var CLASS_NAME_ACTIVE$2 = 'active';
	  var CLASS_NAME_SLIDE = 'slide';
	  var CLASS_NAME_RIGHT = 'carousel-item-right';
	  var CLASS_NAME_LEFT = 'carousel-item-left';
	  var CLASS_NAME_NEXT = 'carousel-item-next';
	  var CLASS_NAME_PREV = 'carousel-item-prev';
	  var CLASS_NAME_POINTER_EVENT = 'pointer-event';
	  var DIRECTION_NEXT = 'next';
	  var DIRECTION_PREV = 'prev';
	  var DIRECTION_LEFT = 'left';
	  var DIRECTION_RIGHT = 'right';
	  var EVENT_SLIDE = "slide" + EVENT_KEY$8;
	  var EVENT_SLID = "slid" + EVENT_KEY$8;
	  var EVENT_KEYDOWN = "keydown" + EVENT_KEY$8;
	  var EVENT_MOUSEENTER = "mouseenter" + EVENT_KEY$8;
	  var EVENT_MOUSELEAVE = "mouseleave" + EVENT_KEY$8;
	  var EVENT_TOUCHSTART = "touchstart" + EVENT_KEY$8;
	  var EVENT_TOUCHMOVE = "touchmove" + EVENT_KEY$8;
	  var EVENT_TOUCHEND = "touchend" + EVENT_KEY$8;
	  var EVENT_POINTERDOWN = "pointerdown" + EVENT_KEY$8;
	  var EVENT_POINTERUP = "pointerup" + EVENT_KEY$8;
	  var EVENT_DRAG_START = "dragstart" + EVENT_KEY$8;
	  var EVENT_LOAD_DATA_API$1 = "load" + EVENT_KEY$8 + DATA_API_KEY$5;
	  var EVENT_CLICK_DATA_API$4 = "click" + EVENT_KEY$8 + DATA_API_KEY$5;
	  var SELECTOR_ACTIVE$1 = '.active';
	  var SELECTOR_ACTIVE_ITEM = '.active.carousel-item';
	  var SELECTOR_ITEM = '.carousel-item';
	  var SELECTOR_ITEM_IMG = '.carousel-item img';
	  var SELECTOR_NEXT_PREV = '.carousel-item-next, .carousel-item-prev';
	  var SELECTOR_INDICATORS = '.carousel-indicators';
	  var SELECTOR_DATA_SLIDE = '[data-slide], [data-slide-to]';
	  var SELECTOR_DATA_RIDE = '[data-ride="carousel"]';
	  var Default$7 = {
	    interval: 5000,
	    keyboard: true,
	    slide: false,
	    pause: 'hover',
	    wrap: true,
	    touch: true
	  };
	  var DefaultType$7 = {
	    interval: '(number|boolean)',
	    keyboard: 'boolean',
	    slide: '(boolean|string)',
	    pause: '(string|boolean)',
	    wrap: 'boolean',
	    touch: 'boolean'
	  };
	  var PointerType = {
	    TOUCH: 'touch',
	    PEN: 'pen'
	  };
	  /**
	   * Class definition
	   */
	
	  var Carousel = /*#__PURE__*/function () {
	    function Carousel(element, config) {
	      this._items = null;
	      this._interval = null;
	      this._activeElement = null;
	      this._isPaused = false;
	      this._isSliding = false;
	      this.touchTimeout = null;
	      this.touchStartX = 0;
	      this.touchDeltaX = 0;
	      this._config = this._getConfig(config);
	      this._element = element;
	      this._indicatorsElement = this._element.querySelector(SELECTOR_INDICATORS);
	      this._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
	      this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);
	
	      this._addEventListeners();
	    } // Getters
	
	
	    var _proto = Carousel.prototype;
	
	    // Public
	    _proto.next = function next() {
	      if (!this._isSliding) {
	        this._slide(DIRECTION_NEXT);
	      }
	    };
	
	    _proto.nextWhenVisible = function nextWhenVisible() {
	      var $element = $__default["default"](this._element); // Don't call next when the page isn't visible
	      // or the carousel or its parent isn't visible
	
	      if (!document.hidden && $element.is(':visible') && $element.css('visibility') !== 'hidden') {
	        this.next();
	      }
	    };
	
	    _proto.prev = function prev() {
	      if (!this._isSliding) {
	        this._slide(DIRECTION_PREV);
	      }
	    };
	
	    _proto.pause = function pause(event) {
	      if (!event) {
	        this._isPaused = true;
	      }
	
	      if (this._element.querySelector(SELECTOR_NEXT_PREV)) {
	        Util.triggerTransitionEnd(this._element);
	        this.cycle(true);
	      }
	
	      clearInterval(this._interval);
	      this._interval = null;
	    };
	
	    _proto.cycle = function cycle(event) {
	      if (!event) {
	        this._isPaused = false;
	      }
	
	      if (this._interval) {
	        clearInterval(this._interval);
	        this._interval = null;
	      }
	
	      if (this._config.interval && !this._isPaused) {
	        this._updateInterval();
	
	        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
	      }
	    };
	
	    _proto.to = function to(index) {
	      var _this = this;
	
	      this._activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
	
	      var activeIndex = this._getItemIndex(this._activeElement);
	
	      if (index > this._items.length - 1 || index < 0) {
	        return;
	      }
	
	      if (this._isSliding) {
	        $__default["default"](this._element).one(EVENT_SLID, function () {
	          return _this.to(index);
	        });
	        return;
	      }
	
	      if (activeIndex === index) {
	        this.pause();
	        this.cycle();
	        return;
	      }
	
	      var direction = index > activeIndex ? DIRECTION_NEXT : DIRECTION_PREV;
	
	      this._slide(direction, this._items[index]);
	    };
	
	    _proto.dispose = function dispose() {
	      $__default["default"](this._element).off(EVENT_KEY$8);
	      $__default["default"].removeData(this._element, DATA_KEY$8);
	      this._items = null;
	      this._config = null;
	      this._element = null;
	      this._interval = null;
	      this._isPaused = null;
	      this._isSliding = null;
	      this._activeElement = null;
	      this._indicatorsElement = null;
	    } // Private
	    ;
	
	    _proto._getConfig = function _getConfig(config) {
	      config = _extends({}, Default$7, config);
	      Util.typeCheckConfig(NAME$8, config, DefaultType$7);
	      return config;
	    };
	
	    _proto._handleSwipe = function _handleSwipe() {
	      var absDeltax = Math.abs(this.touchDeltaX);
	
	      if (absDeltax <= SWIPE_THRESHOLD) {
	        return;
	      }
	
	      var direction = absDeltax / this.touchDeltaX;
	      this.touchDeltaX = 0; // swipe left
	
	      if (direction > 0) {
	        this.prev();
	      } // swipe right
	
	
	      if (direction < 0) {
	        this.next();
	      }
	    };
	
	    _proto._addEventListeners = function _addEventListeners() {
	      var _this2 = this;
	
	      if (this._config.keyboard) {
	        $__default["default"](this._element).on(EVENT_KEYDOWN, function (event) {
	          return _this2._keydown(event);
	        });
	      }
	
	      if (this._config.pause === 'hover') {
	        $__default["default"](this._element).on(EVENT_MOUSEENTER, function (event) {
	          return _this2.pause(event);
	        }).on(EVENT_MOUSELEAVE, function (event) {
	          return _this2.cycle(event);
	        });
	      }
	
	      if (this._config.touch) {
	        this._addTouchEventListeners();
	      }
	    };
	
	    _proto._addTouchEventListeners = function _addTouchEventListeners() {
	      var _this3 = this;
	
	      if (!this._touchSupported) {
	        return;
	      }
	
	      var start = function start(event) {
	        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
	          _this3.touchStartX = event.originalEvent.clientX;
	        } else if (!_this3._pointerEvent) {
	          _this3.touchStartX = event.originalEvent.touches[0].clientX;
	        }
	      };
	
	      var move = function move(event) {
	        // ensure swiping with one touch and not pinching
	        _this3.touchDeltaX = event.originalEvent.touches && event.originalEvent.touches.length > 1 ? 0 : event.originalEvent.touches[0].clientX - _this3.touchStartX;
	      };
	
	      var end = function end(event) {
	        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
	          _this3.touchDeltaX = event.originalEvent.clientX - _this3.touchStartX;
	        }
	
	        _this3._handleSwipe();
	
	        if (_this3._config.pause === 'hover') {
	          // If it's a touch-enabled device, mouseenter/leave are fired as
	          // part of the mouse compatibility events on first tap - the carousel
	          // would stop cycling until user tapped out of it;
	          // here, we listen for touchend, explicitly pause the carousel
	          // (as if it's the second time we tap on it, mouseenter compat event
	          // is NOT fired) and after a timeout (to allow for mouse compatibility
	          // events to fire) we explicitly restart cycling
	          _this3.pause();
	
	          if (_this3.touchTimeout) {
	            clearTimeout(_this3.touchTimeout);
	          }
	
	          _this3.touchTimeout = setTimeout(function (event) {
	            return _this3.cycle(event);
	          }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
	        }
	      };
	
	      $__default["default"](this._element.querySelectorAll(SELECTOR_ITEM_IMG)).on(EVENT_DRAG_START, function (e) {
	        return e.preventDefault();
	      });
	
	      if (this._pointerEvent) {
	        $__default["default"](this._element).on(EVENT_POINTERDOWN, function (event) {
	          return start(event);
	        });
	        $__default["default"](this._element).on(EVENT_POINTERUP, function (event) {
	          return end(event);
	        });
	
	        this._element.classList.add(CLASS_NAME_POINTER_EVENT);
	      } else {
	        $__default["default"](this._element).on(EVENT_TOUCHSTART, function (event) {
	          return start(event);
	        });
	        $__default["default"](this._element).on(EVENT_TOUCHMOVE, function (event) {
	          return move(event);
	        });
	        $__default["default"](this._element).on(EVENT_TOUCHEND, function (event) {
	          return end(event);
	        });
	      }
	    };
	
	    _proto._keydown = function _keydown(event) {
	      if (/input|textarea/i.test(event.target.tagName)) {
	        return;
	      }
	
	      switch (event.which) {
	        case ARROW_LEFT_KEYCODE:
	          event.preventDefault();
	          this.prev();
	          break;
	
	        case ARROW_RIGHT_KEYCODE:
	          event.preventDefault();
	          this.next();
	          break;
	      }
	    };
	
	    _proto._getItemIndex = function _getItemIndex(element) {
	      this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(SELECTOR_ITEM)) : [];
	      return this._items.indexOf(element);
	    };
	
	    _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
	      var isNextDirection = direction === DIRECTION_NEXT;
	      var isPrevDirection = direction === DIRECTION_PREV;
	
	      var activeIndex = this._getItemIndex(activeElement);
	
	      var lastItemIndex = this._items.length - 1;
	      var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;
	
	      if (isGoingToWrap && !this._config.wrap) {
	        return activeElement;
	      }
	
	      var delta = direction === DIRECTION_PREV ? -1 : 1;
	      var itemIndex = (activeIndex + delta) % this._items.length;
	      return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
	    };
	
	    _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
	      var targetIndex = this._getItemIndex(relatedTarget);
	
	      var fromIndex = this._getItemIndex(this._element.querySelector(SELECTOR_ACTIVE_ITEM));
	
	      var slideEvent = $__default["default"].Event(EVENT_SLIDE, {
	        relatedTarget: relatedTarget,
	        direction: eventDirectionName,
	        from: fromIndex,
	        to: targetIndex
	      });
	      $__default["default"](this._element).trigger(slideEvent);
	      return slideEvent;
	    };
	
	    _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
	      if (this._indicatorsElement) {
	        var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(SELECTOR_ACTIVE$1));
	        $__default["default"](indicators).removeClass(CLASS_NAME_ACTIVE$2);
	
	        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];
	
	        if (nextIndicator) {
	          $__default["default"](nextIndicator).addClass(CLASS_NAME_ACTIVE$2);
	        }
	      }
	    };
	
	    _proto._updateInterval = function _updateInterval() {
	      var element = this._activeElement || this._element.querySelector(SELECTOR_ACTIVE_ITEM);
	
	      if (!element) {
	        return;
	      }
	
	      var elementInterval = parseInt(element.getAttribute('data-interval'), 10);
	
	      if (elementInterval) {
	        this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
	        this._config.interval = elementInterval;
	      } else {
	        this._config.interval = this._config.defaultInterval || this._config.interval;
	      }
	    };
	
	    _proto._slide = function _slide(direction, element) {
	      var _this4 = this;
	
	      var activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
	
	      var activeElementIndex = this._getItemIndex(activeElement);
	
	      var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);
	
	      var nextElementIndex = this._getItemIndex(nextElement);
	
	      var isCycling = Boolean(this._interval);
	      var directionalClassName;
	      var orderClassName;
	      var eventDirectionName;
	
	      if (direction === DIRECTION_NEXT) {
	        directionalClassName = CLASS_NAME_LEFT;
	        orderClassName = CLASS_NAME_NEXT;
	        eventDirectionName = DIRECTION_LEFT;
	      } else {
	        directionalClassName = CLASS_NAME_RIGHT;
	        orderClassName = CLASS_NAME_PREV;
	        eventDirectionName = DIRECTION_RIGHT;
	      }
	
	      if (nextElement && $__default["default"](nextElement).hasClass(CLASS_NAME_ACTIVE$2)) {
	        this._isSliding = false;
	        return;
	      }
	
	      var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
	
	      if (slideEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      if (!activeElement || !nextElement) {
	        // Some weirdness is happening, so we bail
	        return;
	      }
	
	      this._isSliding = true;
	
	      if (isCycling) {
	        this.pause();
	      }
	
	      this._setActiveIndicatorElement(nextElement);
	
	      this._activeElement = nextElement;
	      var slidEvent = $__default["default"].Event(EVENT_SLID, {
	        relatedTarget: nextElement,
	        direction: eventDirectionName,
	        from: activeElementIndex,
	        to: nextElementIndex
	      });
	
	      if ($__default["default"](this._element).hasClass(CLASS_NAME_SLIDE)) {
	        $__default["default"](nextElement).addClass(orderClassName);
	        Util.reflow(nextElement);
	        $__default["default"](activeElement).addClass(directionalClassName);
	        $__default["default"](nextElement).addClass(directionalClassName);
	        var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
	        $__default["default"](activeElement).one(Util.TRANSITION_END, function () {
	          $__default["default"](nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(CLASS_NAME_ACTIVE$2);
	          $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2 + " " + orderClassName + " " + directionalClassName);
	          _this4._isSliding = false;
	          setTimeout(function () {
	            return $__default["default"](_this4._element).trigger(slidEvent);
	          }, 0);
	        }).emulateTransitionEnd(transitionDuration);
	      } else {
	        $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2);
	        $__default["default"](nextElement).addClass(CLASS_NAME_ACTIVE$2);
	        this._isSliding = false;
	        $__default["default"](this._element).trigger(slidEvent);
	      }
	
	      if (isCycling) {
	        this.cycle();
	      }
	    } // Static
	    ;
	
	    Carousel._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = $__default["default"](this).data(DATA_KEY$8);
	
	        var _config = _extends({}, Default$7, $__default["default"](this).data());
	
	        if (typeof config === 'object') {
	          _config = _extends({}, _config, config);
	        }
	
	        var action = typeof config === 'string' ? config : _config.slide;
	
	        if (!data) {
	          data = new Carousel(this, _config);
	          $__default["default"](this).data(DATA_KEY$8, data);
	        }
	
	        if (typeof config === 'number') {
	          data.to(config);
	        } else if (typeof action === 'string') {
	          if (typeof data[action] === 'undefined') {
	            throw new TypeError("No method named \"" + action + "\"");
	          }
	
	          data[action]();
	        } else if (_config.interval && _config.ride) {
	          data.pause();
	          data.cycle();
	        }
	      });
	    };
	
	    Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
	      var selector = Util.getSelectorFromElement(this);
	
	      if (!selector) {
	        return;
	      }
	
	      var target = $__default["default"](selector)[0];
	
	      if (!target || !$__default["default"](target).hasClass(CLASS_NAME_CAROUSEL)) {
	        return;
	      }
	
	      var config = _extends({}, $__default["default"](target).data(), $__default["default"](this).data());
	
	      var slideIndex = this.getAttribute('data-slide-to');
	
	      if (slideIndex) {
	        config.interval = false;
	      }
	
	      Carousel._jQueryInterface.call($__default["default"](target), config);
	
	      if (slideIndex) {
	        $__default["default"](target).data(DATA_KEY$8).to(slideIndex);
	      }
	
	      event.preventDefault();
	    };
	
	    _createClass(Carousel, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$8;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$7;
	      }
	    }]);
	
	    return Carousel;
	  }();
	  /**
	   * Data API implementation
	   */
	
	
	  $__default["default"](document).on(EVENT_CLICK_DATA_API$4, SELECTOR_DATA_SLIDE, Carousel._dataApiClickHandler);
	  $__default["default"](window).on(EVENT_LOAD_DATA_API$1, function () {
	    var carousels = [].slice.call(document.querySelectorAll(SELECTOR_DATA_RIDE));
	
	    for (var i = 0, len = carousels.length; i < len; i++) {
	      var $carousel = $__default["default"](carousels[i]);
	
	      Carousel._jQueryInterface.call($carousel, $carousel.data());
	    }
	  });
	  /**
	   * jQuery
	   */
	
	  $__default["default"].fn[NAME$8] = Carousel._jQueryInterface;
	  $__default["default"].fn[NAME$8].Constructor = Carousel;
	
	  $__default["default"].fn[NAME$8].noConflict = function () {
	    $__default["default"].fn[NAME$8] = JQUERY_NO_CONFLICT$8;
	    return Carousel._jQueryInterface;
	  };
	
	  /**
	   * Constants
	   */
	
	  var NAME$7 = 'collapse';
	  var VERSION$7 = '4.6.2';
	  var DATA_KEY$7 = 'bs.collapse';
	  var EVENT_KEY$7 = "." + DATA_KEY$7;
	  var DATA_API_KEY$4 = '.data-api';
	  var JQUERY_NO_CONFLICT$7 = $__default["default"].fn[NAME$7];
	  var CLASS_NAME_SHOW$6 = 'show';
	  var CLASS_NAME_COLLAPSE = 'collapse';
	  var CLASS_NAME_COLLAPSING = 'collapsing';
	  var CLASS_NAME_COLLAPSED = 'collapsed';
	  var DIMENSION_WIDTH = 'width';
	  var DIMENSION_HEIGHT = 'height';
	  var EVENT_SHOW$4 = "show" + EVENT_KEY$7;
	  var EVENT_SHOWN$4 = "shown" + EVENT_KEY$7;
	  var EVENT_HIDE$4 = "hide" + EVENT_KEY$7;
	  var EVENT_HIDDEN$4 = "hidden" + EVENT_KEY$7;
	  var EVENT_CLICK_DATA_API$3 = "click" + EVENT_KEY$7 + DATA_API_KEY$4;
	  var SELECTOR_ACTIVES = '.show, .collapsing';
	  var SELECTOR_DATA_TOGGLE$3 = '[data-toggle="collapse"]';
	  var Default$6 = {
	    toggle: true,
	    parent: ''
	  };
	  var DefaultType$6 = {
	    toggle: 'boolean',
	    parent: '(string|element)'
	  };
	  /**
	   * Class definition
	   */
	
	  var Collapse = /*#__PURE__*/function () {
	    function Collapse(element, config) {
	      this._isTransitioning = false;
	      this._element = element;
	      this._config = this._getConfig(config);
	      this._triggerArray = [].slice.call(document.querySelectorAll("[data-toggle=\"collapse\"][href=\"#" + element.id + "\"]," + ("[data-toggle=\"collapse\"][data-target=\"#" + element.id + "\"]")));
	      var toggleList = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$3));
	
	      for (var i = 0, len = toggleList.length; i < len; i++) {
	        var elem = toggleList[i];
	        var selector = Util.getSelectorFromElement(elem);
	        var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function (foundElem) {
	          return foundElem === element;
	        });
	
	        if (selector !== null && filterElement.length > 0) {
	          this._selector = selector;
	
	          this._triggerArray.push(elem);
	        }
	      }
	
	      this._parent = this._config.parent ? this._getParent() : null;
	
	      if (!this._config.parent) {
	        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
	      }
	
	      if (this._config.toggle) {
	        this.toggle();
	      }
	    } // Getters
	
	
	    var _proto = Collapse.prototype;
	
	    // Public
	    _proto.toggle = function toggle() {
	      if ($__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) {
	        this.hide();
	      } else {
	        this.show();
	      }
	    };
	
	    _proto.show = function show() {
	      var _this = this;
	
	      if (this._isTransitioning || $__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) {
	        return;
	      }
	
	      var actives;
	      var activesData;
	
	      if (this._parent) {
	        actives = [].slice.call(this._parent.querySelectorAll(SELECTOR_ACTIVES)).filter(function (elem) {
	          if (typeof _this._config.parent === 'string') {
	            return elem.getAttribute('data-parent') === _this._config.parent;
	          }
	
	          return elem.classList.contains(CLASS_NAME_COLLAPSE);
	        });
	
	        if (actives.length === 0) {
	          actives = null;
	        }
	      }
	
	      if (actives) {
	        activesData = $__default["default"](actives).not(this._selector).data(DATA_KEY$7);
	
	        if (activesData && activesData._isTransitioning) {
	          return;
	        }
	      }
	
	      var startEvent = $__default["default"].Event(EVENT_SHOW$4);
	      $__default["default"](this._element).trigger(startEvent);
	
	      if (startEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      if (actives) {
	        Collapse._jQueryInterface.call($__default["default"](actives).not(this._selector), 'hide');
	
	        if (!activesData) {
	          $__default["default"](actives).data(DATA_KEY$7, null);
	        }
	      }
	
	      var dimension = this._getDimension();
	
	      $__default["default"](this._element).removeClass(CLASS_NAME_COLLAPSE).addClass(CLASS_NAME_COLLAPSING);
	      this._element.style[dimension] = 0;
	
	      if (this._triggerArray.length) {
	        $__default["default"](this._triggerArray).removeClass(CLASS_NAME_COLLAPSED).attr('aria-expanded', true);
	      }
	
	      this.setTransitioning(true);
	
	      var complete = function complete() {
	        $__default["default"](_this._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
	        _this._element.style[dimension] = '';
	
	        _this.setTransitioning(false);
	
	        $__default["default"](_this._element).trigger(EVENT_SHOWN$4);
	      };
	
	      var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
	      var scrollSize = "scroll" + capitalizedDimension;
	      var transitionDuration = Util.getTransitionDurationFromElement(this._element);
	      $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	      this._element.style[dimension] = this._element[scrollSize] + "px";
	    };
	
	    _proto.hide = function hide() {
	      var _this2 = this;
	
	      if (this._isTransitioning || !$__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) {
	        return;
	      }
	
	      var startEvent = $__default["default"].Event(EVENT_HIDE$4);
	      $__default["default"](this._element).trigger(startEvent);
	
	      if (startEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      var dimension = this._getDimension();
	
	      this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
	      Util.reflow(this._element);
	      $__default["default"](this._element).addClass(CLASS_NAME_COLLAPSING).removeClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
	      var triggerArrayLength = this._triggerArray.length;
	
	      if (triggerArrayLength > 0) {
	        for (var i = 0; i < triggerArrayLength; i++) {
	          var trigger = this._triggerArray[i];
	          var selector = Util.getSelectorFromElement(trigger);
	
	          if (selector !== null) {
	            var $elem = $__default["default"]([].slice.call(document.querySelectorAll(selector)));
	
	            if (!$elem.hasClass(CLASS_NAME_SHOW$6)) {
	              $__default["default"](trigger).addClass(CLASS_NAME_COLLAPSED).attr('aria-expanded', false);
	            }
	          }
	        }
	      }
	
	      this.setTransitioning(true);
	
	      var complete = function complete() {
	        _this2.setTransitioning(false);
	
	        $__default["default"](_this2._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE).trigger(EVENT_HIDDEN$4);
	      };
	
	      this._element.style[dimension] = '';
	      var transitionDuration = Util.getTransitionDurationFromElement(this._element);
	      $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	    };
	
	    _proto.setTransitioning = function setTransitioning(isTransitioning) {
	      this._isTransitioning = isTransitioning;
	    };
	
	    _proto.dispose = function dispose() {
	      $__default["default"].removeData(this._element, DATA_KEY$7);
	      this._config = null;
	      this._parent = null;
	      this._element = null;
	      this._triggerArray = null;
	      this._isTransitioning = null;
	    } // Private
	    ;
	
	    _proto._getConfig = function _getConfig(config) {
	      config = _extends({}, Default$6, config);
	      config.toggle = Boolean(config.toggle); // Coerce string values
	
	      Util.typeCheckConfig(NAME$7, config, DefaultType$6);
	      return config;
	    };
	
	    _proto._getDimension = function _getDimension() {
	      var hasWidth = $__default["default"](this._element).hasClass(DIMENSION_WIDTH);
	      return hasWidth ? DIMENSION_WIDTH : DIMENSION_HEIGHT;
	    };
	
	    _proto._getParent = function _getParent() {
	      var _this3 = this;
	
	      var parent;
	
	      if (Util.isElement(this._config.parent)) {
	        parent = this._config.parent; // It's a jQuery object
	
	        if (typeof this._config.parent.jquery !== 'undefined') {
	          parent = this._config.parent[0];
	        }
	      } else {
	        parent = document.querySelector(this._config.parent);
	      }
	
	      var selector = "[data-toggle=\"collapse\"][data-parent=\"" + this._config.parent + "\"]";
	      var children = [].slice.call(parent.querySelectorAll(selector));
	      $__default["default"](children).each(function (i, element) {
	        _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
	      });
	      return parent;
	    };
	
	    _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
	      var isOpen = $__default["default"](element).hasClass(CLASS_NAME_SHOW$6);
	
	      if (triggerArray.length) {
	        $__default["default"](triggerArray).toggleClass(CLASS_NAME_COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
	      }
	    } // Static
	    ;
	
	    Collapse._getTargetFromElement = function _getTargetFromElement(element) {
	      var selector = Util.getSelectorFromElement(element);
	      return selector ? document.querySelector(selector) : null;
	    };
	
	    Collapse._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var $element = $__default["default"](this);
	        var data = $element.data(DATA_KEY$7);
	
	        var _config = _extends({}, Default$6, $element.data(), typeof config === 'object' && config ? config : {});
	
	        if (!data && _config.toggle && typeof config === 'string' && /show|hide/.test(config)) {
	          _config.toggle = false;
	        }
	
	        if (!data) {
	          data = new Collapse(this, _config);
	          $element.data(DATA_KEY$7, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config]();
	        }
	      });
	    };
	
	    _createClass(Collapse, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$7;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$6;
	      }
	    }]);
	
	    return Collapse;
	  }();
	  /**
	   * Data API implementation
	   */
	
	
	  $__default["default"](document).on(EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function (event) {
	    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
	    if (event.currentTarget.tagName === 'A') {
	      event.preventDefault();
	    }
	
	    var $trigger = $__default["default"](this);
	    var selector = Util.getSelectorFromElement(this);
	    var selectors = [].slice.call(document.querySelectorAll(selector));
	    $__default["default"](selectors).each(function () {
	      var $target = $__default["default"](this);
	      var data = $target.data(DATA_KEY$7);
	      var config = data ? 'toggle' : $trigger.data();
	
	      Collapse._jQueryInterface.call($target, config);
	    });
	  });
	  /**
	   * jQuery
	   */
	
	  $__default["default"].fn[NAME$7] = Collapse._jQueryInterface;
	  $__default["default"].fn[NAME$7].Constructor = Collapse;
	
	  $__default["default"].fn[NAME$7].noConflict = function () {
	    $__default["default"].fn[NAME$7] = JQUERY_NO_CONFLICT$7;
	    return Collapse._jQueryInterface;
	  };
	
	  /**
	   * Constants
	   */
	
	  var NAME$6 = 'dropdown';
	  var VERSION$6 = '4.6.2';
	  var DATA_KEY$6 = 'bs.dropdown';
	  var EVENT_KEY$6 = "." + DATA_KEY$6;
	  var DATA_API_KEY$3 = '.data-api';
	  var JQUERY_NO_CONFLICT$6 = $__default["default"].fn[NAME$6];
	  var ESCAPE_KEYCODE$1 = 27; // KeyboardEvent.which value for Escape (Esc) key
	
	  var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key
	
	  var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key
	
	  var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
	
	  var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
	
	  var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)
	
	  var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE$1);
	  var CLASS_NAME_DISABLED$1 = 'disabled';
	  var CLASS_NAME_SHOW$5 = 'show';
	  var CLASS_NAME_DROPUP = 'dropup';
	  var CLASS_NAME_DROPRIGHT = 'dropright';
	  var CLASS_NAME_DROPLEFT = 'dropleft';
	  var CLASS_NAME_MENURIGHT = 'dropdown-menu-right';
	  var CLASS_NAME_POSITION_STATIC = 'position-static';
	  var EVENT_HIDE$3 = "hide" + EVENT_KEY$6;
	  var EVENT_HIDDEN$3 = "hidden" + EVENT_KEY$6;
	  var EVENT_SHOW$3 = "show" + EVENT_KEY$6;
	  var EVENT_SHOWN$3 = "shown" + EVENT_KEY$6;
	  var EVENT_CLICK = "click" + EVENT_KEY$6;
	  var EVENT_CLICK_DATA_API$2 = "click" + EVENT_KEY$6 + DATA_API_KEY$3;
	  var EVENT_KEYDOWN_DATA_API = "keydown" + EVENT_KEY$6 + DATA_API_KEY$3;
	  var EVENT_KEYUP_DATA_API = "keyup" + EVENT_KEY$6 + DATA_API_KEY$3;
	  var SELECTOR_DATA_TOGGLE$2 = '[data-toggle="dropdown"]';
	  var SELECTOR_FORM_CHILD = '.dropdown form';
	  var SELECTOR_MENU = '.dropdown-menu';
	  var SELECTOR_NAVBAR_NAV = '.navbar-nav';
	  var SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
	  var PLACEMENT_TOP = 'top-start';
	  var PLACEMENT_TOPEND = 'top-end';
	  var PLACEMENT_BOTTOM = 'bottom-start';
	  var PLACEMENT_BOTTOMEND = 'bottom-end';
	  var PLACEMENT_RIGHT = 'right-start';
	  var PLACEMENT_LEFT = 'left-start';
	  var Default$5 = {
	    offset: 0,
	    flip: true,
	    boundary: 'scrollParent',
	    reference: 'toggle',
	    display: 'dynamic',
	    popperConfig: null
	  };
	  var DefaultType$5 = {
	    offset: '(number|string|function)',
	    flip: 'boolean',
	    boundary: '(string|element)',
	    reference: '(string|element)',
	    display: 'string',
	    popperConfig: '(null|object)'
	  };
	  /**
	   * Class definition
	   */
	
	  var Dropdown = /*#__PURE__*/function () {
	    function Dropdown(element, config) {
	      this._element = element;
	      this._popper = null;
	      this._config = this._getConfig(config);
	      this._menu = this._getMenuElement();
	      this._inNavbar = this._detectNavbar();
	
	      this._addEventListeners();
	    } // Getters
	
	
	    var _proto = Dropdown.prototype;
	
	    // Public
	    _proto.toggle = function toggle() {
	      if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1)) {
	        return;
	      }
	
	      var isActive = $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5);
	
	      Dropdown._clearMenus();
	
	      if (isActive) {
	        return;
	      }
	
	      this.show(true);
	    };
	
	    _proto.show = function show(usePopper) {
	      if (usePopper === void 0) {
	        usePopper = false;
	      }
	
	      if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) {
	        return;
	      }
	
	      var relatedTarget = {
	        relatedTarget: this._element
	      };
	      var showEvent = $__default["default"].Event(EVENT_SHOW$3, relatedTarget);
	
	      var parent = Dropdown._getParentFromElement(this._element);
	
	      $__default["default"](parent).trigger(showEvent);
	
	      if (showEvent.isDefaultPrevented()) {
	        return;
	      } // Totally disable Popper for Dropdowns in Navbar
	
	
	      if (!this._inNavbar && usePopper) {
	        // Check for Popper dependency
	        if (typeof Popper__default["default"] === 'undefined') {
	          throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
	        }
	
	        var referenceElement = this._element;
	
	        if (this._config.reference === 'parent') {
	          referenceElement = parent;
	        } else if (Util.isElement(this._config.reference)) {
	          referenceElement = this._config.reference; // Check if it's jQuery element
	
	          if (typeof this._config.reference.jquery !== 'undefined') {
	            referenceElement = this._config.reference[0];
	          }
	        } // If boundary is not `scrollParent`, then set position to `static`
	        // to allow the menu to "escape" the scroll parent's boundaries
	        // https://github.com/twbs/bootstrap/issues/24251
	
	
	        if (this._config.boundary !== 'scrollParent') {
	          $__default["default"](parent).addClass(CLASS_NAME_POSITION_STATIC);
	        }
	
	        this._popper = new Popper__default["default"](referenceElement, this._menu, this._getPopperConfig());
	      } // If this is a touch-enabled device we add extra
	      // empty mouseover listeners to the body's immediate children;
	      // only needed because of broken event delegation on iOS
	      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	
	
	      if ('ontouchstart' in document.documentElement && $__default["default"](parent).closest(SELECTOR_NAVBAR_NAV).length === 0) {
	        $__default["default"](document.body).children().on('mouseover', null, $__default["default"].noop);
	      }
	
	      this._element.focus();
	
	      this._element.setAttribute('aria-expanded', true);
	
	      $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
	      $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_SHOWN$3, relatedTarget));
	    };
	
	    _proto.hide = function hide() {
	      if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || !$__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) {
	        return;
	      }
	
	      var relatedTarget = {
	        relatedTarget: this._element
	      };
	      var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);
	
	      var parent = Dropdown._getParentFromElement(this._element);
	
	      $__default["default"](parent).trigger(hideEvent);
	
	      if (hideEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      if (this._popper) {
	        this._popper.destroy();
	      }
	
	      $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
	      $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
	    };
	
	    _proto.dispose = function dispose() {
	      $__default["default"].removeData(this._element, DATA_KEY$6);
	      $__default["default"](this._element).off(EVENT_KEY$6);
	      this._element = null;
	      this._menu = null;
	
	      if (this._popper !== null) {
	        this._popper.destroy();
	
	        this._popper = null;
	      }
	    };
	
	    _proto.update = function update() {
	      this._inNavbar = this._detectNavbar();
	
	      if (this._popper !== null) {
	        this._popper.scheduleUpdate();
	      }
	    } // Private
	    ;
	
	    _proto._addEventListeners = function _addEventListeners() {
	      var _this = this;
	
	      $__default["default"](this._element).on(EVENT_CLICK, function (event) {
	        event.preventDefault();
	        event.stopPropagation();
	
	        _this.toggle();
	      });
	    };
	
	    _proto._getConfig = function _getConfig(config) {
	      config = _extends({}, this.constructor.Default, $__default["default"](this._element).data(), config);
	      Util.typeCheckConfig(NAME$6, config, this.constructor.DefaultType);
	      return config;
	    };
	
	    _proto._getMenuElement = function _getMenuElement() {
	      if (!this._menu) {
	        var parent = Dropdown._getParentFromElement(this._element);
	
	        if (parent) {
	          this._menu = parent.querySelector(SELECTOR_MENU);
	        }
	      }
	
	      return this._menu;
	    };
	
	    _proto._getPlacement = function _getPlacement() {
	      var $parentDropdown = $__default["default"](this._element.parentNode);
	      var placement = PLACEMENT_BOTTOM; // Handle dropup
	
	      if ($parentDropdown.hasClass(CLASS_NAME_DROPUP)) {
	        placement = $__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT) ? PLACEMENT_TOPEND : PLACEMENT_TOP;
	      } else if ($parentDropdown.hasClass(CLASS_NAME_DROPRIGHT)) {
	        placement = PLACEMENT_RIGHT;
	      } else if ($parentDropdown.hasClass(CLASS_NAME_DROPLEFT)) {
	        placement = PLACEMENT_LEFT;
	      } else if ($__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT)) {
	        placement = PLACEMENT_BOTTOMEND;
	      }
	
	      return placement;
	    };
	
	    _proto._detectNavbar = function _detectNavbar() {
	      return $__default["default"](this._element).closest('.navbar').length > 0;
	    };
	
	    _proto._getOffset = function _getOffset() {
	      var _this2 = this;
	
	      var offset = {};
	
	      if (typeof this._config.offset === 'function') {
	        offset.fn = function (data) {
	          data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets, _this2._element));
	          return data;
	        };
	      } else {
	        offset.offset = this._config.offset;
	      }
	
	      return offset;
	    };
	
	    _proto._getPopperConfig = function _getPopperConfig() {
	      var popperConfig = {
	        placement: this._getPlacement(),
	        modifiers: {
	          offset: this._getOffset(),
	          flip: {
	            enabled: this._config.flip
	          },
	          preventOverflow: {
	            boundariesElement: this._config.boundary
	          }
	        }
	      }; // Disable Popper if we have a static display
	
	      if (this._config.display === 'static') {
	        popperConfig.modifiers.applyStyle = {
	          enabled: false
	        };
	      }
	
	      return _extends({}, popperConfig, this._config.popperConfig);
	    } // Static
	    ;
	
	    Dropdown._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = $__default["default"](this).data(DATA_KEY$6);
	
	        var _config = typeof config === 'object' ? config : null;
	
	        if (!data) {
	          data = new Dropdown(this, _config);
	          $__default["default"](this).data(DATA_KEY$6, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config]();
	        }
	      });
	    };
	
	    Dropdown._clearMenus = function _clearMenus(event) {
	      if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
	        return;
	      }
	
	      var toggles = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$2));
	
	      for (var i = 0, len = toggles.length; i < len; i++) {
	        var parent = Dropdown._getParentFromElement(toggles[i]);
	
	        var context = $__default["default"](toggles[i]).data(DATA_KEY$6);
	        var relatedTarget = {
	          relatedTarget: toggles[i]
	        };
	
	        if (event && event.type === 'click') {
	          relatedTarget.clickEvent = event;
	        }
	
	        if (!context) {
	          continue;
	        }
	
	        var dropdownMenu = context._menu;
	
	        if (!$__default["default"](parent).hasClass(CLASS_NAME_SHOW$5)) {
	          continue;
	        }
	
	        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && $__default["default"].contains(parent, event.target)) {
	          continue;
	        }
	
	        var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);
	        $__default["default"](parent).trigger(hideEvent);
	
	        if (hideEvent.isDefaultPrevented()) {
	          continue;
	        } // If this is a touch-enabled device we remove the extra
	        // empty mouseover listeners we added for iOS support
	
	
	        if ('ontouchstart' in document.documentElement) {
	          $__default["default"](document.body).children().off('mouseover', null, $__default["default"].noop);
	        }
	
	        toggles[i].setAttribute('aria-expanded', 'false');
	
	        if (context._popper) {
	          context._popper.destroy();
	        }
	
	        $__default["default"](dropdownMenu).removeClass(CLASS_NAME_SHOW$5);
	        $__default["default"](parent).removeClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
	      }
	    };
	
	    Dropdown._getParentFromElement = function _getParentFromElement(element) {
	      var parent;
	      var selector = Util.getSelectorFromElement(element);
	
	      if (selector) {
	        parent = document.querySelector(selector);
	      }
	
	      return parent || element.parentNode;
	    } // eslint-disable-next-line complexity
	    ;
	
	    Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
	      // If not input/textarea:
	      //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
	      // If input/textarea:
	      //  - If space key => not a dropdown command
	      //  - If key is other than escape
	      //    - If key is not up or down => not a dropdown command
	      //    - If trigger inside the menu => not a dropdown command
	      if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE$1 && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $__default["default"](event.target).closest(SELECTOR_MENU).length) : !REGEXP_KEYDOWN.test(event.which)) {
	        return;
	      }
	
	      if (this.disabled || $__default["default"](this).hasClass(CLASS_NAME_DISABLED$1)) {
	        return;
	      }
	
	      var parent = Dropdown._getParentFromElement(this);
	
	      var isActive = $__default["default"](parent).hasClass(CLASS_NAME_SHOW$5);
	
	      if (!isActive && event.which === ESCAPE_KEYCODE$1) {
	        return;
	      }
	
	      event.preventDefault();
	      event.stopPropagation();
	
	      if (!isActive || event.which === ESCAPE_KEYCODE$1 || event.which === SPACE_KEYCODE) {
	        if (event.which === ESCAPE_KEYCODE$1) {
	          $__default["default"](parent.querySelector(SELECTOR_DATA_TOGGLE$2)).trigger('focus');
	        }
	
	        $__default["default"](this).trigger('click');
	        return;
	      }
	
	      var items = [].slice.call(parent.querySelectorAll(SELECTOR_VISIBLE_ITEMS)).filter(function (item) {
	        return $__default["default"](item).is(':visible');
	      });
	
	      if (items.length === 0) {
	        return;
	      }
	
	      var index = items.indexOf(event.target);
	
	      if (event.which === ARROW_UP_KEYCODE && index > 0) {
	        // Up
	        index--;
	      }
	
	      if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
	        // Down
	        index++;
	      }
	
	      if (index < 0) {
	        index = 0;
	      }
	
	      items[index].focus();
	    };
	
	    _createClass(Dropdown, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$6;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$5;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType$5;
	      }
	    }]);
	
	    return Dropdown;
	  }();
	  /**
	   * Data API implementation
	   */
	
	
	  $__default["default"](document).on(EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$2, Dropdown._dataApiKeydownHandler).on(EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown._dataApiKeydownHandler).on(EVENT_CLICK_DATA_API$2 + " " + EVENT_KEYUP_DATA_API, Dropdown._clearMenus).on(EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function (event) {
	    event.preventDefault();
	    event.stopPropagation();
	
	    Dropdown._jQueryInterface.call($__default["default"](this), 'toggle');
	  }).on(EVENT_CLICK_DATA_API$2, SELECTOR_FORM_CHILD, function (e) {
	    e.stopPropagation();
	  });
	  /**
	   * jQuery
	   */
	
	  $__default["default"].fn[NAME$6] = Dropdown._jQueryInterface;
	  $__default["default"].fn[NAME$6].Constructor = Dropdown;
	
	  $__default["default"].fn[NAME$6].noConflict = function () {
	    $__default["default"].fn[NAME$6] = JQUERY_NO_CONFLICT$6;
	    return Dropdown._jQueryInterface;
	  };
	
	  /**
	   * Constants
	   */
	
	  var NAME$5 = 'modal';
	  var VERSION$5 = '4.6.2';
	  var DATA_KEY$5 = 'bs.modal';
	  var EVENT_KEY$5 = "." + DATA_KEY$5;
	  var DATA_API_KEY$2 = '.data-api';
	  var JQUERY_NO_CONFLICT$5 = $__default["default"].fn[NAME$5];
	  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
	
	  var CLASS_NAME_SCROLLABLE = 'modal-dialog-scrollable';
	  var CLASS_NAME_SCROLLBAR_MEASURER = 'modal-scrollbar-measure';
	  var CLASS_NAME_BACKDROP = 'modal-backdrop';
	  var CLASS_NAME_OPEN = 'modal-open';
	  var CLASS_NAME_FADE$4 = 'fade';
	  var CLASS_NAME_SHOW$4 = 'show';
	  var CLASS_NAME_STATIC = 'modal-static';
	  var EVENT_HIDE$2 = "hide" + EVENT_KEY$5;
	  var EVENT_HIDE_PREVENTED = "hidePrevented" + EVENT_KEY$5;
	  var EVENT_HIDDEN$2 = "hidden" + EVENT_KEY$5;
	  var EVENT_SHOW$2 = "show" + EVENT_KEY$5;
	  var EVENT_SHOWN$2 = "shown" + EVENT_KEY$5;
	  var EVENT_FOCUSIN = "focusin" + EVENT_KEY$5;
	  var EVENT_RESIZE = "resize" + EVENT_KEY$5;
	  var EVENT_CLICK_DISMISS$1 = "click.dismiss" + EVENT_KEY$5;
	  var EVENT_KEYDOWN_DISMISS = "keydown.dismiss" + EVENT_KEY$5;
	  var EVENT_MOUSEUP_DISMISS = "mouseup.dismiss" + EVENT_KEY$5;
	  var EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss" + EVENT_KEY$5;
	  var EVENT_CLICK_DATA_API$1 = "click" + EVENT_KEY$5 + DATA_API_KEY$2;
	  var SELECTOR_DIALOG = '.modal-dialog';
	  var SELECTOR_MODAL_BODY = '.modal-body';
	  var SELECTOR_DATA_TOGGLE$1 = '[data-toggle="modal"]';
	  var SELECTOR_DATA_DISMISS$1 = '[data-dismiss="modal"]';
	  var SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
	  var SELECTOR_STICKY_CONTENT = '.sticky-top';
	  var Default$4 = {
	    backdrop: true,
	    keyboard: true,
	    focus: true,
	    show: true
	  };
	  var DefaultType$4 = {
	    backdrop: '(boolean|string)',
	    keyboard: 'boolean',
	    focus: 'boolean',
	    show: 'boolean'
	  };
	  /**
	   * Class definition
	   */
	
	  var Modal = /*#__PURE__*/function () {
	    function Modal(element, config) {
	      this._config = this._getConfig(config);
	      this._element = element;
	      this._dialog = element.querySelector(SELECTOR_DIALOG);
	      this._backdrop = null;
	      this._isShown = false;
	      this._isBodyOverflowing = false;
	      this._ignoreBackdropClick = false;
	      this._isTransitioning = false;
	      this._scrollbarWidth = 0;
	    } // Getters
	
	
	    var _proto = Modal.prototype;
	
	    // Public
	    _proto.toggle = function toggle(relatedTarget) {
	      return this._isShown ? this.hide() : this.show(relatedTarget);
	    };
	
	    _proto.show = function show(relatedTarget) {
	      var _this = this;
	
	      if (this._isShown || this._isTransitioning) {
	        return;
	      }
	
	      var showEvent = $__default["default"].Event(EVENT_SHOW$2, {
	        relatedTarget: relatedTarget
	      });
	      $__default["default"](this._element).trigger(showEvent);
	
	      if (showEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      this._isShown = true;
	
	      if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) {
	        this._isTransitioning = true;
	      }
	
	      this._checkScrollbar();
	
	      this._setScrollbar();
	
	      this._adjustDialog();
	
	      this._setEscapeEvent();
	
	      this._setResizeEvent();
	
	      $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, SELECTOR_DATA_DISMISS$1, function (event) {
	        return _this.hide(event);
	      });
	      $__default["default"](this._dialog).on(EVENT_MOUSEDOWN_DISMISS, function () {
	        $__default["default"](_this._element).one(EVENT_MOUSEUP_DISMISS, function (event) {
	          if ($__default["default"](event.target).is(_this._element)) {
	            _this._ignoreBackdropClick = true;
	          }
	        });
	      });
	
	      this._showBackdrop(function () {
	        return _this._showElement(relatedTarget);
	      });
	    };
	
	    _proto.hide = function hide(event) {
	      var _this2 = this;
	
	      if (event) {
	        event.preventDefault();
	      }
	
	      if (!this._isShown || this._isTransitioning) {
	        return;
	      }
	
	      var hideEvent = $__default["default"].Event(EVENT_HIDE$2);
	      $__default["default"](this._element).trigger(hideEvent);
	
	      if (!this._isShown || hideEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      this._isShown = false;
	      var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);
	
	      if (transition) {
	        this._isTransitioning = true;
	      }
	
	      this._setEscapeEvent();
	
	      this._setResizeEvent();
	
	      $__default["default"](document).off(EVENT_FOCUSIN);
	      $__default["default"](this._element).removeClass(CLASS_NAME_SHOW$4);
	      $__default["default"](this._element).off(EVENT_CLICK_DISMISS$1);
	      $__default["default"](this._dialog).off(EVENT_MOUSEDOWN_DISMISS);
	
	      if (transition) {
	        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
	        $__default["default"](this._element).one(Util.TRANSITION_END, function (event) {
	          return _this2._hideModal(event);
	        }).emulateTransitionEnd(transitionDuration);
	      } else {
	        this._hideModal();
	      }
	    };
	
	    _proto.dispose = function dispose() {
	      [window, this._element, this._dialog].forEach(function (htmlElement) {
	        return $__default["default"](htmlElement).off(EVENT_KEY$5);
	      });
	      /**
	       * `document` has 2 events `EVENT_FOCUSIN` and `EVENT_CLICK_DATA_API`
	       * Do not move `document` in `htmlElements` array
	       * It will remove `EVENT_CLICK_DATA_API` event that should remain
	       */
	
	      $__default["default"](document).off(EVENT_FOCUSIN);
	      $__default["default"].removeData(this._element, DATA_KEY$5);
	      this._config = null;
	      this._element = null;
	      this._dialog = null;
	      this._backdrop = null;
	      this._isShown = null;
	      this._isBodyOverflowing = null;
	      this._ignoreBackdropClick = null;
	      this._isTransitioning = null;
	      this._scrollbarWidth = null;
	    };
	
	    _proto.handleUpdate = function handleUpdate() {
	      this._adjustDialog();
	    } // Private
	    ;
	
	    _proto._getConfig = function _getConfig(config) {
	      config = _extends({}, Default$4, config);
	      Util.typeCheckConfig(NAME$5, config, DefaultType$4);
	      return config;
	    };
	
	    _proto._triggerBackdropTransition = function _triggerBackdropTransition() {
	      var _this3 = this;
	
	      var hideEventPrevented = $__default["default"].Event(EVENT_HIDE_PREVENTED);
	      $__default["default"](this._element).trigger(hideEventPrevented);
	
	      if (hideEventPrevented.isDefaultPrevented()) {
	        return;
	      }
	
	      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
	
	      if (!isModalOverflowing) {
	        this._element.style.overflowY = 'hidden';
	      }
	
	      this._element.classList.add(CLASS_NAME_STATIC);
	
	      var modalTransitionDuration = Util.getTransitionDurationFromElement(this._dialog);
	      $__default["default"](this._element).off(Util.TRANSITION_END);
	      $__default["default"](this._element).one(Util.TRANSITION_END, function () {
	        _this3._element.classList.remove(CLASS_NAME_STATIC);
	
	        if (!isModalOverflowing) {
	          $__default["default"](_this3._element).one(Util.TRANSITION_END, function () {
	            _this3._element.style.overflowY = '';
	          }).emulateTransitionEnd(_this3._element, modalTransitionDuration);
	        }
	      }).emulateTransitionEnd(modalTransitionDuration);
	
	      this._element.focus();
	    };
	
	    _proto._showElement = function _showElement(relatedTarget) {
	      var _this4 = this;
	
	      var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);
	      var modalBody = this._dialog ? this._dialog.querySelector(SELECTOR_MODAL_BODY) : null;
	
	      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
	        // Don't move modal's DOM position
	        document.body.appendChild(this._element);
	      }
	
	      this._element.style.display = 'block';
	
	      this._element.removeAttribute('aria-hidden');
	
	      this._element.setAttribute('aria-modal', true);
	
	      this._element.setAttribute('role', 'dialog');
	
	      if ($__default["default"](this._dialog).hasClass(CLASS_NAME_SCROLLABLE) && modalBody) {
	        modalBody.scrollTop = 0;
	      } else {
	        this._element.scrollTop = 0;
	      }
	
	      if (transition) {
	        Util.reflow(this._element);
	      }
	
	      $__default["default"](this._element).addClass(CLASS_NAME_SHOW$4);
	
	      if (this._config.focus) {
	        this._enforceFocus();
	      }
	
	      var shownEvent = $__default["default"].Event(EVENT_SHOWN$2, {
	        relatedTarget: relatedTarget
	      });
	
	      var transitionComplete = function transitionComplete() {
	        if (_this4._config.focus) {
	          _this4._element.focus();
	        }
	
	        _this4._isTransitioning = false;
	        $__default["default"](_this4._element).trigger(shownEvent);
	      };
	
	      if (transition) {
	        var transitionDuration = Util.getTransitionDurationFromElement(this._dialog);
	        $__default["default"](this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
	      } else {
	        transitionComplete();
	      }
	    };
	
	    _proto._enforceFocus = function _enforceFocus() {
	      var _this5 = this;
	
	      $__default["default"](document).off(EVENT_FOCUSIN) // Guard against infinite focus loop
	      .on(EVENT_FOCUSIN, function (event) {
	        if (document !== event.target && _this5._element !== event.target && $__default["default"](_this5._element).has(event.target).length === 0) {
	          _this5._element.focus();
	        }
	      });
	    };
	
	    _proto._setEscapeEvent = function _setEscapeEvent() {
	      var _this6 = this;
	
	      if (this._isShown) {
	        $__default["default"](this._element).on(EVENT_KEYDOWN_DISMISS, function (event) {
	          if (_this6._config.keyboard && event.which === ESCAPE_KEYCODE) {
	            event.preventDefault();
	
	            _this6.hide();
	          } else if (!_this6._config.keyboard && event.which === ESCAPE_KEYCODE) {
	            _this6._triggerBackdropTransition();
	          }
	        });
	      } else if (!this._isShown) {
	        $__default["default"](this._element).off(EVENT_KEYDOWN_DISMISS);
	      }
	    };
	
	    _proto._setResizeEvent = function _setResizeEvent() {
	      var _this7 = this;
	
	      if (this._isShown) {
	        $__default["default"](window).on(EVENT_RESIZE, function (event) {
	          return _this7.handleUpdate(event);
	        });
	      } else {
	        $__default["default"](window).off(EVENT_RESIZE);
	      }
	    };
	
	    _proto._hideModal = function _hideModal() {
	      var _this8 = this;
	
	      this._element.style.display = 'none';
	
	      this._element.setAttribute('aria-hidden', true);
	
	      this._element.removeAttribute('aria-modal');
	
	      this._element.removeAttribute('role');
	
	      this._isTransitioning = false;
	
	      this._showBackdrop(function () {
	        $__default["default"](document.body).removeClass(CLASS_NAME_OPEN);
	
	        _this8._resetAdjustments();
	
	        _this8._resetScrollbar();
	
	        $__default["default"](_this8._element).trigger(EVENT_HIDDEN$2);
	      });
	    };
	
	    _proto._removeBackdrop = function _removeBackdrop() {
	      if (this._backdrop) {
	        $__default["default"](this._backdrop).remove();
	        this._backdrop = null;
	      }
	    };
	
	    _proto._showBackdrop = function _showBackdrop(callback) {
	      var _this9 = this;
	
	      var animate = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4) ? CLASS_NAME_FADE$4 : '';
	
	      if (this._isShown && this._config.backdrop) {
	        this._backdrop = document.createElement('div');
	        this._backdrop.className = CLASS_NAME_BACKDROP;
	
	        if (animate) {
	          this._backdrop.classList.add(animate);
	        }
	
	        $__default["default"](this._backdrop).appendTo(document.body);
	        $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, function (event) {
	          if (_this9._ignoreBackdropClick) {
	            _this9._ignoreBackdropClick = false;
	            return;
	          }
	
	          if (event.target !== event.currentTarget) {
	            return;
	          }
	
	          if (_this9._config.backdrop === 'static') {
	            _this9._triggerBackdropTransition();
	          } else {
	            _this9.hide();
	          }
	        });
	
	        if (animate) {
	          Util.reflow(this._backdrop);
	        }
	
	        $__default["default"](this._backdrop).addClass(CLASS_NAME_SHOW$4);
	
	        if (!callback) {
	          return;
	        }
	
	        if (!animate) {
	          callback();
	          return;
	        }
	
	        var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
	        $__default["default"](this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
	      } else if (!this._isShown && this._backdrop) {
	        $__default["default"](this._backdrop).removeClass(CLASS_NAME_SHOW$4);
	
	        var callbackRemove = function callbackRemove() {
	          _this9._removeBackdrop();
	
	          if (callback) {
	            callback();
	          }
	        };
	
	        if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) {
	          var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
	
	          $__default["default"](this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
	        } else {
	          callbackRemove();
	        }
	      } else if (callback) {
	        callback();
	      }
	    } // ----------------------------------------------------------------------
	    // the following methods are used to handle overflowing modals
	    // todo (fat): these should probably be refactored out of modal.js
	    // ----------------------------------------------------------------------
	    ;
	
	    _proto._adjustDialog = function _adjustDialog() {
	      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
	
	      if (!this._isBodyOverflowing && isModalOverflowing) {
	        this._element.style.paddingLeft = this._scrollbarWidth + "px";
	      }
	
	      if (this._isBodyOverflowing && !isModalOverflowing) {
	        this._element.style.paddingRight = this._scrollbarWidth + "px";
	      }
	    };
	
	    _proto._resetAdjustments = function _resetAdjustments() {
	      this._element.style.paddingLeft = '';
	      this._element.style.paddingRight = '';
	    };
	
	    _proto._checkScrollbar = function _checkScrollbar() {
	      var rect = document.body.getBoundingClientRect();
	      this._isBodyOverflowing = Math.round(rect.left + rect.right) < window.innerWidth;
	      this._scrollbarWidth = this._getScrollbarWidth();
	    };
	
	    _proto._setScrollbar = function _setScrollbar() {
	      var _this10 = this;
	
	      if (this._isBodyOverflowing) {
	        // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
	        //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
	        var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
	        var stickyContent = [].slice.call(document.querySelectorAll(SELECTOR_STICKY_CONTENT)); // Adjust fixed content padding
	
	        $__default["default"](fixedContent).each(function (index, element) {
	          var actualPadding = element.style.paddingRight;
	          var calculatedPadding = $__default["default"](element).css('padding-right');
	          $__default["default"](element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this10._scrollbarWidth + "px");
	        }); // Adjust sticky content margin
	
	        $__default["default"](stickyContent).each(function (index, element) {
	          var actualMargin = element.style.marginRight;
	          var calculatedMargin = $__default["default"](element).css('margin-right');
	          $__default["default"](element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this10._scrollbarWidth + "px");
	        }); // Adjust body padding
	
	        var actualPadding = document.body.style.paddingRight;
	        var calculatedPadding = $__default["default"](document.body).css('padding-right');
	        $__default["default"](document.body).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
	      }
	
	      $__default["default"](document.body).addClass(CLASS_NAME_OPEN);
	    };
	
	    _proto._resetScrollbar = function _resetScrollbar() {
	      // Restore fixed content padding
	      var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
	      $__default["default"](fixedContent).each(function (index, element) {
	        var padding = $__default["default"](element).data('padding-right');
	        $__default["default"](element).removeData('padding-right');
	        element.style.paddingRight = padding ? padding : '';
	      }); // Restore sticky content
	
	      var elements = [].slice.call(document.querySelectorAll("" + SELECTOR_STICKY_CONTENT));
	      $__default["default"](elements).each(function (index, element) {
	        var margin = $__default["default"](element).data('margin-right');
	
	        if (typeof margin !== 'undefined') {
	          $__default["default"](element).css('margin-right', margin).removeData('margin-right');
	        }
	      }); // Restore body padding
	
	      var padding = $__default["default"](document.body).data('padding-right');
	      $__default["default"](document.body).removeData('padding-right');
	      document.body.style.paddingRight = padding ? padding : '';
	    };
	
	    _proto._getScrollbarWidth = function _getScrollbarWidth() {
	      // thx d.walsh
	      var scrollDiv = document.createElement('div');
	      scrollDiv.className = CLASS_NAME_SCROLLBAR_MEASURER;
	      document.body.appendChild(scrollDiv);
	      var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	      return scrollbarWidth;
	    } // Static
	    ;
	
	    Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
	      return this.each(function () {
	        var data = $__default["default"](this).data(DATA_KEY$5);
	
	        var _config = _extends({}, Default$4, $__default["default"](this).data(), typeof config === 'object' && config ? config : {});
	
	        if (!data) {
	          data = new Modal(this, _config);
	          $__default["default"](this).data(DATA_KEY$5, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config](relatedTarget);
	        } else if (_config.show) {
	          data.show(relatedTarget);
	        }
	      });
	    };
	
	    _createClass(Modal, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$5;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$4;
	      }
	    }]);
	
	    return Modal;
	  }();
	  /**
	   * Data API implementation
	   */
	
	
	  $__default["default"](document).on(EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function (event) {
	    var _this11 = this;
	
	    var target;
	    var selector = Util.getSelectorFromElement(this);
	
	    if (selector) {
	      target = document.querySelector(selector);
	    }
	
	    var config = $__default["default"](target).data(DATA_KEY$5) ? 'toggle' : _extends({}, $__default["default"](target).data(), $__default["default"](this).data());
	
	    if (this.tagName === 'A' || this.tagName === 'AREA') {
	      event.preventDefault();
	    }
	
	    var $target = $__default["default"](target).one(EVENT_SHOW$2, function (showEvent) {
	      if (showEvent.isDefaultPrevented()) {
	        // Only register focus restorer if modal will actually get shown
	        return;
	      }
	
	      $target.one(EVENT_HIDDEN$2, function () {
	        if ($__default["default"](_this11).is(':visible')) {
	          _this11.focus();
	        }
	      });
	    });
	
	    Modal._jQueryInterface.call($__default["default"](target), config, this);
	  });
	  /**
	   * jQuery
	   */
	
	  $__default["default"].fn[NAME$5] = Modal._jQueryInterface;
	  $__default["default"].fn[NAME$5].Constructor = Modal;
	
	  $__default["default"].fn[NAME$5].noConflict = function () {
	    $__default["default"].fn[NAME$5] = JQUERY_NO_CONFLICT$5;
	    return Modal._jQueryInterface;
	  };
	
	  /**
	   * --------------------------------------------------------------------------
	   * Bootstrap (v4.6.2): tools/sanitizer.js
	   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
	   * --------------------------------------------------------------------------
	   */
	  var uriAttrs = ['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href'];
	  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
	  var DefaultWhitelist = {
	    // Global attributes allowed on any supplied element below.
	    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
	    a: ['target', 'href', 'title', 'rel'],
	    area: [],
	    b: [],
	    br: [],
	    col: [],
	    code: [],
	    div: [],
	    em: [],
	    hr: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    i: [],
	    img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
	    li: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    small: [],
	    span: [],
	    sub: [],
	    sup: [],
	    strong: [],
	    u: [],
	    ul: []
	  };
	  /**
	   * A pattern that recognizes a commonly useful subset of URLs that are safe.
	   *
	   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
	   */
	
	  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i;
	  /**
	   * A pattern that matches safe data URLs. Only matches image, video and audio types.
	   *
	   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
	   */
	
	  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;
	
	  function allowedAttribute(attr, allowedAttributeList) {
	    var attrName = attr.nodeName.toLowerCase();
	
	    if (allowedAttributeList.indexOf(attrName) !== -1) {
	      if (uriAttrs.indexOf(attrName) !== -1) {
	        return Boolean(SAFE_URL_PATTERN.test(attr.nodeValue) || DATA_URL_PATTERN.test(attr.nodeValue));
	      }
	
	      return true;
	    }
	
	    var regExp = allowedAttributeList.filter(function (attrRegex) {
	      return attrRegex instanceof RegExp;
	    }); // Check if a regular expression validates the attribute.
	
	    for (var i = 0, len = regExp.length; i < len; i++) {
	      if (regExp[i].test(attrName)) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
	    if (unsafeHtml.length === 0) {
	      return unsafeHtml;
	    }
	
	    if (sanitizeFn && typeof sanitizeFn === 'function') {
	      return sanitizeFn(unsafeHtml);
	    }
	
	    var domParser = new window.DOMParser();
	    var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
	    var whitelistKeys = Object.keys(whiteList);
	    var elements = [].slice.call(createdDocument.body.querySelectorAll('*'));
	
	    var _loop = function _loop(i, len) {
	      var el = elements[i];
	      var elName = el.nodeName.toLowerCase();
	
	      if (whitelistKeys.indexOf(el.nodeName.toLowerCase()) === -1) {
	        el.parentNode.removeChild(el);
	        return "continue";
	      }
	
	      var attributeList = [].slice.call(el.attributes); // eslint-disable-next-line unicorn/prefer-spread
	
	      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);
	      attributeList.forEach(function (attr) {
	        if (!allowedAttribute(attr, whitelistedAttributes)) {
	          el.removeAttribute(attr.nodeName);
	        }
	      });
	    };
	
	    for (var i = 0, len = elements.length; i < len; i++) {
	      var _ret = _loop(i);
	
	      if (_ret === "continue") continue;
	    }
	
	    return createdDocument.body.innerHTML;
	  }
	
	  /**
	   * Constants
	   */
	
	  var NAME$4 = 'tooltip';
	  var VERSION$4 = '4.6.2';
	  var DATA_KEY$4 = 'bs.tooltip';
	  var EVENT_KEY$4 = "." + DATA_KEY$4;
	  var JQUERY_NO_CONFLICT$4 = $__default["default"].fn[NAME$4];
	  var CLASS_PREFIX$1 = 'bs-tooltip';
	  var BSCLS_PREFIX_REGEX$1 = new RegExp("(^|\\s)" + CLASS_PREFIX$1 + "\\S+", 'g');
	  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];
	  var CLASS_NAME_FADE$3 = 'fade';
	  var CLASS_NAME_SHOW$3 = 'show';
	  var HOVER_STATE_SHOW = 'show';
	  var HOVER_STATE_OUT = 'out';
	  var SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
	  var SELECTOR_ARROW = '.arrow';
	  var TRIGGER_HOVER = 'hover';
	  var TRIGGER_FOCUS = 'focus';
	  var TRIGGER_CLICK = 'click';
	  var TRIGGER_MANUAL = 'manual';
	  var AttachmentMap = {
	    AUTO: 'auto',
	    TOP: 'top',
	    RIGHT: 'right',
	    BOTTOM: 'bottom',
	    LEFT: 'left'
	  };
	  var Default$3 = {
	    animation: true,
	    template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    selector: false,
	    placement: 'top',
	    offset: 0,
	    container: false,
	    fallbackPlacement: 'flip',
	    boundary: 'scrollParent',
	    customClass: '',
	    sanitize: true,
	    sanitizeFn: null,
	    whiteList: DefaultWhitelist,
	    popperConfig: null
	  };
	  var DefaultType$3 = {
	    animation: 'boolean',
	    template: 'string',
	    title: '(string|element|function)',
	    trigger: 'string',
	    delay: '(number|object)',
	    html: 'boolean',
	    selector: '(string|boolean)',
	    placement: '(string|function)',
	    offset: '(number|string|function)',
	    container: '(string|element|boolean)',
	    fallbackPlacement: '(string|array)',
	    boundary: '(string|element)',
	    customClass: '(string|function)',
	    sanitize: 'boolean',
	    sanitizeFn: '(null|function)',
	    whiteList: 'object',
	    popperConfig: '(null|object)'
	  };
	  var Event$1 = {
	    HIDE: "hide" + EVENT_KEY$4,
	    HIDDEN: "hidden" + EVENT_KEY$4,
	    SHOW: "show" + EVENT_KEY$4,
	    SHOWN: "shown" + EVENT_KEY$4,
	    INSERTED: "inserted" + EVENT_KEY$4,
	    CLICK: "click" + EVENT_KEY$4,
	    FOCUSIN: "focusin" + EVENT_KEY$4,
	    FOCUSOUT: "focusout" + EVENT_KEY$4,
	    MOUSEENTER: "mouseenter" + EVENT_KEY$4,
	    MOUSELEAVE: "mouseleave" + EVENT_KEY$4
	  };
	  /**
	   * Class definition
	   */
	
	  var Tooltip = /*#__PURE__*/function () {
	    function Tooltip(element, config) {
	      if (typeof Popper__default["default"] === 'undefined') {
	        throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
	      } // Private
	
	
	      this._isEnabled = true;
	      this._timeout = 0;
	      this._hoverState = '';
	      this._activeTrigger = {};
	      this._popper = null; // Protected
	
	      this.element = element;
	      this.config = this._getConfig(config);
	      this.tip = null;
	
	      this._setListeners();
	    } // Getters
	
	
	    var _proto = Tooltip.prototype;
	
	    // Public
	    _proto.enable = function enable() {
	      this._isEnabled = true;
	    };
	
	    _proto.disable = function disable() {
	      this._isEnabled = false;
	    };
	
	    _proto.toggleEnabled = function toggleEnabled() {
	      this._isEnabled = !this._isEnabled;
	    };
	
	    _proto.toggle = function toggle(event) {
	      if (!this._isEnabled) {
	        return;
	      }
	
	      if (event) {
	        var dataKey = this.constructor.DATA_KEY;
	        var context = $__default["default"](event.currentTarget).data(dataKey);
	
	        if (!context) {
	          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
	          $__default["default"](event.currentTarget).data(dataKey, context);
	        }
	
	        context._activeTrigger.click = !context._activeTrigger.click;
	
	        if (context._isWithActiveTrigger()) {
	          context._enter(null, context);
	        } else {
	          context._leave(null, context);
	        }
	      } else {
	        if ($__default["default"](this.getTipElement()).hasClass(CLASS_NAME_SHOW$3)) {
	          this._leave(null, this);
	
	          return;
	        }
	
	        this._enter(null, this);
	      }
	    };
	
	    _proto.dispose = function dispose() {
	      clearTimeout(this._timeout);
	      $__default["default"].removeData(this.element, this.constructor.DATA_KEY);
	      $__default["default"](this.element).off(this.constructor.EVENT_KEY);
	      $__default["default"](this.element).closest('.modal').off('hide.bs.modal', this._hideModalHandler);
	
	      if (this.tip) {
	        $__default["default"](this.tip).remove();
	      }
	
	      this._isEnabled = null;
	      this._timeout = null;
	      this._hoverState = null;
	      this._activeTrigger = null;
	
	      if (this._popper) {
	        this._popper.destroy();
	      }
	
	      this._popper = null;
	      this.element = null;
	      this.config = null;
	      this.tip = null;
	    };
	
	    _proto.show = function show() {
	      var _this = this;
	
	      if ($__default["default"](this.element).css('display') === 'none') {
	        throw new Error('Please use show on visible elements');
	      }
	
	      var showEvent = $__default["default"].Event(this.constructor.Event.SHOW);
	
	      if (this.isWithContent() && this._isEnabled) {
	        $__default["default"](this.element).trigger(showEvent);
	        var shadowRoot = Util.findShadowRoot(this.element);
	        var isInTheDom = $__default["default"].contains(shadowRoot !== null ? shadowRoot : this.element.ownerDocument.documentElement, this.element);
	
	        if (showEvent.isDefaultPrevented() || !isInTheDom) {
	          return;
	        }
	
	        var tip = this.getTipElement();
	        var tipId = Util.getUID(this.constructor.NAME);
	        tip.setAttribute('id', tipId);
	        this.element.setAttribute('aria-describedby', tipId);
	        this.setContent();
	
	        if (this.config.animation) {
	          $__default["default"](tip).addClass(CLASS_NAME_FADE$3);
	        }
	
	        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;
	
	        var attachment = this._getAttachment(placement);
	
	        this.addAttachmentClass(attachment);
	
	        var container = this._getContainer();
	
	        $__default["default"](tip).data(this.constructor.DATA_KEY, this);
	
	        if (!$__default["default"].contains(this.element.ownerDocument.documentElement, this.tip)) {
	          $__default["default"](tip).appendTo(container);
	        }
	
	        $__default["default"](this.element).trigger(this.constructor.Event.INSERTED);
	        this._popper = new Popper__default["default"](this.element, tip, this._getPopperConfig(attachment));
	        $__default["default"](tip).addClass(CLASS_NAME_SHOW$3);
	        $__default["default"](tip).addClass(this.config.customClass); // If this is a touch-enabled device we add extra
	        // empty mouseover listeners to the body's immediate children;
	        // only needed because of broken event delegation on iOS
	        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	
	        if ('ontouchstart' in document.documentElement) {
	          $__default["default"](document.body).children().on('mouseover', null, $__default["default"].noop);
	        }
	
	        var complete = function complete() {
	          if (_this.config.animation) {
	            _this._fixTransition();
	          }
	
	          var prevHoverState = _this._hoverState;
	          _this._hoverState = null;
	          $__default["default"](_this.element).trigger(_this.constructor.Event.SHOWN);
	
	          if (prevHoverState === HOVER_STATE_OUT) {
	            _this._leave(null, _this);
	          }
	        };
	
	        if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
	          var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
	          $__default["default"](this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	        } else {
	          complete();
	        }
	      }
	    };
	
	    _proto.hide = function hide(callback) {
	      var _this2 = this;
	
	      var tip = this.getTipElement();
	      var hideEvent = $__default["default"].Event(this.constructor.Event.HIDE);
	
	      var complete = function complete() {
	        if (_this2._hoverState !== HOVER_STATE_SHOW && tip.parentNode) {
	          tip.parentNode.removeChild(tip);
	        }
	
	        _this2._cleanTipClass();
	
	        _this2.element.removeAttribute('aria-describedby');
	
	        $__default["default"](_this2.element).trigger(_this2.constructor.Event.HIDDEN);
	
	        if (_this2._popper !== null) {
	          _this2._popper.destroy();
	        }
	
	        if (callback) {
	          callback();
	        }
	      };
	
	      $__default["default"](this.element).trigger(hideEvent);
	
	      if (hideEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      $__default["default"](tip).removeClass(CLASS_NAME_SHOW$3); // If this is a touch-enabled device we remove the extra
	      // empty mouseover listeners we added for iOS support
	
	      if ('ontouchstart' in document.documentElement) {
	        $__default["default"](document.body).children().off('mouseover', null, $__default["default"].noop);
	      }
	
	      this._activeTrigger[TRIGGER_CLICK] = false;
	      this._activeTrigger[TRIGGER_FOCUS] = false;
	      this._activeTrigger[TRIGGER_HOVER] = false;
	
	      if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
	        var transitionDuration = Util.getTransitionDurationFromElement(tip);
	        $__default["default"](tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	      } else {
	        complete();
	      }
	
	      this._hoverState = '';
	    };
	
	    _proto.update = function update() {
	      if (this._popper !== null) {
	        this._popper.scheduleUpdate();
	      }
	    } // Protected
	    ;
	
	    _proto.isWithContent = function isWithContent() {
	      return Boolean(this.getTitle());
	    };
	
	    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
	      $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX$1 + "-" + attachment);
	    };
	
	    _proto.getTipElement = function getTipElement() {
	      this.tip = this.tip || $__default["default"](this.config.template)[0];
	      return this.tip;
	    };
	
	    _proto.setContent = function setContent() {
	      var tip = this.getTipElement();
	      this.setElementContent($__default["default"](tip.querySelectorAll(SELECTOR_TOOLTIP_INNER)), this.getTitle());
	      $__default["default"](tip).removeClass(CLASS_NAME_FADE$3 + " " + CLASS_NAME_SHOW$3);
	    };
	
	    _proto.setElementContent = function setElementContent($element, content) {
	      if (typeof content === 'object' && (content.nodeType || content.jquery)) {
	        // Content is a DOM node or a jQuery
	        if (this.config.html) {
	          if (!$__default["default"](content).parent().is($element)) {
	            $element.empty().append(content);
	          }
	        } else {
	          $element.text($__default["default"](content).text());
	        }
	
	        return;
	      }
	
	      if (this.config.html) {
	        if (this.config.sanitize) {
	          content = sanitizeHtml(content, this.config.whiteList, this.config.sanitizeFn);
	        }
	
	        $element.html(content);
	      } else {
	        $element.text(content);
	      }
	    };
	
	    _proto.getTitle = function getTitle() {
	      var title = this.element.getAttribute('data-original-title');
	
	      if (!title) {
	        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
	      }
	
	      return title;
	    } // Private
	    ;
	
	    _proto._getPopperConfig = function _getPopperConfig(attachment) {
	      var _this3 = this;
	
	      var defaultBsConfig = {
	        placement: attachment,
	        modifiers: {
	          offset: this._getOffset(),
	          flip: {
	            behavior: this.config.fallbackPlacement
	          },
	          arrow: {
	            element: SELECTOR_ARROW
	          },
	          preventOverflow: {
	            boundariesElement: this.config.boundary
	          }
	        },
	        onCreate: function onCreate(data) {
	          if (data.originalPlacement !== data.placement) {
	            _this3._handlePopperPlacementChange(data);
	          }
	        },
	        onUpdate: function onUpdate(data) {
	          return _this3._handlePopperPlacementChange(data);
	        }
	      };
	      return _extends({}, defaultBsConfig, this.config.popperConfig);
	    };
	
	    _proto._getOffset = function _getOffset() {
	      var _this4 = this;
	
	      var offset = {};
	
	      if (typeof this.config.offset === 'function') {
	        offset.fn = function (data) {
	          data.offsets = _extends({}, data.offsets, _this4.config.offset(data.offsets, _this4.element));
	          return data;
	        };
	      } else {
	        offset.offset = this.config.offset;
	      }
	
	      return offset;
	    };
	
	    _proto._getContainer = function _getContainer() {
	      if (this.config.container === false) {
	        return document.body;
	      }
	
	      if (Util.isElement(this.config.container)) {
	        return $__default["default"](this.config.container);
	      }
	
	      return $__default["default"](document).find(this.config.container);
	    };
	
	    _proto._getAttachment = function _getAttachment(placement) {
	      return AttachmentMap[placement.toUpperCase()];
	    };
	
	    _proto._setListeners = function _setListeners() {
	      var _this5 = this;
	
	      var triggers = this.config.trigger.split(' ');
	      triggers.forEach(function (trigger) {
	        if (trigger === 'click') {
	          $__default["default"](_this5.element).on(_this5.constructor.Event.CLICK, _this5.config.selector, function (event) {
	            return _this5.toggle(event);
	          });
	        } else if (trigger !== TRIGGER_MANUAL) {
	          var eventIn = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSEENTER : _this5.constructor.Event.FOCUSIN;
	          var eventOut = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSELEAVE : _this5.constructor.Event.FOCUSOUT;
	          $__default["default"](_this5.element).on(eventIn, _this5.config.selector, function (event) {
	            return _this5._enter(event);
	          }).on(eventOut, _this5.config.selector, function (event) {
	            return _this5._leave(event);
	          });
	        }
	      });
	
	      this._hideModalHandler = function () {
	        if (_this5.element) {
	          _this5.hide();
	        }
	      };
	
	      $__default["default"](this.element).closest('.modal').on('hide.bs.modal', this._hideModalHandler);
	
	      if (this.config.selector) {
	        this.config = _extends({}, this.config, {
	          trigger: 'manual',
	          selector: ''
	        });
	      } else {
	        this._fixTitle();
	      }
	    };
	
	    _proto._fixTitle = function _fixTitle() {
	      var titleType = typeof this.element.getAttribute('data-original-title');
	
	      if (this.element.getAttribute('title') || titleType !== 'string') {
	        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
	        this.element.setAttribute('title', '');
	      }
	    };
	
	    _proto._enter = function _enter(event, context) {
	      var dataKey = this.constructor.DATA_KEY;
	      context = context || $__default["default"](event.currentTarget).data(dataKey);
	
	      if (!context) {
	        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
	        $__default["default"](event.currentTarget).data(dataKey, context);
	      }
	
	      if (event) {
	        context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
	      }
	
	      if ($__default["default"](context.getTipElement()).hasClass(CLASS_NAME_SHOW$3) || context._hoverState === HOVER_STATE_SHOW) {
	        context._hoverState = HOVER_STATE_SHOW;
	        return;
	      }
	
	      clearTimeout(context._timeout);
	      context._hoverState = HOVER_STATE_SHOW;
	
	      if (!context.config.delay || !context.config.delay.show) {
	        context.show();
	        return;
	      }
	
	      context._timeout = setTimeout(function () {
	        if (context._hoverState === HOVER_STATE_SHOW) {
	          context.show();
	        }
	      }, context.config.delay.show);
	    };
	
	    _proto._leave = function _leave(event, context) {
	      var dataKey = this.constructor.DATA_KEY;
	      context = context || $__default["default"](event.currentTarget).data(dataKey);
	
	      if (!context) {
	        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
	        $__default["default"](event.currentTarget).data(dataKey, context);
	      }
	
	      if (event) {
	        context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = false;
	      }
	
	      if (context._isWithActiveTrigger()) {
	        return;
	      }
	
	      clearTimeout(context._timeout);
	      context._hoverState = HOVER_STATE_OUT;
	
	      if (!context.config.delay || !context.config.delay.hide) {
	        context.hide();
	        return;
	      }
	
	      context._timeout = setTimeout(function () {
	        if (context._hoverState === HOVER_STATE_OUT) {
	          context.hide();
	        }
	      }, context.config.delay.hide);
	    };
	
	    _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
	      for (var trigger in this._activeTrigger) {
	        if (this._activeTrigger[trigger]) {
	          return true;
	        }
	      }
	
	      return false;
	    };
	
	    _proto._getConfig = function _getConfig(config) {
	      var dataAttributes = $__default["default"](this.element).data();
	      Object.keys(dataAttributes).forEach(function (dataAttr) {
	        if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) {
	          delete dataAttributes[dataAttr];
	        }
	      });
	      config = _extends({}, this.constructor.Default, dataAttributes, typeof config === 'object' && config ? config : {});
	
	      if (typeof config.delay === 'number') {
	        config.delay = {
	          show: config.delay,
	          hide: config.delay
	        };
	      }
	
	      if (typeof config.title === 'number') {
	        config.title = config.title.toString();
	      }
	
	      if (typeof config.content === 'number') {
	        config.content = config.content.toString();
	      }
	
	      Util.typeCheckConfig(NAME$4, config, this.constructor.DefaultType);
	
	      if (config.sanitize) {
	        config.template = sanitizeHtml(config.template, config.whiteList, config.sanitizeFn);
	      }
	
	      return config;
	    };
	
	    _proto._getDelegateConfig = function _getDelegateConfig() {
	      var config = {};
	
	      if (this.config) {
	        for (var key in this.config) {
	          if (this.constructor.Default[key] !== this.config[key]) {
	            config[key] = this.config[key];
	          }
	        }
	      }
	
	      return config;
	    };
	
	    _proto._cleanTipClass = function _cleanTipClass() {
	      var $tip = $__default["default"](this.getTipElement());
	      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX$1);
	
	      if (tabClass !== null && tabClass.length) {
	        $tip.removeClass(tabClass.join(''));
	      }
	    };
	
	    _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
	      this.tip = popperData.instance.popper;
	
	      this._cleanTipClass();
	
	      this.addAttachmentClass(this._getAttachment(popperData.placement));
	    };
	
	    _proto._fixTransition = function _fixTransition() {
	      var tip = this.getTipElement();
	      var initConfigAnimation = this.config.animation;
	
	      if (tip.getAttribute('x-placement') !== null) {
	        return;
	      }
	
	      $__default["default"](tip).removeClass(CLASS_NAME_FADE$3);
	      this.config.animation = false;
	      this.hide();
	      this.show();
	      this.config.animation = initConfigAnimation;
	    } // Static
	    ;
	
	    Tooltip._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var $element = $__default["default"](this);
	        var data = $element.data(DATA_KEY$4);
	
	        var _config = typeof config === 'object' && config;
	
	        if (!data && /dispose|hide/.test(config)) {
	          return;
	        }
	
	        if (!data) {
	          data = new Tooltip(this, _config);
	          $element.data(DATA_KEY$4, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config]();
	        }
	      });
	    };
	
	    _createClass(Tooltip, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$4;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$3;
	      }
	    }, {
	      key: "NAME",
	      get: function get() {
	        return NAME$4;
	      }
	    }, {
	      key: "DATA_KEY",
	      get: function get() {
	        return DATA_KEY$4;
	      }
	    }, {
	      key: "Event",
	      get: function get() {
	        return Event$1;
	      }
	    }, {
	      key: "EVENT_KEY",
	      get: function get() {
	        return EVENT_KEY$4;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType$3;
	      }
	    }]);
	
	    return Tooltip;
	  }();
	  /**
	   * jQuery
	   */
	
	
	  $__default["default"].fn[NAME$4] = Tooltip._jQueryInterface;
	  $__default["default"].fn[NAME$4].Constructor = Tooltip;
	
	  $__default["default"].fn[NAME$4].noConflict = function () {
	    $__default["default"].fn[NAME$4] = JQUERY_NO_CONFLICT$4;
	    return Tooltip._jQueryInterface;
	  };
	
	  /**
	   * Constants
	   */
	
	  var NAME$3 = 'popover';
	  var VERSION$3 = '4.6.2';
	  var DATA_KEY$3 = 'bs.popover';
	  var EVENT_KEY$3 = "." + DATA_KEY$3;
	  var JQUERY_NO_CONFLICT$3 = $__default["default"].fn[NAME$3];
	  var CLASS_PREFIX = 'bs-popover';
	  var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
	  var CLASS_NAME_FADE$2 = 'fade';
	  var CLASS_NAME_SHOW$2 = 'show';
	  var SELECTOR_TITLE = '.popover-header';
	  var SELECTOR_CONTENT = '.popover-body';
	
	  var Default$2 = _extends({}, Tooltip.Default, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
	  });
	
	  var DefaultType$2 = _extends({}, Tooltip.DefaultType, {
	    content: '(string|element|function)'
	  });
	
	  var Event = {
	    HIDE: "hide" + EVENT_KEY$3,
	    HIDDEN: "hidden" + EVENT_KEY$3,
	    SHOW: "show" + EVENT_KEY$3,
	    SHOWN: "shown" + EVENT_KEY$3,
	    INSERTED: "inserted" + EVENT_KEY$3,
	    CLICK: "click" + EVENT_KEY$3,
	    FOCUSIN: "focusin" + EVENT_KEY$3,
	    FOCUSOUT: "focusout" + EVENT_KEY$3,
	    MOUSEENTER: "mouseenter" + EVENT_KEY$3,
	    MOUSELEAVE: "mouseleave" + EVENT_KEY$3
	  };
	  /**
	   * Class definition
	   */
	
	  var Popover = /*#__PURE__*/function (_Tooltip) {
	    _inheritsLoose(Popover, _Tooltip);
	
	    function Popover() {
	      return _Tooltip.apply(this, arguments) || this;
	    }
	
	    var _proto = Popover.prototype;
	
	    // Overrides
	    _proto.isWithContent = function isWithContent() {
	      return this.getTitle() || this._getContent();
	    };
	
	    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
	      $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
	    };
	
	    _proto.getTipElement = function getTipElement() {
	      this.tip = this.tip || $__default["default"](this.config.template)[0];
	      return this.tip;
	    };
	
	    _proto.setContent = function setContent() {
	      var $tip = $__default["default"](this.getTipElement()); // We use append for html objects to maintain js events
	
	      this.setElementContent($tip.find(SELECTOR_TITLE), this.getTitle());
	
	      var content = this._getContent();
	
	      if (typeof content === 'function') {
	        content = content.call(this.element);
	      }
	
	      this.setElementContent($tip.find(SELECTOR_CONTENT), content);
	      $tip.removeClass(CLASS_NAME_FADE$2 + " " + CLASS_NAME_SHOW$2);
	    } // Private
	    ;
	
	    _proto._getContent = function _getContent() {
	      return this.element.getAttribute('data-content') || this.config.content;
	    };
	
	    _proto._cleanTipClass = function _cleanTipClass() {
	      var $tip = $__default["default"](this.getTipElement());
	      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);
	
	      if (tabClass !== null && tabClass.length > 0) {
	        $tip.removeClass(tabClass.join(''));
	      }
	    } // Static
	    ;
	
	    Popover._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = $__default["default"](this).data(DATA_KEY$3);
	
	        var _config = typeof config === 'object' ? config : null;
	
	        if (!data && /dispose|hide/.test(config)) {
	          return;
	        }
	
	        if (!data) {
	          data = new Popover(this, _config);
	          $__default["default"](this).data(DATA_KEY$3, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config]();
	        }
	      });
	    };
	
	    _createClass(Popover, null, [{
	      key: "VERSION",
	      get: // Getters
	      function get() {
	        return VERSION$3;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$2;
	      }
	    }, {
	      key: "NAME",
	      get: function get() {
	        return NAME$3;
	      }
	    }, {
	      key: "DATA_KEY",
	      get: function get() {
	        return DATA_KEY$3;
	      }
	    }, {
	      key: "Event",
	      get: function get() {
	        return Event;
	      }
	    }, {
	      key: "EVENT_KEY",
	      get: function get() {
	        return EVENT_KEY$3;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType$2;
	      }
	    }]);
	
	    return Popover;
	  }(Tooltip);
	  /**
	   * jQuery
	   */
	
	
	  $__default["default"].fn[NAME$3] = Popover._jQueryInterface;
	  $__default["default"].fn[NAME$3].Constructor = Popover;
	
	  $__default["default"].fn[NAME$3].noConflict = function () {
	    $__default["default"].fn[NAME$3] = JQUERY_NO_CONFLICT$3;
	    return Popover._jQueryInterface;
	  };
	
	  /**
	   * Constants
	   */
	
	  var NAME$2 = 'scrollspy';
	  var VERSION$2 = '4.6.2';
	  var DATA_KEY$2 = 'bs.scrollspy';
	  var EVENT_KEY$2 = "." + DATA_KEY$2;
	  var DATA_API_KEY$1 = '.data-api';
	  var JQUERY_NO_CONFLICT$2 = $__default["default"].fn[NAME$2];
	  var CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
	  var CLASS_NAME_ACTIVE$1 = 'active';
	  var EVENT_ACTIVATE = "activate" + EVENT_KEY$2;
	  var EVENT_SCROLL = "scroll" + EVENT_KEY$2;
	  var EVENT_LOAD_DATA_API = "load" + EVENT_KEY$2 + DATA_API_KEY$1;
	  var METHOD_OFFSET = 'offset';
	  var METHOD_POSITION = 'position';
	  var SELECTOR_DATA_SPY = '[data-spy="scroll"]';
	  var SELECTOR_NAV_LIST_GROUP$1 = '.nav, .list-group';
	  var SELECTOR_NAV_LINKS = '.nav-link';
	  var SELECTOR_NAV_ITEMS = '.nav-item';
	  var SELECTOR_LIST_ITEMS = '.list-group-item';
	  var SELECTOR_DROPDOWN$1 = '.dropdown';
	  var SELECTOR_DROPDOWN_ITEMS = '.dropdown-item';
	  var SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
	  var Default$1 = {
	    offset: 10,
	    method: 'auto',
	    target: ''
	  };
	  var DefaultType$1 = {
	    offset: 'number',
	    method: 'string',
	    target: '(string|element)'
	  };
	  /**
	   * Class definition
	   */
	
	  var ScrollSpy = /*#__PURE__*/function () {
	    function ScrollSpy(element, config) {
	      var _this = this;
	
	      this._element = element;
	      this._scrollElement = element.tagName === 'BODY' ? window : element;
	      this._config = this._getConfig(config);
	      this._selector = this._config.target + " " + SELECTOR_NAV_LINKS + "," + (this._config.target + " " + SELECTOR_LIST_ITEMS + ",") + (this._config.target + " " + SELECTOR_DROPDOWN_ITEMS);
	      this._offsets = [];
	      this._targets = [];
	      this._activeTarget = null;
	      this._scrollHeight = 0;
	      $__default["default"](this._scrollElement).on(EVENT_SCROLL, function (event) {
	        return _this._process(event);
	      });
	      this.refresh();
	
	      this._process();
	    } // Getters
	
	
	    var _proto = ScrollSpy.prototype;
	
	    // Public
	    _proto.refresh = function refresh() {
	      var _this2 = this;
	
	      var autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
	      var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
	      var offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
	      this._offsets = [];
	      this._targets = [];
	      this._scrollHeight = this._getScrollHeight();
	      var targets = [].slice.call(document.querySelectorAll(this._selector));
	      targets.map(function (element) {
	        var target;
	        var targetSelector = Util.getSelectorFromElement(element);
	
	        if (targetSelector) {
	          target = document.querySelector(targetSelector);
	        }
	
	        if (target) {
	          var targetBCR = target.getBoundingClientRect();
	
	          if (targetBCR.width || targetBCR.height) {
	            // TODO (fat): remove sketch reliance on jQuery position/offset
	            return [$__default["default"](target)[offsetMethod]().top + offsetBase, targetSelector];
	          }
	        }
	
	        return null;
	      }).filter(Boolean).sort(function (a, b) {
	        return a[0] - b[0];
	      }).forEach(function (item) {
	        _this2._offsets.push(item[0]);
	
	        _this2._targets.push(item[1]);
	      });
	    };
	
	    _proto.dispose = function dispose() {
	      $__default["default"].removeData(this._element, DATA_KEY$2);
	      $__default["default"](this._scrollElement).off(EVENT_KEY$2);
	      this._element = null;
	      this._scrollElement = null;
	      this._config = null;
	      this._selector = null;
	      this._offsets = null;
	      this._targets = null;
	      this._activeTarget = null;
	      this._scrollHeight = null;
	    } // Private
	    ;
	
	    _proto._getConfig = function _getConfig(config) {
	      config = _extends({}, Default$1, typeof config === 'object' && config ? config : {});
	
	      if (typeof config.target !== 'string' && Util.isElement(config.target)) {
	        var id = $__default["default"](config.target).attr('id');
	
	        if (!id) {
	          id = Util.getUID(NAME$2);
	          $__default["default"](config.target).attr('id', id);
	        }
	
	        config.target = "#" + id;
	      }
	
	      Util.typeCheckConfig(NAME$2, config, DefaultType$1);
	      return config;
	    };
	
	    _proto._getScrollTop = function _getScrollTop() {
	      return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
	    };
	
	    _proto._getScrollHeight = function _getScrollHeight() {
	      return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
	    };
	
	    _proto._getOffsetHeight = function _getOffsetHeight() {
	      return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
	    };
	
	    _proto._process = function _process() {
	      var scrollTop = this._getScrollTop() + this._config.offset;
	
	      var scrollHeight = this._getScrollHeight();
	
	      var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();
	
	      if (this._scrollHeight !== scrollHeight) {
	        this.refresh();
	      }
	
	      if (scrollTop >= maxScroll) {
	        var target = this._targets[this._targets.length - 1];
	
	        if (this._activeTarget !== target) {
	          this._activate(target);
	        }
	
	        return;
	      }
	
	      if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
	        this._activeTarget = null;
	
	        this._clear();
	
	        return;
	      }
	
	      for (var i = this._offsets.length; i--;) {
	        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);
	
	        if (isActiveTarget) {
	          this._activate(this._targets[i]);
	        }
	      }
	    };
	
	    _proto._activate = function _activate(target) {
	      this._activeTarget = target;
	
	      this._clear();
	
	      var queries = this._selector.split(',').map(function (selector) {
	        return selector + "[data-target=\"" + target + "\"]," + selector + "[href=\"" + target + "\"]";
	      });
	
	      var $link = $__default["default"]([].slice.call(document.querySelectorAll(queries.join(','))));
	
	      if ($link.hasClass(CLASS_NAME_DROPDOWN_ITEM)) {
	        $link.closest(SELECTOR_DROPDOWN$1).find(SELECTOR_DROPDOWN_TOGGLE$1).addClass(CLASS_NAME_ACTIVE$1);
	        $link.addClass(CLASS_NAME_ACTIVE$1);
	      } else {
	        // Set triggered link as active
	        $link.addClass(CLASS_NAME_ACTIVE$1); // Set triggered links parents as active
	        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
	
	        $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_LINKS + ", " + SELECTOR_LIST_ITEMS).addClass(CLASS_NAME_ACTIVE$1); // Handle special case when .nav-link is inside .nav-item
	
	        $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_ITEMS).children(SELECTOR_NAV_LINKS).addClass(CLASS_NAME_ACTIVE$1);
	      }
	
	      $__default["default"](this._scrollElement).trigger(EVENT_ACTIVATE, {
	        relatedTarget: target
	      });
	    };
	
	    _proto._clear = function _clear() {
	      [].slice.call(document.querySelectorAll(this._selector)).filter(function (node) {
	        return node.classList.contains(CLASS_NAME_ACTIVE$1);
	      }).forEach(function (node) {
	        return node.classList.remove(CLASS_NAME_ACTIVE$1);
	      });
	    } // Static
	    ;
	
	    ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = $__default["default"](this).data(DATA_KEY$2);
	
	        var _config = typeof config === 'object' && config;
	
	        if (!data) {
	          data = new ScrollSpy(this, _config);
	          $__default["default"](this).data(DATA_KEY$2, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config]();
	        }
	      });
	    };
	
	    _createClass(ScrollSpy, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$2;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default$1;
	      }
	    }]);
	
	    return ScrollSpy;
	  }();
	  /**
	   * Data API implementation
	   */
	
	
	  $__default["default"](window).on(EVENT_LOAD_DATA_API, function () {
	    var scrollSpys = [].slice.call(document.querySelectorAll(SELECTOR_DATA_SPY));
	    var scrollSpysLength = scrollSpys.length;
	
	    for (var i = scrollSpysLength; i--;) {
	      var $spy = $__default["default"](scrollSpys[i]);
	
	      ScrollSpy._jQueryInterface.call($spy, $spy.data());
	    }
	  });
	  /**
	   * jQuery
	   */
	
	  $__default["default"].fn[NAME$2] = ScrollSpy._jQueryInterface;
	  $__default["default"].fn[NAME$2].Constructor = ScrollSpy;
	
	  $__default["default"].fn[NAME$2].noConflict = function () {
	    $__default["default"].fn[NAME$2] = JQUERY_NO_CONFLICT$2;
	    return ScrollSpy._jQueryInterface;
	  };
	
	  /**
	   * Constants
	   */
	
	  var NAME$1 = 'tab';
	  var VERSION$1 = '4.6.2';
	  var DATA_KEY$1 = 'bs.tab';
	  var EVENT_KEY$1 = "." + DATA_KEY$1;
	  var DATA_API_KEY = '.data-api';
	  var JQUERY_NO_CONFLICT$1 = $__default["default"].fn[NAME$1];
	  var CLASS_NAME_DROPDOWN_MENU = 'dropdown-menu';
	  var CLASS_NAME_ACTIVE = 'active';
	  var CLASS_NAME_DISABLED = 'disabled';
	  var CLASS_NAME_FADE$1 = 'fade';
	  var CLASS_NAME_SHOW$1 = 'show';
	  var EVENT_HIDE$1 = "hide" + EVENT_KEY$1;
	  var EVENT_HIDDEN$1 = "hidden" + EVENT_KEY$1;
	  var EVENT_SHOW$1 = "show" + EVENT_KEY$1;
	  var EVENT_SHOWN$1 = "shown" + EVENT_KEY$1;
	  var EVENT_CLICK_DATA_API = "click" + EVENT_KEY$1 + DATA_API_KEY;
	  var SELECTOR_DROPDOWN = '.dropdown';
	  var SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
	  var SELECTOR_ACTIVE = '.active';
	  var SELECTOR_ACTIVE_UL = '> li > .active';
	  var SELECTOR_DATA_TOGGLE = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]';
	  var SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
	  var SELECTOR_DROPDOWN_ACTIVE_CHILD = '> .dropdown-menu .active';
	  /**
	   * Class definition
	   */
	
	  var Tab = /*#__PURE__*/function () {
	    function Tab(element) {
	      this._element = element;
	    } // Getters
	
	
	    var _proto = Tab.prototype;
	
	    // Public
	    _proto.show = function show() {
	      var _this = this;
	
	      if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $__default["default"](this._element).hasClass(CLASS_NAME_ACTIVE) || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED) || this._element.hasAttribute('disabled')) {
	        return;
	      }
	
	      var target;
	      var previous;
	      var listElement = $__default["default"](this._element).closest(SELECTOR_NAV_LIST_GROUP)[0];
	      var selector = Util.getSelectorFromElement(this._element);
	
	      if (listElement) {
	        var itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE;
	        previous = $__default["default"].makeArray($__default["default"](listElement).find(itemSelector));
	        previous = previous[previous.length - 1];
	      }
	
	      var hideEvent = $__default["default"].Event(EVENT_HIDE$1, {
	        relatedTarget: this._element
	      });
	      var showEvent = $__default["default"].Event(EVENT_SHOW$1, {
	        relatedTarget: previous
	      });
	
	      if (previous) {
	        $__default["default"](previous).trigger(hideEvent);
	      }
	
	      $__default["default"](this._element).trigger(showEvent);
	
	      if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      if (selector) {
	        target = document.querySelector(selector);
	      }
	
	      this._activate(this._element, listElement);
	
	      var complete = function complete() {
	        var hiddenEvent = $__default["default"].Event(EVENT_HIDDEN$1, {
	          relatedTarget: _this._element
	        });
	        var shownEvent = $__default["default"].Event(EVENT_SHOWN$1, {
	          relatedTarget: previous
	        });
	        $__default["default"](previous).trigger(hiddenEvent);
	        $__default["default"](_this._element).trigger(shownEvent);
	      };
	
	      if (target) {
	        this._activate(target, target.parentNode, complete);
	      } else {
	        complete();
	      }
	    };
	
	    _proto.dispose = function dispose() {
	      $__default["default"].removeData(this._element, DATA_KEY$1);
	      this._element = null;
	    } // Private
	    ;
	
	    _proto._activate = function _activate(element, container, callback) {
	      var _this2 = this;
	
	      var activeElements = container && (container.nodeName === 'UL' || container.nodeName === 'OL') ? $__default["default"](container).find(SELECTOR_ACTIVE_UL) : $__default["default"](container).children(SELECTOR_ACTIVE);
	      var active = activeElements[0];
	      var isTransitioning = callback && active && $__default["default"](active).hasClass(CLASS_NAME_FADE$1);
	
	      var complete = function complete() {
	        return _this2._transitionComplete(element, active, callback);
	      };
	
	      if (active && isTransitioning) {
	        var transitionDuration = Util.getTransitionDurationFromElement(active);
	        $__default["default"](active).removeClass(CLASS_NAME_SHOW$1).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	      } else {
	        complete();
	      }
	    };
	
	    _proto._transitionComplete = function _transitionComplete(element, active, callback) {
	      if (active) {
	        $__default["default"](active).removeClass(CLASS_NAME_ACTIVE);
	        var dropdownChild = $__default["default"](active.parentNode).find(SELECTOR_DROPDOWN_ACTIVE_CHILD)[0];
	
	        if (dropdownChild) {
	          $__default["default"](dropdownChild).removeClass(CLASS_NAME_ACTIVE);
	        }
	
	        if (active.getAttribute('role') === 'tab') {
	          active.setAttribute('aria-selected', false);
	        }
	      }
	
	      $__default["default"](element).addClass(CLASS_NAME_ACTIVE);
	
	      if (element.getAttribute('role') === 'tab') {
	        element.setAttribute('aria-selected', true);
	      }
	
	      Util.reflow(element);
	
	      if (element.classList.contains(CLASS_NAME_FADE$1)) {
	        element.classList.add(CLASS_NAME_SHOW$1);
	      }
	
	      var parent = element.parentNode;
	
	      if (parent && parent.nodeName === 'LI') {
	        parent = parent.parentNode;
	      }
	
	      if (parent && $__default["default"](parent).hasClass(CLASS_NAME_DROPDOWN_MENU)) {
	        var dropdownElement = $__default["default"](element).closest(SELECTOR_DROPDOWN)[0];
	
	        if (dropdownElement) {
	          var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(SELECTOR_DROPDOWN_TOGGLE));
	          $__default["default"](dropdownToggleList).addClass(CLASS_NAME_ACTIVE);
	        }
	
	        element.setAttribute('aria-expanded', true);
	      }
	
	      if (callback) {
	        callback();
	      }
	    } // Static
	    ;
	
	    Tab._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var $this = $__default["default"](this);
	        var data = $this.data(DATA_KEY$1);
	
	        if (!data) {
	          data = new Tab(this);
	          $this.data(DATA_KEY$1, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config]();
	        }
	      });
	    };
	
	    _createClass(Tab, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION$1;
	      }
	    }]);
	
	    return Tab;
	  }();
	  /**
	   * Data API implementation
	   */
	
	
	  $__default["default"](document).on(EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function (event) {
	    event.preventDefault();
	
	    Tab._jQueryInterface.call($__default["default"](this), 'show');
	  });
	  /**
	   * jQuery
	   */
	
	  $__default["default"].fn[NAME$1] = Tab._jQueryInterface;
	  $__default["default"].fn[NAME$1].Constructor = Tab;
	
	  $__default["default"].fn[NAME$1].noConflict = function () {
	    $__default["default"].fn[NAME$1] = JQUERY_NO_CONFLICT$1;
	    return Tab._jQueryInterface;
	  };
	
	  /**
	   * Constants
	   */
	
	  var NAME = 'toast';
	  var VERSION = '4.6.2';
	  var DATA_KEY = 'bs.toast';
	  var EVENT_KEY = "." + DATA_KEY;
	  var JQUERY_NO_CONFLICT = $__default["default"].fn[NAME];
	  var CLASS_NAME_FADE = 'fade';
	  var CLASS_NAME_HIDE = 'hide';
	  var CLASS_NAME_SHOW = 'show';
	  var CLASS_NAME_SHOWING = 'showing';
	  var EVENT_CLICK_DISMISS = "click.dismiss" + EVENT_KEY;
	  var EVENT_HIDE = "hide" + EVENT_KEY;
	  var EVENT_HIDDEN = "hidden" + EVENT_KEY;
	  var EVENT_SHOW = "show" + EVENT_KEY;
	  var EVENT_SHOWN = "shown" + EVENT_KEY;
	  var SELECTOR_DATA_DISMISS = '[data-dismiss="toast"]';
	  var Default = {
	    animation: true,
	    autohide: true,
	    delay: 500
	  };
	  var DefaultType = {
	    animation: 'boolean',
	    autohide: 'boolean',
	    delay: 'number'
	  };
	  /**
	   * Class definition
	   */
	
	  var Toast = /*#__PURE__*/function () {
	    function Toast(element, config) {
	      this._element = element;
	      this._config = this._getConfig(config);
	      this._timeout = null;
	
	      this._setListeners();
	    } // Getters
	
	
	    var _proto = Toast.prototype;
	
	    // Public
	    _proto.show = function show() {
	      var _this = this;
	
	      var showEvent = $__default["default"].Event(EVENT_SHOW);
	      $__default["default"](this._element).trigger(showEvent);
	
	      if (showEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      this._clearTimeout();
	
	      if (this._config.animation) {
	        this._element.classList.add(CLASS_NAME_FADE);
	      }
	
	      var complete = function complete() {
	        _this._element.classList.remove(CLASS_NAME_SHOWING);
	
	        _this._element.classList.add(CLASS_NAME_SHOW);
	
	        $__default["default"](_this._element).trigger(EVENT_SHOWN);
	
	        if (_this._config.autohide) {
	          _this._timeout = setTimeout(function () {
	            _this.hide();
	          }, _this._config.delay);
	        }
	      };
	
	      this._element.classList.remove(CLASS_NAME_HIDE);
	
	      Util.reflow(this._element);
	
	      this._element.classList.add(CLASS_NAME_SHOWING);
	
	      if (this._config.animation) {
	        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
	        $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	      } else {
	        complete();
	      }
	    };
	
	    _proto.hide = function hide() {
	      if (!this._element.classList.contains(CLASS_NAME_SHOW)) {
	        return;
	      }
	
	      var hideEvent = $__default["default"].Event(EVENT_HIDE);
	      $__default["default"](this._element).trigger(hideEvent);
	
	      if (hideEvent.isDefaultPrevented()) {
	        return;
	      }
	
	      this._close();
	    };
	
	    _proto.dispose = function dispose() {
	      this._clearTimeout();
	
	      if (this._element.classList.contains(CLASS_NAME_SHOW)) {
	        this._element.classList.remove(CLASS_NAME_SHOW);
	      }
	
	      $__default["default"](this._element).off(EVENT_CLICK_DISMISS);
	      $__default["default"].removeData(this._element, DATA_KEY);
	      this._element = null;
	      this._config = null;
	    } // Private
	    ;
	
	    _proto._getConfig = function _getConfig(config) {
	      config = _extends({}, Default, $__default["default"](this._element).data(), typeof config === 'object' && config ? config : {});
	      Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
	      return config;
	    };
	
	    _proto._setListeners = function _setListeners() {
	      var _this2 = this;
	
	      $__default["default"](this._element).on(EVENT_CLICK_DISMISS, SELECTOR_DATA_DISMISS, function () {
	        return _this2.hide();
	      });
	    };
	
	    _proto._close = function _close() {
	      var _this3 = this;
	
	      var complete = function complete() {
	        _this3._element.classList.add(CLASS_NAME_HIDE);
	
	        $__default["default"](_this3._element).trigger(EVENT_HIDDEN);
	      };
	
	      this._element.classList.remove(CLASS_NAME_SHOW);
	
	      if (this._config.animation) {
	        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
	        $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	      } else {
	        complete();
	      }
	    };
	
	    _proto._clearTimeout = function _clearTimeout() {
	      clearTimeout(this._timeout);
	      this._timeout = null;
	    } // Static
	    ;
	
	    Toast._jQueryInterface = function _jQueryInterface(config) {
	      return this.each(function () {
	        var $element = $__default["default"](this);
	        var data = $element.data(DATA_KEY);
	
	        var _config = typeof config === 'object' && config;
	
	        if (!data) {
	          data = new Toast(this, _config);
	          $element.data(DATA_KEY, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError("No method named \"" + config + "\"");
	          }
	
	          data[config](this);
	        }
	      });
	    };
	
	    _createClass(Toast, null, [{
	      key: "VERSION",
	      get: function get() {
	        return VERSION;
	      }
	    }, {
	      key: "DefaultType",
	      get: function get() {
	        return DefaultType;
	      }
	    }, {
	      key: "Default",
	      get: function get() {
	        return Default;
	      }
	    }]);
	
	    return Toast;
	  }();
	  /**
	   * jQuery
	   */
	
	
	  $__default["default"].fn[NAME] = Toast._jQueryInterface;
	  $__default["default"].fn[NAME].Constructor = Toast;
	
	  $__default["default"].fn[NAME].noConflict = function () {
	    $__default["default"].fn[NAME] = JQUERY_NO_CONFLICT;
	    return Toast._jQueryInterface;
	  };
	
	  exports.Alert = Alert;
	  exports.Button = Button;
	  exports.Carousel = Carousel;
	  exports.Collapse = Collapse;
	  exports.Dropdown = Dropdown;
	  exports.Modal = Modal;
	  exports.Popover = Popover;
	  exports.Scrollspy = ScrollSpy;
	  exports.Tab = Tab;
	  exports.Toast = Toast;
	  exports.Tooltip = Tooltip;
	  exports.Util = Util;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));
	//# sourceMappingURL=bootstrap.js.map


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	var CustomEmailValidatorDirective;
	
	CustomEmailValidatorDirective = function() {
	  return {
	    require: 'ngModel',
	    link: function(scope, elem, attrs, ctrl) {
	      var MY_EMAIL_REGEXP;
	      MY_EMAIL_REGEXP = /^([\w\.%\+\-]+)@([\w\-]+\.)+([\w]{2,})$/i;
	      return ctrl.$validators.email = function(value) {
	        return ctrl.$isEmpty(value) || MY_EMAIL_REGEXP.test(value);
	      };
	    }
	  };
	};
	
	module.exports = CustomEmailValidatorDirective;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var $, DisableAllDirective;
	
	$ = __webpack_require__(1);
	
	DisableAllDirective = function() {
	  return {
	    restrict: 'A',
	    link: function(scope, elem, attrs) {
	      var $element;
	      $element = $(elem);
	      return scope.$watch(attrs.gnpDisableAll, function(value) {
	        return $element.find('input, select, textarea, button').prop("disabled", value);
	      });
	    }
	  };
	};
	
	module.exports = DisableAllDirective;


/***/ }),
/* 255 */
/***/ (function(module, exports) {

	var SubmittingButtonDirective;
	
	SubmittingButtonDirective = function($filter) {
	  return {
	    restrict: 'A',
	    link: function(scope, elem, attrs) {
	      var submittingMessage;
	      submittingMessage = $filter('translate')('PROCESSING');
	      return scope.$watch(attrs.gnpSubmittingButton, function(isSubmitting) {
	        if (isSubmitting) {
	          elem.data('defaultText', elem.text());
	          return elem.text(submittingMessage).prop('disabled', true);
	        } else {
	          return elem.text(elem.data('defaultText')).prop('disabled', false);
	        }
	      });
	    }
	  };
	};
	
	SubmittingButtonDirective.$inject = ['$filter'];
	
	module.exports = SubmittingButtonDirective;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

	var trustedText;
	
	trustedText = function($sce) {
	  return function(text) {
	    var a;
	    a = 1;
	    return $sce.trustAsHtml(text.toString());
	  };
	};
	
	trustedText.$inject = ['$sce'];
	
	module.exports = trustedText;


/***/ }),
/* 257 */
/***/ (function(module, exports) {

	var FormDialogService;
	
	FormDialogService = function() {
	  return {
	    _open: function(options, callback) {
	      var dialog;
	      dialog = document.createElement('input');
	      dialog.type = 'file';
	      dialog.style = 'display:none';
	      options = options || {};
	      document.body.appendChild(dialog);
	      if (options.accept) {
	        dialog.accept = options.accept;
	      }
	      dialog.addEventListener('change', function() {
	        if (!callback) {
	          return;
	        }
	        callback(dialog.files[0], dialog.value);
	        return document.body.removeChild(dialog);
	      });
	      return setTimeout(function() {
	        return dialog.click();
	      }, 0);
	    }
	  };
	};
	
	module.exports = FormDialogService;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var EXIF, FormFileReaderService;
	
	EXIF = __webpack_require__(259);
	
	FormFileReaderService = function($q, $window) {
	  var FileReader, formFileReaderService;
	  formFileReaderService = this;
	  FileReader = $window.FileReader;
	  formFileReaderService.readAsDataURL = function(file) {
	    var delay, reader;
	    delay = $q.defer();
	    reader = new FileReader();
	    reader.onload = function() {
	      return delay.resolve(reader.result);
	    };
	    reader.onerror = function() {
	      return delay.reject(reader.error);
	    };
	    reader.readAsDataURL(file);
	    return delay.promise;
	  };
	  formFileReaderService.resetOrientation = function(srcBase64, srcOrientation, callback) {
	    var img;
	    img = new Image;
	    img.onload = function() {
	      var canvas, ctx, height, width;
	      width = img.width;
	      height = img.height;
	      canvas = document.createElement('canvas');
	      ctx = canvas.getContext('2d');
	      if (4 < srcOrientation && srcOrientation < 9) {
	        canvas.width = height;
	        canvas.height = width;
	      } else {
	        canvas.width = width;
	        canvas.height = height;
	      }
	      switch (srcOrientation) {
	        case 2:
	          ctx.transform(-1, 0, 0, 1, width, 0);
	          break;
	        case 3:
	          ctx.transform(-1, 0, 0, -1, width, height);
	          break;
	        case 4:
	          ctx.transform(1, 0, 0, -1, 0, height);
	          break;
	        case 5:
	          ctx.transform(0, 1, 1, 0, 0, 0);
	          break;
	        case 6:
	          ctx.transform(0, 1, -1, 0, height, 0);
	          break;
	        case 7:
	          ctx.transform(0, -1, -1, 0, height, width);
	          break;
	        case 8:
	          ctx.transform(0, -1, 1, 0, 0, width);
	          break;
	        default:
	          break;
	      }
	      ctx.drawImage(img, 0, 0);
	      return callback(canvas.toDataURL());
	    };
	    return img.src = srcBase64;
	  };
	  formFileReaderService.loadImageOrientation = function(imgClass, file) {
	    var delay;
	    if (!file) {
	      return;
	    }
	    delay = $q.defer();
	    formFileReaderService.readAsDataURL(file).then(function(base64Image) {
	      var img;
	      $(img).attr('src', base64Image);
	      img = $("img." + imgClass).get(0);
	      return EXIF.getData(file, function() {
	        var allMetaData, result;
	        allMetaData = EXIF.getAllTags(file);
	        if (allMetaData.Orientation) {
	          return formFileReaderService.resetOrientation(base64Image, allMetaData.Orientation, function(resetBase64Image) {
	            var result;
	            $(img).attr('src', resetBase64Image);
	            result = {
	              base64Data: resetBase64Image,
	              orientation: allMetaData.Orientation
	            };
	            return delay.resolve(result);
	          });
	        } else {
	          $(img).attr('src', base64Image);
	          result = {
	            base64Data: base64Image
	          };
	          return delay.resolve(result);
	        }
	      });
	    });
	    return delay.promise;
	  };
	  formFileReaderService.base64ImageToBlob = function(str) {
	    var b64, blob, buffer, imageContent, n, pos, type, view;
	    pos = str.indexOf(';base64,');
	    type = str.substring(5, pos);
	    b64 = str.substr(pos + 8);
	    imageContent = atob(b64);
	    buffer = new ArrayBuffer(imageContent.length);
	    view = new Uint8Array(buffer);
	    n = 0;
	    while (n < imageContent.length) {
	      view[n] = imageContent.charCodeAt(n);
	      n++;
	    }
	    blob = new Blob([buffer], {
	      type: type
	    });
	    return blob;
	  };
	  return formFileReaderService;
	};
	
	FormFileReaderService.$inject = ['$q', '$window'];
	
	module.exports = FormFileReaderService;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(260);

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {
	
	    var debug = false;
	
	    var root = this;
	
	    var EXIF = function(obj) {
	        if (obj instanceof EXIF) return obj;
	        if (!(this instanceof EXIF)) return new EXIF(obj);
	        this.EXIFwrapped = obj;
	    };
	
	    if (true) {
	        if (typeof module !== 'undefined' && module.exports) {
	            exports = module.exports = EXIF;
	        }
	        exports.EXIF = EXIF;
	    } else {
	        root.EXIF = EXIF;
	    }
	
	    var ExifTags = EXIF.Tags = {
	
	        // version tags
	        0x9000 : "ExifVersion",             // EXIF version
	        0xA000 : "FlashpixVersion",         // Flashpix format version
	
	        // colorspace tags
	        0xA001 : "ColorSpace",              // Color space information tag
	
	        // image configuration
	        0xA002 : "PixelXDimension",         // Valid width of meaningful image
	        0xA003 : "PixelYDimension",         // Valid height of meaningful image
	        0x9101 : "ComponentsConfiguration", // Information about channels
	        0x9102 : "CompressedBitsPerPixel",  // Compressed bits per pixel
	
	        // user information
	        0x927C : "MakerNote",               // Any desired information written by the manufacturer
	        0x9286 : "UserComment",             // Comments by user
	
	        // related file
	        0xA004 : "RelatedSoundFile",        // Name of related sound file
	
	        // date and time
	        0x9003 : "DateTimeOriginal",        // Date and time when the original image was generated
	        0x9004 : "DateTimeDigitized",       // Date and time when the image was stored digitally
	        0x9290 : "SubsecTime",              // Fractions of seconds for DateTime
	        0x9291 : "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
	        0x9292 : "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized
	
	        // picture-taking conditions
	        0x829A : "ExposureTime",            // Exposure time (in seconds)
	        0x829D : "FNumber",                 // F number
	        0x8822 : "ExposureProgram",         // Exposure program
	        0x8824 : "SpectralSensitivity",     // Spectral sensitivity
	        0x8827 : "ISOSpeedRatings",         // ISO speed rating
	        0x8828 : "OECF",                    // Optoelectric conversion factor
	        0x9201 : "ShutterSpeedValue",       // Shutter speed
	        0x9202 : "ApertureValue",           // Lens aperture
	        0x9203 : "BrightnessValue",         // Value of brightness
	        0x9204 : "ExposureBias",            // Exposure bias
	        0x9205 : "MaxApertureValue",        // Smallest F number of lens
	        0x9206 : "SubjectDistance",         // Distance to subject in meters
	        0x9207 : "MeteringMode",            // Metering mode
	        0x9208 : "LightSource",             // Kind of light source
	        0x9209 : "Flash",                   // Flash status
	        0x9214 : "SubjectArea",             // Location and area of main subject
	        0x920A : "FocalLength",             // Focal length of the lens in mm
	        0xA20B : "FlashEnergy",             // Strobe energy in BCPS
	        0xA20C : "SpatialFrequencyResponse",    //
	        0xA20E : "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
	        0xA20F : "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
	        0xA210 : "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
	        0xA214 : "SubjectLocation",         // Location of subject in image
	        0xA215 : "ExposureIndex",           // Exposure index selected on camera
	        0xA217 : "SensingMethod",           // Image sensor type
	        0xA300 : "FileSource",              // Image source (3 == DSC)
	        0xA301 : "SceneType",               // Scene type (1 == directly photographed)
	        0xA302 : "CFAPattern",              // Color filter array geometric pattern
	        0xA401 : "CustomRendered",          // Special processing
	        0xA402 : "ExposureMode",            // Exposure mode
	        0xA403 : "WhiteBalance",            // 1 = auto white balance, 2 = manual
	        0xA404 : "DigitalZoomRation",       // Digital zoom ratio
	        0xA405 : "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
	        0xA406 : "SceneCaptureType",        // Type of scene
	        0xA407 : "GainControl",             // Degree of overall image gain adjustment
	        0xA408 : "Contrast",                // Direction of contrast processing applied by camera
	        0xA409 : "Saturation",              // Direction of saturation processing applied by camera
	        0xA40A : "Sharpness",               // Direction of sharpness processing applied by camera
	        0xA40B : "DeviceSettingDescription",    //
	        0xA40C : "SubjectDistanceRange",    // Distance to subject
	
	        // other tags
	        0xA005 : "InteroperabilityIFDPointer",
	        0xA420 : "ImageUniqueID"            // Identifier assigned uniquely to each image
	    };
	
	    var TiffTags = EXIF.TiffTags = {
	        0x0100 : "ImageWidth",
	        0x0101 : "ImageHeight",
	        0x8769 : "ExifIFDPointer",
	        0x8825 : "GPSInfoIFDPointer",
	        0xA005 : "InteroperabilityIFDPointer",
	        0x0102 : "BitsPerSample",
	        0x0103 : "Compression",
	        0x0106 : "PhotometricInterpretation",
	        0x0112 : "Orientation",
	        0x0115 : "SamplesPerPixel",
	        0x011C : "PlanarConfiguration",
	        0x0212 : "YCbCrSubSampling",
	        0x0213 : "YCbCrPositioning",
	        0x011A : "XResolution",
	        0x011B : "YResolution",
	        0x0128 : "ResolutionUnit",
	        0x0111 : "StripOffsets",
	        0x0116 : "RowsPerStrip",
	        0x0117 : "StripByteCounts",
	        0x0201 : "JPEGInterchangeFormat",
	        0x0202 : "JPEGInterchangeFormatLength",
	        0x012D : "TransferFunction",
	        0x013E : "WhitePoint",
	        0x013F : "PrimaryChromaticities",
	        0x0211 : "YCbCrCoefficients",
	        0x0214 : "ReferenceBlackWhite",
	        0x0132 : "DateTime",
	        0x010E : "ImageDescription",
	        0x010F : "Make",
	        0x0110 : "Model",
	        0x0131 : "Software",
	        0x013B : "Artist",
	        0x8298 : "Copyright"
	    };
	
	    var GPSTags = EXIF.GPSTags = {
	        0x0000 : "GPSVersionID",
	        0x0001 : "GPSLatitudeRef",
	        0x0002 : "GPSLatitude",
	        0x0003 : "GPSLongitudeRef",
	        0x0004 : "GPSLongitude",
	        0x0005 : "GPSAltitudeRef",
	        0x0006 : "GPSAltitude",
	        0x0007 : "GPSTimeStamp",
	        0x0008 : "GPSSatellites",
	        0x0009 : "GPSStatus",
	        0x000A : "GPSMeasureMode",
	        0x000B : "GPSDOP",
	        0x000C : "GPSSpeedRef",
	        0x000D : "GPSSpeed",
	        0x000E : "GPSTrackRef",
	        0x000F : "GPSTrack",
	        0x0010 : "GPSImgDirectionRef",
	        0x0011 : "GPSImgDirection",
	        0x0012 : "GPSMapDatum",
	        0x0013 : "GPSDestLatitudeRef",
	        0x0014 : "GPSDestLatitude",
	        0x0015 : "GPSDestLongitudeRef",
	        0x0016 : "GPSDestLongitude",
	        0x0017 : "GPSDestBearingRef",
	        0x0018 : "GPSDestBearing",
	        0x0019 : "GPSDestDistanceRef",
	        0x001A : "GPSDestDistance",
	        0x001B : "GPSProcessingMethod",
	        0x001C : "GPSAreaInformation",
	        0x001D : "GPSDateStamp",
	        0x001E : "GPSDifferential"
	    };
	
	     // EXIF 2.3 Spec
	    var IFD1Tags = EXIF.IFD1Tags = {
	        0x0100: "ImageWidth",
	        0x0101: "ImageHeight",
	        0x0102: "BitsPerSample",
	        0x0103: "Compression",
	        0x0106: "PhotometricInterpretation",
	        0x0111: "StripOffsets",
	        0x0112: "Orientation",
	        0x0115: "SamplesPerPixel",
	        0x0116: "RowsPerStrip",
	        0x0117: "StripByteCounts",
	        0x011A: "XResolution",
	        0x011B: "YResolution",
	        0x011C: "PlanarConfiguration",
	        0x0128: "ResolutionUnit",
	        0x0201: "JpegIFOffset",    // When image format is JPEG, this value show offset to JPEG data stored.(aka "ThumbnailOffset" or "JPEGInterchangeFormat")
	        0x0202: "JpegIFByteCount", // When image format is JPEG, this value shows data size of JPEG image (aka "ThumbnailLength" or "JPEGInterchangeFormatLength")
	        0x0211: "YCbCrCoefficients",
	        0x0212: "YCbCrSubSampling",
	        0x0213: "YCbCrPositioning",
	        0x0214: "ReferenceBlackWhite"
	    };
	
	    var StringValues = EXIF.StringValues = {
	        ExposureProgram : {
	            0 : "Not defined",
	            1 : "Manual",
	            2 : "Normal program",
	            3 : "Aperture priority",
	            4 : "Shutter priority",
	            5 : "Creative program",
	            6 : "Action program",
	            7 : "Portrait mode",
	            8 : "Landscape mode"
	        },
	        MeteringMode : {
	            0 : "Unknown",
	            1 : "Average",
	            2 : "CenterWeightedAverage",
	            3 : "Spot",
	            4 : "MultiSpot",
	            5 : "Pattern",
	            6 : "Partial",
	            255 : "Other"
	        },
	        LightSource : {
	            0 : "Unknown",
	            1 : "Daylight",
	            2 : "Fluorescent",
	            3 : "Tungsten (incandescent light)",
	            4 : "Flash",
	            9 : "Fine weather",
	            10 : "Cloudy weather",
	            11 : "Shade",
	            12 : "Daylight fluorescent (D 5700 - 7100K)",
	            13 : "Day white fluorescent (N 4600 - 5400K)",
	            14 : "Cool white fluorescent (W 3900 - 4500K)",
	            15 : "White fluorescent (WW 3200 - 3700K)",
	            17 : "Standard light A",
	            18 : "Standard light B",
	            19 : "Standard light C",
	            20 : "D55",
	            21 : "D65",
	            22 : "D75",
	            23 : "D50",
	            24 : "ISO studio tungsten",
	            255 : "Other"
	        },
	        Flash : {
	            0x0000 : "Flash did not fire",
	            0x0001 : "Flash fired",
	            0x0005 : "Strobe return light not detected",
	            0x0007 : "Strobe return light detected",
	            0x0009 : "Flash fired, compulsory flash mode",
	            0x000D : "Flash fired, compulsory flash mode, return light not detected",
	            0x000F : "Flash fired, compulsory flash mode, return light detected",
	            0x0010 : "Flash did not fire, compulsory flash mode",
	            0x0018 : "Flash did not fire, auto mode",
	            0x0019 : "Flash fired, auto mode",
	            0x001D : "Flash fired, auto mode, return light not detected",
	            0x001F : "Flash fired, auto mode, return light detected",
	            0x0020 : "No flash function",
	            0x0041 : "Flash fired, red-eye reduction mode",
	            0x0045 : "Flash fired, red-eye reduction mode, return light not detected",
	            0x0047 : "Flash fired, red-eye reduction mode, return light detected",
	            0x0049 : "Flash fired, compulsory flash mode, red-eye reduction mode",
	            0x004D : "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
	            0x004F : "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
	            0x0059 : "Flash fired, auto mode, red-eye reduction mode",
	            0x005D : "Flash fired, auto mode, return light not detected, red-eye reduction mode",
	            0x005F : "Flash fired, auto mode, return light detected, red-eye reduction mode"
	        },
	        SensingMethod : {
	            1 : "Not defined",
	            2 : "One-chip color area sensor",
	            3 : "Two-chip color area sensor",
	            4 : "Three-chip color area sensor",
	            5 : "Color sequential area sensor",
	            7 : "Trilinear sensor",
	            8 : "Color sequential linear sensor"
	        },
	        SceneCaptureType : {
	            0 : "Standard",
	            1 : "Landscape",
	            2 : "Portrait",
	            3 : "Night scene"
	        },
	        SceneType : {
	            1 : "Directly photographed"
	        },
	        CustomRendered : {
	            0 : "Normal process",
	            1 : "Custom process"
	        },
	        WhiteBalance : {
	            0 : "Auto white balance",
	            1 : "Manual white balance"
	        },
	        GainControl : {
	            0 : "None",
	            1 : "Low gain up",
	            2 : "High gain up",
	            3 : "Low gain down",
	            4 : "High gain down"
	        },
	        Contrast : {
	            0 : "Normal",
	            1 : "Soft",
	            2 : "Hard"
	        },
	        Saturation : {
	            0 : "Normal",
	            1 : "Low saturation",
	            2 : "High saturation"
	        },
	        Sharpness : {
	            0 : "Normal",
	            1 : "Soft",
	            2 : "Hard"
	        },
	        SubjectDistanceRange : {
	            0 : "Unknown",
	            1 : "Macro",
	            2 : "Close view",
	            3 : "Distant view"
	        },
	        FileSource : {
	            3 : "DSC"
	        },
	
	        Components : {
	            0 : "",
	            1 : "Y",
	            2 : "Cb",
	            3 : "Cr",
	            4 : "R",
	            5 : "G",
	            6 : "B"
	        }
	    };
	
	    function addEvent(element, event, handler) {
	        if (element.addEventListener) {
	            element.addEventListener(event, handler, false);
	        } else if (element.attachEvent) {
	            element.attachEvent("on" + event, handler);
	        }
	    }
	
	    function imageHasData(img) {
	        return !!(img.exifdata);
	    }
	
	
	    function base64ToArrayBuffer(base64, contentType) {
	        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
	        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
	        var binary = atob(base64);
	        var len = binary.length;
	        var buffer = new ArrayBuffer(len);
	        var view = new Uint8Array(buffer);
	        for (var i = 0; i < len; i++) {
	            view[i] = binary.charCodeAt(i);
	        }
	        return buffer;
	    }
	
	    function objectURLToBlob(url, callback) {
	        var http = new XMLHttpRequest();
	        http.open("GET", url, true);
	        http.responseType = "blob";
	        http.onload = function(e) {
	            if (this.status == 200 || this.status === 0) {
	                callback(this.response);
	            }
	        };
	        http.send();
	    }
	
	    function getImageData(img, callback) {
	        function handleBinaryFile(binFile) {
	            var data = findEXIFinJPEG(binFile);
	            img.exifdata = data || {};
	            var iptcdata = findIPTCinJPEG(binFile);
	            img.iptcdata = iptcdata || {};
	            if (EXIF.isXmpEnabled) {
	               var xmpdata= findXMPinJPEG(binFile);
	               img.xmpdata = xmpdata || {};               
	            }
	            if (callback) {
	                callback.call(img);
	            }
	        }
	
	        if (img.src) {
	            if (/^data\:/i.test(img.src)) { // Data URI
	                var arrayBuffer = base64ToArrayBuffer(img.src);
	                handleBinaryFile(arrayBuffer);
	
	            } else if (/^blob\:/i.test(img.src)) { // Object URL
	                var fileReader = new FileReader();
	                fileReader.onload = function(e) {
	                    handleBinaryFile(e.target.result);
	                };
	                objectURLToBlob(img.src, function (blob) {
	                    fileReader.readAsArrayBuffer(blob);
	                });
	            } else {
	                var http = new XMLHttpRequest();
	                http.onload = function() {
	                    if (this.status == 200 || this.status === 0) {
	                        handleBinaryFile(http.response);
	                    } else {
	                        throw "Could not load image";
	                    }
	                    http = null;
	                };
	                http.open("GET", img.src, true);
	                http.responseType = "arraybuffer";
	                http.send(null);
	            }
	        } else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
	            var fileReader = new FileReader();
	            fileReader.onload = function(e) {
	                if (debug) console.log("Got file of length " + e.target.result.byteLength);
	                handleBinaryFile(e.target.result);
	            };
	
	            fileReader.readAsArrayBuffer(img);
	        }
	    }
	
	    function findEXIFinJPEG(file) {
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	            if (debug) console.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength,
	            marker;
	
	        while (offset < length) {
	            if (dataView.getUint8(offset) != 0xFF) {
	                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
	                return false; // not a valid marker, something is wrong
	            }
	
	            marker = dataView.getUint8(offset + 1);
	            if (debug) console.log(marker);
	
	            // we could implement handling for other markers here,
	            // but we're only looking for 0xFFE1 for EXIF data
	
	            if (marker == 225) {
	                if (debug) console.log("Found 0xFFE1 marker");
	
	                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);
	
	                // offset += 2 + file.getShortAt(offset+2, true);
	
	            } else {
	                offset += 2 + dataView.getUint16(offset+2);
	            }
	
	        }
	
	    }
	
	    function findIPTCinJPEG(file) {
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	            if (debug) console.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength;
	
	
	        var isFieldSegmentStart = function(dataView, offset){
	            return (
	                dataView.getUint8(offset) === 0x38 &&
	                dataView.getUint8(offset+1) === 0x42 &&
	                dataView.getUint8(offset+2) === 0x49 &&
	                dataView.getUint8(offset+3) === 0x4D &&
	                dataView.getUint8(offset+4) === 0x04 &&
	                dataView.getUint8(offset+5) === 0x04
	            );
	        };
	
	        while (offset < length) {
	
	            if ( isFieldSegmentStart(dataView, offset )){
	
	                // Get the length of the name header (which is padded to an even number of bytes)
	                var nameHeaderLength = dataView.getUint8(offset+7);
	                if(nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
	                // Check for pre photoshop 6 format
	                if(nameHeaderLength === 0) {
	                    // Always 4
	                    nameHeaderLength = 4;
	                }
	
	                var startOffset = offset + 8 + nameHeaderLength;
	                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
	
	                return readIPTCData(file, startOffset, sectionLength);
	
	                break;
	
	            }
	
	
	            // Not the marker, continue searching
	            offset++;
	
	        }
	
	    }
	    var IptcFieldMap = {
	        0x78 : 'caption',
	        0x6E : 'credit',
	        0x19 : 'keywords',
	        0x37 : 'dateCreated',
	        0x50 : 'byline',
	        0x55 : 'bylineTitle',
	        0x7A : 'captionWriter',
	        0x69 : 'headline',
	        0x74 : 'copyright',
	        0x0F : 'category'
	    };
	    function readIPTCData(file, startOffset, sectionLength){
	        var dataView = new DataView(file);
	        var data = {};
	        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
	        var segmentStartPos = startOffset;
	        while(segmentStartPos < startOffset+sectionLength) {
	            if(dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos+1) === 0x02){
	                segmentType = dataView.getUint8(segmentStartPos+2);
	                if(segmentType in IptcFieldMap) {
	                    dataSize = dataView.getInt16(segmentStartPos+3);
	                    segmentSize = dataSize + 5;
	                    fieldName = IptcFieldMap[segmentType];
	                    fieldValue = getStringFromDB(dataView, segmentStartPos+5, dataSize);
	                    // Check if we already stored a value with this name
	                    if(data.hasOwnProperty(fieldName)) {
	                        // Value already stored with this name, create multivalue field
	                        if(data[fieldName] instanceof Array) {
	                            data[fieldName].push(fieldValue);
	                        }
	                        else {
	                            data[fieldName] = [data[fieldName], fieldValue];
	                        }
	                    }
	                    else {
	                        data[fieldName] = fieldValue;
	                    }
	                }
	
	            }
	            segmentStartPos++;
	        }
	        return data;
	    }
	
	
	
	    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
	        var entries = file.getUint16(dirStart, !bigEnd),
	            tags = {},
	            entryOffset, tag,
	            i;
	
	        for (i=0;i<entries;i++) {
	            entryOffset = dirStart + i*12 + 2;
	            tag = strings[file.getUint16(entryOffset, !bigEnd)];
	            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
	            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
	        }
	        return tags;
	    }
	
	
	    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
	        var type = file.getUint16(entryOffset+2, !bigEnd),
	            numValues = file.getUint32(entryOffset+4, !bigEnd),
	            valueOffset = file.getUint32(entryOffset+8, !bigEnd) + tiffStart,
	            offset,
	            vals, val, n,
	            numerator, denominator;
	
	        switch (type) {
	            case 1: // byte, 8-bit unsigned int
	            case 7: // undefined, 8-bit byte, value depending on field
	                if (numValues == 1) {
	                    return file.getUint8(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getUint8(offset + n);
	                    }
	                    return vals;
	                }
	
	            case 2: // ascii, 8-bit byte
	                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                return getStringFromDB(file, offset, numValues-1);
	
	            case 3: // short, 16 bit int
	                if (numValues == 1) {
	                    return file.getUint16(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getUint16(offset + 2*n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 4: // long, 32 bit int
	                if (numValues == 1) {
	                    return file.getUint32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getUint32(valueOffset + 4*n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 5:    // rational = two long values, first is numerator, second is denominator
	                if (numValues == 1) {
	                    numerator = file.getUint32(valueOffset, !bigEnd);
	                    denominator = file.getUint32(valueOffset+4, !bigEnd);
	                    val = new Number(numerator / denominator);
	                    val.numerator = numerator;
	                    val.denominator = denominator;
	                    return val;
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        numerator = file.getUint32(valueOffset + 8*n, !bigEnd);
	                        denominator = file.getUint32(valueOffset+4 + 8*n, !bigEnd);
	                        vals[n] = new Number(numerator / denominator);
	                        vals[n].numerator = numerator;
	                        vals[n].denominator = denominator;
	                    }
	                    return vals;
	                }
	
	            case 9: // slong, 32 bit signed int
	                if (numValues == 1) {
	                    return file.getInt32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getInt32(valueOffset + 4*n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 10: // signed rational, two slongs, first is numerator, second is denominator
	                if (numValues == 1) {
	                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset+4, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getInt32(valueOffset + 8*n, !bigEnd) / file.getInt32(valueOffset+4 + 8*n, !bigEnd);
	                    }
	                    return vals;
	                }
	        }
	    }
	
	    /**
	    * Given an IFD (Image File Directory) start offset
	    * returns an offset to next IFD or 0 if it's the last IFD.
	    */
	    function getNextIFDOffset(dataView, dirStart, bigEnd){
	        //the first 2bytes means the number of directory entries contains in this IFD
	        var entries = dataView.getUint16(dirStart, !bigEnd);
	
	        // After last directory entry, there is a 4bytes of data,
	        // it means an offset to next IFD.
	        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.
	
	        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
	    }
	
	    function readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd){
	        // get the IFD1 offset
	        var IFD1OffsetPointer = getNextIFDOffset(dataView, tiffStart+firstIFDOffset, bigEnd);
	
	        if (!IFD1OffsetPointer) {
	            // console.log('******** IFD1Offset is empty, image thumb not found ********');
	            return {};
	        }
	        else if (IFD1OffsetPointer > dataView.byteLength) { // this should not happen
	            // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
	            return {};
	        }
	        // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);
	
	        var thumbTags = readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, IFD1Tags, bigEnd)
	
	        // EXIF 2.3 specification for JPEG format thumbnail
	
	        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
	        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
	        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
	        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
	        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.
	
	        if (thumbTags['Compression']) {
	            // console.log('Thumbnail image found!');
	
	            switch (thumbTags['Compression']) {
	                case 6:
	                    // console.log('Thumbnail image format is JPEG');
	                    if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
	                    // extract the thumbnail
	                        var tOffset = tiffStart + thumbTags.JpegIFOffset;
	                        var tLength = thumbTags.JpegIFByteCount;
	                        thumbTags['blob'] = new Blob([new Uint8Array(dataView.buffer, tOffset, tLength)], {
	                            type: 'image/jpeg'
	                        });
	                    }
	                break;
	
	            case 1:
	                console.log("Thumbnail image format is TIFF, which is not implemented.");
	                break;
	            default:
	                console.log("Unknown thumbnail image format '%s'", thumbTags['Compression']);
	            }
	        }
	        else if (thumbTags['PhotometricInterpretation'] == 2) {
	            console.log("Thumbnail image format is RGB, which is not implemented.");
	        }
	        return thumbTags;
	    }
	
	    function getStringFromDB(buffer, start, length) {
	        var outstr = "";
	        for (n = start; n < start+length; n++) {
	            outstr += String.fromCharCode(buffer.getUint8(n));
	        }
	        return outstr;
	    }
	
	    function readEXIFData(file, start) {
	        if (getStringFromDB(file, start, 4) != "Exif") {
	            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
	            return false;
	        }
	
	        var bigEnd,
	            tags, tag,
	            exifData, gpsData,
	            tiffOffset = start + 6;
	
	        // test for TIFF validity and endianness
	        if (file.getUint16(tiffOffset) == 0x4949) {
	            bigEnd = false;
	        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
	            bigEnd = true;
	        } else {
	            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
	            return false;
	        }
	
	        if (file.getUint16(tiffOffset+2, !bigEnd) != 0x002A) {
	            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
	            return false;
	        }
	
	        var firstIFDOffset = file.getUint32(tiffOffset+4, !bigEnd);
	
	        if (firstIFDOffset < 0x00000008) {
	            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset+4, !bigEnd));
	            return false;
	        }
	
	        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);
	
	        if (tags.ExifIFDPointer) {
	            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
	            for (tag in exifData) {
	                switch (tag) {
	                    case "LightSource" :
	                    case "Flash" :
	                    case "MeteringMode" :
	                    case "ExposureProgram" :
	                    case "SensingMethod" :
	                    case "SceneCaptureType" :
	                    case "SceneType" :
	                    case "CustomRendered" :
	                    case "WhiteBalance" :
	                    case "GainControl" :
	                    case "Contrast" :
	                    case "Saturation" :
	                    case "Sharpness" :
	                    case "SubjectDistanceRange" :
	                    case "FileSource" :
	                        exifData[tag] = StringValues[tag][exifData[tag]];
	                        break;
	
	                    case "ExifVersion" :
	                    case "FlashpixVersion" :
	                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
	                        break;
	
	                    case "ComponentsConfiguration" :
	                        exifData[tag] =
	                            StringValues.Components[exifData[tag][0]] +
	                            StringValues.Components[exifData[tag][1]] +
	                            StringValues.Components[exifData[tag][2]] +
	                            StringValues.Components[exifData[tag][3]];
	                        break;
	                }
	                tags[tag] = exifData[tag];
	            }
	        }
	
	        if (tags.GPSInfoIFDPointer) {
	            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
	            for (tag in gpsData) {
	                switch (tag) {
	                    case "GPSVersionID" :
	                        gpsData[tag] = gpsData[tag][0] +
	                            "." + gpsData[tag][1] +
	                            "." + gpsData[tag][2] +
	                            "." + gpsData[tag][3];
	                        break;
	                }
	                tags[tag] = gpsData[tag];
	            }
	        }
	
	        // extract thumbnail
	        tags['thumbnail'] = readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);
	
	        return tags;
	    }
	
	   function findXMPinJPEG(file) {
	
	        if (!('DOMParser' in self)) {
	            // console.warn('XML parsing not supported without DOMParser');
	            return;
	        }
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	           if (debug) console.log("Not a valid JPEG");
	           return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength,
	            dom = new DOMParser();
	
	        while (offset < (length-4)) {
	            if (getStringFromDB(dataView, offset, 4) == "http") {
	                var startOffset = offset - 1;
	                var sectionLength = dataView.getUint16(offset - 2) - 1;
	                var xmpString = getStringFromDB(dataView, startOffset, sectionLength)
	                var xmpEndIndex = xmpString.indexOf('xmpmeta>') + 8;
	                xmpString = xmpString.substring( xmpString.indexOf( '<x:xmpmeta' ), xmpEndIndex );
	
	                var indexOfXmp = xmpString.indexOf('x:xmpmeta') + 10
	                //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
	                //Without these namespaces, XML is thought to be invalid by parsers
	                xmpString = xmpString.slice(0, indexOfXmp)
	                            + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" '
	                            + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" '
	                            + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" '
	                            + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" '
	                            + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" '
	                            + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" '
	                            + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" '
	                            + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" '
	                            + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" '
	                            + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" '
	                            + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" '
	                            + xmpString.slice(indexOfXmp)
	
	                var domDocument = dom.parseFromString( xmpString, 'text/xml' );
	                return xml2Object(domDocument);
	            } else{
	             offset++;
	            }
	        }
	    }
	
	    function xml2json(xml) {
	        var json = {};
	      
	        if (xml.nodeType == 1) { // element node
	          if (xml.attributes.length > 0) {
	            json['@attributes'] = {};
	            for (var j = 0; j < xml.attributes.length; j++) {
	              var attribute = xml.attributes.item(j);
	              json['@attributes'][attribute.nodeName] = attribute.nodeValue;
	            }
	          }
	        } else if (xml.nodeType == 3) { // text node
	          return xml.nodeValue;
	        }
	      
	        // deal with children
	        if (xml.hasChildNodes()) {
	          for(var i = 0; i < xml.childNodes.length; i++) {
	            var child = xml.childNodes.item(i);
	            var nodeName = child.nodeName;
	            if (json[nodeName] == null) {
	              json[nodeName] = xml2json(child);
	            } else {
	              if (json[nodeName].push == null) {
	                var old = json[nodeName];
	                json[nodeName] = [];
	                json[nodeName].push(old);
	              }
	              json[nodeName].push(xml2json(child));
	            }
	          }
	        }
	        
	        return json;
	    }
	
	    function xml2Object(xml) {
	        try {
	            var obj = {};
	            if (xml.children.length > 0) {
	              for (var i = 0; i < xml.children.length; i++) {
	                var item = xml.children.item(i);
	                var attributes = item.attributes;
	                for(var idx in attributes) {
	                    var itemAtt = attributes[idx];
	                    var dataKey = itemAtt.nodeName;
	                    var dataValue = itemAtt.nodeValue;
	
	                    if(dataKey !== undefined) {
	                        obj[dataKey] = dataValue;
	                    }
	                }
	                var nodeName = item.nodeName;
	
	                if (typeof (obj[nodeName]) == "undefined") {
	                  obj[nodeName] = xml2json(item);
	                } else {
	                  if (typeof (obj[nodeName].push) == "undefined") {
	                    var old = obj[nodeName];
	
	                    obj[nodeName] = [];
	                    obj[nodeName].push(old);
	                  }
	                  obj[nodeName].push(xml2json(item));
	                }
	              }
	            } else {
	              obj = xml.textContent;
	            }
	            return obj;
	          } catch (e) {
	              console.log(e.message);
	          }
	    }
	
	    EXIF.enableXmp = function() {
	        EXIF.isXmpEnabled = true;
	    }
	
	    EXIF.disableXmp = function() {
	        EXIF.isXmpEnabled = false;
	    }
	
	    EXIF.getData = function(img, callback) {
	        if (((self.Image && img instanceof self.Image)
	            || (self.HTMLImageElement && img instanceof self.HTMLImageElement))
	            && !img.complete)
	            return false;
	
	        if (!imageHasData(img)) {
	            getImageData(img, callback);
	        } else {
	            if (callback) {
	                callback.call(img);
	            }
	        }
	        return true;
	    }
	
	    EXIF.getTag = function(img, tag) {
	        if (!imageHasData(img)) return;
	        return img.exifdata[tag];
	    }
	    
	    EXIF.getIptcTag = function(img, tag) {
	        if (!imageHasData(img)) return;
	        return img.iptcdata[tag];
	    }
	
	    EXIF.getAllTags = function(img) {
	        if (!imageHasData(img)) return {};
	        var a,
	            data = img.exifdata,
	            tags = {};
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                tags[a] = data[a];
	            }
	        }
	        return tags;
	    }
	    
	    EXIF.getAllIptcTags = function(img) {
	        if (!imageHasData(img)) return {};
	        var a,
	            data = img.iptcdata,
	            tags = {};
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                tags[a] = data[a];
	            }
	        }
	        return tags;
	    }
	
	    EXIF.pretty = function(img) {
	        if (!imageHasData(img)) return "";
	        var a,
	            data = img.exifdata,
	            strPretty = "";
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                if (typeof data[a] == "object") {
	                    if (data[a] instanceof Number) {
	                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
	                    } else {
	                        strPretty += a + " : [" + data[a].length + " values]\r\n";
	                    }
	                } else {
	                    strPretty += a + " : " + data[a] + "\r\n";
	                }
	            }
	        }
	        return strPretty;
	    }
	
	    EXIF.readFromBinaryFile = function(file) {
	        return findEXIFinJPEG(file);
	    }
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return EXIF;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}.call(this));
	


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	var FormCopyService;
	
	FormCopyService = function($window) {
	  var body, spanTag;
	  body = angular.element($window.document.body);
	  spanTag = document.createElement('span');
	  spanTag.style = "position: absolute ; opacity: 0 ; width : 0; height : 0 ; top : 0 ; left: 0";
	  return {
	    copy: function(text) {
	      var error, range, success;
	      spanTag.innerText = text;
	      body.append(spanTag);
	      range = document.createRange();
	      range.selectNode(spanTag);
	      window.getSelection().removeAllRanges();
	      window.getSelection().addRange(range);
	      try {
	        success = document.execCommand('copy');
	        if (!success) {
	          throw success;
	        }
	      } catch (error1) {
	        error = error1;
	        window.prompt("Copy to clipboard: Ctrl+C, Enter", text);
	      }
	      window.getSelection().removeAllRanges();
	      return spanTag.remove();
	    }
	  };
	};
	
	FormCopyService.$inject = ['$window'];
	
	module.exports = FormCopyService;


/***/ }),
/* 262 */
/***/ (function(module, exports) {

	var formatStringFilter, regexParam;
	
	regexParam = /\{(\d+)\}/g;
	
	formatStringFilter = function() {
	  return function(input) {
	    var arg;
	    arg = arguments;
	    return input = input.replace(regexParam, function(match, capture) {
	      return arg[Number(capture) + 1];
	    });
	  };
	};
	
	module.exports = formatStringFilter;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(264);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/session/_session.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/session/_session.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#new-main .cell{padding:0}#new-main .bg-img{background-image:url("+__webpack_require__(265)+");background-position:center;background-repeat:no-repeat;background-size:cover}#new-main .bg-img .container.session{padding:70px 0 90px}#new-main .bg-img .container.session .area{position:relative}#new-main .bg-img .container.session .area .title-tag{position:relative;height:120px;background-repeat:no-repeat}@media (max-width:768px){#new-main .bg-img .container.session .area .title-tag{height:60px}#new-main .bg-img .container.session .area .title-tag img{display:block;margin:0 auto}}@media (max-width:399px){#new-main .bg-img .container.session .area .title-tag img{width:100%}}#new-main .bg-img .container.session .area .display-image{position:relative;background-repeat:no-repeat;top:226px}#new-main .bg-img .container.session .area .display-image img{position:relative;max-width:440px;left:100px}#new-main .bg-img .container.session .frame{position:relative;height:536px}#new-main .bg-img .container.session .frame .content-message{position:relative;width:360px;left:50%;margin-left:-160px;margin-top:0;margin-bottom:0;background-color:#fff;padding-top:10px;padding-bottom:15px}#new-main .bg-img .container.session .frame .content-message .message{margin:5px 20px 0;padding:10px 0;position:relative;border-radius:10px;font-size:15px;text-indent:10px}#new-main .bg-img .container.session .frame .content-message .message ul,#new-main .bg-img .container.session .frame .content-message .message ol{margin:0}#new-main .bg-img .container.session .frame .content-message .error{background:#fbe3e4;color:#8a1f11;border-color:#fbc2c4;border-style:solid}#new-main .bg-img .container.session .frame .newform{position:relative;left:50%;margin-left:-160px;width:360px;text-align:center;background-color:#fff;padding:0}#new-main .bg-img .container.session .frame .newform input[type=email],#new-main .bg-img .container.session .frame .newform input[type=password]{position:relative;text-indent:5px;background-color:#fff;width:290px;height:40px;border-radius:4px;border-color:#bbb;border-width:1px;border-style:solid}#new-main .bg-img .container.session .frame .newform .round-btn{position:relative;top:40px;color:#fff;margin:0 auto;text-align:center;line-height:0;background-color:#000;width:150px;height:30px;border-radius:4px;border-color:#000;border-width:0;border-style:solid;cursor:pointer}#new-main .bg-img .container.session .frame .newform .row .cell1{padding:0 34px;min-height:50px}#new-main .bg-img .container.session .frame .newform .row .error{background-color:transparent;border:0;text-align:left;line-height:24px;padding:2px 10px;margin:0;color:#8a1f11}#new-main .bg-img .container.session .frame .newform .forgot{position:relative;top:50px;color:gray;text-decoration:none}#new-main .bg-img .container.session .frame .newform .sign_up{position:relative;top:62px;height:150px;background-color:#e1e1e1}#new-main .bg-img .container.session .frame .newform .sign_up .sign_up-btn{display:block;position:relative;top:20px;margin:0 auto;background-color:#01a5a3;width:180px;height:50px;border-radius:4px;border-color:#01a5a3;border-width:0;border-style:solid;color:#fff;font-size:18px;text-decoration:none;line-height:40px}#new-main .bg-img .container.session .frame .newform .sign_up p{position:relative;top:45px;padding:0 5px;color:gray}#new-main .bg-img .container.session .frame .newform .sign_up p.sign-up-tiny{top:25px}#new-main .bg-img .container.session .frame .newform .loggin-guide,#new-main .bg-img .container.session .frame .newform .loggin-guide-tiny{position:relative;top:50px;color:gray}@media (min-width:400px){#new-main .bg-img .container.session .frame .newform p.loggin-guide-tiny{display:none}#new-main .bg-img .container.session .frame .newform p.sign-up-tiny{display:none;top:25px}}@media (max-width:399px){#new-main .bg-img .container.session .frame .newform p.loggin-guide,#new-main .bg-img .container.session .frame .newform p.sign-up{display:none}}@media (max-width:768px){#new-main .bg-img .container.session .frame .content-message,#new-main .bg-img .container.session .frame .newform{left:0;margin:0 auto}}@media (max-width:399px){#new-main .bg-img .container.session .frame .content-message,#new-main .bg-img .container.session .frame .newform{width:100%}#new-main .bg-img .container.session .frame .newform input[type=email],#new-main .bg-img .container.session .frame .newform input[type=password]{width:220px}}@media (max-width:399px){#new-main .bg-img .container.session .frame{padding:0 10px}}@media (max-width:399px){#new-main .bg-img .container.session{padding:30px 0 90px}}#new-main #gnp-footer{margin-top:0}@media (max-width:768px){#new-main div.display-image{display:none}}", ""]);

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0a3e3d6ce6a68572451cf0a32478c807.jpg";

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	var SessionNewCtrl;
	
	SessionNewCtrl = function($scope, $filter, $location, flash, AuthService, $cookies) {
	  var date, failureAttempts;
	  if (AuthService.isSignedIn()) {
	    return $location.path('/');
	  }
	  $scope.user = {
	    email: '',
	    password: ''
	  };
	  $scope.isSubmitting = false;
	  $scope.locked = false;
	  date = new Date();
	  date.setTime(date.getTime() + (300 * 1000));
	  failureAttempts = $cookies.get('loginAttempt');
	  if (!$cookies.get('loginAttempt')) {
	    failureAttempts = 0;
	  }
	  if (failureAttempts >= 5) {
	    flash.error($filter('translate')('_SESSION.NEW.LOCK_ACCOUNT'));
	    $scope.locked = true;
	  }
	  return $scope.submit = function(user) {
	    $scope.isSubmitting = true;
	    return AuthService.signIn(user.email, user.password).then(function() {
	      return $location.path('/');
	    })["catch"](function() {
	      $scope.isSubmitting = false;
	      if (failureAttempts === 5) {
	        flash.error($filter('translate')('_SESSION.NEW.LOCK_ACCOUNT'));
	        return $scope.check = true;
	      } else {
	        flash.error($filter('translate')('_SESSION.NEW.ERROR'));
	        failureAttempts++;
	        return $cookies.put('loginAttempt', failureAttempts, {
	          expires: date
	        });
	      }
	    });
	  };
	};
	
	SessionNewCtrl['$inject'] = ['$scope', '$filter', '$location', 'flash', 'AuthService', '$cookies'];
	
	module.exports = SessionNewCtrl;


/***/ }),
/* 267 */
/***/ (function(module, exports) {

	module.exports = {
	  '_SESSION': {
	    'NEW': {
	      'TITLE': '@:_SESSION.NEW.SIGN_IN',
	      'SIGN_IN': 'Sign in',
	      'LOCK_ACCOUNT': 'Login attempt is locked because of protecting the account. Try later again.',
	      'EMAIL_ADDR': 'Email Address',
	      'PASSWORD': 'Password',
	      'FORGOT_PASSWORD': 'Forgot password?',
	      'LOGIN_GUIDE': 'You can use the log-in account from YOUR GOLF and <br>GOLF NETWORK PLUS Applications. <br>It is used for both the application and website.',
	      'LOGIN_GUIDE_TINY': 'You can use the log-in account from YOUR GOLF <br>and GOLF NETWORK PLUS Applications. <br>It is used for both the application and website.',
	      'ERROR': 'The email and password you entered did not match. Please check and try again.',
	      'SIGN_UP_SUP': 'If you are a first time visitor, please sign up from here.',
	      'SIGN_UP_SUP_TINY': 'If you are a first time visitor <br>please sign up from here.'
	    }
	  }
	};


/***/ }),
/* 268 */
/***/ (function(module, exports) {

	module.exports = {
	  '_SESSION': {
	    'NEW': {
	      'TITLE': '@:_SESSION.NEW.SIGN_IN',
	      'SIGN_IN': 'ログイン',
	      'LOCK_ACCOUNT': 'アカウント保護のため、ログインをロックしました。しばらくしてから再度お試しください。',
	      'EMAIL_ADDR': 'メールアドレス',
	      'PASSWORD': 'パスワード',
	      'FORGOT_PASSWORD': 'パスワードを忘れた方はこちら',
	      'LOGIN_GUIDE': 'ログインアカウントは、アプリ／Web共通です。 <br>YOUR GOLF または GOLF NETWORK PLUS アプリを <br>既にお使いの方は、同じアカウントでログインできます。',
	      'LOGIN_GUIDE_TINY': 'ログインアカウントは、アプリ／Web共通です。 <br>YOUR GOLF または GOLF NETWORK PLUS アプリを <br>既にお使いの方は <br>同じアカウントでログインできます。',
	      'ERROR': 'メールアドレスとパスワードの組み合わせが見つかりません。ご確認の上再度お試し下さい。',
	      'SIGN_UP_SUP': 'YOUR GOLF または GOLF NETWORK PLUS アプリを <br>使ったことがない方は、こちらから新規登録しご利用ください。',
	      'SIGN_UP_SUP_TINY': 'YOUR GOLF または <br>GOLF NETWORK PLUS アプリを <br>使ったことがない方は,<br>こちらから新規登録しご利用ください。'
	    }
	  }
	};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var PaidIntroductionCtrl, modules;
	
	__webpack_require__(270);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(82);
	
	__webpack_require__(108);
	
	__webpack_require__(274);
	
	__webpack_require__(301);
	
	PaidIntroductionCtrl = __webpack_require__(305);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-payment'];
	
	angular.module('gnp-app-paid-introduction', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/paid-introduction', {
	      templateUrl: 'web/paid-introduction/paid-introduction.jade',
	      controller: 'PaidIntroductionCtrl',
	      title: '_PAID_INTRO.PAGE_TITLE'
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(306)).translations('ja', __webpack_require__(307));
	  }
	]).controller('PaidIntroductionCtrl', PaidIntroductionCtrl);


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"payment-intro\" gnp-common-wrapper-b=\"\"><div class=\"intro-header\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"intro-message\"><h1>{{ :: '_PAID_INTRO.TITLE' | translate }}</h1><h3>{{ :: '_PAID_INTRO.SUB_TITLE' | translate }}</h3><hr class=\"intro-divider\"/></div></div></div></div></div><div class=\"content-section-b\"><h3><center>{{ :: '_PAID_INTRO.FEE' | translate }}</center></h3></div><div class=\"content-section-a\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-5 col-sm-6\"><hr class=\"section-heading-spacer\"/><div class=\"clearfix\"></div><h2 class=\"section-heading\">{{ :: '_PAID_INTRO.SETTING' | translate }}</h2><p class=\"lead\">{{ :: '_PAID_INTRO.SETTING_CONTENT' | translate }}</p></div><div class=\"col-lg-5 offset-lg-2 col-sm-6\"><img src=\"" + __webpack_require__(271) + "\" alt=\"\" class=\"img-fluid\"/></div></div></div></div><div class=\"content-section-b\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-5 offset-lg-1 col-sm-6 order-sm-2 order-lg-1\"><hr class=\"section-heading-spacer\"/><div class=\"clearfix\"></div><h2 class=\"section-heading\">{{ :: '_PAID_INTRO.COMPATION' | translate }}</h2><p class=\"lead\">{{ :: '_PAID_INTRO.COMPATION_CONTENT' | translate }}</p></div><div class=\"col-lg-5 col-sm-6 order-sm-1 order-lg-2\"><img src=\"" + __webpack_require__(272) + "\" alt=\"\" class=\"img-fluid\"/></div></div></div></div><div class=\"content-section-a\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-5 col-sm-6\"><hr class=\"section-heading-spacer\"/><div class=\"clearfix\"></div><h2 class=\"section-heading\">{{ :: '_PAID_INTRO.PC' | translate }}</h2><p class=\"lead\">{{ :: '_PAID_INTRO.PC_CONTENT' | translate }}</p></div><div class=\"col-lg-5 offset-lg-2 col-sm-6\"><img src=\"" + __webpack_require__(273) + "\" alt=\"\" class=\"img-fluid\"/></div></div></div></div><div class=\"content-section-b\"><h3><center><br/>{{ :: '_PAID_INTRO.ENSURE' | translate }}</center></h3></div><div class=\"banner\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-8\"><h2>{{ :: '_PAID_INTRO.REGISTER' | translate }}</h2></div><div class=\"col-lg-4\"><ul class=\"list-inline banner-social-buttons\"><li><a ng-click=\"paid()\" class=\"btnPaid\"><p class=\"btnTitle\">{{ :: '_PAID_INTRO.BTN_TITLE' | translate }}</p><p class=\"btnNote\">{{ :: '_PAID_INTRO.BTN_NOTE' | translate }}</p></a></li></ul></div></div></div></div><footer><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"></div></div></div></footer></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/paid-introduction/paid-introduction.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6c2a7a0760aaf8096e4ffdcd53904ed4.jpg";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "77141498e9e3578c2e4333f9101ae05c.jpg";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "39e23c6ba6e51f48d4e1a3f6a837f707.jpg";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var CancelModalCtrl, CancelModalService, PayModalCtrl, PayModalService, PaymentInterceptor, PaymentLocationInterceptor, PaymentService, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(33);
	
	__webpack_require__(115);
	
	__webpack_require__(59);
	
	__webpack_require__(275);
	
	__webpack_require__(278);
	
	__webpack_require__(76);
	
	PaymentService = __webpack_require__(285);
	
	PayModalService = __webpack_require__(293);
	
	PayModalCtrl = __webpack_require__(294);
	
	CancelModalService = __webpack_require__(295);
	
	CancelModalCtrl = __webpack_require__(296);
	
	PaymentLocationInterceptor = __webpack_require__(297);
	
	PaymentInterceptor = __webpack_require__(298);
	
	modules = ['ngRoute', 'ngCookies', 'ui.bootstrap', 'gnp-translation', 'gnp-location-tracking', 'gnp-remote-api', 'gnp-auth'];
	
	angular.module('gnp-payment', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/unlock', {
	      redirectTo: '/',
	      permission: {
	        signInRequired: true,
	        paymentRequired: true
	      }
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(299)).translations('ja', __webpack_require__(300));
	  }
	]).controller('PayModalCtrl', PayModalCtrl).controller('CancelModalCtrl', CancelModalCtrl).factory('PaymentService', PaymentService).factory('PayModalService', PayModalService).factory('CancelModalService', CancelModalService).run(PaymentLocationInterceptor).run(PaymentInterceptor);


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var LocationTrackingInterceptor, LocationTrackingService;
	
	__webpack_require__(28);
	
	LocationTrackingService = __webpack_require__(276);
	
	LocationTrackingInterceptor = __webpack_require__(277);
	
	angular.module('gnp-location-tracking', []).factory('LocationTrackingService', LocationTrackingService).run(LocationTrackingInterceptor);


/***/ }),
/* 276 */
/***/ (function(module, exports) {

	var LocationTrackingService;
	
	LocationTrackingService = function($rootScope, $location) {
	  var locationHistories;
	  locationHistories = ['/'];
	  return {
	    saveLocation: function() {
	      var currentLocation;
	      currentLocation = $location.path();
	      locationHistories.push(currentLocation);
	      if (locationHistories.length > 2) {
	        return locationHistories.shift();
	      }
	    },
	    currentLocation: function() {
	      return (locationHistories != null ? locationHistories[1] : void 0) || locationHistories[0];
	    },
	    previousLocation: function() {
	      return locationHistories[0];
	    }
	  };
	};
	
	LocationTrackingService.$inject = ["$rootScope", "$location"];
	
	module.exports = LocationTrackingService;


/***/ }),
/* 277 */
/***/ (function(module, exports) {

	var LocationTrackingInterceptor;
	
	LocationTrackingInterceptor = function($rootScope, $location, LocationTrackingService) {
	  return $rootScope.$on("$locationChangeSuccess", function(event) {
	    return LocationTrackingService.saveLocation();
	  });
	};
	
	LocationTrackingInterceptor.$inject = ["$rootScope", "$location", "LocationTrackingService"];
	
	module.exports = LocationTrackingInterceptor;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var AppSettingAPIService, CountryAPIService, GoalAPIService, PlayerAPIService, RoundAPIService, ScoreCardAPIService;
	
	__webpack_require__(28);
	
	__webpack_require__(89);
	
	GoalAPIService = __webpack_require__(279);
	
	ScoreCardAPIService = __webpack_require__(280);
	
	CountryAPIService = __webpack_require__(281);
	
	AppSettingAPIService = __webpack_require__(282);
	
	RoundAPIService = __webpack_require__(283);
	
	PlayerAPIService = __webpack_require__(284);
	
	angular.module('gnp-remote-api', ['gnp-cache']).factory('CountryAPIService', CountryAPIService).factory("GoalAPIService", GoalAPIService).factory("ScoreCardAPIService", ScoreCardAPIService).factory("AppSettingAPIService", AppSettingAPIService).factory('RoundAPIService', RoundAPIService).factory('PlayerAPIService', PlayerAPIService);


/***/ }),
/* 279 */
/***/ (function(module, exports) {

	var GoalAPIService;
	
	GoalAPIService = function($http, $q) {
	  return {
	    getGoalSettings: function(params) {
	      var defer;
	      defer = $q.defer();
	      $http.get('/api/settings/goal.json', {
	        params: params
	      }).then(function(resp) {
	        return defer.resolve(resp.data);
	      }, function(error) {
	        return defer.resolve({
	          avg_total_shot: null,
	          avg_putt: null,
	          rat_fairway_center: null,
	          rat_par_on: null,
	          rat_recovery: null
	        });
	      });
	      return defer.promise;
	    }
	  };
	};
	
	GoalAPIService.$inject = ['$http', '$q'];
	
	module.exports = GoalAPIService;


/***/ }),
/* 280 */
/***/ (function(module, exports) {

	var ScoreCardAPIService;
	
	ScoreCardAPIService = function($http, $q, cache) {
	  return {
	    getMyAvg: function(id, params) {
	      return $http.get("/api/users/" + id + "/score_cards/analysis.json", {
	        params: params
	      });
	    },
	    getBestWorst: function(id, params) {
	      return $http.get("/api/users/" + id + "/score_cards/best_worst_analysis.json", {
	        params: params
	      });
	    },
	    getAllMembers: function(params) {
	      var defer;
	      defer = $q.defer();
	      $http.get("/api/score_cards/all/analysis.json", {
	        params: params
	      }).then(function(resp) {
	        return defer.resolve(resp.data);
	      });
	      return defer.promise;
	    },
	    getAllMembersByEvent: function(id, params) {
	      var allMembersInfoEvent, defer;
	      defer = $q.defer();
	      allMembersInfoEvent = cache.get('allMembersInfoEvent');
	      if ((allMembersInfoEvent != null) && allMembersInfoEvent.event_id === ("" + id)) {
	        defer.resolve(allMembersInfoEvent);
	      } else {
	        $http.get("/api/group_events/" + id + "/analysis.json", {
	          params: params
	        }).then(function(resp) {
	          resp.data.event_id = id;
	          cache.put('allMembersInfoEvent', resp.data);
	          return defer.resolve(resp.data);
	        });
	      }
	      return defer.promise;
	    },
	    clearAllMembersByEventData: function(id) {
	      var allMembersInfoEvent;
	      allMembersInfoEvent = cache.get('allMembersInfoEvent');
	      if ((allMembersInfoEvent != null) && allMembersInfoEvent.event_id === ("" + id)) {
	        return cache.remove('allMembersInfoEvent');
	      }
	    }
	  };
	};
	
	ScoreCardAPIService.$inject = ['$http', '$q', 'cache'];
	
	module.exports = ScoreCardAPIService;


/***/ }),
/* 281 */
/***/ (function(module, exports) {

	var CountryAPIService;
	
	CountryAPIService = function($http, $q, $location, cache) {
	  return {
	    fromJapan: function() {
	      var delay, fromJapan, params, ref;
	      fromJapan = cache.get("fromJapan");
	      delay = $q.defer();
	      if (!fromJapan) {
	        params = {
	          fake_ip: (ref = $location.search()) != null ? ref.fake_ip : void 0
	        };
	        $http.get('/api/geoip.json', {
	          params: params
	        }).then(function(resp) {
	          var ref1;
	          fromJapan = ((ref1 = resp.data.country) != null ? ref1.country_code2 : void 0) === 'JP';
	          cache.put("fromJapan", fromJapan);
	          return delay.resolve(fromJapan);
	        }, function(error) {
	          return delay.resolve(null);
	        });
	      } else {
	        delay.resolve(fromJapan);
	      }
	      return delay.promise;
	    }
	  };
	};
	
	CountryAPIService.$inject = ['$http', '$q', '$location', 'cache'];
	
	module.exports = CountryAPIService;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

	var AppSettingAPIService;
	
	AppSettingAPIService = function($http, $q, cache) {
	  return {
	    getAppSetting: function(params) {
	      var appSetting, delay;
	      if (params == null) {
	        params = {};
	      }
	      appSetting = cache.get("appSetting");
	      delay = $q.defer();
	      if (!appSetting) {
	        $http.get('/api/settings/app.json', {
	          params: params
	        }).then(function(resp) {
	          cache.put("appSetting", resp.data);
	          return delay.resolve(resp.data);
	        }, function(error) {
	          return delay.resolve(null);
	        });
	      } else {
	        delay.resolve(appSetting);
	      }
	      return delay.promise;
	    },
	    update: function(params) {
	      return $http.put('/api/settings/app.json', params).then(function() {
	        return cache.remove("appSetting");
	      });
	    }
	  };
	};
	
	AppSettingAPIService.$inject = ['$http', '$q', 'cache'];
	
	module.exports = AppSettingAPIService;


/***/ }),
/* 283 */
/***/ (function(module, exports) {

	var RoundAPIService;
	
	RoundAPIService = function($http, $q, $location) {
	  var rounds;
	  rounds = {};
	  return {
	    getRound: function(id, fromRoundDetail, params) {
	      var delay, round;
	      if (fromRoundDetail) {
	        rounds[id] = null;
	      }
	      round = rounds[id];
	      delay = $q.defer();
	      if (!round) {
	        $http.get("/api/score_cards/" + id + ".json", {
	          params: params
	        }).then(function(resp) {
	          rounds[id] = resp.data;
	          return delay.resolve(resp.data);
	        }, function(error) {
	          if (error.data.code === 'error.resource_not_found') {
	            $location.path('/');
	          }
	          return delay.reject(error.data);
	        });
	      } else {
	        delay.resolve(round);
	      }
	      return delay.promise;
	    },
	    uploadScore: function(params) {
	      return $http.post('/api/score_cards/upload.json', params).then(function(resp) {
	        return rounds[resp.data.id] = null;
	      });
	    }
	  };
	};
	
	RoundAPIService.$inject = ['$http', '$q', '$location'];
	
	module.exports = RoundAPIService;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var PlayerAPIService, _;
	
	_ = __webpack_require__(87);
	
	PlayerAPIService = function($rootScope, $http, $q) {
	  var owner;
	  owner = null;
	  $rootScope.$on('signedIn.gnp.authService', function() {
	    return owner = null;
	  });
	  $rootScope.$on('accountUpdated.gnp.AccountService', function() {
	    return owner = null;
	  });
	  return {
	    clearOwnerCache: function() {
	      return owner = null;
	    },
	    search: function(query) {
	      var delay, url;
	      url = "/api/players/search.json";
	      delay = $q.defer();
	      $http.get(url, {
	        params: {
	          q: query
	        }
	      }).then(function(resp) {
	        return delay.resolve(reesp.data);
	      });
	      return delay.promise;
	    },
	    getOwnerPlayer: function() {
	      var delay;
	      delay = $q.defer();
	      if (!owner) {
	        $http.get("/api/players/me.json").then(function(resp) {
	          resp.data.scores = [];
	          owner = resp.data;
	          return delay.resolve(owner);
	        });
	      } else {
	        delay.resolve(owner);
	      }
	      return delay.promise;
	    },
	    savePlayers: function(players) {
	      var data;
	      data = _.reject(players, function(p) {
	        return !p.name;
	      });
	      return $http.put("/api/players/batch_update.json", {
	        players: data
	      });
	    }
	  };
	};
	
	PlayerAPIService.$inject = ['$rootScope', '$http', '$q'];
	
	module.exports = PlayerAPIService;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var PaymentService;
	
	__webpack_require__(286);
	
	__webpack_require__(290);
	
	__webpack_require__(291);
	
	__webpack_require__(292);
	
	PaymentService = function($rootScope, $modal, $cookies) {
	  var paidFrom;
	  paidFrom = void 0;
	  $rootScope.$on('accountLoaded.gnp.AccountService', function(event, userInfo) {
	    return paidFrom = userInfo.payment_company;
	  });
	  return {
	    payModal: function() {
	      return $modal.open({
	        size: 'lg',
	        templateUrl: 'payment/pay-modal/pay-modal.jade',
	        controller: 'PayModalCtrl'
	      });
	    },
	    paid: function() {
	      var paidValue;
	      paidValue = $cookies.get('paid');
	      return paidValue === 'true';
	    },
	    openCancelModal: function() {
	      var templatePrefix;
	      switch (paidFrom) {
	        case 'SBPS':
	        case 'PayPal':
	          templatePrefix = 'web';
	          break;
	        case 'Apple':
	        case 'Google':
	          templatePrefix = 'app';
	          break;
	        default:
	          templatePrefix = 'tv';
	      }
	      return $modal.open({
	        size: 'lg',
	        templateUrl: "payment/cancel-modal/" + templatePrefix + "-cancel-modal.jade",
	        controller: 'CancelModalCtrl'
	      });
	    }
	  };
	};
	
	PaymentService.$inject = ["$rootScope", "$modal", "$cookies"];
	
	module.exports = PaymentService;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"pay_modal-main\" class=\"pay-modal\"><div class=\"modal-header\"><h5 class=\"modal-title\">{{:: '_PAYMENT.INTRO.TITLE' | translate }}</h5><button type=\"button\" data-bs-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\" class=\"close\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"modal-body container\"><div class=\"content\"><div class=\"col-12 row\"><div class=\"col-11 blank\"></div></div><div class=\"col-12 row\"><div class=\"col-1 blank\"></div><div class=\"col-10 title1\"> {{:: '_PAYMENT.INTRO.TITLE1' | translate }}</div><div class=\"col-1 blank\"></div></div><div class=\"col-12 row\"><div class=\"col-1 blank\"></div><div class=\"col-10 title2\">{{:: '_PAYMENT.INTRO.TITLE2' | translate }}</div><div class=\"col-1 blank\"></div></div><div class=\"col-12 row\"><div class=\"col-1 blank\"></div><div class=\"col-10 title3\">{{:: '_PAYMENT.INTRO.TITLE3' | translate }}</div><div class=\"col-1 blank\"></div></div><div class=\"col-12 row\"><div class=\"col-1 blank\"></div><div class=\"col-3\"><img src=\"" + __webpack_require__(287) + "\"/></div><div class=\"col-4 img\"><img src=\"" + __webpack_require__(288) + "\"/></div><div class=\"col-3\"><img src=\"" + __webpack_require__(289) + "\"/></div><div class=\"col-1 blank\"></div></div><div class=\"col-12 row\"><div class=\"col-1 blank\"></div><div class=\"col-3 content1 a\">{{:: '_PAYMENT.INTRO.CONTENT1' | translate }}</div><div class=\"col-4 content1 b\">{{:: '_PAYMENT.INTRO.CONTENT2' | translate }}</div><div class=\"col-3 content1 c\">{{:: '_PAYMENT.INTRO.CONTENT3' | translate }}</div><div class=\"col-1 blank\"></div></div><div class=\"col-12 row\"><div class=\"col-1 blank\"></div><div class=\"col-3 content2 a\">{{:: '_PAYMENT.INTRO.DESCRIPTION1' | translate }}</div><div class=\"col-4 content2 b\">{{:: '_PAYMENT.INTRO.DESCRIPTION2' | translate }}</div><div class=\"col-3 content2 c\">{{:: '_PAYMENT.INTRO.DESCRIPTION3' | translate }}</div><div class=\"col-1 blank\"></div></div><div class=\"col-12 row\"><button type=\"button\" ng-click=\"ok()\" ng-style=\"{'width':'260px'}\" class=\"btn btn-more btn-hint\">{{:: '_PAYMENT.INTRO.BUTTON_SPECIAL' | translate }}<p class=\"hint\">{{:: '_PAYMENT.INTRO.BUTTON_SPECIAL_HINT' | translate }}</p></button></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("payment/pay-modal/pay-modal.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 287 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	var v1="<div id=\"app_cancellation_modal-main\"><div class=\"modal-header\"><button type=\"button\" data-bs-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\" class=\"close\"><span aria-hidden=\"true\">&times;</span></button><h5 class=\"modal-title\">{{:: 'UNSUBSCRIBE' | translate }}</h5></div><div class=\"modal-body container container_fix\"><div class=\"content content_fix\"><div class=\"col-12 row\"><div class=\"col-11\"></div></div><div class=\"row paragraph\"><div class=\"col-1\"></div><div class=\"col-10 title6\">{{:: '_PAYMENT.APP_CANCEL.HEADER' | translate }}<br/>{{:: '_PAYMENT.APP_CANCEL.HEADER_TEXT1' | translate }}<br/>{{:: '_PAYMENT.APP_CANCEL.HEADER_TEXT2' | translate }}</div><div class=\"col-1\"></div></div><div class=\"row paragraph\"><div class=\"col-1\"></div><div class=\"col-10 title3\"><span class=\"note\">{{:: '_PAYMENT.APP_CANCEL.EXPLAIN' | translate }}</span><br/>{{:: '_PAYMENT.APP_CANCEL.EXPLAIN_TEXT1' | translate }}<br/>{{:: '_PAYMENT.APP_CANCEL.EXPLAIN_TEXT2' | translate }}</div><div class=\"col-1\"></div></div><div class=\"row paragraph\"><div class=\"col-1\"></div><div class=\"col-10 title3\">{{:: '_PAYMENT.APP_CANCEL.LIST' | translate }}</div></div><div class=\"row paragraph\"><div class=\"col-1\"></div><div class=\"col-10 title3\">{{:: '_PAYMENT.APP_CANCEL.GOOGLE_HEADER' | translate }}<br/>{{:: '_PAYMENT.APP_CANCEL.GOOGLE_TEXT1' | translate }}<br/>{{:: '_PAYMENT.APP_CANCEL.GOOGLE_TEXT2' | translate }}<br/>{{:: '_PAYMENT.APP_CANCEL.GOOGLE_TEXT3' | translate }}</div><div class=\"col-1\"></div></div><div class=\"row paragraph\"><div class=\"col-1\"></div><div class=\"col-10 title3\">{{:: '_PAYMENT.APP_CANCEL.APPLE_HEADER' | translate }}<br/>{{:: '_PAYMENT.APP_CANCEL.APPLE_TEXT1' | translate }}<br/>{{:: '_PAYMENT.APP_CANCEL.APPLE_TEXT2' | translate }}<br/>{{:: '_PAYMENT.APP_CANCEL.APPLE_TEXT3' | translate }}</div><div class=\"col-1\"></div></div><div class=\"row\"><div class=\"col-4\"></div><button type=\"submit\" ng-click=\"cancel()\" ng-style=\"{&quot;width&quot;:&quot;260px&quot;}\" class=\"col-4 btn btn-more\">{{:: 'CLOSE' | translate }}</button><div class=\"col-4\"></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("payment/cancel-modal/app-cancel-modal.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	var v1="<div id=\"tv_cancelation_modal-main\"><div class=\"modal-header\"><button type=\"button\" data-bs-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\" class=\"close\"><span aria-hidden=\"true\">&times;</span></button><h5 class=\"modal-title\">{{:: 'UNSUBSCRIBE' | translate }}</h5></div><div class=\"modal-body container container_fix\"><div class=\"content content_fix\"><div class=\"col-12 row\"><div class=\"col-11\"></div></div><div class=\"row paragraph\"><div class=\"col-1\"></div><div class=\"col-10 title6\">{{:: '_PAYMENT.TV_CANCEL.HEADER' | translate }}<br/>{{:: '_PAYMENT.TV_CANCEL.HEADER_TEXT1' | translate }}<br/>{{:: '_PAYMENT.TV_CANCEL.HEADER_TEXT2' | translate }}</div><div class=\"col-1\"></div></div><div class=\"row paragraph\"><div class=\"col-1\"></div><div class=\"col-10 title3\">{{:: '_PAYMENT.TV_CANCEL.DESCRIPTION1' | translate }}<br/>{{:: '_PAYMENT.TV_CANCEL.DESCRIPTION2' | translate }}</div><div class=\"col-1\"></div></div><div class=\"row paragraph\"><div class=\"col-1\"></div><div class=\"col-10 title3\"><a href=\"https://tv.golfnetwork.co.jp\" target=\"_blank\" class=\"note\">{{:: '_PAYMENT.TV_CANCEL.DESCRIPTION3' | translate }}</a></div></div><div class=\"row\"><div class=\"col-4\"></div><button type=\"submit\" ng-click=\"cancel()\" ng-style=\"{&quot;width&quot;:&quot;260px&quot;}\" class=\"col-4 btn btn-more\">{{:: 'CLOSE' | translate }}</button><div class=\"col-4\"></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("payment/cancel-modal/tv-cancel-modal.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"web_cancellation_modal-main\"><div class=\"modal-header\"><button type=\"button\" data-bs-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\" class=\"close\"><span aria-hidden=\"true\">&times;</span></button><h5 class=\"modal-title\">{{:: 'UNSUBSCRIBE' | translate }}</h5></div><div class=\"modal-body container container_fix\"><div class=\"content content_fix\"><div class=\"col-12 row\"><div class=\"col-11 blank\"></div></div><div class=\"row\"><div class=\"col-1 blank\"></div><div class=\"col-10 title1\">{{:: '_PAYMENT.WEB_CANCEL.HEADER' | translate }}</div><div class=\"col-1 blank\"></div></div><div class=\"row\"><div class=\"col-1 blank\"></div><div class=\"col-10 title2\">{{:: '_PAYMENT.WEB_CANCEL.TITLE' | translate }}</div></div><div class=\"row\"><div class=\"col-1 blank\"></div><div class=\"col-3 img\"><img src=\"" + __webpack_require__(287) + "\"/></div><div class=\"col-4 img map\"><img src=\"" + __webpack_require__(288) + "\"/></div><div class=\"col-3 ing\"><img src=\"" + __webpack_require__(289) + "\"/></div><div class=\"col-1 blank\"></div></div><div class=\"row\"><div class=\"col-1 blank\"></div><div class=\"col-3 content1\">{{:: '_PAYMENT.INTRO.CONTENT1' | translate }}</div><div class=\"col-4 content1\">{{:: '_PAYMENT.INTRO.CONTENT2' | translate }}</div><div class=\"col-3 content1\">{{:: '_PAYMENT.INTRO.CONTENT3' | translate }}</div><div class=\"col-1 blank\"></div></div><div class=\"row\"><div class=\"col-1 blank\"></div><div class=\"col-10 title3\">{{:: '_PAYMENT.WEB_CANCEL.TEXT_CONTENT_PART1' | translate }}<br/>{{:: '_PAYMENT.WEB_CANCEL.TEXT_CONTENT_PART2' | translate }}</div><div class=\"col-1 blank\"></div></div><div class=\"row\"><div class=\"col-2 blank\"></div><div class=\"col-4 l-btn\"><button type=\"submit\" ng-click=\"ok()\" class=\"btn btn-more\">{{:: 'UNSUBSCRIBE' | translate }}</button></div><div class=\"col-4 r-btn\"><button type=\"submit\" ng-click=\"cancel()\" class=\"btn btn-more\">{{:: 'CLOSE' | translate }}</button></div><div class=\"col-2 blank\"></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("payment/cancel-modal/web-cancel-modal.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	var PayModalService;
	
	PayModalService = function($window, $location, AuthService, returnUrl) {
	  return {
	    navigateToPayment: function() {
	      var paymentUrl, url;
	      url = encodeURIComponent("/");
	      paymentUrl = "/payment/new?return_url=" + url + "&start_url=" + url;
	      if (AuthService.isSignedIn()) {
	        return $window.location = paymentUrl;
	      } else {
	        returnUrl.url = paymentUrl;
	        returnUrl.external = true;
	        return $location.path('/session/new');
	      }
	    }
	  };
	};
	
	PayModalService.$inject = ["$window", "$location", "AuthService", "returnUrl"];
	
	module.exports = PayModalService;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

	var PayModalCtrl;
	
	PayModalCtrl = function($scope, $modalInstance, PayModalService) {
	  $scope.ok = function() {
	    return PayModalService.navigateToPayment();
	  };
	  return $scope.cancel = function() {
	    return $modalInstance.dismiss('cancel');
	  };
	};
	
	PayModalCtrl.$inject = ['$scope', '$modalInstance', 'PayModalService'];
	
	module.exports = PayModalCtrl;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	var CancelModalService;
	
	CancelModalService = function($window) {
	  return {
	    startCancellation: function() {
	      var url;
	      url = encodeURIComponent("/");
	      return $window.location = "/payment/start_cancellation?return_url=" + url + "&start_url=" + url;
	    }
	  };
	};
	
	CancelModalService.$inject = ['$window'];
	
	module.exports = CancelModalService;


/***/ }),
/* 296 */
/***/ (function(module, exports) {

	var CancelModalCtrl;
	
	CancelModalCtrl = function($scope, $modalInstance, CancelModalService) {
	  $scope.ok = function() {
	    return CancelModalService.startCancellation();
	  };
	  return $scope.cancel = function() {
	    return $modalInstance.dismiss('cancel');
	  };
	};
	
	CancelModalCtrl.$inject = ['$scope', '$modalInstance', 'CancelModalService'];
	
	module.exports = CancelModalCtrl;


/***/ }),
/* 297 */
/***/ (function(module, exports) {

	var PaymentLocationInterceptor;
	
	PaymentLocationInterceptor = function($rootScope, $location, PaymentService, AuthService) {
	  var paymentRequired;
	  paymentRequired = function(route) {
	    var ref, ref1;
	    return route != null ? (ref = route.$$route) != null ? (ref1 = ref.permission) != null ? ref1.paymentRequired : void 0 : void 0 : void 0;
	  };
	  return $rootScope.$on("$routeChangeStart", function(event, next, current) {
	    if (PaymentService.paid()) {
	      return;
	    }
	    if (!paymentRequired(next)) {
	      return;
	    }
	    event.preventDefault();
	    if (!AuthService.isSignedIn()) {
	      return;
	    }
	    if (!current) {
	      $location.path('/');
	      return;
	    }
	    if (current.$$route.originalPath === '/session/new') {
	      $location.path('/');
	      return;
	    }
	    return PaymentService.payModal();
	  });
	};
	
	PaymentLocationInterceptor.$inject = ['$rootScope', '$location', 'PaymentService', 'AuthService'];
	
	module.exports = PaymentLocationInterceptor;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

	var PaymentInterceptor;
	
	PaymentInterceptor = function($rootScope, PaymentService) {
	  return $rootScope.$watch((function() {
	    return PaymentService.paid();
	  }), function(newValue) {
	    $rootScope.paid = PaymentService.paid();
	    return $rootScope.$broadcast('accountUpdated.gnp.AccountService');
	  });
	};
	
	PaymentInterceptor.$inject = ['$rootScope', 'PaymentService'];
	
	module.exports = PaymentInterceptor;


/***/ }),
/* 299 */
/***/ (function(module, exports) {

	module.exports = {
	  '_PAYMENT': {
	    'INTRO': {
	      'TITLE': 'Upgrade',
	      'BUTTON_SPECIAL': 'Special member',
	      'BUTTON_SPECIAL_HINT': '$5.00 per month (tax excluding)',
	      'TITLE1': 'To use this feature, you must be registered as a paid-member.',
	      'TITLE2': 'Analyze your abilities with more features!',
	      'TITLE3': 'When you register as a paid-member ($5.00 USD/mo.), you can use more detailed score analyses/course analyses to improve your game.',
	      'CONTENT1': 'Set your target',
	      'CONTENT2': 'Compare your scores, course-by-course',
	      'CONTENT3': 'Edit scores from your PC',
	      'DESCRIPTION1': 'Input your individual target data to improve upon your goals quickly and efficiently',
	      'DESCRIPTION2': 'Compare your personal round results with the course average',
	      'DESCRIPTION3': 'You can also edit your scoring data on your PC after you have entered it in the mobile app'
	    },
	    'WEB_CANCEL': {
	      'HEADER': 'Upon terminating your paid-membership, you will lose the ability to use the following functions.',
	      'TITLE': 'Features only available through paid-membership',
	      'TEXT_CONTENT_PART1': 'To cancel your membership, please press the "Unsubscribe" button below.',
	      'TEXT_CONTENT_PART2': 'For those who would like to continue using the features only provided through paid-membership, please press the "Close" button below.'
	    },
	    'APP_CANCEL': {
	      'HEADER': '[ATTENTION PLEASE]',
	      'HEADER_TEXT1': 'When you process the cancellation procedure, from that date, you will not be able to use the paid service anymore.',
	      'HEADER_TEXT2': 'Please be careful on that.',
	      'EXPLAIN': 'From the Web Service version as well as the Application version, the customer can not process the cancellation procedure for the paid membership.',
	      'EXPLAIN_TEXT1': 'Because the Google Play or Apple ID has been already registered to the paid subscribers,',
	      'EXPLAIN_TEXT2': 'you will therefore need to unsubscribe on each platform.',
	      'LIST': 'Please follow the manual as below.',
	      'GOOGLE_HEADER': '【If you use Google Play】',
	      'GOOGLE_TEXT1': 'From Google Play,',
	      'GOOGLE_TEXT2': 'Please open the GOLF NETWORK PLUS Application screen,',
	      'GOOGLE_TEXT3': 'then execute the cancellation of subscription that will appear on the screen.',
	      'APPLE_HEADER': '【If you use Apple ID Billing】',
	      'APPLE_TEXT1': 'From App Store,',
	      'APPLE_TEXT2': 'Recommendation > Apple ID (Login) > Subscription Management',
	      'APPLE_TEXT3': 'Please follow the cancellation procedure as describe above.'
	    },
	    'TV_CANCEL': {
	      'HEADER': '[ATTENTION PLEASE]',
	      'HEADER_TEXT1': 'When you process the cancellation procedure, from that date, you will not be able to use the paid service anymore.',
	      'HEADER_TEXT2': 'Please be careful on that.',
	      'DESCRIPTION1': 'Because you are registering to the paid membership on GN+ TV Web Service,',
	      'DESCRIPTION2': 'Please process the cancellation procedure from the following link',
	      'DESCRIPTION3': 'Process the cancellation ( It will transition to GN+ TV Web Service)'
	    }
	  }
	};


/***/ }),
/* 300 */
/***/ (function(module, exports) {

	module.exports = {
	  '_PAYMENT': {
	    'INTRO': {
	      'TITLE': 'アップグレード',
	      'BUTTON_SPECIAL': '有料会員になる',
	      'BUTTON_SPECIAL_HINT': '月額 500円（税抜)',
	      'TITLE1': 'この機能をお使いいただくには、有料会員への登録が必要です。',
	      'TITLE2': 'より充実した機能で、自分の実力を分析しよう！',
	      'TITLE3': '有料会員(月額５００円)にご登録いただくと、より詳細なスコア分析／コース分析を利用できます。',
	      'CONTENT1': '目標値の設定',
	      'CONTENT2': 'コース別スコアの比較',
	      'CONTENT3': 'ＰＣからのスコア編集',
	      'DESCRIPTION1': '目標を明確にすることが上達への近道、個人の目標データを入力しましょう。',
	      'DESCRIPTION2': '個人のラウンド結果やコース平均との比較ができます。',
	      'DESCRIPTION3': 'モバイルアプリで入力してスコアデータを後からＰＣで編集することも可能です。'
	    },
	    'WEB_CANCEL': {
	      'HEADER': '有料会員を解約すると、下記の限定機能がご利用いただけなくなります。',
	      'TITLE': '有料会員限定機能',
	      'TEXT_CONTENT_PART1': 'すぐに解約される方は、「解約する」ボタンより解約手続きを行ってください。',
	      'TEXT_CONTENT_PART2': '引き続きご利用いただく方は「閉じる」ボタンを押してください。'
	    },
	    'APP_CANCEL': {
	      'HEADER': '【ご注意ください】',
	      'HEADER_TEXT1': '解約手続きを行うと、その当日から有料サービスのご利用ができなくなります。',
	      'HEADER_TEXT2': 'あらかじめご了承ください。',
	      'EXPLAIN': 'お客様は、ウェブサービス版ならびにアプリ版から有料会員の解約を行うことができません。',
	      'EXPLAIN_TEXT1': 'Google Play もしくは Apple ID より有料会員にご登録いただいておりますので、',
	      'EXPLAIN_TEXT2': 'ご利用の各プラットフォームより、購読を中止頂く必要がございます。',
	      'LIST': '操作方法は、下記のとおりでございます。',
	      'GOOGLE_HEADER': '【Google Play をご利用の場合】',
	      'GOOGLE_TEXT1': 'Google Playより',
	      'GOOGLE_TEXT2': 'GOLF NETWORK PLUS アプリをご表示いただきまして、',
	      'GOOGLE_TEXT3': '画面内に表れます購読のキャンセルを実施してください。',
	      'APPLE_HEADER': '【Apple ID 課金をご利用の場合】',
	      'APPLE_TEXT1': 'App Storeより',
	      'APPLE_TEXT2': 'おすすめ＞Apple ID（ログイン）＞購読：管理',
	      'APPLE_TEXT3': '上記の操作にて、解約手続きに進んでください。'
	    },
	    'TV_CANCEL': {
	      'HEADER': '【ご注意ください】',
	      'HEADER_TEXT1': '解約手続きを行うと、その当日から有料サービスのご利用ができなくなります。',
	      'HEADER_TEXT2': 'あらかじめご了承ください。',
	      'DESCRIPTION1': 'お客様は、GN+ TV サイトより有料会員にご登録いただいておりますため、',
	      'DESCRIPTION2': '下記のリンクより解約手続きへお進みください。',
	      'DESCRIPTION3': '有料会員の解約手続き（GN+ TVサイトへ遷移します）'
	    }
	  }
	};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(302);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_paid_introduction.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_paid_introduction.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#payment-intro{font-size:14px;color:#555}#payment-intro h1,#payment-intro h2,#payment-intro h3,#payment-intro h4,#payment-intro h5,#payment-intro h6{font-family:\"Lato\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-weight:700}#payment-intro #gnp-header .btn-section{font-size:12px}#payment-intro .topnav{font-size:14px}#payment-intro .lead{font-size:18px;font-weight:400}#payment-intro .intro-header{padding-top:50px;padding-bottom:50px;text-align:center;color:#f8f8f8;background:url("+__webpack_require__(303)+") no-repeat center center;background-size:cover}#payment-intro .intro-message{position:relative;padding-top:20%;padding-bottom:20%}#payment-intro .intro-message h1{margin:0;font-size:5em}#payment-intro .intro-message h1,#payment-intro .intro-message h3{text-shadow:2px 2px 3px rgba(0,0,0,.6)}#payment-intro .intro-divider{width:320px;border-top:2px solid #f8f8f8;border-bottom:2px solid rgba(0,0,0,.2)}@media (max-width:767px){#payment-intro .intro-message{padding-bottom:15%}#payment-intro .intro-message h1{font-size:3em}#payment-intro ul.intro-social-buttons>li{display:block;margin-bottom:20px;padding:0}#payment-intro ul.intro-social-buttons>li:last-child{margin-bottom:0}#payment-intro .intro-divider{width:100%}}#payment-intro .network-name{text-transform:uppercase;font-size:14px;font-weight:400;letter-spacing:2px}#payment-intro .content-section-a{padding:50px 0;background-color:#f8f8f8}#payment-intro .content-section-b{background:#fff;padding:50px 0;border-top:1px solid #e7e7e7;border-bottom:1px solid #e7e7e7}#payment-intro .section-heading{margin-bottom:30px}#payment-intro .section-heading-spacer{float:left;width:200px;border-top:3px solid #e7e7e7}#payment-intro .banner{padding:100px 0;color:#f8f8f8;background:url("+__webpack_require__(304)+") no-repeat center center;background-size:cover}#payment-intro .banner h2{margin:0;text-shadow:2px 2px 3px rgba(0,0,0,.6);font-size:3em}#payment-intro .banner ul{margin-bottom:0}#payment-intro .banner-social-buttons{float:right;margin-top:0}#payment-intro .banner-social-buttons a.btnPaid{width:320px;height:60px;display:block;cursor:pointer;background:#03aed9;border:solid 2px #fff;color:#fff;text-shadow:2px 2px 6px #555;text-align:center}#payment-intro .banner-social-buttons a.btnPaid:hover{background:#1dcffd;text-decoration:none}#payment-intro .banner-social-buttons a.btnPaid p{margin:0;font-weight:700}#payment-intro .banner-social-buttons a.btnPaid p.btnTitle{font-size:24px}#payment-intro .banner-social-buttons a.btnPaid p.btnNote{font-size:15px}@media (max-width:1199px){#payment-intro ul.banner-social-buttons{float:left;margin-top:15px}}@media (max-width:767px){#payment-intro .banner h2{margin:0;text-shadow:2px 2px 3px rgba(0,0,0,.6);font-size:3em}#payment-intro ul.banner-social-buttons>li{display:block;margin-bottom:20px;padding:0}#payment-intro ul.banner-social-buttons>li:last-child{margin-bottom:0}}#payment-intro footer{padding:50px 0;background-color:#f8f8f8}#payment-intro p.copyright{margin:15px 0 0;font-weight:700}", ""]);

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0dd4556aa71638d9ea9c4928ae5f6d77.jpg";

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a40bd8fbc5f9c78b91022a66a1b04c85.jpg";

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	var PaidIntroductionCtrl;
	
	PaidIntroductionCtrl = function($scope, PayModalService) {
	  return $scope.paid = function() {
	    return PayModalService.navigateToPayment();
	  };
	};
	
	PaidIntroductionCtrl.$inject = ['$scope', 'PayModalService'];
	
	module.exports = PaidIntroductionCtrl;


/***/ }),
/* 306 */
/***/ (function(module, exports) {

	module.exports = {
	  '_PAID_INTRO': {
	    'PAGE_TITLE': 'GOLF NETWORK PLUS',
	    'TITLE': 'Use the new and improved features to analyze your golfing abilities!',
	    'SUB_TITLE': 'To utilized the improved features, you must be registered with a paid-membership',
	    'FEE': 'When you register as a paid-member (￥500/mo.) you can see more detailed course and score analyses',
	    'SETTING': 'Configure your target value',
	    'SETTING_CONTENT': 'Enter your personal score data to set your goals, see your progress, and improve your game',
	    'COMPATION': 'Compare your scores, course by course',
	    'COMPATION_CONTENT': 'Set your individual round results and scoring average',
	    'PC': 'Edit your scores directly from your PC',
	    'PC_CONTENT': 'Enter your scores through app and edit them from your PC at a later time',
	    'ENSURE': 'To utilize these great features, you must be registered with a paid-membership',
	    'REGISTER': 'Register for your paid-membership',
	    'BTN_TITLE': 'Become a paid member',
	    'BTN_NOTE': 'Pay ￥500/mo. (sales taxes not included)'
	  }
	};


/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports = {
	  '_PAID_INTRO': {
	    'PAGE_TITLE': 'GOLF NETWORK PLUS',
	    'TITLE': 'より充実した機能で、自分の実力を分析しよう！',
	    'SUB_TITLE': 'この機能をお使いいただくには、有料会員への登録が必要です。',
	    'FEE': '有料会員(月額５００円)にご登録いただくと、より詳細なスコア分析／コース分析を利用できます。',
	    'SETTING': '目標値の設定',
	    'SETTING_CONTENT': '目標を明確にすることが上達への近道、個人の目標データを入力しましょう。',
	    'COMPATION': 'コース別スコアの比較',
	    'COMPATION_CONTENT': '個人のラウンド結果やコース平均との比較ができます。',
	    'PC': 'ＰＣからのスコア編集',
	    'PC_CONTENT': 'モバイルアプリで入力してスコアデータを後からＰＣで編集することも可能です。',
	    'ENSURE': 'この機能をお使いいただくには、有料会員への登録が必要です。',
	    'REGISTER': '有料会員に登録する',
	    'BTN_TITLE': '有 料 会 員 に な る',
	    'BTN_NOTE': '月額５００円 (税抜)'
	  }
	};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	var PasswordEditCtrl, PasswordNewCtrl, PasswordService, modules;
	
	__webpack_require__(309);
	
	__webpack_require__(310);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(72);
	
	__webpack_require__(76);
	
	__webpack_require__(112);
	
	__webpack_require__(82);
	
	__webpack_require__(108);
	
	__webpack_require__(311);
	
	__webpack_require__(313);
	
	PasswordNewCtrl = __webpack_require__(315);
	
	PasswordEditCtrl = __webpack_require__(316);
	
	PasswordService = __webpack_require__(317);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-flash', 'gnp-auth', 'gnp-form', 'gnp-common-wrapper', 'gnp-error-handler'];
	
	angular.module('gnp-app-password', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/password/new', {
	      templateUrl: 'web/password/new.jade',
	      controller: 'PasswordNewCtrl',
	      title: '_PASSWORD.NEW.TITLE'
	    }).when('/password/edit/:reset_password_token', {
	      templateUrl: 'web/password/edit.jade',
	      controller: 'PasswordEditCtrl',
	      title: '_PASSWORD.EDIT.TITLE'
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(318)).translations('ja', __webpack_require__(319));
	  }
	]).controller('PasswordNewCtrl', PasswordNewCtrl).controller('PasswordEditCtrl', PasswordEditCtrl).factory('PasswordService', PasswordService);


/***/ }),
/* 309 */
/***/ (function(module, exports) {

	var v1="<div id=\"forgot_password-main\" gnp-common-wrapper-a=\"\"><div class=\"forgot container\"><div class=\"col-12\"><div class=\"title\">{{:: '_PASSWORD.NEW.TITLE' | translate }}</div></div><form name=\"newForm\" gnp-submit=\"submit()\" novalidate=\"\"><div class=\"col-12 content\"><div class=\"sub-title\">{{:: '_PASSWORD.NEW.PAGE_TITLE' | translate }}</div><div class=\"col-12 row\"><div class=\"col-4 label\">{{:: '_PASSWORD.NEW.EMAIL_ADDR' | translate }}</div><div class=\"col-8 error1\"><input placeholder=\"{{ '_PASSWORD.NEW.EMAIL_ADDR' | translate }}\" type=\"email\" name=\"email\" ng-model=\"account.email\" required=\"\" gnp-custom-email-validator=\"\" class=\"cell1\"/><div ng-show=\"newForm.email.$invalid &amp;&amp; !newForm.email.$pristine\" class=\"error\"><div ng-show=\"newForm.email.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</div><div ng-show=\"newForm.email.$error.email\">{{:: \"VALIDATION.EMAIL\" | translate }}</div></div></div><div class=\"col-1 blank\"></div></div><div class=\"col-12 row\"><button type=\"submit\" gnp-submitting-button=\"isSubmitting\" class=\"btn\">{{:: 'SEND' | translate }}</button></div></div></form></div></div><script>$(document.body).css('min-width', 0)</script>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/password/new.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	var v1="<div id=\"new_password-main\" gnp-common-wrapper-b=\"\"><div class=\"new container\"><div class=\"col-12 title-bar\"><span class=\"title\">{{:: '_PASSWORD.EDIT.TITLE' | translate }}</span></div><form name=\"editForm\" gnp-submit=\"submit()\" novalidate=\"\"><div class=\"col-12 content\"><div class=\"sub-title\">{{:: '_PASSWORD.EDIT.PAGE_TITLE' | translate }}</div><div class=\"row\"><div class=\"col-12 col-sm-2 label\"><div>{{:: '_PASSWORD.EDIT.NEW_PASSWORD' | translate }}</div></div><div class=\"col-12 col-sm-5 error1\"><input type=\"password\" name=\"password\" ng-model=\"params.password\" ng-minlength=\"10\" ng-maxlength=\"32\" required=\"\" ng-pattern=\"passwordPattern\" placeholder=\"{{ '_PASSWORD.EDIT.NEW_PASSWORD' | translate }}\" class=\"cell1\"/><div class=\"show-password-rule\"><p>{{:: \"_REGISTRATION.EDIT.RULE_PASSWORD_LABEL\" | translate }}</p></div><div ng-show=\"editForm.password.$invalid &amp;&amp; !editForm.password.$pristine\" class=\"error\"><div ng-show=\"editForm.password.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</div><div ng-show=\"editForm.password.$error.minlength\">{{:: \"VALIDATION.MIN_LENGTH\" | translate:'{\"n\": 10}' }}</div><div ng-show=\"editForm.password.$error.maxlength\">{{:: \"VALIDATION.MAX_LENGTH\" | translate:'{\"n\": 32}' }}</div><div ng-show=\"!editForm.password.$error.required &amp;&amp; !editForm.password.$error.minlength &amp;&amp; !editForm.password.$error.maxlength &amp;&amp; editForm.password.$error.pattern\">{{:: \"VALIDATION.STRENGTH\" | translate}}</div></div></div></div><div class=\"row\"><div class=\"col-12 col-sm-2 label sub-label\"><div>{{:: '_PASSWORD.EDIT.CONFIRM_PASSWORD' | translate }}</div></div><div class=\"col-12 col-sm-5 error2\"><input type=\"password\" name=\"password_confirmation\" ng-model=\"params.password_confirmation\" gnp-match-validate=\"params.password\" required=\"\" placeholder=\"{{ '_PASSWORD.EDIT.CONFIRM_PASSWORD' | translate }}\" class=\"cell1\"/><div ng-show=\"editForm.password_confirmation.$invalid &amp;&amp; !editForm.password_confirmation.$pristine\" class=\"error\"><div ng-show=\"editForm.password_confirmation.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</div><div ng-show=\"editForm.password_confirmation.$error.matchValidate\">{{:: \"VALIDATION.MATCH\" | translate }}</div></div></div></div><div class=\"row\"><button type=\"submit\" gnp-submitting-button=\"isSubmitting\" class=\"btn\">{{:: 'UPDATE' | translate }}</button></div></div></form></div></div><script>$(document.body).css('min-width', 0)</script>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/password/edit.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(312);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_forgot_password.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_forgot_password.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#forgot_password-main .forgot.container{max-width:970px}#forgot_password-main .cell{padding:0}#forgot_password-main .forgot.container{position:relative;min-height:500px}#forgot_password-main .forgot.container .blank{padding:0}#forgot_password-main .forgot.container .title{position:relative;width:290px;height:50px;margin:50px auto 0;padding:0;line-height:40px;text-align:center;font-size:22px;color:#01A5A3;border-bottom:3px solid #01A5A3}#forgot_password-main .forgot.container .content{position:relative;min-height:400px;width:100%;padding:60px 0 0;background-color:#fff}#forgot_password-main .forgot.container .content .sub-title{text-align:center;font-size:25px;color:#000}#forgot_password-main .forgot.container .content .row{min-height:75px;width:100%;padding-top:15px;margin:0}#forgot_password-main .forgot.container .content .row .error{background-color:transparent;text-align:left;padding:7px 10px 3px;color:#8a1f11}#forgot_password-main .forgot.container .content .row .error1{margin:25px 0 0 -15px}#forgot_password-main .forgot.container .content .row .label{top:43px;padding:0;font-size:14px;color:#000;font-weight:700;text-align:center}#forgot_password-main .forgot.container .content .row .cell1{position:relative;margin:3px 8px 0;font-size:15px;text-indent:10px;background-color:0;width:100%;height:40px;border-radius:5px;border-color:#e2e2e2;border-width:2px;border-style:solid}#forgot_password-main .forgot.container .content .row .btn{position:relative;left:50%;margin:25px 0 0 -90px;text-align:center;font-size:15px;line-height:0;color:#fff;background-color:#000;width:180px;height:40px;border-radius:5px;border-color:#000;border-width:2px;border-style:solid}", ""]);

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(314);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_new_password.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_new_password.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#new_password-main .cell{padding:0}#new_password-main .new.container{position:relative;min-height:500px}#new_password-main .new.container .blank{height:100px;padding:0}#new_password-main .new.container .title-bar{height:80px;text-align:center}#new_password-main .new.container .title-bar .title{position:relative;top:37px;padding:0 20px 8px;font-size:24px;color:#01a5a3;border-bottom:3px solid #01a5a3}#new_password-main .new.container .content{position:relative;min-height:400px;padding:60px 0 0;background-color:#fff}#new_password-main .new.container .content .sub-title{text-align:center;font-size:25px;color:#000}#new_password-main .new.container .content .row{min-height:75px;padding-top:20px;margin:0;padding-left:15px;padding-right:15px}#new_password-main .new.container .content .row.retry{margin-top:-60px}#new_password-main .new.container .content .row .error{background-color:transparent;text-align:left;padding:7px 10px 3px;color:#8a1f11}#new_password-main .new.container .content .row .error1{margin:25px 0 0 -15px}#new_password-main .new.container .content .row .error2{margin:-20px 0 0 -15px}#new_password-main .new.container .content .row .label{height:100px;top:43px;padding:0;font-size:14px;color:#000;font-weight:700;text-align:left}#new_password-main .new.container .content .row .label.sub-label{margin-top:-45px}#new_password-main .new.container .content .row .cell1{position:relative;margin:3px 8px 0;font-size:15px;text-indent:10px;background-color:0;width:100%;height:40px;border-radius:5px;border-color:#e2e2e2;border-width:2px;border-style:solid}#new_password-main .new.container .content .row .show-password-rule{margin:3px 8px 0}#new_password-main .new.container .content .row .btn{position:relative;left:50%;margin:-25px 0 0 -90px;text-align:center;font-size:15px;line-height:0;color:#fff;background-color:#000;width:180px;height:40px;border-radius:5px;border-color:#000;border-width:2px;border-style:solid}@media (min-width:769px){#new_password-main .new.container .content .row .label{margin-left:10%;margin-right:10%}}@media (max-width:768px){#new_password-main .new.container .content .row .label{height:20px;top:0}#new_password-main .new.container .content .row .label.sub-label{margin-top:10px}#new_password-main .new.container .content .row .error1,#new_password-main .new.container .content .row .error2{margin:0 0 0 -15px}#new_password-main .new.container .content .row .btn{margin:10px 0 0 -90px}}@media (max-width:768px){#new_password-main .new.container .content{padding-top:25px}}@media (max-width:768px){#new_password-main div.display-image{display:none}}", ""]);

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	var PasswordNewCtrl;
	
	PasswordNewCtrl = function($scope, $filter, $location, $routeParams, flash, PasswordService) {
	  $scope.account = {
	    email: $routeParams.email
	  };
	  $scope.isSubmitting = false;
	  return $scope.submit = function() {
	    $scope.success = $scope.error = false;
	    $scope.isSubmitting = true;
	    return PasswordService.create({
	      email: $scope.account.email
	    }).then(function(resp) {
	      return flash.success($filter('translate')('_PASSWORD.NEW.SUCCESS'));
	    })["catch"](function(resp) {
	      return flash.error($filter('translate')('_PASSWORD.NEW.ERROR'));
	    })["finally"](function() {
	      return $scope.isSubmitting = false;
	    });
	  };
	};
	
	PasswordNewCtrl.$inject = ['$scope', '$filter', '$location', '$routeParams', 'flash', 'PasswordService'];
	
	module.exports = PasswordNewCtrl;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

	var PasswordEditCtrl;
	
	PasswordEditCtrl = function($scope, $routeParams, $location, $filter, flash, PasswordService, AuthService) {
	  $scope.params = {
	    reset_password_token: $routeParams.reset_password_token
	  };
	  $scope.isSubmitting = false;
	  $scope.passwordPattern = /^(?=.{10,}$)((?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*\d))|(?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*[!"#$%&'()*+,\-\.\ \/:;<=>?@\[\\\]^_`{|}~]))|(?=(?:.*[a-z]))(?=(?:.*\d))(?=(?:.*[!"#$%&'()*+,\-\.\ \/:;<=>?@\[\\\]^_`{|}~]))|(?=(?:.*[A-Z]))(?=(?:.*\d))(?=(?:.*[!"#$%&'()*+,\-\.\ \/:;<=>?@\[\\\]^_`{|}~])))[A-Za-z\d!"#$%&'()*+,\-\.\ \/:;<=>?@\[\\\]^_`{|}~]+$/;
	  return $scope.submit = function() {
	    $scope.isSubmitting = true;
	    return PasswordService.update($scope.params).then(function(resp) {
	      flash.success($filter('translate')('API_SUCCESS'));
	      AuthService.signInBypass();
	      return $location.path('/');
	    })["catch"](function(resp) {
	      return flash.error($filter('translate')('API_ERROR'));
	    })["finally"](function() {
	      return $scope.isSubmitting = false;
	    });
	  };
	};
	
	PasswordEditCtrl.$inject = ['$scope', '$routeParams', '$location', '$filter', 'flash', 'PasswordService', 'AuthService'];
	
	module.exports = PasswordEditCtrl;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

	var PasswordService;
	
	PasswordService = function($http) {
	  return {
	    create: function(params) {
	      return $http.post('/api/users/password', params);
	    },
	    update: function(params) {
	      return $http.put('/api/users/password', params);
	    }
	  };
	};
	
	PasswordService.$inject = ['$http'];
	
	module.exports = PasswordService;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

	module.exports = {
	  '_PASSWORD': {
	    'NEW': {
	      'TITLE': 'Forgot Password',
	      'EMAIL_ADDR': 'Email Address',
	      'SUCCESS': 'You will receive an email with instructions about how to reset your password in a few minutes.',
	      'ERROR': 'Your email address was not found.',
	      'PAGE_TITLE': 'Forgot your password? Please enter your email address.'
	    },
	    'EDIT': {
	      'TITLE': 'Reset Password',
	      'PAGE_TITLE': 'Enter your new password.',
	      'NEW_PASSWORD': 'New Password',
	      'CONFIRM_PASSWORD': 'Confirm Password'
	    }
	  }
	};


/***/ }),
/* 319 */
/***/ (function(module, exports) {

	module.exports = {
	  '_PASSWORD': {
	    'NEW': {
	      'TITLE': 'パスワードを忘れた方はこちら',
	      'EMAIL_ADDR': 'メールアドレス',
	      'SUCCESS': 'パースワードのリセット方法を数分以内にメールでご連絡します。',
	      'ERROR': 'メールアドレスが見つかりません。',
	      'PAGE_TITLE': 'ご登録のメールアドレスを入力し、送信ボタンを押してください。'
	    },
	    'EDIT': {
	      'TITLE': 'パスワードリセット',
	      'PAGE_TITLE': '新しいパスワードを入力してください。',
	      'NEW_PASSWORD': '新しいパスワード',
	      'CONFIRM_PASSWORD': '新しいパスワード（確認）'
	    }
	  }
	};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var SettingEditCtrl, modules;
	
	__webpack_require__(321);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(72);
	
	__webpack_require__(82);
	
	__webpack_require__(108);
	
	__webpack_require__(274);
	
	__webpack_require__(278);
	
	__webpack_require__(322);
	
	SettingEditCtrl = __webpack_require__(324);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-flash', 'gnp-common-wrapper', 'gnp-error-handler', 'gnp-payment', 'gnp-remote-api'];
	
	angular.module('gnp-app-setting', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/setting/app', {
	      templateUrl: 'web/setting/edit.jade',
	      controller: 'SettingEditCtrl',
	      resolve: {
	        setting: [
	          'AppSettingAPIService', function(AppSettingAPIService) {
	            return AppSettingAPIService.getAppSetting();
	          }
	        ]
	      },
	      title: '_SETTING.TITLE',
	      permission: {
	        signInRequired: true
	      }
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(325)).translations('ja', __webpack_require__(326));
	  }
	]).controller('SettingEditCtrl', SettingEditCtrl);


/***/ }),
/* 321 */
/***/ (function(module, exports) {

	var v1="<div id=\"function_setting-main\" gnp-common-wrapper-a=\"\"><div class=\"container function\"><div class=\"col-12\"><div class=\"title\">{{ ::'_SETTING.TITLE' | translate }}</div></div><div class=\"col-12 content\"><form name=\"settingForm\"><div class=\"col-12 row\"><div class=\"line\"></div><div class=\"col-4 col-sm-3 label d-flex align-items-center\">{{ ::'_SETTING.DISTANCE_UNIT' | translate }}</div><div class=\"col-8 col-sm-9 no-padding\"><div class=\"switch ml-auto\"><input id=\"yard\" type=\"radio\" name=\"view2\" ng-value=\"false\" ng-model=\"setting.use_meter\" ng-change=\"submit(setting)\" class=\"switch-input\"/><label for=\"yard\" class=\"switch-label switch-label-off\">{{ ::'_SETTING.YARD' | translate }}</label><input id=\"metre\" type=\"radio\" name=\"view2\" ng-value=\"true\" ng-model=\"setting.use_meter\" ng-change=\"submit(setting)\" class=\"switch-input\"/><label for=\"metre\" class=\"switch-label switch-label-on\">{{ ::'_SETTING.METER' | translate }}</label><span class=\"switch-selection2\"></span></div></div></div><div class=\"col-12 row\"><div class=\"line\"></div><div class=\"col-4 col-sm-3 label d-flex align-items-center\">{{ ::'_FRIEND.TITLE' | translate }}</div><div class=\"col-8 col-sm-9 register-wrap\"><a href=\"/friend\" class=\"btn btn-more float-right\">{{ ::'_SETTING.EDIT_FRIEND' | translate }}</a></div></div><div class=\"col-12 row\"><div class=\"line\"></div><div class=\"col-4 col-sm-3 label d-flex align-items-center\">{{ ::'_SETTING.MEMBERSHIP' | translate }}</div><div class=\"col-8 offset-sm-5 col-sm-4 offset-md-6 col-md-3 label pay\"><div class=\"row mx-0\"><div class=\"col-7 no-padding text-right d-flex align-items-center\"><div ng-hide=\"$root.paid\">{{ ::'_SETTING.LBL_SUBSCRIBE' | translate }}</div><div ng-show=\"$root.paid\">{{ ::'_SETTING.LBL_UNSUBSCRIBE' | translate }}</div></div><div class=\"col-5 no-padding text-right d-flex align-items-center\"><a ng-hide=\"$root.paid\" href=\"/unlock\"><span>{{ ::'_SETTING.SUBSCRIBE' | translate }}</span></a><a href=\"javascript:void(0)\" ng-show=\"$root.paid\" ng-click=\"cancelPayment()\"><span>{{ ::'_SETTING.UNSUBSCRIBE' | translate }}</span></a></div></div></div></div><div class=\"col-12 row\"><div class=\"line\"></div></div></form></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/setting/edit.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(323);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_function_setting.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_function_setting.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#function_setting-main .container.function{max-width:none!important;width:970px}#function_setting-main .cell{padding:0}#function_setting-main .container.function{position:relative;height:630px}#function_setting-main .container.function .blank{height:100px;padding:0;opacity:0}#function_setting-main .container.function .title{position:relative;left:50%;width:160px;height:50px;margin:50px 0 0 -80px;line-height:40px;text-align:center;font-size:22px;color:#01a5a3;border-bottom:3px solid #01a5a3}#function_setting-main .container.function .content{position:relative;height:480px;width:100%;padding:50px 8% 0;background-color:#fff}#function_setting-main .container.function .content .row{height:100px;margin:0;padding:0}#function_setting-main .container.function .content .row .line{border:1px solid #e2e2e2;width:100%;height:0}#function_setting-main .container.function .content .row .label{position:relative;padding:0;font-size:15px;text-align:left;color:#000;line-height:0}#function_setting-main .container.function .content .row .no-padding{padding:0}#function_setting-main .container.function .content .row .switch{position:relative;margin:28px 0 20px -14px;padding:0;height:45px;width:175px;background:#cdcdcd;border-radius:3px}#function_setting-main .container.function .content .row .switch-label{position:relative;z-index:2;float:left;width:85px;line-height:46px;font-size:15px;color:#979797;text-align:center;cursor:pointer}#function_setting-main .container.function .content .row .switch-label-off{padding-left:2px;font-weight:400}#function_setting-main .container.function .content .row .switch-label-on{padding-left:8px;font-weight:400}#function_setting-main .container.function .content .row .switch-input{display:none}#function_setting-main .container.function .content .row .switch-input:checked+.switch-label{color:#fff;font-weight:400;transition:.15s ease-out}#function_setting-main .container.function .content .row .switch-input:checked+.switch-label-on~.switch-selection1,#function_setting-main .container.function .content .row .switch-input:checked+.switch-label-on~.switch-selection2{left:87px}#function_setting-main .container.function .content .row .switch-selection1{display:block;position:absolute;z-index:1;width:88px;height:45px;background:#8e8e8e;border-radius:3px;transition:left .15s ease-out}#function_setting-main .container.function .content .row .switch-selection2{display:block;position:absolute;z-index:1;width:88px;height:45px;background:#01a5a3;border-radius:3px;transition:left .15s ease-out}#function_setting-main .container.function .content .row .register-wrap{padding:28px 0}#function_setting-main .container.function .content .row .btn-more{position:relative;top:0%;font-size:15px;color:#fff;text-align:center;background-color:#01a5a3;width:177px;height:45px;border-radius:3px;border-color:#01a5a3;border-width:2px;border-style:solid;padding:8px 12px}@media (max-width:768px){#function_setting-main .container.function{width:100%}}@media (max-width:320px){#function_setting-main .container.function .content .row .label{font-size:13px}}#web_cancellation_modal-main .container_fix,#app_cancellation_modal-main .container_fix,#tv_cancelation_modal-main .container_fix{width:auto!important}#web_cancellation_modal-main .container_fix .content_fix,#app_cancellation_modal-main .container_fix .content_fix,#tv_cancelation_modal-main .container_fix .content_fix{position:initial;width:auto;top:0;left:0;margin:0 auto}#web_cancellation_modal-main .container_fix .content_fix .btn-more,#app_cancellation_modal-main .container_fix .content_fix .btn-more,#tv_cancelation_modal-main .container_fix .content_fix .btn-more{width:185px}#web_cancellation_modal-main .container,#web_cancellation_modal-main .container.function,#app_cancellation_modal-main .container,#app_cancellation_modal-main .container.function{height:600px;width:770px}#tv_cancelation_modal-main .container,#tv_cancelation_modal-main .container.function{width:770px}#web_cancellation_modal-main .content,#app_cancellation_modal-main .content,#tv_cancelation_modal-main .content{position:absolute;margin:-300px 0 0 -399px;top:50%;left:50%;min-height:600px;width:798px;background-color:#fff;z-index:5}#web_cancellation_modal-main .content .blank,#app_cancellation_modal-main .content .blank,#tv_cancelation_modal-main .content .blank{height:55px;padding:0;opacity:0}#web_cancellation_modal-main .content .row,#app_cancellation_modal-main .content .row,#tv_cancelation_modal-main .content .row{padding:0;margin:0}#web_cancellation_modal-main .content .paragraph,#app_cancellation_modal-main .content .paragraph,#tv_cancelation_modal-main .content .paragraph{padding-top:10px;padding-bottom:10px}#web_cancellation_modal-main .content .note,#app_cancellation_modal-main .content .note,#tv_cancelation_modal-main .content .note{color:red;text-decoration:underline}#web_cancellation_modal-main .content .x,#app_cancellation_modal-main .content .x,#tv_cancelation_modal-main .content .x{top:10px;left:2px}#web_cancellation_modal-main .content .title1,#app_cancellation_modal-main .content .title1,#tv_cancelation_modal-main .content .title1{min-height:32px;line-height:32px;text-align:center;font-size:14px;color:#000;background-color:#fa0;font-weight:700}#web_cancellation_modal-main .content .title2,#app_cancellation_modal-main .content .title2,#tv_cancelation_modal-main .content .title2{padding:0;font-size:19px;color:#000;font-weight:700}#web_cancellation_modal-main .content .title3,#app_cancellation_modal-main .content .title3,#tv_cancelation_modal-main .content .title3{padding:0;font-size:14px;color:#000}#web_cancellation_modal-main .content .title4,#app_cancellation_modal-main .content .title4,#tv_cancelation_modal-main .content .title4{padding:0;text-align:center;font-size:28px;color:#00adad}#web_cancellation_modal-main .content .title5,#app_cancellation_modal-main .content .title5,#tv_cancelation_modal-main .content .title5{padding:23px 0 20px;text-align:center;font-size:14px;font-weight:700;color:#000}#web_cancellation_modal-main .content .title6,#app_cancellation_modal-main .content .title6,#tv_cancelation_modal-main .content .title6{padding:15px;font-size:14px;color:#fff;background-color:#00adad}#web_cancellation_modal-main .content .img,#app_cancellation_modal-main .content .img,#tv_cancelation_modal-main .content .img{margin-top:-5px}#web_cancellation_modal-main .content .img.map,#app_cancellation_modal-main .content .img.map,#tv_cancelation_modal-main .content .img.map,#web_cancellation_modal-main .content .map,#app_cancellation_modal-main .content .map,#tv_cancelation_modal-main .content .map{padding-left:43px}#web_cancellation_modal-main .content .content1,#app_cancellation_modal-main .content .content1,#tv_cancelation_modal-main .content .content1{text-align:center;padding:20px 0 0;font-size:16px;font-weight:700;color:#00adad}#web_cancellation_modal-main .content .content2,#app_cancellation_modal-main .content .content2,#tv_cancelation_modal-main .content .content2{font-size:13px;color:#000}#web_cancellation_modal-main .content .content2.a,#app_cancellation_modal-main .content .content2.a,#tv_cancelation_modal-main .content .content2.a{padding:0}#web_cancellation_modal-main .content .content2.b,#app_cancellation_modal-main .content .content2.b,#tv_cancelation_modal-main .content .content2.b{padding:0 33px}#web_cancellation_modal-main .content .content2.c,#app_cancellation_modal-main .content .content2.c,#tv_cancelation_modal-main .content .content2.c{padding:0}#web_cancellation_modal-main .content .l-btn,#app_cancellation_modal-main .content .l-btn,#tv_cancelation_modal-main .content .l-btn{text-align:right}#web_cancellation_modal-main .content .r-btm,#app_cancellation_modal-main .content .r-btm,#tv_cancelation_modal-main .content .r-btm{text-align:left}#web_cancellation_modal-main .content .btn-more,#app_cancellation_modal-main .content .btn-more,#tv_cancelation_modal-main .content .btn-more,#web_cancellation_modal-main .content .submit-btn,#app_cancellation_modal-main .content .submit-btn,#tv_cancelation_modal-main .content .submit-btn{margin-top:40px;font-size:14px;color:#fff;background-color:#00adad;width:200px;height:45px;border-radius:5px;border-color:#00adad;border-width:2px;border-style:solid}#web_cancellation_modal-main .content .submit-btn,#app_cancellation_modal-main .content .submit-btn,#tv_cancelation_modal-main .content .submit-btn{position:relative;left:50%;margin-left:-100px}#app_cancellation_modal-main,#tv_cancelation_modal-main{border:10px solid #00adad}#tv_cancelation_modal-main .container,#tv_cancelation_modal-main .container.function,#tv_cancelation_modal-main .container .content,#tv_cancelation_modal-main .container.function .content{height:350px}", ""]);

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	var SettingEditCtrl;
	
	SettingEditCtrl = function($scope, $filter, flash, setting, AppSettingAPIService, PaymentService) {
	  $scope.setting = setting;
	  $scope.submit = function(setting) {
	    return AppSettingAPIService.update(setting).then(function() {
	      return flash.success($filter('translate')('API_SUCCESS'));
	    });
	  };
	  return $scope.cancelPayment = function() {
	    return PaymentService.openCancelModal();
	  };
	};
	
	SettingEditCtrl['$inject'] = ['$scope', '$filter', 'flash', 'setting', 'AppSettingAPIService', 'PaymentService'];
	
	module.exports = SettingEditCtrl;


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	module.exports = {
	  '_SETTING': {
	    'TITLE': 'Settings',
	    'DISTANCE_UNIT': 'Distance Unit',
	    'METER': 'Meter',
	    'YARD': 'Yard',
	    'EDIT_FRIEND': 'Register or Edit',
	    'MEMBERSHIP': 'Membership',
	    'LBL_SUBSCRIBE': 'Free Member',
	    'SUBSCRIBE': 'Subscribe',
	    'LBL_UNSUBSCRIBE': 'Paid Member',
	    'UNSUBSCRIBE': 'Unsubscribe'
	  }
	};


/***/ }),
/* 326 */
/***/ (function(module, exports) {

	module.exports = {
	  '_SETTING': {
	    'TITLE': '機能設定',
	    'DISTANCE_UNIT': '距離単位',
	    'METER': 'メートル',
	    'YARD': 'ヤード',
	    'EDIT_FRIEND': '登録・編集する',
	    'MEMBERSHIP': '会員登録',
	    'LBL_SUBSCRIBE': '無料会員',
	    'SUBSCRIBE': '有料会員になる',
	    'LBL_UNSUBSCRIBE': '有料会員',
	    'UNSUBSCRIBE': '無料会員になる'
	  }
	};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var CountryService, GenderService, PrefectureService, RegistrationEditCtrl, RegistrationEmailCtrl, RegistrationEmailSuccessCtrl, RegistrationNewCtrl, RegistrationService, modules;
	
	__webpack_require__(328);
	
	__webpack_require__(329);
	
	__webpack_require__(330);
	
	__webpack_require__(332);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(72);
	
	__webpack_require__(112);
	
	__webpack_require__(76);
	
	__webpack_require__(333);
	
	__webpack_require__(82);
	
	__webpack_require__(108);
	
	__webpack_require__(278);
	
	__webpack_require__(90);
	
	__webpack_require__(336);
	
	__webpack_require__(338);
	
	RegistrationNewCtrl = __webpack_require__(340);
	
	RegistrationEmailCtrl = __webpack_require__(341);
	
	RegistrationEmailSuccessCtrl = __webpack_require__(342);
	
	RegistrationEditCtrl = __webpack_require__(343);
	
	RegistrationService = __webpack_require__(344);
	
	CountryService = __webpack_require__(345);
	
	PrefectureService = __webpack_require__(346);
	
	GenderService = __webpack_require__(347);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-flash', 'gnp-form', 'gnp-auth', 'gnp-term', 'gnp-common-wrapper', 'gnp-error-handler', 'gnp-remote-api', 'gnp-account'];
	
	angular.module('gnp-app-registration', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/registration/new/:token', {
	      templateUrl: 'web/registration/new.jade',
	      controller: 'RegistrationNewCtrl',
	      title: '_REGISTRATION.NEW.TITLE'
	    }).when('/registration/email', {
	      templateUrl: 'web/registration/email.jade',
	      controller: 'RegistrationEmailCtrl',
	      title: '_REGISTRATION.EMAIL.TITLE'
	    }).when('/registration/email/success', {
	      templateUrl: 'web/registration/email_success.jade',
	      controller: 'RegistrationEmailSuccessCtrl',
	      title: '_REGISTRATION.EMAIL_SUCCESS.TITLE'
	    }).when('/registration/edit', {
	      templateUrl: 'web/registration/edit.jade',
	      controller: 'RegistrationEditCtrl',
	      resolve: {
	        account: [
	          'RegistrationService', function(RegistrationService) {
	            return RegistrationService.get();
	          }
	        ],
	        confirmationStatus: [
	          'AccountService', function(AccountService) {
	            return AccountService.getUserInfo().then(function(data) {
	              return data.email_confirmed;
	            });
	          }
	        ]
	      },
	      title: '_REGISTRATION.EDIT.TITLE',
	      permission: {
	        signInRequired: true
	      }
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(348)).translations('ja', __webpack_require__(349));
	  }
	]).controller('RegistrationNewCtrl', RegistrationNewCtrl).controller('RegistrationEmailCtrl', RegistrationEmailCtrl).controller('RegistrationEmailSuccessCtrl', RegistrationEmailSuccessCtrl).controller('RegistrationEditCtrl', RegistrationEditCtrl).factory('RegistrationService', RegistrationService).factory('CountryService', CountryService).factory('PrefectureService', PrefectureService).factory('GenderService', GenderService);


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"registration-main\" gnp-common-wrapper-b=\"\"><div class=\"bg-img registration-new-user\"><div ng-show=\"isLoading\" class=\"loader-registration\"><div class=\"loader-background\"></div><div class=\"loader loader-data\"></div></div><div class=\"container content\"><div class=\"row mx-0\"><div class=\"area col-12 col-md-6\"><div class=\"title-tag col-12 col-md-10\"><img src=\"" + __webpack_require__(70) + "\"/></div><div class=\"display-image\"><img src=\"" + __webpack_require__(71) + "\"/></div></div><div class=\"frame col-12 col-md-6\"><form name=\"newForm\" gnp-submit=\"submit(account)\" novalidate=\"\" class=\"newform col-12\"><div class=\"content-message\"></div><div class=\"row mx-0\"><div class=\"col-12 cell1 first\"><p><b>{{ ::\"_REGISTRATION.NEW.PASSWORD\" | translate }}</b></p><input name=\"password\" type=\"password\" ng-model=\"account.password\" ng-minlength=\"10\" ng-maxlength=\"32\" ng-pattern=\"passwordPattern\" required=\"\" placeholder=\"{{ '_REGISTRATION.NEW.PLACEHOLDER_PASSWORD' | translate }}\"/><div ng-show=\"newForm.password.$invalid &amp;&amp; !newForm.password.$pristine\" class=\"error\"><div ng-show=\"newForm.password.$error.required\">{{ ::\"VALIDATION.REQUIRED\" | translate }}</div><div ng-show=\"newForm.password.$error.minlength\">{{ ::\"VALIDATION.MIN_LENGTH\" | translate:'{\"n\": 10}' }}</div><div ng-show=\"newForm.password.$error.maxlength\">{{ ::\"VALIDATION.MAX_LENGTH\" | translate:'{\"n\": 32}'}}</div><div ng-show=\"!newForm.password.$error.required &amp;&amp; !newForm.password.$error.minlength &amp;&amp; !newForm.password.$error.maxlength &amp;&amp; newForm.password.$error.pattern\">{{ ::\"VALIDATION.STRENGTH\" | translate}}</div></div></div></div><div class=\"row mx-0\"><div class=\"col-12 cell1\"><input type=\"password\" name=\"password_confirmation\" ng-model=\"account.password_confirmation\" gnp-match-validate=\"account.password\" required=\"\" placeholder=\"{{ '_REGISTRATION.NEW.PLACEHOLDER_PASSWORD_COMFIRM' | translate }}\"/><div ng-show=\"newForm.password_confirmation.$invalid &amp;&amp; !newForm.password_confirmation.$pristine\" class=\"error\"><div ng-show=\"newForm.password_confirmation.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</div><div ng-show=\"newForm.password_confirmation.$error.matchValidate\">{{:: \"VALIDATION.MATCH\" | translate }}</div></div></div></div><div class=\"row mx-0\"><div class=\"col-12 cell1\"><p><b>{{ ::\"_REGISTRATION.NEW.NAME\" | translate }}</b></p><div class=\"row-name\"><div class=\"last_name col-6\"><input name=\"last_name\" type=\"text\" ng-model=\"account.last_name\" required=\"\" placeholder=\"{{ ::'_REGISTRATION.NEW.LAST_NAME' | translate }}\"/><div ng-show=\"newForm.last_name.$invalid &amp;&amp; !newForm.last_name.$pristine\" class=\"error\"><div ng-show=\"newForm.last_name.$error.required\">{{ ::\"VALIDATION.REQUIRED\" | translate }}</div></div></div><div class=\"first_name col-6\"><input name=\"first_name\" type=\"text\" ng-model=\"account.first_name\" required=\"\" placeholder=\"{{ ::'_REGISTRATION.NEW.FIRST_NAME' | translate }}\"/><div ng-show=\"newForm.first_name.$invalid &amp;&amp; !newForm.first_name.$pristine\" class=\"error\"><div ng-show=\"newForm.first_name.$error.required\">{{ ::\"VALIDATION.REQUIRED\" | translate }}</div></div></div></div></div></div><div class=\"row mx-0\"><div class=\"col-12 cell1\"><p><b>{{ ::\"_REGISTRATION.NEW.BIRTHDAY\" | translate }}</b></p><input name=\"birthday\" gnp-date-input=\"\" ng-model=\"account.birthday\" date-input-date=\"account.birthday\" required=\"\"/><div ng-show=\"newForm.birthday.$invalid &amp;&amp; !newForm.birthday.$pristine\" class=\"error\"><div ng-show=\"newForm.birthday.$error.dateRequired\">{{ ::\"VALIDATION.REQUIRED\" | translate }}</div><div ng-show=\"newForm.birthday.$error.dateValidate\">{{ ::\"VALIDATION.DATE\" | translate }}</div></div></div></div><div class=\"row mx-0\"><div class=\"col-12 cell1\"><p><b>{{ ::\"_REGISTRATION.NEW.GENDER\" | translate }}</b></p><div class=\"row-name\"><div ng-repeat=\"item in defaultData.genders\" class=\"col-5\"><input type=\"radio\" name=\"gender\" ng-value=\"item.key\" ng-model=\"account.gender\" class=\"input-radio-gerder\"/><label>{{ item.value }}</label></div></div></div></div><div class=\"row mx-0\"><div class=\"col-12 cell1\"><p><b>{{ ::\"_REGISTRATION.NEW.COUNTRY_TITLE\" | translate }}</b></p><div class=\"last_name col-6\"><select name=\"country\" ng-model=\"account.country\" ng-options=\"c.value as c.name for c in ::defaultData.countries\" required=\"\" ng-style=\"{'width': '121px'}\" class=\"country\"><option value=\"\" selected=\"selected\" disabled=\"disabled\">{{ ::\"_REGISTRATION.NEW.COUNTRY_DEFAULT_TEXT\" | translate }}</option></select><div ng-show=\"newForm.country.$invalid &amp;&amp; !newForm.country.$pristine\" class=\"error\"><div ng-show=\"newForm.country.$error.required\">{{ ::\"VALIDATION.REQUIRED\" | translate }}</div></div></div><div ng-show=\"account.country === 'JPN'\" class=\"first_name col-6\"><select ng-required=\"account.country === 'JPN'\" ng-model=\"account.prefecture\" name=\"prefecture\" ng-options=\"c.value as c.name for c in ::defaultData.prefectures\" ng-disabled=\"account.country !== 'JPN'\" ng-style=\"{'width': '121px'}\" class=\"prefecture\"><option value=\"\" selected=\"selected\" disabled=\"disabled\">{{ ::\"_REGISTRATION.NEW.PREFECTURE_DEFAULT_TEXT\" | translate }}</option></select><div ng-show=\"newForm.prefecture.$invalid &amp;&amp; !newForm.prefecture.$pristine\" class=\"error\"><div ng-show=\"newForm.prefecture.$error.required\">{{ ::\"VALIDATION.REQUIRED\" | translate }}</div></div></div></div></div><div class=\"row mx-0 content-email-newsletter\"><div class=\"col-12 cell1\"><div class=\"row mx-0\"><div class=\"col-1 no-padding\"><input type=\"checkbox\" ng-model=\"account.email_newsletter\" class=\"custom-checkbox\"/></div><div class=\"col-11 no-padding\"><b>{{ ::\"_REGISTRATION.NEW.EMAIL_NEWSLETTER\" | translate }}</b></div></div></div><div class=\"col-12 cell1\">{{ ::\"_REGISTRATION.NEW.CONTENT_EMAIL_NEWSLETTER_1\" | translate }}<br/>{{ ::\"_REGISTRATION.NEW.CONTENT_EMAIL_NEWSLETTER_2\" | translate }}<br/>{{ ::\"_REGISTRATION.NEW.CONTENT_EMAIL_NEWSLETTER_3\" | translate }}</div></div><div class=\"row mx-0\"><div class=\"col-12\"><div class=\"submit\"><button type=\"submit\" gnp-submitting-button=\"isSubmitting\" analytics-on=\"click\" analytics-event=\"Login_New_Profile\" ng-disabled=\"newForm.$error.required.length &gt; 0\" class=\"btn new_sign_up-btn\">{{ ::\"_REGISTRATION.NEW.SIGN_UP\" | translate }}</button></div></div></div></form></div></div></div></div></div><div tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\" data-backdrop=\"static\" data-keyboard=\"false\" class=\"crop-image-modal modal fade\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\">{{ ::\"_REGISTRATION.NEW.URL_EXPIRED_1\" | translate }}<br/>{{ ::\"_REGISTRATION.NEW.URL_EXPIRED_2\" | translate }}</div><div class=\"modal-footer\"><button ng-click=\"closeModal()\" class=\"btn-primary btn-lg btn-block\">{{ :: '_GROUP_EVENT.FILTER_MODAL_FOOTER' | translate }}</button></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/registration/new.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"registration-main\" gnp-common-wrapper-b=\"\"><div class=\"bg-img\"><div class=\"container content\"><div class=\"row mx-0\"><div class=\"area col-12 col-md-7\"><div class=\"title-tag col-12 col-md-10\"><img src=\"" + __webpack_require__(70) + "\"/></div><div class=\"display-image\"><img src=\"" + __webpack_require__(71) + "\"/></div></div><div class=\"frame col-12 col-md-5\"><form name=\"newForm\" gnp-submit=\"submit(email)\" novalidate=\"\" class=\"newform col-12\"><div class=\"content-message\"></div><div class=\"row mx-0\"><div class=\"col-12 cell1 first\"><input name=\"email\" type=\"email\" ng-model=\"email\" gnp-custom-email-validator=\"\" required=\"\" placeholder=\"{{ ::'_REGISTRATION.NEW.EMAIL' | translate }}\"/><div ng-show=\"newForm.email.$invalid &amp;&amp; !newForm.email.$pristine\" class=\"error\"><div ng-show=\"newForm.email.$error.required\">{{ ::\"VALIDATION.REQUIRED\" | translate }}</div><div ng-show=\"newForm.email.$error.email\">{{ ::\"VALIDATION.EMAIL\" | translate }}</div></div></div></div><div class=\"row mx-0\"><div class=\"col-12\"><p>{{ ::\"_REGISTRATION.EMAIL.TAPPING_SIGN_UP_FIRST\" | translate }}<a href=\"https://tv.golfnetwork.co.jp/kiyaku\">{{ ::\"_REGISTRATION.EMAIL.TERM\" | translate }}</a>{{ ::\"_REGISTRATION.EMAIL.AND\" | translate }}<a href=\"https://www.golfnetwork.plus/privacy.html\">{{ ::\"_REGISTRATION.EMAIL.PRIVACE\" | translate }}</a>{{ ::\"_REGISTRATION.EMAIL.TAPPING_SIGN_UP_LAST\" | translate }}</p></div></div><div class=\"row mx-0\"><div class=\"col-12 no-padding\"><div class=\"submit\"><button type=\"submit\" gnp-submitting-button=\"isSubmitting\" analytics-on=\"click\" analytics-event=\"Login_New_Profile\" class=\"btn new_sign_up-btn\">{{ ::\"_REGISTRATION.NEW.SIGN_UP\" | translate }}</button></div></div></div></form></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/registration/email.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"registration-main\" gnp-common-wrapper-b=\"\"><div class=\"bg-img\"><div class=\"container content\"><div class=\"row mx-0\"><div class=\"area col-12 col-md-7\"><div class=\"title-tag col-12 col-md-10\"><img src=\"" + __webpack_require__(70) + "\"/></div><div class=\"display-image\"><img src=\"" + __webpack_require__(71) + "\"/></div></div><div class=\"frame col-12 col-md-5\"><div class=\"newform col-12 register-email-success\"><div class=\"row mx-0\"><div class=\"col-12\"><img src=\"" + __webpack_require__(331) + "\"/></div></div><div class=\"row mx-0\"><div class=\"col-12\"><h5>{{ ::\"_REGISTRATION.EMAIL_SUCCESS.PLEASE_CHECK_EMAIL\" | translate }}</h5></div></div><div class=\"row mx-0\"><div class=\"col-12\"><p>{{ ::\"_REGISTRATION.EMAIL_SUCCESS.CHECK_EMAIL_DETAIL\" | translate }}</p></div></div><div class=\"row mx-0\"><div class=\"col-12\"><p class=\"email\"><b>{{email}}</b></p></div></div><div class=\"row mx-0\"><div class=\"col-12\"><p>{{ ::\"_REGISTRATION.EMAIL_SUCCESS.NOT_RECEIVE_EMAIL\" | translate }}</p></div></div><div class=\"row mx-0\"><div class=\"col-12\"><p>{{ ::\"_REGISTRATION.EMAIL_SUCCESS.NOT_RECEIVE_EMAIL_1\" | translate }}<br/>{{ ::\"_REGISTRATION.EMAIL_SUCCESS.NOT_RECEIVE_EMAIL_2\" | translate }}</p></div></div><div class=\"row mx-0 last-row\"><div class=\"col-12\"><p>{{ ::\"_REGISTRATION.EMAIL_SUCCESS.PLEASE_CONTACT_1\" | translate }}<a href=\"/contact\">{{:: '_REGISTRATION.EMAIL_SUCCESS.PLEASE_CONTACT_HERE' | translate }}</a>{{ ::\"_REGISTRATION.EMAIL_SUCCESS.PLEASE_CONTACT_2\" | translate }}</p></div></div></div></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/registration/email_success.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAkwAAAFoCAYAAAClsaR+AAA7eUlEQVR42u2dCXxU1b2An1Jta221fdraV7uvry1hkX1VVndxQS2KYrU+X/t8r7a1tcW6IbKLiuyLhC2EkITsKyFhkUUIEHYM+07YA2TPef8TJ3YcZ5I7M3dm7r3zfe/3/exTyAznztzzMffMuf/2bwAAAADwOVqmLGjROmnuC20S57zOaABASGg1843rxIfE8WKuuEPc77JYTBZfFnuILRgxALBYLHWKWTJ/tQTTZvnfdzAiAGB2KHUVE8QaURn0hDhK/DYjCAARDqUbxOni+VsSZn8k/6wXr2dkAMCsUPqJmOlHJHmzQnxL/DIjCgBhDqUrxefEM9qOcdPXyz+VuJrRAQCzYukZV+wok9wptmRkASBMsdRRbAykM13nTiqRf9a6/v+hjBAABBtKV4vTTAwldy+LAxllAAhhKH1DnOa67Kbj6ESP2RN2yz8vuP5/bWtGCgCCiaUbxMIQxZK7r4lXMOIAYGIo6ctvvxNPNYZRzJL5J26bMf6o/POYWywdYrQAIJhY+rW4Lwyx1Ogi8RpGHgBMiKV24lq3KNKxdKz3tHGnWiXPK3X/9+JkRgwAAo2le8TyMMZSo3orgps5AgAQYCjpy29T3C6/NcbS4b5TxpS3SYwt8Ygl7V2MHAAEEksviXURiKVGj4udOBIA4EcoXSH+VizzDKLGWGofP7PYSyxViHxjFwD8CqUviXMjGEruVoqPcVQAwEAstdHbAniJIYmleXv7TRld0WXelE3e/ruYxggCgD+xdJO4xiKx5O5I8UqOEAB4CaWvixPFOp+xNHl0RY8P3tvt69foPZkYSQAwGkttxUMWjKVGU8SvcqQAwBVKjZffTvqIINUqed5uHUu9pr99xHXZTfmQNZMAYCiWBrr2QlIWd4v4A44YQNTHUitxZRMB5IqlUdV9p445721Nk5ubGFEAaC6UrnDtfaRs5El9E1+OHkBUhtJ14ntuO3N7tXXS3B06lrQxS+bta+rXisMYWQBoKpaucd04V9nQavFpjiJA1ISSvvz2hN6du5n40bG0rf+kkXWi/O85W5v79SLfxgUAn7H0XddeR8rmviO24IgCODqWWjZ3+e1fsTRnq46l2yeOUO0WzSo28Hv0+ie+UAIAXmOpk2uPI+UQs8TrObIAjgulr4lvN3f5rVG9GaX+VEnHUqf5Uzca+T3ibEYaALzF0mDX3kbKYe4Uf8oRBnBEKOnLb4+JxwxGz2diqfvs93cY/X3iQ4w4hJVOw/9xo/i4OE6cjZYztsOYl7e0f/ufysFWdRw5NIdjbUlnia+L/cWrOGNCE7H0a7HIj+BRtyTM3qhDSXvbjPEH5d9VGvy91fpTLEYdwhVK33GdEGtEhYjYjGXii+LVnEHBLZS+Ko41evnNWyz1mTr2jPy7M378/qWMPIQrlu4Sz7qfDO9+d6R6ZvZk9d9zpyMiNjh4+gTVe+zrnuG0QWSzQNCx9Kh4xJ9Q0upF3Y2x1G/yqMqYJfMP+vkz/sjoQzhi6V6xTp/4urz1shqZuUTtLTuhAAC8UVNXq9bs3a2ejZ3qHk0HxP/gjBq1ofRLscDfUPKMpU+2D5i7I4Cfw7pHCHks/Ugs1ye8/m+/qTYe2MdsAACGqJf/m7WywD2alot8rTv6Lr+NEWsCiaX2C2d+GktafVkugJ+zkyMB4QimZH2i6zbin6rk0AFmAADwm8nLct2j6UnOrFETSwPFQ4GEkrZD3PTPxFJH+f8D/FnjOBoQ6lj6ceNJbkJ+Fmd9AAiI2ro69fCUtxuDiXt5OT+UfiHmBRpK2o4esdRtzsQtQfy8WzkqEOpg+os+wXUePlSdvljOWR8AAia5eK37p0w/5AzryFD6ijjS9RX+gGNJb0TpHku3znxnbxA/85zI9hYQ8mCar09uQ2ZO5GwPAEFx/PxZ92BiA0HnxdJDwVx+8xVLvaeNLZN/fyGInxnP0YFwBNMyfXL7e+J8zvYAEBR19fWq64iXG4Ppec6wjgmln4rZwYaStsvcySXusdR3yujLMUvmHw3y5w7mKEE4gqlQn9zeSF3M2R4AgqbP2Dcag4k9cewfSteIw8WqUMSSvqluq+R5u4P8uXXiDRwtIJgAgGCCSMTSA+IBM0JJR0232Inb3GNJ23Zx7GYTfvYqjhYQTABAMEG4Q+nHYpZJoeSKpfc/F0sdFs4oNunn/4OjBgQTABBMEK5Q+rL4hh83ujV0M9zusyfs8IwlfWnOxMdoydEDggkACCYIRyzdK+4zMWIaYqnHB+/t9oylnrPeLXWtOzLjMQ5w9IBgAgCCCcJx+S3D5FDSVkgs7fKMpV7Txx2T/3bRxMeZyFEEggkACCYIVSh9SXzV5Mtvn8aS3oTSM5b6Thmt91k6YfJj3cnRBIIJAAgmCEUs3SXuCUEoaS95i6X+k0bVtEqeZ/ZjXtbhxxEFggkACCYwM5R+KKaGKJS05bfNGH/YM5a0bRLnbAnB46VwVIFgAgCCCcy8/PaKvlQWiVhqt2hWcYge81mOLhBMAEAwgRmxdLv4cQhDSXum1/Rxx73FUuf5UzaF8HG/wxEGggkACCYIJpS+LyaFOJQaYqn3tHEnvMVSj9kTdsp/rw/R4xZzlIFgAgCCCQINpS+KQ10LokMaSzFL5p+QWDrpLZb05bkQXwJ8naMNBBMAEEwQSCz1C8Plt09jqc/UsWe8xVKfqWPOyq85FeLn0IEjDgQTABBM4E8ofVdMCEcouWLpiK9Y6jd5VLX89wMhfg7HxSs58kAwAQDBBEZC6WrxJb33URhj6XDfKWPKvcVS/0kjVeukudvC8Dw+4OgDwQQABBMYiaW+4s5whZIrlg76iiXtLQkfbAzTc3mAVwAQTABAMEFTofQdcVE4Q+mTWJq3t9/k0RW+YqnTgmnhiqUq8au8EoBgAgCCCbyF0lXii3qDSKvFUrfY97eF8fnk8WoAggkACCbwFku9xO3hDiVtq+R5u/VCbl+xdNvM8XqBd3UYn9P/8YoAggkACCbwvPy2MBKhZCSW+kwbq7cOOBvm5/UjXhlAMAE4kH8kLWiMh884sSA7oj+LYLJ0KH1B/JN4IVKxpL/t1lQs6Ut0+htzYX5e23l1AMEE4EAOnz3tNXC0IzOTI/azCCZLx1JPcWukQqkxlvpPGlnnK5bkv9W3Sp67MwLPbQyvECCYABxIcvE6n5Gj/1ukfhbBZMlQ+rY4P5KhpG2TOGdLU7Gkbbt49qYIPb+evFKAYPJgyMyJPieHvuOGNfxtG8Dq6E9+fL2O/X0Nm/mzCCbLXX57IZKX3/4VS7ElevPJpmKpQ9z04gg9P71W6gu8YoBg8sDXxNDour2lzMZgeR6cONbr61f/+0j+LILJMrHUTdwc6VBqiKXFsZubi6WucyZtieBzjOMVAwQTwQSsX3LM+iWCyVAofUucY4VQ0t6SMHtjU6Gk7Tnr3T3ya2si+Dwf45UDBBPBBKxfcsz6JYKp2ctv/yuet1AsbWoulnpPG3ciwpcM68R/5xUEBBPBBKxfcsz6JYLJZyx1scrlt0bbLZpV3Fws9Z0y+mLMkvnHIvxcV/AKAoLJJsGkJyX9mN4MxYQV7scD1i8RTCELpW+Ks6wUSkZjSX9brlXyvFILPN+/MVMDwWSTYNLfzGvqW3t2fzxg/RLBZHootRD/EIGdsJu1w8IZzcaSVn9rziLP+VfM1EAw2SSYmns+dn88YP0SwWRqLHUWN1otlBpiKW66oVhqHz+z2CLPeT+zNBBMBBPBxPolx61fiuZgksn9BnGGFUNJ23HBtI1GYqnLvMlWWms1gVkaCCaCiWBi/ZLj1i9FYzDJpH6l+Jx4xqqx1Gn+VEOx1OOD93a7vpVmled+O7M0EEwEE8HE+iXHrV+KtmCSCb2juN6qoaTtbDCWek1/+6j8+ssWeu6XxC8ySwPBRDARTKxfctz6pWgJJtflt+livZVjqcvcySVGYqnv1DF6n6Uyiz3/JczQQDARTAQT65ccuX7J6cHkuvz2O/GUlUPJn1jqN3lUdcySeXst+Gd4mhkaCCaTgmnp9i0Nk4rnzXqfXzBTTSzINi2sojWYdhw73DCOejzdtzpoHF89/majf2bjY3o7rv9IWqDmfFjU8OsuVFwO6DH060L/nMafq/+3Wa+VaF+/5ORgkgm8nbjW6qGk1yB1i31/m5FY0rZOmrPFon+ObzNDA8EUZDDoCdNzMvWl/nX+TIa+JqlgbCoswv14Gl9jp/9949oZHSdGHks/fzPCSR/Tpvaf8qWOHX8eXz9OU68r1i8RTF5C6RviFKtffgsklvQGlhb9c6xndgaCyYRgCkQjk6EOq3A+drgfz8j46rUxgYSLnsQD+cRHh4HR+G0u3Jq7TGVkvIP5pIn1S84KJpm0rxCfscPlN5fVPT6YsMtoLOlvzln4z/IaszMQTBEKJiMhQTAFpw4ff6JJ/1ozYsnoJ2vul+Ga+sSK9UsEk0zYbcTVNgklVyy9t9toLHWfPWGHxf887ZidgWCKYDA19wkCwRS8/gRHU1EQyCdMZr2uWL8UvcEkE/XXxYkW24uoOSt6znr3Y6OxdNuM8Qfl91Ra+M+jb/Z7BbMzEEwRDqamJhyCKTyf9DR+umTmYxq5TBXKYGL9kr2DyXX57bfiSRuFUkMs3Trznb1GY6nP1LFnrLzBpsuZzMxAMFkgmJqaXAmm8H3ao6PKyM/Rfxatt29D+vupSygvybF+yb7BJBN0K/FDm4WS9oI/sdRv8qjKmCXzD9rgzzWAmRkIJpODSS9O1hOpnlD1V9GNfuOsqUkxGr4l5+8ltsZo8We9UXMTe1PfVmvU23oo/e/073UfN6Pfkgvlom/WL9kvmGRivk58T6y1YSyV3zZj/GGjsdR/0kjVOmnuDhv8uarEa5mZgWAyMZh8LTA2si5Gh5ZRjEyyZhKOxzM6vt4mZ/38jERec5/UGAkm/WuaWkSuo8zfrQBCta0A65fsE0yuy29PiCdsGEoNnyz5E0vaWxJmb7TJny2bWRkIJhMndB08TU2kRvYQMvptrmgMpua+7aZDysjWA8FeknN/Po0bZQa6WaXnGJu5cSXrl+wTTK7LbyttGkraM72njTvhTyx1jJtebKM/3/PMykAwmTih68kz2MnY6AQZjcFk5BKXkU+ImhrjpsLASEDpT5fMiCczYP2SPYJJJuObxI3RFEvd5kzcarM/4w+YlYFgCuOEbuQbWARTcD/fSPA0d5yC3VZAf8oVituzsH7J0Z8w6ctx/cU8O4VEzJL5J/pMG3van1i6deY7+/T+TDb6c25jRgaCyeQJ3UjsEEyBjU3j7VHMOE7NrQnSYRvIruJm39IkWFi/ZNtF3zHiXKtHRUMsTR17xp9Y6j1tbJn83vM2+3RpFDMyEEwEE8HkA32DXzO+KRipT5pYv2TfYHILp5vF0eI5C8bS4T5Tx5z1J5b6TRldIb/viA0vOXZnRgaCiWBy3CU5HTpmffKjP2nS69JCvfcT65cIpmbC6aviC+IBq8RS3yljyv2Jpf6TRta1Sp63247rs8QWzMhAMBFMtgomI5NzsIu+fX3C4s9+Wp7qiGP9EsFkQjh9QXxUXB/BWNrvbyxp2y6O3WTTBe3zmY2BYIqCYDLzclA4Hi9c2woEM8nr+NFRpr/yb3Sdk9FPtMzcVoD1S84LJo94ulVMD28szdvbb/LoCn9jqcPCGcU2/gbgIGZjIJhsHkxGLj35CgwdDP5GQzgeL9iNK40EjNFJvvGWJ80dD6MbXQbzyZi/i8dZv+T8YHILp1+I00N909qY5Hl7AomlLnMnl9g4lvRO619nNgaCyebBZDQwPG/T0ngbkUA+HQj144Xj1ijN7ZXl7dM0veGor/2VjGwV0VzwmH1rFNYvRU8wuYXTN8Vh4imzw0GvPeo3eVS1v7HUc9a7pfL762wcTEXMxEAwOSSY/AkFMya8UD9eqG++a/RyXFM7susxaAxCz3vHBXpMzb75LuuXoi+Y3MLpy+LvxY8jGUu9po87Jr//oo1jSfsiMzEQTA4JJiOXg8z6qn44Hi/UsRTIp0vB2tztcvz5c7N+iWDyI5yuFO8XVwUaDK2T5m7rP2lkrb+x1HfK6At6jyabx5L2l8zEQDA5JJjM2GDRSo8XylhqbsF4c4EQys0rzQwm1i8RTF7iqZO42J/LY65YqvM3lnRgtUqeV+qAWNrLLAwEk4OCqbk1JkbXAlnl8UIVSzryjHy13+xPl4xGmpmX5Fi/RDA1EU4/Et8XLzUVC20SY0sCiSVtm8Q5WxwQS9p3mYWBYHJYMGmC2VxRr9exyuMZCZBAosWftTbBXnZ0/3MavQmvmYu+Wb9EMBkIp2+IQ8XjPmJJBRJL7eNnFjsklrT9mIWBYAqCpiZs/SmGkUnEjJ/hDb0Hkj+Xk/Rj6fAxOqmH4/GMRIPRx9WPF+i93PRzNLqg29vankA+fTFrWwHWLxFMfoTT1eLT4lYdCXpzyUBjqfO8KZscFEvl4hd5hQDB5HB0UOhPBjy/6aUnOf3vdLToXxNoKIXy8Yx+yqJ/lo4SfZnKfVJv/Aabry0AAsF9o0r95/Fcw6X/nVb/mmB39A5240rWLxFMAYbTFR0WzngskFDS9pg9YafNtw/wNIlXBRBMYGlCcbkymmD9EsEUDBI/q/zfPuBtfTPdCgfFkvYpXg1AMAHB5GBYv0QwBRlM9/gTS32mjjkXio0yI2y9eBOvBiCYgGByMKxfIpiCDKYrxO1GYklvZqlvxOuwWNKu45UABBMQTA6G9UsEk0nR9FsjwTQ4NW7jHzau/Kh7dpLTPmF6lVcBEExAMLF+KWrXLxFMhoPpavFIc8E0KH7G3hGlJUr72s7inY+uytvcNm1hrQOCqS2vAiCYgGBi/VLUrl8imPyKphebC6b7Zo6vbAwmNy/9qWTN+j75KYdsGkt6AfsVvAKAYAKCifVLUbt+iWDyK5i+Kp5rLpokkLxFU4PDdm86MGTtsvXtMxbZ6Rt00zn6QDABweRwfG2IGsjmnWb+LILJttE0orlgenNn8V5fweRmzd+3fbTx7sKM3TYIpvs48kAwga0n/WB3QQcgmPwOpm+LVU0F0yubVxcbCKZG9WW6luJ4i25FUClew5EHggkACCaCyd9omt5UMP3lw7w1fgTTpMafq287Ig4Us137HlkhmDI54kAwAQAQTIEE08/Eel/B9FxO4gY/gul2b48hofI98RVxX4SD6Q8ccSCYAAAIpkCjKdFXMD2WMKvUYCxdFJu8ma0Ey5VibzHOdXks3MH0fY42EEwAAARToMHU0VcwDZj1zkWDweTXzWwlXr4uPi9uDFMsbeFIA8EEAEAwBRtNy71G06SROoaqDQTTkEAfW28kKU4Uz4UwmEZwlIFgAgAgmIINprt8fco0fNfGA83EUr14Y7DPQaLmS+Jj4tIQBFNXjjIQTAAABFOwwaRvyrvFWzC9umXNxmaCaZXZz0cC50fiMNGMHcVPiy04ykAwAQAQTGZE02BvwfTimqVrmwmml0L1nHToiHeIi8XqAINpLkcXCCYAAILJrGC6SjzoGUy/z0v+qJlg+lU4np+Ez43in8StfgbTIxxdIJgAAAgmM6PpT57BNHjx7N1NxNKeSDxPiaCO+r5w4oVmYqlGvJ4jC7am1cw3vtJh1NAyggkAzA6m9mNf5iargQXTteIZ92C6/4P3zjcRTO9E8vlKDH1FHCKu8BFMhRxVsHssfV/c3GHMy4pgAgCzg+mW916pl3PMS5xtA4qmN92D6Y5Pthao9RFMvazyvCWOfiaOFI+7BdOfOaJg51jqKp4QFcEEACEKJqXPMeJc8Uucef0Kpm+KFZ/ZWmD3psNeYumceJXVnr9E0hfEe8UU8eccUbBrLD0lVrtOZAQTAIQ6mLRrxJs4A/sVTZM/u7XA2s1egmkhIwVgfii1EMe5ncAIJgAIVzBpD4ltORsbDqafuN+U969rC7xtLTCIkQIwN5auEzM9Y4lgAoAwBpP2svgQZ2XD0bSoMZj+sDTFc2sBvabp64wSgHmx9BNxh7dYIpgAIMzB1Ohr4hWcoZsNpnaNwfRE0pwdHsFUyAgBmBdLvcQzTZy0CCYAiEQwaePFazhTNxtNS3UwPRj7/hmPYPoTowNgTiz9Xqxp5oRFMAFApIJJWyzezBm7yWDqr4PpzsmjGm+y2xhMP2V0AIILpavESQZOVJYPpgOnytSslQXq1ZR49deEuYgovrR4vhqTnaLytpWo6tpauweT9pjYkbO3z2DSN+Xd5Npa4JgrlnYyMgDBxdI3xAKjsWTVYKqrr1Pv5WeqLm+93HiLBUT04sDJ49Su40fsHkzaSvExzuI+o2mQDqbXtq7b4gqm0YwKQOCx9J9iqT+xZNVgGpudymSIaNA+495QB0+fsnswNTpSvJIz+ueC6Qvi/pc+KlznCqbujApAYLF0p3g+gJOT5YJpy+GDTIKIfvrHuNlOCSZtingtZ/bPRdPzzxek6WA6LbZgRAD8j6U/i3UBnpgsF0yjspYwASL6aefhQ9WpixecEkzaLeIPOMN/Jpi+8tvUBasllmIZDQD/Qulq8YMgTkiWDKZnZk9hAkQMwDV7dzspmLQnRS49ufFEUuzrEkwDGQkA47H0LXFlsLFEMCESTBYOJuW67+XTnPUbg2nOzRJMX2MkAIzFUivxgBmxZMVgGpnJJTnEQCwrv+DEYGr0bX0/TGYAADAaS/eLl0w8CVkumEoOHWDyQ/TT/10wy0mLvn2Zpe+LyUwAAE2F0hXiyyaffCy7rcCIjGQmQUSD9h77utp/6mQ0BJNy3ReTHa4BwGssfVmMC0UsWTWYaupq1bictIZv/jAhIvp2wPuj1fajh52wcaU/6vtj9mJ2AIBPiYmfcn2rWW9uDFUsWf3WKHtOnlDTivLUy8lx3BID0c2Rmckqc0uxqq6tccKtUQKxttWcMf/FLAEAnwRTwvSYlkmzVavZI6IymADAfoQjmGLmva1aJsUeZZYAgH8FU8oC1XLJXBUzZwzBBABRH0wxce+rhvNi8pwyp5zrR5SW3CgmiRvFwcx+AIEGU4PzVcz8dwkmAIjOYJo1TMUsmqY+PSc6K5gWuO4Rp60S+TYgQODB9Ikx8ZMJJgCIrmD64C3VMvGDz5wLnRJMEkdt3WJJWy9+nRkQIMhgaoimxTPkb1tvEkwA4Pxgih0tcTT3c+dBBwVTnkcwzWP2AzApmBpsWAw+kmACAMcGU8y88arlkvnez4EOCCaJoz4esVQt/pDZD8DMYGpYDD5PxcwZSzABgOOC6dPF3b60eTBJGF0hbvAIpneZ+QBCEUyNl+iCWAxOMAGApYJp1ptKzn3NnvccEEwPecTSBfEGZj6AEAbTvxaDDyOYAMC+weRtcbdzg2mqRzD9k1kPIAzB9Mli8Jnyt7PhBBMA2C+YfC3ujo5PmPaL1zLrAYQpmD5ZDB7r12JwggkAIh1MDYu7U+b7d65zxqLv3uJ/izcx4wGEO5gaF4PPHUswAYDlgylm4UQV0HnOQRtXAkCkgqnxEt2C9wgmALBmMBld3E0wAUCog+mTxeBTmlwMTjABQNiDafaIhr3kgjq/EUwAYGYwNagXg38wnGACgMgH0xw/F3cTTAAQtmBqYjE4wQQA4QqmmPnv+L+4m2ACgLAG06eLwccRTAAQ9mCKWThJmXo+I5gAIGTB9Oli8AkEEwCEJ5gaFnfPMP08ZpdgGlFa0lVcKL4uXs3MBmCjYGqIpkVTGxaDE0wAELJgMmNxt42DSQLpp+Iltw0qhzKzAdgsmBpMnKXav/0awQQApgdTm2kjVcslc0N3/rJ4MEkctRBXe9z+ZAozG4Adg0l/0pQYqzqMe4NgAgDTgqnd5LESS/NDeu6yQTAN9YilWrEdMxuATYPpkxPPPPVc6iLO9AAQFHX19apj7GQVnvOWdYNJwqi1WOMRTG8wqwHYPZhcTt+9VdVzzgeAALhQXaWe/bAgbOcrqwaThNEXxa0esbRBvIpZDcAhwaT924ZVqrKulrM/ABhmX/l5dffStLCeqywcTO96xFKl+EtmNACHBZN20PIcVVZZwSwAAM2y+uQx1SVzcdjPU1YMJgmj+z1iSfsCsxmAQ4NJ2zsnWW0/d4bZAAB8snDfbtUqNS4i5yirBZOE0ffEMx6xlC9eyWwG4OBg0rZLj1e5Rw5G5ERcXVur4td9qIbMnKh6jHql4WvKiPiJfccNU3+Oj1Xr9pZG5P1ZU1en3ti8TkXy/GSlYJIo+oKXLQSOizcxkwFEQTA1OnnnlrAuBj976ZJ6atYkJkZEA76XnxnWWDpXVaWeXrU04ucliwXTSI9Yqhf7MYsBRFkwaf/y0UpVURuexeD/M38mEyGiHyasXx2W9+be8vPqrvw0S5yTrBJMri0EPNctDWcGA4jSYNI+UpStTlZcDukJec2e3UyAiAFcoquurQnpe3PFiaOqc0aCZc5HFgqmJz1iaaW+RMcMBhDFwaTtlZOstpw5FbKT8pjsFCZAxAD8aF/o1jPN3bMzcou7rR9M33atV9KxdEi8mdkLgGD6ZDF4WrzKPLw/JCfmP8fPYfJDDMC0zevN//JFXZ16ddNaZcXzkMXWMF0rdtP/ZOYCIJg+54Qdm01fDP5qSjyTH2IAFuzYau6XL6oq1ZMr8yx7/rH6veQAgGD6jC+sW6Eum7h2ImnDWiY/RD/tPHyoKiu/YNr7sPTCOdU/L8XS5x6CCQBsFUzagYVZ6ujlS6acqC9XVak73hnOJIjoh/qTWbMoPH5YdbLS4m6CCQCcEkzaW7OT1OYzZaacsNfv38NmlYgGfXTqeHXBpG+vzvp4u/UWdxNMAOCkYNLekrZQpR7aZ8qJe8exw+rpDyYzISL6sMtbL6s30xJVeUWFKYu7hxavVnY63xBMAGDbYGp0/LZNqq7enOXgB06XqaJd21T65g2IKGaWFKvVe3ap85fN+VTpVGWFGrwi13bnmXAF04jSkhbiBPGIOE/8ErMTAMFkms+vLVKXakK7kR4ABMfO82dVv9wltjzHhCOYJI6uEGd4bEw5hNkJgGAy1fsLMtSRSxeZlQAsSMGxQ6pD+iLbnl/CFEzDvNz25DFmJwCCyXR7ZCWq4tMnmZ0ALIK+WD5991YVY/NzS6iDScLof73EUpF4FbMTAMEUEtukLVTJB/YwUwFEmMq6WvW3DauUE84roQwmiaJHxHqPWNokXsfMBEAwhdwxW4tNWwwOAP5RVlmhBi3Pccz5JFTBJFF0j1jtEUt7xJuYlQAIprD5+zWFqrymmtkLIIxsP3dG9bHr4u4wBpNEUS/xskcsnRR/wowEQDCF3QEFGerQpXJmMYAwkHvkoGqXHu+484jZweQjls6LbZmNAAimiNkta7FaV3aC2QwgROiL31N2bVFOPYeYGUwSRR1dceQeSzqeejATAXh/01wlfk/sLD4s/lH8nfgVA7/3SnGKWCaeFve7rnvrhYIbxEIxQ4wVx4p/F58VHxJ/FW3B1LgYPGH/x8xsACZTUVur/vLRSuXk84dZwaQ/QfIRS72YFSHao+iLYkvxQfGf4lxxnXjcy1dIG00z8HPvaOL3G/HFaAumRkduWc9icACTOFlxWT1SlO3484aJwbTC41ysF3zfwWwJ0RxKz4i7xLoAYqbcwM/vE2Qw7YrWYNI++2GBulBdxWwHEARbzp5WvXKSo+KcYWIwbfCIpXuZMSGaY+kGsTaImJlu4DH0FvqjxI9dl+TO+Rlnc6I5mLT3LE1XBy5eYNYDCIDMw/tVu7T4qDlfmBhMPVzLJw7qLQWYMSHag+lmA8FyUdwp5rvWGY0Qfy/21uuTgnz8r4rfEH8qdhLvFAeLfxaHu9ZKXRPtwaTtmrlYrT55jNkPwCD6YvaEHZtVtJ0rwnXzXQA7x8/Pxb+JH4qVYp6R3Vddi6z1fhp7xUzxbdei657iN634Z43GYNK2So1TC/ftZiYEaIbLtTXqhXUrVDSeJwgmAN+RpBdob/Xx6dDvnfjnjtZganTY5o9ULYvBAbxy9PIlNbAwK2rPDwQTwL8i6euuS2LrDFxOe5JgcqZPr1qqzlWxGBzAnc1nytSt2UlRfW4gmIBQKi3pJs4XqwyE0hlxjNiCYHKud+Wnqb3l55klAYS0Q/vULWkLo/68YDSYXPssxTC7gpNCSX9TYYuBSNLfZBgv3urUUCKYPm/nzAS1isXgEMXovcrGb9vE+cBgMLn23FvgNnf8mZkWnBJMTW0ceUp8X+yuv74fLWNCMH1+MfjcPTuZOSHquFRTo55fW8R5wGAwub6V7Lkh5RZmWnBCLH1BrPB4ces9jFLFB8Sro3FcCCbvvrZpraquq2MWhajgyKWL6oFlmbz3DQaTzBc/EHd4+Yv3LGZbcEo06QXeF8RD4jDxu9E+JgSTb59ama/OVlUym4KjKT59UvXISuQ9bzCYZN64xcfVilRve90BAMEUFfbPS1GlF84xq4IjWXJwT8MNqnmvGwsmCaL7xEteYmmS09e7gnM+ObpOvIqRIJhCYaeMBFV0/AizKzhqcffYrcW8v/0IJpljXhLrvcTSX5lJwA6hdJO4yPUi1jtsd2BUCKZQLQb/oHQHMy3YnvKaavX7NYW8rw0Gk+ubcHO9hJK+ie4jzCJg9VDSN6Ed4tojyf0FHMvoEEyhdGjxahaDg205fKlcDSjI4L1s0JjkOadct8jy9q3q7swgYPVY0t9OyPWxNcAwRsg/Wi6e+UtOjP55X26KSt++WRXt2oYOcvWeXer0xXLHxtK6shOqW9Zi3sN+2CEtrtbLPKP38vshswdYPZYeFs/5iKXZfEMhgGBKWfADTowB/M1zcazqMO4N1Wn4P9BBdh4+VP1t8Tx1wmEL/RP2f8zi7gDskZPkOc+kiV9l5gArh9JXxJk+Qmmf2I9RIpjCv75hnmo/YSSh4UDvemeEOnrujCMWd4/csoH3qjnBNJpvwoHVY+ln4nYvoaQXer8jXssoEUyR9JZp44kMB/q72Cm2jqUL1VXq2Q8LeI8G895Oj98vc8xU8R5mC7B6LN0rnvcSS0fE2xghgskqtomdpDq9NZTQcJglhw7YMpYOXLyg7lmaznszeDcxS4AdYmmoj0twKeINjBDBZLmtBxbOVB1HvUJoOMg5HxbZLpbWlB1XXTNZ3E0wQbTE0k+9hJL+tsIL0XRjXIKJxeAYWScty7FVLC3ct7thzzDeiwQTRE8w/dIjlsq4BEcw2WkxeDsWgzvCpA1rbRFKtfX1atjmj3jvEUwQpdH0lnhCzBK/z4gQTLZbMDr9HaLDxnZ562V1/Lz1txc4V1Wlnlm1lPccwQQABJONF4PPmaw6jXiZALGhb+emWT6W9pafV3flp/FeI5gAgGBiMTiGX715ZXVtraVjadXJY6pzZgLvMYIJAAgmBy0GT5yjOrw9jBixsD0kap+bM01lbdmo6uX/rMy8PTtZ3E0wAQDB5EzbpcerrMP23NcHrIG+8fNrm9byfiKYIJrQNy9kl26CKRqdsGOzxT+/ACtytqpSPbUyn/cQwQRRFEpXiemu7QLOiO0ZFYIp2nxh3QpVYfE1MmAdSi+cU7fnpfLeIZggyoJpmsceSxMZFYIpGh1YmKWOXb5EDUCTFB0/ojplsLibYIJoi6W/eNnB+/8YGYIpWr01O0ltPlNGFYBXZpfuYHE3wQRRGEt9xTqPWMrXl+gYHYIpqje4TFuo0g/tow7gM4u7Xy5ew/uDYIIojKXvi6c9YmmneD2jQzDhJ76zfZOqq2c5eLRzurJCPbEij/cEwQRRGEtXix95xNJZ8ceMDsGEn/X5tUXqUk0N1RCl7D5/VvXPTeG9QDBBlAbTGI9YqhfvZGQIJvTug8sy1ZHLF6mHKKPg2CHVIX0R7wGCCaI0lvp5WeT9GiNDMGHT9sxOUsWnT1IRUcKM3dtUDK97ggmiNpauF494xFKh2ILRIZjQwI170xaqJQf3UBMOprKuVv19w4e83gkmiPJgmu0RS3qTypsZGYIJ/XPcto0sBncgZZUVatDyHF7jBBNwKe5zl+IGMjIEEwbmH9YUqvKaairDIew4d0b1zV3Ca5tgAoKpZKZHLCUwKgQTBueAggx1+FI5tWFz8o4eVO3T43lNE0wADcH0olssnRRvZFQIJgze7lmJav2pE1SHDdEXVafs2sLrmGAC+EwwtRD/Wxwl/pwRIZjQ3MXgCfs/pkDstLi7tla9uH4Vr1+CCQAIJgy3I7dsYDG4DThZcVn9piib1yzBBAAEE0bK51YvUxeqq6gSi7L17GnVKyeZ1yrBBAAEE0bae5amqwMXL1AnFiPr8AHVjsXdBBMAEExoHbtmLlZry45TKRZZ3P3+jhJelwQTABBMaEVbp8ap+H0sBo8kFbW16oV1K3g9EkwAQDCh1R22+SNVy2LwsHP88iU1sDCL1yDBBOCdEaUl/y62F69mNAgmtIbPrFqqzrMYPGxsPlOmbstO4rVHMAH4jKW24gXXBpXrxasYFYIJreHdS9PU3vLz1EyIST+0T92StpDXHMEE0GQwJXvcAqU9o0IwoXXsnJmgVp08RtWEaHH3u9s38TojmACajaXvibVusVQt3sDIEExoLVulxqn5e3dROCZyqaZGPb+2iNcXwQRgKJiGe3y6FMeoEExoXV/ftE5V19VRO0Fy5PJF9eCyTF5TBBOAoVjS94o75hFMXRkZggmt7VMr89XZqkqqJ0A2ni5TPVncTTAB+BFMd3vEUgmjQjChPbwjL1XtucBicH9ZcnBPw42PeQ0RTAD+BFOCRzD9kVEhmNA+dspIUEXHj1BBBtA3OB63bSOvG4IJwO9Yuk6scoulGvFGRoZgQvstBp9duoMiaoKLNdXqf9awuJtgAggsmAZ7fLqUxqgQTGhfX9m4hsXgXjh8qVwNKMjgNUIwAQQcTGkewTSYUSGY0N4+sSJPna6soJJcrD91QnXPSuS1gQQTBBxL14gVbrFUqS/RMTIEE9rf/rkpavf5s1EfS4n7S1ncjQQTBB1M93l8upTOqBBM6Bw7ZixShccOR+3i7pFbNvA6QIIJTAmmqR7B9ByjQjChs4wRZ+zeFvJAqaitUatPHlXTd5eoocUr1X99mKcGr8hST63MUc+vKVBvbl6j4vbuVDvOnVb19fUhfS7l1dXqudXLOP5IMIFpwbTUI5huZlQIJnSmf9/woaoKwWLwQxcvqPe2F6uHC9PUvUuXGPLpVTkqYf/uhluSmM0BeT73Lk3nmCPBBKYG0xC3WJrDiBBM6GwfX56rykxaDK5jZ/LOzWpAQYrhUPL08eWZKv/oAWXW501ry46rrpmLOdZIMEFIoukXYmfxSkaDYELn2zd3idpx7kxQYaIvqz2zKjfgUPJ02OY16nx1VVDPKX7fx6p1ahzHGAkmACCY0Bzbp8er/KOH/I4SvfZo0b5dQX2q5MshK7NVyZkyv59TrTyn4SUfcVyRYAIAgglD49RdWw1fDtP7OunF3GaHkrv3SYjN3bO9IYKMoD+VembVUo4lEkwAQDBhaH1x/SpVWVvbZJh8dOq4emx5Zkhjyd2/rl+uTlRcavI57Ss/r+5emsYxRIIJAAgmDI+/KcpWJysufy5K9C1W9DYB4Qold39TlKFWnvB+Q+FVJ4+pLizuRoIJAAgmDLe9c5LV1rOnP42SI5fK1f+tXRaRWHL3/R0bP/MJ2Py9uxpuNMwxQ4IJAAgmjIjt0uNV1uEDDV/192dfpVD7hzVLVemFc+qNzes4TkgwAQDBhJFVfy1/yMo8y4SSu/cXpKhHirI4TkgwQfgYUVryZbGf+F1Gg2BC1PbJXaIGLc+yZCx9dvuBXNWWm+kiwQRhiKWrxF2u3b2rxPaMCsGE0e2gomx1n8VDyd1HizJU/7wUjh0STBDSYGrjcf+4kYwKwYTRuoHlIjVkZY5tQumzpqjHV+RwHJFggpAFUz+PYHqFUSGYMPq8Kz9NPbws3aax9C+flODrlJHAMUWCCUwPpkEewfQso0IwYXT55IpcdY/NQ8ndh5alqfsK0jm2SDCBqcH0Px7BdDejQjBhdNgtc7EavCLbMaHk7j0NnzblqhiOMxJMYFIwveYRTCz6JpgwCnxwWaZ6oCDNkbHk7uPLs1XP7ESOORJMEHQwvesRTN9hVAgmdK6tGvZWynV8KHnu2TSwkD2bkGCC4ILpfY9gup5RIZjQubc7GVSUGVWxxJ5NSDCBWcE02yOYrmFUCCZ05g1171uaErWx5H4T33657NmEBBP4H0yx7sHEiBBM6LS9leKj7hKcsbVN7NmEBBP4F0yJbsFUxYgQTOgc78xPVY8UphNITezZ1DFjEa8VggnA72A6x4gQTOgMn1jBp0pGHNgQlOzZRDAB+BdMlxkRggntbZfMxRJLOcRQAHs28fohmACaCqY41jARTOgMH1iWoR5clkoEBejg5dmqexZ7NhFMAN6D6T23YDrKiBBMyN5K0ewDEpwPLcvkdUUwAXwumH4uloh7xXsYEYIJ7eVtOUnqseVZxE4I9mxqk8qeTQQTABBMaHsfLcpWAwrYWylUDlqeqfrkLuG1RjABAMGEdvSWNPZWCpf3NYQTezYRTABAMKGtvCMvVT1SlEHMhPsS3Yrchk1AeQ0STABAMKHFHaz3VuISXMR8uDBD3b00jdciwQQABBNa0c4ZCepJ9layzp5NK9iziWACAIIJLeWAggz10LI0YsViPrEiW3XLWsxrlGACAIIJI7230pMs7GbPJiSYAIBgQu/emp2kHmdvJVvt2dRaApfXLsEEUcCI0pIY8RWxC6NBMGHkfKQoi72V7LhnU1Gm6pOTzGuYYAKHx9IPxErX7VHqxQ6MCsGE4bVt2kL2VrL9nk0patDybF7PBBM4OJgGuN+AVxzDqBBMGD7756WoR9lbyTE+2bBn0yJe2wQTODCYfukRTB8yKgQThsfHG7YL4BKc8/ZsSld35afyGieYwGHBdKV41i2Y9OW5qxkZgglDZye9t9JK9lZy+p5NT7BnE8EEjoumLI9PmXowKgQThsb7CtLZWymKHLwiW3XNZM8mggmcEkwveQTT64wKwYTmGiPqvZXuISKib8+mgjT1wLIM3gcEEzggmNp5BNMqRoVgQvPsmZ2oHl+eTTywZ1PDpqS8JwgmsPc6pjNuwVQn/jsjQzBh8A4szFL3s7cSunxseabqxZ5NBBPYOpoWeHzK9CSjQjAheyuh+erNSR8tYs8mggnsGkyPeARTEqNCMGFg9stNUb9hbyVsbs8mCep26fG8ZwgmsFkwXSdWuwVThfg1RoZgQj/3VlrOdgFo3EcKM9Sd7NlEMIHtoimdy3IEEwZmx4xF7K2EQWw/wJ5NBBPYKZgGeQRTJqNCMGHz3rs0XQ0sTGfix6B8YkWO6pyZwHuKYAIbBNO14kW3YPqYUSGYsGn1vcPYWwnN8sFlqer+AvZsIpjADtH0mlswDWVECCb0bvesRDWYvZUwZHs25bFnE8EENoimNuKvGQmCCb370LJM9cCyVCZ2DPGeTVnq1uwk3nMEEwAQTPayTSp7K2Ek9mzK4v1HMAEAwWQP++QuUYOWZzKJY8Ruq6I3Q+W9SDABAMFkWQctz1H3MWljhH20KEPdnpfCe5JgAgCCyVq2T49XQ1ZwCQ4tZEGKGrwih/cnwQQABJM1vHtpmnq4kNuboIX3bMpgzyaCCQAIJvZWQmzSh5alqQEF6bxnCSawEiNKS74h/oKRIJicbLesxWrwCvZWQvuow15fNmbPJoIJrBFLvcQq12aW8YwIwcTeSojW27OpJ3s2EUwQ8WBa6HGPuQcYFYLJKbaWv5mztxI6wfsLUtTDhezZRDBBJIPpVY9g2it+kZEhmGy/t1JOshpUxN5KyJ5NBBOAOcF0nXjSI5q4zxzBZPO9lbLVfUtTmGDRkT5SmKH657JnE8EEkYimZz2CqUL8MSNDMNlvb6VFDd+CY1JF55uiHl/Onk0EE4Q7mK4UN3hEUw4jQzDZybvyU9XAwnQmUoy6PZs6ZiziHEAwQRijqZ1Y5xFNQxgZgskOPsHeShjlezbdy55NBBOENZre8wimc+J3GBmCyap2zWRvJcTGPZv05egYzgsEE4QlmK4V93lEU5Z4BaNDMFnNB5ZlqAcK0pgsEd18XP4C0TM7kWACCEM03eYRTNo/MjIEk1Vsxd5KiM3s2aTX82URTABhiKb3PYJJ7wTempEhmCJtr5xk9dhy9lZCZM8mggmsEUxfFrd5RFM+I0MwRdJHi7LVgAL2VkL0x98UZap+uUsIJoAQRlOMWOkWTCWMCsEUCdulx6snuQSHGOT96HIIJoAQRtNgsdz1bTnuMUcwhd0781MbdjVmwkMM3idX5qgO6YsIJoAQRdPVfEuOYIqEg1fkMMkhmqze3PWepWkEEwAQTHa3c2ZCw+7FTG6Iod2ziWACAILJpt5fkKEeXJbKpIYYBgcvz1bdsxIJJgAgmNhbCRGb8gH5C8pDhZkEEwAQTFb31uwk9djyLCYvxAjv2dRa/uJCMAGEiBGlJf8ptmckCKbA9lbKYm8lRIs4SP7i0scZezYRTGC5WPqD2z5NsWILRoVgMqLefZhLcIjW876GcMommABMDqZ1HruBzyeaCKbmvD0vRT1axN5KiNa+RJej2tt3zyaCCSwXTJO83Kg3Tu/dxOgQTD73VuISHKItfHhZuro7P41gAjAhmK4RC7xEU5r+b4wQwfTp3koZ7K2EaNs9m1bmEkwAIYymQvE6RohgGlCQrh5alsbkg2jnPZtWZKtumYsJJgAToinbSzSViDczQtEZTA17K63IbfgbKhMOogP2bCpIUw8uyySYAIKMJn3PucVeoumQ2JIRiq5g6pmdpB5nbyVE9mwimAC8RlMLcaaXaCoX72GEoiOYHi7MUvezsBvR2Xs2FWWq3jnJBBNAkOH0mpdoqhP/yOg4N5jYWwkx2vZsSlG/KcommACCjKanxGqPaKoXv8noOC+Y+ueytxJitPrkilzVPj2eYAIIIpp6iqc9gulbjIyzgql9wgfqnnwmDcRotn/WItV6cSzBBBBENP1YzBcPiy8yIs4JppjkearnknlMFoj46Z5NHRNmE0wAQDA12jplQekduUkXmSQQ0dNeWQkH5TxxlmACgGgOpvpOGfEb2FsJEZvyzvzk8tapcdsJJgCIumCKSVlQ1icncS+TASIatUvmomI5f9QSTAAmMqK05DfiOLEro2GtYGqbFrflrvzky0wAiOivfXMTD8pfuI4RTADmxNIAjy0I5og3MjIRD6aqbpkJmzjpI2Iw3p2fXHVL2sJNBBNA8MH0spfNLvWWBM/pHcQZofAHk/yN8FD/3KSjnOwR0Sx7ZCWUyPmlkmACCDyYfiae9RJN2k1id0YpfMHULn1h8d35S2o5wSOi2d6el3SyVWrcXoIJIPBo+ra4yEc0aVPFXzNSIQ2mi7dmL97GSR0RQ7xnU12H9PgNBBNAcOF0u1jqI5r0buGx4vcJJnNPMvI3vt135CWf5WSOiOHytuzFO+X8c45gAgg8mr4oviRe9BFO+j5174jfIJiCl72VEDGCezZdaJ0at5NgAggunP5DnOn6ZMlbOG2OxkXhJgbTqd45iaWctBEx0nbOWKQv0dURTADBhVNLMdNHNH2LYPLfNqlxW+/KT77EiRoRLbRn0/6YlAUnCCaA4MOpq1joFkvruCTntzVdMxdt5OSMiBbds6mybdrCzQQTgDnh1EF8UPwyweTX3kqH++UmHeakjIhWt3tWwuYA92wimACCWAf1tN7LSbwyWoOpXdrCjfI3txpOxIhooz2bTsSkLthPMAGEPpauF0+4XcI7LI4WW0dRMF3qmZ2wlZMvItp1z6b26QuLCSaA0AZTjyY2wtwm/kP8qVODqVVqXOkdeUmnOekiogP2bNoh57ULBBNAaILpa+KhJqKp0Z3iGFdgtXBCMHXMiF/P3kqI6Kg9m/KSzxnYs4lgAggwmm4U/+76REkZUN/0d67Y0abBdKZ3TuLHnFwR0aGX6Br3bKonmABCF0+txFEGP3XSu4n/wk7B5Npb6SInVUR0un1yEvfGpCw4STABhDacrnRdfntX3NdEND1sk2Cq7Zq5qJiTKCJGk3c17NkUV0IwAYQvoH7lumz3odttWPbrb9kZ+L2/FQvEBPENcZD+Fp54TTiCSf6GdaRfbuIhTp6IGK12y0rYJOfDKoIJIPxrnrqJ1xr4tT9r4tOpeld0zRZvCEUw3ZK2cNPd+cnVnDARMdrtn5t0TP4CeZBgArBmXHUwuJD8bTMft21a3He7ZSZkykliEyIifqL8BbK4Q3r8TGYnAOsF0xXifLfLeL6MZbQAAAAg2sPpOrGTOMT1LbxU8WOx1vXPXzJKAAAA1uL/AbyX0gaorLGAAAAAAElFTkSuQmCC"

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	var v1="<div id=\"account_setting-main\" gnp-common-wrapper-b=\"\"><div class=\"account container\"><form name=\"editForm\" gnp-submit=\"submit(account)\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12 col-md-12\"><div class=\"title\">{{:: \"_REGISTRATION.EDIT.GENERAL\" | translate }}</div></div></div><div class=\"col-md-12 col-md-12 content\"><div class=\"col-lg-12 col-md-12 row\"><div class=\"line\"></div><div class=\"col-sm-4 col-12 label\">{{:: \"_REGISTRATION.EDIT.YOURNAME\" | translate }}</div><div class=\"col-sm-4 col-12 error1\"><input type=\"text\" placeholder=\"{{ '_REGISTRATION.NEW.LAST_NAME' | translate }}\" ng-model=\"account.last_name\" name=\"last_name\" required=\"\" tabindex=\"1\" class=\"cell1\"/><div ng-show=\"editForm.last_name.$invalid &amp;&amp; !editForm.last_name.$pristine\" class=\"error\"><span ng-show=\"editForm.last_name.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</span></div></div><div class=\"col-sm-4 col-12 error1 last\"><input type=\"text\" placeholder=\"{{ '_REGISTRATION.NEW.FIRST_NAME' | translate }}\" ng-model=\"account.first_name\" name=\"first_name\" required=\"\" tabindex=\"2\" class=\"cell1\"/><div ng-show=\"editForm.first_name.$invalid &amp;&amp; !editForm.first_name.$pristine\" class=\"error\"><span ng-show=\"editForm.first_name.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</span></div></div></div><div class=\"col-lg-12 col-md-12 row\"><div class=\"line\"></div><div class=\"col-sm-4 col-12 label\">{{:: \"_REGISTRATION.EDIT.BIRTH_DATE\" | translate }}</div><div class=\"col-sm-8 col-12 error4\"><input name=\"birthday\" gnp-date-input=\"\" ng-model=\"account.birthday\" date-input-date=\"account.birthday\" required=\"\" t-index=\"3\"/><div ng-show=\"editForm.birthday.$invalid &amp;&amp; !editForm.birthday.$pristine\" class=\"error\"><div ng-show=\"editForm.birthday.$error.dateRequired\">{{:: \"VALIDATION.REQUIRED\" | translate }}</div><div ng-show=\"editForm.birthday.$error.dateValidate\">{{:: \"VALIDATION.DATE\" | translate }}</div></div></div></div><div class=\"col-lg-12 col-md-12 row\"><div class=\"line\"></div><div class=\"col-sm-4 col-12 label\">{{:: \"_REGISTRATION.EDIT.GENDER\" | translate }}</div><div style=\"margin-bottom: 25px\" class=\"col-sm-8 col-12 error1\"><select name=\"gender\" ng-model=\"account.gender\" ng-options=\"g.key as g.value for g in ::defaultData.genders\" tabindex=\"6\" class=\"cell2\"></select></div></div><div class=\"col-lg-12 col-md-12 row\"><div class=\"line\"></div><div class=\"col-sm-4 col-12 label\">{{:: \"_REGISTRATION.EDIT.COUNTRY\" | translate }}</div><div class=\"col-sm-8 col-12\"><div class=\"error2\"><select name=\"country\" ng-model=\"account.country\" ng-options=\"c.value as c.name for c in ::defaultData.countries\" required=\"\" tabindex=\"7\" class=\"cell2\"><option value=\"\" selected=\"selected\" disabled=\"disabled\">{{:: \"_REGISTRATION.NEW.COUNTRY_DEFAULT_TEXT\" | translate }}</option></select><div ng-show=\"editForm.country.$invalid &amp;&amp; !editForm.country.$pristine\" class=\"error\"><span ng-show=\"editForm.country.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</span></div></div><div ng-show=\"account.country === 'JPN'\" class=\"error3\"><select name=\"prefecture\" ng-required=\"account.country === 'JPN'\" ng-model=\"account.prefecture\" ng-options=\"c.value as c.name for c in ::defaultData.prefectures\" tabindex=\"8\" class=\"cell2\"><option value=\"\" selected=\"selected\" disabled=\"disabled\">{{:: \"_REGISTRATION.NEW.PREFECTURE_DEFAULT_TEXT\" | translate }}</option></select><div ng-show=\"editForm.prefecture.$invalid &amp;&amp; !editForm.prefecture.$pristine\" class=\"error\"><span ng-show=\"editForm.prefecture.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</span></div></div></div></div><div class=\"col-lg-12 col-md-12 row\"><div class=\"line\"></div><div class=\"col-sm-4 col-12 label\">{{:: \"_REGISTRATION.EDIT.EMAIL\" | translate }}</div><div class=\"col-sm-8 col-12 error2\"><input ng-show=\"isShowEmailInput\" placeholder=\"{{ '_REGISTRATION.EDIT.EMAIL' | translate }}\" ng-model=\"account.email\" name=\"email\" type=\"email\" gnp-custom-email-validator=\"\" required=\"\" tabindex=\"9\" class=\"cell3\"/><div ng-show=\"!isShowEmailInput\" class=\"show-email\"><p>{{:: account.email }}</p><a href=\"#\" ng-click=\"showEmailInput()\">{{:: '_REGISTRATION.EDIT.CHANGE_EMAIL' | translate }}</a></div><div class=\"confirmation-warning\"><a ng-if=\"!confirmationStatus\" href=\"/email_confirmation/new\">{{ '_CONFIRMATION.ACCOUNT_PAGE.TEXT' | translate}}</a></div><div ng-show=\"editForm.email.$invalid &amp;&amp; !editForm.email.$pristine\" class=\"error\"><span ng-show=\"editForm.email.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</span><span ng-show=\"editForm.email.$error.email\">{{:: \"VALIDATION.EMAIL\" | translate }}</span></div></div></div><div class=\"col-lg-12 col-md-12 row\"><div class=\"line\"></div><div class=\"col-sm-4 col-12 label change-password\">{{:: \"_REGISTRATION.EDIT.CHANGEPASSWORD\" | translate }}</div><div class=\"col-sm-12 col-12 xs-blank\"></div><div class=\"col-sm-8 col-12 error2\"><input name=\"current_password\" type=\"password\" ng-model=\"account.current_password\" ng-required=\"account.password\" placeholder=\"{{ '_REGISTRATION.EDIT.CURRENTPASSWORD' | translate }}\" tabindex=\"10\" class=\"cell3\"/><div ng-show=\"editForm.current_password.$invalid &amp;&amp; !editForm.current_password.$pristine\" class=\"error\"><span ng-show=\"editForm.current_password.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</span></div></div></div><div class=\"col-lg-12 col-md-12 row\"><div class=\"line1\"></div><div class=\"col-sm-4 col-12 label top-forgot-link\"><a ng-href=\"/password/new?email={{account.email}}\" tabindex=\"11\">{{:: \"_REGISTRATION.EDIT.FORGOTPASSWORD\" | translate }}</a></div><div class=\"col-sm-4 col-12 xs-blank\"></div><div class=\"col-sm-8 col-12 error2\"><input name=\"new_password\" type=\"password\" ng-model=\"account.password\" ng-minlength=\"10\" ng-maxlength=\"32\" ng-pattern=\"passwordPattern\" placeholder=\"{{ '_REGISTRATION.EDIT.NEWPASSWORD' | translate }}\" tabindex=\"12\" class=\"cell3\"/><div class=\"show-password-rule\"><p>{{:: \"_REGISTRATION.EDIT.RULE_PASSWORD_LABEL\" | translate }}</p></div><div ng-show=\"editForm.new_password.$invalid &amp;&amp; !editForm.new_password.$pristine\" class=\"error\"><span ng-show=\"editForm.new_password.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</span><span ng-show=\"editForm.new_password.$error.minlength\">{{:: \"VALIDATION.MIN_LENGTH\" | translate:'{\"n\": 10}' }}</span><span ng-show=\"editForm.new_password.$error.maxlength\">{{:: \"VALIDATION.MAX_LENGTH\" | translate:'{\"n\": 32}'}}</span><span ng-show=\"!editForm.new_password.$error.required &amp;&amp; !editForm.new_password.$error.minlength &amp;&amp; !editForm.new_password.$error.maxlength &amp;&amp; editForm.new_password.$error.pattern\">{{:: \"VALIDATION.STRENGTH\" | translate}}</span></div></div><div class=\"col-sm-4 col-12 xs-blank\"></div><div class=\"col-sm-8 ml-auto col-12 error3\"><input name=\"retry_password\" type=\"password\" ng-model=\"account.confirm_password\" ng-maxlength=\"32\" gnp-match-validate=\"account.password\" ng-required=\"account.password\" placeholder=\"{{ '_REGISTRATION.EDIT.CONFIRMPASSWORD' | translate }}\" tabindex=\"13\" class=\"cell4\"/><div ng-show=\"editForm.retry_password.$invalid &amp;&amp; !editForm.retry_password.$pristine\" class=\"error\"><span ng-show=\"editForm.retry_password.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</span><span ng-show=\"editForm.retry_password.$error.maxlength\">{{:: \"VALIDATION.MAX_LENGTH\" | translate:'{\"n\": 32}'}}</span><span ng-show=\"!editForm.retry_password.$error.required &amp;&amp; !editForm.retry_password.$error.maxlength &amp;&amp; editForm.retry_password.$error.matchValidate\">{{:: \"VALIDATION.MATCH\" | translate }}</span></div></div><div class=\"col-sm-12 col-12 label bottom-forgot-link\"><a ng-href=\"/password/new?email={{account.email}}\" tabindex=\"14\">{{:: \"_REGISTRATION.EDIT.FORGOTPASSWORD\" | translate }}</a></div></div><div class=\"col-lg-12 col-md-12 row last\"><div class=\"line2\"></div><div class=\"col-5 blank\"></div><div class=\"col-2 btn-warp\"><button type=\"submit\" gnp-submitting-button=\"isSubmitting\" tabindex=\"15\" class=\"btn btn-save\">{{:: 'SAVE' | translate }}</button></div></div></div></form></div><script>$(document.body).css('min-width', 0)</script></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/registration/edit.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var TermInterceptor, TermService;
	
	__webpack_require__(28);
	
	TermService = __webpack_require__(334);
	
	TermInterceptor = __webpack_require__(335);
	
	angular.module('gnp-term', []).factory('TermService', TermService).factory('TermInterceptor', TermInterceptor).config([
	  '$httpProvider', function($httpProvider) {
	    return $httpProvider.interceptors.push('TermInterceptor');
	  }
	]).value('returnUrlAfterTerm', {
	  url: '/'
	});


/***/ }),
/* 334 */
/***/ (function(module, exports) {

	var TermService;
	
	TermService = function($http, $location, returnUrlAfterTerm) {
	  return {
	    get: function() {
	      return $http.get('/api/term.json');
	    },
	    accept: function() {
	      return $http.put('/api/term/accept.json').then(function(response) {
	        return $location.path(returnUrlAfterTerm.url);
	      });
	    },
	    acceptLocal: function(version) {
	      localStorage.setItem("acceptedTermVersion", version);
	      return $location.path('/registration/email');
	    },
	    isAccepted: function() {
	      return localStorage.getItem("acceptedTermVersion");
	    },
	    getAcceptedTermVersion: function() {
	      return localStorage.getItem('acceptedTermVersion');
	    },
	    clearAcceptLocal: function() {
	      return localStorage.removeItem('acceptedTermVersion');
	    }
	  };
	};
	
	TermService.$inject = ['$http', '$location', 'returnUrlAfterTerm'];
	
	module.exports = TermService;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

	var TermInterceptor;
	
	TermInterceptor = function($q, $location, returnUrlAfterTerm) {
	  var saveCurrentUrl;
	  saveCurrentUrl = function() {
	    if ($location.path() !== '/term') {
	      return returnUrlAfterTerm.url = $location.path();
	    }
	  };
	  return {
	    responseError: function(rejection) {
	      var ref;
	      switch (rejection.status) {
	        case 400:
	          if (((ref = rejection.data) != null ? ref.code : void 0) === 'error.term_not_accepted') {
	            saveCurrentUrl();
	          }
	      }
	      return $q.reject(rejection);
	    }
	  };
	};
	
	TermInterceptor.$inject = ['$q', '$location', 'returnUrlAfterTerm'];
	
	module.exports = TermInterceptor;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(337);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_registration.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_registration.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#registration-main{background-image:url("+__webpack_require__(265)+");background-position:center;background-repeat:no-repeat;background-size:cover}#registration-main .cell{padding:0}#registration-main .bg-img{background-image:url("+__webpack_require__(265)+");background-position:center;background-repeat:no-repeat;background-size:cover}#registration-main .bg-img .container.content{padding:70px 0 50px}#registration-main .bg-img .container.content .area{position:relative}#registration-main .bg-img .container.content .area .title-tag{position:relative;height:120px;background-repeat:no-repeat}#registration-main .bg-img .container.content .area .display-image{position:relative;height:400px;background-repeat:no-repeat;top:224px}#registration-main .bg-img .container.content .area .display-image img{position:relative;max-width:440px;left:100px}#registration-main .bg-img .container.content .area .title-tag img{width:100%}#registration-main .bg-img .container.content .frame{position:relative;min-height:574px}#registration-main .bg-img .container.content .frame .content-message{position:relative;width:320px;left:50%;margin-left:-160px;margin-top:0;margin-bottom:0;background-color:#fff}#registration-main .bg-img .container.content .frame .content-message .message{margin:5px 20px 0;padding:10px 0;position:relative;border-radius:10px;font-size:15px;text-indent:10px}#registration-main .bg-img .container.content .frame .content-message .message ul,#registration-main .bg-img .container.content .frame .content-message .message ol{margin:0}#registration-main .bg-img .container.content .frame .content-message .error{top:12px;background:#fbe3e4;color:#8a1f11;border-color:#fbc2c4;border-style:solid}#registration-main .bg-img .container.content .frame .newform{width:100%;padding:0;background-color:#fff;text-align:center}#registration-main .bg-img .container.content .frame .newform .row{width:100%;padding:0;margin:0}#registration-main .bg-img .container.content .frame .newform .row a{color:#555;text-decoration:underline}#registration-main .bg-img .container.content .frame .newform .row .cell1{min-height:50px;padding:0 25px}#registration-main .bg-img .container.content .frame .newform .row .cell1.first{min-height:80px;padding-top:30px}#registration-main .bg-img .container.content .frame .newform .row .row-name{display:-ms-flexbox;display:flex}#registration-main .bg-img .container.content .frame .newform .row .first_name,#registration-main .bg-img .container.content .frame .newform .row .last_name{padding:0}#registration-main .bg-img .container.content .frame .newform .row.content-email-newsletter{text-align:left}#registration-main .bg-img .container.content .frame .newform .row.content-email-newsletter .custom-checkbox{-moz-appearance:none;appearance:none;-webkit-appearance:none;width:20px;height:20px;border:1px solid #333;border-radius:5px;position:relative;cursor:pointer;background:#fff}#registration-main .bg-img .container.content .frame .newform .row.content-email-newsletter .custom-checkbox:checked{background-color:#10A6A6;border-color:#10A6A6;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E\");background-size:14px;background-position:center;background-repeat:no-repeat}#registration-main .bg-img .container.content .frame .newform .row.content-email-newsletter .col-11{margin-top:5px;padding-left:5px}#registration-main .bg-img .container.content .frame .newform .row .error{background-color:transparent;border:0;text-align:left;line-height:24px;padding:2px 0 2px 10px;margin:0;color:#8a1f11}#registration-main .bg-img .container.content .frame .newform .row .error.address{float:inherit}#registration-main .bg-img .container.content .frame .newform .row input[type=email],#registration-main .bg-img .container.content .frame .newform .row input[type=password]{position:relative;text-indent:5px;background-color:#fff;width:100%;height:40px;border-radius:4px;border-color:#bbb;border-width:1px;border-style:solid}#registration-main .bg-img .container.content .frame .newform .row input[type=text][name=last_name]{position:relative;text-indent:5px;float:left;background-color:#fff;width:calc(100% - 3px);height:40px;border-radius:4px;border-color:#bbb;border-width:1px;border-style:solid}#registration-main .bg-img .container.content .frame .newform .row input[type=text][name=first_name]{position:relative;text-indent:5px;float:right;background-color:#fff;width:calc(100% - 2px);height:40px;border-radius:4px;border-color:#bbb;border-width:1px;border-style:solid}#registration-main .bg-img .container.content .frame .newform .row input[name=year]{float:left}#registration-main .bg-img .container.content .frame .newform .row input[name=year],#registration-main .bg-img .container.content .frame .newform .row input[name=month],#registration-main .bg-img .container.content .frame .newform .row input[name=day]{position:relative;text-indent:5px;background-color:#fff;width:100%;height:40px;border-radius:4px;border-color:#bbb;border-width:1px;border-style:solid}#registration-main .bg-img .container.content .frame .newform .row input[name=day]{float:right}#registration-main .bg-img .container.content .frame .newform .row .gender{background-color:#fff;width:250px;height:40px;border-radius:4px;border-color:#bbb;border-width:1px;border-style:solid}#registration-main .bg-img .container.content .frame .newform .row .country{float:left;background-color:#fff;width:120px;height:40px;border-radius:4px;border-color:#bbb;border-width:1px;border-style:solid}#registration-main .bg-img .container.content .frame .newform .row .prefecture{float:right;background-color:#fff;width:120px;height:40px;border-radius:4px;border-color:#bbb;border-width:1px;border-style:solid}#registration-main .bg-img .container.content .frame .newform .row .submit{height:120px;width:100%;background-color:#e1e1e1}#registration-main .bg-img .container.content .frame .newform .row .submit .new_sign_up-btn{margin-top:35px;font-size:19px;color:#fff;background-color:#01a5a3;width:200px;height:45px;border-radius:4px;border-color:#01a5a3;border-width:1px;border-style:solid}#registration-main .bg-img .container.content .frame .newform .row .submit .new_sign_up-btn:disabled{background-color:#ccc;border-color:#ccc}#registration-main .bg-img .container.content .frame .register-email-success .col-12{text-align:center}#registration-main .bg-img .container.content .frame .register-email-success .col-12 img{width:50%;margin:20px 0 10px}#registration-main .bg-img .container.content .frame .register-email-success .col-12 h5{color:#2DB2A6}#registration-main .bg-img .container.content .frame .register-email-success .col-12 .email{padding-bottom:20px}#registration-main .bg-img .container.content .frame .register-email-success .col-12 a{color:#555;text-decoration:underline}#registration-main .bg-img .container.content .frame .register-email-success .last-row{margin-bottom:40px}#registration-main #gnp-footer{margin-top:0}#registration-main .loader-registration{width:100%;height:700px;position:absolute;z-index:1;margin-top:-5px}#registration-main .loader-registration .loader-background{position:absolute;width:100%;height:100%;background-color:#333;opacity:.5}#registration-main .loader-registration .loader-data{width:15em;height:15em;margin-top:15%;font-size:7px}#registration-main .registration-new-user .container.content .frame .newform .row p{text-align:left;margin-bottom:5px}#registration-main .registration-new-user .container.content .frame .newform .row .cell1.first{min-height:auto}#registration-main .registration-new-user .container.content .frame .newform .row .cell1{min-height:auto;margin-bottom:10px}#registration-main .registration-new-user .container.content .frame .newform .row .cell1 .col-4{padding:0;width:25%;float:left;margin-left:5px;-ms-flex:0 0 25%;flex:0 0 25%}#registration-main .registration-new-user .container.content .frame .newform .row .cell1 .col-4:first-child{width:calc(50% - 10px);margin:0;-ms-flex:0 0 calc(50% - 15px);flex:0 0 calc(50% - 15px)}#registration-main .registration-new-user .container.content .frame .newform .row .cell1 .col-5{padding:0;text-align:left;width:120px;-ms-flex:0 0 120px;flex:0 0 120px}#registration-main .registration-new-user .container.content .frame .newform .row .cell1 .col-5 input{width:30px;height:30px;margin-right:5px;display:inline-block}#registration-main .registration-new-user .container.content .frame .newform .row .cell1 .col-5 input:checked{background-color:#fff;accent-color:#fff;-moz-appearance:none;appearance:none;-webkit-appearance:none;border-radius:50%;outline:none;border:8px solid #10A6A6;width:30px;height:30px}#registration-main .registration-new-user .container.content .frame .newform .row .cell1 .col-5 label{display:block;width:calc(100% - 45px);float:right;margin-top:10px}#registration-main .registration-new-user .container.content .frame .newform .row input[type=password]::-webkit-input-placeholder{font-size:10px}#registration-main .registration-new-user .container.content .frame .newform .row input[type=password]:-ms-input-placeholder{font-size:10px}#registration-main .registration-new-user .container.content .frame .newform .row input[type=password]::placeholder{font-size:10px}#registration-main .registration-new-user .container.content .frame .newform .row .submit{background-color:#fff}.modal-dialog .modal-body{text-align:center;font-weight:700}.modal-dialog .modal-footer button{background:#fff;color:#3D7CF7;border:none;font-weight:700}.modal-backdrop{z-index:99999}.modal{z-index:999999}@media (max-width:1200px){#registration-main .registration-new-user .container.content .frame .newform .row input[type=password]::-webkit-input-placeholder{font-size:8px}#registration-main .registration-new-user .container.content .frame .newform .row input[type=password]:-ms-input-placeholder{font-size:8px}#registration-main .registration-new-user .container.content .frame .newform .row input[type=password]::placeholder{font-size:8px}}@media (max-width:991px){#registration-main .registration-new-user .container.content .frame .newform .row input[type=password]::-webkit-input-placeholder{font-size:10px}#registration-main .registration-new-user .container.content .frame .newform .row input[type=password]:-ms-input-placeholder{font-size:10px}#registration-main .registration-new-user .container.content .frame .newform .row input[type=password]::placeholder{font-size:10px}}@media (max-width:768px){#registration-main div.display-image{display:none}#registration-main .bg-img .container.content .frame .newform{left:0;margin:0 auto}#registration-main .registration-new-user .container.content{padding:35px 0 50px}#registration-main .registration-new-user .container.content .area .title-tag{display:none}#registration-main .registration-new-user .container.content .frame .newform .row input[type=password]::-webkit-input-placeholder{font-size:8px}#registration-main .registration-new-user .container.content .frame .newform .row input[type=password]:-ms-input-placeholder{font-size:8px}#registration-main .registration-new-user .container.content .frame .newform .row input[type=password]::placeholder{font-size:8px}}", ""]);

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(339);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_account_setting.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_account_setting.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#account_setting-main .account.container{max-width:970px}#account_setting-main .cell{padding:0}#account_setting-main .account.container{position:relative}#account_setting-main .account.container .blank{height:100px;padding:0}#account_setting-main .account.container .title{position:relative;width:160px;height:50px;margin:50px auto 0;padding:0;line-height:40px;text-align:center;font-size:22px;color:#01a5a3;border-bottom:3px solid #01a5a3}#account_setting-main .account.container .content{position:relative;padding:60px 0 0;background-color:#fff}#account_setting-main .account.container .content .row{padding:0 80px;margin:0}#account_setting-main .account.container .content .row input,#account_setting-main .account.container .content .row select{width:100%;max-width:500px}#account_setting-main .account.container .content .row .row-date{padding:0}#account_setting-main .account.container .content .row .confirmation-warning{margin:3px 8px;font-size:16px}#account_setting-main .account.container .content .row .confirmation-warning a{color:orange}#account_setting-main .account.container .content .row .show-email{font-size:16px;margin-top:3px;padding-left:8px}#account_setting-main .account.container .content .row .show-email p{margin-bottom:0}#account_setting-main .account.container .content .row .show-password-rule{padding-left:8px}#account_setting-main .account.container .content .row .error{background-color:transparent;border:0;text-align:left;padding:7px 10px 3px;margin:0;color:#8a1f11}#account_setting-main .account.container .content .row .error1{margin:25px 0 0}#account_setting-main .account.container .content .row .error2{margin:25px 0 0;min-height:65px}#account_setting-main .account.container .content .row .error3{margin:5px 0 0;height:75px}#account_setting-main .account.container .content .row .error4{margin:25px 0 0;padding:0 0 0 15px}#account_setting-main .account.container .content .row .line{position:relative;margin:auto;border:1px solid #e2e2e2;width:100%}#account_setting-main .account.container .content .row .line1{position:relative;margin:auto 0 auto 36%;border:1px solid #e2e2e2;width:100%}#account_setting-main .account.container .content .row .label{height:100px;top:43px;padding:0;font-size:14px;color:#000;font-weight:700;text-align:left}#account_setting-main .account.container .content .row .label.top-forgot-link{max-height:160px}#account_setting-main .account.container .content .row .label.bottom-forgot-link{top:0;height:50px}#account_setting-main .account.container .content .row input[type=text][name=last_name],#account_setting-main .account.container .content .row input[type=text][name=first_name]{position:relative;margin:3px 8px 0;font-size:15px;text-indent:10px;background-color:0;width:100%;height:40px;border-radius:5px;border-color:#e2e2e2;border-width:2px;border-style:solid}#account_setting-main .account.container .content .row input[type=number][name=year],#account_setting-main .account.container .content .row input[type=number][name=month],#account_setting-main .account.container .content .row input[type=number][name=day]{position:relative;margin:3px 7px 0;text-indent:10px;font-size:15px;background-color:0;width:160px;height:40px;border-radius:5px;border-color:#e2e2e2;border-width:2px;border-style:solid}#account_setting-main .account.container .content .row input[type=text][name=mail],#account_setting-main .account.container .content .row input[type=email][name=email],#account_setting-main .account.container .content .row .cell2{position:relative;margin:3px 8px 0;text-indent:5px;font-size:15px;background-color:0;width:100%;height:40px;border-radius:5px;border-color:#e2e2e2;border-width:2px;border-style:solid}#account_setting-main .account.container .content .row input[type=password][name=current_password],#account_setting-main .account.container .content .row input[type=password][name=new_password],#account_setting-main .account.container .content .row input[type=password][name=retry_password]{position:relative;margin:3px 8px 0;font-size:15px;text-indent:10px;background-color:0;width:100%;height:40px;border-radius:5px;border-color:#e2e2e2;border-width:2px;border-style:solid}@media (max-width:991px){#account_setting-main .account.container .content .row input[type=number][name=year],#account_setting-main .account.container .content .row input[type=number][name=month],#account_setting-main .account.container .content .row input[type=number][name=day]{width:112px}}@media (max-width:768px){#account_setting-main .account.container .content .row .error1.last{margin-top:0;margin-bottom:25px}#account_setting-main .account.container .content .row .label{height:20px;top:15px}}@media (min-width:768px){#account_setting-main .account.container .content .row .xs-blank,#account_setting-main .account.container .content .row .label.bottom-forgot-link{display:none}}@media (max-width:760px){#account_setting-main .account.container .content .row .line1{margin-left:40%}}@media (max-width:767px){#account_setting-main .account.container .content .row .label.top-forgot-link{display:none}#account_setting-main .account.container .content .row input[type=number][name=year],#account_setting-main .account.container .content .row input[type=number][name=month],#account_setting-main .account.container .content .row input[type=number][name=day]{width:100%}#account_setting-main .account.container .content .row .error4{margin:25px 0;padding:0 15px}}@media (max-width:400px){#account_setting-main .account.container .content .row input[type=password][name=current_password],#account_setting-main .account.container .content .row input[type=password][name=new_password],#account_setting-main .account.container .content .row input[type=password][name=retry_password]{font-size:13px}}@media (max-width:479px){#account_setting-main .account.container .content .row{padding:0 15px}}#account_setting-main .account.container .content .link{position:relative;top:-24px;left:80px;font-size:14px;text-decoration:none}#account_setting-main .account.container .content .last.row{top:-30px;height:100px;padding:0;margin:0}#account_setting-main .account.container .content .last.row .line2{position:relative;margin:25px auto 0;border:1px solid #e2e2e2;width:100%}#account_setting-main .account.container .content .last.row .btn-wrap{margin:0 auto}#account_setting-main .account.container .content .last.row .btn-save{position:relative;left:50%;margin:40px 0 0 -90px;text-align:center;font-size:15px;line-height:0;color:#fff;background-color:#000;width:180px;height:40px;border-radius:5px;border-color:#000;border-width:2px;border-style:solid}", ""]);

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var RegistrationNewCtrl;
	
	RegistrationNewCtrl = function($scope, $routeParams, $filter, $translate, $location, flash, RegistrationService, AuthService, TermService) {
	  if (AuthService.isSignedIn()) {
	    return $location.path('/');
	  }
	  $scope.isSubmitting = false;
	  $scope.account = {
	    gender: 'male',
	    email_newsletter: true
	  };
	  $scope.passwordPattern = /^(?=.{10,}$)((?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*\d))|(?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*[!"#$%&'()*+,\-\.\ \/:;<=>?@\[\\\]^_`{|}~]))|(?=(?:.*[a-z]))(?=(?:.*\d))(?=(?:.*[!"#$%&'()*+,\-\.\ \/:;<=>?@\[\\\]^_`{|}~]))|(?=(?:.*[A-Z]))(?=(?:.*\d))(?=(?:.*[!"#$%&'()*+,\-\.\ \/:;<=>?@\[\\\]^_`{|}~])))[A-Za-z\d!"#$%&'()*+,\-\.\ \/:;<=>?@\[\\\]^_`{|}~]+$/;
	  $scope.account.token = '';
	  $scope.isLoading = true;
	  $(document).ready(function() {
	    var token;
	    token = $routeParams.token;
	    return RegistrationService.check_token(token).then(function(resp) {
	      $scope.account.token = resp.data.token;
	      return $('.crop-image-modal').modal('hide');
	    })["catch"](function(resp) {
	      var ref;
	      if (((ref = resp.data) != null ? ref.code : void 0) === 'error.token_expired') {
	        return $('.crop-image-modal').modal('show');
	      } else {
	        return flash.error($filter('translate')('API_ERROR'));
	      }
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  });
	  $scope.closeModal = function() {
	    $('.crop-image-modal').modal('hide');
	    window.location = '/';
	  };
	  $scope.defaultData = RegistrationService.getDefaultData();
	  $scope.translateData = {
	    password: {
	      minlength: {
	        subject: $filter('translate')('_REGISTRATION.NEW.PASSWORD'),
	        n: 10
	      },
	      maxlength: {
	        subject: $filter('translate')('_REGISTRATION.NEW.PASSWORD'),
	        n: 32
	      }
	    }
	  };
	  return $scope.submit = function(account) {
	    $scope.isSubmitting = true;
	    return RegistrationService.create(account).then(function(resp) {
	      AuthService.signInBypass();
	      TermService.clearAcceptLocal();
	      return $location.path('/');
	    })["catch"](function(resp) {
	      var ref, ref1;
	      if (((ref = resp.data) != null ? ref.code : void 0) === 'error.token_expired') {
	        return $('.crop-image-modal').modal('show');
	      } else if (((ref1 = resp.data) != null ? ref1.code : void 0) === 'error.email_already_taken') {
	        return flash.error($filter('translate')('EMAIL_DUPLICATED'));
	      } else {
	        return flash.error($filter('translate')('API_ERROR'));
	      }
	    })["finally"](function() {
	      return $scope.isSubmitting = false;
	    });
	  };
	};
	
	RegistrationNewCtrl.$inject = ['$scope', '$routeParams', '$filter', '$translate', '$location', 'flash', 'RegistrationService', 'AuthService', 'TermService'];
	
	module.exports = RegistrationNewCtrl;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	var RegistrationEmailCtrl;
	
	RegistrationEmailCtrl = function($scope, $filter, $translate, $location, flash, RegistrationService, AuthService, TermService) {
	  if (AuthService.isSignedIn()) {
	    return $location.path('/');
	  }
	  $scope.isSubmitting = false;
	  RegistrationService.clearAcceptLocal();
	  $scope.email = '';
	  return $scope.submit = function(email) {
	    $scope.isSubmitting = true;
	    return RegistrationService.create_email(email).then(function(resp) {
	      RegistrationService.setTokenFormEmail(data.email);
	      return $location.path("/registration/email/success");
	    })["catch"](function(resp) {
	      var ref;
	      if (((ref = resp.data) != null ? ref.code : void 0) === 'E0101') {
	        return flash.error($filter('translate')('EMAIL_DUPLICATED'));
	      } else {
	        return flash.error($filter('translate')('API_ERROR'));
	      }
	    })["finally"](function() {
	      return $scope.isSubmitting = false;
	    });
	  };
	};
	
	RegistrationEmailCtrl.$inject = ['$scope', '$filter', '$translate', '$location', 'flash', 'RegistrationService', 'AuthService', 'TermService'];
	
	module.exports = RegistrationEmailCtrl;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

	var RegistrationEmailSuccessCtrl;
	
	RegistrationEmailSuccessCtrl = function($scope, $filter, $translate, $location, flash, RegistrationService, AuthService, TermService) {
	  if (AuthService.isSignedIn()) {
	    return $location.path('/');
	  }
	  return $scope.email = RegistrationService.getTokenFormEmail();
	};
	
	RegistrationEmailSuccessCtrl.$inject = ['$scope', '$filter', '$translate', '$location', 'flash', 'RegistrationService', 'AuthService', 'TermService'];
	
	module.exports = RegistrationEmailSuccessCtrl;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

	var RegistrationEditCtrl;
	
	RegistrationEditCtrl = function($scope, $filter, $translate, $location, flash, account, RegistrationService, AccountService, confirmationStatus) {
	  $scope.account = account;
	  $scope.originalEmail = account.email;
	  $scope.defaultData = RegistrationService.getDefaultData();
	  $scope.isSubmitting = false;
	  $scope.isShowEmailInput = false;
	  $scope.passwordPattern = /^(?=.{10,}$)((?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*\d))|(?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*[!"#$%&'()*+,\-\.\ \/:;<=>?@\[\\\]^_`{|}~]))|(?=(?:.*[a-z]))(?=(?:.*\d))(?=(?:.*[!"#$%&'()*+,\-\.\ \/:;<=>?@\[\\\]^_`{|}~]))|(?=(?:.*[A-Z]))(?=(?:.*\d))(?=(?:.*[!"#$%&'()*+,\-\.\ \/:;<=>?@\[\\\]^_`{|}~])))[A-Za-z\d!"#$%&'()*+,\-\.\ \/:;<=>?@\[\\\]^_`{|}~]+$/;
	  $scope.confirmationStatus = confirmationStatus;
	  $scope.submit = function(account) {
	    $scope.isSubmitting = true;
	    return RegistrationService.update(account).then(function(resp) {
	      flash.success($filter('translate')('API_SUCCESS'));
	      return $scope.$emit("accountUpdated.gnp.AccountService");
	    })["catch"](function(resp) {
	      var ref, ref1;
	      if (((ref = resp.data) != null ? ref.code : void 0) === 'error.email_already_taken') {
	        return flash.error($filter('translate')('EMAIL_DUPLICATED'));
	      } else if (((ref1 = resp.data) != null ? ref1.code : void 0) === 'error.current_password_wrong') {
	        return flash.error($filter('translate')('CURRENT_PASSWORD_ERROR'));
	      } else {
	        return flash.error($filter('translate')('API_ERROR'));
	      }
	    })["finally"](function() {
	      return $scope.isSubmitting = false;
	    });
	  };
	  return $scope.showEmailInput = function() {
	    $scope.isShowEmailInput = true;
	    return false;
	  };
	};
	
	RegistrationEditCtrl['$inject'] = ['$scope', '$filter', '$translate', '$location', 'flash', 'account', 'RegistrationService', 'AccountService', 'confirmationStatus'];
	
	module.exports = RegistrationEditCtrl;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var RegistrationService, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	RegistrationService = function($http, $q, CountryService, PrefectureService, GenderService, TermService) {
	  var formatBirthDay;
	  formatBirthDay = function(date) {
	    return date.format('YYYY-MM-DD');
	  };
	  return {
	    create_email: function(email) {
	      var data;
	      data = _.merge({}, {
	        email: email,
	        accepted_term_version: TermService.getAcceptedTermVersion()
	      });
	      return $http.post('api/registrations/user/email.json', data);
	    },
	    check_token: function(token) {
	      var data;
	      data = _.merge({}, {
	        token: token
	      });
	      return $http.post('api/registrations/user/email/token.json', data);
	    },
	    create: function(account) {
	      var data;
	      data = _.merge({}, account, {
	        birthday: formatBirthDay(account.birthday),
	        accepted_term_version: TermService.getAcceptedTermVersion()
	      });
	      return $http.post('api/registrations/user/email/create.json', data);
	    },
	    get: function() {
	      var delay;
	      delay = $q.defer();
	      $http.get('/api/settings/account.json').then(function(resp) {
	        return delay.resolve(resp.data);
	      })["catch"](function(resp) {
	        return delay.reject('auth error');
	      });
	      return delay.promise;
	    },
	    update: function(account) {
	      var data;
	      data = _.merge({}, account, {
	        birthday: formatBirthDay(account.birthday)
	      });
	      return $http.put('/api/settings/account.json', data);
	    },
	    getDefaultData: function() {
	      return {
	        countries: CountryService.get(),
	        prefectures: PrefectureService.get(),
	        genders: GenderService.get()
	      };
	    },
	    getTokenFormEmail: function() {
	      return localStorage.getItem('tokenFormEmail');
	    },
	    setTokenFormEmail: function(email) {
	      return localStorage.setItem("tokenFormEmail", email);
	    },
	    clearAcceptLocal: function() {
	      return localStorage.removeItem('tokenFormEmail');
	    }
	  };
	};
	
	RegistrationService.$inject = ['$http', '$q', 'CountryService', 'PrefectureService', 'GenderService', 'TermService'];
	
	module.exports = RegistrationService;


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	var CountryService;
	
	CountryService = function() {
	  return {
	    get: function() {
	      var countries;
	      countries = [
	        {
	          name: "Japan 日本",
	          value: "JPN"
	        }, {
	          name: "Afghanistan",
	          value: "AFG"
	        }, {
	          name: "Albania",
	          value: "ALB"
	        }, {
	          name: "Algeria",
	          value: "DZA"
	        }, {
	          name: "Andorra",
	          value: "AND"
	        }, {
	          name: "Angola",
	          value: "AGO"
	        }, {
	          name: "Antigua and Barbuda",
	          value: "ATG"
	        }, {
	          name: "Argentina",
	          value: "ARG"
	        }, {
	          name: "Armenia",
	          value: "ARM"
	        }, {
	          name: "Australia",
	          value: "AUS"
	        }, {
	          name: "Austria",
	          value: "AUT"
	        }, {
	          name: "Azerbaijan",
	          value: "AZE"
	        }, {
	          name: "Bahamas",
	          value: "BHS"
	        }, {
	          name: "Bahrain",
	          value: "BHR"
	        }, {
	          name: "Bangladesh",
	          value: "BGD"
	        }, {
	          name: "Barbados",
	          value: "BRB"
	        }, {
	          name: "Belarus",
	          value: "BLR"
	        }, {
	          name: "Belgium",
	          value: "BEL"
	        }, {
	          name: "Belize",
	          value: "BLZ"
	        }, {
	          name: "Benin",
	          value: "BEN"
	        }, {
	          name: "Bhutan",
	          value: "BTN"
	        }, {
	          name: "Bolivia",
	          value: "BOL"
	        }, {
	          name: "Bosnia and Herzegovina",
	          value: "BIH"
	        }, {
	          name: "Botswana",
	          value: "BWA"
	        }, {
	          name: "Brazil",
	          value: "BRA"
	        }, {
	          name: "Brunei Darussalam",
	          value: "BRN"
	        }, {
	          name: "Bulgaria",
	          value: "BGR"
	        }, {
	          name: "Burkina Faso",
	          value: "BFA"
	        }, {
	          name: "Burundi",
	          value: "BDI"
	        }, {
	          name: "Cambodia",
	          value: "KHM"
	        }, {
	          name: "Cameroon",
	          value: "CMR"
	        }, {
	          name: "Canada",
	          value: "CAN"
	        }, {
	          name: "Cape Verde",
	          value: "CPV"
	        }, {
	          name: "Central African Republic",
	          value: "CAF"
	        }, {
	          name: "Chad",
	          value: "TCD"
	        }, {
	          name: "Chile",
	          value: "CHL"
	        }, {
	          name: "China",
	          value: "CHN"
	        }, {
	          name: "Chinese Taipei",
	          value: "TWN"
	        }, {
	          name: "Colombia",
	          value: "COL"
	        }, {
	          name: "Comoros",
	          value: "COM"
	        }, {
	          name: "Congo",
	          value: "COG"
	        }, {
	          name: "Costa Rica",
	          value: "CRI"
	        }, {
	          name: "Cote d'Ivoire",
	          value: "CIV"
	        }, {
	          name: "Croatia",
	          value: "HRV"
	        }, {
	          name: "Cuba",
	          value: "CUB"
	        }, {
	          name: "Cyprus",
	          value: "CYP"
	        }, {
	          name: "Czech Republic",
	          value: "CZE"
	        }, {
	          name: "Democratic People's of Korea",
	          value: "PRK"
	        }, {
	          name: "Denmark",
	          value: "DNK"
	        }, {
	          name: "Djibouti",
	          value: "DJI"
	        }, {
	          name: "Dominica",
	          value: "DMA"
	        }, {
	          name: "Dominican Republic",
	          value: "DOM"
	        }, {
	          name: "Ecuador",
	          value: "ECU"
	        }, {
	          name: "Egypt",
	          value: "EGY"
	        }, {
	          name: "El Salvador",
	          value: "SLV"
	        }, {
	          name: "Equatorial Guinea",
	          value: "GNQ"
	        }, {
	          name: "Eritrea",
	          value: "ERI"
	        }, {
	          name: "Estonia",
	          value: "EST"
	        }, {
	          name: "Ethiopia",
	          value: "ETH"
	        }, {
	          name: "Federated States of Micronesia",
	          value: "FSM"
	        }, {
	          name: "Fiji",
	          value: "FJI"
	        }, {
	          name: "Finland",
	          value: "FIN"
	        }, {
	          name: "France",
	          value: "FRA"
	        }, {
	          name: "Gabon",
	          value: "GAB"
	        }, {
	          name: "Gambia",
	          value: "GMB"
	        }, {
	          name: "Georgia",
	          value: "GEO"
	        }, {
	          name: "Germany",
	          value: "DEU"
	        }, {
	          name: "Ghana",
	          value: "GHA"
	        }, {
	          name: "Greece",
	          value: "GRC"
	        }, {
	          name: "Greenland",
	          value: "GRL"
	        }, {
	          name: "Grenada",
	          value: "GRD"
	        }, {
	          name: "Guatemala",
	          value: "GTM"
	        }, {
	          name: "Guinea",
	          value: "GIN"
	        }, {
	          name: "Guinea-Bissau",
	          value: "GNB"
	        }, {
	          name: "Guyana",
	          value: "GUY"
	        }, {
	          name: "Haiti",
	          value: "HTI"
	        }, {
	          name: "Holy See (Vatican City State)",
	          value: "VAT"
	        }, {
	          name: "Honduras",
	          value: "HND"
	        }, {
	          name: "Hungary",
	          value: "HUN"
	        }, {
	          name: "Iceland",
	          value: "ISL"
	        }, {
	          name: "India",
	          value: "IND"
	        }, {
	          name: "Indonesia",
	          value: "IDN"
	        }, {
	          name: "Iraq",
	          value: "IRQ"
	        }, {
	          name: "Ireland",
	          value: "IRL"
	        }, {
	          name: "Islamic Republic of Iran",
	          value: "IRN"
	        }, {
	          name: "Israel",
	          value: "ISR"
	        }, {
	          name: "Italy",
	          value: "ITA"
	        }, {
	          name: "Jamaica",
	          value: "JAM"
	        }, {
	          name: "Jordan",
	          value: "JOR"
	        }, {
	          name: "Kazakhstan",
	          value: "KAZ"
	        }, {
	          name: "Kenya",
	          value: "KEN"
	        }, {
	          name: "Kiribati",
	          value: "KIR"
	        }, {
	          name: "Kuwait",
	          value: "KWT"
	        }, {
	          name: "Kyrgyzstan",
	          value: "KGZ"
	        }, {
	          name: "Lao People's Democratic Republic",
	          value: "LAO"
	        }, {
	          name: "Latvia",
	          value: "LVA"
	        }, {
	          name: "Lebanon",
	          value: "LBN"
	        }, {
	          name: "Lesotho",
	          value: "LSO"
	        }, {
	          name: "Liberia",
	          value: "LBR"
	        }, {
	          name: "Libyan Arab Jamahiriya",
	          value: "LBY"
	        }, {
	          name: "Liechtenstein",
	          value: "LIE"
	        }, {
	          name: "Lithuania",
	          value: "LTU"
	        }, {
	          name: "Luxembourg",
	          value: "LUX"
	        }, {
	          name: "Madagascar",
	          value: "MDG"
	        }, {
	          name: "Malawi",
	          value: "MWI"
	        }, {
	          name: "Malaysia",
	          value: "MYS"
	        }, {
	          name: "Maldives",
	          value: "MDV"
	        }, {
	          name: "Mali",
	          value: "MLI"
	        }, {
	          name: "Malta",
	          value: "MLT"
	        }, {
	          name: "Marshall Islands",
	          value: "MHL"
	        }, {
	          name: "Mauritania",
	          value: "MRT"
	        }, {
	          name: "Mauritius",
	          value: "MUS"
	        }, {
	          name: "Mexico",
	          value: "MEX"
	        }, {
	          name: "Monaco",
	          value: "MCO"
	        }, {
	          name: "Mongolia",
	          value: "MNG"
	        }, {
	          name: "Morocco",
	          value: "MAR"
	        }, {
	          name: "Mozambique",
	          value: "MOZ"
	        }, {
	          name: "Myanmar",
	          value: "MMR"
	        }, {
	          name: "Namibia",
	          value: "NAM"
	        }, {
	          name: "Nauru",
	          value: "NRU"
	        }, {
	          name: "Nepal",
	          value: "NPL"
	        }, {
	          name: "Netherlands",
	          value: "NLD"
	        }, {
	          name: "Netherlands Antilles",
	          value: "ANT"
	        }, {
	          name: "New Zealand",
	          value: "NZL"
	        }, {
	          name: "Nicaragua",
	          value: "NIC"
	        }, {
	          name: "Niger",
	          value: "NER"
	        }, {
	          name: "Nigeria",
	          value: "NGA"
	        }, {
	          name: "Norway",
	          value: "NOR"
	        }, {
	          name: "Oman",
	          value: "OMN"
	        }, {
	          name: "Pakistan",
	          value: "PAK"
	        }, {
	          name: "Palau",
	          value: "PLW"
	        }, {
	          name: "Panama",
	          value: "PAN"
	        }, {
	          name: "Papua New Guinea",
	          value: "PNG"
	        }, {
	          name: "Paraguay",
	          value: "PRY"
	        }, {
	          name: "Peru",
	          value: "PER"
	        }, {
	          name: "Philippines",
	          value: "PHL"
	        }, {
	          name: "Poland",
	          value: "POL"
	        }, {
	          name: "Portugal",
	          value: "PRT"
	        }, {
	          name: "Qatar",
	          value: "QAT"
	        }, {
	          name: "Republic of Korea",
	          value: "KOR"
	        }, {
	          name: "Republic of Moldova",
	          value: "MDA"
	        }, {
	          name: "Romania",
	          value: "ROU"
	        }, {
	          name: "Russian Federation",
	          value: "RUS"
	        }, {
	          name: "Rwanda",
	          value: "RWA"
	        }, {
	          name: "Saint Kitts and Nevis",
	          value: "KNA"
	        }, {
	          name: "Saint Lucia",
	          value: "LCA"
	        }, {
	          name: "Saint Vincent and the Grenadines",
	          value: "VCT"
	        }, {
	          name: "Samoa",
	          value: "WSM"
	        }, {
	          name: "San Mario",
	          value: "SMR"
	        }, {
	          name: "Sao Tome and Principe",
	          value: "STP"
	        }, {
	          name: "Saudi Arabia",
	          value: "SAU"
	        }, {
	          name: "Senegal",
	          value: "SEN"
	        }, {
	          name: "Seychelles",
	          value: "SYC"
	        }, {
	          name: "Sierra Leone",
	          value: "SLE"
	        }, {
	          name: "Singapore",
	          value: "SGP"
	        }, {
	          name: "Slovakia",
	          value: "SVK"
	        }, {
	          name: "Slovenia",
	          value: "SVN"
	        }, {
	          name: "Solomon Islands",
	          value: "SLB"
	        }, {
	          name: "Somalia",
	          value: "SOM"
	        }, {
	          name: "South Africa",
	          value: "ZAF"
	        }, {
	          name: "Spain",
	          value: "ESP"
	        }, {
	          name: "Sri Lanka",
	          value: "LKA"
	        }, {
	          name: "Sudan",
	          value: "SDN"
	        }, {
	          name: "Suriname",
	          value: "SUR"
	        }, {
	          name: "Swaziland",
	          value: "SWZ"
	        }, {
	          name: "Sweden",
	          value: "SWE"
	        }, {
	          name: "Switzerland",
	          value: "CHE"
	        }, {
	          name: "Syrian Arab Republic",
	          value: "SYR"
	        }, {
	          name: "Tajikistan",
	          value: "TJK"
	        }, {
	          name: "Thailand",
	          value: "THA"
	        }, {
	          name: "the former Yugoslav Republic Macedonia",
	          value: "MKD"
	        }, {
	          name: "Togo",
	          value: "TGO"
	        }, {
	          name: "Tonga",
	          value: "TON"
	        }, {
	          name: "Trinidad and Tobago",
	          value: "TTO"
	        }, {
	          name: "Tunisia",
	          value: "TUN"
	        }, {
	          name: "Turkey",
	          value: "TUR"
	        }, {
	          name: "Turkmenistan",
	          value: "TKM"
	        }, {
	          name: "Tuvalu",
	          value: "TUV"
	        }, {
	          name: "Uganda",
	          value: "UGA"
	        }, {
	          name: "Ukraine",
	          value: "UKR"
	        }, {
	          name: "United Arab Emirates",
	          value: "ARE"
	        }, {
	          name: "United Kingdom",
	          value: "GBR"
	        }, {
	          name: "United Republic of Tanzania",
	          value: "TZA"
	        }, {
	          name: "United States",
	          value: "USA"
	        }, {
	          name: "Uruguay",
	          value: "URY"
	        }, {
	          name: "Uzbekistan",
	          value: "UZB"
	        }, {
	          name: "Vanuatu",
	          value: "VUT"
	        }, {
	          name: "Venezuela",
	          value: "VEN"
	        }, {
	          name: "Viet Nam",
	          value: "VNM"
	        }, {
	          name: "Yemen",
	          value: "YEM"
	        }, {
	          name: "Zambia",
	          value: "ZMB"
	        }, {
	          name: "Zimbabwe",
	          value: "ZWE"
	        }
	      ];
	      return countries;
	    }
	  };
	};
	
	module.exports = CountryService;


/***/ }),
/* 346 */
/***/ (function(module, exports) {

	var PrefectureService;
	
	PrefectureService = function() {
	  return {
	    get: function() {
	      var japanese;
	      japanese = [
	        {
	          name: "北海道",
	          value: "HKD"
	        }, {
	          name: "青森県",
	          value: "AOM"
	        }, {
	          name: "岩手県",
	          value: "IWT"
	        }, {
	          name: "宮城県",
	          value: "MYG"
	        }, {
	          name: "秋田県",
	          value: "AKT"
	        }, {
	          name: "山形県",
	          value: "YGT"
	        }, {
	          name: "福島県",
	          value: "FKS"
	        }, {
	          name: "茨城県",
	          value: "IBR"
	        }, {
	          name: "栃木県",
	          value: "TCG"
	        }, {
	          name: "群馬県",
	          value: "GNM"
	        }, {
	          name: "埼玉県",
	          value: "SIT"
	        }, {
	          name: "千葉県",
	          value: "CHB"
	        }, {
	          name: "東京都",
	          value: "TKY"
	        }, {
	          name: "神奈川県	",
	          value: "KNG"
	        }, {
	          name: "新潟県",
	          value: "NGT"
	        }, {
	          name: "富山県",
	          value: "TYM"
	        }, {
	          name: "石川県",
	          value: "ISK"
	        }, {
	          name: "福井県",
	          value: "FKI"
	        }, {
	          name: "山梨県",
	          value: "YMN"
	        }, {
	          name: "長野県",
	          value: "NGN"
	        }, {
	          name: "岐阜県",
	          value: "GIF"
	        }, {
	          name: "静岡県",
	          value: "SZO"
	        }, {
	          name: "愛知県",
	          value: "AIC"
	        }, {
	          name: "三重県",
	          value: "MIE"
	        }, {
	          name: "滋賀県",
	          value: "SIG"
	        }, {
	          name: "京都府",
	          value: "KYT"
	        }, {
	          name: "大阪府",
	          value: "OSK"
	        }, {
	          name: "兵庫県",
	          value: "HYG"
	        }, {
	          name: "奈良県",
	          value: "NAR"
	        }, {
	          name: "和歌山県",
	          value: "WKY"
	        }, {
	          name: "鳥取県",
	          value: "TTR"
	        }, {
	          name: "島根県",
	          value: "SMN"
	        }, {
	          name: "岡山県",
	          value: "OKY"
	        }, {
	          name: "広島県",
	          value: "HRS"
	        }, {
	          name: "山口県",
	          value: "YGC"
	        }, {
	          name: "徳島県",
	          value: "TKS"
	        }, {
	          name: "香川県",
	          value: "KGW"
	        }, {
	          name: "愛媛県",
	          value: "EHM"
	        }, {
	          name: "高知県",
	          value: "KUC"
	        }, {
	          name: "福岡県",
	          value: "FKO"
	        }, {
	          name: "佐賀県",
	          value: "SAG"
	        }, {
	          name: "長崎県",
	          value: "NGS"
	        }, {
	          name: "熊本県",
	          value: "KMM"
	        }, {
	          name: "大分県",
	          value: "OIT"
	        }, {
	          name: "宮崎県",
	          value: "MYZ"
	        }, {
	          name: "鹿児島県	",
	          value: "KGS"
	        }, {
	          name: "沖縄県",
	          value: "OKN"
	        }
	      ];
	      return japanese;
	    }
	  };
	};
	
	module.exports = PrefectureService;


/***/ }),
/* 347 */
/***/ (function(module, exports) {

	var GenderService;
	
	GenderService = function($filter) {
	  return {
	    get: function() {
	      var genders;
	      genders = [
	        {
	          key: 'male',
	          value: $filter('translate')('_REGISTRATION.NEW.MALE')
	        }, {
	          key: 'female',
	          value: $filter('translate')('_REGISTRATION.NEW.FEMALE')
	        }
	      ];
	      return genders;
	    }
	  };
	};
	
	GenderService.$inject = ['$filter'];
	
	module.exports = GenderService;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

	module.exports = {
	  '_REGISTRATION': {
	    'NEW': {
	      'TITLE': 'Sign up',
	      'EMAIL': 'Email address',
	      'PASSWORD': 'Password',
	      'FIRST_NAME': 'First name',
	      'LAST_NAME': 'Last name',
	      'BIRTH_DATE': 'Date of birth',
	      'MALE': 'Male',
	      'FEMALE': 'Female',
	      'SIGN_UP': 'Sign up',
	      'GENDER': "Gender",
	      'COUNTRY': "Country",
	      'PREFECTURE': "Prefecture",
	      'COUNTRY_DEFAULT_TEXT': "Country",
	      'PREFECTURE_DEFAULT_TEXT': "Prefecture",
	      'URL_EXPIRED_1': 'URL has expired.',
	      'URL_EXPIRED_2': 'Please try again.',
	      'PLACEHOLDER_PASSWORD': 'At least 10 characters and contain at least three of uppercase, lowercase, numbers, symbols.',
	      'PLACEHOLDER_PASSWORD_COMFIRM': 'Confirmation (Enter the same value as above)',
	      'NAME': 'Name',
	      'BIRTHDAY': 'Birthday',
	      'COUNTRY_TITLE': 'COUNTRY',
	      'EMAIL_NEWSLETTER': '	Send mail magazine',
	      'CONTENT_EMAIL_NEWSLETTER_1': "We'll send you Golf Network Plus program information and special offers.",
	      'CONTENT_EMAIL_NEWSLETTER_2': "If you don't want to receive these updates, uncheck the box.",
	      'CONTENT_EMAIL_NEWSLETTER_3': ""
	    },
	    'EDIT': {
	      'TITLE': 'Account',
	      'GENERAL': "Setting account",
	      'CHANGEPASSWORD': 'Change Password',
	      'FORGOTPASSWORD': 'Forgot your password?',
	      'EMAIL': '@:_REGISTRATION.NEW.EMAIL',
	      'CURRENTPASSWORD': 'Current Password',
	      'NEWPASSWORD': 'New Password',
	      'CONFIRMPASSWORD': 'Confirm Password',
	      'YOURNAME': 'Your name',
	      'BIRTH_DATE': '@:_REGISTRATION.NEW.BIRTH_DATE',
	      'GENDER': '@:_REGISTRATION.NEW.GENDER',
	      'COUNTRY': "@:_REGISTRATION.NEW.COUNTRY",
	      'PREFECTURE': "@:_REGISTRATION.NEW.PREFECTURE",
	      'CHANGE_EMAIL': 'Click here to change a registered email address',
	      'RULE_PASSWORD_LABEL': 'At least 10 characters and contain at least three of uppercase, lowercase, numbers, symbols.'
	    },
	    'EMAIL': {
	      'TITLE': 'Sign up',
	      'TAPPING_SIGN_UP_FIRST': 'By Tapping Sign Up, you agree to our ',
	      'TAPPING_SIGN_UP_LAST': '',
	      'AND': 'and ',
	      'TERM': 'Terms ',
	      'PRIVACE': 'Privacy Policy'
	    },
	    'EMAIL_SUCCESS': {
	      'TITLE': 'Sign up',
	      'PLEASE_CHECK_EMAIL': 'Please check your authentication email',
	      'CHECK_EMAIL_DETAIL': 'An authentication email has been sent to the following email address. Please open the URL in the email and enter your account information.',
	      'NOT_RECEIVE_EMAIL': 'If you do not receive an email, please check the following',
	      'NOT_RECEIVE_EMAIL_1': '1.Are you sure you entered the correct information?',
	      'NOT_RECEIVE_EMAIL_2': '2. It has not arrived in your spam folder.',
	      'PLEASE_CONTACT_1': 'If the problem persists, please contact us ',
	      'PLEASE_CONTACT_2': '',
	      'PLEASE_CONTACT_HERE': 'here.'
	    }
	  }
	};


/***/ }),
/* 349 */
/***/ (function(module, exports) {

	module.exports = {
	  '_REGISTRATION': {
	    'NEW': {
	      'TITLE': '新規会員登録',
	      'EMAIL': 'メールアドレス',
	      'PASSWORD': 'パスワード',
	      'FIRST_NAME': '名',
	      'LAST_NAME': '姓',
	      'BIRTH_DATE': '生年月日',
	      'MALE': '男性',
	      'FEMALE': '女性',
	      'SIGN_UP': '登録',
	      'GENDER': '性別',
	      'COUNTRY': "国",
	      'PREFECTURE': "都道府県",
	      'COUNTRY_DEFAULT_TEXT': "国",
	      'PREFECTURE_DEFAULT_TEXT': "都道府県",
	      'URL_EXPIRED_1': 'URLの有効期限が切れています。',
	      'URL_EXPIRED_2': '再度お試しください。',
	      'PLACEHOLDER_PASSWORD': '英大文字・英小文字・数字・記号のうち3種以上かつ10桁以上(半角)',
	      'PLACEHOLDER_PASSWORD_COMFIRM': '確認用（上部と同じ内容を入力）',
	      'NAME': '氏名',
	      'BIRTHDAY': '生年月日',
	      'COUNTRY_TITLE': 'お住まいの国',
	      'EMAIL_NEWSLETTER': 'メールマガジンを送信する',
	      'CONTENT_EMAIL_NEWSLETTER_1': "ゴルフネットワークプラスTVの番組情報やお得な情報をお届け。",
	      'CONTENT_EMAIL_NEWSLETTER_2': "メルマガ登録者限定キャンペーンも！",
	      'CONTENT_EMAIL_NEWSLETTER_3': "不要な方はチェックを外してください。"
	    },
	    'EDIT': {
	      'TITLE': 'アカウント設定',
	      'GENERAL': "アカウント設定",
	      'CHANGEPASSWORD': 'パスワード変更',
	      'FORGOTPASSWORD': 'パスワードを忘れた方はこちら',
	      'EMAIL': '@:_REGISTRATION.NEW.EMAIL',
	      'CURRENTPASSWORD': '現在のパスワード',
	      'NEWPASSWORD': '新しいパスワード',
	      'CONFIRMPASSWORD': '新しいパスワード（確認)',
	      'YOURNAME': '姓・名',
	      'BIRTH_DATE': '@:_REGISTRATION.NEW.BIRTH_DATE',
	      'GENDER': '@:_REGISTRATION.NEW.GENDER',
	      'COUNTRY': "@:_REGISTRATION.NEW.COUNTRY",
	      'PREFECTURE': "@:_REGISTRATION.NEW.PREFECTURE",
	      'CHANGE_EMAIL': 'メールアドレス変更の方はこちら',
	      'RULE_PASSWORD_LABEL': '英大文字・英小文字・数字・記号のうち3種以上かつ10桁以上(半角)'
	    },
	    'EMAIL': {
	      'TITLE': '新規会員登録',
	      'TAPPING_SIGN_UP_FIRST': '',
	      'TAPPING_SIGN_UP_LAST': 'に同意して登録する。',
	      'AND': 'と ',
	      'TERM': '利用規約 ',
	      'PRIVACE': '個人情報の取扱い '
	    },
	    'EMAIL_SUCCESS': {
	      'TITLE': '新規会員登録',
	      'PLEASE_CHECK_EMAIL': '認証用メールをご確認ください',
	      'CHECK_EMAIL_DETAIL': '下記メールアドレスに、認証用メールをお送りしました。メール内に記載されているURLを開いてアカウント情報の入力を行ってください。',
	      'NOT_RECEIVE_EMAIL': 'メールが届かない場合は、以下を確認してください。',
	      'NOT_RECEIVE_EMAIL_1': '1.入力に誤りがないか',
	      'NOT_RECEIVE_EMAIL_2': '2.迷惑メールフォルダに届いていないか',
	      'PLEASE_CONTACT_1': '解決しない場合は、',
	      'PLEASE_CONTACT_2': 'からお問合せください。',
	      'PLEASE_CONTACT_HERE': 'こちら'
	    }
	  }
	};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var AccordionStateHolderService, RoundInfoCtrl, RoundInfoService, ScoreCardInfoCtrl, ScoreDataHolderService, ScoreRegistrationCtrl, ScoreUploadHelperService, SelectClubCtrl, SelectClubHistoryDirective, SelectClubListDirective, SelectClubSearchDirective, SelectClubSearchService, SelectPlayersCtrl, modules;
	
	__webpack_require__(351);
	
	__webpack_require__(352);
	
	__webpack_require__(353);
	
	__webpack_require__(354);
	
	__webpack_require__(355);
	
	__webpack_require__(356);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(115);
	
	__webpack_require__(384);
	
	__webpack_require__(386);
	
	__webpack_require__(72);
	
	__webpack_require__(59);
	
	__webpack_require__(82);
	
	__webpack_require__(76);
	
	__webpack_require__(112);
	
	__webpack_require__(388);
	
	__webpack_require__(108);
	
	__webpack_require__(278);
	
	__webpack_require__(274);
	
	__webpack_require__(89);
	
	__webpack_require__(412);
	
	__webpack_require__(416);
	
	__webpack_require__(39);
	
	__webpack_require__(90);
	
	__webpack_require__(419);
	
	ScoreRegistrationCtrl = __webpack_require__(424);
	
	SelectClubCtrl = __webpack_require__(425);
	
	SelectPlayersCtrl = __webpack_require__(426);
	
	SelectClubSearchDirective = __webpack_require__(427);
	
	SelectClubListDirective = __webpack_require__(429);
	
	SelectClubHistoryDirective = __webpack_require__(431);
	
	SelectClubSearchService = __webpack_require__(433);
	
	RoundInfoCtrl = __webpack_require__(434);
	
	RoundInfoService = __webpack_require__(436);
	
	ScoreCardInfoCtrl = __webpack_require__(437);
	
	ScoreDataHolderService = __webpack_require__(438);
	
	ScoreUploadHelperService = __webpack_require__(439);
	
	AccordionStateHolderService = __webpack_require__(440);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-flash', 'gnp-common-wrapper', 'gnp-auth', 'gnp-form', 'gnp-score-card', 'gnp-cache', 'ui.bootstrap', 'ui.map', 'gnp-error-handler', 'gnp-remote-api', 'gnp-payment', 'gnp-animate', 'gnp-map', 'gnp-analyze-access', 'gnp-account', 'gnp-modal'];
	
	angular.module("gnp-app-score-registration", modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/score-registration/:id?', {
	      templateUrl: 'web/score-registration/score-registration.jade',
	      controller: 'ScoreRegistrationCtrl',
	      resolve: {
	        round: [
	          'RoundAPIService', '$route', function(RoundAPIService, $route) {
	            if (!$route.current.params.id) {
	              return;
	            }
	            return RoundAPIService.getRound($route.current.params.id);
	          }
	        ],
	        ownerPlayer: [
	          'PlayerAPIService', '$route', function(PlayerAPIService, $route) {
	            if ($route.current.params.id) {
	              return;
	            }
	            return PlayerAPIService.getOwnerPlayer();
	          }
	        ],
	        fromJapan: [
	          'CountryAPIService', function(CountryAPIService) {
	            return CountryAPIService.fromJapan();
	          }
	        ]
	      },
	      title: '_SCORE_REGISTRATION.TITLE',
	      permission: {
	        signInRequired: true,
	        paymentRequired: true
	      }
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(441)).translations('ja', __webpack_require__(442));
	  }
	]).controller('ScoreRegistrationCtrl', ScoreRegistrationCtrl).controller('SelectClubCtrl', SelectClubCtrl).controller('SelectPlayersCtrl', SelectPlayersCtrl).controller('RoundInfoCtrl', RoundInfoCtrl).controller('ScoreRegistrationScoreCardInfoCtrl', ScoreCardInfoCtrl).directive('gnpSelectClubSearch', SelectClubSearchDirective).directive('gnpSelectClubHistory', SelectClubHistoryDirective).directive('gnpSelectClubList', SelectClubListDirective).factory('SelectClubSearchService', SelectClubSearchService).factory('RoundInfoService', RoundInfoService).factory('ScoreDataHolderService', ScoreDataHolderService).factory('ScoreUploadHelperService', ScoreUploadHelperService).factory('AccordionStateHolderService', AccordionStateHolderService);


/***/ }),
/* 351 */
/***/ (function(module, exports) {

	var v1="<div id=\"score-input\" gnp-common-wrapper-a=\"\"><div class=\"container accordion-container score-input-container\"><accordion close-others=\"false\"><accordion-group is-open=\"accordionStateHolder.steps[0].isOpen\" id=\"{{accordionStateHolder.steps[0].id}}\" ng-if=\"!accordionStateHolder.editMode\"><div ng-controller=\"SelectClubCtrl as scCtrl\" ng-include=\"'score-registration/select-club/select-club.jade'\" class=\"step-body-1 container score-input-container\"></div></accordion-group><accordion-group is-open=\"accordionStateHolder.steps[1].isOpen\" id=\"{{accordionStateHolder.steps[1].id}}\" is-disabled=\"!scoreHolder.club\"><div ng-controller=\"RoundInfoCtrl as riCtrl\" ng-include=\"'score-registration/round-info/round-info.jade'\" class=\"step-body-2\"></div></accordion-group><accordion-group is-open=\"accordionStateHolder.steps[2].isOpen\" id=\"{{accordionStateHolder.steps[2].id}}\" is-disabled=\"!scoreHolder.roundInfo\"><div ng-controller=\"SelectPlayersCtrl as spCtrl\" ng-include=\"'score-registration/select-players/select-players.jade'\" class=\"step-body-3\"></div></accordion-group><accordion-group is-open=\"accordionStateHolder.steps[3].isOpen\" id=\"{{accordionStateHolder.steps[3].id}}\" is-disabled=\"!scoreHolder.players\"><div ng-controller=\"ScoreRegistrationScoreCardInfoCtrl as sciCtrl\" ng-include=\"'score-registration/score-card-info/score-card-info.jade'\" class=\"step-body-4\"></div></accordion-group><div class=\"container score-input-container score-step-footer last\"><div class=\"bar-menu-footer\"><div class=\"bar-menu-bg-footer\"><div class=\"bar-menu-5 title\">{{::'_SCORE_REGISTRATION.FOOTER.TITLE' | translate}}</div></div></div><button type=\"submit\" ng-click=\"submit()\" ng-disabled=\"!canSubmit()\" gnp-submitting-button=\"isSubmitting\" analytics-on=\"click\" analytics-event=\"ETR_Submit\" class=\"btn btn-save footer\">{{::'SAVE' | translate}}</button></div></accordion></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/score-registration/score-registration.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	var v1="<div class=\"content-wrap\"><div class=\"content\"><div class=\"course-info\"><div ng-if=\"riCtrl.club.url\" class=\"course-name\"><a href=\"{{ riCtrl.club.url }}\" target=\"_blank\">{{ riCtrl.club.name }}</a></div><div ng-if=\"!riCtrl.club.url\" class=\"course-name\">{{ riCtrl.club.name }}</div><div class=\"row no-padding\"><div class=\"col-12 col-sm-6 course-info-wrap\"><div class=\"course-addr\">{{ riCtrl.club.address }}</div></div><div class=\"col-12 col-sm-6 course-info-wrap\"><div class=\"course-tel\">{{ riCtrl.club.phone }}</div></div></div><div ng-show=\"riCtrl.club.showRakutenId\" class=\"btn-reservation\"><a href=\"{{ riCtrl.rakutenLink }}\" target=\"_blank\"> {{:: '_SCORE_REGISTRATION.ROUND_INFO.RAKUTEN_LINK' | translate }}</a></div></div><form name=\"riCtrl.roundInfoForm\" gnp-submit=\"riCtrl.submit()\" on-form-error=\"riCtrl.showFlashMessage()\" novalidate=\"\"><div class=\"content-row play-date\"><div class=\"row\"><div class=\"line\"></div><div class=\"col-12 no-padding\"><div class=\"column-head\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.PLAY_DATE' | translate }}</div></div><div class=\"col-12 no-padding\"><div class=\"column-input\"><input name=\"play_date\" required=\"\" gnp-date-input=\"\" ng-model=\"riCtrl.roundInfo.play_date\" date-input-date=\"riCtrl.roundInfo.play_date\"/></div></div><div class=\"col-12 no-padding\"><div ng-show=\"riCtrl.roundInfoForm.play_date.$invalid &amp;&amp; !riCtrl.roundInfoForm.play_date.$pristine\" ng-style=\"{'margin-top': '37px'}\"><div ng-show=\"riCtrl.roundInfoForm.play_date.$error.dateRequired\" class=\"error\">{{:: \"VALIDATION.REQUIRED\" | translate }}</div><div ng-show=\"riCtrl.roundInfoForm.play_date.$error.dateValidate\" class=\"error\">{{:: \"VALIDATION.DATE\" | translate }}</div></div></div></div></div><div class=\"content-row weather\"><div class=\"row\"><div class=\"line\"></div><div class=\"column-head\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.WEATHER' | translate }}</div><div class=\"column-input\"><input id=\"score-input-weather-sunny\" type=\"radio\" name=\"weather\" value=\"sunny\" ng-model=\"riCtrl.roundInfo.weather\" checked=\"checked\"/><label for=\"score-input-weather-sunny\"></label><input id=\"score-input-weather-cloudy\" type=\"radio\" name=\"weather\" value=\"cloudy\" ng-model=\"riCtrl.roundInfo.weather\"/><label for=\"score-input-weather-cloudy\"></label><input id=\"score-input-weather-rainy\" type=\"radio\" name=\"weather\" value=\"rainy\" ng-model=\"riCtrl.roundInfo.weather\"/><label for=\"score-input-weather-rainy\"></label><input id=\"score-input-weather-snowing\" type=\"radio\" name=\"weather\" value=\"snowing\" ng-model=\"riCtrl.roundInfo.weather\"/><label for=\"score-input-weather-snowing\"></label><input id=\"score-input-weather-foggy\" type=\"radio\" name=\"weather\" value=\"foggy\" ng-model=\"riCtrl.roundInfo.weather\"/><label for=\"score-input-weather-foggy\"></label></div></div></div><div class=\"content-row course\"><div class=\"row\"><div class=\"line\"></div><div class=\"col-4 no-padding\"><div class=\"column-head\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.COURSE' | translate }}</div></div><div class=\"col-8 no-padding\"><div class=\"column-input\"><div ng-hide=\"riCtrl.AccordionStateHolderService.editMode || riCtrl.club.courses.length == 1\" class=\"input-course\"><select name=\"course\" ng-model=\"riCtrl.roundInfo.course\" ng-required=\"riCtrl.club.courses.length &gt; 1\" ng-options=\"course as course.name for course in riCtrl.club.courses\" ng-change=\"riCtrl.selectCourse(riCtrl.roundInfo.course, true)\"><option value=\"\" disabled=\"disabled\" selected=\"selected\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.COURSE_REQUEST' | translate }}</option></select></div><div ng-show=\"riCtrl.AccordionStateHolderService.editMode || riCtrl.club.courses.length == 1\" class=\"input-course\"><span class=\"course-label\">{{riCtrl.roundInfo.course.name ? riCtrl.roundInfo.course.name : '-'}}</span></div></div><div ng-show=\"riCtrl.roundInfoForm.course.$invalid &amp;&amp; !riCtrl.roundInfoForm.course.$pristine\" ng-style=\"{'margin-top': '37px'}\"><div ng-show=\"riCtrl.roundInfoForm.course.$error.required\" class=\"error\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.COURSE_REQUEST' | translate }}</div></div></div></div></div><div class=\"content-row course\"><div class=\"row\"><div class=\"line\"></div><div class=\"col-4 no-padding\"><div class=\"column-head\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.START_HOLE' | translate }}</div></div><div class=\"col-8 no-padding\"><div class=\"column-input\"><div class=\"input-course\"><select name=\"start_hole\" ng-model=\"riCtrl.roundInfo.started_hole\" ng-required=\"riCtrl.startHoles.length &gt; 1\" ng-options=\"hole.value as hole.label for hole in riCtrl.startHoles\"><option value=\"\" disabled=\"disabled\" selected=\"selected\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.START_REQUEST' | translate }}</option></select></div></div><div ng-show=\"riCtrl.roundInfoForm.start_hole.$invalid &amp;&amp; !riCtrl.roundInfoForm.start_hole.$pristine\" ng-style=\"{'margin-top': '37px'}\"><div ng-show=\"riCtrl.roundInfoForm.start_hole.$error.required\" class=\"error\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.START_REQUEST' | translate }}</div></div></div></div></div><div class=\"content-row course\"><div class=\"row\"><div class=\"line\"></div><div class=\"col-4 no-padding\"><div class=\"column-head\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.TEE_POSITION' | translate }}</div></div><div class=\"col-8 no-padding\"><div class=\"column-input\"><div gnp-indicator=\"riCtrl.isLoadingTees\" ng-hide=\"riCtrl.AccordionStateHolderService.editMode\" class=\"input-course\"><select name=\"tees\" ng-model=\"riCtrl.roundInfo.tee\" required=\"\" ng-options=\"tee as tee.name for tee in riCtrl.tees\"><option value=\"\" disabled=\"disabled\" selected=\"selected\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.TEE_REQUEST' | translate }}</option></select></div><div ng-show=\"riCtrl.AccordionStateHolderService.editMode\" class=\"input-course\"><span class=\"course-label\">{{riCtrl.roundInfo.tee.name ? riCtrl.roundInfo.tee.name : '-' }}</span></div></div><div ng-show=\"riCtrl.roundInfoForm.tees.$invalid &amp;&amp; !riCtrl.roundInfoForm.tees.$pristine\" ng-style=\"{'margin-top': '37px'}\"><div ng-show=\"riCtrl.roundInfoForm.tees.$error.required\" class=\"error\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.TEE_REQUEST' | translate }}</div></div></div></div></div><div ng-hide=\"riCtrl.hideExtra\" class=\"content-row course\"><div class=\"row\"><div class=\"line\"></div><div class=\"col-4 no-padding\"><div class=\"column-head\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.EXTRA_9' | translate }}</div></div><div class=\"col-8 no-padding\"><div class=\"column-input\"><div ng-hide=\"riCtrl.AccordionStateHolderService.editMode\" class=\"input-course\"><select name=\"extra9\" ng-model=\"riCtrl.roundInfo.extra9\" ng-options=\"extra9[0] as extra9[1] for extra9 in riCtrl.extra9Options\" ng-change=\"riCtrl.selectExtra(riCtrl.roundInfo.extra9)\"><option value=\"\" selected=\"selected\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.NONE' | translate }}</option></select></div><div ng-show=\"riCtrl.AccordionStateHolderService.editMode\" class=\"input-course\"><span class=\"course-label\">{{riCtrl.roundInfo.extra9 ? (riCtrl.roundInfo.course.name + ' ' + riCtrl.roundInfo.extra9.split('_')[1]) : '-' }}</span></div></div><div ng-show=\"riCtrl.roundInfoForm.extra9.$invalid &amp;&amp; !riCtrl.roundInfoForm.extra9.$pristine\" ng-style=\"{'margin-top': '37px'}\"><div ng-show=\"riCtrl.roundInfoForm.extra9.$error.required\" class=\"error\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.COURSE_REQUEST' | translate }}</div></div></div></div></div><div ng-hide=\"riCtrl.hideExtra\" ng-if=\"!!riCtrl.roundInfo.extra9\" class=\"content-row course\"><div class=\"row\"><div class=\"line\"></div><div class=\"col-4 no-padding\"><div class=\"column-head\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.TEE_POSITION' | translate }}</div></div><div class=\"col-8 no-padding\"><div class=\"column-input\"><div gnp-indicator=\"riCtrl.isLoadingTees\" ng-hide=\"riCtrl.AccordionStateHolderService.editMode\" class=\"input-course\"><select name=\"tees_extra\" ng-model=\"riCtrl.roundInfo.tee_extra\" ng-required=\"!!riCtrl.roundInfo.extra9\" ng-options=\"tee as tee.name for tee in riCtrl.tees\"><option value=\"\" disabled=\"disabled\" selected=\"selected\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.NONE' | translate }}</option></select></div><div ng-show=\"riCtrl.AccordionStateHolderService.editMode\" class=\"input-course\"><span class=\"course-label\">{{riCtrl.roundInfo.tee_extra.name ? riCtrl.roundInfo.tee_extra.name : '-' }}</span></div></div><div ng-show=\"riCtrl.roundInfoForm.tees_extra.$invalid &amp;&amp; !riCtrl.roundInfoForm.tees_extra.$pristine\" ng-style=\"{'margin-top': '37px'}\"><div ng-show=\"riCtrl.roundInfoForm.tees_extra.$error.required\" class=\"error\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.TEE_REQUEST' | translate }}</div></div></div></div></div><div class=\"content-map\"><div class=\"row\"><div ng-repeat=\"marker in riCtrl.markers\" ui-map-marker=\"riCtrl.markers[$index]\"></div><div id=\"map_canvas\" style=\"width:100%;height:420px\" ng-if=\"riCtrl.mapOptions\" ui-map=\"riCtrl.myMap\" ui-options=\"riCtrl.mapOptions\" class=\"map\"></div></div></div><div class=\"content-button\"><button type=\"submit\" ng-disabled=\"!riCtrl.club\" analytics-on=\"click\" analytics-event=\"ETR_DetailOk\" class=\"btn btn-save\">OK</button><div ng-show=\"riCtrl.roundInfoForm.isDirty &amp;&amp; riCtrl.ScoreDataHolderService.roundInfo\" class=\"link\">{{:: '_SCORE_REGISTRATION.UNSAVED_HINT' | translate }}</div><div class=\"link\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.MOVE_TO_SELECT_PLAYERS' | translate }}</div></div></form></div></div><accordion-heading><span class=\"bar-menu-bg-2 title\">{{:: '_SCORE_REGISTRATION.ROUND_INFO.TITLE' | translate }}</span></accordion-heading>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-registration/round-info/round-info.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	var v1="<div class=\"content-wrap\"><div class=\"content\"><div gnp-score-card=\"\" board-type=\"out\" edit-mode=\"true\" score-card-course=\"sciCtrl.course\" score-card-holes=\"sciCtrl.outScoreCardInfo.holes\" score-card-players=\"sciCtrl.outScoreCardInfo.players\" score-card-tee=\"sciCtrl.tee\" on-scores-updated=\"sciCtrl.onScoresUpdated\"></div><div gnp-score-card=\"\" ng-if=\"sciCtrl.holes.length === 18\" board-type=\"in\" edit-mode=\"true\" score-card-course=\"sciCtrl.course\" score-card-holes=\"sciCtrl.inScoreCardInfo.holes\" score-card-players=\"sciCtrl.inScoreCardInfo.players\" score-card-tee=\"sciCtrl.tee\" on-scores-updated=\"sciCtrl.onScoresUpdated\"></div><div gnp-score-card=\"\" ng-if=\"sciCtrl.extra_9\" board-type=\"extra\" edit-mode=\"true\" score-card-course=\"sciCtrl.course_extra\" score-card-holes=\"sciCtrl.extraScoreCardInfo.holes\" score-card-players=\"sciCtrl.extraScoreCardInfo.players\" score-card-tee=\"sciCtrl.tee_extra\" on-scores-updated=\"sciCtrl.onScoresUpdated\"></div></div></div><accordion-heading class=\"container\"><span class=\"bar-menu-bg-4 title\">{{::'_SCORE_REGISTRATION.SCORE_ENTRY.TITLE' | translate}}</span></accordion-heading>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-registration/score-card-info/score-card-info.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	var v1="<div class=\"content-wrap\"><div class=\"content\"><div class=\"tab\"><div ng-class=\"{'active': scCtrl.currentTabIndex === 0}\" ng-click=\"scCtrl.selectTab(0)\" class=\"tab-1\">{{:: '_SCORE_REGISTRATION.SELECT_CLUB.SEARCH' | translate }}</div><div ng-class=\"{'active': scCtrl.currentTabIndex === 1}\" ng-click=\"scCtrl.selectTab(1)\" class=\"tab-2\">{{:: '_SCORE_REGISTRATION.SELECT_CLUB.HISTORY' | translate }}</div></div><div ng-show=\"scCtrl.currentTabIndex === 0\"><div gnp-select-club-search=\"\" on-club-selected=\"scCtrl.selectClub\"></div></div><div ng-show=\"scCtrl.currentTabIndex === 1\"><div gnp-select-club-history=\"\" on-club-selected=\"scCtrl.selectClub\"></div></div></div></div><accordion-heading class=\"container\"><span class=\"bar-menu-bg-1 title\">{{:: '_SCORE_REGISTRATION.SELECT_CLUB.TITLE' | translate }}</span></accordion-heading>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-registration/select-club/select-club.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	var v1="<div class=\"content-wrap\"><div class=\"content\"><form name=\"spCtrl.form\" novalidate=\"\" gnp-submit=\"spCtrl.savePlayers()\" gnp-indicator=\"spCtrl.isSavingPlayers\" autocomplete=\"off\"><div class=\"col-4 offset-8 col-sm-2 offset-sm-10 select-player-hdcp-title content-row-wrapper\">HDCP</div><div ng-repeat=\"player in spCtrl.players\" class=\"content-row-wrapper\"><div class=\"content-row row\"><div class=\"col-8 col-sm-10\"><input type=\"text\" ng-attr-name=\"'player.name_' + $index\" ng-model=\"player.name\" ng-readonly=\"$index === 0\" gnp-custom-validate=\"spCtrl.validateDuplicatePlayer(value, $index)\" typeahead=\"p as p.name for p in spCtrl.searchPlayers($viewValue)\" typeahead-min-length=\"1\" typeahead-wait-ms=\"250\" typeahead-on-select=\"spCtrl.selectPlayer($item, $index)\" placeholder=\"{{ '_SCORE_REGISTRATION.SELECT_PLAYERS.PARTNER' | translate }}\" class=\"form-control large\"/></div><div class=\"col-4 col-sm-2\"><div class=\"column-input\"><span ng-attr-name=\"'player.hdcp_' + $index\" gnp-player-hdcp=\"\" ng-model=\"player.player_hdcp\"></span></div></div></div><div ng-show=\"spCtrl.form['player.name_' + $index].$invalid &amp;&amp; !spCtrl.form['player.name_' + $index].$pristine\" class=\"error\"><p ng-show=\"spCtrl.form['player.name_' + $index].$error.customValidate\">{{:: \"_SCORE_REGISTRATION.SELECT_PLAYERS.DUPLICATE_PLAYER\" | translate }}</p></div><div ng-show=\"spCtrl.form['player.hdcp_' + $index].$error.hdcp\" class=\"error\"><p ng-show=\"spCtrl.form['player.hdcp_' + $index].$error.hdcp\">{{:: \"_FRIEND.HDCP_INVALID\" | translate }}</p></div></div><div class=\"content-button\"><button type=\"submit\" analytics-on=\"click\" analytics-event=\"ETR_BuddyOk\" class=\"btn btn-save\">OK</button><div ng-show=\"spCtrl.form.isDirty &amp;&amp; spCtrl.ScoreDataHolderService.players\" class=\"link\">{{:: '_SCORE_REGISTRATION.UNSAVED_HINT' | translate }}</div><div class=\"link\">{{:: '_SCORE_REGISTRATION.SELECT_PLAYERS.MOVE_TO_SCORE_REGISTRATION' | translate }}</div></div></form></div></div><accordion-heading class=\"container\"><span class=\"bar-menu-bg-3 title\">{{::'_SCORE_REGISTRATION.SELECT_PLAYERS.SELECT_PLAYER_TITLE' | translate}}</span></accordion-heading>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-registration/select-players/select-players.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(357);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_score_input.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_score_input.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#score-input .score-group.myscore .dropdown-menu.open{height:355px;width:175px;padding:0;margin:0}#score-input .score-group.myscore .dropdown-menu.open .inner{width:300px}#score-input .score-group.myscore .dropdown-menu.open li{height:45px;width:173px}#score-input .score-group.myscore .dropdown-menu.open li a{height:37px}#score-input .score-group.myscore .dropdown-menu.open li a .text{margin:15px 0 0;line-height:0;font-weight:700;font-size:17px}#score-input .score-group.myscore .dropdown-menu.open li a .text .muted{padding-left:3.5em;color:darkgray}#score-input .score-group.even.pat .dropdown-menu.open{height:355px;width:60px;padding:0;margin:0}#score-input .score-group.even.pat .dropdown-menu.open .inner{width:130px}#score-input .score-group.even.pat .dropdown-menu.open li{height:45px;width:58px}#score-input .score-group.even.pat .dropdown-menu.open li a{height:37px;text-align:center}#score-input .score-group.even.pat .dropdown-menu.open li a .text{margin:15px 0 0;line-height:0;font-weight:700;font-size:16px}#score-input .score-group.odd.teeoff .dropdown-menu.open{height:625px;width:75px;padding:0;margin:0}#score-input .score-group.odd.teeoff .dropdown-menu.open .inner{width:130px}#score-input .score-group.odd.teeoff .dropdown-menu.open li{height:45px;width:73px}#score-input .score-group.odd.teeoff .dropdown-menu.open li a{height:37px;text-align:center}#score-input .score-group.odd.teeoff .dropdown-menu.open li a .text{margin:15px 0 0;line-height:0;font-weight:700;font-size:16px}#score-input .score-group.even.keep .dropdown-menu.open{height:175px;width:60px;padding:0;margin:0}#score-input .score-group.even.keep .dropdown-menu.open .inner{width:130px}#score-input .score-group.even.keep .dropdown-menu.open li{height:45px;width:58px}#score-input .score-group.even.keep .dropdown-menu.open li a{height:37px;text-align:center}#score-input .score-group.even.keep .dropdown-menu.open li a .text{margin:15px 0 0;line-height:0;font-weight:700;font-size:16px}#score-input .score-group.odd.paron .dropdown-menu.open,#score-input .score-group.even.bunker .dropdown-menu.open{height:85px;width:60px;padding:0;margin:0}#score-input .score-group.odd.paron .dropdown-menu.open .inner,#score-input .score-group.even.bunker .dropdown-menu.open .inner{width:130px}#score-input .score-group.odd.paron .dropdown-menu.open li,#score-input .score-group.even.bunker .dropdown-menu.open li{height:45px;width:57px}#score-input .score-group.odd.paron .dropdown-menu.open li a,#score-input .score-group.even.bunker .dropdown-menu.open li a{height:37px;text-align:center}#score-input .score-group.odd.paron .dropdown-menu.open li a .text,#score-input .score-group.even.bunker .dropdown-menu.open li a .text{margin:15px 0 0;line-height:0;font-weight:700;font-size:16px}#score-input .score-group.odd.ob .dropdown-menu.open,#score-input .score-group.even.pn .dropdown-menu.open{height:400px;width:60px;padding:0;margin:0}#score-input .score-group.odd.ob .dropdown-menu.open .inner,#score-input .score-group.even.pn .dropdown-menu.open .inner{width:130px}#score-input .score-group.odd.ob .dropdown-menu.open li,#score-input .score-group.even.pn .dropdown-menu.open li{height:45px;width:58px}#score-input .score-group.odd.ob .dropdown-menu.open li a,#score-input .score-group.even.pn .dropdown-menu.open li a{height:37px;text-align:center}#score-input .score-group.odd.ob .dropdown-menu.open li a .text,#score-input .score-group.even.pn .dropdown-menu.open li a .text{margin:15px 0 0;line-height:0;font-weight:700;font-size:16px}#score-input .panel{margin-top:2px;background-color:transparent;border-color:transparent;box-shadow:none}#score-input .panel.last{height:60px}#score-input .panel .panel-heading{position:relative;height:60px;cursor:pointer}#score-input .panel .panel-heading.inactive{opacity:.5}#score-input .panel .panel-heading .bar-menu-bg-1,#score-input .panel .panel-heading .bar-menu-bg-2,#score-input .panel .panel-heading .bar-menu-bg-3,#score-input .panel .panel-heading .bar-menu-bg-4{position:absolute;top:0;right:0;bottom:0;left:-80px;background-repeat:no-repeat;background-position:0,10px 0;z-index:5;cursor:pointer}#score-input .panel .panel-heading .bar-menu-bg-1{background-image:url("+__webpack_require__(358)+")}#score-input .panel .panel-heading .bar-menu-bg-2{background-image:url("+__webpack_require__(359)+")}#score-input .panel .panel-heading .bar-menu-bg-3{background-image:url("+__webpack_require__(360)+")}#score-input .panel .panel-heading .bar-menu-bg-4{background-image:url("+__webpack_require__(361)+")}#score-input .panel .panel-heading .panel-title{position:absolute;left:60px;top:0;right:0;bottom:0;text-indent:0;background-image:url("+__webpack_require__(362)+");background-repeat:repeat;z-index:5}#score-input .panel .panel-heading .title{position:absolute;left:-78px;top:0;line-height:60px;text-indent:80px;font-size:24px;color:#fff;text-decoration:none}#score-input .panel .bar-menu-footer{position:relative;width:100%;height:60px;top:0;left:0;background-repeat:no-repeat}#score-input .panel .bar-menu-footer .bar-menu-bg-footer{position:absolute;left:80px;top:0;right:0;bottom:0;background-image:url("+__webpack_require__(362)+");background-repeat:repeat;z-index:5}#score-input .panel .bar-menu-footer .bar-menu-bg-footer .bar-menu-5{position:absolute;top:0;right:0;bottom:0;left:-100px;background-image:url("+__webpack_require__(363)+");background-repeat:no-repeat;z-index:5}#score-input .panel .bar-menu-footer .bar-menu-bg-footer .bar-menu-5.title{left:-100px;color:#00B2AF;width:220px;line-height:60px;font-size:24px;text-align:center;z-index:10}#score-input .panel .panel-collapse{background-color:#E5E5E5;position:relative}#score-input .panel .panel-collapse .content-wrap{margin-left:6px;background-image:url("+__webpack_require__(364)+");background-repeat:no-repeat;background-position:left 0}#score-input .panel .panel-collapse .content-wrap .content{margin-left:72px;padding:10px 8%;right:0;background-color:#fff}#score-input .panel .panel-collapse.collapse.in{display:block}#score-input .score-step-footer{margin-top:2px;height:60px}#score-input .score-step-footer .bar-menu-footer{position:relative;width:100%;height:60px;top:0;left:0;background-repeat:no-repeat}#score-input .score-step-footer .bar-menu-footer .bar-menu-bg-footer{position:absolute;left:80px;top:0;right:0;bottom:0;background-image:url("+__webpack_require__(362)+");background-repeat:repeat;z-index:5}#score-input .score-step-footer .bar-menu-footer .bar-menu-bg-footer .bar-menu-5{position:absolute;top:0;right:0;bottom:0;left:-100px;background-image:url("+__webpack_require__(363)+");background-repeat:no-repeat;z-index:5}#score-input .score-step-footer .bar-menu-footer .bar-menu-bg-footer .bar-menu-5.title{left:-100px;color:#00B2AF;width:220px;line-height:60px;font-size:24px;text-align:center;z-index:10}#score-input .step-body-1 .tab{position:relative;width:100%;height:60px;background-color:#F2F2F2}#score-input .step-body-1 .tab .tab-1,#score-input .step-body-1 .tab .tab-2{cursor:pointer;position:relative;width:16.67%;min-width:90px;height:60px;line-height:60px;text-align:center;font-size:22px;color:darkgray;float:left}#score-input .step-body-1 .tab .tab-1.active,#score-input .step-body-1 .tab .tab-2.active{background-color:#fff;color:#00AAA5}#score-input .step-body-1 .filter-bar{position:relative;width:100%;height:50px;margin-top:45px;margin-bottom:33px;text-align:center}#score-input .step-body-1 .filter-bar input{width:100%;height:38px;border:solid 1px #ccc;padding:0;text-align:left;text-indent:10px;font-size:14px;border-radius:5px}#score-input .step-body-1 .filter-bar .btn{position:relative;color:#fff;line-height:0;float:right;background-color:#01a5a3;width:80%;height:38px;border-radius:5px;border-color:#01a5a3;border-width:1px;border-style:solid}#score-input .step-body-1 .blank{position:relative;width:20px;height:100px;float:left}#score-input .step-body-1 .list-wrap{position:relative;width:100%;margin-top:20px}#score-input .step-body-1 .list-wrap ul{position:relative;list-style-type:none;padding:0}#score-input .step-body-1 .list-wrap ul li{position:relative;width:100%;padding:10px 0;margin:-3px 0;cursor:pointer}#score-input .step-body-1 .list-wrap ul li.even:hover{height:100%;background-color:#EEFBFA}#score-input .step-body-1 .list-wrap ul .odd{background-color:#F7F7F7}#score-input .step-body-1 .list-wrap ul .course-name,#score-input .step-body-1 .list-wrap ul .course-addr{margin:10px 0;line-height:150%;display:table-cell;vertical-align:middle}#score-input .step-body-1 .list-wrap ul .course-name{font-size:14px}#score-input .step-body-1 .list-wrap ul .course-addr{font-size:12px;overflow:hidden;text-overflow:ellipsis}#score-input .step-body-1 .empty{margin-top:20px;font-size:14px}#score-input .step-body-1 .empty,#score-input .step-body-1 .btn-row{position:relative;text-align:center}#score-input .step-body-1 .btn-row .btn-more{position:relative;width:250px;height:40px;margin-top:35px;border-radius:5px;background-color:#00AAA5}#score-input .step-body-1 .btn-row .btn-more .title{position:relative;top:5px;margin-left:auto;margin-right:auto;width:200px;height:30px;color:#fff;font-size:14px}#score-input .step-body-1 .btn-row .btn-request{position:relative;width:250px;height:80px;margin-top:35px;margin-bottom:35px;border-radius:5px;background-color:#00AAA5}#score-input .step-body-1 .btn-row .btn-request .title{position:relative;top:5px;margin-left:auto;margin-right:auto;width:200px;height:38px;color:#fff;font-size:14px;font-weight:700}#score-input .step-body-1 .btn-row .btn-request .text{position:relative;width:200px;margin-left:auto;margin-right:auto;color:#fff;white-space:pre-line;font-size:12px}#score-input .step-body-2 .course-info{position:relative;margin-left:15px;height:150px;margin-top:60px;margin-bottom:35px}#score-input .step-body-2 .course-info .course-info-wrap{padding:0}#score-input .step-body-2 .course-info .course-name,#score-input .step-body-2 .course-info .course-addr,#score-input .step-body-2 .course-info .course-tel{position:relative;float:left;height:50px;line-height:50px;text-indent:40px;background-repeat:no-repeat;background-position:left center}#score-input .step-body-2 .course-info .course-addr,#score-input .step-body-2 .course-info .course-tel{font-size:14px}#score-input .step-body-2 .course-info .course-name{width:100%;font-size:20px;background-image:url("+__webpack_require__(365)+");white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#score-input .step-body-2 .course-info .course-addr{width:100%;background-image:url("+__webpack_require__(366)+");background-position:left 5px center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#score-input .step-body-2 .course-info .course-tel{width:100%;background-image:url("+__webpack_require__(367)+")}#score-input .step-body-2 .course-info .btn-reservation{position:relative;float:left;width:220px;height:40px;line-height:40px;font-size:12px;text-indent:40px;border:solid 1px #ccc;border-radius:5px;background-repeat:no-repeat;background-position:left 10px center;background-image:url("+__webpack_require__(368)+")}#score-input .step-body-2 .column-head,#score-input .step-body-2 .column-input{position:relative;float:left;line-height:36px}#score-input .step-body-2 .column-head{font-size:14px;font-weight:700}#score-input .step-body-2 .column-input{margin-bottom:13px;width:100%}#score-input .step-body-2 .content-row,#score-input .step-body-2 .row{position:relative}#score-input .step-body-2 .row .line{padding-top:15px;border-top:solid 1px #E6E6E6;width:100%}#score-input .step-body-2 .play-date input[type=number][name=year],#score-input .step-body-2 .play-date input[type=number][name=month],#score-input .step-body-2 .play-date input[type=number][name=day]{position:relative;margin-right:6px;line-height:16px;color:#333;font-size:14px;text-indent:15px;background-color:#fff;width:100%;height:36px;border-radius:5px;border-color:#ccc;border-width:1px;border-style:solid}#score-input .step-body-2 .play-date .error{position:relative;left:240px;width:67%;line-height:15px;background-color:transparent;border:0;padding:0 10px 10px;margin:0;color:#8a1f11}#score-input .step-body-2 .weather{margin-bottom:0}#score-input .step-body-2 .weather input[type=\"radio\"]{display:none}#score-input .step-body-2 .weather input[type=\"radio\"]+label{position:relative;width:80px;height:80px;border:solid 1px #CDCDCD;border-radius:5px;background-repeat:no-repeat;background-position:center;margin-right:14px;cursor:pointer}#score-input .step-body-2 .weather input[type=\"radio\"]+label:last-of-type{margin-right:0}#score-input .step-body-2 .weather input[type=\"radio\"]:checked+label{background-color:#4ac2c2}#score-input .step-body-2 .weather #score-input-weather-cloudy+label{background-image:url("+__webpack_require__(369)+")}#score-input .step-body-2 .weather #score-input-weather-cloudy:checked+label{background-image:url("+__webpack_require__(370)+")}#score-input .step-body-2 .weather #score-input-weather-foggy+label{background-image:url("+__webpack_require__(371)+")}#score-input .step-body-2 .weather #score-input-weather-foggy:checked+label{background-image:url("+__webpack_require__(372)+")}#score-input .step-body-2 .weather #score-input-weather-rainy+label{background-image:url("+__webpack_require__(373)+")}#score-input .step-body-2 .weather #score-input-weather-rainy:checked+label{background-image:url("+__webpack_require__(374)+")}#score-input .step-body-2 .weather #score-input-weather-snowing+label{background-image:url("+__webpack_require__(375)+")}#score-input .step-body-2 .weather #score-input-weather-snowing:checked+label{background-image:url("+__webpack_require__(376)+")}#score-input .step-body-2 .weather #score-input-weather-sunny+label{background-image:url("+__webpack_require__(377)+")}#score-input .step-body-2 .weather #score-input-weather-sunny:checked+label{background-image:url("+__webpack_require__(378)+")}#score-input .step-body-2 .weather .error{position:relative;left:240px;width:67%;line-height:15px;background-color:transparent;border:0;padding:0 10px 10px;margin:0;color:#8a1f11}#score-input .step-body-2 .input-course{position:relative}#score-input .step-body-2 .input-course .course-label{font-size:14px}#score-input .step-body-2 .input-course select{width:100%;height:36px;background-color:#fff;text-indent:10px;font-size:14px;border-color:#ccc}#score-input .step-body-2 .error{position:relative;left:240px;width:67%;line-height:15px;background-color:transparent;border:0;padding:0 10px 10px;margin:0;color:#8a1f11}#score-input .step-body-2 .content-map{position:relative;width:100%;height:420px;margin-top:15px;background-size:cover}#score-input .step-body-2 .content-button{position:relative;padding-top:50px;padding-bottom:20px}#score-input .step-body-2 .content-button .btn-save{position:relative;margin:0 auto;display:block}#score-input .step-body-2 .content-button .link{margin-top:10px;text-align:center}#score-input .step-body-2 .content-button .link a,#score-input .step-body-2 .content-button .link a:hover{font-size:12px;color:#727272;text-decoration:none}#score-input .step-body-3 .content-row-wrapper:first-of-type{margin-top:50px}#score-input .step-body-3 .content-row{width:100%;padding-top:7px;height:55px}#score-input .step-body-3 .content-row input[type=\"text\"]{float:left;width:100%;height:36px;margin-right:20px;line-height:20px}#score-input .step-body-3 select{height:36px;font-size:14px;text-indent:10px;background-color:#fff;border-color:#ccc}#score-input .step-body-3 select.int{width:60px}#score-input .step-body-3 select.few{margin-left:10px;width:55px}#score-input .step-body-3 .error{position:relative;left:170px;width:67%;background-color:transparent;border:0;padding:0 10px 3px;margin:0;color:#8a1f11}#score-input .step-body-3 .period{position:absolute;left:464px;top:19px;font-size:20px}#score-input .step-body-3 .content-button{position:relative;padding-top:50px;padding-bottom:20px}#score-input .step-body-3 .content-button .btn-save{position:relative;display:block;margin:0 auto}#score-input .step-body-3 .content-button .link{margin-top:10px;text-align:center}#score-input .step-body-3 .content-button .link a,#score-input .step-body-3 .content-button .link a:hover{font-size:12px;color:#727272;text-decoration:none}#score-input .step-body-4 .score-board{left:41px}#score-input .step-body-4 .score-board .score-title{background-color:#00B2AF;height:40px;line-height:40px;color:#fff;font-size:18px;font-weight:700;text-indent:20px;margin-bottom:1px}#score-input .step-body-4 .score-board .row{position:relative;margin-bottom:1px;margin-left:0;height:40px;line-height:40px;text-align:center}#score-input .step-body-4 .score-board .row.header{height:30px;line-height:30px}#score-input .step-body-4 .score-board .row .header{background-color:#9BA7A5;color:#fff}#score-input .step-body-4 .score-board .row .odd{background-color:#fff;color:#333}#score-input .step-body-4 .score-board .row .even{background-color:#F2F2F2;color:#333}#score-input .step-body-4 .score-board .row .score-label{position:absolute;left:0;width:160px;height:100%;text-align:left;text-indent:15px;font-size:100%;font-weight:400}#score-input .step-body-4 .score-board .row .score-label.player{font-weight:700}#score-input .step-body-4 .score-board .row .column-label{width:20%;float:left;text-align:left;text-indent:15px}@media (max-width:375px){#score-input .step-body-4 .score-board .row .column-label{font-size:9px}}#score-input .step-body-4 .score-board .row .group{position:absolute;height:100%;left:161px;right:0;font-size:14px}#score-input .step-body-4 .score-board .row .group .hole{position:relative;float:left;width:9.5%;height:100%;font-size:14px;font-weight:700;background-repeat:no-repeat;background-position:center}#score-input .step-body-4 .score-board .row .group .total{position:relative;float:left;width:14.5%;height:100%;font-size:19px;font-weight:700}#score-input .step-body-4 .score-board .row .group .total.header{font-size:14px;font-weight:400}#score-input .step-body-4 .textarea{height:100px;width:500px;border-radius:5px;margin:35px 0 -35px 195px;resize:none}#score-input .step-body-4 .content-button{position:relative;margin-top:50px;padding-bottom:20px}#score-input .step-body-4 .content-button .btn-save{position:relative;left:50%;margin-left:-70px}#score-input .step-body-4 .content-button .link{margin-top:10px;text-align:center}#score-input .step-body-4 .content-button .link a,#score-input .step-body-4 .content-button .link a:hover{font-size:12px;color:#727272;text-decoration:none}#score-input .step-body-2 .row{margin-left:0;margin-right:0;padding:0 1px}@media (max-width:768px){#score-input .panel{padding-left:20px}#score-input .step-body-2 .content-map{width:100%;left:unset}#score-input .step-body-3 .content-row{width:100%;left:unset;margin-left:unset}#score-input .step-body-3 .content-row input[type=\"text\"]{width:100%;margin-right:unset}}@media (max-width:414px){#score-input .panel .panel-collapse .content-wrap .content{padding:10px 0;margin-left:25px}#score-input .step-body-1 .filter-bar{padding:0 15px}#score-input .step-body-2 .weather input[type=\"radio\"]+label{width:54px;height:54px}}@media (max-width:375px){#score-input .step-body-2 .weather input[type=\"radio\"]+label{width:47px;height:47px}}@media (max-width:360px){#score-input .step-body-2 .weather input[type=\"radio\"]+label{width:44px;height:44px}}@media (max-width:320px){#score-input .step-body-2 .weather input[type=\"radio\"]+label{width:36px;height:36px}#score-input .panel .panel-heading .title{font-size:20px}}.score-board-app{margin:60px auto}.score-board-app .score-title{background-color:#00B2AF;height:40px;line-height:40px;color:#fff;font-size:18px;font-weight:700;padding-left:20px;margin-bottom:1px}.score-board-app .row{margin-left:0;margin-right:0}.score-board-app .row>div{padding:0}.score-board-app .score-header .hole{background-color:#9BA7A5;color:#fff;line-height:30px;border-bottom:1px solid #fff}.score-board-app .score-header.row .hole{font-weight:400}.score-board-app .score-header.row .header{text-align:left}.score-board-app .score-body{position:relative}.score-board-app .score-body .hole.header{font-weight:400}.score-board-app .score-body .hole.even{background-color:#F2F2F2;color:#333}.score-board-app .score-body .hole{height:41px;background-color:#fff;color:#000;line-height:40px;border-bottom:1px solid #fff}.score-board-app .score-body .hole .input button{text-decoration:none;text-align:center;padding:0}.score-board-app .score-body .hole .input.normal button{background-color:#fff;width:100%;height:40px;border-radius:0;border-color:#fff;border-width:0;border-style:solid;color:#000}.score-board-app .score-body .hole .input.condor button,.score-board-app .score-body .hole .input.albatross button{color:#fff;background-color:gold;width:100%;height:40px;border-radius:0;border-color:gold;border-width:0;border-style:solid}.score-board-app .score-body .hole .input.eagle button{color:#fff;background-color:#FC1A3A;width:100%;height:40px;border-radius:0;border-color:#FC1A3A;border-width:0;border-style:solid}.score-board-app .score-body .hole .input.birdie button{color:#fff;background-color:#F7931E;width:100%;height:40px;border-radius:0;border-color:#F7931E;border-width:0;border-style:solid}.score-board-app .score-body .hole .input.par button{color:#fff;background-color:#05A2D3;width:100%;height:40px;border-radius:0;border-color:#05A2D3;border-width:0;border-style:solid}.score-board-app .score-body .hole .input.bogey button{color:#fff;background-color:#043377;width:100%;height:40px;border-radius:0;border-color:#043377;border-width:0;border-style:solid}.score-board-app .score-body .hole .input.dbogey button{color:#fff;background-color:#215605;width:100%;height:40px;border-radius:0;border-color:#215605;border-width:0;border-style:solid}.score-board-app .score-body .hole .input.overTbogey button{color:#fff;background-color:#3A3A3A;width:100%;height:40px;border-radius:0;border-color:#3A3A3A;border-width:0;border-style:solid}.score-board-app .score-body .hole .input.gray button{color:#000;background-color:#F2F2F2;width:100%;height:40px;border-radius:0;border-color:#F2F2F2;border-width:0;border-style:solid}.score-board-app .score-body .hole .input.white button{color:#000;background-color:#fff;width:60px;height:37px;border-radius:0;border-color:#fff;border-width:0;border-style:solid}.score-board-app .row .col-1,.score-board-app .row .col-2,.score-board-app .row .col-3{float:left}.score-board-app .row .col-1 button.dropdown-toggle,.score-board-app .row .col-2 button.dropdown-toggle,.score-board-app .row .col-3 button.dropdown-toggle{display:block;overflow:hidden}.score-board-app .row .col-1{width:21.5%;-ms-flex:0 0 21.5%;flex:0 0 21.5%;max-width:21.5%;border-right:1px solid #fff}.score-board-app .row .col-1 .hole.header{font-size:12px}.score-board-app .row .col-2{width:7.5%;-ms-flex:0 0 7.5%;flex:0 0 7.5%;max-width:7.5%}.score-board-app .row .col-3{width:11%;-ms-flex:0 0 11%;flex:0 0 11%;max-width:11%}.score-board-app .col-1 .hole.header.player{font-weight:700}.score-board-app .col-1 .hole.header.title-board{height:31px}.score-board-app .col-1 .hole.header{overflow:hidden;padding-left:15px;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical}.score-board-app .col-1 .hole.header.header-sub{padding-left:20px}@media (max-width:414px){.score-board-app .col-1 .hole.header.header-sub{padding-left:5px;font-size:9px}}.score-board-app .col-1 .hole.header.header-sub span.title-score{white-space:pre-wrap;display:-webkit-box;overflow:hidden}@media (max-width:414px){.score-board-app .col-1 .hole.header.header-sub span.title-score{line-height:18px}}.score-board-app .col-3 .hole.header{text-align:center;font-weight:700;font-size:20px}.score-board-app .col-2 .hole.myscore{font-size:25px}.score-board-app .col-2 .hole.myscore.condor,.score-board-app .col-2 .hole.myscore.albatross{background-color:gold;color:#fff}.score-board-app .col-2 .hole.myscore.eagle{background-color:#FC1A3A;color:#fff}.score-board-app .col-2 .hole.myscore.birdie{background-color:#F7931E;color:#fff}.score-board-app .col-2 .hole.myscore.par{background-color:#05A2D3;color:#fff}.score-board-app .col-2 .hole.myscore.bogey{background-color:#043377;color:#fff}.score-board-app .col-2 .hole.myscore.dbogey{background-color:#215605;color:#fff}.score-board-app .col-2 .hole.myscore.overTbogey{background-color:#3A3A3A;color:#fff}.score-board-app .col-2 .hole{font-size:14px;font-weight:700;text-align:center}.score-board-app .col-2 .hole .dropdown-toggle .score{font-size:25px}.score-board-app .col-2 .dropdown-menu a{height:41px;padding-left:20px;text-align:center;line-height:39px;font-size:19px;font-weight:700}.score-board-app .col-2 .dropdown-menu a .sub-text{margin-left:40px;font-size:18px;color:darkgray}.score-board-app .col-2 .dropdown-menu a .par{color:red}.score-board-app .col-2 .shot .dropdown-menu a{text-align:left}.score-board-app .col-2 .circle-green,.score-board-app .col-2 .arrow-back,.score-board-app .col-2 .circle-red,.score-board-app .col-2 .arrow-forward,.score-board-app .col-2 .check{background-repeat:no-repeat;background-position:center;height:41px}.score-board-app .col-2 .check{background-image:url("+__webpack_require__(379)+")}.score-board-app .col-2 .arrow-back{background-image:url("+__webpack_require__(380)+")}.score-board-app .col-2 .arrow-forward{background-image:url("+__webpack_require__(381)+")}.score-board-app .col-2 .circle-green{background-image:url("+__webpack_require__(382)+")}@media (max-width:375px){.score-board-app .col-2 .circle-green{background-size:15px 15px!important}}.score-board-app .col-2 .circle-red{background-image:url("+__webpack_require__(383)+")}@media (max-width:375px){.score-board-app .col-2 .circle-red{background-size:15px 15px!important}}@media (max-width:414px){.score-board-app .col-3 .hole.header,.score-board-app .col-2 .hole{font-size:13px}}@media (max-width:375px){.score-board-app .col-3 .hole.header{font-size:11px}}@media (max-width:360px){.score-board-app .col-2 .hole{font-size:12px}}@media (max-width:320px){.score-board-app .col-2 .hole{font-size:11px}.score-board-app .col-3 .hole.header{font-size:9px}}#score-input .panel-body{padding:0;border-top:none}#score-input .accordion-container{margin-top:20px}#score-input .container.score-input-container{max-width:none!important;width:970px}#score-input .container.score-input-container .cell{padding:0}#score-input .btn-save{width:140px;height:40px;text-align:center;font-size:12px;color:#fff;background-color:#333;border-radius:5px}#score-input .btn-save.footer{position:relative;top:-50px;right:10px;float:right;z-index:10}#score-input .content-row .dropdown-menu.open{padding:0;margin:0;width:51px}#score-input .play-date .input-date .dropdown-menu.open{width:144px;padding:0;margin:0}#score-input .play-date .input-date .dropdown-menu.open .inner{width:180px}#score-input .play-date .input-date .dropdown-menu.open li{height:39px;width:141px}#score-input .play-date .input-date .dropdown-menu.open li a{height:37px}#score-input .play-date .input-date .dropdown-menu.open li a .text{margin:15px 0 0;line-height:0}#score-input .course .column-input .dropdown-menu.open{width:100%;padding:0;margin:0}#score-input .course .column-input .dropdown-menu.open .inner{width:105%}#score-input .course .column-input .dropdown-menu.open li{height:39px;width:472px}#score-input .course .column-input .dropdown-menu.open li a{height:37px}#score-input .course .column-input .dropdown-menu.open li a .text{margin:15px 0 0;line-height:0}#score-input .course .column-input .dropdown-menu.open li a .text .muted{padding-left:0}@media (max-width:768px){#score-input .container.score-input-container{width:100%}}@media (max-width:414px){#score-input .btn-save{width:100px}}@media (max-width:320px){#score-input .btn-save{width:80px}}.dropdown-menu.scrollable{height:auto;max-height:300px;overflow-x:hidden;overflow-y:auto;min-width:65px}.dropdown-menu.scrollable::-webkit-scrollbar{-webkit-appearance:none}.dropdown-menu.scrollable::-webkit-scrollbar:vertical{width:11px}.dropdown-menu.scrollable::-webkit-scrollbar:horizontal{height:11px}.dropdown-menu.scrollable::-webkit-scrollbar-thumb{border-radius:8px;border:2px solid #fff;background-color:rgba(0,0,0,.5)}@media (max-width:414px){.modal-dialog.modal-sm{margin-top:200px}.recommend-modal .message-content{padding:20px;font-size:16px}}", ""]);

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA8CAMAAADG+c2+AAABelBMVEUAra3///8Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0zvb04v785v786wMA7wMA8wMBEw8NKxcVLxcVMxcVPxsZQx8dSx8dTyMhUyMhozs5pz89qz89309N61NR71dV81dWI2dmO29uR3NyS3NyT3NyU3d2W3d2Z3t6m4uKn4+Oo4+O26Oi36Oi46Oi56Oi76em86enI7e3J7u7N7+/O7+/d9PTf9fXi9vbj9vbo+Pjr+fns+fnt+fnx+vry+/v4/f35/f36/f37/v78/v7+///////E6OIRAAAAQXRSTlMAAAYHDQ4PExUWGRscHj4/QEFDSElVVnBzdHt8k5SVlqSlp6iprrO0vL2+v8LDxcbIycrMzc/S3uPu7/Dz+vv8/WXNqe4AAAJSSURBVFjDvdjpUxMxGMfxLCqKIuKBF94HeNX7QETr125LS+WqWhbECpTDUmrlsFol/7sviuNAN9lk2fH3Mt39THeSeZInwnEcx3HEjrQe775yv28A+wgfsP303Thh0wx29ITXfMDOO+wu28GDl/6Ou/mZUrUmZa1amsm7YcGuF1vapzW5LWsFNwTYcq4xNF6UPpkftwX33gAgsyAVWchYgQceATAlNZmyAFsfA7hlqU3ZNQVbbgJkfsqAbL41BC8AjEiDjBiBXQBZaZSsAXioH0jVzcB6Khi8DlCWhlkJBI8CfJTGmQ4CY8CYtMiYHuwAWLQBl/RgD5CTVsnpwLZXQNEOLOrAU0BC8WIa0r4/JDRgDJj09yqowEk12BoHVpV/UAGuqsETgOs/l29QglJZdsRZ4EPzC+/TWw8owAkleBWY9f9aHTirBB8AJXuwpAT7gGrzC589z/PUkyK/KcEBoKZYhp4a/K4EAaQ9KKMGf0T9yeu2kxIEfrVdNkFgyXZhB4Hqhd0N5O3BiRDFQQu6ocqXF6Z86QqsF6bA6rYANZgIt0kpQe0m5fRGvI02NvolG+/Lfz6KOMcApiM8LDWOcyvRHeec9n5g8LeZtzlocCQ+CTBsBg4bHdovAoyaeKOGbcVtgKFfgZ5pWyH2PwVIBjU+KfPWrO1JtK2ZEPtuATCkbB4Xs5bt7Z7zjaHcvG97+24XDXiysL5j0ywkQ14RXP53RTC3XNmo1zcqy3PhrwiEEJ2xSC8xhBDiSO/raEEhDp+5F48UbFxVXXv47PlLe/APW800MNAVvawAAAAASUVORK5CYII="

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA8CAMAAADG+c2+AAABjFBMVEUAra3///8Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0RsrIiuLgzvb04v785v786wMA7wMA8wMBEw8NKxcVLxcVMxcVPxsZQx8dSx8dTyMhUyMhmzs5ozs5pz89qz89309N61NR71dV81dWI2dmO29uR3NyS3NyT3NyU3d2W3d2Z3t6m4uKn4+Oo4+Oq5OS26Oi36Oi46Oi56Oi76em86enI7e3J7u7M7+/N7+/O7+/d9PTf9fXi9vbj9vbo+Pjr+fns+fnt+fnu+vrx+vry+/v4/f35/f36/f37/v78/v7+///////JUyQlAAAAQXRSTlMAAAYHDQ4PExUWGRscHj4/QEFDSElVVnBzdHt8k5SVlqSlp6iprrO0vL2+v8LDxcbIycrMzc/S3uPu7/Dz+vv8/WXNqe4AAAKvSURBVFjDvZhnVxNBFIZnUVEUEQs27AVs2Asiik+yLF1KiIoBkQBSYigRKRENMn/cD5HkhJ3dnVlyfD/O3HnOztzZW0ZYlmVZltilypP11x42t2IuoQBWn73fRli5gTUN4WkKYO099qZS4OErO+POyGR6ZVPKzZX05IgTFlj36h/ty5os0dqEEwJYcSE/NDwjFZodNgXuvwVAz5z00FyPEfDQEwDGpI/GDICVTwGcJemrJUcXWHEboOe3DND2O03gJYABqaEBLWAdQJ/UUp8G8EgL0JnTA+Y6g4E3AZakppYDgccBPkttjQcBm4AhaaAhf2ANwLwJMOUPbADi0khxP2DVG2DGDDjjBzwDtCuXLSYSia9Z5VS7D7AJGFUdVDRvEcsoJke9gZVtwKp7SbJgEll0z656A08Bjr8jI4pte4YdcR746F4QBSKJVNIGSLjnP3kCrwNTbn8ALEoppQ3YbuCUJ/ARkHbZJ4BY8SzdwLQnsBlYcdl3A8niYbqBPzyBrcCmEpgqfGHUDfzpCVR/QEHZaGHzpQoJzMYAFFf7l+GWd5xtUzjMUq0bOqXoazVPfje8NlJKmbEBoinlZNrwYkspkxGAD+po43Ox64ER6REcPD7P99fzCA5JADvr6X7HMHxlAnirpgE2BmB378gkwKpTwC4roxSgSlKpAKBvkrIa3Wk0CBgPTvQpkyz67T+XItYJgPEyFkv5cm65fOWcVd0CdP3R4213aZTEpwH69YD9WkX7ZYBBHd6gZltxF6B3K5Cn21aIg88BOoIan0791qzqWXlbMyEO3AGg17N5nO8zbG/3XcwPxWeV7e37PTTgHRPru5LmREfIJ4KrxSeC6YXMRi63kVmYDv9EIISobSrrI4YQQhxrfFteoBBHzz1oKysw/1R14/GLl6/NgX8BqotPGolcsTEAAAAASUVORK5CYII="

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA8CAMAAADG+c2+AAABj1BMVEUAra3///8Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0RsrIiuLgzvb04v785v786wMA7wMA8wMBEw8NKxcVLxcVMxcVPxsZQx8dSx8dTyMhUyMhVyMhmzs5ozs5pz89qz89309N61NR71dV81dWI2dmO29uR3NyS3NyT3NyU3d2W3d2Z3t6m4uKn4+Oo4+Oq5OS26Oi36Oi46Oi56Oi76em86enI7e3J7u7M7+/N7+/O7+/d9PTf9fXi9vbj9vbo+Pjr+fns+fnt+fnu+vrx+vry+/v4/f35/f36/f37/v78/v7+///////kw8EeAAAAQXRSTlMAAAYHDQ4PExUWGRscHj4/QEFDSElVVnBzdHt8k5SVlqSlp6iprrO0vL2+v8LDxcbIycrMzc/S3uPu7/Dz+vv8/WXNqe4AAAK8SURBVFjDvZhnVxNBFIZnUVEUFQs27AVs2Asiik8SAgSQHhECIqGzhkBESkSjzA/3Q2hhZ5KZJcf305zZm+fM7tzcJhzHcRxH7FHpmaqbT+oasJdQAMsvPGrEr7zAE9X+aQpgxUP2p1zg0etb++HB8cTSupTrS4nxwbBfYOXbTdrXFZmjlbGwD2DJ5exW/7RUaKbfFnjwLgBts1Kj2TYr4JHnAIzIPBqxAJa+AAgvyLxaCJsCS+4BtP2WBbTx0RB4FaBLGqjLCFgJ0CGN1GEAPFYPtGTMgJmWwsA7AAvSUIsFgacAvkhjjRYC1gI90kI9+YEnAOZsgG5+YDUQlVaK5gOWvQdU8SA9FYvFXCVwOh/wPNCkwA0EAAjGVMSmPMBaYNjLC22bRNJe4LAeWNoILHt+EdllM+AFLuuBZ4Gw+h5jaZnsBUh5idqwIy4Bnz32fUD244W2Vzka0gJvARMe++D2uWJq4IQW+BRIeD9hJBLJrgaAuBeY0ALrgCW9CycDgOKaf2iBDcC6hhaL9aI+oPypBQLojgdAwNU/8wUkOKV49MvvKwcAFGdc9Xsp6RAQ9O5/t3OblOu6m3+POEDSwm2Ujr3Lm131O+sduwoY3GseB0LZ5ZQaOGQXHJI7lIjaDcKW4SsCBOJb0abPJnypA2xOGgqkbQKsJgXEd/GSdilAk6SSmzE70Je2TFJOjSaNpvRZL1o40bs2afnbfy5FnNMAo0UslrLl3GLxyjmnvB5o/WvG22g1KInPAXSaATuNivZrAN0mvG7DtuIBQPufgjzTtkIcfgXQXKjxaTFvzcpeFrc1E+LQfQDatc3jXIdle3vgSnYrOqNsbz/towFvHlvdkzTHmn2OCG7sjAgm51Nrmcxaan7S/4hACFFRW9QhhhBCnKz5UFygEMcvPm4sKjA7qrr97PWbd/bAf1udV6BzJUAMAAAAAElFTkSuQmCC"

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA8CAMAAADG+c2+AAABj1BMVEUAra3///8Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0RsrIiuLgzvb04v785v786wMA7wMA8wMBEw8NKxcVLxcVMxcVPxsZQx8dSx8dTyMhUyMhVyMhmzs5ozs5pz89qz89309N61NR71dV81dWI2dmO29uR3NyS3NyT3NyU3d2W3d2Z3t6m4uKn4+Oo4+Oq5OS26Oi36Oi46Oi56Oi76em86enI7e3J7u7M7+/N7+/O7+/d9PTf9fXi9vbj9vbo+Pjr+fns+fnt+fnu+vrx+vry+/v4/f35/f36/f37/v78/v7+///////kw8EeAAAAQXRSTlMAAAYHDQ4PExUWGRscHj4/QEFDSElVVnBzdHt8k5SVlqSlp6iprrO0vL2+v8LDxcbIycrMzc/S3uPu7/Dz+vv8/WXNqe4AAAJ7SURBVFjDvdjpUxMxGMfxLCqKIuKBF94HeOF9IKL4rWUBATksqFAQueRYy1GxQEWr5A/3RXEcYJ/dZNnx9zLTfGaazeTJE+U4juM4aktKj1ZfulvfiH2UD1h+8nYTUbMdrKiJrvmAlbfYWTaD+y/8HXcHxjNLa1qvLWXGB9yoYNWzDe3Tst6U5VE3AlhypjjUN6V9Mt1nC+6+BkD7jBYy024F7nsAwLAOyLAFWPoQwF3QgVlwTcGS6wDtP3VI1t8YgucAurVBuo3AKoBObZROA/BAA9BaMAMLreHgVYAFbZjFUPAwwEdtnJEwsA7o1RbpDQYrAGZtQC8YrAH6tVX6g8CyF8CUHTgVBJ4AmqWZKSDtM94cANYBQ4I3hgAOyWBpE5Dz9+YTEpiTwWOA6+/lk0igFo8ddRr44A++RwYHRfAyMOHrfQaSEjghgveAjN+UbAJSaQnMiGA9sOQ3JQnJvAh+E8FGYM1/ARPzWgS/iyCAsIBjWga1JZhPwFsdAP6w/Muv4VU+CFyx+yhpIO15npcCUp6X3wZ+tds26S2/8iy2je/GDgfljV0NDNiDg3aHQ9bbiLiGbqTjS/7KuYgHrAgORS0B6QglILBICWBgkXJqYy6jxULv2Xhf/vNVxDkCMBLjZal4nVuM7zrnlDcAbb/NvPU2gyvxcYAuM7DL6NJ+HqDHxOsxbCtuAnT8CvVM2wq19zFAS1jj02rempU9irc1U2rPDQA6xOZxttOyvd11tjjUP+3b3r7bQQPeMrqypWiOtkR8Irj474lgci67WiisZucmoz8RKKUq62J9xFBKqUO1L+MFlTp46k5TrGDxqerK/SdPn9uDfwA7uFym5XBBrQAAAABJRU5ErkJggg=="

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAA1BMVEUAra0UtCArAAAACklEQVQIHWMAAgAABAABDTukuQAAAABJRU5ErkJggg=="

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANwAAAA8CAMAAAA6wCQxAAABa1BMVEUAra3///8Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara0Ara04v785v786wMA7wMA8wMBKxcVLxcVMxcVPxsZQx8dSx8dTyMhUyMhozs5pz89qz8961NR71dV81dWO29uR3NyS3NyT3NyU3d2W3d2m4uKn4+Oo4+O26Oi36Oi46Oi56Oi76em86enI7e3J7u7N7+/O7+/d9PTf9fXi9vbj9vbo+Pjr+fns+fnt+fnx+vry+/v4/f35/f36/f37/v78/v7+//////9ZBjyCAAAAQXRSTlMAAAYHDQ4PExUWGRscHj4/QEFDSElVVnBzdHt8k5SVlqSlp6iprrO0vL2+v8LDxcbIycrMzc/S3uPu7/Dz+vv8/WXNqe4AAAIkSURBVGje5dtXUwIxFAXgYMHee++9914QULGiWBAVLIiKgKKo+fnmZmUQWJVHczwPSTZv38yyu0kuzCDDEmIsq2sdnp43qR2mg8uvHlwyISQZV9iJIdPBFfebcBKPy22Ozpsdp15/mP/5hP3eU4c5FVzF3KfsJMiVStBl/gWXVq9N7bq5gvHs/oTL6JYTaxdc0VysfYvLHpPXR1zhHH2DM47LH5uPKx2fWQ+X1iNvyReueN43dHCNNN7iANlKwlXQ0MYhYkvA5c2KkTWCgYtY43EdNPJxkNzG4UpocMxh4vyKGxD9DgfKTgxXSP0lEu4qhusUnZ1DxR7F5SyKzo2Fc0dxVaJd4WBZ+cTR4+QQDXeo4Yy0YxJAwwU0XDktBjhc5PKA1YpmHw93IHFtojnDw51J3IhovHg4r8RNi8aPh3uQODoPCOPhniSOGg4YZNwz8m0ZQn6g3OO/CqBf4nWicaB+fkF/OEMveaAXq9jbDNAbRIYu4K09bVP2Csl2/U+20w2lNHDi2JzJR1i3KLb4IyxDPh0+rr5h2N5XE46NK2m4iYHbTDrwb6LxNoJtW6dUo48u1l+Vt+mVarCsSbqyqF5kY9Uvj8qZwC2PYiyzV06sK1vYdmn7oSQxvUGbsntUpHn2UiwmtbhCaslCLksKZcAtsTLg85u7xz9fVBR5vLs5T60MmAq4B2ALuClFXcu4OMYKaoaWYHHa313aR6dmFtTGfQC46XY5fl3VJgAAAABJRU5ErkJggg=="

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABGAgMAAAASiTqkAAAACVBMVEWA1taA1taA1tavitb3AAAAAnRSTlMAgJsrThgAAAB2SURBVDjLZcwhAQAgEMDAYQjxEYlGSjw3OXGd+9e4tmu5Oq5xbddygSWWWGKJJZZYYoklllhiiSWWWGKJJZZYYoklllhiiSWWWGKJJZZYYoklllhiiSWWWGKJJZZYYoklllhiiSWWWGKJJZZYYoklllhiibnmAXbEoDcL/SXcAAAAAElFTkSuQmCC"

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAgVBMVEVKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsLNMz44AAAAKnRSTlMAAQMHCBARKDo7PEFGTVlaW15hYmhpbn+LkJmen6StucLFyc/c5OXu8/j/Ql4JAAAAwUlEQVQ4y8XR2RZDMBCA4bFVS9FV1VZFlLz/A5ZQTUiml51L/3ciZwIgDKXw2AIyPaAUIwxgZAI92f0AKsIBORGAjCwApTccPPfoCessAFnmgDzPQJUnoM4MYJkBfP4JNDuI8pIM4EXKPApsjc9u3Iz741bdxO4ne9X8POJjVR47/M4973iN79z7Hx0oNkeAFAUpwAUFVwA9Q3qmD7c6E0Ump2kZhp+3q9rmvsGtynTCpKg7lrq6SELHlK/c2liLL2+5XELjtb47MgAAAABJRU5ErkJggg=="

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAMAAAAbzM5ZAAAArlBMVEVKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsL7wJA+AAAAOXRSTlMAAQMFBggREhUbMDhKS1FUVVpbXF9ub3Fydnd8iYqZoqOkqaqrrL/Iydfb3t/g4ePk7/Lz9/j5/P7hLNb9AAAAzElEQVQYGWXBiVbCMBQE0AECYVEMShGkgiigpRZlC8z//5jxUXrS9F4IZRbfdp8sjEKhv2Fu08dVPaYnruPfK0tiOIaBB0D9MPCr8MiKJywpbKR1ZClWyChGcF4oMpwoNBxNYXGk0HA0xREZxQjOhCLFB4WNWq3IUrxjwIoB1JaBrQKGDAwB1L5Y8lmD07vQc+lBvNEzx1XnwMKhg9yUhSlumilzaRMFw5yBZ02xhq97pnPuomRGZ4ay9o7ctRF4JscINZKkgYq7e9z8ATmiTfRV7QUnAAAAAElFTkSuQmCC"

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAbCAMAAABRPb9kAAAA81BMVEVKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJKwsJ1HCtvAAAAUHRSTlMAAgQGBwkMEBEVFhgZHSAoKissMDM2Nzg5QEJLTE5PVVllaWtyg4SFiouQlJWcrK21trm8vr/HyMvR0tfa29zd3uHn6e7v8PH09ff4+fr8/fIentEAAADHSURBVBgZZcGHVsJAFAXAK0pRBBGkaAAVQbFjwUI1SJUo9/+/hjzDySa7MwBSt0PnHqbylC4LuoJD0YbuhZ4iNAt6HqCZ0bNKI+ydGxbCLumx4wjL8N9bErpnihwMxxR1mFp0OXkYDpZ02bswNCjaEei2PyluYMguKWow1Cl+T6DbeqWYHgL5u4solP0RxVf1/IfslaAUFlRW11H4Kg4Dujn4Tv8YMIBizamMEXBk03eFoMQjNz52EFbpU3T2oIucPU2+mzFgDQt8RPlawhIKAAAAAElFTkSuQmCC"

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAClFBMVEW+Fhu/CQq/Cwy/DA2/DQ6/DQ+/DxG/EhW/Gh6/GiC/GyC/HCLADRDAEBLAERPAGBrAGRvAGyHAHCLAHSPAHiLAHyLAHybAICPAIynAJCrAJSvBERPBFhnBGh3BHCLBICPBISbBIifCGRzCHCDCHSHCJi3CLDDCLTHCLTXCLzPDJyvDKC3DLDHDLzXDMjnENTvEOT/CKzC/DQ/AICbAGx6+EBK/FRfBFhi/CgzCGyC/ERTBFhjCJCnCJCq/DA/AGx+/CwzCJivADQ+/ERS/DQ6+DRDACQrCISXAExW/BgfADhC/Cw3AExfAFRjAERO/Bwe/CAnACgvAEBLCFBe/DxHADxHBCgvADhG/Bgi/CQy/Bge/BQa/BwjABwm/CAi/Cgy/CAnACgy/BQa/CAq/BAXABQa/BAS/BQbABQbAAwO/BAW/AwO/AwTAAgO/AwO/AgK/AgPABQbAAwPABge/AQHAAAC/AADAAAC/AgLAAQLAAgLAAgLAAQG/AgLAAgK/AQG/AQLAAQG/AQHAAQG/AQHAAAC0AAC5AAC6AAC7AAC7DAy8AAC9AAC9BAS+AAC+AwO+CAi/AAC/DQ2/DQ7AAADAAAHAAQHADQ3AEBDAGBjAHh7BAADCCgvDDw/DGhrEFRXEFxfFIiPGKivHLC3HLi7JLi/KODnQSUnQUlPTXF3UXV3Ya2vZamrbc3PbdHPbdXXbe3vbgYLcg4TchIXdf3/dhYfejIzfjo/hkpLhlJTik5Tklpflm5vmoaLnpaXop6fpqavprK3qra3qrq/suLnvxcbxy8zxzs/y0tPz0tL01tf129z24OD34eL45OX45eX66+v67O367e367e778fH78fL89fb89vb99/f+/f3//v////+GM7zgAAAAhnRSTlMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQICBQYIERMTFBoaHyAtLjEzRUhKS0xPYWFjY2NnaHV2dnaCg4yOlZWoqampqqqrrbW3urvExcrT1Nfa2t3e4ODh5Obm5+fu7/Dy9fb2+fn6/Pz9/nszop0AAAGESURBVBgZBcFbS5NhAADg53vfd3O6OXVzps2ItAJFugiKLvrZ3XbjVUEZSogZngLLQ9vU6Zbu8PU82cssHk5M56vTtUol9O7aV5tTWa8e8wTZ0+bKMuCy+ecLJIR3a6sAGo2LmQ+I9Sy+frsMAOWVyvBWEpbf1NGHrATeD/fGKa9v1FFajOMsfzjLi/Cq8zHF5jOM0loRzg9aRdRedFPjOcjvi6NBLDwK/fuIjYM0uwRkTk5Ky08a9eNJWAo1APeti+9X5oFqKAPIsjAYyYBqmgIQQ7k55woopwDIPa6nqut2BDOpB6Bcpr/fmgRnqQ/g73VtrhAAt6EDyFxs7ffS+uI/cBdaHYAUT/fyyZWJEUan4eYQZAVB7fjYwno+4qQVFx7qFfJC6re7WbwJvTTsxtHXnRTau/NR7O+MQ0l82BZKRd9+x9gYH4VmIKaIkFLM7eyeP8RBd/gzzZYA4NOPy/EgTmVmf90OFgHsbx1sV8eDhLyweX00P1etzJx17047n2PEfxUAjQheFiP+AAAAAElFTkSuQmCC"

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAXxJREFUeNpi/P//P8NgBkwMgxyMOnDUgaMOJABYQMS9e/dGQ3CwOJANiMOBeDsQnwHin0D8AYg3AnEREEuQaiAjqCahUhTbA/F8IFbEo+YLEHdA8V96hiAo1PYScBwI8ABxC9QjzPRyoA0QLyLWQiiIBeJSejiQDRoabGTobQRiOWo6MBOa+EEJ/xsQzwTifCBWocBzydTKJCDHpNGgFLkGxNqUhqAHjRwHAlrQjEORA6NoXBZLU+pARRo7UJRcB+oC8VIgNqCxA3uhGZCTWAeCFM4B4kvQ6OWhsQPNgHga1D5jQg4EZf1dxGR/GgBQcXUAPcaYsBSeNgPYeAHF1jrkWokJTTJnELSwQJnSD5sDPeiQ3ogFWB2oyDB4gNxgb1H/xebAO4PIgZuwOXAftMU70ADkhjXYHPgRiGsGgQPLgPgFrjQ4EYhbB8hhoADyB+LphKo6UCiaQDs29EiXZ4G4CYj1kNMeLXp1I7Pjzjg6wjrqwFEHDnEHAgQYAMpOS0I80HWwAAAAAElFTkSuQmCC"

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAllBMVEX////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////MC6PrAAAAMXRSTlMAAwYJDA8YHictMDM8P0hOUVRXaWxvcnV4e4GEh5mcn6Klsbe6vcPJzNXb3vDz9vn8LIXxTAAAAKxJREFUGBntwWsTgUAABdBbHiHPQt7yTlm5///PmcU0yrb7xYwvzsHf79neLkov23Edep2ET2JqQcO7MRNaKNVO+WaCMnbMd6mDT/4uvS4D5s3wYUmVM4q6VKuiIKRaAwVHqrWR09wIqp38CjKVFTViFy/2kVqihacFDRILUlXQpA9pQKM1pIBGB0gBjfaQ+jQaQqoJGog6HkY08PEyp86lh4y7iFkimjn4+547Fc5wv21cIqsAAAAASUVORK5CYII="

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAA/FBMVEXd3d3////d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d2j+VesAAAAU3RSTlMAAAMGCQwPEhUYGx4hJCcqLTAzNjk8P0JFSEtOUVRXWl1gY2ZpbG9ydXh7foGEh4qNk5aZnJ+ipairrrG0t7q9w8bJzM/S1djb3uHk5+rw8/b5/EPHDFgAAAHFSURBVDjLpdNbc5pQFAXgxeUkOSURklabKF7qXUtME6g2aTEmWlS0IOz//1/6YKyiIk6znhjm4wzsxYZwZCDgyLwHSgV7GHg/GzwBZqa0jN8WD8FCSP/SFeNhOqCNtGKhNNl0FCh7YNUOFmaTojF2oUn74uzAG9oftg27MTC1DQcxMB2FWs+Pga9VeQ1liw5kcrWC0oAOxr98gx1KyFQEIID5SZB0AALyiY6+AxDQTIbPx8I+AAF6MuwAEHCS+DHB+XI89SRorJpphYdYaKy7Vm/HsQV2tPfv9SGo6Gl5dedcz5ysrrl+zRD5zab+vLh8pEezhdeQAEBqL2bePLdx4p0K1LxBRlTavq0CRdfJMaZPplmgfhN5Ry7i1AqJxlmAS5ANn8hry+DR5Sq7RL9U4PIMYnVONPgEpC6Aa4eor64heymfad3wjgGfHbf0QbsPexxQHgNDUX/UtseTGYXD2eKWAYBq02+H7Ivt8WiP7rAl46qS5fj45I6+nUItFVPglut83dhC9sfMVRw3D4B3w4dC5dWriYDY8Pv58rizcSIDIDX9kfnkP6sAUJxPLct1CwAkeadCXjc7b0MD+/JwX5L/p+u/Og/lbeVuUCwAAAAASUVORK5CYII="

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAA+VBMVEX////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////r1CuUAAAAUnRSTlMAAwYJDA8SFRgbHiEkJyotMDM2OTw/QkVIS05RVFdaXWBjZmlsb3J1eHt+gYSHio2Tlpmcn6KlqKuusbS3ur3DxsnMz9LV2Nve4eTn6vDz9vn8zWltGQAAAaVJREFUGBnNwQ9TmmAcB/Av8FSMEmrTpeKf+V9ntILpasMsHSo6HuH3/l/MZHpopHK3u93t88H/RSzaI9/73pRxXGZGa7wj4IhiQJGegIPSPu1o4xBxSrt8BW/VbH9ptui1Lt4waR8HcVnajyGmR/ulEDOk/dJ4Retz2u+lJiEiWXTE9Aob4pCO4pdYMyjBTECIcUqiI1SgRF8RalGiJ4RalGiAkE6JDIROOCXwz/FHgxJ0sdEO6Iigi4h6M6EDpoaGf0rR0xI2zvXMCTZk/ZphS7JoxhclhJQ+zZdeU8SK2FnOvUUeW7cqUPeGGUHpcFsFSq6TZ0yfznJAI4tdsoBTKyCa5ABZhNTlRF5Hgsywq+IS/VCByzMItQXR8AOQugCuHaKBigh7rpxpveCWAR8dt/xOuwv6MqA8+F1F/VZHTGYcjObLG4YV1aafDtkXiNEe3FFbwlU1J+P9ozv+cgq1XEpBtlzns4QI+2Xmq45bACD3gvti9cWrC4DQ5INCZWJgiwEQW3xsPvInFSulxcyyXLcIQJQQJzdMI4s19un+rizhL/wGhEHhxbet838AAAAASUVORK5CYII="

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAyVBMVEXd3d3////d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d2eMexgAAAAQnRSTlMAAAMGCQwPEhUYGx4nKi0wMzk8P0JFS05XWmBjZmlvdXh7foGKjZOWmZyfoqWorre6vcPJzM/S1dvh5Ofq7fP2+fxottQtAAABDElEQVQ4y+3VyVLCQBRG4V8hIOCEA5OIyuAEIkKIYIjAef+HcmFpAqTpWKU7z6oX36arb93WTsL0Eyh7BlhNCOuUEsGDOX7WBrOl1nMABO7T1aEZnvSJ5tV3Y6HTY73XoxiYG7PZvLwB8xPiWpyvwZRLfEF+FV5jqrsCM+9GuCxEYQNz7SicbIHTCCywrUIIa1thJYRt/McxQND7esVhLwAYdX1uQth/yUpNGOxJxRmwqEm5EfOq5AxuQ9hMS1Kjn5Kk/RnLiiRlvLIkpS9Ngztk+nlIWyb8G+of/i28g2NJrhV24EzSG64FVqEjleHBAh0fPA84tV2mOAWgZd+PzkXnvn6YeOOa4O/+Ch+4mGdrE/SQywAAAABJRU5ErkJggg=="

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAeJJREFUeNrsmO9HBEEYx/c6jmM5ljiOjkRcShyx3ItEr+LeHvfqXh0R0R8QveoPiF5Hrpf1NtGLlFI6ndKri1yKFL1sRZm+wyxjzbY7Y253aR8+du2Mma+ZnefHZAghRpJtxEi4/UuBzSQLbIMOWNI1YEbjIamAa5AHr2AKfMQp0AI2mOOwuHYq7hE8gC44BHfSs1CBktTAPlGzW9AG2bDzyQgzQYfosXswq1NgEdwQvfYJ6joElkCfDMe+wOJf8wcdkhw4B9Uh+mJ6mGbAi4ofXBuyONcbbKq4mQJ4BmYEEe0HjIMnmRVsRSSOWhasyK5gH0xEmBfQ1SuHFTgGBjEkL2XvNvtt8UJM2ZUd9h+ssCcN+jug5+Me9sBBwKRnrJ8ocbgCu2weQ/hL+ThIGmuPgcV9W+cc7BEY5dps8CZwwi1PNLrkokjTE0bpmFthIwkVkxd8X2Xic4K2SU7kN2gI+hRYwiAKcXS+ZdlIImunoOZ3IpnRfNFJck3iyHROq7pUYCowFZgKlLdtGsIZVUGUiF2g4ykLeCuy53ucArvcO39JVAcl9t6L8/LIZOWAu1rufcs012cenGhRqHA34+Z/A59ifENxTKXCPWglGyz7NtnWXyjdYEV0P5j6wUTarwADAOrYAgjg5WgMAAAAAElFTkSuQmCC"

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAwFBMVEXd3d3////d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3mkf1jAAAAP3RSTlMAAAMGDA8SGBseISQnKi0wMzY5PD9FS1FUV1pgY2lsdXh7gYSHjZCWmZyfoqWosbS9w8zP1djb3uHk5+3z+fwNpxRzAAABb0lEQVQ4y8VUf1OCQBC9CM0fKVSKRZaZllYUiWWRyPv+36rduwMlQZn+cYcZdufe3u7bvV1xVFLEQYGijGSApn2aObTsAuAYq6YQb8GlGAUjIRzAzQd+Ab5wgbAVI7aOF8BrPpAwcELAY4x/BxkgDyhmdEZfnaOyNs7NsW7bfbDwsc9K1LHt6hbQDKEkNMlqrrTlbwE7+gQv0pxrK6pshX4KSD6BuK15sR0M/t44mJ7xT/JVeXiqEtNeBngBzA1WmK8j0tLUIiyrm0ArBm6kK/FdNKKkNM/AspIJPYV2bZPLj+a+4Z8CKQYepDaRbN2kAyojBWTQTiGwBN5jn3RL3vhhrHOsEngitcfiHDUFxZq7nLI+J5e+KK5ji8BDaXmJS25nrmgoENV01aKTol7Psr12C1+Ptfl6bv//Hku/8PXMDHfPzHoKiW931xQqBj3ma1CG78VzbXxzSteUZWPPppjwFUaJ3VN6m+3bj4fa4b/TOnReeiINQwAAAABJRU5ErkJggg=="

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAvVBMVEX////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////jSrqQAAAAPnRSTlMAAwYMDxIYGx4hJCcqLTAzNjk8P0VLUVRXWmBjaWx1eHuBhIeNkJaZnJ+ipaixtL3DzM/V2Nve4eTn7fP5/NIynQkAAAFcSURBVDjL3ZTLVsJAEEQLEIGIRMWoiA8UBRWNDIpGZ3L//7NcJBEiBDiuPNauT1fPdPVL+qeo+Ds5u+UXEPs4T3oyx7o211IAneXENwjVgagZE7fKU3hcTuwAQQSj8hTCS3Bewd9jcODqCgAH/aWsuu93gcQdAti271cXJUckiCqSPJda4QKxnXp4kCRNUstuLTDvjDHmFeLdVJcxxpiLn7SL4Z4klacQJnmMkkoMj3K8A5iUJCkAAn2Xpmb5zOlpxXAmJXqnDZuV5h4+81kOSUN3Y/hItc/Ff6Nm4UaSNACyLo+zjGaklcjIV6zD4YYvvsx9X7UwkCTdFueYSkhUe25O9T7QVXEdmw56kqRRFrK0Myfqg62l6dvtol6P873uFE5Pa356zn8/jxtP+Gxneqt3ZraFtqbDVVuYKDiKYFSawHPxXpfeIdQpRI01l2KA81Ta4PZsfM3+Kr4Ac29wkK7oxUEAAAAASUVORK5CYII="

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAtFBMVEXd3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d39lcWZAAAAO3RSTlMAAwYJDA8SFRskKjAzNjk8QkVIS05RVFdaXWBjZmlvdXt+jZOWmZyfoqWrsbS9wMPGyc/S1djh7fDz/Aki3ZIAAAFsSURBVBgZvcFpc9JQAIbR9ybcptKULSl7qxZkqVoSAgR4/v//shk6SpaOGT94jv6Puerp0FctGxKjGjpAXzX8BHZGH+iFji46ZAa6MEGonDbHVeAoz/QWKYHyDsDxi974w+nIN5KeUiB1lPcMJJ6ay5TMcX0nGwNLFbQg8ZzZmd8WDRtDoKJD4nkx15JbG6dGRRPPichLXPuoCjOKVqry6UyJrworyr6raOialLKzddu6Mtxj76jSsby29W64B2xIlbEFXlt6YxZk7JQqny2ZuTK9CLADqkwtsB/rXTfC3lOla9mPdKXjmpSy8407VNGKsh+q0DxTcq8qM4pWqjDx3Ji8xNpHlRy2nhdzLbm1UWpU0ILtjfuNP9aNRgSBCp6B7Y2a6yOZ04uvRgQsVXAATl8lGX88nfiOpKcjkDrKaXN6eXCV54TrI4Fyeg+uLrpkRrpwwlAf2QA7o7/rAgPVsWFnVEeXvuqZG/27Xwfren0OOZl0AAAAAElFTkSuQmCC"

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAtFBMVEX///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8YFGe8AAAAO3RSTlMAAwYJDA8SFRskKjAzNjk8QkVIS05RVFdaXWBjZmlvdXt+jZOWmZyfoqWrsbS9wMPGyc/S1djh7fDz/Aki3ZIAAAFsSURBVBgZvcFpc9JQAIbR9ybcptKULSl7qxZkqVoSAgR4/v//shk6SpaOGT94jv6Puerp0FctGxKjGjpAXzX8BHZGH+iFji46ZAa6MEGonDbHVeAoz/QWKYHyDsDxi974w+nIN5KeUiB1lPcMJJ6ay5TMcX0nGwNLFbQg8ZzZmd8WDRtDoKJD4nkx15JbG6dGRRPPichLXPuoCjOKVqry6UyJrworyr6raOialLKzddu6Mtxj76jSsby29W64B2xIlbEFXlt6YxZk7JQqny2ZuTK9CLADqkwtsB/rXTfC3lOla9mPdKXjmpSy8407VNGKsh+q0DxTcq8qM4pWqjDx3Ji8xNpHlRy2nhdzLbm1UWpU0ILtjfuNP9aNRgSBCp6B7Y2a6yOZ04uvRgQsVXAATl8lGX88nfiOpKcjkDrKaXN6eXCV54TrI4Fyeg+uLrpkRrpwwlAf2QA7o7/rAgPVsWFnVEeXvuqZG/27Xwfren0OOZl0AAAAAElFTkSuQmCC"

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAATCAMAAABSrFY3AAAAQlBMVEWZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZlTX8olAAAAFXRSTlMAAQYJDBgbZ2hsq6yxsrPV1tjZ6v4ZKx1zAAAAXUlEQVQY03XORw6AMAxEUWNq6CW+/1WJHBShif13o7cZIqOGnHgODiwSgwNikoLI1TpwD/gFYNzYhinKzg5IJgA+dCYCIOrPTB1CoaeCQjX8CKFQDR9ZoGRDohXgBb1QCx2zqfhiAAAAAElFTkSuQmCC"

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAZCAMAAAA2Re/AAAAAw1BMVEXmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAACA8E0OAAAAQHRSTlMAAQIDBAYHDQ8VGBkdICguMDE0NjlBQlBZXmVqbHR3en2Bh4iKjpicqLS2uLq+x8rV2tvd4OPn7O719vj6+/z+baG9rgAAAJlJREFUGBlFwYs2AlEAQNGDCqFIpSJJVJLHIOPt/P9XuWM19+5NbunzbQAPRkNgbmlIcOnahMLAtaddgq6lG4IDox5Q+VK/LbxUgWcdHT1a6AFLx7C9MLgFplcE1Tv1owYN/tVztUF0rnaI6uoxSa57JJkZSeXdEUnX1x2S2e8JSfvngmR/NSFpZqdEm2f3LaLD6/4W0UaN6A8cISJ/qrrt9gAAAABJRU5ErkJggg=="

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAZCAMAAAA2Re/AAAAA0lBMVEXmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAAAbD8EFAAAARXRSTlMAAQIEBgcNDxUYGRodICcuMDE0NTlBQkNRWFleZGVqbHR4eXuAgYeJi46YnKi0tri6vcfK1dna3d7g4+fs7vX2+Pr7/P44bWZBAAAAnUlEQVQYGVXBiTZCUQBA0aPBUMkYhZQxRcZkaiDO//+S+1q959objsafpkZA28wTQdvUDYmOC5cEq68uNAn6pvaBAzPrUHgzMVO/8tAwMdg60xfgzuB2GS68h+JUfSgQXPWgqo7WmKtCTT0hs6OWyZR0TOTZIZFTJ3n+rHy4R6T+c03s/HuXWOe9Qux4uEFs+7GVI5I77G7yT3EJfgHquyUxE1X1CwAAAABJRU5ErkJggg=="

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAMAAADX9CSSAAABVlBMVEUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgUhVgW6w17IAAAAcXRSTlMAAQMGCg8QERIWFxgZGhscHh8gISQlJicqLC0uMzU3Pj9ERUZMUFNUV1hdamxtbm9ydXl7fH1+gYaHiYyNkJKVmJmam5ydn6Chpaaoq6ytr7C2t7i5u8HCw8TFxsrLzM3V1tvd3+Ts7e7v8/T29/n7/O2tqM0AAAEmSURBVCjPhZJXTwIBEIQHzsopqFgQe+8d7IqKIth7x4agYjm////iA0cJiXGeNpPJZnZmpSzM1q4OU0VwL7wA8DxXWcA6A59kkZ50ZOmSU/iODvg9LUO7FuwZGdpxCOf1tsZ3A9uZcRrCTjWt3ifulutk7MKIJJlpTpyOGQuA73EZ16RKJS3x6VYQ3jdnI2kYVaNFQFKSLfksLiokmXG+arXPo+SFXq3xWi5JqvpgUcNQoR6o0RMh20+MW7VAu/qgVG9M2fw8z6qBzj/1XujVOqni/UqyKd9Pxo8r7yfvPxyIpGFMDRZBSeYHx/l7J2Rckiqz89lwqin0kIiveGXs2PnIcQRnuTyvIFqYf6S/udo/GLPgwPinL0meXL+u4urNtu6Cf/gFlHNh4zHyIIYAAAAASUVORK5CYII="

/***/ }),
/* 383 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAMAAADX9CSSAAABYlBMVEXmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADmAADyPhKrAAAAdXRSTlMAAQMGCg8QERIWFxgZGhscHh8gISMkJSYnKSosLS4zNTc+P0RFRkxQU1RXWF1qbG1ub3J1eXt8fX6BhoeJi4yNkJKVmJmam5ydn6Chpaaoq6ytr7C2t7i5u8DBwsPExcbKy8zN1dbb3d/k7O3u7/P09vf5+/wYsh/yAAABJ0lEQVQoz4WSV08CARCEB04UOTtWFLvYu2LvBSv23rsinuX8/r8PHiUkxnnaTCab2ZmVEjBrmxpMZaBg4hmAx7HcNNYd/iABa8CVoLMO4Wu9vaYw2Bm1Ycv4pV27cFzmaAKXsPY7DsGyW5Vzt0/XMyUyotAtSabFgds1bAPw1SfjgphH0jQfBRqBt8joqgU9qrAJS3phRQGbU68k84bPYm1zL/khpAVecyRJee9Mqgu8aoEiPTDv+NngSkGoVyt4FGfQ4cd5VBE0/qn3Q0iLxDL364WIAt+ceCX5Un6S/uOL4YgFvSq3GZFkvrOfurdfxhmxbCefJbeqZu+ebqZKZWw6+ci1B0fJPM9hPT3/1bbq/JqODRt2jH/6klSY7NeXWb1Z15z2Dz+KqGWMnp4rBQAAAABJRU5ErkJggg=="

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(385);

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var angular = __webpack_require__(28);
	
	/**
	 * angular-ui-utils - Swiss-Army-Knife of AngularJS tools (with no external dependencies!)
	 * @version v0.2.3 - 2015-03-30
	 * @link http://angular-ui.github.com
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	angular.module('ui.alias', []).config(['$compileProvider', 'uiAliasConfig', function($compileProvider, uiAliasConfig){
	  'use strict';
	
	  uiAliasConfig = uiAliasConfig || {};
	  angular.forEach(uiAliasConfig, function(config, alias){
	    if (angular.isString(config)) {
	      config = {
	        replace: true,
	        template: config
	      };
	    }
	    $compileProvider.directive(alias, function(){
	      return config;
	    });
	  });
	}]);
	
	/**
	 * General-purpose Event binding. Bind any event not natively supported by Angular
	 * Pass an object with keynames for events to ui-event
	 * Allows $event object and $params object to be passed
	 *
	 * @example <input ui-event="{ focus : 'counter++', blur : 'someCallback()' }">
	 * @example <input ui-event="{ myCustomEvent : 'myEventHandler($event, $params)'}">
	 *
	 * @param ui-event {string|object literal} The event to bind to as a string or a hash of events with their callbacks
	 */
	angular.module('ui.event',[]).directive('uiEvent', ['$parse',
	  function ($parse) {
	    'use strict';
	
	    return function ($scope, elm, attrs) {
	      var events = $scope.$eval(attrs.uiEvent);
	      angular.forEach(events, function (uiEvent, eventName) {
	        var fn = $parse(uiEvent);
	        elm.bind(eventName, function (evt) {
	          var params = Array.prototype.slice.call(arguments);
	          //Take out first paramater (event object);
	          params = params.splice(1);
	          fn($scope, {$event: evt, $params: params});
	          if (!$scope.$$phase) {
	            $scope.$apply();
	          }
	        });
	      });
	    };
	  }]);
	
	/**
	 * A replacement utility for internationalization very similar to sprintf.
	 *
	 * @param replace {mixed} The tokens to replace depends on type
	 *  string: all instances of $0 will be replaced
	 *  array: each instance of $0, $1, $2 etc. will be placed with each array item in corresponding order
	 *  object: all attributes will be iterated through, with :key being replaced with its corresponding value
	 * @return string
	 *
	 * @example: 'Hello :name, how are you :day'.format({ name:'John', day:'Today' })
	 * @example: 'Records $0 to $1 out of $2 total'.format(['10', '20', '3000'])
	 * @example: '$0 agrees to all mentions $0 makes in the event that $0 hits a tree while $0 is driving drunk'.format('Bob')
	 */
	angular.module('ui.format',[]).filter('format', function(){
	  'use strict';
	
	  return function(value, replace) {
	    var target = value;
	    if (angular.isString(target) && replace !== undefined) {
	      if (!angular.isArray(replace) && !angular.isObject(replace)) {
	        replace = [replace];
	      }
	      if (angular.isArray(replace)) {
	        var rlen = replace.length;
	        var rfx = function (str, i) {
	          i = parseInt(i, 10);
	          return (i >= 0 && i < rlen) ? replace[i] : str;
	        };
	        target = target.replace(/\$([0-9]+)/g, rfx);
	      }
	      else {
	        angular.forEach(replace, function(value, key){
	          target = target.split(':' + key).join(value);
	        });
	      }
	    }
	    return target;
	  };
	});
	
	/**
	 * Wraps the
	 * @param text {string} haystack to search through
	 * @param search {string} needle to search for
	 * @param [caseSensitive] {boolean} optional boolean to use case-sensitive searching
	 */
	angular.module('ui.highlight',[]).filter('highlight', function () {
	  'use strict';
	
	  return function (text, search, caseSensitive) {
	    if (text && (search || angular.isNumber(search))) {
	      text = text.toString();
	      search = search.toString();
	      if (caseSensitive) {
	        return text.split(search).join('<span class="ui-match">' + search + '</span>');
	      } else {
	        return text.replace(new RegExp(search, 'gi'), '<span class="ui-match">$&</span>');
	      }
	    } else {
	      return text;
	    }
	  };
	});
	
	// modeled after: angular-1.0.7/src/ng/directive/ngInclude.js
	angular.module('ui.include',[])
	.directive('uiInclude', ['$http', '$templateCache', '$anchorScroll', '$compile',
	                 function($http,   $templateCache,   $anchorScroll,   $compile) {
	  'use strict';
	
	  return {
	    restrict: 'ECA',
	    terminal: true,
	    compile: function(element, attr) {
	      var srcExp = attr.uiInclude || attr.src,
	          fragExp = attr.fragment || '',
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, element) {
	        var changeCounter = 0,
	            childScope;
	
	        var clearContent = function() {
	          if (childScope) {
	            childScope.$destroy();
	            childScope = null;
	          }
	
	          element.html('');
	        };
	
	        function ngIncludeWatchAction() {
	          var thisChangeId = ++changeCounter;
	          var src = scope.$eval(srcExp);
	          var fragment = scope.$eval(fragExp);
	
	          if (src) {
	            $http.get(src, {cache: $templateCache}).success(function(response) {
	              if (thisChangeId !== changeCounter) { return; }
	
	              if (childScope) { childScope.$destroy(); }
	              childScope = scope.$new();
	
	              var contents;
	              if (fragment) {
	                contents = angular.element('<div/>').html(response).find(fragment);
	              }
	              else {
	                contents = angular.element('<div/>').html(response).contents();
	              }
	              element.html(contents);
	              $compile(contents)(childScope);
	
	              if (angular.isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	              }
	
	              childScope.$emit('$includeContentLoaded');
	              scope.$eval(onloadExp);
	            }).error(function() {
	              if (thisChangeId === changeCounter) { clearContent(); }
	            });
	          } else { clearContent(); }
	        }
	
	        scope.$watch(fragExp, ngIncludeWatchAction);
	        scope.$watch(srcExp, ngIncludeWatchAction);
	      };
	    }
	  };
	}]);
	
	/**
	 * Provides an easy way to toggle a checkboxes indeterminate property
	 *
	 * @example <input type="checkbox" ui-indeterminate="isUnkown">
	 */
	angular.module('ui.indeterminate',[]).directive('uiIndeterminate', [
	  function () {
	    'use strict';
	
	    return {
	      compile: function(tElm, tAttrs) {
	        if (!tAttrs.type || tAttrs.type.toLowerCase() !== 'checkbox') {
	          return angular.noop;
	        }
	
	        return function ($scope, elm, attrs) {
	          $scope.$watch(attrs.uiIndeterminate, function(newVal) {
	            elm[0].indeterminate = !!newVal;
	          });
	        };
	      }
	    };
	  }]);
	
	/**
	 * Converts variable-esque naming conventions to something presentational, capitalized words separated by space.
	 * @param {String} value The value to be parsed and prettified.
	 * @param {String} [inflector] The inflector to use. Default: humanize.
	 * @return {String}
	 * @example {{ 'Here Is my_phoneNumber' | inflector:'humanize' }} => Here Is My Phone Number
	 *          {{ 'Here Is my_phoneNumber' | inflector:'underscore' }} => here_is_my_phone_number
	 *          {{ 'Here Is my_phoneNumber' | inflector:'variable' }} => hereIsMyPhoneNumber
	 */
	angular.module('ui.inflector',[]).filter('inflector', function () {
	  'use strict';
	
	  function tokenize(text) {
	    text = text.replace(/([A-Z])|([\-|\_])/g, function(_, $1) { return ' ' + ($1 || ''); });
	    return text.replace(/\s\s+/g, ' ').trim().toLowerCase().split(' ');
	  }
	
	  function capitalizeTokens(tokens) {
	    var result = [];
	    angular.forEach(tokens, function(token) {
	      result.push(token.charAt(0).toUpperCase() + token.substr(1));
	    });
	    return result;
	  }
	
	  var inflectors = {
	    humanize: function (value) {
	      return capitalizeTokens(tokenize(value)).join(' ');
	    },
	    underscore: function (value) {
	      return tokenize(value).join('_');
	    },
	    variable: function (value) {
	      value = tokenize(value);
	      value = value[0] + capitalizeTokens(value.slice(1)).join('');
	      return value;
	    }
	  };
	
	  return function (text, inflector) {
	    if (inflector !== false && angular.isString(text)) {
	      inflector = inflector || 'humanize';
	      return inflectors[inflector](text);
	    } else {
	      return text;
	    }
	  };
	});
	
	/**
	 * General-purpose jQuery wrapper. Simply pass the plugin name as the expression.
	 *
	 * It is possible to specify a default set of parameters for each jQuery plugin.
	 * Under the jq key, namespace each plugin by that which will be passed to ui-jq.
	 * Unfortunately, at this time you can only pre-define the first parameter.
	 * @example { jq : { datepicker : { showOn:'click' } } }
	 *
	 * @param ui-jq {string} The $elm.[pluginName]() to call.
	 * @param [ui-options] {mixed} Expression to be evaluated and passed as options to the function
	 *     Multiple parameters can be separated by commas
	 * @param [ui-refresh] {expression} Watch expression and refire plugin on changes
	 *
	 * @example <input ui-jq="datepicker" ui-options="{showOn:'click'},secondParameter,thirdParameter" ui-refresh="iChange">
	 */
	angular.module('ui.jq',[]).
	  value('uiJqConfig',{}).
	  directive('uiJq', ['uiJqConfig', '$timeout', function uiJqInjectingFunction(uiJqConfig, $timeout) {
	  'use strict';
	
	
	  return {
	    restrict: 'A',
	    compile: function uiJqCompilingFunction(tElm, tAttrs) {
	
	      if (!angular.isFunction(tElm[tAttrs.uiJq])) {
	        throw new Error('ui-jq: The "' + tAttrs.uiJq + '" function does not exist');
	      }
	      var options = uiJqConfig && uiJqConfig[tAttrs.uiJq];
	
	      return function uiJqLinkingFunction(scope, elm, attrs) {
	
	        // If change compatibility is enabled, the form input's "change" event will trigger an "input" event
	        if (attrs.ngModel && elm.is('select,input,textarea')) {
	          elm.bind('change', function() {
	            elm.trigger('input');
	          });
	        }
	
	        function createLinkOptions(){
	          var linkOptions = [];
	
	          // If ui-options are passed, merge (or override) them onto global defaults and pass to the jQuery method
	          if (attrs.uiOptions) {
	            linkOptions = scope.$eval('[' + attrs.uiOptions + ']');
	            if (angular.isObject(options) && angular.isObject(linkOptions[0])) {
	              linkOptions[0] = angular.extend({}, options, linkOptions[0]);
	            }
	          } else if (options) {
	            linkOptions = [options];
	          }
	          return linkOptions;
	        }
	
	        // Call jQuery method and pass relevant options
	        function callPlugin() {
	          $timeout(function() {
	            elm[attrs.uiJq].apply(elm, createLinkOptions());
	          }, 0, false);
	        }
	
	        // If ui-refresh is used, re-fire the the method upon every change
	        if (attrs.uiRefresh) {
	          scope.$watch(attrs.uiRefresh, function() {
	            callPlugin();
	          });
	        }
	        callPlugin();
	      };
	    }
	  };
	}]);
	
	angular.module('ui.keypress',[]).
	factory('keypressHelper', ['$parse', function keypress($parse){
	  'use strict';
	
	  var keysByCode = {
	    8: 'backspace',
	    9: 'tab',
	    13: 'enter',
	    27: 'esc',
	    32: 'space',
	    33: 'pageup',
	    34: 'pagedown',
	    35: 'end',
	    36: 'home',
	    37: 'left',
	    38: 'up',
	    39: 'right',
	    40: 'down',
	    45: 'insert',
	    46: 'delete'
	  };
	
	  var capitaliseFirstLetter = function (string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  };
	
	  return function(mode, scope, elm, attrs) {
	    var params, combinations = [];
	    params = scope.$eval(attrs['ui'+capitaliseFirstLetter(mode)]);
	
	    // Prepare combinations for simple checking
	    angular.forEach(params, function (v, k) {
	      var combination, expression;
	      expression = $parse(v);
	
	      angular.forEach(k.split(' '), function(variation) {
	        combination = {
	          expression: expression,
	          keys: {}
	        };
	        angular.forEach(variation.split('-'), function (value) {
	          combination.keys[value] = true;
	        });
	        combinations.push(combination);
	      });
	    });
	
	    // Check only matching of pressed keys one of the conditions
	    elm.bind(mode, function (event) {
	      // No need to do that inside the cycle
	      var metaPressed = !!(event.metaKey && !event.ctrlKey);
	      var altPressed = !!event.altKey;
	      var ctrlPressed = !!event.ctrlKey;
	      var shiftPressed = !!event.shiftKey;
	      var keyCode = event.keyCode;
	
	      // normalize keycodes
	      if (mode === 'keypress' && !shiftPressed && keyCode >= 97 && keyCode <= 122) {
	        keyCode = keyCode - 32;
	      }
	
	      // Iterate over prepared combinations
	      angular.forEach(combinations, function (combination) {
	
	        var mainKeyPressed = combination.keys[keysByCode[keyCode]] || combination.keys[keyCode.toString()];
	
	        var metaRequired = !!combination.keys.meta;
	        var altRequired = !!combination.keys.alt;
	        var ctrlRequired = !!combination.keys.ctrl;
	        var shiftRequired = !!combination.keys.shift;
	
	        if (
	          mainKeyPressed &&
	          ( metaRequired === metaPressed ) &&
	          ( altRequired === altPressed ) &&
	          ( ctrlRequired === ctrlPressed ) &&
	          ( shiftRequired === shiftPressed )
	        ) {
	          // Run the function
	          scope.$apply(function () {
	            combination.expression(scope, { '$event': event });
	          });
	        }
	      });
	    });
	  };
	}]);
	
	/**
	 * Bind one or more handlers to particular keys or their combination
	 * @param hash {mixed} keyBindings Can be an object or string where keybinding expression of keys or keys combinations and AngularJS Exspressions are set. Object syntax: "{ keys1: expression1 [, keys2: expression2 [ , ... ]]}". String syntax: ""expression1 on keys1 [ and expression2 on keys2 [ and ... ]]"". Expression is an AngularJS Expression, and key(s) are dash-separated combinations of keys and modifiers (one or many, if any. Order does not matter). Supported modifiers are 'ctrl', 'shift', 'alt' and key can be used either via its keyCode (13 for Return) or name. Named keys are 'backspace', 'tab', 'enter', 'esc', 'space', 'pageup', 'pagedown', 'end', 'home', 'left', 'up', 'right', 'down', 'insert', 'delete'.
	 * @example <input ui-keypress="{enter:'x = 1', 'ctrl-shift-space':'foo()', 'shift-13':'bar()'}" /> <input ui-keypress="foo = 2 on ctrl-13 and bar('hello') on shift-esc" />
	 **/
	angular.module('ui.keypress').directive('uiKeydown', ['keypressHelper', function(keypressHelper){
	  'use strict';
	
	  return {
	    link: function (scope, elm, attrs) {
	      keypressHelper('keydown', scope, elm, attrs);
	    }
	  };
	}]);
	
	angular.module('ui.keypress').directive('uiKeypress', ['keypressHelper', function(keypressHelper){
	  'use strict';
	
	  return {
	    link: function (scope, elm, attrs) {
	      keypressHelper('keypress', scope, elm, attrs);
	    }
	  };
	}]);
	
	angular.module('ui.keypress').directive('uiKeyup', ['keypressHelper', function(keypressHelper){
	  'use strict';
	
	  return {
	    link: function (scope, elm, attrs) {
	      keypressHelper('keyup', scope, elm, attrs);
	    }
	  };
	}]);
	
	/*
	 Attaches input mask onto input element
	 */
	angular.module('ui.mask', [])
	  .value('uiMaskConfig', {
	    'maskDefinitions': {
	      '9': /\d/,
	      'A': /[a-zA-Z]/,
	      '*': /[a-zA-Z0-9]/
	    },
	    'clearOnBlur': true
	  })
	  .directive('uiMask', ['uiMaskConfig', '$parse', function (maskConfig, $parse) {
	    'use strict';
	
	    return {
	      priority: 100,
	      require: 'ngModel',
	      restrict: 'A',
	      compile: function uiMaskCompilingFunction(){
	        var options = maskConfig;
	
	        return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller){
	          var maskProcessed = false, eventsBound = false,
	            maskCaretMap, maskPatterns, maskPlaceholder, maskComponents,
	          // Minimum required length of the value to be considered valid
	            minRequiredLength,
	            value, valueMasked, isValid,
	          // Vars for initializing/uninitializing
	            originalPlaceholder = iAttrs.placeholder,
	            originalMaxlength = iAttrs.maxlength,
	          // Vars used exclusively in eventHandler()
	            oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength;
	
	          function initialize(maskAttr){
	            if (!angular.isDefined(maskAttr)) {
	              return uninitialize();
	            }
	            processRawMask(maskAttr);
	            if (!maskProcessed) {
	              return uninitialize();
	            }
	            initializeElement();
	            bindEventListeners();
	            return true;
	          }
	
	          function initPlaceholder(placeholderAttr) {
	            if(! angular.isDefined(placeholderAttr)) {
	              return;
	            }
	
	            maskPlaceholder = placeholderAttr;
	
	            // If the mask is processed, then we need to update the value
	            if (maskProcessed) {
	              eventHandler();
	            }
	          }
	
	          function formatter(fromModelValue){
	            if (!maskProcessed) {
	              return fromModelValue;
	            }
	            value = unmaskValue(fromModelValue || '');
	            isValid = validateValue(value);
	            controller.$setValidity('mask', isValid);
	            return isValid && value.length ? maskValue(value) : undefined;
	          }
	
	          function parser(fromViewValue){
	            if (!maskProcessed) {
	              return fromViewValue;
	            }
	            value = unmaskValue(fromViewValue || '');
	            isValid = validateValue(value);
	            // We have to set viewValue manually as the reformatting of the input
	            // value performed by eventHandler() doesn't happen until after
	            // this parser is called, which causes what the user sees in the input
	            // to be out-of-sync with what the controller's $viewValue is set to.
	            controller.$viewValue = value.length ? maskValue(value) : '';
	            controller.$setValidity('mask', isValid);
	            if (value === '' && iAttrs.required) {
	                controller.$setValidity('required', !controller.$error.required);
	            }
	            return isValid ? value : undefined;
	          }
	
	          var linkOptions = {};
	
	          if (iAttrs.uiOptions) {
	            linkOptions = scope.$eval('[' + iAttrs.uiOptions + ']');
	            if (angular.isObject(linkOptions[0])) {
	              // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge
	              linkOptions = (function(original, current){
	                for(var i in original) {
	                  if (Object.prototype.hasOwnProperty.call(original, i)) {
	                    if (current[i] === undefined) {
	                      current[i] = angular.copy(original[i]);
	                    } else {
	                      angular.extend(current[i], original[i]);
	                    }
	                  }
	                }
	                return current;
	              })(options, linkOptions[0]);
	            }
	          } else {
	            linkOptions = options;
	          }
	
	          iAttrs.$observe('uiMask', initialize);
	          iAttrs.$observe('placeholder', initPlaceholder);
	          var modelViewValue = false;
	          iAttrs.$observe('modelViewValue', function(val) {
	            if(val === 'true') {
	              modelViewValue = true;
	            }
	          });
	          scope.$watch(iAttrs.ngModel, function(val) {
	            if(modelViewValue && val) {
	              var model = $parse(iAttrs.ngModel);
	              model.assign(scope, controller.$viewValue);
	            }
	          });
	          controller.$formatters.push(formatter);
	          controller.$parsers.push(parser);
	
	          function uninitialize(){
	            maskProcessed = false;
	            unbindEventListeners();
	
	            if (angular.isDefined(originalPlaceholder)) {
	              iElement.attr('placeholder', originalPlaceholder);
	            } else {
	              iElement.removeAttr('placeholder');
	            }
	
	            if (angular.isDefined(originalMaxlength)) {
	              iElement.attr('maxlength', originalMaxlength);
	            } else {
	              iElement.removeAttr('maxlength');
	            }
	
	            iElement.val(controller.$modelValue);
	            controller.$viewValue = controller.$modelValue;
	            return false;
	          }
	
	          function initializeElement(){
	            value = oldValueUnmasked = unmaskValue(controller.$viewValue || '');
	            valueMasked = oldValue = maskValue(value);
	            isValid = validateValue(value);
	            var viewValue = isValid && value.length ? valueMasked : '';
	            if (iAttrs.maxlength) { // Double maxlength to allow pasting new val at end of mask
	              iElement.attr('maxlength', maskCaretMap[maskCaretMap.length - 1] * 2);
	            }
	            iElement.attr('placeholder', maskPlaceholder);
	            iElement.val(viewValue);
	            controller.$viewValue = viewValue;
	            // Not using $setViewValue so we don't clobber the model value and dirty the form
	            // without any kind of user interaction.
	          }
	
	          function bindEventListeners(){
	            if (eventsBound) {
	              return;
	            }
	            iElement.bind('blur', blurHandler);
	            iElement.bind('mousedown mouseup', mouseDownUpHandler);
	            iElement.bind('input keyup click focus', eventHandler);
	            eventsBound = true;
	          }
	
	          function unbindEventListeners(){
	            if (!eventsBound) {
	              return;
	            }
	            iElement.unbind('blur', blurHandler);
	            iElement.unbind('mousedown', mouseDownUpHandler);
	            iElement.unbind('mouseup', mouseDownUpHandler);
	            iElement.unbind('input', eventHandler);
	            iElement.unbind('keyup', eventHandler);
	            iElement.unbind('click', eventHandler);
	            iElement.unbind('focus', eventHandler);
	            eventsBound = false;
	          }
	
	          function validateValue(value){
	            // Zero-length value validity is ngRequired's determination
	            return value.length ? value.length >= minRequiredLength : true;
	          }
	
	          function unmaskValue(value){
	            var valueUnmasked = '',
	              maskPatternsCopy = maskPatterns.slice();
	            // Preprocess by stripping mask components from value
	            value = value.toString();
	            angular.forEach(maskComponents, function (component){
	              value = value.replace(component, '');
	            });
	            angular.forEach(value.split(''), function (chr){
	              if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
	                valueUnmasked += chr;
	                maskPatternsCopy.shift();
	              }
	            });
	            return valueUnmasked;
	          }
	
	          function maskValue(unmaskedValue){
	            var valueMasked = '',
	                maskCaretMapCopy = maskCaretMap.slice();
	
	            angular.forEach(maskPlaceholder.split(''), function (chr, i){
	              if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
	                valueMasked  += unmaskedValue.charAt(0) || '_';
	                unmaskedValue = unmaskedValue.substr(1);
	                maskCaretMapCopy.shift();
	              }
	              else {
	                valueMasked += chr;
	              }
	            });
	            return valueMasked;
	          }
	
	          function getPlaceholderChar(i) {
	            var placeholder = iAttrs.placeholder;
	
	            if (typeof placeholder !== 'undefined' && placeholder[i]) {
	              return placeholder[i];
	            } else {
	              return '_';
	            }
	          }
	
	          // Generate array of mask components that will be stripped from a masked value
	          // before processing to prevent mask components from being added to the unmasked value.
	          // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
	          // If a maskable char is followed by a mask char and has a mask
	          // char behind it, we'll split it into it's own component so if
	          // a user is aggressively deleting in the input and a char ahead
	          // of the maskable char gets deleted, we'll still be able to strip
	          // it in the unmaskValue() preprocessing.
	          function getMaskComponents() {
	            return maskPlaceholder.replace(/[_]+/g, '_').replace(/([^_]+)([a-zA-Z0-9])([^_])/g, '$1$2_$3').split('_');
	          }
	
	          function processRawMask(mask){
	            var characterCount = 0;
	
	            maskCaretMap    = [];
	            maskPatterns    = [];
	            maskPlaceholder = '';
	
	            if (typeof mask === 'string') {
	              minRequiredLength = 0;
	
	              var isOptional = false,
	                  numberOfOptionalCharacters = 0,
	                  splitMask  = mask.split('');
	
	              angular.forEach(splitMask, function (chr, i){
	                if (linkOptions.maskDefinitions[chr]) {
	
	                  maskCaretMap.push(characterCount);
	
	                  maskPlaceholder += getPlaceholderChar(i - numberOfOptionalCharacters);
	                  maskPatterns.push(linkOptions.maskDefinitions[chr]);
	
	                  characterCount++;
	                  if (!isOptional) {
	                    minRequiredLength++;
	                  }
	                }
	                else if (chr === '?') {
	                  isOptional = true;
	                  numberOfOptionalCharacters++;
	                }
	                else {
	                  maskPlaceholder += chr;
	                  characterCount++;
	                }
	              });
	            }
	            // Caret position immediately following last position is valid.
	            maskCaretMap.push(maskCaretMap.slice().pop() + 1);
	
	            maskComponents = getMaskComponents();
	            maskProcessed  = maskCaretMap.length > 1 ? true : false;
	          }
	
	          function blurHandler(){
	            if (linkOptions.clearOnBlur) {
	              oldCaretPosition = 0;
	              oldSelectionLength = 0;
	              if (!isValid || value.length === 0) {
	                valueMasked = '';
	                iElement.val('');
	                scope.$apply(function () {
	                  controller.$setViewValue('');
	                });
	              }
	            }
	          }
	
	          function mouseDownUpHandler(e){
	            if (e.type === 'mousedown') {
	              iElement.bind('mouseout', mouseoutHandler);
	            } else {
	              iElement.unbind('mouseout', mouseoutHandler);
	            }
	          }
	
	          iElement.bind('mousedown mouseup', mouseDownUpHandler);
	
	          function mouseoutHandler(){
	            /*jshint validthis: true */
	            oldSelectionLength = getSelectionLength(this);
	            iElement.unbind('mouseout', mouseoutHandler);
	          }
	
	          function eventHandler(e){
	            /*jshint validthis: true */
	            e = e || {};
	            // Allows more efficient minification
	            var eventWhich = e.which,
	              eventType = e.type;
	
	            // Prevent shift and ctrl from mucking with old values
	            if (eventWhich === 16 || eventWhich === 91) { return;}
	
	            var val = iElement.val(),
	              valOld = oldValue,
	              valMasked,
	              valUnmasked = unmaskValue(val),
	              valUnmaskedOld = oldValueUnmasked,
	              valAltered = false,
	
	              caretPos = getCaretPosition(this) || 0,
	              caretPosOld = oldCaretPosition || 0,
	              caretPosDelta = caretPos - caretPosOld,
	              caretPosMin = maskCaretMap[0],
	              caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(),
	
	              selectionLenOld = oldSelectionLength || 0,
	              isSelected = getSelectionLength(this) > 0,
	              wasSelected = selectionLenOld > 0,
	
	            // Case: Typing a character to overwrite a selection
	              isAddition = (val.length > valOld.length) || (selectionLenOld && val.length > valOld.length - selectionLenOld),
	            // Case: Delete and backspace behave identically on a selection
	              isDeletion = (val.length < valOld.length) || (selectionLenOld && val.length === valOld.length - selectionLenOld),
	              isSelection = (eventWhich >= 37 && eventWhich <= 40) && e.shiftKey, // Arrow key codes
	
	              isKeyLeftArrow = eventWhich === 37,
	            // Necessary due to "input" event not providing a key code
	              isKeyBackspace = eventWhich === 8 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === -1)),
	              isKeyDelete = eventWhich === 46 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === 0 ) && !wasSelected),
	
	            // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
	            // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
	            // non-mask character. Also applied to click since users are (arguably) more likely to backspace
	            // a character when clicking within a filled input.
	              caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === 'click') && caretPos > caretPosMin;
	
	            oldSelectionLength = getSelectionLength(this);
	
	            // These events don't require any action
	            if (isSelection || (isSelected && (eventType === 'click' || eventType === 'keyup'))) {
	              return;
	            }
	
	            // Value Handling
	            // ==============
	
	            // User attempted to delete but raw value was unaffected--correct this grievous offense
	            if ((eventType === 'input') && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
	              while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {
	                caretPos--;
	              }
	              while (isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1) {
	                caretPos++;
	              }
	              var charIndex = maskCaretMap.indexOf(caretPos);
	              // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
	              valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
	              valAltered = true;
	            }
	
	            // Update values
	            valMasked = maskValue(valUnmasked);
	
	            oldValue = valMasked;
	            oldValueUnmasked = valUnmasked;
	            iElement.val(valMasked);
	            if (valAltered) {
	              // We've altered the raw value after it's been $digest'ed, we need to $apply the new value.
	              scope.$apply(function (){
	                controller.$setViewValue(valUnmasked);
	              });
	            }
	
	            // Caret Repositioning
	            // ===================
	
	            // Ensure that typing always places caret ahead of typed character in cases where the first char of
	            // the input is a mask char and the caret is placed at the 0 position.
	            if (isAddition && (caretPos <= caretPosMin)) {
	              caretPos = caretPosMin + 1;
	            }
	
	            if (caretBumpBack) {
	              caretPos--;
	            }
	
	            // Make sure caret is within min and max position limits
	            caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;
	
	            // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
	            while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {
	              caretPos += caretBumpBack ? -1 : 1;
	            }
	
	            if ((caretBumpBack && caretPos < caretPosMax) || (isAddition && !isValidCaretPosition(caretPosOld))) {
	              caretPos++;
	            }
	            oldCaretPosition = caretPos;
	            setCaretPosition(this, caretPos);
	          }
	
	          function isValidCaretPosition(pos){ return maskCaretMap.indexOf(pos) > -1; }
	
	          function getCaretPosition(input){
	            if (!input) return 0;
	            if (input.selectionStart !== undefined) {
	              return input.selectionStart;
	            } else if (document.selection) {
	              // Curse you IE
	              input.focus();
	              var selection = document.selection.createRange();
	              selection.moveStart('character', input.value ? -input.value.length : 0);
	              return selection.text.length;
	            }
	            return 0;
	          }
	
	          function setCaretPosition(input, pos){
	            if (!input) return 0;
	            if (input.offsetWidth === 0 || input.offsetHeight === 0) {
	              return; // Input's hidden
	            }
	            if (input.setSelectionRange) {
	              input.focus();
	              input.setSelectionRange(pos, pos);
	            }
	            else if (input.createTextRange) {
	              // Curse you IE
	              var range = input.createTextRange();
	              range.collapse(true);
	              range.moveEnd('character', pos);
	              range.moveStart('character', pos);
	              range.select();
	            }
	          }
	
	          function getSelectionLength(input){
	            if (!input) return 0;
	            if (input.selectionStart !== undefined) {
	              return (input.selectionEnd - input.selectionStart);
	            }
	            if (document.selection) {
	              return (document.selection.createRange().text.length);
	            }
	            return 0;
	          }
	
	          // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
	          if (!Array.prototype.indexOf) {
	            Array.prototype.indexOf = function (searchElement /*, fromIndex */){
	              if (this === null) {
	                throw new TypeError();
	              }
	              var t = Object(this);
	              var len = t.length >>> 0;
	              if (len === 0) {
	                return -1;
	              }
	              var n = 0;
	              if (arguments.length > 1) {
	                n = Number(arguments[1]);
	                if (n !== n) { // shortcut for verifying if it's NaN
	                  n = 0;
	                } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
	                  n = (n > 0 || -1) * Math.floor(Math.abs(n));
	                }
	              }
	              if (n >= len) {
	                return -1;
	              }
	              var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
	              for (; k < len; k++) {
	                if (k in t && t[k] === searchElement) {
	                  return k;
	                }
	              }
	              return -1;
	            };
	          }
	
	        };
	      }
	    };
	  }
	]);
	
	/**
	 * Add a clear button to form inputs to reset their value
	 */
	angular.module('ui.reset',[]).value('uiResetConfig',null).directive('uiReset', ['uiResetConfig', function (uiResetConfig) {
	  'use strict';
	
	  var resetValue = null;
	  if (uiResetConfig !== undefined){
	      resetValue = uiResetConfig;
	  }
	  return {
	    require: 'ngModel',
	    link: function (scope, elm, attrs, ctrl) {
	      var aElement;
	      aElement = angular.element('<a class="ui-reset" />');
	      elm.wrap('<span class="ui-resetwrap" />').after(aElement);
	      aElement.bind('click', function (e) {
	        e.preventDefault();
	        scope.$apply(function () {
	          if (attrs.uiReset){
	            ctrl.$setViewValue(scope.$eval(attrs.uiReset));
	          }else{
	            ctrl.$setViewValue(resetValue);
	          }
	          ctrl.$render();
	        });
	      });
	    }
	  };
	}]);
	
	/**
	 * Set a $uiRoute boolean to see if the current route matches
	 */
	angular.module('ui.route', []).directive('uiRoute', ['$location', '$parse', function ($location, $parse) {
	  'use strict';
	
	  return {
	    restrict: 'AC',
	    scope: true,
	    compile: function(tElement, tAttrs) {
	      var useProperty;
	      if (tAttrs.uiRoute) {
	        useProperty = 'uiRoute';
	      } else if (tAttrs.ngHref) {
	        useProperty = 'ngHref';
	      } else if (tAttrs.href) {
	        useProperty = 'href';
	      } else {
	        throw new Error('uiRoute missing a route or href property on ' + tElement[0]);
	      }
	      return function ($scope, elm, attrs) {
	        var modelSetter = $parse(attrs.ngModel || attrs.routeModel || '$uiRoute').assign;
	        var watcher = angular.noop;
	
	        // Used by href and ngHref
	        function staticWatcher(newVal) {
	          var hash = newVal.indexOf('#');
	          if (hash > -1){
	            newVal = newVal.substr(hash + 1);
	          }
	          watcher = function watchHref() {
	            modelSetter($scope, ($location.path().indexOf(newVal) > -1));
	          };
	          watcher();
	        }
	        // Used by uiRoute
	        function regexWatcher(newVal) {
	          var hash = newVal.indexOf('#');
	          if (hash > -1){
	            newVal = newVal.substr(hash + 1);
	          }
	          watcher = function watchRegex() {
	            var regexp = new RegExp('^' + newVal + '$', ['i']);
	            modelSetter($scope, regexp.test($location.path()));
	          };
	          watcher();
	        }
	
	        switch (useProperty) {
	          case 'uiRoute':
	            // if uiRoute={{}} this will be undefined, otherwise it will have a value and $observe() never gets triggered
	            if (attrs.uiRoute){
	              regexWatcher(attrs.uiRoute);
	            }else{
	              attrs.$observe('uiRoute', regexWatcher);
	            }
	            break;
	          case 'ngHref':
	            // Setup watcher() every time ngHref changes
	            if (attrs.ngHref){
	              staticWatcher(attrs.ngHref);
	            }else{
	              attrs.$observe('ngHref', staticWatcher);
	            }
	            break;
	          case 'href':
	            // Setup watcher()
	            staticWatcher(attrs.href);
	        }
	
	        $scope.$on('$routeChangeSuccess', function(){
	          watcher();
	        });
	
	        //Added for compatibility with ui-router
	        $scope.$on('$stateChangeSuccess', function(){
	          watcher();
	        });
	      };
	    }
	  };
	}]);
	
	angular.module('ui.scroll.jqlite', ['ui.scroll']).service('jqLiteExtras', [
	  '$log', '$window', function(console, window) {
	    'use strict';
	
	    return {
	      registerFor: function(element) {
	        var convertToPx, css, getMeasurements, getStyle, getWidthHeight, isWindow, scrollTo;
	        css = angular.element.prototype.css;
	        element.prototype.css = function(name, value) {
	          var elem, self;
	          self = this;
	          elem = self[0];
	          if (!(!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style)) {
	            return css.call(self, name, value);
	          }
	        };
	        isWindow = function(obj) {
	          return obj && obj.document && obj.location && obj.alert && obj.setInterval;
	        };
	        scrollTo = function(self, direction, value) {
	          var elem, method, preserve, prop, _ref;
	          elem = self[0];
	          _ref = {
	            top: ['scrollTop', 'pageYOffset', 'scrollLeft'],
	            left: ['scrollLeft', 'pageXOffset', 'scrollTop']
	          }[direction], method = _ref[0], prop = _ref[1], preserve = _ref[2];
	          if (isWindow(elem)) {
	            if (angular.isDefined(value)) {
	              return elem.scrollTo(self[preserve].call(self), value);
	            } else {
	              if (prop in elem) {
	                return elem[prop];
	              } else {
	                return elem.document.documentElement[method];
	              }
	            }
	          } else {
	            if (angular.isDefined(value)) {
	              return elem[method] = value;
	            } else {
	              return elem[method];
	            }
	          }
	        };
	        if (window.getComputedStyle) {
	          getStyle = function(elem) {
	            return window.getComputedStyle(elem, null);
	          };
	          convertToPx = function(elem, value) {
	            return parseFloat(value);
	          };
	        } else {
	          getStyle = function(elem) {
	            return elem.currentStyle;
	          };
	          convertToPx = function(elem, value) {
	            var core_pnum, left, result, rnumnonpx, rs, rsLeft, style;
	            core_pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
	            rnumnonpx = new RegExp('^(' + core_pnum + ')(?!px)[a-z%]+$', 'i');
	            if (!rnumnonpx.test(value)) {
	              return parseFloat(value);
	            } else {
	              style = elem.style;
	              left = style.left;
	              rs = elem.runtimeStyle;
	              rsLeft = rs && rs.left;
	              if (rs) {
	                rs.left = style.left;
	              }
	              style.left = value;
	              result = style.pixelLeft;
	              style.left = left;
	              if (rsLeft) {
	                rs.left = rsLeft;
	              }
	              return result;
	            }
	          };
	        }
	        getMeasurements = function(elem, measure) {
	          var base, borderA, borderB, computedMarginA, computedMarginB, computedStyle, dirA, dirB, marginA, marginB, paddingA, paddingB, _ref;
	          if (isWindow(elem)) {
	            base = document.documentElement[{
	              height: 'clientHeight',
	              width: 'clientWidth'
	            }[measure]];
	            return {
	              base: base,
	              padding: 0,
	              border: 0,
	              margin: 0
	            };
	          }
	          _ref = {
	            width: [elem.offsetWidth, 'Left', 'Right'],
	            height: [elem.offsetHeight, 'Top', 'Bottom']
	          }[measure], base = _ref[0], dirA = _ref[1], dirB = _ref[2];
	          computedStyle = getStyle(elem);
	          paddingA = convertToPx(elem, computedStyle['padding' + dirA]) || 0;
	          paddingB = convertToPx(elem, computedStyle['padding' + dirB]) || 0;
	          borderA = convertToPx(elem, computedStyle['border' + dirA + 'Width']) || 0;
	          borderB = convertToPx(elem, computedStyle['border' + dirB + 'Width']) || 0;
	          computedMarginA = computedStyle['margin' + dirA];
	          computedMarginB = computedStyle['margin' + dirB];
	          marginA = convertToPx(elem, computedMarginA) || 0;
	          marginB = convertToPx(elem, computedMarginB) || 0;
	          return {
	            base: base,
	            padding: paddingA + paddingB,
	            border: borderA + borderB,
	            margin: marginA + marginB
	          };
	        };
	        getWidthHeight = function(elem, direction, measure) {
	          var computedStyle, measurements, result;
	          measurements = getMeasurements(elem, direction);
	          if (measurements.base > 0) {
	            return {
	              base: measurements.base - measurements.padding - measurements.border,
	              outer: measurements.base,
	              outerfull: measurements.base + measurements.margin
	            }[measure];
	          } else {
	            computedStyle = getStyle(elem);
	            result = computedStyle[direction];
	            if (result < 0 || result === null) {
	              result = elem.style[direction] || 0;
	            }
	            result = parseFloat(result) || 0;
	            return {
	              base: result - measurements.padding - measurements.border,
	              outer: result,
	              outerfull: result + measurements.padding + measurements.border + measurements.margin
	            }[measure];
	          }
	        };
	        return angular.forEach({
	          before: function(newElem) {
	            var children, elem, i, parent, self, _i, _ref;
	            self = this;
	            elem = self[0];
	            parent = self.parent();
	            children = parent.contents();
	            if (children[0] === elem) {
	              return parent.prepend(newElem);
	            } else {
	              for (i = _i = 1, _ref = children.length - 1; 1 <= _ref ? _i <= _ref : _i >= _ref; i = 1 <= _ref ? ++_i : --_i) {
	                if (children[i] === elem) {
	                  angular.element(children[i - 1]).after(newElem);
	                  return;
	                }
	              }
	              throw new Error('invalid DOM structure ' + elem.outerHTML);
	            }
	          },
	          height: function(value) {
	            var self;
	            self = this;
	            if (angular.isDefined(value)) {
	              if (angular.isNumber(value)) {
	                value = value + 'px';
	              }
	              return css.call(self, 'height', value);
	            } else {
	              return getWidthHeight(this[0], 'height', 'base');
	            }
	          },
	          outerHeight: function(option) {
	            return getWidthHeight(this[0], 'height', option ? 'outerfull' : 'outer');
	          },
	          /*
	          UIScroller no longer relies on jQuery method offset. The jQLite implementation of the method
	          is kept here just for the reference. Also the offset setter method was never implemented
	          */
	
	          offset: function(value) {
	            var box, doc, docElem, elem, self, win;
	            self = this;
	            if (arguments.length) {
	              if (value === void 0) {
	                return self;
	              } else {
	                throw new Error('offset setter method is not implemented');
	              }
	            }
	            box = {
	              top: 0,
	              left: 0
	            };
	            elem = self[0];
	            doc = elem && elem.ownerDocument;
	            if (!doc) {
	              return;
	            }
	            docElem = doc.documentElement;
	            if (elem.getBoundingClientRect != null) {
	              box = elem.getBoundingClientRect();
	            }
	            win = doc.defaultView || doc.parentWindow;
	            return {
	              top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	              left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0)
	            };
	          },
	          scrollTop: function(value) {
	            return scrollTo(this, 'top', value);
	          },
	          scrollLeft: function(value) {
	            return scrollTo(this, 'left', value);
	          }
	        }, function(value, key) {
	          if (!element.prototype[key]) {
	            return element.prototype[key] = value;
	          }
	        });
	      }
	    };
	  }
	]).run([
	  '$log', '$window', 'jqLiteExtras', function(console, window, jqLiteExtras) {
	    'use strict';
	
	    if (!window.jQuery) {
	      return jqLiteExtras.registerFor(angular.element);
	    }
	  }
	]);
	
	/*
	//# sourceURL=src/scripts/ui-scroll-jqlite.js
	*/
	
	
	/*
	 globals: angular, window
	
	 List of used element methods available in JQuery but not in JQuery Lite
	
	 element.before(elem)
	 element.height()
	 element.outerHeight(true)
	 element.height(value) = only for Top/Bottom padding elements
	 element.scrollTop()
	 element.scrollTop(value)
	 */
	
	angular.module('ui.scroll', []).directive('uiScrollViewport', [
	  '$log', function() {
	    'use strict';
	
	    return {
	      controller: [
	        '$scope', '$element', function(scope, element) {
	          this.viewport = element;
	          return this;
	        }
	      ]
	    };
	  }
	]).directive('uiScroll', [
	  '$log', '$injector', '$rootScope', '$timeout', function(console, $injector, $rootScope, $timeout) {
	    'use strict';
	
	    return {
	      require: ['?^uiScrollViewport'],
	      transclude: 'element',
	      priority: 1000,
	      terminal: true,
	      compile: function(elementTemplate, attr, linker) {
	        return function($scope, element, $attr, controllers) {
	          var adapter, adapterOnScope, adjustBuffer, adjustRowHeight, applyUpdate, bof, bottomVisiblePos, buffer, bufferPadding, bufferSize, builder, clipBottom, clipTop, datasource, datasourceName, doAdjustment, doDelete, doInsert, doUpdate, enqueueFetch, eof, eventListener, fetch, finalize, first, getValueChain, hideElementBeforeAppend, insert, isDatasourceValid, itemName, loading, log, match, next, pending, reload, removeFromBuffer, resizeAndScrollHandler, ridActual, scrollHeight, setValueChain, shouldLoadBottom, shouldLoadTop, showElementAfterRender, topVisible, topVisiblePos, viewport, viewportScope, wheelHandler;
	          log = console.debug || console.log;
	          match = $attr.uiScroll.match(/^\s*(\w+)\s+in\s+([\w\.]+)\s*$/);
	          if (!match) {
	            throw new Error('Expected uiScroll in form of \'_item_ in _datasource_\' but got \'' + $attr.uiScroll + '\'');
	          }
	          itemName = match[1];
	          datasourceName = match[2];
	          getValueChain = function(targetScope, target) {
	            var chain;
	            if (!targetScope) {
	              return;
	            }
	            chain = target.match(/^([\w]+)\.(.+)$/);
	            if (!chain || chain.length !== 3) {
	              return targetScope[target];
	            }
	            return getValueChain(targetScope[chain[1]], chain[2]);
	          };
	          setValueChain = function(targetScope, target, value, doNotSet) {
	            var chain;
	            if (!targetScope || !target) {
	              return;
	            }
	            if (!(chain = target.match(/^([\w]+)\.(.+)$/))) {
	              if (target.indexOf('.') !== -1) {
	                return;
	              }
	            }
	            if (!chain || chain.length !== 3) {
	              if (!angular.isObject(targetScope[target]) && !doNotSet) {
	                return targetScope[target] = value;
	              }
	              return targetScope[target] = value;
	            }
	            if (!angular.isObject(targetScope[chain[1]]) && !doNotSet) {
	              targetScope[chain[1]] = {};
	            }
	            return setValueChain(targetScope[chain[1]], chain[2], value, doNotSet);
	          };
	          datasource = getValueChain($scope, datasourceName);
	          isDatasourceValid = function() {
	            return angular.isObject(datasource) && typeof datasource.get === 'function';
	          };
	          if (!isDatasourceValid()) {
	            datasource = $injector.get(datasourceName);
	            if (!isDatasourceValid()) {
	              throw new Error('' + datasourceName + ' is not a valid datasource');
	            }
	          }
	          bufferSize = Math.max(3, +$attr.bufferSize || 10);
	          bufferPadding = function() {
	            return viewport.outerHeight() * Math.max(0.1, +$attr.padding || 0.1);
	          };
	          scrollHeight = function(elem) {
	            var _ref;
	            return (_ref = elem[0].scrollHeight) != null ? _ref : elem[0].document.documentElement.scrollHeight;
	          };
	          builder = null;
	          linker($scope.$new(), function(template) {
	            var bottomPadding, createPadding, padding, repeaterType, topPadding, viewport;
	            repeaterType = template[0].localName;
	            if (repeaterType === 'dl') {
	              throw new Error('ui-scroll directive does not support <' + template[0].localName + '> as a repeating tag: ' + template[0].outerHTML);
	            }
	            if (repeaterType !== 'li' && repeaterType !== 'tr') {
	              repeaterType = 'div';
	            }
	            viewport = controllers[0] && controllers[0].viewport ? controllers[0].viewport : angular.element(window);
	            viewport.css({
	              'overflow-y': 'auto',
	              'display': 'block'
	            });
	            padding = function(repeaterType) {
	              var div, result, table;
	              switch (repeaterType) {
	                case 'tr':
	                  table = angular.element('<table><tr><td><div></div></td></tr></table>');
	                  div = table.find('div');
	                  result = table.find('tr');
	                  result.paddingHeight = function() {
	                    return div.height.apply(div, arguments);
	                  };
	                  return result;
	                default:
	                  result = angular.element('<' + repeaterType + '></' + repeaterType + '>');
	                  result.paddingHeight = result.height;
	                  return result;
	              }
	            };
	            createPadding = function(padding, element, direction) {
	              element[{
	                top: 'before',
	                bottom: 'after'
	              }[direction]](padding);
	              return {
	                paddingHeight: function() {
	                  return padding.paddingHeight.apply(padding, arguments);
	                },
	                insert: function(element) {
	                  return padding[{
	                    top: 'after',
	                    bottom: 'before'
	                  }[direction]](element);
	                }
	              };
	            };
	            topPadding = createPadding(padding(repeaterType), element, 'top');
	            bottomPadding = createPadding(padding(repeaterType), element, 'bottom');
	            $scope.$on('$destroy', template.remove);
	            return builder = {
	              viewport: viewport,
	              topPadding: topPadding.paddingHeight,
	              bottomPadding: bottomPadding.paddingHeight,
	              append: bottomPadding.insert,
	              prepend: topPadding.insert,
	              bottomDataPos: function() {
	                return scrollHeight(viewport) - bottomPadding.paddingHeight();
	              },
	              topDataPos: function() {
	                return topPadding.paddingHeight();
	              }
	            };
	          });
	          viewport = builder.viewport;
	          viewportScope = viewport.scope() || $rootScope;
	          topVisible = function(item) {
	            adapter.topVisible = item.scope[itemName];
	            adapter.topVisibleElement = item.element;
	            adapter.topVisibleScope = item.scope;
	            if ($attr.topVisible) {
	              setValueChain(viewportScope, $attr.topVisible, adapter.topVisible);
	            }
	            if ($attr.topVisibleElement) {
	              setValueChain(viewportScope, $attr.topVisibleElement, adapter.topVisibleElement);
	            }
	            if ($attr.topVisibleScope) {
	              setValueChain(viewportScope, $attr.topVisibleScope, adapter.topVisibleScope);
	            }
	            if (typeof datasource.topVisible === 'function') {
	              return datasource.topVisible(item);
	            }
	          };
	          loading = function(value) {
	            adapter.isLoading = value;
	            if ($attr.isLoading) {
	              setValueChain($scope, $attr.isLoading, value);
	            }
	            if (typeof datasource.loading === 'function') {
	              return datasource.loading(value);
	            }
	          };
	          ridActual = 0;
	          first = 1;
	          next = 1;
	          buffer = [];
	          pending = [];
	          eof = false;
	          bof = false;
	          removeFromBuffer = function(start, stop) {
	            var i, _i;
	            for (i = _i = start; start <= stop ? _i < stop : _i > stop; i = start <= stop ? ++_i : --_i) {
	              buffer[i].scope.$destroy();
	              buffer[i].element.remove();
	            }
	            return buffer.splice(start, stop - start);
	          };
	          reload = function() {
	            ridActual++;
	            first = 1;
	            next = 1;
	            removeFromBuffer(0, buffer.length);
	            builder.topPadding(0);
	            builder.bottomPadding(0);
	            pending = [];
	            eof = false;
	            bof = false;
	            return adjustBuffer(ridActual);
	          };
	          bottomVisiblePos = function() {
	            return viewport.scrollTop() + viewport.outerHeight();
	          };
	          topVisiblePos = function() {
	            return viewport.scrollTop();
	          };
	          shouldLoadBottom = function() {
	            return !eof && builder.bottomDataPos() < bottomVisiblePos() + bufferPadding();
	          };
	          clipBottom = function() {
	            var bottomHeight, i, item, itemHeight, itemTop, newRow, overage, rowTop, _i, _ref;
	            bottomHeight = 0;
	            overage = 0;
	            for (i = _i = _ref = buffer.length - 1; _ref <= 0 ? _i <= 0 : _i >= 0; i = _ref <= 0 ? ++_i : --_i) {
	              item = buffer[i];
	              itemTop = item.element.offset().top;
	              newRow = rowTop !== itemTop;
	              rowTop = itemTop;
	              if (newRow) {
	                itemHeight = item.element.outerHeight(true);
	              }
	              if (builder.bottomDataPos() - bottomHeight - itemHeight > bottomVisiblePos() + bufferPadding()) {
	                if (newRow) {
	                  bottomHeight += itemHeight;
	                }
	                overage++;
	                eof = false;
	              } else {
	                if (newRow) {
	                  break;
	                }
	                overage++;
	              }
	            }
	            if (overage > 0) {
	              builder.bottomPadding(builder.bottomPadding() + bottomHeight);
	              removeFromBuffer(buffer.length - overage, buffer.length);
	              return next -= overage;
	            }
	          };
	          shouldLoadTop = function() {
	            return !bof && (builder.topDataPos() > topVisiblePos() - bufferPadding());
	          };
	          clipTop = function() {
	            var item, itemHeight, itemTop, newRow, overage, rowTop, topHeight, _i, _len;
	            topHeight = 0;
	            overage = 0;
	            for (_i = 0, _len = buffer.length; _i < _len; _i++) {
	              item = buffer[_i];
	              itemTop = item.element.offset().top;
	              newRow = rowTop !== itemTop;
	              rowTop = itemTop;
	              if (newRow) {
	                itemHeight = item.element.outerHeight(true);
	              }
	              if (builder.topDataPos() + topHeight + itemHeight < topVisiblePos() - bufferPadding()) {
	                if (newRow) {
	                  topHeight += itemHeight;
	                }
	                overage++;
	                bof = false;
	              } else {
	                if (newRow) {
	                  break;
	                }
	                overage++;
	              }
	            }
	            if (overage > 0) {
	              builder.topPadding(builder.topPadding() + topHeight);
	              removeFromBuffer(0, overage);
	              return first += overage;
	            }
	          };
	          enqueueFetch = function(rid, direction) {
	            if (!adapter.isLoading) {
	              loading(true);
	            }
	            if (pending.push(direction) === 1) {
	              return fetch(rid);
	            }
	          };
	          hideElementBeforeAppend = function(element) {
	            element.displayTemp = element.css('display');
	            return element.css('display', 'none');
	          };
	          showElementAfterRender = function(element) {
	            if (element.hasOwnProperty('displayTemp')) {
	              return element.css('display', element.displayTemp);
	            }
	          };
	          insert = function(index, item) {
	            var itemScope, toBeAppended, wrapper;
	            itemScope = $scope.$new();
	            itemScope[itemName] = item;
	            toBeAppended = index > first;
	            itemScope.$index = index;
	            if (toBeAppended) {
	              itemScope.$index--;
	            }
	            wrapper = {
	              scope: itemScope
	            };
	            linker(itemScope, function(clone) {
	              wrapper.element = clone;
	              if (toBeAppended) {
	                if (index === next) {
	                  hideElementBeforeAppend(clone);
	                  builder.append(clone);
	                  return buffer.push(wrapper);
	                } else {
	                  buffer[index - first].element.after(clone);
	                  return buffer.splice(index - first + 1, 0, wrapper);
	                }
	              } else {
	                hideElementBeforeAppend(clone);
	                builder.prepend(clone);
	                return buffer.unshift(wrapper);
	              }
	            });
	            return {
	              appended: toBeAppended,
	              wrapper: wrapper
	            };
	          };
	          adjustRowHeight = function(appended, wrapper) {
	            var newHeight;
	            if (appended) {
	              return builder.bottomPadding(Math.max(0, builder.bottomPadding() - wrapper.element.outerHeight(true)));
	            } else {
	              newHeight = builder.topPadding() - wrapper.element.outerHeight(true);
	              if (newHeight >= 0) {
	                return builder.topPadding(newHeight);
	              } else {
	                return viewport.scrollTop(viewport.scrollTop() + wrapper.element.outerHeight(true));
	              }
	            }
	          };
	          doAdjustment = function(rid, finalize) {
	            var item, itemHeight, itemTop, newRow, rowTop, topHeight, _i, _len, _results;
	            if (shouldLoadBottom()) {
	              enqueueFetch(rid, true);
	            } else {
	              if (shouldLoadTop()) {
	                enqueueFetch(rid, false);
	              }
	            }
	            if (finalize) {
	              finalize(rid);
	            }
	            if (pending.length === 0) {
	              topHeight = 0;
	              _results = [];
	              for (_i = 0, _len = buffer.length; _i < _len; _i++) {
	                item = buffer[_i];
	                itemTop = item.element.offset().top;
	                newRow = rowTop !== itemTop;
	                rowTop = itemTop;
	                if (newRow) {
	                  itemHeight = item.element.outerHeight(true);
	                }
	                if (newRow && (builder.topDataPos() + topHeight + itemHeight < topVisiblePos())) {
	                  _results.push(topHeight += itemHeight);
	                } else {
	                  if (newRow) {
	                    topVisible(item);
	                  }
	                  break;
	                }
	              }
	              return _results;
	            }
	          };
	          adjustBuffer = function(rid, newItems, finalize) {
	            if (newItems && newItems.length) {
	              return $timeout(function() {
	                var elt, itemTop, row, rowTop, rows, _i, _j, _len, _len1;
	                rows = [];
	                for (_i = 0, _len = newItems.length; _i < _len; _i++) {
	                  row = newItems[_i];
	                  elt = row.wrapper.element;
	                  showElementAfterRender(elt);
	                  itemTop = elt.offset().top;
	                  if (rowTop !== itemTop) {
	                    rows.push(row);
	                    rowTop = itemTop;
	                  }
	                }
	                for (_j = 0, _len1 = rows.length; _j < _len1; _j++) {
	                  row = rows[_j];
	                  adjustRowHeight(row.appended, row.wrapper);
	                }
	                return doAdjustment(rid, finalize);
	              });
	            } else {
	              return doAdjustment(rid, finalize);
	            }
	          };
	          finalize = function(rid, newItems) {
	            return adjustBuffer(rid, newItems, function() {
	              pending.shift();
	              if (pending.length === 0) {
	                return loading(false);
	              } else {
	                return fetch(rid);
	              }
	            });
	          };
	          fetch = function(rid) {
	            var direction;
	            direction = pending[0];
	            if (direction) {
	              if (buffer.length && !shouldLoadBottom()) {
	                return finalize(rid);
	              } else {
	                return datasource.get(next, bufferSize, function(result) {
	                  var item, newItems, _i, _len;
	                  if ((rid && rid !== ridActual) || $scope.$$destroyed) {
	                    return;
	                  }
	                  newItems = [];
	                  if (result.length < bufferSize) {
	                    eof = true;
	                    builder.bottomPadding(0);
	                  }
	                  if (result.length > 0) {
	                    clipTop();
	                    for (_i = 0, _len = result.length; _i < _len; _i++) {
	                      item = result[_i];
	                      newItems.push(insert(++next, item));
	                    }
	                  }
	                  return finalize(rid, newItems);
	                });
	              }
	            } else {
	              if (buffer.length && !shouldLoadTop()) {
	                return finalize(rid);
	              } else {
	                return datasource.get(first - bufferSize, bufferSize, function(result) {
	                  var i, newItems, _i, _ref;
	                  if ((rid && rid !== ridActual) || $scope.$$destroyed) {
	                    return;
	                  }
	                  newItems = [];
	                  if (result.length < bufferSize) {
	                    bof = true;
	                    builder.topPadding(0);
	                  }
	                  if (result.length > 0) {
	                    if (buffer.length) {
	                      clipBottom();
	                    }
	                    for (i = _i = _ref = result.length - 1; _ref <= 0 ? _i <= 0 : _i >= 0; i = _ref <= 0 ? ++_i : --_i) {
	                      newItems.unshift(insert(--first, result[i]));
	                    }
	                  }
	                  return finalize(rid, newItems);
	                });
	              }
	            }
	          };
	          resizeAndScrollHandler = function() {
	            if (!$rootScope.$$phase && !adapter.isLoading) {
	              adjustBuffer();
	              return $scope.$apply();
	            }
	          };
	          wheelHandler = function(event) {
	            var scrollTop, yMax;
	            scrollTop = viewport[0].scrollTop;
	            yMax = viewport[0].scrollHeight - viewport[0].clientHeight;
	            if ((scrollTop === 0 && !bof) || (scrollTop === yMax && !eof)) {
	              return event.preventDefault();
	            }
	          };
	          viewport.bind('resize', resizeAndScrollHandler);
	          viewport.bind('scroll', resizeAndScrollHandler);
	          viewport.bind('mousewheel', wheelHandler);
	          $scope.$watch(datasource.revision, reload);
	          if (datasource.scope) {
	            eventListener = datasource.scope.$new();
	          } else {
	            eventListener = $scope.$new();
	          }
	          $scope.$on('$destroy', function() {
	            var item, _i, _len;
	            for (_i = 0, _len = buffer.length; _i < _len; _i++) {
	              item = buffer[_i];
	              item.scope.$destroy();
	              item.element.remove();
	            }
	            viewport.unbind('resize', resizeAndScrollHandler);
	            viewport.unbind('scroll', resizeAndScrollHandler);
	            return viewport.unbind('mousewheel', wheelHandler);
	          });
	          adapter = {};
	          adapter.isLoading = false;
	          applyUpdate = function(wrapper, newItems) {
	            var i, inserted, item, ndx, newItem, oldItemNdx, _i, _j, _k, _len, _len1, _len2;
	            inserted = [];
	            if (angular.isArray(newItems)) {
	              if (newItems.length) {
	                if (newItems.length === 1 && newItems[0] === wrapper.scope[itemName]) {
	                  return inserted;
	                } else {
	                  ndx = wrapper.scope.$index;
	                  if (ndx > first) {
	                    oldItemNdx = ndx - first;
	                  } else {
	                    oldItemNdx = 1;
	                  }
	                  for (i = _i = 0, _len = newItems.length; _i < _len; i = ++_i) {
	                    newItem = newItems[i];
	                    inserted.push(insert(ndx + i, newItem));
	                  }
	                  removeFromBuffer(oldItemNdx, oldItemNdx + 1);
	                  for (i = _j = 0, _len1 = buffer.length; _j < _len1; i = ++_j) {
	                    item = buffer[i];
	                    item.scope.$index = first + i;
	                  }
	                }
	              } else {
	                removeFromBuffer(wrapper.scope.$index - first, wrapper.scope.$index - first + 1);
	                next--;
	                for (i = _k = 0, _len2 = buffer.length; _k < _len2; i = ++_k) {
	                  item = buffer[i];
	                  item.scope.$index = first + i;
	                }
	              }
	            }
	            return inserted;
	          };
	          adapter.applyUpdates = function(arg1, arg2) {
	            var inserted, wrapper, _i, _len, _ref, _ref1;
	            inserted = [];
	            ridActual++;
	            if (angular.isFunction(arg1)) {
	              _ref = buffer.slice(0);
	              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	                wrapper = _ref[_i];
	                inserted.concat(inserted, applyUpdate(wrapper, arg1(wrapper.scope[itemName], wrapper.scope, wrapper.element)));
	              }
	            } else {
	              if (arg1 % 1 === 0) {
	                if ((0 <= (_ref1 = arg1 - first - 1) && _ref1 < buffer.length)) {
	                  inserted = applyUpdate(buffer[arg1 - first], arg2);
	                }
	              } else {
	                throw new Error('applyUpdates - ' + arg1 + ' is not a valid index or outside of range');
	              }
	            }
	            return adjustBuffer(ridActual, inserted);
	          };
	          if ($attr.adapter) {
	            adapterOnScope = getValueChain($scope, $attr.adapter);
	            if (!adapterOnScope) {
	              setValueChain($scope, $attr.adapter, {});
	              adapterOnScope = getValueChain($scope, $attr.adapter);
	            }
	            angular.extend(adapterOnScope, adapter);
	            adapter = adapterOnScope;
	          }
	          doUpdate = function(locator, newItem) {
	            var wrapper, _fn, _i, _len, _ref;
	            if (angular.isFunction(locator)) {
	              _fn = function(wrapper) {
	                return locator(wrapper.scope);
	              };
	              for (_i = 0, _len = buffer.length; _i < _len; _i++) {
	                wrapper = buffer[_i];
	                _fn(wrapper);
	              }
	            } else {
	              if ((0 <= (_ref = locator - first - 1) && _ref < buffer.length)) {
	                buffer[locator - first - 1].scope[itemName] = newItem;
	              }
	            }
	            return null;
	          };
	          doDelete = function(locator) {
	            var i, item, temp, wrapper, _fn, _i, _j, _k, _len, _len1, _len2, _ref;
	            if (angular.isFunction(locator)) {
	              temp = [];
	              for (_i = 0, _len = buffer.length; _i < _len; _i++) {
	                item = buffer[_i];
	                temp.unshift(item);
	              }
	              _fn = function(wrapper) {
	                if (locator(wrapper.scope)) {
	                  removeFromBuffer(temp.length - 1 - i, temp.length - i);
	                  return next--;
	                }
	              };
	              for (i = _j = 0, _len1 = temp.length; _j < _len1; i = ++_j) {
	                wrapper = temp[i];
	                _fn(wrapper);
	              }
	            } else {
	              if ((0 <= (_ref = locator - first - 1) && _ref < buffer.length)) {
	                removeFromBuffer(locator - first - 1, locator - first);
	                next--;
	              }
	            }
	            for (i = _k = 0, _len2 = buffer.length; _k < _len2; i = ++_k) {
	              item = buffer[i];
	              item.scope.$index = first + i;
	            }
	            return adjustBuffer();
	          };
	          doInsert = function(locator, item) {
	            var i, inserted, _i, _len, _ref;
	            inserted = [];
	            if (angular.isFunction(locator)) {
	              throw new Error('not implemented - Insert with locator function');
	            } else {
	              if ((0 <= (_ref = locator - first - 1) && _ref < buffer.length)) {
	                inserted.push(insert(locator, item));
	                next++;
	              }
	            }
	            for (i = _i = 0, _len = buffer.length; _i < _len; i = ++_i) {
	              item = buffer[i];
	              item.scope.$index = first + i;
	            }
	            return adjustBuffer(null, inserted);
	          };
	          eventListener.$on('insert.item', function(event, locator, item) {
	            return doInsert(locator, item);
	          });
	          eventListener.$on('update.items', function(event, locator, newItem) {
	            return doUpdate(locator, newItem);
	          });
	          return eventListener.$on('delete.items', function(event, locator) {
	            return doDelete(locator);
	          });
	        };
	      }
	    };
	  }
	]);
	
	/*
	//# sourceURL=src/scripts/ui-scroll.js
	*/
	
	
	/**
	 * Adds a 'ui-scrollfix' class to the element when the page scrolls past it's position.
	 * @param [offset] {int} optional Y-offset to override the detected offset.
	 *   Takes 300 (absolute) or -300 or +300 (relative to detected)
	 */
	angular.module('ui.scrollfix',[]).directive('uiScrollfix', ['$window', function ($window) {
	  'use strict';
	
	  function getWindowScrollTop() {
	    if (angular.isDefined($window.pageYOffset)) {
	      return $window.pageYOffset;
	    } else {
	      var iebody = (document.compatMode && document.compatMode !== 'BackCompat') ? document.documentElement : document.body;
	      return iebody.scrollTop;
	    }
	  }
	  return {
	    require: '^?uiScrollfixTarget',
	    link: function (scope, elm, attrs, uiScrollfixTarget) {
	      var absolute = true,
	          shift = 0,
	          fixLimit,
	          $target = uiScrollfixTarget && uiScrollfixTarget.$element || angular.element($window);
	
	      if (!attrs.uiScrollfix) {
	          absolute = false;
	      } else if (typeof(attrs.uiScrollfix) === 'string') {
	        // charAt is generally faster than indexOf: http://jsperf.com/indexof-vs-charat
	        if (attrs.uiScrollfix.charAt(0) === '-') {
	          absolute = false;
	          shift = - parseFloat(attrs.uiScrollfix.substr(1));
	        } else if (attrs.uiScrollfix.charAt(0) === '+') {
	          absolute = false;
	          shift = parseFloat(attrs.uiScrollfix.substr(1));
	        }
	      }
	
	      fixLimit = absolute ? attrs.uiScrollfix : elm[0].offsetTop + shift;
	
	      function onScroll() {
	
	        var limit = absolute ? attrs.uiScrollfix : elm[0].offsetTop + shift;
	
	        // if pageYOffset is defined use it, otherwise use other crap for IE
	        var offset = uiScrollfixTarget ? $target[0].scrollTop : getWindowScrollTop();
	        if (!elm.hasClass('ui-scrollfix') && offset > limit) {
	          elm.addClass('ui-scrollfix');
	          fixLimit = limit;
	        } else if (elm.hasClass('ui-scrollfix') && offset < fixLimit) {
	          elm.removeClass('ui-scrollfix');
	        }
	      }
	
	      $target.on('scroll', onScroll);
	
	      // Unbind scroll event handler when directive is removed
	      scope.$on('$destroy', function() {
	        $target.off('scroll', onScroll);
	      });
	    }
	  };
	}]).directive('uiScrollfixTarget', [function () {
	  'use strict';
	  return {
	    controller: ['$element', function($element) {
	      this.$element = $element;
	    }]
	  };
	}]);
	
	/**
	 * uiShow Directive
	 *
	 * Adds a 'ui-show' class to the element instead of display:block
	 * Created to allow tighter control  of CSS without bulkier directives
	 *
	 * @param expression {boolean} evaluated expression to determine if the class should be added
	 */
	angular.module('ui.showhide',[])
	.directive('uiShow', [function () {
	  'use strict';
	
	  return function (scope, elm, attrs) {
	    scope.$watch(attrs.uiShow, function (newVal) {
	      if (newVal) {
	        elm.addClass('ui-show');
	      } else {
	        elm.removeClass('ui-show');
	      }
	    });
	  };
	}])
	
	/**
	 * uiHide Directive
	 *
	 * Adds a 'ui-hide' class to the element instead of display:block
	 * Created to allow tighter control  of CSS without bulkier directives
	 *
	 * @param expression {boolean} evaluated expression to determine if the class should be added
	 */
	.directive('uiHide', [function () {
	  'use strict';
	
	  return function (scope, elm, attrs) {
	    scope.$watch(attrs.uiHide, function (newVal) {
	      if (newVal) {
	        elm.addClass('ui-hide');
	      } else {
	        elm.removeClass('ui-hide');
	      }
	    });
	  };
	}])
	
	/**
	 * uiToggle Directive
	 *
	 * Adds a class 'ui-show' if true, and a 'ui-hide' if false to the element instead of display:block/display:none
	 * Created to allow tighter control  of CSS without bulkier directives. This also allows you to override the
	 * default visibility of the element using either class.
	 *
	 * @param expression {boolean} evaluated expression to determine if the class should be added
	 */
	.directive('uiToggle', [function () {
	  'use strict';
	
	  return function (scope, elm, attrs) {
	    scope.$watch(attrs.uiToggle, function (newVal) {
	      if (newVal) {
	        elm.removeClass('ui-hide').addClass('ui-show');
	      } else {
	        elm.removeClass('ui-show').addClass('ui-hide');
	      }
	    });
	  };
	}]);
	
	/**
	 * Filters out all duplicate items from an array by checking the specified key
	 * @param [key] {string} the name of the attribute of each object to compare for uniqueness
	 if the key is empty, the entire object will be compared
	 if the key === false then no filtering will be performed
	 * @return {array}
	 */
	angular.module('ui.unique',[]).filter('unique', ['$parse', function ($parse) {
	  'use strict';
	
	  return function (items, filterOn) {
	
	    if (filterOn === false) {
	      return items;
	    }
	
	    if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
	      var newItems = [],
	        get = angular.isString(filterOn) ? $parse(filterOn) : function (item) { return item; };
	
	      var extractValueToCompare = function (item) {
	        return angular.isObject(item) ? get(item) : item;
	      };
	
	      angular.forEach(items, function (item) {
	        var isDuplicate = false;
	
	        for (var i = 0; i < newItems.length; i++) {
	          if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
	            isDuplicate = true;
	            break;
	          }
	        }
	        if (!isDuplicate) {
	          newItems.push(item);
	        }
	
	      });
	      items = newItems;
	    }
	    return items;
	  };
	}]);
	
	/*
	 * Author: Remy Alain Ticona Carbajal http://realtica.org
	 * Description: The main objective of ng-uploader is to have a user control,
	 * clean, simple, customizable, and above all very easy to implement.
	 * Licence: MIT
	 */
	
	angular.module('ui.uploader', []).service('uiUploader', uiUploader);
	
	uiUploader.$inject = ['$log'];
	
	function uiUploader($log) {
	    'use strict';
	
	    /*jshint validthis: true */
	    var self = this;
	    self.files = [];
	    self.options = {};
	    self.activeUploads = 0;
	    $log.info('uiUploader loaded');
	    
	    function addFiles(files) {
	        for (var i = 0; i < files.length; i++) {
	            self.files.push(files[i]);
	        }
	    }
	
	    function getFiles() {
	        return self.files;
	    }
	
	    function startUpload(options) {
	        self.options = options;
	        for (var i = 0; i < self.files.length; i++) {
	            if (self.activeUploads == self.options.concurrency) {
	                break;
	            }
	            if (self.files[i].active)
	                continue;
	            ajaxUpload(self.files[i], self.options.url);
	        }
	    }
	    
	    function removeFile(file){
	        self.files.splice(self.files.indexOf(file),1);
	    }
	    
	    function removeAll(){
	        self.files.splice(0,self.files.length);
	    }
	    
	    return {
	        addFiles: addFiles,
	        getFiles: getFiles,
	        files: self.files,
	        startUpload: startUpload,
	        removeFile: removeFile,
	        removeAll:removeAll
	    };
	    
	    function getHumanSize(bytes) {
	        var sizes = ['n/a', 'bytes', 'KiB', 'MiB', 'GiB', 'TB', 'PB', 'EiB', 'ZiB', 'YiB'];
	        var i = +Math.floor(Math.log(bytes) / Math.log(1024));
	        return (bytes / Math.pow(1024, i)).toFixed(i ? 1 : 0) + ' ' + sizes[isNaN(bytes) ? 0 : i + 1];
	    }
	
	    function ajaxUpload(file, url) {
	        var xhr, formData, prop, data = '',
	            key = '' || 'file';
	        self.activeUploads += 1;
	        file.active = true;
	        xhr = new window.XMLHttpRequest();
	        formData = new window.FormData();
	        xhr.open('POST', url);
	
	        // Triggered when upload starts:
	        xhr.upload.onloadstart = function() {};
	
	        // Triggered many times during upload:
	        xhr.upload.onprogress = function(event) {
	            if (!event.lengthComputable) {
	                return;
	            }
	            // Update file size because it might be bigger than reported by
	            // the fileSize:
	            //$log.info("progres..");
	            //console.info(event.loaded);
	            file.loaded = event.loaded;
	            file.humanSize = getHumanSize(event.loaded);
	            self.options.onProgress(file);
	        };
	
	        // Triggered when upload is completed:
	        xhr.onload = function() {
	            self.activeUploads -= 1;
	            startUpload(self.options);
	            self.options.onCompleted(file, xhr.responseText);
	        };
	
	        // Triggered when upload fails:
	        xhr.onerror = function() {};
	
	        // Append additional data if provided:
	        if (data) {
	            for (prop in data) {
	                if (data.hasOwnProperty(prop)) {
	                    formData.append(prop, data[prop]);
	                }
	            }
	        }
	
	        // Append file data:
	        formData.append(key, file, file.name);
	
	        // Initiate upload:
	        xhr.send(formData);
	
	        return xhr;
	    }
	
	}
	
	/**
	 * General-purpose validator for ngModel.
	 * angular.js comes with several built-in validation mechanism for input fields (ngRequired, ngPattern etc.) but using
	 * an arbitrary validation function requires creation of a custom formatters and / or parsers.
	 * The ui-validate directive makes it easy to use any function(s) defined in scope as a validator function(s).
	 * A validator function will trigger validation on both model and input changes.
	 *
	 * @example <input ui-validate=" 'myValidatorFunction($value)' ">
	 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }">
	 * @example <input ui-validate="{ foo : '$value > anotherModel' }" ui-validate-watch=" 'anotherModel' ">
	 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }" ui-validate-watch=" { foo : 'anotherModel' } ">
	 *
	 * @param ui-validate {string|object literal} If strings is passed it should be a scope's function to be used as a validator.
	 * If an object literal is passed a key denotes a validation error key while a value should be a validator function.
	 * In both cases validator function should take a value to validate as its argument and should return true/false indicating a validation result.
	 */
	angular.module('ui.validate',[]).directive('uiValidate', function () {
	  'use strict';
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function (scope, elm, attrs, ctrl) {
	      var validateFn, validators = {},
	          validateExpr = scope.$eval(attrs.uiValidate);
	
	      if (!validateExpr){ return;}
	
	      if (angular.isString(validateExpr)) {
	        validateExpr = { validator: validateExpr };
	      }
	
	      angular.forEach(validateExpr, function (exprssn, key) {
	        validateFn = function (valueToValidate) {
	          var expression = scope.$eval(exprssn, { '$value' : valueToValidate });
	          if (angular.isObject(expression) && angular.isFunction(expression.then)) {
	            // expression is a promise
	            expression.then(function(){
	              ctrl.$setValidity(key, true);
	            }, function(){
	              ctrl.$setValidity(key, false);
	            });
	            return valueToValidate;
	          } else if (expression) {
	            // expression is true
	            ctrl.$setValidity(key, true);
	            return valueToValidate;
	          } else {
	            // expression is false
	            ctrl.$setValidity(key, false);
	            return valueToValidate;
	          }
	        };
	        validators[key] = validateFn;
	        ctrl.$formatters.push(validateFn);
	        ctrl.$parsers.push(validateFn);
	      });
	
	      function apply_watch(watch)
	      {
	          //string - update all validators on expression change
	          if (angular.isString(watch))
	          {
	              scope.$watch(watch, function(){
	                  angular.forEach(validators, function(validatorFn){
	                      validatorFn(ctrl.$modelValue);
	                  });
	              });
	              return;
	          }
	
	          //array - update all validators on change of any expression
	          if (angular.isArray(watch))
	          {
	              angular.forEach(watch, function(expression){
	                  scope.$watch(expression, function()
	                  {
	                      angular.forEach(validators, function(validatorFn){
	                          validatorFn(ctrl.$modelValue);
	                      });
	                  });
	              });
	              return;
	          }
	
	          //object - update appropriate validator
	          if (angular.isObject(watch))
	          {
	              angular.forEach(watch, function(expression, validatorKey)
	              {
	                  //value is string - look after one expression
	                  if (angular.isString(expression))
	                  {
	                      scope.$watch(expression, function(){
	                          validators[validatorKey](ctrl.$modelValue);
	                      });
	                  }
	
	                  //value is array - look after all expressions in array
	                  if (angular.isArray(expression))
	                  {
	                      angular.forEach(expression, function(intExpression)
	                      {
	                          scope.$watch(intExpression, function(){
	                              validators[validatorKey](ctrl.$modelValue);
	                          });
	                      });
	                  }
	              });
	          }
	      }
	      // Support for ui-validate-watch
	      if (attrs.uiValidateWatch){
	          apply_watch( scope.$eval(attrs.uiValidateWatch) );
	      }
	    }
	  };
	});
	
	angular.module('ui.utils',  [
	  'ui.event',
	  'ui.format',
	  'ui.highlight',
	  'ui.include',
	  'ui.indeterminate',
	  'ui.inflector',
	  'ui.jq',
	  'ui.keypress',
	  'ui.mask',
	  'ui.reset',
	  'ui.route',
	  'ui.scrollfix',
	  'ui.scroll',
	  'ui.scroll.jqlite',
	  'ui.showhide',
	  'ui.unique',
	  'ui.validate'
	]);
	


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(387);

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var angular = __webpack_require__(28);
	
	'use strict';
	(function () {
	  var app = angular.module('ui.map', ['ui.event']);
	  function bindMapEvents(scope, eventsStr, googleObject, element) {
	    angular.forEach(eventsStr.split(' '), function (eventName) {
	      window.google.maps.event.addListener(googleObject, eventName, function (event) {
	        element.triggerHandler('map-' + eventName, event);
	        if (!scope.$$phase) {
	          scope.$apply();
	        }
	      });
	    });
	  }
	  app.value('uiMapConfig', {}).directive('uiMap', [
	    'uiMapConfig',
	    '$parse',
	    function (uiMapConfig, $parse) {
	      var mapEvents = 'bounds_changed center_changed click dblclick drag dragend ' + 'dragstart heading_changed idle maptypeid_changed mousemove mouseout ' + 'mouseover projection_changed resize rightclick tilesloaded tilt_changed ' + 'zoom_changed';
	      var options = uiMapConfig || {};
	      return {
	        restrict: 'A',
	        link: function (scope, elm, attrs) {
	          var opts = angular.extend({}, options, scope.$eval(attrs.uiOptions));
	          var map = new window.google.maps.Map(elm[0], opts);
	          var model = $parse(attrs.uiMap);
	          model.assign(scope, map);
	          bindMapEvents(scope, mapEvents, map, elm);
	        }
	      };
	    }
	  ]);
	  app.value('uiMapInfoWindowConfig', {}).directive('uiMapInfoWindow', [
	    'uiMapInfoWindowConfig',
	    '$parse',
	    '$compile',
	    function (uiMapInfoWindowConfig, $parse, $compile) {
	      var infoWindowEvents = 'closeclick content_change domready ' + 'position_changed zindex_changed';
	      var options = uiMapInfoWindowConfig || {};
	      return {
	        link: function (scope, elm, attrs) {
	          var opts = angular.extend({}, options, scope.$eval(attrs.uiOptions));
	          opts.content = elm[0];
	          var model = $parse(attrs.uiMapInfoWindow);
	          var infoWindow = model(scope);
	          if (!infoWindow) {
	            infoWindow = new window.google.maps.InfoWindow(opts);
	            model.assign(scope, infoWindow);
	          }
	          bindMapEvents(scope, infoWindowEvents, infoWindow, elm);
	          elm.replaceWith('<div></div>');
	          var _open = infoWindow.open;
	          infoWindow.open = function open(a1, a2, a3, a4, a5, a6) {
	            $compile(elm.contents())(scope);
	            _open.call(infoWindow, a1, a2, a3, a4, a5, a6);
	          };
	        }
	      };
	    }
	  ]);
	  function mapOverlayDirective(directiveName, events) {
	    app.directive(directiveName, [function () {
	        return {
	          restrict: 'A',
	          link: function (scope, elm, attrs) {
	            scope.$watch(attrs[directiveName], function (newObject) {
	              if (newObject) {
	                bindMapEvents(scope, events, newObject, elm);
	              }
	            });
	          }
	        };
	      }]);
	  }
	  mapOverlayDirective('uiMapMarker', 'animation_changed click clickable_changed cursor_changed ' + 'dblclick drag dragend draggable_changed dragstart flat_changed icon_changed ' + 'mousedown mouseout mouseover mouseup position_changed rightclick ' + 'shadow_changed shape_changed title_changed visible_changed zindex_changed');
	  mapOverlayDirective('uiMapPolyline', 'click dblclick mousedown mousemove mouseout mouseover mouseup rightclick');
	  mapOverlayDirective('uiMapPolygon', 'click dblclick mousedown mousemove mouseout mouseover mouseup rightclick');
	  mapOverlayDirective('uiMapRectangle', 'bounds_changed click dblclick mousedown mousemove mouseout mouseover ' + 'mouseup rightclick');
	  mapOverlayDirective('uiMapCircle', 'center_changed click dblclick mousedown mousemove ' + 'mouseout mouseover mouseup radius_changed rightclick');
	  mapOverlayDirective('uiMapGroundOverlay', 'click dblclick');
	}());


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var ScoreCardDetailDirective, ScoreCardDirective, ScoreCardParser, ScoreCardUIService, ScoreCardUtilityService, modules, teeOfClubLabelFilter;
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(112);
	
	__webpack_require__(389);
	
	__webpack_require__(278);
	
	__webpack_require__(394);
	
	ScoreCardUIService = __webpack_require__(395);
	
	ScoreCardParser = __webpack_require__(396);
	
	ScoreCardDirective = __webpack_require__(397);
	
	ScoreCardDetailDirective = __webpack_require__(399);
	
	ScoreCardUtilityService = __webpack_require__(408);
	
	teeOfClubLabelFilter = __webpack_require__(409);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-form', 'gnp-number', 'gnp-remote-api', 'gnp-truncate'];
	
	angular.module('gnp-score-card', modules).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(410)).translations('ja', __webpack_require__(411));
	  }
	]).factory("ScoreCardParser", ScoreCardParser).factory("ScoreCardUIService", ScoreCardUIService).factory("ScoreCardUtilityService", ScoreCardUtilityService).directive('gnpScoreCard', ScoreCardDirective).directive('gnpScoreCardDetail', ScoreCardDetailDirective).filter('teeOfClubLabel', teeOfClubLabelFilter);


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var NumberService, SmallSizedDecimalDirective, modules, percentToFormattedString;
	
	__webpack_require__(28);
	
	NumberService = __webpack_require__(390);
	
	SmallSizedDecimalDirective = __webpack_require__(391);
	
	percentToFormattedString = __webpack_require__(393);
	
	modules = [];
	
	angular.module('gnp-number', modules).factory("NumberService", NumberService).directive('gnpSmallSizedDecimal', SmallSizedDecimalDirective).filter('percentToFormattedString', percentToFormattedString);


/***/ }),
/* 390 */
/***/ (function(module, exports) {

	var NumberService;
	
	NumberService = function() {
	  return {
	    limitFractional: function(number, fractionLimit) {
	      var numberParts;
	      if (fractionLimit == null) {
	        fractionLimit = 2;
	      }
	      if (!number) {
	        return;
	      }
	      numberParts = number.toFixed(fractionLimit).match(/\d+/g);
	      return numberParts.join(".");
	    },
	    getFractionalPart: function(number, fractionLimit) {
	      var numberParts;
	      if (fractionLimit == null) {
	        fractionLimit = 2;
	      }
	      if (!number) {
	        return;
	      }
	      numberParts = number.toString().match(/\d+/g);
	      if ((numberParts != null) && numberParts.length > 1) {
	        return '.' + numberParts[1].substring(0, fractionLimit);
	      } else {
	        return ".00";
	      }
	    },
	    getIntegerPart: function(number) {
	      var matches;
	      if (!number) {
	        return;
	      }
	      matches = number.toString().match(/\d+/g);
	      return (matches != null ? matches[0] : void 0) || null;
	    }
	  };
	};
	
	module.exports = NumberService;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var SmallSizedDecimalDirective;
	
	__webpack_require__(392);
	
	SmallSizedDecimalDirective = function(NumberService) {
	  return {
	    restrict: "A",
	    replace: true,
	    templateUrl: "components/number/small-sized-decimal.jade",
	    scope: {
	      floatNumber: '=val',
	      prefix: '@?'
	    },
	    link: function(scope) {
	      return scope.$watch((function() {
	        return scope.floatNumber;
	      }), function() {
	        if (!scope.floatNumber) {
	          return;
	        }
	        if (scope.floatNumber === 0 || scope.floatNumber === 100) {
	          scope.integerPart = scope.floatNumber;
	          scope.fractionPart = '';
	          return;
	        }
	        scope.integerPart = NumberService.getIntegerPart(scope.floatNumber);
	        return scope.fractionPart = NumberService.getFractionalPart(scope.floatNumber);
	      });
	    }
	  };
	};
	
	SmallSizedDecimalDirective.$inject = ['NumberService'];
	
	module.exports = SmallSizedDecimalDirective;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	var v1="<div><div ng-if=\"floatNumber\" class=\"value\">{{ integerPart }}<span class=\"small\">{{ fractionPart }}{{prefix}}</span></div><div ng-if=\"!floatNumber\" class=\"value\">-</div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/number/small-sized-decimal.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	var _, percentToFormattedString;
	
	_ = __webpack_require__(87);
	
	percentToFormattedString = function() {
	  return function(input, sizeDecimal, nonNumberStr) {
	    if (sizeDecimal == null) {
	      sizeDecimal = 2;
	    }
	    if (nonNumberStr == null) {
	      nonNumberStr = '-';
	    }
	    if (input == null) {
	      return nonNumberStr;
	    }
	    if (!_.isFinite(input)) {
	      return nonNumberStr;
	    }
	    if (input === 0) {
	      return input.toString();
	    }
	    if (input === 100) {
	      return input.toString();
	    }
	    return parseFloat(input).toFixed(sizeDecimal);
	  };
	};
	
	module.exports = percentToFormattedString;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var modules;
	
	__webpack_require__(28);
	
	modules = [];
	
	angular.module('gnp-truncate', modules).filter('gnpTruncate', function() {
	  return function(value, wordwise, max, tail) {
	    var lastspace;
	    if (!value) {
	      return '';
	    }
	    max = parseInt(max, 10);
	    if (!max) {
	      return value;
	    }
	    if (value.length <= max) {
	      return value;
	    }
	    value = value.substr(0, max);
	    if (wordwise) {
	      lastspace = value.lastIndexOf(' ');
	      if (lastspace !== -1) {
	        if (value.charAt(lastspace - 1) === '.' || value.charAt(lastspace - 1) === ',') {
	          lastspace = lastspace - 1;
	        }
	        value = value.substr(0, lastspace);
	      }
	    }
	    return value + (tail || ' …');
	  };
	});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var PAR_VALUE_FOR_DISABLE_FAIRWAY, PUTT_DISABLED_VALUE, ScoreCardUIService, _, fairwayOptions, ob_waterOptions, puttOptions, sandOptions, teeOffClubOptions;
	
	_ = __webpack_require__(87);
	
	PUTT_DISABLED_VALUE = '-';
	
	PAR_VALUE_FOR_DISABLE_FAIRWAY = 3;
	
	teeOffClubOptions = [
	  {
	    value: "dr",
	    text: "1W"
	  }, {
	    value: "2w",
	    text: "2W"
	  }, {
	    value: "3w",
	    text: "3W"
	  }, {
	    value: "4w",
	    text: "4W"
	  }, {
	    value: "5w",
	    text: "5W"
	  }, {
	    value: "6w",
	    text: "6W"
	  }, {
	    value: "7w",
	    text: "7W"
	  }, {
	    value: "8w",
	    text: "8W"
	  }, {
	    value: "9w",
	    text: "9W"
	  }, {
	    value: "10w",
	    text: "10W"
	  }, {
	    value: "11w",
	    text: "11W"
	  }, {
	    value: "12w",
	    text: "12W"
	  }, {
	    value: "13w",
	    text: "13W"
	  }, {
	    value: "14w",
	    text: "14W"
	  }, {
	    value: "15w",
	    text: "15W"
	  }, {
	    value: "h1",
	    text: "U1"
	  }, {
	    value: "h2",
	    text: "U2"
	  }, {
	    value: "h3",
	    text: "U3"
	  }, {
	    value: "h4",
	    text: "U4"
	  }, {
	    value: "h5",
	    text: "U5"
	  }, {
	    value: "h6",
	    text: "U6"
	  }, {
	    value: "h7",
	    text: "U7"
	  }, {
	    value: "h8",
	    text: "U8"
	  }, {
	    value: "h9",
	    text: "U9"
	  }, {
	    value: "hh2",
	    text: "2H"
	  }, {
	    value: "hh3",
	    text: "3H"
	  }, {
	    value: "hh4",
	    text: "4H"
	  }, {
	    value: "hh5",
	    text: "5H"
	  }, {
	    value: "hh6",
	    text: "6H"
	  }, {
	    value: "hh7",
	    text: "7H"
	  }, {
	    value: "hh8",
	    text: "8H"
	  }, {
	    value: "1i",
	    text: "1i"
	  }, {
	    value: "2i",
	    text: "2i"
	  }, {
	    value: "3i",
	    text: "3i"
	  }, {
	    value: "4i",
	    text: "4i"
	  }, {
	    value: "5i",
	    text: "5i"
	  }, {
	    value: "6i",
	    text: "6i"
	  }, {
	    value: "7i",
	    text: "7i"
	  }, {
	    value: "8i",
	    text: "8i"
	  }, {
	    value: "9i",
	    text: "9i"
	  }, {
	    value: "10i",
	    text: "10i"
	  }, {
	    value: "11i",
	    text: "11i"
	  }, {
	    value: "12i",
	    text: "12i"
	  }, {
	    value: "pw",
	    text: "PW"
	  }, {
	    value: "dw",
	    text: "DW"
	  }, {
	    value: "gw48",
	    text: "GW"
	  }, {
	    value: "gw",
	    text: "AW"
	  }, {
	    value: "sw",
	    text: "SW"
	  }, {
	    value: "sw54",
	    text: "SW54"
	  }, {
	    value: "sw55",
	    text: "SW55"
	  }, {
	    value: "sw56",
	    text: "SW56"
	  }, {
	    value: "sw57",
	    text: "SW57"
	  }, {
	    value: "sw58",
	    text: "SW58"
	  }, {
	    value: "lw",
	    text: "LW"
	  }, {
	    value: "lw60",
	    text: "LW60"
	  }, {
	    value: "lw61",
	    text: "LW61"
	  }, {
	    value: "lw62",
	    text: "LW62"
	  }, {
	    value: "lw63",
	    text: "LW63"
	  }, {
	    value: "ptt",
	    text: "PT"
	  }
	];
	
	puttOptions = [
	  {
	    value: PUTT_DISABLED_VALUE,
	    text: '-'
	  }
	];
	
	_.times(16, function(i) {
	  return puttOptions.push({
	    value: i,
	    text: i
	  });
	});
	
	ob_waterOptions = [];
	
	_.times(5, function(i) {
	  return ob_waterOptions.push({
	    value: i + 1,
	    text: i + 1
	  });
	});
	
	fairwayOptions = [
	  {
	    value: "center",
	    text: "<div class='circle-red'></div>"
	  }, {
	    value: "left",
	    text: "<div class='arrow-back'></div>"
	  }, {
	    value: "right",
	    text: "<div class='arrow-forward'></div>"
	  }
	];
	
	sandOptions = [
	  {
	    value: false,
	    text: "<div class='empty'></div>"
	  }, {
	    value: true,
	    text: "<div class='check'></div>"
	  }
	];
	
	ScoreCardUIService = function() {
	  var isParOn, updateShotColor;
	  isParOn = function(score) {
	    if (!score.shot_cnt) {
	      return false;
	    }
	    if (score.putt_disabled) {
	      return false;
	    }
	    return ((score.holePar || 0) - score.shot_cnt + score.putt_cnt) >= 2;
	  };
	  updateShotColor = function(score) {
	    var item;
	    item = _.find(score.scoreOptions, function(s) {
	      return s.value === score.shot_cnt;
	    });
	    return score.shotCntColor = item != null ? item.cssClass : void 0;
	  };
	  return {
	    getScoreOptions: function(holePar) {
	      return _.map([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], function(shotCnt) {
	        var item, score;
	        score = shotCnt - holePar;
	        item = (function() {
	          switch (score) {
	            case -4:
	              return {
	                scoreName: 'Condor',
	                cssClass: "condor"
	              };
	            case -3:
	              return {
	                scoreName: 'Albatross',
	                cssClass: 'albatross'
	              };
	            case -2:
	              return {
	                scoreName: 'Eagle',
	                cssClass: 'eagle'
	              };
	            case -1:
	              return {
	                scoreName: 'Birdie',
	                cssClass: 'birdie'
	              };
	            case 0:
	              return {
	                scoreName: 'Par',
	                cssClass: 'par'
	              };
	            case 1:
	              return {
	                scoreName: 'Bogey',
	                cssClass: 'bogey'
	              };
	            case 2:
	              return {
	                scoreName: '2 Bogey',
	                cssClass: 'dbogey'
	              };
	            default:
	              return {
	                scoreName: score + " Bogey",
	                cssClass: 'overTbogey'
	              };
	          }
	        })();
	        return {
	          value: shotCnt,
	          text: shotCnt + "<span class='sub-text'>" + item.scoreName + "</span>",
	          cssClass: item.cssClass
	        };
	      });
	    },
	    getDefaultData: function() {
	      return {
	        puttOptions: puttOptions,
	        teeOffClubOptions: teeOffClubOptions,
	        fairwayOptions: fairwayOptions,
	        ob_waterOptions: ob_waterOptions,
	        sandOptions: sandOptions
	      };
	    },
	    updateShotCntInfo: function(score) {
	      if (!score.shot_cnt) {
	        return;
	      }
	      updateShotColor(score);
	      if (!score.putt_cnt && score.putt_cnt !== 0) {
	        score.putt_cnt = PUTT_DISABLED_VALUE;
	        score.putt_disabled = true;
	      } else if (score.shot_cnt < score.putt_cnt) {
	        score.putt_cnt = score.shot_cnt;
	      }
	      return score.is_par_on = isParOn(score);
	    },
	    updatePuttInfo: function(score) {
	      score.shot_cnt = score.putt_cnt > score.shot_cnt ? score.putt_cnt : score.shot_cnt;
	      updateShotColor(score);
	      score.putt_disabled = score.putt_cnt === PUTT_DISABLED_VALUE;
	      return score.is_par_on = isParOn(score);
	    },
	    PUTT_DISABLED_VALUE: PUTT_DISABLED_VALUE,
	    PAR_VALUE_FOR_DISABLE_FAIRWAY: PAR_VALUE_FOR_DISABLE_FAIRWAY
	  };
	};
	
	module.exports = ScoreCardUIService;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var ScoreCardParser, _, getDefaultScoreValues;
	
	_ = __webpack_require__(87);
	
	getDefaultScoreValues = function(hole_number) {
	  return {
	    hole_number: hole_number,
	    shot_cnt: void 0,
	    putt_cnt: void 0,
	    fairway: void 0,
	    tee_off_club: void 0,
	    sand_shot: void 0,
	    water_hazard: void 0,
	    ob: void 0,
	    is_par_on: void 0
	  };
	};
	
	ScoreCardParser = function() {
	  var calculateTotal, fillGappedScores, fillGappedScoresExtraForPlayer, fillGappedScoresForPlayer, parseScoreCardBoard;
	  calculateTotal = function(scores, isOut) {
	    return _.chain(scores).filter(function(s) {
	      if (!isOut) {
	        return s.hole_number >= 10;
	      }
	      if (isOut) {
	        return s.hole_number < 10;
	      }
	    }).map(function(s) {
	      return {
	        shot_cnt: s.shot_cnt || 0,
	        putt_cnt: s.putt_cnt || 0,
	        water_hazard: s.water_hazard || 0,
	        sand_shot: s.sand_shot || 0,
	        ob: s.ob || 0
	      };
	    }).reduce(function(sum, s) {
	      sum.total_shot += s.shot_cnt;
	      sum.total_putt += s.putt_cnt;
	      sum.total_water_hazard += s.water_hazard;
	      sum.total_sand_shot += s.sand_shot;
	      sum.total_ob += s.ob;
	      return sum;
	    }, {
	      total_shot: 0,
	      total_putt: 0,
	      total_water_hazard: 0,
	      total_sand_shot: 0,
	      total_ob: 0
	    }).value();
	  };
	  fillGappedScoresForPlayer = function(holeSize) {
	    return function(player) {
	      _.times(holeSize, function(i) {
	        if (!(_.find(player.scores, function(s) {
	          return s.hole_number === i + 1;
	        }))) {
	          return player.scores.push(getDefaultScoreValues(i + 1));
	        }
	      });
	      return player.scores = _.chain(player.scores).map(function(s) {
	        if (s.shot_cnt === 0) {
	          return getDefaultScoreValues(s.hole_number);
	        }
	        return s;
	      }).sortBy(function(s) {
	        return s.hole_number;
	      }).value();
	    };
	  };
	  fillGappedScoresExtraForPlayer = function(holeSize, extraIndex) {
	    return function(player) {
	      if (player.scores_extra.length < 9) {
	        _.times(holeSize, function(i) {
	          if (!(_.find(player.scores_extra, function(s) {
	            return s.hole_number === i + extraIndex;
	          }))) {
	            return player.scores_extra.push(getDefaultScoreValues(i + extraIndex));
	          }
	        });
	      }
	      return player.scores_extra = _.chain(player.scores_extra).map(function(s) {
	        if (s.shot_cnt === 0) {
	          return getDefaultScoreValues(s.hole_number);
	        }
	        if (s.shot_cnt || s.putt_cnt) {
	          if (extraIndex === 1 && s.hole_number > 9) {
	            s.hole_number = s.hole_number - 9;
	          } else if (extraIndex === 10 && s.hole_number <= 9) {
	            s.hole_number = s.hole_number + 9;
	          }
	        }
	        return s;
	      }).sortBy(function(s) {
	        return s.hole_number;
	      }).value();
	    };
	  };
	  fillGappedScores = function(scorecard) {
	    var extraIndex, holeSize;
	    holeSize = scorecard.holes.length;
	    _.forEach(scorecard.players, fillGappedScoresForPlayer(holeSize));
	    extraIndex = scorecard.holes_extra && scorecard.holes_extra[0].hole_number > 9 ? 10 : 1;
	    if (scorecard.holes_extra) {
	      _.forEach(scorecard.players, fillGappedScoresExtraForPlayer(scorecard.holes_extra.length, extraIndex));
	    }
	    return scorecard;
	  };
	  parseScoreCardBoard = function(roundInfo, isOut) {
	    var filledRoundInfo, scoreCardBoard;
	    filledRoundInfo = fillGappedScores(_.cloneDeep(roundInfo));
	    scoreCardBoard = {
	      holes: isOut ? _.take(filledRoundInfo.holes, 9) : _.takeRight(filledRoundInfo.holes, 9),
	      players: filledRoundInfo.players ? _.map(filledRoundInfo.players, function(p) {
	        return {
	          id: p.id,
	          name: p.name,
	          scores: isOut ? _.take(p.scores, 9) : _.takeRight(p.scores, 9),
	          isOwner: p === filledRoundInfo.players[0]
	        };
	      }) : null
	    };
	    return scoreCardBoard;
	  };
	  return {
	    parseScoreCardExtraBoard: function(roundInfo) {
	      var filledRoundInfo, scoreCardBoard;
	      filledRoundInfo = fillGappedScores(_.cloneDeep(roundInfo));
	      scoreCardBoard = {
	        holes: _.take(filledRoundInfo.holes_extra, 9),
	        players: filledRoundInfo.players ? _.map(filledRoundInfo.players, function(p) {
	          return {
	            id: p.id,
	            name: p.name,
	            scores: _.take(p.scores_extra, 9),
	            isOwner: p === filledRoundInfo.players[0]
	          };
	        }) : null
	      };
	      return scoreCardBoard;
	    },
	    parseInViewModel: function(roundInfo) {
	      return parseScoreCardBoard(roundInfo, false);
	    },
	    parseOutViewModel: function(roundInfo) {
	      return parseScoreCardBoard(roundInfo, true);
	    },
	    parseTotalViewModel: function(roundInfo, is18Holes) {
	      var total, totalIn, totalOut;
	      totalOut = calculateTotal(roundInfo.players[0].scores, true);
	      if (is18Holes) {
	        totalIn = calculateTotal(roundInfo.players[0].scores, false);
	      }
	      total = {
	        owner_player: _.pick(roundInfo.players[0], ["player_hdcp"]),
	        "in": totalIn || {},
	        out: totalOut
	      };
	      total.gross = _.clone(total.out);
	      if (totalIn) {
	        _.mergeWith(total.gross, total["in"], function(e1, e2) {
	          if (_.isNumber(e1) && _.isNumber(e2)) {
	            return e1 + e2;
	          } else {
	            return e2;
	          }
	        });
	      }
	      return total;
	    }
	  };
	};
	
	module.exports = ScoreCardParser;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var ScoreCardDirective, _;
	
	__webpack_require__(398);
	
	_ = __webpack_require__(87);
	
	ScoreCardDirective = function($filter, AppSettingAPIService, ScoreCardUtilityService, $routeParams) {
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "components/score-card/score-card.jade",
	    scope: {
	      boardType: '@boardType',
	      editMode: '=',
	      course: '=scoreCardCourse',
	      tee: '=scoreCardTee',
	      holes: '=scoreCardHoles',
	      players: '=scoreCardPlayers',
	      updateScores: '&onScoresUpdated'
	    },
	    link: function(scope) {
	      var params;
	      params = {
	        user_id: $routeParams.user_id
	      };
	      AppSettingAPIService.getAppSetting(params).then(function(res) {
	        return scope.isUsingMeter = res.use_meter;
	      });
	      scope.getTotal = function(key) {
	        return _.chain(scope.holes).map(function(s) {
	          return s[key] || 0;
	        }).reduce(function(sum, val) {
	          return sum + val;
	        }).value();
	      };
	      scope.showHoleDistance = function(holeYard) {
	        if (!holeYard) {
	          return "-";
	        }
	        if (scope.isUsingMeter) {
	          return $filter("number")(ScoreCardUtilityService.yardToMeter(holeYard), 0);
	        } else {
	          return $filter("number")(holeYard);
	        }
	      };
	      scope.boardTypeTitle = (function() {
	        switch (scope.boardType) {
	          case 'in':
	            return $filter("translate")("_SCORE_CARD_BOARD.IN");
	          case 'out':
	            return $filter("translate")("_SCORE_CARD_BOARD.OUT");
	          case 'extra':
	            return $filter("translate")("_SCORE_CARD_BOARD.EXTRA");
	          default:
	            return '';
	        }
	      })();
	      return scope.$watch((function() {
	        return scope.players;
	      }), function() {
	        if (scope.updateScores()) {
	          return scope.updateScores()(scope.players, scope.boardType);
	        }
	      }, true);
	    }
	  };
	};
	
	ScoreCardDirective.$inject = ["$filter", "AppSettingAPIService", "ScoreCardUtilityService", "$routeParams"];
	
	module.exports = ScoreCardDirective;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	var v1="<div class=\"score-board-app\"><div class=\"row mx-0\"><div class=\"col-12 no-padding\"><div class=\"score-title\">{{ boardTypeTitle }}: {{ course.name }}</div></div></div><div class=\"score-header row\"><div class=\"col-1\"><div class=\"hole header title-board\">{{ :: \"_SCORE_CARD_BOARD.HOLE\" | translate }}</div><div class=\"d-block d-sm-none\"><div class=\"hole header title-board\">{{ tee.name ? tee.name : '-' | gnpTruncate:true:10:' ...' }}</div></div><div class=\"d-none d-sm-block\"><div class=\"hole header title-board\">{{ tee.name ? tee.name : '-' | gnpTruncate:true:25:' ...' }}</div></div><div class=\"hole header title-board\">{{ :: \"_SCORE_CARD_BOARD.PAR\" | translate }}</div></div><div ng-repeat=\"hole in holes\" class=\"col-2\"><div class=\"hole\">{{$index + 1}}</div><div class=\"hole\">{{ showHoleDistance(hole.yard) }}</div><div class=\"hole\">{{hole.par}}</div></div><div class=\"col-3\"><div class=\"hole header\">TOTAL</div><div class=\"hole header\">{{ showHoleDistance(getTotal('yard')) }}</div><div class=\"hole header\">{{ getTotal('par') }}</div></div></div><div gnp-score-card-detail=\"\" edit-mode=\"editMode\" score-card-holes=\"holes\" score-card-player=\"player\" ng-repeat=\"player in players track by player.id\"></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/score-card/score-card.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var ScoreCardDetailDirective, _;
	
	__webpack_require__(400);
	
	__webpack_require__(401);
	
	__webpack_require__(402);
	
	__webpack_require__(403);
	
	__webpack_require__(404);
	
	__webpack_require__(405);
	
	__webpack_require__(406);
	
	__webpack_require__(407);
	
	_ = __webpack_require__(87);
	
	ScoreCardDetailDirective = function($filter, ScoreCardUIService) {
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "components/score-card/score-card-detail.jade",
	    scope: {
	      holes: '=scoreCardHoles',
	      player: '=scoreCardPlayer',
	      editMode: '='
	    },
	    link: function(scope) {
	      scope.defaultData = ScoreCardUIService.getDefaultData();
	      scope.boardTypeTitle = (function() {
	        switch (scope.boardType) {
	          case 'in':
	            return $filter("translate")("_SCORE_CARD_BOARD.IN");
	          case 'out':
	            return $filter("translate")("_SCORE_CARD_BOARD.OUT");
	        }
	      })();
	      scope.getTotal = function(key) {
	        return _.chain(scope.player.scores).map(function(s) {
	          return s[key] || 0;
	        }).reduce(function(sum, val) {
	          return sum + val;
	        }).value();
	      };
	      scope.getTotalPutt = function() {
	        return _.chain(scope.player.scores).map(function(s) {
	          return s.putt_cnt || 0;
	        }).reduce(function(sum, val) {
	          return sum + (val === ScoreCardUIService.PUTT_DISABLED_VALUE ? 0 : val);
	        }, 0).value();
	      };
	      scope.getTotalFairway = function() {
	        var result;
	        result = _.chain(scope.player.scores).map(function(s) {
	          if (s.holePar === 3) {
	            return;
	          }
	          return s.fairway;
	        }).reduce(function(result, val) {
	          if (val) {
	            ++result.denominator;
	          }
	          if (val === 'center') {
	            ++result.numerator;
	          }
	          return result;
	        }, {
	          denominator: 0,
	          numerator: 0
	        }).value();
	        if (result.numerator === 0) {
	          return 0;
	        }
	        return (result.numerator / result.denominator) * 100;
	      };
	      scope.getTotalParOn = function() {
	        var result;
	        result = _.chain(scope.player.scores).reduce(function(result, score) {
	          if (score.shot_cnt && !score.putt_disabled) {
	            ++result.denominator;
	          }
	          if (score.is_par_on) {
	            ++result.numerator;
	          }
	          return result;
	        }, {
	          denominator: 0,
	          numerator: 0
	        }).value();
	        if (result.numerator === 0) {
	          return 0;
	        }
	        return (result.numerator / result.denominator) * 100;
	      };
	      scope.getTotalSandShot = function() {
	        return _.chain(scope.player.scores).map(function(s) {
	          return s.sand_shot;
	        }).reduce(function(sum, val) {
	          return sum + (val ? 1 : 0);
	        }, 0).value();
	      };
	      scope.getFairwayCssClass = function(fairway) {
	        if (scope.editMode) {
	          return "";
	        }
	        switch (fairway) {
	          case "center":
	            return "circle-red";
	          case "left":
	            return "arrow-back";
	          case "right":
	            return "arrow-forward";
	        }
	      };
	      scope.valueUpdated = function(score, type) {
	        if (type === 'shot_cnt') {
	          return ScoreCardUIService.updateShotCntInfo(score);
	        } else if (type === 'putt_cnt') {
	          return ScoreCardUIService.updatePuttInfo(score);
	        }
	      };
	      scope.isShotEntered = function(score) {
	        if (score != null ? score.shot_cnt : void 0) {
	          return true;
	        }
	      };
	      scope.allowEnterFairwayHit = function(score) {
	        return score.holePar !== ScoreCardUIService.PAR_VALUE_FOR_DISABLE_FAIRWAY;
	      };
	      return scope.$watch((function() {
	        return scope.player;
	      }), function() {
	        if (!scope.player) {
	          return;
	        }
	        return _.forEach(scope.player.scores, function(score, index) {
	          score.holePar = scope.holes[index].par;
	          if (score.putt_disabled) {
	            score.putt_cnt = ScoreCardUIService.PUTT_DISABLED_VALUE;
	          }
	          score.scoreOptions = ScoreCardUIService.getScoreOptions(score.holePar);
	          ScoreCardUIService.updateShotCntInfo(score);
	        });
	      });
	    }
	  };
	};
	
	ScoreCardDetailDirective.$inject = ["$filter", "ScoreCardUIService"];
	
	module.exports = ScoreCardDetailDirective;


/***/ }),
/* 400 */
/***/ (function(module, exports) {

	var v1="<div class=\"score-body row\"><div class=\"col-1\"><div ng-class=\"player.isOwner ? 'header-sub' : ''\" class=\"hole header player\">{{ player.isOwner ? ('SCORE' | translate) : player.name }}</div><div ng-class=\"player.isOwner ? 'header-sub' : ''\" class=\"hole header even\">{{:: 'PUTTS' | translate }}</div><div ng-if=\"player.isOwner\" class=\"hole header header-sub\"><span class=\"title-score\">{{:: \"_SCORE_CARD_BOARD.TEE_OFF_CLUB\" | translate }}</span></div><div ng-if=\"player.isOwner\" class=\"hole header header-sub even\"><span class=\"title-score\">{{:: \"_SCORE_CARD_BOARD.FAIRWAY_HIT\" | translate }}</span></div><div ng-if=\"player.isOwner\" class=\"hole header header-sub\">{{:: \"_SCORE_CARD_BOARD.PAR_ON\" | translate }}</div><div ng-if=\"player.isOwner\" class=\"hole header header-sub even\"><span class=\"title-score\">{{:: \"_SCORE_CARD_BOARD.SAND_SAVES\" | translate }}</span></div><div ng-if=\"player.isOwner\" class=\"hole header header-sub\">{{:: \"_SCORE_CARD_BOARD.OB\" | translate }}</div><div ng-if=\"player.isOwner\" class=\"hole header header-sub even\"><span class=\"title-score\">{{:: \"_SCORE_CARD_BOARD.WATER_HAZARD\" | translate }}</span></div></div><div ng-repeat=\"pScore in player.scores\" class=\"col-2\"><div class=\"hole myscore {{editMode ? '' : pScore.shotCntColor}}\"><div ng-include=\"'score-card/templates/shot.jade'\" ng-repeat=\"score in [pScore]\"></div></div><div class=\"hole myscore even\"><div ng-include=\"'score-card/templates/putt.jade'\" ng-repeat=\"score in [pScore]\"></div></div><div ng-if=\"player.isOwner\" class=\"hole myscore\"><div ng-include=\"'score-card/templates/tee-off-club.jade'\" ng-repeat=\"score in [pScore]\"></div></div><div ng-if=\"player.isOwner\" ng-class=\"getFairwayCssClass(pScore.fairway)\" class=\"hole myscore even\"><div ng-include=\"'score-card/templates/fairway.jade'\" ng-repeat=\"score in [pScore]\"></div></div><div ng-if=\"player.isOwner\" ng-class=\"pScore.is_par_on ? 'circle-green' : ''\" class=\"hole myscore\">&nbsp;</div><div ng-if=\"player.isOwner\" ng-class=\"(pScore.sand_shot &amp;&amp; !editMode) ? 'check': ''\" class=\"hole myscore even\"><div ng-include=\"'score-card/templates/sand.jade'\" ng-repeat=\"score in [pScore]\"></div></div><div ng-if=\"player.isOwner\" class=\"hole myscore\"><div ng-include=\"'score-card/templates/ob.jade'\" ng-repeat=\"score in [pScore]\"></div></div><div ng-if=\"player.isOwner\" class=\"hole myscore even\"><div ng-include=\"'score-card/templates/water.jade'\" ng-repeat=\"score in [pScore]\"></div></div></div><div class=\"col-3\"><div class=\"hole header\">{{ getTotal('shot_cnt') }}</div><div class=\"hole header even\">{{ getTotalPutt() }}</div><div ng-if=\"player.isOwner\" class=\"hole header\">&nbsp;</div><div ng-if=\"player.isOwner\" class=\"hole header even\">{{ getTotalFairway() | percentToFormattedString }}%</div><div ng-if=\"player.isOwner\" class=\"hole header\">{{ getTotalParOn() | percentToFormattedString }}%</div><div ng-if=\"player.isOwner\" class=\"hole header even\">{{ getTotalSandShot() }}</div><div ng-if=\"player.isOwner\" class=\"hole header\">{{ getTotal('ob') }}</div><div ng-if=\"player.isOwner\" class=\"hole header even\">{{ getTotal('water_hazard') }}</div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/score-card/score-card-detail.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 401 */
/***/ (function(module, exports) {

	var v1="<span ng-if=\"editMode\" class=\"column-input\"><span gnp-custom-select=\"\" ng-model=\"score.fairway\" disable=\"!isShotEntered(score) || !allowEnterFairwayHit(score)\" options=\"defaultData.fairwayOptions\" class=\"input gray\"></span></span>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/fairway.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	var v1="<span ng-if=\"!editMode\">{{ score.ob != 0 ? score.ob : ''}}</span><span ng-if=\"editMode\" class=\"column-input\"><span gnp-custom-select=\"\" empty-value=\"true\" ng-model=\"score.ob\" disable=\"!isShotEntered(score)\" options=\"defaultData.ob_waterOptions\" class=\"input white\"></span></span>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/ob.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	var v1="<span ng-if=\"!editMode\">{{score.putt_cnt }}</span><span ng-if=\"editMode\" class=\"column-input\"><span ng-change=\"valueUpdated(score, 'putt_cnt')\" gnp-custom-select=\"\" ng-model=\"score.putt_cnt\" disable=\"!isShotEntered(score)\" options=\"defaultData.puttOptions\" class=\"input gray\"></span></span>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/putt.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	var v1="<span ng-if=\"editMode\" class=\"column-input\"><span gnp-custom-select=\"\" ng-model=\"score.sand_shot\" disable=\"!isShotEntered(score)\" options=\"defaultData.sandOptions\" class=\"input gray\"></span></span>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/sand.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	var v1="<span ng-if=\"!editMode\">{{ score.shot_cnt }}</span><span ng-if=\"editMode\" class=\"column-input\"><span ng-change=\"valueUpdated(score, 'shot_cnt')\" gnp-custom-select=\"\" ng-model=\"score.shot_cnt\" display-property=\"value\" options=\"score.scoreOptions\" class=\"input {{score.shot_cnt ? score.shotCntColor : 'normal'}} shot\"></span></span>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/shot.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	var v1="<span ng-if=\"!editMode\">{{ score.tee_off_club | teeOfClubLabel }}</span><span ng-if=\"editMode\" class=\"column-input\"><span gnp-custom-select=\"\" ng-model=\"score.tee_off_club\" disable=\"!isShotEntered(score)\" options=\"defaultData.teeOffClubOptions\" class=\"input white\"></span></span>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/tee-off-club.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	var v1="<span ng-if=\"!editMode\">{{ score.water_hazard != 0 ? score.water_hazard : '' }}</span><span ng-if=\"editMode\" class=\"column-input\"><span gnp-custom-select=\"\" empty-value=\"true\" ng-model=\"score.water_hazard\" disable=\"!isShotEntered(score)\" options=\"defaultData.ob_waterOptions\" class=\"input gray\"></span></span>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/water.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	var ScoreCardUtilityService;
	
	ScoreCardUtilityService = function() {
	  return {
	    yardToMeter: function(yard) {
	      if (yard) {
	        return yard * 0.9144;
	      }
	    }
	  };
	};
	
	module.exports = ScoreCardUtilityService;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	var _, teeOfClubLabelFilter;
	
	_ = __webpack_require__(87);
	
	teeOfClubLabelFilter = function(ScoreCardUIService) {
	  return function(input) {
	    var option;
	    if (!input) {
	      return;
	    }
	    option = _.find(ScoreCardUIService.getDefaultData().teeOffClubOptions, function(t) {
	      return t.value === input;
	    });
	    return option != null ? option.text : void 0;
	  };
	};
	
	teeOfClubLabelFilter.$inject = ['ScoreCardUIService'];
	
	module.exports = teeOfClubLabelFilter;


/***/ }),
/* 410 */
/***/ (function(module, exports) {

	module.exports = {
	  '_SCORE_CARD_BOARD': {
	    'OUT': "OUT",
	    'IN': "IN",
	    'EXTRA': "EXTRA",
	    'HOLE': "Hole",
	    'PAR': "Par",
	    'TEE_OFF_CLUB': "Tee Off Club",
	    'FAIRWAY_HIT': "Fairway Hit On Drive",
	    'PAR_ON': "GIR",
	    'SAND_SAVES': "Sand Saves",
	    'OB': "OB",
	    'WATER_HAZARD': "Water"
	  }
	};


/***/ }),
/* 411 */
/***/ (function(module, exports) {

	module.exports = {
	  '_SCORE_CARD_BOARD': {
	    'OUT': "OUT",
	    'IN': "IN",
	    'EXTRA': "EXTRA",
	    'HOLE': "ホール",
	    'PAR': "パー",
	    'TEE_OFF_CLUB': "ティーオフクラブ",
	    'FAIRWAY_HIT': "フェアウェイ",
	    'PAR_ON': "パーオン",
	    'SAND_SAVES': "ガードバンカー",
	    'OB': "OB",
	    'WATER_HAZARD': "ウォーターハザード・PN"
	  }
	};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var IndicatorDirective, modules;
	
	__webpack_require__(28);
	
	IndicatorDirective = __webpack_require__(413);
	
	modules = [];
	
	angular.module('gnp-animate', modules).directive('gnpIndicator', IndicatorDirective);


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var IndicatorDirective;
	
	__webpack_require__(414);
	
	IndicatorDirective = function() {
	  return {
	    restrict: 'A',
	    scope: {
	      isLoading: "=gnpIndicator"
	    },
	    replace: true,
	    link: function(scope, elem) {
	      return scope.$watch('isLoading', function() {
	        if (scope.isLoading) {
	          return elem.block({
	            message: '<div class="loader">Loading...</div>',
	            css: {
	              border: "none",
	              backgroundColor: 'transparent'
	            },
	            overlayCSS: {
	              backgroundColor: '#fff',
	              opacity: 0.3
	            }
	          });
	        } else {
	          return elem.unblock();
	        }
	      });
	    }
	  };
	};
	
	module.exports = IndicatorDirective;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * jQuery blockUI plugin
	 * Version 2.70.0-2014.11.23
	 * Requires jQuery v1.7 or later
	 *
	 * Examples at: http://malsup.com/jquery/block/
	 * Copyright (c) 2007-2013 M. Alsup
	 * Dual licensed under the MIT and GPL licenses:
	 * http://www.opensource.org/licenses/mit-license.php
	 * http://www.gnu.org/licenses/gpl.html
	 *
	 * Thanks to Amir-Hossein Sobhi for some excellent contributions!
	 */
	
	;(function() {
	/*jshint eqeqeq:false curly:false latedef:false */
	"use strict";
	
		function setup($) {
			$.fn._fadeIn = $.fn.fadeIn;
	
			var noOp = $.noop || function() {};
	
			// this bit is to ensure we don't call setExpression when we shouldn't (with extra muscle to handle
			// confusing userAgent strings on Vista)
			var msie = /MSIE/.test(navigator.userAgent);
			var ie6  = /MSIE 6.0/.test(navigator.userAgent) && ! /MSIE 8.0/.test(navigator.userAgent);
			var mode = document.documentMode || 0;
			var setExpr = $.isFunction( document.createElement('div').style.setExpression );
	
			// global $ methods for blocking/unblocking the entire page
			$.blockUI   = function(opts) { install(window, opts); };
			$.unblockUI = function(opts) { remove(window, opts); };
	
			// convenience method for quick growl-like notifications  (http://www.google.com/search?q=growl)
			$.growlUI = function(title, message, timeout, onClose) {
				var $m = $('<div class="growlUI"></div>');
				if (title) $m.append('<h1>'+title+'</h1>');
				if (message) $m.append('<h2>'+message+'</h2>');
				if (timeout === undefined) timeout = 3000;
	
				// Added by konapun: Set timeout to 30 seconds if this growl is moused over, like normal toast notifications
				var callBlock = function(opts) {
					opts = opts || {};
	
					$.blockUI({
						message: $m,
						fadeIn : typeof opts.fadeIn  !== 'undefined' ? opts.fadeIn  : 700,
						fadeOut: typeof opts.fadeOut !== 'undefined' ? opts.fadeOut : 1000,
						timeout: typeof opts.timeout !== 'undefined' ? opts.timeout : timeout,
						centerY: false,
						showOverlay: false,
						onUnblock: onClose,
						css: $.blockUI.defaults.growlCSS
					});
				};
	
				callBlock();
				var nonmousedOpacity = $m.css('opacity');
				$m.mouseover(function() {
					callBlock({
						fadeIn: 0,
						timeout: 30000
					});
	
					var displayBlock = $('.blockMsg');
					displayBlock.stop(); // cancel fadeout if it has started
					displayBlock.fadeTo(300, 1); // make it easier to read the message by removing transparency
				}).mouseout(function() {
					$('.blockMsg').fadeOut(1000);
				});
				// End konapun additions
			};
	
			// plugin method for blocking element content
			$.fn.block = function(opts) {
				if ( this[0] === window ) {
					$.blockUI( opts );
					return this;
				}
				var fullOpts = $.extend({}, $.blockUI.defaults, opts || {});
				this.each(function() {
					var $el = $(this);
					if (fullOpts.ignoreIfBlocked && $el.data('blockUI.isBlocked'))
						return;
					$el.unblock({ fadeOut: 0 });
				});
	
				return this.each(function() {
					if ($.css(this,'position') == 'static') {
						this.style.position = 'relative';
						$(this).data('blockUI.static', true);
					}
					this.style.zoom = 1; // force 'hasLayout' in ie
					install(this, opts);
				});
			};
	
			// plugin method for unblocking element content
			$.fn.unblock = function(opts) {
				if ( this[0] === window ) {
					$.unblockUI( opts );
					return this;
				}
				return this.each(function() {
					remove(this, opts);
				});
			};
	
			$.blockUI.version = 2.70; // 2nd generation blocking at no extra cost!
	
			// override these in your code to change the default behavior and style
			$.blockUI.defaults = {
				// message displayed when blocking (use null for no message)
				message:  '<h1>Please wait...</h1>',
	
				title: null,		// title string; only used when theme == true
				draggable: true,	// only used when theme == true (requires jquery-ui.js to be loaded)
	
				theme: false, // set to true to use with jQuery UI themes
	
				// styles for the message when blocking; if you wish to disable
				// these and use an external stylesheet then do this in your code:
				// $.blockUI.defaults.css = {};
				css: {
					padding:	0,
					margin:		0,
					width:		'30%',
					top:		'40%',
					left:		'35%',
					textAlign:	'center',
					color:		'#000',
					border:		'3px solid #aaa',
					backgroundColor:'#fff',
					cursor:		'wait'
				},
	
				// minimal style set used when themes are used
				themedCSS: {
					width:	'30%',
					top:	'40%',
					left:	'35%'
				},
	
				// styles for the overlay
				overlayCSS:  {
					backgroundColor:	'#000',
					opacity:			0.6,
					cursor:				'wait'
				},
	
				// style to replace wait cursor before unblocking to correct issue
				// of lingering wait cursor
				cursorReset: 'default',
	
				// styles applied when using $.growlUI
				growlCSS: {
					width:		'350px',
					top:		'10px',
					left:		'',
					right:		'10px',
					border:		'none',
					padding:	'5px',
					opacity:	0.6,
					cursor:		'default',
					color:		'#fff',
					backgroundColor: '#000',
					'-webkit-border-radius':'10px',
					'-moz-border-radius':	'10px',
					'border-radius':		'10px'
				},
	
				// IE issues: 'about:blank' fails on HTTPS and javascript:false is s-l-o-w
				// (hat tip to Jorge H. N. de Vasconcelos)
				/*jshint scripturl:true */
				iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank',
	
				// force usage of iframe in non-IE browsers (handy for blocking applets)
				forceIframe: false,
	
				// z-index for the blocking overlay
				baseZ: 1000,
	
				// set these to true to have the message automatically centered
				centerX: true, // <-- only effects element blocking (page block controlled via css above)
				centerY: true,
	
				// allow body element to be stetched in ie6; this makes blocking look better
				// on "short" pages.  disable if you wish to prevent changes to the body height
				allowBodyStretch: true,
	
				// enable if you want key and mouse events to be disabled for content that is blocked
				bindEvents: true,
	
				// be default blockUI will supress tab navigation from leaving blocking content
				// (if bindEvents is true)
				constrainTabKey: true,
	
				// fadeIn time in millis; set to 0 to disable fadeIn on block
				fadeIn:  200,
	
				// fadeOut time in millis; set to 0 to disable fadeOut on unblock
				fadeOut:  400,
	
				// time in millis to wait before auto-unblocking; set to 0 to disable auto-unblock
				timeout: 0,
	
				// disable if you don't want to show the overlay
				showOverlay: true,
	
				// if true, focus will be placed in the first available input field when
				// page blocking
				focusInput: true,
	
	            // elements that can receive focus
	            focusableElements: ':input:enabled:visible',
	
				// suppresses the use of overlay styles on FF/Linux (due to performance issues with opacity)
				// no longer needed in 2012
				// applyPlatformOpacityRules: true,
	
				// callback method invoked when fadeIn has completed and blocking message is visible
				onBlock: null,
	
				// callback method invoked when unblocking has completed; the callback is
				// passed the element that has been unblocked (which is the window object for page
				// blocks) and the options that were passed to the unblock call:
				//	onUnblock(element, options)
				onUnblock: null,
	
				// callback method invoked when the overlay area is clicked.
				// setting this will turn the cursor to a pointer, otherwise cursor defined in overlayCss will be used.
				onOverlayClick: null,
	
				// don't ask; if you really must know: http://groups.google.com/group/jquery-en/browse_thread/thread/36640a8730503595/2f6a79a77a78e493#2f6a79a77a78e493
				quirksmodeOffsetHack: 4,
	
				// class name of the message block
				blockMsgClass: 'blockMsg',
	
				// if it is already blocked, then ignore it (don't unblock and reblock)
				ignoreIfBlocked: false
			};
	
			// private data and functions follow...
	
			var pageBlock = null;
			var pageBlockEls = [];
	
			function install(el, opts) {
				var css, themedCSS;
				var full = (el == window);
				var msg = (opts && opts.message !== undefined ? opts.message : undefined);
				opts = $.extend({}, $.blockUI.defaults, opts || {});
	
				if (opts.ignoreIfBlocked && $(el).data('blockUI.isBlocked'))
					return;
	
				opts.overlayCSS = $.extend({}, $.blockUI.defaults.overlayCSS, opts.overlayCSS || {});
				css = $.extend({}, $.blockUI.defaults.css, opts.css || {});
				if (opts.onOverlayClick)
					opts.overlayCSS.cursor = 'pointer';
	
				themedCSS = $.extend({}, $.blockUI.defaults.themedCSS, opts.themedCSS || {});
				msg = msg === undefined ? opts.message : msg;
	
				// remove the current block (if there is one)
				if (full && pageBlock)
					remove(window, {fadeOut:0});
	
				// if an existing element is being used as the blocking content then we capture
				// its current place in the DOM (and current display style) so we can restore
				// it when we unblock
				if (msg && typeof msg != 'string' && (msg.parentNode || msg.jquery)) {
					var node = msg.jquery ? msg[0] : msg;
					var data = {};
					$(el).data('blockUI.history', data);
					data.el = node;
					data.parent = node.parentNode;
					data.display = node.style.display;
					data.position = node.style.position;
					if (data.parent)
						data.parent.removeChild(node);
				}
	
				$(el).data('blockUI.onUnblock', opts.onUnblock);
				var z = opts.baseZ;
	
				// blockUI uses 3 layers for blocking, for simplicity they are all used on every platform;
				// layer1 is the iframe layer which is used to supress bleed through of underlying content
				// layer2 is the overlay layer which has opacity and a wait cursor (by default)
				// layer3 is the message content that is displayed while blocking
				var lyr1, lyr2, lyr3, s;
				if (msie || opts.forceIframe)
					lyr1 = $('<iframe class="blockUI" style="z-index:'+ (z++) +';display:none;border:none;margin:0;padding:0;position:absolute;width:100%;height:100%;top:0;left:0" src="'+opts.iframeSrc+'"></iframe>');
				else
					lyr1 = $('<div class="blockUI" style="display:none"></div>');
	
				if (opts.theme)
					lyr2 = $('<div class="blockUI blockOverlay ui-widget-overlay" style="z-index:'+ (z++) +';display:none"></div>');
				else
					lyr2 = $('<div class="blockUI blockOverlay" style="z-index:'+ (z++) +';display:none;border:none;margin:0;padding:0;width:100%;height:100%;top:0;left:0"></div>');
	
				if (opts.theme && full) {
					s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage ui-dialog ui-widget ui-corner-all" style="z-index:'+(z+10)+';display:none;position:fixed">';
					if ( opts.title ) {
						s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">'+(opts.title || '&nbsp;')+'</div>';
					}
					s += '<div class="ui-widget-content ui-dialog-content"></div>';
					s += '</div>';
				}
				else if (opts.theme) {
					s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement ui-dialog ui-widget ui-corner-all" style="z-index:'+(z+10)+';display:none;position:absolute">';
					if ( opts.title ) {
						s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">'+(opts.title || '&nbsp;')+'</div>';
					}
					s += '<div class="ui-widget-content ui-dialog-content"></div>';
					s += '</div>';
				}
				else if (full) {
					s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage" style="z-index:'+(z+10)+';display:none;position:fixed"></div>';
				}
				else {
					s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement" style="z-index:'+(z+10)+';display:none;position:absolute"></div>';
				}
				lyr3 = $(s);
	
				// if we have a message, style it
				if (msg) {
					if (opts.theme) {
						lyr3.css(themedCSS);
						lyr3.addClass('ui-widget-content');
					}
					else
						lyr3.css(css);
				}
	
				// style the overlay
				if (!opts.theme /*&& (!opts.applyPlatformOpacityRules)*/)
					lyr2.css(opts.overlayCSS);
				lyr2.css('position', full ? 'fixed' : 'absolute');
	
				// make iframe layer transparent in IE
				if (msie || opts.forceIframe)
					lyr1.css('opacity',0.0);
	
				//$([lyr1[0],lyr2[0],lyr3[0]]).appendTo(full ? 'body' : el);
				var layers = [lyr1,lyr2,lyr3], $par = full ? $('body') : $(el);
				$.each(layers, function() {
					this.appendTo($par);
				});
	
				if (opts.theme && opts.draggable && $.fn.draggable) {
					lyr3.draggable({
						handle: '.ui-dialog-titlebar',
						cancel: 'li'
					});
				}
	
				// ie7 must use absolute positioning in quirks mode and to account for activex issues (when scrolling)
				var expr = setExpr && (!$.support.boxModel || $('object,embed', full ? null : el).length > 0);
				if (ie6 || expr) {
					// give body 100% height
					if (full && opts.allowBodyStretch && $.support.boxModel)
						$('html,body').css('height','100%');
	
					// fix ie6 issue when blocked element has a border width
					if ((ie6 || !$.support.boxModel) && !full) {
						var t = sz(el,'borderTopWidth'), l = sz(el,'borderLeftWidth');
						var fixT = t ? '(0 - '+t+')' : 0;
						var fixL = l ? '(0 - '+l+')' : 0;
					}
	
					// simulate fixed position
					$.each(layers, function(i,o) {
						var s = o[0].style;
						s.position = 'absolute';
						if (i < 2) {
							if (full)
								s.setExpression('height','Math.max(document.body.scrollHeight, document.body.offsetHeight) - (jQuery.support.boxModel?0:'+opts.quirksmodeOffsetHack+') + "px"');
							else
								s.setExpression('height','this.parentNode.offsetHeight + "px"');
							if (full)
								s.setExpression('width','jQuery.support.boxModel && document.documentElement.clientWidth || document.body.clientWidth + "px"');
							else
								s.setExpression('width','this.parentNode.offsetWidth + "px"');
							if (fixL) s.setExpression('left', fixL);
							if (fixT) s.setExpression('top', fixT);
						}
						else if (opts.centerY) {
							if (full) s.setExpression('top','(document.documentElement.clientHeight || document.body.clientHeight) / 2 - (this.offsetHeight / 2) + (blah = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "px"');
							s.marginTop = 0;
						}
						else if (!opts.centerY && full) {
							var top = (opts.css && opts.css.top) ? parseInt(opts.css.top, 10) : 0;
							var expression = '((document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + '+top+') + "px"';
							s.setExpression('top',expression);
						}
					});
				}
	
				// show the message
				if (msg) {
					if (opts.theme)
						lyr3.find('.ui-widget-content').append(msg);
					else
						lyr3.append(msg);
					if (msg.jquery || msg.nodeType)
						$(msg).show();
				}
	
				if ((msie || opts.forceIframe) && opts.showOverlay)
					lyr1.show(); // opacity is zero
				if (opts.fadeIn) {
					var cb = opts.onBlock ? opts.onBlock : noOp;
					var cb1 = (opts.showOverlay && !msg) ? cb : noOp;
					var cb2 = msg ? cb : noOp;
					if (opts.showOverlay)
						lyr2._fadeIn(opts.fadeIn, cb1);
					if (msg)
						lyr3._fadeIn(opts.fadeIn, cb2);
				}
				else {
					if (opts.showOverlay)
						lyr2.show();
					if (msg)
						lyr3.show();
					if (opts.onBlock)
						opts.onBlock.bind(lyr3)();
				}
	
				// bind key and mouse events
				bind(1, el, opts);
	
				if (full) {
					pageBlock = lyr3[0];
					pageBlockEls = $(opts.focusableElements,pageBlock);
					if (opts.focusInput)
						setTimeout(focus, 20);
				}
				else
					center(lyr3[0], opts.centerX, opts.centerY);
	
				if (opts.timeout) {
					// auto-unblock
					var to = setTimeout(function() {
						if (full)
							$.unblockUI(opts);
						else
							$(el).unblock(opts);
					}, opts.timeout);
					$(el).data('blockUI.timeout', to);
				}
			}
	
			// remove the block
			function remove(el, opts) {
				var count;
				var full = (el == window);
				var $el = $(el);
				var data = $el.data('blockUI.history');
				var to = $el.data('blockUI.timeout');
				if (to) {
					clearTimeout(to);
					$el.removeData('blockUI.timeout');
				}
				opts = $.extend({}, $.blockUI.defaults, opts || {});
				bind(0, el, opts); // unbind events
	
				if (opts.onUnblock === null) {
					opts.onUnblock = $el.data('blockUI.onUnblock');
					$el.removeData('blockUI.onUnblock');
				}
	
				var els;
				if (full) // crazy selector to handle odd field errors in ie6/7
					els = $('body').children().filter('.blockUI').add('body > .blockUI');
				else
					els = $el.find('>.blockUI');
	
				// fix cursor issue
				if ( opts.cursorReset ) {
					if ( els.length > 1 )
						els[1].style.cursor = opts.cursorReset;
					if ( els.length > 2 )
						els[2].style.cursor = opts.cursorReset;
				}
	
				if (full)
					pageBlock = pageBlockEls = null;
	
				if (opts.fadeOut) {
					count = els.length;
					els.stop().fadeOut(opts.fadeOut, function() {
						if ( --count === 0)
							reset(els,data,opts,el);
					});
				}
				else
					reset(els, data, opts, el);
			}
	
			// move blocking element back into the DOM where it started
			function reset(els,data,opts,el) {
				var $el = $(el);
				if ( $el.data('blockUI.isBlocked') )
					return;
	
				els.each(function(i,o) {
					// remove via DOM calls so we don't lose event handlers
					if (this.parentNode)
						this.parentNode.removeChild(this);
				});
	
				if (data && data.el) {
					data.el.style.display = data.display;
					data.el.style.position = data.position;
					data.el.style.cursor = 'default'; // #59
					if (data.parent)
						data.parent.appendChild(data.el);
					$el.removeData('blockUI.history');
				}
	
				if ($el.data('blockUI.static')) {
					$el.css('position', 'static'); // #22
				}
	
				if (typeof opts.onUnblock == 'function')
					opts.onUnblock(el,opts);
	
				// fix issue in Safari 6 where block artifacts remain until reflow
				var body = $(document.body), w = body.width(), cssW = body[0].style.width;
				body.width(w-1).width(w);
				body[0].style.width = cssW;
			}
	
			// bind/unbind the handler
			function bind(b, el, opts) {
				var full = el == window, $el = $(el);
	
				// don't bother unbinding if there is nothing to unbind
				if (!b && (full && !pageBlock || !full && !$el.data('blockUI.isBlocked')))
					return;
	
				$el.data('blockUI.isBlocked', b);
	
				// don't bind events when overlay is not in use or if bindEvents is false
				if (!full || !opts.bindEvents || (b && !opts.showOverlay))
					return;
	
				// bind anchors and inputs for mouse and key events
				var events = 'mousedown mouseup keydown keypress keyup touchstart touchend touchmove';
				if (b)
					$(document).bind(events, opts, handler);
				else
					$(document).unbind(events, handler);
	
			// former impl...
			//		var $e = $('a,:input');
			//		b ? $e.bind(events, opts, handler) : $e.unbind(events, handler);
			}
	
			// event handler to suppress keyboard/mouse events when blocking
			function handler(e) {
				// allow tab navigation (conditionally)
				if (e.type === 'keydown' && e.keyCode && e.keyCode == 9) {
					if (pageBlock && e.data.constrainTabKey) {
						var els = pageBlockEls;
						var fwd = !e.shiftKey && e.target === els[els.length-1];
						var back = e.shiftKey && e.target === els[0];
						if (fwd || back) {
							setTimeout(function(){focus(back);},10);
							return false;
						}
					}
				}
				var opts = e.data;
				var target = $(e.target);
				if (target.hasClass('blockOverlay') && opts.onOverlayClick)
					opts.onOverlayClick(e);
	
				// allow events within the message content
				if (target.parents('div.' + opts.blockMsgClass).length > 0)
					return true;
	
				// allow events for content that is not being blocked
				return target.parents().children().filter('div.blockUI').length === 0;
			}
	
			function focus(back) {
				if (!pageBlockEls)
					return;
				var e = pageBlockEls[back===true ? pageBlockEls.length-1 : 0];
				if (e)
					e.focus();
			}
	
			function center(el, x, y) {
				var p = el.parentNode, s = el.style;
				var l = ((p.offsetWidth - el.offsetWidth)/2) - sz(p,'borderLeftWidth');
				var t = ((p.offsetHeight - el.offsetHeight)/2) - sz(p,'borderTopWidth');
				if (x) s.left = l > 0 ? (l+'px') : '0';
				if (y) s.top  = t > 0 ? (t+'px') : '0';
			}
	
			function sz(el, p) {
				return parseInt($.css(el,p),10)||0;
			}
	
		}
	
	
		/*global define:true */
		if ("function" === 'function' && __webpack_require__(415) && __webpack_require__(415).jQuery) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (setup), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			setup(jQuery);
		}
	
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var GoogleMapLoaderService;
	
	__webpack_require__(28);
	
	GoogleMapLoaderService = __webpack_require__(417);
	
	angular.module('gnp-map', []).factory('GoogleMapLoaderService', GoogleMapLoaderService);


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var GoogleMapLoaderService;
	
	GoogleMapLoaderService = function($window, $q) {
	  return {
	    load: function() {
	      var deferred, scriptTag;
	      deferred = $q.defer();
	      if ($window.google) {
	        deferred.resolve();
	        return deferred.promise;
	      }
	      $window.onGoogleReady = function() {
	        if ($window.google.maps) {
	          __webpack_require__(418);
	        }
	        return deferred.resolve();
	      };
	      scriptTag = document.createElement('script');
	      scriptTag.src = '//maps.googleapis.com/maps/api/js?v=3.exp&callback=onGoogleReady&key=AIzaSyD4aCupnhvS4BcsKP79w0V9PHzynYglFcU&sensor=false&.js';
	      document.body.appendChild(scriptTag);
	      return deferred.promise;
	    }
	  };
	};
	
	GoogleMapLoaderService.$inject = ['$window', '$q'];
	
	module.exports = GoogleMapLoaderService;


/***/ }),
/* 418 */
/***/ (function(module, exports) {

	(function(){var b=true,f=false;function g(a){var c=a||{};this.d=this.c=f;if(a.visible==undefined)a.visible=b;if(a.shadow==undefined)a.shadow="7px -3px 5px rgba(88,88,88,0.7)";if(a.anchor==undefined)a.anchor=i.BOTTOM;this.setValues(c)}g.prototype=new google.maps.OverlayView;window.RichMarker=g;g.prototype.getVisible=function(){return this.get("visible")};g.prototype.getVisible=g.prototype.getVisible;g.prototype.setVisible=function(a){this.set("visible",a)};g.prototype.setVisible=g.prototype.setVisible;
	    g.prototype.s=function(){if(this.c){this.a.style.display=this.getVisible()?"":"none";this.draw()}};g.prototype.visible_changed=g.prototype.s;g.prototype.setFlat=function(a){this.set("flat",!!a)};g.prototype.setFlat=g.prototype.setFlat;g.prototype.getFlat=function(){return this.get("flat")};g.prototype.getFlat=g.prototype.getFlat;g.prototype.p=function(){return this.get("width")};g.prototype.getWidth=g.prototype.p;g.prototype.o=function(){return this.get("height")};g.prototype.getHeight=g.prototype.o;
	    g.prototype.setShadow=function(a){this.set("shadow",a);this.g()};g.prototype.setShadow=g.prototype.setShadow;g.prototype.getShadow=function(){return this.get("shadow")};g.prototype.getShadow=g.prototype.getShadow;g.prototype.g=function(){if(this.c)this.a.style.boxShadow=this.a.style.webkitBoxShadow=this.a.style.MozBoxShadow=this.getFlat()?"":this.getShadow()};g.prototype.flat_changed=g.prototype.g;g.prototype.setZIndex=function(a){this.set("zIndex",a)};g.prototype.setZIndex=g.prototype.setZIndex;
	    g.prototype.getZIndex=function(){return this.get("zIndex")};g.prototype.getZIndex=g.prototype.getZIndex;g.prototype.t=function(){if(this.getZIndex()&&this.c)this.a.style.zIndex=this.getZIndex()};g.prototype.zIndex_changed=g.prototype.t;g.prototype.getDraggable=function(){return this.get("draggable")};g.prototype.getDraggable=g.prototype.getDraggable;g.prototype.setDraggable=function(a){this.set("draggable",!!a)};g.prototype.setDraggable=g.prototype.setDraggable;
	    g.prototype.k=function(){if(this.c)this.getDraggable()?j(this,this.a):k(this)};g.prototype.draggable_changed=g.prototype.k;g.prototype.getPosition=function(){return this.get("position")};g.prototype.getPosition=g.prototype.getPosition;g.prototype.setPosition=function(a){this.set("position",a)};g.prototype.setPosition=g.prototype.setPosition;g.prototype.q=function(){this.draw()};g.prototype.position_changed=g.prototype.q;g.prototype.l=function(){return this.get("anchor")};g.prototype.getAnchor=g.prototype.l;
	    g.prototype.r=function(a){this.set("anchor",a)};g.prototype.setAnchor=g.prototype.r;g.prototype.n=function(){this.draw()};g.prototype.anchor_changed=g.prototype.n;function l(a,c){var d=document.createElement("DIV");d.innerHTML=c;if(d.childNodes.length==1)return d.removeChild(d.firstChild);else{for(var e=document.createDocumentFragment();d.firstChild;)e.appendChild(d.firstChild);return e}}function m(a,c){if(c)for(var d;d=c.firstChild;)c.removeChild(d)}
	    g.prototype.setContent=function(a){this.set("content",a)};g.prototype.setContent=g.prototype.setContent;g.prototype.getContent=function(){return this.get("content")};g.prototype.getContent=g.prototype.getContent;
	    g.prototype.j=function(){if(this.b){m(this,this.b);var a=this.getContent();if(a){if(typeof a=="string"){a=a.replace(/^\s*([\S\s]*)\b\s*$/,"$1");a=l(this,a)}this.b.appendChild(a);var c=this;a=this.b.getElementsByTagName("IMG");for(var d=0,e;e=a[d];d++){google.maps.event.addDomListener(e,"mousedown",function(h){if(c.getDraggable()){h.preventDefault&&h.preventDefault();h.returnValue=f}});google.maps.event.addDomListener(e,"load",function(){c.draw()})}google.maps.event.trigger(this,"domready")}this.c&&
	    this.draw()}};g.prototype.content_changed=g.prototype.j;function n(a,c){if(a.c){var d="";if(navigator.userAgent.indexOf("Gecko/")!==-1){if(c=="dragging")d="-moz-grabbing";if(c=="dragready")d="-moz-grab"}else if(c=="dragging"||c=="dragready")d="move";if(c=="draggable")d="pointer";if(a.a.style.cursor!=d)a.a.style.cursor=d}}
	    function o(a,c){if(a.getDraggable())if(!a.d){a.d=b;var d=a.getMap();a.m=d.get("draggable");d.set("draggable",f);a.h=c.clientX;a.i=c.clientY;n(a,"dragready");a.a.style.MozUserSelect="none";a.a.style.KhtmlUserSelect="none";a.a.style.WebkitUserSelect="none";a.a.unselectable="on";a.a.onselectstart=function(){return f};p(a);google.maps.event.trigger(a,"dragstart")}}
	    function q(a){if(a.getDraggable())if(a.d){a.d=f;a.getMap().set("draggable",a.m);a.h=a.i=a.m=null;a.a.style.MozUserSelect="";a.a.style.KhtmlUserSelect="";a.a.style.WebkitUserSelect="";a.a.unselectable="off";a.a.onselectstart=function(){};r(a);n(a,"draggable");google.maps.event.trigger(a,"dragend");a.draw()}}
	    function s(a,c){if(!a.getDraggable()||!a.d)q(a);else{var d=a.h-c.clientX,e=a.i-c.clientY;a.h=c.clientX;a.i=c.clientY;d=parseInt(a.a.style.left,10)-d;e=parseInt(a.a.style.top,10)-e;a.a.style.left=d+"px";a.a.style.top=e+"px";var h=t(a);a.setPosition(a.getProjection().fromDivPixelToLatLng(new google.maps.Point(d-h.width,e-h.height)));n(a,"dragging");google.maps.event.trigger(a,"drag")}}function k(a){if(a.f){google.maps.event.removeListener(a.f);delete a.f}n(a,"")}
	    function j(a,c){if(c){a.f=google.maps.event.addDomListener(c,"mousedown",function(d){o(a,d)});n(a,"draggable")}}function p(a){if(a.a.setCapture){a.a.setCapture(b);a.e=[google.maps.event.addDomListener(a.a,"mousemove",function(c){s(a,c)},b),google.maps.event.addDomListener(a.a,"mouseup",function(){q(a);a.a.releaseCapture()},b)]}else a.e=[google.maps.event.addDomListener(window,"mousemove",function(c){s(a,c)},b),google.maps.event.addDomListener(window,"mouseup",function(){q(a)},b)]}
	    function r(a){if(a.e){for(var c=0,d;d=a.e[c];c++)google.maps.event.removeListener(d);a.e.length=0}}
	    function t(a){var c=a.l();if(typeof c=="object")return c;var d=new google.maps.Size(0,0);if(!a.b)return d;var e=a.b.offsetWidth;a=a.b.offsetHeight;switch(c){case i.TOP:d.width=-e/2;break;case i.TOP_RIGHT:d.width=-e;break;case i.LEFT:d.height=-a/2;break;case i.MIDDLE:d.width=-e/2;d.height=-a/2;break;case i.RIGHT:d.width=-e;d.height=-a/2;break;case i.BOTTOM_LEFT:d.height=-a;break;case i.BOTTOM:d.width=-e/2;d.height=-a;break;case i.BOTTOM_RIGHT:d.width=-e;d.height=-a}return d}
	    g.prototype.onAdd=function(){if(!this.a){this.a=document.createElement("DIV");this.a.style.position="absolute"}if(this.getZIndex())this.a.style.zIndex=this.getZIndex();this.a.style.display=this.getVisible()?"":"none";if(!this.b){this.b=document.createElement("DIV");this.a.appendChild(this.b);var a=this;google.maps.event.addDomListener(this.b,"click",function(){google.maps.event.trigger(a,"click")});google.maps.event.addDomListener(this.b,"mouseover",function(){google.maps.event.trigger(a,"mouseover")});
	        google.maps.event.addDomListener(this.b,"mouseout",function(){google.maps.event.trigger(a,"mouseout")})}this.c=b;this.j();this.g();this.k();var c=this.getPanes();c&&c.overlayImage.appendChild(this.a);google.maps.event.trigger(this,"ready")};g.prototype.onAdd=g.prototype.onAdd;
	    g.prototype.draw=function(){if(!(!this.c||this.d)){var a=this.getProjection();if(a){var c=this.get("position");a=a.fromLatLngToDivPixel(c);c=t(this);this.a.style.top=a.y+c.height+"px";this.a.style.left=a.x+c.width+"px";a=this.b.offsetHeight;c=this.b.offsetWidth;c!=this.get("width")&&this.set("width",c);a!=this.get("height")&&this.set("height",a)}}};g.prototype.draw=g.prototype.draw;g.prototype.onRemove=function(){this.a&&this.a.parentNode&&this.a.parentNode.removeChild(this.a);k(this)};
	    g.prototype.onRemove=g.prototype.onRemove;var i={TOP_LEFT:1,TOP:2,TOP_RIGHT:3,LEFT:4,MIDDLE:5,RIGHT:6,BOTTOM_LEFT:7,BOTTOM:8,BOTTOM_RIGHT:9};window.RichMarkerPosition=i;
	})();

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	var RecommendModal, RecommendModalCtrl, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(115);
	
	__webpack_require__(59);
	
	RecommendModal = __webpack_require__(420);
	
	RecommendModalCtrl = __webpack_require__(421);
	
	modules = ['ui.bootstrap', 'gnp-translation'];
	
	angular.module('gnp-modal', modules).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(422)).translations('ja', __webpack_require__(423));
	  }
	]).controller('RecommendModalCtrl', RecommendModalCtrl);


/***/ }),
/* 420 */
/***/ (function(module, exports) {

	var v1="<div class=\"recommend-modal\"><div class=\"modal-header\"><button type=\"button\" data-bs-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\" class=\"close\"><span aria-hidden=\"true\">&times;</span></button><div class=\"message-content\">{{:: '_RECOMMEND.USE_PC' | translate }}</div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/modal/recommend-pc-modal.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	var RecommendModalCtrl;
	
	RecommendModalCtrl = function($scope, $modalInstance) {
	  return $scope.cancel = function() {
	    return $modalInstance.dismiss('cancel');
	  };
	};
	
	RecommendModalCtrl.$inject = ['$scope', '$modalInstance'];
	
	module.exports = RecommendModalCtrl;


/***/ }),
/* 422 */
/***/ (function(module, exports) {

	module.exports = {
	  '_RECOMMEND': {
	    'USE_PC': 'We recommend that you use the PC site or the app for score entry / information editing.'
	  }
	};


/***/ }),
/* 423 */
/***/ (function(module, exports) {

	module.exports = {
	  '_RECOMMEND': {
	    'USE_PC': 'スコア登録・情報編集はPCサイト、もしくはアプリをご利用ください。'
	  }
	};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var RecommendModal, RecommendModalCtrl, ScoreRegistrationCtrl, _;
	
	_ = __webpack_require__(87);
	
	RecommendModal = __webpack_require__(420);
	
	RecommendModalCtrl = __webpack_require__(421);
	
	ScoreRegistrationCtrl = function($scope, $location, $filter, round, ownerPlayer, fromJapan, flash, RoundAPIService, ScoreDataHolderService, ScoreUploadHelperService, AccordionStateHolderService, $analytics, $modal) {
	  $analytics.eventTrack('ETR_loaded');
	  if (round && round.agency_request_id) {
	    flash.error($filter('translate')('AGENCY_DENINED'));
	    return $location.path('/');
	  }
	  ScoreDataHolderService.init(round, ownerPlayer, fromJapan);
	  AccordionStateHolderService.init(round);
	  $scope.scoreHolder = ScoreDataHolderService;
	  $scope.accordionStateHolder = AccordionStateHolderService;
	  $scope.isSubmitting = false;
	  if (window.innerWidth < 768) {
	    $modal.open({
	      size: 'sm',
	      template: RecommendModal,
	      controller: RecommendModalCtrl
	    });
	  }
	  $scope.canSubmit = function() {
	    return ScoreDataHolderService.club && ScoreDataHolderService.roundInfo && ScoreDataHolderService.players;
	  };
	  return $scope.submit = function() {
	    var params;
	    $scope.isSubmitting = true;
	    params = ScoreUploadHelperService.createParams(ScoreDataHolderService.roundInfo, ScoreDataHolderService.club, ScoreDataHolderService.players);
	    return RoundAPIService.uploadScore(params).then(function() {
	      flash.success($filter('translate')('API_SUCCESS'));
	      return $location.path('/');
	    }, function() {
	      return flash.error($filter('translate')('API_ERROR'));
	    })["finally"](function() {
	      return $scope.isSubmitting = false;
	    });
	  };
	};
	
	ScoreRegistrationCtrl.$inject = ['$scope', '$location', '$filter', 'round', 'ownerPlayer', 'fromJapan', 'flash', 'RoundAPIService', 'ScoreDataHolderService', 'ScoreUploadHelperService', 'AccordionStateHolderService', '$analytics', '$modal'];
	
	module.exports = ScoreRegistrationCtrl;


/***/ }),
/* 425 */
/***/ (function(module, exports) {

	var SelectClubCtrl,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	SelectClubCtrl = (function() {
	  SelectClubCtrl.prototype.currentTabIndex = 0;
	
	  SelectClubCtrl.prototype._selectedClub = void 0;
	
	  function SelectClubCtrl($scope, $filter, $window, ScoreDataHolderService, AccordionStateHolderService) {
	    this.$scope = $scope;
	    this.$filter = $filter;
	    this.$window = $window;
	    this.ScoreDataHolderService = ScoreDataHolderService;
	    this.AccordionStateHolderService = AccordionStateHolderService;
	    this.selectClub = bind(this.selectClub, this);
	  }
	
	  SelectClubCtrl.prototype.selectTab = function(i) {
	    return this.currentTabIndex = i;
	  };
	
	  SelectClubCtrl.prototype.selectClub = function(club, isHistory) {
	    if (this._selectedClub) {
	      if (!this.$window.confirm(this.$filter('translate')('_SCORE_REGISTRATION.ROUND_INFO.CONFIRM_CLEAR_DATA'))) {
	        return;
	      }
	      this.ScoreDataHolderService.players = null;
	      this.ScoreDataHolderService.roundInfo = null;
	    }
	    if (club) {
	      club.isHistory = isHistory;
	    }
	    this._selectedClub = club;
	    this.ScoreDataHolderService.club = club;
	    this.AccordionStateHolderService.steps[2].isOpen = false;
	    this.AccordionStateHolderService.steps[3].isOpen = false;
	    return this.AccordionStateHolderService.goToStep(1);
	  };
	
	  return SelectClubCtrl;
	
	})();
	
	SelectClubCtrl.$inject = ['$scope', '$filter', '$window', 'ScoreDataHolderService', 'AccordionStateHolderService'];
	
	module.exports = SelectClubCtrl;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	var MAX_PLAYERS, SelectPlayersCtrl, _, escape, escapeSelect, preparePlayers;
	
	_ = __webpack_require__(87);
	
	MAX_PLAYERS = 4;
	
	preparePlayers = function(players) {
	  var clonePlayers;
	  clonePlayers = _.cloneDeep(players);
	  _.times(MAX_PLAYERS - clonePlayers.length, function() {
	    return clonePlayers.push({
	      name: '',
	      player_hdcp: void 0,
	      scores: []
	    });
	  });
	  return clonePlayers;
	};
	
	escape = function(name) {
	  var i, len, r, replacements;
	  replacements = [[/&/g, '&amp;'], [/</g, '&lt;'], [/"/g, '&quot;'], [/'/g, '&#039;']];
	  for (i = 0, len = replacements.length; i < len; i++) {
	    r = replacements[i];
	    name = name.replace(r[0], r[1]);
	  }
	  return name;
	};
	
	escapeSelect = function(name) {
	  var i, len, r, replacements;
	  replacements = [[/&amp;/g, '&'], [/&lt;/g, '<'], [/&quot;/g, '"'], [/&#039;/g, "'"]];
	  for (i = 0, len = replacements.length; i < len; i++) {
	    r = replacements[i];
	    name = name.replace(r[0], r[1]);
	  }
	  return name;
	};
	
	SelectPlayersCtrl = (function() {
	  function SelectPlayersCtrl($scope, PlayerAPIService, flash, $filter, ScoreDataHolderService, AccordionStateHolderService) {
	    this.$scope = $scope;
	    this.PlayerAPIService = PlayerAPIService;
	    this.flash = flash;
	    this.$filter = $filter;
	    this.ScoreDataHolderService = ScoreDataHolderService;
	    this.AccordionStateHolderService = AccordionStateHolderService;
	    this.isSavingPlayers = false;
	    this._playersWatch = this.$scope.$watch(((function(_this) {
	      return function() {
	        return _this.ScoreDataHolderService.players;
	      };
	    })(this)), (function(_this) {
	      return function(players) {
	        _this.players = preparePlayers(players || [_this.ScoreDataHolderService.ownerPlayer]);
	        _this._clearFrom();
	        return _this._playersWatch();
	      };
	    })(this));
	  }
	
	  SelectPlayersCtrl.prototype.searchPlayers = function(value) {
	    return this.PlayerAPIService.search(value).then(function(data) {
	      var i, len, n, ref;
	      ref = data.players;
	      for (i = 0, len = ref.length; i < len; i++) {
	        n = ref[i];
	        n.name = escape(n.name);
	      }
	      return data.players;
	    });
	  };
	
	  SelectPlayersCtrl.prototype.selectPlayer = function(item, index) {
	    item.name = escapeSelect(item.name);
	    return this.players[index] = item;
	  };
	
	  SelectPlayersCtrl.prototype.validateDuplicatePlayer = function(value, $index) {
	    return _.chain(this.players).reject(function(p, index) {
	      return index === $index;
	    }).every(function(p) {
	      return p.name !== value;
	    }).value();
	  };
	
	  SelectPlayersCtrl.prototype._updatePlayers = function(responsePlayers) {
	    return _.forEach(responsePlayers, (function(_this) {
	      return function(p1) {
	        var existPlayer;
	        existPlayer = _.find(_this.players, function(p2) {
	          return p1.name === p2.name;
	        });
	        if (existPlayer) {
	          existPlayer.id = p1.id;
	          existPlayer.scores = [];
	          return existPlayer.scores_extra = [];
	        }
	      };
	    })(this));
	  };
	
	  SelectPlayersCtrl.prototype._clearFrom = function() {
	    if (!this.form) {
	      return;
	    }
	    return this.form.clearForm();
	  };
	
	  SelectPlayersCtrl.prototype._processPlayers = function() {
	    var filterPlayers, storedPlayers;
	    filterPlayers = _.filter(this.players, function(p) {
	      return p.id && p.name;
	    });
	    filterPlayers = _.map(filterPlayers, function(p, index) {
	      return _.merge({}, p, {
	        scores_extra: p.scores_extra
	      });
	    });
	    storedPlayers = this.ScoreDataHolderService.players;
	    if (!storedPlayers) {
	      return filterPlayers;
	    }
	    return _.map(filterPlayers, function(p, index) {
	      var sp;
	      sp = storedPlayers[index];
	      return _.merge({}, p, {
	        scores: sp ? sp.scores : p.scores,
	        scores_extra: sp ? sp.scores_extra : p.scores_extra
	      });
	    });
	  };
	
	  SelectPlayersCtrl.prototype.savePlayers = function() {
	    this.isSavingPlayers = true;
	    return this.PlayerAPIService.savePlayers(this.players).then((function(_this) {
	      return function(resp) {
	        _this.PlayerAPIService.clearOwnerCache();
	        _this._updatePlayers(resp.data.players);
	        _this._clearFrom();
	        _this.ScoreDataHolderService.players = _this._processPlayers();
	        return _this.AccordionStateHolderService.goToStep(3);
	      };
	    })(this))["catch"]((function(_this) {
	      return function(resp) {
	        var ref;
	        if (((ref = resp.data) != null ? ref.code : void 0) === 'error.name_already_taken') {
	          return _this.flash.error(_this.$filter('translate')('NAME_DUPLICATED'));
	        } else {
	          return _this.flash.error(_this.$filter('translate')('API_ERROR'));
	        }
	      };
	    })(this))["finally"]((function(_this) {
	      return function() {
	        return _this.isSavingPlayers = false;
	      };
	    })(this));
	  };
	
	  return SelectPlayersCtrl;
	
	})();
	
	SelectPlayersCtrl.$inject = ['$scope', 'PlayerAPIService', 'flash', '$filter', 'ScoreDataHolderService', 'AccordionStateHolderService'];
	
	module.exports = SelectPlayersCtrl;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	var SearchDirective;
	
	__webpack_require__(428);
	
	SearchDirective = function($window, AccountService, $filter, $translate, SelectClubSearchService) {
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "score-registration/select-club/search.jade",
	    scope: {
	      selectClub: '&onClubSelected'
	    },
	    link: function(scope) {
	      scope.mailTo = function() {
	        return AccountService.getUserInfo().then(function(user) {
	          var content, email, mailToCode, subject;
	          email = /^ja/i.test($translate.preferredLanguage()) ? 'course.i.ja@yourgolf.zendesk.com' : 'course.i.en@yourgolf.zendesk.com';
	          subject = $filter('translate')('_SCORE_REGISTRATION.SELECT_CLUB.EMAIL_SUBJECT');
	          content = "Account ID: " + user.email + " \n UserAgent: " + $window.navigator.userAgent + " \n Timestamp: " + (new Date()) + " \n Search Keyword: " + scope.keyword;
	          mailToCode = "mailto:" + email + "?subject=" + subject + "&body=" + (encodeURIComponent(content));
	          return $window.open(mailToCode);
	        });
	      };
	      scope.keyword = void 0;
	      scope.search = function() {
	        if (!scope.keyword) {
	          return;
	        }
	        return scope.$broadcast("reloadClub.gnp.scoreRegistration");
	      };
	      return scope.loadClub = function(page) {
	        return SelectClubSearchService.getClubs(scope.keyword, {
	          page: page
	        });
	      };
	    }
	  };
	};
	
	SearchDirective.$inject = ["$window", "AccountService", "$filter", "$translate", "SelectClubSearchService"];
	
	module.exports = SearchDirective;


/***/ }),
/* 428 */
/***/ (function(module, exports) {

	var v1="<form ng-submit=\"search()\"><div class=\"filter-bar row\"><div class=\"col-8 no-padding\"><input type=\"text\" ng-model=\"keyword\" placeholder=\"{{ '_SCORE_REGISTRATION.SELECT_CLUB.INPUT_KEYWORDS' | translate }}\"/></div><div class=\"col-4 no-padding\"><button type=\"submit\" gnp-submitting-button=\"isLoading\" class=\"btn\">{{:: '_SCORE_REGISTRATION.SELECT_CLUB.SEARCH' | translate }}</button></div></div></form><div gnp-select-club-list=\"\" on-club-selected=\"selectClub()\" on-load-club=\"loadClub\" is-loading=\"isLoading\" mail-to=\"mailTo\"><p ng-show=\"hasNoResult\" class=\"empty\">{{:: '_SCORE_REGISTRATION.SELECT_CLUB.NORESULT' | translate }}</p><a ng-click=\"mailTo()\" target=\"_top\"><button ng-hide=\"hasMore() || isLoading\" class=\"btn btn-request\"><div class=\"title\">{{:: '_SCORE_REGISTRATION.SELECT_CLUB.COURSE_REQUEST_LINK' | translate }}</div><div class=\"text\">{{:: '_SCORE_REGISTRATION.SELECT_CLUB.COURSE_REQUEST_HINT' | translate }}</div></button></a></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-registration/select-club/search.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var ListDirective, _;
	
	__webpack_require__(430);
	
	_ = __webpack_require__(87);
	
	ListDirective = function() {
	  return {
	    restrict: "A",
	    replace: false,
	    transclude: true,
	    templateUrl: "score-registration/select-club/list.jade",
	    scope: {
	      selectClub: '&onClubSelected',
	      loadClub: '&onLoadClub',
	      preload: "=?",
	      isLoading: "=?",
	      isHistory: "=?",
	      mailTo: "=?"
	    },
	    link: function(scope, element, attrs, ctrl, transclude) {
	      var currentPage, loadMore, totalPages;
	      currentPage = void 0;
	      totalPages = void 0;
	      scope.clubs = [];
	      scope.hasNoResult = false;
	      scope.isLoading = false;
	      scope.loadMore = function() {
	        currentPage++;
	        return loadMore();
	      };
	      scope.hasMore = function() {
	        return totalPages && (currentPage !== totalPages);
	      };
	      scope.isSearched = function() {
	        return currentPage >= 1;
	      };
	      scope.showAddressCountry = function(club) {
	        if (club.address && club.country) {
	          return club.address + ', ' + club.country;
	        } else if (!club.address && club.country) {
	          return club.country;
	        } else {
	          return club.address;
	        }
	      };
	      loadMore = function() {
	        scope.isLoading = true;
	        return scope.loadClub()(currentPage).then(function(resp) {
	          if (resp.data.total_pages === 0) {
	            return scope.hasNoResult = true;
	          } else {
	            totalPages = resp.data.total_pages;
	            scope.hasNoResult = false;
	            return scope.clubs = _.union(scope.clubs, resp.data.clubs);
	          }
	        })["finally"](function() {
	          return scope.isLoading = false;
	        });
	      };
	      scope.$on("reloadClub.gnp.scoreRegistration", function() {
	        currentPage = 1;
	        totalPages = void 0;
	        scope.clubs = [];
	        return loadMore();
	      });
	      if (scope.preload) {
	        currentPage = 1;
	        loadMore();
	      }
	      return transclude(scope, function(clone, scope) {
	        return element.find(".custom-place").append(clone);
	      });
	    }
	  };
	};
	
	module.exports = ListDirective;


/***/ }),
/* 430 */
/***/ (function(module, exports) {

	var v1="<div class=\"list-wrap\"><ul><li ng-class-odd=\"'odd'\" ng-class-even=\"'even'\" ng-repeat=\"club in clubs\" ng-click=\"selectClub()(club, isHistory)\" class=\"row\"><div class=\"col-6\"><div class=\"course-name\">{{ ::club.name }}</div></div><div class=\"col-6\"><div class=\"course-addr\">{{ ::showAddressCountry(club) }}</div></div></li></ul></div><div ng-show=\"isSearched()\" class=\"btn-row\"><button type=\"submit\" ng-click=\"loadMore()\" ng-show=\"hasMore()\" ng-disabled=\"isLoading\" class=\"btn btn-more\"><div class=\"title\">{{:: 'SHOW_MORE' | translate }}</div></button><div class=\"custom-place\"></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-registration/select-club/list.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	var HistoryDirective;
	
	__webpack_require__(432);
	
	HistoryDirective = function(SelectClubSearchService) {
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "score-registration/select-club/history.jade",
	    scope: {
	      selectClub: '&onClubSelected'
	    },
	    link: function(scope) {
	      return scope.loadClub = function(page) {
	        return SelectClubSearchService.getPlayedClubs({
	          page: page
	        });
	      };
	    }
	  };
	};
	
	HistoryDirective.$inject = ["SelectClubSearchService"];
	
	module.exports = HistoryDirective;


/***/ }),
/* 432 */
/***/ (function(module, exports) {

	var v1="<div gnp-select-club-list=\"\" on-club-selected=\"selectClub()\" on-load-club=\"loadClub\" preload=\"true\" is-history=\"true\" style=\"margin-top: 24px\"><div ng-show=\"isSearched()\" class=\"span-12\"><p ng-show=\"hasNoResult\">{{:: '_SCORE_REGISTRATION.SELECT_CLUB_HISTORY.NORESULT' | translate }}</p></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-registration/select-club/history.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	var SelectClubService;
	
	SelectClubService = function($http) {
	  return {
	    getClubs: function(keyword, pageParams) {
	      var params, url;
	      url = "/api/clubs/search.json";
	      params = {
	        page: pageParams.page,
	        keyword: keyword
	      };
	      return $http.get(url, {
	        params: params
	      });
	    },
	    getPlayedClubs: function(pageParams) {
	      var params, url;
	      url = "/api/clubs/played.json";
	      params = {
	        page: pageParams.page
	      };
	      return $http.get(url, {
	        params: params
	      });
	    }
	  };
	};
	
	SelectClubService.$inject = ['$http'];
	
	module.exports = SelectClubService;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	var RoundInfoCtrl, _, mapIcon, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	mapIcon = __webpack_require__(435);
	
	RoundInfoCtrl = (function() {
	  function RoundInfoCtrl($scope, $filter, $window, flash, RoundInfoService, ScoreDataHolderService, AccordionStateHolderService, GoogleMapLoaderService) {
	    this.$scope = $scope;
	    this.$filter = $filter;
	    this.$window = $window;
	    this.flash = flash;
	    this.RoundInfoService = RoundInfoService;
	    this.ScoreDataHolderService = ScoreDataHolderService;
	    this.AccordionStateHolderService = AccordionStateHolderService;
	    this.GoogleMapLoaderService = GoogleMapLoaderService;
	    this.GoogleMapLoaderService.load().then((function(_this) {
	      return function() {
	        return _this.mapOptions = {
	          center: new google.maps.LatLng(0, 0),
	          zoom: 15,
	          mapTypeId: google.maps.MapTypeId.ROADMAP
	        };
	      };
	    })(this));
	    this._oldCourse = null;
	    this.extra9Options = [];
	    this.hideExtra = true;
	    this.$scope.$watch(((function(_this) {
	      return function() {
	        return _this.AccordionStateHolderService.steps[1].isOpen;
	      };
	    })(this)), (function(_this) {
	      return function(isOpen) {
	        if (isOpen && _this.myMap) {
	          google.maps.event.trigger(_this.myMap, 'resize');
	          if (_this.club) {
	            return _this._setMarker(_this.club.loc);
	          }
	        }
	      };
	    })(this));
	    this.$scope.$watch(((function(_this) {
	      return function() {
	        return _this.ScoreDataHolderService.club;
	      };
	    })(this)), (function(_this) {
	      return function(club) {
	        var course_selected;
	        if (!club) {
	          return;
	        }
	        _this._reset();
	        _this.club = club;
	        _this.club.showRakutenId = _this.club.rakuten_id;
	        if (_this.myMap) {
	          _this._setMarker(_this.club.loc);
	        }
	        _this.club.showRakutenId = _this.club.rakuten_id && _this.ScoreDataHolderService.fromJapan;
	        _this._setRakutenLink(_this.club.rakuten_id);
	        _this.courses = club.courses;
	        _this.roundInfo.extra9;
	        if (_this.club.courses.length === 1) {
	          course_selected = club.courses[0];
	        }
	        if (club.selected) {
	          course_selected = _.find(club.courses, function(t) {
	            return t.ext_id === club.selected.course_ext_id;
	          });
	          if (club.selected.course_extra) {
	            _this.roundInfo.extra9 = club.selected.course_extra.course_ext_id;
	            _this.roundInfo.tee_extra = club.selected.course_extra.tee_extra;
	          }
	        }
	        _this._generateExtra9Options(_this.courses);
	        if (course_selected) {
	          return _this.selectCourse(course_selected);
	        }
	      };
	    })(this));
	    this.roundInfoWatch = this.$scope.$watch(((function(_this) {
	      return function() {
	        return _this.ScoreDataHolderService.roundInfo;
	      };
	    })(this)), (function(_this) {
	      return function(roundInfo) {
	        var afterFix;
	        if (roundInfo) {
	          _this.roundInfo = _.cloneDeep(roundInfo);
	          if (roundInfo.course) {
	            _this.selectCourse(roundInfo.course);
	          }
	          if (roundInfo.round_type === 1.5) {
	            _this.roundInfo.extra_9 = true;
	          }
	          if (_this.roundInfo.course_extra && _this.roundInfo.holes_extra) {
	            afterFix = _this.roundInfo.holes_extra[0].hole_number > 9 ? 'IN' : 'OUT';
	            _this.roundInfo.extra9 = _this.roundInfo.course_extra.ext_id + "_" + afterFix;
	          }
	        }
	        return _this.roundInfoWatch();
	      };
	    })(this));
	    this._mapWatch = this.$scope.$watch(((function(_this) {
	      return function() {
	        return _this.myMap;
	      };
	    })(this)), (function(_this) {
	      return function(map) {
	        if (!map) {
	          return;
	        }
	        if (_this.club) {
	          _this._setMarker(_this.club.loc);
	        }
	        return _this._mapWatch();
	      };
	    })(this));
	  }
	
	  RoundInfoCtrl.prototype.showFlashMessage = function() {
	    this.flash.error(this.$filter('translate')('_SCORE_REGISTRATION.ROUND_INFO.ERROR_FLASH_MESSAGE'));
	  };
	
	  RoundInfoCtrl.prototype.submit = function() {
	    var roundInfo;
	    roundInfo = _.merge(this.roundInfo, {
	      holes: this.roundInfo.tee.holes
	    });
	    this._resetForm();
	    this._getExtra();
	    this.ScoreDataHolderService.roundInfo = roundInfo;
	    return this.AccordionStateHolderService.goToStep(2);
	  };
	
	  RoundInfoCtrl.prototype.selectCourse = function(course, isChange) {
	    var ref, ref1;
	    if (isChange == null) {
	      isChange = false;
	    }
	    if (this._oldCourse) {
	      if (this.$window.confirm(this.$filter('translate')('_SCORE_REGISTRATION.ROUND_INFO.CONFIRM_CLEAR_DATA'))) {
	        this._clearDataWhenCourseChanged();
	      } else {
	        this.roundInfo.course = this._oldCourse;
	        if (((ref = this.roundInfo.course) != null ? ref.holes : void 0) === 18) {
	          this.hideExtra = false;
	        }
	        return;
	      }
	    }
	    this._oldCourse = course;
	    this.roundInfo.course = course;
	    if (((ref1 = this.roundInfo.course) != null ? ref1.holes : void 0) === 18) {
	      this.hideExtra = false;
	    }
	    if (!course) {
	      return;
	    }
	    this._setStartHoles(course.holes);
	    return this._setTees(isChange);
	  };
	
	  RoundInfoCtrl.prototype._getExtra = function() {
	    var extraOption, holes_extra;
	    if (!this.roundInfo.extra9) {
	      this.roundInfo.extra_9 = false;
	      this.roundInfo.course_extra = void 0;
	      this.roundInfo.tee_extra = void 0;
	      return;
	    }
	    extraOption = this.roundInfo.extra9.split('_');
	    this.roundInfo.extra_9 = true;
	    this.roundInfo.course_extra = _.find(this.courses, (function(_this) {
	      return function(t) {
	        return t.ext_id === extraOption[0];
	      };
	    })(this));
	    if (this.roundInfo.tee_extra) {
	      this.roundInfo.tee_extra = _.find(this.tees, (function(_this) {
	        return function(t) {
	          return t.ext_id === _this.roundInfo.tee_extra.ext_id;
	        };
	      })(this));
	    } else if (this.tees.length === 1) {
	      this.roundInfo.tee_extra = this.tees[0];
	    }
	    holes_extra = _.map(this.roundInfo.tee_extra.holes, (function(_this) {
	      return function(hole) {
	        if (extraOption[1] === 'IN') {
	          if (hole.hole_number >= 10) {
	            return hole;
	          }
	        } else {
	          if (hole.hole_number < 10) {
	            return hole;
	          }
	        }
	      };
	    })(this));
	    holes_extra = _.compact(holes_extra);
	    this.roundInfo.tee_extra.holes = holes_extra;
	    return this.roundInfo.holes_extra = holes_extra;
	  };
	
	  RoundInfoCtrl.prototype._generateExtra9Options = function(courses) {
	    return _.map(courses, (function(_this) {
	      return function(course) {
	        if (course.holes === 18) {
	          _this.extra9Options.push([course.ext_id + "_IN", course.name + " IN"]);
	          return _this.extra9Options.push([course.ext_id + "_OUT", course.name + " OUT"]);
	        }
	      };
	    })(this));
	  };
	
	  RoundInfoCtrl.prototype._getDefaultRoundInfo = function() {
	    return {
	      play_date: moment(),
	      weather: 'sunny',
	      course: void 0,
	      tee: void 0,
	      started_hole: 1
	    };
	  };
	
	  RoundInfoCtrl.prototype._reset = function() {
	    this._resetForm();
	    this._oldCourse = null;
	    this.club = void 0;
	    this.startHoles = [];
	    this.tees = [];
	    this.roundInfo = this._getDefaultRoundInfo();
	    this.hideExtra = true;
	    return this.extra9Options = [];
	  };
	
	  RoundInfoCtrl.prototype._resetForm = function() {
	    var ref;
	    return (ref = this.roundInfoForm) != null ? ref.clearForm() : void 0;
	  };
	
	  RoundInfoCtrl.prototype._clearDataWhenCourseChanged = function() {
	    this.roundInfo.started_hole = void 0;
	    this.roundInfo.tee = void 0;
	    this.roundInfo.tee_extra = void 0;
	    this.roundInfo.extra9 = void 0;
	    this.hideExtra = true;
	    this._resetForm();
	    this.AccordionStateHolderService.steps[2].isOpen = false;
	    this.AccordionStateHolderService.steps[3].isOpen = false;
	    return this.ScoreDataHolderService.players = null;
	  };
	
	  RoundInfoCtrl.prototype._setMarker = function(loc) {
	    var pos;
	    pos = (function(func, args, ctor) {
	      ctor.prototype = func.prototype;
	      var child = new ctor, result = func.apply(child, args);
	      return Object(result) === result ? result : child;
	    })(google.maps.LatLng, loc, function(){});
	    this.myMap.panTo(pos);
	    this.markers = [];
	    return this.markers.push(new google.maps.Marker({
	      map: this.myMap,
	      position: pos,
	      icon: mapIcon
	    }));
	  };
	
	  RoundInfoCtrl.prototype._setRakutenLink = function(rakutenId) {
	    if (!rakutenId) {
	      return;
	    }
	    return this.RoundInfoService.getRakutenLink(rakutenId).then((function(_this) {
	      return function(resp) {
	        return _this.rakutenLink = resp.data.Item.reserveCalUrl;
	      };
	    })(this));
	  };
	
	  RoundInfoCtrl.prototype._setStartHoles = function(holeCnt) {
	    this.startHoles = [
	      {
	        value: 1,
	        label: this.$filter('translate')('_SCORE_REGISTRATION.ROUND_INFO.HOLE_1')
	      }
	    ];
	    if (holeCnt === 18) {
	      return this.startHoles.push({
	        value: 10,
	        label: this.$filter('translate')('_SCORE_REGISTRATION.ROUND_INFO.HOLE_10')
	      });
	    }
	  };
	
	  RoundInfoCtrl.prototype._refreshTeeDropdown = function(data) {
	    this.tees = data.tees;
	    if (this.roundInfo.tee) {
	      this.roundInfo.tee = _.find(this.tees, (function(_this) {
	        return function(t) {
	          return t.ext_id === _this.roundInfo.tee.ext_id;
	        };
	      })(this));
	    } else if (this.tees.length === 1) {
	      this.roundInfo.tee = this.tees[0];
	    }
	    if (this.roundInfo.tee_extra) {
	      return this.roundInfo.tee_extra = _.find(this.tees, (function(_this) {
	        return function(t) {
	          return t.ext_id === _this.roundInfo.tee_extra.ext_id;
	        };
	      })(this));
	    } else if (this.tees.length === 1) {
	      return this.roundInfo.tee_extra = this.tees[0];
	    }
	  };
	
	  RoundInfoCtrl.prototype._setTees = function(isChange) {
	    if (isChange == null) {
	      isChange = false;
	    }
	    this.isLoadingTees = true;
	    return this.RoundInfoService.getTees(this.roundInfo.course.ext_id, this.club.ext_type).then((function(_this) {
	      return function(resp) {
	        if (_this.club.isHistory && !isChange) {
	          _this.roundInfo.tee = _.find(resp.data.tees, function(t) {
	            return t.ext_id === _this.club.selected.tee_ext_id;
	          });
	        }
	        return _this._refreshTeeDropdown(resp.data);
	      };
	    })(this))["finally"]((function(_this) {
	      return function() {
	        return _this.isLoadingTees = false;
	      };
	    })(this));
	  };
	
	  return RoundInfoCtrl;
	
	})();
	
	RoundInfoCtrl.$inject = ['$scope', '$filter', '$window', 'flash', 'RoundInfoService', 'ScoreDataHolderService', 'AccordionStateHolderService', 'GoogleMapLoaderService'];
	
	module.exports = RoundInfoCtrl;


/***/ }),
/* 435 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	var RoundInfoService;
	
	RoundInfoService = function($http) {
	  return {
	    getTees: function(course_ext_id, ext_type) {
	      return $http.get("/api/courses/" + course_ext_id + "/tees.json?ext_type=" + ext_type);
	    },
	    getHistoryTees: function(course_id) {
	      return $http.get("/api/course_snapshots/" + course_id + "/tees.json");
	    },
	    getRakutenLink: function(rakuten_id) {
	      return $http.jsonp('https://app.rakuten.co.jp/services/api/Gora/GoraGolfCourseDetail/20131113', {
	        params: {
	          format: 'json',
	          applicationId: '1083670463465254180',
	          affiliateId: '0db0b791.d6e84c38.0db0b792.a2f620e8',
	          golfCourseId: rakuten_id
	        }
	      });
	    }
	  };
	};
	
	RoundInfoService.$inject = ['$http'];
	
	module.exports = RoundInfoService;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var ScoreCardInfoCtrl, _,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	_ = __webpack_require__(87);
	
	ScoreCardInfoCtrl = (function() {
	  function ScoreCardInfoCtrl($scope, ScoreCardParser, ScoreDataHolderService) {
	    this.$scope = $scope;
	    this.ScoreCardParser = ScoreCardParser;
	    this.ScoreDataHolderService = ScoreDataHolderService;
	    this.onScoresUpdated = bind(this.onScoresUpdated, this);
	    this.$scope.$watch(((function(_this) {
	      return function() {
	        return _this.ScoreDataHolderService.players;
	      };
	    })(this)), (function(_this) {
	      return function() {
	        if (!_this.ScoreDataHolderService.roundInfo) {
	          return;
	        }
	        return _this._setScoresData();
	      };
	    })(this));
	    this.$scope.$watch(((function(_this) {
	      return function() {
	        return _this.ScoreDataHolderService.roundInfo;
	      };
	    })(this)), (function(_this) {
	      return function() {
	        if (!_this.ScoreDataHolderService.roundInfo) {
	          return;
	        }
	        return _this._setScoresData();
	      };
	    })(this));
	  }
	
	  ScoreCardInfoCtrl.prototype.onScoresUpdated = function(players, boardType) {
	    var i, j, len, p, ref, results;
	    if (!players) {
	      return;
	    }
	    ref = this.players;
	    results = [];
	    for (i = j = 0, len = ref.length; j < len; i = ++j) {
	      p = ref[i];
	      results.push(this._updateScores(p, players[i].scores, boardType));
	    }
	    return results;
	  };
	
	  ScoreCardInfoCtrl.prototype._updateScores = function(player, newScores, inOrOut) {
	    if (inOrOut === 'out') {
	      return _.forEach(newScores, function(s, i) {
	        return player.scores[i] = s;
	      });
	    } else if (inOrOut === 'in') {
	      return _.forEach(newScores, function(s, i) {
	        return player.scores[i + 9] = s;
	      });
	    } else {
	      return _.forEach(newScores, function(s, i) {
	        return player.scores_extra[i] = s;
	      });
	    }
	  };
	
	  ScoreCardInfoCtrl.prototype._setScoresData = function() {
	    var roundInfo;
	    this.course = this.ScoreDataHolderService.roundInfo.course;
	    this.course_extra = this.ScoreDataHolderService.roundInfo.course_extra;
	    this.holes = this.ScoreDataHolderService.roundInfo.holes;
	    this.holes_extra = this.ScoreDataHolderService.roundInfo.holes_extra;
	    this.tee = this.ScoreDataHolderService.roundInfo.tee;
	    this.tee_extra = this.ScoreDataHolderService.roundInfo.tee_extra;
	    this.players = this.ScoreDataHolderService.players;
	    this.extra_9 = this.ScoreDataHolderService.roundInfo.extra_9;
	    if (this.ScoreDataHolderService.roundInfo.has_extra) {
	      this.extra_9 = true;
	    }
	    roundInfo = {
	      tee: this.tee,
	      tee_extra: this.tee_extra,
	      extra_9: this.extra_9,
	      holes: this.holes,
	      holes_extra: this.holes_extra,
	      players: this.players
	    };
	    if (this.holes.length === 18) {
	      this.inScoreCardInfo = this.ScoreCardParser.parseInViewModel(roundInfo);
	    }
	    this.outScoreCardInfo = this.ScoreCardParser.parseOutViewModel(roundInfo);
	    if (roundInfo.extra_9) {
	      return this.extraScoreCardInfo = this.ScoreCardParser.parseScoreCardExtraBoard(roundInfo);
	    }
	  };
	
	  return ScoreCardInfoCtrl;
	
	})();
	
	ScoreCardInfoCtrl.$inject = ['$scope', 'ScoreCardParser', 'ScoreDataHolderService'];
	
	module.exports = ScoreCardInfoCtrl;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	var ScoreDataHolderService, _;
	
	_ = __webpack_require__(87);
	
	ScoreDataHolderService = function() {
	  return {
	    init: function(round, ownerPlayer, fromJapan) {
	      this.ownerPlayer = ownerPlayer;
	      this.fromJapan = fromJapan;
	      this.players = round != null ? round.players : void 0;
	      if (round) {
	        this.club = round.club;
	        this.roundInfo = _.pick(round, 'id', 'course', 'course_extra', 'tee', 'tee_extra', 'holes', 'holes_extra', 'extra_9', 'play_date', 'weather', 'started_hole', 'round_type', 'has_extra');
	        if (round.round_type === 1.5) {
	          this.roundInfo.extra_9 = true;
	        }
	        this.roundInfo.course.holes = this.roundInfo.holes.length;
	        if (this.roundInfo.course_extra) {
	          this.roundInfo.course_extra.holes = this.roundInfo.holes.length;
	        }
	        this.club.courses = _.union(this.club.courses, [this.roundInfo.course]);
	        this.club.courses = _.uniq(this.club.courses);
	        return this.editMode = true;
	      } else {
	        this.club = null;
	        return this.roundInfo = null;
	      }
	    }
	  };
	};
	
	module.exports = ScoreDataHolderService;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var ScoreUploadHelper, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	ScoreUploadHelper = function() {
	  return {
	    createParams: function(roundInfo, club, players) {
	      var params, params_extra;
	      params = {
	        id: roundInfo.id,
	        started_hole: roundInfo.started_hole,
	        time_zone_offset: (new Date().getTimezoneOffset() * -1) * 60000,
	        play_date: moment.isMoment(roundInfo.play_date) ? roundInfo.play_date.valueOf() : moment(roundInfo.play_date).valueOf(),
	        weather: roundInfo.weather,
	        club: _.merge(_.omit(club, ["courses", "showRakutenId"]), {
	          ext_id: club.id,
	          loc: [club.lat, club.lng]
	        }),
	        course: _.pick(roundInfo.course, ['ext_id', 'name']),
	        tee: _.pick(roundInfo.tee, ['ext_id', 'name']),
	        holes: roundInfo.holes,
	        players: players.map(function(p) {
	          p.scores = _.filter(p.scores, function(s) {
	            return s.shot_cnt != null;
	          }).map(function(sc) {
	            return _.omit(sc, ['scoreOptions', 'shotCntColor']);
	          });
	          if (roundInfo.extra_9 || roundInfo.has_extra) {
	            p.scores_extra = _.filter(p.scores_extra, function(s) {
	              return s.shot_cnt != null;
	            }).map(function(sc_extra) {
	              return _.omit(sc_extra, ['scoreOptions', 'shotCntColor']);
	            });
	          }
	          return p;
	        })
	      };
	      if (roundInfo.extra_9 || roundInfo.has_extra) {
	        params_extra = {
	          course_extra: _.pick(roundInfo.course_extra, ['ext_id', 'name']),
	          extra_9: true,
	          tee_extra: _.pick(roundInfo.tee_extra, ['ext_id', 'name']),
	          holes_extra: roundInfo.holes_extra
	        };
	        return Object.assign({}, params, params_extra);
	      } else {
	        return params;
	      }
	    }
	  };
	};
	
	module.exports = ScoreUploadHelper;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	var $, AccordionStateHolder;
	
	$ = __webpack_require__(1);
	
	AccordionStateHolder = function($timeout) {
	  return {
	    steps: [
	      {
	        id: 'step-select-club',
	        isOpen: true
	      }, {
	        id: 'step-round-info',
	        isOpen: false
	      }, {
	        id: 'step-select-players',
	        isOpen: false
	      }, {
	        id: 'step-score-enter',
	        isOpen: false
	      }
	    ],
	    editMode: false,
	    init: function(round) {
	      if (round) {
	        this.steps[0].isOpen = false;
	        this.steps[1].isOpen = true;
	        this.steps[2].isOpen = true;
	        this.steps[3].isOpen = true;
	        return this.editMode = true;
	      } else {
	        this.steps[0].isOpen = true;
	        this.steps[1].isOpen = false;
	        this.steps[2].isOpen = false;
	        this.steps[3].isOpen = false;
	        return this.editMode = false;
	      }
	    },
	    goToStep: function(stepIndex) {
	      var $element, step;
	      step = this.steps[stepIndex];
	      step.isOpen = true;
	      $element = $('#' + step.id);
	      return $timeout(function() {
	        $('html, body').animate({
	          scrollTop: $element.offset().top
	        }, 200);
	        return $element.find('input:enabled').first().focus();
	      }, 200);
	    }
	  };
	};
	
	AccordionStateHolder.$inject = ['$timeout'];
	
	module.exports = AccordionStateHolder;


/***/ }),
/* 441 */
/***/ (function(module, exports) {

	module.exports = {
	  '_SCORE_REGISTRATION': {
	    'TITLE': 'Score entry',
	    'SELECT_CLUB': {
	      'TITLE': 'Select Club',
	      'SEARCH': 'Search',
	      'HISTORY': 'History',
	      'NORESULT': "No Result.",
	      'COURSE_REQUEST_HINT': "If you can't find a course, please send request to add new course.",
	      'COURSE_REQUEST_LINK': 'Request',
	      'INPUT_KEYWORDS': 'Input keywords',
	      'EMAIL_SUBJECT': 'Course Request'
	    },
	    'SELECT_CLUB_HISTORY': {
	      'NORESULT': "Rounds information Unregistered"
	    },
	    'ROUND_INFO': {
	      'TITLE': 'Input Round Information',
	      'HOLE_1': 'Hole 1',
	      'HOLE_10': 'Hole 10',
	      'COURSE_REQUEST': 'Please select a course',
	      'START_REQUEST': 'Please select a start',
	      'TEE_REQUEST': 'Please select a tee',
	      'RAKUTEN_LINK': 'Reserve this golf course',
	      'PLAY_DATE': 'Play date',
	      'WEATHER': 'Weather',
	      'COURSE': 'Course',
	      'START_HOLE': 'Start',
	      'TEE_POSITION': 'Tee Position',
	      'EXTRA_9': 'Extra 9',
	      'NONE': 'None',
	      'MOVE_TO_SELECT_PLAYERS': 'Next: Add / Save Players',
	      'CONFIRM_CLEAR_DATA': 'The data you entered below this field will be cleared. Are you sure?',
	      'ERROR_FLASH_MESSAGE': 'There are some errors on your input. Please check again.'
	    },
	    'SELECT_PLAYERS': {
	      'SELECT_PLAYER_TITLE': 'Add / Save Players',
	      'PARTNER': 'Partner',
	      'MOVE_TO_SCORE_REGISTRATION': 'Next: Enter Score',
	      'DUPLICATE_PLAYER': 'This name is already registered. Please input another name.',
	      'CONFIRM_CLEAR_SCORE': 'The score data for this player will be cleared. Are you sure?'
	    },
	    'SCORE_ENTRY': {
	      'TITLE': 'Enter Score'
	    },
	    'FOOTER': {
	      'TITLE': 'Complete'
	    },
	    'UNSAVED_HINT': 'Click OK to apply your changes.'
	  }
	};


/***/ }),
/* 442 */
/***/ (function(module, exports) {

	module.exports = {
	  '_SCORE_REGISTRATION': {
	    'TITLE': 'スコア登録',
	    'SELECT_CLUB': {
	      'TITLE': 'コースの選択',
	      'SEARCH': '検索',
	      'HISTORY': '履歴',
	      'NORESULT': "該当結果なし",
	      'COURSE_REQUEST_HINT': '希望のコースが見つからない場合は追加リクエストをお送りください。',
	      'COURSE_REQUEST_LINK': 'リクエスト',
	      'INPUT_KEYWORDS': 'キーワードを入力してください',
	      'EMAIL_SUBJECT': 'Course Request'
	    },
	    'SELECT_CLUB_HISTORY': {
	      'NORESULT': "該当するラウンド情報がありません"
	    },
	    'ROUND_INFO': {
	      'TITLE': 'ラウンド情報の設定',
	      'HOLE_1': '1ホール',
	      'HOLE_10': '10ホール',
	      'COURSE_REQUEST': 'コースを選択してください',
	      'START_REQUEST': 'スタートを選択してください',
	      'TEE_REQUEST': 'ティーを選択してください',
	      'RAKUTEN_LINK': '予約プランを見る（予約も可)',
	      'PLAY_DATE': 'プレイ日',
	      'WEATHER': '天気',
	      'COURSE': 'コース',
	      'START_HOLE': 'スタート',
	      'TEE_POSITION': 'ティー',
	      'EXTRA_9': 'エクストラ 9',
	      'NONE': '設定なし',
	      'MOVE_TO_SELECT_PLAYERS': '同伴者の設定へ',
	      'CONFIRM_CLEAR_DATA': 'これより下の入力内容がクリアされますが、よろしいでしょうか？',
	      'ERROR_FLASH_MESSAGE': '入力内容に問題が有ります。再度ご確認下さい。'
	    },
	    'SELECT_PLAYERS': {
	      'SELECT_PLAYER_TITLE': '同伴者の設定',
	      'PARTNER': '同伴者',
	      'MOVE_TO_SCORE_REGISTRATION': 'スコアの入力へ',
	      'DUPLICATE_PLAYER': 'その名前は既に登録されています。別の名前を入力してください。',
	      'CONFIRM_CLEAR_SCORE': '変更した Player のスコア入力はクリアされますが、よろしいでしょうか？'
	    },
	    'SCORE_ENTRY': {
	      'TITLE': 'スコアの入力'
	    },
	    'FOOTER': {
	      'TITLE': 'スコア登録完了'
	    },
	    'UNSAVED_HINT': 'OK ボタンを押して変更を適用して下さい。'
	  }
	};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	var TermService, TermShowCtrl, modules;
	
	__webpack_require__(444);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(445);
	
	__webpack_require__(59);
	
	__webpack_require__(82);
	
	__webpack_require__(108);
	
	__webpack_require__(447);
	
	TermShowCtrl = __webpack_require__(449);
	
	TermService = __webpack_require__(333);
	
	modules = ['ngRoute', 'ngSanitize', 'gnp-translation', 'gnp-term', 'gnp-common-wrapper', 'gnp-error-handler'];
	
	angular.module("gnp-app-term", modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/term', {
	      templateUrl: 'web/term/show.jade',
	      controller: 'TermShowCtrl',
	      resolve: {
	        term: [
	          'TermService', function(TermService) {
	            return TermService.get();
	          }
	        ]
	      },
	      title: '_TERM.TITLE'
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(450)).translations('ja', __webpack_require__(451));
	  }
	]).controller('TermShowCtrl', TermShowCtrl);


/***/ }),
/* 444 */
/***/ (function(module, exports) {

	var v1="<div gnp-common-wrapper-a=\"\"><div id=\"term_main\"><div class=\"term container\"><div class=\"content\"><p></p><h2>{{ ::'_TERM.TITLE' | translate }}</h2><p></p><div ng-bind-html=\"termBody\"></div></div><button type=\"submit\" ng-click=\"accept()\" class=\"btn\">{{ ::'_TERM.ACCEPT_BUTTON' | translate }}</button></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/term/show.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(446);

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var angular = __webpack_require__(28);
	
	/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	var bind;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var lowercase;
	var noop;
	var nodeContains;
	var htmlParser;
	var htmlSanitizeWriter;
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a trusted URI list) are
	 *   then serialized back to a properly escaped HTML string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The trusted URIs for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationTrustedUrlList` and `imgSrcSanitizationTrustedUrlList` of {@link $compileProvider}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 * @this
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var hasBeenInstantiated = false;
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    hasBeenInstantiated = true;
	    if (svgEnabled) {
	      extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#addValidElements
	   * @kind function
	   *
	   * @description
	   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
	   * and are not stripped off during sanitization. You can extend the following lists of elements:
	   *
	   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
	   *   elements. HTML elements considered safe will not be removed during sanitization. All other
	   *   elements will be stripped off.
	   *
	   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
	   *   "void elements" (similar to HTML
	   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
	   *   elements have no end tag and cannot have content.
	   *
	   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
	   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
	   *   `$sanitize`.
	   *
	   * <div class="alert alert-info">
	   *   This method must be called during the {@link angular.Module#config config} phase. Once the
	   *   `$sanitize` service has been instantiated, this method has no effect.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
	   *   other vulnerabilities. Be very mindful of the elements you add.
	   * </div>
	   *
	   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
	   *   more of the following properties:
	   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
	   *     HTML elements.
	   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
	   *     void HTML elements; i.e. elements that do not have an end tag.
	   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
	   *     elements. The list of SVG elements is only taken into account if SVG is
	   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
	   *
	   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
	   *
	   * @return {$sanitizeProvider} Returns self for chaining.
	   */
	  this.addValidElements = function(elements) {
	    if (!hasBeenInstantiated) {
	      if (isArray(elements)) {
	        elements = {htmlElements: elements};
	      }
	
	      addElementsTo(svgElements, elements.svgElements);
	      addElementsTo(voidElements, elements.htmlVoidElements);
	      addElementsTo(validElements, elements.htmlVoidElements);
	      addElementsTo(validElements, elements.htmlElements);
	    }
	
	    return this;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#addValidAttrs
	   * @kind function
	   *
	   * @description
	   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
	   * not stripped off during sanitization.
	   *
	   * **Note**:
	   * The new attributes will not be treated as URI attributes, which means their values will not be
	   * sanitized as URIs using `$compileProvider`'s
	   * {@link ng.$compileProvider#aHrefSanitizationTrustedUrlList aHrefSanitizationTrustedUrlList} and
	   * {@link ng.$compileProvider#imgSrcSanitizationTrustedUrlList imgSrcSanitizationTrustedUrlList}.
	   *
	   * <div class="alert alert-info">
	   *   This method must be called during the {@link angular.Module#config config} phase. Once the
	   *   `$sanitize` service has been instantiated, this method has no effect.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
	   *   other vulnerabilities. Be very mindful of the attributes you add.
	   * </div>
	   *
	   * @param {Array<String>} attrs - A list of valid attributes.
	   *
	   * @returns {$sanitizeProvider} Returns self for chaining.
	   */
	  this.addValidAttrs = function(attrs) {
	    if (!hasBeenInstantiated) {
	      extend(validAttrs, arrayToMap(attrs, true));
	    }
	    return this;
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	  // Private stuff
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	
	  bind = angular.bind;
	  extend = angular.extend;
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isDefined = angular.isDefined;
	  lowercase = angular.$$lowercase;
	  noop = angular.noop;
	
	  htmlParser = htmlParserImpl;
	  htmlSanitizeWriter = htmlSanitizeWriterImpl;
	
	  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
	    // eslint-disable-next-line no-bitwise
	    return !!(this.compareDocumentPosition(arg) & 16);
	  };
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	    // Match everything outside of normal chars and " (quote character)
	    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;
	
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = stringToMap('area,br,col,hr,img,wbr');
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = stringToMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
	      optionalEndTagInlineElements = stringToMap('rp,rt'),
	      optionalEndTagElements = extend({},
	                                              optionalEndTagInlineElements,
	                                              optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = extend({}, optionalEndTagBlockElements, stringToMap('address,article,' +
	          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
	          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));
	
	  // Inline Elements - HTML5
	  var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap('a,abbr,acronym,b,' +
	          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
	          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = stringToMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
	          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
	          'radialGradient,rect,stop,svg,switch,text,title,tspan');
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = stringToMap('script,style');
	
	  var validElements = extend({},
	                                     voidElements,
	                                     blockElements,
	                                     inlineElements,
	                                     optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = stringToMap('background,cite,href,longdesc,src,xlink:href,xml:base');
	
	  var htmlAttrs = stringToMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	      'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = stringToMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = extend({},
	                                  uriAttrs,
	                                  svgAttrs,
	                                  htmlAttrs);
	
	  function stringToMap(str, lowercaseKeys) {
	    return arrayToMap(str.split(','), lowercaseKeys);
	  }
	
	  function arrayToMap(items, lowercaseKeys) {
	    var obj = {}, i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  function addElementsTo(elementsMap, newElements) {
	    if (newElements && newElements.length) {
	      extend(elementsMap, arrayToMap(newElements));
	    }
	  }
	
	  /**
	   * Create an inert document that contains the dirty HTML that needs sanitizing.
	   * We use the DOMParser API by default and fall back to createHTMLDocument if DOMParser is not
	   * available.
	   */
	  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
	    if (isDOMParserAvailable()) {
	      return getInertBodyElement_DOMParser;
	    }
	
	    if (!document || !document.implementation) {
	      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
	    }
	    var inertDocument = document.implementation.createHTMLDocument('inert');
	    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');
	    return getInertBodyElement_InertDocument;
	
	    function isDOMParserAvailable() {
	      try {
	        return !!getInertBodyElement_DOMParser('');
	      } catch (e) {
	        return false;
	      }
	    }
	
	    function getInertBodyElement_DOMParser(html) {
	      // We add this dummy element to ensure that the rest of the content is parsed as expected
	      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
	      html = '<remove></remove>' + html;
	      try {
	        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
	        body.firstChild.remove();
	        return body;
	      } catch (e) {
	        return undefined;
	      }
	    }
	
	    function getInertBodyElement_InertDocument(html) {
	      inertBodyElement.innerHTML = html;
	
	      // Support: IE 9-11 only
	      // strip custom-namespaced attributes on IE<=11
	      if (document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	
	      return inertBodyElement;
	    }
	  })(window, window.document);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParserImpl(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	
	    var inertBodyElement = getInertBodyElement(html);
	    if (!inertBodyElement) return '';
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
	      }
	      mXSSAttempts--;
	
	      // trigger mXSS if it is going to happen by reading and writing the innerHTML
	      html = inertBodyElement.innerHTML;
	      inertBodyElement = getInertBodyElement(html);
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1: // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3: // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	        if (node.nodeType === 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = getNonDescendant('nextSibling', node);
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = getNonDescendant('parentNode', node);
	            if (node === inertBodyElement) break;
	            nextNode = getNonDescendant('nextSibling', node);
	            if (node.nodeType === 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while ((node = inertBodyElement.firstChild)) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.
	      replace(/&/g, '&amp;').
	      replace(SURROGATE_PAIR_REGEXP, function(value) {
	        var hi = value.charCodeAt(0);
	        var low = value.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	      }).
	      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	        return '&#' + value.charCodeAt(0) + ';';
	      }).
	      replace(/</g, '&lt;').
	      replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriterImpl(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = bind(buf, buf.push);
	    return {
	      start: function(tag, attrs) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          forEach(attrs, function(value, key) {
	            var lkey = lowercase(key);
	            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	            if (validAttrs[lkey] === true &&
	              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function(tag) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        // eslint-disable-next-line eqeqeq
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function(chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(chars));
	        }
	      }
	    };
	  }
	
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    while (node) {
	      if (node.nodeType === window.Node.ELEMENT_NODE) {
	        var attrs = node.attributes;
	        for (var i = 0, l = attrs.length; i < l; i++) {
	          var attrNode = attrs[i];
	          var attrName = attrNode.name.toLowerCase();
	          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	            node.removeAttributeNode(attrNode);
	            i--;
	            l--;
	          }
	        }
	      }
	
	      var nextNode = node.firstChild;
	      if (nextNode) {
	        stripCustomNsAttrs(nextNode);
	      }
	
	      node = getNonDescendant('nextSibling', node);
	    }
	  }
	
	  function getNonDescendant(propName, node) {
	    // An element is clobbered if its `propName` property points to one of its descendants
	    var nextNode = node[propName];
	    if (nextNode && nodeContains.call(node, nextNode)) {
	      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
	    }
	    return nextNode;
	  }
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', [])
	  .provider('$sanitize', $SanitizeProvider)
	  .info({ angularVersion: '1.8.3' });
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n' +
	             'http://angularjs.org/,\n' +
	             'mailto:us@somewhere.org,\n' +
	             'another@somewhere.org,\n' +
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isDefined = angular.isDefined;
	  var isFunction = angular.isFunction;
	  var isObject = angular.isObject;
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      isFunction(attributes) ? attributes :
	      isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);
	


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(448);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_term.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_term.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#term_main .term.container{max-width:none!important}#term_main .cell{padding:0}#term_main h2{font-size:23px;color:#000}#term_main h3{font-size:17px;margin-top:10px;margin-bottom:15px}#term_main .term.container{width:970px;padding-bottom:50px;background-color:#fff}#term_main .term.container .content{width:780px;margin:60px auto 0}#term_main .term.container .content p{text-indent:-1em;padding-left:2em;margin-bottom:1em}#term_main .btn{position:relative;top:25px;left:50%;width:90px;margin-left:-45px;background-color:#000;color:#fff}", ""]);

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	var TermShowCtrl;
	
	TermShowCtrl = function($scope, $location, TermService, term, AuthService) {
	  $scope.termBody = term.data.body;
	  return $scope.accept = function() {
	    if (AuthService.isSignedIn()) {
	      return TermService.accept();
	    } else {
	      return TermService.acceptLocal(term.data.version);
	    }
	  };
	};
	
	TermShowCtrl.$inject = ['$scope', '$location', 'TermService', 'term', 'AuthService'];
	
	module.exports = TermShowCtrl;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

	module.exports = {
	  '_TERM': {
	    'TITLE': 'Terms of use',
	    'ACCEPT_BUTTON': 'Accept'
	  }
	};


/***/ }),
/* 451 */
/***/ (function(module, exports) {

	module.exports = {
	  '_TERM': {
	    'TITLE': '利用規約',
	    'ACCEPT_BUTTON': '同意する'
	  }
	};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	var AnalysisService, BasicAnalysisCtrl, ClubFilterCtrl, CourseFilterCtrl, DateRangePickerDirective, DetailedAnalysisCtrl, IndexCtrl, PeriodFilterCtrl, ScatterChartDirective, ScatterDataCtrl, ScatterDataService, ScoreAnalysisCtrl, StrokeAnalysisCtrl, TimeSeriesDataCtrl, modules;
	
	__webpack_require__(453);
	
	__webpack_require__(454);
	
	__webpack_require__(455);
	
	__webpack_require__(456);
	
	__webpack_require__(457);
	
	__webpack_require__(458);
	
	__webpack_require__(459);
	
	__webpack_require__(460);
	
	__webpack_require__(461);
	
	__webpack_require__(462);
	
	__webpack_require__(463);
	
	__webpack_require__(471);
	
	__webpack_require__(472);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(384);
	
	__webpack_require__(386);
	
	__webpack_require__(59);
	
	__webpack_require__(82);
	
	__webpack_require__(76);
	
	__webpack_require__(473);
	
	__webpack_require__(274);
	
	__webpack_require__(278);
	
	__webpack_require__(389);
	
	__webpack_require__(416);
	
	__webpack_require__(487);
	
	__webpack_require__(108);
	
	__webpack_require__(39);
	
	IndexCtrl = __webpack_require__(495);
	
	PeriodFilterCtrl = __webpack_require__(496);
	
	ClubFilterCtrl = __webpack_require__(497);
	
	CourseFilterCtrl = __webpack_require__(498);
	
	BasicAnalysisCtrl = __webpack_require__(499);
	
	AnalysisService = __webpack_require__(500);
	
	DateRangePickerDirective = __webpack_require__(501);
	
	StrokeAnalysisCtrl = __webpack_require__(507);
	
	ScoreAnalysisCtrl = __webpack_require__(508);
	
	TimeSeriesDataCtrl = __webpack_require__(509);
	
	DetailedAnalysisCtrl = __webpack_require__(510);
	
	ScatterDataCtrl = __webpack_require__(511);
	
	ScatterDataService = __webpack_require__(512);
	
	ScatterChartDirective = __webpack_require__(513);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-common-wrapper', 'gnp-auth', 'ui.map', 'gnp-analysis-charts', 'gnp-app-goal-settings', 'gnp-payment', 'gnp-remote-api', 'gnp-error-handler', 'gnp-number', 'gnp-map', 'gnp-analyze-access'];
	
	angular.module("gnp-app-analysis", modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/analysis', {
	      templateUrl: 'web/analysis/index.jade',
	      controller: 'AnalysisCtrl',
	      resolve: {
	        goalSettings: [
	          'GoalAPIService', '$route', function(GoalAPIService, $route) {
	            var params;
	            params = {
	              user_id: $route.current.params.user_id
	            };
	            return GoalAPIService.getGoalSettings(params);
	          }
	        ],
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ]
	      },
	      title: '_ANALYSIS.TITLE',
	      permission: {
	        signInRequired: false
	      }
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(515)).translations('ja', __webpack_require__(516));
	  }
	]).controller('AnalysisCtrl', IndexCtrl).controller('AnalysisPeriodFilterCtrl', PeriodFilterCtrl).controller('AnalysisClubFilterCtrl', ClubFilterCtrl).controller('AnalysisCourseFilterCtrl', CourseFilterCtrl).controller('StrokeAnalysisCtrl', StrokeAnalysisCtrl).controller('ScoreAnalysisCtrl', ScoreAnalysisCtrl).controller('BasicAnalysisCtrl', BasicAnalysisCtrl).controller('AnalysisTimeSeriesDataCtrl', TimeSeriesDataCtrl).controller('AnalysisScatterDataCtrl', ScatterDataCtrl).controller('DetailedAnalysisCtrl', DetailedAnalysisCtrl).factory("AnalysisService", AnalysisService).factory("ScatterDataService", ScatterDataService).directive("gnpDateRangePicker", DateRangePickerDirective).directive("gnpScatterChart", ScatterChartDirective);


/***/ }),
/* 453 */
/***/ (function(module, exports) {

	var v1="<div id=\"score-analysis\" gnp-common-wrapper-a=\"\"><div ng-show=\"showNoResultMsg\" class=\"data container score-analysis-container {{hideNoResultMsg ? 'hide-header' : ''}}\"><div class=\"no-title\">{{ 'NO_ROUND.LETS_CREATE' | translate }}</div><div class=\"create-link\"><a ng-href=\"/score-registration\" analytics-on=\"click\" analytics-event=\"ANL_ScoreEntry_Rcmd\">{{ 'NO_ROUND.CREATE_NOW' | translate }}</a></div></div><div class=\"container score-analysis-container content-calendar\"><div ng-controller=\"AnalysisPeriodFilterCtrl as periodCtrl\" ng-include=\"'analysis/period-filter/period-filter.jade'\" class=\"bar-calendar {{hideHeader ? 'non-background' : ''}}\"></div><div gnp-indicator=\"isLoadingScoreCards || isLoadingMap\" class=\"container score-analysis-container content-map\"><div class=\"row mx-0\"><div class=\"col-12 no-padding\"><div ng-controller=\"AnalysisClubFilterCtrl as clubCtrl\" ng-include=\"'analysis/club-filter/club-filter.jade'\"></div></div></div><div class=\"row mx-0\"><div class=\"col-12 no-padding\"><div ng-controller=\"AnalysisCourseFilterCtrl as courseCtrl\" ng-include=\"'analysis/course-filter/course-filter.jade'\" ng-class=\"{freemember: !$root.paid}\" class=\"list\"></div></div></div></div></div><div ng-controller=\"AnalysisTimeSeriesDataCtrl as tsdCtrl\" ng-include=\"'analysis/time-series-data/time-series-data.jade'\" gnp-indicator=\"isLoadingScoreCards\" class=\"container score-analysis-container content-charts\"></div><div ng-controller=\"AnalysisScatterDataCtrl as sctCtrl\" ng-include=\"'analysis/scatter-data/scatter-data.jade'\" gnp-indicator=\"isLoadingScoreCards\" class=\"container score-analysis-container content-scatter-charts\"></div><div ng-show=\"isShowDetailedAnalysis\" gnp-indicator=\"isLoadingDetailedAnalysis\" ng-controller=\"BasicAnalysisCtrl as basicAnalysisCtrl\" ng-include=\"'analysis/basic-analysis/basic-analysis.jade'\" class=\"container score-analysis-container content-score-charts\"></div><div ng-show=\"isShowDetailedAnalysis\" class=\"container score-analysis-container content-semi-circle-charts\"><div class=\"row mx-0\"><div gnp-indicator=\"isLoadingDetailedAnalysis\" ng-controller=\"ScoreAnalysisCtrl as saCtrl\" ng-include=\"'analysis/score-analysis/score-analysis.jade'\" class=\"charts chart-left\"></div><div gnp-indicator=\"isLoadingDetailedAnalysis\" ng-controller=\"StrokeAnalysisCtrl as staCtrl\" ng-include=\"'analysis/stroke-analysis/stroke-analysis.jade'\" class=\"charts chart-right ml-auto\"></div></div></div><div ng-show=\"isShowDetailedAnalysis\" gnp-indicator=\"isLoadingDetailedAnalysis\" ng-controller=\"DetailedAnalysisCtrl as daCtrl\" ng-include=\"'analysis/detailed-analysis/detailed-analysis.jade'\"></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/analysis/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	var v1="<div gnp-basic-analysis=\"\" basic-analysis-data=\"basicAnalysisCtrl.basicAnalysisData\" class=\"score-circle-charts-wrap\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/basic-analysis/basic-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	var v1="<div id=\"map_canvas\" ng-if=\"clubCtrl.mapOptions\" ui-map=\"clubCtrl.myMap\" ui-options=\"clubCtrl.mapOptions\" ui-event=\"{'map-zoom_changed': 'clubCtrl.adjustMarkers()' }\" class=\"map\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/club-filter/club-filter.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	var v1="<ul ng-show=\"$root.paid || disableCourseStats\"><li ng-repeat=\"course in courseCtrl.courses track by course.id\" ng-click=\"courseCtrl.selectCourse(course)\"><div ng-class=\"{select: courseCtrl.selectedCourse === course}\" class=\"course-row col-4\"><div class=\"col-12 col-sm-2 no-padding\"><div class=\"column-num\">{{course.count}}</div></div><div class=\"col-12 col-sm-10 no-padding\"><div class=\"column-text\">{{course.club.name}} {{course.course.name}}</div></div></div></li></ul><ul ng-hide=\"$root.paid || disableCourseStats\"><li><div class=\"course-row col-4\"><div class=\"col-12 col-sm-2 no-padding\"><div class=\"column-num\">16</div></div><div class=\"col-12 col-sm-10 no-padding\"><div class=\"column-text\">Pine Valley Golf Club</div></div></div></li><li><div class=\"course-row col-4\"><div class=\"col-12 col-sm-2 no-padding\"><div class=\"column-num\">10</div></div><div class=\"col-12 col-sm-10 no-padding\"><div class=\"column-text\">Augusta National Golf Club</div></div></div></li><li><div class=\"course-row col-4\"><div class=\"col-12 col-sm-2 no-padding\"><div class=\"column-num\">8</div></div><div class=\"col-12 col-sm-10 no-padding\"><div class=\"column-text\">Cypress Point Club</div></div></div></li><li><div class=\"course-row col-4\"><div class=\"col-12 col-sm-2 no-padding\"><div class=\"column-num\">3</div></div><div class=\"col-12 col-sm-10 no-padding\"><div class=\"column-text\">Pebble Beach Golf Links</div></div></div></li></ul><div ng-hide=\"$root.paid || disableCourseStats\" class=\"message-dialog\"><div class=\"message\"><div class=\"title\">{{:: '_ANALYSIS.UPGRADE.COURSE_STATS' | translate }}</div><div ng-bind-html=\"'_ANALYSIS.UPGRADE.MESSAGE' | translate\" class=\"description\"></div><div class=\"btn-row\"><a href=\"/unlock\" analytics-on=\"click\" analytics-event=\"ANL_ByCourse\"><button type=\"button\" class=\"btn-link btn\">{{:: '_ANALYSIS.UPGRADE.UPGRADE_NOW' | translate }}</button></a></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/course-filter/course-filter.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	var v1="<div class=\"container content-board score-analysis-container\"><div class=\"row header\"><div class=\"col-12 no-padding\"><div class=\"head-column\"></div><div class=\"mydata\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.MY_DATA' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"classTitle\" class=\"pulldown\"><button data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"btn\"><span class=\"title\">{{nameSort}}</span><span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a ng-click=\"activeDisplay(1)\" class=\"goal\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.GOAL' | translate }}</a></li><li><a ng-click=\"activeDisplay(2)\" class=\"avg\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.MY_AVG' | translate }}</a></li><li><a ng-click=\"activeDisplay(3)\" class=\"best\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.BEST_SCORE' | translate }}</a></li><li><a ng-click=\"activeDisplay(4)\" class=\"worst\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.WORST_SCORE' | translate }}</a></li></ul></div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.GOAL' | translate }}</div><div class=\"column avg\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.MY_AVG' | translate }}</div><div class=\"column best\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.BEST_SCORE' | translate }}</div><div class=\"column worst\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.WORST_SCORE' | translate }}</div></div><div class=\"column all-avg\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.ALL_MEMBERS' | translate }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS.DETAILED_ANALYSIS.AVG_TOTAL_SCORE_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.NUMBER_OF_ROUNDS' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.cnt_score_cards }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">-</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">-</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.cnt_score_cards }}</div><div class=\"column best\">-</div><div class=\"column worst\">-</div></div><div class=\"column all-avg\"></div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.AVG_TOTAL_SCORE' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\">{{ ::(daCtrl.goal.avg_total_shot | percentToFormattedString) }}</div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.avg_total_shot | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.avg_total_shot | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.avg_total_shot | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\">{{ ::(daCtrl.goal.avg_total_shot | percentToFormattedString) }}</div><div class=\"column avg\">{{ daCtrl.my_avg.avg_total_shot | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.avg_total_shot | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.avg_total_shot | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.avg_total_shot | percentToFormattedString }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS.DETAILED_ANALYSIS.PUTT_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.AVG_PUTT' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\">{{ ::(daCtrl.goal.avg_putt | percentToFormattedString) }}</div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.avg_putt | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.avg_putt | percentToFormattedString | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.avg_putt | percentToFormattedString | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\">{{ ::(daCtrl.goal.avg_putt | percentToFormattedString) }}</div><div class=\"column avg\">{{ daCtrl.my_avg.avg_putt | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.avg_putt | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.avg_putt | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.avg_putt | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.RAT_AVG_PUTT' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.avg_par_on_putt_cnt | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.avg_par_on_putt_cnt | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.avg_par_on_putt_cnt | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.avg_par_on_putt_cnt | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.avg_par_on_putt_cnt | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.avg_par_on_putt_cnt | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.avg_par_on_putt_cnt | percentToFormattedString }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS.DETAILED_ANALYSIS.RAT_FAIRWAY_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.FAIRWAY_CENTER' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\">{{ ::(daCtrl.goal.rat_fairway_center * 100 | percentToFormattedString) }}</div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.rat_fairway_center * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.rat_fairway_center * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.rat_fairway_center * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\">{{ ::(daCtrl.goal.rat_fairway_center * 100 | percentToFormattedString) }}</div><div class=\"column avg\">{{ daCtrl.my_avg.rat_fairway_center * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.rat_fairway_center * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.rat_fairway_center * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.rat_fairway_center * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.FAIRWAY_RIGHT' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ ::(daCtrl.my_avg.rat_fairway_right * 100 | percentToFormattedString) }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.rat_fairway_right * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.rat_fairway_left * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.rat_fairway_right * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.rat_fairway_right * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.rat_fairway_right * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.rat_fairway_right * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.FAIRWAY_LEFT' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.rat_fairway_left * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.rat_fairway_left * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.rat_fairway_left * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.rat_fairway_left * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.rat_fairway_left * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.rat_fairway_left * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.rat_fairway_left * 100 | percentToFormattedString }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS.DETAILED_ANALYSIS.GIR_ANALYSIS_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.RAT_PAR_ON' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\">{{ ::(daCtrl.goal.rat_par_on * 100 | percentToFormattedString) }}</div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.rat_par_on * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.rat_par_on * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.rat_par_on * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\">{{ ::(daCtrl.goal.rat_par_on * 100 | percentToFormattedString) }}</div><div class=\"column avg\">{{ daCtrl.my_avg.rat_par_on * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.rat_par_on * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.rat_par_on * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.rat_par_on * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.RAT_BOGEY_ON' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\">{{ ::(daCtrl.goal.rat_bogey_on * 100 | percentToFormattedString) }}</div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.rat_bogey_on * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.rat_bogey_on * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.rat_bogey_on * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\">{{ ::(daCtrl.goal.rat_bogey_on * 100 | percentToFormattedString) }}</div><div class=\"column avg\">{{ daCtrl.my_avg.rat_bogey_on * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.rat_bogey_on * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.rat_bogey_on * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.rat_bogey_on * 100 | percentToFormattedString }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS.DETAILED_ANALYSIS.STROKE_ANALYSIS_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.AVG_STROKE_PAR3' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.avg_shot_par3 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.avg_shot_par3 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.avg_shot_par3 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.avg_shot_par3 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.avg_shot_par3 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.avg_shot_par3 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.avg_shot_par3 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.AVG_STROKE_PAR4' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.avg_shot_par4 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.avg_shot_par4 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.avg_shot_par4 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.avg_shot_par4 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.avg_shot_par4 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.avg_shot_par4 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.avg_shot_par4 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.AVG_STROKE_PAR5' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.avg_shot_par5 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.avg_shot_par5 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.avg_shot_par5 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.avg_shot_par5 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.avg_shot_par5 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.avg_shot_par5 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.avg_shot_par5 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.RAT_RECOVERY' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.rat_recovery * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.rat_recovery * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.rat_recovery * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.rat_recovery * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.rat_recovery * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.rat_recovery * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.rat_recovery * 100 | percentToFormattedString }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS.DETAILED_ANALYSIS.SCORE_ANALYSIS_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.RAT_UNDER_EAGLE' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.rat_under_eagle * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.rat_under_eagle * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.rat_under_eagle * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.rat_under_eagle * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.rat_under_eagle * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.rat_under_eagle * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.rat_under_eagle * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.RAT_BIRDIE' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.rat_birdie * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.rat_birdie * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.rat_birdie * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.rat_birdie * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.rat_birdie * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.rat_birdie * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.rat_birdie * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.RAT_PAR' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.rat_par * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.rat_par * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.rat_par * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.rat_par * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.rat_par * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.rat_par * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.rat_par * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.RAT_BOGEY' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.rat_bogey * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.rat_bogey * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.rat_bogey * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.rat_bogey * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.rat_bogey * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.rat_bogey * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.rat_bogey * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.RAT_DBOGEY' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.rat_dbogey * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.rat_dbogey * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.rat_dbogey * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.rat_dbogey * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.rat_dbogey * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.rat_dbogey * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.rat_dbogey * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.RAT_OVER_TBOGEY' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.rat_over_tbogey * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.rat_over_tbogey * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.rat_over_tbogey * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.rat_over_tbogey * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.rat_over_tbogey * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.rat_over_tbogey * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.rat_over_tbogey * 100 | percentToFormattedString }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS.DETAILED_ANALYSIS.SAND_SAVES_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS.DETAILED_ANALYSIS.RAT_SAND_SAVE' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daCtrl.my_avg.rat_sand_save * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daCtrl.best_score.rat_sand_save * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daCtrl.worst_score.rat_sand_save * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daCtrl.my_avg.rat_sand_save * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daCtrl.best_score.rat_sand_save * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daCtrl.worst_score.rat_sand_save * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daCtrl.all_members.rat_sand_save * 100 | percentToFormattedString }}</div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/detailed-analysis/detailed-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	var v1="<div class=\"d-none d-lg-block\"><div class=\"row mx-0\"><div class=\"col-lg-10\"><div class=\"row\"><div class=\"col-4 range-title\">{{:: '_ANALYSIS.PERIOD_FILTER.TARGET_RANGE' | translate }}</div><div gnp-date-range-picker=\"\" start=\"periodCtrl.startDate\" end=\"periodCtrl.endDate\" user=\"periodCtrl.user_id\" class=\"col-8 range-selector\"></div></div><div class=\"round\"><div class=\"row\"><div class=\"col-4 range-title\">{{:: '_ANALYSIS.PERIOD_FILTER.TARGET_ROUND' | translate }}</div><div class=\"col-8 round-checkbox\"><div class=\"row mx-0\"><div ng-class=\"{ 'checked-table' : isInclude15 }\" class=\"col-6 round-check border-right-none\"><label><input type=\"checkbox\" ng-model=\"isInclude15\" ng-click=\"clickInclude15(isInclude15)\" class=\"custom-radio\"/><span class=\"course-name\">{{ (isInclude15 ? '_ANALYSIS.PERIOD_FILTER.INCLUDE_1_5' : '_ANALYSIS.PERIOD_FILTER.EXCLUDE_1_5') | translate }}</span></label></div><div ng-class=\"{ 'checked-table' : isInclude05 }\" class=\"col-6 round-check\"><label><input type=\"checkbox\" ng-model=\"isInclude05\" ng-click=\"clickInclude05(isInclude05)\" class=\"custom-radio\"/><span class=\"course-name\">{{ (isInclude05 ? '_ANALYSIS.PERIOD_FILTER.INCLUDE_0_5' : '_ANALYSIS.PERIOD_FILTER.EXCLUDE_0_5') | translate }}</span></label></div></div></div></div></div></div><div class=\"col-lg-2\"><a href=\"/goal-settings\" analytics-on=\"click\" analytics-event=\"ANL_TgtSetting\" class=\"range-goal click {{hideHeader ? 'hide-header' : ''}}\">{{:: '_GOAL_SETTINGS.TITLE' | translate }}</a></div></div></div><div class=\"d-lg-none filter-container\"><div class=\"row\"><div class=\"col-4 range-title\">{{:: '_ANALYSIS.PERIOD_FILTER.TARGET_RANGE' | translate }}</div><div gnp-date-range-picker=\"\" start=\"periodCtrl.startDate\" end=\"periodCtrl.endDate\" user=\"periodCtrl.user_id\" class=\"col-4 range-selector\"></div><a href=\"/goal-settings\" analytics-on=\"click\" analytics-event=\"ANL_TgtSetting\" class=\"col-4 range-goal click {{hideHeader ? 'hide-header' : ''}}\">{{:: '_GOAL_SETTINGS.TITLE' | translate }}</a></div></div><div class=\"d-lg-none filter-container round\"><div class=\"row\"><div class=\"col-4 range-title\">{{:: '_ANALYSIS.PERIOD_FILTER.TARGET_ROUND' | translate }}</div><div class=\"col-8 round-checkbox\"><div class=\"row mx-0\"><div ng-class=\"{ 'checked-table' : isInclude15 }\" class=\"col-6 round-check border-right-none\"><label><input type=\"checkbox\" ng-model=\"isInclude15\" ng-click=\"clickInclude15(isInclude15)\" class=\"custom-radio\"/><span class=\"course-name\">{{ (isInclude15 ? '_ANALYSIS.PERIOD_FILTER.INCLUDE_1_5_SP' : '_ANALYSIS.PERIOD_FILTER.EXCLUDE_1_5_SP') | translate }}</span></label></div><div ng-class=\"{ 'checked-table' : isInclude05 }\" class=\"col-6 round-check\"><label><input type=\"checkbox\" ng-model=\"isInclude05\" ng-click=\"clickInclude05(isInclude05)\" class=\"custom-radio\"/><span class=\"course-name\">{{ (isInclude05 ? '_ANALYSIS.PERIOD_FILTER.INCLUDE_0_5_SP' : '_ANALYSIS.PERIOD_FILTER.EXCLUDE_0_5_SP') | translate }}</span></label></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/period-filter/period-filter.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	var v1="<div class=\"row\"><div class=\"col-12 col-sm-6 col-md-8\"><div class=\"chart-wrap\"><div class=\"score\">{{:: '_ANALYSIS.SCATTER_CHART.SCORE' | translate }}</div><div class=\"pat\">{{:: '_ANALYSIS.SCATTER_CHART.PUTT' | translate }}</div><div gnp-scatter-chart=\"\" score-data=\"sctCtrl.filteredScorecards\" goal=\"sctCtrl.goal\"></div><div ng-hide=\"$root.paid || disableCourseStats\" class=\"message-dialog\"><div class=\"message\"><div class=\"title\">{{:: '_ANALYSIS.UPGRADE.SCATTER' | translate }}</div><div ng-bind-html=\"'_ANALYSIS.UPGRADE.MESSAGE' | translate\" class=\"description\"></div><div class=\"btn-row\"><a href=\"/unlock\" analytics-on=\"click\" analytics-event=\"ANL_DistMap\"><button class=\"btn-link btn\">{{:: '_ANALYSIS.UPGRADE.UPGRADE_NOW' | translate }}</button></a></div></div></div></div></div><div class=\"col-12 col-sm-6 col-md-4\"><div class=\"ad\"><div id=\"div-gpt-ad-1415763058975-0\" style=\"width:300px; height:250px\" class=\"ad-space\"><script type=\"text/javascript\">googletag.cmd.push(function () {\n  googletag.display('div-gpt-ad-1415763058975-0');\n});</script></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/scatter-data/scatter-data.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	var v1="<div gnp-score-analysis=\"\" score-data=\"saCtrl.scoreData\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/score-analysis/score-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	var v1="<div gnp-stroke-analysis=\"\" stroke-data=\"staCtrl.strokeData\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/stroke-analysis/stroke-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	var v1="<div><div ng-if=\"tsdCtrl.course\" class=\"course-name\">{{tsdCtrl.course.club.name}} {{tsdCtrl.course.course.name}}</div><div gnp-time-series-analysis=\"\" score-data=\"tsdCtrl.scoreData\"></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/time-series-data/time-series-data.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(464);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_score_analysis.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_score_analysis.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.content-calendar .bar-calendar{position:relative;width:100%;height:40px;background-color:#333;background-image:url("+__webpack_require__(465)+");background-repeat:no-repeat;background-position:right center}.content-calendar .bar-calendar a.click{position:relative;left:0;float:right;text-decoration:none;color:#fff;background-color:#ee2e2e}.content-calendar .bar-calendar .select-wrap{position:relative;overflow:hidden;display:inline-block;min-width:12em;width:220px;background-color:#555;background-repeat:no-repeat;background-position:200px 15px;background-image:url("+__webpack_require__(466)+");color:#ddd}.content-calendar .bar-calendar .select-wrap span{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;position:relative;display:block;outline:none;border:0;height:30px;margin:5px 10px;line-height:30px;color:#ddd;font-size:16px;text-indent:.01px;text-overflow:\"\";width:270px}.content-calendar .bar-calendar .round-check{height:50px;line-height:20px}.content-calendar .bar-calendar .round-check.col-6{overflow:hidden}.content-calendar .bar-calendar .round-check.col-6 td{padding-right:10px}.content-calendar .bar-calendar .round-check.border-right-none{border-right:none}.content-calendar .bar-calendar{background-image:none;background-color:transparent}.content-calendar .bar-calendar .filter-container{width:85%;margin:0 auto}.content-calendar .bar-calendar .round{margin-top:20px}.content-calendar .bar-calendar .range-title{font-size:1.1em;height:50px;line-height:50px;background-color:#333;color:#fff;text-align:center;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical}.content-calendar .bar-calendar .range-selector{font-size:1.1em;height:50px;color:#fff;background-color:#4b4b4b;text-align:center;word-break:break-all;white-space:normal}.content-calendar .bar-calendar .range-selector .show-period{line-height:50px}.content-calendar .bar-calendar .range-selector .show-date-only{padding-top:8px}.content-calendar .bar-calendar .range-selector.col-4{padding-left:0;padding-right:0}.content-calendar .bar-calendar .round-checkbox{font-size:1.1em;height:50px;background-color:transparent;text-align:center;padding:0}.content-calendar .bar-calendar .round-checkbox label{font-size:10px;line-height:24px}.content-calendar .bar-calendar a.click{font-size:1.1em;width:33.33333%;padding-top:0;padding-left:0;height:50px;line-height:100px;text-align:center}.content-calendar .bar-calendar tbody tr td{vertical-align:middle}.content-calendar .bar-calendar tbody label{display:block;margin-bottom:0}.content-calendar .bar-calendar .custom-radio{display:none}.content-calendar .bar-calendar .course-name{padding-left:25px;text-indent:-1em;position:relative;font-weight:700}.content-calendar .bar-calendar .course-name::before{content:\"\";display:block;position:absolute;top:3px;left:0;width:15px;height:15px;border:1px solid #4b4b4b;border-radius:4px}.content-calendar .bar-calendar .custom-radio:checked{color:#07a3a4}.content-calendar .bar-calendar .custom-radio:checked+.course-name::after{content:\"\";display:block;position:absolute;top:3px;left:5px;width:7px;height:12px;transform:rotate(40deg);border-bottom:2px solid #fff;border-right:2px solid #fff}.content-calendar .bar-calendar .custom-radio:checked+.course-name::before{background-color:#4b4b4b}.content-calendar .bar-calendar .round-check{border:solid 1px #555}.content-calendar .bar-calendar .round-check.col-6{padding:0 10px}.content-calendar .bar-calendar .round-check.col-6 .course-name{font-size:1.3em;padding-left:35px;display:-webkit-box;-webkit-box-orient:vertical}.content-calendar .bar-calendar .round-check.col-6 .course-name::before{margin:5px 0;height:30px;width:30px}.content-calendar .bar-calendar .round-check.col-6 .course-name::after{top:12px;left:10px;width:10px;height:18px}.content-calendar .bar-calendar .checked-table{background-color:#4b4b4b}.content-calendar .bar-calendar .checked-table .course-name{color:#fff}.content-calendar .bar-calendar .checked-table .course-name::before{border:1px solid #fff}@media (max-width:1024px){.content-calendar .bar-calendar .filter-container{width:96%}.content-calendar .bar-calendar a.click{line-height:50px}}@media (max-width:768px){.content-calendar .bar-calendar .filter-container{width:90%}}@media (max-width:414px){.content-calendar .bar-calendar .filter-container{width:83%}}@media (min-width:768px){.content-calendar .bar-calendar .round-check.col-6 .course-name{font-size:14px;width:200px;display:table-cell;line-height:45px}}@media (min-width:992px){.content-calendar .bar-calendar .round-check.col-6 .course-name{width:250px}.content-calendar .bar-calendar .col-lg-2{padding:0}.content-calendar .bar-calendar .round{margin-top:1px}}@media (min-width:1025px){.content-calendar .bar-calendar .range-goal.click{width:100%;min-height:100px}}#score-analysis .content-map{position:relative;margin-top:100px;background-color:#fff;min-height:400px}#score-analysis .content-map .circle{border-radius:50%;font-size:20px;color:#fff;font-weight:700;line-height:100px;text-align:center;background:#008b8b}#score-analysis .content-map .map{width:100%;height:400px;text-align:center;background-color:#EEFBFA}#score-analysis .content-map .list{height:110px;right:10px;top:10px;overflow-x:scroll;overflow-y:hidden;background-color:#FFF}#score-analysis .content-map .list.freemode{overflow-y:hidden}#score-analysis .content-map .list ul{list-style-type:none;margin:0 0 0 -10px;white-space:nowrap;width:100000%;padding-left:0}#score-analysis .content-map .list ul li{width:300px;display:inline;float:left}#score-analysis .content-map .list ul .course-row{width:100%;height:100px;position:relative;border-bottom:1px solid #F2F2F2;border-right:1px solid gray}#score-analysis .content-map .list ul .course-row.select{background-color:#8ab1b0}#score-analysis .content-map .list ul .course-row.select .column-num{font-weight:700;font-style:italic;color:#000}#score-analysis .content-map .list ul .course-row.select .column-text{font-weight:700;font-style:italic}#score-analysis .content-map .list ul .course-row:hover{background-color:#EEFBFA}#score-analysis .content-map .list ul .course-row .column-num{position:relative;height:100px;color:#00B2AF;line-height:32px;text-align:right;font-weight:700;font-size:16px;padding-right:10px}#score-analysis .content-map .list ul .course-row .column-text{position:relative;width:100%;margin-top:8px;margin-bottom:6px;margin-left:10px;float:left;line-height:150%;font-size:13px;white-space:normal;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}#score-analysis .content-map .list .message-dialog{position:absolute;top:0;left:15px;width:calc(100% - 30px);min-height:100%;background-color:rgba(0,0,0,.5)}#score-analysis .content-map .list .message-dialog .message{width:76%;margin:0 auto;background-color:#FFA700;min-height:110px}#score-analysis .content-map .list .message-dialog .message .title{line-height:20px;font-weight:700;font-size:14px;color:#000;text-align:center}#score-analysis .content-map .list .message-dialog .message .description{color:#000;text-align:center}#score-analysis .content-map .list .message-dialog .message .btn-row{position:relative;text-align:center}#score-analysis .content-map .list .message-dialog .message .btn-row .btn-link{position:relative;min-width:120px;margin-top:15px;min-height:30px;color:#fff;text-decoration:none;background-color:#000;width:\"\";height:\"\";border-radius:5px;border-color:#000;border-width:1px;border-style:solid}@media only screen and (max-width:768px){#score-analysis .content-map{margin-top:100px}#score-analysis .content-map .list ul li{width:250px}#score-analysis .content-map .list ul .course-row .column-text{width:100%;font-size:10px;margin-left:0}}@media only screen and (max-width:414px){#score-analysis .content-map .list.freemember{min-height:124px}#score-analysis .content-map .list ul li{width:150px}#score-analysis .content-map .list ul .course-row:hover{background-color:#8ab1b0}#score-analysis .content-map .list ul .course-row .column-num{text-align:center;padding:0;height:unset}}@media only screen and (max-width:320px){#score-analysis .content-map .list.freemember{min-height:140px}}#score-analysis .content-charts{position:relative;background-color:#fff;margin-bottom:20px;padding-bottom:40px}#score-analysis .content-charts .course-name{position:relative;width:820px;height:27px;background-color:#D9D9D9;border-radius:5px;top:28px;left:50%;padding:0 110px;margin-left:-410px;text-align:center;line-height:27px;font-weight:700;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}#score-analysis .content-charts .chart{position:relative;top:30px;left:50%;margin-left:-410px;width:820px}@media only screen and (max-width:768px){#score-analysis .content-charts .course-name{width:100%;padding:0;left:0;margin-left:0}#score-analysis .content-charts .chart{position:relative;top:30px;left:0;margin-left:0;width:100%}}#score-analysis .content-scatter-charts{position:relative;min-height:340px;background-color:#fff;margin-bottom:20px}#score-analysis .content-scatter-charts .chart-wrap{position:absolute;top:45px;left:60px;width:500px;height:250px;background-size:100% 100%,auto;background-repeat:no-repeat;background-image:url("+__webpack_require__(467)+")}#score-analysis .content-scatter-charts .chart-wrap .score{position:relative;margin-top:2px;margin-left:7px;color:#bbb;font-size:14px}#score-analysis .content-scatter-charts .chart-wrap .pat{position:relative;margin-top:208px;padding:0 10px;float:right;color:#bbb;font-size:14px}#score-analysis .content-scatter-charts .chart-wrap .chart{position:absolute;top:0;left:0;width:100%;height:250px}#score-analysis .content-scatter-charts .chart-wrap .message-dialog{position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5)}#score-analysis .content-scatter-charts .chart-wrap .message-dialog .message{position:absolute;top:50%;left:50%;width:310px;min-height:180px;margin-left:-150px;margin-top:-90px;background-color:#FFA700}#score-analysis .content-scatter-charts .chart-wrap .message-dialog .message .title{position:relative;margin-top:15px;margin-bottom:15px;line-height:30px;font-weight:700;font-size:14px;color:#000;text-align:center}#score-analysis .content-scatter-charts .chart-wrap .message-dialog .message .description{position:relative;width:260px;left:50%;margin-left:-130px;color:#000}#score-analysis .content-scatter-charts .chart-wrap .message-dialog .message .btn-row{position:relative;text-align:center}#score-analysis .content-scatter-charts .chart-wrap .message-dialog .message .btn-row .btn-link{position:relative;min-width:120px;margin-top:15px;min-height:30px;color:#fff;text-decoration:none;background-color:#000;width:\"\";height:\"\";border-radius:5px;border-color:#000;border-width:1px;border-style:solid}#score-analysis .content-scatter-charts .ad{position:absolute;top:45px;right:60px;width:100%;height:250px;text-align:center;line-height:250px}#score-analysis .content-scatter-charts .ad #div-gpt-ad-1415763058975-0{width:300px;float:right}@media only screen and (max-width:768px){#score-analysis .content-scatter-charts{padding:20px}#score-analysis .content-scatter-charts .chart-wrap{width:100%;position:-webkit-sticky;position:sticky}#score-analysis .content-scatter-charts .chart-wrap .chart{width:100%;margin:0 auto}#score-analysis .content-scatter-charts .ad{position:static}}@media (max-width:414px){#score-analysis .content-scatter-charts .chart-wrap{margin-bottom:20px}#score-analysis .content-scatter-charts .ad #div-gpt-ad-1415763058975-0{float:unset;margin:0 auto}}@media (max-width:320px){#score-analysis .content-scatter-charts .ad #div-gpt-ad-1415763058975-0{margin-left:-25px}}#score-analysis .content-board{position:relative;margin-bottom:20px;background-color:#fff}#score-analysis .content-board .row{position:relative;width:100%;height:40px;margin:0;line-height:40px;background-color:#fff;border-bottom:solid 1px #DEDEDE}#score-analysis .content-board .row.header{height:80px;font-size:12px;font-weight:700}#score-analysis .content-board .row.header .mydata{position:absolute;left:243px;height:40px;width:60%;background-color:#00B2AF;color:#fff;float:left;text-align:center;line-height:40px}#score-analysis .content-board .row.header .head-column{height:80px}#score-analysis .content-board .row.header .column{text-align:center}#score-analysis .content-board .row.header .column.goal{top:40px;background-color:#FEBABD}#score-analysis .content-board .row.header .column.avg{top:40px;background-color:#A3E9E7}#score-analysis .content-board .row.header .column.best{top:40px;background-color:#FFD4AD}#score-analysis .content-board .row.header .column.worst{top:40px;background-color:#ccc}#score-analysis .content-board .row.header .column.all-avg{background-color:#B2B096;height:80px;line-height:80px}#score-analysis .content-board .row.title{background-color:#D9D9D9;font-size:14px;font-weight:700;text-indent:20px}#score-analysis .content-board .row .head-column{position:relative;width:25%;height:40px;float:left;text-indent:30px;text-align:left}#score-analysis .content-board .row .column{position:relative;width:15%;height:40px;float:left}#score-analysis .content-board .row .column.goal{color:#FF0021}#score-analysis .content-board .row .column.avg{color:#00B2AF}#score-analysis .content-board .row .column.best{color:#f60}#score-analysis .content-board .row .column.best.label{line-height:normal;padding-top:7px;font-size:10px;border-radius:0}#score-analysis .content-board .row .column.worst{color:#666}#score-analysis .content-board .row .column.worst.label{line-height:normal;padding-top:7px;font-size:10px;border-radius:0}#score-analysis .content-board .row .column.all-avg{color:#7C7B69}#score-analysis .content-board .row.content{font-weight:700;text-align:center}#score-analysis .content-board .row.content .head-column{font-size:12px;text-align:left}#score-analysis .content-board .row.content .column{direction:rtl;font-size:14px}#score-analysis .content-board .row.content .column.all-avg{background-color:#D1D0C0;border-bottom:solid 1px #DEDEDE}@media (max-width:768px){#score-analysis .content-board{position:relative;margin-bottom:20px;background-color:#fff}#score-analysis .content-board .row{position:relative;width:100%;height:40px;margin:0;line-height:40px;background-color:#fff;border-bottom:solid 1px #DEDEDE}#score-analysis .content-board .row.header{height:80px;font-size:11px;font-weight:700}#score-analysis .content-board .row.header .mydata{position:absolute;width:60%;left:25%}#score-analysis .content-board .row.content{font-weight:700;text-align:center}#score-analysis .content-board .row.content .head-column{font-size:11px;text-indent:18px}}@media (max-width:600px){#score-analysis .content-board{position:relative;margin-bottom:20px;background-color:#fff}#score-analysis .content-board .row{position:relative;width:100%;height:40px;margin:0;line-height:40px;background-color:#fff;border-bottom:solid 1px #DEDEDE}#score-analysis .content-board .row.header{height:80px;font-size:12px;font-weight:700}#score-analysis .content-board .row.header .mydata{position:absolute;left:55%;height:40px;width:30%;background-color:#00B2AF;color:#fff;float:left;text-align:center;line-height:40px}#score-analysis .content-board .row.header .pulldown{position:absolute;left:55%;top:40px;height:40px;width:30%;background-color:#A3E9E7;color:#00B2AF;text-align:center}#score-analysis .content-board .row.header .pulldown .caret{margin-left:10px}#score-analysis .content-board .row.header .pulldown .title{font-size:10px;font-weight:700}#score-analysis .content-board .row.header .pulldown button{background:0 0;border:none;width:100%;padding:10px 0}#score-analysis .content-board .row.header .pulldown.goal{color:#FF0021;background-color:#FEBABD}#score-analysis .content-board .row.header .pulldown.avg{color:#00B2AF;background-color:#A3E9E7}#score-analysis .content-board .row.header .pulldown.best{color:#f60;background-color:#FFD4AD}#score-analysis .content-board .row.header .pulldown.worst{color:#666;background-color:#ccc}#score-analysis .content-board .row.header .pulldown ul.dropdown-menu{top:96%;left:0%;width:100%;padding:0;font-size:12px}#score-analysis .content-board .row.header .pulldown li a{color:#00B2AF;line-height:41px;text-align:center;padding:0;font-weight:inherit}#score-analysis .content-board .row.header .pulldown li a .text{margin:15px 0 0;line-height:0;font-size:12px}#score-analysis .content-board .row.header .pulldown li a .text .muted{padding-left:3.5em;color:darkgray}#score-analysis .content-board .row.header .pulldown li a.goal{color:#FF0021;background-color:#FEBABD}#score-analysis .content-board .row.header .pulldown li a.avg{color:#00B2AF;background-color:#A3E9E7}#score-analysis .content-board .row.header .pulldown li a.best{color:#f60;background-color:#FFD4AD}#score-analysis .content-board .row.header .pulldown li a.worst{color:#666;background-color:#ccc}#score-analysis .content-board .row.header .pulldown li a:hover{background-color:#c3e3e3}#score-analysis .content-board .row.header .head-column{height:80px}#score-analysis .content-board .row.header .column{text-align:center}#score-analysis .content-board .row.header .column.goal{top:40px;background-color:#FEBABD}#score-analysis .content-board .row.header .column.avg{top:40px;background-color:#A3E9E7}#score-analysis .content-board .row.header .column.best{top:40px;background-color:#FFD4AD}#score-analysis .content-board .row.header .column.worst{top:40px;background-color:#ccc}#score-analysis .content-board .row.header .column.all-avg{background-color:#B2B096;height:80px;line-height:35px;float:right}#score-analysis .content-board .row.title{background-color:#D9D9D9;font-size:14px;font-weight:700;text-indent:20px}#score-analysis .content-board .row .head-column{position:relative;width:25%;height:40px;float:left}#score-analysis .content-board .row .column{position:relative;width:15%;height:40px;float:left}#score-analysis .content-board .row .column.goal{color:#FF0021}#score-analysis .content-board .row .column.goal.hide{display:!important}#score-analysis .content-board .row .column.avg{color:#00B2AF}#score-analysis .content-board .row .column.avg.hide{display:!important}#score-analysis .content-board .row .column.best{color:#f60}#score-analysis .content-board .row .column.best.hide{display:none!important}#score-analysis .content-board .row .column.best.label{line-height:normal;padding-top:7px;font-size:10px;border-radius:0}#score-analysis .content-board .row .column.worst{color:#666}#score-analysis .content-board .row .column.worst.hide{display:none!important}#score-analysis .content-board .row .column.worst.label{line-height:normal;padding-top:7px;font-size:10px;border-radius:0}#score-analysis .content-board .row .column.all-avg{color:#7C7B69}#score-analysis .content-board .row.content{font-weight:700;text-align:center}#score-analysis .content-board .row.content .head-column{font-size:12px;width:55%}#score-analysis .content-board .row.content .column{direction:rtl;font-size:14px}#score-analysis .content-board .row.content .column.avg,#score-analysis .content-board .row.content .column.best,#score-analysis .content-board .row.content .column.goal,#score-analysis .content-board .row.content .column.worst{-ms-flex:0 0 30%;flex:0 0 30%;display:-ms-flexbox;display:flex;max-width:30%;-ms-flex-pack:center;justify-content:center}#score-analysis .content-board .row.content .column.all-avg{background-color:#D1D0C0;border-bottom:solid 1px #DEDEDE;float:right}}@media (max-width:414px){#score-analysis .content-board{position:relative;margin-bottom:20px;background-color:#fff}#score-analysis .content-board .row{position:relative;width:100%;height:40px;margin:0;line-height:40px;background-color:#fff;border-bottom:solid 1px #DEDEDE}#score-analysis .content-board .row.header{height:80px;font-size:12px;font-weight:700}#score-analysis .content-board .row.header .mydata{position:absolute;left:55%;height:40px;width:30%;background-color:#00B2AF;color:#fff;float:left;text-align:center;line-height:40px}#score-analysis .content-board .row.header .pulldown{position:absolute;left:55%;top:40px;height:40px;width:30%;background-color:#A3E9E7;color:#00B2AF;text-align:center}#score-analysis .content-board .row.header .pulldown .caret{margin-left:10px}#score-analysis .content-board .row.header .pulldown .title{font-size:8px;font-weight:700}#score-analysis .content-board .row.header .pulldown button{background:0 0;border:none;width:100%;padding:5px}#score-analysis .content-board .row.header .pulldown.goal{color:#FF0021;background-color:#FEBABD}#score-analysis .content-board .row.header .pulldown.avg{color:#00B2AF;background-color:#A3E9E7}#score-analysis .content-board .row.header .pulldown.best{color:#f60;background-color:#FFD4AD}#score-analysis .content-board .row.header .pulldown.worst{color:#666;background-color:#ccc}#score-analysis .content-board .row.header .pulldown ul.dropdown-menu{top:96%;left:0%;width:100%;padding:0;font-size:10px}#score-analysis .content-board .row.header .pulldown li a{color:#00B2AF;line-height:41px;text-align:center;padding:0;font-weight:inherit}#score-analysis .content-board .row.header .pulldown li a .text{margin:15px 0 0;line-height:0;font-size:10px}#score-analysis .content-board .row.header .pulldown li a .text .muted{padding-left:3.5em;color:darkgray}#score-analysis .content-board .row.header .pulldown li a.goal{color:#FF0021;background-color:#FEBABD}#score-analysis .content-board .row.header .pulldown li a.avg{color:#00B2AF;background-color:#A3E9E7}#score-analysis .content-board .row.header .pulldown li a.best{color:#f60;background-color:#FFD4AD}#score-analysis .content-board .row.header .pulldown li a.worst{color:#666;background-color:#ccc}#score-analysis .content-board .row.header .pulldown li a:hover{background-color:#c3e3e3}#score-analysis .content-board .row.header .head-column{height:80px}#score-analysis .content-board .row.header .column{text-align:center}#score-analysis .content-board .row.header .column.goal{top:40px;background-color:#FEBABD}#score-analysis .content-board .row.header .column.avg{top:40px;background-color:#A3E9E7}#score-analysis .content-board .row.header .column.best{top:40px;background-color:#FFD4AD}#score-analysis .content-board .row.header .column.worst{top:40px;background-color:#ccc}#score-analysis .content-board .row.header .column.all-avg{background-color:#B2B096;height:80px;line-height:35px;float:right}#score-analysis .content-board .row.title{background-color:#D9D9D9;font-size:10px;font-weight:700;text-indent:20px}#score-analysis .content-board .row .head-column{position:relative;width:25%;height:40px;float:left}#score-analysis .content-board .row .column{position:relative;width:15%;height:40px;float:left}#score-analysis .content-board .row .column.goal{color:#FF0021}#score-analysis .content-board .row .column.goal.hide{display:none!important}#score-analysis .content-board .row .column.avg{color:#00B2AF}#score-analysis .content-board .row .column.avg.hide{display:!important}#score-analysis .content-board .row .column.best{color:#f60}#score-analysis .content-board .row .column.best.hide{display:none!important}#score-analysis .content-board .row .column.best.label{line-height:normal;padding-top:7px;font-size:10px;border-radius:0}#score-analysis .content-board .row .column.worst{color:#666}#score-analysis .content-board .row .column.worst.hide{display:none!important}#score-analysis .content-board .row .column.worst.label{line-height:normal;padding-top:7px;font-size:10px;border-radius:0}#score-analysis .content-board .row .column.all-avg{color:#7C7B69}#score-analysis .content-board .row.content{font-weight:700;text-align:center}#score-analysis .content-board .row.content .head-column{font-size:10px;width:55%}#score-analysis .content-board .row.content .column{direction:rtl;font-size:10px}#score-analysis .content-board .row.content .column.avg,#score-analysis .content-board .row.content .column.best,#score-analysis .content-board .row.content .column.goal,#score-analysis .content-board .row.content .column.worst{-ms-flex:0 0 30%;flex:0 0 30%;display:-ms-flexbox;display:flex;max-width:30%;-ms-flex-pack:center;justify-content:center}#score-analysis .content-board .row.content .column.all-avg{background-color:#D1D0C0;border-bottom:solid 1px #DEDEDE;float:right}}@media (max-width:375px){#score-analysis .content-board .row.header .pulldown ul.dropdown-menu{top:96%;left:-41%;width:100%;padding:0;font-size:12px}#score-analysis .content-board .row.header .pulldown li a{color:#00B2AF;line-height:41px;text-align:center;padding:0;font-weight:inherit}#score-analysis .content-board .row.header .pulldown li a .text{margin:15px 0 0;line-height:0;font-size:12px}#score-analysis .content-board .row.header .pulldown li a .text .muted{padding-left:3.5em;color:darkgray}}@media (max-width:360px){#score-analysis .content-board .row.header .pulldown .title{font-size:7.5px}#score-analysis .content-board .row.header .pulldown ul.dropdown-menu{top:96%;left:-41%;width:100%;padding:0;font-size:12px}#score-analysis .content-board .row.header .pulldown li a{color:#00B2AF;line-height:41px;text-align:center;padding:0;font-weight:inherit}#score-analysis .content-board .row.header .pulldown li a .text{margin:15px 0 0;line-height:0;font-size:12px}#score-analysis .content-board .row.header .pulldown li a .text .muted{padding-left:3.5em;color:darkgray}}@media (max-width:320px){#score-analysis .content-board{position:relative;margin-bottom:20px;background-color:#fff}#score-analysis .content-board .row{position:relative;width:100%;height:40px;margin:0;line-height:40px;background-color:#fff;border-bottom:solid 1px #DEDEDE}#score-analysis .content-board .row.header{height:80px;font-size:12px;font-weight:700}#score-analysis .content-board .row.header .mydata{position:absolute;left:55%;height:40px;width:30%;background-color:#00B2AF;color:#fff;float:left;text-align:center;line-height:40px}#score-analysis .content-board .row.header .pulldown{position:absolute;left:55%;top:40px;height:40px;width:30%;background-color:#A3E9E7;color:#00B2AF;text-align:center}#score-analysis .content-board .row.header .pulldown .caret{margin-left:10px}#score-analysis .content-board .row.header .pulldown .title{font-size:8px;font-weight:700}#score-analysis .content-board .row.header .pulldown button{background:0 0;border:none;width:100%;padding:5px}#score-analysis .content-board .row.header .pulldown.goal{color:#FF0021;background-color:#FEBABD}#score-analysis .content-board .row.header .pulldown.avg{color:#00B2AF;background-color:#A3E9E7}#score-analysis .content-board .row.header .pulldown.best{color:#f60;background-color:#FFD4AD}#score-analysis .content-board .row.header .pulldown.worst{color:#666;background-color:#ccc}#score-analysis .content-board .row.header .pulldown ul.dropdown-menu{top:96%;left:0%;width:100%;padding:0;font-size:8px}#score-analysis .content-board .row.header .pulldown li a{color:#00B2AF;line-height:41px;text-align:center;padding:0;font-weight:inherit}#score-analysis .content-board .row.header .pulldown li a .text{margin:15px 0 0;line-height:0;font-size:8px}#score-analysis .content-board .row.header .pulldown li a .text .muted{padding-left:3.5em;color:darkgray}#score-analysis .content-board .row.header .pulldown li a.goal{color:#FF0021;background-color:#FEBABD}#score-analysis .content-board .row.header .pulldown li a.avg{color:#00B2AF;background-color:#A3E9E7}#score-analysis .content-board .row.header .pulldown li a.best{color:#f60;background-color:#FFD4AD}#score-analysis .content-board .row.header .pulldown li a.worst{color:#666;background-color:#ccc}#score-analysis .content-board .row.header .pulldown li a:hover{background-color:#c3e3e3}#score-analysis .content-board .row.header .head-column{height:80px}#score-analysis .content-board .row.header .column{text-align:center}#score-analysis .content-board .row.header .column.goal{top:40px;background-color:#FEBABD}#score-analysis .content-board .row.header .column.avg{top:40px;background-color:#A3E9E7}#score-analysis .content-board .row.header .column.best{top:40px;background-color:#FFD4AD}#score-analysis .content-board .row.header .column.worst{top:40px;background-color:#ccc}#score-analysis .content-board .row.header .column.all-avg{background-color:#B2B096;height:80px;line-height:35px;float:right}#score-analysis .content-board .row.title{background-color:#D9D9D9;font-size:8px;font-weight:700;text-indent:20px}#score-analysis .content-board .row .head-column{position:relative;width:25%;height:40px;float:left}#score-analysis .content-board .row .column{position:relative;width:15%;height:40px;float:left}#score-analysis .content-board .row .column.goal{color:#FF0021}#score-analysis .content-board .row .column.goal.hide{display:!important}#score-analysis .content-board .row .column.avg{color:#00B2AF}#score-analysis .content-board .row .column.avg.hide{display:!important}#score-analysis .content-board .row .column.best{color:#f60}#score-analysis .content-board .row .column.best.hide{display:none!important}#score-analysis .content-board .row .column.best.label{line-height:normal;padding-top:7px;font-size:8px;border-radius:0}#score-analysis .content-board .row .column.worst{color:#666}#score-analysis .content-board .row .column.worst.hide{display:none!important}#score-analysis .content-board .row .column.worst.label{line-height:normal;padding-top:7px;font-size:8px;border-radius:0}#score-analysis .content-board .row .column.all-avg{color:#7C7B69}#score-analysis .content-board .row.content{font-weight:700;text-align:center}#score-analysis .content-board .row.content .head-column{font-size:8px;width:55%}#score-analysis .content-board .row.content .column{direction:rtl;font-size:8px}#score-analysis .content-board .row.content .column.avg,#score-analysis .content-board .row.content .column.best,#score-analysis .content-board .row.content .column.goal,#score-analysis .content-board .row.content .column.worst{width:30%}#score-analysis .content-board .row.content .column.all-avg{background-color:#D1D0C0;border-bottom:solid 1px #DEDEDE;float:right}}.content-semi-circle-charts{position:relative;margin-bottom:20px}.content-semi-circle-charts .chart-left{height:400px;width:49%;position:relative;float:left;background-image:url("+__webpack_require__(468)+");background-repeat:no-repeat;background-position:138px 158px}.content-semi-circle-charts .chart-left .chart{position:absolute;top:27px;left:50%;margin-left:-250px;width:100%;height:400px}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{position:absolute;left:165px;font-size:12px;font-weight:700;text-align:right;width:50px}.content-semi-circle-charts .chart-left .label1,.content-semi-circle-charts .chart-left .label2,.content-semi-circle-charts .chart-left .label3,.content-semi-circle-charts .chart-left .label4,.content-semi-circle-charts .chart-left .label5,.content-semi-circle-charts .chart-left .label6{position:absolute;left:230px;font-size:12px;width:150px}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .label1{top:236px}.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .label2{top:260px}.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .label3{top:284px}.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .label4{top:308px}.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .label5{top:332px}.content-semi-circle-charts .chart-left .value6,.content-semi-circle-charts .chart-left .label6{top:356px}.content-semi-circle-charts .chart-right{height:400px;width:49%;position:relative;float:right;background-image:url("+__webpack_require__(469)+");background-repeat:no-repeat;background-position:58px 90px}.content-semi-circle-charts .chart-right .chart{position:absolute;top:27px;left:50%;margin-left:-250px;width:100%;height:400px}.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{position:absolute;left:244px;font-size:20px;font-weight:700}.content-semi-circle-charts .chart-right .value1{top:253px;color:#00B8B5}.content-semi-circle-charts .chart-right .value2{top:294px;color:#008886}.content-semi-circle-charts .chart-right .value3{top:334px;color:#006A68}.content-semi-circle-charts .chart-left,.content-semi-circle-charts .chart-right{background-color:#fff}.content-semi-circle-charts .chart-left .title,.content-semi-circle-charts .chart-right .title{position:absolute;top:123px;width:100%;text-align:center;font-size:14px;color:#00B8B5}@media (max-width:768px){.content-semi-circle-charts{position:relative;margin-bottom:20px}.content-semi-circle-charts .chart-left{height:400px;width:49%;float:left;position:relative;background-position:36% 160px}.content-semi-circle-charts .chart-left .chart{margin-left:-190px}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:29%}.content-semi-circle-charts .chart-left .label1,.content-semi-circle-charts .chart-left .label2,.content-semi-circle-charts .chart-left .label3,.content-semi-circle-charts .chart-left .label4,.content-semi-circle-charts .chart-left .label5,.content-semi-circle-charts .chart-left .label6{left:47%}.content-semi-circle-charts .chart-right{height:400px;width:49%;float:right;position:relative;background-position:7% 90px}.content-semi-circle-charts .chart-right .chart{margin-left:-190px}.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{left:51%}}@media (max-width:600px){.content-semi-circle-charts .chart-left{height:400px;width:100%;position:relative;background-position:44% 158px}.content-semi-circle-charts .chart-left .chart{left:33%;margin-left:-200px}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:38%}.content-semi-circle-charts .chart-left .label1,.content-semi-circle-charts .chart-left .label2,.content-semi-circle-charts .chart-left .label3,.content-semi-circle-charts .chart-left .label4,.content-semi-circle-charts .chart-left .label5,.content-semi-circle-charts .chart-left .label6{left:47%}.content-semi-circle-charts .chart-right{height:400px;width:100%;position:relative;background-position:31% 90px}.content-semi-circle-charts .chart-right .chart{left:33%;margin-left:-200px}.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{left:52%}}@media (max-width:414px){.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:34%}.content-semi-circle-charts .chart-left .label1,.content-semi-circle-charts .chart-left .label2,.content-semi-circle-charts .chart-left .label3,.content-semi-circle-charts .chart-left .label4,.content-semi-circle-charts .chart-left .label5,.content-semi-circle-charts .chart-left .label6{left:50%}.content-semi-circle-charts .chart-left .chart{left:48%}.content-semi-circle-charts .chart-right{background-position:15% 90px}.content-semi-circle-charts .chart-right .chart{left:48%}}@media (max-width:375px){.content-semi-circle-charts .chart-left{background-position:37% 158px}.content-semi-circle-charts .chart-left .chart{left:53%}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:34%}.content-semi-circle-charts .chart-right{background-position:9% 90px}.content-semi-circle-charts .chart-right .chart{left:53%}}@media (max-width:360px){.content-semi-circle-charts .chart-left{background-position:37% 158px}.content-semi-circle-charts .chart-left .chart{left:56%}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:34%}.content-semi-circle-charts .chart-right{background-position:13% 92px}.content-semi-circle-charts .chart-right .chart,.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{left:56%}}@media (max-width:320px){.content-semi-circle-charts .chart-left{background-position:37% 158px}.content-semi-circle-charts .chart-left .chart{left:62%}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:34%}.content-semi-circle-charts .chart-right{background-position:11% 128px;background-size:168px}.content-semi-circle-charts .chart-right .title{top:154px}.content-semi-circle-charts .chart-right .chart{left:62%}.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{left:54%;font-size:13px}.content-semi-circle-charts .chart-right .value1{top:266px}.content-semi-circle-charts .chart-right .value2{top:299px}}.content-charts,.content-score-charts{width:100%;background-color:#c2cccc;margin-bottom:20px;padding-top:20px}.content-charts .freemode,.content-score-charts .freemode{opacity:.3}.content-charts .charts,.content-score-charts .charts{background-color:#e5e5e5;margin-bottom:20px}.content-charts .column,.content-score-charts .column{height:210px;margin-bottom:20px}.content-charts .bar-layer,.content-score-charts .bar-layer{position:absolute;width:340px;height:56px;top:139px;left:120px}.content-charts .bar-layer .bar-avg-score,.content-score-charts .bar-layer .bar-avg-score{position:absolute;height:18px;top:16px;background-color:#00adad}.content-charts .bar-layer .bar-all-avg-score,.content-score-charts .bar-layer .bar-all-avg-score{position:absolute;height:18px;top:38px;background-color:#b2af98}.content-charts .bar-layer .pin-goal,.content-score-charts .bar-layer .pin-goal{position:absolute;width:54px;height:56px;margin-left:-6px;background-image:url("+__webpack_require__(470)+")}.content-charts .score-circle,.content-score-charts .score-circle{position:absolute;left:30px;top:50%;margin-top:-90px;color:#fff;text-align:center;background-color:#00adad;width:180px;height:180px;border-radius:90px}.content-charts .score-circle .title,.content-score-charts .score-circle .title{position:absolute;font-size:12px;width:100%;line-height:60px}.content-charts .score-circle .value,.content-score-charts .score-circle .value{position:absolute;font-size:50px;font-weight:700;width:100%;line-height:180px}.content-charts .score-circle .hole,.content-score-charts .score-circle .hole{position:absolute;top:120px;font-size:10px;width:100%;line-height:60px}.content-charts .help-circle,.content-score-charts .help-circle{position:absolute;width:42px;height:42px;left:300px;top:20px;background-image:url("+__webpack_require__(18)+");background-size:42px}.content-charts .goal-circle,.content-score-charts .goal-circle{position:absolute;top:30px;left:50%;color:#fff;text-align:center;background-color:#ee2e2e;width:90px;height:90px;border-radius:45px}.content-charts .goal-circle .title,.content-score-charts .goal-circle .title{position:absolute;font-size:12px;width:100%;line-height:30px}.content-charts .goal-circle .value,.content-score-charts .goal-circle .value{position:absolute;font-size:22px;font-weight:700;width:100%;line-height:90px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{position:absolute;left:80%;top:30px;color:#7c7a6a;text-align:center;background-color:#b2af98;width:90px;height:90px;border-radius:45px}.content-charts .all-score-circle .title,.content-score-charts .all-score-circle .title{position:absolute;font-size:12px;width:100%;line-height:30px}.content-charts .all-score-circle .value,.content-score-charts .all-score-circle .value{position:absolute;font-size:22px;font-weight:700;width:100%;line-height:90px}.content-charts .column-chart-percent,.content-score-charts .column-chart-percent{height:230px}.content-charts .column-chart-percent .chart,.content-score-charts .column-chart-percent .chart{position:absolute;width:170px;height:170px;top:10px;left:40%}.content-charts .column-chart-percent .sub-title,.content-score-charts .column-chart-percent .sub-title{position:absolute;top:182px;left:132px;font-size:12px;font-weight:700;width:180px;height:20px;text-align:center;color:#00adad}@media (max-width:414px){.content-charts .column-chart-percent .sub-title,.content-score-charts .column-chart-percent .sub-title{left:148px}}.content-charts .column-chart-percent .goal,.content-score-charts .column-chart-percent .goal{left:20px;top:80px;width:150px;position:absolute}.content-charts .column-chart-percent .goal .circle,.content-score-charts .column-chart-percent .goal .circle{position:relative;float:left;color:#fff;text-align:center;font-size:10px;line-height:40px;background-color:#ee2e2e;width:40px;height:40px;border-radius:20px}.content-charts .column-chart-percent .goal .value,.content-score-charts .column-chart-percent .goal .value{position:relative;left:5px;font-size:18px;font-weight:700;width:100%;color:#ee2e2e;line-height:40px}.content-charts .column-chart-percent .all-avg,.content-score-charts .column-chart-percent .all-avg{left:20px;top:130px;width:150px;position:absolute}.content-charts .column-chart-percent .all-avg .circle,.content-score-charts .column-chart-percent .all-avg .circle{position:relative;float:left;color:#7c7a6a;text-align:center;font-size:10px;line-height:14px;background-color:#b2af98;width:40px;border-radius:20px;height:40px;padding-top:6px}.content-charts .column-chart-percent .all-avg .value,.content-score-charts .column-chart-percent .all-avg .value{position:relative;left:5px;font-size:18px;font-weight:700;width:100%;color:#7c7a6a;line-height:40px}@media (max-width:768px){.content-charts .help-circle,.content-score-charts .help-circle{left:460px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{position:absolute;left:80%;top:30px;color:#7c7a6a;text-align:center;background-color:#b2af98;width:120px;height:120px;border-radius:60px}.content-charts .all-score-circle .title,.content-score-charts .all-score-circle .title{position:absolute;font-size:12px;width:100%;line-height:40px}.content-charts .all-score-circle .value,.content-score-charts .all-score-circle .value{position:absolute;font-size:22px;font-weight:700;width:100%;line-height:120px}.content-charts .goal-circle,.content-score-charts .goal-circle{position:absolute;top:30px;left:50%;color:#fff;text-align:center;background-color:#ee2e2e;width:120px;height:120px;border-radius:60px}.content-charts .goal-circle .title,.content-score-charts .goal-circle .title{position:absolute;font-size:12px;width:100%;line-height:40px}.content-charts .goal-circle .value,.content-score-charts .goal-circle .value{position:absolute;font-size:22px;font-weight:700;width:100%;line-height:120px}.content-charts .column-chart-percent .chart,.content-score-charts .column-chart-percent .chart{left:45%}.content-charts .column-chart-percent .sub-title,.content-score-charts .column-chart-percent .sub-title{left:172px}.content-charts .column-chart-percent .goal,.content-charts .column-chart-percent .all-avg,.content-score-charts .column-chart-percent .goal,.content-score-charts .column-chart-percent .all-avg{left:60px}}@media (max-width:767px){.content-charts .score-circle-charts-wrap,.content-score-charts .score-circle-charts-wrap{padding:10px}.content-charts .score-circle,.content-score-charts .score-circle{left:10px;width:150px;height:150px;border-radius:75px}.content-charts .score-circle .value,.content-score-charts .score-circle .value{font-size:40px;line-height:150px}.content-charts .score-circle .hole,.content-score-charts .score-circle .hole{top:70px}.content-charts .bar-layer,.content-score-charts .bar-layer{width:350px;height:37px;top:107px;left:70px}.content-charts .goal-circle,.content-charts .all-score-circle,.content-score-charts .goal-circle,.content-score-charts .all-score-circle{width:68px;height:68px;top:19.8px}.content-charts .goal-circle .title,.content-charts .all-score-circle .title,.content-score-charts .goal-circle .title,.content-score-charts .all-score-circle .title{font-size:8px}.content-charts .goal-circle .value,.content-charts .all-score-circle .value,.content-score-charts .goal-circle .value,.content-score-charts .all-score-circle .value{line-height:68px}.content-charts .goal-circle,.content-score-charts .goal-circle{left:210px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{left:290px}}@media (max-width:414px){.content-charts .bar-layer,.content-score-charts .bar-layer{width:283px;left:100px}.content-charts .help-circle,.content-score-charts .help-circle{width:30px;height:30px;left:242px;top:15px;background-size:30px}.content-charts .goal-circle,.content-score-charts .goal-circle{left:200px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{left:315px}.content-charts .column-chart-percent .chart,.content-score-charts .column-chart-percent .chart{left:40%}.content-charts .column-chart-percent .goal,.content-charts .column-chart-percent .all-avg,.content-score-charts .column-chart-percent .goal,.content-score-charts .column-chart-percent .all-avg{left:20px}}@media (max-width:375px){.content-charts .bar-layer,.content-score-charts .bar-layer{width:247px;left:100px}.content-charts .help-circle,.content-score-charts .help-circle{left:224px}.content-charts .goal-circle,.content-score-charts .goal-circle{left:183px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{left:275px}}@media (max-width:360px){.content-charts .bar-layer,.content-score-charts .bar-layer{width:235px;left:100px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{left:265px}}@media (max-width:320px){.content-charts .score-circle-charts-wrap,.content-score-charts .score-circle-charts-wrap{padding:0}.content-charts .bar-layer,.content-score-charts .bar-layer{width:208px;left:100px}.content-charts .goal-circle,.content-score-charts .goal-circle{left:163px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{left:240px}.content-charts .help-circle,.content-score-charts .help-circle{left:206px}}#score-analysis .container.score-analysis-container,#score-analysis .container.content-board{max-width:none!important;width:970px}#score-analysis .content-score-charts{background-color:#fff}#score-analysis .cell{padding:0}#score-analysis .alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px;background:#fbe3e4;color:#8a1f11;border-color:#fbc2c4}#score-analysis .message{padding:.8em;margin-bottom:1em;border:2px solid #ddd}#score-analysis .message.notice{background:#fff6bf;color:#514721;border-color:#ffd324}#score-analysis .message.success{background:#e6efc2;color:#264409;border-color:#c6d880}#score-analysis .message.info{background:#d5edf8;color:#205791;border-color:#92cae4}#score-analysis .message.error{background:#fbe3e4;color:#8a1f11;border-color:#fbc2c4}#score-analysis .content-calendar{margin-bottom:20px;padding-top:20px}#score-analysis .content-calendar .non-background{background-image:none!important}#score-analysis .select-wrap{position:relative;overflow:hidden;display:inline-block;width:100%;background-color:#555;background-repeat:no-repeat;background-position:200px 15px;background-image:url("+__webpack_require__(466)+");color:#ddd}#score-analysis .select-wrap span{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;position:relative;display:block;outline:none;border:0;height:30px;margin:5px 10px;line-height:30px;color:#ddd;font-size:16px;text-indent:.01px;text-overflow:\"\";width:270px}#score-analysis #map_canvas{-ms-touch-action:manipulation;touch-action:manipulation}@media (max-width:991px){#score-analysis #gnp-footer{height:200px}#score-analysis #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#score-analysis .container.score-analysis-container{max-width:none!important;width:100%}#score-analysis #main-main .container,#score-analysis #main-main .container.dashboard-container{width:100%;min-width:0}#score-analysis #gnp-header .ad,#score-analysis #gnp-header .btn-section,#score-analysis #gnp-header .user,#score-analysis #gnp-footer .ad{display:none}#score-analysis #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:414px){#score-analysis #gnp-header .submenu{width:0}}.highcharts-tooltip span{background-color:unset;line-height:unset}.highcharts-tooltip span a{text-decoration:none}.highcharts-tooltip span a,.highcharts-tooltip span .score-wrap{z-index:99999!important;width:70px;height:70px;border-radius:50%;padding-top:10px;text-align:center;color:#fff!important;font-weight:700;position:absolute;white-space:nowrap;font-family:\"Lucida Grande\",\"Lucida Sans Unicode\",Arial,Helvetica,sans-serif;margin-left:0;margin-top:0;left:-12px;top:-20px}.highcharts-tooltip span a .play-date,.highcharts-tooltip span .score-wrap .play-date{padding-top:5px;display:inline-block;font-size:8px;height:unset}.highcharts-tooltip span a .score,.highcharts-tooltip span .score-wrap .score{font-size:15px;margin-top:25px}@media (max-width:414px){.highcharts-tooltip span a,.highcharts-tooltip span .score-wrap{width:60px;height:60px;left:-5px;top:-10px}.highcharts-tooltip span a .play-date,.highcharts-tooltip span .score-wrap .play-date{padding-top:3px}.highcharts-tooltip span a .score,.highcharts-tooltip span .score-wrap .score{font-size:12px;margin-top:5px}}", ""]);

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANwAAAAoCAYAAACVWZSOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAYBJREFUeNrs3T8rxHEAx3Gny6is7AYDj4CykskDUAYPQEomslAGg8mgjGYpK56AlEyiGCzCoJTB+VydMt7g6+7H61Wf+a5vvfv9qetqjUaj5794Hhvr9q+4mq318Gf1OgKxITixITjEhuDEhuAQG4ITGx1V/40P+enX8QMXF2LDFa4NjdZOs+ms5sqG4MqbyI6yy2wu6xMbgitvJNvPbrKlrF9sCK68oWwru882s0GxIbjymle45ew222tdAcWG4AprPtPNt57xDrNxsSG48ppvMWeys2xbbAiuvOtsNlsUG1VX7+Lv9pitZ7vZu9gQXBlv2U62kb24jURwZXxkB9lKdlexcxQblQrupPWMdl7BMxQbbev0S5OrbCqbFBuCK+chW8iaPyM4rujZiY3K3FIOZ68VPjexUakrnNgQHGJDcGJDcGIDwYkNwYkNBCc2BCc2BCc2EJzYEJzYQHBioxvUnkZHf/Pzvv7fuCY2/qP6twg6ER64pQQEB4ID2vcpwAB67lJhlZ1CYAAAAABJRU5ErkJggg=="

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMBAMAAACkW0HUAAAAFVBMVEWZmZn///+ZmZmZmZmZmZmZmZmZmZlqNPAWAAAABnRSTlMAACDA3+D5kQVHAAAAK0lEQVQI12MQBAMGVAoKmNzS0tKCGBhU0tJSFcDcIJCwCogD5BoxoAOIdgA38Aa3E1KWlQAAAABJRU5ErkJggg=="

/***/ }),
/* 467 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA4CAYAAAC2TwutAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAlhJREFUeNrslk9OwkAUxgfCBfAIuHIDi3IEOAJXwJ2JbsoWV/QCGHsEewBN4Ah0QVzoxt4ACP82YKIzyTfmWcsApaCt7yXP+VN8nd/M16/NjcvlD7F/5NSf4nD4NTGpVDbVacl0xPGjKbMh05PpFhIs3EdrKWaZvuJFniLUPWt6HQrsQuYz+tviXWZ5w7U62h5u0CKwKmzM601wAW2TuQ7qNHACAVLgJALUaAIkwH0sUlu1voJ5ldmVebUD2J3Mlxi7aWPRDm6s+iWZl+gLQBYx/4A5HxC6X8LG+dgIG1Aurgm0pTwGtzJHWxY3ltk+QCYOdrdFFkDDxWnVyLhKTkyQa7qWDzCtAP1/rgYbAc4U7R3ghcFAPOzwveE3fWyCIEAUzCIK6IVO6VvkSb8LWUaFlmvcUHIbQFZeAkahpahPLjCBKWO43lDoBtfjhjaIashQtsmXtjQ8QE0iTvUHmIonmavQ3FrmY4KWbO342mjipC3DK6UDBxUhuZbyEYUXW8ZxQr+g34gBFA0yc8gm+CGD8QE0JqYkyHtTgTYKG8DOyHi+J0TdYAwiQoq50LiGBdbx2wF5HUwg51oIRtf9WncU2DQ0niX8ZbKr2Uzw7Gg79/epVTiRFPfdgHPy7DhxnDQxMPpBnEAEh3445//giSUS/xpsnhWw2ZFckaXIYAyWcbA5u2LKpbjkZ4zBGOyorpgZ86AwqbR6E9gizTJksCyBLbMKNkuzI5rA5uyKDMZgDMauGOGKLEUGYzAGi+WKU3ZFluLvgq3RrrIGlvpgMAZjMAaLFZ8CDADaxckyIJ+hzwAAAABJRU5ErkJggg=="

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {// ==ClosureCompiler==
	// @compilation_level SIMPLE_OPTIMIZATIONS
	
	/**
	 * @license Highcharts JS v4.0.4 (2014-09-02)
	 *
	 * (c) 2009-2014 Torstein Honsi
	 *
	 * License: www.highcharts.com/license
	 */
	
	// JSLint options:
	/*global Highcharts, HighchartsAdapter, document, window, navigator, setInterval, clearInterval, clearTimeout, setTimeout, location, jQuery, $, console, each, grep */
	/*jslint ass: true, sloppy: true, forin: true, plusplus: true, nomen: true, vars: true, regexp: true, newcap: true, browser: true, continue: true, white: true */
	(function () {
	// encapsulated variables
	var UNDEFINED,
		doc = document,
		win = window,
		math = Math,
		mathRound = math.round,
		mathFloor = math.floor,
		mathCeil = math.ceil,
		mathMax = math.max,
		mathMin = math.min,
		mathAbs = math.abs,
		mathCos = math.cos,
		mathSin = math.sin,
		mathPI = math.PI,
		deg2rad = mathPI * 2 / 360,
	
	
		// some variables
		userAgent = navigator.userAgent,
		isOpera = win.opera,
		isIE = /msie/i.test(userAgent) && !isOpera,
		docMode8 = doc.documentMode === 8,
		isWebKit = /AppleWebKit/.test(userAgent),
		isFirefox = /Firefox/.test(userAgent),
		isTouchDevice = /(Mobile|Android|Windows Phone)/.test(userAgent),
		SVG_NS = 'http://www.w3.org/2000/svg',
		hasSVG = !!doc.createElementNS && !!doc.createElementNS(SVG_NS, 'svg').createSVGRect,
		hasBidiBug = isFirefox && parseInt(userAgent.split('Firefox/')[1], 10) < 4, // issue #38
		useCanVG = !hasSVG && !isIE && !!doc.createElement('canvas').getContext,
		Renderer,
		hasTouch,
		symbolSizes = {},
		idCounter = 0,
		garbageBin,
		defaultOptions,
		dateFormat, // function
		globalAnimation,
		pathAnim,
		timeUnits,
		error,
		noop = function () { return UNDEFINED; },
		charts = [],
		chartCount = 0,
		PRODUCT = 'Highcharts',
		VERSION = '4.0.4',
	
		// some constants for frequently used strings
		DIV = 'div',
		ABSOLUTE = 'absolute',
		RELATIVE = 'relative',
		HIDDEN = 'hidden',
		PREFIX = 'highcharts-',
		VISIBLE = 'visible',
		PX = 'px',
		NONE = 'none',
		M = 'M',
		L = 'L',
		numRegex = /^[0-9]+$/,
		NORMAL_STATE = '',
		HOVER_STATE = 'hover',
		SELECT_STATE = 'select',
		
		// Object for extending Axis
		AxisPlotLineOrBandExtension,
	
		// constants for attributes
		STROKE_WIDTH = 'stroke-width',
	
		// time methods, changed based on whether or not UTC is used
		Date,  // Allow using a different Date class
		makeTime,
		timezoneOffset,
		getMinutes,
		getHours,
		getDay,
		getDate,
		getMonth,
		getFullYear,
		setMinutes,
		setHours,
		setDate,
		setMonth,
		setFullYear,
	
	
		// lookup over the types and the associated classes
		seriesTypes = {},
		Highcharts;
	
	// The Highcharts namespace
	if (win.Highcharts) {
		error(16, true);
	} else {
		Highcharts = win.Highcharts = {};
	}
	/**
	 * Extend an object with the members of another
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to add to the first one
	 */
	function extend(a, b) {
		var n;
		if (!a) {
			a = {};
		}
		for (n in b) {
			a[n] = b[n];
		}
		return a;
	}
		
	/**
	 * Deep merge two or more objects and return a third object. If the first argument is
	 * true, the contents of the second object is copied into the first object.
	 * Previously this function redirected to jQuery.extend(true), but this had two limitations.
	 * First, it deep merged arrays, which lead to workarounds in Highcharts. Second,
	 * it copied properties from extended prototypes. 
	 */
	function merge() {
		var i,
			args = arguments,
			len,
			ret = {},
			doCopy = function (copy, original) {
				var value, key;
	
				// An object is replacing a primitive
				if (typeof copy !== 'object') {
					copy = {};
				}
	
				for (key in original) {
					if (original.hasOwnProperty(key)) {
						value = original[key];
	
						// Copy the contents of objects, but not arrays or DOM nodes
						if (value && typeof value === 'object' && Object.prototype.toString.call(value) !== '[object Array]'
								&& key !== 'renderTo' && typeof value.nodeType !== 'number') {
							copy[key] = doCopy(copy[key] || {}, value);
					
						// Primitives and arrays are copied over directly
						} else {
							copy[key] = original[key];
						}
					}
				}
				return copy;
			};
	
		// If first argument is true, copy into the existing object. Used in setOptions.
		if (args[0] === true) {
			ret = args[1];
			args = Array.prototype.slice.call(args, 2);
		}
	
		// For each argument, extend the return
		len = args.length;
		for (i = 0; i < len; i++) {
			ret = doCopy(ret, args[i]);
		}
	
		return ret;
	}
	
	/**
	 * Shortcut for parseInt
	 * @param {Object} s
	 * @param {Number} mag Magnitude
	 */
	function pInt(s, mag) {
		return parseInt(s, mag || 10);
	}
	
	/**
	 * Check for string
	 * @param {Object} s
	 */
	function isString(s) {
		return typeof s === 'string';
	}
	
	/**
	 * Check for object
	 * @param {Object} obj
	 */
	function isObject(obj) {
		return obj && typeof obj === 'object';
	}
	
	/**
	 * Check for array
	 * @param {Object} obj
	 */
	function isArray(obj) {
		return Object.prototype.toString.call(obj) === '[object Array]';
	}
	
	/**
	 * Check for number
	 * @param {Object} n
	 */
	function isNumber(n) {
		return typeof n === 'number';
	}
	
	function log2lin(num) {
		return math.log(num) / math.LN10;
	}
	function lin2log(num) {
		return math.pow(10, num);
	}
	
	/**
	 * Remove last occurence of an item from an array
	 * @param {Array} arr
	 * @param {Mixed} item
	 */
	function erase(arr, item) {
		var i = arr.length;
		while (i--) {
			if (arr[i] === item) {
				arr.splice(i, 1);
				break;
			}
		}
		//return arr;
	}
	
	/**
	 * Returns true if the object is not null or undefined. Like MooTools' $.defined.
	 * @param {Object} obj
	 */
	function defined(obj) {
		return obj !== UNDEFINED && obj !== null;
	}
	
	/**
	 * Set or get an attribute or an object of attributes. Can't use jQuery attr because
	 * it attempts to set expando properties on the SVG element, which is not allowed.
	 *
	 * @param {Object} elem The DOM element to receive the attribute(s)
	 * @param {String|Object} prop The property or an abject of key-value pairs
	 * @param {String} value The value if a single property is set
	 */
	function attr(elem, prop, value) {
		var key,
			ret;
	
		// if the prop is a string
		if (isString(prop)) {
			// set the value
			if (defined(value)) {
				elem.setAttribute(prop, value);
	
			// get the value
			} else if (elem && elem.getAttribute) { // elem not defined when printing pie demo...
				ret = elem.getAttribute(prop);
			}
	
		// else if prop is defined, it is a hash of key/value pairs
		} else if (defined(prop) && isObject(prop)) {
			for (key in prop) {
				elem.setAttribute(key, prop[key]);
			}
		}
		return ret;
	}
	/**
	 * Check if an element is an array, and if not, make it into an array. Like
	 * MooTools' $.splat.
	 */
	function splat(obj) {
		return isArray(obj) ? obj : [obj];
	}
	
	
	/**
	 * Return the first value that is defined. Like MooTools' $.pick.
	 */
	function pick() {
		var args = arguments,
			i,
			arg,
			length = args.length;
		for (i = 0; i < length; i++) {
			arg = args[i];
			if (arg !== UNDEFINED && arg !== null) {
				return arg;
			}
		}
	}
	
	/**
	 * Set CSS on a given element
	 * @param {Object} el
	 * @param {Object} styles Style object with camel case property names
	 */
	function css(el, styles) {
		if (isIE && !hasSVG) { // #2686
			if (styles && styles.opacity !== UNDEFINED) {
				styles.filter = 'alpha(opacity=' + (styles.opacity * 100) + ')';
			}
		}
		extend(el.style, styles);
	}
	
	/**
	 * Utility function to create element with attributes and styles
	 * @param {Object} tag
	 * @param {Object} attribs
	 * @param {Object} styles
	 * @param {Object} parent
	 * @param {Object} nopad
	 */
	function createElement(tag, attribs, styles, parent, nopad) {
		var el = doc.createElement(tag);
		if (attribs) {
			extend(el, attribs);
		}
		if (nopad) {
			css(el, {padding: 0, border: NONE, margin: 0});
		}
		if (styles) {
			css(el, styles);
		}
		if (parent) {
			parent.appendChild(el);
		}
		return el;
	}
	
	/**
	 * Extend a prototyped class by new members
	 * @param {Object} parent
	 * @param {Object} members
	 */
	function extendClass(parent, members) {
		var object = function () { return UNDEFINED; };
		object.prototype = new parent();
		extend(object.prototype, members);
		return object;
	}
	
	/**
	 * Format a number and return a string based on input settings
	 * @param {Number} number The input number to format
	 * @param {Number} decimals The amount of decimals
	 * @param {String} decPoint The decimal point, defaults to the one given in the lang options
	 * @param {String} thousandsSep The thousands separator, defaults to the one given in the lang options
	 */
	function numberFormat(number, decimals, decPoint, thousandsSep) {
		var externalFn = Highcharts.numberFormat,
			lang = defaultOptions.lang,
			// http://kevin.vanzonneveld.net/techblog/article/javascript_equivalent_for_phps_number_format/
			n = +number || 0,
			c = decimals === -1 ?
				(n.toString().split('.')[1] || '').length : // preserve decimals
				(isNaN(decimals = mathAbs(decimals)) ? 2 : decimals),
			d = decPoint === undefined ? lang.decimalPoint : decPoint,
			t = thousandsSep === undefined ? lang.thousandsSep : thousandsSep,
			s = n < 0 ? "-" : "",
			i = String(pInt(n = mathAbs(n).toFixed(c))),
			j = i.length > 3 ? i.length % 3 : 0;
	
		return externalFn !== numberFormat ? 
			externalFn(number, decimals, decPoint, thousandsSep) :
			(s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
				(c ? d + mathAbs(n - i).toFixed(c).slice(2) : ""));
	}
	
	/**
	 * Pad a string to a given length by adding 0 to the beginning
	 * @param {Number} number
	 * @param {Number} length
	 */
	function pad(number, length) {
		// Create an array of the remaining length +1 and join it with 0's
		return new Array((length || 2) + 1 - String(number).length).join(0) + number;
	}
	
	/**
	 * Wrap a method with extended functionality, preserving the original function
	 * @param {Object} obj The context object that the method belongs to 
	 * @param {String} method The name of the method to extend
	 * @param {Function} func A wrapper function callback. This function is called with the same arguments
	 * as the original function, except that the original function is unshifted and passed as the first 
	 * argument. 
	 */
	function wrap(obj, method, func) {
		var proceed = obj[method];
		obj[method] = function () {
			var args = Array.prototype.slice.call(arguments);
			args.unshift(proceed);
			return func.apply(this, args);
		};
	}
	
	/**
	 * Based on http://www.php.net/manual/en/function.strftime.php
	 * @param {String} format
	 * @param {Number} timestamp
	 * @param {Boolean} capitalize
	 */
	dateFormat = function (format, timestamp, capitalize) {
		if (!defined(timestamp) || isNaN(timestamp)) {
			return 'Invalid date';
		}
		format = pick(format, '%Y-%m-%d %H:%M:%S');
	
		var date = new Date(timestamp - timezoneOffset),
			key, // used in for constuct below
			// get the basic time values
			hours = date[getHours](),
			day = date[getDay](),
			dayOfMonth = date[getDate](),
			month = date[getMonth](),
			fullYear = date[getFullYear](),
			lang = defaultOptions.lang,
			langWeekdays = lang.weekdays,
	
			// List all format keys. Custom formats can be added from the outside. 
			replacements = extend({
	
				// Day
				'a': langWeekdays[day].substr(0, 3), // Short weekday, like 'Mon'
				'A': langWeekdays[day], // Long weekday, like 'Monday'
				'd': pad(dayOfMonth), // Two digit day of the month, 01 to 31
				'e': dayOfMonth, // Day of the month, 1 through 31
	
				// Week (none implemented)
				//'W': weekNumber(),
	
				// Month
				'b': lang.shortMonths[month], // Short month, like 'Jan'
				'B': lang.months[month], // Long month, like 'January'
				'm': pad(month + 1), // Two digit month number, 01 through 12
	
				// Year
				'y': fullYear.toString().substr(2, 2), // Two digits year, like 09 for 2009
				'Y': fullYear, // Four digits year, like 2009
	
				// Time
				'H': pad(hours), // Two digits hours in 24h format, 00 through 23
				'I': pad((hours % 12) || 12), // Two digits hours in 12h format, 00 through 11
				'l': (hours % 12) || 12, // Hours in 12h format, 1 through 12
				'M': pad(date[getMinutes]()), // Two digits minutes, 00 through 59
				'p': hours < 12 ? 'AM' : 'PM', // Upper case AM or PM
				'P': hours < 12 ? 'am' : 'pm', // Lower case AM or PM
				'S': pad(date.getSeconds()), // Two digits seconds, 00 through  59
				'L': pad(mathRound(timestamp % 1000), 3) // Milliseconds (naming from Ruby)
			}, Highcharts.dateFormats);
	
	
		// do the replaces
		for (key in replacements) {
			while (format.indexOf('%' + key) !== -1) { // regex would do it in one line, but this is faster
				format = format.replace('%' + key, typeof replacements[key] === 'function' ? replacements[key](timestamp) : replacements[key]);
			}
		}
	
		// Optionally capitalize the string and return
		return capitalize ? format.substr(0, 1).toUpperCase() + format.substr(1) : format;
	};
	
	/** 
	 * Format a single variable. Similar to sprintf, without the % prefix.
	 */
	function formatSingle(format, val) {
		var floatRegex = /f$/,
			decRegex = /\.([0-9])/,
			lang = defaultOptions.lang,
			decimals;
	
		if (floatRegex.test(format)) { // float
			decimals = format.match(decRegex);
			decimals = decimals ? decimals[1] : -1;
			if (val !== null) {
				val = numberFormat(
					val,
					decimals,
					lang.decimalPoint,
					format.indexOf(',') > -1 ? lang.thousandsSep : ''
				);
			}
		} else {
			val = dateFormat(format, val);
		}
		return val;
	}
	
	/**
	 * Format a string according to a subset of the rules of Python's String.format method.
	 */
	function format(str, ctx) {
		var splitter = '{',
			isInside = false,
			segment,
			valueAndFormat,
			path,
			i,
			len,
			ret = [],
			val,
			index;
		
		while ((index = str.indexOf(splitter)) !== -1) {
			
			segment = str.slice(0, index);
			if (isInside) { // we're on the closing bracket looking back
				
				valueAndFormat = segment.split(':');
				path = valueAndFormat.shift().split('.'); // get first and leave format
				len = path.length;
				val = ctx;
	
				// Assign deeper paths
				for (i = 0; i < len; i++) {
					val = val[path[i]];
				}
	
				// Format the replacement
				if (valueAndFormat.length) {
					val = formatSingle(valueAndFormat.join(':'), val);
				}
	
				// Push the result and advance the cursor
				ret.push(val);
				
			} else {
				ret.push(segment);
				
			}
			str = str.slice(index + 1); // the rest
			isInside = !isInside; // toggle
			splitter = isInside ? '}' : '{'; // now look for next matching bracket
		}
		ret.push(str);
		return ret.join('');
	}
	
	/**
	 * Get the magnitude of a number
	 */
	function getMagnitude(num) {
		return math.pow(10, mathFloor(math.log(num) / math.LN10));
	}
	
	/**
	 * Take an interval and normalize it to multiples of 1, 2, 2.5 and 5
	 * @param {Number} interval
	 * @param {Array} multiples
	 * @param {Number} magnitude
	 * @param {Object} options
	 */
	function normalizeTickInterval(interval, multiples, magnitude, allowDecimals) {
		var normalized, i;
	
		// round to a tenfold of 1, 2, 2.5 or 5
		magnitude = pick(magnitude, 1);
		normalized = interval / magnitude;
	
		// multiples for a linear scale
		if (!multiples) {
			multiples = [1, 2, 2.5, 5, 10];
	
			// the allowDecimals option
			if (allowDecimals === false) {
				if (magnitude === 1) {
					multiples = [1, 2, 5, 10];
				} else if (magnitude <= 0.1) {
					multiples = [1 / magnitude];
				}
			}
		}
	
		// normalize the interval to the nearest multiple
		for (i = 0; i < multiples.length; i++) {
			interval = multiples[i];
			if (normalized <= (multiples[i] + (multiples[i + 1] || multiples[i])) / 2) {
				break;
			}
		}
	
		// multiply back to the correct magnitude
		interval *= magnitude;
	
		return interval;
	}
	
	
	/**
	 * Utility method that sorts an object array and keeping the order of equal items.
	 * ECMA script standard does not specify the behaviour when items are equal.
	 */
	function stableSort(arr, sortFunction) {
		var length = arr.length,
			sortValue,
			i;
	
		// Add index to each item
		for (i = 0; i < length; i++) {
			arr[i].ss_i = i; // stable sort index
		}
	
		arr.sort(function (a, b) {
			sortValue = sortFunction(a, b);
			return sortValue === 0 ? a.ss_i - b.ss_i : sortValue;
		});
	
		// Remove index from items
		for (i = 0; i < length; i++) {
			delete arr[i].ss_i; // stable sort index
		}
	}
	
	/**
	 * Non-recursive method to find the lowest member of an array. Math.min raises a maximum
	 * call stack size exceeded error in Chrome when trying to apply more than 150.000 points. This
	 * method is slightly slower, but safe.
	 */
	function arrayMin(data) {
		var i = data.length,
			min = data[0];
	
		while (i--) {
			if (data[i] < min) {
				min = data[i];
			}
		}
		return min;
	}
	
	/**
	 * Non-recursive method to find the lowest member of an array. Math.min raises a maximum
	 * call stack size exceeded error in Chrome when trying to apply more than 150.000 points. This
	 * method is slightly slower, but safe.
	 */
	function arrayMax(data) {
		var i = data.length,
			max = data[0];
	
		while (i--) {
			if (data[i] > max) {
				max = data[i];
			}
		}
		return max;
	}
	
	/**
	 * Utility method that destroys any SVGElement or VMLElement that are properties on the given object.
	 * It loops all properties and invokes destroy if there is a destroy method. The property is
	 * then delete'ed.
	 * @param {Object} The object to destroy properties on
	 * @param {Object} Exception, do not destroy this property, only delete it.
	 */
	function destroyObjectProperties(obj, except) {
		var n;
		for (n in obj) {
			// If the object is non-null and destroy is defined
			if (obj[n] && obj[n] !== except && obj[n].destroy) {
				// Invoke the destroy
				obj[n].destroy();
			}
	
			// Delete the property from the object.
			delete obj[n];
		}
	}
	
	
	/**
	 * Discard an element by moving it to the bin and delete
	 * @param {Object} The HTML node to discard
	 */
	function discardElement(element) {
		// create a garbage bin element, not part of the DOM
		if (!garbageBin) {
			garbageBin = createElement(DIV);
		}
	
		// move the node and empty bin
		if (element) {
			garbageBin.appendChild(element);
		}
		garbageBin.innerHTML = '';
	}
	
	/**
	 * Provide error messages for debugging, with links to online explanation 
	 */
	error = function (code, stop) {
		var msg = 'Highcharts error #' + code + ': www.highcharts.com/errors/' + code;
		if (stop) {
			throw msg;
		}
		// else ...
		if (win.console) {
			console.log(msg);
		}
	};
	
	/**
	 * Fix JS round off float errors
	 * @param {Number} num
	 */
	function correctFloat(num) {
		return parseFloat(
			num.toPrecision(14)
		);
	}
	
	/**
	 * Set the global animation to either a given value, or fall back to the
	 * given chart's animation option
	 * @param {Object} animation
	 * @param {Object} chart
	 */
	function setAnimation(animation, chart) {
		globalAnimation = pick(animation, chart.animation);
	}
	
	/**
	 * The time unit lookup
	 */
	timeUnits = {
		millisecond: 1,
		second: 1000,
		minute: 60000,
		hour: 3600000,
		day: 24 * 3600000,
		week: 7 * 24 * 3600000,
		month: 31 * 24 * 3600000,
		year: 31556952000
	};
	/**
	 * Path interpolation algorithm used across adapters
	 */
	pathAnim = {
		/**
		 * Prepare start and end values so that the path can be animated one to one
		 */
		init: function (elem, fromD, toD) {
			fromD = fromD || '';
			var shift = elem.shift,
				bezier = fromD.indexOf('C') > -1,
				numParams = bezier ? 7 : 3,
				endLength,
				slice,
				i,
				start = fromD.split(' '),
				end = [].concat(toD), // copy
				startBaseLine,
				endBaseLine,
				sixify = function (arr) { // in splines make move points have six parameters like bezier curves
					i = arr.length;
					while (i--) {
						if (arr[i] === M) {
							arr.splice(i + 1, 0, arr[i + 1], arr[i + 2], arr[i + 1], arr[i + 2]);
						}
					}
				};
	
			if (bezier) {
				sixify(start);
				sixify(end);
			}
	
			// pull out the base lines before padding
			if (elem.isArea) {
				startBaseLine = start.splice(start.length - 6, 6);
				endBaseLine = end.splice(end.length - 6, 6);
			}
	
			// if shifting points, prepend a dummy point to the end path
			if (shift <= end.length / numParams && start.length === end.length) {
				while (shift--) {
					end = [].concat(end).splice(0, numParams).concat(end);
				}
			}
			elem.shift = 0; // reset for following animations
	
			// copy and append last point until the length matches the end length
			if (start.length) {
				endLength = end.length;
				while (start.length < endLength) {
	
					//bezier && sixify(start);
					slice = [].concat(start).splice(start.length - numParams, numParams);
					if (bezier) { // disable first control point
						slice[numParams - 6] = slice[numParams - 2];
						slice[numParams - 5] = slice[numParams - 1];
					}
					start = start.concat(slice);
				}
			}
	
			if (startBaseLine) { // append the base lines for areas
				start = start.concat(startBaseLine);
				end = end.concat(endBaseLine);
			}
			return [start, end];
		},
	
		/**
		 * Interpolate each value of the path and return the array
		 */
		step: function (start, end, pos, complete) {
			var ret = [],
				i = start.length,
				startVal;
	
			if (pos === 1) { // land on the final path without adjustment points appended in the ends
				ret = complete;
	
			} else if (i === end.length && pos < 1) {
				while (i--) {
					startVal = parseFloat(start[i]);
					ret[i] =
						isNaN(startVal) ? // a letter instruction like M or L
							start[i] :
							pos * (parseFloat(end[i] - startVal)) + startVal;
	
				}
			} else { // if animation is finished or length not matching, land on right value
				ret = end;
			}
			return ret;
		}
	};
	
	(function ($) {
		/**
		 * The default HighchartsAdapter for jQuery
		 */
		win.HighchartsAdapter = win.HighchartsAdapter || ($ && {
			
			/**
			 * Initialize the adapter by applying some extensions to jQuery
			 */
			init: function (pathAnim) {
				
				// extend the animate function to allow SVG animations
				var Fx = $.fx;
				
				/*jslint unparam: true*//* allow unused param x in this function */
				$.extend($.easing, {
					easeOutQuad: function (x, t, b, c, d) {
						return -c * (t /= d) * (t - 2) + b;
					}
				});
				/*jslint unparam: false*/
			
				// extend some methods to check for elem.attr, which means it is a Highcharts SVG object
				$.each(['cur', '_default', 'width', 'height', 'opacity'], function (i, fn) {
					var obj = Fx.step,
						base;
						
					// Handle different parent objects
					if (fn === 'cur') {
						obj = Fx.prototype; // 'cur', the getter, relates to Fx.prototype
					
					} else if (fn === '_default' && $.Tween) { // jQuery 1.8 model
						obj = $.Tween.propHooks[fn];
						fn = 'set';
					}
			
					// Overwrite the method
					base = obj[fn];
					if (base) { // step.width and step.height don't exist in jQuery < 1.7
			
						// create the extended function replacement
						obj[fn] = function (fx) {
	
							var elem;
							
							// Fx.prototype.cur does not use fx argument
							fx = i ? fx : this;
	
							// Don't run animations on textual properties like align (#1821)
							if (fx.prop === 'align') {
								return;
							}
			
							// shortcut
							elem = fx.elem;
			
							// Fx.prototype.cur returns the current value. The other ones are setters
							// and returning a value has no effect.
							return elem.attr ? // is SVG element wrapper
								elem.attr(fx.prop, fn === 'cur' ? UNDEFINED : fx.now) : // apply the SVG wrapper's method
								base.apply(this, arguments); // use jQuery's built-in method
						};
					}
				});
	
				// Extend the opacity getter, needed for fading opacity with IE9 and jQuery 1.10+
				wrap($.cssHooks.opacity, 'get', function (proceed, elem, computed) {
					return elem.attr ? (elem.opacity || 0) : proceed.call(this, elem, computed);
				});
				
				// Define the setter function for d (path definitions)
				this.addAnimSetter('d', function (fx) {
					var elem = fx.elem,
						ends;
			
					// Normally start and end should be set in state == 0, but sometimes,
					// for reasons unknown, this doesn't happen. Perhaps state == 0 is skipped
					// in these cases
					if (!fx.started) {
						ends = pathAnim.init(elem, elem.d, elem.toD);
						fx.start = ends[0];
						fx.end = ends[1];
						fx.started = true;
					}
			
					// Interpolate each value of the path
					elem.attr('d', pathAnim.step(fx.start, fx.end, fx.pos, elem.toD));
				});
				
				/**
				 * Utility for iterating over an array. Parameters are reversed compared to jQuery.
				 * @param {Array} arr
				 * @param {Function} fn
				 */
				this.each = Array.prototype.forEach ?
					function (arr, fn) { // modern browsers
						return Array.prototype.forEach.call(arr, fn);
						
					} : 
					function (arr, fn) { // legacy
						var i, 
							len = arr.length;
						for (i = 0; i < len; i++) {
							if (fn.call(arr[i], arr[i], i, arr) === false) {
								return i;
							}
						}
					};
				
				/**
				 * Register Highcharts as a plugin in the respective framework
				 */
				$.fn.highcharts = function () {
					var constr = 'Chart', // default constructor
						args = arguments,
						options,
						ret,
						chart;
	
					if (this[0]) {
	
						if (isString(args[0])) {
							constr = args[0];
							args = Array.prototype.slice.call(args, 1); 
						}
						options = args[0];
	
						// Create the chart
						if (options !== UNDEFINED) {
							/*jslint unused:false*/
							options.chart = options.chart || {};
							options.chart.renderTo = this[0];
							chart = new Highcharts[constr](options, args[1]);
							ret = this;
							/*jslint unused:true*/
						}
	
						// When called without parameters or with the return argument, get a predefined chart
						if (options === UNDEFINED) {
							ret = charts[attr(this[0], 'data-highcharts-chart')];
						}
					}
					
					return ret;
				};
	
			},
	
			/**
			 * Add an animation setter for a specific property
			 */
			addAnimSetter: function (prop, setter) {
				// jQuery 1.8 style
				if ($.Tween) {
					$.Tween.propHooks[prop] = {
						set: setter
					};
				// pre 1.8
				} else {
					$.fx.step[prop] = setter;
				}
			},
			
			/**
			 * Downloads a script and executes a callback when done.
			 * @param {String} scriptLocation
			 * @param {Function} callback
			 */
			getScript: $.getScript,
			
			/**
			 * Return the index of an item in an array, or -1 if not found
			 */
			inArray: $.inArray,
			
			/**
			 * A direct link to jQuery methods. MooTools and Prototype adapters must be implemented for each case of method.
			 * @param {Object} elem The HTML element
			 * @param {String} method Which method to run on the wrapped element
			 */
			adapterRun: function (elem, method) {
				return $(elem)[method]();
			},
		
			/**
			 * Filter an array
			 */
			grep: $.grep,
		
			/**
			 * Map an array
			 * @param {Array} arr
			 * @param {Function} fn
			 */
			map: function (arr, fn) {
				//return jQuery.map(arr, fn);
				var results = [],
					i = 0,
					len = arr.length;
				for (; i < len; i++) {
					results[i] = fn.call(arr[i], arr[i], i, arr);
				}
				return results;
		
			},
		
			/**
			 * Get the position of an element relative to the top left of the page
			 */
			offset: function (el) {
				return $(el).offset();
			},
		
			/**
			 * Add an event listener
			 * @param {Object} el A HTML element or custom object
			 * @param {String} event The event type
			 * @param {Function} fn The event handler
			 */
			addEvent: function (el, event, fn) {
				$(el).bind(event, fn);
			},
		
			/**
			 * Remove event added with addEvent
			 * @param {Object} el The object
			 * @param {String} eventType The event type. Leave blank to remove all events.
			 * @param {Function} handler The function to remove
			 */
			removeEvent: function (el, eventType, handler) {
				// workaround for jQuery issue with unbinding custom events:
				// http://forum.jQuery.com/topic/javascript-error-when-unbinding-a-custom-event-using-jQuery-1-4-2
				var func = doc.removeEventListener ? 'removeEventListener' : 'detachEvent';
				if (doc[func] && el && !el[func]) {
					el[func] = function () {};
				}
		
				$(el).unbind(eventType, handler);
			},
		
			/**
			 * Fire an event on a custom object
			 * @param {Object} el
			 * @param {String} type
			 * @param {Object} eventArguments
			 * @param {Function} defaultFunction
			 */
			fireEvent: function (el, type, eventArguments, defaultFunction) {
				var event = $.Event(type),
					detachedType = 'detached' + type,
					defaultPrevented;
		
				// Remove warnings in Chrome when accessing returnValue (#2790), layerX and layerY. Although Highcharts
				// never uses these properties, Chrome includes them in the default click event and
				// raises the warning when they are copied over in the extend statement below.
				//
				// To avoid problems in IE (see #1010) where we cannot delete the properties and avoid
				// testing if they are there (warning in chrome) the only option is to test if running IE.
				if (!isIE && eventArguments) {
					delete eventArguments.layerX;
					delete eventArguments.layerY;
					delete eventArguments.returnValue;
				}
		
				extend(event, eventArguments);
		
				// Prevent jQuery from triggering the object method that is named the
				// same as the event. For example, if the event is 'select', jQuery
				// attempts calling el.select and it goes into a loop.
				if (el[type]) {
					el[detachedType] = el[type];
					el[type] = null;
				}
		
				// Wrap preventDefault and stopPropagation in try/catch blocks in
				// order to prevent JS errors when cancelling events on non-DOM
				// objects. #615.
				/*jslint unparam: true*/
				$.each(['preventDefault', 'stopPropagation'], function (i, fn) {
					var base = event[fn];
					event[fn] = function () {
						try {
							base.call(event);
						} catch (e) {
							if (fn === 'preventDefault') {
								defaultPrevented = true;
							}
						}
					};
				});
				/*jslint unparam: false*/
		
				// trigger it
				$(el).trigger(event);
		
				// attach the method
				if (el[detachedType]) {
					el[type] = el[detachedType];
					el[detachedType] = null;
				}
		
				if (defaultFunction && !event.isDefaultPrevented() && !defaultPrevented) {
					defaultFunction(event);
				}
			},
			
			/**
			 * Extension method needed for MooTools
			 */
			washMouseEvent: function (e) {
				var ret = e.originalEvent || e;
				
				// computed by jQuery, needed by IE8
				if (ret.pageX === UNDEFINED) { // #1236
					ret.pageX = e.pageX;
					ret.pageY = e.pageY;
				}
				
				return ret;
			},
		
			/**
			 * Animate a HTML element or SVG element wrapper
			 * @param {Object} el
			 * @param {Object} params
			 * @param {Object} options jQuery-like animation options: duration, easing, callback
			 */
			animate: function (el, params, options) {
				var $el = $(el);
				if (!el.style) {
					el.style = {}; // #1881
				}
				if (params.d) {
					el.toD = params.d; // keep the array form for paths, used in $.fx.step.d
					params.d = 1; // because in jQuery, animating to an array has a different meaning
				}
		
				$el.stop();
				if (params.opacity !== UNDEFINED && el.attr) {
					params.opacity += 'px'; // force jQuery to use same logic as width and height (#2161)
				}
				el.hasAnim = 1; // #3342
				$el.animate(params, options);
		
			},
			/**
			 * Stop running animation
			 */
			stop: function (el) {
				if (el.hasAnim) { // #3342, memory leak on calling $(el) from destroy
					$(el).stop();
				}
			}
		});
	}(__webpack_provided_window_dot_jQuery));
	
	
	// check for a custom HighchartsAdapter defined prior to this file
	var globalAdapter = win.HighchartsAdapter,
		adapter = globalAdapter || {};
		
	// Initialize the adapter
	if (globalAdapter) {
		globalAdapter.init.call(globalAdapter, pathAnim);
	}
	
	
	// Utility functions. If the HighchartsAdapter is not defined, adapter is an empty object
	// and all the utility functions will be null. In that case they are populated by the
	// default adapters below.
	var adapterRun = adapter.adapterRun,
		getScript = adapter.getScript,
		inArray = adapter.inArray,
		each = adapter.each,
		grep = adapter.grep,
		offset = adapter.offset,
		map = adapter.map,
		addEvent = adapter.addEvent,
		removeEvent = adapter.removeEvent,
		fireEvent = adapter.fireEvent,
		washMouseEvent = adapter.washMouseEvent,
		animate = adapter.animate,
		stop = adapter.stop;
	
	
	
	/* ****************************************************************************
	 * Handle the options                                                         *
	 *****************************************************************************/
	var
	
	defaultLabelOptions = {
		enabled: true,
		// rotation: 0,
		// align: 'center',
		x: 0,
		y: 15,
		/*formatter: function () {
			return this.value;
		},*/
		style: {
			color: '#606060',
			cursor: 'default',
			fontSize: '11px'
		}
	};
	
	defaultOptions = {
		colors: ['#7cb5ec', '#434348', '#90ed7d', '#f7a35c', 
			    '#8085e9', '#f15c80', '#e4d354', '#8085e8', '#8d4653', '#91e8e1'],
		symbols: ['circle', 'diamond', 'square', 'triangle', 'triangle-down'],
		lang: {
			loading: 'Loading...',
			months: ['January', 'February', 'March', 'April', 'May', 'June', 'July',
					'August', 'September', 'October', 'November', 'December'],
			shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
			weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
			decimalPoint: '.',
			numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'], // SI prefixes used in axis labels
			resetZoom: 'Reset zoom',
			resetZoomTitle: 'Reset zoom level 1:1',
			thousandsSep: ','
		},
		global: {
			useUTC: true,
			//timezoneOffset: 0,
			canvasToolsURL: 'http://code.highcharts.com/4.0.4/modules/canvas-tools.js',
			VMLRadialGradientURL: 'http://code.highcharts.com/4.0.4/gfx/vml-radial-gradient.png'
		},
		chart: {
			//animation: true,
			//alignTicks: false,
			//reflow: true,
			//className: null,
			//events: { load, selection },
			//margin: [null],
			//marginTop: null,
			//marginRight: null,
			//marginBottom: null,
			//marginLeft: null,
			borderColor: '#4572A7',
			//borderWidth: 0,
			borderRadius: 0,
			defaultSeriesType: 'line',
			ignoreHiddenSeries: true,
			//inverted: false,
			//shadow: false,
			spacing: [10, 10, 15, 10],
			//spacingTop: 10,
			//spacingRight: 10,
			//spacingBottom: 15,
			//spacingLeft: 10,
			//style: {
			//	fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif', // default font
			//	fontSize: '12px'
			//},
			backgroundColor: '#FFFFFF',
			//plotBackgroundColor: null,
			plotBorderColor: '#C0C0C0',
			//plotBorderWidth: 0,
			//plotShadow: false,
			//zoomType: ''
			resetZoomButton: {
				theme: {
					zIndex: 20
				},
				position: {
					align: 'right',
					x: -10,
					//verticalAlign: 'top',
					y: 10
				}
				// relativeTo: 'plot'
			}
		},
		title: {
			text: 'Chart title',
			align: 'center',
			// floating: false,
			margin: 15,
			// x: 0,
			// verticalAlign: 'top',
			// y: null,
			style: {
				color: '#333333',
				fontSize: '18px'
			}
	
		},
		subtitle: {
			text: '',
			align: 'center',
			// floating: false
			// x: 0,
			// verticalAlign: 'top',
			// y: null,
			style: {
				color: '#555555'
			}
		},
	
		plotOptions: {
			line: { // base series options
				allowPointSelect: false,
				showCheckbox: false,
				animation: {
					duration: 1000
				},
				//connectNulls: false,
				//cursor: 'default',
				//clip: true,
				//dashStyle: null,
				//enableMouseTracking: true,
				events: {},
				//legendIndex: 0,
				//linecap: 'round',
				lineWidth: 2,
				//shadow: false,
				// stacking: null,
				marker: {
					//enabled: true,
					//symbol: null,
					lineWidth: 0,
					radius: 4,
					lineColor: '#FFFFFF',
					//fillColor: null,
					states: { // states for a single point
						hover: {
							enabled: true,
							lineWidthPlus: 1,
							radiusPlus: 2
						},
						select: {
							fillColor: '#FFFFFF',
							lineColor: '#000000',
							lineWidth: 2
						}
					}
				},
				point: {
					events: {}
				},
				dataLabels: merge(defaultLabelOptions, {
					align: 'center',
					//defer: true,
					enabled: false,
					formatter: function () {
						return this.y === null ? '' : numberFormat(this.y, -1);
					},
					verticalAlign: 'bottom', // above singular point
					y: 0
					// backgroundColor: undefined,
					// borderColor: undefined,
					// borderRadius: undefined,
					// borderWidth: undefined,
					// padding: 3,
					// shadow: false
				}),
				cropThreshold: 300, // draw points outside the plot area when the number of points is less than this
				pointRange: 0,
				//pointStart: 0,
				//pointInterval: 1,
				//showInLegend: null, // auto: true for standalone series, false for linked series
				states: { // states for the entire series
					hover: {
						//enabled: false,
						lineWidthPlus: 1,
						marker: {
							// lineWidth: base + 1,
							// radius: base + 1
						},
						halo: {
							size: 10,
							opacity: 0.25
						}
					},
					select: {
						marker: {}
					}
				},
				stickyTracking: true,
				//tooltip: {
					//pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y}</b>'
					//valueDecimals: null,
					//xDateFormat: '%A, %b %e, %Y',
					//valuePrefix: '',
					//ySuffix: ''				
				//}
				turboThreshold: 1000
				// zIndex: null
			}
		},
		labels: {
			//items: [],
			style: {
				//font: defaultFont,
				position: ABSOLUTE,
				color: '#3E576F'
			}
		},
		legend: {
			enabled: true,
			align: 'center',
			//floating: false,
			layout: 'horizontal',
			labelFormatter: function () {
				return this.name;
			},
			//borderWidth: 0,
			borderColor: '#909090',
			borderRadius: 0,
			navigation: {
				// animation: true,
				activeColor: '#274b6d',
				// arrowSize: 12
				inactiveColor: '#CCC'
				// style: {} // text styles
			},
			// margin: 20,
			// reversed: false,
			shadow: false,
			// backgroundColor: null,
			/*style: {
				padding: '5px'
			},*/
			itemStyle: {			
				color: '#333333',
				fontSize: '12px',
				fontWeight: 'bold'
			},
			itemHoverStyle: {
				//cursor: 'pointer', removed as of #601
				color: '#000'
			},
			itemHiddenStyle: {
				color: '#CCC'
			},
			itemCheckboxStyle: {
				position: ABSOLUTE,
				width: '13px', // for IE precision
				height: '13px'
			},
			// itemWidth: undefined,
			// symbolRadius: 0,
			// symbolWidth: 16,
			symbolPadding: 5,
			verticalAlign: 'bottom',
			// width: undefined,
			x: 0,
			y: 0,
			title: {
				//text: null,
				style: {
					fontWeight: 'bold'
				}
			}			
		},
	
		loading: {
			// hideDuration: 100,
			labelStyle: {
				fontWeight: 'bold',
				position: RELATIVE,
				top: '45%'
			},
			// showDuration: 0,
			style: {
				position: ABSOLUTE,
				backgroundColor: 'white',
				opacity: 0.5,
				textAlign: 'center'
			}
		},
	
		tooltip: {
			enabled: true,
			animation: hasSVG,
			//crosshairs: null,
			backgroundColor: 'rgba(249, 249, 249, .85)',
			borderWidth: 1,
			borderRadius: 3,
			dateTimeLabelFormats: { 
				millisecond: '%A, %b %e, %H:%M:%S.%L',
				second: '%A, %b %e, %H:%M:%S',
				minute: '%A, %b %e, %H:%M',
				hour: '%A, %b %e, %H:%M',
				day: '%A, %b %e, %Y',
				week: 'Week from %A, %b %e, %Y',
				month: '%B %Y',
				year: '%Y'
			},
			//formatter: defaultFormatter,
			headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
			pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
			shadow: true,
			//shape: 'callout',
			//shared: false,
			snap: isTouchDevice ? 25 : 10,
			style: {
				color: '#333333',
				cursor: 'default',
				fontSize: '12px',
				padding: '8px',
				whiteSpace: 'nowrap'
			}
			//xDateFormat: '%A, %b %e, %Y',
			//valueDecimals: null,
			//valuePrefix: '',
			//valueSuffix: ''
		},
	
		credits: {
			enabled: true,
			text: 'Highcharts.com',
			href: 'http://www.highcharts.com',
			position: {
				align: 'right',
				x: -10,
				verticalAlign: 'bottom',
				y: -5
			},
			style: {
				cursor: 'pointer',
				color: '#909090',
				fontSize: '9px'
			}
		}
	};
	
	
	
	
	// Series defaults
	var defaultPlotOptions = defaultOptions.plotOptions,
		defaultSeriesOptions = defaultPlotOptions.line;
	
	// set the default time methods
	setTimeMethods();
	
	
	
	/**
	 * Set the time methods globally based on the useUTC option. Time method can be either
	 * local time or UTC (default).
	 */
	function setTimeMethods() {
		var useUTC = defaultOptions.global.useUTC,
			GET = useUTC ? 'getUTC' : 'get',
			SET = useUTC ? 'setUTC' : 'set';
	
	
		Date = defaultOptions.global.Date || window.Date;
		timezoneOffset = ((useUTC && defaultOptions.global.timezoneOffset) || 0) * 60000;
		makeTime = useUTC ? Date.UTC : function (year, month, date, hours, minutes, seconds) {
			return new Date(
				year,
				month,
				pick(date, 1),
				pick(hours, 0),
				pick(minutes, 0),
				pick(seconds, 0)
			).getTime();
		};
		getMinutes =  GET + 'Minutes';
		getHours =    GET + 'Hours';
		getDay =      GET + 'Day';
		getDate =     GET + 'Date';
		getMonth =    GET + 'Month';
		getFullYear = GET + 'FullYear';
		setMinutes =  SET + 'Minutes';
		setHours =    SET + 'Hours';
		setDate =     SET + 'Date';
		setMonth =    SET + 'Month';
		setFullYear = SET + 'FullYear';
	
	}
	
	/**
	 * Merge the default options with custom options and return the new options structure
	 * @param {Object} options The new custom options
	 */
	function setOptions(options) {
		
		// Copy in the default options
		defaultOptions = merge(true, defaultOptions, options);
		
		// Apply UTC
		setTimeMethods();
	
		return defaultOptions;
	}
	
	/**
	 * Get the updated default options. Until 3.0.7, merely exposing defaultOptions for outside modules
	 * wasn't enough because the setOptions method created a new object.
	 */
	function getOptions() {
		return defaultOptions;
	}
	
	
	/**
	 * Handle color operations. The object methods are chainable.
	 * @param {String} input The input color in either rbga or hex format
	 */
	var rgbaRegEx = /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
		hexRegEx = /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
		rgbRegEx = /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/;
	
	var Color = function (input) {
		// declare variables
		var rgba = [], result, stops;
	
		/**
		 * Parse the input color to rgba array
		 * @param {String} input
		 */
		function init(input) {
	
			// Gradients
			if (input && input.stops) {
				stops = map(input.stops, function (stop) {
					return Color(stop[1]);
				});
	
			// Solid colors
			} else {
				// rgba
				result = rgbaRegEx.exec(input);
				if (result) {
					rgba = [pInt(result[1]), pInt(result[2]), pInt(result[3]), parseFloat(result[4], 10)];
				} else { 
					// hex
					result = hexRegEx.exec(input);
					if (result) {
						rgba = [pInt(result[1], 16), pInt(result[2], 16), pInt(result[3], 16), 1];
					} else {
						// rgb
						result = rgbRegEx.exec(input);
						if (result) {
							rgba = [pInt(result[1]), pInt(result[2]), pInt(result[3]), 1];
						}
					}
				}
			}		
	
		}
		/**
		 * Return the color a specified format
		 * @param {String} format
		 */
		function get(format) {
			var ret;
	
			if (stops) {
				ret = merge(input);
				ret.stops = [].concat(ret.stops);
				each(stops, function (stop, i) {
					ret.stops[i] = [ret.stops[i][0], stop.get(format)];
				});
	
			// it's NaN if gradient colors on a column chart
			} else if (rgba && !isNaN(rgba[0])) {
				if (format === 'rgb') {
					ret = 'rgb(' + rgba[0] + ',' + rgba[1] + ',' + rgba[2] + ')';
				} else if (format === 'a') {
					ret = rgba[3];
				} else {
					ret = 'rgba(' + rgba.join(',') + ')';
				}
			} else {
				ret = input;
			}
			return ret;
		}
	
		/**
		 * Brighten the color
		 * @param {Number} alpha
		 */
		function brighten(alpha) {
			if (stops) {
				each(stops, function (stop) {
					stop.brighten(alpha);
				});
			
			} else if (isNumber(alpha) && alpha !== 0) {
				var i;
				for (i = 0; i < 3; i++) {
					rgba[i] += pInt(alpha * 255);
	
					if (rgba[i] < 0) {
						rgba[i] = 0;
					}
					if (rgba[i] > 255) {
						rgba[i] = 255;
					}
				}
			}
			return this;
		}
		/**
		 * Set the color's opacity to a given alpha value
		 * @param {Number} alpha
		 */
		function setOpacity(alpha) {
			rgba[3] = alpha;
			return this;
		}
	
		// initialize: parse the input
		init(input);
	
		// public methods
		return {
			get: get,
			brighten: brighten,
			rgba: rgba,
			setOpacity: setOpacity
		};
	};
	
	
	/**
	 * A wrapper object for SVG elements
	 */
	function SVGElement() {}
	
	SVGElement.prototype = {
		
		// Default base for animation
		opacity: 1,
		// For labels, these CSS properties are applied to the <text> node directly
		textProps: ['fontSize', 'fontWeight', 'fontFamily', 'color', 
			'lineHeight', 'width', 'textDecoration', 'textShadow', 'HcTextStroke'],
		
		/**
		 * Initialize the SVG renderer
		 * @param {Object} renderer
		 * @param {String} nodeName
		 */
		init: function (renderer, nodeName) {
			var wrapper = this;
			wrapper.element = nodeName === 'span' ?
				createElement(nodeName) :
				doc.createElementNS(SVG_NS, nodeName);
			wrapper.renderer = renderer;
		},
		
		/**
		 * Animate a given attribute
		 * @param {Object} params
		 * @param {Number} options The same options as in jQuery animation
		 * @param {Function} complete Function to perform at the end of animation
		 */
		animate: function (params, options, complete) {
			var animOptions = pick(options, globalAnimation, true);
			stop(this); // stop regardless of animation actually running, or reverting to .attr (#607)
			if (animOptions) {
				animOptions = merge(animOptions, {}); //#2625
				if (complete) { // allows using a callback with the global animation without overwriting it
					animOptions.complete = complete;
				}
				animate(this, params, animOptions);
			} else {
				this.attr(params);
				if (complete) {
					complete();
				}
			}
			return this;
		},
	
		/**
		 * Build an SVG gradient out of a common JavaScript configuration object
		 */
		colorGradient: function (color, prop, elem) {
			var renderer = this.renderer,
				colorObject,
				gradName,
				gradAttr,
				gradients,
				gradientObject,
				stops,
				stopColor,
				stopOpacity,
				radialReference,
				n,
				id,
				key = [];
	
			// Apply linear or radial gradients
			if (color.linearGradient) {
				gradName = 'linearGradient';
			} else if (color.radialGradient) {
				gradName = 'radialGradient';
			}
	
			if (gradName) {
				gradAttr = color[gradName];
				gradients = renderer.gradients;
				stops = color.stops;
				radialReference = elem.radialReference;
	
				// Keep < 2.2 kompatibility
				if (isArray(gradAttr)) {
					color[gradName] = gradAttr = {
						x1: gradAttr[0],
						y1: gradAttr[1],
						x2: gradAttr[2],
						y2: gradAttr[3],
						gradientUnits: 'userSpaceOnUse'
					};
				}
	
				// Correct the radial gradient for the radial reference system
				if (gradName === 'radialGradient' && radialReference && !defined(gradAttr.gradientUnits)) {
					gradAttr = merge(gradAttr, {
						cx: (radialReference[0] - radialReference[2] / 2) + gradAttr.cx * radialReference[2],
						cy: (radialReference[1] - radialReference[2] / 2) + gradAttr.cy * radialReference[2],
						r: gradAttr.r * radialReference[2],
						gradientUnits: 'userSpaceOnUse'
					});
				}
	
				// Build the unique key to detect whether we need to create a new element (#1282)
				for (n in gradAttr) {
					if (n !== 'id') {
						key.push(n, gradAttr[n]);
					}
				}
				for (n in stops) {
					key.push(stops[n]);
				}
				key = key.join(',');
	
				// Check if a gradient object with the same config object is created within this renderer
				if (gradients[key]) {
					id = gradients[key].attr('id');
	
				} else {
	
					// Set the id and create the element
					gradAttr.id = id = PREFIX + idCounter++;
					gradients[key] = gradientObject = renderer.createElement(gradName)
						.attr(gradAttr)
						.add(renderer.defs);
	
	
					// The gradient needs to keep a list of stops to be able to destroy them
					gradientObject.stops = [];
					each(stops, function (stop) {
						var stopObject;
						if (stop[1].indexOf('rgba') === 0) {
							colorObject = Color(stop[1]);
							stopColor = colorObject.get('rgb');
							stopOpacity = colorObject.get('a');
						} else {
							stopColor = stop[1];
							stopOpacity = 1;
						}
						stopObject = renderer.createElement('stop').attr({
							offset: stop[0],
							'stop-color': stopColor,
							'stop-opacity': stopOpacity
						}).add(gradientObject);
	
						// Add the stop element to the gradient
						gradientObject.stops.push(stopObject);
					});
				}
	
				// Set the reference to the gradient object
				elem.setAttribute(prop, 'url(' + renderer.url + '#' + id + ')');
			} 
		},
	
		/**
		 * Set or get a given attribute
		 * @param {Object|String} hash
		 * @param {Mixed|Undefined} val
		 */
		attr: function (hash, val) {
			var key,
				value,
				element = this.element,
				hasSetSymbolSize,
				ret = this,
				skipAttr;
	
			// single key-value pair
			if (typeof hash === 'string' && val !== UNDEFINED) {
				key = hash;
				hash = {};
				hash[key] = val;
			}
	
			// used as a getter: first argument is a string, second is undefined
			if (typeof hash === 'string') {
				ret = (this[hash + 'Getter'] || this._defaultGetter).call(this, hash, element);
			
			// setter
			} else {
	
				for (key in hash) {
					value = hash[key];
					skipAttr = false;
	
	
	
					if (this.symbolName && /^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)/.test(key)) {
						if (!hasSetSymbolSize) {
							this.symbolAttr(hash);
							hasSetSymbolSize = true;
						}
						skipAttr = true;
					}
	
					if (this.rotation && (key === 'x' || key === 'y')) {
						this.doTransform = true;
					}
					
					if (!skipAttr) {
						(this[key + 'Setter'] || this._defaultSetter).call(this, value, key, element);
					}
	
					// Let the shadow follow the main element
					if (this.shadows && /^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(key)) {
						this.updateShadows(key, value);
					}
				}
	
				// Update transform. Do this outside the loop to prevent redundant updating for batch setting
				// of attributes.
				if (this.doTransform) {
					this.updateTransform();
					this.doTransform = false;
				}
	
			}
	
			return ret;
		},
	
		updateShadows: function (key, value) {
			var shadows = this.shadows,
				i = shadows.length;
			while (i--) {
				shadows[i].setAttribute(
					key,
					key === 'height' ?
						mathMax(value - (shadows[i].cutHeight || 0), 0) :
						key === 'd' ? this.d : value
				);
			}
		},
	
		/**
		 * Add a class name to an element
		 */
		addClass: function (className) {
			var element = this.element,
				currentClassName = attr(element, 'class') || '';
	
			if (currentClassName.indexOf(className) === -1) {
				attr(element, 'class', currentClassName + ' ' + className);
			}
			return this;
		},
		/* hasClass and removeClass are not (yet) needed
		hasClass: function (className) {
			return attr(this.element, 'class').indexOf(className) !== -1;
		},
		removeClass: function (className) {
			attr(this.element, 'class', attr(this.element, 'class').replace(className, ''));
			return this;
		},
		*/
	
		/**
		 * If one of the symbol size affecting parameters are changed,
		 * check all the others only once for each call to an element's
		 * .attr() method
		 * @param {Object} hash
		 */
		symbolAttr: function (hash) {
			var wrapper = this;
	
			each(['x', 'y', 'r', 'start', 'end', 'width', 'height', 'innerR', 'anchorX', 'anchorY'], function (key) {
				wrapper[key] = pick(hash[key], wrapper[key]);
			});
	
			wrapper.attr({
				d: wrapper.renderer.symbols[wrapper.symbolName](
					wrapper.x,
					wrapper.y,
					wrapper.width,
					wrapper.height,
					wrapper
				)
			});
		},
	
		/**
		 * Apply a clipping path to this object
		 * @param {String} id
		 */
		clip: function (clipRect) {
			return this.attr('clip-path', clipRect ? 'url(' + this.renderer.url + '#' + clipRect.id + ')' : NONE);
		},
	
		/**
		 * Calculate the coordinates needed for drawing a rectangle crisply and return the
		 * calculated attributes
		 * @param {Number} strokeWidth
		 * @param {Number} x
		 * @param {Number} y
		 * @param {Number} width
		 * @param {Number} height
		 */
		crisp: function (rect) {
	
			var wrapper = this,
				key,
				attribs = {},
				normalizer,
				strokeWidth = rect.strokeWidth || wrapper.strokeWidth || 0;
	
			normalizer = mathRound(strokeWidth) % 2 / 2; // mathRound because strokeWidth can sometimes have roundoff errors
	
			// normalize for crisp edges
			rect.x = mathFloor(rect.x || wrapper.x || 0) + normalizer;
			rect.y = mathFloor(rect.y || wrapper.y || 0) + normalizer;
			rect.width = mathFloor((rect.width || wrapper.width || 0) - 2 * normalizer);
			rect.height = mathFloor((rect.height || wrapper.height || 0) - 2 * normalizer);
			rect.strokeWidth = strokeWidth;
	
			for (key in rect) {
				if (wrapper[key] !== rect[key]) { // only set attribute if changed
					wrapper[key] = attribs[key] = rect[key];
				}
			}
	
			return attribs;
		},
	
		/**
		 * Set styles for the element
		 * @param {Object} styles
		 */
		css: function (styles) {
			var elemWrapper = this,
				oldStyles = elemWrapper.styles,
				newStyles = {},
				elem = elemWrapper.element,
				textWidth,
				n,
				serializedCss = '',
				hyphenate,
				hasNew = !oldStyles;
	
			// convert legacy
			if (styles && styles.color) {
				styles.fill = styles.color;
			}
	
			// Filter out existing styles to increase performance (#2640)
			if (oldStyles) {
				for (n in styles) {
					if (styles[n] !== oldStyles[n]) {
						newStyles[n] = styles[n];
						hasNew = true;
					}
				}
			}
			if (hasNew) {
				textWidth = elemWrapper.textWidth = styles && styles.width && elem.nodeName.toLowerCase() === 'text' && pInt(styles.width);
	
				// Merge the new styles with the old ones
				if (oldStyles) {
					styles = extend(
						oldStyles,
						newStyles
					);
				}		
	
				// store object
				elemWrapper.styles = styles;
	
				if (textWidth && (useCanVG || (!hasSVG && elemWrapper.renderer.forExport))) {
					delete styles.width;
				}
	
				// serialize and set style attribute
				if (isIE && !hasSVG) {
					css(elemWrapper.element, styles);
				} else {
					/*jslint unparam: true*/
					hyphenate = function (a, b) { return '-' + b.toLowerCase(); };
					/*jslint unparam: false*/
					for (n in styles) {
						serializedCss += n.replace(/([A-Z])/g, hyphenate) + ':' + styles[n] + ';';
					}
					attr(elem, 'style', serializedCss); // #1881
				}
	
	
				// re-build text
				if (textWidth && elemWrapper.added) {
					elemWrapper.renderer.buildText(elemWrapper);
				}
			}
	
			return elemWrapper;
		},
	
		/**
		 * Add an event listener
		 * @param {String} eventType
		 * @param {Function} handler
		 */
		on: function (eventType, handler) {
			var svgElement = this,
				element = svgElement.element;
			
			// touch
			if (hasTouch && eventType === 'click') {
				element.ontouchstart = function (e) {			
					svgElement.touchEventFired = Date.now();				
					e.preventDefault();
					handler.call(element, e);
				};
				element.onclick = function (e) {												
					if (userAgent.indexOf('Android') === -1 || Date.now() - (svgElement.touchEventFired || 0) > 1100) { // #2269
						handler.call(element, e);
					}
				};			
			} else {
				// simplest possible event model for internal use
				element['on' + eventType] = handler;
			}
			return this;
		},
	
		/**
		 * Set the coordinates needed to draw a consistent radial gradient across
		 * pie slices regardless of positioning inside the chart. The format is
		 * [centerX, centerY, diameter] in pixels.
		 */
		setRadialReference: function (coordinates) {
			this.element.radialReference = coordinates;
			return this;
		},
	
		/**
		 * Move an object and its children by x and y values
		 * @param {Number} x
		 * @param {Number} y
		 */
		translate: function (x, y) {
			return this.attr({
				translateX: x,
				translateY: y
			});
		},
	
		/**
		 * Invert a group, rotate and flip
		 */
		invert: function () {
			var wrapper = this;
			wrapper.inverted = true;
			wrapper.updateTransform();
			return wrapper;
		},
	
		/**
		 * Private method to update the transform attribute based on internal
		 * properties
		 */
		updateTransform: function () {
			var wrapper = this,
				translateX = wrapper.translateX || 0,
				translateY = wrapper.translateY || 0,
				scaleX = wrapper.scaleX,
				scaleY = wrapper.scaleY,
				inverted = wrapper.inverted,
				rotation = wrapper.rotation,
				element = wrapper.element,
				transform;
	
			// flipping affects translate as adjustment for flipping around the group's axis
			if (inverted) {
				translateX += wrapper.attr('width');
				translateY += wrapper.attr('height');
			}
	
			// Apply translate. Nearly all transformed elements have translation, so instead
			// of checking for translate = 0, do it always (#1767, #1846).
			transform = ['translate(' + translateX + ',' + translateY + ')'];
	
			// apply rotation
			if (inverted) {
				transform.push('rotate(90) scale(-1,1)');
			} else if (rotation) { // text rotation
				transform.push('rotate(' + rotation + ' ' + (element.getAttribute('x') || 0) + ' ' + (element.getAttribute('y') || 0) + ')');
			}
	
			// apply scale
			if (defined(scaleX) || defined(scaleY)) {
				transform.push('scale(' + pick(scaleX, 1) + ' ' + pick(scaleY, 1) + ')');
			}
	
			if (transform.length) {
				element.setAttribute('transform', transform.join(' '));
			}
		},
		/**
		 * Bring the element to the front
		 */
		toFront: function () {
			var element = this.element;
			element.parentNode.appendChild(element);
			return this;
		},
	
	
		/**
		 * Break down alignment options like align, verticalAlign, x and y
		 * to x and y relative to the chart.
		 *
		 * @param {Object} alignOptions
		 * @param {Boolean} alignByTranslate
		 * @param {String[Object} box The box to align to, needs a width and height. When the
		 *        box is a string, it refers to an object in the Renderer. For example, when
		 *        box is 'spacingBox', it refers to Renderer.spacingBox which holds width, height
		 *        x and y properties.
		 *
		 */
		align: function (alignOptions, alignByTranslate, box) {
			var align,
				vAlign,
				x,
				y,
				attribs = {},
				alignTo,
				renderer = this.renderer,
				alignedObjects = renderer.alignedObjects;
	
			// First call on instanciate
			if (alignOptions) {
				this.alignOptions = alignOptions;
				this.alignByTranslate = alignByTranslate;
				if (!box || isString(box)) { // boxes other than renderer handle this internally
					this.alignTo = alignTo = box || 'renderer';
					erase(alignedObjects, this); // prevent duplicates, like legendGroup after resize
					alignedObjects.push(this);
					box = null; // reassign it below
				}
	
			// When called on resize, no arguments are supplied
			} else {
				alignOptions = this.alignOptions;
				alignByTranslate = this.alignByTranslate;
				alignTo = this.alignTo;
			}
	
			box = pick(box, renderer[alignTo], renderer);
	
			// Assign variables
			align = alignOptions.align;
			vAlign = alignOptions.verticalAlign;
			x = (box.x || 0) + (alignOptions.x || 0); // default: left align
			y = (box.y || 0) + (alignOptions.y || 0); // default: top align
	
			// Align
			if (align === 'right' || align === 'center') {
				x += (box.width - (alignOptions.width || 0)) /
						{ right: 1, center: 2 }[align];
			}
			attribs[alignByTranslate ? 'translateX' : 'x'] = mathRound(x);
	
	
			// Vertical align
			if (vAlign === 'bottom' || vAlign === 'middle') {
				y += (box.height - (alignOptions.height || 0)) /
						({ bottom: 1, middle: 2 }[vAlign] || 1);
	
			}
			attribs[alignByTranslate ? 'translateY' : 'y'] = mathRound(y);
	
			// Animate only if already placed
			this[this.placed ? 'animate' : 'attr'](attribs);
			this.placed = true;
			this.alignAttr = attribs;
	
			return this;
		},
	
		/**
		 * Get the bounding box (width, height, x and y) for the element
		 */
		getBBox: function () {
			var wrapper = this,
				bBox = wrapper.bBox,
				renderer = wrapper.renderer,
				width,
				height,
				rotation = wrapper.rotation,
				element = wrapper.element,
				styles = wrapper.styles,
				rad = rotation * deg2rad,
				textStr = wrapper.textStr,
				cacheKey;
	
			// Since numbers are monospaced, and numerical labels appear a lot in a chart,
			// we assume that a label of n characters has the same bounding box as others 
			// of the same length.
			if (textStr === '' || numRegex.test(textStr)) {
				cacheKey = 'num.' + textStr.toString().length + (styles ? ('|' + styles.fontSize + '|' + styles.fontFamily) : '');
	
			} //else { // This code block made demo/waterfall fail, related to buildText
				// Caching all strings reduces rendering time by 4-5%. 
				// TODO: Check how this affects places where bBox is found on the element
				//cacheKey = textStr + (styles ? ('|' + styles.fontSize + '|' + styles.fontFamily) : '');
			//}
			if (cacheKey) {
				bBox = renderer.cache[cacheKey];
			}
	
			// No cache found
			if (!bBox) {
	
				// SVG elements
				if (element.namespaceURI === SVG_NS || renderer.forExport) {
					try { // Fails in Firefox if the container has display: none.
	
						bBox = element.getBBox ?
							// SVG: use extend because IE9 is not allowed to change width and height in case
							// of rotation (below)
							extend({}, element.getBBox()) :
							// Canvas renderer and legacy IE in export mode
							{
								width: element.offsetWidth,
								height: element.offsetHeight
							};
					} catch (e) {}
	
					// If the bBox is not set, the try-catch block above failed. The other condition
					// is for Opera that returns a width of -Infinity on hidden elements.
					if (!bBox || bBox.width < 0) {
						bBox = { width: 0, height: 0 };
					}
	
	
				// VML Renderer or useHTML within SVG
				} else {
	
					bBox = wrapper.htmlGetBBox();
	
				}
	
				// True SVG elements as well as HTML elements in modern browsers using the .useHTML option
				// need to compensated for rotation
				if (renderer.isSVG) {
					width = bBox.width;
					height = bBox.height;
	
					// Workaround for wrong bounding box in IE9 and IE10 (#1101, #1505, #1669, #2568)
					if (isIE && styles && styles.fontSize === '11px' && height.toPrecision(3) === '16.9') {
						bBox.height = height = 14;
					}
	
					// Adjust for rotated text
					if (rotation) {
						bBox.width = mathAbs(height * mathSin(rad)) + mathAbs(width * mathCos(rad));
						bBox.height = mathAbs(height * mathCos(rad)) + mathAbs(width * mathSin(rad));
					}
				}
	
				// Cache it
				wrapper.bBox = bBox;
				if (cacheKey) {
					renderer.cache[cacheKey] = bBox;
				}
			}
			return bBox;
		},
	
		/**
		 * Show the element
		 */
		show: function (inherit) {
			// IE9-11 doesn't handle visibilty:inherit well, so we remove the attribute instead (#2881)
			if (inherit && this.element.namespaceURI === SVG_NS) {
				this.element.removeAttribute('visibility');
			} else {
				this.attr({ visibility: inherit ? 'inherit' : VISIBLE });
			}
			return this;
		},
	
		/**
		 * Hide the element
		 */
		hide: function () {
			return this.attr({ visibility: HIDDEN });
		},
	
		fadeOut: function (duration) {
			var elemWrapper = this;
			elemWrapper.animate({
				opacity: 0
			}, {
				duration: duration || 150,
				complete: function () {
					elemWrapper.attr({ y: -9999 }); // #3088, assuming we're only using this for tooltips
				}
			});
		},
	
		/**
		 * Add the element
		 * @param {Object|Undefined} parent Can be an element, an element wrapper or undefined
		 *    to append the element to the renderer.box.
		 */
		add: function (parent) {
	
			var renderer = this.renderer,
				parentWrapper = parent || renderer,
				parentNode = parentWrapper.element || renderer.box,
				childNodes,
				element = this.element,
				zIndex = this.zIndex,
				otherElement,
				otherZIndex,
				i,
				inserted;
	
			if (parent) {
				this.parentGroup = parent;
			}
	
			// mark as inverted
			this.parentInverted = parent && parent.inverted;
	
			// build formatted text
			if (this.textStr !== undefined) {
				renderer.buildText(this);
			}
	
			// mark the container as having z indexed children
			if (zIndex) {
				parentWrapper.handleZ = true;
				zIndex = pInt(zIndex);
			}
	
			// insert according to this and other elements' zIndex
			if (parentWrapper.handleZ) { // this element or any of its siblings has a z index
				childNodes = parentNode.childNodes;
				for (i = 0; i < childNodes.length; i++) {
					otherElement = childNodes[i];
					otherZIndex = attr(otherElement, 'zIndex');
					if (otherElement !== element && (
							// insert before the first element with a higher zIndex
							pInt(otherZIndex) > zIndex ||
							// if no zIndex given, insert before the first element with a zIndex
							(!defined(zIndex) && defined(otherZIndex))
	
							)) {
						parentNode.insertBefore(element, otherElement);
						inserted = true;
						break;
					}
				}
			}
	
			// default: append at the end
			if (!inserted) {
				parentNode.appendChild(element);
			}
	
			// mark as added
			this.added = true;
	
			// fire an event for internal hooks
			if (this.onAdd) {
				this.onAdd();
			}
	
			return this;
		},
	
		/**
		 * Removes a child either by removeChild or move to garbageBin.
		 * Issue 490; in VML removeChild results in Orphaned nodes according to sIEve, discardElement does not.
		 */
		safeRemoveChild: function (element) {
			var parentNode = element.parentNode;
			if (parentNode) {
				parentNode.removeChild(element);
			}
		},
	
		/**
		 * Destroy the element and element wrapper
		 */
		destroy: function () {
			var wrapper = this,
				element = wrapper.element || {},
				shadows = wrapper.shadows,
				parentToClean = wrapper.renderer.isSVG && element.nodeName === 'SPAN' && wrapper.parentGroup,
				grandParent,
				key,
				i;
	
			// remove events
			element.onclick = element.onmouseout = element.onmouseover = element.onmousemove = element.point = null;
			stop(wrapper); // stop running animations
	
			if (wrapper.clipPath) {
				wrapper.clipPath = wrapper.clipPath.destroy();
			}
	
			// Destroy stops in case this is a gradient object
			if (wrapper.stops) {
				for (i = 0; i < wrapper.stops.length; i++) {
					wrapper.stops[i] = wrapper.stops[i].destroy();
				}
				wrapper.stops = null;
			}
	
			// remove element
			wrapper.safeRemoveChild(element);
	
			// destroy shadows
			if (shadows) {
				each(shadows, function (shadow) {
					wrapper.safeRemoveChild(shadow);
				});
			}
	
			// In case of useHTML, clean up empty containers emulating SVG groups (#1960, #2393, #2697).
			while (parentToClean && parentToClean.div && parentToClean.div.childNodes.length === 0) {
				grandParent = parentToClean.parentGroup;
				wrapper.safeRemoveChild(parentToClean.div);
				delete parentToClean.div;
				parentToClean = grandParent;
			}
	
			// remove from alignObjects
			if (wrapper.alignTo) {
				erase(wrapper.renderer.alignedObjects, wrapper);
			}
	
			for (key in wrapper) {
				delete wrapper[key];
			}
	
			return null;
		},
	
		/**
		 * Add a shadow to the element. Must be done after the element is added to the DOM
		 * @param {Boolean|Object} shadowOptions
		 */
		shadow: function (shadowOptions, group, cutOff) {
			var shadows = [],
				i,
				shadow,
				element = this.element,
				strokeWidth,
				shadowWidth,
				shadowElementOpacity,
	
				// compensate for inverted plot area
				transform;
	
	
			if (shadowOptions) {
				shadowWidth = pick(shadowOptions.width, 3);
				shadowElementOpacity = (shadowOptions.opacity || 0.15) / shadowWidth;
				transform = this.parentInverted ?
					'(-1,-1)' :
					'(' + pick(shadowOptions.offsetX, 1) + ', ' + pick(shadowOptions.offsetY, 1) + ')';
				for (i = 1; i <= shadowWidth; i++) {
					shadow = element.cloneNode(0);
					strokeWidth = (shadowWidth * 2) + 1 - (2 * i);
					attr(shadow, {
						'isShadow': 'true',
						'stroke': shadowOptions.color || 'black',
						'stroke-opacity': shadowElementOpacity * i,
						'stroke-width': strokeWidth,
						'transform': 'translate' + transform,
						'fill': NONE
					});
					if (cutOff) {
						attr(shadow, 'height', mathMax(attr(shadow, 'height') - strokeWidth, 0));
						shadow.cutHeight = strokeWidth;
					}
	
					if (group) {
						group.element.appendChild(shadow);
					} else {
						element.parentNode.insertBefore(shadow, element);
					}
	
					shadows.push(shadow);
				}
	
				this.shadows = shadows;
			}
			return this;
	
		},
	
		xGetter: function (key) {
			if (this.element.nodeName === 'circle') {
				key = { x: 'cx', y: 'cy' }[key] || key;
			}
			return this._defaultGetter(key);
		},
	
		/** 
		 * Get the current value of an attribute or pseudo attribute, used mainly
		 * for animation.
		 */
		_defaultGetter: function (key) {
			var ret = pick(this[key], this.element ? this.element.getAttribute(key) : null, 0);
	
			if (/^[\-0-9\.]+$/.test(ret)) { // is numerical
				ret = parseFloat(ret);
			}
			return ret;
		},
	
	
		dSetter: function (value, key, element) {
			if (value && value.join) { // join path
				value = value.join(' ');
			}
			if (/(NaN| {2}|^$)/.test(value)) {
				value = 'M 0 0';
			}
			element.setAttribute(key, value);
	
			this[key] = value;
		},
		dashstyleSetter: function (value) {
			var i;
			value = value && value.toLowerCase();
			if (value) {
				value = value
					.replace('shortdashdotdot', '3,1,1,1,1,1,')
					.replace('shortdashdot', '3,1,1,1')
					.replace('shortdot', '1,1,')
					.replace('shortdash', '3,1,')
					.replace('longdash', '8,3,')
					.replace(/dot/g, '1,3,')
					.replace('dash', '4,3,')
					.replace(/,$/, '')
					.split(','); // ending comma
	
				i = value.length;
				while (i--) {
					value[i] = pInt(value[i]) * this['stroke-width'];
				}
				value = value.join(',')
					.replace('NaN', 'none'); // #3226
				this.element.setAttribute('stroke-dasharray', value);
			}
		},
		alignSetter: function (value) {
			this.element.setAttribute('text-anchor', { left: 'start', center: 'middle', right: 'end' }[value]);
		},
		opacitySetter: function (value, key, element) {
			this[key] = value;
			element.setAttribute(key, value);
		},
		titleSetter: function (value) {
			var titleNode = this.element.getElementsByTagName('title')[0];
			if (!titleNode) {
				titleNode = doc.createElementNS(SVG_NS, 'title');
				this.element.appendChild(titleNode);
			}
			titleNode.textContent = pick(value, '').replace(/<[^>]*>/g, ''); // #3276
		},
		textSetter: function (value) {
			if (value !== this.textStr) {
				// Delete bBox memo when the text changes
				delete this.bBox;
			
				this.textStr = value;
				if (this.added) {
					this.renderer.buildText(this);
				}
			}
		},
		fillSetter: function (value, key, element) {
			if (typeof value === 'string') {
				element.setAttribute(key, value);
			} else if (value) {
				this.colorGradient(value, key, element);
			}
		},
		zIndexSetter: function (value, key, element) {
			element.setAttribute(key, value);
			this[key] = value;
		},
		_defaultSetter: function (value, key, element) {
			element.setAttribute(key, value);
		}
	};
	
	// Some shared setters and getters
	SVGElement.prototype.yGetter = SVGElement.prototype.xGetter;
	SVGElement.prototype.translateXSetter = SVGElement.prototype.translateYSetter = 
			SVGElement.prototype.rotationSetter = SVGElement.prototype.verticalAlignSetter = 
			SVGElement.prototype.scaleXSetter = SVGElement.prototype.scaleYSetter = function (value, key) {
		this[key] = value;
		this.doTransform = true;
	};
	
	// WebKit and Batik have problems with a stroke-width of zero, so in this case we remove the 
	// stroke attribute altogether. #1270, #1369, #3065, #3072.
	SVGElement.prototype['stroke-widthSetter'] = SVGElement.prototype.strokeSetter = function (value, key, element) {
		this[key] = value;
		// Only apply the stroke attribute if the stroke width is defined and larger than 0
		if (this.stroke && this['stroke-width']) {
			this.strokeWidth = this['stroke-width'];
			SVGElement.prototype.fillSetter.call(this, this.stroke, 'stroke', element); // use prototype as instance may be overridden
			element.setAttribute('stroke-width', this['stroke-width']);
			this.hasStroke = true;
		} else if (key === 'stroke-width' && value === 0 && this.hasStroke) {
			element.removeAttribute('stroke');
			this.hasStroke = false;
		}
	};
	
	
	/**
	 * The default SVG renderer
	 */
	var SVGRenderer = function () {
		this.init.apply(this, arguments);
	};
	SVGRenderer.prototype = {
		Element: SVGElement,
	
		/**
		 * Initialize the SVGRenderer
		 * @param {Object} container
		 * @param {Number} width
		 * @param {Number} height
		 * @param {Boolean} forExport
		 */
		init: function (container, width, height, style, forExport) {
			var renderer = this,
				loc = location,
				boxWrapper,
				element,
				desc;
	
			boxWrapper = renderer.createElement('svg')
				.attr({
					version: '1.1'
				})
				.css(this.getStyle(style));
			element = boxWrapper.element;
			container.appendChild(element);
	
			// For browsers other than IE, add the namespace attribute (#1978)
			if (container.innerHTML.indexOf('xmlns') === -1) {
				attr(element, 'xmlns', SVG_NS);
			}
	
			// object properties
			renderer.isSVG = true;
			renderer.box = element;
			renderer.boxWrapper = boxWrapper;
			renderer.alignedObjects = [];
	
			// Page url used for internal references. #24, #672, #1070
			renderer.url = (isFirefox || isWebKit) && doc.getElementsByTagName('base').length ?
				loc.href
					.replace(/#.*?$/, '') // remove the hash
					.replace(/([\('\)])/g, '\\$1') // escape parantheses and quotes
					.replace(/ /g, '%20') : // replace spaces (needed for Safari only)
				'';
	
			// Add description
			desc = this.createElement('desc').add();
			desc.element.appendChild(doc.createTextNode('Created with ' + PRODUCT + ' ' + VERSION));
	
	
			renderer.defs = this.createElement('defs').add();
			renderer.forExport = forExport;
			renderer.gradients = {}; // Object where gradient SvgElements are stored
			renderer.cache = {}; // Cache for numerical bounding boxes
	
			renderer.setSize(width, height, false);
	
	
	
			// Issue 110 workaround:
			// In Firefox, if a div is positioned by percentage, its pixel position may land
			// between pixels. The container itself doesn't display this, but an SVG element
			// inside this container will be drawn at subpixel precision. In order to draw
			// sharp lines, this must be compensated for. This doesn't seem to work inside
			// iframes though (like in jsFiddle).
			var subPixelFix, rect;
			if (isFirefox && container.getBoundingClientRect) {
				renderer.subPixelFix = subPixelFix = function () {
					css(container, { left: 0, top: 0 });
					rect = container.getBoundingClientRect();
					css(container, {
						left: (mathCeil(rect.left) - rect.left) + PX,
						top: (mathCeil(rect.top) - rect.top) + PX
					});
				};
	
				// run the fix now
				subPixelFix();
	
				// run it on resize
				addEvent(win, 'resize', subPixelFix);
			}
		},
	
		getStyle: function (style) {
			return (this.style = extend({
				fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', // default font
				fontSize: '12px'
			}, style));
		},
	
		/**
		 * Detect whether the renderer is hidden. This happens when one of the parent elements
		 * has display: none. #608.
		 */
		isHidden: function () {
			return !this.boxWrapper.getBBox().width;
		},
	
		/**
		 * Destroys the renderer and its allocated members.
		 */
		destroy: function () {
			var renderer = this,
				rendererDefs = renderer.defs;
			renderer.box = null;
			renderer.boxWrapper = renderer.boxWrapper.destroy();
	
			// Call destroy on all gradient elements
			destroyObjectProperties(renderer.gradients || {});
			renderer.gradients = null;
	
			// Defs are null in VMLRenderer
			// Otherwise, destroy them here.
			if (rendererDefs) {
				renderer.defs = rendererDefs.destroy();
			}
	
			// Remove sub pixel fix handler
			// We need to check that there is a handler, otherwise all functions that are registered for event 'resize' are removed
			// See issue #982
			if (renderer.subPixelFix) {
				removeEvent(win, 'resize', renderer.subPixelFix);
			}
	
			renderer.alignedObjects = null;
	
			return null;
		},
	
		/**
		 * Create a wrapper for an SVG element
		 * @param {Object} nodeName
		 */
		createElement: function (nodeName) {
			var wrapper = new this.Element();
			wrapper.init(this, nodeName);
			return wrapper;
		},
	
		/**
		 * Dummy function for use in canvas renderer
		 */
		draw: function () {},
	
		/**
		 * Parse a simple HTML string into SVG tspans
		 *
		 * @param {Object} textNode The parent text SVG node
		 */
		buildText: function (wrapper) {
			var textNode = wrapper.element,
				renderer = this,
				forExport = renderer.forExport,
				textStr = pick(wrapper.textStr, '').toString(),
				hasMarkup = textStr.indexOf('<') !== -1,
				lines,
				childNodes = textNode.childNodes,
				styleRegex,
				hrefRegex,
				parentX = attr(textNode, 'x'),
				textStyles = wrapper.styles,
				width = wrapper.textWidth,
				textLineHeight = textStyles && textStyles.lineHeight,
				textStroke = textStyles && textStyles.HcTextStroke,
				i = childNodes.length,
				getLineHeight = function (tspan) {
					return textLineHeight ? 
						pInt(textLineHeight) :
						renderer.fontMetrics(
							/(px|em)$/.test(tspan && tspan.style.fontSize) ?
								tspan.style.fontSize :
								((textStyles && textStyles.fontSize) || renderer.style.fontSize || 12),
							tspan
						).h;
				};
	
			/// remove old text
			while (i--) {
				textNode.removeChild(childNodes[i]);
			}
	
			// Skip tspans, add text directly to text node. The forceTSpan is a hook 
			// used in text outline hack.
			if (!hasMarkup && !textStroke && textStr.indexOf(' ') === -1) {
				textNode.appendChild(doc.createTextNode(textStr));
				return;
	
			// Complex strings, add more logic
			} else {
	
				styleRegex = /<.*style="([^"]+)".*>/;
				hrefRegex = /<.*href="(http[^"]+)".*>/;
	
				if (width && !wrapper.added) {
					this.box.appendChild(textNode); // attach it to the DOM to read offset width
				}
	
				if (hasMarkup) {
					lines = textStr
						.replace(/<(b|strong)>/g, '<span style="font-weight:bold">')
						.replace(/<(i|em)>/g, '<span style="font-style:italic">')
						.replace(/<a/g, '<span')
						.replace(/<\/(b|strong|i|em|a)>/g, '</span>')
						.split(/<br.*?>/g);
	
				} else {
					lines = [textStr];
				}
	
	
				// remove empty line at end
				if (lines[lines.length - 1] === '') {
					lines.pop();
				}
	
				
				// build the lines
				each(lines, function (line, lineNo) {
					var spans, spanNo = 0;
	
					line = line.replace(/<span/g, '|||<span').replace(/<\/span>/g, '</span>|||');
					spans = line.split('|||');
	
					each(spans, function (span) {
						if (span !== '' || spans.length === 1) {
							var attributes = {},
								tspan = doc.createElementNS(SVG_NS, 'tspan'),
								spanStyle; // #390
							if (styleRegex.test(span)) {
								spanStyle = span.match(styleRegex)[1].replace(/(;| |^)color([ :])/, '$1fill$2');
								attr(tspan, 'style', spanStyle);
							}
							if (hrefRegex.test(span) && !forExport) { // Not for export - #1529
								attr(tspan, 'onclick', 'location.href=\"' + span.match(hrefRegex)[1] + '\"');
								css(tspan, { cursor: 'pointer' });
							}
	
							span = (span.replace(/<(.|\n)*?>/g, '') || ' ')
								.replace(/&lt;/g, '<')
								.replace(/&gt;/g, '>');
	
							// Nested tags aren't supported, and cause crash in Safari (#1596)
							if (span !== ' ') {
	
								// add the text node
								tspan.appendChild(doc.createTextNode(span));
	
								if (!spanNo) { // first span in a line, align it to the left
									if (lineNo && parentX !== null) {
										attributes.x = parentX;
									}
								} else {
									attributes.dx = 0; // #16
								}
	
								// add attributes
								attr(tspan, attributes);
	
								// Append it
								textNode.appendChild(tspan);
	
								// first span on subsequent line, add the line height
								if (!spanNo && lineNo) {
	
									// allow getting the right offset height in exporting in IE
									if (!hasSVG && forExport) {
										css(tspan, { display: 'block' });
									}
	
									// Set the line height based on the font size of either
									// the text element or the tspan element
									attr(
										tspan,
										'dy',
										getLineHeight(tspan)
									);
								}
	
								// check width and apply soft breaks
								if (width) {
									var words = span.replace(/([^\^])-/g, '$1- ').split(' '), // #1273
										hasWhiteSpace = spans.length > 1 || (words.length > 1 && textStyles.whiteSpace !== 'nowrap'),
										tooLong,
										actualWidth,
										hcHeight = textStyles.HcHeight,
										rest = [],
										dy = getLineHeight(tspan),
										softLineNo = 1,
										bBox;
	
									while (hasWhiteSpace && (words.length || rest.length)) {
										delete wrapper.bBox; // delete cache
										bBox = wrapper.getBBox();
										actualWidth = bBox.width;
	
										// Old IE cannot measure the actualWidth for SVG elements (#2314)
										if (!hasSVG && renderer.forExport) {
											actualWidth = renderer.measureSpanWidth(tspan.firstChild.data, wrapper.styles);
										}
	
										tooLong = actualWidth > width;
										if (!tooLong || words.length === 1) { // new line needed
											words = rest;
											rest = [];
											if (words.length) {
												softLineNo++;
												if (hcHeight && softLineNo * dy > hcHeight) {
													words = ['...'];
													wrapper.attr('title', wrapper.textStr);
												} else {
	
													tspan = doc.createElementNS(SVG_NS, 'tspan');
													attr(tspan, {
														dy: dy,
														x: parentX
													});
													if (spanStyle) { // #390
														attr(tspan, 'style', spanStyle);
													}
													textNode.appendChild(tspan);
												}
											}
											if (actualWidth > width) { // a single word is pressing it out
												width = actualWidth;
											}
										} else { // append to existing line tspan
											tspan.removeChild(tspan.firstChild);
											rest.unshift(words.pop());
										}
										if (words.length) {
											tspan.appendChild(doc.createTextNode(words.join(' ').replace(/- /g, '-')));
										}
									}
								}
	
								spanNo++;
							}
						}
					});
				});
			}
		},
	
		/**
		 * Create a button with preset states
		 * @param {String} text
		 * @param {Number} x
		 * @param {Number} y
		 * @param {Function} callback
		 * @param {Object} normalState
		 * @param {Object} hoverState
		 * @param {Object} pressedState
		 */
		button: function (text, x, y, callback, normalState, hoverState, pressedState, disabledState, shape) {
			var label = this.label(text, x, y, shape, null, null, null, null, 'button'),
				curState = 0,
				stateOptions,
				stateStyle,
				normalStyle,
				hoverStyle,
				pressedStyle,
				disabledStyle,
				verticalGradient = { x1: 0, y1: 0, x2: 0, y2: 1 };
	
			// Normal state - prepare the attributes
			normalState = merge({
				'stroke-width': 1,
				stroke: '#CCCCCC',
				fill: {
					linearGradient: verticalGradient,
					stops: [
						[0, '#FEFEFE'],
						[1, '#F6F6F6']
					]
				},
				r: 2,
				padding: 5,
				style: {
					color: 'black'
				}
			}, normalState);
			normalStyle = normalState.style;
			delete normalState.style;
	
			// Hover state
			hoverState = merge(normalState, {
				stroke: '#68A',
				fill: {
					linearGradient: verticalGradient,
					stops: [
						[0, '#FFF'],
						[1, '#ACF']
					]
				}
			}, hoverState);
			hoverStyle = hoverState.style;
			delete hoverState.style;
	
			// Pressed state
			pressedState = merge(normalState, {
				stroke: '#68A',
				fill: {
					linearGradient: verticalGradient,
					stops: [
						[0, '#9BD'],
						[1, '#CDF']
					]
				}
			}, pressedState);
			pressedStyle = pressedState.style;
			delete pressedState.style;
	
			// Disabled state
			disabledState = merge(normalState, {
				style: {
					color: '#CCC'
				}
			}, disabledState);
			disabledStyle = disabledState.style;
			delete disabledState.style;
	
			// Add the events. IE9 and IE10 need mouseover and mouseout to funciton (#667).
			addEvent(label.element, isIE ? 'mouseover' : 'mouseenter', function () {
				if (curState !== 3) {
					label.attr(hoverState)
						.css(hoverStyle);
				}
			});
			addEvent(label.element, isIE ? 'mouseout' : 'mouseleave', function () {
				if (curState !== 3) {
					stateOptions = [normalState, hoverState, pressedState][curState];
					stateStyle = [normalStyle, hoverStyle, pressedStyle][curState];
					label.attr(stateOptions)
						.css(stateStyle);
				}
			});
	
			label.setState = function (state) {
				label.state = curState = state;
				if (!state) {
					label.attr(normalState)
						.css(normalStyle);
				} else if (state === 2) {
					label.attr(pressedState)
						.css(pressedStyle);
				} else if (state === 3) {
					label.attr(disabledState)
						.css(disabledStyle);
				}
			};
	
			return label
				.on('click', function () {
					if (curState !== 3) {
						callback.call(label);
					}
				})
				.attr(normalState)
				.css(extend({ cursor: 'default' }, normalStyle));
		},
	
		/**
		 * Make a straight line crisper by not spilling out to neighbour pixels
		 * @param {Array} points
		 * @param {Number} width
		 */
		crispLine: function (points, width) {
			// points format: [M, 0, 0, L, 100, 0]
			// normalize to a crisp line
			if (points[1] === points[4]) {
				// Substract due to #1129. Now bottom and left axis gridlines behave the same.
				points[1] = points[4] = mathRound(points[1]) - (width % 2 / 2);
			}
			if (points[2] === points[5]) {
				points[2] = points[5] = mathRound(points[2]) + (width % 2 / 2);
			}
			return points;
		},
	
	
		/**
		 * Draw a path
		 * @param {Array} path An SVG path in array form
		 */
		path: function (path) {
			var attr = {
				fill: NONE
			};
			if (isArray(path)) {
				attr.d = path;
			} else if (isObject(path)) { // attributes
				extend(attr, path);
			}
			return this.createElement('path').attr(attr);
		},
	
		/**
		 * Draw and return an SVG circle
		 * @param {Number} x The x position
		 * @param {Number} y The y position
		 * @param {Number} r The radius
		 */
		circle: function (x, y, r) {
			var attr = isObject(x) ?
				x :
				{
					x: x,
					y: y,
					r: r
				},
				wrapper = this.createElement('circle');
	
			wrapper.xSetter = function (value) {
				this.element.setAttribute('cx', value);
			};
			wrapper.ySetter = function (value) {
				this.element.setAttribute('cy', value);
			};
			return wrapper.attr(attr);
		},
	
		/**
		 * Draw and return an arc
		 * @param {Number} x X position
		 * @param {Number} y Y position
		 * @param {Number} r Radius
		 * @param {Number} innerR Inner radius like used in donut charts
		 * @param {Number} start Starting angle
		 * @param {Number} end Ending angle
		 */
		arc: function (x, y, r, innerR, start, end) {
			var arc;
	
			if (isObject(x)) {
				y = x.y;
				r = x.r;
				innerR = x.innerR;
				start = x.start;
				end = x.end;
				x = x.x;
			}
	
			// Arcs are defined as symbols for the ability to set
			// attributes in attr and animate
			arc = this.symbol('arc', x || 0, y || 0, r || 0, r || 0, {
				innerR: innerR || 0,
				start: start || 0,
				end: end || 0
			});
			arc.r = r; // #959
			return arc;
		},
	
		/**
		 * Draw and return a rectangle
		 * @param {Number} x Left position
		 * @param {Number} y Top position
		 * @param {Number} width
		 * @param {Number} height
		 * @param {Number} r Border corner radius
		 * @param {Number} strokeWidth A stroke width can be supplied to allow crisp drawing
		 */
		rect: function (x, y, width, height, r, strokeWidth) {
	
			r = isObject(x) ? x.r : r;
	
			var wrapper = this.createElement('rect'),
				attribs = isObject(x) ? x : x === UNDEFINED ? {} : {
					x: x,
					y: y,
					width: mathMax(width, 0),
					height: mathMax(height, 0)
				};
	
			if (strokeWidth !== UNDEFINED) {
				attribs.strokeWidth = strokeWidth;
				attribs = wrapper.crisp(attribs);
			}
	
			if (r) {
				attribs.r = r;
			}
	
			wrapper.rSetter = function (value) {
				attr(this.element, {
					rx: value,
					ry: value
				});
			};
			
			return wrapper.attr(attribs);
		},
	
		/**
		 * Resize the box and re-align all aligned elements
		 * @param {Object} width
		 * @param {Object} height
		 * @param {Boolean} animate
		 *
		 */
		setSize: function (width, height, animate) {
			var renderer = this,
				alignedObjects = renderer.alignedObjects,
				i = alignedObjects.length;
	
			renderer.width = width;
			renderer.height = height;
	
			renderer.boxWrapper[pick(animate, true) ? 'animate' : 'attr']({
				width: width,
				height: height
			});
	
			while (i--) {
				alignedObjects[i].align();
			}
		},
	
		/**
		 * Create a group
		 * @param {String} name The group will be given a class name of 'highcharts-{name}'.
		 *     This can be used for styling and scripting.
		 */
		g: function (name) {
			var elem = this.createElement('g');
			return defined(name) ? elem.attr({ 'class': PREFIX + name }) : elem;
		},
	
		/**
		 * Display an image
		 * @param {String} src
		 * @param {Number} x
		 * @param {Number} y
		 * @param {Number} width
		 * @param {Number} height
		 */
		image: function (src, x, y, width, height) {
			var attribs = {
					preserveAspectRatio: NONE
				},
				elemWrapper;
	
			// optional properties
			if (arguments.length > 1) {
				extend(attribs, {
					x: x,
					y: y,
					width: width,
					height: height
				});
			}
	
			elemWrapper = this.createElement('image').attr(attribs);
	
			// set the href in the xlink namespace
			if (elemWrapper.element.setAttributeNS) {
				elemWrapper.element.setAttributeNS('http://www.w3.org/1999/xlink',
					'href', src);
			} else {
				// could be exporting in IE
				// using href throws "not supported" in ie7 and under, requries regex shim to fix later
				elemWrapper.element.setAttribute('hc-svg-href', src);
			}
			return elemWrapper;
		},
	
		/**
		 * Draw a symbol out of pre-defined shape paths from the namespace 'symbol' object.
		 *
		 * @param {Object} symbol
		 * @param {Object} x
		 * @param {Object} y
		 * @param {Object} radius
		 * @param {Object} options
		 */
		symbol: function (symbol, x, y, width, height, options) {
	
			var obj,
	
				// get the symbol definition function
				symbolFn = this.symbols[symbol],
	
				// check if there's a path defined for this symbol
				path = symbolFn && symbolFn(
					mathRound(x),
					mathRound(y),
					width,
					height,
					options
				),
	
				imageElement,
				imageRegex = /^url\((.*?)\)$/,
				imageSrc,
				imageSize,
				centerImage;
	
			if (path) {
	
				obj = this.path(path);
				// expando properties for use in animate and attr
				extend(obj, {
					symbolName: symbol,
					x: x,
					y: y,
					width: width,
					height: height
				});
				if (options) {
					extend(obj, options);
				}
	
	
			// image symbols
			} else if (imageRegex.test(symbol)) {
	
				// On image load, set the size and position
				centerImage = function (img, size) {
					if (img.element) { // it may be destroyed in the meantime (#1390)
						img.attr({
							width: size[0],
							height: size[1]
						});
	
						if (!img.alignByTranslate) { // #185
							img.translate(
								mathRound((width - size[0]) / 2), // #1378
								mathRound((height - size[1]) / 2)
							);
						}
					}
				};
	
				imageSrc = symbol.match(imageRegex)[1];
				imageSize = symbolSizes[imageSrc] || (options && options.width && options.height && [options.width, options.height]);
	
				// Ireate the image synchronously, add attribs async
				obj = this.image(imageSrc)
					.attr({
						x: x,
						y: y
					});
				obj.isImg = true;
	
				if (imageSize) {
					centerImage(obj, imageSize);
				} else {
					// Initialize image to be 0 size so export will still function if there's no cached sizes.
					obj.attr({ width: 0, height: 0 });
	
					// Create a dummy JavaScript image to get the width and height. Due to a bug in IE < 8,
					// the created element must be assigned to a variable in order to load (#292).
					imageElement = createElement('img', {
						onload: function () {
							centerImage(obj, symbolSizes[imageSrc] = [this.width, this.height]);
						},
						src: imageSrc
					});
				}
			}
	
			return obj;
		},
	
		/**
		 * An extendable collection of functions for defining symbol paths.
		 */
		symbols: {
			'circle': function (x, y, w, h) {
				var cpw = 0.166 * w;
				return [
					M, x + w / 2, y,
					'C', x + w + cpw, y, x + w + cpw, y + h, x + w / 2, y + h,
					'C', x - cpw, y + h, x - cpw, y, x + w / 2, y,
					'Z'
				];
			},
	
			'square': function (x, y, w, h) {
				return [
					M, x, y,
					L, x + w, y,
					x + w, y + h,
					x, y + h,
					'Z'
				];
			},
	
			'triangle': function (x, y, w, h) {
				return [
					M, x + w / 2, y,
					L, x + w, y + h,
					x, y + h,
					'Z'
				];
			},
	
			'triangle-down': function (x, y, w, h) {
				return [
					M, x, y,
					L, x + w, y,
					x + w / 2, y + h,
					'Z'
				];
			},
			'diamond': function (x, y, w, h) {
				return [
					M, x + w / 2, y,
					L, x + w, y + h / 2,
					x + w / 2, y + h,
					x, y + h / 2,
					'Z'
				];
			},
			'arc': function (x, y, w, h, options) {
				var start = options.start,
					radius = options.r || w || h,
					end = options.end - 0.001, // to prevent cos and sin of start and end from becoming equal on 360 arcs (related: #1561)
					innerRadius = options.innerR,
					open = options.open,
					cosStart = mathCos(start),
					sinStart = mathSin(start),
					cosEnd = mathCos(end),
					sinEnd = mathSin(end),
					longArc = options.end - start < mathPI ? 0 : 1;
	
				return [
					M,
					x + radius * cosStart,
					y + radius * sinStart,
					'A', // arcTo
					radius, // x radius
					radius, // y radius
					0, // slanting
					longArc, // long or short arc
					1, // clockwise
					x + radius * cosEnd,
					y + radius * sinEnd,
					open ? M : L,
					x + innerRadius * cosEnd,
					y + innerRadius * sinEnd,
					'A', // arcTo
					innerRadius, // x radius
					innerRadius, // y radius
					0, // slanting
					longArc, // long or short arc
					0, // clockwise
					x + innerRadius * cosStart,
					y + innerRadius * sinStart,
	
					open ? '' : 'Z' // close
				];
			},
	
			/**
			 * Callout shape used for default tooltips, also used for rounded rectangles in VML
			 */
			callout: function (x, y, w, h, options) {
				var arrowLength = 6,
					halfDistance = 6,
					r = mathMin((options && options.r) || 0, w, h),
					safeDistance = r + halfDistance,
					anchorX = options && options.anchorX,
					anchorY = options && options.anchorY,
					path,
					normalizer = mathRound(options.strokeWidth || 0) % 2 / 2; // mathRound because strokeWidth can sometimes have roundoff errors;
	
				x += normalizer;
				y += normalizer;
				path = [
					'M', x + r, y, 
					'L', x + w - r, y, // top side
					'C', x + w, y, x + w, y, x + w, y + r, // top-right corner
					'L', x + w, y + h - r, // right side
					'C', x + w, y + h, x + w, y + h, x + w - r, y + h, // bottom-right corner
					'L', x + r, y + h, // bottom side
					'C', x, y + h, x, y + h, x, y + h - r, // bottom-left corner
					'L', x, y + r, // left side
					'C', x, y, x, y, x + r, y // top-right corner
				];
				
				if (anchorX && anchorX > w && anchorY > y + safeDistance && anchorY < y + h - safeDistance) { // replace right side
					path.splice(13, 3,
						'L', x + w, anchorY - halfDistance, 
						x + w + arrowLength, anchorY,
						x + w, anchorY + halfDistance,
						x + w, y + h - r
					);
				} else if (anchorX && anchorX < 0 && anchorY > y + safeDistance && anchorY < y + h - safeDistance) { // replace left side
					path.splice(33, 3, 
						'L', x, anchorY + halfDistance, 
						x - arrowLength, anchorY,
						x, anchorY - halfDistance,
						x, y + r
					);
				} else if (anchorY && anchorY > h && anchorX > x + safeDistance && anchorX < x + w - safeDistance) { // replace bottom
					path.splice(23, 3,
						'L', anchorX + halfDistance, y + h,
						anchorX, y + h + arrowLength,
						anchorX - halfDistance, y + h,
						x + r, y + h
					);
				} else if (anchorY && anchorY < 0 && anchorX > x + safeDistance && anchorX < x + w - safeDistance) { // replace top
					path.splice(3, 3,
						'L', anchorX - halfDistance, y,
						anchorX, y - arrowLength,
						anchorX + halfDistance, y,
						w - r, y
					);
				}
				return path;
			}
		},
	
		/**
		 * Define a clipping rectangle
		 * @param {String} id
		 * @param {Number} x
		 * @param {Number} y
		 * @param {Number} width
		 * @param {Number} height
		 */
		clipRect: function (x, y, width, height) {
			var wrapper,
				id = PREFIX + idCounter++,
	
				clipPath = this.createElement('clipPath').attr({
					id: id
				}).add(this.defs);
	
			wrapper = this.rect(x, y, width, height, 0).add(clipPath);
			wrapper.id = id;
			wrapper.clipPath = clipPath;
	
			return wrapper;
		},
	
	
		
	
	
		/**
		 * Add text to the SVG object
		 * @param {String} str
		 * @param {Number} x Left position
		 * @param {Number} y Top position
		 * @param {Boolean} useHTML Use HTML to render the text
		 */
		text: function (str, x, y, useHTML) {
	
			// declare variables
			var renderer = this,
				fakeSVG = useCanVG || (!hasSVG && renderer.forExport),
				wrapper,
				attr = {};
	
			if (useHTML && !renderer.forExport) {
				return renderer.html(str, x, y);
			}
	
			attr.x = Math.round(x || 0); // X is always needed for line-wrap logic
			if (y) {
				attr.y = Math.round(y);
			}
			if (str || str === 0) {
				attr.text = str;
			}
	
			wrapper = renderer.createElement('text')
				.attr(attr);
	
			// Prevent wrapping from creating false offsetWidths in export in legacy IE (#1079, #1063)
			if (fakeSVG) {
				wrapper.css({
					position: ABSOLUTE
				});
			}
	
			if (!useHTML) {
				wrapper.xSetter = function (value, key, element) {
					var tspans = element.getElementsByTagName('tspan'),
						tspan,
						parentVal = element.getAttribute(key),
						i;
					for (i = 0; i < tspans.length; i++) {
						tspan = tspans[i];
						// If the x values are equal, the tspan represents a linebreak
						if (tspan.getAttribute(key) === parentVal) {
							tspan.setAttribute(key, value);
						}
					}
					element.setAttribute(key, value);
				};
			}
			
			return wrapper;
		},
	
		/**
		 * Utility to return the baseline offset and total line height from the font size
		 */
		fontMetrics: function (fontSize, elem) {
			fontSize = fontSize || this.style.fontSize;
			if (elem && win.getComputedStyle) {
				elem = elem.element || elem; // SVGElement
				fontSize = win.getComputedStyle(elem, "").fontSize;
			}
			fontSize = /px/.test(fontSize) ? pInt(fontSize) : /em/.test(fontSize) ? parseFloat(fontSize) * 12 : 12;
	
			// Empirical values found by comparing font size and bounding box height.
			// Applies to the default font family. http://jsfiddle.net/highcharts/7xvn7/
			var lineHeight = fontSize < 24 ? fontSize + 4 : mathRound(fontSize * 1.2),
				baseline = mathRound(lineHeight * 0.8);
	
			return {
				h: lineHeight,
				b: baseline,
				f: fontSize
			};
		},
	
		/**
		 * Add a label, a text item that can hold a colored or gradient background
		 * as well as a border and shadow.
		 * @param {string} str
		 * @param {Number} x
		 * @param {Number} y
		 * @param {String} shape
		 * @param {Number} anchorX In case the shape has a pointer, like a flag, this is the
		 *    coordinates it should be pinned to
		 * @param {Number} anchorY
		 * @param {Boolean} baseline Whether to position the label relative to the text baseline,
		 *    like renderer.text, or to the upper border of the rectangle.
		 * @param {String} className Class name for the group
		 */
		label: function (str, x, y, shape, anchorX, anchorY, useHTML, baseline, className) {
	
			var renderer = this,
				wrapper = renderer.g(className),
				text = renderer.text('', 0, 0, useHTML)
					.attr({
						zIndex: 1
					}),
					//.add(wrapper),
				box,
				bBox,
				alignFactor = 0,
				padding = 3,
				paddingLeft = 0,
				width,
				height,
				wrapperX,
				wrapperY,
				crispAdjust = 0,
				deferredAttr = {},
				baselineOffset,
				needsBox;
	
			/**
			 * This function runs after the label is added to the DOM (when the bounding box is
			 * available), and after the text of the label is updated to detect the new bounding
			 * box and reflect it in the border box.
			 */
			function updateBoxSize() {
				var boxX,
					boxY,
					style = text.element.style;
	
				bBox = (width === undefined || height === undefined || wrapper.styles.textAlign) && text.textStr && 
					text.getBBox();
				wrapper.width = (width || bBox.width || 0) + 2 * padding + paddingLeft;
				wrapper.height = (height || bBox.height || 0) + 2 * padding;
	
				// update the label-scoped y offset
				baselineOffset = padding + renderer.fontMetrics(style && style.fontSize, text).b;
	
				
				if (needsBox) {
	
					// create the border box if it is not already present
					if (!box) {
						boxX = mathRound(-alignFactor * padding);
						boxY = baseline ? -baselineOffset : 0;
	
						wrapper.box = box = shape ?
							renderer.symbol(shape, boxX, boxY, wrapper.width, wrapper.height, deferredAttr) :
							renderer.rect(boxX, boxY, wrapper.width, wrapper.height, 0, deferredAttr[STROKE_WIDTH]);
						box.attr('fill', NONE).add(wrapper);
					}
	
					// apply the box attributes
					if (!box.isImg) { // #1630
						box.attr(extend({
							width: mathRound(wrapper.width),
							height: mathRound(wrapper.height)
						}, deferredAttr));
					}
					deferredAttr = null;
				}
			}
	
			/**
			 * This function runs after setting text or padding, but only if padding is changed
			 */
			function updateTextPadding() {
				var styles = wrapper.styles,
					textAlign = styles && styles.textAlign,
					x = paddingLeft + padding * (1 - alignFactor),
					y;
	
				// determin y based on the baseline
				y = baseline ? 0 : baselineOffset;
	
				// compensate for alignment
				if (defined(width) && bBox && (textAlign === 'center' || textAlign === 'right')) {
					x += { center: 0.5, right: 1 }[textAlign] * (width - bBox.width);
				}
	
				// update if anything changed
				if (x !== text.x || y !== text.y) {
					text.attr('x', x);
					if (y !== UNDEFINED) {
						text.attr('y', y);
					}
				}
	
				// record current values
				text.x = x;
				text.y = y;
			}
	
			/**
			 * Set a box attribute, or defer it if the box is not yet created
			 * @param {Object} key
			 * @param {Object} value
			 */
			function boxAttr(key, value) {
				if (box) {
					box.attr(key, value);
				} else {
					deferredAttr[key] = value;
				}
			}
	
			/**
			 * After the text element is added, get the desired size of the border box
			 * and add it before the text in the DOM.
			 */
			wrapper.onAdd = function () {
				text.add(wrapper);
				wrapper.attr({
					text: (str || str === 0) ? str : '', // alignment is available now // #3295: 0 not rendered if given as a value
					x: x,
					y: y
				});
	
				if (box && defined(anchorX)) {
					wrapper.attr({
						anchorX: anchorX,
						anchorY: anchorY
					});
				}
			};
	
			/*
			 * Add specific attribute setters.
			 */
	
			// only change local variables
			wrapper.widthSetter = function (value) {
				width = value;
			};
			wrapper.heightSetter = function (value) {
				height = value;
			};
			wrapper.paddingSetter =  function (value) {
				if (defined(value) && value !== padding) {
					padding = value;
					updateTextPadding();
				}
			};
			wrapper.paddingLeftSetter =  function (value) {
				if (defined(value) && value !== paddingLeft) {
					paddingLeft = value;
					updateTextPadding();
				}
			};
	
	
			// change local variable and prevent setting attribute on the group
			wrapper.alignSetter = function (value) {
				alignFactor = { left: 0, center: 0.5, right: 1 }[value];
			};
	
			// apply these to the box and the text alike
			wrapper.textSetter = function (value) {
				if (value !== UNDEFINED) {
					text.textSetter(value);
				}
				updateBoxSize();
				updateTextPadding();
			};
	
			// apply these to the box but not to the text
			wrapper['stroke-widthSetter'] = function (value, key) {
				if (value) {
					needsBox = true;
				}
				crispAdjust = value % 2 / 2;
				boxAttr(key, value);
			};
			wrapper.strokeSetter = wrapper.fillSetter = wrapper.rSetter = function (value, key) {
				if (key === 'fill' && value) {
					needsBox = true;
				}
				boxAttr(key, value);
			};
			wrapper.anchorXSetter = function (value, key) {
				anchorX = value;
				boxAttr(key, value + crispAdjust - wrapperX);
			};
			wrapper.anchorYSetter = function (value, key) {
				anchorY = value;
				boxAttr(key, value - wrapperY);
			};
	
			// rename attributes
			wrapper.xSetter = function (value) {
				wrapper.x = value; // for animation getter
				if (alignFactor) {
					value -= alignFactor * ((width || bBox.width) + padding);
				}
				wrapperX = mathRound(value);
				wrapper.attr('translateX', wrapperX);
			};
			wrapper.ySetter = function (value) {
				wrapperY = wrapper.y = mathRound(value);
				wrapper.attr('translateY', wrapperY);
			};
	
			// Redirect certain methods to either the box or the text
			var baseCss = wrapper.css;
			return extend(wrapper, {
				/**
				 * Pick up some properties and apply them to the text instead of the wrapper
				 */
				css: function (styles) {
					if (styles) {
						var textStyles = {};
						styles = merge(styles); // create a copy to avoid altering the original object (#537)
						each(wrapper.textProps, function (prop) {
							if (styles[prop] !== UNDEFINED) {
								textStyles[prop] = styles[prop];
								delete styles[prop];
							}
						});
						text.css(textStyles);
					}
					return baseCss.call(wrapper, styles);
				},
				/**
				 * Return the bounding box of the box, not the group
				 */
				getBBox: function () {
					return {
						width: bBox.width + 2 * padding,
						height: bBox.height + 2 * padding,
						x: bBox.x - padding,
						y: bBox.y - padding
					};
				},
				/**
				 * Apply the shadow to the box
				 */
				shadow: function (b) {
					if (box) {
						box.shadow(b);
					}
					return wrapper;
				},
				/**
				 * Destroy and release memory.
				 */
				destroy: function () {
	
					// Added by button implementation
					removeEvent(wrapper.element, 'mouseenter');
					removeEvent(wrapper.element, 'mouseleave');
	
					if (text) {
						text = text.destroy();
					}
					if (box) {
						box = box.destroy();
					}
					// Call base implementation to destroy the rest
					SVGElement.prototype.destroy.call(wrapper);
	
					// Release local pointers (#1298)
					wrapper = renderer = updateBoxSize = updateTextPadding = boxAttr = null;
				}
			});
		}
	}; // end SVGRenderer
	
	
	// general renderer
	Renderer = SVGRenderer;
	// extend SvgElement for useHTML option
	extend(SVGElement.prototype, {
		/**
		 * Apply CSS to HTML elements. This is used in text within SVG rendering and
		 * by the VML renderer
		 */
		htmlCss: function (styles) {
			var wrapper = this,
				element = wrapper.element,
				textWidth = styles && element.tagName === 'SPAN' && styles.width;
	
			if (textWidth) {
				delete styles.width;
				wrapper.textWidth = textWidth;
				wrapper.updateTransform();
			}
	
			wrapper.styles = extend(wrapper.styles, styles);
			css(wrapper.element, styles);
	
			return wrapper;
		},
	
		/**
		 * VML and useHTML method for calculating the bounding box based on offsets
		 * @param {Boolean} refresh Whether to force a fresh value from the DOM or to
		 * use the cached value
		 *
		 * @return {Object} A hash containing values for x, y, width and height
		 */
	
		htmlGetBBox: function () {
			var wrapper = this,
				element = wrapper.element,
				bBox = wrapper.bBox;
	
			// faking getBBox in exported SVG in legacy IE
			if (!bBox) {
				// faking getBBox in exported SVG in legacy IE (is this a duplicate of the fix for #1079?)
				if (element.nodeName === 'text') {
					element.style.position = ABSOLUTE;
				}
	
				bBox = wrapper.bBox = {
					x: element.offsetLeft,
					y: element.offsetTop,
					width: element.offsetWidth,
					height: element.offsetHeight
				};
			}
	
			return bBox;
		},
	
		/**
		 * VML override private method to update elements based on internal
		 * properties based on SVG transform
		 */
		htmlUpdateTransform: function () {
			// aligning non added elements is expensive
			if (!this.added) {
				this.alignOnAdd = true;
				return;
			}
	
			var wrapper = this,
				renderer = wrapper.renderer,
				elem = wrapper.element,
				translateX = wrapper.translateX || 0,
				translateY = wrapper.translateY || 0,
				x = wrapper.x || 0,
				y = wrapper.y || 0,
				align = wrapper.textAlign || 'left',
				alignCorrection = { left: 0, center: 0.5, right: 1 }[align],
				shadows = wrapper.shadows;
	
			// apply translate
			css(elem, {
				marginLeft: translateX,
				marginTop: translateY
			});
			if (shadows) { // used in labels/tooltip
				each(shadows, function (shadow) {
					css(shadow, {
						marginLeft: translateX + 1,
						marginTop: translateY + 1
					});
				});
			}
	
			// apply inversion
			if (wrapper.inverted) { // wrapper is a group
				each(elem.childNodes, function (child) {
					renderer.invertChild(child, elem);
				});
			}
	
			if (elem.tagName === 'SPAN') {
	
				var width,
					rotation = wrapper.rotation,
					baseline,
					textWidth = pInt(wrapper.textWidth),
					currentTextTransform = [rotation, align, elem.innerHTML, wrapper.textWidth].join(',');
	
				if (currentTextTransform !== wrapper.cTT) { // do the calculations and DOM access only if properties changed
	
	
					baseline = renderer.fontMetrics(elem.style.fontSize).b;
	
					// Renderer specific handling of span rotation
					if (defined(rotation)) {
						wrapper.setSpanRotation(rotation, alignCorrection, baseline);
					}
	
					width = pick(wrapper.elemWidth, elem.offsetWidth);
	
					// Update textWidth
					if (width > textWidth && /[ \-]/.test(elem.textContent || elem.innerText)) { // #983, #1254
						css(elem, {
							width: textWidth + PX,
							display: 'block',
							whiteSpace: 'normal'
						});
						width = textWidth;
					}
	
					wrapper.getSpanCorrection(width, baseline, alignCorrection, rotation, align);
				}
	
				// apply position with correction
				css(elem, {
					left: (x + (wrapper.xCorr || 0)) + PX,
					top: (y + (wrapper.yCorr || 0)) + PX
				});
	
				// force reflow in webkit to apply the left and top on useHTML element (#1249)
				if (isWebKit) {
					baseline = elem.offsetHeight; // assigned to baseline for JSLint purpose
				}
	
				// record current text transform
				wrapper.cTT = currentTextTransform;
			}
		},
	
		/**
		 * Set the rotation of an individual HTML span
		 */
		setSpanRotation: function (rotation, alignCorrection, baseline) {
			var rotationStyle = {},
				cssTransformKey = isIE ? '-ms-transform' : isWebKit ? '-webkit-transform' : isFirefox ? 'MozTransform' : isOpera ? '-o-transform' : '';
	
			rotationStyle[cssTransformKey] = rotationStyle.transform = 'rotate(' + rotation + 'deg)';
			rotationStyle[cssTransformKey + (isFirefox ? 'Origin' : '-origin')] = rotationStyle.transformOrigin = (alignCorrection * 100) + '% ' + baseline + 'px';
			css(this.element, rotationStyle);
		},
	
		/**
		 * Get the correction in X and Y positioning as the element is rotated.
		 */
		getSpanCorrection: function (width, baseline, alignCorrection) {
			this.xCorr = -width * alignCorrection;
			this.yCorr = -baseline;
		}
	});
	
	// Extend SvgRenderer for useHTML option.
	extend(SVGRenderer.prototype, {
		/**
		 * Create HTML text node. This is used by the VML renderer as well as the SVG
		 * renderer through the useHTML option.
		 *
		 * @param {String} str
		 * @param {Number} x
		 * @param {Number} y
		 */
		html: function (str, x, y) {
			var wrapper = this.createElement('span'),
				element = wrapper.element,
				renderer = wrapper.renderer;
	
			// Text setter
			wrapper.textSetter = function (value) {
				if (value !== element.innerHTML) {
					delete this.bBox;
				}
				element.innerHTML = this.textStr = value;
			};
	
			// Various setters which rely on update transform
			wrapper.xSetter = wrapper.ySetter = wrapper.alignSetter = wrapper.rotationSetter = function (value, key) {
				if (key === 'align') {
					key = 'textAlign'; // Do not overwrite the SVGElement.align method. Same as VML.
				}
				wrapper[key] = value;
				wrapper.htmlUpdateTransform();
			};
	
			// Set the default attributes
			wrapper.attr({
					text: str,
					x: mathRound(x),
					y: mathRound(y)
				})
				.css({
					position: ABSOLUTE,
					whiteSpace: 'nowrap',
					fontFamily: this.style.fontFamily,
					fontSize: this.style.fontSize
				});
	
			// Use the HTML specific .css method
			wrapper.css = wrapper.htmlCss;
	
			// This is specific for HTML within SVG
			if (renderer.isSVG) {
				wrapper.add = function (svgGroupWrapper) {
	
					var htmlGroup,
						container = renderer.box.parentNode,
						parentGroup,
						parents = [];
	
					this.parentGroup = svgGroupWrapper;
	
					// Create a mock group to hold the HTML elements
					if (svgGroupWrapper) {
						htmlGroup = svgGroupWrapper.div;
						if (!htmlGroup) {
	
							// Read the parent chain into an array and read from top down
							parentGroup = svgGroupWrapper;
							while (parentGroup) {
	
								parents.push(parentGroup);
	
								// Move up to the next parent group
								parentGroup = parentGroup.parentGroup;
							}
	
							// Ensure dynamically updating position when any parent is translated
							each(parents.reverse(), function (parentGroup) {
								var htmlGroupStyle;
	
								// Create a HTML div and append it to the parent div to emulate
								// the SVG group structure
								htmlGroup = parentGroup.div = parentGroup.div || createElement(DIV, {
									className: attr(parentGroup.element, 'class')
								}, {
									position: ABSOLUTE,
									left: (parentGroup.translateX || 0) + PX,
									top: (parentGroup.translateY || 0) + PX
								}, htmlGroup || container); // the top group is appended to container
	
								// Shortcut
								htmlGroupStyle = htmlGroup.style;
	
								// Set listeners to update the HTML div's position whenever the SVG group
								// position is changed
								extend(parentGroup, {
									translateXSetter: function (value, key) {
										htmlGroupStyle.left = value + PX;
										parentGroup[key] = value;
										parentGroup.doTransform = true;
									},
									translateYSetter: function (value, key) {
										htmlGroupStyle.top = value + PX;
										parentGroup[key] = value;
										parentGroup.doTransform = true;
									},
									visibilitySetter: function (value, key) {
										htmlGroupStyle[key] = value;
									}
								});
							});
	
						}
					} else {
						htmlGroup = container;
					}
	
					htmlGroup.appendChild(element);
	
					// Shared with VML:
					wrapper.added = true;
					if (wrapper.alignOnAdd) {
						wrapper.htmlUpdateTransform();
					}
	
					return wrapper;
				};
			}
			return wrapper;
		}
	});
	
	/* ****************************************************************************
	 *                                                                            *
	 * START OF INTERNET EXPLORER <= 8 SPECIFIC CODE                              *
	 *                                                                            *
	 * For applications and websites that don't need IE support, like platform    *
	 * targeted mobile apps and web apps, this code can be removed.               *
	 *                                                                            *
	 *****************************************************************************/
	
	/**
	 * @constructor
	 */
	var VMLRenderer, VMLElement;
	if (!hasSVG && !useCanVG) {
	
	/**
	 * The VML element wrapper.
	 */
	VMLElement = {
	
		/**
		 * Initialize a new VML element wrapper. It builds the markup as a string
		 * to minimize DOM traffic.
		 * @param {Object} renderer
		 * @param {Object} nodeName
		 */
		init: function (renderer, nodeName) {
			var wrapper = this,
				markup =  ['<', nodeName, ' filled="f" stroked="f"'],
				style = ['position: ', ABSOLUTE, ';'],
				isDiv = nodeName === DIV;
	
			// divs and shapes need size
			if (nodeName === 'shape' || isDiv) {
				style.push('left:0;top:0;width:1px;height:1px;');
			}
			style.push('visibility: ', isDiv ? HIDDEN : VISIBLE);
	
			markup.push(' style="', style.join(''), '"/>');
	
			// create element with default attributes and style
			if (nodeName) {
				markup = isDiv || nodeName === 'span' || nodeName === 'img' ?
					markup.join('')
					: renderer.prepVML(markup);
				wrapper.element = createElement(markup);
			}
	
			wrapper.renderer = renderer;
		},
	
		/**
		 * Add the node to the given parent
		 * @param {Object} parent
		 */
		add: function (parent) {
			var wrapper = this,
				renderer = wrapper.renderer,
				element = wrapper.element,
				box = renderer.box,
				inverted = parent && parent.inverted,
	
				// get the parent node
				parentNode = parent ?
					parent.element || parent :
					box;
	
	
			// if the parent group is inverted, apply inversion on all children
			if (inverted) { // only on groups
				renderer.invertChild(element, parentNode);
			}
	
			// append it
			parentNode.appendChild(element);
	
			// align text after adding to be able to read offset
			wrapper.added = true;
			if (wrapper.alignOnAdd && !wrapper.deferUpdateTransform) {
				wrapper.updateTransform();
			}
	
			// fire an event for internal hooks
			if (wrapper.onAdd) {
				wrapper.onAdd();
			}
	
			return wrapper;
		},
	
		/**
		 * VML always uses htmlUpdateTransform
		 */
		updateTransform: SVGElement.prototype.htmlUpdateTransform,
	
		/**
		 * Set the rotation of a span with oldIE's filter
		 */
		setSpanRotation: function () {
			// Adjust for alignment and rotation. Rotation of useHTML content is not yet implemented
			// but it can probably be implemented for Firefox 3.5+ on user request. FF3.5+
			// has support for CSS3 transform. The getBBox method also needs to be updated
			// to compensate for the rotation, like it currently does for SVG.
			// Test case: http://jsfiddle.net/highcharts/Ybt44/
	
			var rotation = this.rotation,
				costheta = mathCos(rotation * deg2rad),
				sintheta = mathSin(rotation * deg2rad);
						
			css(this.element, {
				filter: rotation ? ['progid:DXImageTransform.Microsoft.Matrix(M11=', costheta,
					', M12=', -sintheta, ', M21=', sintheta, ', M22=', costheta,
					', sizingMethod=\'auto expand\')'].join('') : NONE
			});
		},
	
		/**
		 * Get the positioning correction for the span after rotating. 
		 */
		getSpanCorrection: function (width, baseline, alignCorrection, rotation, align) {
	
			var costheta = rotation ? mathCos(rotation * deg2rad) : 1,
				sintheta = rotation ? mathSin(rotation * deg2rad) : 0,
				height = pick(this.elemHeight, this.element.offsetHeight),
				quad,
				nonLeft = align && align !== 'left';
	
			// correct x and y
			this.xCorr = costheta < 0 && -width;
			this.yCorr = sintheta < 0 && -height;
	
			// correct for baseline and corners spilling out after rotation
			quad = costheta * sintheta < 0;
			this.xCorr += sintheta * baseline * (quad ? 1 - alignCorrection : alignCorrection);
			this.yCorr -= costheta * baseline * (rotation ? (quad ? alignCorrection : 1 - alignCorrection) : 1);
			// correct for the length/height of the text
			if (nonLeft) {
				this.xCorr -= width * alignCorrection * (costheta < 0 ? -1 : 1);
				if (rotation) {
					this.yCorr -= height * alignCorrection * (sintheta < 0 ? -1 : 1);
				}
				css(this.element, {
					textAlign: align
				});
			}
		},
	
		/**
		 * Converts a subset of an SVG path definition to its VML counterpart. Takes an array
		 * as the parameter and returns a string.
		 */
		pathToVML: function (value) {
			// convert paths
			var i = value.length,
				path = [];
	
			while (i--) {
	
				// Multiply by 10 to allow subpixel precision.
				// Substracting half a pixel seems to make the coordinates
				// align with SVG, but this hasn't been tested thoroughly
				if (isNumber(value[i])) {
					path[i] = mathRound(value[i] * 10) - 5;
				} else if (value[i] === 'Z') { // close the path
					path[i] = 'x';
				} else {
					path[i] = value[i];
	
					// When the start X and end X coordinates of an arc are too close,
					// they are rounded to the same value above. In this case, substract or 
					// add 1 from the end X and Y positions. #186, #760, #1371, #1410.
					if (value.isArc && (value[i] === 'wa' || value[i] === 'at')) {
						// Start and end X
						if (path[i + 5] === path[i + 7]) {
							path[i + 7] += value[i + 7] > value[i + 5] ? 1 : -1;
						}
						// Start and end Y
						if (path[i + 6] === path[i + 8]) {
							path[i + 8] += value[i + 8] > value[i + 6] ? 1 : -1;
						}
					}
				}
			}
	
			
			// Loop up again to handle path shortcuts (#2132)
			/*while (i++ < path.length) {
				if (path[i] === 'H') { // horizontal line to
					path[i] = 'L';
					path.splice(i + 2, 0, path[i - 1]);
				} else if (path[i] === 'V') { // vertical line to
					path[i] = 'L';
					path.splice(i + 1, 0, path[i - 2]);
				}
			}*/
			return path.join(' ') || 'x';
		},
	
		/**
		 * Set the element's clipping to a predefined rectangle
		 *
		 * @param {String} id The id of the clip rectangle
		 */
		clip: function (clipRect) {
			var wrapper = this,
				clipMembers,
				cssRet;
	
			if (clipRect) {
				clipMembers = clipRect.members;
				erase(clipMembers, wrapper); // Ensure unique list of elements (#1258)
				clipMembers.push(wrapper);
				wrapper.destroyClip = function () {
					erase(clipMembers, wrapper);
				};
				cssRet = clipRect.getCSS(wrapper);
	
			} else {
				if (wrapper.destroyClip) {
					wrapper.destroyClip();
				}
				cssRet = { clip: docMode8 ? 'inherit' : 'rect(auto)' }; // #1214
			}
	
			return wrapper.css(cssRet);
	
		},
	
		/**
		 * Set styles for the element
		 * @param {Object} styles
		 */
		css: SVGElement.prototype.htmlCss,
	
		/**
		 * Removes a child either by removeChild or move to garbageBin.
		 * Issue 490; in VML removeChild results in Orphaned nodes according to sIEve, discardElement does not.
		 */
		safeRemoveChild: function (element) {
			// discardElement will detach the node from its parent before attaching it
			// to the garbage bin. Therefore it is important that the node is attached and have parent.
			if (element.parentNode) {
				discardElement(element);
			}
		},
	
		/**
		 * Extend element.destroy by removing it from the clip members array
		 */
		destroy: function () {
			if (this.destroyClip) {
				this.destroyClip();
			}
	
			return SVGElement.prototype.destroy.apply(this);
		},
	
		/**
		 * Add an event listener. VML override for normalizing event parameters.
		 * @param {String} eventType
		 * @param {Function} handler
		 */
		on: function (eventType, handler) {
			// simplest possible event model for internal use
			this.element['on' + eventType] = function () {
				var evt = win.event;
				evt.target = evt.srcElement;
				handler(evt);
			};
			return this;
		},
	
		/**
		 * In stacked columns, cut off the shadows so that they don't overlap
		 */
		cutOffPath: function (path, length) {
	
			var len;
	
			path = path.split(/[ ,]/);
			len = path.length;
	
			if (len === 9 || len === 11) {
				path[len - 4] = path[len - 2] = pInt(path[len - 2]) - 10 * length;
			}
			return path.join(' ');
		},
	
		/**
		 * Apply a drop shadow by copying elements and giving them different strokes
		 * @param {Boolean|Object} shadowOptions
		 */
		shadow: function (shadowOptions, group, cutOff) {
			var shadows = [],
				i,
				element = this.element,
				renderer = this.renderer,
				shadow,
				elemStyle = element.style,
				markup,
				path = element.path,
				strokeWidth,
				modifiedPath,
				shadowWidth,
				shadowElementOpacity;
	
			// some times empty paths are not strings
			if (path && typeof path.value !== 'string') {
				path = 'x';
			}
			modifiedPath = path;
	
			if (shadowOptions) {
				shadowWidth = pick(shadowOptions.width, 3);
				shadowElementOpacity = (shadowOptions.opacity || 0.15) / shadowWidth;
				for (i = 1; i <= 3; i++) {
	
					strokeWidth = (shadowWidth * 2) + 1 - (2 * i);
	
					// Cut off shadows for stacked column items
					if (cutOff) {
						modifiedPath = this.cutOffPath(path.value, strokeWidth + 0.5);
					}
	
					markup = ['<shape isShadow="true" strokeweight="', strokeWidth,
						'" filled="false" path="', modifiedPath,
						'" coordsize="10 10" style="', element.style.cssText, '" />'];
	
					shadow = createElement(renderer.prepVML(markup),
						null, {
							left: pInt(elemStyle.left) + pick(shadowOptions.offsetX, 1),
							top: pInt(elemStyle.top) + pick(shadowOptions.offsetY, 1)
						}
					);
					if (cutOff) {
						shadow.cutOff = strokeWidth + 1;
					}
	
					// apply the opacity
					markup = ['<stroke color="', shadowOptions.color || 'black', '" opacity="', shadowElementOpacity * i, '"/>'];
					createElement(renderer.prepVML(markup), null, null, shadow);
	
	
					// insert it
					if (group) {
						group.element.appendChild(shadow);
					} else {
						element.parentNode.insertBefore(shadow, element);
					}
	
					// record it
					shadows.push(shadow);
	
				}
	
				this.shadows = shadows;
			}
			return this;
		},
		updateShadows: noop, // Used in SVG only
	
		setAttr: function (key, value) {
			if (docMode8) { // IE8 setAttribute bug
				this.element[key] = value;
			} else {
				this.element.setAttribute(key, value);
			}
		},
		classSetter: function (value) {
			// IE8 Standards mode has problems retrieving the className unless set like this
			this.element.className = value;
		},
		dashstyleSetter: function (value, key, element) {
			var strokeElem = element.getElementsByTagName('stroke')[0] ||
				createElement(this.renderer.prepVML(['<stroke/>']), null, null, element);
			strokeElem[key] = value || 'solid';
			this[key] = value; /* because changing stroke-width will change the dash length
				and cause an epileptic effect */
		},
		dSetter: function (value, key, element) {
			var i,
				shadows = this.shadows;
			value = value || [];
			this.d = value.join && value.join(' '); // used in getter for animation
	
			element.path = value = this.pathToVML(value);
	
			// update shadows
			if (shadows) {
				i = shadows.length;
				while (i--) {
					shadows[i].path = shadows[i].cutOff ? this.cutOffPath(value, shadows[i].cutOff) : value;
				}
			}
			this.setAttr(key, value);
		},
		fillSetter: function (value, key, element) {
			var nodeName = element.nodeName;
			if (nodeName === 'SPAN') { // text color
				element.style.color = value;
			} else if (nodeName !== 'IMG') { // #1336
				element.filled = value !== NONE;
				this.setAttr('fillcolor', this.renderer.color(value, element, key, this));
			}
		},
		opacitySetter: noop, // Don't bother - animation is too slow and filters introduce artifacts
		rotationSetter: function (value, key, element) {
			var style = element.style;
			this[key] = style[key] = value; // style is for #1873
	
			// Correction for the 1x1 size of the shape container. Used in gauge needles.
			style.left = -mathRound(mathSin(value * deg2rad) + 1) + PX;
			style.top = mathRound(mathCos(value * deg2rad)) + PX;
		},
		strokeSetter: function (value, key, element) {
			this.setAttr('strokecolor', this.renderer.color(value, element, key));
		},
		'stroke-widthSetter': function (value, key, element) {
			element.stroked = !!value; // VML "stroked" attribute
			this[key] = value; // used in getter, issue #113
			if (isNumber(value)) {
				value += PX;
			}
			this.setAttr('strokeweight', value);
		},
		titleSetter: function (value, key) {
			this.setAttr(key, value);
		},
		visibilitySetter: function (value, key, element) {
	
			// Handle inherited visibility
			if (value === 'inherit') {
				value = VISIBLE;
			}
			
			// Let the shadow follow the main element
			if (this.shadows) {
				each(this.shadows, function (shadow) {
					shadow.style[key] = value;
				});
			}
	
			// Instead of toggling the visibility CSS property, move the div out of the viewport.
			// This works around #61 and #586
			if (element.nodeName === 'DIV') {
				value = value === HIDDEN ? '-999em' : 0;
	
				// In order to redraw, IE7 needs the div to be visible when tucked away
				// outside the viewport. So the visibility is actually opposite of
				// the expected value. This applies to the tooltip only.
				if (!docMode8) {
					element.style[key] = value ? VISIBLE : HIDDEN;
				}
				key = 'top';
			}
			element.style[key] = value;
		},
		xSetter: function (value, key, element) {
			this[key] = value; // used in getter
	
			if (key === 'x') {
				key = 'left';
			} else if (key === 'y') {
				key = 'top';
			}/* else {
				value = mathMax(0, value); // don't set width or height below zero (#311)
			}*/
	
			// clipping rectangle special
			if (this.updateClipping) {
				this[key] = value; // the key is now 'left' or 'top' for 'x' and 'y'
				this.updateClipping();
			} else {
				// normal
				element.style[key] = value;
			}
		},
		zIndexSetter: function (value, key, element) {
			element.style[key] = value;
		}
	};
	Highcharts.VMLElement = VMLElement = extendClass(SVGElement, VMLElement);
	
	// Some shared setters
	VMLElement.prototype.ySetter =
		VMLElement.prototype.widthSetter = 
		VMLElement.prototype.heightSetter = 
		VMLElement.prototype.xSetter;
	
	
	/**
	 * The VML renderer
	 */
	var VMLRendererExtension = { // inherit SVGRenderer
	
		Element: VMLElement,
		isIE8: userAgent.indexOf('MSIE 8.0') > -1,
	
	
		/**
		 * Initialize the VMLRenderer
		 * @param {Object} container
		 * @param {Number} width
		 * @param {Number} height
		 */
		init: function (container, width, height, style) {
			var renderer = this,
				boxWrapper,
				box,
				css;
	
			renderer.alignedObjects = [];
	
			boxWrapper = renderer.createElement(DIV)
				.css(extend(this.getStyle(style), { position: RELATIVE}));
			box = boxWrapper.element;
			container.appendChild(boxWrapper.element);
	
	
			// generate the containing box
			renderer.isVML = true;
			renderer.box = box;
			renderer.boxWrapper = boxWrapper;
			renderer.cache = {};
	
	
			renderer.setSize(width, height, false);
	
			// The only way to make IE6 and IE7 print is to use a global namespace. However,
			// with IE8 the only way to make the dynamic shapes visible in screen and print mode
			// seems to be to add the xmlns attribute and the behaviour style inline.
			if (!doc.namespaces.hcv) {
	
				doc.namespaces.add('hcv', 'urn:schemas-microsoft-com:vml');
	
				// Setup default CSS (#2153, #2368, #2384)
				css = 'hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke' +
					'{ behavior:url(#default#VML); display: inline-block; } ';
				try {
					doc.createStyleSheet().cssText = css;
				} catch (e) {
					doc.styleSheets[0].cssText += css;
				}
	
			}
		},
	
	
		/**
		 * Detect whether the renderer is hidden. This happens when one of the parent elements
		 * has display: none
		 */
		isHidden: function () {
			return !this.box.offsetWidth;
		},
	
		/**
		 * Define a clipping rectangle. In VML it is accomplished by storing the values
		 * for setting the CSS style to all associated members.
		 *
		 * @param {Number} x
		 * @param {Number} y
		 * @param {Number} width
		 * @param {Number} height
		 */
		clipRect: function (x, y, width, height) {
	
			// create a dummy element
			var clipRect = this.createElement(),
				isObj = isObject(x);
	
			// mimic a rectangle with its style object for automatic updating in attr
			return extend(clipRect, {
				members: [],
				left: (isObj ? x.x : x) + 1,
				top: (isObj ? x.y : y) + 1,
				width: (isObj ? x.width : width) - 1,
				height: (isObj ? x.height : height) - 1,
				getCSS: function (wrapper) {
					var element = wrapper.element,
						nodeName = element.nodeName,
						isShape = nodeName === 'shape',
						inverted = wrapper.inverted,
						rect = this,
						top = rect.top - (isShape ? element.offsetTop : 0),
						left = rect.left,
						right = left + rect.width,
						bottom = top + rect.height,
						ret = {
							clip: 'rect(' +
								mathRound(inverted ? left : top) + 'px,' +
								mathRound(inverted ? bottom : right) + 'px,' +
								mathRound(inverted ? right : bottom) + 'px,' +
								mathRound(inverted ? top : left) + 'px)'
						};
	
					// issue 74 workaround
					if (!inverted && docMode8 && nodeName === 'DIV') {
						extend(ret, {
							width: right + PX,
							height: bottom + PX
						});
					}
					return ret;
				},
	
				// used in attr and animation to update the clipping of all members
				updateClipping: function () {
					each(clipRect.members, function (member) {
						if (member.element) { // Deleted series, like in stock/members/series-remove demo. Should be removed from members, but this will do.
							member.css(clipRect.getCSS(member));
						}
					});
				}
			});
	
		},
	
	
		/**
		 * Take a color and return it if it's a string, make it a gradient if it's a
		 * gradient configuration object, and apply opacity.
		 *
		 * @param {Object} color The color or config object
		 */
		color: function (color, elem, prop, wrapper) {
			var renderer = this,
				colorObject,
				regexRgba = /^rgba/,
				markup,
				fillType,
				ret = NONE;
	
			// Check for linear or radial gradient
			if (color && color.linearGradient) {
				fillType = 'gradient';
			} else if (color && color.radialGradient) {
				fillType = 'pattern';
			}
	
	
			if (fillType) {
	
				var stopColor,
					stopOpacity,
					gradient = color.linearGradient || color.radialGradient,
					x1,
					y1,
					x2,
					y2,
					opacity1,
					opacity2,
					color1,
					color2,
					fillAttr = '',
					stops = color.stops,
					firstStop,
					lastStop,
					colors = [],
					addFillNode = function () {
						// Add the fill subnode. When colors attribute is used, the meanings of opacity and o:opacity2
						// are reversed.
						markup = ['<fill colors="' + colors.join(',') + '" opacity="', opacity2, '" o:opacity2="', opacity1,
							'" type="', fillType, '" ', fillAttr, 'focus="100%" method="any" />'];
						createElement(renderer.prepVML(markup), null, null, elem);
					};
	
				// Extend from 0 to 1
				firstStop = stops[0];
				lastStop = stops[stops.length - 1];
				if (firstStop[0] > 0) {
					stops.unshift([
						0,
						firstStop[1]
					]);
				}
				if (lastStop[0] < 1) {
					stops.push([
						1,
						lastStop[1]
					]);
				}
	
				// Compute the stops
				each(stops, function (stop, i) {
					if (regexRgba.test(stop[1])) {
						colorObject = Color(stop[1]);
						stopColor = colorObject.get('rgb');
						stopOpacity = colorObject.get('a');
					} else {
						stopColor = stop[1];
						stopOpacity = 1;
					}
	
					// Build the color attribute
					colors.push((stop[0] * 100) + '% ' + stopColor);
	
					// Only start and end opacities are allowed, so we use the first and the last
					if (!i) {
						opacity1 = stopOpacity;
						color2 = stopColor;
					} else {
						opacity2 = stopOpacity;
						color1 = stopColor;
					}
				});
	
				// Apply the gradient to fills only.
				if (prop === 'fill') {
	
					// Handle linear gradient angle
					if (fillType === 'gradient') {
						x1 = gradient.x1 || gradient[0] || 0;
						y1 = gradient.y1 || gradient[1] || 0;
						x2 = gradient.x2 || gradient[2] || 0;
						y2 = gradient.y2 || gradient[3] || 0;
						fillAttr = 'angle="' + (90  - math.atan(
							(y2 - y1) / // y vector
							(x2 - x1) // x vector
							) * 180 / mathPI) + '"';
	
						addFillNode();
	
					// Radial (circular) gradient
					} else {
	
						var r = gradient.r,
							sizex = r * 2,
							sizey = r * 2,
							cx = gradient.cx,
							cy = gradient.cy,
							radialReference = elem.radialReference,
							bBox,
							applyRadialGradient = function () {
								if (radialReference) {
									bBox = wrapper.getBBox();
									cx += (radialReference[0] - bBox.x) / bBox.width - 0.5;
									cy += (radialReference[1] - bBox.y) / bBox.height - 0.5;
									sizex *= radialReference[2] / bBox.width;
									sizey *= radialReference[2] / bBox.height;
								}
								fillAttr = 'src="' + defaultOptions.global.VMLRadialGradientURL + '" ' +
									'size="' + sizex + ',' + sizey + '" ' +
									'origin="0.5,0.5" ' +
									'position="' + cx + ',' + cy + '" ' +
									'color2="' + color2 + '" ';
	
								addFillNode();
							};
	
						// Apply radial gradient
						if (wrapper.added) {
							applyRadialGradient();
						} else {
							// We need to know the bounding box to get the size and position right
							wrapper.onAdd = applyRadialGradient;
						}
	
						// The fill element's color attribute is broken in IE8 standards mode, so we
						// need to set the parent shape's fillcolor attribute instead.
						ret = color1;
					}
	
				// Gradients are not supported for VML stroke, return the first color. #722.
				} else {
					ret = stopColor;
				}
	
			// if the color is an rgba color, split it and add a fill node
			// to hold the opacity component
			} else if (regexRgba.test(color) && elem.tagName !== 'IMG') {
	
				colorObject = Color(color);
	
				markup = ['<', prop, ' opacity="', colorObject.get('a'), '"/>'];
				createElement(this.prepVML(markup), null, null, elem);
	
				ret = colorObject.get('rgb');
	
	
			} else {
				var propNodes = elem.getElementsByTagName(prop); // 'stroke' or 'fill' node
				if (propNodes.length) {
					propNodes[0].opacity = 1;
					propNodes[0].type = 'solid';
				}
				ret = color;
			}
	
			return ret;
		},
	
		/**
		 * Take a VML string and prepare it for either IE8 or IE6/IE7.
		 * @param {Array} markup A string array of the VML markup to prepare
		 */
		prepVML: function (markup) {
			var vmlStyle = 'display:inline-block;behavior:url(#default#VML);',
				isIE8 = this.isIE8;
	
			markup = markup.join('');
	
			if (isIE8) { // add xmlns and style inline
				markup = markup.replace('/>', ' xmlns="urn:schemas-microsoft-com:vml" />');
				if (markup.indexOf('style="') === -1) {
					markup = markup.replace('/>', ' style="' + vmlStyle + '" />');
				} else {
					markup = markup.replace('style="', 'style="' + vmlStyle);
				}
	
			} else { // add namespace
				markup = markup.replace('<', '<hcv:');
			}
	
			return markup;
		},
	
		/**
		 * Create rotated and aligned text
		 * @param {String} str
		 * @param {Number} x
		 * @param {Number} y
		 */
		text: SVGRenderer.prototype.html,
	
		/**
		 * Create and return a path element
		 * @param {Array} path
		 */
		path: function (path) {
			var attr = {
				// subpixel precision down to 0.1 (width and height = 1px)
				coordsize: '10 10'
			};
			if (isArray(path)) {
				attr.d = path;
			} else if (isObject(path)) { // attributes
				extend(attr, path);
			}
			// create the shape
			return this.createElement('shape').attr(attr);
		},
	
		/**
		 * Create and return a circle element. In VML circles are implemented as
		 * shapes, which is faster than v:oval
		 * @param {Number} x
		 * @param {Number} y
		 * @param {Number} r
		 */
		circle: function (x, y, r) {
			var circle = this.symbol('circle');
			if (isObject(x)) {
				r = x.r;
				y = x.y;
				x = x.x;
			}
			circle.isCircle = true; // Causes x and y to mean center (#1682)
			circle.r = r;
			return circle.attr({ x: x, y: y });
		},
	
		/**
		 * Create a group using an outer div and an inner v:group to allow rotating
		 * and flipping. A simple v:group would have problems with positioning
		 * child HTML elements and CSS clip.
		 *
		 * @param {String} name The name of the group
		 */
		g: function (name) {
			var wrapper,
				attribs;
	
			// set the class name
			if (name) {
				attribs = { 'className': PREFIX + name, 'class': PREFIX + name };
			}
	
			// the div to hold HTML and clipping
			wrapper = this.createElement(DIV).attr(attribs);
	
			return wrapper;
		},
	
		/**
		 * VML override to create a regular HTML image
		 * @param {String} src
		 * @param {Number} x
		 * @param {Number} y
		 * @param {Number} width
		 * @param {Number} height
		 */
		image: function (src, x, y, width, height) {
			var obj = this.createElement('img')
				.attr({ src: src });
	
			if (arguments.length > 1) {
				obj.attr({
					x: x,
					y: y,
					width: width,
					height: height
				});
			}
			return obj;
		},
	
		/**
		 * For rectangles, VML uses a shape for rect to overcome bugs and rotation problems
		 */
		createElement: function (nodeName) {
			return nodeName === 'rect' ? this.symbol(nodeName) : SVGRenderer.prototype.createElement.call(this, nodeName);	
		},
	
		/**
		 * In the VML renderer, each child of an inverted div (group) is inverted
		 * @param {Object} element
		 * @param {Object} parentNode
		 */
		invertChild: function (element, parentNode) {
			var ren = this,
				parentStyle = parentNode.style,
				imgStyle = element.tagName === 'IMG' && element.style; // #1111
	
			css(element, {
				flip: 'x',
				left: pInt(parentStyle.width) - (imgStyle ? pInt(imgStyle.top) : 1),
				top: pInt(parentStyle.height) - (imgStyle ? pInt(imgStyle.left) : 1),
				rotation: -90
			});
	
			// Recursively invert child elements, needed for nested composite shapes like box plots and error bars. #1680, #1806.
			each(element.childNodes, function (child) {
				ren.invertChild(child, element);
			});
		},
	
		/**
		 * Symbol definitions that override the parent SVG renderer's symbols
		 *
		 */
		symbols: {
			// VML specific arc function
			arc: function (x, y, w, h, options) {
				var start = options.start,
					end = options.end,
					radius = options.r || w || h,
					innerRadius = options.innerR,
					cosStart = mathCos(start),
					sinStart = mathSin(start),
					cosEnd = mathCos(end),
					sinEnd = mathSin(end),
					ret;
	
				if (end - start === 0) { // no angle, don't show it.
					return ['x'];
				}
	
				ret = [
					'wa', // clockwise arc to
					x - radius, // left
					y - radius, // top
					x + radius, // right
					y + radius, // bottom
					x + radius * cosStart, // start x
					y + radius * sinStart, // start y
					x + radius * cosEnd, // end x
					y + radius * sinEnd  // end y
				];
	
				if (options.open && !innerRadius) {
					ret.push(
						'e',
						M,
						x,// - innerRadius,
						y// - innerRadius
					);
				}
	
				ret.push(
					'at', // anti clockwise arc to
					x - innerRadius, // left
					y - innerRadius, // top
					x + innerRadius, // right
					y + innerRadius, // bottom
					x + innerRadius * cosEnd, // start x
					y + innerRadius * sinEnd, // start y
					x + innerRadius * cosStart, // end x
					y + innerRadius * sinStart, // end y
					'x', // finish path
					'e' // close
				);
	
				ret.isArc = true;
				return ret;
	
			},
			// Add circle symbol path. This performs significantly faster than v:oval.
			circle: function (x, y, w, h, wrapper) {
	
				if (wrapper) {
					w = h = 2 * wrapper.r;
				}
	
				// Center correction, #1682
				if (wrapper && wrapper.isCircle) {
					x -= w / 2;
					y -= h / 2;
				}
	
				// Return the path
				return [
					'wa', // clockwisearcto
					x, // left
					y, // top
					x + w, // right
					y + h, // bottom
					x + w, // start x
					y + h / 2,     // start y
					x + w, // end x
					y + h / 2,     // end y
					//'x', // finish path
					'e' // close
				];
			},
			/**
			 * Add rectangle symbol path which eases rotation and omits arcsize problems
			 * compared to the built-in VML roundrect shape. When borders are not rounded,
			 * use the simpler square path, else use the callout path without the arrow.
			 */
			rect: function (x, y, w, h, options) {
				return SVGRenderer.prototype.symbols[
					!defined(options) || !options.r ? 'square' : 'callout'
				].call(0, x, y, w, h, options);
			}
		}
	};
	Highcharts.VMLRenderer = VMLRenderer = function () {
		this.init.apply(this, arguments);
	};
	VMLRenderer.prototype = merge(SVGRenderer.prototype, VMLRendererExtension);
	
		// general renderer
		Renderer = VMLRenderer;
	}
	
	// This method is used with exporting in old IE, when emulating SVG (see #2314)
	SVGRenderer.prototype.measureSpanWidth = function (text, styles) {
		var measuringSpan = doc.createElement('span'),
			offsetWidth,
		textNode = doc.createTextNode(text);
	
		measuringSpan.appendChild(textNode);
		css(measuringSpan, styles);
		this.box.appendChild(measuringSpan);
		offsetWidth = measuringSpan.offsetWidth;
		discardElement(measuringSpan); // #2463
		return offsetWidth;
	};
	
	
	/* ****************************************************************************
	 *                                                                            *
	 * END OF INTERNET EXPLORER <= 8 SPECIFIC CODE                                *
	 *                                                                            *
	 *****************************************************************************/
	/* ****************************************************************************
	 *                                                                            *
	 * START OF ANDROID < 3 SPECIFIC CODE. THIS CAN BE REMOVED IF YOU'RE NOT      *
	 * TARGETING THAT SYSTEM.                                                     *
	 *                                                                            *
	 *****************************************************************************/
	var CanVGRenderer,
		CanVGController;
	
	if (useCanVG) {
		/**
		 * The CanVGRenderer is empty from start to keep the source footprint small.
		 * When requested, the CanVGController downloads the rest of the source packaged
		 * together with the canvg library.
		 */
		Highcharts.CanVGRenderer = CanVGRenderer = function () {
			// Override the global SVG namespace to fake SVG/HTML that accepts CSS
			SVG_NS = 'http://www.w3.org/1999/xhtml';
		};
	
		/**
		 * Start with an empty symbols object. This is needed when exporting is used (exporting.src.js will add a few symbols), but 
		 * the implementation from SvgRenderer will not be merged in until first render.
		 */
		CanVGRenderer.prototype.symbols = {};
	
		/**
		 * Handles on demand download of canvg rendering support.
		 */
		CanVGController = (function () {
			// List of renderering calls
			var deferredRenderCalls = [];
	
			/**
			 * When downloaded, we are ready to draw deferred charts.
			 */
			function drawDeferred() {
				var callLength = deferredRenderCalls.length,
					callIndex;
	
				// Draw all pending render calls
				for (callIndex = 0; callIndex < callLength; callIndex++) {
					deferredRenderCalls[callIndex]();
				}
				// Clear the list
				deferredRenderCalls = [];
			}
	
			return {
				push: function (func, scriptLocation) {
					// Only get the script once
					if (deferredRenderCalls.length === 0) {
						getScript(scriptLocation, drawDeferred);
					}
					// Register render call
					deferredRenderCalls.push(func);
				}
			};
		}());
	
		Renderer = CanVGRenderer;
	} // end CanVGRenderer
	
	/* ****************************************************************************
	 *                                                                            *
	 * END OF ANDROID < 3 SPECIFIC CODE                                           *
	 *                                                                            *
	 *****************************************************************************/
	
	/**
	 * The Tick class
	 */
	function Tick(axis, pos, type, noLabel) {
		this.axis = axis;
		this.pos = pos;
		this.type = type || '';
		this.isNew = true;
	
		if (!type && !noLabel) {
			this.addLabel();
		}
	}
	
	Tick.prototype = {
		/**
		 * Write the tick label
		 */
		addLabel: function () {
			var tick = this,
				axis = tick.axis,
				options = axis.options,
				chart = axis.chart,
				horiz = axis.horiz,
				categories = axis.categories,
				names = axis.names,
				pos = tick.pos,
				labelOptions = options.labels,
				rotation = labelOptions.rotation,
				str,
				tickPositions = axis.tickPositions,
				width = (horiz && categories &&
					!labelOptions.step && !labelOptions.staggerLines &&
					!labelOptions.rotation &&
					chart.plotWidth / tickPositions.length) ||
					(!horiz && (chart.margin[3] || chart.chartWidth * 0.33)), // #1580, #1931
				isFirst = pos === tickPositions[0],
				isLast = pos === tickPositions[tickPositions.length - 1],
				css,
				attr,
				value = categories ?
					pick(categories[pos], names[pos], pos) :
					pos,
				label = tick.label,
				tickPositionInfo = tickPositions.info,
				dateTimeLabelFormat;
	
			// Set the datetime label format. If a higher rank is set for this position, use that. If not,
			// use the general format.
			if (axis.isDatetimeAxis && tickPositionInfo) {
				dateTimeLabelFormat = options.dateTimeLabelFormats[tickPositionInfo.higherRanks[pos] || tickPositionInfo.unitName];
			}
			// set properties for access in render method
			tick.isFirst = isFirst;
			tick.isLast = isLast;
	
			// get the string
			str = axis.labelFormatter.call({
				axis: axis,
				chart: chart,
				isFirst: isFirst,
				isLast: isLast,
				dateTimeLabelFormat: dateTimeLabelFormat,
				value: axis.isLog ? correctFloat(lin2log(value)) : value
			});
	
			// prepare CSS
			css = width && { width: mathMax(1, mathRound(width - 2 * (labelOptions.padding || 10))) + PX };
			
			// first call
			if (!defined(label)) {
				attr = {
					align: axis.labelAlign
				};
				if (isNumber(rotation)) {
					attr.rotation = rotation;
				}
				if (width && labelOptions.ellipsis) {
					css.HcHeight = axis.len / tickPositions.length;
				}
	
				tick.label = label =
					defined(str) && labelOptions.enabled ?
						chart.renderer.text(
								str,
								0,
								0,
								labelOptions.useHTML
							)
							.attr(attr)
							// without position absolute, IE export sometimes is wrong
							.css(extend(css, labelOptions.style))
							.add(axis.labelGroup) :
						null;
	
				// Set the tick baseline and correct for rotation (#1764)
				axis.tickBaseline = chart.renderer.fontMetrics(labelOptions.style.fontSize, label).b;
				if (rotation && axis.side === 2) {
					axis.tickBaseline *= mathCos(rotation * deg2rad);
				}
	
	
			// update
			} else if (label) {
				label.attr({
						text: str
					})
					.css(css);
			}
			tick.yOffset = label ? pick(labelOptions.y, axis.tickBaseline + (axis.side === 2 ? 8 : -(label.getBBox().height / 2))) : 0;
		},
	
		/**
		 * Get the offset height or width of the label
		 */
		getLabelSize: function () {
			var label = this.label,
				axis = this.axis;
			return label ?
				label.getBBox()[axis.horiz ? 'height' : 'width'] :
				0;
		},
	
		/**
		 * Find how far the labels extend to the right and left of the tick's x position. Used for anti-collision
		 * detection with overflow logic.
		 */
		getLabelSides: function () {
			var bBox = this.label.getBBox(),
				axis = this.axis,
				horiz = axis.horiz,
				options = axis.options,
				labelOptions = options.labels,
				size = horiz ? bBox.width : bBox.height,
				leftSide = horiz ?
					labelOptions.x - size * { left: 0, center: 0.5, right: 1 }[axis.labelAlign] :
					0,
				rightSide = horiz ?
					size + leftSide :
					size;
	
			return [leftSide, rightSide];
		},
	
		/**
		 * Handle the label overflow by adjusting the labels to the left and right edge, or
		 * hide them if they collide into the neighbour label.
		 */
		handleOverflow: function (index, xy) {
			var show = true,
				axis = this.axis,
				isFirst = this.isFirst,
				isLast = this.isLast,
				horiz = axis.horiz,
				pxPos = horiz ? xy.x : xy.y,
				reversed = axis.reversed,
				tickPositions = axis.tickPositions,
				sides = this.getLabelSides(),
				leftSide = sides[0],
				rightSide = sides[1],
				axisLeft,
				axisRight,
				neighbour,
				neighbourEdge,
				line = this.label.line,
				lineIndex = line || 0,
				labelEdge = axis.labelEdge,
				justifyLabel = axis.justifyLabels && (isFirst || isLast),
				justifyToPlot;
	
			// Hide it if it now overlaps the neighbour label
			if (labelEdge[lineIndex] === UNDEFINED || pxPos + leftSide > labelEdge[lineIndex]) {
				labelEdge[lineIndex] = pxPos + rightSide;
	
			} else if (!justifyLabel) {
				show = false;
			}
	
			if (justifyLabel) {
				justifyToPlot = axis.justifyToPlot;
				axisLeft = justifyToPlot ? axis.pos : 0;
				axisRight = justifyToPlot ? axisLeft + axis.len : axis.chart.chartWidth;
	
				// Find the firsth neighbour on the same line
				do {
					index += (isFirst ? 1 : -1);
					neighbour = axis.ticks[tickPositions[index]];
				} while (tickPositions[index] && (!neighbour || !neighbour.label || neighbour.label.line !== line)); // #3044
	
				neighbourEdge = neighbour && neighbour.label.xy && neighbour.label.xy.x + neighbour.getLabelSides()[isFirst ? 0 : 1];
	
				if ((isFirst && !reversed) || (isLast && reversed)) {
					// Is the label spilling out to the left of the plot area?
					if (pxPos + leftSide < axisLeft) {
	
						// Align it to plot left
						pxPos = axisLeft - leftSide;
	
						// Hide it if it now overlaps the neighbour label
						if (neighbour && pxPos + rightSide > neighbourEdge) {
							show = false;
						}
					}
	
				} else {
					// Is the label spilling out to the right of the plot area?
					if (pxPos + rightSide > axisRight) {
	
						// Align it to plot right
						pxPos = axisRight - rightSide;
	
						// Hide it if it now overlaps the neighbour label
						if (neighbour && pxPos + leftSide < neighbourEdge) {
							show = false;
						}
	
					}
				}
	
				// Set the modified x position of the label
				xy.x = pxPos;
			}
			return show;
		},
	
		/**
		 * Get the x and y position for ticks and labels
		 */
		getPosition: function (horiz, pos, tickmarkOffset, old) {
			var axis = this.axis,
				chart = axis.chart,
				cHeight = (old && chart.oldChartHeight) || chart.chartHeight;
	
			return {
				x: horiz ?
					axis.translate(pos + tickmarkOffset, null, null, old) + axis.transB :
					axis.left + axis.offset + (axis.opposite ? ((old && chart.oldChartWidth) || chart.chartWidth) - axis.right - axis.left : 0),
	
				y: horiz ?
					cHeight - axis.bottom + axis.offset - (axis.opposite ? axis.height : 0) :
					cHeight - axis.translate(pos + tickmarkOffset, null, null, old) - axis.transB
			};
	
		},
	
		/**
		 * Get the x, y position of the tick label
		 */
		getLabelPosition: function (x, y, label, horiz, labelOptions, tickmarkOffset, index, step) {
			var axis = this.axis,
				transA = axis.transA,
				reversed = axis.reversed,
				staggerLines = axis.staggerLines;
	
			x = x + labelOptions.x - (tickmarkOffset && horiz ?
				tickmarkOffset * transA * (reversed ? -1 : 1) : 0);
			y = y + this.yOffset - (tickmarkOffset && !horiz ?
				tickmarkOffset * transA * (reversed ? 1 : -1) : 0);
	
			// Correct for staggered labels
			if (staggerLines) {
				label.line = (index / (step || 1) % staggerLines);
				y += label.line * (axis.labelOffset / staggerLines);
			}
	
			return {
				x: x,
				y: y
			};
		},
	
		/**
		 * Extendible method to return the path of the marker
		 */
		getMarkPath: function (x, y, tickLength, tickWidth, horiz, renderer) {
			return renderer.crispLine([
					M,
					x,
					y,
					L,
					x + (horiz ? 0 : -tickLength),
					y + (horiz ? tickLength : 0)
				], tickWidth);
		},
	
		/**
		 * Put everything in place
		 *
		 * @param index {Number}
		 * @param old {Boolean} Use old coordinates to prepare an animation into new position
		 */
		render: function (index, old, opacity) {
			var tick = this,
				axis = tick.axis,
				options = axis.options,
				chart = axis.chart,
				renderer = chart.renderer,
				horiz = axis.horiz,
				type = tick.type,
				label = tick.label,
				pos = tick.pos,
				labelOptions = options.labels,
				gridLine = tick.gridLine,
				gridPrefix = type ? type + 'Grid' : 'grid',
				tickPrefix = type ? type + 'Tick' : 'tick',
				gridLineWidth = options[gridPrefix + 'LineWidth'],
				gridLineColor = options[gridPrefix + 'LineColor'],
				dashStyle = options[gridPrefix + 'LineDashStyle'],
				tickLength = options[tickPrefix + 'Length'],
				tickWidth = options[tickPrefix + 'Width'] || 0,
				tickColor = options[tickPrefix + 'Color'],
				tickPosition = options[tickPrefix + 'Position'],
				gridLinePath,
				mark = tick.mark,
				markPath,
				step = labelOptions.step,
				attribs,
				show = true,
				tickmarkOffset = axis.tickmarkOffset,
				xy = tick.getPosition(horiz, pos, tickmarkOffset, old),
				x = xy.x,
				y = xy.y,
				reverseCrisp = ((horiz && x === axis.pos + axis.len) || (!horiz && y === axis.pos)) ? -1 : 1; // #1480, #1687
	
			opacity = pick(opacity, 1);
			this.isActive = true;
	
			// create the grid line
			if (gridLineWidth) {
				gridLinePath = axis.getPlotLinePath(pos + tickmarkOffset, gridLineWidth * reverseCrisp, old, true);
	
				if (gridLine === UNDEFINED) {
					attribs = {
						stroke: gridLineColor,
						'stroke-width': gridLineWidth
					};
					if (dashStyle) {
						attribs.dashstyle = dashStyle;
					}
					if (!type) {
						attribs.zIndex = 1;
					}
					if (old) {
						attribs.opacity = 0;
					}
					tick.gridLine = gridLine =
						gridLineWidth ?
							renderer.path(gridLinePath)
								.attr(attribs).add(axis.gridGroup) :
							null;
				}
	
				// If the parameter 'old' is set, the current call will be followed
				// by another call, therefore do not do any animations this time
				if (!old && gridLine && gridLinePath) {
					gridLine[tick.isNew ? 'attr' : 'animate']({
						d: gridLinePath,
						opacity: opacity
					});
				}
			}
	
			// create the tick mark
			if (tickWidth && tickLength) {
	
				// negate the length
				if (tickPosition === 'inside') {
					tickLength = -tickLength;
				}
				if (axis.opposite) {
					tickLength = -tickLength;
				}
	
				markPath = tick.getMarkPath(x, y, tickLength, tickWidth * reverseCrisp, horiz, renderer);
				if (mark) { // updating
					mark.animate({
						d: markPath,
						opacity: opacity
					});
				} else { // first time
					tick.mark = renderer.path(
						markPath
					).attr({
						stroke: tickColor,
						'stroke-width': tickWidth,
						opacity: opacity
					}).add(axis.axisGroup);
				}
			}
	
			// the label is created on init - now move it into place
			if (label && !isNaN(x)) {
				label.xy = xy = tick.getLabelPosition(x, y, label, horiz, labelOptions, tickmarkOffset, index, step);
	
				// Apply show first and show last. If the tick is both first and last, it is
				// a single centered tick, in which case we show the label anyway (#2100).
				if ((tick.isFirst && !tick.isLast && !pick(options.showFirstLabel, 1)) ||
						(tick.isLast && !tick.isFirst && !pick(options.showLastLabel, 1))) {
					show = false;
	
				// Handle label overflow and show or hide accordingly
				} else if (!axis.isRadial && !labelOptions.step && !labelOptions.rotation && !old && opacity !== 0) {
					show = tick.handleOverflow(index, xy);
				}
	
				// apply step
				if (step && index % step) {
					// show those indices dividable by step
					show = false;
				}
	
				// Set the new position, and show or hide
				if (show && !isNaN(xy.y)) {
					xy.opacity = opacity;
					label[tick.isNew ? 'attr' : 'animate'](xy);
					tick.isNew = false;
				} else {
					label.attr('y', -9999); // #1338
				}
			}
		},
	
		/**
		 * Destructor for the tick prototype
		 */
		destroy: function () {
			destroyObjectProperties(this, this.axis);
		}
	};
	
	/**
	 * The object wrapper for plot lines and plot bands
	 * @param {Object} options
	 */
	Highcharts.PlotLineOrBand = function (axis, options) {
		this.axis = axis;
	
		if (options) {
			this.options = options;
			this.id = options.id;
		}
	};
	
	Highcharts.PlotLineOrBand.prototype = {
		
		/**
		 * Render the plot line or plot band. If it is already existing,
		 * move it.
		 */
		render: function () {
			var plotLine = this,
				axis = plotLine.axis,
				horiz = axis.horiz,
				halfPointRange = (axis.pointRange || 0) / 2,
				options = plotLine.options,
				optionsLabel = options.label,
				label = plotLine.label,
				width = options.width,
				to = options.to,
				from = options.from,
				isBand = defined(from) && defined(to),
				value = options.value,
				dashStyle = options.dashStyle,
				svgElem = plotLine.svgElem,
				path = [],
				addEvent,
				eventType,
				xs,
				ys,
				x,
				y,
				color = options.color,
				zIndex = options.zIndex,
				events = options.events,
				attribs = {},
				renderer = axis.chart.renderer;
	
			// logarithmic conversion
			if (axis.isLog) {
				from = log2lin(from);
				to = log2lin(to);
				value = log2lin(value);
			}
	
			// plot line
			if (width) {
				path = axis.getPlotLinePath(value, width);
				attribs = {
					stroke: color,
					'stroke-width': width
				};
				if (dashStyle) {
					attribs.dashstyle = dashStyle;
				}
			} else if (isBand) { // plot band
				
				// keep within plot area
				from = mathMax(from, axis.min - halfPointRange);
				to = mathMin(to, axis.max + halfPointRange);
				
				path = axis.getPlotBandPath(from, to, options);
				if (color) {
					attribs.fill = color;
				}
				if (options.borderWidth) {
					attribs.stroke = options.borderColor;
					attribs['stroke-width'] = options.borderWidth;
				}
			} else {
				return;
			}
			// zIndex
			if (defined(zIndex)) {
				attribs.zIndex = zIndex;
			}
	
			// common for lines and bands
			if (svgElem) {
				if (path) {
					svgElem.animate({
						d: path
					}, null, svgElem.onGetPath);
				} else {
					svgElem.hide();
					svgElem.onGetPath = function () {
						svgElem.show();
					};
					if (label) {
						plotLine.label = label = label.destroy();
					}
				}
			} else if (path && path.length) {
				plotLine.svgElem = svgElem = renderer.path(path)
					.attr(attribs).add();
	
				// events
				if (events) {
					addEvent = function (eventType) {
						svgElem.on(eventType, function (e) {
							events[eventType].apply(plotLine, [e]);
						});
					};
					for (eventType in events) {
						addEvent(eventType);
					}
				}
			}
	
			// the plot band/line label
			if (optionsLabel && defined(optionsLabel.text) && path && path.length && axis.width > 0 && axis.height > 0) {
				// apply defaults
				optionsLabel = merge({
					align: horiz && isBand && 'center',
					x: horiz ? !isBand && 4 : 10,
					verticalAlign : !horiz && isBand && 'middle',
					y: horiz ? isBand ? 16 : 10 : isBand ? 6 : -4,
					rotation: horiz && !isBand && 90
				}, optionsLabel);
	
				// add the SVG element
				if (!label) {
					attribs = {
						align: optionsLabel.textAlign || optionsLabel.align,
						rotation: optionsLabel.rotation
					};
					if (defined(zIndex)) {
						attribs.zIndex = zIndex;
					}
					plotLine.label = label = renderer.text(
							optionsLabel.text,
							0,
							0,
							optionsLabel.useHTML
						)
						.attr(attribs)
						.css(optionsLabel.style)
						.add();
				}
	
				// get the bounding box and align the label
				// #3000 changed to better handle choice between plotband or plotline
				xs = [path[1], path[4], (isBand ? path[6] : path[1])];
				ys = [path[2], path[5], (isBand ? path[7] : path[2])];
				x = arrayMin(xs);
				y = arrayMin(ys);
	
				label.align(optionsLabel, false, {
					x: x,
					y: y,
					width: arrayMax(xs) - x,
					height: arrayMax(ys) - y
				});
				label.show();
	
			} else if (label) { // move out of sight
				label.hide();
			}
	
			// chainable
			return plotLine;
		},
	
		/**
		 * Remove the plot line or band
		 */
		destroy: function () {
			// remove it from the lookup
			erase(this.axis.plotLinesAndBands, this);
			
			delete this.axis;
			destroyObjectProperties(this);
		}
	};
	
	/**
	 * Object with members for extending the Axis prototype
	 */
	
	AxisPlotLineOrBandExtension = {
	
		/**
		 * Create the path for a plot band
		 */ 
		getPlotBandPath: function (from, to) {
			var toPath = this.getPlotLinePath(to),
				path = this.getPlotLinePath(from);
	
			if (path && toPath) {
				path.push(
					toPath[4],
					toPath[5],
					toPath[1],
					toPath[2]
				);
			} else { // outside the axis area
				path = null;
			}
			
			return path;
		},
	
		addPlotBand: function (options) {
			return this.addPlotBandOrLine(options, 'plotBands');
		},
		
		addPlotLine: function (options) {
			return this.addPlotBandOrLine(options, 'plotLines');
		},
	
		/**
		 * Add a plot band or plot line after render time
		 *
		 * @param options {Object} The plotBand or plotLine configuration object
		 */
		addPlotBandOrLine: function (options, coll) {
			var obj = new Highcharts.PlotLineOrBand(this, options).render(),
				userOptions = this.userOptions;
	
			if (obj) { // #2189
				// Add it to the user options for exporting and Axis.update
				if (coll) {
					userOptions[coll] = userOptions[coll] || [];
					userOptions[coll].push(options); 
				}
				this.plotLinesAndBands.push(obj); 
			}
			
			return obj;
		},
	
		/**
		 * Remove a plot band or plot line from the chart by id
		 * @param {Object} id
		 */
		removePlotBandOrLine: function (id) {
			var plotLinesAndBands = this.plotLinesAndBands,
				options = this.options,
				userOptions = this.userOptions,
				i = plotLinesAndBands.length;
			while (i--) {
				if (plotLinesAndBands[i].id === id) {
					plotLinesAndBands[i].destroy();
				}
			}
			each([options.plotLines || [], userOptions.plotLines || [], options.plotBands || [], userOptions.plotBands || []], function (arr) {
				i = arr.length;
				while (i--) {
					if (arr[i].id === id) {
						erase(arr, arr[i]);
					}
				}
			});
		}
	};
	
	/**
	 * Create a new axis object
	 * @param {Object} chart
	 * @param {Object} options
	 */
	function Axis() {
		this.init.apply(this, arguments);
	}
	
	Axis.prototype = {
	
		/**
		 * Default options for the X axis - the Y axis has extended defaults
		 */
		defaultOptions: {
			// allowDecimals: null,
			// alternateGridColor: null,
			// categories: [],
			dateTimeLabelFormats: {
				millisecond: '%H:%M:%S.%L',
				second: '%H:%M:%S',
				minute: '%H:%M',
				hour: '%H:%M',
				day: '%e. %b',
				week: '%e. %b',
				month: '%b \'%y',
				year: '%Y'
			},
			endOnTick: false,
			gridLineColor: '#C0C0C0',
			// gridLineDashStyle: 'solid',
			// gridLineWidth: 0,
			// reversed: false,
	
			labels: defaultLabelOptions,
				// { step: null },
			lineColor: '#C0D0E0',
			lineWidth: 1,
			//linkedTo: null,
			//max: undefined,
			//min: undefined,
			minPadding: 0.01,
			maxPadding: 0.01,
			//minRange: null,
			minorGridLineColor: '#E0E0E0',
			// minorGridLineDashStyle: null,
			minorGridLineWidth: 1,
			minorTickColor: '#A0A0A0',
			//minorTickInterval: null,
			minorTickLength: 2,
			minorTickPosition: 'outside', // inside or outside
			//minorTickWidth: 0,
			//opposite: false,
			//offset: 0,
			//plotBands: [{
			//	events: {},
			//	zIndex: 1,
			//	labels: { align, x, verticalAlign, y, style, rotation, textAlign }
			//}],
			//plotLines: [{
			//	events: {}
			//  dashStyle: {}
			//	zIndex:
			//	labels: { align, x, verticalAlign, y, style, rotation, textAlign }
			//}],
			//reversed: false,
			// showFirstLabel: true,
			// showLastLabel: true,
			startOfWeek: 1,
			startOnTick: false,
			tickColor: '#C0D0E0',
			//tickInterval: null,
			tickLength: 10,
			tickmarkPlacement: 'between', // on or between
			tickPixelInterval: 100,
			tickPosition: 'outside',
			tickWidth: 1,
			title: {
				//text: null,
				align: 'middle', // low, middle or high
				//margin: 0 for horizontal, 10 for vertical axes,
				//rotation: 0,
				//side: 'outside',
				style: {
					color: '#707070'
				}
				//x: 0,
				//y: 0
			},
			type: 'linear' // linear, logarithmic or datetime
		},
	
		/**
		 * This options set extends the defaultOptions for Y axes
		 */
		defaultYAxisOptions: {
			endOnTick: true,
			gridLineWidth: 1,
			tickPixelInterval: 72,
			showLastLabel: true,
			labels: {
				x: -8,
				y: 3
			},
			lineWidth: 0,
			maxPadding: 0.05,
			minPadding: 0.05,
			startOnTick: true,
			tickWidth: 0,
			title: {
				rotation: 270,
				text: 'Values'
			},
			stackLabels: {
				enabled: false,
				//align: dynamic,
				//y: dynamic,
				//x: dynamic,
				//verticalAlign: dynamic,
				//textAlign: dynamic,
				//rotation: 0,
				formatter: function () {
					return numberFormat(this.total, -1);
				},
				style: defaultLabelOptions.style
			}
		},
	
		/**
		 * These options extend the defaultOptions for left axes
		 */
		defaultLeftAxisOptions: {
			labels: {
				x: -15,
				y: null
			},
			title: {
				rotation: 270
			}
		},
	
		/**
		 * These options extend the defaultOptions for right axes
		 */
		defaultRightAxisOptions: {
			labels: {
				x: 15,
				y: null
			},
			title: {
				rotation: 90
			}
		},
	
		/**
		 * These options extend the defaultOptions for bottom axes
		 */
		defaultBottomAxisOptions: {
			labels: {
				x: 0,
				y: null // based on font size
				// overflow: undefined,
				// staggerLines: null
			},
			title: {
				rotation: 0
			}
		},
		/**
		 * These options extend the defaultOptions for left axes
		 */
		defaultTopAxisOptions: {
			labels: {
				x: 0,
				y: -15
				// overflow: undefined
				// staggerLines: null
			},
			title: {
				rotation: 0
			}
		},
	
		/**
		 * Initialize the axis
		 */
		init: function (chart, userOptions) {
	
	
			var isXAxis = userOptions.isX,
				axis = this;
	
			// Flag, is the axis horizontal
			axis.horiz = chart.inverted ? !isXAxis : isXAxis;
	
			// Flag, isXAxis
			axis.isXAxis = isXAxis;
			axis.coll = isXAxis ? 'xAxis' : 'yAxis';
	
			axis.opposite = userOptions.opposite; // needed in setOptions
			axis.side = userOptions.side || (axis.horiz ?
					(axis.opposite ? 0 : 2) : // top : bottom
					(axis.opposite ? 1 : 3));  // right : left
	
			axis.setOptions(userOptions);
	
	
			var options = this.options,
				type = options.type,
				isDatetimeAxis = type === 'datetime';
	
			axis.labelFormatter = options.labels.formatter || axis.defaultLabelFormatter; // can be overwritten by dynamic format
	
	
			// Flag, stagger lines or not
			axis.userOptions = userOptions;
	
			//axis.axisTitleMargin = UNDEFINED,// = options.title.margin,
			axis.minPixelPadding = 0;
			//axis.ignoreMinPadding = UNDEFINED; // can be set to true by a column or bar series
			//axis.ignoreMaxPadding = UNDEFINED;
	
			axis.chart = chart;
			axis.reversed = options.reversed;
			axis.zoomEnabled = options.zoomEnabled !== false;
	
			// Initial categories
			axis.categories = options.categories || type === 'category';
			axis.names = [];
	
			// Elements
			//axis.axisGroup = UNDEFINED;
			//axis.gridGroup = UNDEFINED;
			//axis.axisTitle = UNDEFINED;
			//axis.axisLine = UNDEFINED;
	
			// Shorthand types
			axis.isLog = type === 'logarithmic';
			axis.isDatetimeAxis = isDatetimeAxis;
	
			// Flag, if axis is linked to another axis
			axis.isLinked = defined(options.linkedTo);
			// Linked axis.
			//axis.linkedParent = UNDEFINED;
	
			// Tick positions
			//axis.tickPositions = UNDEFINED; // array containing predefined positions
			// Tick intervals
			//axis.tickInterval = UNDEFINED;
			//axis.minorTickInterval = UNDEFINED;
	
			axis.tickmarkOffset = (axis.categories && options.tickmarkPlacement === 'between' && 
				pick(options.tickInterval, 1) === 1) ? 0.5 : 0; // #3202
	
			// Major ticks
			axis.ticks = {};
			axis.labelEdge = [];
			// Minor ticks
			axis.minorTicks = {};
			//axis.tickAmount = UNDEFINED;
	
			// List of plotLines/Bands
			axis.plotLinesAndBands = [];
	
			// Alternate bands
			axis.alternateBands = {};
	
			// Axis metrics
			//axis.left = UNDEFINED;
			//axis.top = UNDEFINED;
			//axis.width = UNDEFINED;
			//axis.height = UNDEFINED;
			//axis.bottom = UNDEFINED;
			//axis.right = UNDEFINED;
			//axis.transA = UNDEFINED;
			//axis.transB = UNDEFINED;
			//axis.oldTransA = UNDEFINED;
			axis.len = 0;
			//axis.oldMin = UNDEFINED;
			//axis.oldMax = UNDEFINED;
			//axis.oldUserMin = UNDEFINED;
			//axis.oldUserMax = UNDEFINED;
			//axis.oldAxisLength = UNDEFINED;
			axis.minRange = axis.userMinRange = options.minRange || options.maxZoom;
			axis.range = options.range;
			axis.offset = options.offset || 0;
	
	
			// Dictionary for stacks
			axis.stacks = {};
			axis.oldStacks = {};
			
			// Min and max in the data
			//axis.dataMin = UNDEFINED,
			//axis.dataMax = UNDEFINED,
	
			// The axis range
			axis.max = null;
			axis.min = null;
	
			// User set min and max
			//axis.userMin = UNDEFINED,
			//axis.userMax = UNDEFINED,
	
			// Crosshair options
			axis.crosshair = pick(options.crosshair, splat(chart.options.tooltip.crosshairs)[isXAxis ? 0 : 1], false);
			// Run Axis
	
			var eventType,
				events = axis.options.events;
	
			// Register
			if (inArray(axis, chart.axes) === -1) { // don't add it again on Axis.update()
				if (isXAxis && !this.isColorAxis) { // #2713
					chart.axes.splice(chart.xAxis.length, 0, axis);
				} else {
					chart.axes.push(axis);
				}
	
				chart[axis.coll].push(axis);
			}
	
			axis.series = axis.series || []; // populated by Series
	
			// inverted charts have reversed xAxes as default
			if (chart.inverted && isXAxis && axis.reversed === UNDEFINED) {
				axis.reversed = true;
			}
	
			axis.removePlotBand = axis.removePlotBandOrLine;
			axis.removePlotLine = axis.removePlotBandOrLine;
	
	
			// register event listeners
			for (eventType in events) {
				addEvent(axis, eventType, events[eventType]);
			}
	
			// extend logarithmic axis
			if (axis.isLog) {
				axis.val2lin = log2lin;
				axis.lin2val = lin2log;
			}
		},
	
		/**
		 * Merge and set options
		 */
		setOptions: function (userOptions) {
			this.options = merge(
				this.defaultOptions,
				this.isXAxis ? {} : this.defaultYAxisOptions,
				[this.defaultTopAxisOptions, this.defaultRightAxisOptions,
					this.defaultBottomAxisOptions, this.defaultLeftAxisOptions][this.side],
				merge(
					defaultOptions[this.coll], // if set in setOptions (#1053)
					userOptions
				)
			);
		},
	
		/**
		 * The default label formatter. The context is a special config object for the label.
		 */
		defaultLabelFormatter: function () {
			var axis = this.axis,
				value = this.value,
				categories = axis.categories,
				dateTimeLabelFormat = this.dateTimeLabelFormat,
				numericSymbols = defaultOptions.lang.numericSymbols,
				i = numericSymbols && numericSymbols.length,
				multi,
				ret,
				formatOption = axis.options.labels.format,
	
				// make sure the same symbol is added for all labels on a linear axis
				numericSymbolDetector = axis.isLog ? value : axis.tickInterval;
	
			if (formatOption) {
				ret = format(formatOption, this);
	
			} else if (categories) {
				ret = value;
	
			} else if (dateTimeLabelFormat) { // datetime axis
				ret = dateFormat(dateTimeLabelFormat, value);
	
			} else if (i && numericSymbolDetector >= 1000) {
				// Decide whether we should add a numeric symbol like k (thousands) or M (millions).
				// If we are to enable this in tooltip or other places as well, we can move this
				// logic to the numberFormatter and enable it by a parameter.
				while (i-- && ret === UNDEFINED) {
					multi = Math.pow(1000, i + 1);
					if (numericSymbolDetector >= multi && numericSymbols[i] !== null) {
						ret = numberFormat(value / multi, -1) + numericSymbols[i];
					}
				}
			}
	
			if (ret === UNDEFINED) {
				if (mathAbs(value) >= 10000) { // add thousands separators
					ret = numberFormat(value, 0);
	
				} else { // small numbers
					ret = numberFormat(value, -1, UNDEFINED, ''); // #2466
				}
			}
	
			return ret;
		},
	
		/**
		 * Get the minimum and maximum for the series of each axis
		 */
		getSeriesExtremes: function () {
			var axis = this,
				chart = axis.chart;
	
			axis.hasVisibleSeries = false;
	
			// Reset properties in case we're redrawing (#3353)
			axis.dataMin = axis.dataMax = axis.ignoreMinPadding = axis.ignoreMaxPadding = null;
			
			if (axis.buildStacks) {
				axis.buildStacks();
			}
	
			// loop through this axis' series
			each(axis.series, function (series) {
	
				if (series.visible || !chart.options.chart.ignoreHiddenSeries) {
	
					var seriesOptions = series.options,
						xData,
						threshold = seriesOptions.threshold,
						seriesDataMin,
						seriesDataMax;
	
					axis.hasVisibleSeries = true;
	
					// Validate threshold in logarithmic axes
					if (axis.isLog && threshold <= 0) {
						threshold = null;
					}
	
					// Get dataMin and dataMax for X axes
					if (axis.isXAxis) {
						xData = series.xData;
						if (xData.length) {
							axis.dataMin = mathMin(pick(axis.dataMin, xData[0]), arrayMin(xData));
							axis.dataMax = mathMax(pick(axis.dataMax, xData[0]), arrayMax(xData));
						}
	
					// Get dataMin and dataMax for Y axes, as well as handle stacking and processed data
					} else {
	
						// Get this particular series extremes
						series.getExtremes();
						seriesDataMax = series.dataMax;
						seriesDataMin = series.dataMin;
	
						// Get the dataMin and dataMax so far. If percentage is used, the min and max are
						// always 0 and 100. If seriesDataMin and seriesDataMax is null, then series
						// doesn't have active y data, we continue with nulls
						if (defined(seriesDataMin) && defined(seriesDataMax)) {
							axis.dataMin = mathMin(pick(axis.dataMin, seriesDataMin), seriesDataMin);
							axis.dataMax = mathMax(pick(axis.dataMax, seriesDataMax), seriesDataMax);
						}
	
						// Adjust to threshold
						if (defined(threshold)) {
							if (axis.dataMin >= threshold) {
								axis.dataMin = threshold;
								axis.ignoreMinPadding = true;
							} else if (axis.dataMax < threshold) {
								axis.dataMax = threshold;
								axis.ignoreMaxPadding = true;
							}
						}
					}
				}
			});
		},
	
		/**
		 * Translate from axis value to pixel position on the chart, or back
		 *
		 */
		translate: function (val, backwards, cvsCoord, old, handleLog, pointPlacement) {
			var axis = this,
				sign = 1,
				cvsOffset = 0,
				localA = old ? axis.oldTransA : axis.transA,
				localMin = old ? axis.oldMin : axis.min,
				returnValue,
				minPixelPadding = axis.minPixelPadding,
				postTranslate = (axis.options.ordinal || (axis.isLog && handleLog)) && axis.lin2val;
	
			if (!localA) {
				localA = axis.transA;
			}
	
			// In vertical axes, the canvas coordinates start from 0 at the top like in
			// SVG.
			if (cvsCoord) {
				sign *= -1; // canvas coordinates inverts the value
				cvsOffset = axis.len;
			}
	
			// Handle reversed axis
			if (axis.reversed) {
				sign *= -1;
				cvsOffset -= sign * (axis.sector || axis.len);
			}
	
			// From pixels to value
			if (backwards) { // reverse translation
	
				val = val * sign + cvsOffset;
				val -= minPixelPadding;
				returnValue = val / localA + localMin; // from chart pixel to value
				if (postTranslate) { // log and ordinal axes
					returnValue = axis.lin2val(returnValue);
				}
	
			// From value to pixels
			} else {
				if (postTranslate) { // log and ordinal axes
					val = axis.val2lin(val);
				}
				if (pointPlacement === 'between') {
					pointPlacement = 0.5;
				}
				returnValue = sign * (val - localMin) * localA + cvsOffset + (sign * minPixelPadding) +
					(isNumber(pointPlacement) ? localA * pointPlacement * axis.pointRange : 0);
			}
	
			return returnValue;
		},
	
		/**
		 * Utility method to translate an axis value to pixel position.
		 * @param {Number} value A value in terms of axis units
		 * @param {Boolean} paneCoordinates Whether to return the pixel coordinate relative to the chart
		 *        or just the axis/pane itself.
		 */
		toPixels: function (value, paneCoordinates) {
			return this.translate(value, false, !this.horiz, null, true) + (paneCoordinates ? 0 : this.pos);
		},
	
		/*
		 * Utility method to translate a pixel position in to an axis value
		 * @param {Number} pixel The pixel value coordinate
		 * @param {Boolean} paneCoordiantes Whether the input pixel is relative to the chart or just the
		 *        axis/pane itself.
		 */
		toValue: function (pixel, paneCoordinates) {
			return this.translate(pixel - (paneCoordinates ? 0 : this.pos), true, !this.horiz, null, true);
		},
	
		/**
		 * Create the path for a plot line that goes from the given value on
		 * this axis, across the plot to the opposite side
		 * @param {Number} value
		 * @param {Number} lineWidth Used for calculation crisp line
		 * @param {Number] old Use old coordinates (for resizing and rescaling)
		 */
		getPlotLinePath: function (value, lineWidth, old, force, translatedValue) {
			var axis = this,
				chart = axis.chart,
				axisLeft = axis.left,
				axisTop = axis.top,
				x1,
				y1,
				x2,
				y2,
				cHeight = (old && chart.oldChartHeight) || chart.chartHeight,
				cWidth = (old && chart.oldChartWidth) || chart.chartWidth,
				skip,
				transB = axis.transB;
	
			translatedValue = pick(translatedValue, axis.translate(value, null, null, old));
			x1 = x2 = mathRound(translatedValue + transB);
			y1 = y2 = mathRound(cHeight - translatedValue - transB);
	
			if (isNaN(translatedValue)) { // no min or max
				skip = true;
	
			} else if (axis.horiz) {
				y1 = axisTop;
				y2 = cHeight - axis.bottom;
				if (x1 < axisLeft || x1 > axisLeft + axis.width) {
					skip = true;
				}
			} else {
				x1 = axisLeft;
				x2 = cWidth - axis.right;
	
				if (y1 < axisTop || y1 > axisTop + axis.height) {
					skip = true;
				}
			}
			return skip && !force ?
				null :
				chart.renderer.crispLine([M, x1, y1, L, x2, y2], lineWidth || 1);
		},
	
		/**
		 * Set the tick positions of a linear axis to round values like whole tens or every five.
		 */
		getLinearTickPositions: function (tickInterval, min, max) {
			var pos,
				lastPos,
				roundedMin = correctFloat(mathFloor(min / tickInterval) * tickInterval),
				roundedMax = correctFloat(mathCeil(max / tickInterval) * tickInterval),
				tickPositions = [];
	
			// For single points, add a tick regardless of the relative position (#2662)
			if (min === max && isNumber(min)) {
				return [min];
			}
	
			// Populate the intermediate values
			pos = roundedMin;
			while (pos <= roundedMax) {
	
				// Place the tick on the rounded value
				tickPositions.push(pos);
	
				// Always add the raw tickInterval, not the corrected one.
				pos = correctFloat(pos + tickInterval);
	
				// If the interval is not big enough in the current min - max range to actually increase
				// the loop variable, we need to break out to prevent endless loop. Issue #619
				if (pos === lastPos) {
					break;
				}
	
				// Record the last value
				lastPos = pos;
			}
			return tickPositions;
		},
	
		/**
		 * Return the minor tick positions. For logarithmic axes, reuse the same logic
		 * as for major ticks.
		 */
		getMinorTickPositions: function () {
			var axis = this,
				options = axis.options,
				tickPositions = axis.tickPositions,
				minorTickInterval = axis.minorTickInterval,
				minorTickPositions = [],
				pos,
				i,
				len;
	
			if (axis.isLog) {
				len = tickPositions.length;
				for (i = 1; i < len; i++) {
					minorTickPositions = minorTickPositions.concat(
						axis.getLogTickPositions(minorTickInterval, tickPositions[i - 1], tickPositions[i], true)
					);
				}
			} else if (axis.isDatetimeAxis && options.minorTickInterval === 'auto') { // #1314
				minorTickPositions = minorTickPositions.concat(
					axis.getTimeTicks(
						axis.normalizeTimeTickInterval(minorTickInterval),
						axis.min,
						axis.max,
						options.startOfWeek
					)
				);
				if (minorTickPositions[0] < axis.min) {
					minorTickPositions.shift();
				}
			} else {
				for (pos = axis.min + (tickPositions[0] - axis.min) % minorTickInterval; pos <= axis.max; pos += minorTickInterval) {
					minorTickPositions.push(pos);
				}
			}
			return minorTickPositions;
		},
	
		/**
		 * Adjust the min and max for the minimum range. Keep in mind that the series data is
		 * not yet processed, so we don't have information on data cropping and grouping, or
		 * updated axis.pointRange or series.pointRange. The data can't be processed until
		 * we have finally established min and max.
		 */
		adjustForMinRange: function () {
			var axis = this,
				options = axis.options,
				min = axis.min,
				max = axis.max,
				zoomOffset,
				spaceAvailable = axis.dataMax - axis.dataMin >= axis.minRange,
				closestDataRange,
				i,
				distance,
				xData,
				loopLength,
				minArgs,
				maxArgs;
	
			// Set the automatic minimum range based on the closest point distance
			if (axis.isXAxis && axis.minRange === UNDEFINED && !axis.isLog) {
	
				if (defined(options.min) || defined(options.max)) {
					axis.minRange = null; // don't do this again
	
				} else {
	
					// Find the closest distance between raw data points, as opposed to
					// closestPointRange that applies to processed points (cropped and grouped)
					each(axis.series, function (series) {
						xData = series.xData;
						loopLength = series.xIncrement ? 1 : xData.length - 1;
						for (i = loopLength; i > 0; i--) {
							distance = xData[i] - xData[i - 1];
							if (closestDataRange === UNDEFINED || distance < closestDataRange) {
								closestDataRange = distance;
							}
						}
					});
					axis.minRange = mathMin(closestDataRange * 5, axis.dataMax - axis.dataMin);
				}
			}
	
			// if minRange is exceeded, adjust
			if (max - min < axis.minRange) {
				var minRange = axis.minRange;
				zoomOffset = (minRange - max + min) / 2;
	
				// if min and max options have been set, don't go beyond it
				minArgs = [min - zoomOffset, pick(options.min, min - zoomOffset)];
				if (spaceAvailable) { // if space is available, stay within the data range
					minArgs[2] = axis.dataMin;
				}
				min = arrayMax(minArgs);
	
				maxArgs = [min + minRange, pick(options.max, min + minRange)];
				if (spaceAvailable) { // if space is availabe, stay within the data range
					maxArgs[2] = axis.dataMax;
				}
	
				max = arrayMin(maxArgs);
	
				// now if the max is adjusted, adjust the min back
				if (max - min < minRange) {
					minArgs[0] = max - minRange;
					minArgs[1] = pick(options.min, max - minRange);
					min = arrayMax(minArgs);
				}
			}
	
			// Record modified extremes
			axis.min = min;
			axis.max = max;
		},
	
		/**
		 * Update translation information
		 */
		setAxisTranslation: function (saveOld) {
			var axis = this,
				range = axis.max - axis.min,
				pointRange = axis.axisPointRange || 0,
				closestPointRange,
				minPointOffset = 0,
				pointRangePadding = 0,
				linkedParent = axis.linkedParent,
				ordinalCorrection,
				hasCategories = !!axis.categories,
				transA = axis.transA;
	
			// Adjust translation for padding. Y axis with categories need to go through the same (#1784).
			if (axis.isXAxis || hasCategories || pointRange) {
				if (linkedParent) {
					minPointOffset = linkedParent.minPointOffset;
					pointRangePadding = linkedParent.pointRangePadding;
	
				} else {
					each(axis.series, function (series) {
						var seriesPointRange = hasCategories ? 1 : (axis.isXAxis ? series.pointRange : (axis.axisPointRange || 0)), // #2806
							pointPlacement = series.options.pointPlacement,
							seriesClosestPointRange = series.closestPointRange;
	
						if (seriesPointRange > range) { // #1446
							seriesPointRange = 0;
						}
						pointRange = mathMax(pointRange, seriesPointRange);
	
						// minPointOffset is the value padding to the left of the axis in order to make
						// room for points with a pointRange, typically columns. When the pointPlacement option
						// is 'between' or 'on', this padding does not apply.
						minPointOffset = mathMax(
							minPointOffset,
							isString(pointPlacement) ? 0 : seriesPointRange / 2
						);
	
						// Determine the total padding needed to the length of the axis to make room for the
						// pointRange. If the series' pointPlacement is 'on', no padding is added.
						pointRangePadding = mathMax(
							pointRangePadding,
							pointPlacement === 'on' ? 0 : seriesPointRange
						);
	
						// Set the closestPointRange
						if (!series.noSharedTooltip && defined(seriesClosestPointRange)) {
							closestPointRange = defined(closestPointRange) ?
								mathMin(closestPointRange, seriesClosestPointRange) :
								seriesClosestPointRange;
						}
					});
				}
	
				// Record minPointOffset and pointRangePadding
				ordinalCorrection = axis.ordinalSlope && closestPointRange ? axis.ordinalSlope / closestPointRange : 1; // #988, #1853
				axis.minPointOffset = minPointOffset = minPointOffset * ordinalCorrection;
				axis.pointRangePadding = pointRangePadding = pointRangePadding * ordinalCorrection;
	
				// pointRange means the width reserved for each point, like in a column chart
				axis.pointRange = mathMin(pointRange, range);
	
				// closestPointRange means the closest distance between points. In columns
				// it is mostly equal to pointRange, but in lines pointRange is 0 while closestPointRange
				// is some other value
				axis.closestPointRange = closestPointRange;
			}
	
			// Secondary values
			if (saveOld) {
				axis.oldTransA = transA;
			}
			axis.translationSlope = axis.transA = transA = axis.len / ((range + pointRangePadding) || 1);
			axis.transB = axis.horiz ? axis.left : axis.bottom; // translation addend
			axis.minPixelPadding = transA * minPointOffset;
		},
	
		/**
		 * Set the tick positions to round values and optionally extend the extremes
		 * to the nearest tick
		 */
		setTickPositions: function (secondPass) {
			var axis = this,
				chart = axis.chart,
				options = axis.options,
				startOnTick = options.startOnTick,
				endOnTick = options.endOnTick,
				isLog = axis.isLog,
				isDatetimeAxis = axis.isDatetimeAxis,
				isXAxis = axis.isXAxis,
				isLinked = axis.isLinked,
				tickPositioner = axis.options.tickPositioner,
				maxPadding = options.maxPadding,
				minPadding = options.minPadding,
				length,
				linkedParentExtremes,
				tickIntervalOption = options.tickInterval,
				minTickIntervalOption = options.minTickInterval,
				tickPixelIntervalOption = options.tickPixelInterval,
				tickPositions,
				keepTwoTicksOnly,
				categories = axis.categories;
	
			// linked axis gets the extremes from the parent axis
			if (isLinked) {
				axis.linkedParent = chart[axis.coll][options.linkedTo];
				linkedParentExtremes = axis.linkedParent.getExtremes();
				axis.min = pick(linkedParentExtremes.min, linkedParentExtremes.dataMin);
				axis.max = pick(linkedParentExtremes.max, linkedParentExtremes.dataMax);
				if (options.type !== axis.linkedParent.options.type) {
					error(11, 1); // Can't link axes of different type
				}
			} else { // initial min and max from the extreme data values
				axis.min = pick(axis.userMin, options.min, axis.dataMin);
				axis.max = pick(axis.userMax, options.max, axis.dataMax);
			}
	
			if (isLog) {
				if (!secondPass && mathMin(axis.min, pick(axis.dataMin, axis.min)) <= 0) { // #978
					error(10, 1); // Can't plot negative values on log axis
				}
				axis.min = correctFloat(log2lin(axis.min)); // correctFloat cures #934
				axis.max = correctFloat(log2lin(axis.max));
			}
	
			// handle zoomed range
			if (axis.range && defined(axis.max)) {
				axis.userMin = axis.min = mathMax(axis.min, axis.max - axis.range); // #618
				axis.userMax = axis.max;
	
				axis.range = null;  // don't use it when running setExtremes
			}
	
			// Hook for adjusting this.min and this.max. Used by bubble series.
			if (axis.beforePadding) {
				axis.beforePadding();
			}
	
			// adjust min and max for the minimum range
			axis.adjustForMinRange();
	
			// Pad the values to get clear of the chart's edges. To avoid tickInterval taking the padding
			// into account, we do this after computing tick interval (#1337).
			if (!categories && !axis.axisPointRange && !axis.usePercentage && !isLinked && defined(axis.min) && defined(axis.max)) {
				length = axis.max - axis.min;
				if (length) {
					if (!defined(options.min) && !defined(axis.userMin) && minPadding && (axis.dataMin < 0 || !axis.ignoreMinPadding)) {
						axis.min -= length * minPadding;
					}
					if (!defined(options.max) && !defined(axis.userMax)  && maxPadding && (axis.dataMax > 0 || !axis.ignoreMaxPadding)) {
						axis.max += length * maxPadding;
					}
				}
			}
	
			// Stay within floor and ceiling
			if (isNumber(options.floor)) {
				axis.min = mathMax(axis.min, options.floor);
			}
			if (isNumber(options.ceiling)) {
				axis.max = mathMin(axis.max, options.ceiling);
			}
	
			// get tickInterval
			if (axis.min === axis.max || axis.min === undefined || axis.max === undefined) {
				axis.tickInterval = 1;
			} else if (isLinked && !tickIntervalOption &&
					tickPixelIntervalOption === axis.linkedParent.options.tickPixelInterval) {
				axis.tickInterval = axis.linkedParent.tickInterval;
			} else {
				axis.tickInterval = pick(
					tickIntervalOption,
					categories ? // for categoried axis, 1 is default, for linear axis use tickPix
						1 :
						// don't let it be more than the data range
						(axis.max - axis.min) * tickPixelIntervalOption / mathMax(axis.len, tickPixelIntervalOption)
				);
				// For squished axes, set only two ticks
				if (!defined(tickIntervalOption) && axis.len < tickPixelIntervalOption && !this.isRadial &&
						!this.isLog && !categories && startOnTick && endOnTick) {
					keepTwoTicksOnly = true;
					axis.tickInterval /= 4; // tick extremes closer to the real values
				}
			}
	
			// Now we're finished detecting min and max, crop and group series data. This
			// is in turn needed in order to find tick positions in ordinal axes.
			if (isXAxis && !secondPass) {
				each(axis.series, function (series) {
					series.processData(axis.min !== axis.oldMin || axis.max !== axis.oldMax);
				});
			}
	
			// set the translation factor used in translate function
			axis.setAxisTranslation(true);
	
			// hook for ordinal axes and radial axes
			if (axis.beforeSetTickPositions) {
				axis.beforeSetTickPositions();
			}
	
			// hook for extensions, used in Highstock ordinal axes
			if (axis.postProcessTickInterval) {
				axis.tickInterval = axis.postProcessTickInterval(axis.tickInterval);
			}
	
			// In column-like charts, don't cramp in more ticks than there are points (#1943)
			if (axis.pointRange) {
				axis.tickInterval = mathMax(axis.pointRange, axis.tickInterval);
			}
	
			// Before normalizing the tick interval, handle minimum tick interval. This applies only if tickInterval is not defined.
			if (!tickIntervalOption && axis.tickInterval < minTickIntervalOption) {
				axis.tickInterval = minTickIntervalOption;
			}
	
			// for linear axes, get magnitude and normalize the interval
			if (!isDatetimeAxis && !isLog) { // linear
				if (!tickIntervalOption) {
					axis.tickInterval = normalizeTickInterval(
						axis.tickInterval, 
						null, 
						getMagnitude(axis.tickInterval), 
						// If the tick interval is between 1 and 5 and the axis max is in the order of
						// thousands, chances are we are dealing with years. Don't allow decimals. #3363.
						pick(options.allowDecimals, !(axis.tickInterval > 1 && axis.tickInterval < 5 && axis.max > 1000 && axis.max < 9999))
					);
				}
			}
	
			// get minorTickInterval
			axis.minorTickInterval = options.minorTickInterval === 'auto' && axis.tickInterval ?
					axis.tickInterval / 5 : options.minorTickInterval;
	
			// find the tick positions
			axis.tickPositions = tickPositions = options.tickPositions ?
				[].concat(options.tickPositions) : // Work on a copy (#1565)
				(tickPositioner && tickPositioner.apply(axis, [axis.min, axis.max]));
			if (!tickPositions) {
	
				// Too many ticks
				if (!axis.ordinalPositions && (axis.max - axis.min) / axis.tickInterval > mathMax(2 * axis.len, 200)) {
					error(19, true);
				}
	
				if (isDatetimeAxis) {
					tickPositions = axis.getTimeTicks(
						axis.normalizeTimeTickInterval(axis.tickInterval, options.units),
						axis.min,
						axis.max,
						options.startOfWeek,
						axis.ordinalPositions,
						axis.closestPointRange,
						true
					);
				} else if (isLog) {
					tickPositions = axis.getLogTickPositions(axis.tickInterval, axis.min, axis.max);
				} else {
					tickPositions = axis.getLinearTickPositions(axis.tickInterval, axis.min, axis.max);
				}
	
				if (keepTwoTicksOnly) {
					tickPositions.splice(1, tickPositions.length - 2);
				}
	
				axis.tickPositions = tickPositions;
			}
	
			if (!isLinked) {
	
				// reset min/max or remove extremes based on start/end on tick
				var roundedMin = tickPositions[0],
					roundedMax = tickPositions[tickPositions.length - 1],
					minPointOffset = axis.minPointOffset || 0,
					singlePad;
	
				if (startOnTick) {
					axis.min = roundedMin;
				} else if (axis.min - minPointOffset > roundedMin) {
					tickPositions.shift();
				}
	
				if (endOnTick) {
					axis.max = roundedMax;
				} else if (axis.max + minPointOffset < roundedMax) {
					tickPositions.pop();
				}
	
				// If no tick are left, set one tick in the middle (#3195) 
				if (tickPositions.length === 0 && defined(roundedMin)) {
					tickPositions.push((roundedMax + roundedMin) / 2);
				}
	
				// When there is only one point, or all points have the same value on this axis, then min
				// and max are equal and tickPositions.length is 0 or 1. In this case, add some padding
				// in order to center the point, but leave it with one tick. #1337.
				if (tickPositions.length === 1) {
					singlePad = mathAbs(axis.max) > 10e12 ? 1 : 0.001; // The lowest possible number to avoid extra padding on columns (#2619, #2846)
					axis.min -= singlePad;
					axis.max += singlePad;
				}
			}
		},
	
		/**
		 * Set the max ticks of either the x and y axis collection
		 */
		setMaxTicks: function () {
	
			var chart = this.chart,
				maxTicks = chart.maxTicks || {},
				tickPositions = this.tickPositions,
				key = this._maxTicksKey = [this.coll, this.pos, this.len].join('-');
	
			if (!this.isLinked && !this.isDatetimeAxis && tickPositions && tickPositions.length > (maxTicks[key] || 0) && this.options.alignTicks !== false) {
				maxTicks[key] = tickPositions.length;
			}
			chart.maxTicks = maxTicks;
		},
	
		/**
		 * When using multiple axes, adjust the number of ticks to match the highest
		 * number of ticks in that group
		 */
		adjustTickAmount: function () {
			var axis = this,
				chart = axis.chart,
				key = axis._maxTicksKey,
				tickPositions = axis.tickPositions,
				maxTicks = chart.maxTicks;
	
			if (maxTicks && maxTicks[key] && !axis.isDatetimeAxis && !axis.categories && !axis.isLinked &&
					axis.options.alignTicks !== false && this.min !== UNDEFINED) {
				var oldTickAmount = axis.tickAmount,
					calculatedTickAmount = tickPositions.length,
					tickAmount;
	
				// set the axis-level tickAmount to use below
				axis.tickAmount = tickAmount = maxTicks[key];
	
				if (calculatedTickAmount < tickAmount) {
					while (tickPositions.length < tickAmount) {
						tickPositions.push(correctFloat(
							tickPositions[tickPositions.length - 1] + axis.tickInterval
						));
					}
					axis.transA *= (calculatedTickAmount - 1) / (tickAmount - 1);
					axis.max = tickPositions[tickPositions.length - 1];
	
				}
				if (defined(oldTickAmount) && tickAmount !== oldTickAmount) {
					axis.isDirty = true;
				}
			}
		},
	
		/**
		 * Set the scale based on data min and max, user set min and max or options
		 *
		 */
		setScale: function () {
			var axis = this,
				stacks = axis.stacks,
				type,
				i,
				isDirtyData,
				isDirtyAxisLength;
	
			axis.oldMin = axis.min;
			axis.oldMax = axis.max;
			axis.oldAxisLength = axis.len;
	
			// set the new axisLength
			axis.setAxisSize();
			//axisLength = horiz ? axisWidth : axisHeight;
			isDirtyAxisLength = axis.len !== axis.oldAxisLength;
	
			// is there new data?
			each(axis.series, function (series) {
				if (series.isDirtyData || series.isDirty ||
						series.xAxis.isDirty) { // when x axis is dirty, we need new data extremes for y as well
					isDirtyData = true;
				}
			});
	
			// do we really need to go through all this?
			if (isDirtyAxisLength || isDirtyData || axis.isLinked || axis.forceRedraw ||
				axis.userMin !== axis.oldUserMin || axis.userMax !== axis.oldUserMax) {
	
				// reset stacks
				if (!axis.isXAxis) {
					for (type in stacks) {
						for (i in stacks[type]) {
							stacks[type][i].total = null;
							stacks[type][i].cum = 0;
						}
					}
				}
	
				axis.forceRedraw = false;
	
				// get data extremes if needed
				axis.getSeriesExtremes();
	
				// get fixed positions based on tickInterval
				axis.setTickPositions();
	
				// record old values to decide whether a rescale is necessary later on (#540)
				axis.oldUserMin = axis.userMin;
				axis.oldUserMax = axis.userMax;
	
				// Mark as dirty if it is not already set to dirty and extremes have changed. #595.
				if (!axis.isDirty) {
					axis.isDirty = isDirtyAxisLength || axis.min !== axis.oldMin || axis.max !== axis.oldMax;
				}
			} else if (!axis.isXAxis) {
				if (axis.oldStacks) {
					stacks = axis.stacks = axis.oldStacks;
				}
	
				// reset stacks
				for (type in stacks) {
					for (i in stacks[type]) {
						stacks[type][i].cum = stacks[type][i].total;
					}
				}
			}
	
			// Set the maximum tick amount
			axis.setMaxTicks();
		},
	
		/**
		 * Set the extremes and optionally redraw
		 * @param {Number} newMin
		 * @param {Number} newMax
		 * @param {Boolean} redraw
		 * @param {Boolean|Object} animation Whether to apply animation, and optionally animation
		 *    configuration
		 * @param {Object} eventArguments
		 *
		 */
		setExtremes: function (newMin, newMax, redraw, animation, eventArguments) {
			var axis = this,
				chart = axis.chart;
	
			redraw = pick(redraw, true); // defaults to true
	
			// Extend the arguments with min and max
			eventArguments = extend(eventArguments, {
				min: newMin,
				max: newMax
			});
	
			// Fire the event
			fireEvent(axis, 'setExtremes', eventArguments, function () { // the default event handler
	
				axis.userMin = newMin;
				axis.userMax = newMax;
				axis.eventArgs = eventArguments;
	
				// Mark for running afterSetExtremes
				axis.isDirtyExtremes = true;
	
				// redraw
				if (redraw) {
					chart.redraw(animation);
				}
			});
		},
	
		/**
		 * Overridable method for zooming chart. Pulled out in a separate method to allow overriding
		 * in stock charts.
		 */
		zoom: function (newMin, newMax) {
			var dataMin = this.dataMin,
				dataMax = this.dataMax,
				options = this.options;
	
			// Prevent pinch zooming out of range. Check for defined is for #1946. #1734.
			if (!this.allowZoomOutside) {
				if (defined(dataMin) && newMin <= mathMin(dataMin, pick(options.min, dataMin))) {
					newMin = UNDEFINED;
				}
				if (defined(dataMax) && newMax >= mathMax(dataMax, pick(options.max, dataMax))) {
					newMax = UNDEFINED;
				}
			}
	
			// In full view, displaying the reset zoom button is not required
			this.displayBtn = newMin !== UNDEFINED || newMax !== UNDEFINED;
	
			// Do it
			this.setExtremes(
				newMin,
				newMax,
				false,
				UNDEFINED,
				{ trigger: 'zoom' }
			);
			return true;
		},
	
		/**
		 * Update the axis metrics
		 */
		setAxisSize: function () {
			var chart = this.chart,
				options = this.options,
				offsetLeft = options.offsetLeft || 0,
				offsetRight = options.offsetRight || 0,
				horiz = this.horiz,
				width = pick(options.width, chart.plotWidth - offsetLeft + offsetRight),
				height = pick(options.height, chart.plotHeight),
				top = pick(options.top, chart.plotTop),
				left = pick(options.left, chart.plotLeft + offsetLeft),
				percentRegex = /%$/;
	
			// Check for percentage based input values
			if (percentRegex.test(height)) {
				height = parseInt(height, 10) / 100 * chart.plotHeight;
			}
			if (percentRegex.test(top)) {
				top = parseInt(top, 10) / 100 * chart.plotHeight + chart.plotTop;
			}
	
			// Expose basic values to use in Series object and navigator
			this.left = left;
			this.top = top;
			this.width = width;
			this.height = height;
			this.bottom = chart.chartHeight - height - top;
			this.right = chart.chartWidth - width - left;
	
			// Direction agnostic properties
			this.len = mathMax(horiz ? width : height, 0); // mathMax fixes #905
			this.pos = horiz ? left : top; // distance from SVG origin
		},
	
		/**
		 * Get the actual axis extremes
		 */
		getExtremes: function () {
			var axis = this,
				isLog = axis.isLog;
	
			return {
				min: isLog ? correctFloat(lin2log(axis.min)) : axis.min,
				max: isLog ? correctFloat(lin2log(axis.max)) : axis.max,
				dataMin: axis.dataMin,
				dataMax: axis.dataMax,
				userMin: axis.userMin,
				userMax: axis.userMax
			};
		},
	
		/**
		 * Get the zero plane either based on zero or on the min or max value.
		 * Used in bar and area plots
		 */
		getThreshold: function (threshold) {
			var axis = this,
				isLog = axis.isLog;
	
			var realMin = isLog ? lin2log(axis.min) : axis.min,
				realMax = isLog ? lin2log(axis.max) : axis.max;
	
			if (realMin > threshold || threshold === null) {
				threshold = realMin;
			} else if (realMax < threshold) {
				threshold = realMax;
			}
	
			return axis.translate(threshold, 0, 1, 0, 1);
		},
	
		/**
		 * Compute auto alignment for the axis label based on which side the axis is on
		 * and the given rotation for the label
		 */
		autoLabelAlign: function (rotation) {
			var ret,
				angle = (pick(rotation, 0) - (this.side * 90) + 720) % 360;
	
			if (angle > 15 && angle < 165) {
				ret = 'right';
			} else if (angle > 195 && angle < 345) {
				ret = 'left';
			} else {
				ret = 'center';
			}
			return ret;
		},
	
		/**
		 * Render the tick labels to a preliminary position to get their sizes
		 */
		getOffset: function () {
			var axis = this,
				chart = axis.chart,
				renderer = chart.renderer,
				options = axis.options,
				tickPositions = axis.tickPositions,
				ticks = axis.ticks,
				horiz = axis.horiz,
				side = axis.side,
				invertedSide = chart.inverted ? [1, 0, 3, 2][side] : side,
				hasData,
				showAxis,
				titleOffset = 0,
				titleOffsetOption,
				titleMargin = 0,
				axisTitleOptions = options.title,
				labelOptions = options.labels,
				labelOffset = 0, // reset
				labelOffsetPadded,
				axisOffset = chart.axisOffset,
				clipOffset = chart.clipOffset,
				directionFactor = [-1, 1, 1, -1][side],
				n,
				i,
				autoStaggerLines = 1,
				maxStaggerLines = pick(labelOptions.maxStaggerLines, 5),
				sortedPositions,
				lastRight,
				overlap,
				pos,
				bBox,
				x,
				w,
				lineNo,
				lineHeightCorrection;
	
			// For reuse in Axis.render
			axis.hasData = hasData = (axis.hasVisibleSeries || (defined(axis.min) && defined(axis.max) && !!tickPositions));
			axis.showAxis = showAxis = hasData || pick(options.showEmpty, true);
	
			// Set/reset staggerLines
			axis.staggerLines = axis.horiz && labelOptions.staggerLines;
	
			// Create the axisGroup and gridGroup elements on first iteration
			if (!axis.axisGroup) {
				axis.gridGroup = renderer.g('grid')
					.attr({ zIndex: options.gridZIndex || 1 })
					.add();
				axis.axisGroup = renderer.g('axis')
					.attr({ zIndex: options.zIndex || 2 })
					.add();
				axis.labelGroup = renderer.g('axis-labels')
					.attr({ zIndex: labelOptions.zIndex || 7 })
					.addClass(PREFIX + axis.coll.toLowerCase() + '-labels')
					.add();
			}
	
			if (hasData || axis.isLinked) {
	
				// Set the explicit or automatic label alignment
				axis.labelAlign = pick(labelOptions.align || axis.autoLabelAlign(labelOptions.rotation));
	
				// Generate ticks
				each(tickPositions, function (pos) {
					if (!ticks[pos]) {
						ticks[pos] = new Tick(axis, pos);
					} else {
						ticks[pos].addLabel(); // update labels depending on tick interval
					}
				});
	
				// Handle automatic stagger lines
				if (axis.horiz && !axis.staggerLines && maxStaggerLines && !labelOptions.rotation) {
					sortedPositions = axis.reversed ? [].concat(tickPositions).reverse() : tickPositions;
					while (autoStaggerLines < maxStaggerLines) {
						lastRight = [];
						overlap = false;
	
						for (i = 0; i < sortedPositions.length; i++) {
							pos = sortedPositions[i];
							bBox = ticks[pos].label && ticks[pos].label.getBBox();
							w = bBox ? bBox.width : 0;
							lineNo = i % autoStaggerLines;
	
							if (w) {
								x = axis.translate(pos); // don't handle log
								if (lastRight[lineNo] !== UNDEFINED && x < lastRight[lineNo]) {
									overlap = true;
								}
								lastRight[lineNo] = x + w;
							}
						}
						if (overlap) {
							autoStaggerLines++;
						} else {
							break;
						}
					}
	
					if (autoStaggerLines > 1) {
						axis.staggerLines = autoStaggerLines;
					}
				}
	
	
				each(tickPositions, function (pos) {
					// left side must be align: right and right side must have align: left for labels
					if (side === 0 || side === 2 || { 1: 'left', 3: 'right' }[side] === axis.labelAlign) {
	
						// get the highest offset
						labelOffset = mathMax(
							ticks[pos].getLabelSize(),
							labelOffset
						);
					}
				});
	
				if (axis.staggerLines) {
					labelOffset *= axis.staggerLines;
					axis.labelOffset = labelOffset;
				}
	
	
			} else { // doesn't have data
				for (n in ticks) {
					ticks[n].destroy();
					delete ticks[n];
				}
			}
	
			if (axisTitleOptions && axisTitleOptions.text && axisTitleOptions.enabled !== false) {
				if (!axis.axisTitle) {
					axis.axisTitle = renderer.text(
						axisTitleOptions.text,
						0,
						0,
						axisTitleOptions.useHTML
					)
					.attr({
						zIndex: 7,
						rotation: axisTitleOptions.rotation || 0,
						align:
							axisTitleOptions.textAlign ||
							{ low: 'left', middle: 'center', high: 'right' }[axisTitleOptions.align]
					})
					.addClass(PREFIX + this.coll.toLowerCase() + '-title')
					.css(axisTitleOptions.style)
					.add(axis.axisGroup);
					axis.axisTitle.isNew = true;
				}
	
				if (showAxis) {
					titleOffset = axis.axisTitle.getBBox()[horiz ? 'height' : 'width'];
					titleOffsetOption = axisTitleOptions.offset;
					titleMargin = defined(titleOffsetOption) ? 0 : pick(axisTitleOptions.margin, horiz ? 5 : 10);
				}
	
				// hide or show the title depending on whether showEmpty is set
				axis.axisTitle[showAxis ? 'show' : 'hide']();
			}
	
			// handle automatic or user set offset
			axis.offset = directionFactor * pick(options.offset, axisOffset[side]);
	
			lineHeightCorrection = side === 2 ? axis.tickBaseline : 0;
			labelOffsetPadded = labelOffset + titleMargin +
				(labelOffset && (directionFactor * (horiz ? pick(labelOptions.y, axis.tickBaseline + 8) : labelOptions.x) - lineHeightCorrection));
			axis.axisTitleMargin = pick(titleOffsetOption, labelOffsetPadded);
	
			axisOffset[side] = mathMax(
				axisOffset[side],
				axis.axisTitleMargin + titleOffset + directionFactor * axis.offset,
				labelOffsetPadded // #3027
			);
			clipOffset[invertedSide] = mathMax(clipOffset[invertedSide], mathFloor(options.lineWidth / 2) * 2);
		},
	
		/**
		 * Get the path for the axis line
		 */
		getLinePath: function (lineWidth) {
			var chart = this.chart,
				opposite = this.opposite,
				offset = this.offset,
				horiz = this.horiz,
				lineLeft = this.left + (opposite ? this.width : 0) + offset,
				lineTop = chart.chartHeight - this.bottom - (opposite ? this.height : 0) + offset;
	
			if (opposite) {
				lineWidth *= -1; // crispify the other way - #1480, #1687
			}
	
			return chart.renderer.crispLine([
					M,
					horiz ?
						this.left :
						lineLeft,
					horiz ?
						lineTop :
						this.top,
					L,
					horiz ?
						chart.chartWidth - this.right :
						lineLeft,
					horiz ?
						lineTop :
						chart.chartHeight - this.bottom
				], lineWidth);
		},
	
		/**
		 * Position the title
		 */
		getTitlePosition: function () {
			// compute anchor points for each of the title align options
			var horiz = this.horiz,
				axisLeft = this.left,
				axisTop = this.top,
				axisLength = this.len,
				axisTitleOptions = this.options.title,
				margin = horiz ? axisLeft : axisTop,
				opposite = this.opposite,
				offset = this.offset,
				fontSize = pInt(axisTitleOptions.style.fontSize || 12),
	
				// the position in the length direction of the axis
				alongAxis = {
					low: margin + (horiz ? 0 : axisLength),
					middle: margin + axisLength / 2,
					high: margin + (horiz ? axisLength : 0)
				}[axisTitleOptions.align],
	
				// the position in the perpendicular direction of the axis
				offAxis = (horiz ? axisTop + this.height : axisLeft) +
					(horiz ? 1 : -1) * // horizontal axis reverses the margin
					(opposite ? -1 : 1) * // so does opposite axes
					this.axisTitleMargin +
					(this.side === 2 ? fontSize : 0);
	
			return {
				x: horiz ?
					alongAxis :
					offAxis + (opposite ? this.width : 0) + offset +
						(axisTitleOptions.x || 0), // x
				y: horiz ?
					offAxis - (opposite ? this.height : 0) + offset :
					alongAxis + (axisTitleOptions.y || 0) // y
			};
		},
	
		/**
		 * Render the axis
		 */
		render: function () {
			var axis = this,
				horiz = axis.horiz,
				reversed = axis.reversed,
				chart = axis.chart,
				renderer = chart.renderer,
				options = axis.options,
				isLog = axis.isLog,
				isLinked = axis.isLinked,
				tickPositions = axis.tickPositions,
				sortedPositions,
				axisTitle = axis.axisTitle,			
				ticks = axis.ticks,
				minorTicks = axis.minorTicks,
				alternateBands = axis.alternateBands,
				stackLabelOptions = options.stackLabels,
				alternateGridColor = options.alternateGridColor,
				tickmarkOffset = axis.tickmarkOffset,
				lineWidth = options.lineWidth,
				linePath,
				hasRendered = chart.hasRendered,
				slideInTicks = hasRendered && defined(axis.oldMin) && !isNaN(axis.oldMin),
				hasData = axis.hasData,
				showAxis = axis.showAxis,
				from,
				overflow = options.labels.overflow,
				justifyLabels = axis.justifyLabels = horiz && overflow !== false,
				to;
	
			// Reset
			axis.labelEdge.length = 0;
			axis.justifyToPlot = overflow === 'justify';
	
			// Mark all elements inActive before we go over and mark the active ones
			each([ticks, minorTicks, alternateBands], function (coll) {
				var pos;
				for (pos in coll) {
					coll[pos].isActive = false;
				}
			});
	
			// If the series has data draw the ticks. Else only the line and title
			if (hasData || isLinked) {
	
				// minor ticks
				if (axis.minorTickInterval && !axis.categories) {
					each(axis.getMinorTickPositions(), function (pos) {
						if (!minorTicks[pos]) {
							minorTicks[pos] = new Tick(axis, pos, 'minor');
						}
	
						// render new ticks in old position
						if (slideInTicks && minorTicks[pos].isNew) {
							minorTicks[pos].render(null, true);
						}
	
						minorTicks[pos].render(null, false, 1);
					});
				}
	
				// Major ticks. Pull out the first item and render it last so that
				// we can get the position of the neighbour label. #808.
				if (tickPositions.length) { // #1300
					sortedPositions = tickPositions.slice();
					if ((horiz && reversed) || (!horiz && !reversed)) {
						sortedPositions.reverse();
					}
					if (justifyLabels) {
						sortedPositions = sortedPositions.slice(1).concat([sortedPositions[0]]);
					}
					each(sortedPositions, function (pos, i) {
	
						// Reorganize the indices
						if (justifyLabels) {
							i = (i === sortedPositions.length - 1) ? 0 : i + 1;
						}
	
						// linked axes need an extra check to find out if
						if (!isLinked || (pos >= axis.min && pos <= axis.max)) {
	
							if (!ticks[pos]) {
								ticks[pos] = new Tick(axis, pos);
							}
	
							// render new ticks in old position
							if (slideInTicks && ticks[pos].isNew) {
								ticks[pos].render(i, true, 0.1);
							}
	
							ticks[pos].render(i);
						}
	
					});
					// In a categorized axis, the tick marks are displayed between labels. So
					// we need to add a tick mark and grid line at the left edge of the X axis.
					if (tickmarkOffset && axis.min === 0) {
						if (!ticks[-1]) {
							ticks[-1] = new Tick(axis, -1, null, true);
						}
						ticks[-1].render(-1);
					}
	
				}
	
				// alternate grid color
				if (alternateGridColor) {
					each(tickPositions, function (pos, i) {
						if (i % 2 === 0 && pos < axis.max) {
							if (!alternateBands[pos]) {
								alternateBands[pos] = new Highcharts.PlotLineOrBand(axis);
							}
							from = pos + tickmarkOffset; // #949
							to = tickPositions[i + 1] !== UNDEFINED ? tickPositions[i + 1] + tickmarkOffset : axis.max;
							alternateBands[pos].options = {
								from: isLog ? lin2log(from) : from,
								to: isLog ? lin2log(to) : to,
								color: alternateGridColor
							};
							alternateBands[pos].render();
							alternateBands[pos].isActive = true;
						}
					});
				}
	
				// custom plot lines and bands
				if (!axis._addedPlotLB) { // only first time
					each((options.plotLines || []).concat(options.plotBands || []), function (plotLineOptions) {
						axis.addPlotBandOrLine(plotLineOptions);
					});
					axis._addedPlotLB = true;
				}
	
			} // end if hasData
	
			// Remove inactive ticks
			each([ticks, minorTicks, alternateBands], function (coll) {
				var pos,
					i,
					forDestruction = [],
					delay = globalAnimation ? globalAnimation.duration || 500 : 0,
					destroyInactiveItems = function () {
						i = forDestruction.length;
						while (i--) {
							// When resizing rapidly, the same items may be destroyed in different timeouts,
							// or the may be reactivated
							if (coll[forDestruction[i]] && !coll[forDestruction[i]].isActive) {
								coll[forDestruction[i]].destroy();
								delete coll[forDestruction[i]];
							}
						}
	
					};
	
				for (pos in coll) {
	
					if (!coll[pos].isActive) {
						// Render to zero opacity
						coll[pos].render(pos, false, 0);
						coll[pos].isActive = false;
						forDestruction.push(pos);
					}
				}
	
				// When the objects are finished fading out, destroy them
				if (coll === alternateBands || !chart.hasRendered || !delay) {
					destroyInactiveItems();
				} else if (delay) {
					setTimeout(destroyInactiveItems, delay);
				}
			});
	
			// Static items. As the axis group is cleared on subsequent calls
			// to render, these items are added outside the group.
			// axis line
			if (lineWidth) {
				linePath = axis.getLinePath(lineWidth);
				if (!axis.axisLine) {
					axis.axisLine = renderer.path(linePath)
						.attr({
							stroke: options.lineColor,
							'stroke-width': lineWidth,
							zIndex: 7
						})
						.add(axis.axisGroup);
				} else {
					axis.axisLine.animate({ d: linePath });
				}
	
				// show or hide the line depending on options.showEmpty
				axis.axisLine[showAxis ? 'show' : 'hide']();
			}
	
			if (axisTitle && showAxis) {
	
				axisTitle[axisTitle.isNew ? 'attr' : 'animate'](
					axis.getTitlePosition()
				);
				axisTitle.isNew = false;
			}
	
			// Stacked totals:
			if (stackLabelOptions && stackLabelOptions.enabled) {
				axis.renderStackTotals();
			}
			// End stacked totals
	
			axis.isDirty = false;
		},
	
		/**
		 * Redraw the axis to reflect changes in the data or axis extremes
		 */
		redraw: function () {
			
			// render the axis
			this.render();
	
			// move plot lines and bands
			each(this.plotLinesAndBands, function (plotLine) {
				plotLine.render();
			});
	
			// mark associated series as dirty and ready for redraw
			each(this.series, function (series) {
				series.isDirty = true;
			});
	
		},
	
		/**
		 * Destroys an Axis instance.
		 */
		destroy: function (keepEvents) {
			var axis = this,
				stacks = axis.stacks,
				stackKey,
				plotLinesAndBands = axis.plotLinesAndBands,
				i;
	
			// Remove the events
			if (!keepEvents) {
				removeEvent(axis);
			}
	
			// Destroy each stack total
			for (stackKey in stacks) {
				destroyObjectProperties(stacks[stackKey]);
	
				stacks[stackKey] = null;
			}
	
			// Destroy collections
			each([axis.ticks, axis.minorTicks, axis.alternateBands], function (coll) {
				destroyObjectProperties(coll);
			});
			i = plotLinesAndBands.length;
			while (i--) { // #1975
				plotLinesAndBands[i].destroy();
			}
	
			// Destroy local variables
			each(['stackTotalGroup', 'axisLine', 'axisTitle', 'axisGroup', 'cross', 'gridGroup', 'labelGroup'], function (prop) {
				if (axis[prop]) {
					axis[prop] = axis[prop].destroy();
				}
			});
	
			// Destroy crosshair
			if (this.cross) {
				this.cross.destroy();
			}
		},
	
		/**
		 * Draw the crosshair
		 */
		drawCrosshair: function (e, point) {
			if (!this.crosshair) { return; }// Do not draw crosshairs if you don't have too.
	
			if ((defined(point) || !pick(this.crosshair.snap, true)) === false) {
				this.hideCrosshair();
				return;
			}
	
			var path,
				options = this.crosshair,
				animation = options.animation,
				pos;
	
			// Get the path
			if (!pick(options.snap, true)) {
				pos = (this.horiz ? e.chartX - this.pos : this.len - e.chartY + this.pos);
			} else if (defined(point)) {
				/*jslint eqeq: true*/
				pos = (this.chart.inverted != this.horiz) ? point.plotX : this.len - point.plotY;
				/*jslint eqeq: false*/
			}
	
			if (this.isRadial) {
				path = this.getPlotLinePath(this.isXAxis ? point.x : pick(point.stackY, point.y));
			} else {
				path = this.getPlotLinePath(null, null, null, null, pos);
			}
	
			if (path === null) {
				this.hideCrosshair();
				return;
			}
	
			// Draw the cross
			if (this.cross) {
				this.cross
					.attr({ visibility: VISIBLE })[animation ? 'animate' : 'attr']({ d: path }, animation);
			} else {
				var attribs = {
					'stroke-width': options.width || 1,
					stroke: options.color || '#C0C0C0',
					zIndex: options.zIndex || 2
				};
				if (options.dashStyle) {
					attribs.dashstyle = options.dashStyle;
				}
				this.cross = this.chart.renderer.path(path).attr(attribs).add();
			}
		},
	
		/**
		 *	Hide the crosshair.
		 */
		hideCrosshair: function () {
			if (this.cross) {
				this.cross.hide();
			}
		}
	}; // end Axis
	
	extend(Axis.prototype, AxisPlotLineOrBandExtension);
	
	/**
	 * Set the tick positions to a time unit that makes sense, for example
	 * on the first of each month or on every Monday. Return an array
	 * with the time positions. Used in datetime axes as well as for grouping
	 * data on a datetime axis.
	 *
	 * @param {Object} normalizedInterval The interval in axis values (ms) and the count
	 * @param {Number} min The minimum in axis values
	 * @param {Number} max The maximum in axis values
	 * @param {Number} startOfWeek
	 */
	Axis.prototype.getTimeTicks = function (normalizedInterval, min, max, startOfWeek) {
		var tickPositions = [],
			i,
			higherRanks = {},
			useUTC = defaultOptions.global.useUTC,
			minYear, // used in months and years as a basis for Date.UTC()
			minDate = new Date(min - timezoneOffset),
			interval = normalizedInterval.unitRange,
			count = normalizedInterval.count;
	
		if (defined(min)) { // #1300
			if (interval >= timeUnits.second) { // second
				minDate.setMilliseconds(0);
				minDate.setSeconds(interval >= timeUnits.minute ? 0 :
					count * mathFloor(minDate.getSeconds() / count));
			}
		
			if (interval >= timeUnits.minute) { // minute
				minDate[setMinutes](interval >= timeUnits.hour ? 0 :
					count * mathFloor(minDate[getMinutes]() / count));
			}
		
			if (interval >= timeUnits.hour) { // hour
				minDate[setHours](interval >= timeUnits.day ? 0 :
					count * mathFloor(minDate[getHours]() / count));
			}
		
			if (interval >= timeUnits.day) { // day
				minDate[setDate](interval >= timeUnits.month ? 1 :
					count * mathFloor(minDate[getDate]() / count));
			}
		
			if (interval >= timeUnits.month) { // month
				minDate[setMonth](interval >= timeUnits.year ? 0 :
					count * mathFloor(minDate[getMonth]() / count));
				minYear = minDate[getFullYear]();
			}
		
			if (interval >= timeUnits.year) { // year
				minYear -= minYear % count;
				minDate[setFullYear](minYear);
			}
		
			// week is a special case that runs outside the hierarchy
			if (interval === timeUnits.week) {
				// get start of current week, independent of count
				minDate[setDate](minDate[getDate]() - minDate[getDay]() +
					pick(startOfWeek, 1));
			}
		
		
			// get tick positions
			i = 1;
			if (timezoneOffset) {
				minDate = new Date(minDate.getTime() + timezoneOffset);
			}
			minYear = minDate[getFullYear]();
			var time = minDate.getTime(),
				minMonth = minDate[getMonth](),
				minDateDate = minDate[getDate](),
				localTimezoneOffset = (timeUnits.day + 
						(useUTC ? timezoneOffset : minDate.getTimezoneOffset() * 60 * 1000)
					) % timeUnits.day; // #950, #3359
		
			// iterate and add tick positions at appropriate values
			while (time < max) {
				tickPositions.push(time);
		
				// if the interval is years, use Date.UTC to increase years
				if (interval === timeUnits.year) {
					time = makeTime(minYear + i * count, 0);
		
				// if the interval is months, use Date.UTC to increase months
				} else if (interval === timeUnits.month) {
					time = makeTime(minYear, minMonth + i * count);
		
				// if we're using global time, the interval is not fixed as it jumps
				// one hour at the DST crossover
				} else if (!useUTC && (interval === timeUnits.day || interval === timeUnits.week)) {
					time = makeTime(minYear, minMonth, minDateDate +
						i * count * (interval === timeUnits.day ? 1 : 7));
		
				// else, the interval is fixed and we use simple addition
				} else {
					time += interval * count;
				}
		
				i++;
			}
		
			// push the last time
			tickPositions.push(time);
	
	
			// mark new days if the time is dividible by day (#1649, #1760)
			each(grep(tickPositions, function (time) {
				return interval <= timeUnits.hour && time % timeUnits.day === localTimezoneOffset;
			}), function (time) {
				higherRanks[time] = 'day';
			});
		}
	
	
		// record information on the chosen unit - for dynamic label formatter
		tickPositions.info = extend(normalizedInterval, {
			higherRanks: higherRanks,
			totalRange: interval * count
		});
	
		return tickPositions;
	};
	
	/**
	 * Get a normalized tick interval for dates. Returns a configuration object with
	 * unit range (interval), count and name. Used to prepare data for getTimeTicks. 
	 * Previously this logic was part of getTimeTicks, but as getTimeTicks now runs
	 * of segments in stock charts, the normalizing logic was extracted in order to 
	 * prevent it for running over again for each segment having the same interval. 
	 * #662, #697.
	 */
	Axis.prototype.normalizeTimeTickInterval = function (tickInterval, unitsOption) {
		var units = unitsOption || [[
					'millisecond', // unit name
					[1, 2, 5, 10, 20, 25, 50, 100, 200, 500] // allowed multiples
				], [
					'second',
					[1, 2, 5, 10, 15, 30]
				], [
					'minute',
					[1, 2, 5, 10, 15, 30]
				], [
					'hour',
					[1, 2, 3, 4, 6, 8, 12]
				], [
					'day',
					[1, 2]
				], [
					'week',
					[1, 2]
				], [
					'month',
					[1, 2, 3, 4, 6]
				], [
					'year',
					null
				]],
			unit = units[units.length - 1], // default unit is years
			interval = timeUnits[unit[0]],
			multiples = unit[1],
			count,
			i;
			
		// loop through the units to find the one that best fits the tickInterval
		for (i = 0; i < units.length; i++) {
			unit = units[i];
			interval = timeUnits[unit[0]];
			multiples = unit[1];
	
	
			if (units[i + 1]) {
				// lessThan is in the middle between the highest multiple and the next unit.
				var lessThan = (interval * multiples[multiples.length - 1] +
							timeUnits[units[i + 1][0]]) / 2;
	
				// break and keep the current unit
				if (tickInterval <= lessThan) {
					break;
				}
			}
		}
	
		// prevent 2.5 years intervals, though 25, 250 etc. are allowed
		if (interval === timeUnits.year && tickInterval < 5 * interval) {
			multiples = [1, 2, 5];
		}
	
		// get the count
		count = normalizeTickInterval(
			tickInterval / interval, 
			multiples,
			unit[0] === 'year' ? mathMax(getMagnitude(tickInterval / interval), 1) : 1 // #1913, #2360
		);
		
		return {
			unitRange: interval,
			count: count,
			unitName: unit[0]
		};
	};/**
	 * Methods defined on the Axis prototype
	 */
	
	/**
	 * Set the tick positions of a logarithmic axis
	 */
	Axis.prototype.getLogTickPositions = function (interval, min, max, minor) {
		var axis = this,
			options = axis.options,
			axisLength = axis.len,
			// Since we use this method for both major and minor ticks,
			// use a local variable and return the result
			positions = []; 
		
		// Reset
		if (!minor) {
			axis._minorAutoInterval = null;
		}
		
		// First case: All ticks fall on whole logarithms: 1, 10, 100 etc.
		if (interval >= 0.5) {
			interval = mathRound(interval);
			positions = axis.getLinearTickPositions(interval, min, max);
			
		// Second case: We need intermediary ticks. For example 
		// 1, 2, 4, 6, 8, 10, 20, 40 etc. 
		} else if (interval >= 0.08) {
			var roundedMin = mathFloor(min),
				intermediate,
				i,
				j,
				len,
				pos,
				lastPos,
				break2;
				
			if (interval > 0.3) {
				intermediate = [1, 2, 4];
			} else if (interval > 0.15) { // 0.2 equals five minor ticks per 1, 10, 100 etc
				intermediate = [1, 2, 4, 6, 8];
			} else { // 0.1 equals ten minor ticks per 1, 10, 100 etc
				intermediate = [1, 2, 3, 4, 5, 6, 7, 8, 9];
			}
			
			for (i = roundedMin; i < max + 1 && !break2; i++) {
				len = intermediate.length;
				for (j = 0; j < len && !break2; j++) {
					pos = log2lin(lin2log(i) * intermediate[j]);
					if (pos > min && (!minor || lastPos <= max) && lastPos !== UNDEFINED) { // #1670, lastPos is #3113
						positions.push(lastPos);
					}
					
					if (lastPos > max) {
						break2 = true;
					}
					lastPos = pos;
				}
			}
			
		// Third case: We are so deep in between whole logarithmic values that
		// we might as well handle the tick positions like a linear axis. For
		// example 1.01, 1.02, 1.03, 1.04.
		} else {
			var realMin = lin2log(min),
				realMax = lin2log(max),
				tickIntervalOption = options[minor ? 'minorTickInterval' : 'tickInterval'],
				filteredTickIntervalOption = tickIntervalOption === 'auto' ? null : tickIntervalOption,
				tickPixelIntervalOption = options.tickPixelInterval / (minor ? 5 : 1),
				totalPixelLength = minor ? axisLength / axis.tickPositions.length : axisLength;
			
			interval = pick(
				filteredTickIntervalOption,
				axis._minorAutoInterval,
				(realMax - realMin) * tickPixelIntervalOption / (totalPixelLength || 1)
			);
			
			interval = normalizeTickInterval(
				interval, 
				null, 
				getMagnitude(interval)
			);
			
			positions = map(axis.getLinearTickPositions(
				interval, 
				realMin,
				realMax	
			), log2lin);
			
			if (!minor) {
				axis._minorAutoInterval = interval / 5;
			}
		}
		
		// Set the axis-level tickInterval variable 
		if (!minor) {
			axis.tickInterval = interval;
		}
		return positions;
	};/**
	 * The tooltip object
	 * @param {Object} chart The chart instance
	 * @param {Object} options Tooltip options
	 */
	var Tooltip = Highcharts.Tooltip = function () {
		this.init.apply(this, arguments);
	};
	
	Tooltip.prototype = {
	
		init: function (chart, options) {
	
			var borderWidth = options.borderWidth,
				style = options.style,
				padding = pInt(style.padding);
	
			// Save the chart and options
			this.chart = chart;
			this.options = options;
	
			// Keep track of the current series
			//this.currentSeries = UNDEFINED;
	
			// List of crosshairs
			this.crosshairs = [];
	
			// Current values of x and y when animating
			this.now = { x: 0, y: 0 };
	
			// The tooltip is initially hidden
			this.isHidden = true;
	
	
			// create the label
			this.label = chart.renderer.label('', 0, 0, options.shape || 'callout', null, null, options.useHTML, null, 'tooltip')
				.attr({
					padding: padding,
					fill: options.backgroundColor,
					'stroke-width': borderWidth,
					r: options.borderRadius,
					zIndex: 8
				})
				.css(style)
				.css({ padding: 0 }) // Remove it from VML, the padding is applied as an attribute instead (#1117)
				.add()
				.attr({ y: -9999 }); // #2301, #2657
	
			// When using canVG the shadow shows up as a gray circle
			// even if the tooltip is hidden.
			if (!useCanVG) {
				this.label.shadow(options.shadow);
			}
	
			// Public property for getting the shared state.
			this.shared = options.shared;
		},
	
		/**
		 * Destroy the tooltip and its elements.
		 */
		destroy: function () {
			// Destroy and clear local variables
			if (this.label) {
				this.label = this.label.destroy();
			}
			clearTimeout(this.hideTimer);
			clearTimeout(this.tooltipTimeout);
		},
	
		/**
		 * Provide a soft movement for the tooltip
		 *
		 * @param {Number} x
		 * @param {Number} y
		 * @private
		 */
		move: function (x, y, anchorX, anchorY) {
			var tooltip = this,
				now = tooltip.now,
				animate = tooltip.options.animation !== false && !tooltip.isHidden && 
					// When we get close to the target position, abort animation and land on the right place (#3056)
					(mathAbs(x - now.x) > 1 || mathAbs(y - now.y) > 1),
				skipAnchor = tooltip.followPointer || tooltip.len > 1;
	
			// Get intermediate values for animation
			extend(now, {
				x: animate ? (2 * now.x + x) / 3 : x,
				y: animate ? (now.y + y) / 2 : y,
				anchorX: skipAnchor ? UNDEFINED : animate ? (2 * now.anchorX + anchorX) / 3 : anchorX,
				anchorY: skipAnchor ? UNDEFINED : animate ? (now.anchorY + anchorY) / 2 : anchorY
			});
	
			// Move to the intermediate value
			tooltip.label.attr(now);
	
			
			// Run on next tick of the mouse tracker
			if (animate) {
			
				// Never allow two timeouts
				clearTimeout(this.tooltipTimeout);
				
				// Set the fixed interval ticking for the smooth tooltip
				this.tooltipTimeout = setTimeout(function () {
					// The interval function may still be running during destroy, so check that the chart is really there before calling.
					if (tooltip) {
						tooltip.move(x, y, anchorX, anchorY);
					}
				}, 32);
				
			}
		},
	
		/**
		 * Hide the tooltip
		 */
		hide: function (delay) {
			var tooltip = this,
				hoverPoints;
			
			clearTimeout(this.hideTimer); // disallow duplicate timers (#1728, #1766)
			if (!this.isHidden) {
				hoverPoints = this.chart.hoverPoints;
	
				this.hideTimer = setTimeout(function () {
					tooltip.label.fadeOut();
					tooltip.isHidden = true;
				}, pick(delay, this.options.hideDelay, 500));
	
				// hide previous hoverPoints and set new
				if (hoverPoints) {
					each(hoverPoints, function (point) {
						point.setState();
					});
				}
	
				this.chart.hoverPoints = null;
			}
		},
		
		/** 
		 * Extendable method to get the anchor position of the tooltip
		 * from a point or set of points
		 */
		getAnchor: function (points, mouseEvent) {
			var ret,
				chart = this.chart,
				inverted = chart.inverted,
				plotTop = chart.plotTop,
				plotX = 0,
				plotY = 0,
				yAxis;
			
			points = splat(points);
			
			// Pie uses a special tooltipPos
			ret = points[0].tooltipPos;
			
			// When tooltip follows mouse, relate the position to the mouse
			if (this.followPointer && mouseEvent) {
				if (mouseEvent.chartX === UNDEFINED) {
					mouseEvent = chart.pointer.normalize(mouseEvent);
				}
				ret = [
					mouseEvent.chartX - chart.plotLeft,
					mouseEvent.chartY - plotTop
				];
			}
			// When shared, use the average position
			if (!ret) {
				each(points, function (point) {
					yAxis = point.series.yAxis;
					plotX += point.plotX;
					plotY += (point.plotLow ? (point.plotLow + point.plotHigh) / 2 : point.plotY) +
						(!inverted && yAxis ? yAxis.top - plotTop : 0); // #1151
				});
				
				plotX /= points.length;
				plotY /= points.length;
				
				ret = [
					inverted ? chart.plotWidth - plotY : plotX,
					this.shared && !inverted && points.length > 1 && mouseEvent ? 
						mouseEvent.chartY - plotTop : // place shared tooltip next to the mouse (#424)
						inverted ? chart.plotHeight - plotX : plotY
				];
			}
	
			return map(ret, mathRound);
		},
		
		/**
		 * Place the tooltip in a chart without spilling over
		 * and not covering the point it self.
		 */
		getPosition: function (boxWidth, boxHeight, point) {
			
			var chart = this.chart,
				distance = this.distance,
				ret = {},
				swapped,
				first = ['y', chart.chartHeight, boxHeight, point.plotY + chart.plotTop],
				second = ['x', chart.chartWidth, boxWidth, point.plotX + chart.plotLeft],
				// The far side is right or bottom
				preferFarSide = point.ttBelow || (chart.inverted && !point.negative) || (!chart.inverted && point.negative),
				/**
				 * Handle the preferred dimension. When the preferred dimension is tooltip
				 * on top or bottom of the point, it will look for space there.
				 */
				firstDimension = function (dim, outerSize, innerSize, point) {
					var roomLeft = innerSize < point - distance,
						roomRight = point + distance + innerSize < outerSize,
						alignedLeft = point - distance - innerSize,
						alignedRight = point + distance;
	
					if (preferFarSide && roomRight) {
						ret[dim] = alignedRight;
					} else if (!preferFarSide && roomLeft) {
						ret[dim] = alignedLeft;
					} else if (roomLeft) {
						ret[dim] = alignedLeft;
					} else if (roomRight) {
						ret[dim] = alignedRight;
					} else {
						return false;
					}
				},
				/**
				 * Handle the secondary dimension. If the preferred dimension is tooltip
				 * on top or bottom of the point, the second dimension is to align the tooltip
				 * above the point, trying to align center but allowing left or right
				 * align within the chart box.
				 */
				secondDimension = function (dim, outerSize, innerSize, point) {
					// Too close to the edge, return false and swap dimensions
					if (point < distance || point > outerSize - distance) {
						return false;
					
					// Align left/top
					} else if (point < innerSize / 2) {
						ret[dim] = 1;
					// Align right/bottom
					} else if (point > outerSize - innerSize / 2) {
						ret[dim] = outerSize - innerSize - 2;
					// Align center
					} else {
						ret[dim] = point - innerSize / 2;
					}
				},
				/**
				 * Swap the dimensions 
				 */
				swap = function (count) {
					var temp = first;
					first = second;
					second = temp;
					swapped = count;
				},
				run = function () {
					if (firstDimension.apply(0, first) !== false) {
						if (secondDimension.apply(0, second) === false && !swapped) {
							swap(true);
							run();
						}
					} else if (!swapped) {
						swap(true);
						run();
					} else {
						ret.x = ret.y = 0;
					}
				};
	
			// Under these conditions, prefer the tooltip on the side of the point
			if (chart.inverted || this.len > 1) {
				swap();
			}
			run();
	
			return ret;
		
		},
	
		/**
		 * In case no user defined formatter is given, this will be used. Note that the context
		 * here is an object holding point, series, x, y etc.
		 */
		defaultFormatter: function (tooltip) {
			var items = this.points || splat(this),
				series = items[0].series,
				s;
	
			// build the header
			s = [tooltip.tooltipHeaderFormatter(items[0])];
	
			// build the values
			each(items, function (item) {
				series = item.series;
				s.push((series.tooltipFormatter && series.tooltipFormatter(item)) ||
					item.point.tooltipFormatter(series.tooltipOptions.pointFormat));
			});
	
			// footer
			s.push(tooltip.options.footerFormat || '');
	
			return s.join('');
		},
	
		/**
		 * Refresh the tooltip's text and position.
		 * @param {Object} point
		 */
		refresh: function (point, mouseEvent) {
			var tooltip = this,
				chart = tooltip.chart,
				label = tooltip.label,
				options = tooltip.options,
				x,
				y,
				anchor,
				textConfig = {},
				text,
				pointConfig = [],
				formatter = options.formatter || tooltip.defaultFormatter,
				hoverPoints = chart.hoverPoints,
				borderColor,
				shared = tooltip.shared,
				currentSeries;
				
			clearTimeout(this.hideTimer);
			
			// get the reference point coordinates (pie charts use tooltipPos)
			tooltip.followPointer = splat(point)[0].series.tooltipOptions.followPointer;
			anchor = tooltip.getAnchor(point, mouseEvent);
			x = anchor[0];
			y = anchor[1];
	
			// shared tooltip, array is sent over
			if (shared && !(point.series && point.series.noSharedTooltip)) {
				
				// hide previous hoverPoints and set new
				
				chart.hoverPoints = point;
				if (hoverPoints) {
					each(hoverPoints, function (point) {
						point.setState();
					});
				}
	
				each(point, function (item) {
					item.setState(HOVER_STATE);
	
					pointConfig.push(item.getLabelConfig());
				});
	
				textConfig = {
					x: point[0].category,
					y: point[0].y
				};
				textConfig.points = pointConfig;
				this.len = pointConfig.length;
				point = point[0];
	
			// single point tooltip
			} else {
				textConfig = point.getLabelConfig();
			}
			text = formatter.call(textConfig, tooltip);
	
			// register the current series
			currentSeries = point.series;
			this.distance = pick(currentSeries.tooltipOptions.distance, 16);
	
			// update the inner HTML
			if (text === false) {
				this.hide();
			} else {
	
				// show it
				if (tooltip.isHidden) {
					stop(label);
					label.attr('opacity', 1).show();
				}
	
				// update text
				label.attr({
					text: text
				});
	
				// set the stroke color of the box
				borderColor = options.borderColor || point.color || currentSeries.color || '#606060';
				label.attr({
					stroke: borderColor
				});
				
				tooltip.updatePosition({ plotX: x, plotY: y, negative: point.negative, ttBelow: point.ttBelow });
			
				this.isHidden = false;
			}
			fireEvent(chart, 'tooltipRefresh', {
					text: text,
					x: x + chart.plotLeft,
					y: y + chart.plotTop,
					borderColor: borderColor
				});
		},
		
		/**
		 * Find the new position and perform the move
		 */
		updatePosition: function (point) {
			var chart = this.chart,
				label = this.label, 
				pos = (this.options.positioner || this.getPosition).call(
					this,
					label.width,
					label.height,
					point
				);
	
			// do the move
			this.move(
				mathRound(pos.x), 
				mathRound(pos.y), 
				point.plotX + chart.plotLeft, 
				point.plotY + chart.plotTop
			);
		},
	
	
		/**
		 * Format the header of the tooltip
		 */
		tooltipHeaderFormatter: function (point) {
			var series = point.series,
				tooltipOptions = series.tooltipOptions,
				dateTimeLabelFormats = tooltipOptions.dateTimeLabelFormats,
				xDateFormat = tooltipOptions.xDateFormat,
				xAxis = series.xAxis,
				isDateTime = xAxis && xAxis.options.type === 'datetime' && isNumber(point.key),
				headerFormat = tooltipOptions.headerFormat,
				closestPointRange = xAxis && xAxis.closestPointRange,
				n;
	
			// Guess the best date format based on the closest point distance (#568)
			if (isDateTime && !xDateFormat) {
				if (closestPointRange) {
					for (n in timeUnits) {
						if (timeUnits[n] >= closestPointRange || 
								// If the point is placed every day at 23:59, we need to show
								// the minutes as well. This logic only works for time units less than 
								// a day, since all higher time units are dividable by those. #2637.
								(timeUnits[n] <= timeUnits.day && point.key % timeUnits[n] > 0)) {
							xDateFormat = dateTimeLabelFormats[n];
							break;
						}
					}
				} else {
					xDateFormat = dateTimeLabelFormats.day;
				}
	
				xDateFormat = xDateFormat || dateTimeLabelFormats.year; // #2546, 2581
	
			}
	
			// Insert the header date format if any
			if (isDateTime && xDateFormat) {
				headerFormat = headerFormat.replace('{point.key}', '{point.key:' + xDateFormat + '}');
			}
	
			return format(headerFormat, {
				point: point,
				series: series
			});
		}
	};
	
	var hoverChartIndex;
	
	// Global flag for touch support
	hasTouch = doc.documentElement.ontouchstart !== UNDEFINED;
	
	/**
	 * The mouse tracker object. All methods starting with "on" are primary DOM event handlers. 
	 * Subsequent methods should be named differently from what they are doing.
	 * @param {Object} chart The Chart instance
	 * @param {Object} options The root options object
	 */
	var Pointer = Highcharts.Pointer = function (chart, options) {
		this.init(chart, options);
	};
	
	Pointer.prototype = {
		/**
		 * Initialize Pointer
		 */
		init: function (chart, options) {
			
			var chartOptions = options.chart,
				chartEvents = chartOptions.events,
				zoomType = useCanVG ? '' : chartOptions.zoomType,
				inverted = chart.inverted,
				zoomX,
				zoomY;
	
			// Store references
			this.options = options;
			this.chart = chart;
			
			// Zoom status
			this.zoomX = zoomX = /x/.test(zoomType);
			this.zoomY = zoomY = /y/.test(zoomType);
			this.zoomHor = (zoomX && !inverted) || (zoomY && inverted);
			this.zoomVert = (zoomY && !inverted) || (zoomX && inverted);
			this.hasZoom = zoomX || zoomY;
	
			// Do we need to handle click on a touch device?
			this.runChartClick = chartEvents && !!chartEvents.click;
	
			this.pinchDown = [];
			this.lastValidTouch = {};
	
			if (Highcharts.Tooltip && options.tooltip.enabled) {
				chart.tooltip = new Tooltip(chart, options.tooltip);
				this.followTouchMove = options.tooltip.followTouchMove;
			}
	
			this.setDOMEvents();
		}, 
	
		/**
		 * Add crossbrowser support for chartX and chartY
		 * @param {Object} e The event object in standard browsers
		 */
		normalize: function (e, chartPosition) {
			var chartX,
				chartY,
				ePos;
	
			// common IE normalizing
			e = e || window.event;
	
			// Framework specific normalizing (#1165)
			e = washMouseEvent(e);
	
			// More IE normalizing, needs to go after washMouseEvent
			if (!e.target) {
				e.target = e.srcElement;
			}
			
			// iOS (#2757)
			ePos = e.touches ?  (e.touches.length ? e.touches.item(0) : e.changedTouches[0]) : e;
	
			// Get mouse position
			if (!chartPosition) {
				this.chartPosition = chartPosition = offset(this.chart.container);
			}
	
			// chartX and chartY
			if (ePos.pageX === UNDEFINED) { // IE < 9. #886.
				chartX = mathMax(e.x, e.clientX - chartPosition.left); // #2005, #2129: the second case is 
					// for IE10 quirks mode within framesets
				chartY = e.y;
			} else {
				chartX = ePos.pageX - chartPosition.left;
				chartY = ePos.pageY - chartPosition.top;
			}
	
			return extend(e, {
				chartX: mathRound(chartX),
				chartY: mathRound(chartY)
			});
		},
	
		/**
		 * Get the click position in terms of axis values.
		 *
		 * @param {Object} e A pointer event
		 */
		getCoordinates: function (e) {
			var coordinates = {
					xAxis: [],
					yAxis: []
				};
	
			each(this.chart.axes, function (axis) {
				coordinates[axis.isXAxis ? 'xAxis' : 'yAxis'].push({
					axis: axis,
					value: axis.toValue(e[axis.horiz ? 'chartX' : 'chartY'])
				});
			});
			return coordinates;
		},
		
		/**
		 * Return the index in the tooltipPoints array, corresponding to pixel position in 
		 * the plot area.
		 */
		getIndex: function (e) {
			var chart = this.chart;
			return chart.inverted ? 
				chart.plotHeight + chart.plotTop - e.chartY : 
				e.chartX - chart.plotLeft;
		},
	
		/**
		 * With line type charts with a single tracker, get the point closest to the mouse.
		 * Run Point.onMouseOver and display tooltip for the point or points.
		 */
		runPointActions: function (e) {
			var pointer = this,
				chart = pointer.chart,
				series = chart.series,
				tooltip = chart.tooltip,
				followPointer,
				point,
				points,
				hoverPoint = chart.hoverPoint,
				hoverSeries = chart.hoverSeries,
				i,
				j,
				distance = chart.chartWidth,
				index = pointer.getIndex(e),
				anchor;
	
			// shared tooltip
			if (tooltip && pointer.options.tooltip.shared && !(hoverSeries && hoverSeries.noSharedTooltip)) {
				points = [];
	
				// loop over all series and find the ones with points closest to the mouse
				i = series.length;
				for (j = 0; j < i; j++) {
					if (series[j].visible &&
							series[j].options.enableMouseTracking !== false &&
							!series[j].noSharedTooltip && series[j].singularTooltips !== true && series[j].tooltipPoints.length) {
						point = series[j].tooltipPoints[index];
						if (point && point.series) { // not a dummy point, #1544
							point._dist = mathAbs(index - point.clientX);
							distance = mathMin(distance, point._dist);
							points.push(point);
						}
					}
				}
				// remove furthest points
				i = points.length;
				while (i--) {
					if (points[i]._dist > distance) {
						points.splice(i, 1);
					}
				}
				// refresh the tooltip if necessary
				if (points.length && (points[0].clientX !== pointer.hoverX)) {
					tooltip.refresh(points, e);
					pointer.hoverX = points[0].clientX;
				}
			}
	
			// Separate tooltip and general mouse events
			followPointer = hoverSeries && hoverSeries.tooltipOptions.followPointer;
			if (hoverSeries && hoverSeries.tracker && !followPointer) { // #2584, #2830
	
				// get the point
				point = hoverSeries.tooltipPoints[index];
	
				// a new point is hovered, refresh the tooltip
				if (point && point !== hoverPoint) {
	
					// trigger the events
					point.onMouseOver(e);
	
				}
				
			} else if (tooltip && followPointer && !tooltip.isHidden) {
				anchor = tooltip.getAnchor([{}], e);
				tooltip.updatePosition({ plotX: anchor[0], plotY: anchor[1] });
			}
	
			// Start the event listener to pick up the tooltip 
			if (tooltip && !pointer._onDocumentMouseMove) {
				pointer._onDocumentMouseMove = function (e) {
					if (charts[hoverChartIndex]) {
						charts[hoverChartIndex].pointer.onDocumentMouseMove(e);
					}
				};
				addEvent(doc, 'mousemove', pointer._onDocumentMouseMove);
			}
	
			// Draw independent crosshairs
			each(chart.axes, function (axis) {
				axis.drawCrosshair(e, pick(point, hoverPoint));
			});
		},
	
	
	
		/**
		 * Reset the tracking by hiding the tooltip, the hover series state and the hover point
		 * 
		 * @param allowMove {Boolean} Instead of destroying the tooltip altogether, allow moving it if possible
		 */
		reset: function (allowMove, delay) {
			var pointer = this,
				chart = pointer.chart,
				hoverSeries = chart.hoverSeries,
				hoverPoint = chart.hoverPoint,
				tooltip = chart.tooltip,
				tooltipPoints = tooltip && tooltip.shared ? chart.hoverPoints : hoverPoint;
				
			// Narrow in allowMove
			allowMove = allowMove && tooltip && tooltipPoints;
				
			// Check if the points have moved outside the plot area, #1003
			if (allowMove && splat(tooltipPoints)[0].plotX === UNDEFINED) {
				allowMove = false;
			}	
	
			// Just move the tooltip, #349
			if (allowMove) {
				tooltip.refresh(tooltipPoints);
				if (hoverPoint) { // #2500
					hoverPoint.setState(hoverPoint.state, true);
				}
	
			// Full reset
			} else {
	
				if (hoverPoint) {
					hoverPoint.onMouseOut();
				}
	
				if (hoverSeries) {
					hoverSeries.onMouseOut();
				}
	
				if (tooltip) {
					tooltip.hide(delay);
				}
	
				if (pointer._onDocumentMouseMove) {
					removeEvent(doc, 'mousemove', pointer._onDocumentMouseMove);
					pointer._onDocumentMouseMove = null;
				}
	
				// Remove crosshairs
				each(chart.axes, function (axis) {
					axis.hideCrosshair();
				});
				
				pointer.hoverX = null;
	
			}
		},
	
		/**
		 * Scale series groups to a certain scale and translation
		 */
		scaleGroups: function (attribs, clip) {
	
			var chart = this.chart,
				seriesAttribs;
	
			// Scale each series
			each(chart.series, function (series) {
				seriesAttribs = attribs || series.getPlotBox(); // #1701
				if (series.xAxis && series.xAxis.zoomEnabled) {
					series.group.attr(seriesAttribs);
					if (series.markerGroup) {
						series.markerGroup.attr(seriesAttribs);
						series.markerGroup.clip(clip ? chart.clipRect : null);
					}
					if (series.dataLabelsGroup) {
						series.dataLabelsGroup.attr(seriesAttribs);
					}
				}
			});
			
			// Clip
			chart.clipRect.attr(clip || chart.clipBox);
		},
	
		/**
		 * Start a drag operation
		 */
		dragStart: function (e) {
			var chart = this.chart;
	
			// Record the start position
			chart.mouseIsDown = e.type;
			chart.cancelClick = false;
			chart.mouseDownX = this.mouseDownX = e.chartX;
			chart.mouseDownY = this.mouseDownY = e.chartY;
		},
	
		/**
		 * Perform a drag operation in response to a mousemove event while the mouse is down
		 */
		drag: function (e) {
	
			var chart = this.chart,
				chartOptions = chart.options.chart,
				chartX = e.chartX,
				chartY = e.chartY,
				zoomHor = this.zoomHor,
				zoomVert = this.zoomVert,
				plotLeft = chart.plotLeft,
				plotTop = chart.plotTop,
				plotWidth = chart.plotWidth,
				plotHeight = chart.plotHeight,
				clickedInside,
				size,
				mouseDownX = this.mouseDownX,
				mouseDownY = this.mouseDownY,
				panKey = chartOptions.panKey && e[chartOptions.panKey + 'Key'];
	
			// If the mouse is outside the plot area, adjust to cooordinates
			// inside to prevent the selection marker from going outside
			if (chartX < plotLeft) {
				chartX = plotLeft;
			} else if (chartX > plotLeft + plotWidth) {
				chartX = plotLeft + plotWidth;
			}
	
			if (chartY < plotTop) {
				chartY = plotTop;
			} else if (chartY > plotTop + plotHeight) {
				chartY = plotTop + plotHeight;
			}
			
			// determine if the mouse has moved more than 10px
			this.hasDragged = Math.sqrt(
				Math.pow(mouseDownX - chartX, 2) +
				Math.pow(mouseDownY - chartY, 2)
			);
			
			if (this.hasDragged > 10) {
				clickedInside = chart.isInsidePlot(mouseDownX - plotLeft, mouseDownY - plotTop);
	
				// make a selection
				if (chart.hasCartesianSeries && (this.zoomX || this.zoomY) && clickedInside && !panKey) {
					if (!this.selectionMarker) {
						this.selectionMarker = chart.renderer.rect(
							plotLeft,
							plotTop,
							zoomHor ? 1 : plotWidth,
							zoomVert ? 1 : plotHeight,
							0
						)
						.attr({
							fill: chartOptions.selectionMarkerFill || 'rgba(69,114,167,0.25)',
							zIndex: 7
						})
						.add();
					}
				}
	
				// adjust the width of the selection marker
				if (this.selectionMarker && zoomHor) {
					size = chartX - mouseDownX;
					this.selectionMarker.attr({
						width: mathAbs(size),
						x: (size > 0 ? 0 : size) + mouseDownX
					});
				}
				// adjust the height of the selection marker
				if (this.selectionMarker && zoomVert) {
					size = chartY - mouseDownY;
					this.selectionMarker.attr({
						height: mathAbs(size),
						y: (size > 0 ? 0 : size) + mouseDownY
					});
				}
	
				// panning
				if (clickedInside && !this.selectionMarker && chartOptions.panning) {
					chart.pan(e, chartOptions.panning);
				}
			}
		},
	
		/**
		 * On mouse up or touch end across the entire document, drop the selection.
		 */
		drop: function (e) {
			var chart = this.chart,
				hasPinched = this.hasPinched;
	
			if (this.selectionMarker) {
				var selectionData = {
						xAxis: [],
						yAxis: [],
						originalEvent: e.originalEvent || e
					},
					selectionBox = this.selectionMarker,
					selectionLeft = selectionBox.attr ? selectionBox.attr('x') : selectionBox.x,
					selectionTop = selectionBox.attr ? selectionBox.attr('y') : selectionBox.y,
					selectionWidth = selectionBox.attr ? selectionBox.attr('width') : selectionBox.width,
					selectionHeight = selectionBox.attr ? selectionBox.attr('height') : selectionBox.height,
					runZoom;
	
				// a selection has been made
				if (this.hasDragged || hasPinched) {
	
					// record each axis' min and max
					each(chart.axes, function (axis) {
						if (axis.zoomEnabled) {
							var horiz = axis.horiz,
								minPixelPadding = e.type === 'touchend' ? axis.minPixelPadding: 0, // #1207, #3075
								selectionMin = axis.toValue((horiz ? selectionLeft : selectionTop) + minPixelPadding),
								selectionMax = axis.toValue((horiz ? selectionLeft + selectionWidth : selectionTop + selectionHeight) - minPixelPadding);
	
							if (!isNaN(selectionMin) && !isNaN(selectionMax)) { // #859
								selectionData[axis.coll].push({
									axis: axis,
									min: mathMin(selectionMin, selectionMax), // for reversed axes,
									max: mathMax(selectionMin, selectionMax)
								});
								runZoom = true;
							}
						}
					});
					if (runZoom) {
						fireEvent(chart, 'selection', selectionData, function (args) { 
							chart.zoom(extend(args, hasPinched ? { animation: false } : null)); 
						});
					}
	
				}
				this.selectionMarker = this.selectionMarker.destroy();
	
				// Reset scaling preview
				if (hasPinched) {
					this.scaleGroups();
				}
			}
	
			// Reset all
			if (chart) { // it may be destroyed on mouse up - #877
				css(chart.container, { cursor: chart._cursor });
				chart.cancelClick = this.hasDragged > 10; // #370
				chart.mouseIsDown = this.hasDragged = this.hasPinched = false;
				this.pinchDown = [];
			}
		},
	
		onContainerMouseDown: function (e) {
	
			e = this.normalize(e);
	
			// issue #295, dragging not always working in Firefox
			if (e.preventDefault) {
				e.preventDefault();
			}
			
			this.dragStart(e);
		},
	
		
	
		onDocumentMouseUp: function (e) {
			if (charts[hoverChartIndex]) {
				charts[hoverChartIndex].pointer.drop(e);
			}
		},
	
		/**
		 * Special handler for mouse move that will hide the tooltip when the mouse leaves the plotarea.
		 * Issue #149 workaround. The mouseleave event does not always fire. 
		 */
		onDocumentMouseMove: function (e) {
			var chart = this.chart,
				chartPosition = this.chartPosition,
				hoverSeries = chart.hoverSeries;
	
			e = this.normalize(e, chartPosition);
	
			// If we're outside, hide the tooltip
			if (chartPosition && hoverSeries && !this.inClass(e.target, 'highcharts-tracker') &&
					!chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop)) {
				this.reset();
			}
		},
	
		/**
		 * When mouse leaves the container, hide the tooltip.
		 */
		onContainerMouseLeave: function () {
			var chart = charts[hoverChartIndex];
			if (chart) {
				chart.pointer.reset();
				chart.pointer.chartPosition = null; // also reset the chart position, used in #149 fix
			}
		},
	
		// The mousemove, touchmove and touchstart event handler
		onContainerMouseMove: function (e) {
	
			var chart = this.chart;
	
			hoverChartIndex = chart.index;
	
			e = this.normalize(e);		
			e.returnValue = false; // #2251, #3224
			
			if (chart.mouseIsDown === 'mousedown') {
				this.drag(e);
			} 
			
			// Show the tooltip and run mouse over events (#977)
			if ((this.inClass(e.target, 'highcharts-tracker') || 
					chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop)) && !chart.openMenu) {
				this.runPointActions(e);
			}
		},
	
		/**
		 * Utility to detect whether an element has, or has a parent with, a specific
		 * class name. Used on detection of tracker objects and on deciding whether
		 * hovering the tooltip should cause the active series to mouse out.
		 */
		inClass: function (element, className) {
			var elemClassName;
			while (element) {
				elemClassName = attr(element, 'class');
				if (elemClassName) {
					if (elemClassName.indexOf(className) !== -1) {
						return true;
					} else if (elemClassName.indexOf(PREFIX + 'container') !== -1) {
						return false;
					}
				}
				element = element.parentNode;
			}		
		},
	
		onTrackerMouseOut: function (e) {
			var series = this.chart.hoverSeries,
				relatedTarget = e.relatedTarget || e.toElement,
				relatedSeries = relatedTarget && relatedTarget.point && relatedTarget.point.series; // #2499
			
			if (series && !series.options.stickyTracking && !this.inClass(relatedTarget, PREFIX + 'tooltip') &&
					relatedSeries !== series) {
				series.onMouseOut();
			}
		},
	
		onContainerClick: function (e) {
			var chart = this.chart,
				hoverPoint = chart.hoverPoint, 
				plotLeft = chart.plotLeft,
				plotTop = chart.plotTop;
			
			e = this.normalize(e);
			e.cancelBubble = true; // IE specific
	
			if (!chart.cancelClick) {
				
				// On tracker click, fire the series and point events. #783, #1583
				if (hoverPoint && this.inClass(e.target, PREFIX + 'tracker')) {
	
					// the series click event
					fireEvent(hoverPoint.series, 'click', extend(e, {
						point: hoverPoint
					}));
	
					// the point click event
					if (chart.hoverPoint) { // it may be destroyed (#1844)
						hoverPoint.firePointEvent('click', e);
					}
	
				// When clicking outside a tracker, fire a chart event
				} else {
					extend(e, this.getCoordinates(e));
	
					// fire a click event in the chart
					if (chart.isInsidePlot(e.chartX - plotLeft, e.chartY - plotTop)) {
						fireEvent(chart, 'click', e);
					}
				}
	
	
			}
		},
	
		/**
		 * Set the JS DOM events on the container and document. This method should contain
		 * a one-to-one assignment between methods and their handlers. Any advanced logic should
		 * be moved to the handler reflecting the event's name.
		 */
		setDOMEvents: function () {
	
			var pointer = this,
				container = pointer.chart.container;
	
			container.onmousedown = function (e) {
				pointer.onContainerMouseDown(e);
			};
			container.onmousemove = function (e) {
				pointer.onContainerMouseMove(e);
			};
			container.onclick = function (e) {
				pointer.onContainerClick(e);
			};
			addEvent(container, 'mouseleave', pointer.onContainerMouseLeave);
			if (chartCount === 1) {
				addEvent(doc, 'mouseup', pointer.onDocumentMouseUp);
			}
			if (hasTouch) {
				container.ontouchstart = function (e) {
					pointer.onContainerTouchStart(e);
				};
				container.ontouchmove = function (e) {
					pointer.onContainerTouchMove(e);
				};
				if (chartCount === 1) {
					addEvent(doc, 'touchend', pointer.onDocumentTouchEnd);
				}
			}
			
		},
	
		/**
		 * Destroys the Pointer object and disconnects DOM events.
		 */
		destroy: function () {
			var prop;
	
			removeEvent(this.chart.container, 'mouseleave', this.onContainerMouseLeave);
			if (!chartCount) {
				removeEvent(doc, 'mouseup', this.onDocumentMouseUp);
				removeEvent(doc, 'touchend', this.onDocumentTouchEnd);
			}
	
			// memory and CPU leak
			clearInterval(this.tooltipTimeout);
	
			for (prop in this) {
				this[prop] = null;
			}
		}
	};
	
	
	/* Support for touch devices */
	extend(Highcharts.Pointer.prototype, {
	
		/**
		 * Run translation operations
		 */
		pinchTranslate: function (pinchDown, touches, transform, selectionMarker, clip, lastValidTouch) {
			if (this.zoomHor || this.pinchHor) {
				this.pinchTranslateDirection(true, pinchDown, touches, transform, selectionMarker, clip, lastValidTouch);
			}
			if (this.zoomVert || this.pinchVert) {
				this.pinchTranslateDirection(false, pinchDown, touches, transform, selectionMarker, clip, lastValidTouch);
			}
		},
	
		/**
		 * Run translation operations for each direction (horizontal and vertical) independently
		 */
		pinchTranslateDirection: function (horiz, pinchDown, touches, transform, selectionMarker, clip, lastValidTouch, forcedScale) {
			var chart = this.chart,
				xy = horiz ? 'x' : 'y',
				XY = horiz ? 'X' : 'Y',
				sChartXY = 'chart' + XY,
				wh = horiz ? 'width' : 'height',
				plotLeftTop = chart['plot' + (horiz ? 'Left' : 'Top')],
				selectionWH,
				selectionXY,
				clipXY,
				scale = forcedScale || 1,
				inverted = chart.inverted,
				bounds = chart.bounds[horiz ? 'h' : 'v'],
				singleTouch = pinchDown.length === 1,
				touch0Start = pinchDown[0][sChartXY],
				touch0Now = touches[0][sChartXY],
				touch1Start = !singleTouch && pinchDown[1][sChartXY],
				touch1Now = !singleTouch && touches[1][sChartXY],
				outOfBounds,
				transformScale,
				scaleKey,
				setScale = function () {
					if (!singleTouch && mathAbs(touch0Start - touch1Start) > 20) { // Don't zoom if fingers are too close on this axis
						scale = forcedScale || mathAbs(touch0Now - touch1Now) / mathAbs(touch0Start - touch1Start); 
					}
					
					clipXY = ((plotLeftTop - touch0Now) / scale) + touch0Start;
					selectionWH = chart['plot' + (horiz ? 'Width' : 'Height')] / scale;
				};
	
			// Set the scale, first pass
			setScale();
	
			selectionXY = clipXY; // the clip position (x or y) is altered if out of bounds, the selection position is not
	
			// Out of bounds
			if (selectionXY < bounds.min) {
				selectionXY = bounds.min;
				outOfBounds = true;
			} else if (selectionXY + selectionWH > bounds.max) {
				selectionXY = bounds.max - selectionWH;
				outOfBounds = true;
			}
			
			// Is the chart dragged off its bounds, determined by dataMin and dataMax?
			if (outOfBounds) {
	
				// Modify the touchNow position in order to create an elastic drag movement. This indicates
				// to the user that the chart is responsive but can't be dragged further.
				touch0Now -= 0.8 * (touch0Now - lastValidTouch[xy][0]);
				if (!singleTouch) {
					touch1Now -= 0.8 * (touch1Now - lastValidTouch[xy][1]);
				}
	
				// Set the scale, second pass to adapt to the modified touchNow positions
				setScale();
	
			} else {
				lastValidTouch[xy] = [touch0Now, touch1Now];
			}
	
			// Set geometry for clipping, selection and transformation
			if (!inverted) { // TODO: implement clipping for inverted charts
				clip[xy] = clipXY - plotLeftTop;
				clip[wh] = selectionWH;
			}
			scaleKey = inverted ? (horiz ? 'scaleY' : 'scaleX') : 'scale' + XY;
			transformScale = inverted ? 1 / scale : scale;
	
			selectionMarker[wh] = selectionWH;
			selectionMarker[xy] = selectionXY;
			transform[scaleKey] = scale;
			transform['translate' + XY] = (transformScale * plotLeftTop) + (touch0Now - (transformScale * touch0Start));
		},
		
		/**
		 * Handle touch events with two touches
		 */
		pinch: function (e) {
	
			var self = this,
				chart = self.chart,
				pinchDown = self.pinchDown,
				followTouchMove = self.followTouchMove,
				touches = e.touches,
				touchesLength = touches.length,
				lastValidTouch = self.lastValidTouch,
				hasZoom = self.hasZoom,
				selectionMarker = self.selectionMarker,
				transform = {},
				fireClickEvent = touchesLength === 1 && ((self.inClass(e.target, PREFIX + 'tracker') && 
					chart.runTrackerClick) || self.runChartClick),
				clip = {};
	
			// On touch devices, only proceed to trigger click if a handler is defined
			if ((hasZoom || followTouchMove) && !fireClickEvent) {
				e.preventDefault();
			}
			
			// Normalize each touch
			map(touches, function (e) {
				return self.normalize(e);
			});
			
			// Register the touch start position
			if (e.type === 'touchstart') {
				each(touches, function (e, i) {
					pinchDown[i] = { chartX: e.chartX, chartY: e.chartY };
				});
				lastValidTouch.x = [pinchDown[0].chartX, pinchDown[1] && pinchDown[1].chartX];
				lastValidTouch.y = [pinchDown[0].chartY, pinchDown[1] && pinchDown[1].chartY];
	
				// Identify the data bounds in pixels
				each(chart.axes, function (axis) {
					if (axis.zoomEnabled) {
						var bounds = chart.bounds[axis.horiz ? 'h' : 'v'],
							minPixelPadding = axis.minPixelPadding,
							min = axis.toPixels(pick(axis.options.min, axis.dataMin)),
							max = axis.toPixels(pick(axis.options.max, axis.dataMax)),
							absMin = mathMin(min, max),
							absMax = mathMax(min, max);
	
						// Store the bounds for use in the touchmove handler
						bounds.min = mathMin(axis.pos, absMin - minPixelPadding);
						bounds.max = mathMax(axis.pos + axis.len, absMax + minPixelPadding);
					}
				});
				self.res = true; // reset on next move
			
			// Event type is touchmove, handle panning and pinching
			} else if (pinchDown.length) { // can be 0 when releasing, if touchend fires first
				
	
				// Set the marker
				if (!selectionMarker) {
					self.selectionMarker = selectionMarker = extend({
						destroy: noop
					}, chart.plotBox);
				}
				
				self.pinchTranslate(pinchDown, touches, transform, selectionMarker, clip, lastValidTouch);
	
				self.hasPinched = hasZoom;
	
				// Scale and translate the groups to provide visual feedback during pinching
				self.scaleGroups(transform, clip);
				
				// Optionally move the tooltip on touchmove
				if (!hasZoom && followTouchMove && touchesLength === 1) {
					this.runPointActions(self.normalize(e));
				} else if (self.res) {
					self.res = false;
					this.reset(false, 0);
				}
			}
		},
	
		onContainerTouchStart: function (e) {
			var chart = this.chart;
	
			hoverChartIndex = chart.index;
	
			if (e.touches.length === 1) {
	
				e = this.normalize(e);
	
				if (chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop)) {
	
					// Run mouse events and display tooltip etc
					this.runPointActions(e);
	
					this.pinch(e);
	
				} else {
					// Hide the tooltip on touching outside the plot area (#1203)
					this.reset();
				}
	
			} else if (e.touches.length === 2) {
				this.pinch(e);
			}   
		},
	
		onContainerTouchMove: function (e) {
			if (e.touches.length === 1 || e.touches.length === 2) {
				this.pinch(e);
			}
		},
	
		onDocumentTouchEnd: function (e) {
			if (charts[hoverChartIndex]) {
				charts[hoverChartIndex].pointer.drop(e);
			}
		}
	
	});
	if (win.PointerEvent || win.MSPointerEvent) {
		
		// The touches object keeps track of the points being touched at all times
		var touches = {},
			hasPointerEvent = !!win.PointerEvent,
			getWebkitTouches = function () {
				var key, fake = [];
				fake.item = function (i) { return this[i]; };
				for (key in touches) {
					if (touches.hasOwnProperty(key)) {
						fake.push({
							pageX: touches[key].pageX,
							pageY: touches[key].pageY,
							target: touches[key].target
						});
					}
				}
				return fake;
			},
			translateMSPointer = function (e, method, wktype, callback) {
				var p;
				e = e.originalEvent || e;
				if ((e.pointerType === 'touch' || e.pointerType === e.MSPOINTER_TYPE_TOUCH) && charts[hoverChartIndex]) {
					callback(e);
					p = charts[hoverChartIndex].pointer;
					p[method]({
						type: wktype,
						target: e.currentTarget,
						preventDefault: noop,
						touches: getWebkitTouches()
					});				
				}
			};
	
		/**
		 * Extend the Pointer prototype with methods for each event handler and more
		 */
		extend(Pointer.prototype, {
			onContainerPointerDown: function (e) {
				translateMSPointer(e, 'onContainerTouchStart', 'touchstart', function (e) {
					touches[e.pointerId] = { pageX: e.pageX, pageY: e.pageY, target: e.currentTarget };
				});
			},
			onContainerPointerMove: function (e) {
				translateMSPointer(e, 'onContainerTouchMove', 'touchmove', function (e) {
					touches[e.pointerId] = { pageX: e.pageX, pageY: e.pageY };
					if (!touches[e.pointerId].target) {
						touches[e.pointerId].target = e.currentTarget;
					}
				});
			},
			onDocumentPointerUp: function (e) {
				translateMSPointer(e, 'onContainerTouchEnd', 'touchend', function (e) {
					delete touches[e.pointerId];
				});
			},
	
			/**
			 * Add or remove the MS Pointer specific events
			 */
			batchMSEvents: function (fn) {
				fn(this.chart.container, hasPointerEvent ? 'pointerdown' : 'MSPointerDown', this.onContainerPointerDown);
				fn(this.chart.container, hasPointerEvent ? 'pointermove' : 'MSPointerMove', this.onContainerPointerMove);
				fn(doc, hasPointerEvent ? 'pointerup' : 'MSPointerUp', this.onDocumentPointerUp);
			}
		});
	
		// Disable default IE actions for pinch and such on chart element
		wrap(Pointer.prototype, 'init', function (proceed, chart, options) {
			proceed.call(this, chart, options);
			if (this.hasZoom || this.followTouchMove) {
				css(chart.container, {
					'-ms-touch-action': NONE,
					'touch-action': NONE
				});
			}
		});
	
		// Add IE specific touch events to chart
		wrap(Pointer.prototype, 'setDOMEvents', function (proceed) {
			proceed.apply(this);
			if (this.hasZoom || this.followTouchMove) {
				this.batchMSEvents(addEvent);
			}
		});
		// Destroy MS events also
		wrap(Pointer.prototype, 'destroy', function (proceed) {
			this.batchMSEvents(removeEvent);
			proceed.call(this);
		});
	}
	/**
	 * The overview of the chart's series
	 */
	var Legend = Highcharts.Legend = function (chart, options) {
		this.init(chart, options);
	};
	
	Legend.prototype = {
		
		/**
		 * Initialize the legend
		 */
		init: function (chart, options) {
			
			var legend = this,
				itemStyle = options.itemStyle,
				padding = pick(options.padding, 8),
				itemMarginTop = options.itemMarginTop || 0;
		
			this.options = options;
	
			if (!options.enabled) {
				return;
			}
		
			legend.itemStyle = itemStyle;
			legend.itemHiddenStyle = merge(itemStyle, options.itemHiddenStyle);
			legend.itemMarginTop = itemMarginTop;
			legend.padding = padding;
			legend.initialItemX = padding;
			legend.initialItemY = padding - 5; // 5 is the number of pixels above the text
			legend.maxItemWidth = 0;
			legend.chart = chart;
			legend.itemHeight = 0;
			legend.lastLineHeight = 0;
			legend.symbolWidth = pick(options.symbolWidth, 16);
			legend.pages = [];
	
	
			// Render it
			legend.render();
	
			// move checkboxes
			addEvent(legend.chart, 'endResize', function () { 
				legend.positionCheckboxes();
			});
	
		},
	
		/**
		 * Set the colors for the legend item
		 * @param {Object} item A Series or Point instance
		 * @param {Object} visible Dimmed or colored
		 */
		colorizeItem: function (item, visible) {
			var legend = this,
				options = legend.options,
				legendItem = item.legendItem,
				legendLine = item.legendLine,
				legendSymbol = item.legendSymbol,
				hiddenColor = legend.itemHiddenStyle.color,
				textColor = visible ? options.itemStyle.color : hiddenColor,
				symbolColor = visible ? (item.legendColor || item.color || '#CCC') : hiddenColor,
				markerOptions = item.options && item.options.marker,
				symbolAttr = { fill: symbolColor },
				key,
				val;
			
			if (legendItem) {
				legendItem.css({ fill: textColor, color: textColor }); // color for #1553, oldIE
			}
			if (legendLine) {
				legendLine.attr({ stroke: symbolColor });
			}
			
			if (legendSymbol) {
				
				// Apply marker options
				if (markerOptions && legendSymbol.isMarker) { // #585
					symbolAttr.stroke = symbolColor;
					markerOptions = item.convertAttribs(markerOptions);
					for (key in markerOptions) {
						val = markerOptions[key];
						if (val !== UNDEFINED) {
							symbolAttr[key] = val;
						}
					}
				}
	
				legendSymbol.attr(symbolAttr);
			}
		},
	
		/**
		 * Position the legend item
		 * @param {Object} item A Series or Point instance
		 */
		positionItem: function (item) {
			var legend = this,
				options = legend.options,
				symbolPadding = options.symbolPadding,
				ltr = !options.rtl,
				legendItemPos = item._legendItemPos,
				itemX = legendItemPos[0],
				itemY = legendItemPos[1],
				checkbox = item.checkbox;
	
			if (item.legendGroup) {
				item.legendGroup.translate(
					ltr ? itemX : legend.legendWidth - itemX - 2 * symbolPadding - 4,
					itemY
				);
			}
	
			if (checkbox) {
				checkbox.x = itemX;
				checkbox.y = itemY;
			}
		},
	
		/**
		 * Destroy a single legend item
		 * @param {Object} item The series or point
		 */
		destroyItem: function (item) {
			var checkbox = item.checkbox;
	
			// destroy SVG elements
			each(['legendItem', 'legendLine', 'legendSymbol', 'legendGroup'], function (key) {
				if (item[key]) {
					item[key] = item[key].destroy();
				}
			});
	
			if (checkbox) {
				discardElement(item.checkbox);
			}
		},
	
		/**
		 * Destroys the legend.
		 */
		destroy: function () {
			var legend = this,
				legendGroup = legend.group,
				box = legend.box;
	
			if (box) {
				legend.box = box.destroy();
			}
	
			if (legendGroup) {
				legend.group = legendGroup.destroy();
			}
		},
	
		/**
		 * Position the checkboxes after the width is determined
		 */
		positionCheckboxes: function (scrollOffset) {
			var alignAttr = this.group.alignAttr,
				translateY,
				clipHeight = this.clipHeight || this.legendHeight;
	
			if (alignAttr) {
				translateY = alignAttr.translateY;
				each(this.allItems, function (item) {
					var checkbox = item.checkbox,
						top;
					
					if (checkbox) {
						top = (translateY + checkbox.y + (scrollOffset || 0) + 3);
						css(checkbox, {
							left: (alignAttr.translateX + item.checkboxOffset + checkbox.x - 20) + PX,
							top: top + PX,
							display: top > translateY - 6 && top < translateY + clipHeight - 6 ? '' : NONE
						});
					}
				});
			}
		},
		
		/**
		 * Render the legend title on top of the legend
		 */
		renderTitle: function () {
			var options = this.options,
				padding = this.padding,
				titleOptions = options.title,
				titleHeight = 0,
				bBox;
			
			if (titleOptions.text) {
				if (!this.title) {
					this.title = this.chart.renderer.label(titleOptions.text, padding - 3, padding - 4, null, null, null, null, null, 'legend-title')
						.attr({ zIndex: 1 })
						.css(titleOptions.style)
						.add(this.group);
				}
				bBox = this.title.getBBox();
				titleHeight = bBox.height;
				this.offsetWidth = bBox.width; // #1717
				this.contentGroup.attr({ translateY: titleHeight });
			}
			this.titleHeight = titleHeight;
		},
	
		/**
		 * Render a single specific legend item
		 * @param {Object} item A series or point
		 */
		renderItem: function (item) {
			var legend = this,
				chart = legend.chart,
				renderer = chart.renderer,
				options = legend.options,
				horizontal = options.layout === 'horizontal',
				symbolWidth = legend.symbolWidth,
				symbolPadding = options.symbolPadding,
				itemStyle = legend.itemStyle,
				itemHiddenStyle = legend.itemHiddenStyle,
				padding = legend.padding,
				itemDistance = horizontal ? pick(options.itemDistance, 20) : 0,
				ltr = !options.rtl,
				itemHeight,
				widthOption = options.width,
				itemMarginBottom = options.itemMarginBottom || 0,
				itemMarginTop = legend.itemMarginTop,
				initialItemX = legend.initialItemX,
				bBox,
				itemWidth,
				li = item.legendItem,
				series = item.series && item.series.drawLegendSymbol ? item.series : item,
				seriesOptions = series.options,
				showCheckbox = legend.createCheckboxForItem && seriesOptions && seriesOptions.showCheckbox,
				useHTML = options.useHTML;
	
			if (!li) { // generate it once, later move it
	
				// Generate the group box
				// A group to hold the symbol and text. Text is to be appended in Legend class.
				item.legendGroup = renderer.g('legend-item')
					.attr({ zIndex: 1 })
					.add(legend.scrollGroup);
	
				// Generate the list item text and add it to the group
				item.legendItem = li = renderer.text(
						options.labelFormat ? format(options.labelFormat, item) : options.labelFormatter.call(item),
						ltr ? symbolWidth + symbolPadding : -symbolPadding,
						legend.baseline || 0,
						useHTML
					)
					.css(merge(item.visible ? itemStyle : itemHiddenStyle)) // merge to prevent modifying original (#1021)
					.attr({
						align: ltr ? 'left' : 'right',
						zIndex: 2
					})
					.add(item.legendGroup);
	
				// Get the baseline for the first item - the font size is equal for all
				if (!legend.baseline) {
					legend.baseline = renderer.fontMetrics(itemStyle.fontSize, li).f + 3 + itemMarginTop;
					li.attr('y', legend.baseline);
				}
	
				// Draw the legend symbol inside the group box
				series.drawLegendSymbol(legend, item);
	
				if (legend.setItemEvents) {
					legend.setItemEvents(item, li, useHTML, itemStyle, itemHiddenStyle);
				}			
	
				// Colorize the items
				legend.colorizeItem(item, item.visible);
	
				// add the HTML checkbox on top
				if (showCheckbox) {
					legend.createCheckboxForItem(item);				
				}
			}
	
			// calculate the positions for the next line
			bBox = li.getBBox();
	
			itemWidth = item.checkboxOffset = 
				options.itemWidth || 
				item.legendItemWidth || 
				symbolWidth + symbolPadding + bBox.width + itemDistance + (showCheckbox ? 20 : 0);
			legend.itemHeight = itemHeight = mathRound(item.legendItemHeight || bBox.height);
	
			// if the item exceeds the width, start a new line
			if (horizontal && legend.itemX - initialItemX + itemWidth >
					(widthOption || (chart.chartWidth - 2 * padding - initialItemX - options.x))) {
				legend.itemX = initialItemX;
				legend.itemY += itemMarginTop + legend.lastLineHeight + itemMarginBottom;
				legend.lastLineHeight = 0; // reset for next line
			}
	
			// If the item exceeds the height, start a new column
			/*if (!horizontal && legend.itemY + options.y + itemHeight > chart.chartHeight - spacingTop - spacingBottom) {
				legend.itemY = legend.initialItemY;
				legend.itemX += legend.maxItemWidth;
				legend.maxItemWidth = 0;
			}*/
	
			// Set the edge positions
			legend.maxItemWidth = mathMax(legend.maxItemWidth, itemWidth);
			legend.lastItemY = itemMarginTop + legend.itemY + itemMarginBottom;
			legend.lastLineHeight = mathMax(itemHeight, legend.lastLineHeight); // #915
	
			// cache the position of the newly generated or reordered items
			item._legendItemPos = [legend.itemX, legend.itemY];
	
			// advance
			if (horizontal) {
				legend.itemX += itemWidth;
	
			} else {
				legend.itemY += itemMarginTop + itemHeight + itemMarginBottom;
				legend.lastLineHeight = itemHeight;
			}
	
			// the width of the widest item
			legend.offsetWidth = widthOption || mathMax(
				(horizontal ? legend.itemX - initialItemX - itemDistance : itemWidth) + padding,
				legend.offsetWidth
			);
		},
	
		/**
		 * Get all items, which is one item per series for normal series and one item per point
		 * for pie series.
		 */
		getAllItems: function () {
			var allItems = [];
			each(this.chart.series, function (series) {
				var seriesOptions = series.options;
	
				// Handle showInLegend. If the series is linked to another series, defaults to false.
				if (!pick(seriesOptions.showInLegend, !defined(seriesOptions.linkedTo) ? UNDEFINED : false, true)) {
					return;
				}
	
				// use points or series for the legend item depending on legendType
				allItems = allItems.concat(
						series.legendItems ||
						(seriesOptions.legendType === 'point' ?
								series.data :
								series)
				);
			});
			return allItems;
		},
	
		/**
		 * Render the legend. This method can be called both before and after
		 * chart.render. If called after, it will only rearrange items instead
		 * of creating new ones.
		 */
		render: function () {
			var legend = this,
				chart = legend.chart,
				renderer = chart.renderer,
				legendGroup = legend.group,
				allItems,
				display,
				legendWidth,
				legendHeight,
				box = legend.box,
				options = legend.options,
				padding = legend.padding,
				legendBorderWidth = options.borderWidth,
				legendBackgroundColor = options.backgroundColor;
	
			legend.itemX = legend.initialItemX;
			legend.itemY = legend.initialItemY;
			legend.offsetWidth = 0;
			legend.lastItemY = 0;
	
			if (!legendGroup) {
				legend.group = legendGroup = renderer.g('legend')
					.attr({ zIndex: 7 }) 
					.add();
				legend.contentGroup = renderer.g()
					.attr({ zIndex: 1 }) // above background
					.add(legendGroup);
				legend.scrollGroup = renderer.g()
					.add(legend.contentGroup);
			}
			
			legend.renderTitle();
	
			// add each series or point
			allItems = legend.getAllItems();
	
			// sort by legendIndex
			stableSort(allItems, function (a, b) {
				return ((a.options && a.options.legendIndex) || 0) - ((b.options && b.options.legendIndex) || 0);
			});
	
			// reversed legend
			if (options.reversed) {
				allItems.reverse();
			}
	
			legend.allItems = allItems;
			legend.display = display = !!allItems.length;
	
			// render the items
			each(allItems, function (item) {
				legend.renderItem(item); 
			});
	
			// Draw the border
			legendWidth = options.width || legend.offsetWidth;
			legendHeight = legend.lastItemY + legend.lastLineHeight + legend.titleHeight;
			
			
			legendHeight = legend.handleOverflow(legendHeight);
	
			if (legendBorderWidth || legendBackgroundColor) {
				legendWidth += padding;
				legendHeight += padding;
	
				if (!box) {
					legend.box = box = renderer.rect(
						0,
						0,
						legendWidth,
						legendHeight,
						options.borderRadius,
						legendBorderWidth || 0
					).attr({
						stroke: options.borderColor,
						'stroke-width': legendBorderWidth || 0,
						fill: legendBackgroundColor || NONE
					})
					.add(legendGroup)
					.shadow(options.shadow);
					box.isNew = true;
	
				} else if (legendWidth > 0 && legendHeight > 0) {
					box[box.isNew ? 'attr' : 'animate'](
						box.crisp({ width: legendWidth, height: legendHeight })
					);
					box.isNew = false;
				}
	
				// hide the border if no items
				box[display ? 'show' : 'hide']();
			}
			
			legend.legendWidth = legendWidth;
			legend.legendHeight = legendHeight;
	
			// Now that the legend width and height are established, put the items in the 
			// final position
			each(allItems, function (item) {
				legend.positionItem(item);
			});
	
			// 1.x compatibility: positioning based on style
			/*var props = ['left', 'right', 'top', 'bottom'],
				prop,
				i = 4;
			while (i--) {
				prop = props[i];
				if (options.style[prop] && options.style[prop] !== 'auto') {
					options[i < 2 ? 'align' : 'verticalAlign'] = prop;
					options[i < 2 ? 'x' : 'y'] = pInt(options.style[prop]) * (i % 2 ? -1 : 1);
				}
			}*/
	
			if (display) {
				legendGroup.align(extend({
					width: legendWidth,
					height: legendHeight
				}, options), true, 'spacingBox');
			}
	
			if (!chart.isResizing) {
				this.positionCheckboxes();
			}
		},
		
		/**
		 * Set up the overflow handling by adding navigation with up and down arrows below the
		 * legend.
		 */
		handleOverflow: function (legendHeight) {
			var legend = this,
				chart = this.chart,
				renderer = chart.renderer,
				options = this.options,
				optionsY = options.y,
				alignTop = options.verticalAlign === 'top',
				spaceHeight = chart.spacingBox.height + (alignTop ? -optionsY : optionsY) - this.padding,
				maxHeight = options.maxHeight,
				clipHeight,
				clipRect = this.clipRect,
				navOptions = options.navigation,
				animation = pick(navOptions.animation, true),
				arrowSize = navOptions.arrowSize || 12,
				nav = this.nav,
				pages = this.pages,
				lastY,
				allItems = this.allItems;
				
			// Adjust the height
			if (options.layout === 'horizontal') {
				spaceHeight /= 2;
			}
			if (maxHeight) {
				spaceHeight = mathMin(spaceHeight, maxHeight);
			}
			
			// Reset the legend height and adjust the clipping rectangle
			pages.length = 0;
			if (legendHeight > spaceHeight && !options.useHTML) {
	
				this.clipHeight = clipHeight = mathMax(spaceHeight - 20 - this.titleHeight - this.padding, 0);
				this.currentPage = pick(this.currentPage, 1);
				this.fullHeight = legendHeight;
				
				// Fill pages with Y positions so that the top of each a legend item defines
				// the scroll top for each page (#2098)
				each(allItems, function (item, i) {
					var y = item._legendItemPos[1],
						h = mathRound(item.legendItem.getBBox().height),
						len = pages.length;
					
					if (!len || (y - pages[len - 1] > clipHeight && (lastY || y) !== pages[len - 1])) {
						pages.push(lastY || y);
						len++;
					}
					
					if (i === allItems.length - 1 && y + h - pages[len - 1] > clipHeight) {
						pages.push(y);
					}
					if (y !== lastY) {
						lastY = y;
					}
				});
	
				// Only apply clipping if needed. Clipping causes blurred legend in PDF export (#1787)
				if (!clipRect) {
					clipRect = legend.clipRect = renderer.clipRect(0, this.padding, 9999, 0);
					legend.contentGroup.clip(clipRect);
				}
				clipRect.attr({
					height: clipHeight
				});
				
				// Add navigation elements
				if (!nav) {
					this.nav = nav = renderer.g().attr({ zIndex: 1 }).add(this.group);
					this.up = renderer.symbol('triangle', 0, 0, arrowSize, arrowSize)
						.on('click', function () {
							legend.scroll(-1, animation);
						})
						.add(nav);
					this.pager = renderer.text('', 15, 10)
						.css(navOptions.style)
						.add(nav);
					this.down = renderer.symbol('triangle-down', 0, 0, arrowSize, arrowSize)
						.on('click', function () {
							legend.scroll(1, animation);
						})
						.add(nav);
				}
				
				// Set initial position
				legend.scroll(0);
				
				legendHeight = spaceHeight;
				
			} else if (nav) {
				clipRect.attr({
					height: chart.chartHeight
				});
				nav.hide();
				this.scrollGroup.attr({
					translateY: 1
				});
				this.clipHeight = 0; // #1379
			}
			
			return legendHeight;
		},
		
		/**
		 * Scroll the legend by a number of pages
		 * @param {Object} scrollBy
		 * @param {Object} animation
		 */
		scroll: function (scrollBy, animation) {
			var pages = this.pages,
				pageCount = pages.length,
				currentPage = this.currentPage + scrollBy,
				clipHeight = this.clipHeight,
				navOptions = this.options.navigation,
				activeColor = navOptions.activeColor,
				inactiveColor = navOptions.inactiveColor,
				pager = this.pager,
				padding = this.padding,
				scrollOffset;
			
			// When resizing while looking at the last page
			if (currentPage > pageCount) {
				currentPage = pageCount;
			}
			
			if (currentPage > 0) {
				
				if (animation !== UNDEFINED) {
					setAnimation(animation, this.chart);
				}
				
				this.nav.attr({
					translateX: padding,
					translateY: clipHeight + this.padding + 7 + this.titleHeight,
					visibility: VISIBLE
				});
				this.up.attr({
						fill: currentPage === 1 ? inactiveColor : activeColor
					})
					.css({
						cursor: currentPage === 1 ? 'default' : 'pointer'
					});
				pager.attr({
					text: currentPage + '/' + pageCount
				});
				this.down.attr({
						x: 18 + this.pager.getBBox().width, // adjust to text width
						fill: currentPage === pageCount ? inactiveColor : activeColor
					})
					.css({
						cursor: currentPage === pageCount ? 'default' : 'pointer'
					});
				
				scrollOffset = -pages[currentPage - 1] + this.initialItemY;
	
				this.scrollGroup.animate({
					translateY: scrollOffset
				});			
				
				this.currentPage = currentPage;
				this.positionCheckboxes(scrollOffset);
			}
				
		}
		
	};
	
	/*
	 * LegendSymbolMixin
	 */ 
	
	var LegendSymbolMixin = Highcharts.LegendSymbolMixin = {
	
		/**
		 * Get the series' symbol in the legend
		 * 
		 * @param {Object} legend The legend object
		 * @param {Object} item The series (this) or point
		 */
		drawRectangle: function (legend, item) {
			var symbolHeight = legend.options.symbolHeight || 12;
			
			item.legendSymbol = this.chart.renderer.rect(
				0,
				legend.baseline - 5 - (symbolHeight / 2),
				legend.symbolWidth,
				symbolHeight,
				legend.options.symbolRadius || 0
			).attr({
				zIndex: 3
			}).add(item.legendGroup);		
			
		},
	
		/**
		 * Get the series' symbol in the legend. This method should be overridable to create custom 
		 * symbols through Highcharts.seriesTypes[type].prototype.drawLegendSymbols.
		 * 
		 * @param {Object} legend The legend object
		 */
		drawLineMarker: function (legend) {
	
			var options = this.options,
				markerOptions = options.marker,
				radius,
				legendOptions = legend.options,
				legendSymbol,
				symbolWidth = legend.symbolWidth,
				renderer = this.chart.renderer,
				legendItemGroup = this.legendGroup,
				verticalCenter = legend.baseline - mathRound(renderer.fontMetrics(legendOptions.itemStyle.fontSize, this.legendItem).b * 0.3),
				attr;
	
			// Draw the line
			if (options.lineWidth) {
				attr = {
					'stroke-width': options.lineWidth
				};
				if (options.dashStyle) {
					attr.dashstyle = options.dashStyle;
				}
				this.legendLine = renderer.path([
					M,
					0,
					verticalCenter,
					L,
					symbolWidth,
					verticalCenter
				])
				.attr(attr)
				.add(legendItemGroup);
			}
			
			// Draw the marker
			if (markerOptions && markerOptions.enabled !== false) {
				radius = markerOptions.radius;
				this.legendSymbol = legendSymbol = renderer.symbol(
					this.symbol,
					(symbolWidth / 2) - radius,
					verticalCenter - radius,
					2 * radius,
					2 * radius
				)
				.add(legendItemGroup);
				legendSymbol.isMarker = true;
			}
		}
	};
	
	// Workaround for #2030, horizontal legend items not displaying in IE11 Preview,
	// and for #2580, a similar drawing flaw in Firefox 26.
	// TODO: Explore if there's a general cause for this. The problem may be related 
	// to nested group elements, as the legend item texts are within 4 group elements.
	if (/Trident\/7\.0/.test(userAgent) || isFirefox) {
		wrap(Legend.prototype, 'positionItem', function (proceed, item) {
			var legend = this,
				runPositionItem = function () { // If chart destroyed in sync, this is undefined (#2030)
					if (item._legendItemPos) {
						proceed.call(legend, item);
					}
				};
	
			// Do it now, for export and to get checkbox placement
			runPositionItem();
			
			// Do it after to work around the core issue
			setTimeout(runPositionItem);
		});
	}
	/**
	 * The chart class
	 * @param {Object} options
	 * @param {Function} callback Function to run when the chart has loaded
	 */
	function Chart() {
		this.init.apply(this, arguments);
	}
	
	Chart.prototype = {
	
		/**
		 * Initialize the chart
		 */
		init: function (userOptions, callback) {
	
			// Handle regular options
			var options,
				seriesOptions = userOptions.series; // skip merging data points to increase performance
	
			userOptions.series = null;
			options = merge(defaultOptions, userOptions); // do the merge
			options.series = userOptions.series = seriesOptions; // set back the series data
			this.userOptions = userOptions;
	
			var optionsChart = options.chart;
			
			// Create margin & spacing array
			this.margin = this.splashArray('margin', optionsChart);
			this.spacing = this.splashArray('spacing', optionsChart);
	
			var chartEvents = optionsChart.events;
	
			//this.runChartClick = chartEvents && !!chartEvents.click;
			this.bounds = { h: {}, v: {} }; // Pixel data bounds for touch zoom
	
			this.callback = callback;
			this.isResizing = 0;
			this.options = options;
			//chartTitleOptions = UNDEFINED;
			//chartSubtitleOptions = UNDEFINED;
	
			this.axes = [];
			this.series = [];
			this.hasCartesianSeries = optionsChart.showAxes;
			//this.axisOffset = UNDEFINED;
			//this.maxTicks = UNDEFINED; // handle the greatest amount of ticks on grouped axes
			//this.inverted = UNDEFINED;
			//this.loadingShown = UNDEFINED;
			//this.container = UNDEFINED;
			//this.chartWidth = UNDEFINED;
			//this.chartHeight = UNDEFINED;
			//this.marginRight = UNDEFINED;
			//this.marginBottom = UNDEFINED;
			//this.containerWidth = UNDEFINED;
			//this.containerHeight = UNDEFINED;
			//this.oldChartWidth = UNDEFINED;
			//this.oldChartHeight = UNDEFINED;
	
			//this.renderTo = UNDEFINED;
			//this.renderToClone = UNDEFINED;
	
			//this.spacingBox = UNDEFINED
	
			//this.legend = UNDEFINED;
	
			// Elements
			//this.chartBackground = UNDEFINED;
			//this.plotBackground = UNDEFINED;
			//this.plotBGImage = UNDEFINED;
			//this.plotBorder = UNDEFINED;
			//this.loadingDiv = UNDEFINED;
			//this.loadingSpan = UNDEFINED;
	
			var chart = this,
				eventType;
	
			// Add the chart to the global lookup
			chart.index = charts.length;
			charts.push(chart);
			chartCount++;
	
			// Set up auto resize
			if (optionsChart.reflow !== false) {
				addEvent(chart, 'load', function () {
					chart.initReflow();
				});
			}
	
			// Chart event handlers
			if (chartEvents) {
				for (eventType in chartEvents) {
					addEvent(chart, eventType, chartEvents[eventType]);
				}
			}
	
			chart.xAxis = [];
			chart.yAxis = [];
	
			// Expose methods and variables
			chart.animation = useCanVG ? false : pick(optionsChart.animation, true);
			chart.pointCount = chart.colorCounter = chart.symbolCounter = 0;
	
			chart.firstRender();
		},
	
		/**
		 * Initialize an individual series, called internally before render time
		 */
		initSeries: function (options) {
			var chart = this,
				optionsChart = chart.options.chart,
				type = options.type || optionsChart.type || optionsChart.defaultSeriesType,
				series,
				constr = seriesTypes[type];
	
			// No such series type
			if (!constr) {
				error(17, true);
			}
	
			series = new constr();
			series.init(this, options);
			return series;
		},
	
		/**
		 * Check whether a given point is within the plot area
		 *
		 * @param {Number} plotX Pixel x relative to the plot area
		 * @param {Number} plotY Pixel y relative to the plot area
		 * @param {Boolean} inverted Whether the chart is inverted
		 */
		isInsidePlot: function (plotX, plotY, inverted) {
			var x = inverted ? plotY : plotX,
				y = inverted ? plotX : plotY;
				
			return x >= 0 &&
				x <= this.plotWidth &&
				y >= 0 &&
				y <= this.plotHeight;
		},
	
		/**
		 * Adjust all axes tick amounts
		 */
		adjustTickAmounts: function () {
			if (this.options.chart.alignTicks !== false) {
				each(this.axes, function (axis) {
					axis.adjustTickAmount();
				});
			}
			this.maxTicks = null;
		},
	
		/**
		 * Redraw legend, axes or series based on updated data
		 *
		 * @param {Boolean|Object} animation Whether to apply animation, and optionally animation
		 *    configuration
		 */
		redraw: function (animation) {
			var chart = this,
				axes = chart.axes,
				series = chart.series,
				pointer = chart.pointer,
				legend = chart.legend,
				redrawLegend = chart.isDirtyLegend,
				hasStackedSeries,
				hasDirtyStacks,
				hasCartesianSeries = chart.hasCartesianSeries,
				isDirtyBox = chart.isDirtyBox, // todo: check if it has actually changed?
				seriesLength = series.length,
				i = seriesLength,
				serie,
				renderer = chart.renderer,
				isHiddenChart = renderer.isHidden(),
				afterRedraw = [];
				
			setAnimation(animation, chart);
			
			if (isHiddenChart) {
				chart.cloneRenderTo();
			}
	
			// Adjust title layout (reflow multiline text)
			chart.layOutTitles();
	
			// link stacked series
			while (i--) {
				serie = series[i];
	
				if (serie.options.stacking) {
					hasStackedSeries = true;
					
					if (serie.isDirty) {
						hasDirtyStacks = true;
						break;
					}
				}
			}
			if (hasDirtyStacks) { // mark others as dirty
				i = seriesLength;
				while (i--) {
					serie = series[i];
					if (serie.options.stacking) {
						serie.isDirty = true;
					}
				}
			}
	
			// handle updated data in the series
			each(series, function (serie) {
				if (serie.isDirty) { // prepare the data so axis can read it
					if (serie.options.legendType === 'point') {
						redrawLegend = true;
					}
				}
			});
	
			// handle added or removed series
			if (redrawLegend && legend.options.enabled) { // series or pie points are added or removed
				// draw legend graphics
				legend.render();
	
				chart.isDirtyLegend = false;
			}
	
			// reset stacks
			if (hasStackedSeries) {
				chart.getStacks();
			}
	
	
			if (hasCartesianSeries) {
				if (!chart.isResizing) {
	
					// reset maxTicks
					chart.maxTicks = null;
	
					// set axes scales
					each(axes, function (axis) {
						axis.setScale();
					});
				}
	
				chart.adjustTickAmounts();
			}
	
			chart.getMargins(); // #3098
	
			if (hasCartesianSeries) {
				// If one axis is dirty, all axes must be redrawn (#792, #2169)
				each(axes, function (axis) {
					if (axis.isDirty) {
						isDirtyBox = true;
					}
				});
	
				// redraw axes
				each(axes, function (axis) {
					
					// Fire 'afterSetExtremes' only if extremes are set
					if (axis.isDirtyExtremes) { // #821
						axis.isDirtyExtremes = false;
						afterRedraw.push(function () { // prevent a recursive call to chart.redraw() (#1119)
							fireEvent(axis, 'afterSetExtremes', extend(axis.eventArgs, axis.getExtremes())); // #747, #751
							delete axis.eventArgs;
						});
					}
					
					if (isDirtyBox || hasStackedSeries) {
						axis.redraw();
					}
				});
			}
			
			// the plot areas size has changed
			if (isDirtyBox) {
				chart.drawChartBox();
			}
	
	
			// redraw affected series
			each(series, function (serie) {
				if (serie.isDirty && serie.visible &&
						(!serie.isCartesian || serie.xAxis)) { // issue #153
					serie.redraw();
				}
			});
	
			// move tooltip or reset
			if (pointer) {
				pointer.reset(true);
			}
	
			// redraw if canvas
			renderer.draw();
	
			// fire the event
			fireEvent(chart, 'redraw'); // jQuery breaks this when calling it from addEvent. Overwrites chart.redraw
			
			if (isHiddenChart) {
				chart.cloneRenderTo(true);
			}
			
			// Fire callbacks that are put on hold until after the redraw
			each(afterRedraw, function (callback) {
				callback.call();
			});
		},
	
		/**
		 * Get an axis, series or point object by id.
		 * @param id {String} The id as given in the configuration options
		 */
		get: function (id) {
			var chart = this,
				axes = chart.axes,
				series = chart.series;
	
			var i,
				j,
				points;
	
			// search axes
			for (i = 0; i < axes.length; i++) {
				if (axes[i].options.id === id) {
					return axes[i];
				}
			}
	
			// search series
			for (i = 0; i < series.length; i++) {
				if (series[i].options.id === id) {
					return series[i];
				}
			}
	
			// search points
			for (i = 0; i < series.length; i++) {
				points = series[i].points || [];
				for (j = 0; j < points.length; j++) {
					if (points[j].id === id) {
						return points[j];
					}
				}
			}
			return null;
		},
	
		/**
		 * Create the Axis instances based on the config options
		 */
		getAxes: function () {
			var chart = this,
				options = this.options,
				xAxisOptions = options.xAxis = splat(options.xAxis || {}),
				yAxisOptions = options.yAxis = splat(options.yAxis || {}),
				optionsArray,
				axis;
	
			// make sure the options are arrays and add some members
			each(xAxisOptions, function (axis, i) {
				axis.index = i;
				axis.isX = true;
			});
	
			each(yAxisOptions, function (axis, i) {
				axis.index = i;
			});
	
			// concatenate all axis options into one array
			optionsArray = xAxisOptions.concat(yAxisOptions);
	
			each(optionsArray, function (axisOptions) {
				axis = new Axis(chart, axisOptions);
			});
	
			chart.adjustTickAmounts();
		},
	
	
		/**
		 * Get the currently selected points from all series
		 */
		getSelectedPoints: function () {
			var points = [];
			each(this.series, function (serie) {
				points = points.concat(grep(serie.points || [], function (point) {
					return point.selected;
				}));
			});
			return points;
		},
	
		/**
		 * Get the currently selected series
		 */
		getSelectedSeries: function () {
			return grep(this.series, function (serie) {
				return serie.selected;
			});
		},
	
		/**
		 * Generate stacks for each series and calculate stacks total values
		 */
		getStacks: function () {
			var chart = this;
	
			// reset stacks for each yAxis
			each(chart.yAxis, function (axis) {
				if (axis.stacks && axis.hasVisibleSeries) {
					axis.oldStacks = axis.stacks;
				}
			});
	
			each(chart.series, function (series) {
				if (series.options.stacking && (series.visible === true || chart.options.chart.ignoreHiddenSeries === false)) {
					series.stackKey = series.type + pick(series.options.stack, '');
				}
			});
		},	
	
		/**
		 * Show the title and subtitle of the chart
		 *
		 * @param titleOptions {Object} New title options
		 * @param subtitleOptions {Object} New subtitle options
		 *
		 */
		setTitle: function (titleOptions, subtitleOptions, redraw) {
			var chart = this,
				options = chart.options,
				chartTitleOptions,
				chartSubtitleOptions;
	
			chartTitleOptions = options.title = merge(options.title, titleOptions);
			chartSubtitleOptions = options.subtitle = merge(options.subtitle, subtitleOptions);
	
			// add title and subtitle
			each([
				['title', titleOptions, chartTitleOptions],
				['subtitle', subtitleOptions, chartSubtitleOptions]
			], function (arr) {
				var name = arr[0],
					title = chart[name],
					titleOptions = arr[1],
					chartTitleOptions = arr[2];
	
				if (title && titleOptions) {
					chart[name] = title = title.destroy(); // remove old
				}
				
				if (chartTitleOptions && chartTitleOptions.text && !title) {
					chart[name] = chart.renderer.text(
						chartTitleOptions.text,
						0,
						0,
						chartTitleOptions.useHTML
					)
					.attr({
						align: chartTitleOptions.align,
						'class': PREFIX + name,
						zIndex: chartTitleOptions.zIndex || 4
					})
					.css(chartTitleOptions.style)
					.add();
				}	
			});
			chart.layOutTitles(redraw);
		},
	
		/**
		 * Lay out the chart titles and cache the full offset height for use in getMargins
		 */
		layOutTitles: function (redraw) {
			var titleOffset = 0,
				title = this.title,
				subtitle = this.subtitle,
				options = this.options,
				titleOptions = options.title,
				subtitleOptions = options.subtitle,
				requiresDirtyBox,
				renderer = this.renderer,
				autoWidth = this.spacingBox.width - 44; // 44 makes room for default context button
	
			if (title) {
				title
					.css({ width: (titleOptions.width || autoWidth) + PX })
					.align(extend({ 
						y: renderer.fontMetrics(titleOptions.style.fontSize, title).b - 3
					}, titleOptions), false, 'spacingBox');
				
				if (!titleOptions.floating && !titleOptions.verticalAlign) {
					titleOffset = title.getBBox().height;
				}
			}
			if (subtitle) {
				subtitle
					.css({ width: (subtitleOptions.width || autoWidth) + PX })
					.align(extend({ 
						y: titleOffset + (titleOptions.margin - 13) + renderer.fontMetrics(titleOptions.style.fontSize, subtitle).b 
					}, subtitleOptions), false, 'spacingBox');
				
				if (!subtitleOptions.floating && !subtitleOptions.verticalAlign) {
					titleOffset = mathCeil(titleOffset + subtitle.getBBox().height);
				}
			}
	
			requiresDirtyBox = this.titleOffset !== titleOffset;				
			this.titleOffset = titleOffset; // used in getMargins
	
			if (!this.isDirtyBox && requiresDirtyBox) {
				this.isDirtyBox = requiresDirtyBox;
				// Redraw if necessary (#2719, #2744)		
				if (this.hasRendered && pick(redraw, true) && this.isDirtyBox) {
					this.redraw();
				}
			}
		},
	
		/**
		 * Get chart width and height according to options and container size
		 */
		getChartSize: function () {
			var chart = this,
				optionsChart = chart.options.chart,
				widthOption = optionsChart.width,
				heightOption = optionsChart.height,
				renderTo = chart.renderToClone || chart.renderTo;
	
			// get inner width and height from jQuery (#824)
			if (!defined(widthOption)) {
				chart.containerWidth = adapterRun(renderTo, 'width');
			}
			if (!defined(heightOption)) {
				chart.containerHeight = adapterRun(renderTo, 'height');
			}
			
			chart.chartWidth = mathMax(0, widthOption || chart.containerWidth || 600); // #1393, 1460
			chart.chartHeight = mathMax(0, pick(heightOption,
				// the offsetHeight of an empty container is 0 in standard browsers, but 19 in IE7:
				chart.containerHeight > 19 ? chart.containerHeight : 400));
		},
	
		/**
		 * Create a clone of the chart's renderTo div and place it outside the viewport to allow
		 * size computation on chart.render and chart.redraw
		 */
		cloneRenderTo: function (revert) {
			var clone = this.renderToClone,
				container = this.container;
			
			// Destroy the clone and bring the container back to the real renderTo div
			if (revert) {
				if (clone) {
					this.renderTo.appendChild(container);
					discardElement(clone);
					delete this.renderToClone;
				}
			
			// Set up the clone
			} else {
				if (container && container.parentNode === this.renderTo) {
					this.renderTo.removeChild(container); // do not clone this
				}
				this.renderToClone = clone = this.renderTo.cloneNode(0);
				css(clone, {
					position: ABSOLUTE,
					top: '-9999px',
					display: 'block' // #833
				});
				if (clone.style.setProperty) { // #2631
					clone.style.setProperty('display', 'block', 'important');
				}
				doc.body.appendChild(clone);
				if (container) {
					clone.appendChild(container);
				}
			}
		},
	
		/**
		 * Get the containing element, determine the size and create the inner container
		 * div to hold the chart
		 */
		getContainer: function () {
			var chart = this,
				container,
				optionsChart = chart.options.chart,
				chartWidth,
				chartHeight,
				renderTo,
				indexAttrName = 'data-highcharts-chart',
				oldChartIndex,
				containerId;
	
			chart.renderTo = renderTo = optionsChart.renderTo;
			containerId = PREFIX + idCounter++;
	
			if (isString(renderTo)) {
				chart.renderTo = renderTo = doc.getElementById(renderTo);
			}
			
			// Display an error if the renderTo is wrong
			if (!renderTo) {
				error(13, true);
			}
			
			// If the container already holds a chart, destroy it. The check for hasRendered is there
			// because web pages that are saved to disk from the browser, will preserve the data-highcharts-chart
			// attribute and the SVG contents, but not an interactive chart. So in this case,
			// charts[oldChartIndex] will point to the wrong chart if any (#2609).
			oldChartIndex = pInt(attr(renderTo, indexAttrName));
			if (!isNaN(oldChartIndex) && charts[oldChartIndex] && charts[oldChartIndex].hasRendered) {
				charts[oldChartIndex].destroy();
			}		
			
			// Make a reference to the chart from the div
			attr(renderTo, indexAttrName, chart.index);
	
			// remove previous chart
			renderTo.innerHTML = '';
	
			// If the container doesn't have an offsetWidth, it has or is a child of a node
			// that has display:none. We need to temporarily move it out to a visible
			// state to determine the size, else the legend and tooltips won't render
			// properly. The allowClone option is used in sparklines as a micro optimization,
			// saving about 1-2 ms each chart.
			if (!optionsChart.skipClone && !renderTo.offsetWidth) {
				chart.cloneRenderTo();
			}
	
			// get the width and height
			chart.getChartSize();
			chartWidth = chart.chartWidth;
			chartHeight = chart.chartHeight;
	
			// create the inner container
			chart.container = container = createElement(DIV, {
					className: PREFIX + 'container' +
						(optionsChart.className ? ' ' + optionsChart.className : ''),
					id: containerId
				}, extend({
					position: RELATIVE,
					overflow: HIDDEN, // needed for context menu (avoid scrollbars) and
						// content overflow in IE
					width: chartWidth + PX,
					height: chartHeight + PX,
					textAlign: 'left',
					lineHeight: 'normal', // #427
					zIndex: 0, // #1072
					'-webkit-tap-highlight-color': 'rgba(0,0,0,0)'
				}, optionsChart.style),
				chart.renderToClone || renderTo
			);
	
			// cache the cursor (#1650)
			chart._cursor = container.style.cursor;
	
			// Initialize the renderer
			chart.renderer =
				optionsChart.forExport ? // force SVG, used for SVG export
					new SVGRenderer(container, chartWidth, chartHeight, optionsChart.style, true) :
					new Renderer(container, chartWidth, chartHeight, optionsChart.style);
	
			if (useCanVG) {
				// If we need canvg library, extend and configure the renderer
				// to get the tracker for translating mouse events
				chart.renderer.create(chart, container, chartWidth, chartHeight);
			}
		},
	
		/**
		 * Calculate margins by rendering axis labels in a preliminary position. Title,
		 * subtitle and legend have already been rendered at this stage, but will be
		 * moved into their final positions
		 */
		getMargins: function () {
			var chart = this,
				spacing = chart.spacing,
				axisOffset,
				legend = chart.legend,
				margin = chart.margin,
				legendOptions = chart.options.legend,
				legendMargin = pick(legendOptions.margin, 20),
				legendX = legendOptions.x,
				legendY = legendOptions.y,
				align = legendOptions.align,
				verticalAlign = legendOptions.verticalAlign,
				titleOffset = chart.titleOffset;
	
			chart.resetMargins();
			axisOffset = chart.axisOffset;
	
			// Adjust for title and subtitle
			if (titleOffset && !defined(margin[0])) {
				chart.plotTop = mathMax(chart.plotTop, titleOffset + chart.options.title.margin + spacing[0]);
			}
			
			// Adjust for legend
			if (legend.display && !legendOptions.floating) {
				if (align === 'right') { // horizontal alignment handled first
					if (!defined(margin[1])) {
						chart.marginRight = mathMax(
							chart.marginRight,
							legend.legendWidth - legendX + legendMargin + spacing[1]
						);
					}
				} else if (align === 'left') {
					if (!defined(margin[3])) {
						chart.plotLeft = mathMax(
							chart.plotLeft,
							legend.legendWidth + legendX + legendMargin + spacing[3]
						);
					}
	
				} else if (verticalAlign === 'top') {
					if (!defined(margin[0])) {
						chart.plotTop = mathMax(
							chart.plotTop,
							legend.legendHeight + legendY + legendMargin + spacing[0]
						);
					}
	
				} else if (verticalAlign === 'bottom') {
					if (!defined(margin[2])) {
						chart.marginBottom = mathMax(
							chart.marginBottom,
							legend.legendHeight - legendY + legendMargin + spacing[2]
						);
					}
				}
			}
	
			// adjust for scroller
			if (chart.extraBottomMargin) {
				chart.marginBottom += chart.extraBottomMargin;
			}
			if (chart.extraTopMargin) {
				chart.plotTop += chart.extraTopMargin;
			}
	
			// pre-render axes to get labels offset width
			if (chart.hasCartesianSeries) {
				each(chart.axes, function (axis) {
					axis.getOffset();
				});
			}
			
			if (!defined(margin[3])) {
				chart.plotLeft += axisOffset[3];
			}
			if (!defined(margin[0])) {
				chart.plotTop += axisOffset[0];
			}
			if (!defined(margin[2])) {
				chart.marginBottom += axisOffset[2];
			}
			if (!defined(margin[1])) {
				chart.marginRight += axisOffset[1];
			}
	
			chart.setChartSize();
	
		},
	
		/**
		 * Resize the chart to its container if size is not explicitly set
		 */
		reflow: function (e) {
			var chart = this,
				optionsChart = chart.options.chart,
				renderTo = chart.renderTo,
				width = optionsChart.width || adapterRun(renderTo, 'width'),
				height = optionsChart.height || adapterRun(renderTo, 'height'),
				target = e ? e.target : win, // #805 - MooTools doesn't supply e
				doReflow = function () {
					if (chart.container) { // It may have been destroyed in the meantime (#1257)
						chart.setSize(width, height, false);
						chart.hasUserSize = null;
					}
				};
				
			// Width and height checks for display:none. Target is doc in IE8 and Opera,
			// win in Firefox, Chrome and IE9.
			if (!chart.hasUserSize && width && height && (target === win || target === doc)) {
				if (width !== chart.containerWidth || height !== chart.containerHeight) {
					clearTimeout(chart.reflowTimeout);
					if (e) { // Called from window.resize
						chart.reflowTimeout = setTimeout(doReflow, 100);
					} else { // Called directly (#2224)
						doReflow();
					}
				}
				chart.containerWidth = width;
				chart.containerHeight = height;
			}
		},
	
		/**
		 * Add the event handlers necessary for auto resizing
		 */
		initReflow: function () {
			var chart = this,
				reflow = function (e) {
					chart.reflow(e);
				};
				
			
			addEvent(win, 'resize', reflow);
			addEvent(chart, 'destroy', function () {
				removeEvent(win, 'resize', reflow);
			});
		},
	
		/**
		 * Resize the chart to a given width and height
		 * @param {Number} width
		 * @param {Number} height
		 * @param {Object|Boolean} animation
		 */
		setSize: function (width, height, animation) {
			var chart = this,
				chartWidth,
				chartHeight,
				fireEndResize;
	
			// Handle the isResizing counter
			chart.isResizing += 1;
			fireEndResize = function () {
				if (chart) {
					fireEvent(chart, 'endResize', null, function () {
						chart.isResizing -= 1;
					});
				}
			};
	
			// set the animation for the current process
			setAnimation(animation, chart);
	
			chart.oldChartHeight = chart.chartHeight;
			chart.oldChartWidth = chart.chartWidth;
			if (defined(width)) {
				chart.chartWidth = chartWidth = mathMax(0, mathRound(width));
				chart.hasUserSize = !!chartWidth;
			}
			if (defined(height)) {
				chart.chartHeight = chartHeight = mathMax(0, mathRound(height));
			}
	
			// Resize the container with the global animation applied if enabled (#2503)
			(globalAnimation ? animate : css)(chart.container, {
				width: chartWidth + PX,
				height: chartHeight + PX
			}, globalAnimation);
	
			chart.setChartSize(true);
			chart.renderer.setSize(chartWidth, chartHeight, animation);
	
			// handle axes
			chart.maxTicks = null;
			each(chart.axes, function (axis) {
				axis.isDirty = true;
				axis.setScale();
			});
	
			// make sure non-cartesian series are also handled
			each(chart.series, function (serie) {
				serie.isDirty = true;
			});
	
			chart.isDirtyLegend = true; // force legend redraw
			chart.isDirtyBox = true; // force redraw of plot and chart border
	
			chart.layOutTitles(); // #2857
			chart.getMargins();
	
			chart.redraw(animation);
	
	
			chart.oldChartHeight = null;
			fireEvent(chart, 'resize');
	
			// fire endResize and set isResizing back
			// If animation is disabled, fire without delay
			if (globalAnimation === false) {
				fireEndResize();
			} else { // else set a timeout with the animation duration
				setTimeout(fireEndResize, (globalAnimation && globalAnimation.duration) || 500);
			}
		},
	
		/**
		 * Set the public chart properties. This is done before and after the pre-render
		 * to determine margin sizes
		 */
		setChartSize: function (skipAxes) {
			var chart = this,
				inverted = chart.inverted,
				renderer = chart.renderer,
				chartWidth = chart.chartWidth,
				chartHeight = chart.chartHeight,
				optionsChart = chart.options.chart,
				spacing = chart.spacing,
				clipOffset = chart.clipOffset,
				clipX,
				clipY,
				plotLeft,
				plotTop,
				plotWidth,
				plotHeight,
				plotBorderWidth;
	
			chart.plotLeft = plotLeft = mathRound(chart.plotLeft);
			chart.plotTop = plotTop = mathRound(chart.plotTop);
			chart.plotWidth = plotWidth = mathMax(0, mathRound(chartWidth - plotLeft - chart.marginRight));
			chart.plotHeight = plotHeight = mathMax(0, mathRound(chartHeight - plotTop - chart.marginBottom));
	
			chart.plotSizeX = inverted ? plotHeight : plotWidth;
			chart.plotSizeY = inverted ? plotWidth : plotHeight;
			
			chart.plotBorderWidth = optionsChart.plotBorderWidth || 0;
	
			// Set boxes used for alignment
			chart.spacingBox = renderer.spacingBox = {
				x: spacing[3],
				y: spacing[0],
				width: chartWidth - spacing[3] - spacing[1],
				height: chartHeight - spacing[0] - spacing[2]
			};
			chart.plotBox = renderer.plotBox = {
				x: plotLeft,
				y: plotTop,
				width: plotWidth,
				height: plotHeight
			};
	
			plotBorderWidth = 2 * mathFloor(chart.plotBorderWidth / 2);
			clipX = mathCeil(mathMax(plotBorderWidth, clipOffset[3]) / 2);
			clipY = mathCeil(mathMax(plotBorderWidth, clipOffset[0]) / 2);
			chart.clipBox = {
				x: clipX, 
				y: clipY, 
				width: mathFloor(chart.plotSizeX - mathMax(plotBorderWidth, clipOffset[1]) / 2 - clipX), 
				height: mathMax(0, mathFloor(chart.plotSizeY - mathMax(plotBorderWidth, clipOffset[2]) / 2 - clipY))
			};
	
			if (!skipAxes) {
				each(chart.axes, function (axis) {
					axis.setAxisSize();
					axis.setAxisTranslation();
				});
			}
		},
	
		/**
		 * Initial margins before auto size margins are applied
		 */
		resetMargins: function () {
			var chart = this,
				spacing = chart.spacing,
				margin = chart.margin;
	
			chart.plotTop = pick(margin[0], spacing[0]);
			chart.marginRight = pick(margin[1], spacing[1]);
			chart.marginBottom = pick(margin[2], spacing[2]);
			chart.plotLeft = pick(margin[3], spacing[3]);
			chart.axisOffset = [0, 0, 0, 0]; // top, right, bottom, left
			chart.clipOffset = [0, 0, 0, 0];
		},
	
		/**
		 * Draw the borders and backgrounds for chart and plot area
		 */
		drawChartBox: function () {
			var chart = this,
				optionsChart = chart.options.chart,
				renderer = chart.renderer,
				chartWidth = chart.chartWidth,
				chartHeight = chart.chartHeight,
				chartBackground = chart.chartBackground,
				plotBackground = chart.plotBackground,
				plotBorder = chart.plotBorder,
				plotBGImage = chart.plotBGImage,
				chartBorderWidth = optionsChart.borderWidth || 0,
				chartBackgroundColor = optionsChart.backgroundColor,
				plotBackgroundColor = optionsChart.plotBackgroundColor,
				plotBackgroundImage = optionsChart.plotBackgroundImage,
				plotBorderWidth = optionsChart.plotBorderWidth || 0,
				mgn,
				bgAttr,
				plotLeft = chart.plotLeft,
				plotTop = chart.plotTop,
				plotWidth = chart.plotWidth,
				plotHeight = chart.plotHeight,
				plotBox = chart.plotBox,
				clipRect = chart.clipRect,
				clipBox = chart.clipBox;
	
			// Chart area
			mgn = chartBorderWidth + (optionsChart.shadow ? 8 : 0);
	
			if (chartBorderWidth || chartBackgroundColor) {
				if (!chartBackground) {
					
					bgAttr = {
						fill: chartBackgroundColor || NONE
					};
					if (chartBorderWidth) { // #980
						bgAttr.stroke = optionsChart.borderColor;
						bgAttr['stroke-width'] = chartBorderWidth;
					}
					chart.chartBackground = renderer.rect(mgn / 2, mgn / 2, chartWidth - mgn, chartHeight - mgn,
							optionsChart.borderRadius, chartBorderWidth)
						.attr(bgAttr)
						.addClass(PREFIX + 'background')
						.add()
						.shadow(optionsChart.shadow);
	
				} else { // resize
					chartBackground.animate(
						chartBackground.crisp({ width: chartWidth - mgn, height: chartHeight - mgn })
					);
				}
			}
	
	
			// Plot background
			if (plotBackgroundColor) {
				if (!plotBackground) {
					chart.plotBackground = renderer.rect(plotLeft, plotTop, plotWidth, plotHeight, 0)
						.attr({
							fill: plotBackgroundColor
						})
						.add()
						.shadow(optionsChart.plotShadow);
				} else {
					plotBackground.animate(plotBox);
				}
			}
			if (plotBackgroundImage) {
				if (!plotBGImage) {
					chart.plotBGImage = renderer.image(plotBackgroundImage, plotLeft, plotTop, plotWidth, plotHeight)
						.add();
				} else {
					plotBGImage.animate(plotBox);
				}
			}
			
			// Plot clip
			if (!clipRect) {
				chart.clipRect = renderer.clipRect(clipBox);
			} else {
				clipRect.animate({
					width: clipBox.width,
					height: clipBox.height
				});
			}
	
			// Plot area border
			if (plotBorderWidth) {
				if (!plotBorder) {
					chart.plotBorder = renderer.rect(plotLeft, plotTop, plotWidth, plotHeight, 0, -plotBorderWidth)
						.attr({
							stroke: optionsChart.plotBorderColor,
							'stroke-width': plotBorderWidth,
							fill: NONE,
							zIndex: 1
						})
						.add();
				} else {
					plotBorder.animate(
						plotBorder.crisp({ x: plotLeft, y: plotTop, width: plotWidth, height: plotHeight, strokeWidth: -plotBorderWidth }) //#3282 plotBorder should be negative
					);
				}
			}
	
			// reset
			chart.isDirtyBox = false;
		},
	
		/**
		 * Detect whether a certain chart property is needed based on inspecting its options
		 * and series. This mainly applies to the chart.invert property, and in extensions to 
		 * the chart.angular and chart.polar properties.
		 */
		propFromSeries: function () {
			var chart = this,
				optionsChart = chart.options.chart,
				klass,
				seriesOptions = chart.options.series,
				i,
				value;
				
				
			each(['inverted', 'angular', 'polar'], function (key) {
				
				// The default series type's class
				klass = seriesTypes[optionsChart.type || optionsChart.defaultSeriesType];
				
				// Get the value from available chart-wide properties
				value = (
					chart[key] || // 1. it is set before
					optionsChart[key] || // 2. it is set in the options
					(klass && klass.prototype[key]) // 3. it's default series class requires it
				);
		
				// 4. Check if any the chart's series require it
				i = seriesOptions && seriesOptions.length;
				while (!value && i--) {
					klass = seriesTypes[seriesOptions[i].type];
					if (klass && klass.prototype[key]) {
						value = true;
					}
				}
		
				// Set the chart property
				chart[key] = value;	
			});
			
		},
	
		/**
		 * Link two or more series together. This is done initially from Chart.render,
		 * and after Chart.addSeries and Series.remove.
		 */
		linkSeries: function () {
			var chart = this,
				chartSeries = chart.series;
	
			// Reset links
			each(chartSeries, function (series) {
				series.linkedSeries.length = 0;
			});
	
			// Apply new links
			each(chartSeries, function (series) {
				var linkedTo = series.options.linkedTo;
				if (isString(linkedTo)) {
					if (linkedTo === ':previous') {
						linkedTo = chart.series[series.index - 1];
					} else {
						linkedTo = chart.get(linkedTo);
					}
					if (linkedTo) {
						linkedTo.linkedSeries.push(series);
						series.linkedParent = linkedTo;
					}
				}
			});
		},
	
		/**
		 * Render series for the chart
		 */
		renderSeries: function () {
			each(this.series, function (serie) {
				serie.translate();
				if (serie.setTooltipPoints) {
					serie.setTooltipPoints();
				}
				serie.render();
			});
		},
			
		/**
		 * Render labels for the chart
		 */
		renderLabels: function () {
			var chart = this,
				labels = chart.options.labels;
			if (labels.items) {
				each(labels.items, function (label) {
					var style = extend(labels.style, label.style),
						x = pInt(style.left) + chart.plotLeft,
						y = pInt(style.top) + chart.plotTop + 12;
	
					// delete to prevent rewriting in IE
					delete style.left;
					delete style.top;
	
					chart.renderer.text(
						label.html,
						x,
						y
					)
					.attr({ zIndex: 2 })
					.css(style)
					.add();
	
				});
			}
		},
	
		/**
		 * Render all graphics for the chart
		 */
		render: function () {
			var chart = this,
				axes = chart.axes,
				renderer = chart.renderer,
				options = chart.options;
	
			// Title
			chart.setTitle();
	
	
			// Legend
			chart.legend = new Legend(chart, options.legend);
	
			chart.getStacks(); // render stacks
	
			// Get margins by pre-rendering axes
			// set axes scales
			each(axes, function (axis) {
				axis.setScale();
			});
	
			chart.getMargins();
	
			chart.maxTicks = null; // reset for second pass
			each(axes, function (axis) {
				axis.setTickPositions(true); // update to reflect the new margins
				axis.setMaxTicks();
			});
			chart.adjustTickAmounts();
			chart.getMargins(); // second pass to check for new labels
	
	
			// Draw the borders and backgrounds
			chart.drawChartBox();		
	
	
			// Axes
			if (chart.hasCartesianSeries) {
				each(axes, function (axis) {
					axis.render();
				});
			}
	
			// The series
			if (!chart.seriesGroup) {
				chart.seriesGroup = renderer.g('series-group')
					.attr({ zIndex: 3 })
					.add();
			}
			chart.renderSeries();
	
			// Labels
			chart.renderLabels();
	
			// Credits
			chart.showCredits(options.credits);
	
			// Set flag
			chart.hasRendered = true;
	
		},
	
		/**
		 * Show chart credits based on config options
		 */
		showCredits: function (credits) {
			if (credits.enabled && !this.credits) {
				this.credits = this.renderer.text(
					credits.text,
					0,
					0
				)
				.on('click', function () {
					if (credits.href) {
						location.href = credits.href;
					}
				})
				.attr({
					align: credits.position.align,
					zIndex: 8
				})
				.css(credits.style)
				.add()
				.align(credits.position);
			}
		},
	
		/**
		 * Clean up memory usage
		 */
		destroy: function () {
			var chart = this,
				axes = chart.axes,
				series = chart.series,
				container = chart.container,
				i,
				parentNode = container && container.parentNode;
				
			// fire the chart.destoy event
			fireEvent(chart, 'destroy');
			
			// Delete the chart from charts lookup array
			charts[chart.index] = UNDEFINED;
			chartCount--;
			chart.renderTo.removeAttribute('data-highcharts-chart');
	
			// remove events
			removeEvent(chart);
	
			// ==== Destroy collections:
			// Destroy axes
			i = axes.length;
			while (i--) {
				axes[i] = axes[i].destroy();
			}
	
			// Destroy each series
			i = series.length;
			while (i--) {
				series[i] = series[i].destroy();
			}
	
			// ==== Destroy chart properties:
			each(['title', 'subtitle', 'chartBackground', 'plotBackground', 'plotBGImage', 
					'plotBorder', 'seriesGroup', 'clipRect', 'credits', 'pointer', 'scroller', 
					'rangeSelector', 'legend', 'resetZoomButton', 'tooltip', 'renderer'], function (name) {
				var prop = chart[name];
	
				if (prop && prop.destroy) {
					chart[name] = prop.destroy();
				}
			});
	
			// remove container and all SVG
			if (container) { // can break in IE when destroyed before finished loading
				container.innerHTML = '';
				removeEvent(container);
				if (parentNode) {
					discardElement(container);
				}
	
			}
	
			// clean it all up
			for (i in chart) {
				delete chart[i];
			}
	
		},
	
	
		/**
		 * VML namespaces can't be added until after complete. Listening
		 * for Perini's doScroll hack is not enough.
		 */
		isReadyToRender: function () {
			var chart = this;
	
			// Note: in spite of JSLint's complaints, win == win.top is required
			/*jslint eqeq: true*/
			if ((!hasSVG && (win == win.top && doc.readyState !== 'complete')) || (useCanVG && !win.canvg)) {
			/*jslint eqeq: false*/
				if (useCanVG) {
					// Delay rendering until canvg library is downloaded and ready
					CanVGController.push(function () { chart.firstRender(); }, chart.options.global.canvasToolsURL);
				} else {
					doc.attachEvent('onreadystatechange', function () {
						doc.detachEvent('onreadystatechange', chart.firstRender);
						if (doc.readyState === 'complete') {
							chart.firstRender();
						}
					});
				}
				return false;
			}
			return true;
		},
	
		/**
		 * Prepare for first rendering after all data are loaded
		 */
		firstRender: function () {
			var chart = this,
				options = chart.options,
				callback = chart.callback;
	
			// Check whether the chart is ready to render
			if (!chart.isReadyToRender()) {
				return;
			}
	
			// Create the container
			chart.getContainer();
	
			// Run an early event after the container and renderer are established
			fireEvent(chart, 'init');
	
			
			chart.resetMargins();
			chart.setChartSize();
	
			// Set the common chart properties (mainly invert) from the given series
			chart.propFromSeries();
	
			// get axes
			chart.getAxes();
	
			// Initialize the series
			each(options.series || [], function (serieOptions) {
				chart.initSeries(serieOptions);
			});
	
			chart.linkSeries();
	
			// Run an event after axes and series are initialized, but before render. At this stage,
			// the series data is indexed and cached in the xData and yData arrays, so we can access
			// those before rendering. Used in Highstock. 
			fireEvent(chart, 'beforeRender'); 
	
			// depends on inverted and on margins being set
			if (Highcharts.Pointer) {
				chart.pointer = new Pointer(chart, options);
			}
	
			chart.render();
	
			// add canvas
			chart.renderer.draw();
			// run callbacks
			if (callback) {
				callback.apply(chart, [chart]);
			}
			each(chart.callbacks, function (fn) {
				fn.apply(chart, [chart]);
			});
			
			
			// If the chart was rendered outside the top container, put it back in
			chart.cloneRenderTo(true);
			
			fireEvent(chart, 'load');
	
		},
	
		/**
		* Creates arrays for spacing and margin from given options.
		*/
		splashArray: function (target, options) {
			var oVar = options[target],
				tArray = isObject(oVar) ? oVar : [oVar, oVar, oVar, oVar];
	
			return [pick(options[target + 'Top'], tArray[0]),
					pick(options[target + 'Right'], tArray[1]),
					pick(options[target + 'Bottom'], tArray[2]),
					pick(options[target + 'Left'], tArray[3])];
		}
	}; // end Chart
	
	// Hook for exporting module
	Chart.prototype.callbacks = [];
	
	var CenteredSeriesMixin = Highcharts.CenteredSeriesMixin = {
		/**
		 * Get the center of the pie based on the size and center options relative to the  
		 * plot area. Borrowed by the polar and gauge series types.
		 */
		getCenter: function () {
			
			var options = this.options,
				chart = this.chart,
				slicingRoom = 2 * (options.slicedOffset || 0),
				handleSlicingRoom,
				plotWidth = chart.plotWidth - 2 * slicingRoom,
				plotHeight = chart.plotHeight - 2 * slicingRoom,
				centerOption = options.center,
				positions = [pick(centerOption[0], '50%'), pick(centerOption[1], '50%'), options.size || '100%', options.innerSize || 0],
				smallestSize = mathMin(plotWidth, plotHeight),
				isPercent;
			
			return map(positions, function (length, i) {
				isPercent = /%$/.test(length);
				handleSlicingRoom = i < 2 || (i === 2 && isPercent);
				return (isPercent ?
					// i == 0: centerX, relative to width
					// i == 1: centerY, relative to height
					// i == 2: size, relative to smallestSize
					// i == 4: innerSize, relative to smallestSize
					[plotWidth, plotHeight, smallestSize, smallestSize][i] *
						pInt(length) / 100 :
					length) + (handleSlicingRoom ? slicingRoom : 0);
			});
		}
	};
	
	/**
	 * The Point object and prototype. Inheritable and used as base for PiePoint
	 */
	var Point = function () {};
	Point.prototype = {
	
		/**
		 * Initialize the point
		 * @param {Object} series The series object containing this point
		 * @param {Object} options The data in either number, array or object format
		 */
		init: function (series, options, x) {
	
			var point = this,
				colors;
			point.series = series;
			point.applyOptions(options, x);
			point.pointAttr = {};
	
			if (series.options.colorByPoint) {
				colors = series.options.colors || series.chart.options.colors;
				point.color = point.color || colors[series.colorCounter++];
				// loop back to zero
				if (series.colorCounter === colors.length) {
					series.colorCounter = 0;
				}
			}
	
			series.chart.pointCount++;
			return point;
		},
		/**
		 * Apply the options containing the x and y data and possible some extra properties.
		 * This is called on point init or from point.update.
		 *
		 * @param {Object} options
		 */
		applyOptions: function (options, x) {
			var point = this,
				series = point.series,
				pointValKey = series.options.pointValKey || series.pointValKey;
	
			options = Point.prototype.optionsToObject.call(this, options);
	
			// copy options directly to point
			extend(point, options);
			point.options = point.options ? extend(point.options, options) : options;
	
			// For higher dimension series types. For instance, for ranges, point.y is mapped to point.low.
			if (pointValKey) {
				point.y = point[pointValKey];
			}
	
			// If no x is set by now, get auto incremented value. All points must have an
			// x value, however the y value can be null to create a gap in the series
			if (point.x === UNDEFINED && series) {
				point.x = x === UNDEFINED ? series.autoIncrement() : x;
			}
	
			return point;
		},
	
		/**
		 * Transform number or array configs into objects
		 */
		optionsToObject: function (options) {
			var ret = {},
				series = this.series,
				pointArrayMap = series.pointArrayMap || ['y'],
				valueCount = pointArrayMap.length,
				firstItemType,
				i = 0,
				j = 0;
	
			if (typeof options === 'number' || options === null) {
				ret[pointArrayMap[0]] = options;
	
			} else if (isArray(options)) {
				// with leading x value
				if (options.length > valueCount) {
					firstItemType = typeof options[0];
					if (firstItemType === 'string') {
						ret.name = options[0];
					} else if (firstItemType === 'number') {
						ret.x = options[0];
					}
					i++;
				}
				while (j < valueCount) {
					ret[pointArrayMap[j++]] = options[i++];
				}
			} else if (typeof options === 'object') {
				ret = options;
	
				// This is the fastest way to detect if there are individual point dataLabels that need
				// to be considered in drawDataLabels. These can only occur in object configs.
				if (options.dataLabels) {
					series._hasPointLabels = true;
				}
	
				// Same approach as above for markers
				if (options.marker) {
					series._hasPointMarkers = true;
				}
			}
			return ret;
		},
	
		/**
		 * Destroy a point to clear memory. Its reference still stays in series.data.
		 */
		destroy: function () {
			var point = this,
				series = point.series,
				chart = series.chart,
				hoverPoints = chart.hoverPoints,
				prop;
	
			chart.pointCount--;
	
			if (hoverPoints) {
				point.setState();
				erase(hoverPoints, point);
				if (!hoverPoints.length) {
					chart.hoverPoints = null;
				}
	
			}
			if (point === chart.hoverPoint) {
				point.onMouseOut();
			}
	
			// remove all events
			if (point.graphic || point.dataLabel) { // removeEvent and destroyElements are performance expensive
				removeEvent(point);
				point.destroyElements();
			}
	
			if (point.legendItem) { // pies have legend items
				chart.legend.destroyItem(point);
			}
	
			for (prop in point) {
				point[prop] = null;
			}
	
	
		},
	
		/**
		 * Destroy SVG elements associated with the point
		 */
		destroyElements: function () {
			var point = this,
				props = ['graphic', 'dataLabel', 'dataLabelUpper', 'group', 'connector', 'shadowGroup'],
				prop,
				i = 6;
			while (i--) {
				prop = props[i];
				if (point[prop]) {
					point[prop] = point[prop].destroy();
				}
			}
		},
	
		/**
		 * Return the configuration hash needed for the data label and tooltip formatters
		 */
		getLabelConfig: function () {
			var point = this;
			return {
				x: point.category,
				y: point.y,
				key: point.name || point.category,
				series: point.series,
				point: point,
				percentage: point.percentage,
				total: point.total || point.stackTotal
			};
		},	
	
		/**
		 * Extendable method for formatting each point's tooltip line
		 *
		 * @return {String} A string to be concatenated in to the common tooltip text
		 */
		tooltipFormatter: function (pointFormat) {
	
			// Insert options for valueDecimals, valuePrefix, and valueSuffix
			var series = this.series,
				seriesTooltipOptions = series.tooltipOptions,
				valueDecimals = pick(seriesTooltipOptions.valueDecimals, ''),
				valuePrefix = seriesTooltipOptions.valuePrefix || '',
				valueSuffix = seriesTooltipOptions.valueSuffix || '';
	
			// Loop over the point array map and replace unformatted values with sprintf formatting markup
			each(series.pointArrayMap || ['y'], function (key) {
				key = '{point.' + key; // without the closing bracket
				if (valuePrefix || valueSuffix) {
					pointFormat = pointFormat.replace(key + '}', valuePrefix + key + '}' + valueSuffix);
				}
				pointFormat = pointFormat.replace(key + '}', key + ':,.' + valueDecimals + 'f}');
			});
	
			return format(pointFormat, {
				point: this,
				series: this.series
			});
		},
	
		/**
		 * Fire an event on the Point object. Must not be renamed to fireEvent, as this
		 * causes a name clash in MooTools
		 * @param {String} eventType
		 * @param {Object} eventArgs Additional event arguments
		 * @param {Function} defaultFunction Default event handler
		 */
		firePointEvent: function (eventType, eventArgs, defaultFunction) {
			var point = this,
				series = this.series,
				seriesOptions = series.options;
	
			// load event handlers on demand to save time on mouseover/out
			if (seriesOptions.point.events[eventType] || (point.options && point.options.events && point.options.events[eventType])) {
				this.importEvents();
			}
	
			// add default handler if in selection mode
			if (eventType === 'click' && seriesOptions.allowPointSelect) {
				defaultFunction = function (event) {
					// Control key is for Windows, meta (= Cmd key) for Mac, Shift for Opera
					point.select(null, event.ctrlKey || event.metaKey || event.shiftKey);
				};
			}
	
			fireEvent(this, eventType, eventArgs, defaultFunction);
		}
	};/**
	 * @classDescription The base function which all other series types inherit from. The data in the series is stored
	 * in various arrays.
	 *
	 * - First, series.options.data contains all the original config options for
	 * each point whether added by options or methods like series.addPoint.
	 * - Next, series.data contains those values converted to points, but in case the series data length
	 * exceeds the cropThreshold, or if the data is grouped, series.data doesn't contain all the points. It
	 * only contains the points that have been created on demand.
	 * - Then there's series.points that contains all currently visible point objects. In case of cropping,
	 * the cropped-away points are not part of this array. The series.points array starts at series.cropStart
	 * compared to series.data and series.options.data. If however the series data is grouped, these can't
	 * be correlated one to one.
	 * - series.xData and series.processedXData contain clean x values, equivalent to series.data and series.points.
	 * - series.yData and series.processedYData contain clean x values, equivalent to series.data and series.points.
	 *
	 * @param {Object} chart
	 * @param {Object} options
	 */
	var Series = function () {};
	
	Series.prototype = {
	
		isCartesian: true,
		type: 'line',
		pointClass: Point,
		sorted: true, // requires the data to be sorted
		requireSorting: true,
		pointAttrToOptions: { // mapping between SVG attributes and the corresponding options
			stroke: 'lineColor',
			'stroke-width': 'lineWidth',
			fill: 'fillColor',
			r: 'radius'
		},
		axisTypes: ['xAxis', 'yAxis'],
		colorCounter: 0,
		parallelArrays: ['x', 'y'], // each point's x and y values are stored in this.xData and this.yData
		init: function (chart, options) {
			var series = this,
				eventType,
				events,
				chartSeries = chart.series,
				sortByIndex = function (a, b) {
					return pick(a.options.index, a._i) - pick(b.options.index, b._i);
				};
	
			series.chart = chart;
			series.options = options = series.setOptions(options); // merge with plotOptions
			series.linkedSeries = [];
	
			// bind the axes
			series.bindAxes();
	
			// set some variables
			extend(series, {
				name: options.name,
				state: NORMAL_STATE,
				pointAttr: {},
				visible: options.visible !== false, // true by default
				selected: options.selected === true // false by default
			});
	
			// special
			if (useCanVG) {
				options.animation = false;
			}
	
			// register event listeners
			events = options.events;
			for (eventType in events) {
				addEvent(series, eventType, events[eventType]);
			}
			if (
				(events && events.click) ||
				(options.point && options.point.events && options.point.events.click) ||
				options.allowPointSelect
			) {
				chart.runTrackerClick = true;
			}
	
			series.getColor();
			series.getSymbol();
	
			// Set the data
			each(series.parallelArrays, function (key) {
				series[key + 'Data'] = [];
			});
			series.setData(options.data, false);
	
			// Mark cartesian
			if (series.isCartesian) {
				chart.hasCartesianSeries = true;
			}
	
			// Register it in the chart
			chartSeries.push(series);
			series._i = chartSeries.length - 1;
	
			// Sort series according to index option (#248, #1123, #2456)
			stableSort(chartSeries, sortByIndex);
			if (this.yAxis) {
				stableSort(this.yAxis.series, sortByIndex);
			}
	
			each(chartSeries, function (series, i) {
				series.index = i;
				series.name = series.name || 'Series ' + (i + 1);
			});
	
		},
	
		/**
		 * Set the xAxis and yAxis properties of cartesian series, and register the series
		 * in the axis.series array
		 */
		bindAxes: function () {
			var series = this,
				seriesOptions = series.options,
				chart = series.chart,
				axisOptions;
	
			each(series.axisTypes || [], function (AXIS) { // repeat for xAxis and yAxis
	
				each(chart[AXIS], function (axis) { // loop through the chart's axis objects
					axisOptions = axis.options;
	
					// apply if the series xAxis or yAxis option mathches the number of the
					// axis, or if undefined, use the first axis
					if ((seriesOptions[AXIS] === axisOptions.index) ||
							(seriesOptions[AXIS] !== UNDEFINED && seriesOptions[AXIS] === axisOptions.id) ||
							(seriesOptions[AXIS] === UNDEFINED && axisOptions.index === 0)) {
	
						// register this series in the axis.series lookup
						axis.series.push(series);
	
						// set this series.xAxis or series.yAxis reference
						series[AXIS] = axis;
	
						// mark dirty for redraw
						axis.isDirty = true;
					}
				});
	
				// The series needs an X and an Y axis
				if (!series[AXIS] && series.optionalAxis !== AXIS) {
					error(18, true);
				}
	
			});
		},
	
		/**
		 * For simple series types like line and column, the data values are held in arrays like
		 * xData and yData for quick lookup to find extremes and more. For multidimensional series
		 * like bubble and map, this can be extended with arrays like zData and valueData by
		 * adding to the series.parallelArrays array.
		 */
		updateParallelArrays: function (point, i) {
			var series = point.series,
				args = arguments,
				fn = typeof i === 'number' ?
					 // Insert the value in the given position
					function (key) {
						var val = key === 'y' && series.toYData ? series.toYData(point) : point[key];
						series[key + 'Data'][i] = val;
					} :
					// Apply the method specified in i with the following arguments as arguments
					function (key) {
						Array.prototype[i].apply(series[key + 'Data'], Array.prototype.slice.call(args, 2));
					};
	
			each(series.parallelArrays, fn);
		},
	
		/**
		 * Return an auto incremented x value based on the pointStart and pointInterval options.
		 * This is only used if an x value is not given for the point that calls autoIncrement.
		 */
		autoIncrement: function () {
			var series = this,
				options = series.options,
				xIncrement = series.xIncrement;
	
			xIncrement = pick(xIncrement, options.pointStart, 0);
	
			series.pointInterval = pick(series.pointInterval, options.pointInterval, 1);
	
			series.xIncrement = xIncrement + series.pointInterval;
			return xIncrement;
		},
	
		/**
		 * Divide the series data into segments divided by null values.
		 */
		getSegments: function () {
			var series = this,
				lastNull = -1,
				segments = [],
				i,
				points = series.points,
				pointsLength = points.length;
	
			if (pointsLength) { // no action required for []
	
				// if connect nulls, just remove null points
				if (series.options.connectNulls) {
					i = pointsLength;
					while (i--) {
						if (points[i].y === null) {
							points.splice(i, 1);
						}
					}
					if (points.length) {
						segments = [points];
					}
	
				// else, split on null points
				} else {
					each(points, function (point, i) {
						if (point.y === null) {
							if (i > lastNull + 1) {
								segments.push(points.slice(lastNull + 1, i));
							}
							lastNull = i;
						} else if (i === pointsLength - 1) { // last value
							segments.push(points.slice(lastNull + 1, i + 1));
						}
					});
				}
			}
	
			// register it
			series.segments = segments;
		},
	
		/**
		 * Set the series options by merging from the options tree
		 * @param {Object} itemOptions
		 */
		setOptions: function (itemOptions) {
			var chart = this.chart,
				chartOptions = chart.options,
				plotOptions = chartOptions.plotOptions,
				userOptions = chart.userOptions || {},
				userPlotOptions = userOptions.plotOptions || {},
				typeOptions = plotOptions[this.type],
				options;
	
			this.userOptions = itemOptions;
	
			options = merge(
				typeOptions,
				plotOptions.series,
				itemOptions
			);
	
			// The tooltip options are merged between global and series specific options
			this.tooltipOptions = merge(
				defaultOptions.tooltip,
				defaultOptions.plotOptions[this.type].tooltip,
				userOptions.tooltip,
				userPlotOptions.series && userPlotOptions.series.tooltip,
				userPlotOptions[this.type] && userPlotOptions[this.type].tooltip,
				itemOptions.tooltip
			);
	
			// Delete marker object if not allowed (#1125)
			if (typeOptions.marker === null) {
				delete options.marker;
			}
	
			return options;
	
		},
	
		getCyclic: function (prop, value, defaults) {
			var i,
				userOptions = this.userOptions,
				indexName = '_' + prop + 'Index',
				counterName = prop + 'Counter';
	
			if (!value) {
				if (defined(userOptions[indexName])) { // after Series.update()
					i = userOptions[indexName];
				} else {
					userOptions[indexName] = i = this.chart[counterName] % defaults.length;
					this.chart[counterName] += 1;
				}
				value = defaults[i];
			}
			this[prop] = value;
		},
	
		/**
		 * Get the series' color
		 */
		getColor: function () {
			if (!this.options.colorByPoint) {
				this.getCyclic('color', this.options.color || defaultPlotOptions[this.type].color, this.chart.options.colors);
			}
		},
		/**
		 * Get the series' symbol
		 */
		getSymbol: function () {
			var seriesMarkerOption = this.options.marker;
	
			this.getCyclic('symbol', seriesMarkerOption.symbol, this.chart.options.symbols);
	
			// don't substract radius in image symbols (#604)
			if (/^url/.test(this.symbol)) {
				seriesMarkerOption.radius = 0;
			}
		},
	
		drawLegendSymbol: LegendSymbolMixin.drawLineMarker,
	
		/**
		 * Replace the series data with a new set of data
		 * @param {Object} data
		 * @param {Object} redraw
		 */
		setData: function (data, redraw, animation, updatePoints) {
			var series = this,
				oldData = series.points,
				oldDataLength = (oldData && oldData.length) || 0,
				dataLength,
				options = series.options,
				chart = series.chart,
				firstPoint = null,
				xAxis = series.xAxis,
				hasCategories = xAxis && !!xAxis.categories,
				tooltipPoints = series.tooltipPoints,
				i,
				turboThreshold = options.turboThreshold,
				pt,
				xData = this.xData,
				yData = this.yData,
				pointArrayMap = series.pointArrayMap,
				valueCount = pointArrayMap && pointArrayMap.length;
	
			data = data || [];
			dataLength = data.length;
			redraw = pick(redraw, true);
	
			// If the point count is the same as is was, just run Point.update which is
			// cheaper, allows animation, and keeps references to points.
			if (updatePoints !== false && dataLength && oldDataLength === dataLength && !series.cropped && !series.hasGroupedData) {
				each(data, function (point, i) {
					oldData[i].update(point, false, null, false);
				});
	
			} else {
	
				// Reset properties
				series.xIncrement = null;
				series.pointRange = hasCategories ? 1 : options.pointRange;
	
				series.colorCounter = 0; // for series with colorByPoint (#1547)
				
				// Update parallel arrays
				each(this.parallelArrays, function (key) {
					series[key + 'Data'].length = 0;
				});
	
				// In turbo mode, only one- or twodimensional arrays of numbers are allowed. The
				// first value is tested, and we assume that all the rest are defined the same
				// way. Although the 'for' loops are similar, they are repeated inside each
				// if-else conditional for max performance.
				if (turboThreshold && dataLength > turboThreshold) {
	
					// find the first non-null point
					i = 0;
					while (firstPoint === null && i < dataLength) {
						firstPoint = data[i];
						i++;
					}
	
	
					if (isNumber(firstPoint)) { // assume all points are numbers
						var x = pick(options.pointStart, 0),
							pointInterval = pick(options.pointInterval, 1);
	
						for (i = 0; i < dataLength; i++) {
							xData[i] = x;
							yData[i] = data[i];
							x += pointInterval;
						}
						series.xIncrement = x;
					} else if (isArray(firstPoint)) { // assume all points are arrays
						if (valueCount) { // [x, low, high] or [x, o, h, l, c]
							for (i = 0; i < dataLength; i++) {
								pt = data[i];
								xData[i] = pt[0];
								yData[i] = pt.slice(1, valueCount + 1);
							}
						} else { // [x, y]
							for (i = 0; i < dataLength; i++) {
								pt = data[i];
								xData[i] = pt[0];
								yData[i] = pt[1];
							}
						}
					} else {
						error(12); // Highcharts expects configs to be numbers or arrays in turbo mode
					}
				} else {
					for (i = 0; i < dataLength; i++) {
						if (data[i] !== UNDEFINED) { // stray commas in oldIE
							pt = { series: series };
							series.pointClass.prototype.applyOptions.apply(pt, [data[i]]);
							series.updateParallelArrays(pt, i);
							if (hasCategories && pt.name) {
								xAxis.names[pt.x] = pt.name; // #2046
							}
						}
					}
				}
	
				// Forgetting to cast strings to numbers is a common caveat when handling CSV or JSON
				if (isString(yData[0])) {
					error(14, true);
				}
	
				series.data = [];
				series.options.data = data;
				//series.zData = zData;
	
				// destroy old points
				i = oldDataLength;
				while (i--) {
					if (oldData[i] && oldData[i].destroy) {
						oldData[i].destroy();
					}
				}
				if (tooltipPoints) { // #2594
					tooltipPoints.length = 0;
				}
	
				// reset minRange (#878)
				if (xAxis) {
					xAxis.minRange = xAxis.userMinRange;
				}
	
				// redraw
				series.isDirty = series.isDirtyData = chart.isDirtyBox = true;
				animation = false;
			}
	
			if (redraw) {
				chart.redraw(animation);
			}
		},
	
		/**
		 * Process the data by cropping away unused data points if the series is longer
		 * than the crop threshold. This saves computing time for lage series.
		 */
		processData: function (force) {
			var series = this,
				processedXData = series.xData, // copied during slice operation below
				processedYData = series.yData,
				dataLength = processedXData.length,
				croppedData,
				cropStart = 0,
				cropped,
				distance,
				closestPointRange,
				xAxis = series.xAxis,
				i, // loop variable
				options = series.options,
				cropThreshold = options.cropThreshold,
				activePointCount = 0,
				isCartesian = series.isCartesian,
				xExtremes,
				min,
				max;
	
			// If the series data or axes haven't changed, don't go through this. Return false to pass
			// the message on to override methods like in data grouping.
			if (isCartesian && !series.isDirty && !xAxis.isDirty && !series.yAxis.isDirty && !force) {
				return false;
			}
	
			if (xAxis) {
				xExtremes = xAxis.getExtremes(); // corrected for log axis (#3053)
				min = xExtremes.min;
				max = xExtremes.max;
			}
	
			// optionally filter out points outside the plot area
			if (isCartesian && series.sorted && (!cropThreshold || dataLength > cropThreshold || series.forceCrop)) {
				
				// it's outside current extremes
				if (processedXData[dataLength - 1] < min || processedXData[0] > max) {
					processedXData = [];
					processedYData = [];
	
				// only crop if it's actually spilling out
				} else if (processedXData[0] < min || processedXData[dataLength - 1] > max) {
					croppedData = this.cropData(series.xData, series.yData, min, max);
					processedXData = croppedData.xData;
					processedYData = croppedData.yData;
					cropStart = croppedData.start;
					cropped = true;
					activePointCount = processedXData.length;
				}
			}
	
	
			// Find the closest distance between processed points
			for (i = processedXData.length - 1; i >= 0; i--) {
				distance = processedXData[i] - processedXData[i - 1];
				
				if (!cropped && processedXData[i] > min && processedXData[i] < max) {
					activePointCount++;
				}
				
				if (distance > 0 && (closestPointRange === UNDEFINED || distance < closestPointRange)) {
					closestPointRange = distance;
	
				// Unsorted data is not supported by the line tooltip, as well as data grouping and
				// navigation in Stock charts (#725) and width calculation of columns (#1900)
				} else if (distance < 0 && series.requireSorting) {
					error(15);
				}
			}
	
			// Record the properties
			series.cropped = cropped; // undefined or true
			series.cropStart = cropStart;
			series.processedXData = processedXData;
			series.processedYData = processedYData;
			series.activePointCount = activePointCount;
	
			if (options.pointRange === null) { // null means auto, as for columns, candlesticks and OHLC
				series.pointRange = closestPointRange || 1;
			}
			series.closestPointRange = closestPointRange;
	
		},
	
		/**
		 * Iterate over xData and crop values between min and max. Returns object containing crop start/end
		 * cropped xData with corresponding part of yData, dataMin and dataMax within the cropped range
		 */
		cropData: function (xData, yData, min, max) {
			var dataLength = xData.length,
				cropStart = 0,
				cropEnd = dataLength,
				cropShoulder = pick(this.cropShoulder, 1), // line-type series need one point outside
				i;
	
			// iterate up to find slice start
			for (i = 0; i < dataLength; i++) {
				if (xData[i] >= min) {
					cropStart = mathMax(0, i - cropShoulder);
					break;
				}
			}
	
			// proceed to find slice end
			for (; i < dataLength; i++) {
				if (xData[i] > max) {
					cropEnd = i + cropShoulder;
					break;
				}
			}
	
			return {
				xData: xData.slice(cropStart, cropEnd),
				yData: yData.slice(cropStart, cropEnd),
				start: cropStart,
				end: cropEnd
			};
		},
	
	
		/**
		 * Generate the data point after the data has been processed by cropping away
		 * unused points and optionally grouped in Highcharts Stock.
		 */
		generatePoints: function () {
			var series = this,
				options = series.options,
				dataOptions = options.data,
				data = series.data,
				dataLength,
				processedXData = series.processedXData,
				processedYData = series.processedYData,
				pointClass = series.pointClass,
				processedDataLength = processedXData.length,
				cropStart = series.cropStart || 0,
				cursor,
				hasGroupedData = series.hasGroupedData,
				point,
				points = [],
				i;
	
			if (!data && !hasGroupedData) {
				var arr = [];
				arr.length = dataOptions.length;
				data = series.data = arr;
			}
	
			for (i = 0; i < processedDataLength; i++) {
				cursor = cropStart + i;
				if (!hasGroupedData) {
					if (data[cursor]) {
						point = data[cursor];
					} else if (dataOptions[cursor] !== UNDEFINED) { // #970
						data[cursor] = point = (new pointClass()).init(series, dataOptions[cursor], processedXData[i]);
					}
					points[i] = point;
				} else {
					// splat the y data in case of ohlc data array
					points[i] = (new pointClass()).init(series, [processedXData[i]].concat(splat(processedYData[i])));
				}
				points[i].index = cursor; // For faster access in Point.update
			}
	
			// Hide cropped-away points - this only runs when the number of points is above cropThreshold, or when
			// swithching view from non-grouped data to grouped data (#637)
			if (data && (processedDataLength !== (dataLength = data.length) || hasGroupedData)) {
				for (i = 0; i < dataLength; i++) {
					if (i === cropStart && !hasGroupedData) { // when has grouped data, clear all points
						i += processedDataLength;
					}
					if (data[i]) {
						data[i].destroyElements();
						data[i].plotX = UNDEFINED; // #1003
					}
				}
			}
	
			series.data = data;
			series.points = points;
		},
	
		/**
		 * Calculate Y extremes for visible data
		 */
		getExtremes: function (yData) {
			var xAxis = this.xAxis,
				yAxis = this.yAxis,
				xData = this.processedXData,
				yDataLength,
				activeYData = [],
				activeCounter = 0,
				xExtremes = xAxis.getExtremes(), // #2117, need to compensate for log X axis
				xMin = xExtremes.min,
				xMax = xExtremes.max,
				validValue,
				withinRange,
				dataMin,
				dataMax,
				x,
				y,
				i,
				j;
	
			yData = yData || this.stackedYData || this.processedYData;
			yDataLength = yData.length;
	
			for (i = 0; i < yDataLength; i++) {
	
				x = xData[i];
				y = yData[i];
	
				// For points within the visible range, including the first point outside the
				// visible range, consider y extremes
				validValue = y !== null && y !== UNDEFINED && (!yAxis.isLog || (y.length || y > 0));
				withinRange = this.getExtremesFromAll || this.cropped || ((xData[i + 1] || x) >= xMin &&
					(xData[i - 1] || x) <= xMax);
	
				if (validValue && withinRange) {
	
					j = y.length;
					if (j) { // array, like ohlc or range data
						while (j--) {
							if (y[j] !== null) {
								activeYData[activeCounter++] = y[j];
							}
						}
					} else {
						activeYData[activeCounter++] = y;
					}
				}
			}
			this.dataMin = pick(dataMin, arrayMin(activeYData));
			this.dataMax = pick(dataMax, arrayMax(activeYData));
		},
	
		/**
		 * Translate data points from raw data values to chart specific positioning data
		 * needed later in drawPoints, drawGraph and drawTracker.
		 */
		translate: function () {
			if (!this.processedXData) { // hidden series
				this.processData();
			}
			this.generatePoints();
			var series = this,
				options = series.options,
				stacking = options.stacking,
				xAxis = series.xAxis,
				categories = xAxis.categories,
				yAxis = series.yAxis,
				points = series.points,
				dataLength = points.length,
				hasModifyValue = !!series.modifyValue,
				i,
				pointPlacement = options.pointPlacement,
				dynamicallyPlaced = pointPlacement === 'between' || isNumber(pointPlacement),
				threshold = options.threshold;
	
			// Translate each point
			for (i = 0; i < dataLength; i++) {
				var point = points[i],
					xValue = point.x,
					yValue = point.y,
					yBottom = point.low,
					stack = stacking && yAxis.stacks[(series.negStacks && yValue < threshold ? '-' : '') + series.stackKey],
					pointStack,
					stackValues;
	
				// Discard disallowed y values for log axes
				if (yAxis.isLog && yValue <= 0) {
					point.y = yValue = null;
					error(10);
				}
	
				// Get the plotX translation
				point.plotX = xAxis.translate(xValue, 0, 0, 0, 1, pointPlacement, this.type === 'flags'); // Math.round fixes #591
	
	
				// Calculate the bottom y value for stacked series
				if (stacking && series.visible && stack && stack[xValue]) {
	
					pointStack = stack[xValue];
					stackValues = pointStack.points[series.index + ',' + i];
					yBottom = stackValues[0];
					yValue = stackValues[1];
	
					if (yBottom === 0) {
						yBottom = pick(threshold, yAxis.min);
					}
					if (yAxis.isLog && yBottom <= 0) { // #1200, #1232
						yBottom = null;
					}
	
					point.total = point.stackTotal = pointStack.total;
					point.percentage = pointStack.total && (point.y / pointStack.total * 100);
					point.stackY = yValue;
	
					// Place the stack label
					pointStack.setOffset(series.pointXOffset || 0, series.barW || 0);
	
				}
	
				// Set translated yBottom or remove it
				point.yBottom = defined(yBottom) ?
					yAxis.translate(yBottom, 0, 1, 0, 1) :
					null;
	
				// general hook, used for Highstock compare mode
				if (hasModifyValue) {
					yValue = series.modifyValue(yValue, point);
				}
	
				// Set the the plotY value, reset it for redraws
				point.plotY = (typeof yValue === 'number' && yValue !== Infinity) ?
					//mathRound(yAxis.translate(yValue, 0, 1, 0, 1) * 10) / 10 : // Math.round fixes #591
					yAxis.translate(yValue, 0, 1, 0, 1) :
					UNDEFINED;
	
				// Set client related positions for mouse tracking
				point.clientX = dynamicallyPlaced ? xAxis.translate(xValue, 0, 0, 0, 1) : point.plotX; // #1514
	
				point.negative = point.y < (threshold || 0);
	
				// some API data
				point.category = categories && categories[point.x] !== UNDEFINED ?
					categories[point.x] : point.x;
	
			}
	
			// now that we have the cropped data, build the segments
			series.getSegments();
		},
	
		/**
		 * Animate in the series
		 */
		animate: function (init) {
			var series = this,
				chart = series.chart,
				renderer = chart.renderer,
				clipRect,
				markerClipRect,
				animation = series.options.animation,
				clipBox = series.clipBox || chart.clipBox,
				inverted = chart.inverted,
				sharedClipKey;
	
			// Animation option is set to true
			if (animation && !isObject(animation)) {
				animation = defaultPlotOptions[series.type].animation;
			}
			sharedClipKey = ['_sharedClip', animation.duration, animation.easing, clipBox.height].join(',');
	
			// Initialize the animation. Set up the clipping rectangle.
			if (init) {
	
				// If a clipping rectangle with the same properties is currently present in the chart, use that.
				clipRect = chart[sharedClipKey];
				markerClipRect = chart[sharedClipKey + 'm'];
				if (!clipRect) {
					chart[sharedClipKey] = clipRect = renderer.clipRect(
						extend(clipBox, { width: 0 })
					);
	
					chart[sharedClipKey + 'm'] = markerClipRect = renderer.clipRect(
						-99, // include the width of the first marker
						inverted ? -chart.plotLeft : -chart.plotTop,
						99,
						inverted ? chart.chartWidth : chart.chartHeight
					);
				}
				series.group.clip(clipRect);
				series.markerGroup.clip(markerClipRect);
				series.sharedClipKey = sharedClipKey;
	
			// Run the animation
			} else {
				clipRect = chart[sharedClipKey];
				if (clipRect) {
					clipRect.animate({
						width: chart.plotSizeX
					}, animation);
				}
				if (chart[sharedClipKey + 'm']) {
					chart[sharedClipKey + 'm'].animate({
						width: chart.plotSizeX + 99
					}, animation);
				}
	
				// Delete this function to allow it only once
				series.animate = null;
	 
			}
		},
	
		/**
		 * This runs after animation to land on the final plot clipping
		 */
		afterAnimate: function () {
			var chart = this.chart,
				sharedClipKey = this.sharedClipKey,
				group = this.group,
				clipBox = this.clipBox;
	
			if (group && this.options.clip !== false) {
				if (!sharedClipKey || !clipBox) {
					group.clip(clipBox ? chart.renderer.clipRect(clipBox) : chart.clipRect);
				}
				this.markerGroup.clip(); // no clip
			}
	
			fireEvent(this, 'afterAnimate');
	
			// Remove the shared clipping rectancgle when all series are shown
			setTimeout(function () {
				if (sharedClipKey && chart[sharedClipKey]) {
					if (!clipBox) {
						chart[sharedClipKey] = chart[sharedClipKey].destroy();
					}
					if (chart[sharedClipKey + 'm']) {
						chart[sharedClipKey + 'm'] = chart[sharedClipKey + 'm'].destroy();
					}
				}
			}, 100);
		},
	
		/**
		 * Draw the markers
		 */
		drawPoints: function () {
			var series = this,
				pointAttr,
				points = series.points,
				chart = series.chart,
				plotX,
				plotY,
				i,
				point,
				radius,
				symbol,
				isImage,
				graphic,
				options = series.options,
				seriesMarkerOptions = options.marker,
				seriesPointAttr = series.pointAttr[''],
				pointMarkerOptions,
				hasPointMarker,
				enabled,
				isInside,
				markerGroup = series.markerGroup,
				globallyEnabled = pick(
					seriesMarkerOptions.enabled, 
					!series.requireSorting || series.activePointCount < (0.5 * series.xAxis.len / seriesMarkerOptions.radius)
				);
	
			if (seriesMarkerOptions.enabled !== false || series._hasPointMarkers) {
	
				i = points.length;
				while (i--) {
					point = points[i];
					plotX = mathFloor(point.plotX); // #1843
					plotY = point.plotY;
					graphic = point.graphic;
					pointMarkerOptions = point.marker || {};
					hasPointMarker = !!point.marker;
					enabled = (globallyEnabled && pointMarkerOptions.enabled === UNDEFINED) || pointMarkerOptions.enabled;
					isInside = chart.isInsidePlot(mathRound(plotX), plotY, chart.inverted); // #1858
	
					// only draw the point if y is defined
					if (enabled && plotY !== UNDEFINED && !isNaN(plotY) && point.y !== null) {
	
						// shortcuts
						pointAttr = point.pointAttr[point.selected ? SELECT_STATE : NORMAL_STATE] || seriesPointAttr;
						radius = pointAttr.r;
						symbol = pick(pointMarkerOptions.symbol, series.symbol);
						isImage = symbol.indexOf('url') === 0;
	
						if (graphic) { // update
							graphic[isInside ? 'show' : 'hide'](true) // Since the marker group isn't clipped, each individual marker must be toggled
								.animate(extend({
									x: plotX - radius,
									y: plotY - radius
								}, graphic.symbolName ? { // don't apply to image symbols #507
									width: 2 * radius,
									height: 2 * radius
								} : {}));
						} else if (isInside && (radius > 0 || isImage)) {
							point.graphic = graphic = chart.renderer.symbol(
								symbol,
								plotX - radius,
								plotY - radius,
								2 * radius,
								2 * radius,
								hasPointMarker ? pointMarkerOptions : seriesMarkerOptions
							)
							.attr(pointAttr)
							.add(markerGroup);
						}
	
					} else if (graphic) {
						point.graphic = graphic.destroy(); // #1269
					}
				}
			}
	
		},
	
		/**
		 * Convert state properties from API naming conventions to SVG attributes
		 *
		 * @param {Object} options API options object
		 * @param {Object} base1 SVG attribute object to inherit from
		 * @param {Object} base2 Second level SVG attribute object to inherit from
		 */
		convertAttribs: function (options, base1, base2, base3) {
			var conversion = this.pointAttrToOptions,
				attr,
				option,
				obj = {};
	
			options = options || {};
			base1 = base1 || {};
			base2 = base2 || {};
			base3 = base3 || {};
	
			for (attr in conversion) {
				option = conversion[attr];
				obj[attr] = pick(options[option], base1[attr], base2[attr], base3[attr]);
			}
			return obj;
		},
	
		/**
		 * Get the state attributes. Each series type has its own set of attributes
		 * that are allowed to change on a point's state change. Series wide attributes are stored for
		 * all series, and additionally point specific attributes are stored for all
		 * points with individual marker options. If such options are not defined for the point,
		 * a reference to the series wide attributes is stored in point.pointAttr.
		 */
		getAttribs: function () {
			var series = this,
				seriesOptions = series.options,
				normalOptions = defaultPlotOptions[series.type].marker ? seriesOptions.marker : seriesOptions,
				stateOptions = normalOptions.states,
				stateOptionsHover = stateOptions[HOVER_STATE],
				pointStateOptionsHover,
				seriesColor = series.color,
				normalDefaults = {
					stroke: seriesColor,
					fill: seriesColor
				},
				points = series.points || [], // #927
				i,
				point,
				seriesPointAttr = [],
				pointAttr,
				pointAttrToOptions = series.pointAttrToOptions,
				hasPointSpecificOptions = series.hasPointSpecificOptions,
				negativeColor = seriesOptions.negativeColor,
				defaultLineColor = normalOptions.lineColor,
				defaultFillColor = normalOptions.fillColor,
				turboThreshold = seriesOptions.turboThreshold,
				attr,
				key;
	
			// series type specific modifications
			if (seriesOptions.marker) { // line, spline, area, areaspline, scatter
	
				// if no hover radius is given, default to normal radius + 2
				stateOptionsHover.radius = stateOptionsHover.radius || normalOptions.radius + stateOptionsHover.radiusPlus;
				stateOptionsHover.lineWidth = stateOptionsHover.lineWidth || normalOptions.lineWidth + stateOptionsHover.lineWidthPlus;
	
			} else { // column, bar, pie
	
				// if no hover color is given, brighten the normal color
				stateOptionsHover.color = stateOptionsHover.color ||
					Color(stateOptionsHover.color || seriesColor)
						.brighten(stateOptionsHover.brightness).get();
			}
	
			// general point attributes for the series normal state
			seriesPointAttr[NORMAL_STATE] = series.convertAttribs(normalOptions, normalDefaults);
	
			// HOVER_STATE and SELECT_STATE states inherit from normal state except the default radius
			each([HOVER_STATE, SELECT_STATE], function (state) {
				seriesPointAttr[state] =
						series.convertAttribs(stateOptions[state], seriesPointAttr[NORMAL_STATE]);
			});
	
			// set it
			series.pointAttr = seriesPointAttr;
	
	
			// Generate the point-specific attribute collections if specific point
			// options are given. If not, create a referance to the series wide point
			// attributes
			i = points.length;
			if (!turboThreshold || i < turboThreshold || hasPointSpecificOptions) {
				while (i--) {
					point = points[i];
					normalOptions = (point.options && point.options.marker) || point.options;
					if (normalOptions && normalOptions.enabled === false) {
						normalOptions.radius = 0;
					}
	
					if (point.negative && negativeColor) {
						point.color = point.fillColor = negativeColor;
					}
	
					hasPointSpecificOptions = seriesOptions.colorByPoint || point.color; // #868
	
					// check if the point has specific visual options
					if (point.options) {
						for (key in pointAttrToOptions) {
							if (defined(normalOptions[pointAttrToOptions[key]])) {
								hasPointSpecificOptions = true;
							}
						}
					}
	
					// a specific marker config object is defined for the individual point:
					// create it's own attribute collection
					if (hasPointSpecificOptions) {
						normalOptions = normalOptions || {};
						pointAttr = [];
						stateOptions = normalOptions.states || {}; // reassign for individual point
						pointStateOptionsHover = stateOptions[HOVER_STATE] = stateOptions[HOVER_STATE] || {};
	
						// Handle colors for column and pies
						if (!seriesOptions.marker) { // column, bar, point
							// If no hover color is given, brighten the normal color. #1619, #2579
							pointStateOptionsHover.color = pointStateOptionsHover.color || (!point.options.color && stateOptionsHover.color) ||
								Color(point.color)
									.brighten(pointStateOptionsHover.brightness || stateOptionsHover.brightness)
									.get();
						}
	
						// normal point state inherits series wide normal state
						attr = { color: point.color }; // #868
						if (!defaultFillColor) { // Individual point color or negative color markers (#2219)
							attr.fillColor = point.color;
						}
						if (!defaultLineColor) {
							attr.lineColor = point.color; // Bubbles take point color, line markers use white
						}
						pointAttr[NORMAL_STATE] = series.convertAttribs(extend(attr, normalOptions), seriesPointAttr[NORMAL_STATE]);
	
						// inherit from point normal and series hover
						pointAttr[HOVER_STATE] = series.convertAttribs(
							stateOptions[HOVER_STATE],
							seriesPointAttr[HOVER_STATE],
							pointAttr[NORMAL_STATE]
						);
	
						// inherit from point normal and series hover
						pointAttr[SELECT_STATE] = series.convertAttribs(
							stateOptions[SELECT_STATE],
							seriesPointAttr[SELECT_STATE],
							pointAttr[NORMAL_STATE]
						);
	
	
					// no marker config object is created: copy a reference to the series-wide
					// attribute collection
					} else {
						pointAttr = seriesPointAttr;
					}
	
					point.pointAttr = pointAttr;
				}
			}
		},
	
		/**
		 * Clear DOM objects and free up memory
		 */
		destroy: function () {
			var series = this,
				chart = series.chart,
				issue134 = /AppleWebKit\/533/.test(userAgent),
				destroy,
				i,
				data = series.data || [],
				point,
				prop,
				axis;
	
			// add event hook
			fireEvent(series, 'destroy');
	
			// remove all events
			removeEvent(series);
	
			// erase from axes
			each(series.axisTypes || [], function (AXIS) {
				axis = series[AXIS];
				if (axis) {
					erase(axis.series, series);
					axis.isDirty = axis.forceRedraw = true;
				}
			});
	
			// remove legend items
			if (series.legendItem) {
				series.chart.legend.destroyItem(series);
			}
	
			// destroy all points with their elements
			i = data.length;
			while (i--) {
				point = data[i];
				if (point && point.destroy) {
					point.destroy();
				}
			}
			series.points = null;
	
			// Clear the animation timeout if we are destroying the series during initial animation
			clearTimeout(series.animationTimeout);
	
			// destroy all SVGElements associated to the series
			each(['area', 'graph', 'dataLabelsGroup', 'group', 'markerGroup', 'tracker',
					'graphNeg', 'areaNeg', 'posClip', 'negClip'], function (prop) {
				if (series[prop]) {
	
					// issue 134 workaround
					destroy = issue134 && prop === 'group' ?
						'hide' :
						'destroy';
	
					series[prop][destroy]();
				}
			});
	
			// remove from hoverSeries
			if (chart.hoverSeries === series) {
				chart.hoverSeries = null;
			}
			erase(chart.series, series);
	
			// clear all members
			for (prop in series) {
				delete series[prop];
			}
		},
	
		/**
		 * Return the graph path of a segment
		 */
		getSegmentPath: function (segment) {
			var series = this,
				segmentPath = [],
				step = series.options.step;
	
			// build the segment line
			each(segment, function (point, i) {
	
				var plotX = point.plotX,
					plotY = point.plotY,
					lastPoint;
	
				if (series.getPointSpline) { // generate the spline as defined in the SplineSeries object
					segmentPath.push.apply(segmentPath, series.getPointSpline(segment, point, i));
	
				} else {
	
					// moveTo or lineTo
					segmentPath.push(i ? L : M);
	
					// step line?
					if (step && i) {
						lastPoint = segment[i - 1];
						if (step === 'right') {
							segmentPath.push(
								lastPoint.plotX,
								plotY
							);
	
						} else if (step === 'center') {
							segmentPath.push(
								(lastPoint.plotX + plotX) / 2,
								lastPoint.plotY,
								(lastPoint.plotX + plotX) / 2,
								plotY
							);
	
						} else {
							segmentPath.push(
								plotX,
								lastPoint.plotY
							);
						}
					}
	
					// normal line to next point
					segmentPath.push(
						point.plotX,
						point.plotY
					);
				}
			});
	
			return segmentPath;
		},
	
		/**
		 * Get the graph path
		 */
		getGraphPath: function () {
			var series = this,
				graphPath = [],
				segmentPath,
				singlePoints = []; // used in drawTracker
	
			// Divide into segments and build graph and area paths
			each(series.segments, function (segment) {
	
				segmentPath = series.getSegmentPath(segment);
	
				// add the segment to the graph, or a single point for tracking
				if (segment.length > 1) {
					graphPath = graphPath.concat(segmentPath);
				} else {
					singlePoints.push(segment[0]);
				}
			});
	
			// Record it for use in drawGraph and drawTracker, and return graphPath
			series.singlePoints = singlePoints;
			series.graphPath = graphPath;
	
			return graphPath;
	
		},
	
		/**
		 * Draw the actual graph
		 */
		drawGraph: function () {
			var series = this,
				options = this.options,
				props = [['graph', options.lineColor || this.color]],
				lineWidth = options.lineWidth,
				dashStyle =  options.dashStyle,
				roundCap = options.linecap !== 'square',
				graphPath = this.getGraphPath(),
				negativeColor = options.negativeColor;
	
			if (negativeColor) {
				props.push(['graphNeg', negativeColor]);
			}
	
			// draw the graph
			each(props, function (prop, i) {
				var graphKey = prop[0],
					graph = series[graphKey],
					attribs;
	
				if (graph) {
					stop(graph); // cancel running animations, #459
					graph.animate({ d: graphPath });
	
				} else if (lineWidth && graphPath.length) { // #1487
					attribs = {
						stroke: prop[1],
						'stroke-width': lineWidth,
						fill: NONE,
						zIndex: 1 // #1069
					};
					if (dashStyle) {
						attribs.dashstyle = dashStyle;
					} else if (roundCap) {
						attribs['stroke-linecap'] = attribs['stroke-linejoin'] = 'round';
					}
	
					series[graphKey] = series.chart.renderer.path(graphPath)
						.attr(attribs)
						.add(series.group)
						.shadow(!i && options.shadow);
				}
			});
		},
	
		/**
		 * Clip the graphs into the positive and negative coloured graphs
		 */
		clipNeg: function () {
			var options = this.options,
				chart = this.chart,
				renderer = chart.renderer,
				negativeColor = options.negativeColor || options.negativeFillColor,
				translatedThreshold,
				posAttr,
				negAttr,
				graph = this.graph,
				area = this.area,
				posClip = this.posClip,
				negClip = this.negClip,
				chartWidth = chart.chartWidth,
				chartHeight = chart.chartHeight,
				chartSizeMax = mathMax(chartWidth, chartHeight),
				yAxis = this.yAxis,
				above,
				below;
	
			if (negativeColor && (graph || area)) {
				translatedThreshold = mathRound(yAxis.toPixels(options.threshold || 0, true));
				if (translatedThreshold < 0) {
					chartSizeMax -= translatedThreshold; // #2534
				}
				above = {
					x: 0,
					y: 0,
					width: chartSizeMax,
					height: translatedThreshold
				};
				below = {
					x: 0,
					y: translatedThreshold,
					width: chartSizeMax,
					height: chartSizeMax
				};
	
				if (chart.inverted) {
	
					above.height = below.y = chart.plotWidth - translatedThreshold;
					if (renderer.isVML) {
						above = {
							x: chart.plotWidth - translatedThreshold - chart.plotLeft,
							y: 0,
							width: chartWidth,
							height: chartHeight
						};
						below = {
							x: translatedThreshold + chart.plotLeft - chartWidth,
							y: 0,
							width: chart.plotLeft + translatedThreshold,
							height: chartWidth
						};
					}
				}
	
				if (yAxis.reversed) {
					posAttr = below;
					negAttr = above;
				} else {
					posAttr = above;
					negAttr = below;
				}
	
				if (posClip) { // update
					posClip.animate(posAttr);
					negClip.animate(negAttr);
				} else {
	
					this.posClip = posClip = renderer.clipRect(posAttr);
					this.negClip = negClip = renderer.clipRect(negAttr);
	
					if (graph && this.graphNeg) {
						graph.clip(posClip);
						this.graphNeg.clip(negClip);
					}
	
					if (area) {
						area.clip(posClip);
						this.areaNeg.clip(negClip);
					}
				}
			}
		},
	
		/**
		 * Initialize and perform group inversion on series.group and series.markerGroup
		 */
		invertGroups: function () {
			var series = this,
				chart = series.chart;
	
			// Pie, go away (#1736)
			if (!series.xAxis) {
				return;
			}
	
			// A fixed size is needed for inversion to work
			function setInvert() {
				var size = {
					width: series.yAxis.len,
					height: series.xAxis.len
				};
	
				each(['group', 'markerGroup'], function (groupName) {
					if (series[groupName]) {
						series[groupName].attr(size).invert();
					}
				});
			}
	
			addEvent(chart, 'resize', setInvert); // do it on resize
			addEvent(series, 'destroy', function () {
				removeEvent(chart, 'resize', setInvert);
			});
	
			// Do it now
			setInvert(); // do it now
	
			// On subsequent render and redraw, just do setInvert without setting up events again
			series.invertGroups = setInvert;
		},
	
		/**
		 * General abstraction for creating plot groups like series.group, series.dataLabelsGroup and
		 * series.markerGroup. On subsequent calls, the group will only be adjusted to the updated plot size.
		 */
		plotGroup: function (prop, name, visibility, zIndex, parent) {
			var group = this[prop],
				isNew = !group;
	
			// Generate it on first call
			if (isNew) {
				this[prop] = group = this.chart.renderer.g(name)
					.attr({
						visibility: visibility,
						zIndex: zIndex || 0.1 // IE8 needs this
					})
					.add(parent);
			}
			// Place it on first and subsequent (redraw) calls
			group[isNew ? 'attr' : 'animate'](this.getPlotBox());
			return group;
		},
	
		/**
		 * Get the translation and scale for the plot area of this series
		 */
		getPlotBox: function () {
			var chart = this.chart,
				xAxis = this.xAxis,
				yAxis = this.yAxis;
	
			// Swap axes for inverted (#2339)
			if (chart.inverted) {
				xAxis = yAxis;
				yAxis = this.xAxis;
			}
			return {
				translateX: xAxis ? xAxis.left : chart.plotLeft,
				translateY: yAxis ? yAxis.top : chart.plotTop,
				scaleX: 1, // #1623
				scaleY: 1
			};
		},
	
		/**
		 * Render the graph and markers
		 */
		render: function () {
			var series = this,
				chart = series.chart,
				group,
				options = series.options,
				animation = options.animation,
				// Animation doesn't work in IE8 quirks when the group div is hidden,
				// and looks bad in other oldIE
				animDuration = (animation && !!series.animate && chart.renderer.isSVG && pick(animation.duration, 500)) || 0,
				visibility = series.visible ? VISIBLE : HIDDEN,
				zIndex = options.zIndex,
				hasRendered = series.hasRendered,
				chartSeriesGroup = chart.seriesGroup;
	
			// the group
			group = series.plotGroup(
				'group',
				'series',
				visibility,
				zIndex,
				chartSeriesGroup
			);
	
			series.markerGroup = series.plotGroup(
				'markerGroup',
				'markers',
				visibility,
				zIndex,
				chartSeriesGroup
			);
	
			// initiate the animation
			if (animDuration) {
				series.animate(true);
			}
	
			// cache attributes for shapes
			series.getAttribs();
	
			// SVGRenderer needs to know this before drawing elements (#1089, #1795)
			group.inverted = series.isCartesian ? chart.inverted : false;
	
			// draw the graph if any
			if (series.drawGraph) {
				series.drawGraph();
				series.clipNeg();
			}
	
			each(series.points, function (point) {
				if (point.redraw) {
					point.redraw();
				}
			});
	
			// draw the data labels (inn pies they go before the points)
			if (series.drawDataLabels) {
				series.drawDataLabels();
			}
	
			// draw the points
			if (series.visible) {
				series.drawPoints();
			}
	
	
			// draw the mouse tracking area
			if (series.drawTracker && series.options.enableMouseTracking !== false) {
				series.drawTracker();
			}
	
			// Handle inverted series and tracker groups
			if (chart.inverted) {
				series.invertGroups();
			}
	
			// Initial clipping, must be defined after inverting groups for VML
			if (options.clip !== false && !series.sharedClipKey && !hasRendered) {
				group.clip(chart.clipRect);
			}
	
			// Run the animation
			if (animDuration) {
				series.animate();
			} 
	
			// Call the afterAnimate function on animation complete (but don't overwrite the animation.complete option
			// which should be available to the user).
			if (!hasRendered) {
				if (animDuration) {
					series.animationTimeout = setTimeout(function () {
						series.afterAnimate();
					}, animDuration);
				} else {
					series.afterAnimate();
				}
			}
	
			series.isDirty = series.isDirtyData = false; // means data is in accordance with what you see
			// (See #322) series.isDirty = series.isDirtyData = false; // means data is in accordance with what you see
			series.hasRendered = true;
		},
	
		/**
		 * Redraw the series after an update in the axes.
		 */
		redraw: function () {
			var series = this,
				chart = series.chart,
				wasDirtyData = series.isDirtyData, // cache it here as it is set to false in render, but used after
				group = series.group,
				xAxis = series.xAxis,
				yAxis = series.yAxis;
	
			// reposition on resize
			if (group) {
				if (chart.inverted) {
					group.attr({
						width: chart.plotWidth,
						height: chart.plotHeight
					});
				}
	
				group.animate({
					translateX: pick(xAxis && xAxis.left, chart.plotLeft),
					translateY: pick(yAxis && yAxis.top, chart.plotTop)
				});
			}
	
			series.translate();
			if (series.setTooltipPoints) {
				series.setTooltipPoints(true);
			}
			series.render();
	
			if (wasDirtyData) {
				fireEvent(series, 'updatedData');
			}
		}
	}; // end Series prototype
	
	/**
	 * The class for stack items
	 */
	function StackItem(axis, options, isNegative, x, stackOption) {
		
		var inverted = axis.chart.inverted;
	
		this.axis = axis;
	
		// Tells if the stack is negative
		this.isNegative = isNegative;
	
		// Save the options to be able to style the label
		this.options = options;
	
		// Save the x value to be able to position the label later
		this.x = x;
	
		// Initialize total value
		this.total = null;
	
		// This will keep each points' extremes stored by series.index and point index
		this.points = {};
	
		// Save the stack option on the series configuration object, and whether to treat it as percent
		this.stack = stackOption;
	
		// The align options and text align varies on whether the stack is negative and
		// if the chart is inverted or not.
		// First test the user supplied value, then use the dynamic.
		this.alignOptions = {
			align: options.align || (inverted ? (isNegative ? 'left' : 'right') : 'center'),
			verticalAlign: options.verticalAlign || (inverted ? 'middle' : (isNegative ? 'bottom' : 'top')),
			y: pick(options.y, inverted ? 4 : (isNegative ? 14 : -6)),
			x: pick(options.x, inverted ? (isNegative ? -6 : 6) : 0)
		};
	
		this.textAlign = options.textAlign || (inverted ? (isNegative ? 'right' : 'left') : 'center');
	}
	
	StackItem.prototype = {
		destroy: function () {
			destroyObjectProperties(this, this.axis);
		},
	
		/**
		 * Renders the stack total label and adds it to the stack label group.
		 */
		render: function (group) {
			var options = this.options,
				formatOption = options.format,
				str = formatOption ?
					format(formatOption, this) : 
					options.formatter.call(this);  // format the text in the label
	
			// Change the text to reflect the new total and set visibility to hidden in case the serie is hidden
			if (this.label) {
				this.label.attr({text: str, visibility: HIDDEN});
			// Create new label
			} else {
				this.label =
					this.axis.chart.renderer.text(str, null, null, options.useHTML)		// dummy positions, actual position updated with setOffset method in columnseries
						.css(options.style)				// apply style
						.attr({
							align: this.textAlign,				// fix the text-anchor
							rotation: options.rotation,	// rotation
							visibility: HIDDEN					// hidden until setOffset is called
						})				
						.add(group);							// add to the labels-group
			}
		},
	
		/**
		 * Sets the offset that the stack has from the x value and repositions the label.
		 */
		setOffset: function (xOffset, xWidth) {
			var stackItem = this,
				axis = stackItem.axis,
				chart = axis.chart,
				inverted = chart.inverted,
				neg = this.isNegative,							// special treatment is needed for negative stacks
				y = axis.translate(axis.usePercentage ? 100 : this.total, 0, 0, 0, 1), // stack value translated mapped to chart coordinates
				yZero = axis.translate(0),						// stack origin
				h = mathAbs(y - yZero),							// stack height
				x = chart.xAxis[0].translate(this.x) + xOffset,	// stack x position
				plotHeight = chart.plotHeight,
				stackBox = {	// this is the box for the complete stack
					x: inverted ? (neg ? y : y - h) : x,
					y: inverted ? plotHeight - x - xWidth : (neg ? (plotHeight - y - h) : plotHeight - y),
					width: inverted ? h : xWidth,
					height: inverted ? xWidth : h
				},
				label = this.label,
				alignAttr;
			
			if (label) {
				label.align(this.alignOptions, null, stackBox);	// align the label to the box
					
				// Set visibility (#678)
				alignAttr = label.alignAttr;
				label[this.options.crop === false || chart.isInsidePlot(alignAttr.x, alignAttr.y) ? 'show' : 'hide'](true);
			}
		}
	};
	
	
	// Stacking methods defined on the Axis prototype
	
	/**
	 * Build the stacks from top down
	 */
	Axis.prototype.buildStacks = function () {
		var series = this.series,
			reversedStacks = pick(this.options.reversedStacks, true),
			i = series.length;
		if (!this.isXAxis) {
			this.usePercentage = false;
			while (i--) {
				series[reversedStacks ? i : series.length - i - 1].setStackedPoints();
			}
			// Loop up again to compute percent stack
			if (this.usePercentage) {
				for (i = 0; i < series.length; i++) {
					series[i].setPercentStacks();
				}
			}
		}
	};
	
	Axis.prototype.renderStackTotals = function () {
		var axis = this,
			chart = axis.chart,
			renderer = chart.renderer,
			stacks = axis.stacks,
			stackKey, 
			oneStack, 
			stackCategory,
			stackTotalGroup = axis.stackTotalGroup;
	
		// Create a separate group for the stack total labels
		if (!stackTotalGroup) {
			axis.stackTotalGroup = stackTotalGroup =
				renderer.g('stack-labels')
					.attr({
						visibility: VISIBLE,
						zIndex: 6
					})
					.add();
		}
	
		// plotLeft/Top will change when y axis gets wider so we need to translate the
		// stackTotalGroup at every render call. See bug #506 and #516
		stackTotalGroup.translate(chart.plotLeft, chart.plotTop);
	
		// Render each stack total
		for (stackKey in stacks) {
			oneStack = stacks[stackKey];
			for (stackCategory in oneStack) {
				oneStack[stackCategory].render(stackTotalGroup);
			}
		}
	};
	
	
	// Stacking methods defnied for Series prototype
	
	/**
	 * Adds series' points value to corresponding stack
	 */
	Series.prototype.setStackedPoints = function () {
		if (!this.options.stacking || (this.visible !== true && this.chart.options.chart.ignoreHiddenSeries !== false)) {
			return;
		}
	
		var series = this,
			xData = series.processedXData,
			yData = series.processedYData,
			stackedYData = [],
			yDataLength = yData.length,
			seriesOptions = series.options,
			threshold = seriesOptions.threshold,
			stackOption = seriesOptions.stack,
			stacking = seriesOptions.stacking,
			stackKey = series.stackKey,
			negKey = '-' + stackKey,
			negStacks = series.negStacks,
			yAxis = series.yAxis,
			stacks = yAxis.stacks,
			oldStacks = yAxis.oldStacks,
			isNegative,
			stack,
			other,
			key,
			pointKey,
			i,
			x,
			y;
	
		// loop over the non-null y values and read them into a local array
		for (i = 0; i < yDataLength; i++) {
			x = xData[i];
			y = yData[i];
			pointKey = series.index + ',' + i;
	
			// Read stacked values into a stack based on the x value,
			// the sign of y and the stack key. Stacking is also handled for null values (#739)
			isNegative = negStacks && y < threshold;
			key = isNegative ? negKey : stackKey;
	
			// Create empty object for this stack if it doesn't exist yet
			if (!stacks[key]) {
				stacks[key] = {};
			}
	
			// Initialize StackItem for this x
			if (!stacks[key][x]) {
				if (oldStacks[key] && oldStacks[key][x]) {
					stacks[key][x] = oldStacks[key][x];
					stacks[key][x].total = null;
				} else {
					stacks[key][x] = new StackItem(yAxis, yAxis.options.stackLabels, isNegative, x, stackOption);
				}
			}
	
			// If the StackItem doesn't exist, create it first
			stack = stacks[key][x];
			stack.points[pointKey] = [stack.cum || 0];
	
			// Add value to the stack total
			if (stacking === 'percent') {
	
				// Percent stacked column, totals are the same for the positive and negative stacks
				other = isNegative ? stackKey : negKey;
				if (negStacks && stacks[other] && stacks[other][x]) {
					other = stacks[other][x];
					stack.total = other.total = mathMax(other.total, stack.total) + mathAbs(y) || 0;
	
				// Percent stacked areas
				} else {
					stack.total = correctFloat(stack.total + (mathAbs(y) || 0));
				}
			} else {
				stack.total = correctFloat(stack.total + (y || 0));
			}
	
			stack.cum = (stack.cum || 0) + (y || 0);
	
			stack.points[pointKey].push(stack.cum);
			stackedYData[i] = stack.cum;
	
		}
	
		if (stacking === 'percent') {
			yAxis.usePercentage = true;
		}
	
		this.stackedYData = stackedYData; // To be used in getExtremes
	
		// Reset old stacks
		yAxis.oldStacks = {};
	};
	
	/**
	 * Iterate over all stacks and compute the absolute values to percent
	 */
	Series.prototype.setPercentStacks = function () {
		var series = this,
			stackKey = series.stackKey,
			stacks = series.yAxis.stacks,
			processedXData = series.processedXData;
	
		each([stackKey, '-' + stackKey], function (key) {
			var i = processedXData.length,
				x,
				stack,
				pointExtremes,
				totalFactor;
	
			while (i--) {
				x = processedXData[i];
				stack = stacks[key] && stacks[key][x];
				pointExtremes = stack && stack.points[series.index + ',' + i];
				if (pointExtremes) {
					totalFactor = stack.total ? 100 / stack.total : 0;
					pointExtremes[0] = correctFloat(pointExtremes[0] * totalFactor); // Y bottom value
					pointExtremes[1] = correctFloat(pointExtremes[1] * totalFactor); // Y value
					series.stackedYData[i] = pointExtremes[1];
				}
			}
		});
	};
	
	// Extend the Chart prototype for dynamic methods
	extend(Chart.prototype, {
	
		/**
		 * Add a series dynamically after  time
		 *
		 * @param {Object} options The config options
		 * @param {Boolean} redraw Whether to redraw the chart after adding. Defaults to true.
		 * @param {Boolean|Object} animation Whether to apply animation, and optionally animation
		 *    configuration
		 *
		 * @return {Object} series The newly created series object
		 */
		addSeries: function (options, redraw, animation) {
			var series,
				chart = this;
	
			if (options) {
				redraw = pick(redraw, true); // defaults to true
	
				fireEvent(chart, 'addSeries', { options: options }, function () {
					series = chart.initSeries(options);
	
					chart.isDirtyLegend = true; // the series array is out of sync with the display
					chart.linkSeries();
					if (redraw) {
						chart.redraw(animation);
					}
				});
			}
	
			return series;
		},
	
		/**
	     * Add an axis to the chart
	     * @param {Object} options The axis option
	     * @param {Boolean} isX Whether it is an X axis or a value axis
	     */
		addAxis: function (options, isX, redraw, animation) {
			var key = isX ? 'xAxis' : 'yAxis',
				chartOptions = this.options,
				axis;
	
			/*jslint unused: false*/
			axis = new Axis(this, merge(options, {
				index: this[key].length,
				isX: isX
			}));
			/*jslint unused: true*/
	
			// Push the new axis options to the chart options
			chartOptions[key] = splat(chartOptions[key] || {});
			chartOptions[key].push(options);
	
			if (pick(redraw, true)) {
				this.redraw(animation);
			}
		},
	
		/**
		 * Dim the chart and show a loading text or symbol
		 * @param {String} str An optional text to show in the loading label instead of the default one
		 */
		showLoading: function (str) {
			var chart = this,
				options = chart.options,
				loadingDiv = chart.loadingDiv,
				loadingOptions = options.loading,
				setLoadingSize = function () {
					if (loadingDiv) {
						css(loadingDiv, {
							left: chart.plotLeft + PX,
							top: chart.plotTop + PX,
							width: chart.plotWidth + PX,
							height: chart.plotHeight + PX
						});
					}
				};
	
			// create the layer at the first call
			if (!loadingDiv) {
				chart.loadingDiv = loadingDiv = createElement(DIV, {
					className: PREFIX + 'loading'
				}, extend(loadingOptions.style, {
					zIndex: 10,
					display: NONE
				}), chart.container);
	
				chart.loadingSpan = createElement(
					'span',
					null,
					loadingOptions.labelStyle,
					loadingDiv
				);
				addEvent(chart, 'redraw', setLoadingSize); // #1080
			}
	
			// update text
			chart.loadingSpan.innerHTML = str || options.lang.loading;
	
			// show it
			if (!chart.loadingShown) {
				css(loadingDiv, {
					opacity: 0,
					display: ''				
				});
				animate(loadingDiv, {
					opacity: loadingOptions.style.opacity
				}, {
					duration: loadingOptions.showDuration || 0
				});
				chart.loadingShown = true;
			}
			setLoadingSize();
		},
	
		/**
		 * Hide the loading layer
		 */
		hideLoading: function () {
			var options = this.options,
				loadingDiv = this.loadingDiv;
	
			if (loadingDiv) {
				animate(loadingDiv, {
					opacity: 0
				}, {
					duration: options.loading.hideDuration || 100,
					complete: function () {
						css(loadingDiv, { display: NONE });
					}
				});
			}
			this.loadingShown = false;
		}
	});
	
	// extend the Point prototype for dynamic methods
	extend(Point.prototype, {
		/**
		 * Update the point with new options (typically x/y data) and optionally redraw the series.
		 *
		 * @param {Object} options Point options as defined in the series.data array
		 * @param {Boolean} redraw Whether to redraw the chart or wait for an explicit call
		 * @param {Boolean|Object} animation Whether to apply animation, and optionally animation
		 *    configuration
		 *
		 */
		update: function (options, redraw, animation, runEvent) {
			var point = this,
				series = point.series,
				graphic = point.graphic,
				i,
				chart = series.chart,
				seriesOptions = series.options;
	
			redraw = pick(redraw, true);
	
			function update() {
	
				point.applyOptions(options);
	
				// Update visuals
				if (isObject(options) && !isArray(options)) {
					// Defer the actual redraw until getAttribs has been called (#3260)
					point.redraw = function () {
						if (graphic) {
							if (options && options.marker && options.marker.symbol) {
								point.graphic = graphic.destroy();
							} else {
								graphic.attr(point.pointAttr[point.state || '']);
							}
						}
						if (options && options.dataLabels && point.dataLabel) { // #2468
							point.dataLabel = point.dataLabel.destroy();
						}
						point.redraw = null;
					};
				}
	
				// record changes in the parallel arrays
				i = point.index;
				series.updateParallelArrays(point, i);
	
				seriesOptions.data[i] = point.options;
	
				// redraw
				series.isDirty = series.isDirtyData = true;
				if (!series.fixedBox && series.hasCartesianSeries) { // #1906, #2320
					chart.isDirtyBox = true;
				}
	
				if (seriesOptions.legendType === 'point') { // #1831, #1885
					chart.legend.destroyItem(point);
				}
				if (redraw) {
					chart.redraw(animation);
				}
			}
	
			// Fire the event with a default handler of doing the update
			if (runEvent === false) { // When called from setData
				update();
			} else {
				point.firePointEvent('update', { options: options }, update);
			}
		},
	
		/**
		 * Remove a point and optionally redraw the series and if necessary the axes
		 * @param {Boolean} redraw Whether to redraw the chart or wait for an explicit call
		 * @param {Boolean|Object} animation Whether to apply animation, and optionally animation
		 *    configuration
		 */
		remove: function (redraw, animation) {
			var point = this,
				series = point.series,
				points = series.points,
				chart = series.chart,
				i,
				data = series.data;
	
			setAnimation(animation, chart);
			redraw = pick(redraw, true);
	
			// fire the event with a default handler of removing the point
			point.firePointEvent('remove', null, function () {
	
				// splice all the parallel arrays
				i = inArray(point, data);
				if (data.length === points.length) {
					points.splice(i, 1);
				}
				data.splice(i, 1);
				series.options.data.splice(i, 1);
				series.updateParallelArrays(point, 'splice', i, 1);
	
				point.destroy();
	
				// redraw
				series.isDirty = true;
				series.isDirtyData = true;
				if (redraw) {
					chart.redraw();
				}
			});
		}
	});
	
	// Extend the series prototype for dynamic methods
	extend(Series.prototype, {
		/**
		 * Add a point dynamically after chart load time
		 * @param {Object} options Point options as given in series.data
		 * @param {Boolean} redraw Whether to redraw the chart or wait for an explicit call
		 * @param {Boolean} shift If shift is true, a point is shifted off the start
		 *    of the series as one is appended to the end.
		 * @param {Boolean|Object} animation Whether to apply animation, and optionally animation
		 *    configuration
		 */
		addPoint: function (options, redraw, shift, animation) {
			var series = this,
				seriesOptions = series.options,
				data = series.data,
				graph = series.graph,
				area = series.area,
				chart = series.chart,
				names = series.xAxis && series.xAxis.names,
				currentShift = (graph && graph.shift) || 0,
				dataOptions = seriesOptions.data,
				point,
				isInTheMiddle,
				xData = series.xData,
				x,
				i;
	
			setAnimation(animation, chart);
	
			// Make graph animate sideways
			if (shift) {
				each([graph, area, series.graphNeg, series.areaNeg], function (shape) {
					if (shape) {
						shape.shift = currentShift + 1;
					}
				});
			}
			if (area) {
				area.isArea = true; // needed in animation, both with and without shift
			}
	
			// Optional redraw, defaults to true
			redraw = pick(redraw, true);
	
			// Get options and push the point to xData, yData and series.options. In series.generatePoints
			// the Point instance will be created on demand and pushed to the series.data array.
			point = { series: series };
			series.pointClass.prototype.applyOptions.apply(point, [options]);
			x = point.x;
	
			// Get the insertion point
			i = xData.length;
			if (series.requireSorting && x < xData[i - 1]) {
				isInTheMiddle = true;
				while (i && xData[i - 1] > x) {
					i--;
				}
			}
	
			series.updateParallelArrays(point, 'splice', i, 0, 0); // insert undefined item
			series.updateParallelArrays(point, i); // update it
	
			if (names && point.name) {
				names[x] = point.name;
			}
			dataOptions.splice(i, 0, options);
	
			if (isInTheMiddle) {
				series.data.splice(i, 0, null);
				series.processData();
			}
	
			// Generate points to be added to the legend (#1329)
			if (seriesOptions.legendType === 'point') {
				series.generatePoints();
			}
	
			// Shift the first point off the parallel arrays
			// todo: consider series.removePoint(i) method
			if (shift) {
				if (data[0] && data[0].remove) {
					data[0].remove(false);
				} else {
					data.shift();
					series.updateParallelArrays(point, 'shift');
	
					dataOptions.shift();
				}
			}
	
			// redraw
			series.isDirty = true;
			series.isDirtyData = true;
			if (redraw) {
				series.getAttribs(); // #1937
				chart.redraw();
			}
		},
	
		/**
		 * Remove a series and optionally redraw the chart
		 *
		 * @param {Boolean} redraw Whether to redraw the chart or wait for an explicit call
		 * @param {Boolean|Object} animation Whether to apply animation, and optionally animation
		 *    configuration
		 */
	
		remove: function (redraw, animation) {
			var series = this,
				chart = series.chart;
			redraw = pick(redraw, true);
	
			if (!series.isRemoving) {  /* prevent triggering native event in jQuery
					(calling the remove function from the remove event) */
				series.isRemoving = true;
	
				// fire the event with a default handler of removing the point
				fireEvent(series, 'remove', null, function () {
	
	
					// destroy elements
					series.destroy();
	
	
					// redraw
					chart.isDirtyLegend = chart.isDirtyBox = true;
					chart.linkSeries();
	
					if (redraw) {
						chart.redraw(animation);
					}
				});
	
			}
			series.isRemoving = false;
		},
	
		/**
		 * Update the series with a new set of options
		 */
		update: function (newOptions, redraw) {
			var series = this,
				chart = this.chart,
				// must use user options when changing type because this.options is merged
				// in with type specific plotOptions
				oldOptions = this.userOptions,
				oldType = this.type,
				proto = seriesTypes[oldType].prototype,
				preserve = ['group', 'markerGroup', 'dataLabelsGroup'],
				n;
	
			// Make sure groups are not destroyed (#3094)
			each(preserve, function (prop) {
				preserve[prop] = series[prop];
				delete series[prop];
			});
	
			// Do the merge, with some forced options
			newOptions = merge(oldOptions, {
				animation: false,
				index: this.index,
				pointStart: this.xData[0] // when updating after addPoint
			}, { data: this.options.data }, newOptions);
	
			// Destroy the series and reinsert methods from the type prototype
			this.remove(false);
			for (n in proto) { // Overwrite series-type specific methods (#2270)
				if (proto.hasOwnProperty(n)) {
					this[n] = UNDEFINED;
				}
			}
			extend(this, seriesTypes[newOptions.type || oldType].prototype);
	
			// Re-register groups (#3094)
			each(preserve, function (prop) {
				series[prop] = preserve[prop];
			});
	
	
			this.init(chart, newOptions);
			chart.linkSeries(); // Links are lost in this.remove (#3028)
			if (pick(redraw, true)) {
				chart.redraw(false);
			}
		}
	});
	
	// Extend the Axis.prototype for dynamic methods
	extend(Axis.prototype, {
	
		/**
		 * Update the axis with a new options structure
		 */
		update: function (newOptions, redraw) {
			var chart = this.chart;
	
			newOptions = chart.options[this.coll][this.options.index] = merge(this.userOptions, newOptions);
	
			this.destroy(true);
			this._addedPlotLB = UNDEFINED; // #1611, #2887
	
			this.init(chart, extend(newOptions, { events: UNDEFINED }));
	
			chart.isDirtyBox = true;
			if (pick(redraw, true)) {
				chart.redraw();
			}
		},
	
		/**
	     * Remove the axis from the chart
	     */
		remove: function (redraw) {
			var chart = this.chart,
				key = this.coll, // xAxis or yAxis
				axisSeries = this.series,
				i = axisSeries.length;
	
			// Remove associated series (#2687)
			while (i--) {
				if (axisSeries[i]) {
					axisSeries[i].remove(false);
				}
			}
	
			// Remove the axis
			erase(chart.axes, this);
			erase(chart[key], this);
			chart.options[key].splice(this.options.index, 1);
			each(chart[key], function (axis, i) { // Re-index, #1706
				axis.options.index = i;
			});
			this.destroy();
			chart.isDirtyBox = true;
	
			if (pick(redraw, true)) {
				chart.redraw();
			}
		},
	
		/**
		 * Update the axis title by options
		 */
		setTitle: function (newTitleOptions, redraw) {
			this.update({ title: newTitleOptions }, redraw);
		},
	
		/**
		 * Set new axis categories and optionally redraw
		 * @param {Array} categories
		 * @param {Boolean} redraw
		 */
		setCategories: function (categories, redraw) {
			this.update({ categories: categories }, redraw);
		}
	
	});
	
	
	/**
	 * LineSeries object
	 */
	var LineSeries = extendClass(Series);
	seriesTypes.line = LineSeries;
	
	/**
	 * Set the default options for area
	 */
	defaultPlotOptions.area = merge(defaultSeriesOptions, {
		threshold: 0
		// trackByArea: false,
		// lineColor: null, // overrides color, but lets fillColor be unaltered
		// fillOpacity: 0.75,
		// fillColor: null
	});
	
	/**
	 * AreaSeries object
	 */
	var AreaSeries = extendClass(Series, {
		type: 'area',
		/**
		 * For stacks, don't split segments on null values. Instead, draw null values with 
		 * no marker. Also insert dummy points for any X position that exists in other series
		 * in the stack.
		 */ 
		getSegments: function () {
			var series = this,
				segments = [],
				segment = [],
				keys = [],
				xAxis = this.xAxis,
				yAxis = this.yAxis,
				stack = yAxis.stacks[this.stackKey],
				pointMap = {},
				plotX,
				plotY,
				points = this.points,
				connectNulls = this.options.connectNulls,
				i,
				x;
	
			if (this.options.stacking && !this.cropped) { // cropped causes artefacts in Stock, and perf issue
				// Create a map where we can quickly look up the points by their X value.
				for (i = 0; i < points.length; i++) {
					pointMap[points[i].x] = points[i];
				}
	
				// Sort the keys (#1651)
				for (x in stack) {
					if (stack[x].total !== null) { // nulled after switching between grouping and not (#1651, #2336)
						keys.push(+x);
					}
				}
				keys.sort(function (a, b) {
					return a - b;
				});
	
				each(keys, function (x) {
					var y = 0,
						stackPoint;
	
					if (connectNulls && (!pointMap[x] || pointMap[x].y === null)) { // #1836
						return;
	
					// The point exists, push it to the segment
					} else if (pointMap[x]) {
						segment.push(pointMap[x]);
	
					// There is no point for this X value in this series, so we 
					// insert a dummy point in order for the areas to be drawn
					// correctly.
					} else {
	
						// Loop down the stack to find the series below this one that has
						// a value (#1991)
						for (i = series.index; i <= yAxis.series.length; i++) {
							stackPoint = stack[x].points[i + ',' + x];
							if (stackPoint) {
								y = stackPoint[1];
								break;
							}
						}
	
						plotX = xAxis.translate(x);
						plotY = yAxis.toPixels(y, true);
						segment.push({ 
							y: null, 
							plotX: plotX,
							clientX: plotX, 
							plotY: plotY, 
							yBottom: plotY,
							onMouseOver: noop
						});
					}
				});
	
				if (segment.length) {
					segments.push(segment);
				}
	
			} else {
				Series.prototype.getSegments.call(this);
				segments = this.segments;
			}
	
			this.segments = segments;
		},
		
		/**
		 * Extend the base Series getSegmentPath method by adding the path for the area.
		 * This path is pushed to the series.areaPath property.
		 */
		getSegmentPath: function (segment) {
			
			var segmentPath = Series.prototype.getSegmentPath.call(this, segment), // call base method
				areaSegmentPath = [].concat(segmentPath), // work on a copy for the area path
				i,
				options = this.options,
				segLength = segmentPath.length,
				translatedThreshold = this.yAxis.getThreshold(options.threshold), // #2181
				yBottom;
			
			if (segLength === 3) { // for animation from 1 to two points
				areaSegmentPath.push(L, segmentPath[1], segmentPath[2]);
			}
			if (options.stacking && !this.closedStacks) {
				
				// Follow stack back. Todo: implement areaspline. A general solution could be to 
				// reverse the entire graphPath of the previous series, though may be hard with
				// splines and with series with different extremes
				for (i = segment.length - 1; i >= 0; i--) {
	
					yBottom = pick(segment[i].yBottom, translatedThreshold);
				
					// step line?
					if (i < segment.length - 1 && options.step) {
						areaSegmentPath.push(segment[i + 1].plotX, yBottom);
					}
					
					areaSegmentPath.push(segment[i].plotX, yBottom);
				}
	
			} else { // follow zero line back
				this.closeSegment(areaSegmentPath, segment, translatedThreshold);
			}
			this.areaPath = this.areaPath.concat(areaSegmentPath);
			return segmentPath;
		},
		
		/**
		 * Extendable method to close the segment path of an area. This is overridden in polar 
		 * charts.
		 */
		closeSegment: function (path, segment, translatedThreshold) {
			path.push(
				L,
				segment[segment.length - 1].plotX,
				translatedThreshold,
				L,
				segment[0].plotX,
				translatedThreshold
			);
		},
		
		/**
		 * Draw the graph and the underlying area. This method calls the Series base
		 * function and adds the area. The areaPath is calculated in the getSegmentPath
		 * method called from Series.prototype.drawGraph.
		 */
		drawGraph: function () {
			
			// Define or reset areaPath
			this.areaPath = [];
			
			// Call the base method
			Series.prototype.drawGraph.apply(this);
			
			// Define local variables
			var series = this,
				areaPath = this.areaPath,
				options = this.options,
				negativeColor = options.negativeColor,
				negativeFillColor = options.negativeFillColor,
				props = [['area', this.color, options.fillColor]]; // area name, main color, fill color
			
			if (negativeColor || negativeFillColor) {
				props.push(['areaNeg', negativeColor, negativeFillColor]);
			}
			
			each(props, function (prop) {
				var areaKey = prop[0],
					area = series[areaKey];
					
				// Create or update the area
				if (area) { // update
					area.animate({ d: areaPath });
		
				} else { // create
					series[areaKey] = series.chart.renderer.path(areaPath)
						.attr({
							fill: pick(
								prop[2],
								Color(prop[1]).setOpacity(pick(options.fillOpacity, 0.75)).get()
							),
							zIndex: 0 // #1069
						}).add(series.group);
				}
			});
		},
	
		drawLegendSymbol: LegendSymbolMixin.drawRectangle
	});
	
	seriesTypes.area = AreaSeries;
	/**
	 * Set the default options for spline
	 */
	defaultPlotOptions.spline = merge(defaultSeriesOptions);
	
	/**
	 * SplineSeries object
	 */
	var SplineSeries = extendClass(Series, {
		type: 'spline',
	
		/**
		 * Get the spline segment from a given point's previous neighbour to the given point
		 */
		getPointSpline: function (segment, point, i) {
			var smoothing = 1.5, // 1 means control points midway between points, 2 means 1/3 from the point, 3 is 1/4 etc
				denom = smoothing + 1,
				plotX = point.plotX,
				plotY = point.plotY,
				lastPoint = segment[i - 1],
				nextPoint = segment[i + 1],
				leftContX,
				leftContY,
				rightContX,
				rightContY,
				ret;
	
			// find control points
			if (lastPoint && nextPoint) {
			
				var lastX = lastPoint.plotX,
					lastY = lastPoint.plotY,
					nextX = nextPoint.plotX,
					nextY = nextPoint.plotY,
					correction;
	
				leftContX = (smoothing * plotX + lastX) / denom;
				leftContY = (smoothing * plotY + lastY) / denom;
				rightContX = (smoothing * plotX + nextX) / denom;
				rightContY = (smoothing * plotY + nextY) / denom;
	
				// have the two control points make a straight line through main point
				correction = ((rightContY - leftContY) * (rightContX - plotX)) /
					(rightContX - leftContX) + plotY - rightContY;
	
				leftContY += correction;
				rightContY += correction;
	
				// to prevent false extremes, check that control points are between
				// neighbouring points' y values
				if (leftContY > lastY && leftContY > plotY) {
					leftContY = mathMax(lastY, plotY);
					rightContY = 2 * plotY - leftContY; // mirror of left control point
				} else if (leftContY < lastY && leftContY < plotY) {
					leftContY = mathMin(lastY, plotY);
					rightContY = 2 * plotY - leftContY;
				}
				if (rightContY > nextY && rightContY > plotY) {
					rightContY = mathMax(nextY, plotY);
					leftContY = 2 * plotY - rightContY;
				} else if (rightContY < nextY && rightContY < plotY) {
					rightContY = mathMin(nextY, plotY);
					leftContY = 2 * plotY - rightContY;
				}
	
				// record for drawing in next point
				point.rightContX = rightContX;
				point.rightContY = rightContY;
	
			}
			
			// Visualize control points for debugging
			/*
			if (leftContX) {
				this.chart.renderer.circle(leftContX + this.chart.plotLeft, leftContY + this.chart.plotTop, 2)
					.attr({
						stroke: 'red',
						'stroke-width': 1,
						fill: 'none'
					})
					.add();
				this.chart.renderer.path(['M', leftContX + this.chart.plotLeft, leftContY + this.chart.plotTop,
					'L', plotX + this.chart.plotLeft, plotY + this.chart.plotTop])
					.attr({
						stroke: 'red',
						'stroke-width': 1
					})
					.add();
				this.chart.renderer.circle(rightContX + this.chart.plotLeft, rightContY + this.chart.plotTop, 2)
					.attr({
						stroke: 'green',
						'stroke-width': 1,
						fill: 'none'
					})
					.add();
				this.chart.renderer.path(['M', rightContX + this.chart.plotLeft, rightContY + this.chart.plotTop,
					'L', plotX + this.chart.plotLeft, plotY + this.chart.plotTop])
					.attr({
						stroke: 'green',
						'stroke-width': 1
					})
					.add();
			}
			*/
	
			// moveTo or lineTo
			if (!i) {
				ret = [M, plotX, plotY];
			} else { // curve from last point to this
				ret = [
					'C',
					lastPoint.rightContX || lastPoint.plotX,
					lastPoint.rightContY || lastPoint.plotY,
					leftContX || plotX,
					leftContY || plotY,
					plotX,
					plotY
				];
				lastPoint.rightContX = lastPoint.rightContY = null; // reset for updating series later
			}
			return ret;
		}
	});
	seriesTypes.spline = SplineSeries;
	
	/**
	 * Set the default options for areaspline
	 */
	defaultPlotOptions.areaspline = merge(defaultPlotOptions.area);
	
	/**
	 * AreaSplineSeries object
	 */
	var areaProto = AreaSeries.prototype,
		AreaSplineSeries = extendClass(SplineSeries, {
			type: 'areaspline',
			closedStacks: true, // instead of following the previous graph back, follow the threshold back
			
			// Mix in methods from the area series
			getSegmentPath: areaProto.getSegmentPath,
			closeSegment: areaProto.closeSegment,
			drawGraph: areaProto.drawGraph,
			drawLegendSymbol: LegendSymbolMixin.drawRectangle
		});
	
	seriesTypes.areaspline = AreaSplineSeries;
	
	/**
	 * Set the default options for column
	 */
	defaultPlotOptions.column = merge(defaultSeriesOptions, {
		borderColor: '#FFFFFF',
		//borderWidth: 1,
		borderRadius: 0,
		//colorByPoint: undefined,
		groupPadding: 0.2,
		//grouping: true,
		marker: null, // point options are specified in the base options
		pointPadding: 0.1,
		//pointWidth: null,
		minPointLength: 0,
		cropThreshold: 50, // when there are more points, they will not animate out of the chart on xAxis.setExtremes
		pointRange: null, // null means auto, meaning 1 in a categorized axis and least distance between points if not categories
		states: {
			hover: {
				brightness: 0.1,
				shadow: false,
				halo: false
			},
			select: {
				color: '#C0C0C0',
				borderColor: '#000000',
				shadow: false
			}
		},
		dataLabels: {
			align: null, // auto
			verticalAlign: null, // auto
			y: null
		},
		stickyTracking: false,
		tooltip: {
			distance: 6
		},
		threshold: 0
	});
	
	/**
	 * ColumnSeries object
	 */
	var ColumnSeries = extendClass(Series, {
		type: 'column',
		pointAttrToOptions: { // mapping between SVG attributes and the corresponding options
			stroke: 'borderColor',
			fill: 'color',
			r: 'borderRadius'
		},
		cropShoulder: 0,
		trackerGroups: ['group', 'dataLabelsGroup'],
		negStacks: true, // use separate negative stacks, unlike area stacks where a negative 
			// point is substracted from previous (#1910)
		
		/**
		 * Initialize the series
		 */
		init: function () {
			Series.prototype.init.apply(this, arguments);
	
			var series = this,
				chart = series.chart;
	
			// if the series is added dynamically, force redraw of other
			// series affected by a new column
			if (chart.hasRendered) {
				each(chart.series, function (otherSeries) {
					if (otherSeries.type === series.type) {
						otherSeries.isDirty = true;
					}
				});
			}
		},
	
		/**
		 * Return the width and x offset of the columns adjusted for grouping, groupPadding, pointPadding,
		 * pointWidth etc. 
		 */
		getColumnMetrics: function () {
	
			var series = this,
				options = series.options,
				xAxis = series.xAxis,
				yAxis = series.yAxis,
				reversedXAxis = xAxis.reversed,
				stackKey,
				stackGroups = {},
				columnIndex,
				columnCount = 0;
	
			// Get the total number of column type series.
			// This is called on every series. Consider moving this logic to a
			// chart.orderStacks() function and call it on init, addSeries and removeSeries
			if (options.grouping === false) {
				columnCount = 1;
			} else {
				each(series.chart.series, function (otherSeries) {
					var otherOptions = otherSeries.options,
						otherYAxis = otherSeries.yAxis;
					if (otherSeries.type === series.type && otherSeries.visible &&
							yAxis.len === otherYAxis.len && yAxis.pos === otherYAxis.pos) {  // #642, #2086
						if (otherOptions.stacking) {
							stackKey = otherSeries.stackKey;
							if (stackGroups[stackKey] === UNDEFINED) {
								stackGroups[stackKey] = columnCount++;
							}
							columnIndex = stackGroups[stackKey];
						} else if (otherOptions.grouping !== false) { // #1162
							columnIndex = columnCount++;
						}
						otherSeries.columnIndex = columnIndex;
					}
				});
			}
	
			var categoryWidth = mathMin(
					mathAbs(xAxis.transA) * (xAxis.ordinalSlope || options.pointRange || xAxis.closestPointRange || xAxis.tickInterval || 1), // #2610
					xAxis.len // #1535
				),
				groupPadding = categoryWidth * options.groupPadding,
				groupWidth = categoryWidth - 2 * groupPadding,
				pointOffsetWidth = groupWidth / columnCount,
				optionPointWidth = options.pointWidth,
				pointPadding = defined(optionPointWidth) ? (pointOffsetWidth - optionPointWidth) / 2 :
					pointOffsetWidth * options.pointPadding,
				pointWidth = pick(optionPointWidth, pointOffsetWidth - 2 * pointPadding), // exact point width, used in polar charts
				colIndex = (reversedXAxis ? 
					columnCount - (series.columnIndex || 0) : // #1251
					series.columnIndex) || 0,
				pointXOffset = pointPadding + (groupPadding + colIndex *
					pointOffsetWidth - (categoryWidth / 2)) *
					(reversedXAxis ? -1 : 1);
	
			// Save it for reading in linked series (Error bars particularly)
			return (series.columnMetrics = { 
				width: pointWidth, 
				offset: pointXOffset 
			});
				
		},
	
		/**
		 * Translate each point to the plot area coordinate system and find shape positions
		 */
		translate: function () {
			var series = this,
				chart = series.chart,
				options = series.options,
				borderWidth = series.borderWidth = pick(
					options.borderWidth, 
					series.activePointCount > 0.5 * series.xAxis.len ? 0 : 1
				),
				yAxis = series.yAxis,
				threshold = options.threshold,
				translatedThreshold = series.translatedThreshold = yAxis.getThreshold(threshold),
				minPointLength = pick(options.minPointLength, 5),
				metrics = series.getColumnMetrics(),
				pointWidth = metrics.width,
				seriesBarW = series.barW = mathMax(pointWidth, 1 + 2 * borderWidth), // postprocessed for border width
				pointXOffset = series.pointXOffset = metrics.offset,
				xCrisp = -(borderWidth % 2 ? 0.5 : 0),
				yCrisp = borderWidth % 2 ? 0.5 : 1;
	
			if (chart.renderer.isVML && chart.inverted) {
				yCrisp += 1;
			}
	
			// When the pointPadding is 0, we want the columns to be packed tightly, so we allow individual
			// columns to have individual sizes. When pointPadding is greater, we strive for equal-width
			// columns (#2694).
			if (options.pointPadding) {
				seriesBarW = mathCeil(seriesBarW);
			}
	
			Series.prototype.translate.apply(series);
	
			// Record the new values
			each(series.points, function (point) {
				var yBottom = pick(point.yBottom, translatedThreshold),
					plotY = mathMin(mathMax(-999 - yBottom, point.plotY), yAxis.len + 999 + yBottom), // Don't draw too far outside plot area (#1303, #2241)
					barX = point.plotX + pointXOffset,
					barW = seriesBarW,
					barY = mathMin(plotY, yBottom),
					right,
					bottom,
					fromTop,
					barH = mathMax(plotY, yBottom) - barY;
	
				// Handle options.minPointLength
				if (mathAbs(barH) < minPointLength) {
					if (minPointLength) {
						barH = minPointLength;
						barY =
							mathRound(mathAbs(barY - translatedThreshold) > minPointLength ? // stacked
								yBottom - minPointLength : // keep position
								translatedThreshold - (yAxis.translate(point.y, 0, 1, 0, 1) <= translatedThreshold ? minPointLength : 0)); // use exact yAxis.translation (#1485)
					}
				}
	
				// Cache for access in polar
				point.barX = barX;
				point.pointWidth = pointWidth;
	
				// Fix the tooltip on center of grouped columns (#1216, #424)
				point.tooltipPos = chart.inverted ? 
					[yAxis.len - plotY, series.xAxis.len - barX - barW / 2] : 
					[barX + barW / 2, plotY + yAxis.pos - chart.plotTop];
	
				// Round off to obtain crisp edges and avoid overlapping with neighbours (#2694)
				right = mathRound(barX + barW) + xCrisp;
				barX = mathRound(barX) + xCrisp;
				barW = right - barX;
	
				fromTop = mathAbs(barY) < 0.5;
				bottom = mathRound(barY + barH) + yCrisp;
				barY = mathRound(barY) + yCrisp;
				barH = bottom - barY;
	
				// Top edges are exceptions
				if (fromTop) {
					barY -= 1;
					barH += 1;
				}
	
				// Register shape type and arguments to be used in drawPoints
				point.shapeType = 'rect';
				point.shapeArgs = {
					x: barX,
					y: barY,
					width: barW,
					height: barH
				};
	
			});
	
		},
	
		getSymbol: noop,
		
		/**
		 * Use a solid rectangle like the area series types
		 */
		drawLegendSymbol: LegendSymbolMixin.drawRectangle,
		
		
		/**
		 * Columns have no graph
		 */
		drawGraph: noop,
	
		/**
		 * Draw the columns. For bars, the series.group is rotated, so the same coordinates
		 * apply for columns and bars. This method is inherited by scatter series.
		 *
		 */
		drawPoints: function () {
			var series = this,
				chart = this.chart,
				options = series.options,
				renderer = chart.renderer,
				animationLimit = options.animationLimit || 250,
				shapeArgs,
				pointAttr;
	
			// draw the columns
			each(series.points, function (point) {
				var plotY = point.plotY,
					graphic = point.graphic,
					borderAttr;
	
				if (plotY !== UNDEFINED && !isNaN(plotY) && point.y !== null) {
					shapeArgs = point.shapeArgs;
	
					borderAttr = defined(series.borderWidth) ? {
						'stroke-width': series.borderWidth
					} : {};
	
					pointAttr = point.pointAttr[point.selected ? SELECT_STATE : NORMAL_STATE] || series.pointAttr[NORMAL_STATE];
					
					if (graphic) { // update
						stop(graphic);
						graphic.attr(borderAttr)[chart.pointCount < animationLimit ? 'animate' : 'attr'](merge(shapeArgs));
	
					} else {
						point.graphic = graphic = renderer[point.shapeType](shapeArgs)
							.attr(pointAttr)
							.attr(borderAttr)
							.add(series.group)
							.shadow(options.shadow, null, options.stacking && !options.borderRadius);
					}
	
				} else if (graphic) {
					point.graphic = graphic.destroy(); // #1269
				}
			});
		},
	
		/**
		 * Animate the column heights one by one from zero
		 * @param {Boolean} init Whether to initialize the animation or run it
		 */
		animate: function (init) {
			var series = this,
				yAxis = this.yAxis,
				options = series.options,
				inverted = this.chart.inverted,
				attr = {},
				translatedThreshold;
	
			if (hasSVG) { // VML is too slow anyway
				if (init) {
					attr.scaleY = 0.001;
					translatedThreshold = mathMin(yAxis.pos + yAxis.len, mathMax(yAxis.pos, yAxis.toPixels(options.threshold)));
					if (inverted) {
						attr.translateX = translatedThreshold - yAxis.len;
					} else {
						attr.translateY = translatedThreshold;
					}
					series.group.attr(attr);
	
				} else { // run the animation
					
					attr.scaleY = 1;
					attr[inverted ? 'translateX' : 'translateY'] = yAxis.pos;
					series.group.animate(attr, series.options.animation);
	
					// delete this function to allow it only once
					series.animate = null;
				}
			}
		},
		
		/**
		 * Remove this series from the chart
		 */
		remove: function () {
			var series = this,
				chart = series.chart;
	
			// column and bar series affects other series of the same type
			// as they are either stacked or grouped
			if (chart.hasRendered) {
				each(chart.series, function (otherSeries) {
					if (otherSeries.type === series.type) {
						otherSeries.isDirty = true;
					}
				});
			}
	
			Series.prototype.remove.apply(series, arguments);
		}
	});
	seriesTypes.column = ColumnSeries;
	/**
	 * Set the default options for bar
	 */
	defaultPlotOptions.bar = merge(defaultPlotOptions.column);
	/**
	 * The Bar series class
	 */
	var BarSeries = extendClass(ColumnSeries, {
		type: 'bar',
		inverted: true
	});
	seriesTypes.bar = BarSeries;
	
	/**
	 * Set the default options for scatter
	 */
	defaultPlotOptions.scatter = merge(defaultSeriesOptions, {
		lineWidth: 0,
		tooltip: {
			headerFormat: '<span style="color:{series.color}">\u25CF</span> <span style="font-size: 10px;"> {series.name}</span><br/>',
			pointFormat: 'x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>'
		},
		stickyTracking: false
	});
	
	/**
	 * The scatter series class
	 */
	var ScatterSeries = extendClass(Series, {
		type: 'scatter',
		sorted: false,
		requireSorting: false,
		noSharedTooltip: true,
		trackerGroups: ['markerGroup', 'dataLabelsGroup'],
		takeOrdinalPosition: false, // #2342
		singularTooltips: true,
		drawGraph: function () {
			if (this.options.lineWidth) {
				Series.prototype.drawGraph.call(this);
			}
		}
	});
	
	seriesTypes.scatter = ScatterSeries;
	
	/**
	 * Set the default options for pie
	 */
	defaultPlotOptions.pie = merge(defaultSeriesOptions, {
		borderColor: '#FFFFFF',
		borderWidth: 1,
		center: [null, null],
		clip: false,
		colorByPoint: true, // always true for pies
		dataLabels: {
			// align: null,
			// connectorWidth: 1,
			// connectorColor: point.color,
			// connectorPadding: 5,
			distance: 30,
			enabled: true,
			formatter: function () { // #2945
				return this.point.name;
			}
			// softConnector: true,
			//y: 0
		},
		ignoreHiddenPoint: true,
		//innerSize: 0,
		legendType: 'point',
		marker: null, // point options are specified in the base options
		size: null,
		showInLegend: false,
		slicedOffset: 10,
		states: {
			hover: {
				brightness: 0.1,
				shadow: false
			}
		},
		stickyTracking: false,
		tooltip: {
			followPointer: true
		}
	});
	
	/**
	 * Extended point object for pies
	 */
	var PiePoint = extendClass(Point, {
		/**
		 * Initiate the pie slice
		 */
		init: function () {
	
			Point.prototype.init.apply(this, arguments);
	
			var point = this,
				toggleSlice;
	
			// Disallow negative values (#1530)
			if (point.y < 0) {
				point.y = null;
			}
	
			//visible: options.visible !== false,
			extend(point, {
				visible: point.visible !== false,
				name: pick(point.name, 'Slice')
			});
	
			// add event listener for select
			toggleSlice = function (e) {
				point.slice(e.type === 'select');
			};
			addEvent(point, 'select', toggleSlice);
			addEvent(point, 'unselect', toggleSlice);
	
			return point;
		},
	
		/**
		 * Toggle the visibility of the pie slice
		 * @param {Boolean} vis Whether to show the slice or not. If undefined, the
		 *    visibility is toggled
		 */
		setVisible: function (vis) {
			var point = this,
				series = point.series,
				chart = series.chart;
	
			// if called without an argument, toggle visibility
			point.visible = point.options.visible = vis = vis === UNDEFINED ? !point.visible : vis;
			series.options.data[inArray(point, series.data)] = point.options; // update userOptions.data
	
			// Show and hide associated elements
			each(['graphic', 'dataLabel', 'connector', 'shadowGroup'], function (key) {
				if (point[key]) {
					point[key][vis ? 'show' : 'hide'](true);
				}
			});
	
			if (point.legendItem) {
				chart.legend.colorizeItem(point, vis);
			}
			
			// Handle ignore hidden slices
			if (!series.isDirty && series.options.ignoreHiddenPoint) {
				series.isDirty = true;
				chart.redraw();
			}
		},
	
		/**
		 * Set or toggle whether the slice is cut out from the pie
		 * @param {Boolean} sliced When undefined, the slice state is toggled
		 * @param {Boolean} redraw Whether to redraw the chart. True by default.
		 */
		slice: function (sliced, redraw, animation) {
			var point = this,
				series = point.series,
				chart = series.chart,
				translation;
	
			setAnimation(animation, chart);
	
			// redraw is true by default
			redraw = pick(redraw, true);
	
			// if called without an argument, toggle
			point.sliced = point.options.sliced = sliced = defined(sliced) ? sliced : !point.sliced;
			series.options.data[inArray(point, series.data)] = point.options; // update userOptions.data
	
			translation = sliced ? point.slicedTranslation : {
				translateX: 0,
				translateY: 0
			};
	
			point.graphic.animate(translation);
			
			if (point.shadowGroup) {
				point.shadowGroup.animate(translation);
			}
	
		},
	
		haloPath: function (size) {
			var shapeArgs = this.shapeArgs,
				chart = this.series.chart;
	
			return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(chart.plotLeft + shapeArgs.x, chart.plotTop + shapeArgs.y, shapeArgs.r + size, shapeArgs.r + size, {
				innerR: this.shapeArgs.r,
				start: shapeArgs.start,
				end: shapeArgs.end
			});
		}
	});
	
	/**
	 * The Pie series class
	 */
	var PieSeries = {
		type: 'pie',
		isCartesian: false,
		pointClass: PiePoint,
		requireSorting: false,
		noSharedTooltip: true,
		trackerGroups: ['group', 'dataLabelsGroup'],
		axisTypes: [],
		pointAttrToOptions: { // mapping between SVG attributes and the corresponding options
			stroke: 'borderColor',
			'stroke-width': 'borderWidth',
			fill: 'color'
		},
		singularTooltips: true,
	
		/**
		 * Pies have one color each point
		 */
		getColor: noop,
	
		/**
		 * Animate the pies in
		 */
		animate: function (init) {
			var series = this,
				points = series.points,
				startAngleRad = series.startAngleRad;
	
			if (!init) {
				each(points, function (point) {
					var graphic = point.graphic,
						args = point.shapeArgs;
	
					if (graphic) {
						// start values
						graphic.attr({
							r: series.center[3] / 2, // animate from inner radius (#779)
							start: startAngleRad,
							end: startAngleRad
						});
	
						// animate
						graphic.animate({
							r: args.r,
							start: args.start,
							end: args.end
						}, series.options.animation);
					}
				});
	
				// delete this function to allow it only once
				series.animate = null;
			}
		},
	
		/**
		 * Extend the basic setData method by running processData and generatePoints immediately,
		 * in order to access the points from the legend.
		 */
		setData: function (data, redraw, animation, updatePoints) {
			Series.prototype.setData.call(this, data, false, animation, updatePoints);
			this.processData();
			this.generatePoints();
			if (pick(redraw, true)) {
				this.chart.redraw(animation);
			} 
		},
	
		/**
		 * Extend the generatePoints method by adding total and percentage properties to each point
		 */
		generatePoints: function () {
			var i,
				total = 0,
				points,
				len,
				point,
				ignoreHiddenPoint = this.options.ignoreHiddenPoint;
	
			Series.prototype.generatePoints.call(this);
	
			// Populate local vars
			points = this.points;
			len = points.length;
			
			// Get the total sum
			for (i = 0; i < len; i++) {
				point = points[i];
				total += (ignoreHiddenPoint && !point.visible) ? 0 : point.y;
			}
			this.total = total;
	
			// Set each point's properties
			for (i = 0; i < len; i++) {
				point = points[i];
				point.percentage = total > 0 ? (point.y / total) * 100 : 0;
				point.total = total;
			}
			
		},
		
		/**
		 * Do translation for pie slices
		 */
		translate: function (positions) {
			this.generatePoints();
			
			var series = this,
				cumulative = 0,
				precision = 1000, // issue #172
				options = series.options,
				slicedOffset = options.slicedOffset,
				connectorOffset = slicedOffset + options.borderWidth,
				start,
				end,
				angle,
				startAngle = options.startAngle || 0,
				startAngleRad = series.startAngleRad = mathPI / 180 * (startAngle - 90),
				endAngleRad = series.endAngleRad = mathPI / 180 * ((pick(options.endAngle, startAngle + 360)) - 90),
				circ = endAngleRad - startAngleRad, //2 * mathPI,
				points = series.points,
				radiusX, // the x component of the radius vector for a given point
				radiusY,
				labelDistance = options.dataLabels.distance,
				ignoreHiddenPoint = options.ignoreHiddenPoint,
				i,
				len = points.length,
				point;
	
			// Get positions - either an integer or a percentage string must be given.
			// If positions are passed as a parameter, we're in a recursive loop for adjusting
			// space for data labels.
			if (!positions) {
				series.center = positions = series.getCenter();
			}
	
			// utility for getting the x value from a given y, used for anticollision logic in data labels
			series.getX = function (y, left) {
	
				angle = math.asin(mathMin((y - positions[1]) / (positions[2] / 2 + labelDistance), 1));
	
				return positions[0] +
					(left ? -1 : 1) *
					(mathCos(angle) * (positions[2] / 2 + labelDistance));
			};
	
			// Calculate the geometry for each point
			for (i = 0; i < len; i++) {
				
				point = points[i];
				
				// set start and end angle
				start = startAngleRad + (cumulative * circ);
				if (!ignoreHiddenPoint || point.visible) {
					cumulative += point.percentage / 100;
				}
				end = startAngleRad + (cumulative * circ);
	
				// set the shape
				point.shapeType = 'arc';
				point.shapeArgs = {
					x: positions[0],
					y: positions[1],
					r: positions[2] / 2,
					innerR: positions[3] / 2,
					start: mathRound(start * precision) / precision,
					end: mathRound(end * precision) / precision
				};
	
				// The angle must stay within -90 and 270 (#2645)
				angle = (end + start) / 2;
				if (angle > 1.5 * mathPI) {
					angle -= 2 * mathPI;
				} else if (angle < -mathPI / 2) {
					angle += 2 * mathPI;
				}
	
				// Center for the sliced out slice
				point.slicedTranslation = {
					translateX: mathRound(mathCos(angle) * slicedOffset),
					translateY: mathRound(mathSin(angle) * slicedOffset)
				};
	
				// set the anchor point for tooltips
				radiusX = mathCos(angle) * positions[2] / 2;
				radiusY = mathSin(angle) * positions[2] / 2;
				point.tooltipPos = [
					positions[0] + radiusX * 0.7,
					positions[1] + radiusY * 0.7
				];
				
				point.half = angle < -mathPI / 2 || angle > mathPI / 2 ? 1 : 0;
				point.angle = angle;
	
				// set the anchor point for data labels
				connectorOffset = mathMin(connectorOffset, labelDistance / 2); // #1678
				point.labelPos = [
					positions[0] + radiusX + mathCos(angle) * labelDistance, // first break of connector
					positions[1] + radiusY + mathSin(angle) * labelDistance, // a/a
					positions[0] + radiusX + mathCos(angle) * connectorOffset, // second break, right outside pie
					positions[1] + radiusY + mathSin(angle) * connectorOffset, // a/a
					positions[0] + radiusX, // landing point for connector
					positions[1] + radiusY, // a/a
					labelDistance < 0 ? // alignment
						'center' :
						point.half ? 'right' : 'left', // alignment
					angle // center angle
				];
	
			}
		},
		
		drawGraph: null,
	
		/**
		 * Draw the data points
		 */
		drawPoints: function () {
			var series = this,
				chart = series.chart,
				renderer = chart.renderer,
				groupTranslation,
				//center,
				graphic,
				//group,
				shadow = series.options.shadow,
				shadowGroup,
				shapeArgs;
	
			if (shadow && !series.shadowGroup) {
				series.shadowGroup = renderer.g('shadow')
					.add(series.group);
			}
	
			// draw the slices
			each(series.points, function (point) {
				graphic = point.graphic;
				shapeArgs = point.shapeArgs;
				shadowGroup = point.shadowGroup;
	
				// put the shadow behind all points
				if (shadow && !shadowGroup) {
					shadowGroup = point.shadowGroup = renderer.g('shadow')
						.add(series.shadowGroup);
				}
	
				// if the point is sliced, use special translation, else use plot area traslation
				groupTranslation = point.sliced ? point.slicedTranslation : {
					translateX: 0,
					translateY: 0
				};
	
				//group.translate(groupTranslation[0], groupTranslation[1]);
				if (shadowGroup) {
					shadowGroup.attr(groupTranslation);
				}
	
				// draw the slice
				if (graphic) {
					graphic.animate(extend(shapeArgs, groupTranslation));
				} else {
					point.graphic = graphic = renderer[point.shapeType](shapeArgs)
						.setRadialReference(series.center)
						.attr(
							point.pointAttr[point.selected ? SELECT_STATE : NORMAL_STATE]
						)
						.attr({ 
							'stroke-linejoin': 'round'
							//zIndex: 1 // #2722 (reversed)
						})
						.attr(groupTranslation)
						.add(series.group)
						.shadow(shadow, shadowGroup);	
				}
	
				// detect point specific visibility (#2430)
				if (point.visible !== undefined) {
					point.setVisible(point.visible);
				}
	
			});
	
		},
	
		/**
		 * Utility for sorting data labels
		 */
		sortByAngle: function (points, sign) {
			points.sort(function (a, b) {
				return a.angle !== undefined && (b.angle - a.angle) * sign;
			});
		},		
	
		/**
		 * Use a simple symbol from LegendSymbolMixin
		 */
		drawLegendSymbol: LegendSymbolMixin.drawRectangle,
	
		/**
		 * Use the getCenter method from drawLegendSymbol
		 */
		getCenter: CenteredSeriesMixin.getCenter,
	
		/**
		 * Pies don't have point marker symbols
		 */
		getSymbol: noop
	
	};
	PieSeries = extendClass(Series, PieSeries);
	seriesTypes.pie = PieSeries;
	
	/**
	 * Draw the data labels
	 */
	Series.prototype.drawDataLabels = function () {
	
		var series = this,
			seriesOptions = series.options,
			cursor = seriesOptions.cursor,
			options = seriesOptions.dataLabels,
			points = series.points,
			pointOptions,
			generalOptions,
			hasRendered = series.hasRendered || 0,
			str,
			dataLabelsGroup;
	
		if (options.enabled || series._hasPointLabels) {
	
			// Process default alignment of data labels for columns
			if (series.dlProcessOptions) {
				series.dlProcessOptions(options);
			}
	
			// Create a separate group for the data labels to avoid rotation
			dataLabelsGroup = series.plotGroup(
				'dataLabelsGroup',
				'data-labels',
				options.defer ? HIDDEN : VISIBLE,
				options.zIndex || 6
			);
	
			if (pick(options.defer, true)) {
				dataLabelsGroup.attr({ opacity: +hasRendered }); // #3300
				if (!hasRendered) {
					addEvent(series, 'afterAnimate', function () {
						if (series.visible) { // #3023, #3024
							dataLabelsGroup.show();
						}
						dataLabelsGroup[seriesOptions.animation ? 'animate' : 'attr']({ opacity: 1 }, { duration: 200 });
					});
				}
			}
	
			// Make the labels for each point
			generalOptions = options;
			each(points, function (point) {
	
				var enabled,
					dataLabel = point.dataLabel,
					labelConfig,
					attr,
					name,
					rotation,
					connector = point.connector,
					isNew = true;
	
				// Determine if each data label is enabled
				pointOptions = point.options && point.options.dataLabels;
				enabled = pick(pointOptions && pointOptions.enabled, generalOptions.enabled); // #2282
	
	
				// If the point is outside the plot area, destroy it. #678, #820
				if (dataLabel && !enabled) {
					point.dataLabel = dataLabel.destroy();
	
				// Individual labels are disabled if the are explicitly disabled
				// in the point options, or if they fall outside the plot area.
				} else if (enabled) {
	
					// Create individual options structure that can be extended without
					// affecting others
					options = merge(generalOptions, pointOptions);
	
					rotation = options.rotation;
	
					// Get the string
					labelConfig = point.getLabelConfig();
					str = options.format ?
						format(options.format, labelConfig) :
						options.formatter.call(labelConfig, options);
	
					// Determine the color
					options.style.color = pick(options.color, options.style.color, series.color, 'black');
	
	
					// update existing label
					if (dataLabel) {
	
						if (defined(str)) {
							dataLabel
								.attr({
									text: str
								});
							isNew = false;
	
						} else { // #1437 - the label is shown conditionally
							point.dataLabel = dataLabel = dataLabel.destroy();
							if (connector) {
								point.connector = connector.destroy();
							}
						}
	
					// create new label
					} else if (defined(str)) {
						attr = {
							//align: align,
							fill: options.backgroundColor,
							stroke: options.borderColor,
							'stroke-width': options.borderWidth,
							r: options.borderRadius || 0,
							rotation: rotation,
							padding: options.padding,
							zIndex: 1
						};
						// Remove unused attributes (#947)
						for (name in attr) {
							if (attr[name] === UNDEFINED) {
								delete attr[name];
							}
						}
	
						dataLabel = point.dataLabel = series.chart.renderer[rotation ? 'text' : 'label']( // labels don't support rotation
							str,
							0,
							-999,
							null,
							null,
							null,
							options.useHTML
						)
						.attr(attr)
						.css(extend(options.style, cursor && { cursor: cursor }))
						.add(dataLabelsGroup)
						.shadow(options.shadow);
	
					}
	
					if (dataLabel) {
						// Now the data label is created and placed at 0,0, so we need to align it
						series.alignDataLabel(point, dataLabel, options, null, isNew);
					}
				}
			});
		}
	};
	
	/**
	 * Align each individual data label
	 */
	Series.prototype.alignDataLabel = function (point, dataLabel, options, alignTo, isNew) {
		var chart = this.chart,
			inverted = chart.inverted,
			plotX = pick(point.plotX, -999),
			plotY = pick(point.plotY, -999),
			bBox = dataLabel.getBBox(),
			// Math.round for rounding errors (#2683), alignTo to allow column labels (#2700)
			visible = this.visible && (point.series.forceDL || chart.isInsidePlot(plotX, mathRound(plotY), inverted) ||
				(alignTo && chart.isInsidePlot(plotX, inverted ? alignTo.x + 1 : alignTo.y + alignTo.height - 1, inverted))),
			alignAttr; // the final position;
	
		if (visible) {
	
			// The alignment box is a singular point
			alignTo = extend({
				x: inverted ? chart.plotWidth - plotY : plotX,
				y: mathRound(inverted ? chart.plotHeight - plotX : plotY),
				width: 0,
				height: 0
			}, alignTo);
	
			// Add the text size for alignment calculation
			extend(options, {
				width: bBox.width,
				height: bBox.height
			});
	
			// Allow a hook for changing alignment in the last moment, then do the alignment
			if (options.rotation) { // Fancy box alignment isn't supported for rotated text
				dataLabel[isNew ? 'attr' : 'animate']({
						x: alignTo.x + options.x + alignTo.width / 2,
						y: alignTo.y + options.y + alignTo.height / 2
					})
					.attr({ // #3003
						align: options.align
					});
			} else {
				dataLabel.align(options, null, alignTo);
				alignAttr = dataLabel.alignAttr;
	
				// Handle justify or crop
				if (pick(options.overflow, 'justify') === 'justify') {
					this.justifyDataLabel(dataLabel, options, alignAttr, bBox, alignTo, isNew);
	
				} else if (pick(options.crop, true)) {
					// Now check that the data label is within the plot area
					visible = chart.isInsidePlot(alignAttr.x, alignAttr.y) && chart.isInsidePlot(alignAttr.x + bBox.width, alignAttr.y + bBox.height);
	
				}
			}
		}
	
		// Show or hide based on the final aligned position
		if (!visible) {
			dataLabel.attr({ y: -999 });
			dataLabel.placed = false; // don't animate back in
		}
	
	};
	
	/**
	 * If data labels fall partly outside the plot area, align them back in, in a way that
	 * doesn't hide the point.
	 */
	Series.prototype.justifyDataLabel = function (dataLabel, options, alignAttr, bBox, alignTo, isNew) {
		var chart = this.chart,
			align = options.align,
			verticalAlign = options.verticalAlign,
			off,
			justified;
	
		// Off left
		off = alignAttr.x;
		if (off < 0) {
			if (align === 'right') {
				options.align = 'left';
			} else {
				options.x = -off;
			}
			justified = true;
		}
	
		// Off right
		off = alignAttr.x + bBox.width;
		if (off > chart.plotWidth) {
			if (align === 'left') {
				options.align = 'right';
			} else {
				options.x = chart.plotWidth - off;
			}
			justified = true;
		}
	
		// Off top
		off = alignAttr.y;
		if (off < 0) {
			if (verticalAlign === 'bottom') {
				options.verticalAlign = 'top';
			} else {
				options.y = -off;
			}
			justified = true;
		}
	
		// Off bottom
		off = alignAttr.y + bBox.height;
		if (off > chart.plotHeight) {
			if (verticalAlign === 'top') {
				options.verticalAlign = 'bottom';
			} else {
				options.y = chart.plotHeight - off;
			}
			justified = true;
		}
	
		if (justified) {
			dataLabel.placed = !isNew;
			dataLabel.align(options, null, alignTo);
		}
	};
	
	/**
	 * Override the base drawDataLabels method by pie specific functionality
	 */
	if (seriesTypes.pie) {
		seriesTypes.pie.prototype.drawDataLabels = function () {
			var series = this,
				data = series.data,
				point,
				chart = series.chart,
				options = series.options.dataLabels,
				connectorPadding = pick(options.connectorPadding, 10),
				connectorWidth = pick(options.connectorWidth, 1),
				plotWidth = chart.plotWidth,
				plotHeight = chart.plotHeight,
				connector,
				connectorPath,
				softConnector = pick(options.softConnector, true),
				distanceOption = options.distance,
				seriesCenter = series.center,
				radius = seriesCenter[2] / 2,
				centerY = seriesCenter[1],
				outside = distanceOption > 0,
				dataLabel,
				dataLabelWidth,
				labelPos,
				labelHeight,
				halves = [// divide the points into right and left halves for anti collision
					[], // right
					[]  // left
				],
				x,
				y,
				visibility,
				rankArr,
				i,
				j,
				overflow = [0, 0, 0, 0], // top, right, bottom, left
				sort = function (a, b) {
					return b.y - a.y;
				};
	
			// get out if not enabled
			if (!series.visible || (!options.enabled && !series._hasPointLabels)) {
				return;
			}
	
			// run parent method
			Series.prototype.drawDataLabels.apply(series);
	
			// arrange points for detection collision
			each(data, function (point) {
				if (point.dataLabel && point.visible) { // #407, #2510
					halves[point.half].push(point);
				}
			});
	
			/* Loop over the points in each half, starting from the top and bottom
			 * of the pie to detect overlapping labels.
			 */
			i = 2;
			while (i--) {
	
				var slots = [],
					slotsLength,
					usedSlots = [],
					points = halves[i],
					pos,
					bottom,
					length = points.length,
					slotIndex;
	
				if (!length) {
					continue;
				}
	
				// Sort by angle
				series.sortByAngle(points, i - 0.5);
	
				// Assume equal label heights on either hemisphere (#2630)
				j = labelHeight = 0;
				while (!labelHeight && points[j]) { // #1569
					labelHeight = points[j] && points[j].dataLabel && (points[j].dataLabel.getBBox().height || 21); // 21 is for #968
					j++;
				}
	
				// Only do anti-collision when we are outside the pie and have connectors (#856)
				if (distanceOption > 0) {
	
					// Build the slots
					bottom = mathMin(centerY + radius + distanceOption, chart.plotHeight);
					for (pos = mathMax(0, centerY - radius - distanceOption); pos <= bottom; pos += labelHeight) {
						slots.push(pos);
					}
					slotsLength = slots.length;
	
	
					/* Visualize the slots
					if (!series.slotElements) {
						series.slotElements = [];
					}
					if (i === 1) {
						series.slotElements.forEach(function (elem) {
							elem.destroy();
						});
						series.slotElements.length = 0;
					}
						
					slots.forEach(function (pos, no) {
						var slotX = series.getX(pos, i) + chart.plotLeft - (i ? 100 : 0),
							slotY = pos + chart.plotTop;
						
						if (!isNaN(slotX)) {
							series.slotElements.push(chart.renderer.rect(slotX, slotY - 7, 100, labelHeight, 1)
								.attr({
									'stroke-width': 1,
									stroke: 'silver',
									fill: 'rgba(0,0,255,0.1)'
								})
								.add());
							series.slotElements.push(chart.renderer.text('Slot '+ no, slotX, slotY + 4)
								.attr({
									fill: 'silver'
								}).add());
						}
					});
					// */
	
					// if there are more values than available slots, remove lowest values
					if (length > slotsLength) {
						// create an array for sorting and ranking the points within each quarter
						rankArr = [].concat(points);
						rankArr.sort(sort);
						j = length;
						while (j--) {
							rankArr[j].rank = j;
						}
						j = length;
						while (j--) {
							if (points[j].rank >= slotsLength) {
								points.splice(j, 1);
							}
						}
						length = points.length;
					}
	
					// The label goes to the nearest open slot, but not closer to the edge than
					// the label's index.
					for (j = 0; j < length; j++) {
	
						point = points[j];
						labelPos = point.labelPos;
	
						var closest = 9999,
							distance,
							slotI;
	
						// find the closest slot index
						for (slotI = 0; slotI < slotsLength; slotI++) {
							distance = mathAbs(slots[slotI] - labelPos[1]);
							if (distance < closest) {
								closest = distance;
								slotIndex = slotI;
							}
						}
	
						// if that slot index is closer to the edges of the slots, move it
						// to the closest appropriate slot
						if (slotIndex < j && slots[j] !== null) { // cluster at the top
							slotIndex = j;
						} else if (slotsLength  < length - j + slotIndex && slots[j] !== null) { // cluster at the bottom
							slotIndex = slotsLength - length + j;
							while (slots[slotIndex] === null) { // make sure it is not taken
								slotIndex++;
							}
						} else {
							// Slot is taken, find next free slot below. In the next run, the next slice will find the
							// slot above these, because it is the closest one
							while (slots[slotIndex] === null) { // make sure it is not taken
								slotIndex++;
							}
						}
	
						usedSlots.push({ i: slotIndex, y: slots[slotIndex] });
						slots[slotIndex] = null; // mark as taken
					}
					// sort them in order to fill in from the top
					usedSlots.sort(sort);
				}
	
				// now the used slots are sorted, fill them up sequentially
				for (j = 0; j < length; j++) {
	
					var slot, naturalY;
	
					point = points[j];
					labelPos = point.labelPos;
					dataLabel = point.dataLabel;
					visibility = point.visible === false ? HIDDEN : VISIBLE;
					naturalY = labelPos[1];
	
					if (distanceOption > 0) {
						slot = usedSlots.pop();
						slotIndex = slot.i;
	
						// if the slot next to currrent slot is free, the y value is allowed
						// to fall back to the natural position
						y = slot.y;
						if ((naturalY > y && slots[slotIndex + 1] !== null) ||
								(naturalY < y &&  slots[slotIndex - 1] !== null)) {
							y = mathMin(mathMax(0, naturalY), chart.plotHeight);
						}
	
					} else {
						y = naturalY;
					}
	
					// get the x - use the natural x position for first and last slot, to prevent the top
					// and botton slice connectors from touching each other on either side
					x = options.justify ?
						seriesCenter[0] + (i ? -1 : 1) * (radius + distanceOption) :
						series.getX(y === centerY - radius - distanceOption || y === centerY + radius + distanceOption ? naturalY : y, i);
	
	
					// Record the placement and visibility
					dataLabel._attr = {
						visibility: visibility,
						align: labelPos[6]
					};
					dataLabel._pos = {
						x: x + options.x +
							({ left: connectorPadding, right: -connectorPadding }[labelPos[6]] || 0),
						y: y + options.y - 10 // 10 is for the baseline (label vs text)
					};
					dataLabel.connX = x;
					dataLabel.connY = y;
	
	
					// Detect overflowing data labels
					if (this.options.size === null) {
						dataLabelWidth = dataLabel.width;
						// Overflow left
						if (x - dataLabelWidth < connectorPadding) {
							overflow[3] = mathMax(mathRound(dataLabelWidth - x + connectorPadding), overflow[3]);
	
						// Overflow right
						} else if (x + dataLabelWidth > plotWidth - connectorPadding) {
							overflow[1] = mathMax(mathRound(x + dataLabelWidth - plotWidth + connectorPadding), overflow[1]);
						}
	
						// Overflow top
						if (y - labelHeight / 2 < 0) {
							overflow[0] = mathMax(mathRound(-y + labelHeight / 2), overflow[0]);
	
						// Overflow left
						} else if (y + labelHeight / 2 > plotHeight) {
							overflow[2] = mathMax(mathRound(y + labelHeight / 2 - plotHeight), overflow[2]);
						}
					}
				} // for each point
			} // for each half
	
			// Do not apply the final placement and draw the connectors until we have verified
			// that labels are not spilling over.
			if (arrayMax(overflow) === 0 || this.verifyDataLabelOverflow(overflow)) {
	
				// Place the labels in the final position
				this.placeDataLabels();
	
				// Draw the connectors
				if (outside && connectorWidth) {
					each(this.points, function (point) {
						connector = point.connector;
						labelPos = point.labelPos;
						dataLabel = point.dataLabel;
	
						if (dataLabel && dataLabel._pos) {
							visibility = dataLabel._attr.visibility;
							x = dataLabel.connX;
							y = dataLabel.connY;
							connectorPath = softConnector ? [
								M,
								x + (labelPos[6] === 'left' ? 5 : -5), y, // end of the string at the label
								'C',
								x, y, // first break, next to the label
								2 * labelPos[2] - labelPos[4], 2 * labelPos[3] - labelPos[5],
								labelPos[2], labelPos[3], // second break
								L,
								labelPos[4], labelPos[5] // base
							] : [
								M,
								x + (labelPos[6] === 'left' ? 5 : -5), y, // end of the string at the label
								L,
								labelPos[2], labelPos[3], // second break
								L,
								labelPos[4], labelPos[5] // base
							];
	
							if (connector) {
								connector.animate({ d: connectorPath });
								connector.attr('visibility', visibility);
	
							} else {
								point.connector = connector = series.chart.renderer.path(connectorPath).attr({
									'stroke-width': connectorWidth,
									stroke: options.connectorColor || point.color || '#606060',
									visibility: visibility
									//zIndex: 0 // #2722 (reversed)
								})
								.add(series.dataLabelsGroup);
							}
						} else if (connector) {
							point.connector = connector.destroy();
						}
					});
				}
			}
		};
		/**
		 * Perform the final placement of the data labels after we have verified that they
		 * fall within the plot area.
		 */
		seriesTypes.pie.prototype.placeDataLabels = function () {
			each(this.points, function (point) {
				var dataLabel = point.dataLabel,
					_pos;
	
				if (dataLabel) {
					_pos = dataLabel._pos;
					if (_pos) {
						dataLabel.attr(dataLabel._attr);
						dataLabel[dataLabel.moved ? 'animate' : 'attr'](_pos);
						dataLabel.moved = true;
					} else if (dataLabel) {
						dataLabel.attr({ y: -999 });
					}
				}
			});
		};
	
		seriesTypes.pie.prototype.alignDataLabel =  noop;
	
		/**
		 * Verify whether the data labels are allowed to draw, or we should run more translation and data
		 * label positioning to keep them inside the plot area. Returns true when data labels are ready
		 * to draw.
		 */
		seriesTypes.pie.prototype.verifyDataLabelOverflow = function (overflow) {
	
			var center = this.center,
				options = this.options,
				centerOption = options.center,
				minSize = options.minSize || 80,
				newSize = minSize,
				ret;
	
			// Handle horizontal size and center
			if (centerOption[0] !== null) { // Fixed center
				newSize = mathMax(center[2] - mathMax(overflow[1], overflow[3]), minSize);
	
			} else { // Auto center
				newSize = mathMax(
					center[2] - overflow[1] - overflow[3], // horizontal overflow
					minSize
				);
				center[0] += (overflow[3] - overflow[1]) / 2; // horizontal center
			}
	
			// Handle vertical size and center
			if (centerOption[1] !== null) { // Fixed center
				newSize = mathMax(mathMin(newSize, center[2] - mathMax(overflow[0], overflow[2])), minSize);
	
			} else { // Auto center
				newSize = mathMax(
					mathMin(
						newSize,
						center[2] - overflow[0] - overflow[2] // vertical overflow
					),
					minSize
				);
				center[1] += (overflow[0] - overflow[2]) / 2; // vertical center
			}
	
			// If the size must be decreased, we need to run translate and drawDataLabels again
			if (newSize < center[2]) {
				center[2] = newSize;
				this.translate(center);
				each(this.points, function (point) {
					if (point.dataLabel) {
						point.dataLabel._pos = null; // reset
					}
				});
	
				if (this.drawDataLabels) {
					this.drawDataLabels();
				}
			// Else, return true to indicate that the pie and its labels is within the plot area
			} else {
				ret = true;
			}
			return ret;
		};
	}
	
	if (seriesTypes.column) {
	
		/**
		 * Override the basic data label alignment by adjusting for the position of the column
		 */
		seriesTypes.column.prototype.alignDataLabel = function (point, dataLabel, options,  alignTo, isNew) {
			var chart = this.chart,
				inverted = chart.inverted,
				dlBox = point.dlBox || point.shapeArgs, // data label box for alignment
				below = point.below || (point.plotY > pick(this.translatedThreshold, chart.plotSizeY)),
				inside = pick(options.inside, !!this.options.stacking); // draw it inside the box?
	
			// Align to the column itself, or the top of it
			if (dlBox) { // Area range uses this method but not alignTo
				alignTo = merge(dlBox);
	
				if (inverted) {
					alignTo = {
						x: chart.plotWidth - alignTo.y - alignTo.height,
						y: chart.plotHeight - alignTo.x - alignTo.width,
						width: alignTo.height,
						height: alignTo.width
					};
				}
	
				// Compute the alignment box
				if (!inside) {
					if (inverted) {
						alignTo.x += below ? 0 : alignTo.width;
						alignTo.width = 0;
					} else {
						alignTo.y += below ? alignTo.height : 0;
						alignTo.height = 0;
					}
				}
			}
	
	
			// When alignment is undefined (typically columns and bars), display the individual
			// point below or above the point depending on the threshold
			options.align = pick(
				options.align,
				!inverted || inside ? 'center' : below ? 'right' : 'left'
			);
			options.verticalAlign = pick(
				options.verticalAlign,
				inverted || inside ? 'middle' : below ? 'top' : 'bottom'
			);
	
			// Call the parent method
			Series.prototype.alignDataLabel.call(this, point, dataLabel, options, alignTo, isNew);
		};
	}
	
	
	
	/**
	 * TrackerMixin for points and graphs
	 */
	
	var TrackerMixin = Highcharts.TrackerMixin = {
	
		drawTrackerPoint: function () {
			var series = this,
				chart = series.chart,
				pointer = chart.pointer,
				cursor = series.options.cursor,
				css = cursor && { cursor: cursor },
				onMouseOver = function (e) {
					var target = e.target,
					point;
	
					if (chart.hoverSeries !== series) {
						series.onMouseOver();
					}
	
					while (target && !point) {
						point = target.point;
						target = target.parentNode;
					}
	
					if (point !== UNDEFINED && point !== chart.hoverPoint) { // undefined on graph in scatterchart
						point.onMouseOver(e);
					}
				};
	
			// Add reference to the point
			each(series.points, function (point) {
				if (point.graphic) {
					point.graphic.element.point = point;
				}
				if (point.dataLabel) {
					point.dataLabel.element.point = point;
				}
			});
	
			// Add the event listeners, we need to do this only once
			if (!series._hasTracking) {
				each(series.trackerGroups, function (key) {
					if (series[key]) { // we don't always have dataLabelsGroup
						series[key]
							.addClass(PREFIX + 'tracker')
							.on('mouseover', onMouseOver)
							.on('mouseout', function (e) { pointer.onTrackerMouseOut(e); })
							.css(css);
						if (hasTouch) {
							series[key].on('touchstart', onMouseOver);
						}
					}
				});
				series._hasTracking = true;
			}
		},
	
		/**
		 * Draw the tracker object that sits above all data labels and markers to
		 * track mouse events on the graph or points. For the line type charts
		 * the tracker uses the same graphPath, but with a greater stroke width
		 * for better control.
		 */
		drawTrackerGraph: function () {
			var series = this,
				options = series.options,
				trackByArea = options.trackByArea,
				trackerPath = [].concat(trackByArea ? series.areaPath : series.graphPath),
				trackerPathLength = trackerPath.length,
				chart = series.chart,
				pointer = chart.pointer,
				renderer = chart.renderer,
				snap = chart.options.tooltip.snap,
				tracker = series.tracker,
				cursor = options.cursor,
				css = cursor && { cursor: cursor },
				singlePoints = series.singlePoints,
				singlePoint,
				i,
				onMouseOver = function () {
					if (chart.hoverSeries !== series) {
						series.onMouseOver();
					}
				},
				/*
				 * Empirical lowest possible opacities for TRACKER_FILL for an element to stay invisible but clickable
				 * IE6: 0.002
				 * IE7: 0.002
				 * IE8: 0.002
				 * IE9: 0.00000000001 (unlimited)
				 * IE10: 0.0001 (exporting only)
				 * FF: 0.00000000001 (unlimited)
				 * Chrome: 0.000001
				 * Safari: 0.000001
				 * Opera: 0.00000000001 (unlimited)
				 */
				TRACKER_FILL = 'rgba(192,192,192,' + (hasSVG ? 0.0001 : 0.002) + ')';
	
			// Extend end points. A better way would be to use round linecaps,
			// but those are not clickable in VML.
			if (trackerPathLength && !trackByArea) {
				i = trackerPathLength + 1;
				while (i--) {
					if (trackerPath[i] === M) { // extend left side
						trackerPath.splice(i + 1, 0, trackerPath[i + 1] - snap, trackerPath[i + 2], L);
					}
					if ((i && trackerPath[i] === M) || i === trackerPathLength) { // extend right side
						trackerPath.splice(i, 0, L, trackerPath[i - 2] + snap, trackerPath[i - 1]);
					}
				}
			}
	
			// handle single points
			for (i = 0; i < singlePoints.length; i++) {
				singlePoint = singlePoints[i];
				trackerPath.push(M, singlePoint.plotX - snap, singlePoint.plotY,
				L, singlePoint.plotX + snap, singlePoint.plotY);
			}
	
			// draw the tracker
			if (tracker) {
				tracker.attr({ d: trackerPath });
			} else { // create
	
				series.tracker = renderer.path(trackerPath)
				.attr({
					'stroke-linejoin': 'round', // #1225
					visibility: series.visible ? VISIBLE : HIDDEN,
					stroke: TRACKER_FILL,
					fill: trackByArea ? TRACKER_FILL : NONE,
					'stroke-width' : options.lineWidth + (trackByArea ? 0 : 2 * snap),
					zIndex: 2
				})
				.add(series.group);
	
				// The tracker is added to the series group, which is clipped, but is covered
				// by the marker group. So the marker group also needs to capture events.
				each([series.tracker, series.markerGroup], function (tracker) {
					tracker.addClass(PREFIX + 'tracker')
						.on('mouseover', onMouseOver)
						.on('mouseout', function (e) { pointer.onTrackerMouseOut(e); })
						.css(css);
	
					if (hasTouch) {
						tracker.on('touchstart', onMouseOver);
					}
				});
			}
		}
	};
	/* End TrackerMixin */
	
	
	/**
	 * Add tracking event listener to the series group, so the point graphics
	 * themselves act as trackers
	 */ 
	
	if (seriesTypes.column) {
		ColumnSeries.prototype.drawTracker = TrackerMixin.drawTrackerPoint;	
	}
	
	if (seriesTypes.pie) {
		seriesTypes.pie.prototype.drawTracker = TrackerMixin.drawTrackerPoint;
	}
	
	if (seriesTypes.scatter) {
		ScatterSeries.prototype.drawTracker = TrackerMixin.drawTrackerPoint;
	}
	
	/* 
	 * Extend Legend for item events 
	 */ 
	extend(Legend.prototype, {
	
		setItemEvents: function (item, legendItem, useHTML, itemStyle, itemHiddenStyle) {
		var legend = this;
		// Set the events on the item group, or in case of useHTML, the item itself (#1249)
		(useHTML ? legendItem : item.legendGroup).on('mouseover', function () {
				item.setState(HOVER_STATE);
				legendItem.css(legend.options.itemHoverStyle);
			})
			.on('mouseout', function () {
				legendItem.css(item.visible ? itemStyle : itemHiddenStyle);
				item.setState();
			})
			.on('click', function (event) {
				var strLegendItemClick = 'legendItemClick',
					fnLegendItemClick = function () {
						item.setVisible();
					};
					
				// Pass over the click/touch event. #4.
				event = {
					browserEvent: event
				};
	
				// click the name or symbol
				if (item.firePointEvent) { // point
					item.firePointEvent(strLegendItemClick, event, fnLegendItemClick);
				} else {
					fireEvent(item, strLegendItemClick, event, fnLegendItemClick);
				}
			});
		},
	
		createCheckboxForItem: function (item) {
			var legend = this;
	
			item.checkbox = createElement('input', {
				type: 'checkbox',
				checked: item.selected,
				defaultChecked: item.selected // required by IE7
			}, legend.options.itemCheckboxStyle, legend.chart.container);
	
			addEvent(item.checkbox, 'click', function (event) {
				var target = event.target;
				fireEvent(item, 'checkboxClick', {
						checked: target.checked
					},
					function () {
						item.select();
					}
				);
			});
		}	
	});
	
	/* 
	 * Add pointer cursor to legend itemstyle in defaultOptions
	 */
	defaultOptions.legend.itemStyle.cursor = 'pointer';
	
	
	/* 
	 * Extend the Chart object with interaction
	 */
	
	extend(Chart.prototype, {
		/**
		 * Display the zoom button
		 */
		showResetZoom: function () {
			var chart = this,
				lang = defaultOptions.lang,
				btnOptions = chart.options.chart.resetZoomButton,
				theme = btnOptions.theme,
				states = theme.states,
				alignTo = btnOptions.relativeTo === 'chart' ? null : 'plotBox';
				
			this.resetZoomButton = chart.renderer.button(lang.resetZoom, null, null, function () { chart.zoomOut(); }, theme, states && states.hover)
				.attr({
					align: btnOptions.position.align,
					title: lang.resetZoomTitle
				})
				.add()
				.align(btnOptions.position, false, alignTo);
				
		},
	
		/**
		 * Zoom out to 1:1
		 */
		zoomOut: function () {
			var chart = this;
			fireEvent(chart, 'selection', { resetSelection: true }, function () { 
				chart.zoom();
			});
		},
	
		/**
		 * Zoom into a given portion of the chart given by axis coordinates
		 * @param {Object} event
		 */
		zoom: function (event) {
			var chart = this,
				hasZoomed,
				pointer = chart.pointer,
				displayButton = false,
				resetZoomButton;
	
			// If zoom is called with no arguments, reset the axes
			if (!event || event.resetSelection) {
				each(chart.axes, function (axis) {
					hasZoomed = axis.zoom();
				});
			} else { // else, zoom in on all axes
				each(event.xAxis.concat(event.yAxis), function (axisData) {
					var axis = axisData.axis,
						isXAxis = axis.isXAxis;
	
					// don't zoom more than minRange
					if (pointer[isXAxis ? 'zoomX' : 'zoomY'] || pointer[isXAxis ? 'pinchX' : 'pinchY']) {
						hasZoomed = axis.zoom(axisData.min, axisData.max);
						if (axis.displayBtn) {
							displayButton = true;
						}
					}
				});
			}
			
			// Show or hide the Reset zoom button
			resetZoomButton = chart.resetZoomButton;
			if (displayButton && !resetZoomButton) {
				chart.showResetZoom();
			} else if (!displayButton && isObject(resetZoomButton)) {
				chart.resetZoomButton = resetZoomButton.destroy();
			}
			
	
			// Redraw
			if (hasZoomed) {
				chart.redraw(
					pick(chart.options.chart.animation, event && event.animation, chart.pointCount < 100) // animation
				);
			}
		},
	
		/**
		 * Pan the chart by dragging the mouse across the pane. This function is called
		 * on mouse move, and the distance to pan is computed from chartX compared to
		 * the first chartX position in the dragging operation.
		 */
		pan: function (e, panning) {
	
			var chart = this,
				hoverPoints = chart.hoverPoints,
				doRedraw;
	
			// remove active points for shared tooltip
			if (hoverPoints) {
				each(hoverPoints, function (point) {
					point.setState();
				});
			}
	
			each(panning === 'xy' ? [1, 0] : [1], function (isX) { // xy is used in maps
				var mousePos = e[isX ? 'chartX' : 'chartY'],
					axis = chart[isX ? 'xAxis' : 'yAxis'][0],
					startPos = chart[isX ? 'mouseDownX' : 'mouseDownY'],
					halfPointRange = (axis.pointRange || 0) / 2,
					extremes = axis.getExtremes(),
					newMin = axis.toValue(startPos - mousePos, true) + halfPointRange,
					newMax = axis.toValue(startPos + chart[isX ? 'plotWidth' : 'plotHeight'] - mousePos, true) - halfPointRange;
	
				if (axis.series.length && newMin > mathMin(extremes.dataMin, extremes.min) && newMax < mathMax(extremes.dataMax, extremes.max)) {
					axis.setExtremes(newMin, newMax, false, false, { trigger: 'pan' });
					doRedraw = true;
				}
	
				chart[isX ? 'mouseDownX' : 'mouseDownY'] = mousePos; // set new reference for next run
			});
	
			if (doRedraw) {
				chart.redraw(false);
			}
			css(chart.container, { cursor: 'move' });
		}
	});
	
	/*
	 * Extend the Point object with interaction
	 */
	extend(Point.prototype, {
		/**
		 * Toggle the selection status of a point
		 * @param {Boolean} selected Whether to select or unselect the point.
		 * @param {Boolean} accumulate Whether to add to the previous selection. By default,
		 *		 this happens if the control key (Cmd on Mac) was pressed during clicking.
		 */
		select: function (selected, accumulate) {
			var point = this,
				series = point.series,
				chart = series.chart;
	
			selected = pick(selected, !point.selected);
	
			// fire the event with the defalut handler
			point.firePointEvent(selected ? 'select' : 'unselect', { accumulate: accumulate }, function () {
				point.selected = point.options.selected = selected;
				series.options.data[inArray(point, series.data)] = point.options;
	
				point.setState(selected && SELECT_STATE);
	
				// unselect all other points unless Ctrl or Cmd + click
				if (!accumulate) {
					each(chart.getSelectedPoints(), function (loopPoint) {
						if (loopPoint.selected && loopPoint !== point) {
							loopPoint.selected = loopPoint.options.selected = false;
							series.options.data[inArray(loopPoint, series.data)] = loopPoint.options;
							loopPoint.setState(NORMAL_STATE);
								loopPoint.firePointEvent('unselect');
						}
					});
				}
			});
		},
	
		/**
		 * Runs on mouse over the point
		 */
		onMouseOver: function (e) {
			var point = this,
				series = point.series,
				chart = series.chart,
				tooltip = chart.tooltip,
				hoverPoint = chart.hoverPoint;
	
			// set normal state to previous series
			if (hoverPoint && hoverPoint !== point) {
				hoverPoint.onMouseOut();
			}
	
			// trigger the event
			point.firePointEvent('mouseOver');
	
			// update the tooltip
			if (tooltip && (!tooltip.shared || series.noSharedTooltip)) {
				tooltip.refresh(point, e);
			}
	
			// hover this
			point.setState(HOVER_STATE);
			chart.hoverPoint = point;
		},
	
		/**
		 * Runs on mouse out from the point
		 */
		onMouseOut: function () {
			var chart = this.series.chart,
				hoverPoints = chart.hoverPoints;
	
			this.firePointEvent('mouseOut');
	
			if (!hoverPoints || inArray(this, hoverPoints) === -1) { // #887, #2240
				this.setState();
				chart.hoverPoint = null;
			}
		},
	
		/**
		 * Import events from the series' and point's options. Only do it on
		 * demand, to save processing time on hovering.
		 */
		importEvents: function () {
			if (!this.hasImportedEvents) {
				var point = this,
					options = merge(point.series.options.point, point.options),
					events = options.events,
					eventType;
	
				point.events = events;
	
				for (eventType in events) {
					addEvent(point, eventType, events[eventType]);
				}
				this.hasImportedEvents = true;
	
			}
		},
	
		/**
		 * Set the point's state
		 * @param {String} state
		 */
		setState: function (state, move) {
			var point = this,
				plotX = point.plotX,
				plotY = point.plotY,
				series = point.series,
				stateOptions = series.options.states,
				markerOptions = defaultPlotOptions[series.type].marker && series.options.marker,
				normalDisabled = markerOptions && !markerOptions.enabled,
				markerStateOptions = markerOptions && markerOptions.states[state],
				stateDisabled = markerStateOptions && markerStateOptions.enabled === false,
				stateMarkerGraphic = series.stateMarkerGraphic,
				pointMarker = point.marker || {},
				chart = series.chart,
				radius,
				halo = series.halo,
				haloOptions,
				newSymbol,
				pointAttr;
	
			state = state || NORMAL_STATE; // empty string
			pointAttr = point.pointAttr[state] || series.pointAttr[state];
	
			if (
					// already has this state
					(state === point.state && !move) ||
					// selected points don't respond to hover
					(point.selected && state !== SELECT_STATE) ||
					// series' state options is disabled
					(stateOptions[state] && stateOptions[state].enabled === false) ||
					// general point marker's state options is disabled
					(state && (stateDisabled || (normalDisabled && markerStateOptions.enabled === false))) ||
					// individual point marker's state options is disabled
					(state && pointMarker.states && pointMarker.states[state] && pointMarker.states[state].enabled === false) // #1610
	
				) {
				return;
			}
	
			// apply hover styles to the existing point
			if (point.graphic) {
				radius = markerOptions && point.graphic.symbolName && pointAttr.r;
				point.graphic.attr(merge(
					pointAttr,
					radius ? { // new symbol attributes (#507, #612)
						x: plotX - radius,
						y: plotY - radius,
						width: 2 * radius,
						height: 2 * radius
					} : {}
				));
	
				// Zooming in from a range with no markers to a range with markers
				if (stateMarkerGraphic) {
					stateMarkerGraphic.hide();
				}
			} else {
				// if a graphic is not applied to each point in the normal state, create a shared
				// graphic for the hover state
				if (state && markerStateOptions) {
					radius = markerStateOptions.radius;
					newSymbol = pointMarker.symbol || series.symbol;
	
					// If the point has another symbol than the previous one, throw away the
					// state marker graphic and force a new one (#1459)
					if (stateMarkerGraphic && stateMarkerGraphic.currentSymbol !== newSymbol) {
						stateMarkerGraphic = stateMarkerGraphic.destroy();
					}
	
					// Add a new state marker graphic
					if (!stateMarkerGraphic) {
						if (newSymbol) {
							series.stateMarkerGraphic = stateMarkerGraphic = chart.renderer.symbol(
								newSymbol,
								plotX - radius,
								plotY - radius,
								2 * radius,
								2 * radius
							)
							.attr(pointAttr)
							.add(series.markerGroup);
							stateMarkerGraphic.currentSymbol = newSymbol;
						}
	
					// Move the existing graphic
					} else {
						stateMarkerGraphic[move ? 'animate' : 'attr']({ // #1054
							x: plotX - radius,
							y: plotY - radius
						});
					}
				}
	
				if (stateMarkerGraphic) {
					stateMarkerGraphic[state && chart.isInsidePlot(plotX, plotY, chart.inverted) ? 'show' : 'hide'](); // #2450
				}
			}
	
			// Show me your halo
			haloOptions = stateOptions[state] && stateOptions[state].halo;
			if (haloOptions && haloOptions.size) {
				if (!halo) {
					series.halo = halo = chart.renderer.path()
						.add(series.seriesGroup);
				}
				halo.attr(extend({
					fill: Color(point.color || series.color).setOpacity(haloOptions.opacity).get()
				}, haloOptions.attributes))[move ? 'animate' : 'attr']({
					d: point.haloPath(haloOptions.size)
				});
			} else if (halo) {
				halo.attr({ d: [] });
			}
	
			point.state = state;
		},
	
		haloPath: function (size) {
			var series = this.series,
				chart = series.chart,
				plotBox = series.getPlotBox(),
				inverted = chart.inverted;
	
			return chart.renderer.symbols.circle(
				plotBox.translateX + (inverted ? series.yAxis.len - this.plotY : this.plotX) - size, 
				plotBox.translateY + (inverted ? series.xAxis.len - this.plotX : this.plotY) - size, 
				size * 2, 
				size * 2
			);
		}
	});
	
	/*
	 * Extend the Series object with interaction
	 */
	
	extend(Series.prototype, {
		/**
		 * Series mouse over handler
		 */
		onMouseOver: function () {
			var series = this,
				chart = series.chart,
				hoverSeries = chart.hoverSeries;
	
			// set normal state to previous series
			if (hoverSeries && hoverSeries !== series) {
				hoverSeries.onMouseOut();
			}
	
			// trigger the event, but to save processing time,
			// only if defined
			if (series.options.events.mouseOver) {
				fireEvent(series, 'mouseOver');
			}
	
			// hover this
			series.setState(HOVER_STATE);
			chart.hoverSeries = series;
		},
	
		/**
		 * Series mouse out handler
		 */
		onMouseOut: function () {
			// trigger the event only if listeners exist
			var series = this,
				options = series.options,
				chart = series.chart,
				tooltip = chart.tooltip,
				hoverPoint = chart.hoverPoint;
	
			// trigger mouse out on the point, which must be in this series
			if (hoverPoint) {
				hoverPoint.onMouseOut();
			}
	
			// fire the mouse out event
			if (series && options.events.mouseOut) {
				fireEvent(series, 'mouseOut');
			}
	
	
			// hide the tooltip
			if (tooltip && !options.stickyTracking && (!tooltip.shared || series.noSharedTooltip)) {
				tooltip.hide();
			}
	
			// set normal state
			series.setState();
			chart.hoverSeries = null;
		},
	
		/**
		 * Set the state of the graph
		 */
		setState: function (state) {
			var series = this,
				options = series.options,
				graph = series.graph,
				graphNeg = series.graphNeg,
				stateOptions = options.states,
				lineWidth = options.lineWidth,
				attribs;
	
			state = state || NORMAL_STATE;
	
			if (series.state !== state) {
				series.state = state;
	
				if (stateOptions[state] && stateOptions[state].enabled === false) {
					return;
				}
	
				if (state) {
					lineWidth = stateOptions[state].lineWidth || lineWidth + (stateOptions[state].lineWidthPlus || 0);
				}
	
				if (graph && !graph.dashstyle) { // hover is turned off for dashed lines in VML
					attribs = {
						'stroke-width': lineWidth
					};
					// use attr because animate will cause any other animation on the graph to stop
					graph.attr(attribs);
					if (graphNeg) {
						graphNeg.attr(attribs);
					}
				}
			}
		},
	
		/**
		 * Set the visibility of the graph
		 *
		 * @param vis {Boolean} True to show the series, false to hide. If UNDEFINED,
		 *				the visibility is toggled.
		 */
		setVisible: function (vis, redraw) {
			var series = this,
				chart = series.chart,
				legendItem = series.legendItem,
				showOrHide,
				ignoreHiddenSeries = chart.options.chart.ignoreHiddenSeries,
				oldVisibility = series.visible;
	
			// if called without an argument, toggle visibility
			series.visible = vis = series.userOptions.visible = vis === UNDEFINED ? !oldVisibility : vis;
			showOrHide = vis ? 'show' : 'hide';
	
			// show or hide elements
			each(['group', 'dataLabelsGroup', 'markerGroup', 'tracker'], function (key) {
				if (series[key]) {
					series[key][showOrHide]();
				}
			});
	
	
			// hide tooltip (#1361)
			if (chart.hoverSeries === series) {
				series.onMouseOut();
			}
	
	
			if (legendItem) {
				chart.legend.colorizeItem(series, vis);
			}
	
	
			// rescale or adapt to resized chart
			series.isDirty = true;
			// in a stack, all other series are affected
			if (series.options.stacking) {
				each(chart.series, function (otherSeries) {
					if (otherSeries.options.stacking && otherSeries.visible) {
						otherSeries.isDirty = true;
					}
				});
			}
	
			// show or hide linked series
			each(series.linkedSeries, function (otherSeries) {
				otherSeries.setVisible(vis, false);
			});
	
			if (ignoreHiddenSeries) {
				chart.isDirtyBox = true;
			}
			if (redraw !== false) {
				chart.redraw();
			}
	
			fireEvent(series, showOrHide);
		},
	
		/**
		 * Memorize tooltip texts and positions
		 */
		setTooltipPoints: function (renew) {
			var series = this,
				points = [],
				pointsLength,
				low,
				high,
				xAxis = series.xAxis,
				xExtremes = xAxis && xAxis.getExtremes(),
				axisLength = xAxis ? (xAxis.tooltipLen || xAxis.len) : series.chart.plotSizeX, // tooltipLen and tooltipPosName used in polar
				point,
				pointX,
				nextPoint,
				i,
				tooltipPoints = []; // a lookup array for each pixel in the x dimension
	
			// don't waste resources if tracker is disabled
			if (series.options.enableMouseTracking === false || series.singularTooltips) {
				return;
			}
	
			// renew
			if (renew) {
				series.tooltipPoints = null;
			}
	
			// concat segments to overcome null values
			each(series.segments || series.points, function (segment) {
				points = points.concat(segment);
			});
	
			// Reverse the points in case the X axis is reversed
			if (xAxis && xAxis.reversed) {
				points = points.reverse();
			}
	
			// Polar needs additional shaping
			if (series.orderTooltipPoints) {
				series.orderTooltipPoints(points);
			}
	
			// Assign each pixel position to the nearest point
			pointsLength = points.length;
			for (i = 0; i < pointsLength; i++) {
				point = points[i];
				pointX = point.x;
				if (pointX >= xExtremes.min && pointX <= xExtremes.max) { // #1149
					nextPoint = points[i + 1];
	
					// Set this range's low to the last range's high plus one
					low = high === UNDEFINED ? 0 : high + 1;
					// Now find the new high
					high = points[i + 1] ?
						mathMin(mathMax(0, mathFloor( // #2070
							(point.clientX + (nextPoint ? (nextPoint.wrappedClientX || nextPoint.clientX) : axisLength)) / 2
						)), axisLength) :
						axisLength;
	
					while (low >= 0 && low <= high) {
						tooltipPoints[low++] = point;
					}
				}
			}
			series.tooltipPoints = tooltipPoints;
		},
	
		/**
		 * Show the graph
		 */
		show: function () {
			this.setVisible(true);
		},
	
		/**
		 * Hide the graph
		 */
		hide: function () {
			this.setVisible(false);
		},
	
	
		/**
		 * Set the selected state of the graph
		 *
		 * @param selected {Boolean} True to select the series, false to unselect. If
		 *				UNDEFINED, the selection state is toggled.
		 */
		select: function (selected) {
			var series = this;
			// if called without an argument, toggle
			series.selected = selected = (selected === UNDEFINED) ? !series.selected : selected;
	
			if (series.checkbox) {
				series.checkbox.checked = selected;
			}
	
			fireEvent(series, selected ? 'select' : 'unselect');
		},
	
		drawTracker: TrackerMixin.drawTrackerGraph
	});
	// global variables
	extend(Highcharts, {
		
		// Constructors
		Axis: Axis,
		Chart: Chart,
		Color: Color,
		Point: Point,
		Tick: Tick,	
		Renderer: Renderer,
		Series: Series,
		SVGElement: SVGElement,
		SVGRenderer: SVGRenderer,
		
		// Various
		arrayMin: arrayMin,
		arrayMax: arrayMax,
		charts: charts,
		dateFormat: dateFormat,
		format: format,
		pathAnim: pathAnim,
		getOptions: getOptions,
		hasBidiBug: hasBidiBug,
		isTouchDevice: isTouchDevice,
		numberFormat: numberFormat,
		seriesTypes: seriesTypes,
		setOptions: setOptions,
		addEvent: addEvent,
		removeEvent: removeEvent,
		createElement: createElement,
		discardElement: discardElement,
		css: css,
		each: each,
		extend: extend,
		map: map,
		merge: merge,
		pick: pick,
		splat: splat,
		extendClass: extendClass,
		pInt: pInt,
		wrap: wrap,
		svg: hasSVG,
		canvas: useCanVG,
		vml: !hasSVG && !useCanVG,
		product: PRODUCT,
		version: VERSION
	});
	
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	// ==ClosureCompiler==
	// @compilation_level SIMPLE_OPTIMIZATIONS
	
	/**
	 * @license Highcharts JS v4.0.4 (2014-09-02)
	 *
	 * (c) 2009-2014 Torstein Honsi
	 *
	 * License: www.highcharts.com/license
	 */
	
	// JSLint options:
	/*global Highcharts, HighchartsAdapter, document, window, navigator, setInterval, clearInterval, clearTimeout, setTimeout, location, jQuery, $, console */
	
	(function (Highcharts, UNDEFINED) {
	var arrayMin = Highcharts.arrayMin,
		arrayMax = Highcharts.arrayMax,
		each = Highcharts.each,
		extend = Highcharts.extend,
		merge = Highcharts.merge,
		map = Highcharts.map,
		pick = Highcharts.pick,
		pInt = Highcharts.pInt,
		defaultPlotOptions = Highcharts.getOptions().plotOptions,
		seriesTypes = Highcharts.seriesTypes,
		extendClass = Highcharts.extendClass,
		splat = Highcharts.splat,
		wrap = Highcharts.wrap,
		Axis = Highcharts.Axis,
		Tick = Highcharts.Tick,
		Point = Highcharts.Point,
		Pointer = Highcharts.Pointer,
		CenteredSeriesMixin = Highcharts.CenteredSeriesMixin,
		TrackerMixin = Highcharts.TrackerMixin,
		Series = Highcharts.Series,
		math = Math,
		mathRound = math.round,
		mathFloor = math.floor,
		mathMax = math.max,
		Color = Highcharts.Color,
		noop = function () {};/**
	 * The Pane object allows options that are common to a set of X and Y axes.
	 * 
	 * In the future, this can be extended to basic Highcharts and Highstock.
	 */
	function Pane(options, chart, firstAxis) {
		this.init.call(this, options, chart, firstAxis);
	}
	
	// Extend the Pane prototype
	extend(Pane.prototype, {
		
		/**
		 * Initiate the Pane object
		 */
		init: function (options, chart, firstAxis) {
			var pane = this,
				backgroundOption,
				defaultOptions = pane.defaultOptions;
			
			pane.chart = chart;
			
			// Set options
			if (chart.angular) { // gauges
				defaultOptions.background = {}; // gets extended by this.defaultBackgroundOptions
			}
			pane.options = options = merge(defaultOptions, options);
			
			backgroundOption = options.background;
			
			// To avoid having weighty logic to place, update and remove the backgrounds,
			// push them to the first axis' plot bands and borrow the existing logic there.
			if (backgroundOption) {
				each([].concat(splat(backgroundOption)).reverse(), function (config) {
					var backgroundColor = config.backgroundColor; // if defined, replace the old one (specific for gradients)
					config = merge(pane.defaultBackgroundOptions, config);
					if (backgroundColor) {
						config.backgroundColor = backgroundColor;
					}
					config.color = config.backgroundColor; // due to naming in plotBands
					firstAxis.options.plotBands.unshift(config);
				});
			}
		},
		
		/**
		 * The default options object
		 */
		defaultOptions: {
			// background: {conditional},
			center: ['50%', '50%'],
			size: '85%',
			startAngle: 0
			//endAngle: startAngle + 360
		},	
		
		/**
		 * The default background options
		 */
		defaultBackgroundOptions: {
			shape: 'circle',
			borderWidth: 1,
			borderColor: 'silver',
			backgroundColor: {
				linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
				stops: [
					[0, '#FFF'],
					[1, '#DDD']
				]
			},
			from: -Number.MAX_VALUE, // corrected to axis min
			innerRadius: 0,
			to: Number.MAX_VALUE, // corrected to axis max
			outerRadius: '105%'
		}
		
	});
	var axisProto = Axis.prototype,
		tickProto = Tick.prototype;
		
	/**
	 * Augmented methods for the x axis in order to hide it completely, used for the X axis in gauges
	 */
	var hiddenAxisMixin = {
		getOffset: noop,
		redraw: function () {
			this.isDirty = false; // prevent setting Y axis dirty
		},
		render: function () {
			this.isDirty = false; // prevent setting Y axis dirty
		},
		setScale: noop,
		setCategories: noop,
		setTitle: noop
	};
	
	/**
	 * Augmented methods for the value axis
	 */
	/*jslint unparam: true*/
	var radialAxisMixin = {
		isRadial: true,
		
		/**
		 * The default options extend defaultYAxisOptions
		 */
		defaultRadialGaugeOptions: {
			labels: {
				align: 'center',
				x: 0,
				y: null // auto
			},
			minorGridLineWidth: 0,
			minorTickInterval: 'auto',
			minorTickLength: 10,
			minorTickPosition: 'inside',
			minorTickWidth: 1,
			tickLength: 10,
			tickPosition: 'inside',
			tickWidth: 2,
			title: {
				rotation: 0
			},
			zIndex: 2 // behind dials, points in the series group
		},
		
		// Circular axis around the perimeter of a polar chart
		defaultRadialXOptions: {
			gridLineWidth: 1, // spokes
			labels: {
				align: null, // auto
				distance: 15,
				x: 0,
				y: null // auto
			},
			maxPadding: 0,
			minPadding: 0,
			showLastLabel: false, 
			tickLength: 0
		},
		
		// Radial axis, like a spoke in a polar chart
		defaultRadialYOptions: {
			gridLineInterpolation: 'circle',
			labels: {
				align: 'right',
				x: -3,
				y: -2
			},
			showLastLabel: false,
			title: {
				x: 4,
				text: null,
				rotation: 90
			}
		},
		
		/**
		 * Merge and set options
		 */
		setOptions: function (userOptions) {
			
			var options = this.options = merge(
				this.defaultOptions,
				this.defaultRadialOptions,
				userOptions
			);
	
			// Make sure the plotBands array is instanciated for each Axis (#2649)
			if (!options.plotBands) {
				options.plotBands = [];
			}
			
		},
		
		/**
		 * Wrap the getOffset method to return zero offset for title or labels in a radial 
		 * axis
		 */
		getOffset: function () {
			// Call the Axis prototype method (the method we're in now is on the instance)
			axisProto.getOffset.call(this);
			
			// Title or label offsets are not counted
			this.chart.axisOffset[this.side] = 0;
			
			// Set the center array
			this.center = this.pane.center = CenteredSeriesMixin.getCenter.call(this.pane);
		},
	
	
		/**
		 * Get the path for the axis line. This method is also referenced in the getPlotLinePath
		 * method.
		 */
		getLinePath: function (lineWidth, radius) {
			var center = this.center;
			radius = pick(radius, center[2] / 2 - this.offset);
			
			return this.chart.renderer.symbols.arc(
				this.left + center[0],
				this.top + center[1],
				radius,
				radius, 
				{
					start: this.startAngleRad,
					end: this.endAngleRad,
					open: true,
					innerR: 0
				}
			);
		},
	
		/**
		 * Override setAxisTranslation by setting the translation to the difference
		 * in rotation. This allows the translate method to return angle for 
		 * any given value.
		 */
		setAxisTranslation: function () {
			
			// Call uber method		
			axisProto.setAxisTranslation.call(this);
				
			// Set transA and minPixelPadding
			if (this.center) { // it's not defined the first time
				if (this.isCircular) {
					
					this.transA = (this.endAngleRad - this.startAngleRad) / 
						((this.max - this.min) || 1);
						
					
				} else { 
					this.transA = (this.center[2] / 2) / ((this.max - this.min) || 1);
				}
				
				if (this.isXAxis) {
					this.minPixelPadding = this.transA * this.minPointOffset;
				} else {
					// This is a workaround for regression #2593, but categories still don't position correctly.
					// TODO: Implement true handling of Y axis categories on gauges.
					this.minPixelPadding = 0; 
				}
			}
		},
		
		/**
		 * In case of auto connect, add one closestPointRange to the max value right before
		 * tickPositions are computed, so that ticks will extend passed the real max.
		 */
		beforeSetTickPositions: function () {
			if (this.autoConnect) {
				this.max += (this.categories && 1) || this.pointRange || this.closestPointRange || 0; // #1197, #2260
			}
		},
		
		/**
		 * Override the setAxisSize method to use the arc's circumference as length. This
		 * allows tickPixelInterval to apply to pixel lengths along the perimeter
		 */
		setAxisSize: function () {
			
			axisProto.setAxisSize.call(this);
	
			if (this.isRadial) {
	
				// Set the center array
				this.center = this.pane.center = Highcharts.CenteredSeriesMixin.getCenter.call(this.pane);
	
				// The sector is used in Axis.translate to compute the translation of reversed axis points (#2570)
				if (this.isCircular) {
					this.sector = this.endAngleRad - this.startAngleRad;	
				}
				
				// Axis len is used to lay out the ticks
				this.len = this.width = this.height = this.center[2] * pick(this.sector, 1) / 2;
	
	
			}
		},
		
		/**
		 * Returns the x, y coordinate of a point given by a value and a pixel distance
		 * from center
		 */
		getPosition: function (value, length) {
			return this.postTranslate(
				this.isCircular ? this.translate(value) : 0, // #2848
				pick(this.isCircular ? length : this.translate(value), this.center[2] / 2) - this.offset
			);		
		},
		
		/**
		 * Translate from intermediate plotX (angle), plotY (axis.len - radius) to final chart coordinates. 
		 */
		postTranslate: function (angle, radius) {
			
			var chart = this.chart,
				center = this.center;
				
			angle = this.startAngleRad + angle;
	
			return {
				x: chart.plotLeft + center[0] + Math.cos(angle) * radius,
				y: chart.plotTop + center[1] + Math.sin(angle) * radius
			}; 
			
		},
		
		/**
		 * Find the path for plot bands along the radial axis
		 */
		getPlotBandPath: function (from, to, options) {
			var center = this.center,
				startAngleRad = this.startAngleRad,
				fullRadius = center[2] / 2,
				radii = [
					pick(options.outerRadius, '100%'),
					options.innerRadius,
					pick(options.thickness, 10)
				],
				percentRegex = /%$/,
				start,
				end,
				open,
				isCircular = this.isCircular, // X axis in a polar chart
				ret;
				
			// Polygonal plot bands
			if (this.options.gridLineInterpolation === 'polygon') {
				ret = this.getPlotLinePath(from).concat(this.getPlotLinePath(to, true));
			
			// Circular grid bands
			} else {
				
				// Plot bands on Y axis (radial axis) - inner and outer radius depend on to and from
				if (!isCircular) {
					radii[0] = this.translate(from);
					radii[1] = this.translate(to);
				}
				
				// Convert percentages to pixel values
				radii = map(radii, function (radius) {
					if (percentRegex.test(radius)) {
						radius = (pInt(radius, 10) * fullRadius) / 100;
					}
					return radius;
				});
				
				// Handle full circle
				if (options.shape === 'circle' || !isCircular) {
					start = -Math.PI / 2;
					end = Math.PI * 1.5;
					open = true;
				} else {
					start = startAngleRad + this.translate(from);
					end = startAngleRad + this.translate(to);
				}
			
			
				ret = this.chart.renderer.symbols.arc(
					this.left + center[0],
					this.top + center[1],
					radii[0],
					radii[0],
					{
						start: start,
						end: end,
						innerR: pick(radii[1], radii[0] - radii[2]),
						open: open
					}
				);
			}
			 
			return ret;
		},
		
		/**
		 * Find the path for plot lines perpendicular to the radial axis.
		 */
		getPlotLinePath: function (value, reverse) {
			var axis = this,
				center = axis.center,
				chart = axis.chart,
				end = axis.getPosition(value),
				xAxis,
				xy,
				tickPositions,
				ret;
			
			// Spokes
			if (axis.isCircular) {
				ret = ['M', center[0] + chart.plotLeft, center[1] + chart.plotTop, 'L', end.x, end.y];
			
			// Concentric circles			
			} else if (axis.options.gridLineInterpolation === 'circle') {
				value = axis.translate(value);
				if (value) { // a value of 0 is in the center
					ret = axis.getLinePath(0, value);
				}
			// Concentric polygons 
			} else {
				// Find the X axis in the same pane
				each(chart.xAxis, function (a) {
					if (a.pane === axis.pane) {
						xAxis = a;
					}
				});
				ret = [];
				value = axis.translate(value);
				tickPositions = xAxis.tickPositions;
				if (xAxis.autoConnect) {
					tickPositions = tickPositions.concat([tickPositions[0]]);
				}
				// Reverse the positions for concatenation of polygonal plot bands
				if (reverse) {
					tickPositions = [].concat(tickPositions).reverse();
				}
					
				each(tickPositions, function (pos, i) {
					xy = xAxis.getPosition(pos, value);
					ret.push(i ? 'L' : 'M', xy.x, xy.y);
				});
				
			}
			return ret;
		},
		
		/**
		 * Find the position for the axis title, by default inside the gauge
		 */
		getTitlePosition: function () {
			var center = this.center,
				chart = this.chart,
				titleOptions = this.options.title;
			
			return { 
				x: chart.plotLeft + center[0] + (titleOptions.x || 0), 
				y: chart.plotTop + center[1] - ({ high: 0.5, middle: 0.25, low: 0 }[titleOptions.align] * 
					center[2]) + (titleOptions.y || 0)  
			};
		}
		
	};
	/*jslint unparam: false*/
	
	/**
	 * Override axisProto.init to mix in special axis instance functions and function overrides
	 */
	wrap(axisProto, 'init', function (proceed, chart, userOptions) {
		var axis = this,
			angular = chart.angular,
			polar = chart.polar,
			isX = userOptions.isX,
			isHidden = angular && isX,
			isCircular,
			startAngleRad,
			endAngleRad,
			options,
			chartOptions = chart.options,
			paneIndex = userOptions.pane || 0,
			pane,
			paneOptions;
			
		// Before prototype.init
		if (angular) {
			extend(this, isHidden ? hiddenAxisMixin : radialAxisMixin);
			isCircular =  !isX;
			if (isCircular) {
				this.defaultRadialOptions = this.defaultRadialGaugeOptions;
			}
			
		} else if (polar) {
			//extend(this, userOptions.isX ? radialAxisMixin : radialAxisMixin);
			extend(this, radialAxisMixin);
			isCircular = isX;
			this.defaultRadialOptions = isX ? this.defaultRadialXOptions : merge(this.defaultYAxisOptions, this.defaultRadialYOptions);
			
		}
		
		// Run prototype.init
		proceed.call(this, chart, userOptions);
		
		if (!isHidden && (angular || polar)) {
			options = this.options;
			
			// Create the pane and set the pane options.
			if (!chart.panes) {
				chart.panes = [];
			}
			this.pane = pane = chart.panes[paneIndex] = chart.panes[paneIndex] || new Pane(
				splat(chartOptions.pane)[paneIndex],
				chart,
				axis
			);
			paneOptions = pane.options;
			
				
			// Disable certain features on angular and polar axes
			chart.inverted = false;
			chartOptions.chart.zoomType = null;
			
			// Start and end angle options are
			// given in degrees relative to top, while internal computations are
			// in radians relative to right (like SVG).
			this.startAngleRad = startAngleRad = (paneOptions.startAngle - 90) * Math.PI / 180;
			this.endAngleRad = endAngleRad = (pick(paneOptions.endAngle, paneOptions.startAngle + 360)  - 90) * Math.PI / 180;
			this.offset = options.offset || 0;
			
			this.isCircular = isCircular;
			
			// Automatically connect grid lines?
			if (isCircular && userOptions.max === UNDEFINED && endAngleRad - startAngleRad === 2 * Math.PI) {
				this.autoConnect = true;
			}
		}
		
	});
	
	/**
	 * Add special cases within the Tick class' methods for radial axes.
	 */	
	wrap(tickProto, 'getPosition', function (proceed, horiz, pos, tickmarkOffset, old) {
		var axis = this.axis;
		
		return axis.getPosition ? 
			axis.getPosition(pos) :
			proceed.call(this, horiz, pos, tickmarkOffset, old);	
	});
	
	/**
	 * Wrap the getLabelPosition function to find the center position of the label
	 * based on the distance option
	 */	
	wrap(tickProto, 'getLabelPosition', function (proceed, x, y, label, horiz, labelOptions, tickmarkOffset, index, step) {
		var axis = this.axis,
			optionsY = labelOptions.y,
			ret,
			align = labelOptions.align,
			angle = ((axis.translate(this.pos) + axis.startAngleRad + Math.PI / 2) / Math.PI * 180) % 360;
	
		if (axis.isRadial) {
			ret = axis.getPosition(this.pos, (axis.center[2] / 2) + pick(labelOptions.distance, -25));
			
			// Automatically rotated
			if (labelOptions.rotation === 'auto') {
				label.attr({ 
					rotation: angle
				});
			
			// Vertically centered
			} else if (optionsY === null) {
				optionsY = axis.chart.renderer.fontMetrics(label.styles.fontSize).b - label.getBBox().height / 2;
			}
			
			// Automatic alignment
			if (align === null) {
				if (axis.isCircular) {
					if (angle > 20 && angle < 160) {
						align = 'left'; // right hemisphere
					} else if (angle > 200 && angle < 340) {
						align = 'right'; // left hemisphere
					} else {
						align = 'center'; // top or bottom
					}
				} else {
					align = 'center';
				}
				label.attr({
					align: align
				});
			}
			
			ret.x += labelOptions.x;
			ret.y += optionsY;
			
		} else {
			ret = proceed.call(this, x, y, label, horiz, labelOptions, tickmarkOffset, index, step);
		}
		return ret;
	});
	
	/**
	 * Wrap the getMarkPath function to return the path of the radial marker
	 */
	wrap(tickProto, 'getMarkPath', function (proceed, x, y, tickLength, tickWidth, horiz, renderer) {
		var axis = this.axis,
			endPoint,
			ret;
			
		if (axis.isRadial) {
			endPoint = axis.getPosition(this.pos, axis.center[2] / 2 + tickLength);
			ret = [
				'M',
				x,
				y,
				'L',
				endPoint.x,
				endPoint.y
			];
		} else {
			ret = proceed.call(this, x, y, tickLength, tickWidth, horiz, renderer);
		}
		return ret;
	});/* 
	 * The AreaRangeSeries class
	 * 
	 */
	
	/**
	 * Extend the default options with map options
	 */
	defaultPlotOptions.arearange = merge(defaultPlotOptions.area, {
		lineWidth: 1,
		marker: null,
		threshold: null,
		tooltip: {
			pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'
		},
		trackByArea: true,
		dataLabels: {
			align: null,
			verticalAlign: null,
			xLow: 0,
			xHigh: 0,
			yLow: 0,
			yHigh: 0	
		},
		states: {
			hover: {
				halo: false
			}
		}
	});
	
	/**
	 * Add the series type
	 */
	seriesTypes.arearange = extendClass(seriesTypes.area, {
		type: 'arearange',
		pointArrayMap: ['low', 'high'],
		toYData: function (point) {
			return [point.low, point.high];
		},
		pointValKey: 'low',
		
		/**
		 * Extend getSegments to force null points if the higher value is null. #1703.
		 */
		getSegments: function () {
			var series = this;
	
			each(series.points, function (point) {
				if (!series.options.connectNulls && (point.low === null || point.high === null)) {
					point.y = null;
				} else if (point.low === null && point.high !== null) {
					point.y = point.high;
				}
			});
			Series.prototype.getSegments.call(this);
		},
		
		/**
		 * Translate data points from raw values x and y to plotX and plotY
		 */
		translate: function () {
			var series = this,
				yAxis = series.yAxis;
	
			seriesTypes.area.prototype.translate.apply(series);
	
			// Set plotLow and plotHigh
			each(series.points, function (point) {
	
				var low = point.low,
					high = point.high,
					plotY = point.plotY;
	
				if (high === null && low === null) {
					point.y = null;
				} else if (low === null) {
					point.plotLow = point.plotY = null;
					point.plotHigh = yAxis.translate(high, 0, 1, 0, 1);
				} else if (high === null) {
					point.plotLow = plotY;
					point.plotHigh = null;
				} else {
					point.plotLow = plotY;
					point.plotHigh = yAxis.translate(high, 0, 1, 0, 1);
				}
			});
		},
		
		/**
		 * Extend the line series' getSegmentPath method by applying the segment
		 * path to both lower and higher values of the range
		 */
		getSegmentPath: function (segment) {
			
			var lowSegment,
				highSegment = [],
				i = segment.length,
				baseGetSegmentPath = Series.prototype.getSegmentPath,
				point,
				linePath,
				lowerPath,
				options = this.options,
				step = options.step,
				higherPath;
				
			// Remove nulls from low segment
			lowSegment = HighchartsAdapter.grep(segment, function (point) {
				return point.plotLow !== null;
			});
			
			// Make a segment with plotX and plotY for the top values
			while (i--) {
				point = segment[i];
				if (point.plotHigh !== null) {
					highSegment.push({
						plotX: point.plotX,
						plotY: point.plotHigh
					});
				}
			}
			
			// Get the paths
			lowerPath = baseGetSegmentPath.call(this, lowSegment);
			if (step) {
				if (step === true) {
					step = 'left';
				}
				options.step = { left: 'right', center: 'center', right: 'left' }[step]; // swap for reading in getSegmentPath
			}
			higherPath = baseGetSegmentPath.call(this, highSegment);
			options.step = step;
			
			// Create a line on both top and bottom of the range
			linePath = [].concat(lowerPath, higherPath);
			
			// For the area path, we need to change the 'move' statement into 'lineTo' or 'curveTo'
			higherPath[0] = 'L'; // this probably doesn't work for spline			
			this.areaPath = this.areaPath.concat(lowerPath, higherPath);
			
			return linePath;
		},
		
		/**
		 * Extend the basic drawDataLabels method by running it for both lower and higher
		 * values.
		 */
		drawDataLabels: function () {
			
			var data = this.data,
				length = data.length,
				i,
				originalDataLabels = [],
				seriesProto = Series.prototype,
				dataLabelOptions = this.options.dataLabels,
				align = dataLabelOptions.align,
				point,
				inverted = this.chart.inverted;
				
			if (dataLabelOptions.enabled || this._hasPointLabels) {
				
				// Step 1: set preliminary values for plotY and dataLabel and draw the upper labels
				i = length;
				while (i--) {
					point = data[i];
					
					// Set preliminary values
					point.y = point.high;
					point._plotY = point.plotY;
					point.plotY = point.plotHigh;
					
					// Store original data labels and set preliminary label objects to be picked up 
					// in the uber method
					originalDataLabels[i] = point.dataLabel;
					point.dataLabel = point.dataLabelUpper;
					
					// Set the default offset
					point.below = false;
					if (inverted) {
						if (!align) {
							dataLabelOptions.align = 'left';
						}
						dataLabelOptions.x = dataLabelOptions.xHigh;								
					} else {
						dataLabelOptions.y = dataLabelOptions.yHigh;
					}
				}
				
				if (seriesProto.drawDataLabels) {
					seriesProto.drawDataLabels.apply(this, arguments); // #1209
				}
				
				// Step 2: reorganize and handle data labels for the lower values
				i = length;
				while (i--) {
					point = data[i];
					
					// Move the generated labels from step 1, and reassign the original data labels
					point.dataLabelUpper = point.dataLabel;
					point.dataLabel = originalDataLabels[i];
					
					// Reset values
					point.y = point.low;
					point.plotY = point._plotY;
					
					// Set the default offset
					point.below = true;
					if (inverted) {
						if (!align) {
							dataLabelOptions.align = 'right';
						}
						dataLabelOptions.x = dataLabelOptions.xLow;
					} else {
						dataLabelOptions.y = dataLabelOptions.yLow;
					}
				}
				if (seriesProto.drawDataLabels) {
					seriesProto.drawDataLabels.apply(this, arguments);
				}
			}
	
			dataLabelOptions.align = align;
		
		},
		
		alignDataLabel: function () {
			seriesTypes.column.prototype.alignDataLabel.apply(this, arguments);
		},
		
		getSymbol: noop,
		
		drawPoints: noop
	});/**
	 * The AreaSplineRangeSeries class
	 */
	
	defaultPlotOptions.areasplinerange = merge(defaultPlotOptions.arearange);
	
	/**
	 * AreaSplineRangeSeries object
	 */
	seriesTypes.areasplinerange = extendClass(seriesTypes.arearange, {
		type: 'areasplinerange',
		getPointSpline: seriesTypes.spline.prototype.getPointSpline
	});
	
	(function () {
		
		var colProto = seriesTypes.column.prototype;
	
		/**
		 * The ColumnRangeSeries class
		 */
		defaultPlotOptions.columnrange = merge(defaultPlotOptions.column, defaultPlotOptions.arearange, {
			lineWidth: 1,
			pointRange: null
		});
	
		/**
		 * ColumnRangeSeries object
		 */
		seriesTypes.columnrange = extendClass(seriesTypes.arearange, {
			type: 'columnrange',
			/**
			 * Translate data points from raw values x and y to plotX and plotY
			 */
			translate: function () {
				var series = this,
					yAxis = series.yAxis,
					plotHigh;
	
				colProto.translate.apply(series);
	
				// Set plotLow and plotHigh
				each(series.points, function (point) {
					var shapeArgs = point.shapeArgs,
						minPointLength = series.options.minPointLength,
						heightDifference,
						height,
						y;
	
					point.tooltipPos = null; // don't inherit from column
					point.plotHigh = plotHigh = yAxis.translate(point.high, 0, 1, 0, 1);
					point.plotLow = point.plotY;
	
					// adjust shape
					y = plotHigh;
					height = point.plotY - plotHigh;
	
					if (height < minPointLength) {
						heightDifference = (minPointLength - height);
						height += heightDifference;
						y -= heightDifference / 2;
					}
					shapeArgs.height = height;
					shapeArgs.y = y;
				});
			},
			trackerGroups: ['group', 'dataLabelsGroup'],
			drawGraph: noop,
			pointAttrToOptions: colProto.pointAttrToOptions,
			drawPoints: colProto.drawPoints,
			drawTracker: colProto.drawTracker,
			animate: colProto.animate,
			getColumnMetrics: colProto.getColumnMetrics
		});
	}());
	
	/* 
	 * The GaugeSeries class
	 */
	
	
	
	/**
	 * Extend the default options
	 */
	defaultPlotOptions.gauge = merge(defaultPlotOptions.line, {
		dataLabels: {
			enabled: true,
			defer: false,
			y: 15,
			borderWidth: 1,
			borderColor: 'silver',
			borderRadius: 3,
			crop: false,
			style: {
				fontWeight: 'bold'
			},
			verticalAlign: 'top',
			zIndex: 2
		},
		dial: {
			// radius: '80%',
			// backgroundColor: 'black',
			// borderColor: 'silver',
			// borderWidth: 0,
			// baseWidth: 3,
			// topWidth: 1,
			// baseLength: '70%' // of radius
			// rearLength: '10%'
		},
		pivot: {
			//radius: 5,
			//borderWidth: 0
			//borderColor: 'silver',
			//backgroundColor: 'black'
		},
		tooltip: {
			headerFormat: ''
		},
		showInLegend: false
	});
	
	/**
	 * Extend the point object
	 */
	var GaugePoint = extendClass(Point, {
		/**
		 * Don't do any hover colors or anything
		 */
		setState: function (state) {
			this.state = state;
		}
	});
	
	
	/**
	 * Add the series type
	 */
	var GaugeSeries = {
		type: 'gauge',
		pointClass: GaugePoint,
		
		// chart.angular will be set to true when a gauge series is present, and this will
		// be used on the axes
		angular: true, 
		drawGraph: noop,
		fixedBox: true,
		forceDL: true,
		trackerGroups: ['group', 'dataLabelsGroup'],
		
		/**
		 * Calculate paths etc
		 */
		translate: function () {
			
			var series = this,
				yAxis = series.yAxis,
				options = series.options,
				center = yAxis.center;
				
			series.generatePoints();
			
			each(series.points, function (point) {
				
				var dialOptions = merge(options.dial, point.dial),
					radius = (pInt(pick(dialOptions.radius, 80)) * center[2]) / 200,
					baseLength = (pInt(pick(dialOptions.baseLength, 70)) * radius) / 100,
					rearLength = (pInt(pick(dialOptions.rearLength, 10)) * radius) / 100,
					baseWidth = dialOptions.baseWidth || 3,
					topWidth = dialOptions.topWidth || 1,
					overshoot = options.overshoot,
					rotation = yAxis.startAngleRad + yAxis.translate(point.y, null, null, null, true);
	
				// Handle the wrap and overshoot options
				if (overshoot && typeof overshoot === 'number') {
					overshoot = overshoot / 180 * Math.PI;
					rotation = Math.max(yAxis.startAngleRad - overshoot, Math.min(yAxis.endAngleRad + overshoot, rotation));			
				
				} else if (options.wrap === false) {
					rotation = Math.max(yAxis.startAngleRad, Math.min(yAxis.endAngleRad, rotation));
				}
	
				rotation = rotation * 180 / Math.PI;
					
				point.shapeType = 'path';
				point.shapeArgs = {
					d: dialOptions.path || [
						'M', 
						-rearLength, -baseWidth / 2, 
						'L', 
						baseLength, -baseWidth / 2,
						radius, -topWidth / 2,
						radius, topWidth / 2,
						baseLength, baseWidth / 2,
						-rearLength, baseWidth / 2,
						'z'
					],
					translateX: center[0],
					translateY: center[1],
					rotation: rotation
				};
				
				// Positions for data label
				point.plotX = center[0];
				point.plotY = center[1];
			});
		},
		
		/**
		 * Draw the points where each point is one needle
		 */
		drawPoints: function () {
			
			var series = this,
				center = series.yAxis.center,
				pivot = series.pivot,
				options = series.options,
				pivotOptions = options.pivot,
				renderer = series.chart.renderer;
			
			each(series.points, function (point) {
				
				var graphic = point.graphic,
					shapeArgs = point.shapeArgs,
					d = shapeArgs.d,
					dialOptions = merge(options.dial, point.dial); // #1233
				
				if (graphic) {
					graphic.animate(shapeArgs);
					shapeArgs.d = d; // animate alters it
				} else {
					point.graphic = renderer[point.shapeType](shapeArgs)
						.attr({
							stroke: dialOptions.borderColor || 'none',
							'stroke-width': dialOptions.borderWidth || 0,
							fill: dialOptions.backgroundColor || 'black',
							rotation: shapeArgs.rotation // required by VML when animation is false
						})
						.add(series.group);
				}
			});
			
			// Add or move the pivot
			if (pivot) {
				pivot.animate({ // #1235
					translateX: center[0],
					translateY: center[1]
				});
			} else {
				series.pivot = renderer.circle(0, 0, pick(pivotOptions.radius, 5))
					.attr({
						'stroke-width': pivotOptions.borderWidth || 0,
						stroke: pivotOptions.borderColor || 'silver',
						fill: pivotOptions.backgroundColor || 'black'
					})
					.translate(center[0], center[1])
					.add(series.group);
			}
		},
		
		/**
		 * Animate the arrow up from startAngle
		 */
		animate: function (init) {
			var series = this;
	
			if (!init) {
				each(series.points, function (point) {
					var graphic = point.graphic;
	
					if (graphic) {
						// start value
						graphic.attr({
							rotation: series.yAxis.startAngleRad * 180 / Math.PI
						});
	
						// animate
						graphic.animate({
							rotation: point.shapeArgs.rotation
						}, series.options.animation);
					}
				});
	
				// delete this function to allow it only once
				series.animate = null;
			}
		},
		
		render: function () {
			this.group = this.plotGroup(
				'group', 
				'series', 
				this.visible ? 'visible' : 'hidden', 
				this.options.zIndex, 
				this.chart.seriesGroup
			);
			Series.prototype.render.call(this);
			this.group.clip(this.chart.clipRect);
		},
		
		/**
		 * Extend the basic setData method by running processData and generatePoints immediately,
		 * in order to access the points from the legend.
		 */
		setData: function (data, redraw) {
			Series.prototype.setData.call(this, data, false);
			this.processData();
			this.generatePoints();
			if (pick(redraw, true)) {
				this.chart.redraw();
			}
		},
	
		/**
		 * If the tracking module is loaded, add the point tracker
		 */
		drawTracker: TrackerMixin && TrackerMixin.drawTrackerPoint
	};
	seriesTypes.gauge = extendClass(seriesTypes.line, GaugeSeries);
	
	/* ****************************************************************************
	 * Start Box plot series code											      *
	 *****************************************************************************/
	
	// Set default options
	defaultPlotOptions.boxplot = merge(defaultPlotOptions.column, {
		fillColor: '#FFFFFF',
		lineWidth: 1,
		//medianColor: null,
		medianWidth: 2,
		states: {
			hover: {
				brightness: -0.3
			}
		},
		//stemColor: null,
		//stemDashStyle: 'solid'
		//stemWidth: null,
		threshold: null,
		tooltip: {
			pointFormat: '<span style="color:{series.color}">\u25CF</span> <b> {series.name}</b><br/>' +
				'Maximum: {point.high}<br/>' +
				'Upper quartile: {point.q3}<br/>' +
				'Median: {point.median}<br/>' +
				'Lower quartile: {point.q1}<br/>' +
				'Minimum: {point.low}<br/>'
				
		},
		//whiskerColor: null,
		whiskerLength: '50%',
		whiskerWidth: 2
	});
	
	// Create the series object
	seriesTypes.boxplot = extendClass(seriesTypes.column, {
		type: 'boxplot',
		pointArrayMap: ['low', 'q1', 'median', 'q3', 'high'], // array point configs are mapped to this
		toYData: function (point) { // return a plain array for speedy calculation
			return [point.low, point.q1, point.median, point.q3, point.high];
		},
		pointValKey: 'high', // defines the top of the tracker
		
		/**
		 * One-to-one mapping from options to SVG attributes
		 */
		pointAttrToOptions: { // mapping between SVG attributes and the corresponding options
			fill: 'fillColor',
			stroke: 'color',
			'stroke-width': 'lineWidth'
		},
		
		/**
		 * Disable data labels for box plot
		 */
		drawDataLabels: noop,
	
		/**
		 * Translate data points from raw values x and y to plotX and plotY
		 */
		translate: function () {
			var series = this,
				yAxis = series.yAxis,
				pointArrayMap = series.pointArrayMap;
	
			seriesTypes.column.prototype.translate.apply(series);
	
			// do the translation on each point dimension
			each(series.points, function (point) {
				each(pointArrayMap, function (key) {
					if (point[key] !== null) {
						point[key + 'Plot'] = yAxis.translate(point[key], 0, 1, 0, 1);
					}
				});
			});
		},
	
		/**
		 * Draw the data points
		 */
		drawPoints: function () {
			var series = this,  //state = series.state,
				points = series.points,
				options = series.options,
				chart = series.chart,
				renderer = chart.renderer,
				pointAttr,
				q1Plot,
				q3Plot,
				highPlot,
				lowPlot,
				medianPlot,
				crispCorr,
				crispX,
				graphic,
				stemPath,
				stemAttr,
				boxPath,
				whiskersPath,
				whiskersAttr,
				medianPath,
				medianAttr,
				width,
				left,
				right,
				halfWidth,
				shapeArgs,
				color,
				doQuartiles = series.doQuartiles !== false, // error bar inherits this series type but doesn't do quartiles
				whiskerLength = parseInt(series.options.whiskerLength, 10) / 100;
	
	
			each(points, function (point) {
	
				graphic = point.graphic;
				shapeArgs = point.shapeArgs; // the box
				stemAttr = {};
				whiskersAttr = {};
				medianAttr = {};
				color = point.color || series.color;
				
				if (point.plotY !== UNDEFINED) {
	
					pointAttr = point.pointAttr[point.selected ? 'selected' : ''];
	
					// crisp vector coordinates
					width = shapeArgs.width;
					left = mathFloor(shapeArgs.x);
					right = left + width;
					halfWidth = mathRound(width / 2);
					//crispX = mathRound(left + halfWidth) + crispCorr;
					q1Plot = mathFloor(doQuartiles ? point.q1Plot : point.lowPlot);// + crispCorr;
					q3Plot = mathFloor(doQuartiles ? point.q3Plot : point.lowPlot);// + crispCorr;
					highPlot = mathFloor(point.highPlot);// + crispCorr;
					lowPlot = mathFloor(point.lowPlot);// + crispCorr;
					
					// Stem attributes
					stemAttr.stroke = point.stemColor || options.stemColor || color;
					stemAttr['stroke-width'] = pick(point.stemWidth, options.stemWidth, options.lineWidth);
					stemAttr.dashstyle = point.stemDashStyle || options.stemDashStyle;
					
					// Whiskers attributes
					whiskersAttr.stroke = point.whiskerColor || options.whiskerColor || color;
					whiskersAttr['stroke-width'] = pick(point.whiskerWidth, options.whiskerWidth, options.lineWidth);
					
					// Median attributes
					medianAttr.stroke = point.medianColor || options.medianColor || color;
					medianAttr['stroke-width'] = pick(point.medianWidth, options.medianWidth, options.lineWidth);
					medianAttr['stroke-linecap'] = 'round'; // #1638
					
					
					// The stem
					crispCorr = (stemAttr['stroke-width'] % 2) / 2;
					crispX = left + halfWidth + crispCorr;				
					stemPath = [
						// stem up
						'M',
						crispX, q3Plot,
						'L',
						crispX, highPlot,
						
						// stem down
						'M',
						crispX, q1Plot,
						'L',
						crispX, lowPlot
					];
					
					// The box
					if (doQuartiles) {
						crispCorr = (pointAttr['stroke-width'] % 2) / 2;
						crispX = mathFloor(crispX) + crispCorr;
						q1Plot = mathFloor(q1Plot) + crispCorr;
						q3Plot = mathFloor(q3Plot) + crispCorr;
						left += crispCorr;
						right += crispCorr;
						boxPath = [
							'M',
							left, q3Plot,
							'L',
							left, q1Plot,
							'L',
							right, q1Plot,
							'L',
							right, q3Plot,
							'L',
							left, q3Plot,
							'z'
						];
					}
					
					// The whiskers
					if (whiskerLength) {
						crispCorr = (whiskersAttr['stroke-width'] % 2) / 2;
						highPlot = highPlot + crispCorr;
						lowPlot = lowPlot + crispCorr;
						whiskersPath = [
							// High whisker
							'M',
							crispX - halfWidth * whiskerLength, 
							highPlot,
							'L',
							crispX + halfWidth * whiskerLength, 
							highPlot,
							
							// Low whisker
							'M',
							crispX - halfWidth * whiskerLength, 
							lowPlot,
							'L',
							crispX + halfWidth * whiskerLength, 
							lowPlot
						];
					}
					
					// The median
					crispCorr = (medianAttr['stroke-width'] % 2) / 2;				
					medianPlot = mathRound(point.medianPlot) + crispCorr;
					medianPath = [
						'M',
						left, 
						medianPlot,
						'L',
						right, 
						medianPlot
					];
					
					// Create or update the graphics
					if (graphic) { // update
						
						point.stem.animate({ d: stemPath });
						if (whiskerLength) {
							point.whiskers.animate({ d: whiskersPath });
						}
						if (doQuartiles) {
							point.box.animate({ d: boxPath });
						}
						point.medianShape.animate({ d: medianPath });
						
					} else { // create new
						point.graphic = graphic = renderer.g()
							.add(series.group);
						
						point.stem = renderer.path(stemPath)
							.attr(stemAttr)
							.add(graphic);
							
						if (whiskerLength) {
							point.whiskers = renderer.path(whiskersPath) 
								.attr(whiskersAttr)
								.add(graphic);
						}
						if (doQuartiles) {
							point.box = renderer.path(boxPath)
								.attr(pointAttr)
								.add(graphic);
						}	
						point.medianShape = renderer.path(medianPath)
							.attr(medianAttr)
							.add(graphic);
					}
				}
			});
	
		}
	
	
	});
	
	/* ****************************************************************************
	 * End Box plot series code												*
	 *****************************************************************************/
	/* ****************************************************************************
	 * Start error bar series code                                                *
	 *****************************************************************************/
	
	// 1 - set default options
	defaultPlotOptions.errorbar = merge(defaultPlotOptions.boxplot, {
		color: '#000000',
		grouping: false,
		linkedTo: ':previous',
		tooltip: {
			pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'
		},
		whiskerWidth: null
	});
	
	// 2 - Create the series object
	seriesTypes.errorbar = extendClass(seriesTypes.boxplot, {
		type: 'errorbar',
		pointArrayMap: ['low', 'high'], // array point configs are mapped to this
		toYData: function (point) { // return a plain array for speedy calculation
			return [point.low, point.high];
		},
		pointValKey: 'high', // defines the top of the tracker
		doQuartiles: false,
		drawDataLabels: seriesTypes.arearange ? seriesTypes.arearange.prototype.drawDataLabels : noop,
	
		/**
		 * Get the width and X offset, either on top of the linked series column
		 * or standalone
		 */
		getColumnMetrics: function () {
			return (this.linkedParent && this.linkedParent.columnMetrics) || 
				seriesTypes.column.prototype.getColumnMetrics.call(this);
		}
	});
	
	/* ****************************************************************************
	 * End error bar series code                                                  *
	 *****************************************************************************/
	/* ****************************************************************************
	 * Start Waterfall series code                                                *
	 *****************************************************************************/
	
	// 1 - set default options
	defaultPlotOptions.waterfall = merge(defaultPlotOptions.column, {
		lineWidth: 1,
		lineColor: '#333',
		dashStyle: 'dot',
		borderColor: '#333',
		states: {
			hover: {
				lineWidthPlus: 0 // #3126
			}
		}
	});
	
	
	// 2 - Create the series object
	seriesTypes.waterfall = extendClass(seriesTypes.column, {
		type: 'waterfall',
	
		upColorProp: 'fill',
	
		pointArrayMap: ['low', 'y'],
	
		pointValKey: 'y',
	
		/**
		 * Init waterfall series, force stacking
		 */
		init: function (chart, options) {
			// force stacking
			options.stacking = true;
	
			seriesTypes.column.prototype.init.call(this, chart, options);
		},
	
	
		/**
		 * Translate data points from raw values
		 */
		translate: function () {
			var series = this,
				options = series.options,
				yAxis = series.yAxis,
				len,
				i,
				points,
				point,
				shapeArgs,
				stack,
				y,
				previousY,
				previousIntermediate,
				stackPoint,
				threshold = options.threshold,
				tooltipY;
	
			// run column series translate
			seriesTypes.column.prototype.translate.apply(this);
	
			previousY = previousIntermediate = threshold;
			points = series.points;
	
			for (i = 0, len = points.length; i < len; i++) {
				// cache current point object
				point = points[i];
				shapeArgs = point.shapeArgs;
	
				// get current stack
				stack = series.getStack(i);
				stackPoint = stack.points[series.index + ',' + i];
	
				// override point value for sums
				if (isNaN(point.y)) {
					point.y = series.yData[i];
				}
	
				// up points
				y = mathMax(previousY, previousY + point.y) + stackPoint[0];
				shapeArgs.y = yAxis.translate(y, 0, 1);
	
	
				// sum points
				if (point.isSum) {
					shapeArgs.y = yAxis.translate(stackPoint[1], 0, 1);
					shapeArgs.height = yAxis.translate(stackPoint[0], 0, 1) - shapeArgs.y;
	
				} else if (point.isIntermediateSum) {
					shapeArgs.y = yAxis.translate(stackPoint[1], 0, 1);
					shapeArgs.height = yAxis.translate(previousIntermediate, 0, 1) - shapeArgs.y;
					previousIntermediate = stackPoint[1];
	
				// if it's not the sum point, update previous stack end position
				} else {
					previousY += stack.total;
				}
	
				// negative points
				if (shapeArgs.height < 0) {
					shapeArgs.y += shapeArgs.height;
					shapeArgs.height *= -1;
				}
	
				point.plotY = shapeArgs.y = mathRound(shapeArgs.y) - (series.borderWidth % 2) / 2;
				shapeArgs.height = mathMax(mathRound(shapeArgs.height), 0.001); // #3151
				point.yBottom = shapeArgs.y + shapeArgs.height;
	
				// Correct tooltip placement (#3014)
				tooltipY = point.plotY + (point.negative ? shapeArgs.height : 0);
				if (series.chart.inverted) {
					point.tooltipPos[0] = yAxis.len - tooltipY;
				} else {
					point.tooltipPos[1] = tooltipY;
				}
	
			}
		},
	
		/**
		 * Call default processData then override yData to reflect waterfall's extremes on yAxis
		 */
		processData: function (force) {
			var series = this,
				options = series.options,
				yData = series.yData,
				points = series.points,
				point,
				dataLength = yData.length,
				threshold = options.threshold || 0,
				subSum,
				sum,
				dataMin,
				dataMax,
				y,
				i;
	
			sum = subSum = dataMin = dataMax = threshold;
	
			for (i = 0; i < dataLength; i++) {
				y = yData[i];
				point = points && points[i] ? points[i] : {};
	
				if (y === "sum" || point.isSum) {
					yData[i] = sum;
				} else if (y === "intermediateSum" || point.isIntermediateSum) {
					yData[i] = subSum;
				} else {
					sum += y;
					subSum += y;
				}
				dataMin = Math.min(sum, dataMin);
				dataMax = Math.max(sum, dataMax);
			}
	
			Series.prototype.processData.call(this, force);
	
			// Record extremes
			series.dataMin = dataMin;
			series.dataMax = dataMax;
		},
	
		/**
		 * Return y value or string if point is sum
		 */
		toYData: function (pt) {
			if (pt.isSum) {
				return (pt.x === 0 ? null : "sum"); //#3245 Error when first element is Sum or Intermediate Sum
			} else if (pt.isIntermediateSum) {
				return (pt.x === 0 ? null : "intermediateSum"); //#3245
			}
			return pt.y;
		},
	
		/**
		 * Postprocess mapping between options and SVG attributes
		 */
		getAttribs: function () {
			seriesTypes.column.prototype.getAttribs.apply(this, arguments);
	
			var series = this,
				options = series.options,
				stateOptions = options.states,
				upColor = options.upColor || series.color,
				hoverColor = Highcharts.Color(upColor).brighten(0.1).get(),
				seriesDownPointAttr = merge(series.pointAttr),
				upColorProp = series.upColorProp;
	
			seriesDownPointAttr[''][upColorProp] = upColor;
			seriesDownPointAttr.hover[upColorProp] = stateOptions.hover.upColor || hoverColor;
			seriesDownPointAttr.select[upColorProp] = stateOptions.select.upColor || upColor;
	
			each(series.points, function (point) {
				if (point.y > 0 && !point.color) {
					point.pointAttr = seriesDownPointAttr;
					point.color = upColor;
				}
			});
		},
	
		/**
		 * Draw columns' connector lines
		 */
		getGraphPath: function () {
	
			var data = this.data,
				length = data.length,
				lineWidth = this.options.lineWidth + this.borderWidth,
				normalizer = mathRound(lineWidth) % 2 / 2,
				path = [],
				M = 'M',
				L = 'L',
				prevArgs,
				pointArgs,
				i,
				d;
	
			for (i = 1; i < length; i++) {
				pointArgs = data[i].shapeArgs;
				prevArgs = data[i - 1].shapeArgs;
	
				d = [
					M,
					prevArgs.x + prevArgs.width, prevArgs.y + normalizer,
					L,
					pointArgs.x, prevArgs.y + normalizer
				];
	
				if (data[i - 1].y < 0) {
					d[2] += prevArgs.height;
					d[5] += prevArgs.height;
				}
	
				path = path.concat(d);
			}
	
			return path;
		},
	
		/**
		 * Extremes are recorded in processData
		 */
		getExtremes: noop,
	
		/**
		 * Return stack for given index
		 */
		getStack: function (i) {
			var axis = this.yAxis,
				stacks = axis.stacks,
				key = this.stackKey;
	
			if (this.processedYData[i] < this.options.threshold) {
				key = '-' + key;
			}
	
			return stacks[key][i];
		},
	
		drawGraph: Series.prototype.drawGraph
	});
	
	/* ****************************************************************************
	 * End Waterfall series code                                                  *
	 *****************************************************************************/
	/* ****************************************************************************
	 * Start Bubble series code											          *
	 *****************************************************************************/
	
	// 1 - set default options
	defaultPlotOptions.bubble = merge(defaultPlotOptions.scatter, {
		dataLabels: {
			formatter: function () { // #2945
				return this.point.z;
			},
			inside: true,
			style: {
				color: 'white',
				textShadow: '0px 0px 3px black'
			},
			verticalAlign: 'middle'
		},
		// displayNegative: true,
		marker: {
			// fillOpacity: 0.5,
			lineColor: null, // inherit from series.color
			lineWidth: 1
		},
		minSize: 8,
		maxSize: '20%',
		// negativeColor: null,
		// sizeBy: 'area'
		states: {
			hover: {
				halo: {
					size: 5
				}
			}
		},
		tooltip: {
			pointFormat: '({point.x}, {point.y}), Size: {point.z}'
		},
		turboThreshold: 0,
		zThreshold: 0
	});
	
	var BubblePoint = extendClass(Point, {
		haloPath: function () {
			return Point.prototype.haloPath.call(this, this.shapeArgs.r + this.series.options.states.hover.halo.size);
		}
	});
	
	// 2 - Create the series object
	seriesTypes.bubble = extendClass(seriesTypes.scatter, {
		type: 'bubble',
		pointClass: BubblePoint,
		pointArrayMap: ['y', 'z'],
		parallelArrays: ['x', 'y', 'z'],
		trackerGroups: ['group', 'dataLabelsGroup'],
		bubblePadding: true,
		
		/**
		 * Mapping between SVG attributes and the corresponding options
		 */
		pointAttrToOptions: { 
			stroke: 'lineColor',
			'stroke-width': 'lineWidth',
			fill: 'fillColor'
		},
		
		/**
		 * Apply the fillOpacity to all fill positions
		 */
		applyOpacity: function (fill) {
			var markerOptions = this.options.marker,
				fillOpacity = pick(markerOptions.fillOpacity, 0.5);
			
			// When called from Legend.colorizeItem, the fill isn't predefined
			fill = fill || markerOptions.fillColor || this.color; 
			
			if (fillOpacity !== 1) {
				fill = Color(fill).setOpacity(fillOpacity).get('rgba');
			}
			return fill;
		},
		
		/**
		 * Extend the convertAttribs method by applying opacity to the fill
		 */
		convertAttribs: function () {
			var obj = Series.prototype.convertAttribs.apply(this, arguments);
			
			obj.fill = this.applyOpacity(obj.fill);
			
			return obj;
		},
	
		/**
		 * Get the radius for each point based on the minSize, maxSize and each point's Z value. This
		 * must be done prior to Series.translate because the axis needs to add padding in 
		 * accordance with the point sizes.
		 */
		getRadii: function (zMin, zMax, minSize, maxSize) {
			var len,
				i,
				pos,
				zData = this.zData,
				radii = [],
				sizeByArea = this.options.sizeBy !== 'width',
				zRange;
			
			// Set the shape type and arguments to be picked up in drawPoints
			for (i = 0, len = zData.length; i < len; i++) {
				zRange = zMax - zMin;
				pos = zRange > 0 ? // relative size, a number between 0 and 1
					(zData[i] - zMin) / (zMax - zMin) : 
					0.5;
				if (sizeByArea && pos >= 0) {
					pos = Math.sqrt(pos);
				}
				radii.push(math.ceil(minSize + pos * (maxSize - minSize)) / 2);
			}
			this.radii = radii;
		},
		
		/**
		 * Perform animation on the bubbles
		 */
		animate: function (init) {
			var animation = this.options.animation;
			
			if (!init) { // run the animation
				each(this.points, function (point) {
					var graphic = point.graphic,
						shapeArgs = point.shapeArgs;
	
					if (graphic && shapeArgs) {
						// start values
						graphic.attr('r', 1);
	
						// animate
						graphic.animate({
							r: shapeArgs.r
						}, animation);
					}
				});
	
				// delete this function to allow it only once
				this.animate = null;
			}
		},
		
		/**
		 * Extend the base translate method to handle bubble size
		 */
		translate: function () {
			
			var i,
				data = this.data,
				point,
				radius,
				radii = this.radii;
			
			// Run the parent method
			seriesTypes.scatter.prototype.translate.call(this);
			
			// Set the shape type and arguments to be picked up in drawPoints
			i = data.length;
			
			while (i--) {
				point = data[i];
				radius = radii ? radii[i] : 0; // #1737
	
				// Flag for negativeColor to be applied in Series.js
				point.negative = point.z < (this.options.zThreshold || 0);
				
				if (radius >= this.minPxSize / 2) {
					// Shape arguments
					point.shapeType = 'circle';
					point.shapeArgs = {
						x: point.plotX,
						y: point.plotY,
						r: radius
					};
					
					// Alignment box for the data label
					point.dlBox = {
						x: point.plotX - radius,
						y: point.plotY - radius,
						width: 2 * radius,
						height: 2 * radius
					};
				} else { // below zThreshold
					point.shapeArgs = point.plotY = point.dlBox = UNDEFINED; // #1691
				}
			}
		},
		
		/**
		 * Get the series' symbol in the legend
		 * 
		 * @param {Object} legend The legend object
		 * @param {Object} item The series (this) or point
		 */
		drawLegendSymbol: function (legend, item) {
			var radius = pInt(legend.itemStyle.fontSize) / 2;
			
			item.legendSymbol = this.chart.renderer.circle(
				radius,
				legend.baseline - radius,
				radius
			).attr({
				zIndex: 3
			}).add(item.legendGroup);
			item.legendSymbol.isMarker = true;	
			
		},
		
		drawPoints: seriesTypes.column.prototype.drawPoints,
		alignDataLabel: seriesTypes.column.prototype.alignDataLabel
	});
	
	/**
	 * Add logic to pad each axis with the amount of pixels
	 * necessary to avoid the bubbles to overflow.
	 */
	Axis.prototype.beforePadding = function () {
		var axis = this,
			axisLength = this.len,
			chart = this.chart,
			pxMin = 0, 
			pxMax = axisLength,
			isXAxis = this.isXAxis,
			dataKey = isXAxis ? 'xData' : 'yData',
			min = this.min,
			extremes = {},
			smallestSize = math.min(chart.plotWidth, chart.plotHeight),
			zMin = Number.MAX_VALUE,
			zMax = -Number.MAX_VALUE,
			range = this.max - min,
			transA = axisLength / range,
			activeSeries = [];
	
		// Handle padding on the second pass, or on redraw
		if (this.tickPositions) {
			each(this.series, function (series) {
	
				var seriesOptions = series.options,
					zData;
	
				if (series.bubblePadding && (series.visible || !chart.options.chart.ignoreHiddenSeries)) {
	
					// Correction for #1673
					axis.allowZoomOutside = true;
	
					// Cache it
					activeSeries.push(series);
	
					if (isXAxis) { // because X axis is evaluated first
					
						// For each series, translate the size extremes to pixel values
						each(['minSize', 'maxSize'], function (prop) {
							var length = seriesOptions[prop],
								isPercent = /%$/.test(length);
							
							length = pInt(length);
							extremes[prop] = isPercent ?
								smallestSize * length / 100 :
								length;
							
						});
						series.minPxSize = extremes.minSize;
						
						// Find the min and max Z
						zData = series.zData;
						if (zData.length) { // #1735
							zMin = pick(seriesOptions.zMin, math.min(
								zMin,
								math.max(
									arrayMin(zData), 
									seriesOptions.displayNegative === false ? seriesOptions.zThreshold : -Number.MAX_VALUE
								)
							));
							zMax = pick(seriesOptions.zMax, math.max(zMax, arrayMax(zData)));
						}
					}
				}
			});
	
			each(activeSeries, function (series) {
	
				var data = series[dataKey],
					i = data.length,
					radius;
	
				if (isXAxis) {
					series.getRadii(zMin, zMax, extremes.minSize, extremes.maxSize);
				}
				
				if (range > 0) {
					while (i--) {
						if (typeof data[i] === 'number') {
							radius = series.radii[i];
							pxMin = Math.min(((data[i] - min) * transA) - radius, pxMin);
							pxMax = Math.max(((data[i] - min) * transA) + radius, pxMax);
						}
					}
				}
			});
			
			if (activeSeries.length && range > 0 && pick(this.options.min, this.userMin) === UNDEFINED && pick(this.options.max, this.userMax) === UNDEFINED) {
				pxMax -= axisLength;
				transA *= (axisLength + pxMin - pxMax) / axisLength;
				this.min += pxMin / transA;
				this.max += pxMax / transA;
			}
		}
	};
	
	/* ****************************************************************************
	 * End Bubble series code                                                     *
	 *****************************************************************************/
	
	(function () {
	
		/**
		 * Extensions for polar charts. Additionally, much of the geometry required for polar charts is
		 * gathered in RadialAxes.js.
		 * 
		 */
	
		var seriesProto = Series.prototype,
			pointerProto = Pointer.prototype,
			colProto;
	
		/**
		 * Translate a point's plotX and plotY from the internal angle and radius measures to 
		 * true plotX, plotY coordinates
		 */
		seriesProto.toXY = function (point) {
			var xy,
				chart = this.chart,
				plotX = point.plotX,
				plotY = point.plotY,
				clientX;
		
			// Save rectangular plotX, plotY for later computation
			point.rectPlotX = plotX;
			point.rectPlotY = plotY;
		
			// Record the angle in degrees for use in tooltip
			clientX = ((plotX / Math.PI * 180) + this.xAxis.pane.options.startAngle) % 360;
			if (clientX < 0) { // #2665
				clientX += 360;
			}
			point.clientX = clientX;
	
		
			// Find the polar plotX and plotY
			xy = this.xAxis.postTranslate(point.plotX, this.yAxis.len - plotY);
			point.plotX = point.polarPlotX = xy.x - chart.plotLeft;
			point.plotY = point.polarPlotY = xy.y - chart.plotTop;
		};
	
		/** 
		 * Order the tooltip points to get the mouse capture ranges correct. #1915. 
		 */
		seriesProto.orderTooltipPoints = function (points) {
			if (this.chart.polar) {
				points.sort(function (a, b) {
					return a.clientX - b.clientX;
				});
	
				// Wrap mouse tracking around to capture movement on the segment to the left
				// of the north point (#1469, #2093).
				if (points[0]) {
					points[0].wrappedClientX = points[0].clientX + 360;
					points.push(points[0]);
				}
			}
		};
	
	
		/**
		 * Add some special init logic to areas and areasplines
		 */
		function initArea(proceed, chart, options) {
			proceed.call(this, chart, options);
			if (this.chart.polar) {
			
				/**
				 * Overridden method to close a segment path. While in a cartesian plane the area 
				 * goes down to the threshold, in the polar chart it goes to the center.
				 */
				this.closeSegment = function (path) {
					var center = this.xAxis.center;
					path.push(
						'L',
						center[0],
						center[1]
					);			
				};
			
				// Instead of complicated logic to draw an area around the inner area in a stack,
				// just draw it behind
				this.closedStacks = true;
			}
		}
	
		if (seriesTypes.area) {		
			wrap(seriesTypes.area.prototype, 'init', initArea);	
		}
		if (seriesTypes.areaspline) {		
			wrap(seriesTypes.areaspline.prototype, 'init', initArea);			
		}	
	
		if (seriesTypes.spline) {
			/**
			 * Overridden method for calculating a spline from one point to the next
			 */
			wrap(seriesTypes.spline.prototype, 'getPointSpline', function (proceed, segment, point, i) {
		
				var ret,
					smoothing = 1.5, // 1 means control points midway between points, 2 means 1/3 from the point, 3 is 1/4 etc;
					denom = smoothing + 1,
					plotX, 
					plotY,
					lastPoint,
					nextPoint,
					lastX,
					lastY,
					nextX,
					nextY,
					leftContX,
					leftContY,
					rightContX,
					rightContY,
					distanceLeftControlPoint,
					distanceRightControlPoint,
					leftContAngle,
					rightContAngle,
					jointAngle;
			
			
				if (this.chart.polar) {
			
					plotX = point.plotX;
					plotY = point.plotY;
					lastPoint = segment[i - 1];
					nextPoint = segment[i + 1];
				
					// Connect ends
					if (this.connectEnds) {
						if (!lastPoint) {
							lastPoint = segment[segment.length - 2]; // not the last but the second last, because the segment is already connected
						}
						if (!nextPoint) {
							nextPoint = segment[1];
						}	
					}
	
					// find control points
					if (lastPoint && nextPoint) {
			
						lastX = lastPoint.plotX;
						lastY = lastPoint.plotY;
						nextX = nextPoint.plotX;
						nextY = nextPoint.plotY;
						leftContX = (smoothing * plotX + lastX) / denom;
						leftContY = (smoothing * plotY + lastY) / denom;
						rightContX = (smoothing * plotX + nextX) / denom;
						rightContY = (smoothing * plotY + nextY) / denom;
						distanceLeftControlPoint = Math.sqrt(Math.pow(leftContX - plotX, 2) + Math.pow(leftContY - plotY, 2));
						distanceRightControlPoint = Math.sqrt(Math.pow(rightContX - plotX, 2) + Math.pow(rightContY - plotY, 2));
						leftContAngle = Math.atan2(leftContY - plotY, leftContX - plotX);
						rightContAngle = Math.atan2(rightContY - plotY, rightContX - plotX);
						jointAngle = (Math.PI / 2) + ((leftContAngle + rightContAngle) / 2);
					
					
						// Ensure the right direction, jointAngle should be in the same quadrant as leftContAngle
						if (Math.abs(leftContAngle - jointAngle) > Math.PI / 2) {
							jointAngle -= Math.PI;
						}
				
						// Find the corrected control points for a spline straight through the point
						leftContX = plotX + Math.cos(jointAngle) * distanceLeftControlPoint;
						leftContY = plotY + Math.sin(jointAngle) * distanceLeftControlPoint;
						rightContX = plotX + Math.cos(Math.PI + jointAngle) * distanceRightControlPoint;
						rightContY = plotY + Math.sin(Math.PI + jointAngle) * distanceRightControlPoint;
				
						// Record for drawing in next point
						point.rightContX = rightContX;
						point.rightContY = rightContY;
	
					}
			
			
					// moveTo or lineTo
					if (!i) {
						ret = ['M', plotX, plotY];
					} else { // curve from last point to this
						ret = [
							'C',
							lastPoint.rightContX || lastPoint.plotX,
							lastPoint.rightContY || lastPoint.plotY,
							leftContX || plotX,
							leftContY || plotY,
							plotX,
							plotY
						];
						lastPoint.rightContX = lastPoint.rightContY = null; // reset for updating series later
					}
			
			
				} else {
					ret = proceed.call(this, segment, point, i);
				}
				return ret;
			});
		}
	
		/**
		 * Extend translate. The plotX and plotY values are computed as if the polar chart were a
		 * cartesian plane, where plotX denotes the angle in radians and (yAxis.len - plotY) is the pixel distance from
		 * center. 
		 */
		wrap(seriesProto, 'translate', function (proceed) {
			
			// Run uber method
			proceed.call(this);
		
			// Postprocess plot coordinates
			if (this.chart.polar && !this.preventPostTranslate) {
				var points = this.points,
					i = points.length;
				while (i--) {
					// Translate plotX, plotY from angle and radius to true plot coordinates
					this.toXY(points[i]);
				}
			}
		});
	
		/** 
		 * Extend getSegmentPath to allow connecting ends across 0 to provide a closed circle in 
		 * line-like series.
		 */
		wrap(seriesProto, 'getSegmentPath', function (proceed, segment) {
			
			var points = this.points;
		
			// Connect the path
			if (this.chart.polar && this.options.connectEnds !== false && 
					segment[segment.length - 1] === points[points.length - 1] && points[0].y !== null) {
				this.connectEnds = true; // re-used in splines
				segment = [].concat(segment, [points[0]]);
			}
		
			// Run uber method
			return proceed.call(this, segment);
		
		});
	
	
		function polarAnimate(proceed, init) {
			var chart = this.chart,
				animation = this.options.animation,
				group = this.group,
				markerGroup = this.markerGroup,
				center = this.xAxis.center,
				plotLeft = chart.plotLeft,
				plotTop = chart.plotTop,
				attribs;
	
			// Specific animation for polar charts
			if (chart.polar) {
			
				// Enable animation on polar charts only in SVG. In VML, the scaling is different, plus animation
				// would be so slow it would't matter.
				if (chart.renderer.isSVG) {
	
					if (animation === true) {
						animation = {};
					}
		
					// Initialize the animation
					if (init) {
					
						// Scale down the group and place it in the center
						attribs = {
							translateX: center[0] + plotLeft,
							translateY: center[1] + plotTop,
							scaleX: 0.001, // #1499
							scaleY: 0.001
						};
						
						group.attr(attribs);
						if (markerGroup) {
							//markerGroup.attrSetters = group.attrSetters;
							markerGroup.attr(attribs);
						}
					
					// Run the animation
					} else {
						attribs = {
							translateX: plotLeft,
							translateY: plotTop,
							scaleX: 1,
							scaleY: 1
						};
						group.animate(attribs, animation);
						if (markerGroup) {
							markerGroup.animate(attribs, animation);
						}
					
						// Delete this function to allow it only once
						this.animate = null;
					}
				}
		
			// For non-polar charts, revert to the basic animation
			} else {
				proceed.call(this, init);
			} 
		}
	
		// Define the animate method for regular series
		wrap(seriesProto, 'animate', polarAnimate);
	
		/**
		 * Throw in a couple of properties to let setTooltipPoints know we're indexing the points
		 * in degrees (0-360), not plot pixel width.
		 */
		wrap(seriesProto, 'setTooltipPoints', function (proceed, renew) {
			
			if (this.chart.polar) {
				extend(this.xAxis, {
					tooltipLen: 360 // degrees are the resolution unit of the tooltipPoints array
				});	
			}
			// Run uber method
			return proceed.call(this, renew);
		});
	
	
		if (seriesTypes.column) {
	
			colProto = seriesTypes.column.prototype;
			/**
			* Define the animate method for columnseries
			*/
			wrap(colProto, 'animate', polarAnimate);
	
	
			/**
			 * Extend the column prototype's translate method
			 */
			wrap(colProto, 'translate', function (proceed) {
			
				var xAxis = this.xAxis,
					len = this.yAxis.len,
					center = xAxis.center,
					startAngleRad = xAxis.startAngleRad,
					renderer = this.chart.renderer,
					start,
					points,
					point,
					i;
		
				this.preventPostTranslate = true;
		
				// Run uber method
				proceed.call(this);
		
				// Postprocess plot coordinates
				if (xAxis.isRadial) {
					points = this.points;
					i = points.length;
					while (i--) {
						point = points[i];
						start = point.barX + startAngleRad;
						point.shapeType = 'path';
						point.shapeArgs = {
							d: renderer.symbols.arc(
								center[0],
								center[1],
								len - point.plotY,
								null, 
								{
									start: start,
									end: start + point.pointWidth,
									innerR: len - pick(point.yBottom, len)
								}
							)
						};
						// Provide correct plotX, plotY for tooltip
						this.toXY(point); 
						point.tooltipPos = [point.plotX, point.plotY];
						point.ttBelow = point.plotY > center[1];
					}
				}
			});
	
	
			/**
			 * Align column data labels outside the columns. #1199.
			 */
			wrap(colProto, 'alignDataLabel', function (proceed, point, dataLabel, options, alignTo, isNew) {
		
				if (this.chart.polar) {
					var angle = point.rectPlotX / Math.PI * 180,
						align,
						verticalAlign;
			
					// Align nicely outside the perimeter of the columns
					if (options.align === null) {
						if (angle > 20 && angle < 160) {
							align = 'left'; // right hemisphere
						} else if (angle > 200 && angle < 340) {
							align = 'right'; // left hemisphere
						} else {
							align = 'center'; // top or bottom
						}
						options.align = align;
					}
					if (options.verticalAlign === null) {
						if (angle < 45 || angle > 315) {
							verticalAlign = 'bottom'; // top part
						} else if (angle > 135 && angle < 225) {
							verticalAlign = 'top'; // bottom part
						} else {
							verticalAlign = 'middle'; // left or right
						}
						options.verticalAlign = verticalAlign;
					}
			
					seriesProto.alignDataLabel.call(this, point, dataLabel, options, alignTo, isNew);
				} else {
					proceed.call(this, point, dataLabel, options, alignTo, isNew);
				}
		
			});		
		}
	
	
		/**
		 * Extend the mouse tracker to return the tooltip position index in terms of
		 * degrees rather than pixels
		 */
		wrap(pointerProto, 'getIndex', function (proceed, e) {
			var ret,
				chart = this.chart,
				center,
				x,
				y;
		
			if (chart.polar) {
				center = chart.xAxis[0].center;
				x = e.chartX - center[0] - chart.plotLeft;
				y = e.chartY - center[1] - chart.plotTop;
			
				ret = 180 - Math.round(Math.atan2(x, y) / Math.PI * 180);
		
			} else {
		
				// Run uber method
				ret = proceed.call(this, e);
			}
			return ret;
		});
	
		/**
		 * Extend getCoordinates to prepare for polar axis values
		 */
		wrap(pointerProto, 'getCoordinates', function (proceed, e) {
			var chart = this.chart,
				ret = {
					xAxis: [],
					yAxis: []
				};
		
			if (chart.polar) {	
	
				each(chart.axes, function (axis) {
					var isXAxis = axis.isXAxis,
						center = axis.center,
						x = e.chartX - center[0] - chart.plotLeft,
						y = e.chartY - center[1] - chart.plotTop;
				
					ret[isXAxis ? 'xAxis' : 'yAxis'].push({
						axis: axis,
						value: axis.translate(
							isXAxis ?
								Math.PI - Math.atan2(x, y) : // angle 
								Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)), // distance from center
							true
						)
					});
				});
			
			} else {
				ret = proceed.call(this, e);
			}
		
			return ret;
		});
	
	}());
	
	}(Highcharts));


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	var BasicAnalysisDirective, BasicAnalysisService, ScoreAnalysisDirective, StrokeAnalysisDirective, StrokeAnalysisService, TimeSeriesAnalysisDirective, TimeSeriesAnalysisService, modules;
	
	__webpack_require__(471);
	
	__webpack_require__(472);
	
	__webpack_require__(28);
	
	__webpack_require__(59);
	
	__webpack_require__(389);
	
	__webpack_require__(274);
	
	StrokeAnalysisDirective = __webpack_require__(474);
	
	ScoreAnalysisDirective = __webpack_require__(476);
	
	StrokeAnalysisService = __webpack_require__(478);
	
	BasicAnalysisDirective = __webpack_require__(479);
	
	BasicAnalysisService = __webpack_require__(481);
	
	TimeSeriesAnalysisDirective = __webpack_require__(482);
	
	TimeSeriesAnalysisService = __webpack_require__(484);
	
	modules = ['gnp-translation', 'gnp-number', 'gnp-payment'];
	
	angular.module('gnp-analysis-charts', modules).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(485)).translations('ja', __webpack_require__(486));
	  }
	]).factory("BasicAnalysisService", BasicAnalysisService).directive('gnpStrokeAnalysis', StrokeAnalysisDirective).directive('gnpScoreAnalysis', ScoreAnalysisDirective).directive('gnpBasicAnalysis', BasicAnalysisDirective).factory('StrokeAnalysisService', StrokeAnalysisService).directive('gnpTimeSeriesAnalysis', TimeSeriesAnalysisDirective).factory('TimeSeriesAnalysisService', TimeSeriesAnalysisService);


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	var StrokeAnalysisDirective;
	
	__webpack_require__(475);
	
	StrokeAnalysisDirective = function(StrokeAnalysisService) {
	  var createChartOptions;
	  createChartOptions = function(data, element) {
	    return {
	      chart: {
	        renderTo: element[0],
	        type: 'pie',
	        backgroundColor: 'transparent'
	      },
	      plotOptions: {
	        pie: {
	          borderWidth: 0,
	          shadow: false,
	          startAngle: -90,
	          endAngle: 90,
	          center: ['50%', '50%'],
	          enableMouseTracking: false,
	          dataLabels: {
	            enabled: false
	          }
	        }
	      },
	      tooltip: {
	        enabled: false
	      },
	      title: {
	        floating: true,
	        y: 28,
	        text: ''
	      },
	      credits: {
	        enabled: false
	      },
	      series: [
	        {
	          size: '100%',
	          innerSize: '92%',
	          data: [
	            {
	              color: '#006A68',
	              y: data.par5.y1
	            }, {
	              color: '#B3CECE',
	              y: data.par5.y2
	            }
	          ]
	        }, {
	          size: '92%',
	          innerSize: '84%',
	          data: [
	            {
	              color: '#008886',
	              y: data.par4.y1
	            }, {
	              color: '#B1D4D3',
	              y: data.par4.y2
	            }
	          ]
	        }, {
	          size: '84%',
	          innerSize: '82%',
	          data: [
	            {
	              color: '#00B8B5',
	              y: data.par3.y1
	            }, {
	              color: '#B9DEDD',
	              y: data.par3.y2
	            }
	          ]
	        }
	      ]
	    };
	  };
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "analysis-charts/stroke-analysis/stroke-analysis.jade",
	    scope: {
	      strokeData: '=strokeData'
	    },
	    link: function(scope, element) {
	      var target;
	      target = element.find(".stroke-chart");
	      return scope.$watch((function() {
	        return scope.strokeData;
	      }), function() {
	        var strokeData;
	        strokeData = StrokeAnalysisService.convertStrokeDataForChart(scope.strokeData);
	        return new Highcharts.Chart(createChartOptions(strokeData, target));
	      });
	    }
	  };
	};
	
	StrokeAnalysisDirective.$inject = ['StrokeAnalysisService'];
	
	module.exports = StrokeAnalysisDirective;


/***/ }),
/* 475 */
/***/ (function(module, exports) {

	var v1="<div class=\"chart stroke-chart\"></div><div class=\"title\">{{:: '_STROKE_ANALYSIS.TITLE' | translate }}</div><div class=\"value1\">{{ strokeData.avg_shot_par3 | number: 2 }}</div><div class=\"value2\">{{ strokeData.avg_shot_par4 | number: 2 }}</div><div class=\"value3\">{{ strokeData.avg_shot_par5 | number: 2 }}</div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis-charts/stroke-analysis/stroke-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	var ScoreAnalysisDirective;
	
	__webpack_require__(477);
	
	ScoreAnalysisDirective = function() {
	  var createChartOptions;
	  createChartOptions = function(data, element) {
	    return {
	      chart: {
	        renderTo: element[0],
	        type: 'pie',
	        backgroundColor: 'transparent'
	      },
	      plotOptions: {
	        pie: {
	          borderWidth: 0,
	          shadow: false,
	          startAngle: -90,
	          endAngle: 90,
	          center: ['50%', '50%'],
	          enableMouseTracking: false,
	          dataLabels: {
	            enabled: false
	          }
	        }
	      },
	      tooltip: {
	        enabled: false
	      },
	      title: {
	        floating: true,
	        y: 28,
	        text: ''
	      },
	      credits: {
	        enabled: false
	      },
	      series: [
	        {
	          threshold: 1,
	          size: '100%',
	          innerSize: '85%',
	          data: [
	            {
	              color: '#ff0000',
	              y: data.rat_under_eagle
	            }, {
	              color: '#ff7400',
	              y: data.rat_birdie
	            }, {
	              color: '#05a2d3',
	              y: data.rat_par
	            }, {
	              color: '#215605',
	              y: data.rat_bogey
	            }, {
	              color: '#3a3a3a',
	              y: data.rat_dbogey
	            }, {
	              color: '#000000',
	              y: data.rat_over_tbogey
	            }
	          ]
	        }
	      ]
	    };
	  };
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "analysis-charts/score-analysis/score-analysis.jade",
	    scope: {
	      scoreData: '=scoreData'
	    },
	    link: function(scope, element) {
	      var target;
	      target = element.find(".score-chart");
	      return scope.$watch((function() {
	        return scope.scoreData;
	      }), function() {
	        if (!scope.scoreData.rat_birdie && !scope.scoreData.rat_bogey && !scope.scoreData.rat_dbogey && !scope.scoreData.rat_over_tbogey && !scope.scoreData.rat_par && !scope.scoreData.rat_under_eagle) {
	          return;
	        }
	        return new Highcharts.Chart(createChartOptions(scope.scoreData, target));
	      });
	    }
	  };
	};
	
	module.exports = ScoreAnalysisDirective;


/***/ }),
/* 477 */
/***/ (function(module, exports) {

	var v1="<div class=\"chart score-chart\"></div><div class=\"title\">{{:: '_SCORE_ANALYSIS.TITLE' | translate }}</div><div class=\"value1\">{{ (scoreData.rat_under_eagle * 100 | percentToFormattedString) }}%</div><div class=\"label1\">{{:: '_SCORE_ANALYSIS.EAGLE' | translate }}</div><div class=\"value2\">{{ (scoreData.rat_birdie * 100 | percentToFormattedString) }}%</div><div class=\"label2\">{{:: '_SCORE_ANALYSIS.BIRDIE' | translate }}</div><div class=\"value3\">{{ (scoreData.rat_par * 100 | percentToFormattedString) }}%</div><div class=\"label3\">{{:: '_SCORE_ANALYSIS.PAR' | translate }}</div><div class=\"value4\">{{ (scoreData.rat_bogey * 100 | percentToFormattedString) }}%</div><div class=\"label4\">{{:: '_SCORE_ANALYSIS.BOGEY' | translate }}</div><div class=\"value5\">{{ (scoreData.rat_dbogey * 100 | percentToFormattedString) }}%</div><div class=\"label5\">{{:: '_SCORE_ANALYSIS.DBOGEY' | translate }}</div><div class=\"value6\">{{ (scoreData.rat_over_tbogey * 100 | percentToFormattedString) }}%</div><div class=\"label6\">{{:: '_SCORE_ANALYSIS.TRIPLE_BOGEY_OVER' | translate }}</div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis-charts/score-analysis/score-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	var StrokeAnalysisService, _;
	
	_ = __webpack_require__(87);
	
	StrokeAnalysisService = function() {
	  return {
	    convertStrokeDataForChart: function(data) {
	      return {
	        par5: {
	          y1: (data.avg_shot_par5 * 100) / 10,
	          y2: ((10 - data.avg_shot_par5) * 100) / 10
	        },
	        par4: {
	          y1: (data.avg_shot_par4 * 100) / 8,
	          y2: ((8 - data.avg_shot_par4) * 100) / 8
	        },
	        par3: {
	          y1: (data.avg_shot_par3 * 100) / 6,
	          y2: ((6 - data.avg_shot_par3) * 100) / 6
	        }
	      };
	    }
	  };
	};
	
	module.exports = StrokeAnalysisService;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	var BasicAnalysisDirective, _, createChartOptions;
	
	__webpack_require__(480);
	
	_ = __webpack_require__(87);
	
	createChartOptions = function(per_my, per_goal, per_all, element, NumberService) {
	  var per_my_text;
	  if (per_my) {
	    per_my_text = per_my === 100 ? per_my : NumberService.limitFractional(per_my);
	  } else {
	    per_my = 0;
	    per_my_text = '-';
	  }
	  per_goal = per_goal || 0;
	  per_all = per_all || 0;
	  return {
	    chart: {
	      renderTo: element[0],
	      type: 'pie',
	      backgroundColor: 'transparent'
	    },
	    plotOptions: {
	      pie: {
	        borderWidth: 0,
	        shadow: false,
	        center: ['50%', '50%'],
	        enableMouseTracking: false,
	        dataLabels: {
	          enabled: false
	        }
	      }
	    },
	    tooltip: {
	      enabled: false
	    },
	    title: {
	      floating: true,
	      y: 80,
	      text: per_my_text + ' %',
	      style: {
	        'fontSize': '24px',
	        'color': '#008484'
	      }
	    },
	    credits: {
	      enabled: false
	    },
	    series: [
	      {
	        size: 160,
	        innerSize: 142,
	        data: [
	          {
	            color: '#979581',
	            y: per_all
	          }, {
	            color: '#b5bbb5',
	            y: 100 - per_all
	          }
	        ]
	      }, {
	        size: 140,
	        innerSize: 122,
	        data: [
	          {
	            color: '#ee2e2e',
	            y: per_goal
	          }, {
	            color: '#cf9c9c',
	            y: 100 - per_goal
	          }
	        ]
	      }, {
	        size: 120,
	        innerSize: 102,
	        data: [
	          {
	            color: '#008484',
	            y: per_my
	          }, {
	            color: '#87b6b6',
	            y: 100 - per_my
	          }
	        ]
	      }
	    ]
	  };
	};
	
	BasicAnalysisDirective = function(NumberService, BasicAnalysisService, $location, $routeParams, $filter) {
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "analysis-charts/basic-analysis/basic-analysis.jade",
	    scope: {
	      basicAnalysisData: '=basicAnalysisData'
	    },
	    link: function(scope, element) {
	      var bogeyOnChartElement, fairwayChartElement, girChartElement, path;
	      fairwayChartElement = element.find(".fairway-chart");
	      girChartElement = element.find(".gir-chart");
	      bogeyOnChartElement = element.find(".bogey-on-chart");
	      path = $location.path();
	      if ($routeParams.event_id !== void 0) {
	        scope.hideLabel = true;
	      }
	      scope.displayNumber = function(number, putt_disabled) {
	        if (putt_disabled == null) {
	          putt_disabled = false;
	        }
	        if (path.indexOf('round-detail') === 1 && putt_disabled && putt_disabled !== 0) {
	          return null;
	        }
	        if (!angular.isNumber(number)) {
	          return number;
	        }
	        return $filter('number')(number, 2);
	      };
	      scope.mixPanelEventPrefix = path === '/' ? 'DSB' : path.indexOf('round-detail') > -1 ? 'DTL' : 'ANL';
	      scope.$watchCollection('basicAnalysisData', function() {
	        var viewModel;
	        viewModel = BasicAnalysisService.createViewModel(scope.basicAnalysisData);
	        scope.my_avg = viewModel.my_avg;
	        scope.goal = viewModel.goal;
	        scope.all_members = viewModel.all_members;
	        scope.showRoundIcon = viewModel.showRoundIcon;
	        new Highcharts.Chart(createChartOptions(scope.my_avg.per_fairway_center, scope.goal.per_fairway_center, scope.all_members.per_fairway_center, fairwayChartElement, NumberService));
	        new Highcharts.Chart(createChartOptions(scope.my_avg.per_par_on, scope.goal.per_par_on, scope.all_members.per_par_on, girChartElement, NumberService));
	        return new Highcharts.Chart(createChartOptions(scope.my_avg.per_bogey_on, scope.goal.per_bogey_on, scope.all_members.per_bogey_on, bogeyOnChartElement, NumberService));
	      });
	      return scope.classForRoundIcons = function() {
	        var ref;
	        switch ((ref = scope.$parent.roundInfo) != null ? ref.round_type : void 0) {
	          case 1.5:
	            return 'icons-extra9';
	          case 0.5:
	            return 'icons-half-nine';
	          default:
	            return '';
	        }
	      };
	    }
	  };
	};
	
	BasicAnalysisDirective.$inject = ['NumberService', 'BasicAnalysisService', '$location', '$routeParams', '$filter'];
	
	module.exports = BasicAnalysisDirective;


/***/ }),
/* 480 */
/***/ (function(module, exports) {

	var v1="<div class=\"d-block d-sm-none d-none d-sm-block d-md-none\"><div ng-class=\"{show: showRoundIcon}\" class=\"round-icon-wrap hide\"><div ng-class=\"classForRoundIcons(history)\" class=\"icon-round\"></div></div></div><div class=\"row mx-0\"><div class=\"col-sm-12 col-md-6 column\"><div class=\"d-none d-md-block\"><div ng-class=\"{show: showRoundIcon}\" class=\"hide\"><div ng-class=\"classForRoundIcons(history)\" class=\"icon-round\"></div></div></div><div class=\"bar-layer\"><div ng-style=\"{'width': my_avg.per_total_shot + '%'}\" class=\"bar-avg-score\"></div><div ng-style=\"{'width': all_members.per_total_shot + '%'}\" class=\"bar-all-avg-score\"></div><div ng-class=\"{freemode: !$root.paid}\" ng-style=\"{'left': goal.per_total_shot + '%'}\" class=\"pin-goal\"></div></div><div class=\"score-circle\"><div class=\"title\">{{:: '_BASIC_ANALYSIS.MY_AVG_TOTAL_SHOT' | translate }}</div><div gnp-small-sized-decimal=\"\" val=\"displayNumber(my_avg.avg_total_shot)\"></div></div><a href=\"/goal-settings\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_Tgt_AvgScore'}}\" class=\"{{(hideHeader || hideLabel) ? 'inactive' : ''}}\"><div ng-class=\"{freemode: !$root.paid}\" class=\"goal-circle\"><div class=\"title\">{{:: '_BASIC_ANALYSIS.MY_GOAL' | translate }}</div><div gnp-small-sized-decimal=\"\" val=\"displayNumber(goal.avg_total_shot)\"></div></div></a><div class=\"all-score-circle\"><div class=\"title\">{{:: '_BASIC_ANALYSIS.ALL_MEMBERS_TOP' | translate }} {{:: '_BASIC_ANALYSIS.ALL_MEMBERS_BELLOW' | translate }}</div><div gnp-small-sized-decimal=\"\" val=\"displayNumber(all_members.avg_total_shot)\"></div></div><a href=\"/goal-settings\" class=\"{{(hideHeader || hideLabel) ? 'hide-header' : ''}}\"><div ng-hide=\"$root.paid\" class=\"help-circle\"></div></a></div><div class=\"col-sm-12 col-md-6 column last\"><div class=\"bar-layer\"><div ng-style=\"{'width': my_avg.per_avg_putt + '%'}\" class=\"bar-avg-score\"></div><div ng-style=\"{'width': all_members.per_avg_putt + '%'}\" class=\"bar-all-avg-score\"></div><div ng-class=\"{freemode: !$root.paid}\" ng-style=\"{'left': goal.per_avg_putt + '%'}\" class=\"pin-goal\"></div></div><div class=\"score-circle\"><div class=\"title\">{{:: '_BASIC_ANALYSIS.MY_AVG_PUTT' | translate }}</div><div gnp-small-sized-decimal=\"\" val=\"displayNumber(my_avg.avg_putt,my_avg.cnt_putt_disabled)\"></div><div class=\"hole\">{{:: '_BASIC_ANALYSIS.PER_ONE_HOLE' | translate }}</div></div><a href=\"/goal-settings\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_Tgt_AvgPutt'}}\" class=\"{{(hideHeader || hideLabel) ? 'inactive' : ''}}\"><div ng-class=\"{freemode: !$root.paid}\" class=\"goal-circle\"><div class=\"title\">{{:: '_BASIC_ANALYSIS.MY_GOAL' | translate }}</div><div gnp-small-sized-decimal=\"\" val=\"displayNumber(goal.avg_putt)\"></div></div></a><div class=\"all-score-circle\"><div class=\"title\">{{:: '_BASIC_ANALYSIS.ALL_MEMBERS_TOP' | translate }} {{:: '_BASIC_ANALYSIS.ALL_MEMBERS_BELLOW' | translate }}</div><div gnp-small-sized-decimal=\"\" val=\"displayNumber(all_members.avg_putt)\"></div></div><a href=\"/goal-settings\" class=\"{{(hideHeader || hideLabel) ? 'hide-header' : ''}}\"><div ng-hide=\"$root.paid\" class=\"help-circle\"></div></a></div><div class=\"col-12 col-sm-6 col-md-4 column-chart-percent\"><a href=\"/goal-settings\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_Tgt_AvgFw'}}\" class=\"{{(hideHeader || hideLabel) ? 'inactive' : ''}}\"><div ng-class=\"{freemode: !$root.paid}\" class=\"goal\"><div class=\"circle\">{{:: '_BASIC_ANALYSIS.MY_GOAL' | translate }}</div><div gnp-small-sized-decimal=\"\" val=\"displayNumber(goal.per_fairway_center)\" prefix=\"%\"></div></div></a><div class=\"all-avg\"><div class=\"circle\">{{:: '_BASIC_ANALYSIS.ALL_MEMBERS_TOP' | translate }}<br/>{{:: '_BASIC_ANALYSIS.ALL_MEMBERS_BELLOW' | translate }}</div><div gnp-small-sized-decimal=\"\" val=\"displayNumber(all_members.per_fairway_center)\" prefix=\"%\"></div></div><div class=\"chart fairway-chart\"></div><div class=\"sub-title\">{{:: '_BASIC_ANALYSIS.FAIRWAY_HIT' | translate }}</div></div><div class=\"col-12 col-sm-6 col-md-4 column-chart-percent\"><a href=\"/goal-settings\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_Tgt_AvgGir'}}\" class=\"{{(hideHeader || hideLabel) ? 'inactive' : ''}}\"><div ng-class=\"{freemode: !$root.paid}\" class=\"goal\"><div class=\"circle\">{{:: '_BASIC_ANALYSIS.MY_GOAL' | translate }}</div><div gnp-small-sized-decimal=\"\" val=\"displayNumber(goal.per_par_on)\" prefix=\"%\"></div></div></a><div class=\"all-avg\"><div class=\"circle\">{{:: '_BASIC_ANALYSIS.ALL_MEMBERS_TOP' | translate }}<br/>{{:: '_BASIC_ANALYSIS.ALL_MEMBERS_BELLOW' | translate }}</div><div gnp-small-sized-decimal=\"\" val=\"displayNumber(all_members.per_par_on)\" prefix=\"%\"></div></div><div class=\"chart gir-chart\"></div><div class=\"sub-title\">{{:: '_BASIC_ANALYSIS.RAT_PAR_ON' | translate }}</div></div><div class=\"col-12 col-sm-6 col-md-4 column-chart-percent\"><a href=\"/goal-settings\" analytics-on=\"click\" analytics-event=\"{{mixPanelEventPrefix + '_Tgt_AvgRcv'}}\" class=\"{{(hideHeader || hideLabel) ? 'inactive' : ''}}\"><div ng-class=\"{freemode: !$root.paid}\" class=\"goal\"><div class=\"circle\">{{:: '_BASIC_ANALYSIS.MY_GOAL' | translate }}</div><div gnp-small-sized-decimal=\"\" val=\"displayNumber(goal.per_bogey_on)\" prefix=\"%\"></div></div></a><div class=\"all-avg\"><div class=\"circle\">{{:: '_BASIC_ANALYSIS.ALL_MEMBERS_TOP' | translate }}<br/>{{:: '_BASIC_ANALYSIS.ALL_MEMBERS_BELLOW' | translate }}</div><div gnp-small-sized-decimal=\"\" val=\"displayNumber(all_members.per_bogey_on)\" prefix=\"%\"></div></div><div class=\"chart bogey-on-chart\"></div><div class=\"sub-title\">{{:: '_BASIC_ANALYSIS.RAT_BOGEY_ON' | translate }}</div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis-charts/basic-analysis/basic-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	var BasicAnalysisService, MAX_TOTAL_PUTT, MAX_TOTAL_SHOT, PER_AVG_PUTT_DEFAULT, PER_TOTAL_SHOT_DEFAULT, _;
	
	_ = __webpack_require__(87);
	
	MAX_TOTAL_SHOT = 200;
	
	MAX_TOTAL_PUTT = 5;
	
	PER_TOTAL_SHOT_DEFAULT = (72 * 100) / MAX_TOTAL_SHOT;
	
	PER_AVG_PUTT_DEFAULT = (2 * 100) / MAX_TOTAL_PUTT;
	
	BasicAnalysisService = function() {
	  var ratioToPercent;
	  ratioToPercent = function(data) {
	    return {
	      avg_total_shot: (data != null ? data.avg_total_shot : void 0) || [],
	      avg_putt: data != null ? data.avg_putt : void 0,
	      per_fairway_center: (data != null ? data.rat_fairway_center : void 0) * 100,
	      per_bogey_on: (data != null ? data.rat_bogey_on : void 0) * 100,
	      per_par_on: (data != null ? data.rat_par_on : void 0) * 100,
	      cnt_putt_disabled: data != null ? data.cnt_putt_disabled : void 0,
	      per_total_shot: (function() {
	        if (!(data != null ? data.avg_total_shot : void 0)) {
	          return PER_TOTAL_SHOT_DEFAULT;
	        }
	        return _.min([data.avg_total_shot / MAX_TOTAL_SHOT, 1]) * 100;
	      })(),
	      per_avg_putt: (function() {
	        if (!(data != null ? data.avg_putt : void 0)) {
	          return PER_AVG_PUTT_DEFAULT;
	        }
	        return _.min([data.avg_putt / MAX_TOTAL_PUTT, 1]) * 100;
	      })()
	    };
	  };
	  return {
	    parseDetailedAnalysisData: function(data) {
	      var requiredFields;
	      requiredFields = ['avg_total_shot', 'avg_putt', 'rat_fairway_center', 'rat_bogey_on', 'rat_par_on', 'cnt_putt_disabled'];
	      return {
	        my_avg: _.pick(data.my_avg, requiredFields),
	        goal: _.pick(data.goal, requiredFields),
	        all_members: _.pick(data.all_members, requiredFields)
	      };
	    },
	    createViewModel: function(data) {
	      return _.mapValues(data, function(val) {
	        return ratioToPercent(val);
	      });
	    }
	  };
	};
	
	BasicAnalysisService.$inject = ['NumberService'];
	
	module.exports = BasicAnalysisService;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var TimeSeriesAnalysisDirective, createChartOptions;
	
	__webpack_require__(483);
	
	createChartOptions = function(scoreData, target) {
	  return {
	    chart: {
	      renderTo: target[0],
	      type: 'line',
	      backgroundColor: 'transparent',
	      marginRight: 30,
	      marginTop: 55
	    },
	    credits: {
	      enabled: false
	    },
	    title: {
	      text: null
	    },
	    plotOptions: {
	      series: {
	        marker: {
	          symbol: 'circle',
	          lineWidth: 4,
	          lineColor: null
	        },
	        point: {
	          events: {
	            mouseOver: function() {
	              var plotIndex, serieIndex;
	              plotIndex = this.x;
	              serieIndex = this.series.index;
	              localStorage.setItem("PLOT_INDEX_ANALYSIS", plotIndex);
	              localStorage.setItem("SERIE_INDEX_ANALYSIS", serieIndex);
	              if (!localStorage.getItem("TRANSITION_FROM_ANALYSIS")) {
	                return localStorage.setItem("TRANSITION_FROM_ANALYSIS", '1');
	              }
	            }
	          }
	        }
	      }
	    },
	    tooltip: {
	      useHTML: true,
	      borderWidth: 0,
	      borderRadius: 0,
	      backgroundColor: null,
	      shadow: false,
	      style: {
	        pointerEvents: ''
	      },
	      formatter: function() {
	        return "<a class='score-wrap' href='/round-detail/" + this.point.id + "' style='background-color: " + this.series.color + ";' zindex='1'> <span class='play-date'>" + this.point.play_date + "</span> <br/> <span class='score'>" + this.y + "</span> </a>";
	      },
	      positioner: function(boxWidth, boxHeight, point) {
	        var pointX, pointY;
	        pointX = point.plotX;
	        pointY = point.plotY;
	        return {
	          x: pointX + 15,
	          y: pointY - 20
	        };
	      }
	    },
	    legend: {
	      floating: true,
	      borderWidth: 2,
	      backgroundColor: '#FFFFFF',
	      verticalAlign: 'top',
	      align: 'right',
	      layout: 'vertical'
	    },
	    yAxis: {
	      title: {
	        text: null
	      },
	      labels: {
	        style: {
	          color: '#000',
	          fontWeight: 'bold'
	        }
	      },
	      min: 0
	    },
	    xAxis: {
	      type: 'linear',
	      minorTickPosition: 'inside',
	      categories: scoreData.categories
	    },
	    series: scoreData.series
	  };
	};
	
	TimeSeriesAnalysisDirective = function() {
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "analysis-charts/time-series-analysis/time-series-analysis.jade",
	    scope: {
	      scoreData: '=scoreData'
	    },
	    link: function(scope, element) {
	      var plotIndex, serieIndex, target;
	      target = element.find(".chart");
	      localStorage.removeItem("TRANSITION_FROM_ANALYSIS");
	      plotIndex = localStorage.getItem("PLOT_INDEX_ANALYSIS");
	      serieIndex = localStorage.getItem("SERIE_INDEX_ANALYSIS");
	      return scope.$watch((function() {
	        return scope.scoreData;
	      }), function() {
	        var chart;
	        chart = new Highcharts.Chart(createChartOptions(scope.scoreData, target));
	        if (chart.tooltip && plotIndex && serieIndex) {
	          return chart.tooltip.refresh(chart.series[serieIndex].points[plotIndex]);
	        }
	      });
	    }
	  };
	};
	
	TimeSeriesAnalysisDirective.$inject = [];
	
	module.exports = TimeSeriesAnalysisDirective;


/***/ }),
/* 483 */
/***/ (function(module, exports) {

	var v1="<div class=\"chart\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis-charts/time-series-analysis/time-series-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var TimeSeriesAnalysisService, _;
	
	_ = __webpack_require__(87);
	
	TimeSeriesAnalysisService = function($filter) {
	  return {
	    convertToCategories: function(filteredScorecards) {
	      return _.map(filteredScorecards, function(ts, key) {
	        if (!(key === 0 || key === (filteredScorecards.length - 1))) {
	          return '';
	        }
	        return ts.play_date.format("YYYY/MM/DD");
	      });
	    },
	    convertToSeries: function(filteredScorecards) {
	      var putts_data, scores_data;
	      scores_data = [];
	      putts_data = [];
	      _.map(filteredScorecards, function(ts, key) {
	        var play_date;
	        play_date = (ts.play_date.format("YYYY/")) + "</br>" + (ts.play_date.format("MM/DD"));
	        scores_data.push({
	          play_date: play_date,
	          y: ts.total_shot_all_holes,
	          id: ts.id
	        });
	        return putts_data.push({
	          play_date: play_date,
	          y: ts.total_putt_all_holes,
	          id: ts.id
	        });
	      });
	      return [
	        {
	          name: $filter('translate')('SCORE'),
	          color: "#4D90B6",
	          data: scores_data
	        }, {
	          name: $filter('translate')('PUTTS'),
	          color: "#00C7C4",
	          data: putts_data
	        }
	      ];
	    }
	  };
	};
	
	TimeSeriesAnalysisService.$inject = ['$filter'];
	
	module.exports = TimeSeriesAnalysisService;


/***/ }),
/* 485 */
/***/ (function(module, exports) {

	module.exports = {
	  '_BASIC_ANALYSIS': {
	    'MY_AVG_TOTAL_SHOT': 'Average Score',
	    'MY_AVG_PUTT': 'Avg. Putts',
	    'PER_ONE_HOLE': 'Per 1 Hole',
	    'MY_GOAL': 'Goal',
	    'ALL_MEMBERS_TOP': 'All User\'s',
	    'ALL_MEMBERS_BELLOW': '',
	    'FAIRWAY_HIT': 'Fairway hit',
	    'RAT_PAR_ON': 'GIR (%)',
	    'RAT_BOGEY_ON': 'GIR+1 (%)',
	    'THIS_YEAR': 'Current year',
	    'LAST_3_MONTHS': 'Last 3 months',
	    'LAST_6_MONTHS': 'Last 6 months',
	    'ENTIRE_PERIOD': 'Entire period'
	  },
	  '_SCORE_ANALYSIS': {
	    'TITLE': 'Score Analysis',
	    'EAGLE': 'Eagle or under',
	    'BIRDIE': 'Birdie',
	    'PAR': 'Par',
	    'BOGEY': 'Bogey',
	    'DBOGEY': 'Double Bogey',
	    'TRIPLE_BOGEY_OVER': 'Triple Bogey or Over'
	  },
	  '_STROKE_ANALYSIS': {
	    'TITLE': 'Stroke Analysis'
	  }
	};


/***/ }),
/* 486 */
/***/ (function(module, exports) {

	module.exports = {
	  '_BASIC_ANALYSIS': {
	    'MY_AVG_TOTAL_SHOT': '平均スコア',
	    'MY_AVG_PUTT': '平均パット数 ',
	    'PER_ONE_HOLE': '1ホール',
	    'MY_GOAL': '目標',
	    'ALL_MEMBERS_TOP': '会員',
	    'ALL_MEMBERS_BELLOW': '平均',
	    'FAIRWAY_HIT': 'フェアウェイキープ率',
	    'RAT_PAR_ON': 'パーオン率',
	    'RAT_BOGEY_ON': 'ボギーオン率',
	    'THIS_YEAR': '当年',
	    'LAST_3_MONTHS': '直近3ヶ月',
	    'LAST_6_MONTHS': '直近6ヶ月',
	    'ENTIRE_PERIOD': '全期間'
	  },
	  '_SCORE_ANALYSIS': {
	    'TITLE': 'スコア分析',
	    'EAGLE': 'イーグル以上',
	    'BIRDIE': 'バーディ',
	    'PAR': 'パー',
	    'BOGEY': 'ボギー',
	    'DBOGEY': 'ダブルボギー',
	    'TRIPLE_BOGEY_OVER': 'トリプルボギー以上'
	  },
	  '_STROKE_ANALYSIS': {
	    'TITLE': '平均ストローク数'
	  }
	};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	var GoalSettingsCtrl, GoalSettingsService, modules;
	
	__webpack_require__(488);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(76);
	
	__webpack_require__(389);
	
	__webpack_require__(82);
	
	__webpack_require__(275);
	
	__webpack_require__(412);
	
	__webpack_require__(108);
	
	__webpack_require__(274);
	
	__webpack_require__(39);
	
	__webpack_require__(489);
	
	GoalSettingsCtrl = __webpack_require__(491);
	
	GoalSettingsService = __webpack_require__(492);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-auth', 'gnp-common-wrapper', 'gnp-form', 'gnp-location-tracking', 'gnp-animate', 'gnp-error-handler', 'gnp-number', 'gnp-payment', 'gnp-analyze-access'];
	
	angular.module('gnp-app-goal-settings', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/goal-settings', {
	      templateUrl: 'web/goal-settings/goal-settings.jade',
	      controller: 'GoalSettingsCtrl',
	      title: '_GOAL_SETTINGS.TITLE',
	      permission: {
	        signInRequired: true,
	        paymentRequired: true
	      }
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(493)).translations('ja', __webpack_require__(494));
	  }
	]).controller('GoalSettingsCtrl', GoalSettingsCtrl).factory('GoalSettingsService', GoalSettingsService);


/***/ }),
/* 488 */
/***/ (function(module, exports) {

	var v1="<div id=\"goal_setting-main\" gnp-common-wrapper-a=\"\"><div class=\"goal container\"><div class=\"col-12\"><div class=\"title\">{{:: '_GOAL_SETTINGS.TITLE' | translate }}</div></div><div gnp-indicator=\"isLoading\" class=\"col-12 content\"><form name=\"form\" gnp-submit=\"save()\" novalidate=\"\"><div class=\"col-12 row\"><div class=\"col-3 col-md-4 blank\"></div><div class=\"col-9 col-md-8\"><div class=\"row\"><div class=\"col-4\"><div class=\"header-label\">{{:: '_GOAL_SETTINGS.ALL_USERS_AVG_DATA' | translate }}</div></div><div class=\"col-4\"><div class=\"header-label\">{{:: '_GOAL_SETTINGS.MY_DATA' | translate }}</div></div><div class=\"col-4\"><div class=\"header-label\">{{:: '_GOAL_SETTINGS.VALUE_OF_YOUR_GOAL' | translate }}</div></div></div></div><div class=\"line\"></div></div><div class=\"col-12 row\"><div class=\"col-3 col-md-4 label-wrap\"><div class=\"label\">{{:: '_GOAL_SETTINGS.AVG_SCORE' | translate }}</div></div><div class=\"col-9 col-md-8\"><div class=\"row\"><div class=\"col-4\"><div class=\"cell1\">{{goalSettings.all_users_data.avg_total_shot | percentToFormattedString}}</div></div><div class=\"col-4\"><div class=\"cell2\">{{goalSettings.my_data.avg_total_shot | percentToFormattedString}}</div></div><div class=\"col-4\"><div class=\"cell3\"><input type=\"number\" name=\"avg_total_shot\" ng-model=\"goalSettings.goal.avg_total_shot\" required=\"\" min=\"0\" max=\"270\"/><div ng-show=\"form.avg_total_shot.$invalid &amp;&amp; !form.avg_total_shot.$pristine\" class=\"error\"><ul><li ng-show=\"form.avg_total_shot.$error.required &amp;&amp; !form.avg_total_shot.$error.number\">{{:: \"VALIDATION.REQUIRED\" | translate }}</li><li ng-show=\"form.avg_total_shot.$error.number\">{{:: \"VALIDATION.NUMERIC\" | translate }}</li><li ng-show=\"form.avg_total_shot.$error.min\">{{:: \"VALIDATION.MIN_VALUE\" | translate:'{\"n\": 0}' }}</li><li ng-show=\"form.avg_total_shot.$error.max\">{{:: \"VALIDATION.MAX_VALUE\" | translate:'{\"n\": 270}' }}</li></ul></div></div></div></div></div><div class=\"line\"></div></div><div class=\"col-12 row\"><div class=\"col-3 col-md-4 label-wrap\"><div class=\"label\">{{:: '_GOAL_SETTINGS.AVG_PUTTS' | translate }}</div></div><div class=\"col-9 col-md-8\"><div class=\"row\"><div class=\"col-4\"><div class=\"cell1\">{{goalSettings.all_users_data.avg_putt | percentToFormattedString}}</div></div><div class=\"col-4\"><div class=\"cell2\">{{goalSettings.my_data.avg_putt | percentToFormattedString}}</div></div><div class=\"col-4\"><div class=\"cell3\"><input type=\"number\" name=\"avg_putt\" ng-model=\"goalSettings.goal.avg_putt\" required=\"\" min=\"0\" max=\"15\"/><div ng-show=\"form.avg_putt.$invalid &amp;&amp; !form.avg_putt.$pristine\" class=\"error\"><ul><li ng-show=\"form.avg_putt.$error.required &amp;&amp; !form.avg_putt.$error.number\">{{:: \"VALIDATION.REQUIRED\" | translate }}</li><li ng-show=\"form.avg_putt.$error.number\">{{:: \"VALIDATION.NUMERIC\" | translate }}</li><li ng-show=\"form.avg_putt.$error.min\">{{:: \"VALIDATION.MIN_VALUE\" | translate:'{\"n\": 0}' }}</li><li ng-show=\"form.avg_putt.$error.max\">{{:: \"VALIDATION.MAX_VALUE\" | translate:'{\"n\": 15}' }}</li></ul></div></div></div></div></div><div class=\"line\"></div></div><div class=\"col-12 row\"><div class=\"col-3 col-md-4 label-wrap\"><div class=\"label\">{{:: '_GOAL_SETTINGS.FAIRWAY_HIT' | translate }}</div></div><div class=\"col-9 col-md-8\"><div class=\"row\"><div class=\"col-4\"><div class=\"cell1\">{{goalSettings.all_users_data.rat_fairway_center | percentToFormattedString}}</div></div><div class=\"col-4\"><div class=\"cell2\">{{goalSettings.my_data.rat_fairway_center | percentToFormattedString}}</div></div><div class=\"col-4\"><div class=\"cell3\"><input type=\"number\" name=\"rat_fairway_center\" ng-model=\"goalSettings.goal.rat_fairway_center\" required=\"\" min=\"0\" max=\"100\"/><div ng-show=\"form.rat_fairway_center.$invalid &amp;&amp; !form.rat_fairway_center.$pristine\" class=\"error\"><ul><li ng-show=\"form.rat_fairway_center.$error.required &amp;&amp; !form.rat_fairway_center.$error.number\">{{:: \"VALIDATION.REQUIRED\" | translate }}</li><li ng-show=\"form.rat_fairway_center.$error.number\">{{:: \"VALIDATION.NUMERIC\" | translate }}</li><li ng-show=\"form.rat_fairway_center.$error.min\">{{:: \"VALIDATION.MIN_VALUE\" | translate:'{\"n\": 0}' }}</li><li ng-show=\"form.rat_fairway_center.$error.max\">{{:: \"VALIDATION.MAX_VALUE\" | translate:'{\"n\": 100}'}}</li></ul></div></div></div></div></div><div class=\"line\"></div></div><div class=\"col-12 row\"><div class=\"col-3 col-md-4 label-wrap\"><div class=\"label\">{{:: '_GOAL_SETTINGS.GIR' | translate }}</div></div><div class=\"col-9 col-md-8\"><div class=\"row\"><div class=\"col-4\"><div class=\"cell1\">{{goalSettings.all_users_data.rat_par_on | percentToFormattedString}}</div></div><div class=\"col-4\"><div class=\"cell2\">{{goalSettings.my_data.rat_par_on | percentToFormattedString}}</div></div><div class=\"col-4\"><div class=\"cell3\"><input type=\"number\" name=\"rat_par_on\" ng-model=\"goalSettings.goal.rat_par_on\" required=\"\" min=\"0\" max=\"100\"/><div ng-show=\"form.rat_par_on.$invalid &amp;&amp; !form.rat_par_on.$pristine\" class=\"error\"><ul><li ng-show=\"form.rat_par_on.$error.required &amp;&amp; !form.rat_par_on.$error.number\">{{:: \"VALIDATION.REQUIRED\" | translate }}</li><li ng-show=\"form.rat_par_on.$error.number\">{{:: \"VALIDATION.NUMERIC\" | translate }}</li><li ng-show=\"form.rat_par_on.$error.min\">{{:: \"VALIDATION.MIN_VALUE\" | translate:'{\"n\": 0}' }}</li><li ng-show=\"form.rat_par_on.$error.max\">{{:: \"VALIDATION.MAX_VALUE\" | translate:'{\"n\": 100}'}}</li></ul></div></div></div></div></div><div class=\"line\"></div></div><div class=\"col-12 row\"><div class=\"col-3 col-md-4 label-wrap\"><div class=\"label\">{{:: '_GOAL_SETTINGS.BOGEY_ON' | translate }}</div></div><div class=\"col-9 col-md-8\"><div class=\"row\"><div class=\"col-4\"><div class=\"cell1\">{{goalSettings.all_users_data.rat_bogey_on | percentToFormattedString}}</div></div><div class=\"col-4\"><div class=\"cell2\">{{goalSettings.my_data.rat_bogey_on | percentToFormattedString}}</div></div><div class=\"col-4\"><div class=\"cell3\"><input type=\"number\" name=\"rat_bogey_on\" ng-model=\"goalSettings.goal.rat_bogey_on\" required=\"\" min=\"0\" max=\"100\"/><div ng-show=\"form.rat_bogey_on.$invalid &amp;&amp; !form.rat_bogey_on.$pristine\" class=\"error\"><ul><li ng-show=\"form.rat_bogey_on.$error.required &amp;&amp; !form.rat_bogey_on.$error.number\">{{:: \"VALIDATION.REQUIRED\" | translate }}</li><li ng-show=\"form.rat_bogey_on.$error.number\">{{:: \"VALIDATION.NUMERIC\" | translate }}</li><li ng-show=\"form.rat_bogey_on.$error.min\">{{:: \"VALIDATION.MIN_VALUE\" | translate:'{\"n\": 0}' }}</li><li ng-show=\"form.rat_bogey_on.$error.max\">{{:: \"VALIDATION.MAX_VALUE\" | translate:'{\"n\": 100}'}}</li></ul></div></div></div></div></div></div><div class=\"col-12 row\"><button type=\"submit\" gnp-submitting-button=\"isSubmitting\" analytics-on=\"click\" analytics-event=\"TGT_Saved\" class=\"btn-more\">{{:: 'SAVE' | translate }}</button><div class=\"line\"></div></div></form></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/goal-settings/goal-settings.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(490);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_goal_setting.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_goal_setting.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#goal_setting-main .cell{padding:0}#goal_setting-main ul{margin-left:-15px;color:red}#goal_setting-main .goal.container{width:970px;position:relative}#goal_setting-main .goal.container .blank{height:100px;padding:0;opacity:0}#goal_setting-main .goal.container .title{position:relative;left:50%;width:160px;height:50px;margin:50px 0 0 -80px;line-height:40px;text-align:center;font-size:24px;color:#01a5a3;border-bottom:3px solid #01a5a3}#goal_setting-main .goal.container .content{position:relative;width:100%;margin:0;padding:0;background-color:#fff}#goal_setting-main .goal.container .content .row{width:100%;margin:0;padding:0 5%}#goal_setting-main .goal.container .content .row .line{position:relative;width:100%;margin:auto;border:1px solid #e2e2e2}#goal_setting-main .goal.container .content .row .header-label{padding:40px 0 0;text-align:center;font-size:14px;word-wrap:break-word}#goal_setting-main .goal.container .content .row .label-wrap{padding-top:40px}#goal_setting-main .goal.container .content .row .label{position:relative;padding:0;color:#000;text-align:left;font-size:14px;word-wrap:break-word;font-weight:700;white-space:initial}#goal_setting-main .goal.container .content .row .cell1{color:#8d8a76;background-color:#c2c0ae;border-color:#c2c0ae}#goal_setting-main .goal.container .content .row .cell1,#goal_setting-main .goal.container .content .row .cell2{position:relative;margin:20px auto;line-height:60px;font-size:24px;text-align:center;width:100%;height:60px;border-radius:5px;border-width:2px;border-style:solid}#goal_setting-main .goal.container .content .row .cell2{color:#fff;background-color:#01a5a3;border-color:#01a5a3}#goal_setting-main .goal.container .content .row .cell3{position:relative;padding:0}#goal_setting-main .goal.container .content .row .cell3 input[type='number']{margin:20px auto;font-size:24px;display:block;color:#000;text-align:center;background-color:#fff;width:100%;height:60px;border-radius:5px;border-color:#ff1e30;border-width:2px;border-style:solid}#goal_setting-main .goal.container .content .row .cell3 .error{position:relative;padding:0;margin-top:15px;border:0;background-color:transparent;font-size:9px}#goal_setting-main .goal.container .btn-more{color:#fff;margin:50px auto;display:block;background-color:#000;width:27%;height:40px;border-radius:5px;border-color:#000;border-width:0;border-style:solid}@media (max-width:768px){#goal_setting-main .goal.container{width:100%}}@media (max-width:414px){#goal_setting-main .goal.container .content .row{padding:0 10px}#goal_setting-main .goal.container .content .row .col-4,#goal_setting-main .goal.container .content .row .col-3,#goal_setting-main .goal.container .content .row .col-9{padding:0 5px}#goal_setting-main .goal.container .content .row .header-label{padding-top:25px;line-height:unset}#goal_setting-main .goal.container .content .row .label-wrap.col-3{padding-top:40px}#goal_setting-main .goal.container .content .row .label{width:96%}#goal_setting-main .goal.container .content .row .cell1,#goal_setting-main .goal.container .content .row .cell2,#goal_setting-main .goal.container .content .row .cell3 input[type='number']{font-size:16px}}@media (max-width:320px){#goal_setting-main .goal.container .content .row .label{font-size:12px}}", ""]);

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	var GoalSettingsCtrl;
	
	GoalSettingsCtrl = function($scope, $location, $filter, flash, GoalSettingsService, LocationTrackingService, $analytics) {
	  $analytics.eventTrack('TGT_loaded');
	  $scope.isLoading = true;
	  $scope.goalSettings = {};
	  $scope.isSubmitting = false;
	  GoalSettingsService.get().then(function(data) {
	    return $scope.goalSettings = data;
	  })["finally"](function() {
	    return $scope.isLoading = false;
	  });
	  return $scope.save = function() {
	    $scope.isSubmitting = true;
	    return GoalSettingsService.save($scope.goalSettings.goal).then(function(resp) {
	      flash.success($filter('translate')('API_SUCCESS'));
	      return $location.path(LocationTrackingService.previousLocation());
	    })["catch"](function(resp) {
	      return flash.error($filter('translate')('API_ERROR'));
	    })["finally"](function() {
	      return $scope.isSubmitting = false;
	    });
	  };
	};
	
	GoalSettingsCtrl.$inject = ['$scope', '$location', '$filter', 'flash', 'GoalSettingsService', 'LocationTrackingService', '$analytics'];
	
	module.exports = GoalSettingsCtrl;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	var GoalSettingsService, _;
	
	_ = __webpack_require__(87);
	
	GoalSettingsService = function($http, $q) {
	  var calculateDefaultGoal, convertToGoalSettings, percentToRatio, ratioToPercent;
	  ratioToPercent = function(data) {
	    return _.merge({}, data, {
	      rat_fairway_center: data.rat_fairway_center ? data.rat_fairway_center * 100 : void 0,
	      rat_par_on: data.rat_par_on ? data.rat_par_on * 100 : void 0,
	      rat_bogey_on: data.rat_bogey_on ? data.rat_bogey_on * 100 : void 0
	    });
	  };
	  percentToRatio = function(data) {
	    return _.merge({}, data, {
	      rat_fairway_center: data.rat_fairway_center ? data.rat_fairway_center / 100 : void 0,
	      rat_par_on: data.rat_par_on ? data.rat_par_on / 100 : void 0,
	      rat_bogey_on: data.rat_bogey_on ? data.rat_bogey_on / 100 : void 0
	    });
	  };
	  calculateDefaultGoal = function(my_data) {
	    return {
	      avg_total_shot: my_data.avg_total_shot ? Math.round(my_data.avg_total_shot - 5) : void 0,
	      avg_putt: my_data.avg_putt ? my_data.avg_putt - 0.5 : void 0,
	      rat_fairway_center: (function() {
	        if (!my_data.rat_fairway_center) {
	          return;
	        }
	        if (my_data.rat_fairway_center + 10 > 100) {
	          return 100;
	        }
	        return my_data.rat_fairway_center + 10;
	      })(),
	      rat_par_on: (function() {
	        if (!my_data.rat_par_on) {
	          return;
	        }
	        if (my_data.rat_par_on + 10 > 100) {
	          return 100;
	        }
	        return my_data.rat_par_on + 10;
	      })(),
	      rat_bogey_on: (function() {
	        if (!my_data.rat_bogey_on) {
	          return;
	        }
	        if (my_data.rat_bogey_on + 5 > 100) {
	          return 100;
	        }
	        return my_data.rat_bogey_on + 5;
	      })()
	    };
	  };
	  convertToGoalSettings = function(settings) {
	    var all_users_data, default_goal, goal, my_data;
	    all_users_data = ratioToPercent(settings.all_users_data);
	    my_data = ratioToPercent(settings.my_data);
	    goal = ratioToPercent(settings.goal);
	    default_goal = calculateDefaultGoal(my_data);
	    goal = _.mapValues(goal, function(v, k) {
	      if (_.isNumber(v)) {
	        return Math.round(v * 100) / 100;
	      }
	      if (_.isNumber(default_goal[k])) {
	        return Math.round(default_goal[k] * 100) / 100;
	      }
	    });
	    return {
	      goal: goal,
	      my_data: my_data,
	      all_users_data: all_users_data
	    };
	  };
	  return {
	    get: function() {
	      var delay, promises;
	      delay = $q.defer();
	      promises = {
	        all_users_data: $http.get('/api/score_cards/all/analysis.json'),
	        my_data: $http.get('/api/users/me/score_cards/analysis.json'),
	        goal: $http.get('/api/settings/goal.json')
	      };
	      $q.all(promises).then(function(data) {
	        return delay.resolve(convertToGoalSettings(_.mapValues(data, 'data')));
	      });
	      return delay.promise;
	    },
	    save: function(data) {
	      return $http.put('/api/settings/goal.json', percentToRatio(data));
	    }
	  };
	};
	
	GoalSettingsService.$inject = ['$http', '$q'];
	
	module.exports = GoalSettingsService;


/***/ }),
/* 493 */
/***/ (function(module, exports) {

	module.exports = {
	  '_GOAL_SETTINGS': {
	    'TITLE': 'Goal Settings',
	    'ALL_USERS_AVG_DATA': "All User's Avg. Data",
	    'VALUE_OF_YOUR_GOAL': 'Value of Your Goal',
	    'AVG_SCORE': 'Avg. Score',
	    'AVG_PUTTS': 'Avg. Putts (per 1 hole)',
	    'FAIRWAY_HIT': 'Fairway hit (%)',
	    'GIR': 'GIR (%)',
	    'BOGEY_ON': 'GIR+1 (%)',
	    'MY_DATA': 'My Data (Entire Period)'
	  }
	};


/***/ }),
/* 494 */
/***/ (function(module, exports) {

	module.exports = {
	  '_GOAL_SETTINGS': {
	    'TITLE': '目標設定',
	    'ALL_USERS_AVG_DATA': "GOLF NETWORK PLUS 会員平均",
	    'VALUE_OF_YOUR_GOAL': '目標設定値',
	    'AVG_SCORE': '平均スコア',
	    'AVG_PUTTS': '平均パット数 (1ホール)',
	    'FAIRWAY_HIT': 'フェアウェイキープ率 (%)',
	    'GIR': 'パーオン率 (%)',
	    'BOGEY_ON': 'ボギーオン率',
	    'MY_DATA': 'MY DATA (全期間)'
	  }
	};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	var $, IndexCtrl, _, isSupportedCourse;
	
	_ = __webpack_require__(87);
	
	$ = __webpack_require__(1);
	
	isSupportedCourse = function(course) {
	  if (!course) {
	    return true;
	  }
	  if (course.club.ext_type === "yourgolf2") {
	    return true;
	  }
	  return false;
	};
	
	IndexCtrl = function($scope, AnalysisService, goalSettings, $analytics, $routeParams, $filter, userInfo) {
	  var callMyAnalysis, createMyAnalysisParams, createViewModel;
	  $analytics.eventTrack('ANL_loaded');
	  createViewModel = function() {
	    return AnalysisService.convertScoreCards($scope.scorecards, {
	      startDate: $scope.startDate,
	      endDate: $scope.endDate,
	      course: $scope.course,
	      roundType: $scope.roundType
	    });
	  };
	  createMyAnalysisParams = function(course, roundType) {
	    return {
	      from: $scope.startDate,
	      to: $scope.endDate,
	      course: course != null ? course.course : void 0,
	      round_type: roundType
	    };
	  };
	  callMyAnalysis = function(course, roundType) {
	    var params;
	    params = createMyAnalysisParams(course, roundType);
	    $scope.isLoadingDetailedAnalysis = true;
	    return AnalysisService.getMyAnalysis(params).then(function(myAnalysis) {
	      return $scope.$broadcast("myAnalysisUpdated.gnp.analysis", myAnalysis);
	    })["finally"](function() {
	      return $scope.isLoadingDetailedAnalysis = false;
	    });
	  };
	  $scope.activeDisplay = function(tab) {
	    $scope.tab = tab;
	    if ($scope.tab === 1) {
	      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.GOAL');
	      return $scope.classTitle = "goal";
	    } else if ($scope.tab === 2) {
	      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.MY_AVG');
	      return $scope.classTitle = "avg";
	    } else if ($scope.tab === 3) {
	      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.BEST_SCORE');
	      return $scope.classTitle = "best";
	    } else if ($scope.tab === 4) {
	      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.WORST_SCORE');
	      return $scope.classTitle = "worst";
	    }
	  };
	  $scope.disableCourseStats = false;
	  if ($routeParams.user_id !== void 0) {
	    $scope.hideNoResultMsg = true;
	  }
	  $scope.course = void 0;
	  $scope.roundType = [0.5, 1, 1.5];
	  $scope.goalSettings = goalSettings;
	  $scope.scorecards = [];
	  $scope.startDate = void 0;
	  $scope.endDate = void 0;
	  $scope.isShowDetailedAnalysis = true;
	  $scope.isLoadingScoreCards = true;
	  $scope.isLoadingDetailedAnalysis = true;
	  $scope.isLoadingMap = true;
	  $scope.showNoResultMsg = false;
	  $scope.hideHeader = false;
	  $scope.classTitle = "avg";
	  $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.MY_AVG');
	  $scope.userInfo = userInfo;
	  $('#map_canvas').on('touchstart click dblclick touchmove touchend wheel mousewheel DOMMouseScroll', function(e) {
	    e.preventDefault();
	  });
	  $('body').bind('touchmove', function(e) {
	    e.preventDefault();
	  });
	  if ($routeParams.hide_header === '1') {
	    $scope.hideHeader = true;
	    $scope.disableCourseStats = true;
	  }
	  $scope.$on("mapLoaded.gnp.analysis", function() {
	    return $scope.isLoadingMap = false;
	  });
	  $scope.$on("courseChanged.gnp.analysis", function(event, course) {
	    var viewModel;
	    $scope.course = course;
	    viewModel = createViewModel();
	    $scope.$broadcast("filteredScorecardsUpdated.gnp.analysis", viewModel.filteredScorecards);
	    $scope.$broadcast("selectedCourseUpdated.gnp.analysis", course);
	    $scope.isShowDetailedAnalysis = false;
	    if (!isSupportedCourse(course)) {
	      return;
	    }
	    $scope.isShowDetailedAnalysis = true;
	    return callMyAnalysis(course, $scope.roundType);
	  });
	  $scope.$on("periodSelected.gnp.analysis", function(event, startDate, endDate, roundType) {
	    var viewModel;
	    $scope.startDate = startDate != null ? startDate.clone() : void 0;
	    $scope.endDate = endDate != null ? endDate.clone() : void 0;
	    $scope.roundType = roundType;
	    viewModel = createViewModel();
	    $scope.$broadcast("coursesUpdated.gnp.analysis", viewModel.courses);
	    $scope.$broadcast("clubsUpdated.gnp.analysis", viewModel.clubs);
	    return $scope.$broadcast("filteredScorecardsUpdated.gnp.analysis", viewModel.filteredScorecards);
	  });
	  $scope.$on("roundTypeUpdated.gnp.analysis", function(event, roundType) {
	    var viewModel;
	    $scope.roundType = roundType;
	    viewModel = createViewModel();
	    callMyAnalysis($scope.course, roundType);
	    $scope.$broadcast("coursesUpdated.gnp.analysis", viewModel.courses);
	    $scope.$broadcast("clubsUpdated.gnp.analysis", viewModel.clubs);
	    return $scope.$broadcast("filteredScorecardsUpdated.gnp.analysis", viewModel.filteredScorecards);
	  });
	  return AnalysisService.getScoreCards().then(function(res) {
	    $scope.scorecards = res.data.score_cards;
	    $scope.showNoResultMsg = $scope.scorecards.length === 0;
	    return $scope.$emit("periodSelected.gnp.analysis", $scope.startDate, $scope.endDate);
	  })["finally"](function() {
	    return $scope.isLoadingScoreCards = false;
	  });
	};
	
	IndexCtrl.$inject = ['$scope', 'AnalysisService', 'goalSettings', '$analytics', '$routeParams', '$filter', 'userInfo'];
	
	module.exports = IndexCtrl;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	var PeriodFilterCtrl, _, moment,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	PeriodFilterCtrl = (function() {
	  function PeriodFilterCtrl($scope, $filter) {
	    var endDate, label, ref, roundType, startDate;
	    this.$scope = $scope;
	    this.$filter = $filter;
	    this._publishChange = bind(this._publishChange, this);
	    this.user_id = (ref = this.$scope.userInfo) != null ? ref.user_id : void 0;
	    startDate = localStorage.getItem(this.user_id + "_FILTER_PERIOD_START_DATE");
	    endDate = localStorage.getItem(this.user_id + "_FILTER_PERIOD_END_DATE");
	    this.startDate = startDate != null ? moment(startDate) : moment().subtract(10, 'years');
	    this.endDate = endDate != null ? moment(endDate) : moment().endOf('year');
	    label = localStorage.getItem(this.user_id + "_FILTER_PERIOD_SELECTED_LABEL");
	    if (label === this.$filter('translate')('_ANALYSIS.PERIOD_FILTER.ENTIRE_PERIOD')) {
	      this.endDate = moment().endOf('year');
	    }
	    this.$scope.$watch(((function(_this) {
	      return function() {
	        return _this.startDate + _this.endDate;
	      };
	    })(this)), this._publishChange);
	    roundType = localStorage.getItem(this.user_id + "_FILTER_roundType");
	    this.$scope.roundType = roundType != null ? JSON.parse(roundType) : [1, 1.5];
	    this.$scope.isInclude15 = JSON.parse(localStorage.getItem(this.user_id + "_FILTER_isInclude15"));
	    this.$scope.isInclude05 = JSON.parse(localStorage.getItem(this.user_id + "_FILTER_isInclude05"));
	    if (this.$scope.isInclude15 == null) {
	      this.$scope.isInclude15 = true;
	      localStorage.setItem(this.user_id + "_FILTER_isInclude15", JSON.stringify(true));
	    }
	    if (this.$scope.isInclude05 == null) {
	      this.$scope.isInclude05 = false;
	      this.$scope.roundType = _.filter(this.$scope.roundType, function(type) {
	        return type !== 0.5;
	      });
	      localStorage.setItem(this.user_id + "_FILTER_isInclude05", JSON.stringify(false));
	    }
	    this.handleRoundType15();
	    this.handleRoundType05();
	    this.$scope.clickInclude15 = (function(_this) {
	      return function(isInclude15) {
	        _this.$scope.isInclude15 = isInclude15;
	        localStorage.setItem(_this.user_id + "_FILTER_isInclude15", JSON.stringify(isInclude15));
	        _this.handleRoundType15();
	        _this.$scope.$emit("roundTypeUpdated.gnp.analysis", _this.$scope.roundType.sort());
	        return localStorage.setItem(_this.user_id + "_FILTER_roundType", JSON.stringify(_this.$scope.roundType.sort()));
	      };
	    })(this);
	    this.$scope.clickInclude05 = (function(_this) {
	      return function(isInclude05) {
	        _this.$scope.isInclude05 = isInclude05;
	        localStorage.setItem(_this.user_id + "_FILTER_isInclude05", JSON.stringify(isInclude05));
	        _this.handleRoundType05();
	        _this.$scope.$emit("roundTypeUpdated.gnp.analysis", _this.$scope.roundType.sort());
	        return localStorage.setItem(_this.user_id + "_FILTER_roundType", JSON.stringify(_this.$scope.roundType.sort()));
	      };
	    })(this);
	  }
	
	  PeriodFilterCtrl.prototype.handleRoundType15 = function() {
	    if (this.$scope.isInclude15) {
	      if (indexOf.call(this.$scope.roundType, 1.5) < 0) {
	        return this.$scope.roundType.push(1.5);
	      }
	    } else {
	      return this.$scope.roundType = _.filter(this.$scope.roundType, function(type) {
	        return type !== 1.5;
	      });
	    }
	  };
	
	  PeriodFilterCtrl.prototype.handleRoundType05 = function() {
	    if (this.$scope.isInclude05) {
	      if (indexOf.call(this.$scope.roundType, 0.5) < 0) {
	        return this.$scope.roundType.push(0.5);
	      }
	    } else {
	      return this.$scope.roundType = _.filter(this.$scope.roundType, function(type) {
	        return type !== 0.5;
	      });
	    }
	  };
	
	  PeriodFilterCtrl.prototype._publishChange = function() {
	    localStorage.setItem(this.user_id + "_FILTER_PERIOD_START_DATE", this.startDate);
	    localStorage.setItem(this.user_id + "_FILTER_PERIOD_END_DATE", this.endDate);
	    return this.$scope.$emit("periodSelected.gnp.analysis", this.startDate, this.endDate, this.$scope.roundType.sort());
	  };
	
	  return PeriodFilterCtrl;
	
	})();
	
	PeriodFilterCtrl.$inject = ['$scope', '$filter'];
	
	module.exports = PeriodFilterCtrl;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	var ClubFilterCtrl, _,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	_ = __webpack_require__(87);
	
	ClubFilterCtrl = (function() {
	  function ClubFilterCtrl($scope, GoogleMapLoaderService) {
	    this.$scope = $scope;
	    this.GoogleMapLoaderService = GoogleMapLoaderService;
	    this._renderNewMarkers = bind(this._renderNewMarkers, this);
	    this._clubs = [];
	    this._markers = [];
	    this._mostPlayedClub = void 0;
	    this._cachedLocation = void 0;
	    this.GoogleMapLoaderService.load().then((function(_this) {
	      return function() {
	        _this.$scope.$emit('mapLoaded.gnp.analysis');
	        return _this.mapOptions = {
	          center: new google.maps.LatLng(0, 0),
	          zoom: 2,
	          mapTypeId: google.maps.MapTypeId.ROADMAP
	        };
	      };
	    })(this));
	    this.$scope.$on("clubsUpdated.gnp.analysis", (function(_this) {
	      return function(event, clubs) {
	        _this._clearMap();
	        _this._clubs = clubs;
	        _this._mostPlayedClub = _this._findMostPlayedClub();
	        return _this._renderNewMarkers();
	      };
	    })(this));
	    this.$scope.$on("selectedCourseUpdated.gnp.analysis", (function(_this) {
	      return function(event, scorecard) {
	        if (!scorecard) {
	          return;
	        }
	        if (_this.myMap) {
	          return _this.myMap.panTo((function(func, args, ctor) {
	            ctor.prototype = func.prototype;
	            var child = new ctor, result = func.apply(child, args);
	            return Object(result) === result ? result : child;
	          })(google.maps.LatLng, scorecard.club.loc, function(){}));
	        } else {
	          return _this._cachedLocation = scorecard.club.loc;
	        }
	      };
	    })(this));
	    this.$scope.$watch(((function(_this) {
	      return function() {
	        return _this.myMap;
	      };
	    })(this)), this._renderNewMarkers);
	  }
	
	  ClubFilterCtrl.prototype.adjustMarkers = function() {
	    this._clearMap();
	    return this._addMarkers();
	  };
	
	  ClubFilterCtrl.prototype._findMostPlayedClub = function() {
	    return _.maxBy(this._clubs, 'count') || {};
	  };
	
	  ClubFilterCtrl.prototype._addMarkers = function() {
	    return _.forEach(this._clubs, (function(_this) {
	      return function(club) {
	        return _this._setMarker(club);
	      };
	    })(this));
	  };
	
	  ClubFilterCtrl.prototype._renderNewMarkers = function() {
	    var loc, ref;
	    loc = this._cachedLocation || ((ref = this._mostPlayedClub) != null ? ref.loc : void 0);
	    if (!(this.myMap && loc)) {
	      return;
	    }
	    this._addMarkers();
	    this.myMap.panTo((function(func, args, ctor) {
	      ctor.prototype = func.prototype;
	      var child = new ctor, result = func.apply(child, args);
	      return Object(result) === result ? result : child;
	    })(google.maps.LatLng, loc, function(){}));
	    return this.myMap.setZoom(15);
	  };
	
	  ClubFilterCtrl.prototype._clearMap = function() {
	    _.forEach(this._markers, function(m) {
	      return m.setMap(null);
	    });
	    return this._markers = [];
	  };
	
	  ClubFilterCtrl.prototype._setMarker = function(club) {
	    var div, fontSize, marker, maximumSize, pos, size, sizePerRound;
	    pos = new google.maps.LatLng(club.loc[0], club.loc[1]);
	    maximumSize = (80 * this.myMap.getZoom()) / 15;
	    fontSize = (18 * this.myMap.getZoom()) / 15;
	    sizePerRound = maximumSize / this._mostPlayedClub.count;
	    size = (club.count.toString().length + 1) * 12;
	    size = size + "px";
	    div = document.createElement('DIV');
	    div.className = "circle";
	    div.style.cssText = "width:" + size + ";height:" + size + ";font-size:" + fontSize + "px;line-height:" + size;
	    div.innerHTML = club.count;
	    marker = new RichMarker({
	      id: club.id,
	      map: this.myMap,
	      position: pos,
	      draggable: false,
	      flat: true,
	      anchor: RichMarkerPosition.MIDDLE,
	      content: div
	    });
	    return this._markers.push(marker);
	  };
	
	  return ClubFilterCtrl;
	
	})();
	
	ClubFilterCtrl.$inject = ['$scope', 'GoogleMapLoaderService'];
	
	module.exports = ClubFilterCtrl;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	var CourseFilterCtrl, _;
	
	_ = __webpack_require__(87);
	
	CourseFilterCtrl = (function() {
	  CourseFilterCtrl.prototype.selectedCourse = void 0;
	
	  function CourseFilterCtrl($scope) {
	    this.$scope = $scope;
	    this.$scope.$on("coursesUpdated.gnp.analysis", (function(_this) {
	      return function(event, courses) {
	        var cachedCourse;
	        _this.courses = courses;
	        cachedCourse = localStorage.getItem("ANALYSIS_SELECTED_COURSE");
	        if (!(cachedCourse && cachedCourse !== 'undefined')) {
	          _this._refreshSelectedCourse();
	          return _this.$scope.$emit('courseChanged.gnp.analysis', _this.selectedCourse);
	        }
	      };
	    })(this));
	    this.$scope.$watch(((function(_this) {
	      return function() {
	        return _this.courses;
	      };
	    })(this)), (function(_this) {
	      return function(courses) {
	        var cachedCourse;
	        cachedCourse = localStorage.getItem("ANALYSIS_SELECTED_COURSE");
	        if (cachedCourse && cachedCourse !== 'undefined') {
	          _this.selectedCourse = _.find(courses, function(c) {
	            return c.id === cachedCourse;
	          });
	          if (_this.selectedCourse) {
	            return _this.$scope.$emit('courseChanged.gnp.analysis', _this.selectedCourse);
	          }
	        }
	      };
	    })(this));
	  }
	
	  CourseFilterCtrl.prototype._refreshSelectedCourse = function() {
	    if (!this.selectedCourse) {
	      return;
	    }
	    return this.selectedCourse = _.find(this.courses, (function(_this) {
	      return function(c) {
	        return c.course.ext_id === _this.selectedCourse.course.ext_id;
	      };
	    })(this));
	  };
	
	  CourseFilterCtrl.prototype.selectCourse = function(course) {
	    if (!this.$scope.$root.paid) {
	      return;
	    }
	    this.selectedCourse = this.selectedCourse === course ? void 0 : course;
	    if (course) {
	      localStorage.setItem("ANALYSIS_SELECTED_COURSE", course.id);
	    }
	    return this.$scope.$emit('courseChanged.gnp.analysis', this.selectedCourse);
	  };
	
	  return CourseFilterCtrl;
	
	})();
	
	CourseFilterCtrl.$inject = ['$scope'];
	
	module.exports = CourseFilterCtrl;


/***/ }),
/* 499 */
/***/ (function(module, exports) {

	var BasicAnalysisCtrl;
	
	BasicAnalysisCtrl = (function() {
	  function BasicAnalysisCtrl($scope, ScoreCardAPIService, $routeParams) {
	    var params;
	    this.$scope = $scope;
	    this.basicAnalysisData = {
	      goal: this.$scope.$parent.goalSettings,
	      my_avg: void 0,
	      all_members: void 0
	    };
	    params = {
	      user_id: $routeParams.user_id
	    };
	    ScoreCardAPIService.getAllMembers(params).then((function(_this) {
	      return function(data) {
	        return _this.basicAnalysisData.all_members = data;
	      };
	    })(this));
	    this.$scope.$on("myAnalysisUpdated.gnp.analysis", (function(_this) {
	      return function(event, myAnalysis) {
	        return _this.basicAnalysisData.my_avg = myAnalysis.my_avg;
	      };
	    })(this));
	  }
	
	  return BasicAnalysisCtrl;
	
	})();
	
	BasicAnalysisCtrl.$inject = ['$scope', 'ScoreCardAPIService', '$routeParams'];
	
	module.exports = BasicAnalysisCtrl;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	var AnalysisService, _, moment,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	AnalysisService = function($http, $q, ScoreCardAPIService, $routeParams, cache) {
	  var id;
	  id = $routeParams.user_id;
	  if ($routeParams.user_id === void 0) {
	    id = "me";
	  }
	  return {
	    getScoreCards: function() {
	      return $http.get("/api/users/" + id + "/score_cards.json");
	    },
	    getMyAnalysis: function(options) {
	      var cacheParams, cachedMyAnalysis, defer, params, promises, ref, ref1;
	      if (options == null) {
	        options = {};
	      }
	      params = _.pickBy({
	        from: (options.from ? options.from.utc().toISOString() : void 0),
	        to: (options.to ? options.to.utc().toISOString() : void 0),
	        course_id: (ref = options.course) != null ? ref.ext_id : void 0,
	        round_type: (ref1 = options.round_type) != null ? ref1.join(',') : void 0
	      }, function(v) {
	        return v !== null && v !== void 0;
	      });
	      cacheParams = JSON.stringify(params);
	      cachedMyAnalysis = cache.get(cacheParams);
	      defer = $q.defer();
	      if (cachedMyAnalysis) {
	        defer.resolve(cachedMyAnalysis);
	      } else {
	        promises = {
	          best_worst: ScoreCardAPIService.getBestWorst(id, params),
	          my_avg: ScoreCardAPIService.getMyAvg(id, params)
	        };
	        $q.all(promises).then(function(result) {
	          var myAnalysis;
	          myAnalysis = {
	            my_avg: result.my_avg.data,
	            best_score: result.best_worst.data.best_score,
	            worst_score: result.best_worst.data.worst_score
	          };
	          cache.put(cacheParams, myAnalysis);
	          return defer.resolve(myAnalysis);
	        });
	      }
	      return defer.promise;
	    },
	    convertScoreCards: function(scorecards, options) {
	      var clubs, courses, filterByRoundType, filteredByTime, filteredScorecards, hasSelectedCourse;
	      if (options == null) {
	        options = {};
	      }
	      _.defaults(options, {
	        endDate: moment(),
	        startDate: moment().subtract(1, 'years')
	      });
	      filteredByTime = _.chain(scorecards).map(function(sc) {
	        return _.merge({}, sc, {
	          play_date: moment(sc.play_date)
	        });
	      }).filter(function(sc) {
	        var ref;
	        return (options.startDate <= (ref = sc.play_date) && ref <= options.endDate.endOf('day'));
	      });
	      filterByRoundType = filteredByTime.filter(function(sc) {
	        var ref;
	        if (!options.roundType) {
	          return true;
	        }
	        return ref = sc.round_type, indexOf.call(options.roundType, ref) >= 0;
	      });
	      clubs = filterByRoundType.groupBy(function(sc) {
	        return sc.club.ext_type + "-" + sc.club.ext_id;
	      }).map(function(score_cards, key) {
	        var sc;
	        sc = score_cards[0];
	        return {
	          id: key,
	          loc: sc.club.loc,
	          count: score_cards.length
	        };
	      }).value();
	      courses = filterByRoundType.groupBy(function(sc) {
	        return sc.club.ext_type + "-" + sc.club.ext_id + "-" + sc.course.ext_id;
	      }).map(function(score_cards, key) {
	        var sc;
	        sc = score_cards[0];
	        return {
	          id: key,
	          club: sc.club,
	          course: sc.course,
	          count: score_cards.length
	        };
	      }).sortBy(function(course) {
	        return -course.count;
	      }).value();
	      hasSelectedCourse = filterByRoundType.some(function(sc) {
	        if (!options.course) {
	          return false;
	        }
	        return sc.course.ext_id === options.course.course.ext_id;
	      }).value();
	      filteredScorecards = filterByRoundType.filter(function(sc) {
	        if (!options.course) {
	          return true;
	        }
	        if (!hasSelectedCourse) {
	          return true;
	        }
	        return sc.course.ext_id === options.course.course.ext_id;
	      }).sortBy(function(sc) {
	        return sc.play_date;
	      }).map(function(sc) {
	        return _.pick(sc, 'id', 'play_date', 'total_shot_all_holes', 'total_putt_all_holes', 'course', 'club', 'round_type');
	      }).value();
	      return {
	        clubs: clubs,
	        courses: courses,
	        filteredScorecards: filteredScorecards
	      };
	    }
	  };
	};
	
	AnalysisService.$inject = ['$http', '$q', 'ScoreCardAPIService', '$routeParams', 'cache'];
	
	module.exports = AnalysisService;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	var DateRangePickerDirective, moment;
	
	__webpack_require__(502);
	
	moment = __webpack_require__(126);
	
	__webpack_require__(503);
	
	DateRangePickerDirective = function($filter) {
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "analysis/period-filter/daterangepicker.jade",
	    scope: {
	      start: '=start',
	      end: '=end',
	      user_id: '=user'
	    },
	    link: function(scope, elem) {
	      var currentYear, label, ranges;
	      label = localStorage.getItem(scope.user_id + "_FILTER_PERIOD_SELECTED_LABEL");
	      scope.label = label != null ? label : $filter('translate')('_ANALYSIS.PERIOD_FILTER.ENTIRE_PERIOD');
	      currentYear = (new Date()).getFullYear();
	      ranges = {};
	      ranges[$filter('translate')('_ANALYSIS.PERIOD_FILTER.ENTIRE_PERIOD')] = [moment().subtract(10, 'years'), moment().endOf('year')];
	      ranges[" " + currentYear] = [moment().startOf('year'), moment().endOf('year')];
	      ranges[" " + (currentYear - 1)] = [moment().subtract(1, 'years').startOf('year'), moment().subtract(1, 'years').endOf('year')];
	      ranges[$filter('translate')('_ANALYSIS.PERIOD_FILTER.LAST_3_MONTHS')] = [moment().subtract(3, "months"), moment()];
	      ranges[$filter('translate')('_ANALYSIS.PERIOD_FILTER.LAST_6_MONTHS')] = [moment().subtract(6, "months"), moment()];
	      return elem.daterangepicker({
	        format: "YYYY-MM-DD",
	        startDate: scope.start,
	        endDate: scope.end,
	        ranges: ranges,
	        applyButtonClasses: 'btn-success',
	        showDropdowns: true,
	        minYear: 2008,
	        maxYear: currentYear + 1,
	        locale: {
	          applyLabel: $filter('translate')('_ANALYSIS.PERIOD_FILTER.APPLY_LABEL'),
	          cancelLabel: $filter('translate')('_ANALYSIS.PERIOD_FILTER.CANCEL_LABEL'),
	          customRangeLabel: $filter('translate')('_ANALYSIS.PERIOD_FILTER.CUSTOM_RANGE_LABEL')
	        }
	      }, function(start, end, label) {
	        return scope.$apply(function() {
	          scope.start = start;
	          scope.end = end;
	          scope.label = label;
	          return localStorage.setItem(scope.user_id + "_FILTER_PERIOD_SELECTED_LABEL", label);
	        });
	      });
	    }
	  };
	};
	
	DateRangePickerDirective.$inject = ["$filter"];
	
	module.exports = DateRangePickerDirective;


/***/ }),
/* 502 */
/***/ (function(module, exports) {

	var v1="<div ng-if=\"label == ('_ANALYSIS.PERIOD_FILTER.CUSTOM_RANGE_LABEL' | translate)\"><div class=\"d-none d-sm-block\"><div class=\"show-period\">{{start.format(\"YYYY/MM/DD\")}} ~ {{end.format(\"YYYY/MM/DD\")}}</div></div><div class=\"d-block d-sm-none\"><div class=\"show-date-only\"><span>{{start.format(\"YYYY/MM/DD\")}} ~</span><br/><span>{{end.format(\"YYYY/MM/DD\")}}</span></div></div></div><div ng-if=\"label != ('_ANALYSIS.PERIOD_FILTER.CUSTOM_RANGE_LABEL' | translate)\"><div class=\"show-period\">{{label}}</div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/period-filter/daterangepicker.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(504);
	__webpack_require__(505);

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	* @version: 3.0.5
	* @author: Dan Grossman http://www.dangrossman.info/
	* @copyright: Copyright (c) 2012-2019 Dan Grossman. All rights reserved.
	* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
	* @website: http://www.daterangepicker.com/
	*/
	// Following the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
	(function (root, factory) {
	    if (true) {
	        // AMD. Make globaly available as well
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(126), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (moment, jquery) {
	            if (!jquery.fn) jquery.fn = {}; // webpack server rendering
	            if (typeof moment !== 'function' && moment.default) moment = moment.default
	            return factory(moment, jquery);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        // Node / Browserify
	        //isomorphic issue
	        var jQuery = (typeof window != 'undefined') ? window.jQuery : undefined;
	        if (!jQuery) {
	            jQuery = require('jquery');
	            if (!jQuery.fn) jQuery.fn = {};
	        }
	        var moment = (typeof window != 'undefined' && typeof window.moment != 'undefined') ? window.moment : require('moment');
	        module.exports = factory(moment, jQuery);
	    } else {
	        // Browser globals
	        root.daterangepicker = factory(root.moment, root.jQuery);
	    }
	}(this, function(moment, $) {
	    var DateRangePicker = function(element, options, cb) {
	
	        //default settings for options
	        this.parentEl = 'body';
	        this.element = $(element);
	        this.startDate = moment().startOf('day');
	        this.endDate = moment().endOf('day');
	        this.minDate = false;
	        this.maxDate = false;
	        this.maxSpan = false;
	        this.autoApply = false;
	        this.singleDatePicker = false;
	        this.showDropdowns = false;
	        this.minYear = moment().subtract(100, 'year').format('YYYY');
	        this.maxYear = moment().add(100, 'year').format('YYYY');
	        this.showWeekNumbers = false;
	        this.showISOWeekNumbers = false;
	        this.showCustomRangeLabel = true;
	        this.timePicker = false;
	        this.timePicker24Hour = false;
	        this.timePickerIncrement = 1;
	        this.timePickerSeconds = false;
	        this.linkedCalendars = true;
	        this.autoUpdateInput = true;
	        this.alwaysShowCalendars = false;
	        this.ranges = {};
	
	        this.opens = 'right';
	        if (this.element.hasClass('pull-right'))
	            this.opens = 'left';
	
	        this.drops = 'down';
	        if (this.element.hasClass('dropup'))
	            this.drops = 'up';
	
	        this.buttonClasses = 'btn btn-sm';
	        this.applyButtonClasses = 'btn-primary';
	        this.cancelButtonClasses = 'btn-default';
	
	        this.locale = {
	            direction: 'ltr',
	            format: moment.localeData().longDateFormat('L'),
	            separator: ' - ',
	            applyLabel: 'Apply',
	            cancelLabel: 'Cancel',
	            weekLabel: 'W',
	            customRangeLabel: 'Custom Range',
	            daysOfWeek: moment.weekdaysMin(),
	            monthNames: moment.monthsShort(),
	            firstDay: moment.localeData().firstDayOfWeek()
	        };
	
	        this.callback = function() { };
	
	        //some state information
	        this.isShowing = false;
	        this.leftCalendar = {};
	        this.rightCalendar = {};
	
	        //custom options from user
	        if (typeof options !== 'object' || options === null)
	            options = {};
	
	        //allow setting options with data attributes
	        //data-api options will be overwritten with custom javascript options
	        options = $.extend(this.element.data(), options);
	
	        //html template for the picker UI
	        if (typeof options.template !== 'string' && !(options.template instanceof $))
	            options.template =
	            '<div class="daterangepicker">' +
	                '<div class="ranges"></div>' +
	                '<div class="drp-calendar left">' +
	                    '<div class="calendar-table"></div>' +
	                    '<div class="calendar-time"></div>' +
	                '</div>' +
	                '<div class="drp-calendar right">' +
	                    '<div class="calendar-table"></div>' +
	                    '<div class="calendar-time"></div>' +
	                '</div>' +
	                '<div class="drp-buttons">' +
	                    '<span class="drp-selected"></span>' +
	                    '<button class="cancelBtn" type="button"></button>' +
	                    '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
	                '</div>' +
	            '</div>';
	
	        this.parentEl = (options.parentEl && $(options.parentEl).length) ? $(options.parentEl) : $(this.parentEl);
	        this.container = $(options.template).appendTo(this.parentEl);
	
	        //
	        // handle all the possible options overriding defaults
	        //
	
	        if (typeof options.locale === 'object') {
	
	            if (typeof options.locale.direction === 'string')
	                this.locale.direction = options.locale.direction;
	
	            if (typeof options.locale.format === 'string')
	                this.locale.format = options.locale.format;
	
	            if (typeof options.locale.separator === 'string')
	                this.locale.separator = options.locale.separator;
	
	            if (typeof options.locale.daysOfWeek === 'object')
	                this.locale.daysOfWeek = options.locale.daysOfWeek.slice();
	
	            if (typeof options.locale.monthNames === 'object')
	              this.locale.monthNames = options.locale.monthNames.slice();
	
	            if (typeof options.locale.firstDay === 'number')
	              this.locale.firstDay = options.locale.firstDay;
	
	            if (typeof options.locale.applyLabel === 'string')
	              this.locale.applyLabel = options.locale.applyLabel;
	
	            if (typeof options.locale.cancelLabel === 'string')
	              this.locale.cancelLabel = options.locale.cancelLabel;
	
	            if (typeof options.locale.weekLabel === 'string')
	              this.locale.weekLabel = options.locale.weekLabel;
	
	            if (typeof options.locale.customRangeLabel === 'string'){
	                //Support unicode chars in the custom range name.
	                var elem = document.createElement('textarea');
	                elem.innerHTML = options.locale.customRangeLabel;
	                var rangeHtml = elem.value;
	                this.locale.customRangeLabel = rangeHtml;
	            }
	        }
	        this.container.addClass(this.locale.direction);
	
	        if (typeof options.startDate === 'string')
	            this.startDate = moment(options.startDate, this.locale.format);
	
	        if (typeof options.endDate === 'string')
	            this.endDate = moment(options.endDate, this.locale.format);
	
	        if (typeof options.minDate === 'string')
	            this.minDate = moment(options.minDate, this.locale.format);
	
	        if (typeof options.maxDate === 'string')
	            this.maxDate = moment(options.maxDate, this.locale.format);
	
	        if (typeof options.startDate === 'object')
	            this.startDate = moment(options.startDate);
	
	        if (typeof options.endDate === 'object')
	            this.endDate = moment(options.endDate);
	
	        if (typeof options.minDate === 'object')
	            this.minDate = moment(options.minDate);
	
	        if (typeof options.maxDate === 'object')
	            this.maxDate = moment(options.maxDate);
	
	        // sanity check for bad options
	        if (this.minDate && this.startDate.isBefore(this.minDate))
	            this.startDate = this.minDate.clone();
	
	        // sanity check for bad options
	        if (this.maxDate && this.endDate.isAfter(this.maxDate))
	            this.endDate = this.maxDate.clone();
	
	        if (typeof options.applyButtonClasses === 'string')
	            this.applyButtonClasses = options.applyButtonClasses;
	
	        if (typeof options.applyClass === 'string') //backwards compat
	            this.applyButtonClasses = options.applyClass;
	
	        if (typeof options.cancelButtonClasses === 'string')
	            this.cancelButtonClasses = options.cancelButtonClasses;
	
	        if (typeof options.cancelClass === 'string') //backwards compat
	            this.cancelButtonClasses = options.cancelClass;
	
	        if (typeof options.maxSpan === 'object')
	            this.maxSpan = options.maxSpan;
	
	        if (typeof options.dateLimit === 'object') //backwards compat
	            this.maxSpan = options.dateLimit;
	
	        if (typeof options.opens === 'string')
	            this.opens = options.opens;
	
	        if (typeof options.drops === 'string')
	            this.drops = options.drops;
	
	        if (typeof options.showWeekNumbers === 'boolean')
	            this.showWeekNumbers = options.showWeekNumbers;
	
	        if (typeof options.showISOWeekNumbers === 'boolean')
	            this.showISOWeekNumbers = options.showISOWeekNumbers;
	
	        if (typeof options.buttonClasses === 'string')
	            this.buttonClasses = options.buttonClasses;
	
	        if (typeof options.buttonClasses === 'object')
	            this.buttonClasses = options.buttonClasses.join(' ');
	
	        if (typeof options.showDropdowns === 'boolean')
	            this.showDropdowns = options.showDropdowns;
	
	        if (typeof options.minYear === 'number')
	            this.minYear = options.minYear;
	
	        if (typeof options.maxYear === 'number')
	            this.maxYear = options.maxYear;
	
	        if (typeof options.showCustomRangeLabel === 'boolean')
	            this.showCustomRangeLabel = options.showCustomRangeLabel;
	
	        if (typeof options.singleDatePicker === 'boolean') {
	            this.singleDatePicker = options.singleDatePicker;
	            if (this.singleDatePicker)
	                this.endDate = this.startDate.clone();
	        }
	
	        if (typeof options.timePicker === 'boolean')
	            this.timePicker = options.timePicker;
	
	        if (typeof options.timePickerSeconds === 'boolean')
	            this.timePickerSeconds = options.timePickerSeconds;
	
	        if (typeof options.timePickerIncrement === 'number')
	            this.timePickerIncrement = options.timePickerIncrement;
	
	        if (typeof options.timePicker24Hour === 'boolean')
	            this.timePicker24Hour = options.timePicker24Hour;
	
	        if (typeof options.autoApply === 'boolean')
	            this.autoApply = options.autoApply;
	
	        if (typeof options.autoUpdateInput === 'boolean')
	            this.autoUpdateInput = options.autoUpdateInput;
	
	        if (typeof options.linkedCalendars === 'boolean')
	            this.linkedCalendars = options.linkedCalendars;
	
	        if (typeof options.isInvalidDate === 'function')
	            this.isInvalidDate = options.isInvalidDate;
	
	        if (typeof options.isCustomDate === 'function')
	            this.isCustomDate = options.isCustomDate;
	
	        if (typeof options.alwaysShowCalendars === 'boolean')
	            this.alwaysShowCalendars = options.alwaysShowCalendars;
	
	        // update day names order to firstDay
	        if (this.locale.firstDay != 0) {
	            var iterator = this.locale.firstDay;
	            while (iterator > 0) {
	                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
	                iterator--;
	            }
	        }
	
	        var start, end, range;
	
	        //if no start/end dates set, check if an input element contains initial values
	        if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
	            if ($(this.element).is(':text')) {
	                var val = $(this.element).val(),
	                    split = val.split(this.locale.separator);
	
	                start = end = null;
	
	                if (split.length == 2) {
	                    start = moment(split[0], this.locale.format);
	                    end = moment(split[1], this.locale.format);
	                } else if (this.singleDatePicker && val !== "") {
	                    start = moment(val, this.locale.format);
	                    end = moment(val, this.locale.format);
	                }
	                if (start !== null && end !== null) {
	                    this.setStartDate(start);
	                    this.setEndDate(end);
	                }
	            }
	        }
	
	        if (typeof options.ranges === 'object') {
	            for (range in options.ranges) {
	
	                if (typeof options.ranges[range][0] === 'string')
	                    start = moment(options.ranges[range][0], this.locale.format);
	                else
	                    start = moment(options.ranges[range][0]);
	
	                if (typeof options.ranges[range][1] === 'string')
	                    end = moment(options.ranges[range][1], this.locale.format);
	                else
	                    end = moment(options.ranges[range][1]);
	
	                // If the start or end date exceed those allowed by the minDate or maxSpan
	                // options, shorten the range to the allowable period.
	                if (this.minDate && start.isBefore(this.minDate))
	                    start = this.minDate.clone();
	
	                var maxDate = this.maxDate;
	                if (this.maxSpan && maxDate && start.clone().add(this.maxSpan).isAfter(maxDate))
	                    maxDate = start.clone().add(this.maxSpan);
	                if (maxDate && end.isAfter(maxDate))
	                    end = maxDate.clone();
	
	                // If the end of the range is before the minimum or the start of the range is
	                // after the maximum, don't display this range option at all.
	                if ((this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day'))
	                  || (maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')))
	                    continue;
	
	                //Support unicode chars in the range names.
	                var elem = document.createElement('textarea');
	                elem.innerHTML = range;
	                var rangeHtml = elem.value;
	
	                this.ranges[rangeHtml] = [start, end];
	            }
	
	            var list = '<ul>';
	            for (range in this.ranges) {
	                list += '<li data-range-key="' + range + '">' + range + '</li>';
	            }
	            if (this.showCustomRangeLabel) {
	                list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
	            }
	            list += '</ul>';
	            this.container.find('.ranges').prepend(list);
	        }
	
	        if (typeof cb === 'function') {
	            this.callback = cb;
	        }
	
	        if (!this.timePicker) {
	            this.startDate = this.startDate.startOf('day');
	            this.endDate = this.endDate.endOf('day');
	            this.container.find('.calendar-time').hide();
	        }
	
	        //can't be used together for now
	        if (this.timePicker && this.autoApply)
	            this.autoApply = false;
	
	        if (this.autoApply) {
	            this.container.addClass('auto-apply');
	        }
	
	        if (typeof options.ranges === 'object')
	            this.container.addClass('show-ranges');
	
	        if (this.singleDatePicker) {
	            this.container.addClass('single');
	            this.container.find('.drp-calendar.left').addClass('single');
	            this.container.find('.drp-calendar.left').show();
	            this.container.find('.drp-calendar.right').hide();
	            if (!this.timePicker) {
	                this.container.addClass('auto-apply');
	            }
	        }
	
	        if ((typeof options.ranges === 'undefined' && !this.singleDatePicker) || this.alwaysShowCalendars) {
	            this.container.addClass('show-calendar');
	        }
	
	        this.container.addClass('opens' + this.opens);
	
	        //apply CSS classes and labels to buttons
	        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
	        if (this.applyButtonClasses.length)
	            this.container.find('.applyBtn').addClass(this.applyButtonClasses);
	        if (this.cancelButtonClasses.length)
	            this.container.find('.cancelBtn').addClass(this.cancelButtonClasses);
	        this.container.find('.applyBtn').html(this.locale.applyLabel);
	        this.container.find('.cancelBtn').html(this.locale.cancelLabel);
	
	        //
	        // event listeners
	        //
	
	        this.container.find('.drp-calendar')
	            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
	            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
	            .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
	            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
	            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
	            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
	            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this))
	
	        this.container.find('.ranges')
	            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this))
	
	        this.container.find('.drp-buttons')
	            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
	            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this))
	
	        if (this.element.is('input') || this.element.is('button')) {
	            this.element.on({
	                'click.daterangepicker': $.proxy(this.show, this),
	                'focus.daterangepicker': $.proxy(this.show, this),
	                'keyup.daterangepicker': $.proxy(this.elementChanged, this),
	                'keydown.daterangepicker': $.proxy(this.keydown, this) //IE 11 compatibility
	            });
	        } else {
	            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
	            this.element.on('keydown.daterangepicker', $.proxy(this.toggle, this));
	        }
	
	        //
	        // if attached to a text input, set the initial value
	        //
	
	        this.updateElement();
	
	    };
	
	    DateRangePicker.prototype = {
	
	        constructor: DateRangePicker,
	
	        setStartDate: function(startDate) {
	            if (typeof startDate === 'string')
	                this.startDate = moment(startDate, this.locale.format);
	
	            if (typeof startDate === 'object')
	                this.startDate = moment(startDate);
	
	            if (!this.timePicker)
	                this.startDate = this.startDate.startOf('day');
	
	            if (this.timePicker && this.timePickerIncrement)
	                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	
	            if (this.minDate && this.startDate.isBefore(this.minDate)) {
	                this.startDate = this.minDate.clone();
	                if (this.timePicker && this.timePickerIncrement)
	                    this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	            }
	
	            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
	                this.startDate = this.maxDate.clone();
	                if (this.timePicker && this.timePickerIncrement)
	                    this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	            }
	
	            if (!this.isShowing)
	                this.updateElement();
	
	            this.updateMonthsInView();
	        },
	
	        setEndDate: function(endDate) {
	            if (typeof endDate === 'string')
	                this.endDate = moment(endDate, this.locale.format);
	
	            if (typeof endDate === 'object')
	                this.endDate = moment(endDate);
	
	            if (!this.timePicker)
	                this.endDate = this.endDate.endOf('day');
	
	            if (this.timePicker && this.timePickerIncrement)
	                this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	
	            if (this.endDate.isBefore(this.startDate))
	                this.endDate = this.startDate.clone();
	
	            if (this.maxDate && this.endDate.isAfter(this.maxDate))
	                this.endDate = this.maxDate.clone();
	
	            if (this.maxSpan && this.startDate.clone().add(this.maxSpan).isBefore(this.endDate))
	                this.endDate = this.startDate.clone().add(this.maxSpan);
	
	            this.previousRightTime = this.endDate.clone();
	
	            this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
	
	            if (!this.isShowing)
	                this.updateElement();
	
	            this.updateMonthsInView();
	        },
	
	        isInvalidDate: function() {
	            return false;
	        },
	
	        isCustomDate: function() {
	            return false;
	        },
	
	        updateView: function() {
	            if (this.timePicker) {
	                this.renderTimePicker('left');
	                this.renderTimePicker('right');
	                if (!this.endDate) {
	                    this.container.find('.right .calendar-time select').attr('disabled', 'disabled').addClass('disabled');
	                } else {
	                    this.container.find('.right .calendar-time select').removeAttr('disabled').removeClass('disabled');
	                }
	            }
	            if (this.endDate)
	                this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
	            this.updateMonthsInView();
	            this.updateCalendars();
	            this.updateFormInputs();
	        },
	
	        updateMonthsInView: function() {
	            if (this.endDate) {
	
	                //if both dates are visible already, do nothing
	                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
	                    (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
	                    &&
	                    (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
	                    ) {
	                    return;
	                }
	
	                this.leftCalendar.month = this.startDate.clone().date(2);
	                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
	                    this.rightCalendar.month = this.endDate.clone().date(2);
	                } else {
	                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
	                }
	
	            } else {
	                if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
	                    this.leftCalendar.month = this.startDate.clone().date(2);
	                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
	                }
	            }
	            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
	              this.rightCalendar.month = this.maxDate.clone().date(2);
	              this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
	            }
	        },
	
	        updateCalendars: function() {
	
	            if (this.timePicker) {
	                var hour, minute, second;
	                if (this.endDate) {
	                    hour = parseInt(this.container.find('.left .hourselect').val(), 10);
	                    minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
	                    if (isNaN(minute)) {
	                        minute = parseInt(this.container.find('.left .minuteselect option:last').val(), 10);
	                    }
	                    second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.left .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                } else {
	                    hour = parseInt(this.container.find('.right .hourselect').val(), 10);
	                    minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
	                    if (isNaN(minute)) {
	                        minute = parseInt(this.container.find('.right .minuteselect option:last').val(), 10);
	                    }
	                    second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.right .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                }
	                this.leftCalendar.month.hour(hour).minute(minute).second(second);
	                this.rightCalendar.month.hour(hour).minute(minute).second(second);
	            }
	
	            this.renderCalendar('left');
	            this.renderCalendar('right');
	
	            //highlight any predefined range matching the current start and end dates
	            this.container.find('.ranges li').removeClass('active');
	            if (this.endDate == null) return;
	
	            this.calculateChosenLabel();
	        },
	
	        renderCalendar: function(side) {
	
	            //
	            // Build the matrix of dates that will populate the calendar
	            //
	
	            var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
	            var month = calendar.month.month();
	            var year = calendar.month.year();
	            var hour = calendar.month.hour();
	            var minute = calendar.month.minute();
	            var second = calendar.month.second();
	            var daysInMonth = moment([year, month]).daysInMonth();
	            var firstDay = moment([year, month, 1]);
	            var lastDay = moment([year, month, daysInMonth]);
	            var lastMonth = moment(firstDay).subtract(1, 'month').month();
	            var lastYear = moment(firstDay).subtract(1, 'month').year();
	            var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
	            var dayOfWeek = firstDay.day();
	
	            //initialize a 6 rows x 7 columns array for the calendar
	            var calendar = [];
	            calendar.firstDay = firstDay;
	            calendar.lastDay = lastDay;
	
	            for (var i = 0; i < 6; i++) {
	                calendar[i] = [];
	            }
	
	            //populate the calendar with date objects
	            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
	            if (startDay > daysInLastMonth)
	                startDay -= 7;
	
	            if (dayOfWeek == this.locale.firstDay)
	                startDay = daysInLastMonth - 6;
	
	            var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);
	
	            var col, row;
	            for (var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
	                if (i > 0 && col % 7 === 0) {
	                    col = 0;
	                    row++;
	                }
	                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
	                curDate.hour(12);
	
	                if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') {
	                    calendar[row][col] = this.minDate.clone();
	                }
	
	                if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') {
	                    calendar[row][col] = this.maxDate.clone();
	                }
	
	            }
	
	            //make the calendar object available to hoverDate/clickDate
	            if (side == 'left') {
	                this.leftCalendar.calendar = calendar;
	            } else {
	                this.rightCalendar.calendar = calendar;
	            }
	
	            //
	            // Display the calendar
	            //
	
	            var minDate = side == 'left' ? this.minDate : this.startDate;
	            var maxDate = this.maxDate;
	            var selected = side == 'left' ? this.startDate : this.endDate;
	            var arrow = this.locale.direction == 'ltr' ? {left: 'chevron-left', right: 'chevron-right'} : {left: 'chevron-right', right: 'chevron-left'};
	
	            var html = '<table class="table-condensed">';
	            html += '<thead>';
	            html += '<tr>';
	
	            // add empty cell for week number
	            if (this.showWeekNumbers || this.showISOWeekNumbers)
	                html += '<th></th>';
	
	            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) {
	                html += '<th class="prev available"><span></span></th>';
	            } else {
	                html += '<th></th>';
	            }
	
	            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");
	
	            if (this.showDropdowns) {
	                var currentMonth = calendar[1][1].month();
	                var currentYear = calendar[1][1].year();
	                var maxYear = (maxDate && maxDate.year()) || (this.maxYear);
	                var minYear = (minDate && minDate.year()) || (this.minYear);
	                var inMinYear = currentYear == minYear;
	                var inMaxYear = currentYear == maxYear;
	
	                var monthHtml = '<select class="monthselect">';
	                for (var m = 0; m < 12; m++) {
	                    if ((!inMinYear || (minDate && m >= minDate.month())) && (!inMaxYear || (maxDate && m <= maxDate.month()))) {
	                        monthHtml += "<option value='" + m + "'" +
	                            (m === currentMonth ? " selected='selected'" : "") +
	                            ">" + this.locale.monthNames[m] + "</option>";
	                    } else {
	                        monthHtml += "<option value='" + m + "'" +
	                            (m === currentMonth ? " selected='selected'" : "") +
	                            " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
	                    }
	                }
	                monthHtml += "</select>";
	
	                var yearHtml = '<select class="yearselect">';
	                for (var y = minYear; y <= maxYear; y++) {
	                    yearHtml += '<option value="' + y + '"' +
	                        (y === currentYear ? ' selected="selected"' : '') +
	                        '>' + y + '</option>';
	                }
	                yearHtml += '</select>';
	
	                dateHtml = monthHtml + yearHtml;
	            }
	
	            html += '<th colspan="5" class="month">' + dateHtml + '</th>';
	            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) {
	                html += '<th class="next available"><span></span></th>';
	            } else {
	                html += '<th></th>';
	            }
	
	            html += '</tr>';
	            html += '<tr>';
	
	            // add week number label
	            if (this.showWeekNumbers || this.showISOWeekNumbers)
	                html += '<th class="week">' + this.locale.weekLabel + '</th>';
	
	            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
	                html += '<th>' + dayOfWeek + '</th>';
	            });
	
	            html += '</tr>';
	            html += '</thead>';
	            html += '<tbody>';
	
	            //adjust maxDate to reflect the maxSpan setting in order to
	            //grey out end dates beyond the maxSpan
	            if (this.endDate == null && this.maxSpan) {
	                var maxLimit = this.startDate.clone().add(this.maxSpan).endOf('day');
	                if (!maxDate || maxLimit.isBefore(maxDate)) {
	                    maxDate = maxLimit;
	                }
	            }
	
	            for (var row = 0; row < 6; row++) {
	                html += '<tr>';
	
	                // add week number
	                if (this.showWeekNumbers)
	                    html += '<td class="week">' + calendar[row][0].week() + '</td>';
	                else if (this.showISOWeekNumbers)
	                    html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';
	
	                for (var col = 0; col < 7; col++) {
	
	                    var classes = [];
	
	                    //highlight today's date
	                    if (calendar[row][col].isSame(new Date(), "day"))
	                        classes.push('today');
	
	                    //highlight weekends
	                    if (calendar[row][col].isoWeekday() > 5)
	                        classes.push('weekend');
	
	                    //grey out the dates in other months displayed at beginning and end of this calendar
	                    if (calendar[row][col].month() != calendar[1][1].month())
	                        classes.push('off', 'ends');
	
	                    //don't allow selection of dates before the minimum date
	                    if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
	                        classes.push('off', 'disabled');
	
	                    //don't allow selection of dates after the maximum date
	                    if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
	                        classes.push('off', 'disabled');
	
	                    //don't allow selection of date if a custom function decides it's invalid
	                    if (this.isInvalidDate(calendar[row][col]))
	                        classes.push('off', 'disabled');
	
	                    //highlight the currently selected start date
	                    if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD'))
	                        classes.push('active', 'start-date');
	
	                    //highlight the currently selected end date
	                    if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD'))
	                        classes.push('active', 'end-date');
	
	                    //highlight dates in-between the selected dates
	                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
	                        classes.push('in-range');
	
	                    //apply custom classes for this date
	                    var isCustom = this.isCustomDate(calendar[row][col]);
	                    if (isCustom !== false) {
	                        if (typeof isCustom === 'string')
	                            classes.push(isCustom);
	                        else
	                            Array.prototype.push.apply(classes, isCustom);
	                    }
	
	                    var cname = '', disabled = false;
	                    for (var i = 0; i < classes.length; i++) {
	                        cname += classes[i] + ' ';
	                        if (classes[i] == 'disabled')
	                            disabled = true;
	                    }
	                    if (!disabled)
	                        cname += 'available';
	
	                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';
	
	                }
	                html += '</tr>';
	            }
	
	            html += '</tbody>';
	            html += '</table>';
	
	            this.container.find('.drp-calendar.' + side + ' .calendar-table').html(html);
	
	        },
	
	        renderTimePicker: function(side) {
	
	            // Don't bother updating the time picker if it's currently disabled
	            // because an end date hasn't been clicked yet
	            if (side == 'right' && !this.endDate) return;
	
	            var html, selected, minDate, maxDate = this.maxDate;
	
	            if (this.maxSpan && (!this.maxDate || this.startDate.clone().add(this.maxSpan).isBefore(this.maxDate)))
	                maxDate = this.startDate.clone().add(this.maxSpan);
	
	            if (side == 'left') {
	                selected = this.startDate.clone();
	                minDate = this.minDate;
	            } else if (side == 'right') {
	                selected = this.endDate.clone();
	                minDate = this.startDate;
	
	                //Preserve the time already selected
	                var timeSelector = this.container.find('.drp-calendar.right .calendar-time');
	                if (timeSelector.html() != '') {
	
	                    selected.hour(!isNaN(selected.hour()) ? selected.hour() : timeSelector.find('.hourselect option:selected').val());
	                    selected.minute(!isNaN(selected.minute()) ? selected.minute() : timeSelector.find('.minuteselect option:selected').val());
	                    selected.second(!isNaN(selected.second()) ? selected.second() : timeSelector.find('.secondselect option:selected').val());
	
	                    if (!this.timePicker24Hour) {
	                        var ampm = timeSelector.find('.ampmselect option:selected').val();
	                        if (ampm === 'PM' && selected.hour() < 12)
	                            selected.hour(selected.hour() + 12);
	                        if (ampm === 'AM' && selected.hour() === 12)
	                            selected.hour(0);
	                    }
	
	                }
	
	                if (selected.isBefore(this.startDate))
	                    selected = this.startDate.clone();
	
	                if (maxDate && selected.isAfter(maxDate))
	                    selected = maxDate.clone();
	
	            }
	
	            //
	            // hours
	            //
	
	            html = '<select class="hourselect">';
	
	            var start = this.timePicker24Hour ? 0 : 1;
	            var end = this.timePicker24Hour ? 23 : 12;
	
	            for (var i = start; i <= end; i++) {
	                var i_in_24 = i;
	                if (!this.timePicker24Hour)
	                    i_in_24 = selected.hour() >= 12 ? (i == 12 ? 12 : i + 12) : (i == 12 ? 0 : i);
	
	                var time = selected.clone().hour(i_in_24);
	                var disabled = false;
	                if (minDate && time.minute(59).isBefore(minDate))
	                    disabled = true;
	                if (maxDate && time.minute(0).isAfter(maxDate))
	                    disabled = true;
	
	                if (i_in_24 == selected.hour() && !disabled) {
	                    html += '<option value="' + i + '" selected="selected">' + i + '</option>';
	                } else if (disabled) {
	                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
	                } else {
	                    html += '<option value="' + i + '">' + i + '</option>';
	                }
	            }
	
	            html += '</select> ';
	
	            //
	            // minutes
	            //
	
	            html += ': <select class="minuteselect">';
	
	            for (var i = 0; i < 60; i += this.timePickerIncrement) {
	                var padded = i < 10 ? '0' + i : i;
	                var time = selected.clone().minute(i);
	
	                var disabled = false;
	                if (minDate && time.second(59).isBefore(minDate))
	                    disabled = true;
	                if (maxDate && time.second(0).isAfter(maxDate))
	                    disabled = true;
	
	                if (selected.minute() == i && !disabled) {
	                    html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
	                } else if (disabled) {
	                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
	                } else {
	                    html += '<option value="' + i + '">' + padded + '</option>';
	                }
	            }
	
	            html += '</select> ';
	
	            //
	            // seconds
	            //
	
	            if (this.timePickerSeconds) {
	                html += ': <select class="secondselect">';
	
	                for (var i = 0; i < 60; i++) {
	                    var padded = i < 10 ? '0' + i : i;
	                    var time = selected.clone().second(i);
	
	                    var disabled = false;
	                    if (minDate && time.isBefore(minDate))
	                        disabled = true;
	                    if (maxDate && time.isAfter(maxDate))
	                        disabled = true;
	
	                    if (selected.second() == i && !disabled) {
	                        html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
	                    } else if (disabled) {
	                        html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
	                    } else {
	                        html += '<option value="' + i + '">' + padded + '</option>';
	                    }
	                }
	
	                html += '</select> ';
	            }
	
	            //
	            // AM/PM
	            //
	
	            if (!this.timePicker24Hour) {
	                html += '<select class="ampmselect">';
	
	                var am_html = '';
	                var pm_html = '';
	
	                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate))
	                    am_html = ' disabled="disabled" class="disabled"';
	
	                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate))
	                    pm_html = ' disabled="disabled" class="disabled"';
	
	                if (selected.hour() >= 12) {
	                    html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
	                } else {
	                    html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
	                }
	
	                html += '</select>';
	            }
	
	            this.container.find('.drp-calendar.' + side + ' .calendar-time').html(html);
	
	        },
	
	        updateFormInputs: function() {
	
	            if (this.singleDatePicker || (this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)))) {
	                this.container.find('button.applyBtn').removeAttr('disabled');
	            } else {
	                this.container.find('button.applyBtn').attr('disabled', 'disabled');
	            }
	
	        },
	
	        move: function() {
	            var parentOffset = { top: 0, left: 0 },
	                containerTop;
	            var parentRightEdge = $(window).width();
	            if (!this.parentEl.is('body')) {
	                parentOffset = {
	                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
	                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
	                };
	                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
	            }
	
	            if (this.drops == 'up')
	                containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
	            else
	                containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
	
	            // Force the container to it's actual width
	            this.container.css({
	              top: 0,
	              left: 0,
	              right: 'auto'
	            });
	            var containerWidth = this.container.outerWidth();
	
	            this.container[this.drops == 'up' ? 'addClass' : 'removeClass']('drop-up');
	
	            if (this.opens == 'left') {
	                var containerRight = parentRightEdge - this.element.offset().left - this.element.outerWidth();
	                if (containerWidth + containerRight > $(window).width()) {
	                    this.container.css({
	                        top: containerTop,
	                        right: 'auto',
	                        left: 9
	                    });
	                } else {
	                    this.container.css({
	                        top: containerTop,
	                        right: containerRight,
	                        left: 'auto'
	                    });
	                }
	            } else if (this.opens == 'center') {
	                var containerLeft = this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2
	                                        - containerWidth / 2;
	                if (containerLeft < 0) {
	                    this.container.css({
	                        top: containerTop,
	                        right: 'auto',
	                        left: 9
	                    });
	                } else if (containerLeft + containerWidth > $(window).width()) {
	                    this.container.css({
	                        top: containerTop,
	                        left: 'auto',
	                        right: 0
	                    });
	                } else {
	                    this.container.css({
	                        top: containerTop,
	                        left: containerLeft,
	                        right: 'auto'
	                    });
	                }
	            } else {
	                var containerLeft = this.element.offset().left - parentOffset.left;
	                if (containerLeft + containerWidth > $(window).width()) {
	                    this.container.css({
	                        top: containerTop,
	                        left: 'auto',
	                        right: 0
	                    });
	                } else {
	                    this.container.css({
	                        top: containerTop,
	                        left: containerLeft,
	                        right: 'auto'
	                    });
	                }
	            }
	        },
	
	        show: function(e) {
	            if (this.isShowing) return;
	
	            // Create a click proxy that is private to this instance of datepicker, for unbinding
	            this._outsideClickProxy = $.proxy(function(e) { this.outsideClick(e); }, this);
	
	            // Bind global datepicker mousedown for hiding and
	            $(document)
	              .on('mousedown.daterangepicker', this._outsideClickProxy)
	              // also support mobile devices
	              .on('touchend.daterangepicker', this._outsideClickProxy)
	              // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
	              .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
	              // and also close when focus changes to outside the picker (eg. tabbing between controls)
	              .on('focusin.daterangepicker', this._outsideClickProxy);
	
	            // Reposition the picker if the window is resized while it's open
	            $(window).on('resize.daterangepicker', $.proxy(function(e) { this.move(e); }, this));
	
	            this.oldStartDate = this.startDate.clone();
	            this.oldEndDate = this.endDate.clone();
	            this.previousRightTime = this.endDate.clone();
	
	            this.updateView();
	            this.container.show();
	            this.move();
	            this.element.trigger('show.daterangepicker', this);
	            this.isShowing = true;
	        },
	
	        hide: function(e) {
	            if (!this.isShowing) return;
	
	            //incomplete date selection, revert to last values
	            if (!this.endDate) {
	                this.startDate = this.oldStartDate.clone();
	                this.endDate = this.oldEndDate.clone();
	            }
	
	            //if a new date range was selected, invoke the user callback function
	            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
	                this.callback(this.startDate.clone(), this.endDate.clone(), this.chosenLabel);
	
	            //if picker is attached to a text input, update it
	            this.updateElement();
	
	            $(document).off('.daterangepicker');
	            $(window).off('.daterangepicker');
	            this.container.hide();
	            this.element.trigger('hide.daterangepicker', this);
	            this.isShowing = false;
	        },
	
	        toggle: function(e) {
	            if (this.isShowing) {
	                this.hide();
	            } else {
	                this.show();
	            }
	        },
	
	        outsideClick: function(e) {
	            var target = $(e.target);
	            // if the page is clicked anywhere except within the daterangerpicker/button
	            // itself then call this.hide()
	            if (
	                // ie modal dialog fix
	                e.type == "focusin" ||
	                target.closest(this.element).length ||
	                target.closest(this.container).length ||
	                target.closest('.calendar-table').length
	                ) return;
	            this.hide();
	            this.element.trigger('outsideClick.daterangepicker', this);
	        },
	
	        showCalendars: function() {
	            this.container.addClass('show-calendar');
	            this.move();
	            this.element.trigger('showCalendar.daterangepicker', this);
	        },
	
	        hideCalendars: function() {
	            this.container.removeClass('show-calendar');
	            this.element.trigger('hideCalendar.daterangepicker', this);
	        },
	
	        clickRange: function(e) {
	            var label = e.target.getAttribute('data-range-key');
	            this.chosenLabel = label;
	            if (label == this.locale.customRangeLabel) {
	                this.showCalendars();
	            } else {
	                var dates = this.ranges[label];
	                this.startDate = dates[0];
	                this.endDate = dates[1];
	
	                if (!this.timePicker) {
	                    this.startDate.startOf('day');
	                    this.endDate.endOf('day');
	                }
	
	                if (!this.alwaysShowCalendars)
	                    this.hideCalendars();
	                this.clickApply();
	            }
	        },
	
	        clickPrev: function(e) {
	            var cal = $(e.target).parents('.drp-calendar');
	            if (cal.hasClass('left')) {
	                this.leftCalendar.month.subtract(1, 'month');
	                if (this.linkedCalendars)
	                    this.rightCalendar.month.subtract(1, 'month');
	            } else {
	                this.rightCalendar.month.subtract(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        clickNext: function(e) {
	            var cal = $(e.target).parents('.drp-calendar');
	            if (cal.hasClass('left')) {
	                this.leftCalendar.month.add(1, 'month');
	            } else {
	                this.rightCalendar.month.add(1, 'month');
	                if (this.linkedCalendars)
	                    this.leftCalendar.month.add(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        hoverDate: function(e) {
	
	            //ignore dates that can't be selected
	            if (!$(e.target).hasClass('available')) return;
	
	            var title = $(e.target).attr('data-title');
	            var row = title.substr(1, 1);
	            var col = title.substr(3, 1);
	            var cal = $(e.target).parents('.drp-calendar');
	            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
	
	            //highlight the dates between the start date and the date being hovered as a potential end date
	            var leftCalendar = this.leftCalendar;
	            var rightCalendar = this.rightCalendar;
	            var startDate = this.startDate;
	            if (!this.endDate) {
	                this.container.find('.drp-calendar tbody td').each(function(index, el) {
	
	                    //skip week numbers, only look at dates
	                    if ($(el).hasClass('week')) return;
	
	                    var title = $(el).attr('data-title');
	                    var row = title.substr(1, 1);
	                    var col = title.substr(3, 1);
	                    var cal = $(el).parents('.drp-calendar');
	                    var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];
	
	                    if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
	                        $(el).addClass('in-range');
	                    } else {
	                        $(el).removeClass('in-range');
	                    }
	
	                });
	            }
	
	        },
	
	        clickDate: function(e) {
	
	            if (!$(e.target).hasClass('available')) return;
	
	            var title = $(e.target).attr('data-title');
	            var row = title.substr(1, 1);
	            var col = title.substr(3, 1);
	            var cal = $(e.target).parents('.drp-calendar');
	            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
	
	            //
	            // this function needs to do a few things:
	            // * alternate between selecting a start and end date for the range,
	            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
	            // * if autoapply is enabled, and an end date was chosen, apply the selection
	            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
	            // * if one of the inputs above the calendars was focused, cancel that manual input
	            //
	
	            if (this.endDate || date.isBefore(this.startDate, 'day')) { //picking start
	                if (this.timePicker) {
	                    var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.left .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                    var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
	                    if (isNaN(minute)) {
	                        minute = parseInt(this.container.find('.left .minuteselect option:last').val(), 10);
	                    }
	                    var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
	                    date = date.clone().hour(hour).minute(minute).second(second);
	                }
	                this.endDate = null;
	                this.setStartDate(date.clone());
	            } else if (!this.endDate && date.isBefore(this.startDate)) {
	                //special case: clicking the same date for start/end,
	                //but the time of the end date is before the start date
	                this.setEndDate(this.startDate.clone());
	            } else { // picking end
	                if (this.timePicker) {
	                    var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.right .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                    var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
	                    if (isNaN(minute)) {
	                        minute = parseInt(this.container.find('.right .minuteselect option:last').val(), 10);
	                    }
	                    var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
	                    date = date.clone().hour(hour).minute(minute).second(second);
	                }
	                this.setEndDate(date.clone());
	                if (this.autoApply) {
	                  this.calculateChosenLabel();
	                  this.clickApply();
	                }
	            }
	
	            if (this.singleDatePicker) {
	                this.setEndDate(this.startDate);
	                if (!this.timePicker)
	                    this.clickApply();
	            }
	
	            this.updateView();
	
	            //This is to cancel the blur event handler if the mouse was in one of the inputs
	            e.stopPropagation();
	
	        },
	
	        calculateChosenLabel: function () {
	            var customRange = true;
	            var i = 0;
	            for (var range in this.ranges) {
	              if (this.timePicker) {
	                    var format = this.timePickerSeconds ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";
	                    //ignore times when comparing dates if time picker seconds is not enabled
	                    if (this.startDate.format(format) == this.ranges[range][0].format(format) && this.endDate.format(format) == this.ranges[range][1].format(format)) {
	                        customRange = false;
	                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
	                        break;
	                    }
	                } else {
	                    //ignore times when comparing dates if time picker is not enabled
	                    if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
	                        customRange = false;
	                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
	                        break;
	                    }
	                }
	                i++;
	            }
	            if (customRange) {
	                if (this.showCustomRangeLabel) {
	                    this.chosenLabel = this.container.find('.ranges li:last').addClass('active').attr('data-range-key');
	                } else {
	                    this.chosenLabel = null;
	                }
	                this.showCalendars();
	            }
	        },
	
	        clickApply: function(e) {
	            this.hide();
	            this.element.trigger('apply.daterangepicker', this);
	        },
	
	        clickCancel: function(e) {
	            this.startDate = this.oldStartDate;
	            this.endDate = this.oldEndDate;
	            this.hide();
	            this.element.trigger('cancel.daterangepicker', this);
	        },
	
	        monthOrYearChanged: function(e) {
	            var isLeft = $(e.target).closest('.drp-calendar').hasClass('left'),
	                leftOrRight = isLeft ? 'left' : 'right',
	                cal = this.container.find('.drp-calendar.'+leftOrRight);
	
	            // Month must be Number for new moment versions
	            var month = parseInt(cal.find('.monthselect').val(), 10);
	            var year = cal.find('.yearselect').val();
	
	            if (!isLeft) {
	                if (year < this.startDate.year() || (year == this.startDate.year() && month < this.startDate.month())) {
	                    month = this.startDate.month();
	                    year = this.startDate.year();
	                }
	            }
	
	            if (this.minDate) {
	                if (year < this.minDate.year() || (year == this.minDate.year() && month < this.minDate.month())) {
	                    month = this.minDate.month();
	                    year = this.minDate.year();
	                }
	            }
	
	            if (this.maxDate) {
	                if (year > this.maxDate.year() || (year == this.maxDate.year() && month > this.maxDate.month())) {
	                    month = this.maxDate.month();
	                    year = this.maxDate.year();
	                }
	            }
	
	            if (isLeft) {
	                this.leftCalendar.month.month(month).year(year);
	                if (this.linkedCalendars)
	                    this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
	            } else {
	                this.rightCalendar.month.month(month).year(year);
	                if (this.linkedCalendars)
	                    this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        timeChanged: function(e) {
	
	            var cal = $(e.target).closest('.drp-calendar'),
	                isLeft = cal.hasClass('left');
	
	            var hour = parseInt(cal.find('.hourselect').val(), 10);
	            var minute = parseInt(cal.find('.minuteselect').val(), 10);
	            if (isNaN(minute)) {
	                minute = parseInt(cal.find('.minuteselect option:last').val(), 10);
	            }
	            var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;
	
	            if (!this.timePicker24Hour) {
	                var ampm = cal.find('.ampmselect').val();
	                if (ampm === 'PM' && hour < 12)
	                    hour += 12;
	                if (ampm === 'AM' && hour === 12)
	                    hour = 0;
	            }
	
	            if (isLeft) {
	                var start = this.startDate.clone();
	                start.hour(hour);
	                start.minute(minute);
	                start.second(second);
	                this.setStartDate(start);
	                if (this.singleDatePicker) {
	                    this.endDate = this.startDate.clone();
	                } else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
	                    this.setEndDate(start.clone());
	                }
	            } else if (this.endDate) {
	                var end = this.endDate.clone();
	                end.hour(hour);
	                end.minute(minute);
	                end.second(second);
	                this.setEndDate(end);
	            }
	
	            //update the calendars so all clickable dates reflect the new time component
	            this.updateCalendars();
	
	            //update the form inputs above the calendars with the new time
	            this.updateFormInputs();
	
	            //re-render the time pickers because changing one selection can affect what's enabled in another
	            this.renderTimePicker('left');
	            this.renderTimePicker('right');
	
	        },
	
	        elementChanged: function() {
	            if (!this.element.is('input')) return;
	            if (!this.element.val().length) return;
	
	            var dateString = this.element.val().split(this.locale.separator),
	                start = null,
	                end = null;
	
	            if (dateString.length === 2) {
	                start = moment(dateString[0], this.locale.format);
	                end = moment(dateString[1], this.locale.format);
	            }
	
	            if (this.singleDatePicker || start === null || end === null) {
	                start = moment(this.element.val(), this.locale.format);
	                end = start;
	            }
	
	            if (!start.isValid() || !end.isValid()) return;
	
	            this.setStartDate(start);
	            this.setEndDate(end);
	            this.updateView();
	        },
	
	        keydown: function(e) {
	            //hide on tab or enter
	            if ((e.keyCode === 9) || (e.keyCode === 13)) {
	                this.hide();
	            }
	
	            //hide on esc and prevent propagation
	            if (e.keyCode === 27) {
	                e.preventDefault();
	                e.stopPropagation();
	
	                this.hide();
	            }
	        },
	
	        updateElement: function() {
	            if (this.element.is('input') && this.autoUpdateInput) {
	                var newValue = this.startDate.format(this.locale.format);
	                if (!this.singleDatePicker) {
	                    newValue += this.locale.separator + this.endDate.format(this.locale.format);
	                }
	                if (newValue !== this.element.val()) {
	                    this.element.val(newValue).trigger('change');
	                }
	            }
	        },
	
	        remove: function() {
	            this.container.remove();
	            this.element.off('.daterangepicker');
	            this.element.removeData();
	        }
	
	    };
	
	    $.fn.daterangepicker = function(options, callback) {
	        var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
	        this.each(function() {
	            var el = $(this);
	            if (el.data('daterangepicker'))
	                el.data('daterangepicker').remove();
	            el.data('daterangepicker', new DateRangePicker(el, implementOptions, callback));
	        });
	        return this;
	    };
	
	    return DateRangePicker;
	
	}));


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(506);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/bower_components/bootstrap-daterangepicker/daterangepicker.css", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/bower_components/bootstrap-daterangepicker/daterangepicker.css");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".daterangepicker{position:absolute;color:inherit;background-color:#fff;border-radius:4px;border:1px solid #ddd;width:278px;max-width:none;padding:0;margin-top:7px;top:100px;left:20px;z-index:3001;display:none;font-family:arial;font-size:15px;line-height:1em}.daterangepicker:before,.daterangepicker:after{position:absolute;display:inline-block;border-bottom-color:rgba(0,0,0,.2);content:''}.daterangepicker:before{top:-7px;border-right:7px solid transparent;border-left:7px solid transparent;border-bottom:7px solid #ccc}.daterangepicker:after{top:-6px;border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent}.daterangepicker.opensleft:before{right:9px}.daterangepicker.opensleft:after{right:10px}.daterangepicker.openscenter:before,.daterangepicker.openscenter:after{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.daterangepicker.opensright:before{left:9px}.daterangepicker.opensright:after{left:10px}.daterangepicker.drop-up{margin-top:-7px}.daterangepicker.drop-up:before{top:initial;bottom:-7px;border-bottom:initial;border-top:7px solid #ccc}.daterangepicker.drop-up:after{top:initial;bottom:-6px;border-bottom:initial;border-top:6px solid #fff}.daterangepicker.single .daterangepicker .ranges,.daterangepicker.single .drp-calendar{float:none}.daterangepicker.single .drp-selected{display:none}.daterangepicker.show-calendar .drp-calendar,.daterangepicker.show-calendar .drp-buttons{display:block}.daterangepicker.auto-apply .drp-buttons{display:none}.daterangepicker .drp-calendar{display:none;max-width:270px}.daterangepicker .drp-calendar.left{padding:8px 0 8px 8px}.daterangepicker .drp-calendar.right{padding:8px}.daterangepicker .drp-calendar.single .calendar-table{border:none}.daterangepicker .calendar-table .next span,.daterangepicker .calendar-table .prev span{color:#fff;border:solid #000;border-width:0 2px 2px 0;border-radius:0;display:inline-block;padding:3px}.daterangepicker .calendar-table .next span{transform:rotate(-45deg);-webkit-transform:rotate(-45deg)}.daterangepicker .calendar-table .prev span{transform:rotate(135deg);-webkit-transform:rotate(135deg)}.daterangepicker .calendar-table th,.daterangepicker .calendar-table td{text-align:center;vertical-align:middle;min-width:32px;width:32px;height:24px;line-height:24px;font-size:12px;border-radius:4px;border:1px solid transparent;white-space:nowrap;cursor:pointer}.daterangepicker .calendar-table{border:1px solid #fff;border-radius:4px;background-color:#fff}.daterangepicker .calendar-table table{width:100%;margin:0;border-spacing:0;border-collapse:collapse}.daterangepicker td.available:hover,.daterangepicker th.available:hover{background-color:#eee;border-color:transparent;color:inherit}.daterangepicker td.week,.daterangepicker th.week{font-size:80%;color:#ccc}.daterangepicker td.off,.daterangepicker td.off.in-range,.daterangepicker td.off.start-date,.daterangepicker td.off.end-date{background-color:#fff;border-color:transparent;color:#999}.daterangepicker td.in-range{background-color:#ebf4f8;border-color:transparent;color:#000;border-radius:0}.daterangepicker td.start-date{border-radius:4px 0 0 4px}.daterangepicker td.end-date{border-radius:0 4px 4px 0}.daterangepicker td.start-date.end-date{border-radius:4px}.daterangepicker td.active,.daterangepicker td.active:hover{background-color:#357ebd;border-color:transparent;color:#fff}.daterangepicker th.month{width:auto}.daterangepicker td.disabled,.daterangepicker option.disabled{color:#999;cursor:not-allowed;text-decoration:line-through}.daterangepicker select.monthselect,.daterangepicker select.yearselect{font-size:12px;padding:1px;height:auto;cursor:default}.daterangepicker select.yearselect{margin:0}.daterangepicker select.monthselect{margin:0 2% 0 0;width:56%}.daterangepicker select.yearselect{width:40%}.daterangepicker select.hourselect,.daterangepicker select.minuteselect,.daterangepicker select.secondselect,.daterangepicker select.ampmselect{width:50px;margin:0 auto;background:#eee;border:1px solid #eee;padding:2px;outline:0;font-size:12px}.daterangepicker .calendar-time{text-align:center;margin:4px auto 0;line-height:30px;position:relative}.daterangepicker .calendar-time select.disabled{color:#ccc;cursor:not-allowed}.daterangepicker .drp-buttons{clear:both;text-align:right;padding:8px;border-top:1px solid #ddd;display:none;line-height:12px;vertical-align:middle}.daterangepicker .drp-selected{display:inline-block;font-size:12px;padding-right:8px}.daterangepicker .drp-buttons .btn{margin-left:8px;font-size:12px;font-weight:700;padding:4px 8px}.daterangepicker.show-ranges.single.rtl .drp-calendar.left{border-right:1px solid #ddd}.daterangepicker.show-ranges.single.ltr .drp-calendar.left{border-left:1px solid #ddd}.daterangepicker.show-ranges.rtl .drp-calendar.right{border-right:1px solid #ddd}.daterangepicker.show-ranges.ltr .drp-calendar.left{border-left:1px solid #ddd}.daterangepicker .ranges{float:none;text-align:left;margin:0}.daterangepicker.show-calendar .ranges{margin-top:8px}.daterangepicker .ranges ul{list-style:none;margin:0 auto;padding:0;width:100%}.daterangepicker .ranges li{font-size:12px;padding:8px 12px;cursor:pointer}.daterangepicker .ranges li:hover{background-color:#eee}.daterangepicker .ranges li.active{background-color:#08c;color:#fff}@media (min-width:564px){.daterangepicker{width:auto}.daterangepicker .ranges ul{width:140px}.daterangepicker.single .ranges ul{width:100%}.daterangepicker.single .drp-calendar.left{clear:none}.daterangepicker.single .ranges,.daterangepicker.single .drp-calendar{float:left}.daterangepicker{direction:ltr;text-align:left}.daterangepicker .drp-calendar.left{clear:left;margin-right:0}.daterangepicker .drp-calendar.left .calendar-table{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}.daterangepicker .drp-calendar.right{margin-left:0}.daterangepicker .drp-calendar.right .calendar-table{border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.daterangepicker .drp-calendar.left .calendar-table{padding-right:8px}.daterangepicker .ranges,.daterangepicker .drp-calendar{float:left}}@media (min-width:730px){.daterangepicker .ranges{width:auto;float:left}.daterangepicker.rtl .ranges{float:right}.daterangepicker .drp-calendar.left{clear:none!important}}", ""]);

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	var StrokeAnalysisCtrl;
	
	StrokeAnalysisCtrl = (function() {
	  function StrokeAnalysisCtrl($scope) {
	    this.$scope = $scope;
	    this.strokeData = {
	      avg_shot_par3: 0,
	      avg_shot_par4: 0,
	      avg_shot_par5: 0
	    };
	    this.$scope.$on("myAnalysisUpdated.gnp.analysis", (function(_this) {
	      return function(event, myAnalysis) {
	        return _this.strokeData = myAnalysis.my_avg;
	      };
	    })(this));
	  }
	
	  return StrokeAnalysisCtrl;
	
	})();
	
	StrokeAnalysisCtrl.$inject = ['$scope'];
	
	module.exports = StrokeAnalysisCtrl;


/***/ }),
/* 508 */
/***/ (function(module, exports) {

	var ScoreAnalysisCtrl;
	
	ScoreAnalysisCtrl = (function() {
	  function ScoreAnalysisCtrl($scope) {
	    this.$scope = $scope;
	    this.scoreData = {
	      rat_under_eagle: 0,
	      rat_birdie: 0,
	      rat_par: 0,
	      rat_bogey: 0,
	      rat_dbogey: 0,
	      rat_over_tbogey: 0
	    };
	    this.$scope.$on("myAnalysisUpdated.gnp.analysis", (function(_this) {
	      return function(event, myAnalysis) {
	        return _this.scoreData = myAnalysis.my_avg;
	      };
	    })(this));
	  }
	
	  return ScoreAnalysisCtrl;
	
	})();
	
	ScoreAnalysisCtrl.$inject = ['$scope'];
	
	module.exports = ScoreAnalysisCtrl;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	var TimeSeriesDataCtrl, _;
	
	_ = __webpack_require__(87);
	
	TimeSeriesDataCtrl = (function() {
	  function TimeSeriesDataCtrl($scope, TimeSeriesAnalysisService) {
	    this.$scope = $scope;
	    this.TimeSeriesAnalysisService = TimeSeriesAnalysisService;
	    this.scoreData = {
	      categories: [],
	      series: []
	    };
	    this.$scope.$on('filteredScorecardsUpdated.gnp.analysis', (function(_this) {
	      return function(event, timeseries) {
	        return _this.scoreData = {
	          categories: _this.TimeSeriesAnalysisService.convertToCategories(timeseries),
	          series: _this.TimeSeriesAnalysisService.convertToSeries(timeseries)
	        };
	      };
	    })(this));
	    this.$scope.$on('selectedCourseUpdated.gnp.analysis', (function(_this) {
	      return function(event, course) {
	        return _this.course = course;
	      };
	    })(this));
	  }
	
	  return TimeSeriesDataCtrl;
	
	})();
	
	TimeSeriesDataCtrl.$inject = ['$scope', 'TimeSeriesAnalysisService'];
	
	module.exports = TimeSeriesDataCtrl;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	var DetailedAnalysisCtrl, _;
	
	_ = __webpack_require__(87);
	
	DetailedAnalysisCtrl = (function() {
	  function DetailedAnalysisCtrl($scope, ScoreCardAPIService, $routeParams) {
	    var params;
	    this.$scope = $scope;
	    this.goal = _.mapValues(this.$scope.$parent.goalSettings, function(val) {
	      if (_.isNull(val)) {
	        return "-";
	      } else {
	        return val;
	      }
	    });
	    params = {
	      user_id: $routeParams.user_id
	    };
	    ScoreCardAPIService.getAllMembers(params).then((function(_this) {
	      return function(data) {
	        return _this.all_members = data;
	      };
	    })(this));
	    this.$scope.$on("myAnalysisUpdated.gnp.analysis", (function(_this) {
	      return function(event, myAnalysis) {
	        _this.my_avg = _.mapValues(myAnalysis.my_avg, function(val) {
	          if (_.isNull(val)) {
	            return "-";
	          } else {
	            return val;
	          }
	        });
	        _this.best_score = _.mapValues(myAnalysis.best_score, function(val) {
	          if (_.isNull(val)) {
	            return "-";
	          } else {
	            return val;
	          }
	        });
	        return _this.worst_score = _.mapValues(myAnalysis.worst_score, function(val) {
	          if (_.isNull(val)) {
	            return "-";
	          } else {
	            return val;
	          }
	        });
	      };
	    })(this));
	  }
	
	  return DetailedAnalysisCtrl;
	
	})();
	
	DetailedAnalysisCtrl.$inject = ['$scope', 'ScoreCardAPIService', '$routeParams'];
	
	module.exports = DetailedAnalysisCtrl;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	var MAX_HOLES, ScatterDataCtrl, _;
	
	_ = __webpack_require__(87);
	
	MAX_HOLES = 18;
	
	ScatterDataCtrl = (function() {
	  var prepareGoal;
	
	  prepareGoal = function(goalSettings) {
	    if (!(goalSettings != null ? goalSettings.avg_total_shot : void 0)) {
	      return;
	    }
	    if (!(goalSettings != null ? goalSettings.avg_putt : void 0)) {
	      return;
	    }
	    return {
	      total_shot_all_holes: goalSettings.avg_total_shot,
	      total_putt_all_holes: goalSettings.avg_putt * MAX_HOLES
	    };
	  };
	
	  function ScatterDataCtrl($scope, ScatterDataService) {
	    this.$scope = $scope;
	    this.ScatterDataService = ScatterDataService;
	    this.goal = prepareGoal(this.$scope.$parent.goalSettings);
	    this.filteredScorecards = [];
	    if (this.$scope.$root.paid) {
	      this.$scope.$on('filteredScorecardsUpdated.gnp.analysis', (function(_this) {
	        return function(event, filteredScorecards) {
	          return _this.filteredScorecards = filteredScorecards;
	        };
	      })(this));
	    } else {
	      this.filteredScorecards = this.ScatterDataService.prepareDummyData();
	    }
	  }
	
	  return ScatterDataCtrl;
	
	})();
	
	ScatterDataCtrl.$inject = ['$scope', 'ScatterDataService'];
	
	module.exports = ScatterDataCtrl;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	var ScatterDataService, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	ScatterDataService = function() {
	  return {
	    convertScoreCards: function(filteredScorecards) {
	      return _.map(filteredScorecards, function(sc) {
	        return {
	          play_date: sc.play_date.format("YYYY/MM/DD"),
	          name: sc.club.name + " " + sc.course.name,
	          x: sc.total_putt_all_holes,
	          y: sc.total_shot_all_holes
	        };
	      });
	    },
	    calculateRange: function(scoreData, goal) {
	      var scoreDataWithGoalSettings;
	      scoreDataWithGoalSettings = scoreData || [];
	      if (goal) {
	        scoreDataWithGoalSettings = _.union(scoreDataWithGoalSettings, [
	          {
	            x: goal.total_putt_all_holes,
	            y: goal.total_shot_all_holes
	          }
	        ]);
	      }
	      return {
	        xRange: {
	          min: (_.minBy(scoreDataWithGoalSettings, 'x') || {
	            x: 0
	          }).x - 1,
	          max: (_.maxBy(scoreDataWithGoalSettings, 'x') || {
	            x: 0
	          }).x + 1
	        },
	        yRange: {
	          min: (_.minBy(scoreDataWithGoalSettings, 'y') || {
	            y: 0
	          }).y - 1,
	          max: (_.maxBy(scoreDataWithGoalSettings, 'y') || {
	            y: 0
	          }).y + 1
	        }
	      };
	    },
	    prepareDummyData: function() {
	      return [
	        {
	          play_date: moment(),
	          club: {
	            name: 'dummy'
	          },
	          course: {
	            name: 'dummy'
	          },
	          total_shot_all_holes: 5,
	          total_putt_all_holes: 3
	        }, {
	          play_date: moment(),
	          club: {
	            name: 'dummy'
	          },
	          course: {
	            name: 'dummy'
	          },
	          total_shot_all_holes: 2,
	          total_putt_all_holes: 3
	        }, {
	          play_date: moment(),
	          club: {
	            name: 'dummy'
	          },
	          course: {
	            name: 'dummy'
	          },
	          total_shot_all_holes: 2.5,
	          total_putt_all_holes: 2.5
	        }, {
	          play_date: moment(),
	          club: {
	            name: 'dummy'
	          },
	          course: {
	            name: 'dummy'
	          },
	          total_shot_all_holes: 4,
	          total_putt_all_holes: 2.7
	        }, {
	          play_date: moment(),
	          club: {
	            name: 'dummy'
	          },
	          course: {
	            name: 'dummy'
	          },
	          total_shot_all_holes: 1,
	          total_putt_all_holes: 2
	        }, {
	          play_date: moment(),
	          club: {
	            name: 'dummy'
	          },
	          course: {
	            name: 'dummy'
	          },
	          total_shot_all_holes: 14,
	          total_putt_all_holes: 10
	        }, {
	          play_date: moment(),
	          club: {
	            name: 'dummy'
	          },
	          course: {
	            name: 'dummy'
	          },
	          total_shot_all_holes: 13,
	          total_putt_all_holes: 10.5
	        }, {
	          play_date: moment(),
	          club: {
	            name: 'dummy'
	          },
	          course: {
	            name: 'dummy'
	          },
	          total_shot_all_holes: 14,
	          total_putt_all_holes: 11
	        }, {
	          play_date: moment(),
	          club: {
	            name: 'dummy'
	          },
	          course: {
	            name: 'dummy'
	          },
	          total_shot_all_holes: 11.5,
	          total_putt_all_holes: 11.5
	        }, {
	          play_date: moment(),
	          club: {
	            name: 'dummy'
	          },
	          course: {
	            name: 'dummy'
	          },
	          total_shot_all_holes: 11,
	          total_putt_all_holes: 11
	        }
	      ];
	    }
	  };
	};
	
	ScatterDataService.$inject = [];
	
	module.exports = ScatterDataService;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	var ScatterChartDirective, _, createChartOptions, renderGoal;
	
	__webpack_require__(514);
	
	_ = __webpack_require__(87);
	
	renderGoal = function(goal) {
	  var path, xAxis, yAxis;
	  if (!goal) {
	    return;
	  }
	  xAxis = this.xAxis[0];
	  yAxis = this.yAxis[0];
	  path = ['M', xAxis.toPixels(xAxis.min) - 100, yAxis.toPixels(goal.total_shot_all_holes), 'L', xAxis.toPixels(goal.total_putt_all_holes), yAxis.toPixels(goal.total_shot_all_holes), xAxis.toPixels(goal.total_putt_all_holes), yAxis.toPixels(yAxis.min) + 100];
	  this.renderer.path(path).attr({
	    'stroke-width': 2,
	    stroke: 'red',
	    dashstyle: 'line',
	    zIndex: 4,
	    gridLineWidth: 1,
	    gridZIndex: 4
	  }).add();
	  this.renderer.label(goal.total_putt_all_holes.toFixed(2), xAxis.toPixels(goal.total_putt_all_holes), yAxis.toPixels(yAxis.min) - 8).css({
	    fontWeight: 'bold',
	    color: 'red'
	  }).attr({
	    zIndex: 4,
	    gridLineWidth: 1,
	    gridZIndex: 4
	  }).add();
	  return this.renderer.label(goal.total_shot_all_holes.toFixed(2), xAxis.toPixels(xAxis.min) - 10, yAxis.toPixels(goal.total_shot_all_holes)).css({
	    fontWeight: 'bold',
	    color: 'red'
	  }).attr({
	    zIndex: 4,
	    gridLineWidth: 1,
	    gridZIndex: 4
	  }).add();
	};
	
	createChartOptions = function(scoreData, goal, range, target) {
	  return {
	    chart: {
	      renderTo: target[0],
	      type: 'scatter',
	      backgroundColor: 'transparent',
	      events: {
	        load: function() {
	          return renderGoal.call(this, goal);
	        }
	      }
	    },
	    credits: {
	      enabled: false
	    },
	    title: {
	      text: null
	    },
	    xAxis: {
	      min: range.xRange.min,
	      max: range.xRange.max,
	      title: {
	        enabled: false
	      },
	      labels: {
	        enabled: false
	      },
	      gridLineWidth: 0,
	      lineWidth: 0,
	      tickWidth: 0
	    },
	    yAxis: {
	      min: range.yRange.min,
	      max: range.yRange.max,
	      title: {
	        enabled: false
	      },
	      labels: {
	        enabled: false
	      },
	      gridLineWidth: 0,
	      lineWidth: 0,
	      tickWidth: 0
	    },
	    legend: {
	      enabled: false
	    },
	    plotOptions: {
	      scatter: {
	        marker: {
	          radius: 5,
	          states: {
	            hover: {
	              enabled: true,
	              lineColor: 'rgb(100,100,100)'
	            }
	          }
	        },
	        states: {
	          hover: {
	            marker: {
	              enabled: false
	            }
	          }
	        },
	        tooltip: {
	          headerFormat: '',
	          pointFormat: '<span style="color: #00B2AF; font-size: 12px; font-weight: bold;">{point.play_date}</span>\n<br />{point.name}<br />\n<span style="color: #00B2AF; font-size: 14px; font-weight: bold;">{point.y}\n  <span style="color: #00B2AF; font-size: 12px; font-weight: bold;">{point.x}</span>\n</span>'
	        }
	      }
	    },
	    series: [
	      {
	        color: '#00B2AF',
	        data: scoreData
	      }
	    ]
	  };
	};
	
	ScatterChartDirective = function(ScatterDataService) {
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "analysis/scatter-data/scatter-chart.jade",
	    scope: {
	      scoreData: '=scoreData',
	      goal: '='
	    },
	    link: function(scope, element) {
	      var target;
	      target = element.find(".chart");
	      return scope.$watch("scoreData", function() {
	        var range, scoreData;
	        scoreData = ScatterDataService.convertScoreCards(scope.scoreData);
	        range = ScatterDataService.calculateRange(scoreData, scope.goal);
	        return new Highcharts.Chart(createChartOptions(scoreData, scope.goal, range, target));
	      });
	    }
	  };
	};
	
	ScatterChartDirective.$inject = ["ScatterDataService"];
	
	module.exports = ScatterChartDirective;


/***/ }),
/* 514 */
/***/ (function(module, exports) {

	var v1="<div class=\"chart\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/scatter-data/scatter-chart.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	module.exports = {
	  '_ANALYSIS': {
	    'TITLE': 'Analysis',
	    'UPGRADE': {
	      'COURSE_STATS': 'Course Stats',
	      'SCATTER': 'Distribution map of your target of scoring',
	      'MESSAGE': 'Upgrade to GN+ addict member to track more stats, Edit your score data on the web, Access Concierge service, and more.',
	      'UPGRADE_NOW': 'Upgrade Now'
	    },
	    'PERIOD_FILTER': {
	      'ENTIRE_PERIOD': 'Entire Period',
	      'LAST_3_MONTHS': 'Last 3 months',
	      'LAST_6_MONTHS': 'Last 6 months',
	      'CUSTOM_RANGE_LABEL': 'Custom Range',
	      'APPLY_LABEL': 'Apply',
	      'CANCEL_LABEL': 'Cancel',
	      'TARGET_RANGE': 'Period',
	      'TARGET_ROUND': 'Target round',
	      'INCLUDE_1_5': 'Include 1.5 Round',
	      'EXCLUDE_1_5': 'Exclude 1.5 Round',
	      'INCLUDE_0_5': 'Include 0.5 Round',
	      'EXCLUDE_0_5': 'Exclude 0.5 Round',
	      'INCLUDE_1_5_SP': 'Include 1.5R',
	      'EXCLUDE_1_5_SP': 'Exclude 1.5R',
	      'INCLUDE_0_5_SP': 'Include 0.5R',
	      'EXCLUDE_0_5_SP': 'Exclude 0.5R'
	    },
	    'DETAILED_ANALYSIS': {
	      'MY_DATA': "MY DATA",
	      'GOAL': "Goal",
	      'MY_AVG': "Average",
	      'BEST_SCORE': "Best Score Round",
	      'WORST_SCORE': "Worst Score Round",
	      'ALL_MEMBERS': "All User's Avg. Data",
	      'AVG_TOTAL_SCORE_TITLE': "Average Total Score (Only completed 18H rounds)",
	      'NUMBER_OF_ROUNDS': "Number of Rounds",
	      'AVG_TOTAL_SCORE': "Average Total Score",
	      'PUTT_TITLE': "Putt Analysis",
	      'AVG_PUTT': "Avg. Putts",
	      'RAT_AVG_PUTT': "GIR. Avg. Putts",
	      'RAT_FAIRWAY_TITLE': "Driving Accuracy",
	      'FAIRWAY_CENTER': "Fairway hit (%)",
	      'FAIRWAY_RIGHT': "Missed right (%)",
	      'FAIRWAY_LEFT': "Missed left (%)",
	      'GIR_ANALYSIS_TITLE': "GIR Analysis",
	      'RAT_PAR_ON': "GIR (%)",
	      'RAT_BOGEY_ON': "GIR+1 (%)",
	      'STROKE_ANALYSIS_TITLE': "Stroke Analysis",
	      'AVG_STROKE_PAR3': "Avg. Stroke (Par 3)",
	      'AVG_STROKE_PAR4': "Avg. Stroke (Par 4)",
	      'AVG_STROKE_PAR5': "Avg. Stroke (Par 5)",
	      'RAT_RECOVERY': "Recovery (%)",
	      'SCORE_ANALYSIS_TITLE': 'Score Analysis',
	      'RAT_UNDER_EAGLE': "Eagle or under (%)",
	      'RAT_BIRDIE': "Birdie (%)",
	      'RAT_PAR': "Par (%)",
	      'RAT_BOGEY': "Bogey (%)",
	      'RAT_DBOGEY': "Double Bogey (%)",
	      'RAT_OVER_TBOGEY': "Triple Bogey or over (%)",
	      'SAND_SAVES_TITLE': "Guard Bunker",
	      'RAT_SAND_SAVE': "Scrambling from the Sand (%)"
	    },
	    'SCATTER_CHART': {
	      'SCORE': 'SCORE',
	      'PUTT': 'PUTT'
	    }
	  }
	};


/***/ }),
/* 516 */
/***/ (function(module, exports) {

	module.exports = {
	  '_ANALYSIS': {
	    'TITLE': 'スコア分析',
	    'UPGRADE': {
	      'COURSE_STATS': 'コース別分析機能',
	      'SCATTER': 'スコア/目標値分布図機能',
	      'MESSAGE': 'こちらの機能は有料会員向け機能です。<br/>機能詳細について下記リンクボタンをご覧ください。',
	      'UPGRADE_NOW': '機能詳細はこちら'
	    },
	    'PERIOD_FILTER': {
	      'ENTIRE_PERIOD': '全期間',
	      'LAST_3_MONTHS': '直近3ヶ月',
	      'LAST_6_MONTHS': '直近6ヶ月',
	      'CUSTOM_RANGE_LABEL': '期間指定',
	      'APPLY_LABEL': '適用',
	      'CANCEL_LABEL': 'キャンセル',
	      'TARGET_RANGE': '対象期間',
	      'TARGET_ROUND': '対象ラウンド',
	      'INCLUDE_1_5': '1.5ラウンドを含める',
	      'EXCLUDE_1_5': '1.5ラウンドを含めない',
	      'INCLUDE_0_5': '0.5ラウンドを含める',
	      'EXCLUDE_0_5': '0.5ラウンドを含まない',
	      'INCLUDE_1_5_SP': '1.5 R を含める',
	      'EXCLUDE_1_5_SP': '1.5 R を含めない',
	      'INCLUDE_0_5_SP': '0.5 R を含める',
	      'EXCLUDE_0_5_SP': '0.5 R を含まない'
	    },
	    'DETAILED_ANALYSIS': {
	      'MY_DATA': "マイデータ",
	      'GOAL': "目標",
	      'MY_AVG': "平均",
	      'BEST_SCORE': "ベストスコアラウンド",
	      'WORST_SCORE': "ワーストスコアラウンド",
	      'ALL_MEMBERS': "会員平均",
	      'AVG_TOTAL_SCORE_TITLE': "平均トータルスコア（★１８Ｈ記録済ラウンドのみ対象）",
	      'NUMBER_OF_ROUNDS': "ラウンド数合計",
	      'AVG_TOTAL_SCORE': "平均トータルスコア",
	      'PUTT_TITLE': "パット分析",
	      'AVG_PUTT': "ひとホールあたりの平均パット数",
	      'RAT_AVG_PUTT': "パーオン時の平均パット数",
	      'RAT_FAIRWAY_TITLE': "フェアウェイキープ",
	      'FAIRWAY_CENTER': "フェアウェイキープ率 （％）",
	      'FAIRWAY_RIGHT': "右ミス （％）",
	      'FAIRWAY_LEFT': "左ミス （％）",
	      'GIR_ANALYSIS_TITLE': "GIR分析",
	      'RAT_PAR_ON': "パーオン率 （％）",
	      'RAT_BOGEY_ON': "ボギーオン率 （％）",
	      'STROKE_ANALYSIS_TITLE': "ストローク分析",
	      'AVG_STROKE_PAR3': "平均ストローク（Par 3）",
	      'AVG_STROKE_PAR4': "平均ストローク（Par 4）",
	      'AVG_STROKE_PAR5': "平均ストローク（Par 5）",
	      'RAT_RECOVERY': "リカバリー率 （％）",
	      'SCORE_ANALYSIS_TITLE': "スコア分析",
	      'RAT_UNDER_EAGLE': "イーグル以上 （％）",
	      'RAT_BIRDIE': "パーディ （％）",
	      'RAT_PAR': "パー （％）",
	      'RAT_BOGEY': "ボギー （％）",
	      'RAT_DBOGEY': "ダブルボギー （％）",
	      'RAT_OVER_TBOGEY': "トリプルボギー以上 （％）",
	      'SAND_SAVES_TITLE': "ガードバンカー",
	      'RAT_SAND_SAVE': "Scrambling from the Sand （％）"
	    },
	    'SCATTER_CHART': {
	      'SCORE': 'SCORE',
	      'PUTT': 'PUTT'
	    }
	  }
	};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	var AnalysisEventService, BasicAnalysisEventCtrl, DetailedAnalysisEventCtrl, IndexEventCtrl, ScoreAnalysisEventCtrl, StrokeAnalysisEventCtrl, modules;
	
	__webpack_require__(518);
	
	__webpack_require__(520);
	
	__webpack_require__(521);
	
	__webpack_require__(522);
	
	__webpack_require__(523);
	
	__webpack_require__(524);
	
	__webpack_require__(471);
	
	__webpack_require__(472);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(384);
	
	__webpack_require__(386);
	
	__webpack_require__(59);
	
	__webpack_require__(82);
	
	__webpack_require__(76);
	
	__webpack_require__(473);
	
	__webpack_require__(278);
	
	__webpack_require__(389);
	
	__webpack_require__(416);
	
	__webpack_require__(487);
	
	__webpack_require__(108);
	
	__webpack_require__(39);
	
	IndexEventCtrl = __webpack_require__(526);
	
	BasicAnalysisEventCtrl = __webpack_require__(527);
	
	AnalysisEventService = __webpack_require__(528);
	
	StrokeAnalysisEventCtrl = __webpack_require__(529);
	
	ScoreAnalysisEventCtrl = __webpack_require__(530);
	
	DetailedAnalysisEventCtrl = __webpack_require__(531);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-common-wrapper', 'gnp-auth', 'ui.map', 'gnp-analysis-charts', 'gnp-app-goal-settings', 'gnp-remote-api', 'gnp-error-handler', 'gnp-number', 'gnp-map', 'gnp-analyze-access'];
	
	angular.module("gnp-app-analysis-event", modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/analysis-event/:id', {
	      templateUrl: 'web/analysis-event/index.jade',
	      controller: 'AnalysisEventCtrl',
	      resolve: {
	        goalSettings: [
	          'GoalAPIService', '$route', function(GoalAPIService, $route) {
	            var params;
	            params = {
	              user_id: $route.current.params.user_id
	            };
	            return GoalAPIService.getGoalSettings(params);
	          }
	        ]
	      },
	      title: '_ANALYSIS.TITLE',
	      permission: {
	        signInRequired: false
	      }
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(532)).translations('ja', __webpack_require__(533));
	  }
	]).controller('AnalysisEventCtrl', IndexEventCtrl).controller('StrokeAnalysisEventCtrl', StrokeAnalysisEventCtrl).controller('ScoreAnalysisEventCtrl', ScoreAnalysisEventCtrl).controller('BasicAnalysisEventCtrl', BasicAnalysisEventCtrl).controller('DetailedAnalysisEventCtrl', DetailedAnalysisEventCtrl).factory("AnalysisEventService", AnalysisEventService);


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"score-analysis-event\" gnp-common-wrapper-a=\"\"><div ng-click=\"gotoEventTab()\" class=\"container analysis-event-container content-name-event\"><img src=\"" + __webpack_require__(519) + "\"/>{{eventData.name}}</div><div class=\"container analysis-event-container content-user-event\">{{infoUser.first_name}}{{:: '_ANALYSIS_EVENT.USER_NAME_OF_SCORE_ANALYSIS' | translate }}</div><div ng-show=\"isShowDetailedAnalysisEvent\" ng-controller=\"BasicAnalysisEventCtrl as baeCtrl\" ng-include=\"'analysis-event/basic-analysis/basic-analysis.jade'\" class=\"container analysis-event-container content-score-charts\"></div><div ng-show=\"isShowDetailedAnalysisEvent\" class=\"container analysis-event-container content-semi-circle-charts\"><div class=\"row mx-0\"><div ng-controller=\"ScoreAnalysisEventCtrl as saeCtrl\" ng-include=\"'analysis-event/score-analysis/score-analysis.jade'\" class=\"charts chart-left\"></div><div ng-controller=\"StrokeAnalysisEventCtrl as staeCtrl\" ng-include=\"'analysis-event/stroke-analysis/stroke-analysis.jade'\" class=\"charts chart-right ml-auto\"></div></div></div><div ng-show=\"isShowDetailedAnalysisEvent\" ng-controller=\"DetailedAnalysisEventCtrl as daeCtrl\" ng-include=\"'analysis-event/detailed-analysis/detailed-analysis.jade'\"></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/analysis-event/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAApCAMAAAB9Yuu9AAAA+VBMVEUPvKb///8PvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKa+AGPcAAAAUnRSTlMAAAECAwQICQoMDRASFBUWIiMmKCorLC8wOTs9PkZLTE1RWl1eZmdobm9xc3R6e35/gIeIiYqMlpiZoaSmsrW9vsXMz9Xa3eTo7u/w8vP3+Pv8pdcSAAAAARVJREFUOMvt1clSwkAQBuBGohBZBMS4IsEQQ1wgnZgIKEtQdtnm/R/Gi5ZSDNp957/2d5ie+asGIpLAs3iC9XxPtvDG7anC4Yj3l3EOR6wWUxyO6NxkOBwRrbN9Dkd8uIpzuGNk6PzxOkU/jH1+QF+1fLxHvsiqfkR/pruLGKMEfpRVMReYPCKd7PiOgzSbFZNGPSkYlZrnvYu3hufVKkZBU6Uwqpn17lBIMuzWTW2t/UmzNRV/Ztoyk184/7IQhCxe8wCguEtBzNJVwBeM+DDn8A8IOTyEbJ+u+1kA1ZnQ8MQ5BACAhNVZ/WdXHSvx81DpUhBuXXoeBqX0Rg+UnG4HzXZvMBrPhJiNR4NeuxnYeu7Xj/kJxW28GKyT78oAAAAASUVORK5CYII="

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	var v1="<div gnp-basic-analysis=\"\" basic-analysis-data=\"baeCtrl.basicAnalysisData\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis-event/basic-analysis/basic-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	var v1="<div gnp-score-analysis=\"\" score-data=\"saeCtrl.scoreData\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis-event/score-analysis/score-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	var v1="<div gnp-stroke-analysis=\"\" stroke-data=\"staeCtrl.strokeData\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis-event/stroke-analysis/stroke-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	var v1="<div class=\"container content-board analysis-event-container\"><div class=\"row header\"><div class=\"col-12 no-padding\"><div class=\"head-column\"></div><div class=\"mydata\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.MY_DATA' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"classTitle\" class=\"pulldown\"><button data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"btn\"><span class=\"title\">{{nameSort}}</span><span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a ng-click=\"activeDisplay(1)\" class=\"goal\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.GOAL' | translate }}</a></li><li><a ng-click=\"activeDisplay(2)\" class=\"avg\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.MY_AVG' | translate }}</a></li><li><a ng-click=\"activeDisplay(3)\" class=\"best\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.BEST_SCORE' | translate }}</a></li><li><a ng-click=\"activeDisplay(4)\" class=\"worst\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.WORST_SCORE' | translate }}</a></li></ul></div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.GOAL' | translate }}</div><div class=\"column avg\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.MY_AVG' | translate }}</div><div class=\"column best\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.BEST_SCORE' | translate }}</div><div class=\"column worst\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.WORST_SCORE' | translate }}</div></div><div class=\"column all-avg\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.ALL_MEMBERS' | translate }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.AVG_TOTAL_SCORE_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.NUMBER_OF_ROUNDS' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\">-</div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.cnt_score_cards_by_round_type }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">-</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">-</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\">-</div><div class=\"column avg\">{{ daeCtrl.my_avg.cnt_score_cards_by_round_type }}</div><div class=\"column best\">-</div><div class=\"column worst\">-</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.cnt_score_cards_by_round_type }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.AVG_TOTAL_SCORE' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\">{{ ::(daeCtrl.goal.avg_total_shot | percentToFormattedString) }}</div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.avg_total_shot | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.avg_total_shot | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.avg_total_shot | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\">{{ ::(daeCtrl.goal.avg_total_shot | percentToFormattedString) }}</div><div class=\"column avg\">{{ daeCtrl.my_avg.avg_total_shot | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.avg_total_shot | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.avg_total_shot | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.avg_total_shot | percentToFormattedString }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.PUTT_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.AVG_PUTT' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\">{{ ::(daeCtrl.goal.avg_putt | percentToFormattedString) }}</div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.avg_putt | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.avg_putt | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.avg_putt | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\">{{ ::(daeCtrl.goal.avg_putt | percentToFormattedString) }}</div><div class=\"column avg\">{{ daeCtrl.my_avg.avg_putt | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.avg_putt | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.avg_putt | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.avg_putt | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.RAT_AVG_PUTT' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.avg_par_on_putt_cnt | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.avg_par_on_putt_cnt | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.avg_par_on_putt_cnt | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.avg_par_on_putt_cnt | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.avg_par_on_putt_cnt | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.avg_par_on_putt_cnt | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.avg_par_on_putt_cnt | percentToFormattedString }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.RAT_FAIRWAY_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.FAIRWAY_CENTER' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\">{{ ::(daeCtrl.goal.rat_fairway_center * 100 | percentToFormattedString) }}</div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.rat_fairway_center * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.rat_fairway_center * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.rat_fairway_center * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\">{{ ::(daeCtrl.goal.rat_fairway_center * 100 | percentToFormattedString) }}</div><div class=\"column avg\">{{ daeCtrl.my_avg.rat_fairway_center * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.rat_fairway_center * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.rat_fairway_center * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.rat_fairway_center * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.FAIRWAY_RIGHT' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.rat_fairway_right * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.rat_fairway_right * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.rat_fairway_right * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.rat_fairway_right * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.rat_fairway_right * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.rat_fairway_right * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.rat_fairway_right * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.FAIRWAY_LEFT' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.rat_fairway_left * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.rat_fairway_left * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.rat_fairway_left * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.rat_fairway_left * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.rat_fairway_left * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.rat_fairway_left * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.rat_fairway_left * 100 | percentToFormattedString }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.GIR_ANALYSIS_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.RAT_PAR_ON' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\">{{ ::(daeCtrl.goal.rat_par_on * 100 | percentToFormattedString) }}</div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.rat_par_on * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.rat_par_on * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.rat_par_on * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\">{{ ::(daeCtrl.goal.rat_par_on * 100 | percentToFormattedString) }}</div><div class=\"column avg\">{{ daeCtrl.my_avg.rat_par_on * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.rat_par_on * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.rat_par_on * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.rat_par_on * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.RAT_BOGEY_ON' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\">{{ ::(daeCtrl.goal.rat_bogey_on * 100 | percentToFormattedString) }}</div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.rat_bogey_on * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.rat_bogey_on * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.rat_bogey_on * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\">{{ ::(daeCtrl.goal.rat_bogey_on * 100 | percentToFormattedString) }}</div><div class=\"column avg\">{{ daeCtrl.my_avg.rat_bogey_on * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.rat_bogey_on * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.rat_bogey_on * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.rat_bogey_on * 100 | percentToFormattedString }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.STROKE_ANALYSIS_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.AVG_STROKE_PAR3' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.avg_shot_par3 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.avg_shot_par3 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.avg_shot_par3 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.avg_shot_par3 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.avg_shot_par3 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.avg_shot_par3 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.avg_shot_par3 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.AVG_STROKE_PAR4' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.avg_shot_par4 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.avg_shot_par4 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.avg_shot_par4 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.avg_shot_par4 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.avg_shot_par4 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.avg_shot_par4 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.avg_shot_par4 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.AVG_STROKE_PAR5' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.avg_shot_par5 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.avg_shot_par5 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.avg_shot_par5 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.avg_shot_par5 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.avg_shot_par5 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.avg_shot_par5 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.avg_shot_par5 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.RAT_RECOVERY' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.rat_recovery * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.rat_recovery * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.rat_recovery * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.rat_recovery * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.rat_recovery * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.rat_recovery * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.rat_recovery * 100 | percentToFormattedString }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.SCORE_ANALYSIS_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.RAT_UNDER_EAGLE' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.rat_under_eagle * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.rat_under_eagle * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.rat_under_eagle * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.rat_under_eagle * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.rat_under_eagle * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.rat_under_eagle * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.rat_under_eagle * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.RAT_BIRDIE' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.rat_birdie * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.rat_birdie * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.rat_birdie * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.rat_birdie * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.rat_birdie * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.rat_birdie * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.rat_birdie * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.RAT_PAR' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.rat_par * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.rat_par * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.rat_par * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.rat_par * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.rat_par * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.rat_par * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.rat_par * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.RAT_BOGEY' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.rat_bogey * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.rat_bogey * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.rat_bogey * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.rat_bogey * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.rat_bogey * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.rat_bogey * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.rat_bogey * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.RAT_DBOGEY' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.rat_dbogey * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.rat_dbogey * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.rat_dbogey * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.rat_dbogey * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.rat_dbogey * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.rat_dbogey * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.rat_dbogey * 100 | percentToFormattedString }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.RAT_OVER_TBOGEY' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.rat_over_tbogey * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.rat_over_tbogey * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.rat_over_tbogey * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.rat_over_tbogey * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.rat_over_tbogey * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.rat_over_tbogey * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.rat_over_tbogey * 100 | percentToFormattedString }}</div></div></div><div class=\"row title\"><div class=\"col-12 no-padding\"><div>{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.SAND_SAVES_TITLE' | translate }}</div></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"head-column\">{{:: '_ANALYSIS_EVENT.DETAILED_ANALYSIS.RAT_SAND_SAVE' | translate }}</div><div class=\"d-block d-sm-none\"><div ng-class=\"{hide : classTitle !== &quot;goal&quot;}\" class=\"column goal\"></div><div ng-class=\"{hide : classTitle !== &quot;avg&quot;}\" class=\"column avg\">{{ daeCtrl.my_avg.rat_sand_save * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;best&quot;}\" class=\"column best\">{{ daeCtrl.best_score.rat_sand_save * 100 | percentToFormattedString }}</div><div ng-class=\"{hide : classTitle !== &quot;worst&quot;}\" class=\"column worst\">{{ daeCtrl.worst_score.rat_sand_save * 100 | percentToFormattedString }}</div></div><div class=\"d-none d-sm-block\"><div class=\"column goal\"></div><div class=\"column avg\">{{ daeCtrl.my_avg.rat_sand_save * 100 | percentToFormattedString }}</div><div class=\"column best\">{{ daeCtrl.best_score.rat_sand_save * 100 | percentToFormattedString }}</div><div class=\"column worst\">{{ daeCtrl.worst_score.rat_sand_save * 100 | percentToFormattedString }}</div></div><div class=\"column all-avg\">{{ daeCtrl.all_members.rat_sand_save * 100 | percentToFormattedString }}</div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis-event/detailed-analysis/detailed-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(525);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_score_analysis_event.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_score_analysis_event.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.content-semi-circle-charts{position:relative;margin-bottom:20px}.content-semi-circle-charts .chart-left{height:400px;width:49%;position:relative;float:left;background-image:url("+__webpack_require__(468)+");background-repeat:no-repeat;background-position:138px 158px}.content-semi-circle-charts .chart-left .chart{position:absolute;top:27px;left:50%;margin-left:-250px;width:100%;height:400px}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{position:absolute;left:165px;font-size:12px;font-weight:700;text-align:right;width:50px}.content-semi-circle-charts .chart-left .label1,.content-semi-circle-charts .chart-left .label2,.content-semi-circle-charts .chart-left .label3,.content-semi-circle-charts .chart-left .label4,.content-semi-circle-charts .chart-left .label5,.content-semi-circle-charts .chart-left .label6{position:absolute;left:230px;font-size:12px;width:150px}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .label1{top:236px}.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .label2{top:260px}.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .label3{top:284px}.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .label4{top:308px}.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .label5{top:332px}.content-semi-circle-charts .chart-left .value6,.content-semi-circle-charts .chart-left .label6{top:356px}.content-semi-circle-charts .chart-right{height:400px;width:49%;position:relative;float:right;background-image:url("+__webpack_require__(469)+");background-repeat:no-repeat;background-position:58px 90px}.content-semi-circle-charts .chart-right .chart{position:absolute;top:27px;left:50%;margin-left:-250px;width:100%;height:400px}.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{position:absolute;left:244px;font-size:20px;font-weight:700}.content-semi-circle-charts .chart-right .value1{top:253px;color:#00B8B5}.content-semi-circle-charts .chart-right .value2{top:294px;color:#008886}.content-semi-circle-charts .chart-right .value3{top:334px;color:#006A68}.content-semi-circle-charts .chart-left,.content-semi-circle-charts .chart-right{background-color:#fff}.content-semi-circle-charts .chart-left .title,.content-semi-circle-charts .chart-right .title{position:absolute;top:123px;width:100%;text-align:center;font-size:14px;color:#00B8B5}@media (max-width:768px){.content-semi-circle-charts{position:relative;margin-bottom:20px}.content-semi-circle-charts .chart-left{height:400px;width:49%;float:left;position:relative;background-position:36% 160px}.content-semi-circle-charts .chart-left .chart{margin-left:-190px}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:29%}.content-semi-circle-charts .chart-left .label1,.content-semi-circle-charts .chart-left .label2,.content-semi-circle-charts .chart-left .label3,.content-semi-circle-charts .chart-left .label4,.content-semi-circle-charts .chart-left .label5,.content-semi-circle-charts .chart-left .label6{left:47%}.content-semi-circle-charts .chart-right{height:400px;width:49%;float:right;position:relative;background-position:7% 90px}.content-semi-circle-charts .chart-right .chart{margin-left:-190px}.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{left:51%}}@media (max-width:600px){.content-semi-circle-charts .chart-left{height:400px;width:100%;position:relative;background-position:44% 158px}.content-semi-circle-charts .chart-left .chart{left:33%;margin-left:-200px}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:38%}.content-semi-circle-charts .chart-left .label1,.content-semi-circle-charts .chart-left .label2,.content-semi-circle-charts .chart-left .label3,.content-semi-circle-charts .chart-left .label4,.content-semi-circle-charts .chart-left .label5,.content-semi-circle-charts .chart-left .label6{left:47%}.content-semi-circle-charts .chart-right{height:400px;width:100%;position:relative;background-position:31% 90px}.content-semi-circle-charts .chart-right .chart{left:33%;margin-left:-200px}.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{left:52%}}@media (max-width:414px){.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:34%}.content-semi-circle-charts .chart-left .label1,.content-semi-circle-charts .chart-left .label2,.content-semi-circle-charts .chart-left .label3,.content-semi-circle-charts .chart-left .label4,.content-semi-circle-charts .chart-left .label5,.content-semi-circle-charts .chart-left .label6{left:50%}.content-semi-circle-charts .chart-left .chart{left:48%}.content-semi-circle-charts .chart-right{background-position:15% 90px}.content-semi-circle-charts .chart-right .chart{left:48%}}@media (max-width:375px){.content-semi-circle-charts .chart-left{background-position:37% 158px}.content-semi-circle-charts .chart-left .chart{left:53%}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:34%}.content-semi-circle-charts .chart-right{background-position:9% 90px}.content-semi-circle-charts .chart-right .chart{left:53%}}@media (max-width:360px){.content-semi-circle-charts .chart-left{background-position:37% 158px}.content-semi-circle-charts .chart-left .chart{left:56%}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:34%}.content-semi-circle-charts .chart-right{background-position:13% 92px}.content-semi-circle-charts .chart-right .chart,.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{left:56%}}@media (max-width:320px){.content-semi-circle-charts .chart-left{background-position:37% 158px}.content-semi-circle-charts .chart-left .chart{left:62%}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:34%}.content-semi-circle-charts .chart-right{background-position:11% 128px;background-size:168px}.content-semi-circle-charts .chart-right .title{top:154px}.content-semi-circle-charts .chart-right .chart{left:62%}.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{left:54%;font-size:13px}.content-semi-circle-charts .chart-right .value1{top:266px}.content-semi-circle-charts .chart-right .value2{top:299px}}#score-analysis-event .content-board{position:relative;margin-bottom:20px;background-color:#fff}#score-analysis-event .content-board .row{position:relative;width:100%;height:40px;margin:0;line-height:40px;background-color:#fff;border-bottom:solid 1px #DEDEDE}#score-analysis-event .content-board .row.header{height:80px;font-size:12px;font-weight:700}#score-analysis-event .content-board .row.header .mydata{position:absolute;left:243px;height:40px;width:60%;background-color:#00B2AF;color:#fff;float:left;text-align:center;line-height:40px}#score-analysis-event .content-board .row.header .head-column{height:80px}#score-analysis-event .content-board .row.header .column{text-align:center}#score-analysis-event .content-board .row.header .column.goal{top:40px;background-color:#FEBABD}#score-analysis-event .content-board .row.header .column.avg{top:40px;background-color:#A3E9E7}#score-analysis-event .content-board .row.header .column.best{top:40px;background-color:#FFD4AD}#score-analysis-event .content-board .row.header .column.worst{top:40px;background-color:#ccc}#score-analysis-event .content-board .row.header .column.all-avg{background-color:#B2B096;height:80px;line-height:80px}#score-analysis-event .content-board .row.title{background-color:#D9D9D9;font-size:14px;font-weight:700;text-indent:20px}#score-analysis-event .content-board .row .head-column{position:relative;width:25%;height:40px;float:left;text-indent:30px;text-align:left}#score-analysis-event .content-board .row .column{position:relative;width:15%;height:40px;float:left}#score-analysis-event .content-board .row .column.goal{color:#FF0021}#score-analysis-event .content-board .row .column.avg{color:#00B2AF}#score-analysis-event .content-board .row .column.best{color:#f60}#score-analysis-event .content-board .row .column.best.label{line-height:normal;padding-top:7px;font-size:10px;border-radius:0}#score-analysis-event .content-board .row .column.worst{color:#666}#score-analysis-event .content-board .row .column.worst.label{line-height:normal;padding-top:7px;font-size:10px;border-radius:0}#score-analysis-event .content-board .row .column.all-avg{color:#7C7B69}#score-analysis-event .content-board .row.content{font-weight:700;text-align:center}#score-analysis-event .content-board .row.content .head-column{font-size:12px;text-align:left}#score-analysis-event .content-board .row.content .column{direction:rtl;font-size:14px}#score-analysis-event .content-board .row.content .column.all-avg{background-color:#D1D0C0;border-bottom:solid 1px #DEDEDE}@media (max-width:768px){#score-analysis-event .content-board .row.header{font-size:11px}#score-analysis-event .content-board .row.header .mydata{position:absolute;width:60%;left:25%}#score-analysis-event .content-board .row.content{font-weight:700;text-align:center}#score-analysis-event .content-board .row.content .head-column{font-size:11px;text-indent:18px}}@media (max-width:600px){#score-analysis-event .content-board .row.header{font-size:12px}#score-analysis-event .content-board .row.header .mydata{left:55%;height:40px;width:30%;background-color:#00B2AF;color:#fff;float:left;text-align:center;line-height:40px}#score-analysis-event .content-board .row.header .pulldown{position:absolute;left:55%;top:40px;height:40px;width:30%;background-color:#A3E9E7;color:#00B2AF;text-align:center}#score-analysis-event .content-board .row.header .pulldown .caret{margin-left:10px}#score-analysis-event .content-board .row.header .pulldown .title{font-size:10px;font-weight:700}#score-analysis-event .content-board .row.header .pulldown button{background:0 0;border:none;width:100%;padding:10px 0}#score-analysis-event .content-board .row.header .pulldown.goal{color:#FF0021;background-color:#FEBABD}#score-analysis-event .content-board .row.header .pulldown.avg{color:#00B2AF;background-color:#A3E9E7}#score-analysis-event .content-board .row.header .pulldown.best{color:#f60;background-color:#FFD4AD}#score-analysis-event .content-board .row.header .pulldown.worst{color:#666;background-color:#ccc}#score-analysis-event .content-board .row.header .pulldown ul.dropdown-menu{top:96%;left:0%;width:100%;padding:0;font-size:12px}#score-analysis-event .content-board .row.header .pulldown li a{color:#00B2AF;line-height:41px;text-align:center;padding:0;font-weight:inherit}#score-analysis-event .content-board .row.header .pulldown li a .text{margin:15px 0 0;line-height:0;font-size:12px}#score-analysis-event .content-board .row.header .pulldown li a .text .muted{padding-left:3.5em;color:darkgray}#score-analysis-event .content-board .row.header .pulldown li a.goal{color:#FF0021;background-color:#FEBABD}#score-analysis-event .content-board .row.header .pulldown li a.avg{color:#00B2AF;background-color:#A3E9E7}#score-analysis-event .content-board .row.header .pulldown li a.best{color:#f60;background-color:#FFD4AD}#score-analysis-event .content-board .row.header .pulldown li a.worst{color:#666;background-color:#ccc}#score-analysis-event .content-board .row.header .pulldown li a:hover{background-color:#c3e3e3}#score-analysis-event .content-board .row.header .head-column{height:80px}#score-analysis-event .content-board .row.header .column{text-align:center}#score-analysis-event .content-board .row.header .column.goal{top:40px;background-color:#FEBABD}#score-analysis-event .content-board .row.header .column.avg{top:40px;background-color:#A3E9E7}#score-analysis-event .content-board .row.header .column.best{top:40px;background-color:#FFD4AD}#score-analysis-event .content-board .row.header .column.worst{top:40px;background-color:#ccc}#score-analysis-event .content-board .row.header .column.all-avg{background-color:#B2B096;height:80px;line-height:35px;float:right}#score-analysis-event .content-board .row.title{background-color:#D9D9D9;font-size:14px;font-weight:700;text-indent:20px}#score-analysis-event .content-board .row .head-column{position:relative;width:25%;height:40px;float:left}#score-analysis-event .content-board .row .column{position:relative;width:15%;height:40px;float:left}#score-analysis-event .content-board .row .column.goal{color:#FF0021}#score-analysis-event .content-board .row .column.goal.hide{display:!important}#score-analysis-event .content-board .row .column.avg{color:#00B2AF}#score-analysis-event .content-board .row .column.avg.hide{display:!important}#score-analysis-event .content-board .row .column.best{color:#f60}#score-analysis-event .content-board .row .column.best.hide{display:none!important}#score-analysis-event .content-board .row .column.best.label{line-height:normal;padding-top:7px;font-size:10px;border-radius:0}#score-analysis-event .content-board .row .column.worst{color:#666}#score-analysis-event .content-board .row .column.worst.hide{display:none!important}#score-analysis-event .content-board .row .column.worst.label{line-height:normal;padding-top:7px;font-size:10px;border-radius:0}#score-analysis-event .content-board .row .column.all-avg{color:#7C7B69}#score-analysis-event .content-board .row.content .head-column{font-size:12px;width:55%}#score-analysis-event .content-board .row.content .column{font-size:14px}#score-analysis-event .content-board .row.content .column.avg,#score-analysis-event .content-board .row.content .column.best,#score-analysis-event .content-board .row.content .column.goal,#score-analysis-event .content-board .row.content .column.worst{-ms-flex:0 0 30%;flex:0 0 30%;display:-ms-flexbox;display:flex;max-width:30%;-ms-flex-pack:center;justify-content:center}#score-analysis-event .content-board .row.content .column.all-avg{background-color:#D1D0C0;border-bottom:solid 1px #DEDEDE;float:right}}@media (max-width:414px){#score-analysis-event .content-board .row.header{font-size:12px}#score-analysis-event .content-board .row.header .pulldown .title{font-size:8px;font-weight:700}#score-analysis-event .content-board .row.header .pulldown button{padding:5px}#score-analysis-event .content-board .row.header .pulldown ul.dropdown-menu{left:0%;font-size:10px}#score-analysis-event .content-board .row.header .pulldown li a .text,#score-analysis-event .content-board .row.title,#score-analysis-event .content-board .row.content .head-column,#score-analysis-event .content-board .row.content .column{font-size:10px}}@media (max-width:375px){#score-analysis-event .content-board .row.header .pulldown ul.dropdown-menu{left:-41%;font-size:12px}}@media (max-width:360px){#score-analysis-event .content-board .row.header .pulldown .title{font-size:7.5px}}@media (max-width:320px){#score-analysis-event .content-board .row.header .pulldown ul.dropdown-menu{font-size:8px}#score-analysis-event .content-board .row.header .pulldown .title{font-size:8px;font-weight:700}#score-analysis-event .content-board .row.header .pulldown ul.dropdown-menu{left:0%}#score-analysis-event .content-board .row.header .pulldown li a .text,#score-analysis-event .content-board .row.title,#score-analysis-event .content-board .row .column.best.label,#score-analysis-event .content-board .row .column.worst.label,#score-analysis-event .content-board .row.content .head-column,#score-analysis-event .content-board .row.content .column{font-size:8px}}#score-analysis-event .content-calendar{margin-bottom:20px;padding-top:20px}#score-analysis-event .content-calendar .non-background{background-image:none!important}#score-analysis-event .content-calendar .bar-calendar{position:relative;width:100%;height:40px;background-color:#333;background-image:url("+__webpack_require__(465)+");background-repeat:no-repeat;background-position:right center}#score-analysis-event .content-calendar .bar-calendar a.click{position:relative;height:38px;width:120px;left:0;padding-top:9px;padding-left:20px;float:right;font-size:14px;text-decoration:none;color:#fff;background-color:#ee2e2e}#score-analysis-event .content-calendar .bar-calendar .select-wrap{position:relative;overflow:hidden;display:inline-block;min-width:12em;width:220px;background-color:#555;background-repeat:no-repeat;background-position:200px 15px;background-image:url("+__webpack_require__(466)+");color:#ddd}#score-analysis-event .content-calendar .bar-calendar .select-wrap span{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;position:relative;display:block;outline:none;border:0;height:30px;margin:5px 10px;line-height:30px;color:#ddd;font-size:16px;text-indent:.01px;text-overflow:\"\";width:270px}#score-analysis-event .content-charts{position:relative;background-color:#fff;margin-bottom:20px;padding-bottom:40px}#score-analysis-event .content-charts .course-name{position:relative;width:820px;height:27px;background-color:#D9D9D9;border-radius:5px;top:28px;left:50%;padding:0 110px;margin-left:-410px;text-align:center;line-height:27px;font-weight:700;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}#score-analysis-event .content-charts .chart{position:relative;top:30px;left:50%;margin-left:-410px;width:820px}#score-analysis-event .content-map{position:relative;margin-top:20px;background-color:#fff;height:400px}#score-analysis-event .content-map .circle{border-radius:50%;font-size:20px;color:#fff;font-weight:700;line-height:100px;text-align:center;background:#008b8b}#score-analysis-event .content-map .map{position:absolute;width:640px;height:400px;text-align:center;background-color:#EEFBFA}#score-analysis-event .content-map .list{position:absolute;width:310px;height:380px;right:10px;top:10px;overflow-x:hidden;overflow-y:scroll}#score-analysis-event .content-map .list.freemode{overflow-y:hidden}#score-analysis-event .content-map .list ul{list-style-type:none;margin:0 0 0 -10px}#score-analysis-event .content-map .list ul .row{position:relative;width:100%;border-bottom:solid 1px #F2F2F2}#score-analysis-event .content-map .list ul .row:hover{background-color:#EEFBFA}#score-analysis-event .content-map .list ul .row .column-num{position:relative;width:45px;height:34px;float:left;color:#00B2AF;line-height:34px;text-align:right;font-weight:700;font-size:16px}#score-analysis-event .content-map .list ul .row .column-text{position:relative;width:180px;margin-top:8px;margin-bottom:6px;margin-left:10px;float:left;line-height:150%;font-size:13px}#score-analysis-event .content-map .list ul .row .column-text.select{font-weight:700;font-style:italic}#score-analysis-event .content-map .list .message-dialog{position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5)}#score-analysis-event .content-map .list .message-dialog .message{position:absolute;top:50%;left:50%;width:180px;min-height:240px;margin-top:-120px;margin-left:-90px;background-color:#FFA700}#score-analysis-event .content-map .list .message-dialog .message .title{position:relative;margin-top:20px;margin-bottom:20px;line-height:30px;font-weight:700;font-size:14px;color:#000;text-align:center}#score-analysis-event .content-map .list .message-dialog .message .description{position:relative;width:120px;left:50%;margin-left:-60px;color:#000}#score-analysis-event .content-map .list .message-dialog .message .btn-row{position:relative;text-align:center}#score-analysis-event .content-map .list .message-dialog .message .btn-row .btn-link{position:relative;min-width:120px;margin-top:15px;min-height:30px;color:#fff;text-decoration:none;background-color:#000;width:\"\";height:\"\";border-radius:5px;border-color:#000;border-width:1px;border-style:solid}#score-analysis-event .content-scatter-charts{position:relative;height:340px;background-color:#fff;margin-bottom:20px}#score-analysis-event .content-scatter-charts .chart-wrap{position:absolute;top:45px;left:60px;width:500px;height:250px;background-repeat:no-repeat;background-image:url("+__webpack_require__(467)+")}#score-analysis-event .content-scatter-charts .chart-wrap .score{position:relative;margin-top:2px;margin-left:7px;color:#bbb;font-size:14px}#score-analysis-event .content-scatter-charts .chart-wrap .pat{position:relative;margin-top:208px;margin-left:460px;color:#bbb;font-size:14px}#score-analysis-event .content-scatter-charts .chart-wrap .chart{position:absolute;top:0;left:0;width:500px;height:250px}#score-analysis-event .content-scatter-charts .chart-wrap .message-dialog{position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5)}#score-analysis-event .content-scatter-charts .chart-wrap .message-dialog .message{position:absolute;top:50%;left:50%;width:310px;min-height:180px;margin-left:-150px;margin-top:-90px;background-color:#FFA700}#score-analysis-event .content-scatter-charts .chart-wrap .message-dialog .message .title{position:relative;margin-top:15px;margin-bottom:15px;line-height:30px;font-weight:700;font-size:14px;color:#000;text-align:center}#score-analysis-event .content-scatter-charts .chart-wrap .message-dialog .message .description{position:relative;width:260px;left:50%;margin-left:-130px;color:#000}#score-analysis-event .content-scatter-charts .chart-wrap .message-dialog .message .btn-row{position:relative;text-align:center}#score-analysis-event .content-scatter-charts .chart-wrap .message-dialog .message .btn-row .btn-link{position:relative;min-width:120px;margin-top:15px;min-height:30px;color:#fff;text-decoration:none;background-color:#000;width:\"\";height:\"\";border-radius:5px;border-color:#000;border-width:1px;border-style:solid}#score-analysis-event .content-scatter-charts .ad{position:absolute;top:45px;right:60px;width:300px;height:250px;text-align:center;line-height:250px}#score-analysis-event .content-score-charts{position:relative;margin-bottom:20px;background-color:#fff;padding-top:30px;padding-bottom:30px}#score-analysis-event .content-score-charts a{pointer-events:none;cursor:default}#score-analysis-event .content-score-charts .freemode{opacity:.3}#score-analysis-event .content-score-charts .charts{background-color:#e5e5e5;margin-bottom:20px}#score-analysis-event .content-score-charts .column{height:210px;margin-bottom:20px}#score-analysis-event .content-score-charts .bar-layer{position:absolute;width:340px;height:56px;top:139px;left:120px}#score-analysis-event .content-score-charts .bar-layer .bar-avg-score{position:absolute;height:18px;top:16px;background-color:#00adad}#score-analysis-event .content-score-charts .bar-layer .bar-all-avg-score{position:absolute;height:18px;top:38px;background-color:#b2af98}#score-analysis-event .content-score-charts .bar-layer .pin-goal{position:absolute;width:54px;height:56px;margin-left:-6px;background-image:url("+__webpack_require__(470)+")}#score-analysis-event .content-score-charts .score-circle{position:absolute;left:30px;top:50%;margin-top:-90px;color:#fff;text-align:center;background-color:#00adad;width:180px;height:180px;border-radius:90px}#score-analysis-event .content-score-charts .score-circle .title{position:absolute;font-size:12px;width:100%;line-height:60px}#score-analysis-event .content-score-charts .score-circle .value{position:absolute;font-size:50px;font-weight:700;width:100%;line-height:180px}#score-analysis-event .content-score-charts .score-circle .hole{position:absolute;top:120px;font-size:10px;width:100%;line-height:60px}#score-analysis-event .content-score-charts .help-circle{position:absolute;width:42px;height:42px;left:300px;top:20px;background-image:url("+__webpack_require__(18)+");background-size:42px}#score-analysis-event .content-score-charts .goal-circle{position:absolute;top:30px;left:50%;color:#fff;text-align:center;background-color:#ee2e2e;width:90px;height:90px;border-radius:45px}#score-analysis-event .content-score-charts .goal-circle .title{position:absolute;font-size:12px;width:100%;line-height:30px}#score-analysis-event .content-score-charts .goal-circle .value{position:absolute;font-size:22px;font-weight:700;width:100%;line-height:90px}#score-analysis-event .content-score-charts .all-score-circle{position:absolute;left:80%;top:30px;color:#7c7a6a;text-align:center;background-color:#b2af98;width:90px;height:90px;border-radius:45px}#score-analysis-event .content-score-charts .all-score-circle .title{position:absolute;font-size:12px;width:100%;line-height:30px}#score-analysis-event .content-score-charts .all-score-circle .value{position:absolute;font-size:22px;font-weight:700;width:100%;line-height:90px}#score-analysis-event .content-score-charts .column-chart-percent{height:230px}#score-analysis-event .content-score-charts .column-chart-percent .chart{position:absolute;width:170px;height:170px;top:10px;left:40%}#score-analysis-event .content-score-charts .column-chart-percent .sub-title{position:absolute;top:182px;left:132px;font-size:12px;font-weight:700;width:180px;height:20px;text-align:center;color:#00adad}@media (max-width:414px){#score-analysis-event .content-score-charts .column-chart-percent .sub-title{left:148px}}#score-analysis-event .content-score-charts .column-chart-percent .goal{left:20px;top:80px;width:150px;position:absolute}#score-analysis-event .content-score-charts .column-chart-percent .goal .circle{position:relative;float:left;color:#fff;text-align:center;font-size:10px;line-height:40px;background-color:#ee2e2e;width:40px;height:40px;border-radius:20px}#score-analysis-event .content-score-charts .column-chart-percent .goal .value{position:relative;left:5px;font-size:18px;font-weight:700;width:100%;color:#ee2e2e;line-height:40px}#score-analysis-event .content-score-charts .column-chart-percent .all-avg{left:20px;top:130px;width:150px;position:absolute}#score-analysis-event .content-score-charts .column-chart-percent .all-avg .circle{position:relative;float:left;color:#7c7a6a;text-align:center;font-size:10px;line-height:14px;background-color:#b2af98;width:40px;border-radius:20px;height:40px;padding-top:6px}#score-analysis-event .content-score-charts .column-chart-percent .all-avg .value{position:relative;left:5px;font-size:18px;font-weight:700;width:100%;color:#7c7a6a;line-height:40px}#score-analysis-event .content-score-charts .help-circle{display:none}@media (max-width:768px){#score-analysis-event .content-score-charts .score-circle{width:160px;height:160px;border-radius:80px;left:3%}#score-analysis-event .content-score-charts .bar-layer{width:306px;top:119px;left:23%}#score-analysis-event .content-score-charts .goal-circle{width:80px;height:80px;border-radius:40px;left:50%}#score-analysis-event .content-score-charts .all-score-circle{width:80px;height:80px;border-radius:40px;left:75%}#score-analysis-event .content-score-charts .column-chart-percent .chart{left:32%}#score-analysis-event .content-score-charts .column-chart-percent .sub-title{left:28%}}@media (max-width:600px){#score-analysis-event .content-score-charts .bar-layer{left:17%}}@media (max-width:414px){#score-analysis-event .content-score-charts .bar-layer{width:294px;left:110px}#score-analysis-event .content-score-charts .score-circle{left:15px}#score-analysis-event .content-score-charts .goal-circle{left:210px}#score-analysis-event .content-score-charts .all-score-circle{left:310px}}@media (max-width:375px){#score-analysis-event .content-score-charts .bar-layer{width:290px;left:85px;top:128px}#score-analysis-event .content-score-charts .score-circle{left:10px;width:170px;height:170px}#score-analysis-event .content-score-charts .goal-circle{left:200px;width:80px;height:80px}#score-analysis-event .content-score-charts .all-score-circle{left:290px;width:80px;height:80px}}@media (max-width:360px){#score-analysis-event .content-score-charts .bar-layer{width:71%;left:25%;top:129px}#score-analysis-event .content-score-charts .goal-circle{left:190px;width:70px;height:70px}#score-analysis-event .content-score-charts .all-score-circle{left:280px;width:70px;height:70px}}@media (max-width:320px){#score-analysis-event .content-score-charts .bar-layer{top:109px}#score-analysis-event .content-score-charts .score-circle{left:10px;width:150px;height:150px}#score-analysis-event .content-score-charts .score-circle .hole{top:100px}#score-analysis-event .content-score-charts .score-circle .value{font-size:40px}#score-analysis-event .content-score-charts .goal-circle{left:180px;width:60px;height:60px}#score-analysis-event .content-score-charts .all-score-circle{left:250px;width:60px;height:60px}#score-analysis-event .content-score-charts .all-score-circle .title{font-size:10px}#score-analysis-event .content-score-charts .all-score-circle .value{font-size:16px}}#score-analysis-event .container.analysis-event-container,#score-analysis-event .container.content-board{max-width:none!important;width:970px}#score-analysis-event .cell{padding:0}#score-analysis-event .alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px;background:#fbe3e4;color:#8a1f11;border-color:#fbc2c4}#score-analysis-event .message{padding:.8em;margin-bottom:1em;border:2px solid #ddd}#score-analysis-event .message.notice{background:#fff6bf;color:#514721;border-color:#ffd324}#score-analysis-event .message.success{background:#e6efc2;color:#264409;border-color:#c6d880}#score-analysis-event .message.info{background:#d5edf8;color:#205791;border-color:#92cae4}#score-analysis-event .message.error{background:#fbe3e4;color:#8a1f11;border-color:#fbc2c4}#score-analysis-event .content-name-event{padding:10px 10px 5px;background-color:#fff;font-size:16px;font-weight:700;cursor:pointer}#score-analysis-event .content-name-event img{width:22px;margin:0 5px 5px 0}#score-analysis-event .content-name-event .event-name{margin-left:10px;font-size:14px}#score-analysis-event .content-user-event{background-color:#47aba9;padding:5px 10px;color:#fff;font-size:16px}@media (max-width:991px){#score-analysis-event #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#score-analysis-event .container.analysis-event-container,#score-analysis-event .container.content-board{max-width:none!important;width:100%}#score-analysis-event #main-main .container{width:100%;min-width:0}#score-analysis-event #gnp-header .btn-section,#score-analysis-event #gnp-header .user{display:none}#score-analysis-event #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:414px){#score-analysis-event #gnp-header .submenu{width:0}}", ""]);

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	var IndexEventCtrl, _;
	
	_ = __webpack_require__(87);
	
	IndexEventCtrl = function($scope, $location, AnalysisEventService, goalSettings, $analytics, $routeParams, $filter, $translate) {
	  var callMyAnalysis, createMyAnalysisParams;
	  angular.element(document.body).css('min-width', 0);
	  $analytics.eventTrack('ANL_loaded');
	  if ($routeParams.user_id === void 0) {
	    $routeParams.user_id = "me";
	  }
	  createMyAnalysisParams = function() {
	    return {
	      from: $scope.startDate,
	      to: $scope.endDate
	    };
	  };
	  callMyAnalysis = function() {
	    var params;
	    params = createMyAnalysisParams();
	    if (_.isEqual(params, $scope.previousMyAnalysisParams)) {
	      return;
	    }
	    $scope.previousMyAnalysisParams = params;
	    $scope.isLoadingDetailedAnalysisEvent = true;
	    return AnalysisEventService.getMyAnalysis(params).then(function(myAnalysis) {
	      return $scope.$broadcast("myAnalysisEventUpdated.gnp.analysis", myAnalysis);
	    })["finally"](function() {
	      return $scope.isLoadingDetailedAnalysisEvent = false;
	    });
	  };
	  $scope.goalSettings = goalSettings;
	  $scope.scorecards = [];
	  $scope.startDate = void 0;
	  $scope.endDate = void 0;
	  $scope.isShowDetailedAnalysisEvent = true;
	  $scope.isLoadingScoreCards = true;
	  $scope.isLoadingDetailedAnalysisEvent = true;
	  $scope.showNoResultMsg = false;
	  $scope.previousMyAnalysisParams = void 0;
	  $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.MY_AVG');
	  $scope.tab = 1;
	  $scope.classTitle = "avg";
	  $scope.gotoEventTab = function() {
	    var url;
	    url = "/group-event/" + $routeParams.id + "/ranking";
	    return $location.url(url);
	  };
	  $scope.activeDisplay = function(tab) {
	    $scope.tab = tab;
	    if ($scope.tab === 1) {
	      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.GOAL');
	      return $scope.classTitle = "goal";
	    } else if ($scope.tab === 2) {
	      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.MY_AVG');
	      return $scope.classTitle = "avg";
	    } else if ($scope.tab === 3) {
	      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.BEST_SCORE');
	      return $scope.classTitle = "best";
	    } else if ($scope.tab === 4) {
	      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.WORST_SCORE');
	      return $scope.classTitle = "worst";
	    }
	  };
	  $scope.eventData = false;
	  AnalysisEventService.getEvent().then(function(res) {
	    if (res.status === 200) {
	      return $scope.eventData = res.data;
	    }
	  });
	  return AnalysisEventService.getUserInfo().then(function(res) {
	    callMyAnalysis();
	    if (res.status === 200) {
	      return $scope.infoUser = res.data;
	    }
	  })["finally"](function() {
	    return $scope.isLoadingScoreCards = false;
	  });
	};
	
	IndexEventCtrl.$inject = ['$scope', '$location', 'AnalysisEventService', 'goalSettings', '$analytics', '$routeParams', '$filter', '$translate'];
	
	module.exports = IndexEventCtrl;


/***/ }),
/* 527 */
/***/ (function(module, exports) {

	var BasicAnalysisEventCtrl;
	
	BasicAnalysisEventCtrl = (function() {
	  function BasicAnalysisEventCtrl($scope, ScoreCardAPIService, $routeParams) {
	    var params;
	    this.$scope = $scope;
	    this.basicAnalysisData = {
	      goal: this.$scope.$parent.goalSettings,
	      my_avg: void 0,
	      all_members: void 0
	    };
	    params = {
	      user_id: $routeParams.user_id,
	      round_type: '0.5,1,1.5'
	    };
	    ScoreCardAPIService.getAllMembersByEvent($routeParams.id, params).then((function(_this) {
	      return function(data) {
	        return _this.basicAnalysisData.all_members = data;
	      };
	    })(this));
	    this.$scope.$on("myAnalysisEventUpdated.gnp.analysis", (function(_this) {
	      return function(event, myAnalysis) {
	        return _this.basicAnalysisData.my_avg = myAnalysis.my_avg;
	      };
	    })(this));
	  }
	
	  return BasicAnalysisEventCtrl;
	
	})();
	
	BasicAnalysisEventCtrl.$inject = ['$scope', 'ScoreCardAPIService', '$routeParams'];
	
	module.exports = BasicAnalysisEventCtrl;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var AnalysisEventService, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	AnalysisEventService = function($http, $q, ScoreCardAPIService, $routeParams) {
	  return {
	    getUserInfo: function() {
	      var id;
	      id = $routeParams.user_id;
	      return $http.get("/api/settings/account.json?user_id=" + id);
	    },
	    getScoreCards: function() {
	      var id;
	      id = $routeParams.user_id;
	      return $http.get("/api/users/" + id + "/score_cards.json");
	    },
	    getEvent: function() {
	      var event_id;
	      event_id = $routeParams.id;
	      return $http.get("/api/group_events/" + event_id + ".json");
	    },
	    getMyAnalysis: function(options) {
	      var defer, event_id, id, params, promises;
	      if (options == null) {
	        options = {};
	      }
	      id = $routeParams.user_id;
	      event_id = $routeParams.id;
	      params = _.pickBy({
	        event_id: $routeParams.id,
	        round_type: '0.5,1,1.5'
	      }, function(v) {
	        return v !== null && v !== void 0;
	      });
	      promises = {
	        best_worst: ScoreCardAPIService.getBestWorst(id, params),
	        my_avg: ScoreCardAPIService.getMyAvg(id, params)
	      };
	      defer = $q.defer();
	      $q.all(promises).then(function(result) {
	        return defer.resolve({
	          my_avg: result.my_avg.data,
	          best_score: result.best_worst.data.best_score,
	          worst_score: result.best_worst.data.worst_score
	        });
	      });
	      return defer.promise;
	    }
	  };
	};
	
	AnalysisEventService.$inject = ['$http', '$q', 'ScoreCardAPIService', '$routeParams'];
	
	module.exports = AnalysisEventService;


/***/ }),
/* 529 */
/***/ (function(module, exports) {

	var StrokeAnalysisEventCtrl;
	
	StrokeAnalysisEventCtrl = (function() {
	  function StrokeAnalysisEventCtrl($scope) {
	    this.$scope = $scope;
	    this.strokeData = {
	      avg_shot_par3: 0,
	      avg_shot_par4: 0,
	      avg_shot_par5: 0
	    };
	    this.$scope.$on("myAnalysisEventUpdated.gnp.analysis", (function(_this) {
	      return function(event, myAnalysis) {
	        return _this.strokeData = myAnalysis.my_avg;
	      };
	    })(this));
	  }
	
	  return StrokeAnalysisEventCtrl;
	
	})();
	
	StrokeAnalysisEventCtrl.$inject = ['$scope'];
	
	module.exports = StrokeAnalysisEventCtrl;


/***/ }),
/* 530 */
/***/ (function(module, exports) {

	var ScoreAnalysisEventCtrl;
	
	ScoreAnalysisEventCtrl = (function() {
	  function ScoreAnalysisEventCtrl($scope) {
	    this.$scope = $scope;
	    this.scoreData = {
	      rat_under_eagle: 0,
	      rat_birdie: 0,
	      rat_par: 0,
	      rat_bogey: 0,
	      rat_dbogey: 0,
	      rat_over_tbogey: 0
	    };
	    this.$scope.$on("myAnalysisEventUpdated.gnp.analysis", (function(_this) {
	      return function(event, myAnalysis) {
	        return _this.scoreData = myAnalysis.my_avg;
	      };
	    })(this));
	  }
	
	  return ScoreAnalysisEventCtrl;
	
	})();
	
	ScoreAnalysisEventCtrl.$inject = ['$scope'];
	
	module.exports = ScoreAnalysisEventCtrl;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var DetailedAnalysisEventCtrl, _;
	
	_ = __webpack_require__(87);
	
	DetailedAnalysisEventCtrl = (function() {
	  function DetailedAnalysisEventCtrl($scope, ScoreCardAPIService, $routeParams) {
	    var params;
	    this.$scope = $scope;
	    this.goal = _.mapValues(this.$scope.$parent.goalSettings, function(val) {
	      if (_.isNull(val)) {
	        return "-";
	      } else {
	        return val;
	      }
	    });
	    params = {
	      user_id: $routeParams.user_id,
	      round_type: '0.5,1,1.5'
	    };
	    ScoreCardAPIService.getAllMembersByEvent($routeParams.id, params).then((function(_this) {
	      return function(data) {
	        return _this.all_members = data;
	      };
	    })(this));
	    this.$scope.$on("myAnalysisEventUpdated.gnp.analysis", (function(_this) {
	      return function(event, myAnalysis) {
	        _this.my_avg = _.mapValues(myAnalysis.my_avg, function(val) {
	          if (_.isNull(val)) {
	            return "-";
	          } else {
	            return val;
	          }
	        });
	        _this.best_score = _.mapValues(myAnalysis.best_score, function(val) {
	          if (_.isNull(val)) {
	            return "-";
	          } else {
	            return val;
	          }
	        });
	        return _this.worst_score = _.mapValues(myAnalysis.worst_score, function(val) {
	          if (_.isNull(val)) {
	            return "-";
	          } else {
	            return val;
	          }
	        });
	      };
	    })(this));
	  }
	
	  return DetailedAnalysisEventCtrl;
	
	})();
	
	DetailedAnalysisEventCtrl.$inject = ['$scope', 'ScoreCardAPIService', '$routeParams'];
	
	module.exports = DetailedAnalysisEventCtrl;


/***/ }),
/* 532 */
/***/ (function(module, exports) {

	module.exports = {
	  '_ANALYSIS_EVENT': {
	    'TITLE': 'Analysis',
	    'USER_NAME_OF_SCORE_ANALYSIS': " s'score analysis",
	    'UPGRADE': {
	      'COURSE_STATS': 'Course Stats',
	      'SCATTER': 'Distribution map of your target of scoring',
	      'MESSAGE': 'Upgrade to GN+ addict member to track more stats, Edit your score data on the web, Access Concierge service, and more.',
	      'UPGRADE_NOW': 'Upgrade Now'
	    },
	    'PERIOD_FILTER': {
	      'LAST_1_YEAR': 'Last 1 year',
	      'LAST_6_MONTHS': 'Last 6 months',
	      'LAST_3_MONTHS': 'Last 3 months',
	      'LAST_YEAR': 'Last year',
	      'THIS_YEAR': 'This year'
	    },
	    'DETAILED_ANALYSIS': {
	      'MY_DATA': "MY DATA",
	      'GOAL': "Goal",
	      'MY_AVG': "Average",
	      'BEST_SCORE': "Best Score Round",
	      'WORST_SCORE': "Worst Score Round",
	      'ALL_MEMBERS': "All User's Avg. Data",
	      'AVG_TOTAL_SCORE_TITLE': "Average Total Score",
	      'NUMBER_OF_ROUNDS': "Number of Rounds",
	      'AVG_TOTAL_SCORE': "Average Total Score",
	      'PUTT_TITLE': "Putt Analysis",
	      'AVG_PUTT': "Avg. Putts",
	      'RAT_AVG_PUTT': "GIR. Avg. Putts",
	      'RAT_FAIRWAY_TITLE': "Driving Accuracy",
	      'FAIRWAY_CENTER': "Fairway hit (%)",
	      'FAIRWAY_RIGHT': "Missed right (%)",
	      'FAIRWAY_LEFT': "Missed left (%)",
	      'GIR_ANALYSIS_TITLE': "GIR Analysis",
	      'RAT_PAR_ON': "GIR (%)",
	      'RAT_BOGEY_ON': "GIR+1 (%)",
	      'STROKE_ANALYSIS_TITLE': "Stroke Analysis",
	      'AVG_STROKE_PAR3': "Avg. Stroke (Par 3)",
	      'AVG_STROKE_PAR4': "Avg. Stroke (Par 4)",
	      'AVG_STROKE_PAR5': "Avg. Stroke (Par 5)",
	      'RAT_RECOVERY': "Recovery (%)",
	      'SCORE_ANALYSIS_TITLE': 'Score Analysis',
	      'RAT_UNDER_EAGLE': "Eagle or under (%)",
	      'RAT_BIRDIE': "Birdie (%)",
	      'RAT_PAR': "Par (%)",
	      'RAT_BOGEY': "Bogey (%)",
	      'RAT_DBOGEY': "Double Bogey (%)",
	      'RAT_OVER_TBOGEY': "Triple Bogey or over (%)",
	      'SAND_SAVES_TITLE': "Guard Bunker",
	      'RAT_SAND_SAVE': "Scrambling from the Sand (%)"
	    },
	    'SCATTER_CHART': {
	      'SCORE': 'SCORE',
	      'PUTT': 'PUTT'
	    }
	  }
	};


/***/ }),
/* 533 */
/***/ (function(module, exports) {

	module.exports = {
	  '_ANALYSIS_EVENT': {
	    'TITLE': 'スコア分析',
	    'USER_NAME_OF_SCORE_ANALYSIS': "さんのスコア分析 ",
	    'UPGRADE': {
	      'COURSE_STATS': 'コース別分析機能',
	      'SCATTER': 'スコア/目標値分布図機能',
	      'MESSAGE': 'こちらの機能は有料会員向け機能です。<br/>機能詳細について下記リンクボタンをご覧ください。',
	      'UPGRADE_NOW': '機能詳細はこちら'
	    },
	    'PERIOD_FILTER': {
	      'LAST_1_YEAR': '直近1年',
	      'LAST_6_MONTHS': '直近6ヶ月',
	      'LAST_3_MONTHS': '直近3ヶ月',
	      'LAST_YEAR': '去年',
	      'THIS_YEAR': '今年'
	    },
	    'DETAILED_ANALYSIS': {
	      'MY_DATA': "マイデータ",
	      'GOAL': "目標",
	      'MY_AVG': "平均",
	      'BEST_SCORE': "ベストスコアラウンド",
	      'WORST_SCORE': "ワーストスコアラウンド",
	      'ALL_MEMBERS': "会員平均",
	      'AVG_TOTAL_SCORE_TITLE': "平均トータルスコア",
	      'NUMBER_OF_ROUNDS': "ラウンド数合計",
	      'AVG_TOTAL_SCORE': "平均トータルスコア",
	      'PUTT_TITLE': "パット分析",
	      'AVG_PUTT': "ひとホールあたりの平均パット数",
	      'RAT_AVG_PUTT': "パーオン時の平均パット数",
	      'RAT_FAIRWAY_TITLE': "フェアウェイキープ",
	      'FAIRWAY_CENTER': "フェアウェイキープ率 （％）",
	      'FAIRWAY_RIGHT': "右ミス （％）",
	      'FAIRWAY_LEFT': "左ミス （％）",
	      'GIR_ANALYSIS_TITLE': "GIR分析",
	      'RAT_PAR_ON': "パーオン率 （％）",
	      'RAT_BOGEY_ON': "ボギーオン率 （％）",
	      'STROKE_ANALYSIS_TITLE': "ストローク分析",
	      'AVG_STROKE_PAR3': "平均ストローク（Par 3）",
	      'AVG_STROKE_PAR4': "平均ストローク（Par 4）",
	      'AVG_STROKE_PAR5': "平均ストローク（Par 5）",
	      'RAT_RECOVERY': "リカバリー率 （％）",
	      'SCORE_ANALYSIS_TITLE': "スコア分析",
	      'RAT_UNDER_EAGLE': "イーグル以上 （％）",
	      'RAT_BIRDIE': "パーディ （％）",
	      'RAT_PAR': "パー （％）",
	      'RAT_BOGEY': "ボギー （％）",
	      'RAT_DBOGEY': "ダブルボギー （％）",
	      'RAT_OVER_TBOGEY': "トリプルボギー以上 （％）",
	      'SAND_SAVES_TITLE': "ガードバンカー",
	      'RAT_SAND_SAVE': "Scrambling from the Sand （％）"
	    },
	    'SCATTER_CHART': {
	      'SCORE': 'SCORE',
	      'PUTT': 'PUTT'
	    }
	  }
	};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	var HistoryCtrl, HistoryPeriodFilterCtrl, HistoryService, modules;
	
	__webpack_require__(535);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(76);
	
	__webpack_require__(82);
	
	__webpack_require__(473);
	
	__webpack_require__(108);
	
	__webpack_require__(39);
	
	__webpack_require__(536);
	
	__webpack_require__(541);
	
	HistoryCtrl = __webpack_require__(542);
	
	HistoryService = __webpack_require__(543);
	
	HistoryPeriodFilterCtrl = __webpack_require__(544);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-auth', 'gnp-common-wrapper', 'gnp-analysis-charts', 'gnp-error-handler', 'gnp-analyze-access'];
	
	angular.module('gnp-app-history', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/history', {
	      templateUrl: 'web/history/index.jade',
	      controller: 'HistoryCtrl',
	      title: '_HISTORY.TITLE',
	      resolve: {
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ]
	      },
	      permission: {
	        signInRequired: false
	      }
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(545)).translations('ja', __webpack_require__(546));
	  }
	]).controller('HistoryCtrl', HistoryCtrl).controller('HistoryPeriodFilterCtrl', HistoryPeriodFilterCtrl).factory('HistoryService', HistoryService);


/***/ }),
/* 535 */
/***/ (function(module, exports) {

	var v1="<div id=\"history-main\" gnp-common-wrapper-a=\"\"><div class=\"container history-main\"><div ng-show=\"noResults\" class=\"data container history-main\"><div class=\"no-title\">{{:: 'NO_ROUND.LETS_CREATE' | translate }}</div> <div class=\"create-link\"><a ng-href=\"/score-registration\" analytics-on=\"click\" analytics-event=\"HST_ScoreEntry_Rcmd\">{{:: 'NO_ROUND.CREATE_NOW' | translate }}</a></div></div> <div class=\"col-1\"></div> <div gnp-indicator=\"isLoading\" ng-show=\"isLoading\" class=\"content-charts col-12\"></div> </div><div class=\"container history-main\"><div class=\"content-calendar\"><div ng-controller=\"HistoryPeriodFilterCtrl as periodCtrl\" ng-include=\"'history/period-filter/period-filter.jade'\" class=\"bar-calendar {{hideHeader ? 'non-background' : ''}}\"></div></div><div class=\"content-history\"><div class=\"row mx-0\"><div class=\"col-1\"></div> <div class=\"history-group col-12\"><div ng-repeat=\"group in viewModel.scorecards track by group.key\"><div class=\"history_bar\">{{ ::group.key }}</div> <div ng-repeat=\"history in group.value track by history.id\" ng-click=\"showScoreCardDetail(history.id)\" class=\"row mx-0 history-row\"><div id=\"{{:: history.id }}\" class=\"col-3 col-sm-2 column-date\"><div class=\"yyyymmdd\">{{:: formatDate(history.play_date) }}</div><div class=\"weather-icon icons-{{ ::history.weather }}\"></div></div><div class=\"col-4 col-sm-3 col-md-2 column-score\"><div ng-class=\"classForRoundIcons(history)\" class=\"icon-round\"></div><div class=\"score-circle\"><div class=\"title\">{{:: 'SCORE' | translate }}</div><div class=\"value\">{{ ::history.total_shot_all_holes }}</div></div></div><div class=\"col-5 col-sm-7 col-md-8 column-course\"><div class=\"name-list\"><div class=\"name\">{{ ::history.club_name }} {{ ::history.course_name }}</div><div class=\"addr\">{{ ::history.address }}</div></div><div class=\"cell-wrap\"><div class=\"cell\"><div class=\"content\">{{ ::history.memo }}</div></div></div></div></div></div></div> <div class=\"col-1\"></div> <div ng-hide=\"noResults\" class=\"col-12\"><button ng-click=\"loadMore()\" ng-show=\"hasMore()\" gnp-indicator=\"isLoading\" class=\"btn btn-more\">{{:: 'SHOW_MORE' | translate }}</button></div></div></div><div class=\"score-float-icon-wrap d-block d-sm-none\"><a ng-href=\"/score-registration\" analytics-on=\"click\" analytics-event=\"DSB_ScoreEntry_Rcmd\" ng-class=\"{freemode: !$root.paid}\" class=\"score-float-icon\"></a><a ng-href=\"/score-registration\" ng-hide=\"$root.paid\" ng-class=\"{freemode: !$root.paid}\" class=\"help-circle\"></a></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/history/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(537);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_history.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_history.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell,.content-history .history-row .column-score3 .column-date .yyyymmdd,.content-history .history-row .column-date .column-score3 .yyyymmdd,.content-history .history-row .column-score3 .column-date .weather-icon,.content-history .history-row .column-date .column-score3 .weather-icon{width:116px}.history-row .column-score3 .cell .label,.content-history .history-row .column-score3 .column-date .yyyymmdd .label,.content-history .history-row .column-date .column-score3 .yyyymmdd .label,.content-history .history-row .column-score3 .column-date .weather-icon .label,.content-history .history-row .column-date .column-score3 .weather-icon .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.content-history .history-row{height:151px;border-bottom:1px solid #8e8e8e;position:relative;margin-bottom:unset;padding:0;cursor:pointer}.content-history .history-row .column-date{height:150px;padding:0;background-color:#4ac2c2;text-align:center;color:#fff}.content-history .history-row .column-date .cell,.content-history .history-row .column-date .yyyymmdd,.content-history .history-row .column-date .weather-icon{width:100%;height:50px;background-repeat:no-repeat;background-position:center;line-height:50px}.content-history .history-row .column-date .yyyymmdd{margin-top:16%;font-size:27px}@media (max-width:768px){.content-history .history-row .column-date .yyyymmdd{font-size:21px}}.content-history .history-row .column-date .weather-icon.icons-cloudy{background-image:url("+__webpack_require__(370)+")}.content-history .history-row .column-date .weather-icon.icons-foggy{background-image:url("+__webpack_require__(372)+")}.content-history .history-row .column-date .weather-icon.icons-rainy{background-image:url("+__webpack_require__(374)+")}.content-history .history-row .column-date .weather-icon.icons-snowing{background-image:url("+__webpack_require__(376)+")}.content-history .history-row .column-date .weather-icon.icons-sunny{background-image:url("+__webpack_require__(378)+")}.content-history .history-row .column-score{position:relative;height:150px;background-color:#fff;text-align:center;color:#fff}.content-history .history-row .column-score .score-circle{position:absolute;left:63%;top:50%;margin-left:-60px;margin-top:-60px;background-color:#00adad;width:120px;height:120px;border-radius:60px}.content-history .history-row .column-score .score-circle .title{position:absolute;font-size:12px;width:100%;line-height:40px}.content-history .history-row .column-score .score-circle .value{position:absolute;font-size:40px;width:100%;line-height:120px;font-weight:700}@media (max-width:320px){.content-history .history-row .column-score .score-circle{width:100px;height:100px;margin-left:-50px;margin-top:-50px}}.content-history .history-row .icon-round{position:absolute;top:15px;left:15px;width:27px;height:27px;background-repeat:no-repeat;background-position:center;background-size:27px;line-height:27px}.content-history .history-row .icon-round.icons-half-nine{background-image:url("+__webpack_require__(538)+")}.content-history .history-row .icon-round.icons-extra9{background-image:url("+__webpack_require__(539)+")}.content-history .history-row .column-course{position:relative;height:150px;background-color:#fff}.content-history .history-row .column-course .name-list{position:relative}.content-history .history-row .column-course .name-list .name{top:20px;padding:0 20px 0 10px;margin:0 auto;font-weight:700;font-size:16px;height:44.8px;line-height:1.4;-webkit-line-clamp:2}.content-history .history-row .column-course .name-list .name,.content-history .history-row .column-course .name-list .addr{position:relative;display:block;display:-webkit-box;max-width:100%;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}.content-history .history-row .column-course .name-list .addr{padding:15px 25px 5px 10px;font-size:15px;height:40px;line-height:25px;-webkit-line-clamp:1}.content-history .history-row .column-course .cell-wrap{padding-right:20px}.content-history .history-row .column-course .cell-wrap .cell,.content-history .history-row .column-course .cell-wrap .column-date .yyyymmdd,.content-history .history-row .column-date .column-course .cell-wrap .yyyymmdd,.content-history .history-row .column-course .cell-wrap .column-date .weather-icon,.content-history .history-row .column-date .column-course .cell-wrap .weather-icon{top:85px;color:gray;background-color:#f2f2f2;width:100%;height:45px;border-radius:5px;border-color:#f2f2f2;border-width:2px;border-style:solid}.content-history .history-row .column-course .cell-wrap .cell .content,.content-history .history-row .column-course .cell-wrap .column-date .yyyymmdd .content,.content-history .history-row .column-date .column-course .cell-wrap .yyyymmdd .content,.content-history .history-row .column-course .cell-wrap .column-date .weather-icon .content,.content-history .history-row .column-date .column-course .cell-wrap .weather-icon .content{display:block;display:-webkit-box;padding:5px 10px 0;margin:0 auto;font-size:12px;max-width:100%;height:33.6px;line-height:1.4;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}.content-history .etc{text-align:center}.content-history .btn-more{background-color:#000;width:180px;height:35px;border-radius:4px;border-color:#000;border-width:2px;border-style:solid;font-size:12px;color:#fff}@media (max-width:768px){.content-history .history-row .column-score .score-circle{left:60%}}@media (max-width:414px){.content-history .history-row{height:141px}.content-history .history-row .column-date{height:140px;background-color:#4ac2c2}.content-history .history-row .column-date .cell,.content-history .history-row .column-date .yyyymmdd,.content-history .history-row .column-date .weather-icon{width:100%;height:46.66667px;line-height:46.66667px}.content-history .history-row .column-date .yyyymmdd{margin-top:16%;font-size:19px}.content-history .history-row .column-score{height:140px}.content-history .history-row .column-score .score-circle{left:64%;margin-left:-50px;margin-top:-50px;background-color:#00adad;width:100px;height:100px;border-radius:50px}.content-history .history-row .column-score .score-circle .title{font-size:10px;line-height:33.33333px}.content-history .history-row .column-score .score-circle .value{font-size:30px;line-height:100px}.content-history .history-row .column-course{height:140px}.content-history .history-row .column-course .name-list .name{top:10px}.content-history .history-row .column-course .name-list .addr{padding-top:10px}.content-history .history-row .column-course .cell-wrap{padding-right:0}.content-history .history-row .column-course .cell-wrap .cell,.content-history .history-row .column-course .cell-wrap .column-date .yyyymmdd,.content-history .history-row .column-date .column-course .cell-wrap .yyyymmdd,.content-history .history-row .column-course .cell-wrap .column-date .weather-icon,.content-history .history-row .column-date .column-course .cell-wrap .weather-icon{top:80px;color:gray;background-color:#f2f2f2;width:100%;height:35px;border-radius:5px;border-color:#f2f2f2;border-width:2px;border-style:solid}.content-history .history-row .icon-round{top:22px;left:15px;width:22px;height:22px;background-size:22px;line-height:22px}}@media (max-width:375px){.content-history .history-row{height:131px}.content-history .history-row .column-date{height:130px;background-color:#4ac2c2}.content-history .history-row .column-date .cell,.content-history .history-row .column-date .yyyymmdd,.content-history .history-row .column-date .weather-icon{width:100%;height:43.33333px;line-height:43.33333px}.content-history .history-row .column-date .yyyymmdd{margin-top:16%;font-size:16px}.content-history .history-row .column-score{height:130px}.content-history .history-row .column-score .score-circle{left:66%;margin-left:-40px;margin-top:-40px;background-color:#00adad;width:80px;height:80px;border-radius:40px}.content-history .history-row .column-score .score-circle .title{font-size:10px;line-height:26.66667px}.content-history .history-row .column-score .score-circle .value{font-size:30px;line-height:80px}.content-history .history-row .column-course{height:130px}.content-history .history-row .column-course .name-list .name{top:10px}.content-history .history-row .column-course .name-list .addr{padding-top:10px}.content-history .history-row .column-course .cell-wrap{padding-right:0}.content-history .history-row .column-course .cell-wrap .cell,.content-history .history-row .column-course .cell-wrap .column-date .yyyymmdd,.content-history .history-row .column-date .column-course .cell-wrap .yyyymmdd,.content-history .history-row .column-course .cell-wrap .column-date .weather-icon,.content-history .history-row .column-date .column-course .cell-wrap .weather-icon{top:75px;color:gray;background-color:#f2f2f2;width:100%;height:30px;border-radius:5px;border-color:#f2f2f2;border-width:2px;border-style:solid}}@media (max-width:360px){.content-history .history-row .column-score .score-circle{left:67%}}@media (max-width:320px){.content-history .history-row .column-date .yyyymmdd{font-size:14px}.content-history .history-row .column-course{width:40%}.content-history .history-row .column-score .score-circle{left:63%}.content-history .history-row .icon-round{top:20px;left:10px;width:20px;height:20px;background-size:20px;line-height:20px}}.content-calendar .bar-calendar{position:relative;width:100%;height:40px;background-color:#333;background-image:url("+__webpack_require__(465)+");background-repeat:no-repeat;background-position:right center}.content-calendar .bar-calendar a.click{position:relative;left:0;float:right;text-decoration:none;color:#fff;background-color:#ee2e2e}.content-calendar .bar-calendar .select-wrap{position:relative;overflow:hidden;display:inline-block;min-width:12em;width:220px;background-color:#555;background-repeat:no-repeat;background-position:200px 15px;background-image:url("+__webpack_require__(466)+");color:#ddd}.content-calendar .bar-calendar .select-wrap span{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;position:relative;display:block;outline:none;border:0;height:30px;margin:5px 10px;line-height:30px;color:#ddd;font-size:16px;text-indent:.01px;text-overflow:\"\";width:270px}.content-calendar .bar-calendar .round-check{height:50px;line-height:20px}.content-calendar .bar-calendar .round-check.col-6{overflow:hidden}.content-calendar .bar-calendar .round-check.col-6 td{padding-right:10px}.content-calendar .bar-calendar .round-check.border-right-none{border-right:none}.content-calendar .bar-calendar{background-image:none;background-color:transparent}.content-calendar .bar-calendar .filter-container{width:85%;margin:0 auto}.content-calendar .bar-calendar .round{margin-top:20px}.content-calendar .bar-calendar .range-title{font-size:1.1em;height:50px;line-height:50px;background-color:#333;color:#fff;text-align:center;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical}.content-calendar .bar-calendar .range-selector{font-size:1.1em;height:50px;color:#fff;background-color:#4b4b4b;text-align:center;word-break:break-all;white-space:normal}.content-calendar .bar-calendar .range-selector .show-period{line-height:50px}.content-calendar .bar-calendar .range-selector .show-date-only{padding-top:8px}.content-calendar .bar-calendar .range-selector.col-4{padding-left:0;padding-right:0}.content-calendar .bar-calendar .round-checkbox{font-size:1.1em;height:50px;background-color:transparent;text-align:center;padding:0}.content-calendar .bar-calendar .round-checkbox label{font-size:10px;line-height:24px}.content-calendar .bar-calendar a.click{font-size:1.1em;width:33.33333%;padding-top:0;padding-left:0;height:50px;line-height:100px;text-align:center}.content-calendar .bar-calendar tbody tr td{vertical-align:middle}.content-calendar .bar-calendar tbody label{display:block;margin-bottom:0}.content-calendar .bar-calendar .custom-radio{display:none}.content-calendar .bar-calendar .course-name{padding-left:25px;text-indent:-1em;position:relative;font-weight:700}.content-calendar .bar-calendar .course-name::before{content:\"\";display:block;position:absolute;top:3px;left:0;width:15px;height:15px;border:1px solid #4b4b4b;border-radius:4px}.content-calendar .bar-calendar .custom-radio:checked{color:#07a3a4}.content-calendar .bar-calendar .custom-radio:checked+.course-name::after{content:\"\";display:block;position:absolute;top:3px;left:5px;width:7px;height:12px;transform:rotate(40deg);border-bottom:2px solid #fff;border-right:2px solid #fff}.content-calendar .bar-calendar .custom-radio:checked+.course-name::before{background-color:#4b4b4b}.content-calendar .bar-calendar .round-check{border:solid 1px #555}.content-calendar .bar-calendar .round-check.col-6{padding:0 10px}.content-calendar .bar-calendar .round-check.col-6 .course-name{font-size:1.3em;padding-left:35px;display:-webkit-box;-webkit-box-orient:vertical}.content-calendar .bar-calendar .round-check.col-6 .course-name::before{margin:5px 0;height:30px;width:30px}.content-calendar .bar-calendar .round-check.col-6 .course-name::after{top:12px;left:10px;width:10px;height:18px}.content-calendar .bar-calendar .checked-table{background-color:#4b4b4b}.content-calendar .bar-calendar .checked-table .course-name{color:#fff}.content-calendar .bar-calendar .checked-table .course-name::before{border:1px solid #fff}@media (max-width:1024px){.content-calendar .bar-calendar .filter-container{width:96%}.content-calendar .bar-calendar a.click{line-height:50px}}@media (max-width:768px){.content-calendar .bar-calendar .filter-container{width:90%}}@media (max-width:414px){.content-calendar .bar-calendar .filter-container{width:83%}}@media (min-width:768px){.content-calendar .bar-calendar .round-check.col-6 .course-name{font-size:14px;width:200px;display:table-cell;line-height:45px}}@media (min-width:992px){.content-calendar .bar-calendar .round-check.col-6 .course-name{width:250px}.content-calendar .bar-calendar .col-lg-2{padding:0}.content-calendar .bar-calendar .round{margin-top:1px}}@media (min-width:1025px){.content-calendar .bar-calendar .range-goal.click{width:100%;min-height:100px}}a.score-float-icon{background-image:url("+__webpack_require__(540)+");width:150px;background-size:150px;height:150px;border-radius:20px;background-color:transparent;border-color:transparent}a.score-float-icon,.score-float-icon-wrap .help-circle{position:fixed;right:2%;top:80%;z-index:1;background-repeat:no-repeat;background-position:center}.score-float-icon-wrap .help-circle{width:60px;height:60px;background-size:60px;background-image:url("+__webpack_require__(18)+")}.score-float-icon-wrap .help-circle.freemode{opacity:1}.freemode{opacity:.3}@media (max-width:1024px){a.score-float-icon{right:5%}}@media (max-width:768px){a.score-float-icon{right:3%}}@media (max-width:414px){a.score-float-icon{right:3px;width:100px;height:100px;background-size:100px}.score-float-icon-wrap .help-circle{right:1%;top:80%;width:45px;height:45px;background-size:45px}}@media (max-width:412px){a.score-float-icon{right:4px;width:100px;height:100px;background-size:100px}}@media (max-width:375px){a.score-float-icon{right:1px}.score-float-icon-wrap .help-circle{right:-.5%}}@media (max-width:360px){a.score-float-icon{right:0}}@media (max-width:320px){a.score-float-icon{right:-3px}}#history-main .container.history-main{max-width:none!important;width:970px}#history-main .container.history-main .history-group.col-12{padding:0}#history-main .container.history-main .content-calendar .bar-calendar{margin:20px 0 80px}#history-main .cell,#history-main .content-history .history-row .column-date .yyyymmdd,.content-history .history-row .column-date #history-main .yyyymmdd,#history-main .content-history .history-row .column-date .weather-icon,.content-history .history-row .column-date #history-main .weather-icon{padding:0}#history-main .btn-more{display:block;margin:0 auto 50px;color:#fff;background-color:#000;width:220px;height:40px;border-radius:4px;border-color:#000;border-width:2px;border-style:solid}#history-main .content-history .history-group .history_bar{margin-bottom:1px;height:25px;width:100%;background-color:#8e8e8e;color:#fff;font-size:19px;line-height:25px;text-indent:10px}@media (max-width:768px){#history-main .container.history-main{max-width:none!important;width:100%}#history-main .container.history-main .content-calendar .bar-calendar{margin-bottom:100px}}", ""]);

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAMAAABgZ9sFAAABklBMVEUfsZ0jsZ4ksZ0nsZ4qsp8tsqAusp8ws6Azs6A2s6A2s6E4tKE7tKI/taNBtaNEtqNFt6RHt6RHt6VPuadRuadRuahUuqhYu6lau6pbu6tdvKtgvaxkvq1mvq5nv69qv69uwbFvwrJxwrJyw7N1w7R2xLR3xLV7xbd/x7iCyLmEyLqFybuHybyIyryJyryKy72Ly72NzL6PzL+RzsCRzsGSzsGUz8KVz8OW0MOX0MOY0MSc0sWd0sae08ef08eg08eh1Mij1cmn1sqn1sup18yr2M2u2c+v2tCw2tC03NK13NK33dS53tW839a839e+4Ne/4dfA4dnB4trD49vF49zG5NzH5d3I5d7L5t/M5+DO6OHP6OLQ6ePR6ePS6uTT6uTU6uTV6+XW6+XZ7ejb7une7+re7+vg8Ozh8e3i8e3i8e7j8u7k8u7l8u/o9PHp9PLq9fLr9fLr9fPt9vTv9/bw+Pbx+Pfy+ff0+fj0+fn0+vn1+vr2+/r4/Pv5/Pv5/Pz6/f37/f38/v79/v7+///////bxS6sAAAB40lEQVRIx7WVZ1fCMBSGqyDi3qiIFRUBB07cC/eqCO6991YcqOCg9n970wYtnJBWj9wveZP3OWmz7mWYOIeeVRl6EWcFlcEq4f65nsaOsQN1OD8sfZ4pP1SB+83fy9N5FXHeLNuOhF0lnENeoqWzPhuJIl4BLwYr7wzEWwuitun4DbI2RBkqBOmi45vgZGM9AtpOx73gVGC9BLqMjqOVWrFelah/xN2/w+fBMWE9o4xvgaN5knQzCb/YkeN3yOoX5amOhLt0uTl270uYNyHPefh8O53FEHGxpzXXmsXubOSbi4Gj6yT161TieIDv1+CBVCoe3m7hcrSx2tHnuVil4tXRm0rGMxZ23U6jNnNCHW6I9cbx7aThjxzEq6TbgXLQ8bcksIZEeZsCckrhZxqQ5/IJ7ysGpK4V8HOt6OK9bxKUlsrJzrTomYh/+H0+fxAPeJLDdOVDdBbj96sMwXScwo32oZWAIFy1oeNnSuf4qBx53AKkISC/Uxr7Okxysrl/H52w+S5RROIQtkdifh9kfvBMo4yvJOIW1CyP29B7XgslyRIvEV9ETZ7T1Z4Pd6NVNns3udisFZBqXNrkZ4zaxC/VpEayGgsXoJWy0JF3oMnKmkpYi6OX2wv+ofKR8F+W4TjGF2MZRfyzv9/VAAAAAElFTkSuQmCC"

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAMAAABgZ9sFAAAB+FBMVEUAvaYAvaYAvaYAvaYAvaYAs5kAtJsAtZwAtpwAtp0At50At54At58AuJ8AuKAAuaAAuaEAuqEAuqIAuqMAu6MAu6QAvKQAvKUAvaUAvaYAvqYAvqkAv6gAv6oAwKkAwKsAwaoAwawAwa0Awq0Awq4Aw64Aw68AxLAAxLEAxbEAxbIAxrIAxrMAx7QAyLUAyLYAybYAybcAybgAyrgAyrkAy7oAzLsAzb4Azr4Azr8Az78A0MEA0cEA0sIA0sMA08QA08UA1MQA1MUA1MYA1cYA1ccA1sgA18kA18oA2MoA2MsA2csA2cwA2s4A284A288E3NAN29AT3NAc3NEr3dI33tNM4NVU4NZY4dda4tdc4thf4thh4thj49ll49ls49pt5Npw5dt05t115dx85t1/59+B59+D59+E6N+G6OCK6OCK6OGP6uKU6+KV6uSb6+Sc7OSg7OWh7OWi7ean7uex7+my7+m37+u38Ou48Oy58ey78ey98u2+8e3C8e7C8u7G8+/H8+/J8+/L9PDO9PHP9fHS9fLT9vPV9vPZ9/Ta9/Tb9/Xe+PXf+Pbh+Pbj+ffn+vjq+vns+/rt+/rv+/rw/Prw/Pvx/Pvy/fzz/Pz0/fz1/fz2/fz3/v34/f35/v36/v77/v78//78///9/v7+//7+//////8ejkcDAAAABXRSTlPB09Tp7I5/qrcAAAIYSURBVEjHY2BgYiQBMLBIkgIYmCUlxUWIAxDlEkrGRAFdiHIhh+VEgSoRkpRXkqa8YlQ5Ecq7M9IqwIJLCjKzwSArezJO5QVqvOx2YME56jwCYMAv0IRLeZSIkKSAM0S5rqgYfuVOy604lWXhygX1wsPAYAIu5RZm1ep8MOW89nAVCe5eIBDRgaq8eO4kZYRyW7hyc05ediDglM9BC5k+JOWOy+vzy6aAONZ8xsGBQX4G/NItOJULGlmJC4mop4KUc/qBxKYacoXiVC4qLsDPLywikAZS7gMWDOFwxaVcR1hEySvIVFREbQJcuQOnBy7lBuKqtUDKVESoEKR82dKl01MkedNxKF/W1wkO70QBgfjl1gIqhoaGWiLcZjNwKIeBEhH+6OXWQiJ8fPwikq79ywkoLxXji1luzWNTVOQjINuzHJfyBTNnLQLRxWDTOX2XL5+ozOuDU3mrpqIniI4WEEyDhkwAr0w7NuXLFixYPFubTypv+fI2HRGJBqjyLnleb2zKG/U0kpbH8YpJmlopifLZLYOFuyevbDuacgVuh+XlfGyhy+e78AsJCAjxGfYtX27JCnZYsySHG6ryfj1Zr+V1KrKxQHayiaKsZhAo6/nrRII95K9v0YeifNn0KbOXL5w2ZR5YurdjFlq+XrRwtNCjtnJn4pTXQJQLW3d1EgG6ckUh1bC0ojwRQFEOWmtLihMHYMqJBwA7vGlcO9LTBwAAAABJRU5ErkJggg=="

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	var v1="<div class=\"d-none d-lg-block\"><div class=\"row mx-0\"><div class=\"col-lg-10\"><div class=\"row\"><div class=\"col-4 range-title\">{{:: '_DASHBOARD.PERIOD_FILTER.TARGET_RANGE' | translate }}</div><div gnp-date-range-picker=\"\" start=\"periodCtrl.startDate\" end=\"periodCtrl.endDate\" user=\"periodCtrl.user_id\" class=\"col-8 range-selector\"></div></div><div class=\"round\"><div class=\"row\"><div class=\"col-4 range-title\">{{:: '_DASHBOARD.PERIOD_FILTER.TARGET_ROUND' | translate }}</div><div class=\"col-8 round-checkbox\"><div class=\"row mx-0\"><div ng-class=\"{ 'checked-table' : isInclude15 }\" class=\"col-6 round-check border-right-none\"><label><input type=\"checkbox\" ng-model=\"isInclude15\" ng-click=\"clickInclude15(isInclude15)\" class=\"custom-radio\"/><span class=\"course-name\">{{ (isInclude15 ? '_DASHBOARD.PERIOD_FILTER.INCLUDE_1_5' : '_DASHBOARD.PERIOD_FILTER.EXCLUDE_1_5') | translate }}</span></label></div><div ng-class=\"{ 'checked-table' : isInclude05 }\" class=\"col-6 round-check\"><label><input type=\"checkbox\" ng-model=\"isInclude05\" ng-click=\"clickInclude05(isInclude05)\" class=\"custom-radio\"/><span class=\"course-name\">{{ (isInclude05 ? '_DASHBOARD.PERIOD_FILTER.INCLUDE_0_5' : '_DASHBOARD.PERIOD_FILTER.EXCLUDE_0_5') | translate }}</span></label></div></div></div></div></div></div><div class=\"col-lg-2\"><a href=\"/goal-settings\" analytics-on=\"click\" analytics-event=\"ANL_TgtSetting\" class=\"range-goal click {{hideHeader ? 'hide-header' : ''}}\">{{:: '_GOAL_SETTINGS.TITLE' | translate }}</a></div></div></div><div class=\"d-lg-none filter-container\"><div class=\"row\"><div class=\"col-4 range-title\">{{:: '_DASHBOARD.PERIOD_FILTER.TARGET_RANGE' | translate }}</div><div gnp-date-range-picker=\"\" start=\"periodCtrl.startDate\" end=\"periodCtrl.endDate\" user=\"periodCtrl.user_id\" class=\"col-4 range-selector\"></div><a href=\"/goal-settings\" analytics-on=\"click\" analytics-event=\"ANL_TgtSetting\" class=\"col-4 range-goal click {{hideHeader ? 'hide-header' : ''}}\">{{:: '_GOAL_SETTINGS.TITLE' | translate }}</a></div></div><div class=\"d-lg-none filter-container round\"><div class=\"row\"><div class=\"col-4 range-title\">{{:: '_DASHBOARD.PERIOD_FILTER.TARGET_ROUND' | translate }}</div><div class=\"col-8 round-checkbox\"><div class=\"row mx-0\"><div ng-class=\"{ 'checked-table' : isInclude15 }\" class=\"col-6 round-check border-right-none\"><label><input type=\"checkbox\" ng-model=\"isInclude15\" ng-click=\"clickInclude15(isInclude15)\" class=\"custom-radio\"/><span class=\"course-name\">{{ (isInclude15 ? '_DASHBOARD.PERIOD_FILTER.INCLUDE_1_5_SP' : '_DASHBOARD.PERIOD_FILTER.EXCLUDE_1_5_SP') | translate }}</span></label></div><div ng-class=\"{ 'checked-table' : isInclude05 }\" class=\"col-6 round-check\"><label><input type=\"checkbox\" ng-model=\"isInclude05\" ng-click=\"clickInclude05(isInclude05)\" class=\"custom-radio\"/><span class=\"course-name\">{{ (isInclude05 ? '_DASHBOARD.PERIOD_FILTER.INCLUDE_0_5_SP' : '_DASHBOARD.PERIOD_FILTER.EXCLUDE_0_5_SP') | translate }}</span></label></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("history/period-filter/period-filter.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	var $, IndexCtrl, _, moment;
	
	_ = __webpack_require__(87);
	
	$ = __webpack_require__(1);
	
	moment = __webpack_require__(126);
	
	IndexCtrl = function($scope, $rootScope, $location, HistoryService, $analytics, $routeParams, cache, userInfo) {
	  var createViewModel;
	  $analytics.eventTrack('HST_loaded');
	  $scope.scorecards = [];
	  $scope.viewModel = void 0;
	  $scope.currentPage = 0;
	  $scope.isLoading = true;
	  $scope.noResults = false;
	  $scope.hideHeader = false;
	  $scope.cacheForUser = "history_page_state_for_user_" + $routeParams.user_id;
	  $scope.roundIdPositionCached = "round_id_position_cached_for_user_" + $routeParams.user_id;
	  $scope.userInfo = userInfo;
	  if ($routeParams.hide_header === '1') {
	    $scope.hideHeader = true;
	  }
	  if (cache.get($scope.cacheForUser)) {
	    $rootScope.$watch((function() {
	      return $location.absUrl();
	    }), function() {
	      var currentPath;
	      currentPath = $location.absUrl();
	      if (currentPath.indexOf('/history') === -1 && currentPath.indexOf('/round-detail') === -1) {
	        cache.remove($scope.cacheForUser);
	        return cache.remove($scope.roundIdPositionCached);
	      }
	    });
	  }
	  angular.element(document).ready(function() {
	    var roundIdPositionCached;
	    roundIdPositionCached = cache.get($scope.roundIdPositionCached);
	    if (roundIdPositionCached != null) {
	      return $([document.documentElement, document.body]).animate({
	        scrollTop: parseInt(roundIdPositionCached) - 260
	      }, 200);
	    }
	  });
	  createViewModel = function() {
	    return {
	      scorecards: HistoryService.convertToHistoryList($scope.scorecards)
	    };
	  };
	  $scope.loadMore = function(pageSize) {
	    var cachedPage, params, ref;
	    if (pageSize == null) {
	      pageSize = 10;
	    }
	    $scope.isLoading = true;
	    cachedPage = cache.get($scope.cacheForUser);
	    if (cachedPage && $scope.currentPage === 0) {
	      pageSize = pageSize * cachedPage;
	      $scope.currentPage++;
	    } else if (cachedPage && $scope.currentPage > 0) {
	      $scope.currentPage += cachedPage;
	      cache.remove($scope.cacheForUser);
	    } else {
	      $scope.currentPage++;
	    }
	    params = {
	      page: $scope.currentPage,
	      page_size: pageSize,
	      user_id: $routeParams.user_id || userInfo.user_id,
	      round_type: ((ref = $scope.roundType) != null ? ref.join(',') : void 0) || $routeParams.round_type,
	      from: $scope.startDate || $routeParams.from,
	      to: $scope.endDate || $routeParams.to
	    };
	    return HistoryService.get(params).then(function(resp) {
	      var newScorecards;
	      newScorecards = resp.data.score_cards.map(function(item) {
	        return _.merge({}, item, {
	          yyyy: moment(item.play_date).format('YYYY'),
	          mmdd: moment(item.play_date).format('MM/DD')
	        });
	      });
	      $scope.scorecards = _.union($scope.scorecards, newScorecards);
	      $scope.scorecards = _.uniqBy($scope.scorecards, 'id');
	      $scope.totalPages = resp.data.total_pages;
	      $scope.viewModel = createViewModel();
	      return $scope.noResults = $scope.scorecards.length === 0;
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  };
	  $scope.showScoreCardDetail = function(id) {
	    var cachedPage, ref;
	    cachedPage = _.max([cache.get($scope.cacheForUser), $scope.currentPage]);
	    cache.put($scope.cacheForUser, cachedPage);
	    cache.put($scope.roundIdPositionCached, (ref = $("#" + id).offset()) != null ? ref.top : void 0);
	    return $location.path('/round-detail/' + id);
	  };
	  $scope.hasMore = function() {
	    return $scope.currentPage !== $scope.totalPages;
	  };
	  $scope.formatDate = function(date) {
	    return moment(date).format("YYYY/MM/DD");
	  };
	  $scope.classForRoundIcons = function(history) {
	    switch (history.round_type) {
	      case 1.5:
	        return 'icons-extra9';
	      case 0.5:
	        return 'icons-half-nine';
	      default:
	        return '';
	    }
	  };
	  $scope.$on("periodSelected.gnp.history", function(event, startDate, endDate, roundType) {
	    $scope.currentPage = 0;
	    $scope.scorecards = [];
	    $scope.startDate = startDate != null ? startDate.clone() : void 0;
	    $scope.endDate = endDate != null ? endDate.clone() : void 0;
	    $scope.roundType = roundType;
	    return $scope.loadMore();
	  });
	  return $scope.$on("roundTypeUpdated.gnp.history", function(event, roundType) {
	    $scope.currentPage = 0;
	    $scope.scorecards = [];
	    $scope.roundType = roundType;
	    return $scope.loadMore();
	  });
	};
	
	IndexCtrl.$inject = ['$scope', '$rootScope', '$location', 'HistoryService', '$analytics', '$routeParams', 'cache', 'userInfo'];
	
	module.exports = IndexCtrl;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	var HistoryService, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	HistoryService = function($http, TimeSeriesAnalysisService, $filter) {
	  return {
	    get: function(params) {
	      var label;
	      label = localStorage.getItem(params.user_id + "_FILTER_PERIOD_SELECTED_LABEL");
	      if (label === $filter('translate')('_ANALYSIS.PERIOD_FILTER.ENTIRE_PERIOD') || label === null) {
	        params.from = null;
	        params.to = null;
	      }
	      return $http.get("/api/score_cards.json", {
	        params: params
	      });
	    },
	    convertToHistoryList: function(scorecards) {
	      return _(scorecards).groupBy('yyyy').toPairs().sortBy(function(a) {
	        return -a[0];
	      }).map(function(a) {
	        return {
	          key: a[0],
	          value: a[1]
	        };
	      }).value();
	    }
	  };
	};
	
	HistoryService.$inject = ['$http', 'TimeSeriesAnalysisService', '$filter'];
	
	module.exports = HistoryService;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	var PeriodFilterCtrl, _, moment,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	PeriodFilterCtrl = (function() {
	  function PeriodFilterCtrl($scope, $filter) {
	    var endDate, label, ref, roundType, startDate;
	    this.$scope = $scope;
	    this.$filter = $filter;
	    this._publishChange = bind(this._publishChange, this);
	    this.user_id = (ref = this.$scope.userInfo) != null ? ref.user_id : void 0;
	    startDate = localStorage.getItem(this.user_id + "_FILTER_PERIOD_START_DATE");
	    endDate = localStorage.getItem(this.user_id + "_FILTER_PERIOD_END_DATE");
	    this.startDate = startDate != null ? moment(startDate) : moment().subtract(10, 'years');
	    this.endDate = endDate != null ? moment(endDate) : moment().endOf('year');
	    label = localStorage.getItem(this.user_id + "_FILTER_PERIOD_SELECTED_LABEL");
	    if (label === this.$filter('translate')('_ANALYSIS.PERIOD_FILTER.ENTIRE_PERIOD')) {
	      this.endDate = moment().endOf('year');
	    }
	    this.$scope.$watch(((function(_this) {
	      return function() {
	        return _this.startDate + _this.endDate;
	      };
	    })(this)), this._publishChange);
	    roundType = localStorage.getItem(this.user_id + "_FILTER_roundType");
	    this.$scope.roundType = roundType != null ? JSON.parse(roundType) : [0, 1, 1.5];
	    this.$scope.isInclude15 = JSON.parse(localStorage.getItem(this.user_id + "_FILTER_isInclude15"));
	    this.$scope.isInclude05 = JSON.parse(localStorage.getItem(this.user_id + "_FILTER_isInclude05"));
	    if (this.$scope.isInclude15 == null) {
	      this.$scope.isInclude15 = true;
	      localStorage.setItem(this.user_id + "_FILTER_isInclude15", JSON.stringify(true));
	    }
	    if (this.$scope.isInclude05 == null) {
	      this.$scope.isInclude05 = false;
	      this.$scope.roundType = _.filter(this.$scope.roundType, function(type) {
	        return type !== 0.5;
	      });
	      localStorage.setItem(this.user_id + "_FILTER_isInclude05", JSON.stringify(false));
	    }
	    this.handleRoundType15();
	    this.handleRoundType05();
	    this.$scope.clickInclude15 = (function(_this) {
	      return function(isInclude15) {
	        _this.$scope.isInclude15 = isInclude15;
	        localStorage.setItem(_this.user_id + "_FILTER_isInclude15", JSON.stringify(isInclude15));
	        _this.handleRoundType15();
	        _this.$scope.$parent.$emit("roundTypeUpdated.gnp.history", _this.$scope.roundType.sort());
	        return localStorage.setItem(_this.user_id + "_FILTER_roundType", JSON.stringify(_this.$scope.roundType.sort()));
	      };
	    })(this);
	    this.$scope.clickInclude05 = (function(_this) {
	      return function(isInclude05) {
	        _this.$scope.isInclude05 = isInclude05;
	        localStorage.setItem(_this.user_id + "_FILTER_isInclude05", JSON.stringify(isInclude05));
	        _this.handleRoundType05();
	        _this.$scope.$parent.$emit("roundTypeUpdated.gnp.history", _this.$scope.roundType.sort());
	        return localStorage.setItem(_this.user_id + "_FILTER_roundType", JSON.stringify(_this.$scope.roundType.sort()));
	      };
	    })(this);
	  }
	
	  PeriodFilterCtrl.prototype.handleRoundType15 = function() {
	    if (this.$scope.isInclude15) {
	      if (indexOf.call(this.$scope.roundType, 1.5) < 0) {
	        return this.$scope.roundType.push(1.5);
	      }
	    } else {
	      return this.$scope.roundType = _.filter(this.$scope.roundType, function(type) {
	        return type !== 1.5;
	      });
	    }
	  };
	
	  PeriodFilterCtrl.prototype.handleRoundType05 = function() {
	    if (this.$scope.isInclude05) {
	      if (indexOf.call(this.$scope.roundType, 0.5) < 0) {
	        return this.$scope.roundType.push(0.5);
	      }
	    } else {
	      return this.$scope.roundType = _.filter(this.$scope.roundType, function(type) {
	        return type !== 0.5;
	      });
	    }
	  };
	
	  PeriodFilterCtrl.prototype._publishChange = function() {
	    localStorage.setItem(this.user_id + "_FILTER_PERIOD_START_DATE", this.startDate);
	    localStorage.setItem(this.user_id + "_FILTER_PERIOD_END_DATE", this.endDate);
	    return this.$scope.$parent.$emit("periodSelected.gnp.history", this.startDate, this.endDate, this.$scope.roundType.sort());
	  };
	
	  return PeriodFilterCtrl;
	
	})();
	
	PeriodFilterCtrl.$inject = ['$scope', '$filter'];
	
	module.exports = PeriodFilterCtrl;


/***/ }),
/* 545 */
/***/ (function(module, exports) {

	module.exports = {
	  '_HISTORY': {
	    'TITLE': 'History'
	  }
	};


/***/ }),
/* 546 */
/***/ (function(module, exports) {

	module.exports = {
	  '_HISTORY': {
	    'TITLE': 'ヒストリ'
	  }
	};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	var DashboardBasicAnalysisCtrl, DashboardBasicAnalysisService, DashboardBestScoreCtrl, DashboardCtrl, DashboardFairwayHitCtrl, DashboardFavoriteCourseCtrl, DashboardHistoryCtrl, DashboardPeriodFilterCtrl, DashboardService, FairwayHitChartDirective, modules;
	
	__webpack_require__(471);
	
	__webpack_require__(472);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(72);
	
	__webpack_require__(76);
	
	__webpack_require__(82);
	
	__webpack_require__(278);
	
	__webpack_require__(473);
	
	__webpack_require__(108);
	
	__webpack_require__(389);
	
	__webpack_require__(89);
	
	__webpack_require__(39);
	
	__webpack_require__(548);
	
	__webpack_require__(549);
	
	__webpack_require__(550);
	
	__webpack_require__(551);
	
	__webpack_require__(552);
	
	__webpack_require__(553);
	
	__webpack_require__(554);
	
	__webpack_require__(555);
	
	DashboardCtrl = __webpack_require__(558);
	
	DashboardHistoryCtrl = __webpack_require__(559);
	
	DashboardBestScoreCtrl = __webpack_require__(560);
	
	DashboardFavoriteCourseCtrl = __webpack_require__(561);
	
	DashboardFairwayHitCtrl = __webpack_require__(562);
	
	DashboardBasicAnalysisCtrl = __webpack_require__(563);
	
	DashboardPeriodFilterCtrl = __webpack_require__(564);
	
	DashboardService = __webpack_require__(565);
	
	DashboardBasicAnalysisService = __webpack_require__(566);
	
	FairwayHitChartDirective = __webpack_require__(567);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-flash', 'gnp-error-handler', 'gnp-auth', 'gnp-common-wrapper', 'gnp-remote-api', 'gnp-analysis-charts', 'gnp-number', 'gnp-cache', 'gnp-analyze-access'];
	
	angular.module('gnp-app-dashboard', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/', {
	      templateUrl: 'web/dashboard/dashboard.jade',
	      controller: 'DashboardCtrl',
	      title: '_DASHBOARD.TITLE',
	      resolve: {
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ]
	      },
	      permission: {
	        signInRequired: true
	      }
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(569)).translations('ja', __webpack_require__(570));
	  }
	]).controller('DashboardCtrl', DashboardCtrl).controller('DashboardHistoryCtrl', DashboardHistoryCtrl).controller('DashboardBestScoreCtrl', DashboardBestScoreCtrl).controller('DashboardFavoriteCourseCtrl', DashboardFavoriteCourseCtrl).controller('DashboardFairwayHitCtrl', DashboardFairwayHitCtrl).controller('DashboardBasicAnalysisCtrl', DashboardBasicAnalysisCtrl).controller('DashboardPeriodFilterCtrl', DashboardPeriodFilterCtrl).factory('DashboardService', DashboardService).factory('DashboardBasicAnalysisService', DashboardBasicAnalysisService).directive("gnpFairwayHitChart", FairwayHitChartDirective);


/***/ }),
/* 548 */
/***/ (function(module, exports) {

	var v1="<div id=\"main-main\" gnp-common-wrapper-a=\"\" class=\"dashboard-page\"><div ng-hide=\"hasHistories\" class=\"data container dashboard-container\"><div class=\"no-title\">{{:: 'NO_ROUND.LETS_CREATE' | translate }}</div><div class=\"create-link\"><a ng-href=\"/score-registration\" analytics-on=\"click\" analytics-event=\"DSB_ScoreEntry_Rcmd\">{{:: 'NO_ROUND.CREATE_NOW' | translate }}</a></div></div><div class=\"content-charts\"><div ng-controller=\"DashboardBasicAnalysisCtrl as basicAnalysisCtrl\" ng-include=\"'dashboard/basic-analysis/basic-analysis.jade'\" gnp-indicator=\"isLoading\" class=\"container dashboard-container\"></div></div><div ng-hide=\"!hasHistories\" ng-controller=\"DashboardHistoryCtrl as hiCtrl\" ng-include=\"'dashboard/history/history.jade'\" gnp-indicator=\"isLoading\" class=\"content-history\"></div><div class=\"content-ranking\"><div class=\"container dashboard-container cell1\"><div class=\"row mx-0\"><div ng-controller=\"DashboardBestScoreCtrl as bsCtrl\" ng-include=\"'dashboard/best-score/best-score.jade'\" gnp-indicator=\"isLoading\" class=\"col-12 col-sm-4 list-width\"></div><div ng-controller=\"DashboardFavoriteCourseCtrl as fcCtrl\" ng-include=\"'dashboard/favorite-course/favorite-course.jade'\" gnp-indicator=\"isLoading\" class=\"col-12 col-sm-4 list-width\"></div><div ng-controller=\"DashboardFairwayHitCtrl as fwCtrl\" ng-include=\"'dashboard/fairway-hit/fairway-hit.jade'\" gnp-indicator=\"isLoading\" class=\"col-12 col-sm-4 list-width\"></div></div></div></div><div class=\"score-float-icon-wrap d-block d-sm-none\"><a ng-href=\"/score-registration\" analytics-on=\"click\" analytics-event=\"DSB_ScoreEntry_Rcmd\" ng-class=\"{freemode: !$root.paid}\" class=\"score-float-icon\"></a><a ng-href=\"/score-registration\" ng-hide=\"$root.paid\" ng-class=\"{freemode: !$root.paid}\" class=\"help-circle\"></a></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/dashboard/dashboard.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 549 */
/***/ (function(module, exports) {

	var v1="<div class=\"container dashboard-container\"><div ng-repeat=\"history in histories\" ng-click=\"showScoreCardDetail(history.id)\" class=\"row mx-0 history-row col-12 last\"><div class=\"col-3 col-sm-2 column-date\"><div class=\"yyyymmdd\">{{ ::history.play_date }}</div><div class=\"weather-icon icons-{{ ::history.weather }}\"></div></div><div class=\"col-4 col-sm-3 col-md-2 column-score\"><div ng-class=\"classForRoundIcons(history)\" class=\"icon-round\"></div><div class=\"score-circle\"><div class=\"title\">{{:: 'SCORE' | translate }}</div><div class=\"value\">{{ ::history.total_shot_all_holes }}</div></div></div><div class=\"col-5 col-sm-7 col-md-8 column-course\"><div class=\"name-list\"><div class=\"name\">{{ ::history.club_name }} {{ ::history.course_name }}</div><div class=\"addr\">{{ ::history.address }}</div></div><div class=\"cell-wrap\"><div class=\"cell\"><div class=\"content\">{{ ::history.memo }}</div></div></div></div></div><div class=\"row mx-0\"><div class=\"col-12 etc\"><div ng-click=\"navigateToHistory()\" analytics-on=\"click\" analytics-event=\"DSB_more\" class=\"btn btn-more\">{{:: 'SHOW_MORE' | translate }}</div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("dashboard/history/history.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 550 */
/***/ (function(module, exports) {

	var v1="<div class=\"content-calendar\"><div ng-controller=\"DashboardPeriodFilterCtrl as periodCtrl\" ng-include=\"'dashboard/period-filter/period-filter.jade'\" class=\"bar-calendar {{hideHeader ? 'non-background' : ''}}\"></div></div><div gnp-basic-analysis=\"\" basic-analysis-data=\"basicAnalysisData\" class=\"score-circle-charts-wrap\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("dashboard/basic-analysis/basic-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 551 */
/***/ (function(module, exports) {

	var v1="<div class=\"content-wrap\"><div class=\"title\">{{:: '_DASHBOARD.BEST_SCORE' | translate }}&nbsp;<span class=\"small\">{{:: '_DASHBOARD.RANKING' | translate }}</span></div><div ng-repeat=\"item in bestScores\" class=\"row pointer\"><div ng-click=\"showScoreCardDetail(item.score_card_id)\"><div class=\"best-score-column-value\"><div ng-class=\"classForRoundIcons(item)\" class=\"icon-round\"></div><div class=\"value-circle\">{{ ::item.total_shot }}</div></div><div class=\"best-score-column-content\"><div class=\"date\">{{ ::item.play_date }}</div><div class=\"desc\">{{ ::item.club_name }} {{ ::item.course_name }}</div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("dashboard/best-score/best-score.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	var v1="<div class=\"content-wrap center\"><div class=\"title\">{{:: '_DASHBOARD.FAVORITE_COURSE' | translate }}&nbsp;<span class=\"small\"> {{:: '_DASHBOARD.RANKING' | translate }}</span></div><div ng-repeat=\"item in favoriteCourses\" class=\"row\"><div class=\"column-value\"><div class=\"value-round-rect\">{{ ::item.cnt_score_cards }}</div></div><div class=\"column-content\"><div class=\"date\">{{ ::item.play_date }}</div><div class=\"desc\">{{ ::item.club_name }} {{ ::item.course_name }}</div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("dashboard/favorite-course/favorite-course.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 553 */
/***/ (function(module, exports) {

	var v1="<div class=\"content-wrap right\"><div class=\"title\">{{:: '_DASHBOARD.FAIRWAY_KEEP_COURSE' | translate }}&nbsp;<span class=\"small\"> {{:: '_DASHBOARD.RANKING' | translate }}</span></div><div ng-repeat=\"item in topFairwayHitCourses\" class=\"row\"><div class=\"column-value\"><div gnp-fairway-hit-chart=\"\" fairway-hit-data=\"::(item.rat_fairway_center * 100 | percentToFormattedString)\"></div></div><div class=\"column-content\"><div class=\"date\">{{ ::item.play_date }}</div><div class=\"desc\">{{ ::item.club_name }} {{ ::item.course_name }}</div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("dashboard/fairway-hit/fairway-hit.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	var v1="<div class=\"d-none d-lg-block\"><div class=\"row mx-0\"><div class=\"col-lg-10\"><div class=\"row\"><div class=\"col-4 range-title\">{{:: '_DASHBOARD.PERIOD_FILTER.TARGET_RANGE' | translate }}</div><div gnp-date-range-picker=\"\" start=\"periodCtrl.startDate\" end=\"periodCtrl.endDate\" user=\"periodCtrl.user_id\" class=\"col-8 range-selector\"></div></div><div class=\"round\"><div class=\"row\"><div class=\"col-4 range-title\">{{:: '_DASHBOARD.PERIOD_FILTER.TARGET_ROUND' | translate }}</div><div class=\"col-8 round-checkbox\"><div class=\"row mx-0\"><div ng-class=\"{ 'checked-table' : isInclude15 }\" class=\"col-6 round-check border-right-none\"><label><input type=\"checkbox\" ng-model=\"isInclude15\" ng-click=\"clickInclude15(isInclude15)\" class=\"custom-radio\"/><span class=\"course-name\">{{ (isInclude15 ? '_DASHBOARD.PERIOD_FILTER.INCLUDE_1_5' : '_DASHBOARD.PERIOD_FILTER.EXCLUDE_1_5') | translate }}</span></label></div><div ng-class=\"{ 'checked-table' : isInclude05 }\" class=\"col-6 round-check\"><label><input type=\"checkbox\" ng-model=\"isInclude05\" ng-click=\"clickInclude05(isInclude05)\" class=\"custom-radio\"/><span class=\"course-name\">{{ (isInclude05 ? '_DASHBOARD.PERIOD_FILTER.INCLUDE_0_5' : '_DASHBOARD.PERIOD_FILTER.EXCLUDE_0_5') | translate }}</span></label></div></div></div></div></div></div><div class=\"col-lg-2\"><a href=\"/goal-settings\" analytics-on=\"click\" analytics-event=\"ANL_TgtSetting\" class=\"range-goal click {{hideHeader ? 'hide-header' : ''}}\">{{:: '_GOAL_SETTINGS.TITLE' | translate }}</a></div></div></div><div class=\"d-lg-none filter-container\"><div class=\"row\"><div class=\"col-4 range-title\">{{:: '_DASHBOARD.PERIOD_FILTER.TARGET_RANGE' | translate }}</div><div gnp-date-range-picker=\"\" start=\"periodCtrl.startDate\" end=\"periodCtrl.endDate\" user=\"periodCtrl.user_id\" class=\"col-4 range-selector\"></div><a href=\"/goal-settings\" analytics-on=\"click\" analytics-event=\"ANL_TgtSetting\" class=\"col-4 range-goal click {{hideHeader ? 'hide-header' : ''}}\">{{:: '_GOAL_SETTINGS.TITLE' | translate }}</a></div></div><div class=\"d-lg-none filter-container round\"><div class=\"row\"><div class=\"col-4 range-title\">{{:: '_DASHBOARD.PERIOD_FILTER.TARGET_ROUND' | translate }}</div><div class=\"col-8 round-checkbox\"><div class=\"row mx-0\"><div ng-class=\"{ 'checked-table' : isInclude15 }\" class=\"col-6 round-check border-right-none\"><label><input type=\"checkbox\" ng-model=\"isInclude15\" ng-click=\"clickInclude15(isInclude15)\" class=\"custom-radio\"/><span class=\"course-name\">{{ (isInclude15 ? '_DASHBOARD.PERIOD_FILTER.INCLUDE_1_5_SP' : '_DASHBOARD.PERIOD_FILTER.EXCLUDE_1_5_SP') | translate }}</span></label></div><div ng-class=\"{ 'checked-table' : isInclude05 }\" class=\"col-6 round-check\"><label><input type=\"checkbox\" ng-model=\"isInclude05\" ng-click=\"clickInclude05(isInclude05)\" class=\"custom-radio\"/><span class=\"course-name\">{{ (isInclude05 ? '_DASHBOARD.PERIOD_FILTER.INCLUDE_0_5_SP' : '_DASHBOARD.PERIOD_FILTER.EXCLUDE_0_5_SP') | translate }}</span></label></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("dashboard/period-filter/period-filter.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(556);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/main/_main.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/main/_main.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell,.content-history .history-row .column-score3 .column-date .yyyymmdd,.content-history .history-row .column-date .column-score3 .yyyymmdd,.content-history .history-row .column-score3 .column-date .weather-icon,.content-history .history-row .column-date .column-score3 .weather-icon{width:116px}.history-row .column-score3 .cell .label,.content-history .history-row .column-score3 .column-date .yyyymmdd .label,.content-history .history-row .column-date .column-score3 .yyyymmdd .label,.content-history .history-row .column-score3 .column-date .weather-icon .label,.content-history .history-row .column-date .column-score3 .weather-icon .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.content-calendar .bar-calendar{position:relative;width:100%;height:40px;background-color:#333;background-image:url("+__webpack_require__(465)+");background-repeat:no-repeat;background-position:right center}.content-calendar .bar-calendar a.click{position:relative;left:0;float:right;text-decoration:none;color:#fff;background-color:#ee2e2e}.content-calendar .bar-calendar .select-wrap{position:relative;overflow:hidden;display:inline-block;min-width:12em;width:220px;background-color:#555;background-repeat:no-repeat;background-position:200px 15px;background-image:url("+__webpack_require__(466)+");color:#ddd}.content-calendar .bar-calendar .select-wrap span{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;position:relative;display:block;outline:none;border:0;height:30px;margin:5px 10px;line-height:30px;color:#ddd;font-size:16px;text-indent:.01px;text-overflow:\"\";width:270px}.content-calendar .bar-calendar .round-check{height:50px;line-height:20px}.content-calendar .bar-calendar .round-check.col-6{overflow:hidden}.content-calendar .bar-calendar .round-check.col-6 td{padding-right:10px}.content-calendar .bar-calendar .round-check.border-right-none{border-right:none}.content-calendar .bar-calendar{background-image:none;background-color:transparent}.content-calendar .bar-calendar .filter-container{width:85%;margin:0 auto}.content-calendar .bar-calendar .round{margin-top:20px}.content-calendar .bar-calendar .range-title{font-size:1.1em;height:50px;line-height:50px;background-color:#333;color:#fff;text-align:center;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical}.content-calendar .bar-calendar .range-selector{font-size:1.1em;height:50px;color:#fff;background-color:#4b4b4b;text-align:center;word-break:break-all;white-space:normal}.content-calendar .bar-calendar .range-selector .show-period{line-height:50px}.content-calendar .bar-calendar .range-selector .show-date-only{padding-top:8px}.content-calendar .bar-calendar .range-selector.col-4{padding-left:0;padding-right:0}.content-calendar .bar-calendar .round-checkbox{font-size:1.1em;height:50px;background-color:transparent;text-align:center;padding:0}.content-calendar .bar-calendar .round-checkbox label{font-size:10px;line-height:24px}.content-calendar .bar-calendar a.click{font-size:1.1em;width:33.33333%;padding-top:0;padding-left:0;height:50px;line-height:100px;text-align:center}.content-calendar .bar-calendar tbody tr td{vertical-align:middle}.content-calendar .bar-calendar tbody label{display:block;margin-bottom:0}.content-calendar .bar-calendar .custom-radio{display:none}.content-calendar .bar-calendar .course-name{padding-left:25px;text-indent:-1em;position:relative;font-weight:700}.content-calendar .bar-calendar .course-name::before{content:\"\";display:block;position:absolute;top:3px;left:0;width:15px;height:15px;border:1px solid #4b4b4b;border-radius:4px}.content-calendar .bar-calendar .custom-radio:checked{color:#07a3a4}.content-calendar .bar-calendar .custom-radio:checked+.course-name::after{content:\"\";display:block;position:absolute;top:3px;left:5px;width:7px;height:12px;transform:rotate(40deg);border-bottom:2px solid #fff;border-right:2px solid #fff}.content-calendar .bar-calendar .custom-radio:checked+.course-name::before{background-color:#4b4b4b}.content-calendar .bar-calendar .round-check{border:solid 1px #555}.content-calendar .bar-calendar .round-check.col-6{padding:0 10px}.content-calendar .bar-calendar .round-check.col-6 .course-name{font-size:1.3em;padding-left:35px;display:-webkit-box;-webkit-box-orient:vertical}.content-calendar .bar-calendar .round-check.col-6 .course-name::before{margin:5px 0;height:30px;width:30px}.content-calendar .bar-calendar .round-check.col-6 .course-name::after{top:12px;left:10px;width:10px;height:18px}.content-calendar .bar-calendar .checked-table{background-color:#4b4b4b}.content-calendar .bar-calendar .checked-table .course-name{color:#fff}.content-calendar .bar-calendar .checked-table .course-name::before{border:1px solid #fff}@media (max-width:1024px){.content-calendar .bar-calendar .filter-container{width:96%}.content-calendar .bar-calendar a.click{line-height:50px}}@media (max-width:768px){.content-calendar .bar-calendar .filter-container{width:90%}}@media (max-width:414px){.content-calendar .bar-calendar .filter-container{width:83%}}@media (min-width:768px){.content-calendar .bar-calendar .round-check.col-6 .course-name{font-size:14px;width:200px;display:table-cell;line-height:45px}}@media (min-width:992px){.content-calendar .bar-calendar .round-check.col-6 .course-name{width:250px}.content-calendar .bar-calendar .col-lg-2{padding:0}.content-calendar .bar-calendar .round{margin-top:1px}}@media (min-width:1025px){.content-calendar .bar-calendar .range-goal.click{width:100%;min-height:100px}}.content-history .history-row{height:151px;border-bottom:1px solid #8e8e8e;position:relative;margin-bottom:unset;padding:0;cursor:pointer}.content-history .history-row .column-date{height:150px;padding:0;background-color:#4ac2c2;text-align:center;color:#fff}.content-history .history-row .column-date .cell,.content-history .history-row .column-date .yyyymmdd,.content-history .history-row .column-date .weather-icon{width:100%;height:50px;background-repeat:no-repeat;background-position:center;line-height:50px}.content-history .history-row .column-date .yyyymmdd{margin-top:16%;font-size:27px}@media (max-width:768px){.content-history .history-row .column-date .yyyymmdd{font-size:21px}}.content-history .history-row .column-date .weather-icon.icons-cloudy{background-image:url("+__webpack_require__(370)+")}.content-history .history-row .column-date .weather-icon.icons-foggy{background-image:url("+__webpack_require__(372)+")}.content-history .history-row .column-date .weather-icon.icons-rainy{background-image:url("+__webpack_require__(374)+")}.content-history .history-row .column-date .weather-icon.icons-snowing{background-image:url("+__webpack_require__(376)+")}.content-history .history-row .column-date .weather-icon.icons-sunny{background-image:url("+__webpack_require__(378)+")}.content-history .history-row .column-score{position:relative;height:150px;background-color:#fff;text-align:center;color:#fff}.content-history .history-row .column-score .score-circle{position:absolute;left:63%;top:50%;margin-left:-60px;margin-top:-60px;background-color:#00adad;width:120px;height:120px;border-radius:60px}.content-history .history-row .column-score .score-circle .title{position:absolute;font-size:12px;width:100%;line-height:40px}.content-history .history-row .column-score .score-circle .value{position:absolute;font-size:40px;width:100%;line-height:120px;font-weight:700}@media (max-width:320px){.content-history .history-row .column-score .score-circle{width:100px;height:100px;margin-left:-50px;margin-top:-50px}}.content-history .history-row .icon-round{position:absolute;top:15px;left:15px;width:27px;height:27px;background-repeat:no-repeat;background-position:center;background-size:27px;line-height:27px}.content-history .history-row .icon-round.icons-half-nine{background-image:url("+__webpack_require__(538)+")}.content-history .history-row .icon-round.icons-extra9{background-image:url("+__webpack_require__(539)+")}.content-history .history-row .column-course{position:relative;height:150px;background-color:#fff}.content-history .history-row .column-course .name-list{position:relative}.content-history .history-row .column-course .name-list .name{top:20px;padding:0 20px 0 10px;margin:0 auto;font-weight:700;font-size:16px;height:44.8px;line-height:1.4;-webkit-line-clamp:2}.content-history .history-row .column-course .name-list .name,.content-history .history-row .column-course .name-list .addr{position:relative;display:block;display:-webkit-box;max-width:100%;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}.content-history .history-row .column-course .name-list .addr{padding:15px 25px 5px 10px;font-size:15px;height:40px;line-height:25px;-webkit-line-clamp:1}.content-history .history-row .column-course .cell-wrap{padding-right:20px}.content-history .history-row .column-course .cell-wrap .cell,.content-history .history-row .column-course .cell-wrap .column-date .yyyymmdd,.content-history .history-row .column-date .column-course .cell-wrap .yyyymmdd,.content-history .history-row .column-course .cell-wrap .column-date .weather-icon,.content-history .history-row .column-date .column-course .cell-wrap .weather-icon{top:85px;color:gray;background-color:#f2f2f2;width:100%;height:45px;border-radius:5px;border-color:#f2f2f2;border-width:2px;border-style:solid}.content-history .history-row .column-course .cell-wrap .cell .content,.content-history .history-row .column-course .cell-wrap .column-date .yyyymmdd .content,.content-history .history-row .column-date .column-course .cell-wrap .yyyymmdd .content,.content-history .history-row .column-course .cell-wrap .column-date .weather-icon .content,.content-history .history-row .column-date .column-course .cell-wrap .weather-icon .content{display:block;display:-webkit-box;padding:5px 10px 0;margin:0 auto;font-size:12px;max-width:100%;height:33.6px;line-height:1.4;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}.content-history .etc{text-align:center}.content-history .btn-more{background-color:#000;width:180px;height:35px;border-radius:4px;border-color:#000;border-width:2px;border-style:solid;font-size:12px;color:#fff}@media (max-width:768px){.content-history .history-row .column-score .score-circle{left:60%}}@media (max-width:414px){.content-history .history-row{height:141px}.content-history .history-row .column-date{height:140px;background-color:#4ac2c2}.content-history .history-row .column-date .cell,.content-history .history-row .column-date .yyyymmdd,.content-history .history-row .column-date .weather-icon{width:100%;height:46.66667px;line-height:46.66667px}.content-history .history-row .column-date .yyyymmdd{margin-top:16%;font-size:19px}.content-history .history-row .column-score{height:140px}.content-history .history-row .column-score .score-circle{left:64%;margin-left:-50px;margin-top:-50px;background-color:#00adad;width:100px;height:100px;border-radius:50px}.content-history .history-row .column-score .score-circle .title{font-size:10px;line-height:33.33333px}.content-history .history-row .column-score .score-circle .value{font-size:30px;line-height:100px}.content-history .history-row .column-course{height:140px}.content-history .history-row .column-course .name-list .name{top:10px}.content-history .history-row .column-course .name-list .addr{padding-top:10px}.content-history .history-row .column-course .cell-wrap{padding-right:0}.content-history .history-row .column-course .cell-wrap .cell,.content-history .history-row .column-course .cell-wrap .column-date .yyyymmdd,.content-history .history-row .column-date .column-course .cell-wrap .yyyymmdd,.content-history .history-row .column-course .cell-wrap .column-date .weather-icon,.content-history .history-row .column-date .column-course .cell-wrap .weather-icon{top:80px;color:gray;background-color:#f2f2f2;width:100%;height:35px;border-radius:5px;border-color:#f2f2f2;border-width:2px;border-style:solid}.content-history .history-row .icon-round{top:22px;left:15px;width:22px;height:22px;background-size:22px;line-height:22px}}@media (max-width:375px){.content-history .history-row{height:131px}.content-history .history-row .column-date{height:130px;background-color:#4ac2c2}.content-history .history-row .column-date .cell,.content-history .history-row .column-date .yyyymmdd,.content-history .history-row .column-date .weather-icon{width:100%;height:43.33333px;line-height:43.33333px}.content-history .history-row .column-date .yyyymmdd{margin-top:16%;font-size:16px}.content-history .history-row .column-score{height:130px}.content-history .history-row .column-score .score-circle{left:66%;margin-left:-40px;margin-top:-40px;background-color:#00adad;width:80px;height:80px;border-radius:40px}.content-history .history-row .column-score .score-circle .title{font-size:10px;line-height:26.66667px}.content-history .history-row .column-score .score-circle .value{font-size:30px;line-height:80px}.content-history .history-row .column-course{height:130px}.content-history .history-row .column-course .name-list .name{top:10px}.content-history .history-row .column-course .name-list .addr{padding-top:10px}.content-history .history-row .column-course .cell-wrap{padding-right:0}.content-history .history-row .column-course .cell-wrap .cell,.content-history .history-row .column-course .cell-wrap .column-date .yyyymmdd,.content-history .history-row .column-date .column-course .cell-wrap .yyyymmdd,.content-history .history-row .column-course .cell-wrap .column-date .weather-icon,.content-history .history-row .column-date .column-course .cell-wrap .weather-icon{top:75px;color:gray;background-color:#f2f2f2;width:100%;height:30px;border-radius:5px;border-color:#f2f2f2;border-width:2px;border-style:solid}}@media (max-width:360px){.content-history .history-row .column-score .score-circle{left:67%}}@media (max-width:320px){.content-history .history-row .column-date .yyyymmdd{font-size:14px}.content-history .history-row .column-course{width:40%}.content-history .history-row .column-score .score-circle{left:63%}.content-history .history-row .icon-round{top:20px;left:10px;width:20px;height:20px;background-size:20px;line-height:20px}}.content-ranking{position:relative;margin-top:30px;margin-bottom:20px}.content-ranking .list-width{padding:0}.content-ranking .list-width .content-wrap{width:310px;position:relative;margin:0 auto 0 0;padding:0}.content-ranking .list-width .content-wrap.center{margin:0 auto}.content-ranking .list-width .content-wrap.right{margin:0 0 0 auto}.content-ranking .list-width .content-wrap .title{position:relative;width:100%;height:46px;background-color:#aeb8b7;background-repeat:no-repeat;background-image:url("+__webpack_require__(557)+");color:#fff;line-height:46px;text-indent:56px;font-size:11pt}.content-ranking .list-width .content-wrap .row{margin:0;position:relative;width:100%;height:90px;background-color:#fff}.content-ranking .list-width .content-wrap .row.pointer{cursor:pointer;display:block}.content-ranking .list-width .content-wrap .row .column-value,.content-ranking .list-width .content-wrap .row .best-score-column-value{position:relative;height:90px;text-align:center;float:left}.content-ranking .list-width .content-wrap .row .column-value .chart,.content-ranking .list-width .content-wrap .row .best-score-column-value .chart{position:absolute;top:50%;left:50%;width:70px;height:70px;margin-left:-35px;margin-top:-35px}.content-ranking .list-width .content-wrap .row .column-value .value-circle,.content-ranking .list-width .content-wrap .row .best-score-column-value .value-circle{position:absolute;left:65%;top:50%;margin-left:-33px;margin-top:-33px;background-color:#00adad;width:66px;height:66px;border-radius:33px;color:#fff;font-size:25px;line-height:66px}.content-ranking .list-width .content-wrap .row .column-value .value-round-rect,.content-ranking .list-width .content-wrap .row .best-score-column-value .value-round-rect{position:absolute;left:50%;top:50%;margin-left:-32px;margin-top:-32px;color:#fff;font-size:25px;line-height:64px;background-color:#aeb8b7;width:64px;height:64px;border-radius:3px;border-color:#aeb8b7;border-width:2px;border-style:solid}.content-ranking .list-width .content-wrap .row .column-value .icon-round,.content-ranking .list-width .content-wrap .row .best-score-column-value .icon-round{position:absolute;top:10px;left:10px;width:25px;height:25px;background-repeat:no-repeat;background-position:center;background-size:25px;line-height:25px}.content-ranking .list-width .content-wrap .row .column-value .icon-round.icons-half-nine,.content-ranking .list-width .content-wrap .row .best-score-column-value .icon-round.icons-half-nine{background-image:url("+__webpack_require__(538)+")}.content-ranking .list-width .content-wrap .row .column-value .icon-round.icons-extra9,.content-ranking .list-width .content-wrap .row .best-score-column-value .icon-round.icons-extra9{background-image:url("+__webpack_require__(539)+")}.content-ranking .list-width .content-wrap .row .column-value{width:80px}.content-ranking .list-width .content-wrap .row .column-content,.content-ranking .list-width .content-wrap .row .best-score-column-content{position:relative;height:90px;float:left;font-size:12px;line-height:20px}.content-ranking .list-width .content-wrap .row .column-content .date,.content-ranking .list-width .content-wrap .row .best-score-column-content .date{margin:10px 0 5px;font-size:16px;color:#00adad}.content-ranking .list-width .content-wrap .row .column-content .desc,.content-ranking .list-width .content-wrap .row .best-score-column-content .desc{position:relative;display:block;display:-webkit-box;top:5px;padding-right:10px;margin:0 auto;font-size:12px;max-width:100%;-webkit-line-height:1.4;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}.content-ranking .list-width .content-wrap .row .column-content{width:230px}.content-ranking .list-width .content-wrap .row .best-score-column-value{width:35%}.content-ranking .list-width .content-wrap .row .best-score-column-content{width:65%}@media (max-width:768px){.content-ranking .list-width .content-wrap{width:97%}.content-ranking .list-width .content-wrap .row .column-value{width:33%}.content-ranking .list-width .content-wrap .row .column-content{width:67%}.content-ranking .list-width .content-wrap .row .best-score-column-value .value-circle{position:absolute;left:65%;top:50%;margin-left:-20px;margin-top:-20px;background-color:#00adad;width:40px;height:40px;border-radius:20px;color:#fff;font-size:20px;line-height:40px}}@media (max-width:414px){.content-ranking .list-width .content-wrap .row .column-value{width:25%}.content-ranking .list-width .content-wrap .row .column-content{width:75%}.content-ranking .list-width .content-wrap .row .best-score-column-value{width:30%}.content-ranking .list-width .content-wrap .row .best-score-column-value .value-circle{margin-left:-33px;margin-top:-33px;background-color:#00adad;width:66px;height:66px;border-radius:33px;font-size:25px;line-height:66px}.content-ranking .list-width .content-wrap .row .best-score-column-content{width:70%}.content-ranking .list-width .content-wrap .row .icon-round{position:absolute;top:10px;left:10px;width:30px;height:30px;background-repeat:no-repeat;background-position:center;background-size:30px;line-height:30px}.content-ranking .list-width .content-wrap .row .icon-round.icons-half-nine{background-image:url("+__webpack_require__(538)+")}.content-ranking .list-width .content-wrap .row .icon-round.icons-extra9{background-image:url("+__webpack_require__(539)+")}}@media (max-width:375px){.content-ranking .list-width .content-wrap .row .best-score-column-value .value-circle{margin-left:-25px;margin-top:-25px;background-color:#00adad;width:50px;height:50px;border-radius:25px;font-size:20px;line-height:50px}}.content-charts,.content-score-charts{width:100%;background-color:#c2cccc;margin-bottom:20px;padding-top:20px}.content-charts .freemode,.content-score-charts .freemode{opacity:.3}.content-charts .charts,.content-score-charts .charts{background-color:#e5e5e5;margin-bottom:20px}.content-charts .column,.content-score-charts .column{height:210px;margin-bottom:20px}.content-charts .bar-layer,.content-score-charts .bar-layer{position:absolute;width:340px;height:56px;top:139px;left:120px}.content-charts .bar-layer .bar-avg-score,.content-score-charts .bar-layer .bar-avg-score{position:absolute;height:18px;top:16px;background-color:#00adad}.content-charts .bar-layer .bar-all-avg-score,.content-score-charts .bar-layer .bar-all-avg-score{position:absolute;height:18px;top:38px;background-color:#b2af98}.content-charts .bar-layer .pin-goal,.content-score-charts .bar-layer .pin-goal{position:absolute;width:54px;height:56px;margin-left:-6px;background-image:url("+__webpack_require__(470)+")}.content-charts .score-circle,.content-score-charts .score-circle{position:absolute;left:30px;top:50%;margin-top:-90px;color:#fff;text-align:center;background-color:#00adad;width:180px;height:180px;border-radius:90px}.content-charts .score-circle .title,.content-score-charts .score-circle .title{position:absolute;font-size:12px;width:100%;line-height:60px}.content-charts .score-circle .value,.content-score-charts .score-circle .value{position:absolute;font-size:50px;font-weight:700;width:100%;line-height:180px}.content-charts .score-circle .hole,.content-score-charts .score-circle .hole{position:absolute;top:120px;font-size:10px;width:100%;line-height:60px}.content-charts .help-circle,.content-score-charts .help-circle{position:absolute;width:42px;height:42px;left:300px;top:20px;background-image:url("+__webpack_require__(18)+");background-size:42px}.content-charts .goal-circle,.content-score-charts .goal-circle{position:absolute;top:30px;left:50%;color:#fff;text-align:center;background-color:#ee2e2e;width:90px;height:90px;border-radius:45px}.content-charts .goal-circle .title,.content-score-charts .goal-circle .title{position:absolute;font-size:12px;width:100%;line-height:30px}.content-charts .goal-circle .value,.content-score-charts .goal-circle .value{position:absolute;font-size:22px;font-weight:700;width:100%;line-height:90px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{position:absolute;left:80%;top:30px;color:#7c7a6a;text-align:center;background-color:#b2af98;width:90px;height:90px;border-radius:45px}.content-charts .all-score-circle .title,.content-score-charts .all-score-circle .title{position:absolute;font-size:12px;width:100%;line-height:30px}.content-charts .all-score-circle .value,.content-score-charts .all-score-circle .value{position:absolute;font-size:22px;font-weight:700;width:100%;line-height:90px}.content-charts .column-chart-percent,.content-score-charts .column-chart-percent{height:230px}.content-charts .column-chart-percent .chart,.content-score-charts .column-chart-percent .chart{position:absolute;width:170px;height:170px;top:10px;left:40%}.content-charts .column-chart-percent .sub-title,.content-score-charts .column-chart-percent .sub-title{position:absolute;top:182px;left:132px;font-size:12px;font-weight:700;width:180px;height:20px;text-align:center;color:#00adad}@media (max-width:414px){.content-charts .column-chart-percent .sub-title,.content-score-charts .column-chart-percent .sub-title{left:148px}}.content-charts .column-chart-percent .goal,.content-score-charts .column-chart-percent .goal{left:20px;top:80px;width:150px;position:absolute}.content-charts .column-chart-percent .goal .circle,.content-score-charts .column-chart-percent .goal .circle{position:relative;float:left;color:#fff;text-align:center;font-size:10px;line-height:40px;background-color:#ee2e2e;width:40px;height:40px;border-radius:20px}.content-charts .column-chart-percent .goal .value,.content-score-charts .column-chart-percent .goal .value{position:relative;left:5px;font-size:18px;font-weight:700;width:100%;color:#ee2e2e;line-height:40px}.content-charts .column-chart-percent .all-avg,.content-score-charts .column-chart-percent .all-avg{left:20px;top:130px;width:150px;position:absolute}.content-charts .column-chart-percent .all-avg .circle,.content-score-charts .column-chart-percent .all-avg .circle{position:relative;float:left;color:#7c7a6a;text-align:center;font-size:10px;line-height:14px;background-color:#b2af98;width:40px;border-radius:20px;height:40px;padding-top:6px}.content-charts .column-chart-percent .all-avg .value,.content-score-charts .column-chart-percent .all-avg .value{position:relative;left:5px;font-size:18px;font-weight:700;width:100%;color:#7c7a6a;line-height:40px}@media (max-width:768px){.content-charts .help-circle,.content-score-charts .help-circle{left:460px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{position:absolute;left:80%;top:30px;color:#7c7a6a;text-align:center;background-color:#b2af98;width:120px;height:120px;border-radius:60px}.content-charts .all-score-circle .title,.content-score-charts .all-score-circle .title{position:absolute;font-size:12px;width:100%;line-height:40px}.content-charts .all-score-circle .value,.content-score-charts .all-score-circle .value{position:absolute;font-size:22px;font-weight:700;width:100%;line-height:120px}.content-charts .goal-circle,.content-score-charts .goal-circle{position:absolute;top:30px;left:50%;color:#fff;text-align:center;background-color:#ee2e2e;width:120px;height:120px;border-radius:60px}.content-charts .goal-circle .title,.content-score-charts .goal-circle .title{position:absolute;font-size:12px;width:100%;line-height:40px}.content-charts .goal-circle .value,.content-score-charts .goal-circle .value{position:absolute;font-size:22px;font-weight:700;width:100%;line-height:120px}.content-charts .column-chart-percent .chart,.content-score-charts .column-chart-percent .chart{left:45%}.content-charts .column-chart-percent .sub-title,.content-score-charts .column-chart-percent .sub-title{left:172px}.content-charts .column-chart-percent .goal,.content-charts .column-chart-percent .all-avg,.content-score-charts .column-chart-percent .goal,.content-score-charts .column-chart-percent .all-avg{left:60px}}@media (max-width:767px){.content-charts .score-circle-charts-wrap,.content-score-charts .score-circle-charts-wrap{padding:10px}.content-charts .score-circle,.content-score-charts .score-circle{left:10px;width:150px;height:150px;border-radius:75px}.content-charts .score-circle .value,.content-score-charts .score-circle .value{font-size:40px;line-height:150px}.content-charts .score-circle .hole,.content-score-charts .score-circle .hole{top:70px}.content-charts .bar-layer,.content-score-charts .bar-layer{width:350px;height:37px;top:107px;left:70px}.content-charts .goal-circle,.content-charts .all-score-circle,.content-score-charts .goal-circle,.content-score-charts .all-score-circle{width:68px;height:68px;top:19.8px}.content-charts .goal-circle .title,.content-charts .all-score-circle .title,.content-score-charts .goal-circle .title,.content-score-charts .all-score-circle .title{font-size:8px}.content-charts .goal-circle .value,.content-charts .all-score-circle .value,.content-score-charts .goal-circle .value,.content-score-charts .all-score-circle .value{line-height:68px}.content-charts .goal-circle,.content-score-charts .goal-circle{left:210px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{left:290px}}@media (max-width:414px){.content-charts .bar-layer,.content-score-charts .bar-layer{width:283px;left:100px}.content-charts .help-circle,.content-score-charts .help-circle{width:30px;height:30px;left:242px;top:15px;background-size:30px}.content-charts .goal-circle,.content-score-charts .goal-circle{left:200px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{left:315px}.content-charts .column-chart-percent .chart,.content-score-charts .column-chart-percent .chart{left:40%}.content-charts .column-chart-percent .goal,.content-charts .column-chart-percent .all-avg,.content-score-charts .column-chart-percent .goal,.content-score-charts .column-chart-percent .all-avg{left:20px}}@media (max-width:375px){.content-charts .bar-layer,.content-score-charts .bar-layer{width:247px;left:100px}.content-charts .help-circle,.content-score-charts .help-circle{left:224px}.content-charts .goal-circle,.content-score-charts .goal-circle{left:183px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{left:275px}}@media (max-width:360px){.content-charts .bar-layer,.content-score-charts .bar-layer{width:235px;left:100px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{left:265px}}@media (max-width:320px){.content-charts .score-circle-charts-wrap,.content-score-charts .score-circle-charts-wrap{padding:0}.content-charts .bar-layer,.content-score-charts .bar-layer{width:208px;left:100px}.content-charts .goal-circle,.content-score-charts .goal-circle{left:163px}.content-charts .all-score-circle,.content-score-charts .all-score-circle{left:240px}.content-charts .help-circle,.content-score-charts .help-circle{left:206px}}a.score-float-icon{background-image:url("+__webpack_require__(540)+");width:150px;background-size:150px;height:150px;border-radius:20px;background-color:transparent;border-color:transparent}a.score-float-icon,.score-float-icon-wrap .help-circle{position:fixed;right:2%;top:80%;z-index:1;background-repeat:no-repeat;background-position:center}.score-float-icon-wrap .help-circle{width:60px;height:60px;background-size:60px;background-image:url("+__webpack_require__(18)+")}.score-float-icon-wrap .help-circle.freemode{opacity:1}.freemode{opacity:.3}@media (max-width:1024px){a.score-float-icon{right:5%}}@media (max-width:768px){a.score-float-icon{right:3%}}@media (max-width:414px){a.score-float-icon{right:3px;width:100px;height:100px;background-size:100px}.score-float-icon-wrap .help-circle{right:1%;top:80%;width:45px;height:45px;background-size:45px}}@media (max-width:412px){a.score-float-icon{right:4px;width:100px;height:100px;background-size:100px}}@media (max-width:375px){a.score-float-icon{right:1px}.score-float-icon-wrap .help-circle{right:-.5%}}@media (max-width:360px){a.score-float-icon{right:0}}@media (max-width:320px){a.score-float-icon{right:-3px}}.daterangepicker.ltr.show-ranges.opensright{left:670px!important}.daterangepicker.ltr.show-ranges.opensright:before,.daterangepicker.ltr.show-ranges.opensright:after{left:60px}.daterangepicker.ltr.show-ranges.opensright.show-calendar{left:470px!important}.daterangepicker.ltr.show-ranges.opensright.show-calendar:before,.daterangepicker.ltr.show-ranges.opensright.show-calendar:after{left:260px}@media (max-width:1024px){.daterangepicker.ltr.show-ranges.opensright.show-calendar{right:auto!important;left:180px!important}.daterangepicker.ltr.show-ranges.opensright{left:440px!important}.daterangepicker.ltr.show-ranges.opensright.show-calendar:before,.daterangepicker.ltr.show-ranges.opensright.show-calendar:after{left:320px}.daterangepicker.ltr.show-ranges.opensright:before,.daterangepicker.ltr.show-ranges.opensright:after{left:66px}}@media (max-width:768px){.daterangepicker.ltr.show-ranges.opensright{left:312px!important}.daterangepicker.ltr.show-ranges.opensright.show-calendar{right:auto!important;left:50px!important}}@media (max-width:414px){.daterangepicker.ltr.show-ranges.opensright,.daterangepicker.ltr.show-ranges.opensright.show-calendar{left:70px!important}.daterangepicker.ltr.show-ranges.opensright:before,.daterangepicker.ltr.show-ranges.opensright:after,.daterangepicker.ltr.show-ranges.opensright.show-calendar:before,.daterangepicker.ltr.show-ranges.opensright.show-calendar:after{left:130px}.applyBtn.btn-success{margin:15px 0 10px}}@media (max-width:375px){.daterangepicker.ltr.show-ranges.opensright,.daterangepicker.ltr.show-ranges.opensright.show-calendar{left:50px!important}}@media (max-width:360px){.daterangepicker.ltr.show-ranges.opensright,.daterangepicker.ltr.show-ranges.opensright.show-calendar{left:40px!important}}@media (max-width:320px){.daterangepicker.ltr.show-ranges.opensright,.daterangepicker.ltr.show-ranges.opensright.show-calendar{left:20px!important}}#main-main .container.dashboard-container{max-width:none!important;width:970px}#main-main .score-circle-charts-wrap{margin-top:100px}@media (max-width:768px){#main-main .container.dashboard-container{width:100%}}#main-main .cell,#main-main .content-history .history-row .column-date .yyyymmdd,.content-history .history-row .column-date #main-main .yyyymmdd,#main-main .content-history .history-row .column-date .weather-icon,.content-history .history-row .column-date #main-main .weather-icon{padding:0}.data{position:relative;min-height:130px;margin:20px auto;padding:20px 0 0;background-color:#fff}.data .no-title{padding-bottom:20px;text-align:center;font-size:25px;color:#000}.data .create-link{text-align:center;font-size:22px;text-decoration:none}", ""]);

/***/ }),
/* 557 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAMAAABgZ9sFAAAA2FBMVEX/qgD/qwT/rAX/rAf/rQr/rgz/rw//sBL/sRT/sRb/tB//tSH/tiT/tyf/uS7/ui//ujD/w0r/w0v/w0z/xE//xVH/xlT/xlX/x1f/yVz/yV7/ymH/z2//0HL/0nf/0nn/03v/1H7/1YD/1YH/1YL/14j/3JX/3Jf/35//4KL/4qj/46r/46v/5K3/5K7/5bD/57f/57j/6b3/6b7/6r//6sD/6sH/9N7/9eD/9eH/9eL/9uT/9+b/9+j/+On/+Ov/+e3/+u//+vD/+vH/+/P//v3///7///9Jsoi5AAAA3ElEQVQYGe3Bx1bCQACG0V9jryRqomJXLIBiwUJIQFH53v+NnOzmeMxMFi5zr2q1vwXNZqDqOnCr6j7hS9V1oCe/KMtCGcH9QyAjyrJQ5QaQq/D0rMIAcpVLIVfhfaJCCrnKRfn3vowVWJWxxzCSy3VXxjbsyGjfyO2YWNIpnEuKOZFbzHhZuoOetDRiV24b0JVe4U1qQ0Nuc1NIFqbAYgzMyyOFcYKRjGAon0dggvEB9OVzieVKPgdYDuUTYtmSzxqWdfnMtCyz+mebR5aGfPpYXuRz1rJcqFb77QcbqTTJ+DqBGQAAAABJRU5ErkJggg=="

/***/ }),
/* 558 */
/***/ (function(module, exports) {

	var DashboardCtrl;
	
	DashboardCtrl = function($scope, $location, $filter, $analytics, flash, userInfo) {
	  var code, options;
	  $analytics.eventTrack('DSB_loaded');
	  $scope.hasHistories = true;
	  $scope.userInfo = userInfo;
	  $scope.$on("historiesLoaded.gnp.dashboard", function(event, hasHistories) {
	    return $scope.hasHistories = hasHistories;
	  });
	  $scope.hideHeader = false;
	  if ($location.search().msg_code) {
	    options = {
	      timeOut: '0',
	      extendedTimeOut: '0'
	    };
	    code = $location.search().msg_code;
	    flash.warning($filter('translate')("_DASHBOARD.MESSAGES." + code), options);
	    return $location.search('msg_code', null);
	  }
	};
	
	DashboardCtrl.$inject = ['$scope', '$location', '$filter', '$analytics', 'flash', 'userInfo'];
	
	module.exports = DashboardCtrl;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	var HistoryCtrl, _, moment;
	
	moment = __webpack_require__(126);
	
	_ = __webpack_require__(87);
	
	HistoryCtrl = function($scope, $location, DashboardService) {
	  var callMyAnalysis, createMyAnalysisParams, prepareParams, processData;
	  $scope.histories = [];
	  $scope.isLoading = true;
	  processData = function(data) {
	    return data.map(function(item) {
	      return _.merge({}, item, {
	        course_analysis: {
	          best_score: item.course_analysis.best_score || "-",
	          avg_total_shot: item.course_analysis.avg_total_shot || "-"
	        },
	        play_date: moment(item.play_date).format("YYYY/MM/DD"),
	        rat_par_on: item.rat_par_on * 100,
	        rat_fairway_center: item.rat_fairway_center * 100,
	        rat_bogey_on: item.rat_bogey_on * 100
	      });
	    });
	  };
	  callMyAnalysis = function(params) {
	    if (params == null) {
	      params = {};
	    }
	    $scope.isLoading = true;
	    return DashboardService.getHistories(params).then(function(res) {
	      return $scope.histories = processData(res.score_cards);
	    })["finally"](function() {
	      $scope.isLoading = false;
	      return $scope.$emit("historiesLoaded.gnp.dashboard", $scope.histories.length > 0);
	    });
	  };
	  createMyAnalysisParams = function() {
	    return {
	      from: $scope.startDate,
	      to: $scope.endDate,
	      round_type: $scope.roundType
	    };
	  };
	  $scope.$parent.$on("periodSelected.gnp.dashboard", function(event, startDate, endDate, roundType) {
	    var params;
	    $scope.startDate = startDate != null ? startDate.clone() : void 0;
	    $scope.endDate = endDate != null ? endDate.clone() : void 0;
	    $scope.roundType = roundType;
	    params = createMyAnalysisParams();
	    return callMyAnalysis(params);
	  });
	  $scope.$parent.$on("roundTypeUpdated.gnp.dashboard", function(event, roundType) {
	    var params;
	    $scope.roundType = roundType;
	    params = createMyAnalysisParams();
	    return callMyAnalysis(params);
	  });
	  $scope.classForRoundIcons = function(history) {
	    switch (history.round_type) {
	      case 1.5:
	        return 'icons-extra9';
	      case 0.5:
	        return 'icons-half-nine';
	      default:
	        return '';
	    }
	  };
	  $scope.navigateToHistory = function() {
	    return $location.path("/history");
	  };
	  $scope.showScoreCardDetail = function(id) {
	    return $location.path('/round-detail/' + id);
	  };
	  return prepareParams = function(options) {
	    var ref;
	    return _.pickBy({
	      from: (options.from ? options.from.format("YYYY-MM-DD") : void 0),
	      to: (options.to ? options.to.format("YYYY-MM-DD") : void 0),
	      round_type: (ref = options.round_type) != null ? ref.join(',') : void 0
	    }, function(v) {
	      return v !== null && v !== void 0;
	    });
	  };
	};
	
	HistoryCtrl.$inject = ['$scope', '$location', 'DashboardService'];
	
	module.exports = HistoryCtrl;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	var DashboardBestScoreCtrl, _, moment;
	
	moment = __webpack_require__(126);
	
	_ = __webpack_require__(87);
	
	DashboardBestScoreCtrl = function($scope, $location, DashboardService) {
	  var callMyAnalysis, createMyAnalysisParams, processData;
	  $scope.isLoading = true;
	  $scope.bestScores = [];
	  processData = function(data) {
	    return data.map(function(item) {
	      return _.merge({}, item, {
	        play_date: moment(item.play_date).format("YYYY/MM/DD")
	      });
	    });
	  };
	  $scope.classForRoundIcons = function(item) {
	    switch (item.round_type) {
	      case 1.5:
	        return 'icons-extra9';
	      case 0.5:
	        return 'icons-half-nine';
	      default:
	        return '';
	    }
	  };
	  $scope.showScoreCardDetail = function(id) {
	    return $location.path("/round-detail/" + id);
	  };
	  createMyAnalysisParams = function() {
	    return {
	      from: $scope.startDate,
	      to: $scope.endDate,
	      round_type: $scope.roundType
	    };
	  };
	  callMyAnalysis = function(params) {
	    if (params == null) {
	      params = {};
	    }
	    $scope.isLoading = true;
	    return DashboardService.getBestScores(params).then(function(res) {
	      return $scope.bestScores = processData(res.best_scores);
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  };
	  $scope.$parent.$on("periodSelected.gnp.dashboard", function(event, startDate, endDate, roundType) {
	    var params;
	    $scope.startDate = startDate != null ? startDate.clone() : void 0;
	    $scope.endDate = endDate != null ? endDate.clone() : void 0;
	    $scope.roundType = roundType;
	    params = createMyAnalysisParams();
	    return callMyAnalysis(params);
	  });
	  return $scope.$parent.$on("roundTypeUpdated.gnp.dashboard", function(event, roundType) {
	    var params;
	    $scope.roundType = roundType;
	    params = createMyAnalysisParams();
	    return callMyAnalysis(params);
	  });
	};
	
	DashboardBestScoreCtrl.$inject = ['$scope', '$location', 'DashboardService'];
	
	module.exports = DashboardBestScoreCtrl;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	var DashboardFavoriteCourseCtrl, _, moment;
	
	moment = __webpack_require__(126);
	
	_ = __webpack_require__(87);
	
	DashboardFavoriteCourseCtrl = function($scope, DashboardService) {
	  var callMyAnalysis, createMyAnalysisParams, processData;
	  $scope.isLoading = true;
	  $scope.favoriteCourses = [];
	  processData = function(data) {
	    return data.map(function(item) {
	      return _.merge({}, item, {
	        play_date: moment(item.play_date).format("YYYY/MM/DD")
	      });
	    });
	  };
	  createMyAnalysisParams = function() {
	    return {
	      from: $scope.startDate,
	      to: $scope.endDate,
	      round_type: $scope.roundType
	    };
	  };
	  callMyAnalysis = function(params) {
	    if (params == null) {
	      params = {};
	    }
	    $scope.isLoading = true;
	    return DashboardService.getFavoriteCourses(params).then(function(res) {
	      return $scope.favoriteCourses = processData(res.courses);
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  };
	  $scope.$parent.$on("periodSelected.gnp.dashboard", function(event, startDate, endDate, roundType) {
	    var params;
	    $scope.startDate = startDate != null ? startDate.clone() : void 0;
	    $scope.endDate = endDate != null ? endDate.clone() : void 0;
	    $scope.roundType = roundType;
	    params = createMyAnalysisParams();
	    return callMyAnalysis(params);
	  });
	  return $scope.$parent.$on("roundTypeUpdated.gnp.dashboard", function(event, roundType) {
	    var params;
	    $scope.roundType = roundType;
	    params = createMyAnalysisParams();
	    return callMyAnalysis(params);
	  });
	};
	
	DashboardFavoriteCourseCtrl.$inject = ['$scope', 'DashboardService'];
	
	module.exports = DashboardFavoriteCourseCtrl;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	var DashboardFairwayHitCtrl, _, moment;
	
	moment = __webpack_require__(126);
	
	_ = __webpack_require__(87);
	
	DashboardFairwayHitCtrl = function($scope, DashboardService) {
	  var callMyAnalysis, createMyAnalysisParams, processData;
	  $scope.isLoading = true;
	  $scope.topFairwayHitCourses = [];
	  processData = function(data) {
	    return data.map(function(item) {
	      return _.merge({}, item, {
	        play_date: moment(item.play_date).format("YYYY/MM/DD")
	      });
	    });
	  };
	  createMyAnalysisParams = function() {
	    return {
	      from: $scope.startDate,
	      to: $scope.endDate,
	      round_type: $scope.roundType
	    };
	  };
	  callMyAnalysis = function(params) {
	    if (params == null) {
	      params = {};
	    }
	    $scope.isLoading = true;
	    return DashboardService.getTopFairwayHitCourses(params).then(function(res) {
	      return $scope.topFairwayHitCourses = processData(res.courses);
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  };
	  $scope.$parent.$on("periodSelected.gnp.dashboard", function(event, startDate, endDate, roundType) {
	    var params;
	    $scope.startDate = startDate != null ? startDate.clone() : void 0;
	    $scope.endDate = endDate != null ? endDate.clone() : void 0;
	    $scope.roundType = roundType;
	    params = createMyAnalysisParams();
	    return callMyAnalysis(params);
	  });
	  return $scope.$parent.$on("roundTypeUpdated.gnp.dashboard", function(event, roundType) {
	    var params;
	    $scope.roundType = roundType;
	    params = createMyAnalysisParams();
	    return callMyAnalysis(params);
	  });
	};
	
	DashboardFairwayHitCtrl.$inject = ['$scope', 'DashboardService'];
	
	module.exports = DashboardFairwayHitCtrl;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	var BasicAnalysisCtrl, moment;
	
	moment = __webpack_require__(126);
	
	BasicAnalysisCtrl = function($scope, $filter, ScoreCardAPIService, GoalAPIService, DashboardBasicAnalysisService, cache) {
	  var callMyAnalysis, createMyAnalysisParams;
	  $scope.isLoading = false;
	  $scope.basicAnalysisData = {
	    goal: void 0,
	    my_avg: void 0,
	    all_members: void 0
	  };
	  callMyAnalysis = function(params) {
	    if (params == null) {
	      params = {};
	    }
	    $scope.isLoading = true;
	    return DashboardBasicAnalysisService.getMyAnalysis(params).then(function(res) {
	      return $scope.basicAnalysisData.my_avg = res.data;
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  };
	  createMyAnalysisParams = function() {
	    return {
	      from: $scope.startDate,
	      to: $scope.endDate,
	      round_type: $scope.roundType
	    };
	  };
	  ScoreCardAPIService.getAllMembers().then(function(data) {
	    return $scope.basicAnalysisData.all_members = data;
	  });
	  GoalAPIService.getGoalSettings().then(function(res) {
	    return $scope.basicAnalysisData.goal = res;
	  });
	  $scope.$on("periodSelected.gnp.dashboard", function(event, startDate, endDate, roundType) {
	    var params;
	    $scope.startDate = startDate != null ? startDate.clone() : void 0;
	    $scope.endDate = endDate != null ? endDate.clone() : void 0;
	    $scope.roundType = roundType;
	    params = createMyAnalysisParams();
	    return callMyAnalysis(params);
	  });
	  return $scope.$on("roundTypeUpdated.gnp.dashboard", function(event, roundType) {
	    var params;
	    $scope.roundType = roundType;
	    params = createMyAnalysisParams();
	    return callMyAnalysis(params);
	  });
	};
	
	BasicAnalysisCtrl.$inject = ['$scope', '$filter', 'ScoreCardAPIService', 'GoalAPIService', 'DashboardBasicAnalysisService', 'cache'];
	
	module.exports = BasicAnalysisCtrl;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	var PeriodFilterCtrl, _, moment,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	PeriodFilterCtrl = (function() {
	  function PeriodFilterCtrl($scope, $filter) {
	    var endDate, label, ref, roundType, startDate;
	    this.$scope = $scope;
	    this.$filter = $filter;
	    this._publishChange = bind(this._publishChange, this);
	    this.user_id = (ref = this.$scope.userInfo) != null ? ref.user_id : void 0;
	    startDate = localStorage.getItem(this.user_id + "_FILTER_PERIOD_START_DATE");
	    endDate = localStorage.getItem(this.user_id + "_FILTER_PERIOD_END_DATE");
	    this.startDate = startDate != null ? moment(startDate) : moment().subtract(10, 'years');
	    this.endDate = endDate != null ? moment(endDate) : moment().endOf('year');
	    label = localStorage.getItem(this.user_id + "_FILTER_PERIOD_SELECTED_LABEL");
	    if (label === this.$filter('translate')('_ANALYSIS.PERIOD_FILTER.ENTIRE_PERIOD')) {
	      this.endDate = moment().endOf('year');
	    }
	    this.$scope.$watch(((function(_this) {
	      return function() {
	        return _this.startDate + _this.endDate;
	      };
	    })(this)), this._publishChange);
	    roundType = localStorage.getItem(this.user_id + "_FILTER_roundType");
	    this.$scope.roundType = roundType != null ? JSON.parse(roundType) : [1, 1.5];
	    this.$scope.isInclude15 = JSON.parse(localStorage.getItem(this.user_id + "_FILTER_isInclude15"));
	    this.$scope.isInclude05 = JSON.parse(localStorage.getItem(this.user_id + "_FILTER_isInclude05"));
	    if (this.$scope.isInclude15 == null) {
	      this.$scope.isInclude15 = true;
	      localStorage.setItem(this.user_id + "_FILTER_isInclude15", JSON.stringify(true));
	    }
	    if (this.$scope.isInclude05 == null) {
	      this.$scope.isInclude05 = false;
	      this.$scope.roundType = _.filter(this.$scope.roundType, function(type) {
	        return type !== 0.5;
	      });
	      localStorage.setItem(this.user_id + "_FILTER_isInclude05", JSON.stringify(false));
	    }
	    this.handleRoundType15();
	    this.handleRoundType05();
	    this.$scope.clickInclude15 = (function(_this) {
	      return function(isInclude15) {
	        _this.$scope.isInclude15 = isInclude15;
	        localStorage.setItem(_this.user_id + "_FILTER_isInclude15", JSON.stringify(isInclude15));
	        _this.handleRoundType15();
	        _this.$scope.$parent.$emit("roundTypeUpdated.gnp.dashboard", _this.$scope.roundType.sort());
	        return localStorage.setItem(_this.user_id + "_FILTER_roundType", JSON.stringify(_this.$scope.roundType.sort()));
	      };
	    })(this);
	    this.$scope.clickInclude05 = (function(_this) {
	      return function(isInclude05) {
	        _this.$scope.isInclude05 = isInclude05;
	        localStorage.setItem(_this.user_id + "_FILTER_isInclude05", JSON.stringify(isInclude05));
	        _this.handleRoundType05();
	        _this.$scope.$parent.$emit("roundTypeUpdated.gnp.dashboard", _this.$scope.roundType.sort());
	        return localStorage.setItem(_this.user_id + "_FILTER_roundType", JSON.stringify(_this.$scope.roundType.sort()));
	      };
	    })(this);
	  }
	
	  PeriodFilterCtrl.prototype.handleRoundType15 = function() {
	    if (this.$scope.isInclude15) {
	      if (indexOf.call(this.$scope.roundType, 1.5) < 0) {
	        return this.$scope.roundType.push(1.5);
	      }
	    } else {
	      return this.$scope.roundType = _.filter(this.$scope.roundType, function(type) {
	        return type !== 1.5;
	      });
	    }
	  };
	
	  PeriodFilterCtrl.prototype.handleRoundType05 = function() {
	    if (this.$scope.isInclude05) {
	      if (indexOf.call(this.$scope.roundType, 0.5) < 0) {
	        return this.$scope.roundType.push(0.5);
	      }
	    } else {
	      return this.$scope.roundType = _.filter(this.$scope.roundType, function(type) {
	        return type !== 0.5;
	      });
	    }
	  };
	
	  PeriodFilterCtrl.prototype._publishChange = function() {
	    localStorage.setItem(this.user_id + "_FILTER_PERIOD_START_DATE", this.startDate);
	    localStorage.setItem(this.user_id + "_FILTER_PERIOD_END_DATE", this.endDate);
	    return this.$scope.$parent.$emit("periodSelected.gnp.dashboard", this.startDate, this.endDate, this.$scope.roundType.sort());
	  };
	
	  return PeriodFilterCtrl;
	
	})();
	
	PeriodFilterCtrl.$inject = ['$scope', '$filter'];
	
	module.exports = PeriodFilterCtrl;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	var DashboardService, moment;
	
	moment = __webpack_require__(126);
	
	DashboardService = function($http, $q, ScoreCardAPIService) {
	  var prepareParams;
	  prepareParams = function(options) {
	    var ref;
	    return _.pickBy({
	      from: (options.from ? options.from.format("YYYY-MM-DD") : void 0),
	      to: (options.to ? options.to.format("YYYY-MM-DD") : void 0),
	      round_type: (ref = options.round_type) != null ? ref.join(',') : void 0
	    }, function(v) {
	      return v !== null && v !== void 0;
	    });
	  };
	  return {
	    getHistories: function(options) {
	      var delay, params;
	      if (options == null) {
	        options = {};
	      }
	      delay = $q.defer();
	      params = prepareParams(options);
	      $http.get("/api/score_cards/recent.json", {
	        params: params
	      }).then(function(resp) {
	        return delay.resolve(resp.data);
	      });
	      return delay.promise;
	    },
	    getBestScores: function(options) {
	      var delay, params;
	      if (options == null) {
	        options = {};
	      }
	      delay = $q.defer();
	      params = prepareParams(options);
	      $http.get("/api/score_cards/best_scores.json", {
	        params: params
	      }).then(function(resp) {
	        return delay.resolve(resp.data);
	      });
	      return delay.promise;
	    },
	    getFavoriteCourses: function(options) {
	      var delay, params;
	      if (options == null) {
	        options = {};
	      }
	      delay = $q.defer();
	      params = prepareParams(options);
	      $http.get("/api/courses/most_played.json", {
	        params: params
	      }).then(function(resp) {
	        return delay.resolve(resp.data);
	      });
	      return delay.promise;
	    },
	    getTopFairwayHitCourses: function(options) {
	      var delay, params;
	      if (options == null) {
	        options = {};
	      }
	      delay = $q.defer();
	      params = prepareParams(options);
	      $http.get("/api/courses/top_fairway_hit.json", {
	        params: params
	      }).then(function(resp) {
	        return delay.resolve(resp.data);
	      });
	      return delay.promise;
	    }
	  };
	};
	
	DashboardService.$inject = ['$http', '$q', 'ScoreCardAPIService'];
	
	module.exports = DashboardService;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var DashboardBasicAnalysisService, _;
	
	_ = __webpack_require__(87);
	
	DashboardBasicAnalysisService = function($http, ScoreCardAPIService, $routeParams) {
	  var id;
	  id = $routeParams.user_id;
	  if ($routeParams.user_id === void 0) {
	    id = "me";
	  }
	  return {
	    getMyAnalysis: function(options) {
	      var params, ref;
	      if (options == null) {
	        options = {};
	      }
	      params = _.pickBy({
	        from: (options.from ? options.from.format("YYYY-MM-DD") : void 0),
	        to: (options.to ? options.to.format("YYYY-MM-DD") : void 0),
	        round_type: (ref = options.round_type) != null ? ref.join(',') : void 0
	      }, function(v) {
	        return v !== null && v !== void 0;
	      });
	      return ScoreCardAPIService.getMyAvg(id, params);
	    }
	  };
	};
	
	DashboardBasicAnalysisService.$inject = ['$http', 'ScoreCardAPIService', '$routeParams'];
	
	module.exports = DashboardBasicAnalysisService;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	var FairwayHitChartDirective;
	
	__webpack_require__(568);
	
	FairwayHitChartDirective = function() {
	  var createChartOptions;
	  createChartOptions = function(fairwayHitData, target) {
	    return {
	      chart: {
	        renderTo: target[0],
	        type: 'pie',
	        backgroundColor: 'transparent'
	      },
	      plotOptions: {
	        pie: {
	          borderWidth: 0,
	          shadow: false,
	          center: ['50%', '50%'],
	          enableMouseTracking: false,
	          dataLabels: {
	            enabled: false
	          }
	        }
	      },
	      tooltip: {
	        enabled: false
	      },
	      title: {
	        floating: true,
	        y: 28,
	        text: fairwayHitData,
	        style: {
	          'fontSize': '14px',
	          'color': '#008484'
	        }
	      },
	      credits: {
	        enabled: false
	      },
	      series: [
	        {
	          size: 60,
	          innerSize: 50,
	          data: [
	            {
	              color: '#008484',
	              y: parseFloat(fairwayHitData)
	            }, {
	              color: '#87b6b6',
	              y: 100 - parseFloat(fairwayHitData)
	            }
	          ]
	        }
	      ]
	    };
	  };
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "dashboard/fairway-hit/fairway-hit-chart.jade",
	    scope: {
	      fairwayHitData: '=fairwayHitData'
	    },
	    link: function(scope, element) {
	      var target;
	      target = element.find(".chart");
	      return scope.$watch((function() {
	        return scope.fairwayHitData;
	      }), function() {
	        return new Highcharts.Chart(createChartOptions(scope.fairwayHitData, target));
	      });
	    }
	  };
	};
	
	module.exports = FairwayHitChartDirective;


/***/ }),
/* 568 */
/***/ (function(module, exports) {

	var v1="<div class=\"chart\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("dashboard/fairway-hit/fairway-hit-chart.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	module.exports = {
	  '_DASHBOARD': {
	    'TITLE': 'Dashboard',
	    'HISTORY': {
	      'TOTAL_ROUNDS': 'Total Rounds',
	      'BEST_SCORE': 'Best Score',
	      'AVERAGE_SCORE': 'Average Score',
	      'SCORE': 'Score',
	      'FAIRWAY_HIT': 'Fairway hit',
	      'GIR': 'GIR (%)',
	      'BOGEY_ON': 'GIR+1 (%)'
	    },
	    'PERIOD_FILTER': {
	      'TARGET_RANGE': 'Period',
	      'TARGET_ROUND': 'Target round',
	      'INCLUDE_1_5': 'Include 1.5 Round',
	      'EXCLUDE_1_5': 'Exclude 1.5 Round',
	      'INCLUDE_0_5': 'Include 0.5 Round',
	      'EXCLUDE_0_5': 'Exclude 0.5 Round',
	      'INCLUDE_1_5_SP': 'Include 1.5R',
	      'EXCLUDE_1_5_SP': 'Exclude 1.5R',
	      'INCLUDE_0_5_SP': 'Include 0.5R',
	      'EXCLUDE_0_5_SP': 'Exclude 0.5R'
	    },
	    'BEST_SCORE': "Best Score",
	    'FAVORITE_COURSE': "Favorite Course",
	    'FAIRWAY_KEEP_COURSE': "FW Keep Course",
	    'RANKING': "Ranking",
	    'MESSAGES': {
	      'M0001': 'This operation is not permitted for current signed in user. Please sign out and try again.'
	    }
	  }
	};


/***/ }),
/* 570 */
/***/ (function(module, exports) {

	module.exports = {
	  '_DASHBOARD': {
	    'TITLE': 'ダッシュボード',
	    'HISTORY': {
	      'TOTAL_ROUNDS': '総ラウンド',
	      'BEST_SCORE': 'ベストスコア',
	      'AVERAGE_SCORE': '平均スコア',
	      'SCORE': 'スコア',
	      'FAIRWAY_HIT': 'フェアウェイキープ',
	      'GIR': 'パーオン',
	      'BOGEY_ON': 'ボギーオン率'
	    },
	    'PERIOD_FILTER': {
	      'TARGET_RANGE': '対象期間',
	      'TARGET_ROUND': '対象ラウンド',
	      'INCLUDE_1_5': '1.5ラウンドを含める',
	      'EXCLUDE_1_5': '1.5ラウンドを含めない',
	      'INCLUDE_0_5': '0.5ラウンドを含める',
	      'EXCLUDE_0_5': '0.5ラウンドを含まない',
	      'INCLUDE_1_5_SP': '1.5 R を含める',
	      'EXCLUDE_1_5_SP': '1.5 R を含めない',
	      'INCLUDE_0_5_SP': '0.5 R を含める',
	      'EXCLUDE_0_5_SP': '0.5 R を含まない'
	    },
	    'BEST_SCORE': "ベストスコア",
	    'FAVORITE_COURSE': "よく行くコース",
	    'FAIRWAY_KEEP_COURSE': "FW キープコース",
	    'RANKING': "ランキング",
	    'MESSAGES': {
	      'M0001': 'この操作は現在ログインしているユーザでは実行できません。ログアウトしてから再度お試し下さい'
	    }
	  }
	};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	var MemoCtrl, MemoModalCtrl, MemoService, PlayersAnalysisCtrl, RoundBasicChartCtrl, RoundDetailCtrl, RoundDetailInfoCtrl, RoundDetailService, RoundMapCtrl, RoundScoreChartCtrl, RoundStrokeChartCtrl, ScoreCardInfoCtrl, modules;
	
	__webpack_require__(572);
	
	__webpack_require__(573);
	
	__webpack_require__(574);
	
	__webpack_require__(575);
	
	__webpack_require__(576);
	
	__webpack_require__(577);
	
	__webpack_require__(578);
	
	__webpack_require__(579);
	
	__webpack_require__(580);
	
	__webpack_require__(581);
	
	__webpack_require__(582);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(72);
	
	__webpack_require__(76);
	
	__webpack_require__(82);
	
	__webpack_require__(275);
	
	__webpack_require__(473);
	
	__webpack_require__(278);
	
	__webpack_require__(388);
	
	__webpack_require__(274);
	
	__webpack_require__(108);
	
	__webpack_require__(117);
	
	__webpack_require__(389);
	
	__webpack_require__(416);
	
	__webpack_require__(39);
	
	RoundDetailCtrl = __webpack_require__(589);
	
	RoundDetailInfoCtrl = __webpack_require__(590);
	
	RoundDetailService = __webpack_require__(591);
	
	PlayersAnalysisCtrl = __webpack_require__(592);
	
	RoundMapCtrl = __webpack_require__(593);
	
	RoundBasicChartCtrl = __webpack_require__(594);
	
	RoundScoreChartCtrl = __webpack_require__(595);
	
	RoundStrokeChartCtrl = __webpack_require__(596);
	
	ScoreCardInfoCtrl = __webpack_require__(597);
	
	MemoCtrl = __webpack_require__(598);
	
	MemoModalCtrl = __webpack_require__(599);
	
	MemoService = __webpack_require__(600);
	
	modules = ['ngRoute', 'ui.bootstrap', 'gnp-translation', 'gnp-flash', 'gnp-auth', 'gnp-common-wrapper', 'gnp-location-tracking', 'gnp-analysis-charts', 'gnp-score-card', 'gnp-payment', 'gnp-remote-api', 'gnp-error-handler', 'gnp-hdcp', 'gnp-number', 'gnp-map', 'gnp-analyze-access'];
	
	angular.module('gnp-app-round-detail', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/round-detail/:id', {
	      templateUrl: 'web/round-detail/round-detail.jade',
	      controller: 'RoundDetailCtrl',
	      resolve: {
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ],
	        roundInfo: [
	          'RoundAPIService', '$route', function(RoundAPIService, $route) {
	            var params;
	            params = {
	              user_id: $route.current.params.user_id
	            };
	            return RoundAPIService.getRound($route.current.params.id, true, params);
	          }
	        ],
	        playersAnalysis: [
	          'RoundDetailService', '$route', function(RoundDetailService, $route) {
	            var params;
	            params = {
	              user_id: $route.current.params.user_id
	            };
	            return RoundDetailService.getAnalysisDataRound($route.current.params.id, params);
	          }
	        ],
	        goalSettings: [
	          'GoalAPIService', '$route', function(GoalAPIService, $route) {
	            var params;
	            params = {
	              user_id: $route.current.params.user_id
	            };
	            return GoalAPIService.getGoalSettings(params);
	          }
	        ],
	        allMembersAnalysis: [
	          'ScoreCardAPIService', '$route', function(ScoreCardAPIService, $route) {
	            var params;
	            params = {
	              user_id: $route.current.params.user_id
	            };
	            return ScoreCardAPIService.getAllMembers(params);
	          }
	        ]
	      },
	      title: '_ROUND_DETAIL.TITLE',
	      permission: {
	        signInRequired: false
	      }
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(601)).translations('ja', __webpack_require__(602));
	  }
	]).controller('RoundDetailCtrl', RoundDetailCtrl).controller('RoundDetailInfoCtrl', RoundDetailInfoCtrl).controller('PlayersAnalysisCtrl', PlayersAnalysisCtrl).controller('RoundMapCtrl', RoundMapCtrl).controller('RoundBasicChartCtrl', RoundBasicChartCtrl).controller('RoundScoreChartCtrl', RoundScoreChartCtrl).controller('RoundStrokeChartCtrl', RoundStrokeChartCtrl).controller('ScoreCardInfoCtrl', ScoreCardInfoCtrl).controller('MemoCtrl', MemoCtrl).controller('MemoModalCtrl', MemoModalCtrl).factory('RoundDetailService', RoundDetailService).factory('MemoService', MemoService);


/***/ }),
/* 572 */
/***/ (function(module, exports) {

	var v1="<div id=\"page-round-detail\" gnp-common-wrapper-a=\"\"><div ng-controller=\"RoundDetailInfoCtrl as riCtrl\" ng-include=\"'round-detail/round-info/round-info.jade'\"></div><div class=\"bar-goal container page-round-detail {{(hideHeader || hideLabel) ? 'hide-header' : ''}}\"><div class=\"click-space\"><a href=\"/goal-settings\" analytics-on=\"click\" analytics-event=\"DTL_TgtSetting\" class=\"click\">{{:: '_GOAL_SETTINGS.TITLE' | translate }}</a></div></div><div class=\"content-charts\"><div ng-controller=\"RoundBasicChartCtrl as rbCtrl\" ng-include=\"'round-detail/round-basic-chart/round-basic-chart.jade'\" class=\"container page-round-detail charts\"></div><div class=\"container page-round-detail content-semi-circle-charts\"><div class=\"row mx-0\"><div ng-controller=\"RoundScoreChartCtrl as rsCtrl\" ng-include=\"'round-detail/round-score-chart/round-score-chart.jade'\" class=\"charts chart-left\"></div><div ng-controller=\"RoundStrokeChartCtrl as rstCtrl\" ng-include=\"'round-detail/round-stroke-chart/round-stroke-chart.jade'\" class=\"charts chart-right ml-auto\"></div></div></div></div><div ng-controller=\"ScoreCardInfoCtrl as sciCtrl\" ng-include=\"'round-detail/score-card-info/score-card-info.jade'\" class=\"content-score-board\"></div><div ng-controller=\"PlayersAnalysisCtrl as paCtrl\" ng-include=\"'round-detail/players-analysis/players-analysis.jade'\" class=\"content-board\"></div><div ng-controller=\"MemoCtrl as mmCtrl\" ng-include=\"'round-detail/score-card-memo/memo-show.jade'\" class=\"content-memo\"></div><div ng-controller=\"RoundMapCtrl as rmCtrl\" ng-include=\"'round-detail/round-map/round-map.jade'\" class=\"content-map\"></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/round-detail/round-detail.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 573 */
/***/ (function(module, exports) {

	var v1="<div class=\"container page-round-detail\"><div class=\"sub-score-board\"><div class=\"board\"><div class=\"d-block d-sm-none\"><div class=\"row header\"><div class=\"column-label one-player-label\">&nbsp;</div><div class=\"column header one-player\"><div class=\"pulldown\"><button data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"btn btn-player-dropdown {{ (players.length &gt; 1) ? '' : 'is-fulltext' }}\"><div class=\"title float-left text-center {{ (players.length &gt; 1) ? '' : 'is-fulltext' }}\">{{ players[activeTab].name }}<br/>({{ (players[activeTab].player_hdcp | hdcpToLabel) }})</div><span ng-if=\"players.length &gt; 1\" class=\"caret ml-auto player-caret\"></span></button><ul ng-if=\"players.length &gt; 1\" class=\"dropdown-menu player-analysis-dropdown\"><li ng-repeat=\"p in ::players | limitTo:4\"><a ng-click=\"activeDisplay($index, p)\"><div class=\"player-name-xs\">{{ ::p.name }}</div><div>({{ ::(p.player_hdcp | hdcpToLabel) }})</div></a></li></ul></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row header\"><div class=\"column-label\">&nbsp;</div><div ng-repeat=\"p in ::players | limitTo:4\" class=\"column header\"><div class=\"player-name\">{{ ::p.name }}</div><div>({{ ::(p.player_hdcp | hdcpToLabel) }})</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label odd\">{{:: \"SCORE\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player odd\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.total_shot) === ''\">-</span><span ng-if=\"(pa.total_shot) !== ''\">{{ ::(pa.total_shot) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label odd\">{{:: \"SCORE\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column odd\"><span ng-if=\"(pa.total_shot) === ''\">-</span><span ng-if=\"(pa.total_shot) !== ''\">{{ ::(pa.total_shot) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column odd\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label even\">{{:: \"PUTTS\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player even\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.total_putt) === ''\">-</span><span ng-if=\"(pa.total_putt) !== ''\">{{ ::(pa.total_putt) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label even\">{{:: \"PUTTS\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column even\"><span ng-if=\"(pa.total_putt) === ''\">-</span><span ng-if=\"(pa.total_putt) !== ''\">{{ ::(pa.total_putt) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column even\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.PAR_ON\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player odd\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.rat_par_on * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_par_on * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_par_on * 100 | percentToFormattedString) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.PAR_ON\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column odd\"><span ng-if=\"(pa.rat_par_on * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_par_on * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_par_on * 100 | percentToFormattedString) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column odd\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.BOGEY_ON\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player even\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.rat_bogey_on * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_bogey_on * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_bogey_on * 100 | percentToFormattedString) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.BOGEY_ON\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column even\"><span ng-if=\"(pa.rat_bogey_on * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_bogey_on * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_bogey_on * 100 | percentToFormattedString) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column even\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.AVG_PUTT\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player odd\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.avg_putt | number:2) === ''\">-</span><span ng-if=\"(pa.avg_putt | number:2) !== ''\">{{ ::(pa.avg_putt | number:2) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.AVG_PUTT\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column odd\"><span ng-if=\"(pa.avg_putt | number:2) === ''\">-</span><span ng-if=\"(pa.avg_putt | number:2) !== ''\">{{ ::(pa.avg_putt | number:2) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column odd\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.AVG_PAR_ON_PUTT_CNT\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player even\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.avg_par_on_putt_cnt | number:2) === ''\">-</span><span ng-if=\"(pa.avg_par_on_putt_cnt | number:2) !== ''\">{{ ::(pa.avg_par_on_putt_cnt | number:2) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.AVG_PAR_ON_PUTT_CNT\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column even\"><span ng-if=\"(pa.avg_par_on_putt_cnt | number:2) === ''\">-</span><span ng-if=\"(pa.avg_par_on_putt_cnt | number:2) !== ''\">{{ ::(pa.avg_par_on_putt_cnt | number:2) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column even\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_UNDER_EAGLE\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player odd\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.rat_under_eagle * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_under_eagle * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_under_eagle * 100 | percentToFormattedString) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_UNDER_EAGLE\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column odd\"><span ng-if=\"(pa.rat_under_eagle * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_under_eagle * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_under_eagle * 100 | percentToFormattedString) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column odd\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_BIRDIE\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player even\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.rat_birdie * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_birdie * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_birdie * 100 | percentToFormattedString) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_BIRDIE\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column even\"><span ng-if=\"(pa.rat_birdie * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_birdie * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_birdie * 100 | percentToFormattedString) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column even\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_PAR\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player odd\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.rat_par * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_par * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_par * 100 | percentToFormattedString) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_PAR\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column odd\"><span ng-if=\"(pa.rat_par * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_par * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_par * 100 | percentToFormattedString) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column odd\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_BOGEY\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player even\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.rat_bogey * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_bogey * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_bogey * 100 | percentToFormattedString) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_BOGEY\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column even\"><span ng-if=\"(pa.rat_bogey * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_bogey * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_bogey * 100 | percentToFormattedString) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column even\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_DBOGEY\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player odd\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.rat_dbogey * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_dbogey * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_dbogey * 100 | percentToFormattedString) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_DBOGEY\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column odd\"><span ng-if=\"(pa.rat_dbogey * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_dbogey * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_dbogey * 100 | percentToFormattedString) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column odd\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_OVER_TBOGEY\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player even\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.rat_over_tbogey * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_over_tbogey * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_over_tbogey * 100 | percentToFormattedString) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_OVER_TBOGEY\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column even\"><span ng-if=\"(pa.rat_over_tbogey * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_over_tbogey * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_over_tbogey * 100 | percentToFormattedString) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column even\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.AVG_SHOT_PAR3\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player odd\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.avg_shot_par3 | number:2) === ''\">-</span><span ng-if=\"(pa.avg_shot_par3 | number:2) !== ''\">{{ ::(pa.avg_shot_par3 | number:2) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.AVG_SHOT_PAR3\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column odd\"><span ng-if=\"(pa.avg_shot_par3 | number:2) === ''\">-</span><span ng-if=\"(pa.avg_shot_par3 | number:2) !== ''\">{{ ::(pa.avg_shot_par3 | number:2) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column odd\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.AVG_SHOT_PAR4\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player even\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.avg_shot_par4 | number:2) === ''\">-</span><span ng-if=\"(pa.avg_shot_par4 | number:2) !== ''\">{{ ::(pa.avg_shot_par4 | number:2) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.AVG_SHOT_PAR4\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column even\"><span ng-if=\"(pa.avg_shot_par4 | number:2) === ''\">-</span><span ng-if=\"(pa.avg_shot_par4 | number:2) !== ''\">{{ ::(pa.avg_shot_par4 | number:2) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column even\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.AVG_SHOT_PAR5\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player odd\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.avg_shot_par5 | number:2) === ''\">-</span><span ng-if=\"(pa.avg_shot_par5 | number:2) !== ''\">{{ ::(pa.avg_shot_par5 | number:2) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.AVG_SHOT_PAR5\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column odd\"><span ng-if=\"(pa.avg_shot_par5 | number:2) === ''\">-</span><span ng-if=\"(pa.avg_shot_par5 | number:2) !== ''\">{{ ::(pa.avg_shot_par5 | number:2) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column odd\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_RECOVERY\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player even\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.rat_recovery * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_recovery * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_recovery * 100 | percentToFormattedString) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_RECOVERY\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column even\"><span ng-if=\"(pa.rat_recovery * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_recovery * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_recovery * 100 | percentToFormattedString) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column even\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_SAND_SAVE\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player odd\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.rat_sand_save * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_sand_save * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_sand_save * 100 | percentToFormattedString) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_SAND_SAVE\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column odd\"><span ng-if=\"(pa.rat_sand_save * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_sand_save * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_sand_save * 100 | percentToFormattedString) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column odd\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_FAIRWAY_CENTER\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player even\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.rat_fairway_center * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_fairway_center * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_fairway_center * 100 | percentToFormattedString) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_FAIRWAY_CENTER\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column even\"><span ng-if=\"(pa.rat_fairway_center * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_fairway_center * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_fairway_center * 100 | percentToFormattedString) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column even\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_FAIRWAY_RIGHT\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player odd\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.rat_fairway_right * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_fairway_right * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_fairway_right * 100 | percentToFormattedString) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label odd\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_FAIRWAY_RIGHT\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column odd\"><span ng-if=\"(pa.rat_fairway_right * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_fairway_right * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_fairway_right * 100 | percentToFormattedString) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column odd\">&nbsp;</div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row\"><div class=\"col-12\"><div class=\"column-label one-player-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_FAIRWAY_LEFT\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column one-player even\"><div ng-class=\"{hide : activeTab !== $index}\"><span ng-if=\"(pa.rat_fairway_left * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_fairway_left * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_fairway_left * 100 | percentToFormattedString) }}</span></div></div></div></div></div><div class=\"d-none d-sm-block\"><div class=\"row row-analysis\"><div class=\"col-12\"><div class=\"column-label even\">{{:: \"_ROUND_DETAIL.PLAYERS_ANALYSIS.RAT_FAIRWAY_LEFT\" | translate }}</div><div ng-repeat=\"pa in playerAnalysis | limitTo:4\" class=\"column even\"><span ng-if=\"(pa.rat_fairway_left * 100 | percentToFormattedString) === ''\">-</span><span ng-if=\"(pa.rat_fairway_left * 100 | percentToFormattedString) !== ''\">{{ ::(pa.rat_fairway_left * 100 | percentToFormattedString) }}</span></div><div ng-repeat=\"n in [0,1,2,3] | limitTo:4-playerAnalysis.length\" class=\"column even\">&nbsp;</div></div></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("round-detail/players-analysis/players-analysis.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 574 */
/***/ (function(module, exports) {

	var v1="<div gnp-basic-analysis=\"\" basic-analysis-data=\"::rbCtrl.basicAnalysisData\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("round-detail/round-basic-chart/round-basic-chart.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	var v1="<div class=\"container page-round-detail\"><div class=\"row\"><div class=\"col-12\"><div ng-click=\"riCtrl.$scope.$parent.navigateBackToPreviousLink()\" class=\"btn-close\"></div></div></div></div><div class=\"content-course-info\"><div class=\"container page-round-detail position-relative\"><div ng-hide=\"$root.paid\" ng-click=\"riCtrl.$scope.$parent.navigateToEnterScorePage()\" class=\"help-circle {{(hideHeader || hideLabel) ? 'hide-header' : ''}}\"></div><div class=\"d-none d-sm-block\"><div class=\"row row-top\"><div class=\"col-2 column-date\"><div class=\"yeardate\">{{ ::riCtrl.roundInfo.play_date }}</div></div><div class=\"col-1 column-weather icons-{{ ::riCtrl.roundInfo.weather }}\"></div><div class=\"col-9 last column-course\"><div class=\"course-list\"><div class=\"course-name-wrap\"><a href=\"/clubs/{{ ::riCtrl.roundInfo.club.ext_id }}\"><p class=\"course-name {{(hideHeader || hideLabel) ? 'long-text' : 'short-text'}}\">{{ ::(riCtrl.roundInfo.club.name + ' ' + riCtrl.roundInfo.course.name) }}</p><p class=\"course-addr\">{{ ::riCtrl.roundInfo.club.address }}</p></a></div><a href=\"#\" class=\"{{(hideHeader || hideLabel) ? 'hide-header' : ''}}\"><div ng-class=\"{freemode: !$root.paid}\" ng-click=\"riCtrl.$scope.$parent.navigateToEnterScorePage()\" analytics-on=\"click\" analytics-event=\"DTL_CourseEdit\" class=\"btn-edit\">{{:: 'EDIT' | translate }}</div></a></div></div></div></div><div class=\"d-block d-sm-none\"><div class=\"row cource-detail\"><div class=\"col-10 column-date\"><div class=\"yeardate\">{{ ::riCtrl.roundInfo.play_date }}</div></div><div class=\"col-2 column-weather icons-{{ ::riCtrl.roundInfo.weather }}\"></div><div class=\"col-12 last column-course\"><div class=\"course-list\"><div class=\"course-name-wrap {{(hideHeader || hideLabel) ? 'col-12' : 'col-10'}}\"><a href=\"/clubs/{{ ::riCtrl.roundInfo.club.ext_id }}\"><p class=\"course-name {{(hideHeader || hideLabel) ? 'long-text' : 'short-text'}}\">{{ ::(riCtrl.roundInfo.club.name + ' ' + riCtrl.roundInfo.course.name) }}</p><p class=\"course-addr\">{{ ::riCtrl.roundInfo.club.address }}</p></a></div><div class=\"col-2\"><a href=\"#\" class=\"{{(hideHeader || hideLabel) ? 'hide-header' : ''}}\"><div ng-class=\"{freemode: !$root.paid}\" ng-click=\"riCtrl.$scope.$parent.navigateToEnterScorePage()\" analytics-on=\"click\" analytics-event=\"DTL_CourseEdit\" class=\"btn-edit\">{{:: 'EDIT' | translate }}</div></a></div></div></div></div></div><div class=\"d-none d-sm-block\"><div ng-if=\"::(riCtrl.roundInfo.player_1 || riCtrl.roundInfo.player_2 || riCtrl.roundInfo.player_3)\"><div class=\"col-3 column-hdcp\">{{:: '_ROUND_DETAIL.INFO.COMPETITORS' | translate }}（HDCP)</div><div class=\"col-3 column-hdcp-name-sm\"><div ng-if=\"::(riCtrl.roundInfo.player_1)\"><div class=\"col-10 col-md-8 no-padding\"><div class=\"name\">{{ ::riCtrl.roundInfo.player_1.name }}</div></div><div class=\"col-2 col-md-4 no-padding\"><div ng-if=\"::(riCtrl.roundInfo.player_1.player_hdcp != null)\" class=\"hdcp\">({{ ::(riCtrl.roundInfo.player_1.player_hdcp | hdcpToLabel) }})</div></div></div></div><div class=\"col-3 column-hdcp-name-sm\"><div ng-if=\"::(riCtrl.roundInfo.player_2)\"><div class=\"col-10 col-md-8 no-padding\"><div class=\"name\">{{ ::riCtrl.roundInfo.player_2.name }}</div></div><div class=\"col-2 col-md-4 no-padding\"><div ng-if=\"::(riCtrl.roundInfo.player_2.player_hdcp != null)\" class=\"hdcp\">({{ ::(riCtrl.roundInfo.player_2.player_hdcp | hdcpToLabel) }})</div></div></div></div><div class=\"col-3 column-hdcp-name-sm\"><div ng-if=\"::(riCtrl.roundInfo.player_3)\"><div class=\"col-10 col-md-8 no-padding\"><div class=\"name\">{{ ::riCtrl.roundInfo.player_3.name }}</div></div><div class=\"col-2 col-md-4 no-padding\"><div ng-if=\"::(riCtrl.roundInfo.player_3.player_hdcp != null)\" class=\"hdcp\">({{ ::(riCtrl.roundInfo.player_3.player_hdcp | hdcpToLabel) }})</div></div></div></div></div></div><div class=\"d-block d-sm-none\"><div ng-if=\"::(riCtrl.roundInfo.player_1 || riCtrl.roundInfo.player_2 || riCtrl.roundInfo.player_3)\"><div class=\"col-12 round-detail-competitor\"><div class=\"column-hdcp\">{{:: '_ROUND_DETAIL.INFO.COMPETITORS' | translate }}（HDCP)</div></div><div class=\"col-12 column-hdcp-name\"><div ng-if=\"::(riCtrl.roundInfo.player_1)\" class=\"player-info-wrap\"><span class=\"name\">{{ ::riCtrl.roundInfo.player_1.name }}</span><span ng-if=\"::(riCtrl.roundInfo.player_1.player_hdcp != null)\" class=\"hdcp\">({{ ::(riCtrl.roundInfo.player_1.player_hdcp | hdcpToLabel) }})</span></div></div><div class=\"col-12 column-hdcp-name\"><div ng-if=\"::(riCtrl.roundInfo.player_2)\" class=\"player-info-wrap\"><span class=\"name\">{{ ::riCtrl.roundInfo.player_2.name }}</span><span ng-if=\"::(riCtrl.roundInfo.player_2.player_hdcp != null)\" class=\"hdcp\">({{ ::(riCtrl.roundInfo.player_2.player_hdcp | hdcpToLabel) }})</span></div></div><div class=\"col-12 column-hdcp-name\"><div ng-if=\"::(riCtrl.roundInfo.player_3)\" class=\"player-info-wrap\"><span class=\"name\">{{ ::riCtrl.roundInfo.player_3.name }}</span><span ng-if=\"::(riCtrl.roundInfo.player_3.player_hdcp != null)\" class=\"hdcp\">({{ ::(riCtrl.roundInfo.player_3.player_hdcp | hdcpToLabel) }})</span></div></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("round-detail/round-info/round-info.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 576 */
/***/ (function(module, exports) {

	var v1="<div class=\"container page-round-detail\"><div id=\"map_canvas\" ng-if=\"rmCtrl.mapOptions\" ui-map=\"::rmCtrl.myMap\" ui-options=\"::rmCtrl.mapOptions\" class=\"col-12 map\"></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("round-detail/round-map/round-map.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 577 */
/***/ (function(module, exports) {

	var v1="<div gnp-score-analysis=\"\" score-data=\"::rsCtrl.scoreData\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("round-detail/round-score-chart/round-score-chart.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	var v1="<div gnp-stroke-analysis=\"\" stroke-data=\"::rstCtrl.strokeData\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("round-detail/round-stroke-chart/round-stroke-chart.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	var v1="<div class=\"container page-round-detail\"><div class=\"header-score-board position-relative\"><a href=\"#\" class=\"{{(hideHeader || hideLabel) ? 'hide-header' : ''}}\"><div ng-class=\"{freemode: !$root.paid}\" ng-click=\"sciCtrl.$scope.$parent.navigateToEnterScorePage()\" analytics-on=\"click\" analytics-event=\"DTL_ScoreEdit\" class=\"btn-edit\">{{:: 'EDIT' | translate }}</div></a><div ng-hide=\"$root.paid\" ng-click=\"sciCtrl.$scope.$parent.navigateToEnterScorePage()\" class=\"help-circle {{(hideHeader || hideLabel) ? 'hide-header' : ''}}\"></div></div><div gnp-score-card=\"\" board-type=\"out\" edit-mode=\"false\" score-card-course=\"sciCtrl.course\" score-card-tee=\"sciCtrl.tee\" score-card-holes=\"sciCtrl.outScoreCardInfo.holes\" score-card-players=\"sciCtrl.outScoreCardInfo.players\"></div><div gnp-score-card=\"\" ng-if=\"sciCtrl.is18Holes\" board-type=\"in\" edit-mode=\"false\" score-card-course=\"sciCtrl.course\" score-card-tee=\"sciCtrl.tee\" score-card-holes=\"sciCtrl.inScoreCardInfo.holes\" score-card-players=\"sciCtrl.inScoreCardInfo.players\"></div><div gnp-score-card=\"\" ng-if=\"sciCtrl.hasExtra\" board-type=\"extra\" edit-mode=\"false\" score-card-course=\"sciCtrl.course_extra\" score-card-tee=\"sciCtrl.tee_extra\" score-card-holes=\"sciCtrl.extraScoreCardInfo.holes\" score-card-players=\"sciCtrl.extraScoreCardInfo.players\"></div><div class=\"score-board\"><div class=\"row\"><div class=\"title-green\">TOTAL</div><div class=\"title-gray\">OUT</div><div class=\"title-gray\">IN</div><div class=\"title-gray\">GROSS</div><div class=\"title-gray\">NET</div></div><div class=\"row\"><div class=\"column-label score odd\">{{:: 'SCORE' | translate }}</div><div class=\"column-total score odd\">{{ ::(sciCtrl.totalScoreCardInfo.out.total_shot) }}</div><div class=\"column-total score odd\">{{ ::(sciCtrl.is18Holes ? sciCtrl.totalScoreCardInfo.in.total_shot : \"-\") }}</div><div class=\"column-total score odd\">{{ ::(sciCtrl.totalScoreCardInfo.gross.total_shot) }}</div><div class=\"column-total score odd\">&nbsp;<span ng-show=\"::sciCtrl.hasPlayerHdcp\">{{ ::(sciCtrl.totalScoreCardInfo.gross.total_shot - sciCtrl.totalScoreCardInfo.owner_player.player_hdcp).toFixed(1); }}</span></div></div><div class=\"row\"><div class=\"column-label even\">{{:: 'PUTTS' | translate }}</div><div class=\"column-total even\">{{ ::(sciCtrl.totalScoreCardInfo.out.total_putt) }}</div><div class=\"column-total even\">{{ ::(sciCtrl.is18Holes ? sciCtrl.totalScoreCardInfo.in.total_putt : \"-\") }}</div><div class=\"column-total even\">{{ ::(sciCtrl.totalScoreCardInfo.gross.total_putt) }}</div><div class=\"column-total even\">-</div></div><div class=\"row\"><div class=\"column-label odd\">{{:: \"_ROUND_DETAIL.TOTAL.OB\" | translate }}</div><div class=\"column-total odd\">{{ ::(sciCtrl.totalScoreCardInfo.out.total_ob) }}</div><div class=\"column-total odd\">{{ ::(sciCtrl.is18Holes ? sciCtrl.totalScoreCardInfo.in.total_ob : \"-\") }}</div><div class=\"column-total odd\">{{ ::(sciCtrl.totalScoreCardInfo.gross.total_ob) }}</div><div class=\"column-total odd\">-</div></div><div class=\"row\"><div class=\"column-label even\">{{:: \"_ROUND_DETAIL.TOTAL.SAND_SAVES\" | translate }}</div><div class=\"column-total even\">{{ ::(sciCtrl.totalScoreCardInfo.out.total_sand_shot) }}</div><div class=\"column-total even\">{{ ::(sciCtrl.is18Holes ? sciCtrl.totalScoreCardInfo.in.total_sand_shot : \"-\") }}</div><div class=\"column-total even\">{{ ::(sciCtrl.totalScoreCardInfo.gross.total_sand_shot) }}</div><div class=\"column-total even\">-</div></div><div class=\"row\"><div class=\"column-label odd\">{{:: \"_ROUND_DETAIL.TOTAL.WATER_HAZARD\" | translate }}</div><div class=\"column-total odd\">{{ ::(sciCtrl.totalScoreCardInfo.out.total_water_hazard) }}</div><div class=\"column-total odd\">{{ ::(sciCtrl.is18Holes ? sciCtrl.totalScoreCardInfo.in.total_water_hazard : \"-\") }}</div><div class=\"column-total odd\">{{ ::(sciCtrl.totalScoreCardInfo.gross.total_water_hazard) }}</div><div class=\"column-total odd\">-</div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("round-detail/score-card-info/score-card-info.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	var v1="<div class=\"container page-round-detail\"><div class=\"header-description position-relative\"><div class=\"memo\">Memo</div><a href=\"javascript:void(0)\" class=\"{{(hideHeader || hideLabel) ? 'hide-header' : ''}}\"><div ng-class=\"{freemode: !$root.paid}\" ng-click=\"mmCtrl.editMemo($root.paid)\" analytics-on=\"click\" analytics-event=\"DTL_MemoEdit\" class=\"btn-edit\">{{:: 'EDIT' | translate }}</div></a><div class=\"{{(hideHeader || hideLabel) ? 'hide-header' : ''}}\"><div ng-hide=\"$root.paid\" ng-click=\"mmCtrl.$scope.$parent.navigateToEnterScorePage()\" class=\"help-circle\"></div></div></div><div class=\"description\">{{ mmCtrl.memo }}</div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("round-detail/score-card-memo/memo-show.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	var v1="<div class=\"modal-wrapper\"><div class=\"modal-header\"><button type=\"button\" data-bs-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\" class=\"close\"><span aria-hidden=\"true\">&times;</span></button><h5 class=\"modal-title\">{{:: '_ROUND_DETAIL.MEMO.TITLE' | translate }}</h5></div><div class=\"modal-body\"><div class=\"memo-area\"><textarea name=\"memo\" ng-model=\"memo\" class=\"textarea\"></textarea></div><div class=\"footer row\"><div class=\"col-12 offset-sm-2 col-sm-4 offset-md-3 col-md-3\"><button type=\"button\" ng-click=\"ok()\" class=\"button submit\">{{:: 'SAVE' | translate }}</button></div><div class=\"col-12 col-sm-4 col-md-3\"><button type=\"button\" ng-click=\"cancel()\" class=\"button\">{{:: 'CANCEL' | translate }}</button></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("round-detail/score-card-memo/memo-edit.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(583);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_round_detail.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_round_detail.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.content-semi-circle-charts{position:relative;margin-bottom:20px}.content-semi-circle-charts .chart-left{height:400px;width:49%;position:relative;float:left;background-image:url("+__webpack_require__(468)+");background-repeat:no-repeat;background-position:138px 158px}.content-semi-circle-charts .chart-left .chart{position:absolute;top:27px;left:50%;margin-left:-250px;width:100%;height:400px}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{position:absolute;left:165px;font-size:12px;font-weight:700;text-align:right;width:50px}.content-semi-circle-charts .chart-left .label1,.content-semi-circle-charts .chart-left .label2,.content-semi-circle-charts .chart-left .label3,.content-semi-circle-charts .chart-left .label4,.content-semi-circle-charts .chart-left .label5,.content-semi-circle-charts .chart-left .label6{position:absolute;left:230px;font-size:12px;width:150px}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .label1{top:236px}.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .label2{top:260px}.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .label3{top:284px}.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .label4{top:308px}.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .label5{top:332px}.content-semi-circle-charts .chart-left .value6,.content-semi-circle-charts .chart-left .label6{top:356px}.content-semi-circle-charts .chart-right{height:400px;width:49%;position:relative;float:right;background-image:url("+__webpack_require__(469)+");background-repeat:no-repeat;background-position:58px 90px}.content-semi-circle-charts .chart-right .chart{position:absolute;top:27px;left:50%;margin-left:-250px;width:100%;height:400px}.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{position:absolute;left:244px;font-size:20px;font-weight:700}.content-semi-circle-charts .chart-right .value1{top:253px;color:#00B8B5}.content-semi-circle-charts .chart-right .value2{top:294px;color:#008886}.content-semi-circle-charts .chart-right .value3{top:334px;color:#006A68}.content-semi-circle-charts .chart-left,.content-semi-circle-charts .chart-right{background-color:#fff}.content-semi-circle-charts .chart-left .title,.content-semi-circle-charts .chart-right .title{position:absolute;top:123px;width:100%;text-align:center;font-size:14px;color:#00B8B5}@media (max-width:768px){.content-semi-circle-charts{position:relative;margin-bottom:20px}.content-semi-circle-charts .chart-left{height:400px;width:49%;float:left;position:relative;background-position:36% 160px}.content-semi-circle-charts .chart-left .chart{margin-left:-190px}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:29%}.content-semi-circle-charts .chart-left .label1,.content-semi-circle-charts .chart-left .label2,.content-semi-circle-charts .chart-left .label3,.content-semi-circle-charts .chart-left .label4,.content-semi-circle-charts .chart-left .label5,.content-semi-circle-charts .chart-left .label6{left:47%}.content-semi-circle-charts .chart-right{height:400px;width:49%;float:right;position:relative;background-position:7% 90px}.content-semi-circle-charts .chart-right .chart{margin-left:-190px}.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{left:51%}}@media (max-width:600px){.content-semi-circle-charts .chart-left{height:400px;width:100%;position:relative;background-position:44% 158px}.content-semi-circle-charts .chart-left .chart{left:33%;margin-left:-200px}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:38%}.content-semi-circle-charts .chart-left .label1,.content-semi-circle-charts .chart-left .label2,.content-semi-circle-charts .chart-left .label3,.content-semi-circle-charts .chart-left .label4,.content-semi-circle-charts .chart-left .label5,.content-semi-circle-charts .chart-left .label6{left:47%}.content-semi-circle-charts .chart-right{height:400px;width:100%;position:relative;background-position:31% 90px}.content-semi-circle-charts .chart-right .chart{left:33%;margin-left:-200px}.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{left:52%}}@media (max-width:414px){.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:34%}.content-semi-circle-charts .chart-left .label1,.content-semi-circle-charts .chart-left .label2,.content-semi-circle-charts .chart-left .label3,.content-semi-circle-charts .chart-left .label4,.content-semi-circle-charts .chart-left .label5,.content-semi-circle-charts .chart-left .label6{left:50%}.content-semi-circle-charts .chart-left .chart{left:48%}.content-semi-circle-charts .chart-right{background-position:15% 90px}.content-semi-circle-charts .chart-right .chart{left:48%}}@media (max-width:375px){.content-semi-circle-charts .chart-left{background-position:37% 158px}.content-semi-circle-charts .chart-left .chart{left:53%}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:34%}.content-semi-circle-charts .chart-right{background-position:9% 90px}.content-semi-circle-charts .chart-right .chart{left:53%}}@media (max-width:360px){.content-semi-circle-charts .chart-left{background-position:37% 158px}.content-semi-circle-charts .chart-left .chart{left:56%}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:34%}.content-semi-circle-charts .chart-right{background-position:13% 92px}.content-semi-circle-charts .chart-right .chart,.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{left:56%}}@media (max-width:320px){.content-semi-circle-charts .chart-left{background-position:37% 158px}.content-semi-circle-charts .chart-left .chart{left:62%}.content-semi-circle-charts .chart-left .value1,.content-semi-circle-charts .chart-left .value2,.content-semi-circle-charts .chart-left .value3,.content-semi-circle-charts .chart-left .value4,.content-semi-circle-charts .chart-left .value5,.content-semi-circle-charts .chart-left .value6{left:34%}.content-semi-circle-charts .chart-right{background-position:11% 128px;background-size:168px}.content-semi-circle-charts .chart-right .title{top:154px}.content-semi-circle-charts .chart-right .chart{left:62%}.content-semi-circle-charts .chart-right .value1,.content-semi-circle-charts .chart-right .value2,.content-semi-circle-charts .chart-right .value3{left:54%;font-size:13px}.content-semi-circle-charts .chart-right .value1{top:266px}.content-semi-circle-charts .chart-right .value2{top:299px}}#page-round-detail .content-course-info{position:relative;margin-bottom:20px}#page-round-detail .content-course-info .help-circle{position:absolute;width:42px;height:42px;right:-20px;z-index:1;top:25px;background-image:url("+__webpack_require__(18)+")}@media (max-width:414px){#page-round-detail .content-course-info .help-circle{right:-5px;top:130px}}#page-round-detail .content-course-info .column-date{height:100px;background-color:#4ac2c2;text-align:center;color:#fff;margin-top:5px;margin-bottom:5px}#page-round-detail .content-course-info .column-date .yeardate{font-size:20px;line-height:82px;margin-top:10px}#page-round-detail .content-course-info .column-weather{height:100px;background-color:#6ecece;background-position:center;background-repeat:no-repeat;margin-top:5px;margin-bottom:5px}#page-round-detail .content-course-info .column-weather.icons-cloudy{background-image:url("+__webpack_require__(370)+")}#page-round-detail .content-course-info .column-weather.icons-foggy{background-image:url("+__webpack_require__(372)+")}#page-round-detail .content-course-info .column-weather.icons-rainy{background-image:url("+__webpack_require__(374)+")}#page-round-detail .content-course-info .column-weather.icons-snowing{background-image:url("+__webpack_require__(376)+")}#page-round-detail .content-course-info .column-weather.icons-sunny{background-image:url("+__webpack_require__(378)+")}#page-round-detail .content-course-info .column-course{margin-top:5px;margin-bottom:10px;background-color:#fff;padding:0}@media (min-width:768px){#page-round-detail .content-course-info .column-course{height:100px}}@media (max-width:768px){#page-round-detail .content-course-info .column-course{min-height:100px}}#page-round-detail .content-course-info .column-course .course-list{width:100%}@media (max-width:414px){#page-round-detail .content-course-info .column-course .course-list{-webkit-line-clamp:2}}#page-round-detail .content-course-info .column-course .course-list .course-name-wrap{padding:25px 15px 15px}@media (max-width:414px){#page-round-detail .content-course-info .column-course .course-list .course-name-wrap{padding:20px 15px 15px;-webkit-line-clamp:2}}#page-round-detail .content-course-info .column-course .course-list .course-name{width:92%;margin:0;font-size:18px;font-weight:700;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical}@media (max-width:992px){#page-round-detail .content-course-info .column-course .course-list .course-name{width:87%}}@media (max-width:414px){#page-round-detail .content-course-info .column-course .course-list .course-name{-webkit-line-clamp:2}}#page-round-detail .content-course-info .column-course .course-list .course-name.long-text{width:100%}#page-round-detail .content-course-info .column-course .course-list .course-name.short-text{width:91%}@media (max-width:992px){#page-round-detail .content-course-info .column-course .course-list .course-name.short-text{width:86%}}@media (max-width:414px){#page-round-detail .content-course-info .column-course .course-list .course-name.short-text{width:100%}}#page-round-detail .content-course-info .column-course .course-list .course-addr{width:600px;margin-top:5px;font-size:14px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}@media (max-width:768px){#page-round-detail .content-course-info .column-course .course-list .course-addr{width:100%}}#page-round-detail .content-course-info .column-course .btn-edit{position:absolute;top:0;right:0;width:80px;height:40px;background-color:#ee2e2e;color:#fff;font-size:12px;font-weight:700;text-align:center;text-indent:20px;line-height:40px;background-image:url("+__webpack_require__(584)+");background-repeat:no-repeat;background-position:8px center}@media (max-width:414px){#page-round-detail .content-course-info .column-course .btn-edit{width:100%}}#page-round-detail .content-course-info .column-course .btn-edit a{height:40px;display:block;text-decoration:none;color:#fff}#page-round-detail .content-course-info .column-hdcp{height:60px;background-color:#e5e5e5;font-size:14px;font-weight:700;text-indent:70px;line-height:60px;background-image:url("+__webpack_require__(585)+");background-repeat:no-repeat;background-position:30px center}#page-round-detail .content-course-info .column-hdcp-name,#page-round-detail .content-course-info .column-hdcp-name-sm{height:60px;background-color:#fff;font-size:14px;line-height:60px;background-repeat:no-repeat;background-position:20px center}#page-round-detail .content-course-info .column-hdcp-name .name,#page-round-detail .content-course-info .column-hdcp-name-sm .name{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;background-repeat:no-repeat;background-position:10px 20px;background-image:url("+__webpack_require__(586)+");text-indent:45px}#page-round-detail .content-course-info .column-hdcp-name .hdcp,#page-round-detail .content-course-info .column-hdcp-name-sm .hdcp{text-indent:0}#page-round-detail .content-course-info .column-hdcp-name .name{position:absolute;width:145px}#page-round-detail .content-course-info .column-hdcp-name .hdcp{position:absolute;width:75px;left:160px}@media (max-width:767px){#page-round-detail .content-course-info .row.cource-detail{margin-left:0;margin-right:0}#page-round-detail .content-course-info .column-weather,#page-round-detail .content-course-info .column-date{margin-bottom:0}#page-round-detail .content-course-info .column-course{margin-top:0}}@media (max-width:414px){#page-round-detail .round-detail-competitor{background-color:#e5e5e5}#page-round-detail .round-detail-competitor .column-hdcp{width:240px;margin:0 auto}#page-round-detail .player-info-wrap{width:200px;margin:0 auto;position:relative}}#page-round-detail .content-charts .round-icon-wrap{margin-bottom:10px;height:5px;position:relative}#page-round-detail .content-charts .icon-round{position:absolute;top:5px;left:10px;width:40px;height:40px;background-repeat:no-repeat;background-position:center;background-size:40px;line-height:40px}#page-round-detail .content-charts .icon-round.icons-half-nine{background-image:url("+__webpack_require__(538)+")}#page-round-detail .content-charts .icon-round.icons-extra9{background-image:url("+__webpack_require__(539)+")}#page-round-detail .content-charts .freemode{opacity:.3}#page-round-detail .content-charts .charts{background-color:#e5e5e5;margin-bottom:20px}#page-round-detail .content-charts .column{height:210px;margin-bottom:20px}#page-round-detail .content-charts .bar-layer{position:absolute;width:340px;height:56px;top:139px;left:120px}#page-round-detail .content-charts .bar-layer .bar-avg-score{position:absolute;height:18px;top:16px;background-color:#00adad}#page-round-detail .content-charts .bar-layer .bar-all-avg-score{position:absolute;height:18px;top:38px;background-color:#b2af98}#page-round-detail .content-charts .bar-layer .pin-goal{position:absolute;width:54px;height:56px;margin-left:-6px;background-image:url("+__webpack_require__(470)+")}#page-round-detail .content-charts .score-circle{position:absolute;left:30px;top:50%;margin-top:-90px;color:#fff;text-align:center;background-color:#00adad;width:180px;height:180px;border-radius:90px}#page-round-detail .content-charts .score-circle .title{position:absolute;font-size:12px;width:100%;line-height:60px}#page-round-detail .content-charts .score-circle .value{position:absolute;font-size:50px;font-weight:700;width:100%;line-height:180px}#page-round-detail .content-charts .score-circle .hole{position:absolute;top:120px;font-size:10px;width:100%;line-height:60px}#page-round-detail .content-charts .help-circle{position:absolute;width:42px;height:42px;left:300px;top:20px;background-image:url("+__webpack_require__(18)+");background-size:42px}#page-round-detail .content-charts .goal-circle{position:absolute;top:30px;left:50%;color:#fff;text-align:center;background-color:#ee2e2e;width:90px;height:90px;border-radius:45px}#page-round-detail .content-charts .goal-circle .title{position:absolute;font-size:12px;width:100%;line-height:30px}#page-round-detail .content-charts .goal-circle .value{position:absolute;font-size:22px;font-weight:700;width:100%;line-height:90px}#page-round-detail .content-charts .all-score-circle{position:absolute;left:80%;top:30px;color:#7c7a6a;text-align:center;background-color:#b2af98;width:90px;height:90px;border-radius:45px}#page-round-detail .content-charts .all-score-circle .title{position:absolute;font-size:12px;width:100%;line-height:30px}#page-round-detail .content-charts .all-score-circle .value{position:absolute;font-size:22px;font-weight:700;width:100%;line-height:90px}#page-round-detail .content-charts .column-chart-percent{height:230px}#page-round-detail .content-charts .column-chart-percent .chart{position:absolute;width:170px;height:170px;top:10px;left:40%}#page-round-detail .content-charts .column-chart-percent .sub-title{position:absolute;top:182px;left:132px;font-size:12px;font-weight:700;width:180px;height:20px;text-align:center;color:#00adad}@media (max-width:414px){#page-round-detail .content-charts .column-chart-percent .sub-title{left:148px}}#page-round-detail .content-charts .column-chart-percent .goal{left:20px;top:80px;width:150px;position:absolute}#page-round-detail .content-charts .column-chart-percent .goal .circle{position:relative;float:left;color:#fff;text-align:center;font-size:10px;line-height:40px;background-color:#ee2e2e;width:40px;height:40px;border-radius:20px}#page-round-detail .content-charts .column-chart-percent .goal .value{position:relative;left:5px;font-size:18px;font-weight:700;width:100%;color:#ee2e2e;line-height:40px}#page-round-detail .content-charts .column-chart-percent .all-avg{left:20px;top:130px;width:150px;position:absolute}#page-round-detail .content-charts .column-chart-percent .all-avg .circle{position:relative;float:left;color:#7c7a6a;text-align:center;font-size:10px;line-height:14px;background-color:#b2af98;width:40px;border-radius:20px;height:40px;padding-top:6px}#page-round-detail .content-charts .column-chart-percent .all-avg .value{position:relative;left:5px;font-size:18px;font-weight:700;width:100%;color:#7c7a6a;line-height:40px}@media (max-width:768px){#page-round-detail .content-charts .help-circle{left:450px}}@media (max-width:767px){#page-round-detail .content-charts .container.charts{height:auto}#page-round-detail .content-charts .round-icon-wrap{margin-bottom:30px}#page-round-detail .content-charts .score-circle{left:10px;width:120px;height:120px}#page-round-detail .content-charts .score-circle .value{font-size:40px;line-height:120px}#page-round-detail .content-charts .score-circle .hole{top:70px}#page-round-detail .content-charts .bar-layer{width:225px;height:37px;top:78px;left:70px}#page-round-detail .content-charts .goal-circle,#page-round-detail .content-charts .all-score-circle{width:68px;height:68px;top:19.8px}#page-round-detail .content-charts .goal-circle .title,#page-round-detail .content-charts .all-score-circle .title{font-size:8px}#page-round-detail .content-charts .goal-circle .value,#page-round-detail .content-charts .all-score-circle .value{line-height:68px}#page-round-detail .content-charts .goal-circle{left:210px}#page-round-detail .content-charts .all-score-circle{left:290px}#page-round-detail .content-charts .help-circle{left:250px;top:20px}}@media (max-width:320px){#page-round-detail .content-charts .goal-circle{left:165px}#page-round-detail .content-charts .all-score-circle{left:245px}#page-round-detail .content-charts .help-circle{top:16px;left:206px}}#page-round-detail .content-score-board{position:relative;margin-bottom:20px}#page-round-detail .content-score-board .container{background-color:#e5e5e5}#page-round-detail .content-score-board .help-circle{position:absolute;width:42px;height:42px;right:-20px;z-index:1;top:25px;background-image:url("+__webpack_require__(18)+")}@media (max-width:414px){#page-round-detail .content-score-board .help-circle{right:-5px}}#page-round-detail .content-score-board .header-score-board{height:60px}#page-round-detail .content-score-board .header-score-board .btn-edit{position:relative;top:0;right:0;width:80px;height:40px;float:right;background-color:#ee2e2e;color:#fff;font-size:12px;font-weight:700;text-align:center;text-indent:20px;line-height:40px;background-image:url("+__webpack_require__(584)+");background-repeat:no-repeat;background-position:8px center}#page-round-detail .content-score-board .header-score-board .btn-edit a{height:40px;display:block;text-decoration:none;color:#fff}#page-round-detail .content-score-board .score-board .score-title{background-color:#00B2AF;height:40px;line-height:40px;color:#fff;font-size:18px;font-weight:700;text-indent:20px;margin-bottom:1px}#page-round-detail .content-score-board .score-board .row{position:relative;margin-bottom:1px;margin-left:0;height:40px;line-height:40px;text-align:center}#page-round-detail .content-score-board .score-board .row.header{height:30px;line-height:30px}#page-round-detail .content-score-board .score-board .row .header{background-color:#9BA7A5;color:#fff}#page-round-detail .content-score-board .score-board .row .odd{background-color:#fff;color:#333}#page-round-detail .content-score-board .score-board .row .even{background-color:#F2F2F2;color:#333}#page-round-detail .content-score-board .score-board .row .score-label{position:absolute;left:0;width:160px;height:100%;text-align:left;text-indent:15px;font-size:100%;font-weight:400}#page-round-detail .content-score-board .score-board .row .score-label.player{font-weight:700}#page-round-detail .content-score-board .score-board .row .column-label{width:20%;float:left;text-align:left;text-indent:15px}@media (max-width:375px){#page-round-detail .content-score-board .score-board .row .column-label{font-size:9px}}#page-round-detail .content-score-board .score-board .row .group{position:absolute;height:100%;left:161px;right:0;font-size:14px}#page-round-detail .content-score-board .score-board .row .group .hole{position:relative;float:left;width:9.5%;height:100%;font-size:14px;font-weight:700;background-repeat:no-repeat;background-position:center}#page-round-detail .content-score-board .score-board .row .group .total{position:relative;float:left;width:14.5%;height:100%;font-size:19px;font-weight:700}#page-round-detail .content-score-board .score-board .row .group .total.header{font-size:14px;font-weight:400}#page-round-detail .content-score-board .score-board{left:50%;margin-bottom:50px}#page-round-detail .content-score-board .score-board .row .title-green{background-color:#00B2AF;width:20%;height:40px;line-height:40px;color:#fff;font-size:17px;font-weight:700;text-indent:20px;text-align:left;float:left}#page-round-detail .content-score-board .score-board .row .title-gray{background-color:#9BA7A5;width:19.6%;height:40px;line-height:40px;color:#fff;font-size:15px;margin-left:1px;float:left}@media (max-width:768px){#page-round-detail .content-score-board .score-board .row .title-gray{width:19.4%}}#page-round-detail .content-score-board .score-board .row .column-total{width:19.6%;margin-left:1px;float:left}@media (max-width:768px){#page-round-detail .content-score-board .score-board .row .column-total{width:19.4%}}#page-round-detail .content-score-board .score-board .row .column-total.score.odd{font-weight:700;font-size:19px}#page-round-detail .content-score-board .score-board .row .column-total.even,#page-round-detail .content-score-board .score-board .row .column-total.odd{font-size:15px}#page-round-detail .content-score-board .score-board .row .group .hole.score{font-size:19px;font-weight:700}#page-round-detail .content-score-board .score-board .row .group .hole.check{background-image:url("+__webpack_require__(379)+")}#page-round-detail .content-score-board .score-board .row .group .hole.arrow-back{background-image:url("+__webpack_require__(380)+")}#page-round-detail .content-score-board .score-board .row .group .hole.arrow-forward{background-image:url("+__webpack_require__(381)+")}#page-round-detail .content-score-board .score-board .row .group .hole.circle-green{background-image:url("+__webpack_require__(382)+")}@media (max-width:375px){#page-round-detail .content-score-board .score-board .row .group .hole.circle-green{background-size:15px 15px!important}}#page-round-detail .content-score-board .score-board .row .group .hole.circle-red{background-image:url("+__webpack_require__(383)+")}@media (max-width:375px){#page-round-detail .content-score-board .score-board .row .group .hole.circle-red{background-size:15px 15px!important}}#page-round-detail .content-score-board .score-board .row .group .myscore{font-size:25px}#page-round-detail .content-score-board .score-board .row .group .myscore.condor,#page-round-detail .content-score-board .score-board .row .group .myscore.albatross{background-color:gold;color:#fff}#page-round-detail .content-score-board .score-board .row .group .myscore.eagle{background-color:#FC1A3A;color:#fff}#page-round-detail .content-score-board .score-board .row .group .myscore.birdie{background-color:#F7931E;color:#fff}#page-round-detail .content-score-board .score-board .row .group .myscore.par{background-color:#05A2D3;color:#fff}#page-round-detail .content-score-board .score-board .row .group .myscore.bogey{background-color:#043377;color:#fff}#page-round-detail .content-score-board .score-board .row .group .myscore.dbogey{background-color:#215605;color:#fff}#page-round-detail .content-score-board .score-board .row .group .myscore.overTbogey{background-color:#3A3A3A;color:#fff}@media (max-width:767px){#page-round-detail .content-score-board .score-board{left:unset;margin-left:0;margin-right:0;width:auto}#page-round-detail .content-score-board .score-board .title-gray{width:100px}#page-round-detail .content-score-board .score-board .row{margin-left:0;margin-right:0;width:auto}#page-round-detail .content-score-board .score-board .row .title-green,#page-round-detail .content-score-board .score-board .row .column-label{width:38.5%}#page-round-detail .content-score-board .score-board .row .title-gray,#page-round-detail .content-score-board .score-board .row .column-total{width:15%}}#page-round-detail .content-board{margin-bottom:20px}#page-round-detail .content-board>.container{padding-top:60px;padding-bottom:60px;background-color:#e5e5e5}#page-round-detail .content-board .sub-score-board{padding:0}#page-round-detail .content-board .sub-score-board .row.row-analysis{margin-right:-25px;margin-left:-30px}#page-round-detail .content-board .sub-score-board .board{left:50%;padding:0}@media (max-width:768px){#page-round-detail .content-board .sub-score-board .board{width:771px}}#page-round-detail .content-board .sub-score-board .board .row{height:40px;line-height:40px}#page-round-detail .content-board .sub-score-board .board .row.header{height:50px}#page-round-detail .content-board .sub-score-board .board .column-label{width:20.2%;-ms-flex:0 0 20.2%;flex:0 0 20.2%;margin-right:1px;margin-left:14px;float:left;text-indent:20px;font-size:12px}@media (max-width:768px){#page-round-detail .content-board .sub-score-board .board .column-label{font-size:8px}}#page-round-detail .content-board .sub-score-board .board .column-label.odd,#page-round-detail .content-board .sub-score-board .board .column-label.even{margin-left:15px}#page-round-detail .content-board .sub-score-board .board .column{width:19.3%;-ms-flex:0 0 19.3%;flex:0 0 19.3%;float:left;font-size:14px;text-align:center}@media (max-width:768px){#page-round-detail .content-board .sub-score-board .board .column{width:18.3%}}#page-round-detail .content-board .sub-score-board .board .column.header{padding-right:0;text-align:center;font-size:12px;line-height:20px;margin-top:5px}#page-round-detail .content-board .sub-score-board .board .odd{background-color:#fff}#page-round-detail .content-board .sub-score-board .board .even{background-color:#F2F2F2}@media (max-width:767px){#page-round-detail .content-board .sub-score-board .board{width:100%;left:unset;margin-left:0}#page-round-detail .content-board .sub-score-board .board .row{margin-left:0;margin-right:0;width:100%}#page-round-detail .content-board .sub-score-board .board .column-label{width:40%;font-size:9px;margin-left:0;text-indent:2px}#page-round-detail .content-board .sub-score-board .board .column-label.one-member{width:60%}}@media (max-width:767px) and (max-width:414px){#page-round-detail .content-board .sub-score-board .board .column-label.one-member{text-indent:15px}}@media (max-width:767px){#page-round-detail .content-board .sub-score-board .board .column-label.odd,#page-round-detail .content-board .sub-score-board .board .column-label.even{margin-left:0}#page-round-detail .content-board .sub-score-board .board .column.header{width:14%!important;-ms-flex:0 0 14%!important;flex:0 0 14%!important}#page-round-detail .content-board .sub-score-board .board .column.one-player{width:39.6%!important;-ms-flex:0 0 39.6%!important;flex:0 0 39.6%!important;text-align:center}#page-round-detail .content-board .sub-score-board .board .column-label.one-player-label{width:60%!important;-ms-flex:0 0 60%!important;flex:0 0 60%!important;text-indent:15px}#page-round-detail .content-board .sub-score-board .board .column{text-indent:4px;width:14.93%!important;-ms-flex:0 0 14.93%!important;flex:0 0 14.93%!important;margin:0;padding:0;text-align:left}#page-round-detail .content-board .sub-score-board .board .column.one-member{width:39.6%!important;-ms-flex:0 0 39.6%!important;flex:0 0 39.6%!important;text-align:center}#page-round-detail .content-board .sub-score-board .board .column.odd,#page-round-detail .content-board .sub-score-board .board .column.even{width:10%;-ms-flex:0 0 10%!important;flex:0 0 10%!important}#page-round-detail .content-board .container{padding-top:0}}#page-round-detail .bar-goal{position:relative;height:40px;background-image:url("+__webpack_require__(465)+"),url("+__webpack_require__(587)+");background-repeat:no-repeat,repeat-x;background-position:right,bottom;background-color:#d4d4d4}#page-round-detail .bar-goal .click-space{position:absolute;height:38px;width:122px;top:2px;right:0;padding:8px 32px;font-size:14px;text-decoration:none;color:#fff;background-color:#ee2e2e}#page-round-detail .bar-goal .click-space a.click{position:relative;top:-20px;left:-33px;margin-top:9px;padding-top:12px;padding-left:25px;width:123px;height:43px;display:block;text-decoration:none;color:#fff}@media (max-width:767px){#page-round-detail .bar-goal .click-space{left:auto}}#page-round-detail .content-memo{position:relative;margin-bottom:20px}#page-round-detail .content-memo .container{background-color:#e5e5e5;padding-bottom:60px}#page-round-detail .content-memo .help-circle{position:absolute;width:42px;height:42px;right:-20px;z-index:1;top:25px;background-image:url("+__webpack_require__(18)+")}@media (max-width:414px){#page-round-detail .content-memo .help-circle{right:-5px}}#page-round-detail .content-memo .header-description{height:60px}#page-round-detail .content-memo .header-description .memo{position:absolute;padding-top:15px;font-size:14px;font-weight:700;text-indent:15px}#page-round-detail .content-memo .header-description .btn-edit{position:relative;top:0;right:0;width:80px;height:40px;float:right;background-color:#ee2e2e;color:#fff;font-size:12px;font-weight:700;text-align:center;text-indent:20px;line-height:40px;background-image:url("+__webpack_require__(584)+");background-repeat:no-repeat;background-position:8px center}#page-round-detail .content-memo .header-description .btn-edit a{height:40px;display:block;text-decoration:none;color:#fff}#page-round-detail .content-memo .description{font-size:14px;font-weight:700;line-height:27px;white-space:pre-line;word-wrap:break-word;text-align:justify;margin:0 15px}a.score-float-icon{background-image:url("+__webpack_require__(540)+");width:150px;background-size:150px;height:150px;border-radius:20px;background-color:transparent;border-color:transparent}a.score-float-icon,.score-float-icon-wrap .help-circle{position:fixed;right:2%;top:80%;z-index:1;background-repeat:no-repeat;background-position:center}.score-float-icon-wrap .help-circle{width:60px;height:60px;background-size:60px;background-image:url("+__webpack_require__(18)+")}.score-float-icon-wrap .help-circle.freemode{opacity:1}.freemode{opacity:.3}@media (max-width:1024px){a.score-float-icon{right:5%}}@media (max-width:768px){a.score-float-icon{right:3%}}@media (max-width:414px){a.score-float-icon{right:3px;width:100px;height:100px;background-size:100px}.score-float-icon-wrap .help-circle{right:1%;top:80%;width:45px;height:45px;background-size:45px}}@media (max-width:412px){a.score-float-icon{right:4px;width:100px;height:100px;background-size:100px}}@media (max-width:375px){a.score-float-icon{right:1px}.score-float-icon-wrap .help-circle{right:-.5%}}@media (max-width:360px){a.score-float-icon{right:0}}@media (max-width:320px){a.score-float-icon{right:-3px}}#page-round-detail{background-color:#d4d4d4}#page-round-detail .container.page-round-detail{max-width:970px}#page-round-detail .container.page-round-detail .row-top{margin-left:0;margin-right:0}#page-round-detail .freemode{opacity:.3}#page-round-detail .position-relative{position:relative}#page-round-detail .cell{padding:0}#page-round-detail .btn-close{position:relative;width:50px;height:50px;background-image:url("+__webpack_require__(588)+");background-position:center;background-repeat:no-repeat;float:right;cursor:pointer}#page-round-detail .content-map{margin-bottom:20px}#page-round-detail .content-map .map{height:360px;background-color:#fff}#page-round-detail .btn-player-dropdown{width:100%;border:1px solid #555;margin:-5px 0 0 -5px}#page-round-detail .btn-player-dropdown.is-fulltext{background-color:unset;border:none}#page-round-detail .btn-player-dropdown .title{width:80%;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical}#page-round-detail .btn-player-dropdown .title.is-fulltext{width:100%}#page-round-detail .btn-player-dropdown .player-caret{margin-top:13px;border-left:8px solid transparent;border-right:8px solid transparent;border-top:12px solid #000}#page-round-detail .player-name,#page-round-detail .player-name-xs{overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical}#page-round-detail .player-name-xs{padding:0 5px;width:95%}#page-round-detail .player-name{display:-webkit-box}#page-round-detail .player-analysis-dropdown{top:unset;left:unset;width:39.6%;min-width:unset}#page-round-detail .player-analysis-dropdown li{border-bottom:1px solid #555;text-align:center}#page-round-detail .player-analysis-dropdown li a{padding:3px 0}#page-round-detail .player-analysis-dropdown li:last-child{border-bottom:none}.modal-wrapper .footer{text-align:center;margin-top:20px}.modal-wrapper .memo-area{padding:0}.modal-wrapper .memo-area .textarea{height:100px;width:100%;resize:none}.modal-wrapper .button{height:45px;min-width:160px;background-color:#00adad;color:#fff;border-radius:5px;border-color:#00adad;border-width:2px;border-style:solid;font-size:14px}.modal-wrapper .button.submit{margin-bottom:10px}#modal-overlay{position:fixed;top:0;left:0;width:100%;height:120%;z-index:1;display:none;background-color:rgba(0,0,0,.75)}a{text-decoration:none}.button-link:hover{cursor:pointer}@media (max-width:767px){#page-round-detail .container.page-round-detail{max-width:970px;width:auto!important}#page-round-detail .score-board-app{width:auto}#page-round-detail .score-board-app .col-3 .hole{font-size:12px}}@media (max-width:767px) and (max-width:375px){#page-round-detail .score-board-app .col-3 .hole{font-size:10px}}@media (max-width:767px){#page-round-detail .score-board-app .col-2 .hole.myscore{font-size:12px!important}}@media (max-width:767px) and (max-width:375px){#page-round-detail .score-board-app .col-2 .hole.myscore{font-size:10px}}", ""]);

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAZlBMVEX///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+rG8stAAAAIXRSTlMABAkKCwwTFRodHiAhKTdiZZGWl5ulqaq7vtPc3ebw8/SIyyV6AAAAXElEQVQI11XOVw6AMAwD0LD3LFCgZfj+l6RIJID/nixZJuIk86k8UbwCUNKVk+PGWm2pgZEFOC+ByDn3P8LTxT9Rpr+qzb3JogG20KLoAEzq850Ge1fJVerb8AVdwCcIrmdwnPIAAAAASUVORK5CYII="

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAVCAMAAABi3H5uAAABFFBMVEWZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmsnkRTAAAAW3RSTlMAAQMEBgkKCwwNDg8QFBgZGxwgIiMsLTEzNDU4Pj9AQ0lUWF1eYGdsb3FydXZ4eX+AhoqMj5KXnp+goaWmp6ittbq8vsLEyMnKzNDR3N3e4OXn7fL09vj5/P3+SUUbRgAAANtJREFUGBltwQkjwmAAx+F/lnLnyi3kiuSInJH73EZy9vv+30N722rM8yiQnFvN6H/TD5/wVdxKKSpm07SvqEF8l4pK47tR1BS+Wykxk9+MK2QB31089Qq4R2qzCWwsYSTV4hLYWccYUksJnzNewBhQ2wHGx3D/C0ZBbV3nNNRXNErTvcKqwJnUUcHzNq8wFyhKSjzSkFfYZB04VENnFU7VEhtbPn7Hc5GbsFSGbQWyz4TU9np3sTOWjGyd3576rqF2tRiT5PBXbg1PSbKIKM/i+e5RtxNxMuIY6R9rSWdoUDFyggAAAABJRU5ErkJggg=="

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAMAAABxCz6aAAAAtFBMVEXMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMxi7ZerAAAAO3RSTlMAAQQGCwwNDg8ZGyAsLTEzNDU4QENUWGBnbG92f4aKj5KXnp+hpaaotbq8xMjJzNHc3d7g5/L2+Pn8/gfl6lgAAACKSURBVBgZZcEFAoJAAATABbsbFRXsDsBm//8vFQ+OgxmEst1hB6r2+UW+rXEJkubwbwapTGEPqUrhAKlF4QipR+GUQcRhaISIx9AEkSkFrw5pzsCzgpjcll/+AKobyQ0SPJIWVE2f5AKSVusvH/zZmQ0dAePKmLtdAGD4VF2KgMskEzpT1si7KasPD6ouvqv5Y84AAAAASUVORK5CYII="

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAEAQMAAAB1Fsd5AAAAA1BMVEUzMzPK7GI1AAAAAXRSTlOArV5bRgAAAApJREFUCB1jgAIAAAgAAYw3ty8AAAAASUVORK5CYII="

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeBAMAAADJHrORAAAAHlBMVEVmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmb2HXvaAAAACXRSTlMAChUWl5iZ09TAduSjAAAAhElEQVQY02WPwQ2AMAhFiV3BeDaeOoJreHQNR/CkAxh1W4sU/w82aQq8FwrS9oLTTDIvlOdD8gmh2ddyIeSrMAiKhYQXQzCMt2IPvOzRhy0ENoGwCgNhFTbGRbgZ//Loh37xvzBPnDfs48FYBReT1dHIBPR5Bd5bBZ5DhZkXGQ/peI80PSDSNMzB5gL7AAAAAElFTkSuQmCC"

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	var RoundDetailCtrl;
	
	RoundDetailCtrl = function($scope, $location, $filter, flash, LocationTrackingService, roundInfo, playersAnalysis, goalSettings, allMembersAnalysis, RoundDetailService, $analytics, $routeParams, userInfo) {
	  $analytics.eventTrack('DTL_loaded');
	  RoundDetailService.savePreviousLocation(roundInfo.id);
	  $scope.roundInfo = roundInfo;
	  $scope.playersAnalysis = playersAnalysis;
	  $scope.goalSettings = goalSettings;
	  $scope.allMembers = allMembersAnalysis;
	  $scope.hideHeader = false;
	  $scope.hideLabel = false;
	  if ($routeParams.hide_header === '1') {
	    $scope.hideHeader = true;
	  }
	  if ($routeParams.user_id !== void 0 && $routeParams.event_id !== void 0) {
	    $scope.hideLabel = true;
	  }
	  if ($routeParams.user_id !== void 0 && (userInfo != null) && userInfo.user_id !== $routeParams.user_id) {
	    $scope.hideLabel = true;
	  }
	  $scope.navigateBackToPreviousLink = function() {
	    var transitionFromAnalysis;
	    transitionFromAnalysis = localStorage.getItem("TRANSITION_FROM_ANALYSIS");
	    if (transitionFromAnalysis && transitionFromAnalysis === '1') {
	      return $location.url("/analysis");
	    }
	    if ($routeParams.event_id !== void 0) {
	      return $location.url("/group-event/" + $routeParams.event_id + "/ranking");
	    } else {
	      $location.path(RoundDetailService.getPreviousLocation(roundInfo.id));
	      return RoundDetailService.clearPreviousLocation(roundInfo.id);
	    }
	  };
	  return $scope.navigateToEnterScorePage = function() {
	    if (roundInfo.agency_request_id) {
	      flash.error($filter('translate')('AGENCY_DENINED'));
	      return;
	    }
	    return $location.path("/score-registration/" + $scope.roundInfo.id);
	  };
	};
	
	RoundDetailCtrl.$inject = ['$scope', '$location', '$filter', 'flash', 'LocationTrackingService', 'roundInfo', 'playersAnalysis', 'goalSettings', 'allMembersAnalysis', 'RoundDetailService', '$analytics', '$routeParams', 'userInfo'];
	
	module.exports = RoundDetailCtrl;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var RoundDetailInfoCtrl, convertToViewModel, moment;
	
	moment = __webpack_require__(126);
	
	convertToViewModel = function(roundInfo) {
	  var ref, ref1, ref2, viewModel;
	  viewModel = {
	    club: roundInfo.club,
	    course: roundInfo.course,
	    weather: roundInfo.weather,
	    memo: roundInfo.memo,
	    owner: roundInfo.players[0],
	    play_date: moment(roundInfo.play_date).format("YYYY/MM/DD"),
	    player_1: (ref = roundInfo.players) != null ? ref[1] : void 0,
	    player_2: (ref1 = roundInfo.players) != null ? ref1[2] : void 0,
	    player_3: (ref2 = roundInfo.players) != null ? ref2[3] : void 0
	  };
	  return viewModel;
	};
	
	RoundDetailInfoCtrl = (function() {
	  function RoundDetailInfoCtrl($scope) {
	    this.$scope = $scope;
	    this.roundInfo = convertToViewModel(this.$scope.$parent.roundInfo);
	  }
	
	  return RoundDetailInfoCtrl;
	
	})();
	
	RoundDetailInfoCtrl.$inject = ['$scope'];
	
	module.exports = RoundDetailInfoCtrl;


/***/ }),
/* 591 */
/***/ (function(module, exports) {

	var RoundDetailService;
	
	RoundDetailService = function($http, $q, LocationTrackingService) {
	  var roundPreviousLocations;
	  roundPreviousLocations = {};
	  return {
	    savePreviousLocation: function(id) {
	      var previousLocation;
	      previousLocation = LocationTrackingService.previousLocation();
	      if (roundPreviousLocations[id]) {
	        if (previousLocation === '/history' || previousLocation === '/') {
	          return roundPreviousLocations[id] = previousLocation;
	        }
	      } else {
	        return roundPreviousLocations[id] = previousLocation;
	      }
	    },
	    getPreviousLocation: function(id) {
	      return roundPreviousLocations[id];
	    },
	    clearPreviousLocation: function(id) {
	      return roundPreviousLocations[id] = null;
	    },
	    getRound: function(id) {
	      var delay;
	      delay = $q.defer();
	      $http.get("/api/score_cards/" + id + ".json").then(function(resp) {
	        return delay.resolve(resp.data);
	      });
	      return delay.promise;
	    },
	    getAnalysisDataRound: function(id, params) {
	      var delay;
	      delay = $q.defer();
	      $http.get("/api/score_cards/" + id + "/analysis.json", {
	        params: params
	      }).then(function(resp) {
	        return delay.resolve(resp.data);
	      });
	      return delay.promise;
	    }
	  };
	};
	
	RoundDetailService.$inject = ['$http', '$q', 'LocationTrackingService'];
	
	module.exports = RoundDetailService;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	var PlayersAnalysisCtrl, _;
	
	_ = __webpack_require__(87);
	
	PlayersAnalysisCtrl = function($scope, $routeParams) {
	  $scope.players = $scope.$parent.roundInfo.players;
	  $scope.specialMem = false;
	  $scope.activeTab = 0;
	  if ($routeParams.user_id !== void 0) {
	    $scope.specialMem = true;
	  }
	  $scope.playerAnalysis = _.map($scope.$parent.playersAnalysis.players, function(pa) {
	    return _.mapValues(pa, function(val) {
	      if (_.isNull(val)) {
	        return '-';
	      } else {
	        return val;
	      }
	    });
	  });
	  $scope.activeDisplay = function(tab) {
	    $scope.activeTab = tab;
	  };
	  return $scope.activeDisplay(0);
	};
	
	PlayersAnalysisCtrl.$inject = ['$scope', '$routeParams'];
	
	module.exports = PlayersAnalysisCtrl;


/***/ }),
/* 593 */
/***/ (function(module, exports) {

	var RoundMapCtrl;
	
	RoundMapCtrl = (function() {
	  function RoundMapCtrl($scope, GoogleMapLoaderService) {
	    this.$scope = $scope;
	    this.GoogleMapLoaderService = GoogleMapLoaderService;
	    this.GoogleMapLoaderService.load().then((function(_this) {
	      return function() {
	        return _this.mapOptions = {
	          center: new google.maps.LatLng(_this.$scope.$parent.roundInfo.club.loc[0], _this.$scope.$parent.roundInfo.club.loc[1]),
	          zoom: 15,
	          mapTypeId: google.maps.MapTypeId.SATELLITE
	        };
	      };
	    })(this));
	  }
	
	  return RoundMapCtrl;
	
	})();
	
	RoundMapCtrl.$inject = ['$scope', 'GoogleMapLoaderService'];
	
	module.exports = RoundMapCtrl;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	var RoundBasicChartCtrl, _;
	
	_ = __webpack_require__(87);
	
	RoundBasicChartCtrl = (function() {
	  function RoundBasicChartCtrl($scope) {
	    this.$scope = $scope;
	    this.basicAnalysisData = {
	      goal: this.$scope.$parent.goalSettings,
	      all_members: this.$scope.$parent.allMembers,
	      my_avg: _.merge({}, this.$scope.$parent.playersAnalysis.players[0], {
	        avg_total_shot: this.$scope.$parent.playersAnalysis.players[0].total_shot
	      }),
	      showRoundIcon: true
	    };
	  }
	
	  return RoundBasicChartCtrl;
	
	})();
	
	RoundBasicChartCtrl.$inject = ['$scope'];
	
	module.exports = RoundBasicChartCtrl;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	var RoundScoreChartCtrl, _;
	
	_ = __webpack_require__(87);
	
	RoundScoreChartCtrl = (function() {
	  function RoundScoreChartCtrl($scope) {
	    this.$scope = $scope;
	    this.scoreData = _.pick(this.$scope.$parent.playersAnalysis.players[0], 'rat_under_eagle', 'rat_birdie', 'rat_par', 'rat_bogey', 'rat_dbogey', 'rat_over_tbogey');
	  }
	
	  return RoundScoreChartCtrl;
	
	})();
	
	RoundScoreChartCtrl.$inject = ['$scope'];
	
	module.exports = RoundScoreChartCtrl;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	var RoundStrokeChartCtrl, _;
	
	_ = __webpack_require__(87);
	
	RoundStrokeChartCtrl = (function() {
	  function RoundStrokeChartCtrl($scope) {
	    this.$scope = $scope;
	    this.strokeData = _.pick(this.$scope.$parent.playersAnalysis.players[0], 'avg_shot_par3', 'avg_shot_par4', 'avg_shot_par5');
	  }
	
	  return RoundStrokeChartCtrl;
	
	})();
	
	RoundStrokeChartCtrl.$inject = ['$scope'];
	
	module.exports = RoundStrokeChartCtrl;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	var ScoreCardInfoCtrl, _;
	
	_ = __webpack_require__(87);
	
	ScoreCardInfoCtrl = (function() {
	  function ScoreCardInfoCtrl($scope, ScoreCardParser) {
	    this.$scope = $scope;
	    this.ScoreCardParser = ScoreCardParser;
	    this.is18Holes = _.size(this.$scope.$parent.roundInfo.holes) === 18;
	    this.roundType = this.$scope.$parent.roundInfo.round_type;
	    this.hasExtra = this.$scope.$parent.roundInfo.has_extra;
	    this.course = this.$scope.$parent.roundInfo.course;
	    this.course_extra = this.$scope.$parent.roundInfo.course;
	    this.tee = this.$scope.$parent.roundInfo.tee;
	    this.tee_extra = this.$scope.$parent.roundInfo.tee_extra;
	    if (this.is18Holes) {
	      this.inScoreCardInfo = this.ScoreCardParser.parseInViewModel(this.$scope.$parent.roundInfo);
	    }
	    this.outScoreCardInfo = this.ScoreCardParser.parseOutViewModel(this.$scope.$parent.roundInfo);
	    if (this.hasExtra) {
	      this.extraScoreCardInfo = this.ScoreCardParser.parseScoreCardExtraBoard(this.$scope.$parent.roundInfo);
	    }
	    this.totalScoreCardInfo = this.ScoreCardParser.parseTotalViewModel(this.$scope.$parent.roundInfo, this.is18Holes);
	    this.hasPlayerHdcp = this.$scope.$parent.roundInfo.players[0].player_hdcp !== null;
	  }
	
	  return ScoreCardInfoCtrl;
	
	})();
	
	ScoreCardInfoCtrl.$inject = ['$scope', 'ScoreCardParser'];
	
	module.exports = ScoreCardInfoCtrl;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	var MemoCtrl;
	
	__webpack_require__(581);
	
	MemoCtrl = (function() {
	  function MemoCtrl($scope, $modal, PaymentService) {
	    this.$scope = $scope;
	    this.$modal = $modal;
	    this.PaymentService = PaymentService;
	    this.memo = this.$scope.$parent.roundInfo.memo;
	  }
	
	  MemoCtrl.prototype.editMemo = function(paid) {
	    if (paid) {
	      return this.$modal.open({
	        size: 'lg',
	        templateUrl: 'round-detail/score-card-memo/memo-edit.jade',
	        controller: 'MemoModalCtrl',
	        resolve: {
	          modalModel: (function(_this) {
	            return function() {
	              return {
	                memo: _this.memo,
	                id: _this.$scope.$parent.roundInfo.id
	              };
	            };
	          })(this)
	        }
	      }).result.then((function(_this) {
	        return function(memo) {
	          return _this.memo = memo;
	        };
	      })(this));
	    } else {
	      return this.PaymentService.payModal();
	    }
	  };
	
	  return MemoCtrl;
	
	})();
	
	MemoCtrl.$inject = ['$scope', '$modal', 'PaymentService'];
	
	module.exports = MemoCtrl;


/***/ }),
/* 599 */
/***/ (function(module, exports) {

	var MemoModalCtrl;
	
	MemoModalCtrl = function($scope, $modalInstance, MemoService, modalModel) {
	  $scope.memo = modalModel.memo;
	  $scope.ok = function() {
	    var memo;
	    memo = $scope.memo;
	    return MemoService.updateMemo(modalModel.id, memo).then(function(resp) {
	      return $modalInstance.close(memo);
	    });
	  };
	  return $scope.cancel = function() {
	    return $modalInstance.dismiss('cancel');
	  };
	};
	
	MemoModalCtrl.$inject = ['$scope', '$modalInstance', 'MemoService', 'modalModel'];
	
	module.exports = MemoModalCtrl;


/***/ }),
/* 600 */
/***/ (function(module, exports) {

	var MemoService;
	
	MemoService = function($http) {
	  return {
	    updateMemo: function(id, memo) {
	      return $http.put("/api/score_cards/" + id + ".json", {
	        memo: memo
	      });
	    }
	  };
	};
	
	MemoService.$inject = ['$http'];
	
	module.exports = MemoService;


/***/ }),
/* 601 */
/***/ (function(module, exports) {

	module.exports = {
	  '_ROUND_DETAIL': {
	    "TITLE": 'Round detail',
	    "INFO": {
	      'COMPETITORS': 'Competitors'
	    },
	    "MEMO": {
	      "TITLE": "Memo"
	    },
	    'TOTAL': {
	      'OB': 'OB',
	      'SAND_SAVES': 'Sand Saves',
	      'WATER_HAZARD': 'Water'
	    },
	    'PLAYERS_ANALYSIS': {
	      'PAR_ON': "GIR (%)",
	      'BOGEY_ON': "GIR+1 (%)",
	      'AVG_PUTT': 'Avg. Putts',
	      'AVG_PAR_ON_PUTT_CNT': 'GIR. Avg. Putts',
	      'RAT_UNDER_EAGLE': 'Eagle or under (%)',
	      'RAT_BIRDIE': 'Birdie (%)',
	      'RAT_PAR': 'Par (%)',
	      'RAT_BOGEY': 'Bogey (%)',
	      'RAT_DBOGEY': 'Double Bogey (%)',
	      'RAT_OVER_TBOGEY': 'Triple Bogey or over (%)',
	      'AVG_SHOT_PAR3': 'Avg. Stroke[Par 3]',
	      'AVG_SHOT_PAR4': 'Avg. Stroke[Par 4]',
	      'AVG_SHOT_PAR5': 'Avg. Stroke[Par 5]',
	      'RAT_RECOVERY': 'Recovery (%)',
	      'RAT_SAND_SAVE': 'Sand Saves  (%)',
	      'RAT_FAIRWAY_CENTER': 'Fairway hit (%)',
	      'RAT_FAIRWAY_LEFT': 'Missed left (%)',
	      'RAT_FAIRWAY_RIGHT': 'Missed right (%)'
	    }
	  }
	};


/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports = {
	  '_ROUND_DETAIL': {
	    "TITLE": 'ラウンド詳細',
	    "INFO": {
	      'COMPETITORS': '同伴者'
	    },
	    "MEMO": {
	      "TITLE": "メモ"
	    },
	    'TOTAL': {
	      'OB': 'OB',
	      'SAND_SAVES': 'ガードバンカー',
	      'WATER_HAZARD': 'ウォーターハザード・PN'
	    },
	    'PLAYERS_ANALYSIS': {
	      'PAR_ON': "パーオン率（％）",
	      'BOGEY_ON': "ボギーオン率（％）",
	      'AVG_PUTT': "ひとホールあたりの平均パット数",
	      'AVG_PAR_ON_PUTT_CNT': "パーオン時の平均パット数",
	      'RAT_UNDER_EAGLE': "イーグル以上（％）",
	      'RAT_BIRDIE': "パーディ（％）",
	      'RAT_PAR': "パー（％）",
	      'RAT_BOGEY': "ボギー（％）",
	      'RAT_DBOGEY': "ダブルボギー（％）",
	      'RAT_OVER_TBOGEY': "トリプルボギー以上（％）",
	      'AVG_SHOT_PAR3': "平均ストローク[Par 3]",
	      'AVG_SHOT_PAR4': "平均ストローク[Par 4]",
	      'AVG_SHOT_PAR5': "平均ストローク[Par 5]",
	      'RAT_RECOVERY': "リカバリー",
	      'RAT_SAND_SAVE': "ガードバンカー",
	      'RAT_FAIRWAY_CENTER': 'フェアウェイキープ率（％)',
	      'RAT_FAIRWAY_LEFT': '左ミス（％)',
	      'RAT_FAIRWAY_RIGHT': '右ミス（％)'
	    }
	  }
	};


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	var FriendCtrl, FriendService, modules;
	
	__webpack_require__(604);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(76);
	
	__webpack_require__(82);
	
	__webpack_require__(117);
	
	__webpack_require__(108);
	
	__webpack_require__(412);
	
	__webpack_require__(607);
	
	FriendCtrl = __webpack_require__(609);
	
	FriendService = __webpack_require__(610);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-auth', 'gnp-common-wrapper', 'gnp-form', 'gnp-hdcp', 'gnp-animate', 'gnp-error-handler'];
	
	angular.module('gnp-app-friend', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/friend', {
	      templateUrl: 'web/friend/friend.jade',
	      controller: 'FriendCtrl',
	      title: '_FRIEND.TITLE',
	      permission: {
	        signInRequired: true
	      }
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(611)).translations('ja', __webpack_require__(612));
	  }
	]).controller('FriendCtrl', FriendCtrl).factory('FriendService', FriendService);


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"friend_setting-main\" gnp-common-wrapper-a=\"\"><div ng-click=\"clearAllEditMode()\"><div class=\"container friend\"><div class=\"col-12 title-bar\"><span class=\"title\">{{:: '_FRIEND.TITLE' | translate }}</span></div><div gnp-indicator=\"isLoading\" class=\"col-12 content\"><div class=\"col-12 row bar\"><div ng-click=\"changeSort('name')\" class=\"col-4 col-sm-4 cell1\">{{:: '_FRIEND.NAME' | translate }}<img ng-class=\"sortClass('name')\" src=\"" + __webpack_require__(605) + "\" class=\"sort-img name-img\"/></div><div ng-click=\"changeSort('player_hdcp')\" class=\"col-3 col-sm-2 cell1 player-hdcp\">HDCP<img ng-class=\"sortClass('player_hdcp')\" src=\"" + __webpack_require__(605) + "\" class=\"sort-img hdcp-img\"/></div><div ng-click=\"changeSort('email')\" class=\"col-5 col-sm-5 email-cell cell1\"><span>{{:: '_FRIEND.EMAIL' | translate }}</span><img ng-class=\"sortClass('email')\" src=\"" + __webpack_require__(605) + "\" class=\"sort-img email-img\"/></div><div class=\"d-none d-sm-block col-sm-1 cell1\"></div></div><div class=\"col-12 no-padding add-friend-form\"><form name=\"newFriend.form\" novalidate=\"\" gnp-submit=\"addFriend()\" ng-keydown=\"handleKeyDown($event)\" class=\"row\"><input name=\"name\" placeholder=\"{{ '_FRIEND.ENTER_NEW_FRIEND' | translate }}\" ng-model=\"newFriend.name\" required=\"\" class=\"col-4 col-sm-4 cell2\"/><div ng-show=\"newFriend.form.$invalid &amp;&amp; newFriend.form.$dirty &amp;&amp; newFriend.form.name.$error.required\" role=\"tooltip\" style=\"top: 35px; left: 169.833px; display: block\" class=\"tooltip fade bottom show\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\">{{:: \"VALIDATION.REQUIRED\" | translate }}</div></div><div class=\"content-row-odd col-3 col-sm-2 player-hdcp\"><span name=\"player_hdcp\" gnp-player-hdcp=\"\" ng-model=\"newFriend.player_hdcp\"></span><div ng-show=\"newFriend.form.player_hdcp.$invalid &amp;&amp; newFriend.form.player_hdcp.$dirty &amp;&amp; newFriend.form.player_hdcp.$error.hdcp\" role=\"tooltip\" style=\"top: 35px; left: 0; display: block\" class=\"tooltip fade bottom show\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\">{{:: \"_FRIEND.HDCP_INVALID\" | translate }}</div></div></div><input type=\"email\" name=\"email\" placeholder=\"{{ '_FRIEND.ENTER_EMAIL' | translate }}\" ng-model=\"newFriend.email\" gnp-custom-email-validator=\"\" class=\"col-5 col-sm-6 email-cell cell2\"/><div ng-show=\"newFriend.form.$invalid &amp;&amp; newFriend.form.$dirty &amp;&amp; newFriend.form.email.$error.email\" role=\"tooltip\" style=\"top: 35px; left: 654.833px; display: block\" class=\"tooltip fade bottom show\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\">{{:: \"VALIDATION.EMAIL\" | translate }}</div></div></form></div><div ng-class=\"{'highlight': friend.highlight}\" ng-repeat=\"friend in friends\" ng-click=\"toggleEdit($event, friend)\" class=\"col-12 no-padding\"><div ng-hide=\"friend.isEditMode\" class=\"row\"><div ng-class-odd=\"'cell3'\" ng-class-even=\"'cell4'\" class=\"col-4 col-sm-4\">{{friend.name}}</div><div ng-class-odd=\"'cell3'\" ng-class-even=\"'cell4'\" class=\"col-2 email-cell player-hdcp\">{{ friend.player_hdcp | hdcpToLabel }}</div><div ng-class-odd=\"'cell3'\" ng-class-even=\"'cell4'\" class=\"col-4 col-sm-5\">{{friend.email}}</div><div ng-class-odd=\"'content-row-even'\" ng-class-even=\"'content-row-odd'\" class=\"col-2 col-sm-1 text-center\"><img src=\"" + __webpack_require__(606) + "\" ng-click=\"removeFriend($event, friend)\" class=\"img\"/></div></div><div ng-show=\"friend.isEditMode\"><form name=\"friend.form\" novalidate=\"\" gnp-submit=\"updateFriend(friend)\" ng-keydown=\"handleKeyDown($event, friend)\"><div class=\"row no-margin\"><input ng-class-odd=\"'cell5'\" ng-class-even=\"'cell2'\" name=\"name\" ng-model=\"friend.name\" required=\"\" class=\"col-4 col-sm-4\"/><div ng-show=\"friend.form.$invalid &amp;&amp; friend.form.$dirty &amp;&amp; friend.form.name.$error.required\" role=\"tooltip\" style=\"top: 35px; left: 169.833px; display: block\" class=\"tooltip fade bottom show\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\">{{:: \"VALIDATION.REQUIRED\" | translate }}</div></div><div ng-class-odd=\"'content-row-even'\" ng-class-even=\"'content-row-odd'\" class=\"col-3 col-sm-2 player-hdcp\"><span name=\"player_hdcp\" ng-model=\"friend.player_hdcp\" gnp-player-hdcp=\"\"></span><p ng-model=\"friend.form.player_hdcp\"></p><div ng-show=\"friend.form.player_hdcp.$invalid &amp;&amp; friend.form.player_hdcp.$dirty &amp;&amp; friend.form.player_hdcp.$error.hdcp\" role=\"tooltip\" style=\"top: 35px; left: 0; display: block\" class=\"tooltip fade bottom show\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\">{{:: \"_FRIEND.HDCP_INVALID\" | translate }}</div></div></div><input ng-class-odd=\"'cell5'\" ng-class-even=\"'cell2'\" type=\"email\" name=\"email\" ng-model=\"friend.email\" gnp-custom-email-validator=\"\" class=\"col-5 col-sm-6 email-cell\"/><div ng-show=\"friend.form.$invalid &amp;&amp; friend.form.$dirty &amp;&amp; friend.form.email.$error.email\" role=\"tooltip\" style=\"top: 35px; left: 654.833px; display: block\" class=\"tooltip fade bottom show\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\">{{:: \"VALIDATION.EMAIL\" | translate }}</div></div></div></form></div></div><div class=\"col-12 row last\"><nav aria-label=\"Page navigation\"><pagination ng-show=\"friends.length\" total-items=\"pageOptions.totalItems\" ng-model=\"pageOptions.currentPage\" max-size=\"5\" ng-change=\"loadData()\" items-per-page=\"pageOptions.pageSize\" class=\"pagination-sm\"></pagination></nav></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/friend/friend.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAANBAMAAACX52mGAAAAJFBMVEUAAABmZmZnZ2d3d3ebm5ucnJydnZ2qqqqrq6vY2Nj19fX7+/s404IIAAAAAXRSTlMAQObYZgAAADFJREFUCNdjYACDbRuARGMBAwOnoiYDw2JB4QUMgYKCAQwI4Cgo6ACRACthKCyAaAMAHuQJedzrfqAAAAAASUVORK5CYII="

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAS1BMVEUAAADMzMzNzc3Ozs7Pz8/R0dHS0tLT09PU1NTY2NjZ2dnc3Nzd3d3e3t7h4eHj4+Pk5OTs7Ozt7e3u7u7v7+/6+vr7+/v9/f3+/v41YJ2OAAAAAXRSTlMAQObYZgAAAIVJREFUGNNtke0WgyAIhnmz1Jx9aW3e/5UuFTu18f4QeA4IIlFWipNVyk4x0aVowDI7o7TgprXCGfijET86b/gM2elrXIxOtJXgGLNxR6GBXiXFvUc+TnnSaLQxWOrQaGPo79Cxqx7lTM2zkeNG4kji8BSEZ8oLkVcnLjknB29Vp32o3/EFjaAGvHlACyEAAAAASUVORK5CYII="

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(608);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_friend.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_friend.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#friend_setting-main{background-color:#f7f7f7}#friend_setting-main .container.friend{max-width:none!important;width:970px}#friend_setting-main .cell,#friend_setting-main .container.friend{padding:0}#friend_setting-main .container.friend .blank{height:40px;opacity:0}#friend_setting-main .container.friend .title-bar{height:70px;text-align:center}#friend_setting-main .container.friend .title-bar .title{position:relative;top:33px;padding:0 20px 6px;font-size:22px;color:#01a5a3;border-bottom:3px solid #01a5a3}#friend_setting-main .container.friend .content{position:relative;width:100%;padding:0 8%;background-color:#fff}#friend_setting-main .container.friend .content .content-message{position:relative;height:30px;width:66%;left:50%;margin-left:-320px;margin-bottom:15px;background-color:#fff}#friend_setting-main .container.friend .content .content-message .message{position:relative;margin-bottom:-30px;line-height:40px;font-size:15px;text-indent:10px}#friend_setting-main .container.friend .content .content-message .message.error{background:#fbe3e4;color:#8a1f11;border-color:#fbc2c4;border-style:solid}#friend_setting-main .container.friend .content .content-message .message.success{background:#e6efc2;color:#264409;border-color:#c6d880;border-style:solid}#friend_setting-main .container.friend .content .tooltip-inner{background-color:#8a1f11}#friend_setting-main .container.friend .content .tooltip-arrow{border-bottom:5px solid #8a1f11}#friend_setting-main .container.friend .content .img{position:absolute;margin-top:10px;margin-right:10px}#friend_setting-main .container.friend .content .sort-img{position:absolute;margin-top:10px;right:10px}#friend_setting-main .container.friend .content .sort-img.asc{clip:rect(0,8px,8px,0)}#friend_setting-main .container.friend .content .sort-img.desc{clip:rect(8px,8px,16px,0)}#friend_setting-main .container.friend .content .row{padding:0;margin:0}#friend_setting-main .container.friend .content .row.bar{margin-top:10px}#friend_setting-main .container.friend .content .row.last{height:160px}#friend_setting-main .container.friend .content .row.add-friend-form{margin-top:5px}#friend_setting-main .container.friend .content .row .period{position:absolute;left:80px;top:16px;font-size:20px}#friend_setting-main .container.friend .content .row .content-row-odd{height:40px;margin-top:-5px;background-color:#f7f7f7}#friend_setting-main .container.friend .content .row .content-row-even{height:40px;margin-top:-5px;background-color:#fff}#friend_setting-main .container.friend .content .row select{margin-top:3px;height:35px;text-indent:10px;border-color:#ccc;font-size:14px}#friend_setting-main .container.friend .content .row select.int{width:60px}#friend_setting-main .container.friend .content .row select.int.even{background-color:#fff}#friend_setting-main .container.friend .content .row select.few{margin-left:10px;width:55px}#friend_setting-main .container.friend .content .row select.few.even{background-color:#fff}#friend_setting-main .container.friend .content .row .btn-group .dropdown-menu.open{padding:0}#friend_setting-main .container.friend .content .row .cell1{position:relative;height:35px;line-height:35px;font-size:14px;text-indent:15px;color:#000;background-color:#e2e2e2}#friend_setting-main .container.friend .content .row .cell2{position:relative;height:40px;margin-top:-5px;font-size:13px;text-indent:14px;box-sizing:border-box;background-color:#f7f7f7;border-color:#f7f7f7;border-style:solid}#friend_setting-main .container.friend .content .row .cell3{position:relative;height:40px;margin-top:-5px;line-height:40px;font-size:14px;text-indent:18px;color:#000;background-color:#fff;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}#friend_setting-main .container.friend .content .row .cell3.main{text-indent:0;text-align:center}#friend_setting-main .container.friend .content .row .cell3.sub{text-indent:13px}#friend_setting-main .container.friend .content .row .cell4{position:relative;height:40px;margin-top:-5px;line-height:40px;font-size:14px;color:#000;text-indent:18px;background-color:#f7f7f7;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}#friend_setting-main .container.friend .content .row .cell4.main{text-indent:0;text-align:center}#friend_setting-main .container.friend .content .row .cell4.sub{text-indent:13px}#friend_setting-main .container.friend .content .row .cell5{position:relative;height:40px;margin-top:-5px;font-size:13px;text-indent:14px;box-sizing:border-box;background-color:#fff;border-color:#fff;border-style:solid;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}#friend_setting-main .container.friend .content .pagination{position:absolute;left:50%;margin-left:-100px;margin-top:20px}#friend_setting-main .container.friend .content .pagination li>a{padding:5px 10px;font-size:12px;line-height:1.42857;text-decoration:none;border:1px solid #ddd;color:#777}#friend_setting-main .container.friend .content .pagination li:first-child a{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}#friend_setting-main .container.friend .content .pagination li.disabled a{pointer-events:none;background-color:#fff;color:#777;border-color:#ddd}#friend_setting-main .container.friend .content .pagination li.disabled{cursor:not-allowed}#friend_setting-main .container.friend .content .pagination li.active a{z-index:2;color:#fff;background-color:#428bca;border-color:#428bca;cursor:default}#friend_setting-main .container.friend .content .pagination li.active{cursor:default}@media (max-width:768px){#friend_setting-main .container.friend{width:100%}#friend_setting-main .container.friend .content{padding:0 10px}#friend_setting-main .container.friend .content .player-hdcp{padding:0}#friend_setting-main .container.friend .content .row .cell1{font-size:13px}}", ""]);

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	var $, FriendCtrl, _;
	
	_ = __webpack_require__(87);
	
	$ = __webpack_require__(1);
	
	FriendCtrl = function($scope, $filter, $window, $timeout, flash, FriendService) {
	  var createQueryOptions, getEditingFriend, hasInvalidEditingFriend;
	  createQueryOptions = function() {
	    return {
	      page: $scope.pageOptions.currentPage,
	      page_size: $scope.pageOptions.pageSize,
	      sort: (function() {
	        var sortOrder;
	        if (!$scope.sort.column) {
	          return;
	        }
	        sortOrder = $scope.sort.descending ? "desc" : "asc";
	        return $scope.sort.column + ":" + sortOrder;
	      })()
	    };
	  };
	  getEditingFriend = function() {
	    return _.find($scope.friends, function(f) {
	      return f.isEditMode;
	    });
	  };
	  hasInvalidEditingFriend = function() {
	    var friend;
	    friend = getEditingFriend();
	    if (!friend) {
	      return false;
	    }
	    return friend.form.$invalid;
	  };
	  $scope.pageOptions = {
	    totalItems: 0,
	    currentPage: 1,
	    pageSize: 15
	  };
	  $scope.friends = [];
	  $scope.isLoading = false;
	  $scope.sort = {
	    column: void 0,
	    descending: false
	  };
	  $scope.newFriend = {
	    name: void 0,
	    email: void 0,
	    player_hdcp: void 0
	  };
	  $scope.loadData = function() {
	    $scope.isLoading = true;
	    return FriendService.getFriends(createQueryOptions()).then(function(result) {
	      $scope.friends = result.players;
	      $scope.pageOptions.totalItems = result.total;
	      if ($scope.editingFriend) {
	        return _.forEach($scope.friends, function(friend) {
	          if (friend.id === $scope.editingFriend.id) {
	            return friend.isEditMode = true;
	          }
	        });
	      }
	    })["finally"](function() {
	      $scope.isUpdatedHdcpList = false;
	      return $scope.isLoading = false;
	    });
	  };
	  $scope.changeSort = function(column) {
	    if ($scope.sort.column === column) {
	      $scope.sort.descending = !$scope.sort.descending;
	    } else {
	      $scope.sort.column = column;
	      $scope.sort.column.descending = false;
	    }
	    return $scope.loadData();
	  };
	  $scope.sortClass = function(column) {
	    if ($scope.sort.column !== column) {
	      return "";
	    }
	    if ($scope.sort.descending) {
	      return "desc";
	    }
	    return "asc";
	  };
	  $scope.addFriend = function() {
	    $scope.isLoading = true;
	    return FriendService.addFriend($scope.newFriend).then(function(resp) {
	      flash.success($filter('translate')('API_SUCCESS'));
	      $scope.friends.unshift(_.cloneDeep($scope.newFriend));
	      $scope.newFriend.highlight = true;
	      $scope.clearFriend();
	      return $scope.loadData();
	    })["catch"](function(resp) {
	      var ref;
	      if (((ref = resp.data) != null ? ref.code : void 0) === 'error.name_already_taken') {
	        return flash.error($filter('translate')('NAME_DUPLICATED'));
	      } else {
	        return flash.error($filter('translate')('API_ERROR'));
	      }
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  };
	  $scope.clearFriend = function() {
	    $scope.newFriend.name = void 0;
	    $scope.newFriend.email = void 0;
	    $scope.newFriend.player_hdcp = void 0;
	    $scope.newFriend.form.$setPristine();
	    return $scope.newFriend.form.submitted = false;
	  };
	  $scope.clearAllEditMode = function() {
	    var editingFriend;
	    editingFriend = getEditingFriend();
	    if (!editingFriend) {
	      return;
	    }
	    if (!editingFriend.isDataChanged()) {
	      editingFriend.isEditMode = false;
	      return;
	    }
	    if (editingFriend.form.$invalid) {
	      editingFriend.form.submitted = true;
	      return editingFriend.form.$setDirty();
	    } else {
	      return $scope.updateFriend(editingFriend);
	    }
	  };
	  $scope.toggleEdit = function(event, friend) {
	    if (!$scope.isUpdatedHdcpList) {
	      $scope.isUpdatedHdcpList = true;
	      $('.dropdown-toggle').dropdown();
	    }
	    if (friend.isEditMode) {
	      $scope.$broadcast('dropdownListClose');
	    }
	    event.stopImmediatePropagation();
	    if (friend.isEditMode) {
	      return;
	    }
	    if (hasInvalidEditingFriend()) {
	      return;
	    }
	    $scope.clearAllEditMode();
	    friend.isEditMode = true;
	    $scope.editingFriend = friend;
	  };
	  $scope.updateFriend = function(friend) {
	    if (!friend.isDataChanged()) {
	      return;
	    }
	    $scope.isLoading = true;
	    return FriendService.updateFriend(friend).then(function(resp) {
	      flash.success($filter('translate')('API_SUCCESS'));
	      friend.isEditMode = false;
	      friend.highlight = true;
	      return $scope.loadData();
	    })["catch"](function(resp) {
	      var ref;
	      if (((ref = resp.data) != null ? ref.code : void 0) === 'error.name_already_taken') {
	        return flash.error($filter('translate')('NAME_DUPLICATED'));
	      } else {
	        return flash.error($filter('translate')('API_ERROR'));
	      }
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  };
	  $scope.cancelEditFriend = function(friend) {
	    friend.restore();
	    friend.isEditMode = false;
	    friend.form.$setPristine();
	    return friend.form.submitted = false;
	  };
	  $scope.removeFriend = function(event, friend) {
	    event.stopImmediatePropagation();
	    if ($window.confirm($filter('translate')('CONFIRMATION_MSG'))) {
	      $scope.isLoading = true;
	      return FriendService.removeFriend(friend).then(function(resp) {
	        flash.success($filter('translate')('API_SUCCESS'));
	        return $scope.loadData();
	      })["finally"](function() {
	        return $scope.isLoading = false;
	      });
	    }
	  };
	  $scope.handleKeyDown = function($event, friend) {
	    if ($event.which === 13) {
	      $timeout(function() {
	        return $($event.target).closest('form').submit();
	      });
	      return false;
	    } else if ($event.which === 27 && friend) {
	      return $scope.cancelEditFriend(friend);
	    }
	  };
	  return $scope.loadData();
	};
	
	FriendCtrl.$inject = ['$scope', '$filter', '$window', '$timeout', 'flash', 'FriendService'];
	
	module.exports = FriendCtrl;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	var FriendService, _;
	
	_ = __webpack_require__(87);
	
	FriendService = function($http, $q) {
	  return {
	    addFriend: function(friend) {
	      return $http.post("/api/players.json", {
	        name: friend.name,
	        player_hdcp: friend.player_hdcp,
	        email: friend.email
	      });
	    },
	    removeFriend: function(friend) {
	      return $http.put("/api/players/" + friend.id + ".json", {
	        display_as_friend: "0"
	      });
	    },
	    updateFriend: function(friend) {
	      return $http.put("/api/players/" + friend.id + ".json", {
	        name: friend.name,
	        player_hdcp: friend.player_hdcp,
	        email: friend.email
	      });
	    },
	    getFriends: function(options) {
	      var delay, params, url;
	      url = "/api/players.json";
	      delay = $q.defer();
	      params = _.pickBy(options, function(v) {
	        return v !== null && v !== void 0;
	      });
	      $http.get(url, {
	        params: params
	      }).then(function(resp) {
	        resp.data.players = _.forEach(resp.data.players, function(f) {
	          f.restore = function() {
	            return _.merge(f, f._cache);
	          };
	          f.isDataChanged = function() {
	            return f.name !== f._cache.name || f.email !== f._cache.email || f.player_hdcp !== f._cache.player_hdcp;
	          };
	          f.setCache = function() {
	            return f._cache = _.pick(f, 'name', 'player_hdcp', 'email');
	          };
	          return f.setCache();
	        });
	        return delay.resolve(resp.data);
	      });
	      return delay.promise;
	    }
	  };
	};
	
	FriendService.$inject = ['$http', '$q'];
	
	module.exports = FriendService;


/***/ }),
/* 611 */
/***/ (function(module, exports) {

	module.exports = {
	  '_FRIEND': {
	    "TITLE": "Friends",
	    "NAME": "Name",
	    "EMAIL": "Email Address",
	    "ENTER_NEW_FRIEND": "Enter New Friend",
	    "ENTER_EMAIL": "Enter Email",
	    "HDCP_INVALID": "This HDCP value is invalid"
	  }
	};


/***/ }),
/* 612 */
/***/ (function(module, exports) {

	module.exports = {
	  '_FRIEND': {
	    "TITLE": "友達設定",
	    "NAME": "名前",
	    "EMAIL": "メールアドレス",
	    "ENTER_NEW_FRIEND": "新しい友達を入力",
	    "ENTER_EMAIL": "メールアドレスを入力",
	    "HDCP_INVALID": "HDCPの値が不正です"
	  }
	};


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	var ContactCtrl, ContactService, ContactSuccessCtrl, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(76);
	
	__webpack_require__(90);
	
	__webpack_require__(82);
	
	__webpack_require__(108);
	
	__webpack_require__(112);
	
	__webpack_require__(614);
	
	ContactSuccessCtrl = __webpack_require__(616);
	
	__webpack_require__(617);
	
	ContactCtrl = __webpack_require__(619);
	
	ContactService = __webpack_require__(621);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-auth', 'gnp-common-wrapper', 'gnp-form', 'gnp-error-handler', 'gnp-account'];
	
	angular.module('gnp-app-contact', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/contact', {
	      templateUrl: 'web/contact/contact.jade',
	      controller: 'ContactCtrl',
	      resolve: {
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ]
	      },
	      title: '_CONTACT.TITLE'
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(622)).translations('ja', __webpack_require__(623));
	  }
	]).controller('ContactCtrl', ContactCtrl).controller('ContactSuccessCtrl', ContactSuccessCtrl).factory('ContactService', ContactService);


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"contact_form-main\" gnp-common-wrapper-a=\"\"><div class=\"contact container\"><div class=\"col-12\"><div class=\"title\">{{:: '_CONTACT.TITLE' | translate }}</div></div><form name=\"form\" gnp-submit=\"send()\" novalidate=\"\"><div class=\"col-12 content\"><div class=\"col-12 row\"><div class=\"col-4 label\">{{:: '_CONTACT.YOUR_NAME' | translate }}</div><div class=\"col-8 error1\"><input type=\"text\" name=\"name\" ng-model=\"contact.name\" required=\"\" placeholder=\"{{ '_CONTACT.YOUR_NAME' | translate }}\" class=\"cell1\"/><div ng-show=\"form.name.$invalid &amp;&amp; !form.name.$pristine\" class=\"error\"><div ng-show=\"form.name.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</div></div></div><div class=\"line\"></div></div><div class=\"col-12 row\"><div class=\"col-4 label\">{{:: '_CONTACT.EMAIL_ADDRESS' | translate }}</div><div class=\"col-8 error1\"><input type=\"email\" name=\"email\" ng-model=\"contact.email\" placeholder=\"{{ '_CONTACT.EMAIL_ADDRESS' | translate }}\" required=\"\" gnp-custom-email-validator=\"\" class=\"cell1\"/><div ng-show=\"form.email.$invalid &amp;&amp; !form.email.$pristine\" class=\"error\"><div ng-show=\"form.email.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</div><div ng-show=\"form.email.$error.email\">{{:: \"VALIDATION.EMAIL\" | translate }}</div></div></div><div class=\"line\"></div></div><div class=\"col-12 row\"><div class=\"col-4 label\">{{:: '_CONTACT.SUBJECT' | translate }}</div><div class=\"col-8 error1\"><select name=\"subject\" ng-model=\"contact.subject\" ng-options=\"s for s in ::subjects\" required=\"\" ng-style=\"{'width': '100%'}\" class=\"cell1\"><option value=\"\" selected=\"selected\" disabled=\"disabled\">{{:: \"_CONTACT.SUBJECT_DEFAULT_TEXT\" | translate }}</option></select><div ng-show=\"form.subject.$invalid &amp;&amp; !form.subject.$pristine\" class=\"error\"><div ng-show=\"form.subject.$error.required\">{{:: \"VALIDATION.REQUIRED\" | translate }}</div></div></div><div class=\"line\"></div></div><div class=\"col-12 row\"><div class=\"col-4 label\">{{:: '_CONTACT.BODY' | translate }}</div><div class=\"col-8 error1\"><textarea name=\"body\" ng-model=\"contact.body\" required=\"\" class=\"textarea\"></textarea><div ng-show=\"form.body.$invalid &amp;&amp; !form.body.$pristine\" class=\"error area\"><div ng-show=\"form.body.$error.required\" class=\"error\">{{:: \"VALIDATION.REQUIRED\" | translate }}</div></div></div><div class=\"line\"></div></div><div class=\"col-12 row\"><div class=\"col-12 label2\">以下の個人情報取り扱いについて同意の上、お問い合わせ内容を送信してください。</div><div class=\"line\"></div></div><div class=\"col-12 row\"><div class=\"col-12 error2\"><div class=\"byalaw\"><span class=\"main-title\">個人情報保護方針</span><span class=\"sub-titile\">ゴルフネットワークプラス株式会社における個人情報保護方針を次のように定める。</span><span class=\"sub-titile\">（宣言）</span><span class=\"text text-line-height\">ゴルフネットワークプラス株式会社（以下、「ゴルフネットワークプラス」という。）は、お客様に様々なサービス・情報を広く提供するために、お客様の個人情報を活用させていただくことがあります。 したがって、個人情報の利用にあたって、適正かつ厳重な保護管理を行う責任があります。 「ゴルフネットワークプラス」は、従来から個人情報保護に努めてまいりましたが、さらに、ブロードバンド時代の進展の中で、 個人に関する情報を適切に管理できるようにすることが重要と考え、個人情報保護のための基本方針を以下に宣言し、 「JIS Q 15001個人情報保護マネジメントシステム－要求事項」に則った個人情報保護マネジメントシステムを策定するものとします。</span><span class=\"sub-titile\">基本方針</span><span class=\"text indent\">1. 事業内容及び規模（お客様に様々なサービス・情報を広く提供する）を考慮し適正かつ厳重な個人情報の保護管理と取得、利用及び提供等を実施いたします。</span><span class=\"text indent\">2. 個人情報の取得、利用及び提供にあたっては、できる限りその目的を特定するとともに、目的外利用はいたしません。また、そのための措置を講じます。個人情報の取得元又はその取得方法をできる限り具体的に明記し、個人情報に関する法令、国が定める指針及びその他の規範を遵守します。</span><span class=\"text indent\">3. 個人情報を管理する際は、管理責任者を置き、適切な管理を行うとともに、外部への流出防止に努めます。また、外部からの不正アクセス、個人情報の滅失、き損、改ざん及び漏えい等の危険防止に対して、適切かつ合理的なレベルの安全対策などの未然防止に万全を期すとともに、事故発生のリスクに対して速やかに是正処置を講じます。</span><span class=\"text indent\">4. 個人情報の取扱いは、利用目的の達成のために必要な範囲に限り、お客様の権利を損なわないように、十分配慮して行います。また、当社は、法令及びその他の規範で特に定められている事項に該当する場合を除き、お客様ご自身の同意なしに業務委託先以外の第三者に開示・提供致しません。</span><span class=\"text indent\">5. 個人情報の取扱いに関する苦情及び相談について、適切に対応いたします。</span><span class=\"text indent\">6. 個人情報保護マネジメントシステムは、今後の情勢変化に沿って継続的に改善します。</span><span class=\"text indent\">7. お客様の個人情報の漏えい等が発生した場合には、事実関係を速やかにお客様に通知するなど法令及びその他の規定に基づき対応するよう努めます。</span><span class=\"text indent\">8. 利用目的に必要なお客様の個人情報の保存期間を定め、保存期間経過後又は利用目的達成後は、お客様の個人情報を遅滞なく消去いたします。ただし、法令及びその他の規範で特に定められている事項に該当する場合はこの限りではありません。</span><span class=\"text indent\">9. 当社は、このプライバシーポリシーの内容を必要に応じて変更することがあります。この場合、最新の内容を「ゴルフネットワークプラス」のウェブサイトに掲載します。</span><span class=\"text\">2017年 6月13日発効<br/>2023年 7月18日改訂</span><span class=\"text right-text\">ゴルフネットワークプラス株式会社<br/>代表取締役社長　前田　鎮男</span><span class=\"sub-titile\">個人情報保護方針に関するお問い合わせ</span><span class=\"sub-titile\">当社の個人情報保護方針に関するお問い合わせは、こちらまでお願いいたします。</span><span class=\"sub-titile\">ゴルフネットワークプラス株式会社　「個人情報保護　苦情・相談窓口」<br/>E-MAIL：otoiawase@golfnetwork.plus</span><div id=\"p-mark\"><div class=\"p-top\"><span>当社は、２０１７年１２月７日に、プライバシーマークの付与を認定されました。このマークは、一般財団法人日本情報経済社会推進協会が運用する「プライバシーマーク制度」に基づき、当社の個人情報の取扱いがＪＩＳＱ１５００１「個人情報保護に関するマネジメントシステムの要求事項」に準拠して、適正に行なわれていることを認定した証として、その使用を許可されたものです。</span><a href=\"https://privacymark.jp/\" target=\"_blank\" class=\"mark\"><img src=\"" + __webpack_require__(615) + "\"/></a><div class=\"p-box\"><span>1.認定個人情報保護団体の名称<br/> ：一般財団法人日本情報経済社会推進協会</span><br/><br/><span>2.苦情の解決の申出先<br/> ：個人情報保護苦情相談室</span><br/><br/><span>＜住所＞　〒106-0032<br/> 東京都港区六本木一丁目9番9号 六本木ファーストビル内</span><br/><span>＜電話番号＞　03-5860-7565<br/> 0120-700-779</span></div><span class=\"p-bold-text\">【当社のサービスに関する問い合わせは<br class=\"sp-material\"/>ご遠慮くださいますようお願い致します】</span></div></div><span class=\"sub-titile\">（当社の個人情報取扱規程）</span><span class=\"text\">発　　効：２０１７年６月１３日<br/>改　　訂：２０２２年４月１日</span><span class=\"text\">当社が、取得、利用、提供させていただく個人情報の取扱いとお客様窓口について、以下に公表いたします。<br/>当社は、お客様からのプレゼントキャンペーン応募やメールマガジンの配信依頼などの際に、お客様から当社への情報の提供により、お客様の個人情報を取得いたします。<br/>この場合、ご利用者ご自身の判断によって個人情報を登録しないことは可能ですが、個人情報の提供がサービスの提供上不可欠な場合は、当該サービスをご利用いただけないことがあります。<br/>なお、今後以下に掲示する個人情報取扱規程の全部又は一部を改訂する場合があります。変更がある場合には、当社ホームページ上において速やかに公表いたします。<br/></span><span class=\"right-text\">ゴルフネットワークプラス株式会社<br class=\"hide-br\"/>個人情報保護管理者　管理部長<br/>〒135-0064　東京都江東区青海二丁目5番10号テレコムセンタービル西館18F</span><span class=\"indent text added-top-margin\"><span class=\"bold-text\">1. 個人情報とは</span><br/>お客様から当社へのプレゼントキャンペーン応募やメールマガジンの配信依頼などの際に、お客様から当社への情報の提供により、当社が取得したお客様個人に関する情報、およびお取引先業者様、採用応募者の皆様、社員及びスタッフ個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別できるもの(他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます。)をいいます。</span><span class=\"indent text added-top-margin\"><span class=\"bold-text\">2. 個人情報の利用目的</span><br/>当社が個人情報を取得する際、利用目的は、原則として当社ホームページ上での掲載によって、事前に皆様に公表致します。<span class=\"text indent\">1. お客様の個人情報各種サービスにおきましては、法令等に定められている場合を除き、以下に提示する利用目的の範囲においてのみ利用いたします。</span><table border=\"1\" class=\"table-1\"><tbody><tr><td style=\"width: 40%\" class=\"sc\"><p>サービス種別</p></td><td colspan=\"3\"><p>個人情報の利用目的</p></td></tr><tr><td rowspan=\"5\"><span class=\"sub-titile added-padding\">会員登録</span></td><td colspan=\"3\"><span class=\"sub-titile\">（メールマガジン配信サービス</span><span class=\"text\"> • メールマガジンの配信サービスの提供</span><br/><span class=\"text\"> • 運営するサービスに関する情報及び有用な情報等の提供</span><br/><span class=\"text\"> • サービスの改善等に関するアンケートの依頼</span><br/><span class=\"sub-titile\">（アプリ/ウェブサイトサービス）</span><span class=\"text\">• ユーザー識別IDの付与</span><br/><span class=\"text\">• 運営するサービスに関する情報及び有用な情報等の提供</span><br/><span class=\"text\">• サービスの改善等に関するアンケートの依頼</span><br/></td></tr><tr><td colspan=\"3\" style=\"background: #efefef\"><span class=\"sub-titile\">（動画配信サービス）</span><span class=\"text\">• 動画の提供</span></td></tr><tr><td><span class=\"sub-titile\">（プレゼントキャンペーン）</span><span class=\"text\">• 各種応募の抽選</span><br/><span class=\"text\">• 当選時の景品の発送</span><br/><span class=\"text\">• 募集事業に必要なご連絡／お問い合わせに関する対応業務</span></td><td rowspan=\"2\"><span class=\"text\">• 同種のキャンペーン、イベントに関する情報提供</span><span class=\"text\">• サービスの改善等に関するアンケートの依頼</span><span class=\"text\">• 当社が運営するサービスに関する情報及び有用な情報の提供</span></td></tr><tr><td style=\"background: #efefef\"><span class=\"sub-titile\">（イベント／番組　参加者募集）</span><span class=\"text\">• 参加応募者の選考・抽選</span><span class=\"text\">• 参加者への参加通知、実施要綱等の発送業務</span><span class=\"text\">• 募集事業に必要なご連絡／お問い合わせに関する対応業務</span><span class=\"sub-titile\">（会員登録情報に関するお問い合わせ対応業務）</span><span class=\"text\">• 登録情報の参照、及び再設定手続きに関する連絡</span><br/><span class=\"text\">• ユーザーＩＤ・パスワードの参照、及び再設定手続きに関する連絡</span></td></tr><tr><td colspan=\"3\"><span class=\"sub-titile\">（会員登録情報に関するお問い合わせ対応業務）</span><br/><span class=\"text\">• 登録情報の参照、及び再設定手続きに関する連絡</span><br/><span class=\"text\">• ユーザーＩＤ・パスワードの参照、及び再設定手続きに関する連絡</span><br/></td></tr><tr style=\"background: #efefef\"><td><span class=\"sub-titile added-padding\">オンラインショップサービス</span></td><td colspan=\"3\"><span class=\"text\">• ご購入商品の発送業務</span><br/><span class=\"text\">• 商品・サービスに関するお問い合わせ対応業務</span><br/><span class=\"text\">• おすすめ商品のご案内</span><br/><span class=\"text\">• 購入履歴のご案内</span></td></tr><tr><td><span class=\"sub-titile added-padding\">各種情報提供サービス<br/>（資料請求、ご意見、お問い合わせ等）</span></td><td colspan=\"3\"><span class=\"text\">• 資料送付</span><br/><span class=\"text\">• ご意見等に関する連絡</span><br/><span class=\"text\">• お問い合わせ対応業務</span><br/><span class=\"text\">• サービスに関する情報及び有用な情報等の提供</span><br/><span class=\"text\">• サービスの改善等に関するアンケートの依頼</span></td></tr></tbody></table><span class=\"text added-top-margin indent\">2. お取引先業者様、採用応募者の皆様、社員及びスタッフの個人情報</span><table border=\"1\" class=\"table-2\"><tbody><tr><td style=\"width: 50%\"><p>個人情報の保有主体</p></td><td colspan=\"3\"><p>個人情報の利用目的</p></td></tr><tr><td style=\"width: 50%\"><p>お取引先業者様</p></td><td colspan=\"3\"><p>• 業務上の連絡、挨拶状の送付</p></td></tr><tr><td style=\"width: 50%\"><p>採用応募者の皆様</p></td><td colspan=\"3\"><p>• 採用に関する判定、面接の連絡、採用結果の通知業務</p></td></tr><tr><td style=\"width: 50%\"><p>社員及びスタッフ</p></td><td colspan=\"3\"><p>• 人事・労務管理上必要な業務</p></td></tr></tbody></table><span class=\"text added-top-margin indent\">3. 映像・画像<br/>当社では、取材、購入した映像を放送・配信する際に、番組の本題とは異なる群集として個人を特定できる映像が含まれる場合があります。 放送・配信内容に関するご意見は下記8．のお客様窓口にて対応させていただきますので、ご理解の程よろしくお願いいたします。</span><span class=\"text added-top-margin indent\">4. 未成年者の個人情報の取得及び使用<br/>未成年者が個人情報を当社にご提供される場合は、必ず保護者の方の同意のもとにご提供下さるようお願い致します。</span><span class=\"text added-top-margin indent\">5. その他の場合の個人情報<br/>新規事業その他で、上記以外に個人情報をいただく場合は、利用目的を明示して、ご同意を得ます。</span></span><span class=\"indent text added-top-margin\"><span class=\"bold-text\">3. 個人情報の共同利用</span><br/><span class=\"text indent\">1. 当社は、下記要領にて個人情報の共同利用を行っています。<span class=\"text indent\">1. 広告営業活動における顧客リストの共同利用</span><br/><table border=\"1\" class=\"table-2\"><tbody><tr class=\"angle-left\"><td><p>共同利用する個人情報の項目</p></td><td><p>氏名、所属会社名、所属会社住所、所属部署、役職、所属会社電話番号・ＦＡＸ番号・メールアドレス</p></td></tr><tr><td><p>共同利用する者の範囲</p></td><td><p>ジュピターゴルフネットワーク株式会社</p></td></tr><tr><td><p>共同利用する者の利用目的</p></td><td><p>業務上の連絡、挨拶状の送付、新規取引のご案内</p></td></tr><tr><td><p>共同利用管理責任者</p></td><td><p>ゴルフネットワークプラス株式会社</p></td></tr><tr><td><p>取得方法</p></td><td><p>名刺交換</p></td></tr></tbody></table><span class=\"text added-top-margin indent\">2. 広報活動におけるメディアリストの共同利用</span><table border=\"1\" class=\"table-2\"><tbody><tr class=\"angle-left\"><td><p>共同利用する個人情報の項目</p></td><td><p>氏名、所属会社名、所属会社住所、所属部署、役職、所属会社電話番号・ＦＡＸ番号・メールアドレス</p></td></tr><tr><td><p>共同利用する者の範囲</p></td><td><p>ジュピターゴルフネットワーク株式会社</p></td></tr><tr><td><p>共同利用する者の利用目的</p></td><td><p>プレスリリース、記者会見案内状等の送付</p></td></tr><tr><td><p>共同利用管理責任者</p></td><td><p>ゴルフネットワークプラス株式会社</p></td></tr><tr><td><p>取得方法</p></td><td><p>名刺交換、電話・メール等による取得</p></td></tr></tbody></table><span class=\"text added-top-margin indent\">3. 対有料放送／配信プラットフォーム各社（ケーブルテレビ局等）営業活動における顧客リストの共同利用</span><table border=\"1\" class=\"table-2\"><tbody><tr class=\"angle-left\"><td><p>共同利用する個人情報の項目</p></td><td><p>氏名、所属会社名、所属会社住所、所属部署、役職、所属会社電話番号・ＦＡＸ番号・メールアドレス</p></td></tr><tr><td><p>共同利用する者の範囲</p></td><td><p>ジュピターゴルフネットワーク株式会社</p></td></tr><tr><td><p>共同利用する者の利用目的</p></td><td><p>業務上の連絡、挨拶状の送付</p></td></tr><tr><td><p>共同利用管理責任者</p></td><td><p>ゴルフネットワークプラス株式会社</p></td></tr><tr><td><p>取得方法</p></td><td><p>名刺交換、電話・メール・ＦＡＸ等による取得</p></td></tr></tbody></table><span class=\"text added-top-margin indent\">4. アプリ/ウェブサイトサービスの顧客リストの共同利用</span><tbod></tbod><table border=\"1\" class=\"table-2\"><tbody><tr class=\"angle-left\"><td style=\"width: 30%\"><p>共同利用する個人情報の項目</p></td><td><p>氏名、メールアドレス、居住地（国、都道府県）、生年月日、性別、顧客ID</p></td></tr><tr><td><p>共同利用する者の範囲</p></td><td><p>ジュピターゴルフネットワーク株式会社、JCOM株式会社</p></td></tr><tr><td><p>共同利用する者の利用目的</p></td><td><p>アプリ/ウェブサイトサービスの運営、お問い合わせに関する対応業務、運営するサービスに関する情報及び有用な情報等の提供</p></td></tr><tr><td><p>共同利用管理責任者</p></td><td><p>ゴルフネットワークプラス株式会社</p></td></tr><tr><td><p>取得方法</p></td><td><p>アプリ/ウェブサイトでの登録</p></td></tr></tbody></table></span><br/><br/><span class=\"text indent\">2. お客様に関する個人情報<br/> 弊社はお客様に、より一層の高いサービスを提供するため、以下の範囲内で必要な場合に限り、厳格な管理・監督のもと個人情報を共同利用させていただきます。<br/><br/><span class=\"text indent\">1. 共同利用する個人情報の項目<br/>氏名、性別、生年月日、職業、住所、電話番号、メールアドレス、通話記録、ユーザー識別ID、懸賞応募やアンケート調査等に関する情報、配信サービスの利用履歴情報、オンラインショップの利用履歴等の他、お客様が弊社サービスのご契約時及び当該サービス提供中に取得する全ての個人情報（ただし、共同利用が通信の秘密に抵触する場合は除く）。</span><span class=\"text indent\">2. 共同利用する者の利用目的<br/>弊社は、上記「2. 個人情報の利用目的」で定めた利用目的の範囲内で共同利用いたします。</span><span class=\"text indent\">3. 共同利用する者の範囲<br/><a href=\"https://www.jcom.co.jp/corporate/site_info/privacy_policy/pdf/index_group20211120.pdf\" target=\"_blank\">次に定めるJ:COMグループ各社</a></span><span class=\"text indent\">4. 共同利用の際の取得方法<br/>共同利用する個人情報は、申込書、インターネット、ハガキなどを通じてJ:COMグループ各社が取得したものといたします。</span><span class=\"text indent\">5. 共同利用する個人情報の管理について責任を有する者及び住所、代表者の氏名<br/>・責任を有する者：JCOM株式会社　個人情報保護管理者<br/>・住所：東京都千代田区丸の内1-8-1　丸の内トラストタワーN館<br/>・代表者の氏名：岩木　陽一</span></span><span class=\"indent text\">3. 上記以外の場面<br/>上記以外の場面で個人情報を共同利用する場合は、共同利用の相手方の明示など、法令の定める手続きを履行いたします。</span></span><span class=\"indent text added-top-margin\"><span class=\"bold-text\">4. 個人情報の第三者提供</span><br/>以下に掲示されている場合以外に、当社が個人情報を第三者に提供することはございません。<span class=\"text added-top-margin indent\">1. 各種サービスの提供等に際し、お客様から同意を得た場合<br/><span class=\"text\">例）</span></span><tbod></tbod><table border=\"1\" class=\"table-2\"><tbody><tr><td><p>サービス種別</p></td><td><p>提供目的</p></td><td><p>提供先</p></td><td><p>提供項目（方法）</p></td></tr><tr><td><p>各種募集(イベント、プレゼント、キャンペーン等）</p></td><td><p>各種応募の抽選、景品の発送、協賛企業の商品・サービス紹介等</p></td><td><p>協賛企業に提供する場合は、応募（募集）要綱に記載いたします。</p></td><td><p>応募用紙等に記載又は画面入力された事項</p></td></tr></tbody></table><span class=\"text indent\">2. 法令、平成29年総務省告示第152号「電気通信事業における個人情報保護に関するガイドライン」、その他監督官庁が定める規則等に基づく場合</span></span><span class=\"indent text added-top-margin\"><span class=\"bold-text\">5. 個人情報の取扱いの委託</span><br/>お預かりした個人情報は、配送等の業務のために、ジュピターゴルフネットワーク株式会社、その他の当社提携事業者に取扱いを委託することがあります。 委託先につきましては、当社の定める基準に適合する事業者を選定し、秘密保持、安全管理等についての契約を締結して、適切な監督を行います。</span><span class=\"indent text added-top-margin\"><span class=\"bold-text\">6. 個人情報の内容</span><br/>個人情報の取得につきましては、原則としてサービス提供を行うにあたり、必要最低限の内容を取得いたします。なお、各種サービスのお申込様式において、一部任意事項を取得させていただく場合には、任意事項であることを表記いたします。この表記がある項目につきましては、無記入であっても提供するサービスの範囲、品質に影響は一切ございません。</span><span class=\"indent text added-top-margin\"><span class=\"bold-text\">7．安全管理措置</span><br/> 当社は、個人情報の取扱いについて、JISQ15001の要求事項に準拠した安全管理措置を適切に実施いたします。<br/><br/><span class=\"text indent\">1. 基本方針の策定<br/>個人データの適正な取扱いを確保するため、「個人情報保護方針」を策定しております。</span><span class=\"text indent\">2. 個人データの取扱いに係る規律の整備<br/>個人データの取扱方法、責任者・担当者およびその役割等について、個人データの取扱規程を策定しております。</span><span class=\"text indent\">3. 組織的安全管理措置<br/>個人情報の取扱い責任者として「個人情報保護管理者」を任命したうえで、個人情報の取扱いに関する従業員の責任と権限を明確化し監督するとともに、法や社内規程に違反している事実または兆候を把握した場合は、責任者へ報告・連絡する体制を整備しております。<br/>個人情報の取扱い状況を定期的に点検し、適切な監査を実施しております。</span><span class=\"text indent\">4. 物理的・技術的安全管理措置<br/>個人データを取り扱う区域において、従業員及び第三者の入退室管理を行うとともに、個人情報を含む文書や媒体、機器等は施錠保管等の措置を実施しております。また、個人データを取り扱う情報システムへのアクセス制御、コンピュータウイルス対策、不正ソフトウェア対策、情報システムの監視等を実施しております。</span><span class=\"text indent\">5. 人的安全管理措置<br/>従業員に対し個人情報の適正な取り扱いに関する教育・研修を定期的に実施しております。</span></span><span class=\"indent text added-top-margin\"><span class=\"bold-text\">8. 個人情報の開示・訂正（追加・削除）、利用停止（消去）</span><span class=\"text indent\">1. お客様窓口</span><br/>当社が保有する個人情報に関する請求［開示、訂正(追加・削除)、利用停止(消去)］につきましては、以下の窓口までご連絡ください。当社指定の方法によるご連絡を通じて、合理的期間内で速やかに対応いたします。<br/>但し、メールマガジン配信希望のお客様が、会員登録の際に提供された個人情報の訂正等に関しましては、当社のメールマガジンの利用規約に準拠します。<span class=\"indent text added-top-margin indent\"><span class=\"bold-text\">■ゴルフネットワークプラス株式会社　個人情報保護　苦情・相談窓口</span><br/><span class=\"text\">【インターネットの場合】</span><br/><span class=\"text\">ゴルフネットワークプラス株式会社　「個人情報保護　苦情・相談窓口」</span><br/><span class=\"text\">-　E-MAIL：otoiawase@golfnetwork.plus</span><br/><br/><span class=\"text\">2. ご請求内容</span><span class=\"text indent-2\">1. 当社が保有している｢開示対象個人情報｣の開示請求</span><span class=\"text indent-2\">2. 当社が保有している｢開示対象個人情報｣内容の訂正、追加または削除に関する請求</span><span class=\"text indent-2\">3. 当社が保有している｢開示対象個人情報｣の利用停止または消去に関する請求</span></span><span class=\"text indent\">3. お手続き方法<span class=\"text indent\">1. 上記窓口に、お問合せをいただきます。<br/>（原則として、ご本人以外はお手続きできません。※（注２））</span><span class=\"text indent\">2. 必要に応じ、ご請求用紙等をご登録住所に郵送いたします。</span><span class=\"text indent\">3. 請求用紙に所定の事項をご記入いただき、その他当社の指定する必要書類等をご同封の上、お問合せの際に、当社でご案内する宛先に、ご郵送いただきます。<br/>(お客様の個人情報が安易に漏れてしまわぬよう努める義務から、当社はご請求のありました皆様全員に、御本人様であることを厳正に確認させていただいております。大変お手数をおかけしますが、ご本人様確認のため、公的機関発行の証明書[運転免許証、パスポート、健康保険証、住民票写し、写真付住民基本台帳カード、外国人登録証明書又は年金手帳]から、2種類のコピーを添付していただきます。ご理解の程宜しくお願い申し上げます。)</span><span class=\"text indent\">4. ご請求の内容について確認のうえ、適正な処理を遅滞なく実施し、原則として書面(封書)で、回答いたします。(ご本人様確認のために送付を受けた証明書に記載された住所に本人限定郵便にて郵送いたします。)</span><span class=\"text indent\">5. 法令の定めにより、開示等のご請求に応じられない場合があります。ご請求に応じられない場合は、その理由をお知らせいたします。<br/>※（注２）代理人の方からの請求をご希望される場合の手続きに関しましては、上記担当窓口に、直接お問い合わせください。</span></span><span class=\"text indent\">4. 手数料<br/>上記「8.(2)ご請求内容」のうち、「1.当社が保有している「開示対象個人情報」の開示請求」をいただく際につきましては、恐れ入りますが、ご請求者皆様に対して、係る事務取扱手数料として1件につき一律1,000円（税抜）を申し受けます。<br/>なお、お支払い方法につきましては、お客様からの開示請求の際に、当社からお送りする請求用紙等と共に、ご案内を添付いたします。</span></span><span class=\"indent text added-top-margin\"><span class=\"bold-text\">9. 個人情報に関する苦情・相談</span><br/> 個人情報に関する苦情・相談につきましては、上記8.1.お客様窓口で承ります。</span><span class=\"indent text added-top-margin\"><span class=\"bold-text\">10. 個人情報の保存期間期間を定めます。</span><br/><span class=\"text indent\">1.お客様の個人情報の保存期間は、原則として利用目的終了後、6ヶ月以内とします。この期間を超える保存期間を定める場合は、公表又は通知するように努めます。</span><br/><span class=\"text indent\">2.上記1. 以外の個人情報の保存期間は、法令等の定め及び当社の業務上の必要に基づき、最短の期間を定めます。</span><br/><span class=\"text indent\">3.保存期間が終了した個人情報は完全に消去、又は廃棄いたします。</span></span><span class=\"indent text added-top-margin\"><span class=\"bold-text\">11. 当社ホームページ及びゴルフネットワークプラスアプリにおけるサービス提供にあたって</span><span class=\"text indent\">1. アクセスログの収集について<br/>当社ホームページでは、ホームページにアクセスされたお客様の情報をアクセスログという形で記録しています。アクセスログは、アクセスされたお客様のIP アドレス、使用しているブラウザの種類、アクセス日時等が含まれますが、個人を特定できる情報を含むものではありません。アクセスログはホームページの利用状況やシステム負荷状況の確認、不正アクセス等を発見するためのシステム監査等の目的で活用されますが、それ以外の目的で利用されることはありません。</span><span class=\"text indent\">2. クッキーの使用について<br/>当社ホームページ及びゴルフネットワークプラスアプリの一部において、クッキー等の情報収集技術（以下、「クッキー」と記す。）を使用しています。クッキーとは、ウェブサーバーがお客様の情報端末機器を識別する技術です。当社では、お客様がホームページやゴルフネットワークプラスアプリをご覧になったという情報などの認識や、一部のサービスをより便利にご利用いただくため、およびバナー広告の配信にクッキーを利用しています。</span><span class=\"text indent\">3. アクセスデータ・クッキーの取り扱いについて<br/>本サイトはアクセスデータやクッキー情報を、以下の目的で利用いたします。<br/><br/><span class=\"text indent\">①マーケティング分析</span><br/><br/><span class=\"text indent\">②当社サービス (本サイトに限りません) の品質向上</span><br/><br/><span class=\"text indent\">③お客さまごとに有益と思われる情報の表示</span><br/><br/>上記の目的に沿って、各種情報を以下の各社へ送信致します。取得した情報の取り扱い及び各社への情報送信を停止する方法（オプトアウト）につきましては、以下に記載する各社のウェブサイトをご確認ください。<br/>また、最適なバナー配信を行うためにクッキーを利用しています。本クッキーの使用に関する説明、クッキーによって収集される情報、履歴削除方法及びオプトアウト（クッキーの利用に対する拒否権、アクセスデータの情報送信拒否）の手続について詳しくお知りになりたい方は、以下の各社プライバシーポリシーや各ウェブブラウザのヘルプ等をご覧ください。<br/><div class=\"dl3rdP\"><dl><dt>事業者名</dt><dt>オプトアウト</dt><dt>プライバシーに関する記載</dt></dl><dl><dd>Apple Inc.</dd><dd><a href=\"https://support.apple.com/ja-jp/HT202074\" target=\"_blank\">オプトアウトはこちら</a></dd><dd><a href=\"https://www.apple.com/jp/privacy/\" target=\"_blank\">プライバシーポリシーはこちら</a></dd></dl><dl><dd>Facebook, Inc. - facebook</dd><dd><a href=\"https://www.facebook.com/policies/cookies/\" target=\"_blank\">オプトアウトはこちら</a></dd><dd><a href=\"https://www.facebook.com/privacy/explanation\" target=\"_blank\">プライバシーポリシーはこちら</a></dd></dl><dl><dd>Facebook, Inc. -Instagram</dd><dd><a href=\"https://www.instagram.com/about/legal/privacy/\" target=\"_blank\">オプトアウトはこちら</a></dd><dd><a href=\"https://www.instagram.com/legal/privacy/\" target=\"_blank\">プライバシーポリシーはこちら</a></dd></dl><dl><dd>Google LLC -GDN</dd><dd><a href=\"https://support.google.com/accounts/answer/2662856\" target=\"_blank\">オプトアウトはこちら</a></dd><dd><a href=\"https://policies.google.com/privacy\" target=\"_blank\">プライバシーポリシーはこちら</a></dd></dl><dl><dd>Google LLC -Google Analytics</dd><dd><a href=\"https://support.google.com/analytics/answer/181881?hl=ja&amp;ref_topic=2919631\" target=\"_blank\">オプトアウトはこちら</a></dd><dd><a href=\"https://policies.google.com/privacy\" target=\"_blank\">プライバシーポリシーはこちら</a></dd></dl><dl><dd>LINE株式会社</dd><dd><a href=\"https://terms.line.me/line_rules_optimize\" target=\"_blank\">オプトアウトはこちら</a></dd><dd><a href=\"https://linecorp.com/ja/security/article/30\" target=\"_blank\">プライバシーポリシーはこちら</a></dd></dl><dl><dd>Twitter, Inc.</dd><dd><a href=\"https://business.twitter.com/ja/help/ads-policies/product-policies/interest-based-opt-out-policy.html\" target=\"_blank\">オプトアウトはこちら</a></dd><dd><a href=\"https://twitter.com/ja/privacy\" target=\"_blank\">プライバシーポリシーはこちら</a></dd></dl><dl><dd>ヤフー株式会社</dd><dd><a href=\"https://btoptout.yahoo.co.jp/optout/index.html\" target=\"_blank\">オプトアウトはこちら</a></dd><dd><a href=\"https://privacy.yahoo.co.jp/jp20191001.html\" target=\"_blank\">プライバシーポリシーはこちら</a></dd></dl><dl><dd>株式会社エフ・コード</dd><dd><a href=\"https://codemarketing.cloud/optout.html?_code_optout=https://docs.codemarketing.cloud/ja/\" target=\"_blank\">オプトアウトはこちら</a></dd><dd><a href=\"https://f-code.co.jp/privacypolicy.html\" target=\"_blank\">プライバシーポリシーはこちら</a></dd></dl><dl><dd>Supership株式会社</dd><dd><a href=\"https://supership.jp/optout/\" target=\"_blank\">オプトアウトはこちら</a></dd><dd><a href=\"https://supership.jp/privacy/\" target=\"_blank\">プライバシーポリシーはこちら</a></dd></dl></div>ゴルフネットワークプラスアプリで使用する以下に関しては、オプトアウトは出来ませんのでご了承ください。<div class=\"dl3rdP\"><dl><dt>事業者名</dt><dt>収集される情報</dt><dt>プライバシーに関する記載</dt><dt>利用規約</dt></dl><dl><dd>Repro株式会社</dd><dd>生年月日、性別、アクセスログなど</dd><dd><a href=\"https://repro.io/privacy/\" target=\"_blank\">プライバシーポリシーはこちら</a></dd><dd><a href=\"https://repro.io/terms/\" target=\"_blank\">利用規約はこちら</a></dd></dl></div> ＜ブラウザによるクッキー（ Cookie ）の無効化設定について＞<br/><br/> お客さまがご利用されているブラウザの設定を変更することで、クッキー（ Cookie ）受入れを拒否することができます。詳細については、下記の対象ブラウザのリンク先にてご確認をお願い致します。<br/>※その場合、サービス内容に制約が生じたり正常に提供できない場合がありますので、ご了承ください。<br/><br/><span style=\"text-indent: 0\"><a href=\"https://support.google.com/chrome/bin/-answer.py?hl=ja&amp;&amp;answer=95647&amp;&amp;p=cpn_cookies\" target=\"_blank\">Google Chrome</a><br/><a href=\"https://support.microsoft.com/ja-jp/help/17442/windows-internet-explorer-delete-manage-cookies\" target=\"_blank\">Microsoft Internet Explorer</a><br/><a href=\"https://privacy.microsoft.com/ja-JP/windows-10-microsoft-edge-and-privacy\" target=\"_blank\">Microsoft Edge</a><br/><a href=\"http://support.mozilla.org/ja-jp/kb/Cookies\" target=\"_blank\">Mozilla Firefox</a><br/><a href=\"https://support.apple.com/ja-jp/guide/safari/sfri11471/mac\" target=\"_blank\">Apple Safari</a></span><br/></span></span><span class=\"indent text added-top-margin\"><span class=\"text indent\">（改訂履歴）<br/>最終更新日　：２０２３年７月６日</span></span></div></div><div class=\"col-1 blank\"></div></div><div class=\"col-12 row\"><div class=\"col-6 alignright\"><button type=\"submit\" ng-click=\"cancel()\" class=\"btn\">同意しない</button></div><div class=\"col-6 alignleft\"><button type=\"submit\" gnp-submitting-button=\"isSubmitting\" class=\"btn\">同意して送信</button></div><div class=\"line\"></div></div></div></form></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/contact/contact.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	var ContactSuccessCtrl;
	
	ContactSuccessCtrl = function($scope, $modalInstance, $location) {
	  return $scope.cancel = function() {
	    $modalInstance.dismiss('cancel');
	    return window.location.reload();
	  };
	};
	
	ContactSuccessCtrl.$inject = ['$scope', '$modalInstance', '$location'];
	
	module.exports = ContactSuccessCtrl;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(618);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_contact_form.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_contact_form.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#contact_form-main .cell{padding:0}#contact_form-main .contact.container{width:970px;position:relative;min-height:500px}#contact_form-main .contact.container .blank{padding:0}#contact_form-main .contact.container .title{position:relative;width:50%;height:50px;margin:50px auto 0;padding:0;line-height:40px;text-align:center;font-size:22px;color:#01A5A3;border-bottom:3px solid #01A5A3}#contact_form-main .contact.container .content{position:relative;min-height:400px;width:100%;padding:60px;background-color:#fff}#contact_form-main .contact.container .content .row{min-height:75px;width:100%;padding-top:25px;margin:0}#contact_form-main .contact.container .content .row .error{background-color:transparent;text-align:left;padding:7px 10px 3px;color:#8a1f11}#contact_form-main .contact.container .content .row .alignleft{text-align:left;padding:0 10px}#contact_form-main .contact.container .content .row .alignright{text-align:right;padding:0 10px}#contact_form-main .contact.container .content .row .error1{margin-top:25px}#contact_form-main .contact.container .content .row .error2{margin:25px 0 0;padding:0}#contact_form-main .contact.container .content .row .label{top:43px;padding:0;font-size:14px;color:#000;font-weight:700;text-align:left}#contact_form-main .contact.container .content .row .label2{background:#000;top:20px;padding:10px 5px;font-size:14px;color:#fff;font-weight:700;text-align:center}#contact_form-main .contact.container .content .row .cell1{position:relative;margin:3px 8px 0;font-size:15px;text-indent:10px;background-color:0;width:100%;height:40px;border-radius:5px;border-color:#e2e2e2;border-width:2px;border-style:solid}#contact_form-main .contact.container .content .row .textarea{position:relative;height:100px;width:100%;margin:3px 8px 0;border-color:#e2e2e2;border-width:2px;border-radius:5px;resize:none}#contact_form-main .contact.container .content .row .byalaw{background:0 0 #fff;border:1px solid #E4E4E4;height:200px;margin:0 auto;overflow:auto;padding:20px}#contact_form-main .contact.container .content .row .byalaw span{display:inline-block}#contact_form-main .contact.container .content .row .byalaw .main-title{font-size:1.1vw;width:100%;text-align:center;margin-bottom:4%}#contact_form-main .contact.container .content .row .byalaw .text{font-size:1.1vw}#contact_form-main .contact.container .content .row .byalaw .text .text-line-height{line-height:1.9vw}#contact_form-main .contact.container .content .row .byalaw .sub-titile{font-size:1.1vw;width:100%;margin:3% 0 1%}#contact_form-main .contact.container .content .row .byalaw .indent{width:96.3%;text-indent:-2.7%;margin-left:3%}#contact_form-main .contact.container .content .row .byalaw .indent-2{width:100%;text-indent:0}#contact_form-main .contact.container .content .row .byalaw .right-text{margin-top:4%;width:100%;text-align:right;font-size:1.1vw}#contact_form-main .contact.container .content .row .byalaw .right-text .hide-br{display:none}#contact_form-main .contact.container .content .row .byalaw #p-mark{margin-top:5%}#contact_form-main .contact.container .content .row .byalaw #p-mark .p-top{width:100%}#contact_form-main .contact.container .content .row .byalaw #p-mark .p-top span{font-size:1.1vw}#contact_form-main .contact.container .content .row .byalaw #p-mark .p-top>span{display:inline-block;float:right;width:80%}#contact_form-main .contact.container .content .row .byalaw #p-mark .p-top .mark{width:14%;display:inline-block;padding:0}#contact_form-main .contact.container .content .row .byalaw #p-mark .p-top .mark img{display:block;width:100%;height:auto;border:0;background-color:#fff}#contact_form-main .contact.container .content .row .byalaw #p-mark .p-top .p-box{box-sizing:border-box;width:100%;margin-top:3%;padding:3%;border:1px solid #337fb8;display:inline-block}#contact_form-main .contact.container .content .row .byalaw #p-mark .p-bold-text{font-weight:700;display:inline-block;width:100%!important;text-align:center}#contact_form-main .contact.container .content .row .byalaw #p-mark .p-bold-text .sp-material{display:none}#contact_form-main .contact.container .content .row .byalaw .added-top-margin{margin-top:3%}#contact_form-main .contact.container .content .row .byalaw .bold-text{font-weight:700}#contact_form-main .contact.container .content .row .byalaw table.table-1,#contact_form-main .contact.container .content .row .byalaw table.table-2{font-size:.9vw;text-indent:0;width:100%}#contact_form-main .contact.container .content .row .byalaw table.table-1 td,#contact_form-main .contact.container .content .row .byalaw table.table-2 td{padding:3% 0}#contact_form-main .contact.container .content .row .byalaw table.table-1 tr:nth-child(1),#contact_form-main .contact.container .content .row .byalaw table.table-2 tr:nth-child(1){text-align:center}#contact_form-main .contact.container .content .row .byalaw table.table-1 span.sub-titile,#contact_form-main .contact.container .content .row .byalaw table.table-2 span.sub-titile{font-size:.9vw}#contact_form-main .contact.container .content .row .byalaw table.table-1 span.text,#contact_form-main .contact.container .content .row .byalaw table.table-2 span.text{font-size:.9vw;display:inline-block;width:90%;padding-left:3%}#contact_form-main .contact.container .content .row .byalaw table.table-1 p,#contact_form-main .contact.container .content .row .byalaw table.table-2 p{width:97%;padding-left:1%}#contact_form-main .contact.container .content .row .byalaw table.table-1 .angle-left,#contact_form-main .contact.container .content .row .byalaw table.table-2 .angle-left{text-align:left!important}#contact_form-main .contact.container .content .row .byalaw table.table-2 tr:nth-child(even){background:#efefef}#contact_form-main .contact.container .content .row .byalaw a{text-decoration:underline}#contact_form-main .contact.container .content .row .byalaw .dl3rdP{box-sizing:border-box;width:100%;margin:30px 0;border-bottom:grey 1px solid}#contact_form-main .contact.container .content .row .byalaw .dl3rdP dl{display:-ms-flexbox;display:flex;box-sizing:border-box;border-top:grey 1px solid;border-left:grey 1px solid;border-right:grey 1px solid;margin:0}#contact_form-main .contact.container .content .row .byalaw .dl3rdP dl dt{background:#efefef}#contact_form-main .contact.container .content .row .byalaw .dl3rdP dl dt:first-of-type,#contact_form-main .contact.container .content .row .byalaw .dl3rdP dl dd:first-of-type{border-left:none}#contact_form-main .contact.container .content .row .byalaw .dl3rdP dl dt,#contact_form-main .contact.container .content .row .byalaw .dl3rdP dl dd{box-sizing:border-box;display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center;padding:10px;margin:0;text-indent:0;width:100%;border-left:grey 1px solid}#contact_form-main .contact.container .content .row .line{border:1px solid #e2e2e2}#contact_form-main .contact.container .content .row .btn{position:relative;margin-top:25px;padding:0 5px;font-size:15px;line-height:0;color:#fff;height:40px;border-radius:5px;border-color:#000;border-width:1px;border-style:solid;background-color:#000}@media (max-width:479px){#contact_form-main .contact.container .content{padding:60px 20px}#contact_form-main .contact.container .content .btn{font-size:12px!important}}@media (max-width:768px){#contact_form-main .contact.container{width:100%}}.container_fix{width:100%}.container_fix .row{margin:10px 5px}.container_fix .row button{width:100%}.btn-more{position:relative;top:50%;font-size:15px;color:#fff;text-align:center;background-color:#01a5a3;width:177px;height:45px;border-radius:3px;border-color:#01a5a3;border-width:2px;border-style:solid;padding:8px 12px}", ""]);

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	var ContactCtrl;
	
	__webpack_require__(620);
	
	ContactCtrl = function($scope, $filter, $translate, $location, userInfo, flash, ContactService, $modal) {
	  $scope.contact = {
	    name: userInfo != null ? userInfo.name : void 0,
	    email: userInfo != null ? userInfo.email : void 0
	  };
	  $scope.isSubmitting = false;
	  $scope.subjects = /^ja/i.test($translate.preferredLanguage()) ? ["こんな機能がほしい", "バグをみつけた", "登録アカウント情報を変更したい", "課金について聞きたい", "退会方法について聞きたい", "その他"] : ["I would like to leave feedback.", "I'm having trouble with this site.", "How can I change my account information?", "Other"];
	  $scope.send = function() {
	    $scope.isSubmitting = true;
	    return ContactService.send($scope.contact).then(function(resp) {
	      return $modal.open({
	        size: 'lg',
	        templateUrl: "contact/modals/web-contact-success-modal.jade",
	        controller: 'ContactSuccessCtrl',
	        backdrop: 'static',
	        keyboard: false
	      });
	    })["catch"](function(data) {
	      return flash.error($filter('translate')('API_ERROR'));
	    })["finally"](function() {
	      return $scope.isSubmitting = false;
	    });
	  };
	  return $scope.cancel = function() {
	    return $location.path('/');
	  };
	};
	
	ContactCtrl.$inject = ['$scope', '$filter', '$translate', '$location', 'userInfo', 'flash', 'ContactService', '$modal'];
	
	module.exports = ContactCtrl;


/***/ }),
/* 620 */
/***/ (function(module, exports) {

	var v1="<div id=\"web_contact_success_modal-main\"><div class=\"modal-body container container_fix\"><div class=\"content content_fix\"><div class=\"col-12 row\"><div class=\"col-11 blank\"></div></div><div class=\"row\"><div class=\"col-1 blank\"></div><div class=\"col-10 title1\">{{:: '_CONTACT.INQUIRY_SUCCESS' | translate }}</div><div class=\"col-1 blank\"></div></div><div class=\"row\"><div class=\"col-2 blank\"></div><div class=\"col-8 r-btn\"><button type=\"submit\" ng-click=\"cancel()\" class=\"btn btn-more\">{{:: 'OK' | translate }}</button></div><div class=\"col-2 blank\"></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("contact/modals/web-contact-success-modal.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	var ContactService, _;
	
	_ = __webpack_require__(87);
	
	ContactService = function($http) {
	  return {
	    send: function(data) {
	      var params;
	      params = _.merge({}, data, {
	        localtime: (new Date()).toString()
	      });
	      return $http.post("/api/inquiry/send.json", params);
	    }
	  };
	};
	
	ContactService.$inject = ['$http'];
	
	module.exports = ContactService;


/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports = {
	  '_CONTACT': {
	    'TITLE': 'Contact',
	    'SUBJECT': "Subject",
	    'YOUR_NAME': 'Your Name',
	    'EMAIL_ADDRESS': 'Email Address',
	    'BODY': 'Body',
	    'SUBJECT_DEFAULT_TEXT': "-- Please choose a subject --",
	    'INQUIRY_SUCCESS': 'Your inquiry email has been sent successfully. User support will reply by email.'
	  }
	};


/***/ }),
/* 623 */
/***/ (function(module, exports) {

	module.exports = {
	  '_CONTACT': {
	    'TITLE': 'お問合わせ',
	    'SUBJECT': "お問合せ種別",
	    'YOUR_NAME': 'お名前',
	    'EMAIL_ADDRESS': '返信先メールアドレス',
	    'BODY': 'お問合せ内容',
	    'SUBJECT_DEFAULT_TEXT': "-- こちらからお選びください --",
	    'INQUIRY_SUCCESS': 'お問い合わせメールの送信が完了しました。ユーザーサポートよりメールで返信させていただきます。'
	  }
	};


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	var TitleInterceptor;
	
	__webpack_require__(28);
	
	TitleInterceptor = __webpack_require__(625);
	
	angular.module('gnp-app-title', []).run(TitleInterceptor);


/***/ }),
/* 625 */
/***/ (function(module, exports) {

	var TitleInterceptor;
	
	TitleInterceptor = function($rootScope) {
	  return $rootScope.$on("$routeChangeSuccess", function(event, current, previous) {
	    if (!current.$$route) {
	      return;
	    }
	    return $rootScope.title = current.$$route.title;
	  });
	};
	
	TitleInterceptor.$inject = ['$rootScope'];
	
	module.exports = TitleInterceptor;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	var modules;
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(82);
	
	__webpack_require__(627);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-common-wrapper'];
	
	angular.module('gnp-app-policy', modules).config([
	  '$routeProvider', '$translateProvider', function($routeProvider, $translateProvider) {
	    $translateProvider.translations('en', __webpack_require__(630)).translations('ja', __webpack_require__(631));
	    return $routeProvider.when('/policy', {
	      controller: 'PolicyCtrl',
	      template: '<div ng-include="templateUrl"></div>',
	      title: '_PRIVACY_POLICY.TITLE'
	    });
	  }
	]).controller('PolicyCtrl', [
	  '$scope', '$translate', function($scope, $translate) {
	    return $scope.templateUrl = "templates/policy/index." + ($translate.use()) + ".html";
	  }
	]);


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(628);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_privacy.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_privacy.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#privacy-main{color:#000}#privacy-main .privacy.container{max-width:none!important}#privacy-main .cell{padding:0}#privacy-main .privacy.container{width:970px;padding-bottom:50px;background-color:#fff}#privacy-main .privacy.container .content{width:780px;margin:60px auto 0}#privacy-main p{line-height:30px}#privacy-main ol{margin:0;padding:0}#privacy-main .c57{margin-left:15px}#privacy-main .c57 td{padding:20pt 5pt;vertical-align:inherit}#privacy-main .c53{border-bottom-width:1pt;border-top-style:solid;width:133.6pt;background-color:#f0f0f0;border-right-style:solid;padding:5pt 8pt;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c52{width:74pt}#privacy-main .c52,#privacy-main .c5{border-bottom-width:1pt;border-top-style:solid;background-color:#f0f0f0;border-right-style:solid;padding:5pt 8pt;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c5{width:117.2pt}#privacy-main .c37{width:468pt}#privacy-main .c37,#privacy-main .c43{border-bottom-width:1pt;border-top-style:solid;background-color:#f0f0f0;border-right-style:solid;padding:5pt 8pt;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c43{width:143.2pt}#privacy-main .c35{width:119.9pt}#privacy-main .c35,#privacy-main .c46{border-bottom-width:1pt;border-top-style:solid;background-color:#f0f0f0;border-right-style:solid;padding:5pt 8pt;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c46{width:124pt}#privacy-main .c38{width:354pt}#privacy-main .c38,#privacy-main .c41{border-bottom-width:1pt;border-top-style:solid;background-color:#f0f0f0;border-right-style:solid;padding:5pt 8pt;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c41{width:205pt}#privacy-main .c47{width:80.9pt;background-color:#f0f0f0;padding:5pt 8pt}#privacy-main .c47,#privacy-main .c48{border-bottom-width:1pt;border-top-style:solid;border-right-style:solid;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c48{width:117.2pt;padding:5pt}#privacy-main .c2{width:352pt}#privacy-main .c2,#privacy-main .c6{border-bottom-width:1pt;border-top-style:solid;border-right-style:solid;padding:5pt;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c6{width:116pt}#privacy-main .c32{width:468pt}#privacy-main .c32,#privacy-main .c44{border-bottom-width:1pt;border-top-style:solid;border-right-style:solid;padding:5pt;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c44{width:141.6pt}#privacy-main .c39{width:80.9pt;padding:5pt}#privacy-main .c39,#privacy-main .c49{border-bottom-width:1pt;border-top-style:solid;border-right-style:solid;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c49{width:468pt;padding:5pt 8pt}#privacy-main .c31{width:119.9pt}#privacy-main .c31,#privacy-main .c20{border-bottom-width:1pt;border-top-style:solid;border-right-style:solid;padding:5pt;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c20{width:234pt}#privacy-main .c29{width:74pt}#privacy-main .c29,#privacy-main .c42{border-bottom-width:1pt;border-top-style:solid;border-right-style:solid;padding:5pt;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c42{width:234pt}#privacy-main .c30{width:172pt}#privacy-main .c30,#privacy-main .c40{border-bottom-width:1pt;border-top-style:solid;border-right-style:solid;padding:5pt;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c40{width:124pt}#privacy-main .c28{width:296pt}#privacy-main .c28,#privacy-main .c34{border-bottom-width:1pt;border-top-style:solid;border-right-style:solid;padding:5pt;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c34{width:326.4pt}#privacy-main .c22{width:143.2pt}#privacy-main .c22,#privacy-main .c51{border-bottom-width:1pt;border-top-style:solid;border-right-style:solid;padding:5pt;border-bottom-color:#ccc;border-top-width:1pt;border-bottom-style:solid;vertical-align:top;border-top-color:#ccc;border-left-color:#ccc;border-right-color:#ccc;border-left-style:solid;border-right-width:1pt;border-left-width:1pt}#privacy-main .c51{width:133.6pt}#privacy-main .c11{vertical-align:baseline;color:#000;font-size:9pt;font-style:normal;background-color:#f0f0f0;font-family:\"Arial\";text-decoration:none;font-weight:700}#privacy-main .c4{color:#333;font-weight:400}#privacy-main .c4,#privacy-main .c54{vertical-align:baseline;font-size:9pt;font-style:normal;font-family:\"Arial\";text-decoration:none}#privacy-main .c54{color:#000}#privacy-main .c18{line-height:1.15;padding-top:0;text-indent:-4pt;text-align:left;margin-left:5pt;padding-bottom:0}#privacy-main .c13{text-indent:-18pt;margin-left:11pt}#privacy-main .c13,#privacy-main .c16{line-height:1.15;padding-top:0;text-align:left;padding-bottom:0}#privacy-main .c16{margin-left:-4pt}#privacy-main .c27{text-align:center}#privacy-main .c27,#privacy-main .c19{line-height:1.15;padding-top:0;padding-bottom:0}#privacy-main .c19{text-align:left}#privacy-main .c25{margin-right:auto;border-collapse:collapse}#privacy-main .c25 td{padding:10pt 8pt}#privacy-main .c25 td span.c4{margin-left:8px}#privacy-main .c0{widows:2;orphans:2;direction:ltr}#privacy-main .c3{color:#333;font-size:10pt}#privacy-main .c26{max-width:468pt;padding:72pt}#privacy-main .c36{padding-left:0;margin-left:36pt}#privacy-main .c9{text-indent:-18pt;margin-left:18pt}#privacy-main .c55{width:680px;float:left}#privacy-main .c56{margin-top:-25px;height:100px;width:100px;float:left;background-repeat:no-repeat;background-image:url("+__webpack_require__(629)+")}#privacy-main .c58{display:block;float:left;width:24%;margin-right:1%}#privacy-main .c58 img{width:100%}#privacy-main .c59{display:block;float:right;width:75%}#privacy-main .c60{margin-left:30px}#privacy-main .content3 .c2{width:1186pt}#privacy-main .content32{padding-bottom:15px}#privacy-main .dl3rdP{box-sizing:border-box;width:100%;margin:30px 0;border-bottom:grey 1px solid}#privacy-main .dl3rdP dl{border-top:grey 1px solid;border-right:grey 1px solid}#privacy-main .dl3rdP dl,#privacy-main .dl3rdP dl dd,#privacy-main .dl3rdP dl dt{box-sizing:border-box;display:-ms-flexbox;display:flex;margin:0;border-left:grey 1px solid}#privacy-main .dl3rdP dl dd,#privacy-main .dl3rdP dl dt{-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center;padding:10px;text-indent:0;width:100%;color:#333;font-size:11pt;font-family:\"Arial\";line-height:30px}#privacy-main .dl3rdP dl dt:first-of-type,#privacy-main .dl3rdP dl dd:first-of-type{border-left:none}#privacy-main .dl3rdP dl dt{background:#efefef;font-weight:700}#privacy-main .p-box{box-sizing:border-box;width:100%;margin-top:3%;padding:3%;border:1px solid #337fb8;display:inline-block}#privacy-main .c1{color:#333;background-color:#fff}#privacy-main .c8{color:#333;font-weight:700}#privacy-main .c7{font-size:7pt;font-family:\"Times New Roman\"}#privacy-main .c45{margin:0;padding:0}#privacy-main .c23{text-indent:-5pt;margin-left:5pt}#privacy-main .c33{text-align:center}#privacy-main .c17{color:#333}#privacy-main .c14{text-align:right}#privacy-main .c10{margin-left:8px;background-color:#fff}#privacy-main .c21{margin-left:11pt}#privacy-main .c50{margin-left:18pt}#privacy-main .c12{height:0}#privacy-main .c24{height:11pt}#privacy-main .c15{font-weight:700}#privacy-main .title{color:#000;font-size:21pt;padding-bottom:0}#privacy-main .title,#privacy-main .subtitle{widows:2;padding-top:0;line-height:1.15;orphans:2;text-align:left;font-family:\"Trebuchet MS\";page-break-after:avoid}#privacy-main .subtitle{color:#666;font-style:italic;font-size:13pt;padding-bottom:10pt}#privacy-main li,#privacy-main p{color:#000;font-size:11pt;font-family:\"Arial\"}#privacy-main p{margin:0}#privacy-main h1{widows:2;padding-top:10pt;line-height:1.15;orphans:2;text-align:left;color:#000;font-size:16pt;font-family:\"Trebuchet MS\";padding-bottom:0;page-break-after:avoid}#privacy-main h2{padding-top:10pt;color:#000;font-size:13pt}#privacy-main h2,#privacy-main h3{widows:2;line-height:1.15;orphans:2;text-align:left;font-family:\"Trebuchet MS\";font-weight:700;padding-bottom:0;page-break-after:avoid}#privacy-main h3{padding-top:8pt;color:#666;font-size:12pt}#privacy-main h4{text-decoration:underline}#privacy-main h4,#privacy-main h5,#privacy-main h6{widows:2;padding-top:8pt;line-height:1.15;orphans:2;text-align:left;color:#666;font-size:11pt;font-family:\"Trebuchet MS\";padding-bottom:0;page-break-after:avoid}#privacy-main h6{font-style:italic}#privacy-main .d1{width:200px}#privacy-main .d1,#privacy-main .d2{padding:5px 5px 5px 10px}#privacy-main .d2 span.c11{font-size:12px;margin:0}#privacy-main .d3{padding:5px;font-size:12px;font-weight:700;background-color:#f0f0f0;text-align:center}#privacy-main .d4{padding:5px 5px 5px 10px;font-size:12px}#privacy-main .t1{margin-bottom:90px;border-collapse:separate}#privacy-main .t2{margin-bottom:60px;border-collapse:separate}#privacy-main ul{line-height:30px;font-size:15px;list-style-type:decimal}#privacy-main ul .c15{margin:0}@media (max-width:768px){#privacy-main{position:relative;top:-25px}#privacy-main .privacy.container{width:100%}#privacy-main .privacy.container .content{width:80%}#privacy-main .c55{width:70%}}@media (max-width:320px){#privacy-main .c0 .c1 a{font-size:12px}}", ""]);

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	module.exports = {
	  '_PRIVACY_POLICY': {
	    'TITLE': 'Privacy Policy'
	  }
	};


/***/ }),
/* 631 */
/***/ (function(module, exports) {

	module.exports = {
	  '_PRIVACY_POLICY': {
	    'TITLE': '個人情報保護ポリシー'
	  }
	};


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	var modules;
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(82);
	
	__webpack_require__(633);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-common-wrapper'];
	
	angular.module('gnp-app-legal', modules).config([
	  '$routeProvider', '$translateProvider', function($routeProvider, $translateProvider) {
	    $translateProvider.translations('en', __webpack_require__(635)).translations('ja', __webpack_require__(636));
	    return $routeProvider.when('/legal', {
	      controller: 'LegalCtrl',
	      template: '<div ng-include="templateUrl"></div>',
	      title: '_LEGAL.TITLE'
	    });
	  }
	]).controller('LegalCtrl', [
	  '$scope', '$translate', function($scope, $translate) {
	    return $scope.templateUrl = "templates/legal/index." + ($translate.use()) + ".html";
	  }
	]);


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(634);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_term-of-use.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_term-of-use.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#term-of-use-main .cell{padding:0}#term-of-use-main .term-of-use.container{max-width:none!important;width:970px;padding-bottom:50px;background-color:#fff}#term-of-use-main .row{margin:0;font-size:14px}#term-of-use-main .row.c0{margin:50px 0 35px 50px;font-size:20px;font-weight:700}#term-of-use-main .row.c1{border-top:solid 1px #ccc;padding-top:15px;margin-top:20px}#term-of-use-main .row.c1 a{text-decoration:none;cursor:pointer}#term-of-use-main .row.c1.last{border-bottom:solid 1px #ccc;padding-bottom:15px}#term-of-use-main .row .col-3{font-weight:700}@media (max-width:768px){#term-of-use-main .term-of-use.container{width:100%}}", ""]);

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	module.exports = {
	  '_LEGAL': {
	    'TITLE': 'Legal Information'
	  }
	};


/***/ }),
/* 636 */
/***/ (function(module, exports) {

	module.exports = {
	  '_LEGAL': {
	    'TITLE': '特定商取引法に基づく表示'
	  }
	};


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	var EmailConfirmationEditCtrl, EmailConfirmationNewCtrl, EmailConfirmationService, RegistrationService, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(76);
	
	__webpack_require__(90);
	
	__webpack_require__(82);
	
	__webpack_require__(108);
	
	__webpack_require__(112);
	
	__webpack_require__(638);
	
	__webpack_require__(639);
	
	__webpack_require__(640);
	
	EmailConfirmationNewCtrl = __webpack_require__(642);
	
	EmailConfirmationEditCtrl = __webpack_require__(643);
	
	EmailConfirmationService = __webpack_require__(644);
	
	RegistrationService = __webpack_require__(344);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-auth', 'gnp-common-wrapper', 'gnp-form', 'gnp-error-handler', 'gnp-account', 'gnp-animate'];
	
	angular.module('gnp-app-email-confirmation', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/email_confirmation/new', {
	      templateUrl: 'web/email-confirmation/new.jade',
	      controller: 'EmailConfirmationNewCtrl',
	      title: '_CONFIRMATION.NEW.TITLE',
	      resolve: {
	        account: [
	          'RegistrationService', function(RegistrationService) {
	            return RegistrationService.get();
	          }
	        ]
	      },
	      permission: {
	        signInRequired: true
	      }
	    }).when('/email_confirmation/edit/:token', {
	      templateUrl: 'web/email-confirmation/edit.jade',
	      controller: 'EmailConfirmationEditCtrl',
	      title: '_CONFIRMATION.EDIT.TITLE',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ]
	      }
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(645)).translations('ja', __webpack_require__(646));
	  }
	]).controller('EmailConfirmationNewCtrl', EmailConfirmationNewCtrl).controller('EmailConfirmationEditCtrl', EmailConfirmationEditCtrl).factory('EmailConfirmationService', EmailConfirmationService).factory('RegistrationService', RegistrationService);


/***/ }),
/* 638 */
/***/ (function(module, exports) {

	var v1="<div id=\"confirmation-new-main\" gnp-common-wrapper-a=\"\"><div class=\"container confirmation-new-main\"><div class=\"col-12 page-header\"><h1>{{:: '_CONFIRMATION.NEW.TITLE' | translate }}</h1></div><div class=\"col-12 content\"><div class=\"current-email\"><p>{{:: '_CONFIRMATION.NEW.CURRENT_EMIL' | translate }} {{ originalEmail }}</p></div><div class=\"confirmation\"><p>{{:: '_CONFIRMATION.NEW.CONFIRMATION_MSG' | translate }}</p></div><div class=\"row\"><div class=\"main col-12 col-sm-6 offset-sm-3\"><ol><li>{{:: '_CONFIRMATION.NEW.INSTRUCTION_STEP1' | translate }}</li><li>{{:: '_CONFIRMATION.NEW.INSTRUCTION_STEP2' | translate }}</li><li>{{:: '_CONFIRMATION.NEW.INSTRUCTION_STEP3' | translate }}</li></ol><button type=\"submit\" ng-click=\"send_confirmation_email()\" ng-disabled=\"emailSent\" class=\"btn btn-secondary\">{{:: '_CONFIRMATION.NEW.SEND' | translate }}</button><a href=\"/registration/edit\">{{:: '_CONFIRMATION.NEW.CHANGE_EMAIL_NOW' | translate }}</a></div></div><div ng-if=\"lang == &quot;ja&quot;\" class=\"attention\"><h2>{{:: '_CONFIRMATION.NEW.ATTENTION_TITLE' | translate }}</h2><div><p>{{:: '_CONFIRMATION.NEW.ATTENTION_MSG1' | translate }}</p><p>{{:: '_CONFIRMATION.NEW.ATTENTION_MSG2' | translate }}</p><p>{{:: '_CONFIRMATION.NEW.ATTENTION_MSG3' | translate }}</p></div></div></div></div></div><script>$(document.body).css('min-width', 0)</script>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/email-confirmation/new.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	var v1="<div id=\"confirmation-new-main\" gnp-common-wrapper-a=\"\"><div class=\"container confirmation-new-main\"><div class=\"col-12 page-header\"><h1>{{:: '_CONFIRMATION.EDIT.TITLE' | translate }}</h1></div><div class=\"col-12 content\"><p ng-show=\"confirmed\">{{:: '_CONFIRMATION.EDIT.SUCCESS' | translate }}</p><p ng-show=\"!confirmed\">{{:: '_CONFIRMATION.EDIT.INVALID' | translate }}</p><button type=\"submit\" ng-click=\"backToDashboard()\" class=\"btn\">{{:: '_CONFIRMATION.EDIT.DASHBOARD' | translate | trustedText}}</button></div></div></div><script>$(document.body).css('min-width', 0)</script>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/email-confirmation/edit.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(641);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_email_confirmation.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_email_confirmation.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}@media (max-width:768px){#confirmation-new-main{position:relative;top:-25px}}#confirmation-new-main .container.confirmation-new-main{max-width:970px}#confirmation-new-main .page-header{margin:50px 0 0;padding:3px;text-align:center}#confirmation-new-main .page-header h1{font-size:22px;line-height:22px;color:#01A5A3;border-bottom:3px solid #01A5A3;margin:0;padding:0;display:inline}#confirmation-new-main .content{background-color:#fff;padding-top:10px;padding-bottom:10px}#confirmation-new-main .current-email{border:3px solid #01A5A3;text-align:center;font-size:20px;margin:0 auto;padding:10px 0}#confirmation-new-main .current-email p{margin:0}#confirmation-new-main .confirmation{text-align:center;font-size:24px;font-weight:700;color:#000;margin:30px auto 0}#confirmation-new-main .main{display:table-cell;text-align:center}#confirmation-new-main .main ol{color:#ec1723;font-size:.85rem;text-align:left;display:inline-block}#confirmation-new-main .main button{background-color:#ec1723;color:#fff;width:100%;margin-bottom:12px}#confirmation-new-main .main a{font-size:.85rem;color:#000;text-decoration:underline}#confirmation-new-main .main .label{font-weight:700}#confirmation-new-main .attention{margin-top:10px;padding:4px;color:#ec1723;border:1px solid #ec1723}#confirmation-new-main .attention h2{text-align:center;margin:0 0 10px;padding:0;font-size:16px}", ""]);

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	var EmailConfirmationNewCtrl;
	
	EmailConfirmationNewCtrl = function($scope, $filter, $translate, flash, account, EmailConfirmationService) {
	  $scope.originalEmail = account.email;
	  $scope.lang = $translate.use();
	  $scope.openPositiveConfirmation = false;
	  $scope.send_confirmation_email = function() {
	    return EmailConfirmationService.send().then(function(resp) {
	      $scope.emailSent = true;
	      return flash.success($filter('translate')('_CONFIRMATION.NEW.EMAIL_SENT'));
	    })["catch"](function(error) {
	      return flash.error($filter('translate')('_ERROR_HANDLER.UNEXPECTED_ERROR_MSG'));
	    });
	  };
	  return $scope.toggle_positive_confirmation = function() {
	    return $scope.openPositiveConfirmation = !$scope.openPositiveConfirmation;
	  };
	};
	
	EmailConfirmationNewCtrl.$inject = ['$scope', '$filter', '$translate', 'flash', 'account', 'EmailConfirmationService'];
	
	module.exports = EmailConfirmationNewCtrl;


/***/ }),
/* 643 */
/***/ (function(module, exports) {

	var EmailConfirmationEditCtrl;
	
	EmailConfirmationEditCtrl = function($scope, $routeParams, $location, EmailConfirmationService, AccountService) {
	  $scope.params = {
	    token: $routeParams.token
	  };
	  $scope.isLoading = true;
	  EmailConfirmationService.confirm($scope.params.token).then(function(resp) {
	    AccountService.setConfirmationStatus();
	    return $scope.confirmed = true;
	  })["catch"](function(error) {
	    return $scope.confirmed = false;
	  })["finally"](function() {
	    return $scope.isLoading = false;
	  });
	  return $scope.backToDashboard = function() {
	    return $location.path('/');
	  };
	};
	
	EmailConfirmationEditCtrl.$inject = ['$scope', '$routeParams', '$location', 'EmailConfirmationService', 'AccountService'];
	
	module.exports = EmailConfirmationEditCtrl;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	var EmailConfirmationService, _;
	
	_ = __webpack_require__(87);
	
	EmailConfirmationService = function($http) {
	  return {
	    send: function() {
	      return $http.post('/api/email_confirmation/send.json');
	    },
	    confirm: function(token) {
	      return $http.post('/api/email_confirmation/confirm.json', {
	        token: token
	      });
	    }
	  };
	};
	
	EmailConfirmationService.$inject = ['$http'];
	
	module.exports = EmailConfirmationService;


/***/ }),
/* 645 */
/***/ (function(module, exports) {

	module.exports = {
	  '_CONFIRMATION': {
	    'NEW': {
	      'TITLE': 'Email address confirmation',
	      'CURRENT_EMIL': 'Registered email address',
	      'CONFIRMATION_MSG': 'Follow these steps to complete your email confirmation.',
	      'INSTRUCTION_STEP1': 'A confirmation email will be sent to you after you tap "Send" button.',
	      'INSTRUCTION_STEP2': 'Click the link written on the confirmation email.',
	      'INSTRUCTION_STEP3': 'Then, the procedures is completed.',
	      'SEND': 'Send ( A confirmation email will be sent to you. )',
	      'CHANGE_EMAIL_NOW': 'I want to change my email address.',
	      'EMAIL_SENT': 'Confirmation email has been sent, please check your inbox.'
	    },
	    'EDIT': {
	      'TITLE': 'Confirmed',
	      'SUCCESS': 'Email confirmation has been completed.',
	      'INVALID': 'Invalid token. Please check again.',
	      'DASHBOARD': 'Back to dashboard'
	    },
	    'NOTIFICATION': {
	      'TEXT': 'Please confirm your account email'
	    },
	    'ACCOUNT_PAGE': {
	      'TEXT': 'Please complete email confirmation.'
	    }
	  }
	};


/***/ }),
/* 646 */
/***/ (function(module, exports) {

	module.exports = {
	  '_CONFIRMATION': {
	    'NEW': {
	      'TITLE': 'メールアドレスのご本人確認',
	      'CURRENT_EMIL': '現在のご登録メールアドレス',
	      'CONFIRMATION_MSG': '下記の操作を行い、ご自身のメールアドレスであることをお知らせ下さい',
	      'INSTRUCTION_STEP1': '確認メールを送信（下記ボタンをタップ）',
	      'INSTRUCTION_STEP2': '届いたメールの本文中にある URL をクリック',
	      'INSTRUCTION_STEP3': 'メールアドレスのご本人確認が完了',
	      'SEND': '確認メールを送信',
	      'CHANGE_EMAIL_NOW': 'ご登録メールアドレスを変更されたい方はこちら',
	      'ATTENTION_TITLE': '※ご注意ください※',
	      'ATTENTION_MSG1': '確認メールは下記の件名で、こちらのシステムアカウントより送信されます',
	      'ATTENTION_MSG2': '【件名】GOLF NETWORK PLUSメールアドレス確認',
	      'ATTENTION_MSG3': '【送信元アカウント】no-reply@golfnetwork.jp',
	      'EMAIL_SENT': '確認メールが送信されました。メールをご確認ください。'
	    },
	    'EDIT': {
	      'TITLE': 'メール確認',
	      'SUCCESS': 'メールアドレスの本人確認手続きが完了しました。',
	      'INVALID': 'トークンが無効です。',
	      'DASHBOARD': 'ダッシュボードに戻る'
	    },
	    'NOTIFICATION': {
	      'TEXT': 'ご登録メールアドレスのご確認をお願いします'
	    },
	    'ACCOUNT_PAGE': {
	      'TEXT': 'メールアドレスの本人確認手続きを行って下さい.'
	    }
	  }
	};


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	var ClubHoleByHoleBarChartDirective, ClubHoleByHoleCtrl, ClubHoleByHoleDetailDirective, ClubMapCtrl, ClubScoreCardCtrl, ClubScoreCardDirective, ClubService, ClubShowCtrl, RoundInfoService, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(386);
	
	__webpack_require__(59);
	
	__webpack_require__(82);
	
	__webpack_require__(416);
	
	__webpack_require__(389);
	
	__webpack_require__(39);
	
	__webpack_require__(648);
	
	__webpack_require__(659);
	
	ClubService = __webpack_require__(662);
	
	RoundInfoService = __webpack_require__(436);
	
	ClubShowCtrl = __webpack_require__(663);
	
	ClubMapCtrl = __webpack_require__(664);
	
	ClubScoreCardCtrl = __webpack_require__(666);
	
	ClubScoreCardDirective = __webpack_require__(668);
	
	ClubHoleByHoleCtrl = __webpack_require__(670);
	
	ClubHoleByHoleDetailDirective = __webpack_require__(674);
	
	ClubHoleByHoleBarChartDirective = __webpack_require__(676);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-common-wrapper', 'gnp-remote-api', 'gnp-map', 'gnp-number', 'gnp-analyze-access'];
	
	angular.module('gnp-app-club', modules).config([
	  '$routeProvider', '$translateProvider', function($routeProvider, $translateProvider) {
	    $translateProvider.translations('en', __webpack_require__(679)).translations('ja', __webpack_require__(680));
	    return $routeProvider.when('/clubs/:id', {
	      controller: 'ClubShowCtrl',
	      templateUrl: 'web/club/index.jade',
	      resolve: {
	        clubInfo: [
	          'ClubService', '$route', function(ClubService, $route) {
	            return ClubService.getClub($route.current.params.id, true);
	          }
	        ],
	        fromJapan: [
	          'CountryAPIService', function(CountryAPIService) {
	            return CountryAPIService.fromJapan();
	          }
	        ]
	      },
	      title: '_CLUB_PAGE.PAGE_TITLE'
	    });
	  }
	]).controller('ClubShowCtrl', ClubShowCtrl).controller('ClubMapCtrl', ClubMapCtrl).controller('ClubScoreCardCtrl', ClubScoreCardCtrl).controller('ClubHoleByHoleCtrl', ClubHoleByHoleCtrl).factory('ClubService', ClubService).factory('RoundInfoService', RoundInfoService).directive('clubScoreCard', ClubScoreCardDirective).directive('clubHoleByHoleDetail', ClubHoleByHoleDetailDirective).directive('clubHoleByHoleBarChart', ClubHoleByHoleBarChartDirective);


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"club-page\" gnp-common-wrapper-b=\"\"><div id=\"top-page\"><div class=\"row\"><div class=\"col-12 col-lg-4 offset-lg-4\"><div class=\"col-md-12\"><div id=\"summary\"><h3><left>{{ :: clubInfo.name }}</left></h3><hr/><div href=\"javascript:void(0)\" ng-click=\"showBasicInfo()\" class=\"row no-margin\"><div class=\"col-10 no-padding info-heading\"><img src=\"" + __webpack_require__(649) + "\"/><span>{{ :: '_CLUB_PAGE.BASIC_INFO' | translate }}</span></div><div class=\"col-2 no-padding\"><a ng-class=\"{active:isShowBasicInfo}\" class=\"btn-show-detail\"><img src=\"" + __webpack_require__(650) + "\"/></a></div></div><div class=\"border-gray\"></div><div ng-show=\"isShowBasicInfo\" class=\"golf-course-basic-info\"><div class=\"address\"><div class=\"row\"><div class=\"col-2 col-sm-1 col-lg-2\"><span class=\"address-label\">{{ :: '_CLUB_PAGE.ADDRESS' | translate }}</span></div><div class=\"col-7 col-sm-8 col-lg-7 no-padding\"><span class=\"address-value address-url ellipsis\">{{ clubInfo.address }}</span></div><div class=\"col-3 no-padding\"><img src=\"" + __webpack_require__(651) + "\" ng-click=\"showMap()\" class=\"map-icon\"/></div></div></div><div ng-if=\"isShowMap\" class=\"row margin-20\"><div class=\"col-md-12 no-padding\"><div ng-controller=\"ClubMapCtrl as clubMapCtrl\" ng-include=\"'club/club-map/club-map.jade'\" class=\"club-map\"></div></div></div><div class=\"address\"><div class=\"row\"><div class=\"col-2 col-sm-1 col-lg-2\"><span class=\"address-label\">{{ :: '_CLUB_PAGE.TEL' | translate }}</span></div><div class=\"col-10 col-sm-11 col-lg-10 no-padding\"><span class=\"address-value\">{{ clubInfo.phone }}</span></div></div></div><div class=\"address\"><div class=\"row\"><div class=\"col-2 col-sm-1 col-lg-2\"><span class=\"address-label\">{{ :: '_CLUB_PAGE.URL' | translate }}</span></div><div class=\"col-10 col-sm-11 col-lg-10 no-padding\"><a href=\"{{ clubInfo.site_original_url }}\" target=\"_blank\" class=\"address-value address-url ellipsis\">{{ clubInfo.site_original_url }}</a></div></div></div><hr/></div><div ng-if=\"recommentPlans.length &gt; 0\" class=\"info-heading margin-20\"><img src=\"" + __webpack_require__(652) + "\"/><span>{{ :: '_CLUB_PAGE.RECOMMENT_PLAN' | translate }}</span></div><div ng-repeat=\"recommentPlan in recommentPlans track by $index\" ng-if=\"clubInfo.rakuten_id &amp;&amp; $index &lt; 1\" class=\"recommend-plan\"><a href=\"{{ recommentPlan.plan.callInfo.reservePageUrlPC }}\" target=\"_blank\"><div class=\"recommend-plan-title\">{{ recommentPlan.plan.planName }}</div><div class=\"row\"><div class=\"col-lg-3 col-md-4 col-sm-3 col-4\"><div class=\"stock-count\">空枠数{{recommentPlan.plan.callInfo.stockCount}}</div></div><div class=\"col-lg-8 col-md-7 col-sm-8 col-6\"><span class=\"price\">{{recommentPlan.plan.price | number}}</span><span class=\"price-desc\">円（税込）</span></div><div class=\"col-sm-1 col-2 no-padding next-wrap\"><img src=\"" + __webpack_require__(653) + "\"/></div></div></a></div><a href=\"{{ rakutenLink }}\" target=\"_blank\" ng-if=\"recommentPlans.length &gt; 0\" class=\"see-more-rakuten\"><i class=\"btn-rakuten\"></i><span>{{ :: '_CLUB_PAGE.SEE_MORES_RECOMMENT_PLAN' | translate }}</span><img src=\"" + __webpack_require__(654) + "\"/></a></div></div><div class=\"col-md-12\"><div id=\"hole-by-hole\" ng-controller=\"ClubHoleByHoleCtrl as holeByHoleCtrl\" ng-include=\"'club/club-hole-by-hole/club-hole-by-hole.jade'\"></div><div class=\"border-green-xs mb-20\"></div></div><div class=\"col-md-12\"><div id=\"score-card\" ng-controller=\"ClubScoreCardCtrl as scoreCardCtrl\" ng-include=\"'club/club-scorecard/club-scorecard.jade'\"></div><div class=\"border-green-xs margin-20\"></div><div class=\"ranking-users\"><div href=\"javascript:void(0)\" ng-click=\"showRankingUsers()\" class=\"row text-green text-heading no-margin\"><div class=\"col-10 no-padding\"><left>{{ :: '_CLUB_PAGE.RANKING_USERS' | translate }}</left></div><div class=\"col-2 no-padding\"><a ng-class=\"{active:isShowRankingUsers}\" class=\"btn-show-detail no-margin\"><img src=\"" + __webpack_require__(655) + "\"/></a></div></div><div ng-if=\"isShowRankingUsers\" ng-show=\"rankingUsers.users\" class=\"margin-20\"><div class=\"row\"><div class=\"col-12\"><div class=\"ranking-notice\">{{ :: '_CLUB_PAGE.RANKING_NOTICE' | translate }}</div></div></div><div class=\"row no-margin\"><div class=\"col-2 no-padding rank-column head-column\">{{ :: '_CLUB_PAGE.RANK' | translate }}</div><div class=\"col-8 user-info-column head-column\">{{ :: '_CLUB_PAGE.NAME' | translate }}</div><div class=\"col-2 no-padding avg-score-column head-column\">{{ :: '_CLUB_PAGE.SCORE' | translate }}</div></div><div ng-repeat=\"user in rankingUsers.users\" ng-class=\"{'odd-row':($index % 2 == 1)}\" ng-if=\"$index &lt; 5\" class=\"row no-margin ranking-user-item\"><div class=\"col-2 no-padding rank-column text-center\"><div ng-if=\"user.rank == 1\"><img src=\"" + __webpack_require__(656) + "\" class=\"ranking-icon\"/></div><div ng-if=\"user.rank == 2\"><img src=\"" + __webpack_require__(657) + "\" class=\"ranking-icon\"/></div><div ng-if=\"user.rank == 3\"><img src=\"" + __webpack_require__(658) + "\" class=\"ranking-icon\"/></div><div ng-if=\"user.rank &gt; 3\">{{user.rank}}</div></div><div ng-click=\"goToProfilePage(user.id)\" class=\"col-8 user-info-column\"><div class=\"row no-margin\"><div class=\"col-3 col-lg-2 no-padding\"><div ng-if=\"user.avatar_image_path\" class=\"imgContainer\"><div class=\"avatarContainer avatar-for-{{user.id}}\"><img ng-src=\"{{user.avatar_image_path}}\" class=\"rounded-circle avatar-image is-full\"/><span ng-if=\"isAvatarColorRecent(user)\" class=\"avatar-image-text\">{{ getTextOfAvatarRecent(user) }}</span></div></div></div><div class=\"col-9 col-lg-10 username ellipsis\">{{displayUserName(user)}}</div></div></div><div class=\"col-2 text-center avg-score-column avg-score no-padding\">{{user.best_score | number:0}}</div></div><button ng-click=\"seeMoreRanking()\" ng-if=\"!isShowSeeMore &amp;&amp; rankingUsers.users.length &gt;= 5\" class=\"btn btn-see-more\">{{:: 'SHOW_MORE' | translate }}</button><div ng-if=\"isShowSeeMore\"><div ng-repeat=\"user in rankingUsers.users\" ng-class=\"{'odd-row':($index % 2 == 1)}\" ng-if=\"$index &gt;= 5\" class=\"row no-margin ranking-user-item\"><div class=\"col-2 rank-column text-center no-padding\"><div ng-if=\"user.rank == 1\"><img src=\"" + __webpack_require__(656) + "\" class=\"ranking-icon\"/></div><div ng-if=\"user.rank == 2\"><img src=\"" + __webpack_require__(657) + "\" class=\"ranking-icon\"/></div><div ng-if=\"user.rank == 3\"><img src=\"" + __webpack_require__(658) + "\" class=\"ranking-icon\"/></div><div ng-if=\"user.rank &gt; 3\">{{user.rank}}</div></div><div ng-click=\"goToProfilePage(user.id)\" class=\"col-8 user-info-column\"><div class=\"row no-margin\"><div class=\"col-3 col-lg-2 no-padding\"><div ng-if=\"user.avatar_image_path\" class=\"imgContainer\"><div class=\"avatarContainer avatar-for-{{user.id}}\"><img ng-src=\"{{user.avatar_image_path}}\" class=\"rounded-circle avatar-image is-full\"/><span ng-if=\"isAvatarColorRecent(user)\" class=\"avatar-image-text\">{{ getTextOfAvatarRecent(user) }}</span></div></div></div><div class=\"col-9 col-lg-10 username ellipsis\">{{displayUserName(user)}}</div></div></div><div class=\"col-2 text-center avg-score-column avg-score no-padding\">{{user.best_score | number:0}}</div></div></div></div></div><div class=\"border-green-xs margin-20\"></div><div class=\"recent-played-users\"><div href=\"javascript:void(0)\" ng-click=\"showRecentUsers()\" class=\"row text-green text-heading no-margin\"><div class=\"col-10 no-padding\"><left>{{ :: '_CLUB_PAGE.RECENT_PLAYED_USERS' | translate }}</left></div><div class=\"col-2 no-padding\"><a ng-class=\"{active:isShowRecentUsers}\" class=\"btn-show-detail no-margin\"><img src=\"" + __webpack_require__(655) + "\"/></a></div></div><div ng-if=\"isShowRecentUsers\" class=\"row margin-20\"><row><div class=\"col-12 no-padding\"><div class=\"ranking-notice\">{{ :: '_CLUB_PAGE.RANKING_NOTICE' | translate }}</div></div></row><div class=\"row no-margin\"><div ng-repeat=\"score_card in recentPlayedUsers.score_cards\" class=\"col-6 recent-user-wrap\"><div ng-click=\"goToProfilePage(score_card.user.id)\" class=\"recent-user-item\"><div class=\"row no-margin user-info\"><div class=\"col-3 col-sm-3 no-padding\"><div ng-if=\"score_card.user.avatar_image_path\" class=\"imgContainer\"><div class=\"avatarContainer avatar-for-{{score_card.user.id}}\"><img ng-src=\"{{score_card.user.avatar_image_path}}\" class=\"rounded-circle avatar-image is-full\"/><span ng-if=\"isAvatarColorRecent(score_card.user)\" class=\"avatar-image-text\">{{ getTextOfAvatarRecent(score_card.user) }}</span></div></div></div><div class=\"col-9 col-sm-9 no-padding\"><div class=\"username\">{{displayUserName(score_card.user)}}</div></div></div><div class=\"row no-margin\"><div class=\"col-12 text-right score-column\"><span class=\"score\">{{ :: '_CLUB_PAGE.SCORE' | translate }}</span><span class=\"score-number\">{{score_card.total_shot_all_holes}}</span></div></div></div></div></div></div></div><div class=\"border-green-xs margin-20\"></div><div ng-if=\"ratingUrlPC\" class=\"see-reviews\"><a href=\"{{ ratingUrlPC }}\" target=\"_blank\"><div class=\"row text-heading no-margin\"><div class=\"col-10 no-padding\"><left class=\"text-green\">{{ :: '_CLUB_PAGE.SEE_REVIEWS' | translate }}</left></div><div class=\"col-2 no-padding\"><div class=\"btn-show-detail rotate-90 no-margin\"><img src=\"" + __webpack_require__(655) + "\"/></div></div></div></a></div><div ng-if=\"ratingUrlPC\" class=\"border-green-xs margin-20\"></div></div></div></div></div></div><script>$(document.body).css('min-width', 0)</script><div id=\"fb-root\"><script>(function(d, s, id) {\nvar js, fjs = d.getElementsByTagName(s)[0];\nif (d.getElementById(id)) return;\njs = d.createElement(s); js.id = id;\njs.src = \"//connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v2.4\";\nfjs.parentNode.insertBefore(js, fjs);\n}(document, 'script', 'facebook-jssdk'));</script></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/club/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 649 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAABSlBMVEVVVVX///9VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVXG5lSZAAAAbXRSTlMAAAIFBggJCgsMDQ4REhQVGRobISQmKC0vMDM6Ozw+P0ZHS01PUFJTVFVXYGFnaGlqc3R1fYCDhoqLjY+QkZibpKanqK6wtLW2ur7AwsPGyc3Q0dXW2Nzf4eLl5ufq6+zu7/Hz9PX29/j6+/z+E1p8PwAAAtZJREFUSMe1l+l30kAQwBdEBanFo+VQsChtYgsUC9IjVBRprQoKWrDIUbUCAm3+/6+yF0n2Qh+6X5I3M7+3yczszCwAouWL58v13sA0B716OR/32VSu2RJwgUz10nSsy2om8AdopDQxBWtSCs9Bg29N6ToJKlDvwdhUrPG+V4aGGpbZsFLMJXU9mStWhpb0NCRGUyNq0TGiHkvuiRkdqvmVEqG7VF3T3Kzv3HqNand59AVRna0LIw02zohBgUXpnoXrQLJuHDL70v/E0osEUKzEBbZK2dEQ9lAnDJQr0sW+ClmoF0els+Iw9O8cHe34HaIVzDa8M/QAf61zz9UWFLZWHcIw/uZ9igZxDjn/0/0J/9hnZ6QSOK+CBMV5W3D+1xoN5JpTjv18gtEIjicTlTRF00yMcHzDCC2hdzYTNim66ZS7NpC0BNEAOp81NhBLfUz2lxjUhXJyEpiiGWShcUHcxug2YFENyTNTtApf2m4+AfSmaTafAg51o3NUdQEfqkOGMHuWl3nZ1LUGqlc+EEfbRzmT29rW1rN1IRpFSBzkUU3wsBZ7V0g/uitAPahu5EEZPircnlckNE0B6qpATRnU4aPIGjyhUe2L0CLU1EEPPrLSXbsiNAc1PTCAjyTnjeeEfSNCk1AzAMhA5z3pj32AmmMRqiNIigJwPA+VfLASJR8sdpMaJW4SB0eNkuCIU0KNkpSQJKIKpYkoS38FGiPpLz90UpQeOvlRl6Gzoy4tMFJUnxUYSVmTo1ZZExfTm6+aqCR+fZm+Ji2m4hLesgaI1/ISThrHod3ggX1yuSdtHKJ29ciO3pe3K1GT/G6R7+3NmWmStDV3ba35zsdvP36OR18q7/Zuca351PvXA0GYHwgWGUMWGX4WGbnmDHqaatCzj5dt46F9vIwabfV4yQ21WTjUZh1DbSP070fpRQZ45bUh8j8vK/iK9Hh6RTqf+md4Lr8i/Qa8dtzIOsRw5wAAAABJRU5ErkJggg=="

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAVCAMAAAD7JKfbAAAAbFBMVEXGxsb////GxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsaLPAyQAAAAI3RSTlMAAAEDBgoPFRwkKissN0NQXm16fY2cqrfDzc7Q2OHp8Pb6/e7yqB8AAADRSURBVCjPddLbFoIgEIXhbSc1O1jagays/vd/xy5YKIPFHbM+WDCzte5wG/1bG0e3lgOe5R9SPgEnAB7FT1I8AFAHwD3/QfI7AJ2qHoDbakJWNwD6Stq+ALguE7K8AvDaZpJ2bwAuC0MWFwDeuyyTpP0HgPM8IvMzAJ995o1qADjNBjI7+VKtYHTwlXYwrS8cNBo1vtZMt6OJDibXRmZ8QPK8yIwfSb4Zm6EhR9suY0JjsW23JgzIji8xYdAmBqkJgYnjNDE+eCaWU6PK4SpZ8wUN6yG6SuhWOgAAAABJRU5ErkJggg=="

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAABfVBMVEUAAAD///8iFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxQiFxTgeEI1AAAAfnRSTlMAAAECAwUGBwoLDA4PExUWFxobHCAhIiQqLC0xNTg6Oz5AQUJGR0hLVFdYW1xdXl9gYmRlZmlqa3R1d3t8fX+AgYKFh4iJi4yNkJGbnqGjpqeoqa2xsrO1t7u9vr/Cw8XMzc7P0NLW2Nna3N7i5OXn6Orr7e7v8/T3+fr8/f7pr2x7AAACjklEQVRIx52XaUPTQBCGR8XaVLGiqBhQ8Sre9aQqYlVqxTtFW0WlYoqCBxIPDAbd325Ok919N02db5uZJ8nuzryzS4SsUKoapmUzZlumUS0VKKP1V9oO48xpj/dnAIcbAhfSjeEu4FCTKa05lAJqNYelmFPTVKS+yLrYoo7J8hrramtlRE6wTDYhk3WW0er/+U3w3TIMenYVPubmq+MVOqCtwrVKrLOGd2We6C7eo3h/a3hSZ4gGf0NP7V/24Ryycq7vKc6rKCdb+KM3PN8o9rXCWsHeX0Xf28HeoI4a2PkoePE57G34le2kvZe2fMWz9Wq/gsm5aBFvYn/FdbXxWw9F6PYvMKDtKpj4v9/ezz6pX9kXJ0xxfOrhi7cr68K7C1SKR58ujY3szKmEYGNRP3p6No4uUTUe/NC7ad62+Ti6SkYyf/amk/nXiWCDzOQEllPZ/KtkrEkWy8ryJLPI5hdueY+KzL3kI20S9+vjLgUpibuEKliZZOIPK1hA2sIy+fZB7g+PgRLwmxPaKZEcAEEmlxKRnRDRHSDISCZiZH+K0g+/k6OqyfRPiKhoQFRLctExdktGj8gFXUClfjCM33T8wtZoc36CUpcFZrUvCN89x9jnwyHbRAIjydpMUNkXg2S5n/eHl5GsSWJ63t/J59Fwab83HkRiKkn4gPvs5Pd4vH57s/tkCUot3zgW3DnM8HELrvLcQ41DaFd3aGxFaiLX+o7BdsU3ybMPkOy+GZGb5AbXtK4HJrE1e5SPqg4EqsOTTjGqOIYorExJlCazk9eJR2k6KzlNIpr1u5Mkoz0dLwW0l0OtiPZwlJZQNydbarKVOMADNOu1AaL4slIRLisKNLwidYIrUgdekTzqL0gvGMTJw8h+AAAAAElFTkSuQmCC"

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAABXCAMAAABSg7e/AAAB11BMVEVdXV3////Q0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NBNMHKUAAAAnHRSTlMAAAECAwQFBgcICQwNDg8QERITFBUWFxgZGx4gIiQmJykqKywtLjAxMjM1OD1AQkRFR0lKS05PUFJTV1tcYGJkZWdoaWttbnBydXd4eYCCh4iJi46QkpOVl5iZm52eoKWoqa6wsrS1t7i5uru8vsDCyM3Oz9DS09TV1tfZ2tze3+Di4+Tn6Onq6+zt7u/w8fLz9PX29/j5+vv8/f4BjVihAAACS0lEQVRIx3XW61tMURQG8L2bTqeEUbkkMxGNGZeQ5J6I5N7FLdeIFJEYtxBiyMhgZJyZOn+sp5n97qce7zof5sv7e9bMmr3PXlvp/NP8ZCbdt1otfPJJ4fOAP/d8rJSAO5kHfq8ENhRy31sjgIgB/k0BFH8yIFcr/Mh2lLglAHfCgNl6DnQrStwRgDMOsZkDfRBgSACBMYitHOi9ACMCKIpD7OBANwGMCkCPQuwWQANAvIgDPQKxXwBbAMYCHKhBiBYBRAHGSzhQ/RBtAqibNWCijAPVhxIdAgjnDEiUc6Cuo8RpAdR4BiSDHKhLKHFWANV/DEhVcaB6UKJLAFVpA35Xc6DOocQFAQRTBmRqOFBnUOKKAMqTBmTDHKgOexwIYFEC73IdB6oNJW4LwP0AEeVAtdgSAnDeGpCWwGscfAI4jq94zEHFFMBODi4jH+RtrsfWza3j4D4KXOR/9S7kUxUUlLwBaOfLbdfylUNB5XeARr7lbIv3+K6uR4vZtRwM2z3N36xm5N+WUeBimf1j/O0+gfylQ8Hy1PwDm4Be5Hf5IWZb9Go5eIQC5/lBugf51yAFrh1sR/lhfhL5C4eCFT8AtvOBcvW/2boQRGbQYpgD22IPH4t2bE4upaD0HcARPppPIX9eTMHKnwDb+PXgGrs+zAMbMYn+hjiwE7Wb34L2If+yhIKy9wCH+U3MHs3PAhSs+gXQwG+DN5D3KwpiaDET4mAABTo1BxmTf14sgKwBh7QAHhbypwEJbJqey6djWgI6Oux5D6JaAv8AZuPdLXu2I1EAAAAASUVORK5CYII="

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAA9CAMAAABvCjJxAAABOFBMVEX////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////iDWJFAAAAZ3RSTlMAAQIDBAUGCgwPExcYHCIjJCUrLDA0NTk8PUJDRUdJS01PUVJVWFtfYGRoa21wcnN0dnd4eXt8fn+Ag4SFhoeJiouMjY6PkJGSk5SVlpmdnqKlpqusrrCytLa4uru+xMnf5+3y+Pv+2rDhAgAAAStJREFUGBltweVaVAEYBOBZAVlKOqS7QUBZpRulO5WQmvu/Ax73zPnxzfq+yPv+lw/D+I99/pNDgXYmKuA2mFiDG6c0wGQpB3A/KJ0wxZQruAnKENw9JQMzSPkCd075CNNGmYfbpVTB1FE24VYoTTDllCO4HKUbpohyAzdGGYG7o2Rg+ikzcKeUUpjPlCW4n5RqmFrKFtwypRkmSzmG+8bEC9wBE08wI5QFREVMVSBapkwhaqZcwBxT2hGNUdYRZZkqQ7RKGUfUSjmBOaO0IJqkrCAqZ6oE0SZlFFEX5RDmmtKI6CtlEVEVUx8QbVOGEfVR9mD+UOoR5ShziGqZyiDaoQwgGqT8QpRh6hOiacoszCMTv+HemOiFu2XeNgr0MK8ShTouX583alDgHb6x06FuGbEOAAAAAElFTkSuQmCC"

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAcCAMAAAAURxzFAAAApVBMVEUPvKb///8PvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKYPvKZsvLX+AAAANnRSTlMAAAEDBgoPExUcJC01Nz1CR05PUVtdaXd4eoSHiJKXnqWqsbK0vsnQ09fY3N7k6/H09vr7/f5EarBdAAABMUlEQVQ4y5XS6bKCMAwF4KMggoqK4r4rbriD9v0f7UIKA0ipXP7QJOebCQtM13fqKHnVHd81cWaMHbRyQjsE4TN8VtqQYD624Y3ta79FbU/RLbRjSROJY7CQfqKjo8qF6lDspFeCQnep2EmNuqOQq1dCAuNC5UYpFsqGIhcDnMC4UmNdaJQ1Ba4GYoLGjVqrqlhUVzS+NZCQ2CyFprpMRELQvFN7ISILGt2byJLYzPNinhZpgtaDRtNvMaX2o4U8gcnNOCvGXJgQEbRfNB6leyNqvdoQE3S4GSadIRcdFBF0vazhwuuimMAi87F5ZX9IWJAR9N9h6k3G5uc+5CTO9YBeSksJBnx/i+/IBvhN4mf2vt+ehERGLApI9MXzf4KExEYgCglmoZjhPwST53MCMfkD92tEhDxBWyIAAAAASUVORK5CYII="

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAABECAMAAADdnWnYAAACK1BMVEW7u7r///+7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7q7u7rAwL/FxcTKysnOzs7T09PY2Nfc3Nzh4eDl5eXq6unu7u7y8vL39/f7+/v///8EzyDmAAAAqXRSTlMAAAECAwQGBwkKCwwODxARFBUWFxgZGhscHR4gISIkJykqKywuLzAxMjc4OTo7PD5AQUJDRUdJTk9QUlNZXF1eX2BjZGVoaWprbnBxc3R1eHl8fX+AgYKDhIaHiIqMjo+QkZOUl5iZmp+goqSmp6ipq62vsLK1t7i6u7/AxMXGx8nLzM7Q0tPW19jb3eDh4uTl5ufo6err7O3u7/Dx8vT19vf4+fr7/P3+zHpbrAAAA/dJREFUWMPtmOtfDFEYxydboptFSaRslDZURKjIYkNuoVIUuWxUot1yXV1sg+TaukQrpJU93Utb++eZnZ2dncu5zH52fLzxe9PMPL/n25yz5zlzzqEo5ap3XSebwvwKAlwIACj8G+Q4O0O2x/0Fcj3wql59cg7wKUdtcuRzjvw8UmVyBfCrUl2ybpgnO9PUJGvaQUAdGhXJJUCoI+qREwdF5MFEIllfq6eoGDLZAsSyEMhrmgEYoMzAmksAFwCpCnDk6HND3oZRXuO9LBw4tk9G7otF/9iGPq5dNPu3bROafA3IZUKWqo1zGKnz3JVZh/BudUHIIBvqTW7hDev4+QC4mlOgZf0MBgY9kCKPufCDj/eGUREO/m6kYa3cfhbAVSHr4EPvBeErzHhuEdw7TUkS//phBHlY0nvbaVF4F0M2iJ4M1SUI/YseAZTahUWe0ioOOqMZcrwk4/sFbSDDCNAqCXxuap2S2EO2urulKV8r/N+khC8Ysr/II0o+ymJlLLlKnuQ4Hc0mmQFOviLf+RQSymTJ2bCs/pNLKGo3wIsp8tQ7sMAHDUsOH4Cm2Uu1bwjkt2sv/4QGmrhZ9DYi8QcgyYV4XsyRDUBtxXPkeCXmydl5D6O56TGyl+a/Kd1E7ziL9WlmlOSu4clVJOuURyg3Cb2dJ2eTesLjCQb9LZInI8adX6MLErJnFuu/I/h238Y6pz0yYX/GowJyMZbMvbJ7PPBPZnD+VAF5hQs3LjjahOD95zD+V6KVjE3BwGBvJnzXCxj/dRG5UkE3C8kejL9QRN6McY5N+CRswDza/itORA7/pHBGmPORf6Md7ZIVY7MysL8zptCWsxJysTKym9gZIEtCxo47XjPcK0+iLZ/Dpetnm5KZVEGdtMhW5pVk8PiCglnjgIy8mQgenVcyHSXJyMRxN+pWAn4G2afcVAaextsuQch7FY23KULL8iFkLXbczXIz0RynccRCYils19ZFBgc0Afc9gO4Hy4MAo8gnoGR9EGAUeSOUrOlXDkaQ+xC74yblYAS5AUHeG/J6rghBXuYIEexYhjorSD5cc+thz6fgkUOvH9+9UW1MRp5CaLdt8O4iFidm5hUePF5+0dTYet/aQT95ycjB6T1z3UN3WR+0Nl6tLjuyb09uZkoUm5yetxxFjnrn3Vq96LSYzh3bvzsnI2VVLG6nH7N6vX5HgaH0TN3N+7Tdu/h/F4Ugp0Pa+Z15yRc0TXdY/bLRdM/LN45BWK+kI8gZIY+NjP/kf0rWhUzWIcgaiyskrsuiQZ4ERqxM25JfZDxVVWdqMLdZO+lepuIGvKU3Eji58d4OMM976U5rm7nBVFd1yliUvyVtZYTojPEPFyLIHf5xjoQAAAAASUVORK5CYII="

/***/ }),
/* 658 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAABECAMAAADdnWnYAAACK1BMVEW/j1D///+/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1C/j1DEmGHIoXDNqX7RsYzWuZjawaTeyLDjz7vn18Xr3tDv5drz6+P38u37+fb///8NUtEZAAAAqXRSTlMAAAECAwQGBwkKCwwODxARFBUWFxgZGhscHR4gISIkJykqKywuLzAxMjc4OTo7PD5AQUJDRUdJTk9QUlNZXF1eX2BjZGVoaWprbnBxc3R1eHl8fX+AgYKDhIaHiIqMjo+QkZOUl5iZmp+goqSmp6ipq62vsLK1t7i6u7/AxMXGx8nLzM7Q0tPW19jb3eDh4uTl5ufo6err7O3u7/Dx8vT19vf4+fr7/P3+zHpbrAAABA9JREFUWMPtmPlfDGEcx4ct0U2RlC5KhUoRKhI25AgdcufYUqR2C7E61NDh7KC0ogv7dO3atm3/PDPbzDTHc8y+dnv5xeeX3Znn87xfM9/5fp+LotSrylxNNq3h5QY4FwCQuxrk4H6G3B+8CuQqwKrK++R0sKx0b5P9ejhyj5+XyWWAV7l3yfGTAnkqwZtkTQtYUavGi+RCINZp75EjRiXk0QgiOeVmCkUFkskGIJWBQN5WB8AIpQfGDAI4B8iVgyMHXBlnX4xijc9SceCgPgW5Lwj9sQv6uPeiXb9Nu9Dk+0ApHbJUOziHlrrG/dPHI7x7zRAySIN6oxsEw3ZhPADmuhhoWXfBwKAbUuSB1yeE9t41lK9JuPpVE6W0lwC4yhQBPjkoar7L5HOD6HpKFynzx00iyJOy6GXSkuaDDLlAcme8crPYv/YlQKlFXOQxjdLGqQCGHC7rMXY9dKWHFqBVuDLd3JyStb1wVXenvMv3Mn5O2vwNQ+aL3Lfwi6LtootcoexkuhTg6qQHOC0X+YE3kKZkFzkN1mvownqKOgTwYoo89gms4bPGRfYZgXbrLwr9SCB/irrzE9rwkBtF6xEdJ8QXczaHk5Hjz4zophnRM58jFwCiphecgv6Q7eEcOZwMXnSKZCPZaWFO6SRZJWCn00qw3xDIFQSnVQp2Lk3j/ZkCOY1AdnBRsPLRnsfaf/gJZETeCWmxjLMwfy1qwvFENHfXqwjGoujx8eQzInI+1jlvZWURfUs8OVZE3mQG6jSjIs7vJSuZDnXg+eVgOLCmagm5XA2XT76lWawtV0Le7Q55Duv6HSwh+wy788zYD9giWzHWuUHGjxwlMnK+msQA05YlYkBSZWS1ecfV4wLS8NVHvn5WmXf8sIdsb1CszNF5Z5ew7ATycQV5N4k8Kxn3kO5IBRmddzZxaLk4I8ldkH3KI2RJczD7/PQsnxvIL3gbQj5CGvjFsqC82RByqJmQaSLZUdaJDbBdW7v6eXAG5XwO3Q+Wqp1iF5FgcB5KTsHUx6xN4DosGN9OKFkzhF3MWKx2u91mxY7NfYjd8UPgqWoQ5CMek/MQ5BCTh2BTCOqsIPrUjccvuofdR45/ePX0wVVtNPIUInTfDnYXsS4iOSv3xLnSW7raxmZjK/36HSMTp0HmfzfdbnzeWHvv6sXTRw9nJMf4uzonZm1Ekf0H2K3V2zaD7srZY4fSk2K2BOF2+oFb41L25xQUXa581Ez3s4v/AX8EORHynmPMQ76labrVyKuDprvffTSNwqKSiCAneZwbSf/J/5Qc7zE5HkHWGMwecc0GDfIk0DcsYU92nra4olJXo28yttG9TMWNsKX3a+Xkhr0cYe730m3GJn2NrrKiWJuXvSchzFdyxvgXYO/HfCBny/gAAAAASUVORK5CYII="

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(660);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_club.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_club.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#club-page{background-color:#fff}#club-page .chart-heading{color:#30b9ba;font-size:1.3em;margin:10px 0}#club-page #top-page{padding-left:15px;padding-right:15px}#club-page #top-page #map-canvas{height:150px;width:100%}#club-page #top-page #club-name{color:#fff;height:100px;padding-top:400px}#club-page #top-page #sns-area{width:100%;padding:20px 20px 0 0;text-align:right}#club-page #top-page #sns-area li{display:inline-block;margin:0 0 0 3px;vertical-align:top}#club-page #top-page #score-card table{border-radius:4px;margin:0;background-color:#fff}#club-page #top-page #score-card th,#club-page #top-page #score-card td{margin:0;padding:2px 0;text-align:center}#club-page #top-page #score-card th{width:50px}#club-page #top-page #score-card th.hole,#club-page #top-page #score-card td.hole{background-color:#ddd}#club-page #top-page #score-card .table-bordered>thead>tr>th,#club-page #top-page #score-card .table-bordered>tbody>tr>th,#club-page #top-page #score-card .table-bordered>tfoot>tr>th,#club-page #top-page #score-card .table-bordered>thead>tr>td,#club-page #top-page #score-card .table-bordered>tbody>tr>td,#club-page #top-page #score-card .table-bordered>tfoot>tr>td{border:1px solid #ddd;border-right-width:0;border-left-width:0}#club-page #top-page #hole-by-hole .select-buttons{margin-bottom:10px}#club-page #top-page #hole-by-hole .select-buttons a{box-shadow:none;color:#00adad;background-color:#fff;border-radius:0;font-size:10px;padding:10px 0;border:2px solid #00adad}#club-page #top-page #hole-by-hole .select-buttons a.active{color:#fff;background-color:#0fbca6}#club-page #top-page #hole-by-hole .select-buttons a:first-child{border-right:none}#club-page #top-page #hole-by-hole .select-buttons a:last-child{border-left:none}#club-page #top-page #hole-by-hole table.users-avg th{width:33%}#club-page #top-page #hole-by-hole table.users-avg td{text-align:right}#club-page #top-page .empty p{color:#888;font-size:14px}#club-page #top-page .chart .col-6{padding:0}#club-page #top-page .chart table.borderless th,#club-page #top-page .chart table.borderless td,#club-page #top-page .chart table.borderless tbody{border:none}#club-page #top-page .chart table th,#club-page #top-page .chart table td{vertical-align:middle}#club-page #top-page .chart table th{padding:5px;font-size:10px;text-align:center;background-color:#e6e6e6}#club-page #top-page .chart table td{padding:0;height:26px}#club-page #top-page .chart table td.hole-num{font-weight:700;text-align:center;width:35px}#club-page #top-page .chart table td.par{color:#888;text-align:center;width:30px}#club-page #top-page .chart table td.raw-value{text-align:center;padding-left:3px;padding-right:3px;width:60px}#club-page #top-page .chart table td.score-minus{padding-left:3px;width:10%}#club-page #top-page .chart table td.stroke,#club-page #top-page .chart table td.putt{width:20%}#club-page #top-page .chart table td.gir{color:#00a3d8}#club-page #top-page .chart table td.gir1{color:#005b00}#club-page #top-page .chart table td.raw-value.recovery{color:#ff454d}#club-page #top-page .chart table th.left-border,#club-page #top-page .chart table td.left-border{border-left:2px solid #bbb}#club-page #top-page .chart table td.left-border-light{border-left:1px solid #ddd}#club-page #top-page .chart table tbody.hole-data{border-bottom:2px solid #bbb}#club-page #top-page .chart table tbody.hole-data .difficult-hall-color{border-bottom:1px solid #fff}#club-page #top-page .chart table tbody.hole-data .difficult-hall-color .col-1-chart{background-color:#c9f3cb}#club-page #top-page .chart table tbody.hole-data .difficult-hall-color.raw-value{color:#fff}#club-page #top-page .chart table tbody.hole-data .chance-hall-color{border-bottom:1px solid #fff}#club-page #top-page .chart table tbody.hole-data .chance-hall-color .col-1-chart{background-color:#ffc7e7}#club-page #top-page .chart table tbody.hole-data .chance-hall-color.raw-value{color:#fff}#club-page #top-page .chart table tbody.hole-data .three-putts-color{border-bottom:1px solid #fff}#club-page #top-page .chart table tbody.hole-data .three-putts-color .col-1-chart{background-color:#c6ecfd}#club-page #top-page .chart table tbody.hole-data .three-putts-color.raw-value{color:#fff}#club-page #top-page .chart table tbody.hole-data .one-putt-color{border-bottom:1px solid #fff}#club-page #top-page .chart table tbody.hole-data .one-putt-color .col-1-chart{background-color:#ffebc8}#club-page #top-page .chart table tbody.hole-data .one-putt-color.raw-value{color:#fff}#club-page #top-page .chart table tbody.out-in td{font-weight:700}#club-page #top-page .chart table tbody.out-in td.label-out-in{text-align:center}#club-page #top-page .chart table tbody.out-in td.zero{position:relative;text-align:right;right:-4px}#club-page #top-page .chart .bar-wrapper{height:15px;float:left;width:100%;display:-ms-flexbox;display:flex}#club-page #top-page .chart .bar-wrapper .bar{height:15px;display:inline-block}#club-page #top-page .chart .bar-wrapper .col-1-chart{background-color:#00a3d8}#club-page #top-page .chart .bar-wrapper .col-2{background-color:#00bfe3}#club-page #top-page .chart .bar-wrapper .col-3{background-color:#88dcf0}#club-page #top-page .chart .bar-wrapper.minus{text-align:right}#club-page #top-page .chart .bar-wrapper.minus .col-1-chart{background-color:#ff6400}#club-page #top-page .chart .bar-wrapper.minus .col-2{background-color:#ffcda1}#club-page #top-page .chart .bar-wrapper.putt .col-1-chart{background-color:#00b3af}#club-page #top-page .chart .bar-wrapper.putt .col-2{background-color:#00cbc7}#club-page #top-page .chart .bar-wrapper.putt .col-3{background-color:#82e2df}#club-page #top-page .chart .bar-wrapper.par_bogey{background-color:#999}#club-page #top-page .chart .bar-wrapper.par_bogey .col-1-chart{background-color:#00a3d8}#club-page #top-page .chart .bar-wrapper.par_bogey .col-2{background-color:#005b00}#club-page #top-page .chart .bar-wrapper.recovery{background-color:#999}#club-page #top-page .chart .bar-wrapper.recovery .col-1-chart{background-color:#ff454d}#club-page #top-page #summary{margin-top:20px}#club-page #top-page #summary .see-more-rakuten{background-color:#0fbca6;padding:6px 5px 10px;border-radius:30px;margin:20px auto;display:block;width:76%;color:#fff}#club-page #top-page #summary .see-more-rakuten span{color:#fff;font-size:1.2em;margin:0 5%}#club-page #top-page #summary .see-more-rakuten img{width:8px;margin-top:5px;margin-right:10px;float:right}#club-page #top-page #summary .see-more-rakuten:hover{text-decoration:none}#club-page #top-page #summary .btn-rakuten{position:relative;width:30px;height:30px;font-size:12px;border:0;background-repeat:no-repeat;background-image:url("+__webpack_require__(661)+");background-size:30px;display:inline-block;margin-bottom:-10px}#club-page #top-page #summary .info-heading{font-size:1.4em}#club-page #top-page #summary .info-heading img{width:25px;margin-right:5px;margin-top:-5px}#club-page #top-page #summary .address-label{background:#c00;padding:3px;color:#fff;font-weight:700;font-size:10px;width:46px;display:inline-block;text-align:center}#club-page #top-page #summary .address-value{-ms-word-break:break-all;word-break:break-word;-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto;font-size:14px}#club-page #top-page #summary .address{padding-top:5px}#club-page .square-description{padding:5px 0}#club-page .square{width:100%;height:20px;margin-bottom:5px}#club-page .chance-hall-color{background-color:#f8007c}#club-page .chance-hall-color.gray{background-color:#c6c6c6}#club-page .one-putt-color{background-color:#ff9700}#club-page .one-putt-color.gray{background-color:#c6c6c6}#club-page .difficult-hall-color{background-color:#00b600}#club-page .difficult-hall-color.gray{background-color:#c6c6c6}#club-page .three-putts-color{background-color:#009cf1}#club-page .three-putts-color.gray{background-color:#c6c6c6}#club-page .color-desc{text-indent:5px}#club-page .text-gray{color:#c6c6c6}#club-page .text-green{color:#30b9ba}#club-page .text-heading{font-size:18px;font-weight:700}#club-page .hall-advice{margin-bottom:5px}#club-page .border-green{border-bottom:3px solid #30b9ba}#club-page .border-green-xs{border-bottom:1px solid #30b9ba}#club-page .border-gray{margin:10px 0;border-bottom:1px solid #eee}#club-page .select-courses-line{border-bottom:1px solid #30b9ba;margin-top:20px}#club-page .btn-show-detail{width:14px;margin-bottom:20px;float:right;display:block}#club-page .btn-show-detail.active{transform:rotate(180deg)}#club-page .btn-show-detail.rotate-90{transform:rotate(-90deg)}#club-page .btn-show-detail.no-margin{margin-bottom:unset}#club-page .btn-show-detail img{width:15px;height:10px}#club-page .courses-list-wrap{position:absolute;z-index:1000;width:100%;padding:0 15px}#club-page .course-item{padding:5px 10px;width:100%;font-size:15px;background-color:#fff;border:1px solid #82e0d6;border-top:none}#club-page .course-item.selected-course{color:#fff;background-color:#0fbca6}#club-page .course-item:not(.selected-course):hover{background-color:#b2e0db}#club-page .recommend-plan{border:2px solid #82e0d6;margin:5px 0;padding:5px;font-size:1em}#club-page .recommend-plan a{color:#000}#club-page .recommend-plan a:hover{text-decoration:none}#club-page .recommend-plan .recommend-plan-title{width:95%;font-weight:700;margin-bottom:10px}#club-page .recommend-plan .stock-count{background-color:#ff5858;padding:5px 10px;border-radius:20px;text-align:center;color:#fff}#club-page .recommend-plan .price{font-size:1.8em;color:red;margin-right:5px;font-weight:700}#club-page .recommend-plan .price-desc{font-weight:700;font-size:1.2em}#club-page .recommend-plan .next-wrap{text-indent:5px}#club-page .recommend-plan img{width:12px;margin-top:-15px}#club-page .lamp-icon{width:20px;margin-top:-5px;margin-right:5px}#club-page .map-icon{width:50px;margin-left:20px}#club-page .see-reviews{margin:20px 0}#club-page .col-6.recent-user-wrap{padding:5px 2px}#club-page .recent-user-item{border:1px solid #eee;padding:5px;min-height:105px}#club-page .recent-user-item .user-info{min-height:50px}#club-page .recent-user-item .avatarContainer .avatar-image-text{top:50%}#club-page .recent-user-item .score{font-size:16px;margin-right:5px}#club-page .recent-user-item .score-number{font-size:24px}#club-page .recent-played-users .user-info{margin-bottom:10px}#club-page .recent-played-users .username{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;padding-left:10px;font-size:16px;word-break:break-word}#club-page .ranking-notice{font-size:14px;margin-bottom:5px;color:lightgray}#club-page .username{padding:0 0 0 15px}#club-page .address-url{display:inline-block;width:97%}#club-page .ranking-users{font-size:1.4em}#club-page .ranking-users .ranking-user-item:last-of-type{border-bottom:1px solid #aceae9}#club-page .ranking-users .head-column{border:1px solid #aceae9;border-bottom:2px solid #0fbca6;color:#0fbca6;text-align:center}#club-page .ranking-users .head-column.user-info-column,#club-page .ranking-users .head-column.avg-score-column{border-left:none}#club-page .ranking-users .rank-column{border-left:1px solid #aceae9;border-right:1px solid #aceae9}#club-page .ranking-users .rank-column,#club-page .ranking-users .user-info-column,#club-page .ranking-users .avg-score-column{height:50px;line-height:50px}#club-page .ranking-users .user-info-column,#club-page .ranking-users .avg-score-column{border-right:1px solid #aceae9}#club-page .ranking-users .avg-score{font-size:1.4em}#club-page .ranking-users .ranking-icon{width:43px}#club-page .ranking-users .odd-row{background-color:#d6f5f4}#club-page .ranking-users .avatarContainer .avatar-image-text{top:54%}#club-page .ranking-users .btn-see-more{display:block;margin:50px auto;color:#0fbca6;background-color:#fff;width:250px;height:40px;border-radius:30px;border-color:#0fbca6;border-width:1px;border-style:solid}#club-page .avatarContainer .avatar-image-text.one-character{font-size:18px}#club-page .avatarContainer .avatar-image-text.two-characters{font-size:14px}@media (max-width:1024px){#club-page .recommend-plan .next-wrap{text-indent:0}#club-page #top-page #summary .see-more-rakuten{width:37%}#club-page #top-page #summary .see-more-rakuten span{font-size:1.2em}#club-page .recent-played-users .username,#club-page .recent-played-users .score{font-size:15px}#club-page .recent-user-item{min-height:105px}#club-page .recent-user-item .user-info{min-height:52px}#club-page .ranking-users .ranking-icon{width:40px}#club-page .ranking-users .avatarContainer{width:44px;margin-top:-1px}#club-page .recent-user-item .avatarContainer{width:52px}}@media (max-width:991px){#club-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#club-page #main-main .container,#club-page #main-main .container.dashboard-container{width:100%;min-width:0}#club-page #gnp-header .btn-section,#club-page #gnp-header .user{display:none}#club-page #gnp-footer .copyright{text-align:left;margin-top:0}#club-page .recommend-plan .next-wrap{text-indent:15px}#club-page #top-page #summary .see-more-rakuten{width:50%}#club-page #top-page #summary .see-more-rakuten span{font-size:1.2em}#club-page #top-page #summary .address-value{padding-left:15px}#club-page .recent-user-item .user-info{min-height:37px}#club-page .ranking-users .avatarContainer{width:44px;margin-top:-1px}#club-page .recent-user-item .avatarContainer{width:52px}#club-page .recent-user-item{min-height:110px}#club-page .recent-played-users .username,#club-page .recent-played-users .score{font-size:20px}}@media (max-width:628px){#club-page #top-page #summary .see-more-rakuten{width:68%}}@media (max-width:430px){#club-page #top-page #summary .see-more-rakuten span{margin:0 2%}#club-page .recommend-plan .price{font-size:1.4em}#club-page .recommend-plan .price-desc{font-size:1em}}@media (max-width:414px){#club-page .recommend-plan .next-wrap{text-indent:unset}#club-page #top-page #summary .see-more-rakuten{width:78%}#club-page #top-page #summary .see-more-rakuten span{font-size:1.1em}#club-page .recent-user-item{min-height:96px}#club-page .recent-user-item .avatarContainer{width:42px}#club-page .ranking-users .avatarContainer{width:80%}#club-page .recent-played-users .username,#club-page .recent-played-users .score{font-size:14px}#club-page .ranking-notice,#club-page .avatarContainer .avatar-image-text.two-characters{font-size:13px}}@media (max-width:375px){#club-page #top-page #summary .see-more-rakuten{width:85%}#club-page #top-page #summary .address-value{font-size:13px}#club-page .ranking-users .avatarContainer{width:92%}#club-page .recent-user-item{min-height:94px}#club-page .ranking-notice{font-size:12px}#club-page .recent-played-users .username,#club-page .recent-played-users .score{padding-left:12px}#club-page .avatarContainer .avatar-image-text.two-characters{font-size:12px}}@media (max-width:360px){#club-page #top-page #summary .see-more-rakuten{width:80%}#club-page #top-page #summary .see-more-rakuten span{font-size:1em;margin:0 2%}#club-page #top-page #summary .address-value{font-size:12px}#club-page .ranking-users .avatarContainer{width:95%}#club-page .ranking-users{font-size:14px}}@media (max-width:320px){#club-page #top-page #summary .see-more-rakuten{width:90%}#club-page #top-page #summary .address-value{padding-left:20px}#club-page .color-desc{font-size:11px}#club-page .recent-user-item{min-height:92px}#club-page .recent-played-users .username,#club-page .recent-played-users .score{font-size:12px;padding-left:18px}#club-page .recent-played-users .score-column{padding:0}#club-page .ranking-users .head-column{font-size:14px}#club-page .ranking-users .ranking-icon{width:36px}#club-page .recommend-plan .stock-count{font-size:10px}#club-page .recommend-plan .price,#club-page .recommend-plan .price-desc{font-size:1em}}@media (max-width:300px){#club-page #top-page #summary .see-more-rakuten span{font-size:.8em}}@media (max-width:270px){#club-page #top-page #summary .see-more-rakuten span{font-size:.5em}}@media (max-width:1200px){#club-page .ranking-users .avatarContainer{width:44px;margin-top:-1px}#club-page .recent-user-item .avatarContainer{width:52px}}@media (min-width:1280px){#club-page .ranking-users .ranking-icon{width:40px}}@media (min-width:1366px){#club-page .ranking-users .ranking-icon{width:43px}}@media (min-width:1680px){#club-page .ranking-users .avatarContainer,#club-page .avatarContainer{width:75%}}@media (min-width:1920px){#club-page .ranking-users .avatarContainer,#club-page .avatarContainer{width:68%}#club-page .ranking-users .ranking-icon{width:46px}}", ""]);

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	var ClubService, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	ClubService = function($http, $q, $location) {
	  return {
	    getClub: function(clubId) {
	      var delay;
	      delay = $q.defer();
	      $http.get("/api/clubs/" + clubId + ".json").then(function(resp) {
	        return delay.resolve(resp.data);
	      });
	      return delay.promise;
	    },
	    getCourses: function(clubId) {
	      return $http.get("/api/clubs/" + clubId + "/courses.json");
	    },
	    getYardage: function(courseId) {
	      var delay;
	      delay = $q.defer();
	      $http.get("/api/courses/" + courseId + "/yardage.json").then(function(resp) {
	        return delay.resolve(resp.data);
	      });
	      return delay.promise;
	    },
	    getAnalysis: function(courseId) {
	      var delay;
	      delay = $q.defer();
	      $http.get("/api/courses/" + courseId + "/analysis.json").then(function(resp) {
	        return delay.resolve(resp.data);
	      }, function() {
	        return delay.reject();
	      });
	      return delay.promise;
	    },
	    getRecommendPlans: function(rakuten_id) {
	      var delay, playDate;
	      delay = $q.defer();
	      playDate = moment().add(14, 'days').format("YYYY-MM-DD");
	      $http.jsonp('https://app.rakuten.co.jp/services/api/Gora/GoraPlanSearch/20170623', {
	        params: {
	          format: 'json',
	          applicationId: '1083670463465254180',
	          golfCourseId: rakuten_id,
	          playDate: playDate
	        }
	      }).then(function(resp) {
	        return delay.resolve(resp.data);
	      });
	      return delay.promise;
	    },
	    getRecentUsers: function(clubId, params) {
	      return $http.get("/api/clubs/" + clubId + "/users/played.json", {
	        params: params
	      });
	    },
	    getRankingUsers: function(clubId, params) {
	      if (params == null) {
	        params = {};
	      }
	      return $http.get("/api/clubs/" + clubId + "/ranking_users.json", {
	        params: params
	      });
	    }
	  };
	};
	
	ClubService.$inject = ['$http', '$q', '$location'];
	
	module.exports = ClubService;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var ClubShowCtrl, _;
	
	_ = __webpack_require__(87);
	
	ClubShowCtrl = function($rootScope, $scope, $location, $routeParams, RoundInfoService, $analytics, clubInfo, fromJapan, ClubService, $filter, $translate) {
	  var _setRakutenLink;
	  $scope.showBasicInfo = function() {
	    return $scope.isShowBasicInfo = !$scope.isShowBasicInfo;
	  };
	  $scope.showRecentUsers = function() {
	    return $scope.isShowRecentUsers = !$scope.isShowRecentUsers;
	  };
	  $scope.showRankingUsers = function() {
	    return $scope.isShowRankingUsers = !$scope.isShowRankingUsers;
	  };
	  $scope.seeMoreRanking = function() {
	    return $scope.isShowSeeMore = !$scope.isShowSeeMore;
	  };
	  $scope.showMap = function() {
	    return $scope.isShowMap = !$scope.isShowMap;
	  };
	  $scope.getTextOfAvatarRecent = function(item) {
	    var $avatarElement;
	    $avatarElement = $(".avatar-for-" + item.id + " .avatar-image-text:not(.is-small)");
	    if (item.display_text_avatar.length === 1) {
	      $avatarElement.removeClass('two-characters');
	      $avatarElement.addClass('one-character');
	    } else {
	      $avatarElement.removeClass('one-character');
	      $avatarElement.addClass('two-characters');
	    }
	    return item.display_text_avatar;
	  };
	  $scope.isAvatarColorRecent = function(item) {
	    var ref;
	    return ((ref = item.avatar_image_path) != null ? ref.indexOf('avatar_color') : void 0) > -1;
	  };
	  $scope.displayUserName = function(user) {
	    var firstName, lastName, ref, ref1;
	    if (user.nickname) {
	      return user.nickname;
	    }
	    firstName = (ref = user.first_name) != null ? ref : '';
	    lastName = (ref1 = user.last_name) != null ? ref1 : '';
	    if (firstName + lastName === '') {
	      return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED');
	    }
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      return lastName + " " + firstName;
	    }
	    return firstName + " " + lastName;
	  };
	  $scope.goToProfilePage = function(userId) {
	    return window.location.href = '/profile/' + userId;
	  };
	  _setRakutenLink = function(rakutenId) {
	    if (!rakutenId) {
	      return;
	    }
	    return RoundInfoService.getRakutenLink(rakutenId).then(function(response) {
	      return $scope.rakutenLink = response.data.Item.reserveCalUrl;
	    });
	  };
	  $analytics.eventTrack('GNUserScore_loaded');
	  $scope.clubInfo = clubInfo;
	  $scope.clubInfo.showRakutenId = clubInfo.rakuten_id && fromJapan;
	  $scope.lineLink = encodeURIComponent(clubInfo.name + " - GN+ SCORE\n" + ($location.absUrl()));
	  $rootScope.title = clubInfo.name;
	  $scope.clubHeader = true;
	  $scope.isShowBasicInfo = false;
	  $scope.isShowRecentUsers = true;
	  $scope.isShowRankingUsers = true;
	  $scope.isShowSeeMore = false;
	  $scope.isShowMap = false;
	  $scope.recommentPlans = [];
	  if (clubInfo.rakuten_id) {
	    ClubService.getRecommendPlans(clubInfo.rakuten_id).then(function(data) {
	      return _.forEach(data.Items, function(Item) {
	        $scope.recommentPlans = _.union($scope.recommentPlans, Item.Item.planInfo);
	        $scope.ratingUrlPC = Item.Item.ratingUrlPC;
	        return _setRakutenLink(clubInfo.rakuten_id);
	      });
	    });
	  }
	  return $scope.$on("courseChanged.gnp.club", function(event, course_id) {
	    $scope.recentPlayedUsers = [];
	    $scope.rankingUsers = [];
	    $scope.isShowSeeMore = false;
	    ClubService.getRecentUsers(clubInfo.id, {
	      page_size: 6,
	      course_id: course_id
	    }).then(function(data) {
	      return $scope.recentPlayedUsers = data.data;
	    });
	    return ClubService.getRankingUsers(clubInfo.id, {
	      page_size: 20,
	      course_id: course_id
	    }).then(function(data) {
	      return $scope.rankingUsers = data.data;
	    });
	  });
	};
	
	ClubShowCtrl.$inject = ['$rootScope', '$scope', '$location', '$routeParams', 'RoundInfoService', '$analytics', 'clubInfo', 'fromJapan', 'ClubService', '$filter', '$translate'];
	
	module.exports = ClubShowCtrl;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	var ClubMapCtrl;
	
	__webpack_require__(665);
	
	ClubMapCtrl = (function() {
	  function ClubMapCtrl(scope, GoogleMapLoaderService) {
	    this.GoogleMapLoaderService = GoogleMapLoaderService;
	    this.GoogleMapLoaderService.load().then((function(_this) {
	      return function() {
	        return _this.mapOptions = {
	          center: new google.maps.LatLng(scope.$parent.clubInfo.loc[0], scope.$parent.clubInfo.loc[1]),
	          zoom: 15,
	          mapTypeId: google.maps.MapTypeId.ROADMAP
	        };
	      };
	    })(this));
	  }
	
	  return ClubMapCtrl;
	
	})();
	
	ClubMapCtrl.$inject = ['$scope', 'GoogleMapLoaderService'];
	
	module.exports = ClubMapCtrl;


/***/ }),
/* 665 */
/***/ (function(module, exports) {

	var v1="<div id=\"map-canvas\" style=\"height:200px\" ng-if=\"clubMapCtrl.mapOptions\" ui-map=\"::clubMapCtrl.myMap\" ui-options=\"::clubMapCtrl.mapOptions\" class=\"map\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("club/club-map/club-map.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var ClubScoreCardCtrl, _;
	
	__webpack_require__(667);
	
	_ = __webpack_require__(87);
	
	ClubScoreCardCtrl = (function() {
	  function ClubScoreCardCtrl($scope, ClubService) {
	    this.ClubService = ClubService;
	    this.scorecards = [];
	    $scope.isShowYardage = false;
	    _.forEach($scope.$parent.clubInfo.courses, (function(_this) {
	      return function(course) {
	        return _this.ClubService.getYardage(course.id).then(function(data) {
	          return _this.scorecards.push({
	            course: course,
	            yardage: data
	          });
	        });
	      };
	    })(this));
	    $scope.showYardage = function() {
	      return $scope.isShowYardage = !$scope.isShowYardage;
	    };
	  }
	
	  return ClubScoreCardCtrl;
	
	})();
	
	ClubScoreCardCtrl.$inject = ['$scope', 'ClubService'];
	
	module.exports = ClubScoreCardCtrl;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div href=\"javascript:void(0)\" ng-click=\"showYardage()\" class=\"row text-green text-heading no-margin\"><div class=\"col-10 no-padding\"><left>{{ :: '_CLUB_PAGE.YARDAGE' | translate }}</left></div><div class=\"col-2 no-padding\"><a ng-class=\"{active:isShowYardage}\" class=\"btn-show-detail no-margin\"><img src=\"" + __webpack_require__(655) + "\"/></a></div></div><div ng-repeat=\"card in scoreCardCtrl.scorecards\" club-score-card=\"\" course=\"card.yardage\" course-name=\"card.course.name\" show=\"isShowYardage\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("club/club-scorecard/club-scorecard.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	var ClubScoreCardDetailDirective, _;
	
	__webpack_require__(669);
	
	_ = __webpack_require__(87);
	
	ClubScoreCardDetailDirective = function($filter) {
	  return {
	    templateUrl: "club/club-scorecard/club-scorecard-detail.jade",
	    scope: {
	      course: '=course',
	      name: '=courseName',
	      show: '=show'
	    },
	    link: function(scope) {
	      scope.holes9 = [1, 2, 3, 4, 5, 6, 7, 8, 9];
	      scope.holes18 = [10, 11, 12, 13, 14, 15, 16, 17, 18];
	      scope.getDistance = function(holes, hole_num) {
	        var hole;
	        hole = _.find(holes, _.matches({
	          num: hole_num
	        }));
	        if (hole) {
	          return hole.distance;
	        } else {
	          return "";
	        }
	      };
	      return scope.getPar = function(holes, hole_num) {
	        var hole;
	        hole = _.find(holes, _.matches({
	          num: hole_num
	        }));
	        if (hole) {
	          return hole.men_par;
	        } else {
	          return "-";
	        }
	      };
	    }
	  };
	};
	
	ClubScoreCardDetailDirective.$inject = ["$filter"];
	
	module.exports = ClubScoreCardDetailDirective;


/***/ }),
/* 669 */
/***/ (function(module, exports) {

	var v1="<div ng-if=\"show\"><h4><left>{{ name }}</left></h4><table class=\"table table-bordered\"><tbody><tr><th class=\"hole\">{{ \"No.\" }}</th><td ng-repeat=\"hole in holes9\" class=\"hole\">{{ hole }}</td></tr><tr ng-repeat=\"tee in course.tees\"><th>{{ tee.name }}</th><td ng-repeat=\"hole in holes9\">{{ getDistance(tee.holes, hole) }}</td></tr><tr><th>{{ \"Par\" }}</th><td ng-repeat=\"hole in holes9\">{{ getPar(course.tees[0].holes, hole) }}</td></tr><tr><th class=\"hole\">{{ \"No.\" }}</th><td ng-repeat=\"hole in holes18\" class=\"hole\">{{ hole }}</td></tr><tr ng-repeat=\"tee in course.tees\"><th>{{ tee.name }}</th><td ng-repeat=\"hole in holes18\">{{ getDistance(tee.holes, hole) }}</td></tr><tr><th>{{ \"Par\" }}</th><td ng-repeat=\"hole in holes18\">{{ getPar(course.tees[0].holes, hole) }}</td></tr></tbody></table></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("club/club-scorecard/club-scorecard-detail.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	var ClubHoleByHoleCtrl, _;
	
	__webpack_require__(671);
	
	_ = __webpack_require__(87);
	
	ClubHoleByHoleCtrl = (function() {
	  function ClubHoleByHoleCtrl($scope, ClubService) {
	    this.ClubService = ClubService;
	    this.courses = [];
	    $scope.isShowDetail = true;
	    $scope.isShowCourseOptions = false;
	    _.forEach($scope.$parent.clubInfo.courses, (function(_this) {
	      return function(course) {
	        return _this.ClubService.getAnalysis(course.id).then(function(data) {
	          return _this.courses.push({
	            course: course,
	            analysis: data
	          });
	        })["catch"](function() {
	          return _this.courses.push({
	            course: course,
	            analysis: {}
	          });
	        });
	      };
	    })(this));
	    $scope.showDetail = function() {
	      return $scope.isShowDetail = !$scope.isShowDetail;
	    };
	    $scope.selectCourse = function(course) {
	      $scope.selectedCourse = course;
	      $scope.$emit('courseChanged.gnp.club', course.id);
	      return $scope.isShowCourseOptions = false;
	    };
	    $scope.showCourseOptions = function() {
	      return $scope.isShowCourseOptions = !$scope.isShowCourseOptions;
	    };
	    $scope.selectCourse($scope.$parent.clubInfo.courses[0]);
	  }
	
	  return ClubHoleByHoleCtrl;
	
	})();
	
	ClubHoleByHoleCtrl.$inject = ['$scope', 'ClubService'];
	
	module.exports = ClubHoleByHoleCtrl;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<h3 class=\"hall-advice\"><img src=\"" + __webpack_require__(672) + "\" class=\"lamp-icon\"/><span class=\"text-green\">{{ :: '_CLUB_PAGE.HOLE_ADVICE' | translate }}</span></h3><div class=\"border-green\"></div><div ng-if=\"selectedCourse.name\"><h5 class=\"text-green\">{{ :: '_CLUB_PAGE.COURSE_SELECT' | translate }}</h5><div ng-click=\"showCourseOptions()\" class=\"course-item selected-course\"><span>{{ selectedCourse.name }}</span><a href=\"javascript:void(0)\" ng-class=\"{active:isShowCourseOptions}\" class=\"btn-show-detail\"><img src=\"" + __webpack_require__(673) + "\"/></a></div><div class=\"row courses-list-wrap\"><div ng-repeat=\"course in holeByHoleCtrl.courses\" ng-click=\"selectCourse(course.course)\" class=\"courses-list no-padding col-12\"><div ng-show=\"isShowCourseOptions\" class=\"course-item\">{{course.course.name}}</div></div></div><div class=\"select-courses-line\"></div></div><div href=\"javascript:void(0)\" ng-click=\"showDetail()\" class=\"row text-green text-heading no-margin mt-20\"><div class=\"col-10 no-padding\"><left>{{ :: '_CLUB_PAGE.HOLE_BY_HOLE_AVG' | translate }}</left></div><div class=\"col-2 no-padding\"><a ng-class=\"{active:isShowDetail}\" class=\"btn-show-detail\"><img src=\"" + __webpack_require__(655) + "\"/></a></div></div><div ng-repeat=\"course in holeByHoleCtrl.courses\" club-hole-by-hole-detail=\"\" analysis=\"course.analysis\" course=\"course.course\" selected=\"selectedCourse.id\" ng-if=\"isShowDetail\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("club/club-hole-by-hole/club-hole-by-hole.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAjCAMAAADR57icAAAAk1BMVEX///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+AVyv3AAAAMHRSTlMABAUQERMUFScoLEZHS0xNTmprbHBxco6PkJGUlZaztLW5urvT1NXY2drr7O/6+/xGNdanAAAAyklEQVQ4y43QxxaCMBRF0QPYO/aCYq+o+f+vc6ARwSSPO7zrjDZrVWg76vci3bMB8yLhEijd5C6pAgzkcAyAd5S6iw8ALSns8Vns7ra6E4gejW/ITKLRcxG9afQcRKPfDu9g685+JqRpC7vkFks0bqJfGr2pKYz+OwIDUVIxhPQlGjtRnsZK1MGyVbbb2Dpqd4nGSBTZuwyRmUYvTMOhq8Pb6+7kO8OUqIOwlUSTJXLR6E2UUmohdwRXpZJygZBQokmJJJovUdtwvgAYiIMC6QZW5QAAAABJRU5ErkJggg=="

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	var ClubHoleByHoleDetailDirective, _;
	
	__webpack_require__(675);
	
	_ = __webpack_require__(87);
	
	ClubHoleByHoleDetailDirective = function($filter) {
	  return {
	    templateUrl: "club/club-hole-by-hole/club-hole-by-hole-detail.jade",
	    scope: {
	      analysis: '=analysis',
	      course: '=course',
	      selected: '=selected'
	    }
	  };
	};
	
	ClubHoleByHoleDetailDirective.$inject = ["$filter"];
	
	module.exports = ClubHoleByHoleDetailDirective;


/***/ }),
/* 675 */
/***/ (function(module, exports) {

	var v1="<div ng-show=\"course.id == selected\"><h4><left>{{ course.name }}</left></h4><div ng-if=\"analysis.holes\" class=\"analysis-area\"><table class=\"table table-bordered users-avg\"><tr><th>{{ :: '_CLUB_PAGE.SHOT_AVG' | translate }}</th><td>{{ :: analysis.avg_total_shot_per_play | percentToFormattedString }}</td></tr><tr><th>{{ :: '_CLUB_PAGE.PUTT_AVG_COUNT' | translate }}</th><td>{{ :: analysis.avg_total_putt_per_play | percentToFormattedString }}</td></tr></table><div class=\"chart-wrap\"><div club-hole-by-hole-bar-chart=\"\" holes=\"analysis.holes\"></div></div></div><div ng-if=\"!analysis.holes\" class=\"empty\"><p>{{ :: '_CLUB_PAGE.NO_ROUND_PLAYED' | translate }}</p></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("club/club-hole-by-hole/club-hole-by-hole-detail.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	var ClubHoleByHoleBarChartDirective, MAX_LEVEL, MIN_LEVEL, _;
	
	__webpack_require__(677);
	
	_ = __webpack_require__(87);
	
	MAX_LEVEL = 3;
	
	MIN_LEVEL = -2;
	
	ClubHoleByHoleBarChartDirective = function(NumberService) {
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "club/club-hole-by-hole/club-hole-by-hole-bar-chart.jade",
	    scope: {
	      holes: '=holes'
	    },
	    link: function(scope, element) {
	      var maxPutt, maxStroke, minStroke, target;
	      target = element.find(".chart");
	      scope.formatEmptyValue = function(value) {
	        if (value === null || value === void 0 || value === '') {
	          return '-';
	        }
	        return value;
	      };
	      scope.decorate = function(holes) {
	        return _.map(holes, function(hole) {
	          if (hole.avg_shot !== null && hole.avg_shot !== void 0) {
	            hole.stroke = hole.avg_shot - hole.par;
	          }
	          hole.par_on_percent = scope.formatEmptyValue(NumberService.limitFractional(hole.rat_par_on * 100));
	          hole.bogey_on_percent = scope.formatEmptyValue(NumberService.limitFractional(hole.rat_bogey_on * 100));
	          hole.recovery_percent = scope.formatEmptyValue(NumberService.limitFractional(hole.rat_recovery * 100));
	          return hole;
	        });
	      };
	      scope.decorate(scope.holes);
	      scope.outIn = ['OUT', 'IN'];
	      scope.selectedButton = 'SCR';
	      scope.isSelected = function(type) {
	        return scope.selectedButton === type;
	      };
	      scope.clickButton = function(type) {
	        return scope.selectedButton = type;
	      };
	      scope.isVisbleBarCol = function(level, value) {
	        if (level > 0) {
	          return level < value + 1;
	        } else {
	          return level > value - 1;
	        }
	      };
	      scope.getStrokeColWidthPercent = function(level, value) {
	        var max, min, ratio;
	        if (level > 0) {
	          max = scope.maxStroke();
	          if (level < MAX_LEVEL && level <= value) {
	            return 1 / max * 100;
	          } else {
	            ratio = scope.getColumnWidthRatio(value);
	            return ratio / max * 100;
	          }
	        } else {
	          min = Math.abs(scope.minStroke());
	          if (level > MIN_LEVEL && level >= value) {
	            return 1 / min * 100;
	          } else {
	            ratio = scope.getColumnWidthRatio(value);
	            return ratio / min * 100;
	          }
	        }
	      };
	      scope.getPuttColWidthPercent = function(level, value) {
	        var max, ratio;
	        max = scope.maxPutt();
	        if (level < MAX_LEVEL && level <= value) {
	          return 1 / max * 100;
	        } else {
	          ratio = scope.getColumnWidthRatio(value);
	          return ratio / max * 100;
	        }
	      };
	      scope.getColumnWidthRatio = function(value) {
	        var intDecimal;
	        if (value >= MAX_LEVEL) {
	          return value - (MAX_LEVEL - 1);
	        }
	        if (value <= MIN_LEVEL) {
	          return Math.abs(value) + (MIN_LEVEL + 1);
	        }
	        intDecimal = String(value).split('.');
	        if (intDecimal.length !== 2) {
	          return '0';
	        }
	        return parseFloat('0.' + intDecimal[1]);
	      };
	      minStroke = null;
	      maxStroke = null;
	      maxPutt = null;
	      scope.maxPutt = function() {
	        var value;
	        if (maxPutt) {
	          return maxPutt;
	        }
	        value = _.maxBy(scope.holes, function(hole) {
	          return hole.avg_putt;
	        });
	        maxPutt = value != null ? value.avg_putt : void 0;
	        return maxPutt;
	      };
	      scope.maxStroke = function() {
	        var value;
	        if (maxStroke) {
	          return maxStroke;
	        }
	        value = _.maxBy(scope.holes, function(hole) {
	          return hole.stroke;
	        });
	        maxStroke = value != null ? value.stroke : void 0;
	        return maxStroke;
	      };
	      scope.minStroke = function() {
	        var value;
	        if (minStroke) {
	          return minStroke;
	        }
	        value = _.min(scope.holes, function(hole) {
	          return hole.stroke;
	        });
	        minStroke = value.stroke;
	        return minStroke;
	      };
	      scope.sliceHoles = function(outInType, holes) {
	        if (outInType === 'OUT') {
	          return holes.slice(0, 9);
	        } else {
	          return holes.slice(9, 18);
	        }
	      };
	      scope.getColorForStroke = function(hole) {
	        if (hole.stroke === 0) {
	          return 'chance-hall-color';
	        }
	        if (!hole.stroke) {
	          return;
	        }
	        if (hole.stroke < 1) {
	          return 'chance-hall-color';
	        } else if (hole.stroke >= 2) {
	          return 'difficult-hall-color';
	        }
	      };
	      return scope.getColorForPutt = function(hole) {
	        if (hole.avg_putt === 0) {
	          return 'one-putt-color';
	        }
	        if (!hole.avg_putt) {
	          return;
	        }
	        if (hole.avg_putt >= 3) {
	          return 'three-putts-color';
	        } else if (hole.avg_putt < 2) {
	          return 'one-putt-color';
	        }
	      };
	    }
	  };
	};
	
	ClubHoleByHoleBarChartDirective.$inject = ["NumberService"];
	
	module.exports = ClubHoleByHoleBarChartDirective;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div class=\"chart-heading\"><img src=\"" + __webpack_require__(678) + "\" class=\"lamp-icon\"/><span>{{ '_CLUB_PAGE.CHART_HEADING' | translate }}</span></div><div class=\"btn-group d-flex select-buttons\"><a ng-class=\"{'active': isSelected('SCR')}\" ng-click=\"clickButton(&quot;SCR&quot;)\" class=\"btn btn-secondary flex-fill\">{{ '_CLUB_PAGE.STROKE_PUTT' | translate }}</a><a ng-class=\"{'active': isSelected('GIR')}\" ng-click=\"clickButton(&quot;GIR&quot;)\" class=\"btn btn-secondary flex-fill\">{{ '_CLUB_PAGE.GIR_GIR1' | translate }}</a><a ng-class=\"{'active': isSelected('REC')}\" ng-click=\"clickButton(&quot;REC&quot;)\" class=\"btn btn-secondary flex-fill\">{{ '_CLUB_PAGE.RECOVERY' | translate }}</a></div><div ng-class=\"{'text-gray': !isSelected('SCR')}\" class=\"row square-description\"><div class=\"col-6\"><div class=\"row mx-0\"><div class=\"col-3 no-padding\"><div ng-class=\"{'gray': !isSelected('SCR')}\" class=\"square chance-hall-color\"></div></div><div class=\"col-9 no-padding\"><div class=\"color-desc\">{{ '_CLUB_PAGE.CHANCE_HOLE' | translate }}</div></div></div></div><div class=\"col-6\"><div class=\"row mx-0\"><div class=\"col-3 no-padding\"><div ng-class=\"{'gray': !isSelected('SCR')}\" class=\"square one-putt-color\"></div></div><div class=\"col-9 no-padding\"><div class=\"color-desc\">{{ '_CLUB_PAGE.ONE_PUTT' | translate }}</div></div></div></div><div class=\"col-6\"><div class=\"row mx-0\"><div class=\"col-3 no-padding\"><div ng-class=\"{'gray': !isSelected('SCR')}\" class=\"square difficult-hall-color\"></div></div><div class=\"col-9 no-padding\"><div class=\"color-desc\">{{ '_CLUB_PAGE.DIFFICULT_HOLE' | translate }}</div></div></div></div><div class=\"col-6\"><div class=\"row mx-0\"><div class=\"col-3 no-padding\"><div ng-class=\"{'gray': !isSelected('SCR')}\" class=\"square three-putts-color\"></div></div><div class=\"col-9 no-padding\"><div class=\"color-desc\">{{ '_CLUB_PAGE.THREE_PUTTS' | translate }}</div></div></div></div></div><div class=\"chart\"><table ng-hide=\"!isSelected('SCR')\" class=\"table borderless\"><thead><tr><th>{{ 'Hole' }}</th><th>{{ 'Par' }}</th><th colspan=\"3\" class=\"left-border\">{{ '_CLUB_PAGE.SCORE_AVG' | translate }}</th><th colspan=\"2\" class=\"left-border\">{{ '_CLUB_PAGE.PUTT_AVG' | translate }}</th></tr></thead><tbody ng-repeat-start=\"outInType in outIn\" class=\"out-in\"><tr><td class=\"label-out-in\">{{ outInType }}</td><td></td><td class=\"left-border zero\">E</td><td></td><td></td><td class=\"left-border\"></td><td></td></tr></tbody><tbody ng-repeat-end=\"ng-repeat-end\" class=\"hole-data\"><tr ng-repeat=\"hole in sliceHoles(outInType, holes)\"><td class=\"hole-num\">{{ hole.num }}</td><td class=\"par\">{{ hole.par }}</td><td ng-class=\"getColorForStroke(hole)\" class=\"left-border score-minus\"><div class=\"bar-wrapper minus\"><div ng-hide=\"!isVisbleBarCol(-2, hole.stroke)\" ng-style=\"{'width': getStrokeColWidthPercent(-2, hole.stroke) + '%'}\" class=\"bar col-1-chart\"></div><div ng-hide=\"!isVisbleBarCol(-1, hole.stroke)\" ng-style=\"{'width': getStrokeColWidthPercent(-1, hole.stroke) + '%'}\" class=\"bar col-1-chart\"></div></div></td><td ng-class=\"getColorForStroke(hole)\" class=\"stroke left-border-light\"><div class=\"bar-wrapper\"><div ng-hide=\"!isVisbleBarCol(1, hole.stroke)\" ng-style=\"{'width': getStrokeColWidthPercent(1, hole.stroke) + '%'}\" class=\"bar col-1-chart\"></div><div ng-hide=\"!isVisbleBarCol(2, hole.stroke)\" ng-style=\"{'width': getStrokeColWidthPercent(2, hole.stroke) + '%'}\" class=\"bar col-1-chart\"></div><div ng-hide=\"!isVisbleBarCol(3, hole.stroke)\" ng-style=\"{'width': getStrokeColWidthPercent(3, hole.stroke) + '%'}\" class=\"bar col-1-chart\"></div></div></td><td ng-class=\"getColorForStroke(hole)\" class=\"raw-value\">{{ (hole.stroke > 0) ? '+' : '' }}{{ hole.stroke | percentToFormattedString }}</td><td ng-class=\"getColorForPutt(hole)\" class=\"putt left-border\"><div class=\"bar-wrapper putt\"><div ng-hide=\"!isVisbleBarCol(1, hole.avg_putt)\" ng-style=\"{'width': getPuttColWidthPercent(1, hole.avg_putt) + '%'}\" class=\"bar col-1-chart\"></div><div ng-hide=\"!isVisbleBarCol(2, hole.avg_putt)\" ng-style=\"{'width': getPuttColWidthPercent(2, hole.avg_putt) + '%'}\" class=\"bar col-1-chart\"></div><div ng-hide=\"!isVisbleBarCol(3, hole.avg_putt)\" ng-style=\"{'width': getPuttColWidthPercent(3, hole.avg_putt) + '%'}\" class=\"bar col-1-chart\"></div></div></td><td ng-class=\"getColorForPutt(hole)\" class=\"raw-value\">{{ hole.avg_putt | percentToFormattedString }}</td></tr></tbody></table><table ng-hide=\"!isSelected('GIR')\" class=\"table borderless\"><thead><tr><th>{{ 'Hole' }}</th><th>{{ 'Par' }}</th><th class=\"left-border\"></th><th>GIR</th><th>GIR+1</th></tr></thead><tbody ng-repeat-start=\"outInType in outIn\" class=\"out-in\"><tr><td class=\"label-out-in\">{{ outInType }}</td><td></td><td colspan=\"4\" class=\"left-border\"></td></tr></tbody><tbody ng-repeat-end=\"ng-repeat-end\" class=\"hole-data\"><tr ng-repeat=\"hole in sliceHoles(outInType, holes)\"><td class=\"hole-num\">{{ hole.num }}</td><td class=\"par\">{{ hole.par }}</td><td class=\"left-border\"><div class=\"bar-wrapper par_bogey\"><div ng-style=\"{'width': hole.par_on_percent + '%'}\" class=\"bar col-1-chart\"></div><div ng-style=\"{'width': hole.bogey_on_percent + '%'}\" class=\"bar col-1-chart\"></div></div></td><td class=\"raw-value gir\">{{ hole.par_on_percent }}</td><td class=\"raw-value gir1\">{{ hole.bogey_on_percent }}</td></tr></tbody></table><table ng-hide=\"!isSelected('REC')\" class=\"table borderless\"><thead><tr><th>{{ 'Hole' }}</th><th>{{ 'Par' }}</th><th colspan=\"2\" class=\"left-border\"></th></tr></thead><tbody ng-repeat-start=\"outInType in outIn\" class=\"out-in\"><tr><td class=\"label-out-in\">{{ outInType }}</td><td></td><td colspan=\"2\" class=\"left-border\"></td></tr></tbody><tbody ng-repeat-end=\"ng-repeat-end\" class=\"hole-data\"><tr ng-repeat=\"hole in sliceHoles(outInType, holes)\"><td class=\"hole-num\">{{ hole.num }}</td><td class=\"par\">{{ hole.par }}</td><td class=\"left-border\"><div class=\"bar-wrapper recovery\"><div ng-style=\"{'width': hole.recovery_percent + '%'}\" class=\"bar col-1-chart\"></div></div></td><td class=\"raw-value recovery\">{{ hole.recovery_percent }}</td></tr></tbody></table></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("club/club-hole-by-hole/club-hole-by-hole-bar-chart.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 678 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAtCAYAAADhoUi4AAAFTElEQVRogc3aa4hd1RXA8V9uxmDQJKMGIhpLfNVYUx/xSdCUZrSoaRWLtY7mS1FBLGJANFJagkZFqh9soMkHW8WaOqBBYqqCjzFFW0NtGkNsFUSM2AQMJpKIwceYTD+sPcmZfe6de+6jE/9wmHPW2Wfttc7Zj7XWnQnTXnlSFzgE5+DMdJyAmZiBqZiY2u3FZ9iOrfgAm9KxAUOtdryrr3/UdU871ieOws9wBebjsArPTMQR6Zid3duD17AWT2NnO0bV2njmh1iDj7ESl6nmTDMOS7pWJt1rUl8t0YpDF+OfeBVX6uzrNqMn9fFq6vPiVh5sxnewAgubtBvGf8R82IyPxDzZg92pzTTxJWYmvaeLOXcaJjTQew5exvO4JeltSDOHFglnpjS4/yX+gtVYh0+a6GvEdCzA1fgJDq3TZiH+LZxa1UhRoyE3EcvxhPrObMFisYpdg6e07wzsSDquSToXpz5ypiSbljuwco6inkOT0kO3Nuj4lzgFvxNLcLf5LOn+buprR502tyYbJ+U3cocm4HH05w0xIJbaFVrbLxaIPWZDOq/KN6mv2anvnH483js4MGru5Q79BtdmsiExbq/T+t4wUcyvs9OxWoOhMgY7U9+3KL/Ia4XN+yk6dAGWZg98ISbqyhaNGOFYsYmOcESStcPKZMsXmXxp7+DABSMXIw714DGjHRwWb2ZtmwYU9TeTVWWtsGk40/dY7+BAT1H5IuVQ5F6xW3/bWCNsKzJb+LDfoSVZg81Y9v+1qyOWCRuLLCEcOlf56/xKG5HvODIkbCwyu3dw4NyaiJaLbMEL42JWZ7ygvPleUcP5mXC10ZPu28qwsLXI+TXMyYT/GB97ukJu65yaSNSK/HecjOkGua1H1ZTjoa/HyZhukNs6qYbPM+GR42RMN8hH16c1vJ8Jz+tih/WW/m5uB6dn11trWJ8Jf97FDrfhvcL1e0nWLX6UXb9Zw3OZ8Exc3sVOF+KRdDRL41thJi7JZOtqeFF5tXhYdyo5cDg+TcfhXdJJpA3FVGQP1tZE8e++rPHJ4o02KlxU5VK8KeKsJen80g51EqnOjZls1a6+/s9HgtM/impNkX6RMXbi1D2iqjrCIUnWCdPxZ6PTkCHcryD8BtcrJ08340/qV2GqcExFWVWm4VlRai5y/66+/o8Y7eU7IqfYlzVehDdwYhsG/LWirAoz8BLmZfKNClMmzx6fwU3KTp2Ft3G71iqmi/F64fr1JGuVefiX8h65HVft6uvfv7fVS4cfFcWHfPhNxkPijfy4oiE7RCH/hHTMV78s1YheseL+TbkWsQOXjwy1ERrl90+LtCKPIuD7olq6E6dWNGyL+oXDRkzFHan/25QXpo9FSWxj/uBYBYu3RV35Dw3uH6l+vaxdJuAi/F5EE79VjtWI+Tw32Vei2XzYLebUE2IJPy2730kgOznpmyuGYh+OHqP916I48oAx4sGqE/w1nCGiir6CvLh3HS2+2Czxq0NelOwRkcIUMR9mVOybGOJ3iZV4TFpZsfYqD9HiZ38Dx6fzWS3obcQ+UYd7MOmuRCsOTRIVoiJvpb/zHXCmU94VX3qV1hYStObQAuXgcr0YOg1/r2nCPpFSbBIb7qD6K2tlWnHoF9n1WyIifw7HZfdewd/T+ZCIhOErkSFvFxH+h8r7XUdUdegk/DSTHSre7ORMvl5E1Hs7M609qjp0d5229TbVD3CVg+QM1X4JuFBU/JvxDn4ghtNBo4pDd1Zo86gIlbZ2Zk7nVHGo0a48LHKTubhBuRx2UKgyh36N74lfKLaJ1W2dqCuP+T8DB4P/AUTeE8dI2HXpAAAAAElFTkSuQmCC"

/***/ }),
/* 679 */
/***/ (function(module, exports) {

	module.exports = {
	  '_CLUB_PAGE': {
	    'PAGE_TITLE': "Club",
	    'SCORE_CARD': 'Score Card',
	    'NO_ROUND_PLAYED': 'There is no round played on this course yet.',
	    'HOLE_BY_HOLE_AVG': 'GN+ User\'s Average',
	    'SHOT_AVG': 'Average Score',
	    'PUTT_AVG': 'Average Put',
	    'SCORE_AVG': 'Average Score',
	    'PUTT_AVG_COUNT': 'Average Putt',
	    'STROKE_PUTT': 'Stroke/Putt',
	    'GIR_GIR1': 'GIR/GIR+1',
	    'RECOVERY': 'Recovery',
	    'ADDRESS': 'Address',
	    'TEL': 'TEL',
	    'URL': 'URL',
	    'HEADER_TITLE_LARGE': 'GN+ User’s Score',
	    'HEADER_TITLE_SMALL': '- Publishing 1 million of Score data -',
	    'CHART_HEADING': 'Currently advising from score data of 1,200,000 people!',
	    'CHANCE_HOLE': 'Chance Hole',
	    'ONE_PUTT': 'Aim for! 1 putts',
	    'DIFFICULT_HOLE': 'Difficult Hole',
	    'THREE_PUTTS': '3 putts attention!',
	    'YARDAGE': 'Yardage',
	    'SEE_REVIEWS': 'Golf Course reviews See',
	    'HOLE_ADVICE': 'Hole Advice',
	    'COURSE_SELECT': 'Course Select',
	    'BASIC_INFO': 'Golf course basic information',
	    'RECOMMENT_PLAN': 'Recommend plan',
	    'SEE_MORES_RECOMMENT_PLAN': 'See more recommend plan',
	    'RECENT_PLAYED_USERS': 'Recently rounded users',
	    'RANKING_USERS': 'Best score ranking',
	    'RANK': 'Rank',
	    'NAME': 'Name',
	    'SCORE': 'Score',
	    'RANKING_NOTICE': 'Target user : Nickname or name already set.'
	  }
	};


/***/ }),
/* 680 */
/***/ (function(module, exports) {

	module.exports = {
	  '_CLUB_PAGE': {
	    'PAGE_TITLE': "Club",
	    'SCORE_CARD': 'スコアカード',
	    'NO_ROUND_PLAYED': 'このコースにはまだスコア記録がありません。',
	    'HOLE_BY_HOLE_AVG': 'GN+ユーザー平均',
	    'SHOT_AVG': '平均スコア',
	    'PUTT_AVG': '平均パット',
	    'SCORE_AVG': '平均ストローク数',
	    'PUTT_AVG_COUNT': '平均パット数',
	    'STROKE_PUTT': 'ストローク/パット',
	    'GIR_GIR1': 'パーオン/ボギーオン',
	    'RECOVERY': 'リカバリー率',
	    'ADDRESS': '住所',
	    'TEL': 'TEL',
	    'URL': 'URL',
	    'HEADER_TITLE_LARGE': 'みんなのスコア',
	    'HEADER_TITLE_SMALL': '- 100万人のスコアデータ公開中 -',
	    'CHART_HEADING': '現在120万人のスコアデータからアドバイス中',
	    'CHANCE_HOLE': 'チャンスホール',
	    'ONE_PUTT': '目指せ！１パット',
	    'DIFFICULT_HOLE': '難関ホール',
	    'THREE_PUTTS': '３パット注意！',
	    'YARDAGE': 'ヤーデージ',
	    'SEE_REVIEWS': 'このゴルフ場の口コミを見る',
	    'HOLE_ADVICE': 'ホールアドバイス',
	    'COURSE_SELECT': 'コース選択',
	    'BASIC_INFO': 'ゴルフ場基本情報',
	    'RECOMMENT_PLAN': 'おすすめプラン',
	    'SEE_MORES_RECOMMENT_PLAN': 'おすすめプランをもっと見る',
	    'RECENT_PLAYED_USERS': '最近ラウンドしたユーザー',
	    'RANKING_USERS': 'ベストスコアランキング',
	    'RANK': '順位',
	    'NAME': 'ニックネーム / 名前',
	    'SCORE': 'スコア',
	    'RANKING_NOTICE': '対象：ニックネームまたは名前が設定されているユーザー'
	  }
	};


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	var GroupDataService, GroupDetailCtrl, GroupDetailToolbarCtrl, GroupDetailToolbarService, GroupEditCtrl, GroupInformationCtrl, GroupListCtrl, GroupMembersDetailCtrl, GroupPermissionCtrl, GroupRegisDataService, GroupRegistrationCtrl, GroupSearchCtrl, GroupSearchItemDirective, GroupUploadDataService, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(386);
	
	__webpack_require__(682);
	
	__webpack_require__(59);
	
	__webpack_require__(72);
	
	__webpack_require__(108);
	
	__webpack_require__(82);
	
	__webpack_require__(112);
	
	__webpack_require__(412);
	
	__webpack_require__(90);
	
	__webpack_require__(76);
	
	__webpack_require__(686);
	
	__webpack_require__(740);
	
	__webpack_require__(749);
	
	__webpack_require__(766);
	
	__webpack_require__(786);
	
	__webpack_require__(796);
	
	__webpack_require__(797);
	
	__webpack_require__(798);
	
	__webpack_require__(799);
	
	__webpack_require__(800);
	
	__webpack_require__(806);
	
	__webpack_require__(807);
	
	__webpack_require__(808);
	
	__webpack_require__(809);
	
	__webpack_require__(811);
	
	__webpack_require__(815);
	
	__webpack_require__(818);
	
	__webpack_require__(820);
	
	__webpack_require__(822);
	
	GroupRegistrationCtrl = __webpack_require__(824);
	
	GroupSearchCtrl = __webpack_require__(825);
	
	GroupEditCtrl = __webpack_require__(826);
	
	GroupListCtrl = __webpack_require__(827);
	
	GroupDetailCtrl = __webpack_require__(830);
	
	GroupDetailToolbarCtrl = __webpack_require__(831);
	
	GroupPermissionCtrl = __webpack_require__(832);
	
	GroupMembersDetailCtrl = __webpack_require__(833);
	
	GroupInformationCtrl = __webpack_require__(834);
	
	GroupDataService = __webpack_require__(835);
	
	GroupRegisDataService = __webpack_require__(732);
	
	GroupUploadDataService = __webpack_require__(733);
	
	GroupDetailToolbarService = __webpack_require__(836);
	
	GroupSearchItemDirective = __webpack_require__(837);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-common-wrapper', 'gnp-remote-api', 'gnp-form', 'gnp-flash', 'gnp-animate', 'gnp-error-handler', 'gnp-app-group-event', 'gnp-app-group-ranking', 'gnp-app-group-timeline', 'gnp-app-group-member', 'gnp-app-group-info', 'uiCropper'];
	
	angular.module('gnp-app-group', modules).config([
	  '$routeProvider', '$translateProvider', function($routeProvider, $translateProvider) {
	    $translateProvider.translations('en', __webpack_require__(842)).translations('ja', __webpack_require__(843));
	    $routeProvider.when('/groups/registration', {
	      controller: 'GroupRegistrationCtrl',
	      templateUrl: 'web/groups/registration.jade',
	      title: '_GROUP.PAGE_TITLE',
	      permission: {
	        signInRequired: true
	      }
	    });
	    return $routeProvider.when('/groups/search', {
	      controller: 'GroupSearchCtrl',
	      templateUrl: 'web/groups/search.jade',
	      title: '_GROUP.PAGE_TITLE',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ]
	      }
	    }).when('/groups/:id/edit', {
	      controller: 'GroupEditCtrl',
	      templateUrl: 'web/groups/edit.jade',
	      title: '_GROUP.EDIT.PAGE_TITLE',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        groupInfo: [
	          'groupRegisDataService', '$route', function(groupRegisDataService, $route) {
	            return groupRegisDataService.getGroup($route.current.params.id);
	          }
	        ],
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ],
	        groupStatus: [
	          'groupRegisDataService', '$route', function(groupRegisDataService, $route) {
	            return groupRegisDataService.groupStatus($route.current.params.id);
	          }
	        ]
	      }
	    }).when('/groups/:id/information', {
	      controller: 'GroupInformationCtrl',
	      templateUrl: 'web/groups/info.jade',
	      title: '_GROUP.PAGE_TITLE',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        groupInfo: [
	          'groupRegisDataService', '$route', function(groupRegisDataService, $route) {
	            return groupRegisDataService.getGroup($route.current.params.id);
	          }
	        ],
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ],
	        groupStatus: [
	          'groupRegisDataService', '$route', function(groupRegisDataService, $route) {
	            return groupRegisDataService.groupStatus($route.current.params.id);
	          }
	        ]
	      }
	    }).when('/groups/:id/members', {
	      controller: 'GroupListMembersCtrl',
	      templateUrl: 'web/group-member/list-member.jade',
	      title: '_GROUP.PAGE_TITLE',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        groupInfo: [
	          'groupRegisDataService', '$route', function(groupRegisDataService, $route) {
	            return groupRegisDataService.getGroup($route.current.params.id);
	          }
	        ],
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ]
	      }
	    }).when('/groups/:id/members/:page', {
	      controller: 'GroupMembersDetailCtrl',
	      templateUrl: 'web/groups/members.jade',
	      title: '_GROUP.PAGE_TITLE',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        groupInfo: [
	          'groupRegisDataService', '$route', function(groupRegisDataService, $route) {
	            return groupRegisDataService.getGroup($route.current.params.id);
	          }
	        ],
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ],
	        groupStatus: [
	          'groupRegisDataService', '$route', function(groupRegisDataService, $route) {
	            return groupRegisDataService.groupStatus($route.current.params.id);
	          }
	        ]
	      }
	    }).when('/groups/join', {
	      controller: 'GroupPermissionCtrl',
	      template: '',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ]
	      }
	    }).when('/groups/:id', {
	      controller: 'GroupDetailCtrl',
	      templateUrl: 'web/groups/detail.jade',
	      title: '_GROUP.EDIT.PAGE_TITLE',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        groupInfo: [
	          'groupRegisDataService', '$route', function(groupRegisDataService, $route) {
	            return groupRegisDataService.getGroup($route.current.params.id);
	          }
	        ],
	        groupStatus: [
	          'groupRegisDataService', '$route', function(groupRegisDataService, $route) {
	            return groupRegisDataService.groupStatus($route.current.params.id);
	          }
	        ],
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ]
	      }
	    }).when('/groups', {
	      controller: 'GroupListCtrl',
	      templateUrl: 'web/groups/index.jade',
	      title: '_GROUP.LIST.PAGE_TITLE',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ]
	      }
	    });
	  }
	]).factory('groupDataService', GroupDataService).factory('groupRegisDataService', GroupRegisDataService).factory('groupUploadDataService', GroupUploadDataService).factory('groupDetailToolbarService', GroupDetailToolbarService).controller('GroupRegistrationCtrl', GroupRegistrationCtrl).controller('GroupEditCtrl', GroupEditCtrl).controller('GroupListCtrl', GroupListCtrl).controller('GroupDetailCtrl', GroupDetailCtrl).controller('GroupDetailToolbarCtrl', GroupDetailToolbarCtrl).controller('GroupPermissionCtrl', GroupPermissionCtrl).controller('GroupSearchCtrl', GroupSearchCtrl).controller('GroupMembersDetailCtrl', GroupMembersDetailCtrl).controller('GroupInformationCtrl', GroupInformationCtrl).directive('groupSearchItem', GroupSearchItemDirective);


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(683);
	__webpack_require__(684);

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! uiCropper v1.0.9 License: MIT */angular.module("uiCropper",[]),angular.module("uiCropper").factory("cropAreaCircle",["cropArea",function(t){function e(){t.apply(this,arguments),this._boxResizeBaseSize=25,this._boxResizeNormalRatio=1,this._boxResizeHoverRatio=1.2,this._iconMoveNormalRatio=.9,this._iconMoveHoverRatio=1.2,this._boxResizeNormalSize=this._boxResizeBaseSize*this._boxResizeNormalRatio,this._boxResizeHoverSize=this._boxResizeBaseSize*this._boxResizeHoverRatio,this._posDragStartX=0,this._posDragStartY=0,this._posResizeStartX=0,this._posResizeStartY=0,this._posResizeStartSize=0,this._boxResizeIsHover=!1,this._areaIsHover=!1,this._boxResizeIsDragging=!1,this._areaIsDragging=!1}return(e.prototype=new t).getType=function(){return"circle"},e.prototype._calcCirclePerimeterCoords=function(e){var t=this._size.w/2,i=e*(Math.PI/180);return[this.getCenterPoint().x+t*Math.cos(i),this.getCenterPoint().y+t*Math.sin(i)]},e.prototype._calcResizeIconCenterCoords=function(){return this._calcCirclePerimeterCoords(-45)},e.prototype._isCoordWithinArea=function(e){return Math.sqrt((e[0]-this.getCenterPoint().x)*(e[0]-this.getCenterPoint().x)+(e[1]-this.getCenterPoint().y)*(e[1]-this.getCenterPoint().y))<this._size.w/2},e.prototype._isCoordWithinBoxResize=function(e){var t=this._calcResizeIconCenterCoords(),i=this._boxResizeHoverSize/2;return e[0]>t[0]-i&&e[0]<t[0]+i&&e[1]>t[1]-i&&e[1]<t[1]+i},e.prototype._drawArea=function(e,t,i){e.arc(t.x,t.y,i.w/2,0,2*Math.PI)},e.prototype.draw=function(){t.prototype.draw.apply(this,arguments);var e=this.getCenterPoint();this._cropCanvas.drawIconMove([e.x,e.y],this._areaIsHover?this._iconMoveHoverRatio:this._iconMoveNormalRatio),this._cropCanvas.drawIconResizeBoxNESW(this._calcResizeIconCenterCoords(),this._boxResizeBaseSize,this._boxResizeIsHover?this._boxResizeHoverRatio:this._boxResizeNormalRatio)},e.prototype.setSizeByScale=function(e){var t=this.getCenterPoint(),i=this.getSize().w*e/2,r={x:t.x-i,y:t.y-i},s={x:t.x+i,y:t.y+i};this.circleOnMove(r,s),this._events.trigger("area-resize")},e.prototype.processMouseMove=function(e,t){var i="default",r=!1;if(this._boxResizeIsHover=!1,this._areaIsHover=!1,this._areaIsDragging)this.setCenterPointOnMove({x:e-this._posDragStartX,y:t-this._posDragStartY}),i="move",r=this._areaIsHover=!0,this._events.trigger("area-move");else if(this._boxResizeIsDragging){var s,a,n;i="nesw-resize",a=e-this._posResizeStartX,s=(n=this._posResizeStartY-t)<a?this._posResizeStartSize.w+2*n:this._posResizeStartSize.w+2*a;var o={},h={};o.x=this.getCenterPoint().x-.5*s,h.x=this.getCenterPoint().x+.5*s,o.y=this.getCenterPoint().y-.5*s,h.y=this.getCenterPoint().y+.5*s,this.circleOnMove(o,h),r=this._boxResizeIsHover=!0,this._events.trigger("area-resize")}else this._isCoordWithinBoxResize([e,t])?(i="nesw-resize",this._areaIsHover=!1,r=this._boxResizeIsHover=!0):this._isCoordWithinArea([e,t])&&(i="move",r=this._areaIsHover=!0);return angular.element(this._ctx.canvas).css({cursor:i}),r},e.prototype.processMouseDown=function(e,t){if(this._isCoordWithinBoxResize([e,t]))this._areaIsDragging=!1,this._areaIsHover=!1,this._boxResizeIsDragging=!0,this._boxResizeIsHover=!0,this._posResizeStartX=e,this._posResizeStartY=t,this._posResizeStartSize=this._size,this._events.trigger("area-resize-start");else if(this._isCoordWithinArea([e,t])){this._areaIsDragging=!0,this._areaIsHover=!0,this._boxResizeIsDragging=!1,this._boxResizeIsHover=!1;var i=this.getCenterPoint();this._posDragStartX=e-i.x,this._posDragStartY=t-i.y,this._events.trigger("area-move-start")}},e.prototype.processMouseUp=function(){this._areaIsDragging&&(this._areaIsDragging=!1,this._events.trigger("area-move-end")),this._boxResizeIsDragging&&(this._boxResizeIsDragging=!1,this._events.trigger("area-resize-end")),this._areaIsHover=!1,this._boxResizeIsHover=!1,this._posDragStartX=0,this._posDragStartY=0},e}]),angular.module("uiCropper").factory("cropAreaRectangle",["cropArea",function(a){function e(){a.apply(this,arguments),this._resizeCtrlBaseRadius=15,this._resizeCtrlNormalRatio=.6,this._resizeCtrlHoverRatio=.7,this._iconMoveNormalRatio=.9,this._iconMoveHoverRatio=1.2,this._resizeCtrlNormalRadius=this._resizeCtrlBaseRadius*this._resizeCtrlNormalRatio,this._resizeCtrlHoverRadius=this._resizeCtrlBaseRadius*this._resizeCtrlHoverRatio,this._posDragStartX=0,this._posDragStartY=0,this._posResizeStartX=0,this._posResizeStartY=0,this._posResizeStartSize={w:0,h:0},this._resizeCtrlIsHover=-1,this._areaIsHover=!1,this._resizeCtrlIsDragging=-1,this._areaIsDragging=!1}return(e.prototype=new a).getType=function(){return"rectangle"},e.prototype._calcRectangleCorners=function(){var e=this.getSize(),t=this.getSouthEastBound();return[[e.x,e.y],[t.x,e.y],[e.x,t.y],[t.x,t.y]]},e.prototype._calcRectangleDimensions=function(){var e=this.getSize(),t=this.getSouthEastBound();return{left:e.x,top:e.y,right:t.x,bottom:t.y}},e.prototype._isCoordWithinArea=function(e){var t=this._calcRectangleDimensions();return e[0]>=t.left&&e[0]<=t.right&&e[1]>=t.top&&e[1]<=t.bottom},e.prototype._isCoordWithinResizeCtrl=function(e){for(var t=this._calcRectangleCorners(),i=-1,r=0,s=t.length;r<s;r++){var a=t[r];if(e[0]>a[0]-this._resizeCtrlHoverRadius&&e[0]<a[0]+this._resizeCtrlHoverRadius&&e[1]>a[1]-this._resizeCtrlHoverRadius&&e[1]<a[1]+this._resizeCtrlHoverRadius){i=r;break}}return i},e.prototype._drawArea=function(e,t,i){e.rect(i.x,i.y,i.w,i.h)},e.prototype.draw=function(){a.prototype.draw.apply(this,arguments);var e=this.getCenterPoint();this._cropCanvas.drawIconMove([e.x,e.y],this._areaIsHover?this._iconMoveHoverRatio:this._iconMoveNormalRatio);for(var t=this._calcRectangleCorners(),i=0,r=t.length;i<r;i++){var s=t[i];this._cropCanvas.drawIconResizeBoxBase(s,this._resizeCtrlBaseRadius,this._resizeCtrlIsHover===i?this._resizeCtrlHoverRatio:this._resizeCtrlNormalRatio)}},e.prototype.setSizeByScale=function(e,t){var i,r,s=this.getCenterPoint(),a=this.getSize();if(this._aspect){var n=a.w*e,o=a.h*e;i={x:s.x-n/2,y:s.y-o/2},r={x:s.x+n/2,y:s.y+o/2}}else switch(i={x:a.x,y:a.y},r={x:a.x+a.w,y:a.y+a.h},t){case"up":case"down":r.y=a.y+a.h*e;break;case"left":case"right":r.x=a.x+a.w*e}this.setSizeByCorners(i,r),this._events.trigger("area-resize")},e.prototype.processMouseMove=function(e,t){var i="default",r=!1;if(this._resizeCtrlIsHover=-1,this._areaIsHover=!1,this._areaIsDragging)this.setCenterPointOnMove({x:e-this._posDragStartX,y:t-this._posDragStartY}),i="move",r=this._areaIsHover=!0,this._events.trigger("area-move");else if(-1<this._resizeCtrlIsDragging){var s=this.getSize(),a=this.getSouthEastBound(),n=e;switch(this._resizeCtrlIsDragging){case 0:this._aspect&&(n=a.x-(a.y-t)*this._aspect),this.setSizeByCorners({x:n,y:t},{x:a.x,y:a.y}),i="nwse-resize";break;case 1:this._aspect&&(n=s.x+(a.y-t)*this._aspect),this.setSizeByCorners({x:s.x,y:t},{x:n,y:a.y}),i="nesw-resize";break;case 2:this._aspect&&(n=a.x-(t-s.y)*this._aspect),this.setSizeByCorners({x:n,y:s.y},{x:a.x,y:t}),i="nesw-resize";break;case 3:this._aspect&&(n=s.x+(t-s.y)*this._aspect),this.setSizeByCorners({x:s.x,y:s.y},{x:n,y:t}),i="nwse-resize"}this._resizeCtrlIsHover=this._resizeCtrlIsDragging,r=!0,this._events.trigger("area-resize")}else{var o=this._isCoordWithinResizeCtrl([e,t]);if(-1<o){switch(o){case 0:i="nwse-resize";break;case 1:case 2:i="nesw-resize";break;case 3:i="nwse-resize"}this._areaIsHover=!1,this._resizeCtrlIsHover=o,r=!0}else this._isCoordWithinArea([e,t])&&(i="move",r=this._areaIsHover=!0)}return angular.element(this._ctx.canvas).css({cursor:i}),r},e.prototype.processMouseDown=function(e,t){var i=this._isCoordWithinResizeCtrl([e,t]);if(-1<i)this._areaIsDragging=!1,this._areaIsHover=!1,this._resizeCtrlIsDragging=i,this._resizeCtrlIsHover=i,this._posResizeStartX=e,this._posResizeStartY=t,this._posResizeStartSize=this._size,this._events.trigger("area-resize-start");else if(this._isCoordWithinArea([e,t])){this._areaIsDragging=!0,this._areaIsHover=!0,this._resizeCtrlIsDragging=-1,this._resizeCtrlIsHover=-1;var r=this.getCenterPoint();this._posDragStartX=e-r.x,this._posDragStartY=t-r.y,this._events.trigger("area-move-start")}},e.prototype.processMouseUp=function(){this._areaIsDragging&&(this._areaIsDragging=!1,this._events.trigger("area-move-end")),-1<this._resizeCtrlIsDragging&&(this._resizeCtrlIsDragging=-1,this._events.trigger("area-resize-end")),this._areaIsHover=!1,this._resizeCtrlIsHover=-1,this._posDragStartX=0,this._posDragStartY=0},e}]),angular.module("uiCropper").factory("cropAreaSquare",["cropArea",function(a){function e(){a.apply(this,arguments),this._resizeCtrlBaseRadius=15,this._resizeCtrlNormalRatio=.6,this._resizeCtrlHoverRatio=.7,this._iconMoveNormalRatio=.9,this._iconMoveHoverRatio=1.2,this._resizeCtrlNormalRadius=this._resizeCtrlBaseRadius*this._resizeCtrlNormalRatio,this._resizeCtrlHoverRadius=this._resizeCtrlBaseRadius*this._resizeCtrlHoverRatio,this._posDragStartX=0,this._posDragStartY=0,this._posResizeStartX=0,this._posResizeStartY=0,this._posResizeStartSize=0,this._resizeCtrlIsHover=-1,this._areaIsHover=!1,this._resizeCtrlIsDragging=-1,this._areaIsDragging=!1}return(e.prototype=new a).getType=function(){return"square"},e.prototype._calcSquareCorners=function(){var e=this.getSize(),t=this.getSouthEastBound();return[[e.x,e.y],[t.x,e.y],[e.x,t.y],[t.x,t.y]]},e.prototype._calcSquareDimensions=function(){var e=this.getSize(),t=this.getSouthEastBound();return{left:e.x,top:e.y,right:t.x,bottom:t.y}},e.prototype._isCoordWithinArea=function(e){var t=this._calcSquareDimensions();return e[0]>=t.left&&e[0]<=t.right&&e[1]>=t.top&&e[1]<=t.bottom},e.prototype._isCoordWithinResizeCtrl=function(e){for(var t=this._calcSquareCorners(),i=-1,r=0,s=t.length;r<s;r++){var a=t[r];if(e[0]>a[0]-this._resizeCtrlHoverRadius&&e[0]<a[0]+this._resizeCtrlHoverRadius&&e[1]>a[1]-this._resizeCtrlHoverRadius&&e[1]<a[1]+this._resizeCtrlHoverRadius){i=r;break}}return i},e.prototype._drawArea=function(e,t,i){e.rect(i.x,i.y,i.w,i.h)},e.prototype.draw=function(){a.prototype.draw.apply(this,arguments);var e=this.getCenterPoint();this._cropCanvas.drawIconMove([e.x,e.y],this._areaIsHover?this._iconMoveHoverRatio:this._iconMoveNormalRatio);for(var t=this._calcSquareCorners(),i=0,r=t.length;i<r;i++){var s=t[i];this._cropCanvas.drawIconResizeBoxBase(s,this._resizeCtrlBaseRadius,this._resizeCtrlIsHover===i?this._resizeCtrlHoverRatio:this._resizeCtrlNormalRatio)}},e.prototype._clampPoint=function(e,t){var i=this._ctx.canvas.width;return e<0&&(t-=Math.abs(e),e=0),t<0&&(e-=Math.abs(t),t=0),i<e&&(t-=i-e,e=i),i<t&&(e-=i-t,t=i),{x:e,y:t}},e.prototype.setSizeByScale=function(e){var t=this.getCenterPoint(),i=this.getSize().w*e;i<this._minSize.w&&(i=this._minSize.w);var r={x:t.x-i/2,y:t.y-i/2},s={x:t.x+i/2,y:t.y+i/2};this.setSizeByCorners(r,s),this._events.trigger("area-resize")},e.prototype.processMouseMove=function(e,t){var i="default",r=!1;if(this._resizeCtrlIsHover=-1,this._areaIsHover=!1,this._areaIsDragging)this.setCenterPointOnMove({x:e-this._posDragStartX,y:t-this._posDragStartY}),i="move",r=this._areaIsHover=!0,this._events.trigger("area-move");else if(-1<this._resizeCtrlIsDragging){var s,a;switch(this._resizeCtrlIsDragging){case 0:a=s=-1,i="nwse-resize";break;case 1:a=-(s=1),i="nesw-resize";break;case 2:s=-1,a=1,i="nesw-resize";break;case 3:a=s=1,i="nwse-resize"}var n,o=(e-this._posResizeStartX)*s,h=(t-this._posResizeStartY)*a;n=h<o?this._posResizeStartSize.w+h:this._posResizeStartSize.w+o;var c=Math.max(this._minSize.w,n),u={},l={},g={},p={},f=this.getSize(),d=this.getSouthEastBound();switch(this._resizeCtrlIsDragging){case 0:u.x=d.x-c,u.y=d.y-c,u=this._clampPoint(u.x,u.y),this.setSizeByCorners(u,{x:d.x,y:d.y}),i="nwse-resize";break;case 1:p.x=f.x+c,p.y=d.y-c,p=this._clampPoint(p.x,p.y),this.setSizeByCorners({x:f.x,y:p.y},{x:p.x,y:d.y}),i="nesw-resize";break;case 2:g.x=d.x-c,g.y=f.y+c,g=this._clampPoint(g.x,g.y),this.setSizeByCorners({x:g.x,y:f.y},{x:d.x,y:g.y}),i="nesw-resize";break;case 3:l.x=f.x+c,l.y=f.y+c,l=this._clampPoint(l.x,l.y),this.setSizeByCorners({x:f.x,y:f.y},l),i="nwse-resize"}this._resizeCtrlIsHover=this._resizeCtrlIsDragging,r=!0,this._events.trigger("area-resize")}else{var v=this._isCoordWithinResizeCtrl([e,t]);if(-1<v){switch(v){case 0:i="nwse-resize";break;case 1:case 2:i="nesw-resize";break;case 3:i="nwse-resize"}this._areaIsHover=!1,this._resizeCtrlIsHover=v,r=!0}else this._isCoordWithinArea([e,t])&&(i="move",r=this._areaIsHover=!0)}return angular.element(this._ctx.canvas).css({cursor:i}),r},e.prototype.processMouseDown=function(e,t){var i=this._isCoordWithinResizeCtrl([e,t]);if(-1<i)this._areaIsDragging=!1,this._areaIsHover=!1,this._resizeCtrlIsDragging=i,this._resizeCtrlIsHover=i,this._posResizeStartX=e,this._posResizeStartY=t,this._posResizeStartSize=this._size,this._events.trigger("area-resize-start");else if(this._isCoordWithinArea([e,t])){this._areaIsDragging=!0,this._areaIsHover=!0,this._resizeCtrlIsDragging=-1,this._resizeCtrlIsHover=-1;var r=this.getCenterPoint();this._posDragStartX=e-r.x,this._posDragStartY=t-r.y,this._events.trigger("area-move-start")}},e.prototype.processMouseUp=function(){this._areaIsDragging&&(this._areaIsDragging=!1,this._events.trigger("area-move-end")),-1<this._resizeCtrlIsDragging&&(this._resizeCtrlIsDragging=-1,this._events.trigger("area-resize-end")),this._areaIsHover=!1,this._resizeCtrlIsHover=-1,this._posDragStartX=0,this._posDragStartY=0},e}]),angular.module("uiCropper").factory("cropArea",["cropCanvas",function(i){function e(e,t){this._ctx=e,this._events=t,this._minSize={x:0,y:0,w:80,h:80},this._initSize=void 0,this._initCoords=void 0,this._allowCropResizeOnCorners=!1,this._forceAspectRatio=!1,this._aspect=null,this._disableCrop=!1,this._cropCanvas=new i(e,this._disableCrop),this._image=new Image,this._size={x:0,y:0,w:150,h:150}}return e.prototype.setAllowCropResizeOnCorners=function(e){this._allowCropResizeOnCorners=e},e.prototype.getImage=function(){return this._image},e.prototype.setImage=function(e){this._image=e},e.prototype.setForceAspectRatio=function(e){this._forceAspectRatio=e},e.prototype.setAspect=function(e){this._aspect=e},e.prototype.getAspect=function(){return this._aspect},e.prototype.getCanvasSize=function(){return{w:this._ctx.canvas.width,h:this._ctx.canvas.height}},e.prototype.getSize=function(){return this._size},e.prototype.setSize=function(e){e=this._processSize(e),this._size=this._preventBoundaryCollision(e)},e.prototype.setSizeOnMove=function(e){e=this._processSize(e),this._allowCropResizeOnCorners?this._size=this._preventBoundaryCollision(e):this._size=this._allowMouseOutsideCanvas(e)},e.prototype.circleOnMove=function(e,t){var i={x:e.x,y:e.y,w:t.x-e.x,h:t.y-e.y},r=this._ctx.canvas.height,s=this._ctx.canvas.width;(i.w>s||i.h>r)&&(s<r?(i.w=s,i.h=s):(i.w=r,i.h=r)),i.x+i.w>s&&(i.x=s-i.w),i.y+i.h>r&&(i.y=r-i.h),i.x<0&&(i.x=0),i.y<0&&(i.y=0),this._minSize.w>i.w&&(i.w=this._minSize.w,i.x=this._size.x),this._minSize.h>i.h&&(i.h=this._minSize.h,i.y=this._size.y),this._size=i},e.prototype.setSizeByCorners=function(e,t){var i={x:e.x,y:e.y,w:t.x-e.x,h:t.y-e.y};this.setSize(i)},e.prototype.getSouthEastBound=function(){return this._southEastBound(this.getSize())},e.prototype.setMinSize=function(e){this._minSize=this._processSize(e),this.setSize(this._minSize)},e.prototype.getMinSize=function(){return this._minSize},e.prototype.getCenterPoint=function(){var e=this.getSize();return{x:e.x+e.w/2,y:e.y+e.h/2}},e.prototype.setCenterPoint=function(e){var t=this.getSize();this.setSize({x:e.x-t.w/2,y:e.y-t.h/2,w:t.w,h:t.h})},e.prototype.setCenterPointOnMove=function(e){var t=this.getSize();this.setSizeOnMove({x:e.x-t.w/2,y:e.y-t.h/2,w:t.w,h:t.h})},e.prototype.setInitSize=function(e){this._initSize=this._processSize(e),this.setSize(this._initSize)},e.prototype.getInitSize=function(){return this._initSize},e.prototype.setInitCoords=function(e){e.h=this.getSize().h,e.w=this.getSize().w,this._initCoords=this._processSize(e),this.setSize(this._initCoords)},e.prototype.setDisableCrop=function(e){this._disableCrop=e,this._cropCanvas=new i(this._ctx,this._disableCrop)},e.prototype.getInitCoords=function(){return this._initCoords},e.prototype.getType=function(){return"circle"},e.prototype._allowMouseOutsideCanvas=function(e){var t=this._ctx.canvas.height,i=this._ctx.canvas.width,r={w:e.w,h:e.h};return e.x<0?r.x=0:e.x+e.w>i?r.x=i-e.w:r.x=e.x,e.y<0?r.y=0:e.y+e.h>t?r.y=t-e.h:r.y=e.y,r},e.prototype._preventBoundaryCollision=function(e){var t=this._ctx.canvas.height,i=this._ctx.canvas.width,r={x:e.x,y:e.y},s=this._southEastBound(e);r.x<0&&(r.x=0),r.y<0&&(r.y=0),s.x>i&&(s.x=i),s.y>t&&(s.y=t);var a=this._forceAspectRatio?e.w:s.x-r.x,n=this._forceAspectRatio?e.h:s.y-r.y;t<n&&(n=t),this._aspect&&(a=n*this._aspect,r.x+a>i&&(n=(a=i-r.x)/this._aspect,this._minSize.w>a&&(a=this._minSize.w),this._minSize.h>n&&(n=this._minSize.h),r.x=i-a),r.y+n>t&&(r.y=t-n)),this._forceAspectRatio&&(a=n,r.x+a>i&&((a=i-r.x)<this._minSize.w&&(a=this._minSize.w),n=a));var o={x:r.x,y:r.y,w:a,h:n};return o.w<this._minSize.w&&!this._forceAspectRatio&&(o.w=this._minSize.w,(s=this._southEastBound(o)).x>i&&(s.x=i,r.x=Math.max(s.x-i,s.x-this._minSize.w),o={x:r.x,y:r.y,w:s.x-r.x,h:s.y-r.y})),o.h<this._minSize.h&&!this._forceAspectRatio&&(o.h=this._minSize.h,(s=this._southEastBound(o)).y>t&&(s.y=t,r.y=Math.max(s.y-t,s.y-this._minSize.h),o={x:r.x,y:r.y,w:s.x-r.x,h:s.y-r.y})),this._forceAspectRatio&&((s=this._southEastBound(o)).y>t&&(o.y=t-o.h),s.x>i&&(o.x=i-o.w)),o},e.prototype._dontDragOutside=function(){var e=this._ctx.canvas.height,t=this._ctx.canvas.width;this._width>t&&(this._width=t),this._height>e&&(this._height=e),this._x<this._width/2&&(this._x=this._width/2),this._x>t-this._width/2&&(this._x=t-this._width/2),this._y<this._height/2&&(this._y=this._height/2),this._y>e-this._height/2&&(this._y=e-this._height/2)},e.prototype._drawArea=function(){},e.prototype._processSize=function(e){"number"==typeof e&&(e={w:e,h:e});var t=e.w,i=e.h;return this._aspect&&(1<=this.aspect?t=e.h*this._aspect:i=e.w/this._aspect),{x:void 0===e.x?this.getSize().x:e.x,y:void 0===e.y?this.getSize().y:e.y,w:t||this._minSize.w,h:i||this._minSize.h}},e.prototype._southEastBound=function(e){return{x:e.x+e.w,y:e.y+e.h}},e.prototype.draw=function(){this._cropCanvas.drawCropArea(this._image,this.getCenterPoint(),this._size,this._drawArea)},e.prototype.processMouseMove=function(){},e.prototype.processMouseDown=function(){},e.prototype.processMouseUp=function(){},e}]),angular.module("uiCropper").factory("cropCanvas",[function(){var s=[[-.5,-2],[-3,-4.5],[-.5,-7],[-7,-7],[-7,-.5],[-4.5,-3],[-2,-.5]],a=[[.5,-2],[3,-4.5],[.5,-7],[7,-7],[7,-.5],[4.5,-3],[2,-.5]],n=[[-.5,2],[-3,4.5],[-.5,7],[-7,7],[-7,.5],[-4.5,3],[-2,.5]],u=[[.5,2],[3,4.5],[.5,7],[7,7],[7,.5],[4.5,3],[2,.5]],i=[[-1.5,-2.5],[-1.5,-6],[-5,-6],[0,-11],[5,-6],[1.5,-6],[1.5,-2.5]],l=[[-2.5,-1.5],[-6,-1.5],[-6,-5],[-11,0],[-6,5],[-6,1.5],[-2.5,1.5]],g=[[-1.5,2.5],[-1.5,6],[-5,6],[0,11],[5,6],[1.5,6],[1.5,2.5]],p=[[2.5,-1.5],[6,-1.5],[6,-5],[11,0],[6,5],[6,1.5],[2.5,1.5]],f="#fff",d="#bababa",v="#444",m="#fff",w="#bababa",y="#444",_="#fff",z=1;return function(h,c){function o(e,t,i){return[i*e[0]+t[0],i*e[1]+t[1]]}function r(e,t,i,r){if(!c){h.save(),h.fillStyle=t,h.beginPath();var s,a=o(e[0],i,r);for(var n in h.moveTo(a[0],a[1]),e)0<n&&(s=o(e[n],i,r),h.lineTo(s[0],s[1]));h.lineTo(a[0],a[1]),h.fill(),h.closePath(),h.restore()}}this.drawIconMove=function(e,t){c||(r(i,_,e,t),r(l,_,e,t),r(g,_,e,t),r(p,_,e,t))},this.drawIconResizeCircle=function(e,t,i){if(!c){var r=t*i;h.save(),h.strokeStyle=w,h.lineWidth=z,h.fillStyle=y,h.beginPath(),h.arc(e[0],e[1],r,0,2*Math.PI),h.fill(),h.stroke(),h.closePath(),h.restore()}},this.drawIconResizeBoxBase=function(e,t,i){if(!c){var r=t*i;h.save(),h.strokeStyle=d,h.lineWidth=z,h.fillStyle=v,h.fillRect(e[0]-r/2,e[1]-r/2,r,r),h.strokeRect(e[0]-r/2,e[1]-r/2,r,r),h.restore()}},this.drawIconResizeBoxNESW=function(e,t,i){c||(this.drawIconResizeBoxBase(e,t,i),r(a,m,e,i),r(n,m,e,i))},this.drawIconResizeBoxNWSE=function(e,t,i){c||(this.drawIconResizeBoxBase(e,t,i),r(s,m,e,i),r(u,m,e,i))},this.drawCropArea=function(e,t,i,r){if(!c){var s=Math.abs(e.width/h.canvas.width),a=Math.abs(e.height/h.canvas.height),n=Math.abs(t.x-i.w/2),o=Math.abs(t.y-i.h/2);h.save(),h.strokeStyle=f,h.lineWidth=z,h.setLineDash([5,5]),h.beginPath(),r(h,t,i),h.stroke(),h.clip(),0<i.w&&h.drawImage(e,n*s,o*a,Math.abs(i.w*s),Math.abs(i.h*a),n,o,Math.abs(i.w),Math.abs(i.h)),h.beginPath(),r(h,t,i),h.stroke(),h.clip(),h.restore()}}}}]),angular.module("uiCropper").service("cropEXIF",[function(){var u=!1,c=this.Tags={36864:"ExifVersion",40960:"FlashpixVersion",40961:"ColorSpace",40962:"PixelXDimension",40963:"PixelYDimension",37121:"ComponentsConfiguration",37122:"CompressedBitsPerPixel",37500:"MakerNote",37510:"UserComment",40964:"RelatedSoundFile",36867:"DateTimeOriginal",36868:"DateTimeDigitized",37520:"SubsecTime",37521:"SubsecTimeOriginal",37522:"SubsecTimeDigitized",33434:"ExposureTime",33437:"FNumber",34850:"ExposureProgram",34852:"SpectralSensitivity",34855:"ISOSpeedRatings",34856:"OECF",37377:"ShutterSpeedValue",37378:"ApertureValue",37379:"BrightnessValue",37380:"ExposureBias",37381:"MaxApertureValue",37382:"SubjectDistance",37383:"MeteringMode",37384:"LightSource",37385:"Flash",37396:"SubjectArea",37386:"FocalLength",41483:"FlashEnergy",41484:"SpatialFrequencyResponse",41486:"FocalPlaneXResolution",41487:"FocalPlaneYResolution",41488:"FocalPlaneResolutionUnit",41492:"SubjectLocation",41493:"ExposureIndex",41495:"SensingMethod",41728:"FileSource",41729:"SceneType",41730:"CFAPattern",41985:"CustomRendered",41986:"ExposureMode",41987:"WhiteBalance",41988:"DigitalZoomRation",41989:"FocalLengthIn35mmFilm",41990:"SceneCaptureType",41991:"GainControl",41992:"Contrast",41993:"Saturation",41994:"Sharpness",41995:"DeviceSettingDescription",41996:"SubjectDistanceRange",40965:"InteroperabilityIFDPointer",42016:"ImageUniqueID"},l=this.TiffTags={256:"ImageWidth",257:"ImageHeight",34665:"ExifIFDPointer",34853:"GPSInfoIFDPointer",40965:"InteroperabilityIFDPointer",258:"BitsPerSample",259:"Compression",262:"PhotometricInterpretation",274:"Orientation",277:"SamplesPerPixel",284:"PlanarConfiguration",530:"YCbCrSubSampling",531:"YCbCrPositioning",282:"XResolution",283:"YResolution",296:"ResolutionUnit",273:"StripOffsets",278:"RowsPerStrip",279:"StripByteCounts",513:"JPEGInterchangeFormat",514:"JPEGInterchangeFormatLength",301:"TransferFunction",318:"WhitePoint",319:"PrimaryChromaticities",529:"YCbCrCoefficients",532:"ReferenceBlackWhite",306:"DateTime",270:"ImageDescription",271:"Make",272:"Model",305:"Software",315:"Artist",33432:"Copyright"},g=this.GPSTags={0:"GPSVersionID",1:"GPSLatitudeRef",2:"GPSLatitude",3:"GPSLongitudeRef",4:"GPSLongitude",5:"GPSAltitudeRef",6:"GPSAltitude",7:"GPSTimeStamp",8:"GPSSatellites",9:"GPSStatus",10:"GPSMeasureMode",11:"GPSDOP",12:"GPSSpeedRef",13:"GPSSpeed",14:"GPSTrackRef",15:"GPSTrack",16:"GPSImgDirectionRef",17:"GPSImgDirection",18:"GPSMapDatum",19:"GPSDestLatitudeRef",20:"GPSDestLatitude",21:"GPSDestLongitudeRef",22:"GPSDestLongitude",23:"GPSDestBearingRef",24:"GPSDestBearing",25:"GPSDestDistanceRef",26:"GPSDestDistance",27:"GPSProcessingMethod",28:"GPSAreaInformation",29:"GPSDateStamp",30:"GPSDifferential"},p=this.StringValues={ExposureProgram:{0:"Not defined",1:"Manual",2:"Normal program",3:"Aperture priority",4:"Shutter priority",5:"Creative program",6:"Action program",7:"Portrait mode",8:"Landscape mode"},MeteringMode:{0:"Unknown",1:"Average",2:"CenterWeightedAverage",3:"Spot",4:"MultiSpot",5:"Pattern",6:"Partial",255:"Other"},LightSource:{0:"Unknown",1:"Daylight",2:"Fluorescent",3:"Tungsten (incandescent light)",4:"Flash",9:"Fine weather",10:"Cloudy weather",11:"Shade",12:"Daylight fluorescent (D 5700 - 7100K)",13:"Day white fluorescent (N 4600 - 5400K)",14:"Cool white fluorescent (W 3900 - 4500K)",15:"White fluorescent (WW 3200 - 3700K)",17:"Standard light A",18:"Standard light B",19:"Standard light C",20:"D55",21:"D65",22:"D75",23:"D50",24:"ISO studio tungsten",255:"Other"},Flash:{0:"Flash did not fire",1:"Flash fired",5:"Strobe return light not detected",7:"Strobe return light detected",9:"Flash fired, compulsory flash mode",13:"Flash fired, compulsory flash mode, return light not detected",15:"Flash fired, compulsory flash mode, return light detected",16:"Flash did not fire, compulsory flash mode",24:"Flash did not fire, auto mode",25:"Flash fired, auto mode",29:"Flash fired, auto mode, return light not detected",31:"Flash fired, auto mode, return light detected",32:"No flash function",65:"Flash fired, red-eye reduction mode",69:"Flash fired, red-eye reduction mode, return light not detected",71:"Flash fired, red-eye reduction mode, return light detected",73:"Flash fired, compulsory flash mode, red-eye reduction mode",77:"Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",79:"Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",89:"Flash fired, auto mode, red-eye reduction mode",93:"Flash fired, auto mode, return light not detected, red-eye reduction mode",95:"Flash fired, auto mode, return light detected, red-eye reduction mode"},SensingMethod:{1:"Not defined",2:"One-chip color area sensor",3:"Two-chip color area sensor",4:"Three-chip color area sensor",5:"Color sequential area sensor",7:"Trilinear sensor",8:"Color sequential linear sensor"},SceneCaptureType:{0:"Standard",1:"Landscape",2:"Portrait",3:"Night scene"},SceneType:{1:"Directly photographed"},CustomRendered:{0:"Normal process",1:"Custom process"},WhiteBalance:{0:"Auto white balance",1:"Manual white balance"},GainControl:{0:"None",1:"Low gain up",2:"High gain up",3:"Low gain down",4:"High gain down"},Contrast:{0:"Normal",1:"Soft",2:"Hard"},Saturation:{0:"Normal",1:"Low saturation",2:"High saturation"},Sharpness:{0:"Normal",1:"Soft",2:"Hard"},SubjectDistanceRange:{0:"Unknown",1:"Macro",2:"Close view",3:"Distant view"},FileSource:{3:"DSC"},Components:{0:"",1:"Y",2:"Cb",3:"Cr",4:"R",5:"G",6:"B"}};function s(e){return!!e.exifdata}function i(r,s){function t(e){var t=a(e),i=function(e){var t=new DataView(e);if(u&&console.log("Got file of length "+e.byteLength),255!==t.getUint8(0)||216!==t.getUint8(1))return u&&console.log("Not a valid JPEG"),!1;for(var i,r,s=2,a=e.byteLength;s<a;){if(r=s,56===(i=t).getUint8(r)&&66===i.getUint8(r+1)&&73===i.getUint8(r+2)&&77===i.getUint8(r+3)&&4===i.getUint8(r+4)&&4===i.getUint8(r+5)){var n=t.getUint8(s+7);n%2!=0&&(n+=1),0===n&&(n=4);var o=s+8+n,h=t.getUint16(s+6+n);return d(e,o,h)}s++}}(e);r.exifdata=t||{},r.iptcdata=i||{},s&&s.call(r)}var i=new FileReader;if(r.src){/^data\:/i.test(r.src)?t(function(e,t){t=t||e.match(/^data\:([^\;]+)\;base64,/im)[1]||"",e=e.replace(/^data\:([^\;]+)\;base64,/gim,"");for(var i=atob(e),r=i.length,s=new ArrayBuffer(r),a=new Uint8Array(s),n=0;n<r;n++)a[n]=i.charCodeAt(n);return s}(r.src)):/^blob\:/i.test(r.src)&&(i.onload=function(e){t(e.target.result)},function(e,t){var i=new XMLHttpRequest;i.open("GET",e,!0),i.responseType="blob",i.onload=function(e){200!==this.status&&0!==this.status||t(this.response)},i.send()}(r.src,function(e){i.readAsArrayBuffer(e)}));var e=new XMLHttpRequest;e.onload=function(){if(200!==this.status&&0!==this.status)throw"Could not load image";t(e.response),e=null},e.open("GET",r.src,!0),e.responseType="arraybuffer";try{e.send(null)}catch(e){}}else window.FileReader&&(r instanceof window.Blob||r instanceof window.File)&&(i.onload=function(e){u&&console.log("Got file of length "+e.target.result.byteLength),t(e.target.result)},i.readAsArrayBuffer(r))}function a(e){var t=new DataView(e);if(u&&console.log("Got file of length "+e.byteLength),255!==t.getUint8(0)||216!==t.getUint8(1))return u&&console.log("Not a valid JPEG"),!1;for(var i,r=2,s=e.byteLength;r<s;){if(255!==t.getUint8(r))return u&&console.log("Not a valid marker at offset "+r+", found: "+t.getUint8(r)),!1;if(i=t.getUint8(r+1),u&&console.log(i),225===i)return u&&console.log("Found 0xFFE1 marker"),n(t,r+4,t.getUint16(r+2));r+=2+t.getUint16(r+2)}}var f={120:"caption",110:"credit",25:"keywords",55:"dateCreated",80:"byline",85:"bylineTitle",122:"captionWriter",105:"headline",116:"copyright",15:"category"};function d(e,t,i){for(var r,s,a,n,o=new DataView(e),h={},c=t;c<t+i;)28===o.getUint8(c)&&2===o.getUint8(c+1)&&(n=o.getUint8(c+2))in f&&(a=o.getInt16(c+3),s=f[n],r=w(o,c+5,a),h.hasOwnProperty(s)?h[s]instanceof Array?h[s].push(r):h[s]=[h[s],r]:h[s]=r),c++;return h}function v(e,t,i,r,s){var a,n,o,h=e.getUint16(i,!s),c={};for(o=0;o<h;o++)a=i+12*o+2,!(n=r[e.getUint16(a,!s)])&&u&&console.log("Unknown tag: "+e.getUint16(a,!s)),c[n]=m(e,a,t,0,s);return c}function m(e,t,i,r,s){var a,n,o,h,c,u,l=e.getUint16(t+2,!s),g=e.getUint32(t+4,!s),p=e.getUint32(t+8,!s)+i;switch(l){case 1:case 7:if(1===g)return e.getUint8(t+8,!s);for(a=4<g?p:t+8,n=[],h=0;h<g;h++)n[h]=e.getUint8(a+h);return n;case 2:return w(e,a=4<g?p:t+8,g-1);case 3:if(1===g)return e.getUint16(t+8,!s);for(a=2<g?p:t+8,n=[],h=0;h<g;h++)n[h]=e.getUint16(a+2*h,!s);return n;case 4:if(1===g)return e.getUint32(t+8,!s);for(n=[],h=0;h<g;h++)n[h]=e.getUint32(p+4*h,!s);return n;case 5:if(1===g)return c=e.getUint32(p,!s),u=e.getUint32(p+4,!s),(o={}).numerator=c,o.denominator=u,o;for(n=[],h=0;h<g;h++)c=e.getUint32(p+8*h,!s),u=e.getUint32(p+4+8*h,!s),n[h]={},n[h].numerator=c,n[h].denominator=u;return n;case 9:if(1===g)return e.getInt32(t+8,!s);for(n=[],h=0;h<g;h++)n[h]=e.getInt32(p+4*h,!s);return n;case 10:if(1===g)return e.getInt32(p,!s)/e.getInt32(p+4,!s);for(n=[],h=0;h<g;h++)n[h]=e.getInt32(p+8*h,!s)/e.getInt32(p+4+8*h,!s);return n}}function w(e,t,i){for(var r="",s=t;s<t+i;s++)r+=String.fromCharCode(e.getUint8(s));return r}function n(e,t){if("Exif"!==w(e,t,4))return u&&console.log("Not valid EXIF data! "+w(e,t,4)),!1;var i,r,s,a,n,o=t+6;if(18761===e.getUint16(o))i=!1;else{if(19789!==e.getUint16(o))return u&&console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)"),!1;i=!0}if(42!==e.getUint16(o+2,!i))return u&&console.log("Not valid TIFF data! (no 0x002A)"),!1;var h=e.getUint32(o+4,!i);if(h<8)return u&&console.log("Not valid TIFF data! (First offset less than 8)",e.getUint32(o+4,!i)),!1;if((r=v(e,o,o+h,l,i)).ExifIFDPointer)for(s in a=v(e,o,o+r.ExifIFDPointer,c,i)){switch(s){case"LightSource":case"Flash":case"MeteringMode":case"ExposureProgram":case"SensingMethod":case"SceneCaptureType":case"SceneType":case"CustomRendered":case"WhiteBalance":case"GainControl":case"Contrast":case"Saturation":case"Sharpness":case"SubjectDistanceRange":case"FileSource":a[s]=p[s][a[s]];break;case"ExifVersion":case"FlashpixVersion":a[s]=String.fromCharCode(a[s][0],a[s][1],a[s][2],a[s][3]);break;case"ComponentsConfiguration":a[s]=p.Components[a[s][0]]+p.Components[a[s][1]]+p.Components[a[s][2]]+p.Components[a[s][3]]}r[s]=a[s]}if(r.GPSInfoIFDPointer)for(s in n=v(e,o,o+r.GPSInfoIFDPointer,g,i)){switch(s){case"GPSVersionID":n[s]=n[s][0]+"."+n[s][1]+"."+n[s][2]+"."+n[s][3]}r[s]=n[s]}return r}this.getData=function(e,t){return!((e instanceof Image||e instanceof HTMLImageElement)&&!e.complete||(s(e)?t&&t.call(e):i(e,t),0))},this.getTag=function(e,t){if(s(e))return e.exifdata[t]},this.getAllTags=function(e){if(!s(e))return{};var t,i=e.exifdata,r={};for(t in i)i.hasOwnProperty(t)&&(r[t]=i[t]);return r},this.pretty=function(e){if(!s(e))return"";var t,i=e.exifdata,r="";for(t in i)i.hasOwnProperty(t)&&("object"==typeof i[t]?i[t]instanceof Number?r+=t+" : "+i[t]+" ["+i[t].numerator+"/"+i[t].denominator+"]\r\n":r+=t+" : ["+i[t].length+" values]\r\n":r+=t+" : "+i[t]+"\r\n");return r},this.readFromBinaryFile=function(e){return a(e)}}]),angular.module("uiCropper").factory("cropHost",["$document","$q","cropAreaCircle","cropAreaSquare","cropAreaRectangle","cropEXIF",function(P,A,B,H,U,L){function F(e){var t=e.getBoundingClientRect(),i=document.body,r=document.documentElement,s=window.pageYOffset||r.scrollTop||i.scrollTop,a=window.pageXOffset||r.scrollLeft||i.scrollLeft,n=r.clientTop||i.clientTop||0,o=r.clientLeft||i.clientLeft||0,h=t.top+s-n,c=t.left+a-o;return{top:Math.round(h),left:Math.round(c)}}var N=8;return function(p,s,f){var d=null,v=null,m=null,u=null,l=null,g=this,w=[100,100],y=[300,300],_=null,i=[],r={w:200,h:200},a=null,z="image/png",n=null,o={up:38,down:40,left:37,right:39},S=!1;function C(){d.clearRect(0,0,d.canvas.width,d.canvas.height),null!==v&&(d.drawImage(v,0,0,d.canvas.width,d.canvas.height),d.save(),m._disableCrop||(d.fillStyle="rgba(0, 0, 0, 0.65)",d.fillRect(0,0,d.canvas.width,d.canvas.height),d.restore()),m.draw())}function x(){p[0].focus()}function I(e,t){var i=e/t,r=[e,t],s={left:0,top:0};return r[0]>y[0]?(r[0]=y[0],r[1]=r[0]/i,s.top=(y[1]-r[1])/2):(r[1]>y[1]?(r[1]=y[1],r[0]=r[1]*i):s.top=(y[1]-r[1])/2,s.left=(y[0]-r[0])/2),{dims:r,margins:s}}function b(){var e=[0,0];if(null!==v){if(x(),m.setImage(v),"fit"===_){var t=I(v.width,v.height);e=t.dims;var i=t.margins;p.css({"margin-left":i.left+"px","margin-top":i.top+"px"})}else{var r=[v.width,v.height],s=v.width/v.height;(e=r)[0]>y[0]?(e[0]=y[0],e[1]=e[0]/s):e[0]<w[0]&&(e[0]=w[0],e[1]=e[0]/s),"fixed-height"===_&&e[1]>y[1]?(e[1]=y[1],e[0]=e[1]*s):e[1]<w[1]&&(e[1]=w[1],e[0]=e[1]*s)}p.prop("width",e[0]).prop("height",e[1]),"fixed-height"===_&&p.css({"margin-left":-e[0]/2+"px","margin-top":-e[1]/2+"px"});var a=d.canvas.width,n=d.canvas.height,o=g.getAreaType();if("circle"===o||"square"===o)n<a&&(a=n),n=a;else if("rectangle"===o&&l){var h=m.getAspect();h<a/n?a=h*n:n=h*a}if(u?m.setSize({w:a,h:n}):void 0!==m.getInitSize()?m.setSize({w:Math.min(m.getInitSize().w,a/2),h:Math.min(m.getInitSize().h,n/2)}):m.setSize({w:Math.min(200,a/2),h:Math.min(200,n/2)}),m.getInitCoords())if(g.areaInitIsRelativeToImage){var c=v.width/e[0];m.setSize({w:m.getInitSize().w/c,h:m.getInitSize().h/c,x:m.getInitCoords().x/c,y:m.getInitCoords().y/c})}else m.setSize({w:m.getSize().w,h:m.getSize().h,x:m.getInitCoords().x,y:m.getInitCoords().y});else m.setCenterPoint({x:d.canvas.width/2,y:d.canvas.height/2})}else p.prop("width",0).prop("height",0).css({"margin-top":0});C()}function h(e){return angular.isDefined(e.changedTouches)?e.changedTouches:e.originalEvent.changedTouches}function e(e){if(!m._disableCrop&&null!==v){var t,i,r=F(d.canvas);i="touchmove"===e.type?(t=h(e)[0].pageX,h(e)[0].pageY):(t=e.pageX,e.pageY),m.processMouseMove(t-r.left,i-r.top),C()}}function t(e){if(e.preventDefault(),!m._disableCrop&&(s.allowPropagation||e.stopPropagation(),null!==v)){x();var t,i,r=F(d.canvas);i="touchstart"===e.type?(t=h(e)[0].pageX,h(e)[0].pageY):(t=e.pageX,e.pageY),m.processMouseDown(t-r.left,i-r.top),C()}}function c(e){if(!m._disableCrop&&null!==v){var t,i,r=F(d.canvas);i="touchend"===e.type?(t=h(e)[0].pageX,h(e)[0].pageY):(t=e.pageX,e.pageY),m.processMouseUp(t-r.left,i-r.top),C()}}function R(e){if(!m._disableCrop&&null!==v&&!0!==s.disableKeyboardAccess){var t=e.which;switch(t){case o.up:case o.down:case o.left:case o.right:e.preventDefault(),e.stopPropagation();var i=function(i){return Object.keys(o).reduce(function(e,t){return i===o[t]?t:e},null)}(t);e.shiftKey?function(e){if(!m._disableCrop){var t;switch(e){case"up":case"left":t=.95;break;case"down":case"right":t=1.05;break;default:return}m.setSizeByScale(t,e),C()}}(i):function(e){if(!m._disableCrop){var t=m.getCenterPoint(),i={x:t.x,y:t.y};switch(e){case"up":i.y-=5;break;case"down":i.y+=5;break;case"left":i.x-=5;break;case"right":i.x+=5;break;default:return}m.setCenterPointOnMove(i),C()}}(i);break;default:return}}}function D(e,t){var i,r;if(i=(r=angular.element("<canvas></canvas>")[0]).getContext("2d"),r.width=e.w,r.height=e.h,null!==v){var s=(t.x-m.getSize().w/2)*(v.width/d.canvas.width),a=(t.y-m.getSize().h/2)*(v.height/d.canvas.height),n=m.getSize().w*(v.width/d.canvas.width),o=m.getSize().h*(v.height/d.canvas.height);if(S)i.drawImage(v,s,a,n,o,0,0,e.w,e.h);else{var h,c,u=n/o;1<u?h=(c=e.w)/u:c=(h=e.h)*u,r.width=c,r.height=h,i.drawImage(v,s,a,n,o,0,0,Math.round(c),Math.round(h))}}return r}function M(e){var t,i={dataURI:null,imageData:null};return t=D(e,m.getCenterPoint()),null!==v&&(i.dataURI=null!==n?t.toDataURL(z,n):t.toDataURL(z)),i}this.setInitMax=function(e){u=e},this.setAllowCropResizeOnCorners=function(e){m.setAllowCropResizeOnCorners(e)},this.setDisableCrop=function(e){m.setDisableCrop(e),C()},this.getResultImage=function(){if(0===i.length)return M(this.getResultImageSize());for(var e=[],t=0;t<i.length;t++)e.push({dataURI:M(i[t]).dataURI,w:i[t].w,h:i[t].h});return e},this.getResultImageDataBlob=function(){var e,t=A.defer();return e=D(this.getResultImageSize(),m.getCenterPoint()),null!==n?e.toBlob(function(e){t.resolve(e)},z,n):e.toBlob(function(e){t.resolve(e)},z),t.promise},this.getAreaCoords=function(){return m.getSize()},this.getArea=function(){return m},this.setNewImageSource=function(e){if(v=null,b(),e){var g=new Image;g.onload=function(){f.trigger("load-done"),L.getData(g,function(){var e=L.getTag(g,"Orientation");if(-1<[3,6,8].indexOf(e)){var t=document.createElement("canvas"),i=t.getContext("2d"),r=g.width,s=g.height,a=0,n=0,o=0,h=0,c=0;switch(h=r,c=s,e){case 3:a=-g.width,n=-g.height,o=180;break;case 6:r=g.height,s=g.width,n=-g.height,h=s,c=r,o=90;break;case 8:r=g.height,s=g.width,a=-g.width,h=s,c=r,o=270}var u=1e3;if(u<r||u<s){var l=0;u<r?(l=u/r,r=u,s*=l):u<s&&(l=u/s,s=u,r*=l),n*=l,a*=l,h*=l,c*=l}t.width=r,t.height=s,i.rotate(o*Math.PI/180),i.drawImage(g,a,n,h,c),(v=new Image).onload=function(){b(),f.trigger("image-updated")},v.src=t.toDataURL(z)}else v=g,f.trigger("image-updated");b()})},g.onerror=function(){f.trigger("load-error")},f.trigger("load-start"),e instanceof window.Blob?g.src=URL.createObjectURL(e):("http"!==e.substring(0,4).toLowerCase()&&"//"!==e.substring(0,2)||(g.crossOrigin="anonymous"),g.src=e)}},this.setMaxDimensions=function(e,t){if(y=[e,t],null!==v){var i=d.canvas.width,r=d.canvas.height,s=[0,0];if("fit"===_){var a=I(v.width,v.height);s=a.dims;var n=a.margins;p.css({"margin-left":n.left+"px","margin-top":n.top+"px"})}else{var o=[v.width,v.height],h=v.width/v.height;(s=o)[0]>y[0]?(s[0]=y[0],s[1]=s[0]/h):s[0]<w[0]&&(s[0]=w[0],s[1]=s[0]/h),"fixed-height"===_&&s[1]>y[1]?(s[1]=y[1],s[0]=s[1]*h):s[1]<w[1]&&(s[1]=w[1],s[0]=s[1]*h)}p.prop("width",s[0]).prop("height",s[1]),"fixed-height"===_&&p.css({"margin-left":-s[0]/2+"px","margin-top":-s[1]/2+"px"});var c=i?d.canvas.width/i:0,u=r?d.canvas.height/r:0,l=Math.min(c,u),g=m.getCenterPoint();m.setSize({w:m.getSize().w*l,h:m.getSize().h*l}),m.setCenterPoint({x:g.x*c,y:g.y*u})}else p.prop("width",0).prop("height",0).css({"margin-top":0});C()},this.setAreaMinSize=function(e){angular.isUndefined(e)||(e="number"==typeof e||"string"==typeof e?{w:parseInt(parseInt(e),10),h:parseInt(parseInt(e),10)}:{w:parseInt(e.w,10),h:parseInt(e.h,10)},isNaN(e.w)||isNaN(e.h)||(m.setMinSize(e),C()))},this.setAreaMinRelativeSize=function(e){if(null!==v&&!angular.isUndefined(e)){var t=m.getCanvasSize();e="number"==typeof e||"string"==typeof e?(a={w:e,h:e},{w:t.w/(v.width/parseInt(parseInt(e),10)),h:t.h/(v.height/parseInt(parseInt(e),10))}):(a=e,{w:t.w/(v.width/parseInt(parseInt(e.w),10)),h:t.h/(v.height/parseInt(parseInt(e.h),10))}),isNaN(e.w)||isNaN(e.h)||(m.setMinSize(e),C())}},this.setAreaInitSize=function(e){angular.isUndefined(e)||(e="number"==typeof e||"string"==typeof e?{w:parseInt(parseInt(e),10),h:parseInt(parseInt(e),10)}:{w:parseInt(e.w,10),h:parseInt(e.h,10)},isNaN(e.w)||isNaN(e.h)||(m.setInitSize(e),C()))},this.setAreaInitCoords=function(e){angular.isUndefined(e)||(e={x:parseInt(e.x,10),y:parseInt(e.y,10)},isNaN(e.x)||isNaN(e.y)||(m.setInitCoords(e),C()))},this.setMaxCanvasDimensions=function(e){if(!angular.isUndefined(e)){var t=[];t="number"==typeof e||"string"==typeof e?[parseInt(parseInt(e),10),parseInt(parseInt(e),10)]:[parseInt(e.w,10),parseInt(e.h,10)],!isNaN(t[0])&&0<t[0]&&t[0]>w[0]&&!isNaN(t[1])&&0<t[1]&&t[1]>w[1]&&(y=t)}},this.setMinCanvasDimensions=function(e){if(!angular.isUndefined(e)){var t=[];t="number"==typeof e||"string"==typeof e?[parseInt(parseInt(e),10),parseInt(parseInt(e),10)]:[parseInt(e.w,10),parseInt(e.h,10)],!isNaN(t[0])&&0<=t[0]&&!isNaN(t[1])&&0<=t[1]&&(w=t)}},this.setScalemode=function(e){_=e},this.getScalemode=function(){return _},this.getResultImageSize=function(){if("selection"===r)return m.getSize();if("max"!==r)return r;var e=1;v&&d&&d.canvas&&(e=v.width/d.canvas.width);var t={w:e*m.getSize().w,h:e*m.getSize().h};return a&&(t.w<a.w&&(t.w=a.w),t.h<a.h&&(t.h=a.h)),t},this.setResultImageSize=function(e){if(angular.isArray(e))return i=e.slice(),void(e={w:parseInt(e[0].w,10),h:parseInt(e[0].h,10)});angular.isUndefined(e)||(angular.isString(e)?r=e:(angular.isNumber(e)&&(e={w:e=parseInt(e,10),h:e}),e={w:parseInt(e.w,10),h:parseInt(e.h,10)},isNaN(e.w)||isNaN(e.h)||(r=e,C())))},this.setResultImageFormat=function(e){z=e},this.setResultImageQuality=function(e){e=parseFloat(e),!isNaN(e)&&0<=e&&e<=1&&(n=e)},this.getAreaType=function(){return m.getType()},this.setAreaType=function(e){var t=m.getCenterPoint(),i=m.getSize(),r=m.getMinSize(),s=t.x,a=t.y,n=B;"square"===e?n=H:"rectangle"===e&&(n=U),(m=new n(d,f)).setMinSize(r),m.setSize(i),"square"===e||"circle"===e?(S=!0,m.setForceAspectRatio(!0)):(S=!1,m.setForceAspectRatio(!1)),m.setCenterPoint({x:s,y:a}),null!==v&&m.setImage(v),C()},this.getDominantColor=function(e){var t=new Image,i=new ColorThief,r=null,s=A.defer();return t.src=e,t.onload=function(){r=i.getColor(t),s.resolve(r)},s.promise},this.getPalette=function(e){var t=new Image,i=new ColorThief,r=null,s=A.defer();return t.src=e,t.onload=function(){r=i.getPalette(t,N),s.resolve(r)},s.promise},this.setPaletteColorLength=function(e){N=e},this.setAspect=function(e){l=!0,m.setAspect(e);var t=m.getMinSize();t.w=t.h*e,m.setMinSize(t);var i=m.getSize();i.w=i.h*e,m.setSize(i)},d=p[0].getContext("2d"),m=new B(d,f),P.on("mousemove",e),p.on("mousedown",t),P.on("mouseup",c),P.on("touchmove",e),p.on("touchstart",t),P.on("touchend",c),p.prop("tabindex","0"),p.on("keydown",R),this.destroy=function(){P.off("mousemove",e),p.off("mousedown",t),P.off("mouseup",c),P.off("touchmove",e),p.off("touchstart",t),P.off("touchend",c),p.off("keydown",R),p.remove()}}}]),angular.module("uiCropper").factory("cropPubSub",[function(){return function(){var i={};this.on=function(e,t){return e.split(" ").forEach(function(e){i[e]||(i[e]=[]),i[e].push(t)}),this},this.trigger=function(e,t){return angular.forEach(i[e],function(e){e.call(null,t)}),this}}}]),angular.module("uiCropper").directive("uiCropper",["$timeout","cropHost","cropPubSub",function(h,c,t){return{restrict:"E",scope:{image:"=",resultImage:"=",resultArrayImage:"=?",resultBlob:"=?",urlBlob:"=?",chargement:"=?",cropject:"=?",maxCanvasDimensions:"=?",minCanvasDimensions:"=?",canvasScalemode:"@?",changeOnFly:"=?",disableKeyboardAccess:"=?",allowPropagation:"=?",liveView:"=?",initMaxArea:"=?",areaCoords:"=?",areaType:"@",areaMinSize:"=?",areaInitSize:"=?",areaInitCoords:"=?",areaInitIsRelativeToImage:"=?",areaMinRelativeSize:"=?",resultImageSize:"=?",resultImageFormat:"@",resultImageQuality:"=?",aspectRatio:"=?",allowCropResizeOnCorners:"=?",dominantColor:"=?",paletteColor:"=?",paletteColorLength:"=?",disableCrop:"=?",onChange:"&",onLoadBegin:"&",onLoadDone:"&",onLoadError:"&"},template:"<canvas></canvas>",controller:["$scope",function(e){e.events=new t}],link:function(i,r){var n,e=i.events,o=new c(r.find("canvas"),{disableKeyboardAccess:i.disableKeyboardAccess,allowPropagation:i.allowPropagation},e);function t(t,e,i){if(""!==t.image&&(!t.liveView.block||e)){var r,s=o.getResultImage();angular.isArray(s)?(r=s[0].dataURI,t.resultArrayImage=s):r=s.dataURI;var a=window.URL||window.webkitURL;n!==r&&(n=r,t.resultImage=r,t.liveView.callback&&t.liveView.callback(r),i&&i(r),o.getResultImageDataBlob().then(function(e){t.resultBlob=e,t.urlBlob=e?a.createObjectURL(e):null}),t.resultImage&&(o.getDominantColor(t.resultImage).then(function(e){t.dominantColor=e}),o.getPalette(t.resultImage).then(function(e){t.paletteColor=e})),function(e){e.areaCoords=o.getAreaCoords()}(t),t.onChange({$dataURI:t.resultImage}))}}function s(e){var t=o.getAreaCoords(),i=o.getArea().getImage().width/o.getArea().getCanvasSize().w,r=o.getArea().getImage().height/o.getArea().getCanvasSize().h;e.cropject={canvasSize:o.getArea().getCanvasSize(),areaCoords:t,cropWidth:t.w,cropHeight:t.h,cropTop:t.y,cropLeft:t.x,cropImageWidth:Math.round(t.w*i),cropImageHeight:Math.round(t.h*r),cropImageTop:Math.round(t.y*r),cropImageLeft:Math.round(t.x*i)}}function a(t){return function(){h(function(){i.$apply(function(e){t(e)})})}}i.canvasScalemode?o.setScalemode(i.canvasScalemode):o.setScalemode("fixed-height"),r.addClass(o.getScalemode()),i.liveView&&"boolean"==typeof i.liveView.block?i.liveView.render=function(e){t(i,!0,e)}:i.liveView={block:!1},i.chargement||(i.chargement=function(){switch(window.navigator.userLanguage||window.navigator.language){case"nl":case"nl_NL":return"Aan het laden";case"fr":case"fr-FR":return"Chargement";case"es":case"es-ES":return"Cargando";case"ca":case"ca-ES":return"Càrrega";case"de":case"de-DE":return"Laden";case"pt":case"pt-BR":return"Carregando";default:return"Loading"}}()),e.on("load-start",a(function(e){e.onLoadBegin({})})).on("load-done",a(function(e){var t=r.children();angular.forEach(t,function(e){angular.element(e).hasClass("loading")&&angular.element(e).remove()}),s(e),e.onLoadDone({})})).on("load-error",a(function(e){e.onLoadError({})})).on("area-move area-resize",a(function(e){!0===e.changeOnFly&&t(e),s(e)})).on("image-updated",a(function(e){o.setAreaMinRelativeSize(e.areaMinRelativeSize)})).on("area-move-end area-resize-end image-updated",a(function(e){t(e),s(e)})),i.$watch("image",function(e){o.getArea()&&(o.getArea()._size={x:0,y:0,w:0,h:0}),e&&r.append('<div class="loading"><span>'+i.chargement+"...</span></div>"),null!==i.timeout&&h.cancel(i.timeout),i.timeout=h(function(){i.timeout=null,o.setInitMax(i.initMaxArea),o.setNewImageSource(i.image)},100)}),i.$watch("areaType",function(){o.setAreaType(i.areaType),t(i)}),i.$watch("areaMinSize",function(){o.setAreaMinSize(i.areaMinSize),t(i)}),i.$watch("areaMinRelativeSize",function(){""!==i.image&&(o.setAreaMinRelativeSize(i.areaMinRelativeSize),t(i))}),i.$watch("areaInitSize",function(){o.setAreaInitSize(i.areaInitSize),t(i)}),i.$watch("areaInitCoords",function(){o.setAreaInitCoords(i.areaInitCoords),o.areaInitIsRelativeToImage=i.areaInitIsRelativeToImage,t(i)}),i.$watch("maxCanvasDimensions",function(){o.setMaxCanvasDimensions(i.maxCanvasDimensions)}),i.$watch("minCanvasDimensions",function(){o.setMinCanvasDimensions(i.minCanvasDimensions)}),i.$watch("resultImageFormat",function(){o.setResultImageFormat(i.resultImageFormat),t(i)}),i.$watch("resultImageQuality",function(){o.setResultImageQuality(i.resultImageQuality),t(i)}),i.$watch("resultImageSize",function(){o.setResultImageSize(i.resultImageSize),t(i)}),i.$watch("paletteColorLength",function(){o.setPaletteColorLength(i.paletteColorLength)}),i.$watch("aspectRatio",function(){"string"==typeof i.aspectRatio&&""!==i.aspectRatio&&(i.aspectRatio=parseFloat(i.aspectRatio)),i.aspectRatio&&o.setAspect(i.aspectRatio)}),i.$watch("allowCropResizeOnCorners",function(){i.allowCropResizeOnCorners&&o.setAllowCropResizeOnCorners(i.allowCropResizeOnCorners)}),i.$watch("disableCrop",function(){o.setDisableCrop(i.disableCrop)}),i.$watch(function(){return"fit"===o.getScalemode()?[r[0].clientWidth,r[0].clientHeight]:"fixed-height"===o.getScalemode()?[r[0].clientWidth,r[0].clientHeight]:"full-width"===o.getScalemode()?r[0].clientWidth:void 0},function(e){"fit"===o.getScalemode()&&(o.setMaxDimensions(e[0],e[1]),t(i)),"fixed-height"===o.getScalemode()&&0<e[0]&&0<e[1]&&(o.setMaxDimensions(e[0],e[1]),t(i)),"full-width"===o.getScalemode()&&0<e&&o.setMaxDimensions(e)},!0),i.$on("$destroy",function(){o.destroy()})}}}]),function(e){"use strict";var u,l=e.Uint8Array,t=e.HTMLCanvasElement,i=t&&t.prototype,h=/\s*;\s*base64\s*(?:;|$)/i,c="toDataURL";l&&(u=new l([62,-1,-1,-1,63,52,53,54,55,56,57,58,59,60,61,-1,-1,-1,0,-1,-1,-1,0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,-1,-1,-1,-1,-1,-1,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51])),t&&!i.toBlob&&(i.toBlob=function(e,t){if(t||(t="image/png"),this.mozGetAsFile)e(this.mozGetAsFile("canvas",t));else if(this.msToBlob&&/^\s*image\/png\s*(?:$|;)/i.test(t))e(this.msToBlob());else{var i,r=Array.prototype.slice.call(arguments,1),s=this[c].apply(this,r),a=s.indexOf(","),n=s.substring(a+1),o=h.test(s.substring(0,a));Blob.fake?((i=new Blob).encoding=o?"base64":"URI",i.data=n,i.size=n.length):l&&(i=o?new Blob([function(e){for(var t,i,r=e.length,s=new l(r/4*3|0),a=0,n=0,o=[0,0],h=0,c=0;r--;)i=e.charCodeAt(a++),255!==(t=u[i-43])&&void 0!==t&&(o[1]=o[0],o[0]=i,c=c<<6|t,4===++h&&(s[n++]=c>>>16,61!==o[1]&&(s[n++]=c>>>8),61!==o[0]&&(s[n++]=c),h=0));return s}(n)],{type:t}):new Blob([decodeURIComponent(n)],{type:t})),void 0!==e&&e(i)}},i.toDataURLHD?i.toBlobHD=function(){c="toDataURLHD";var e=this.toBlob();return c="toDataURL",e}:i.toBlobHD=i.toBlob)}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||this.content||this),function(){function f(e){this.canvas=document.createElement("canvas"),this.context=this.canvas.getContext("2d"),document.body.appendChild(this.canvas),this.width=this.canvas.width=e.width,this.height=this.canvas.height=e.height,this.context.drawImage(e,0,0,this.width,this.height)}f.prototype.clear=function(){this.context.clearRect(0,0,this.width,this.height)},f.prototype.update=function(e){this.context.putImageData(e,0,0)},f.prototype.getPixelCount=function(){return this.width*this.height},f.prototype.getImageData=function(){return this.context.getImageData(0,0,this.width,this.height)},f.prototype.removeCanvas=function(){this.canvas.parentNode.removeChild(this.canvas)};function e(){}if((window.ColorThief=e).prototype.getColor=function(e,t){return this.getPalette(e,5,t)[0]},e.prototype.getPalette=function(e,t,i){void 0===t&&(t=10),(void 0===i||i<1)&&(i=10);for(var r,s,a,n,o=new f(e),h=o.getImageData().data,c=o.getPixelCount(),u=[],l=0;l<c;l+=i)s=h[0+(r=4*l)],a=h[1+r],n=h[2+r],125<=h[3+r]&&(250<s&&250<a&&250<n||u.push([s,a,n]));var g=v.quantize(u,t),p=g?g.palette():null;return o.removeCanvas(),p},!d)var d={map:function(e,i){var r={};return i?e.map(function(e,t){return r.index=t,i.call(r,e)}):e.slice()},naturalOrder:function(e,t){return e<t?-1:t<e?1:0},sum:function(e,r){var s={};return e.reduce(r?function(e,t,i){return s.index=i,e+r.call(s,t)}:function(e,t){return e+t},0)},max:function(e,t){return Math.max.apply(null,t?d.map(e,t):e)}};var g,l,v=(l=8-(g=5),p.prototype={volume:function(e){var t=this;return t._volume&&!e||(t._volume=(t.r2-t.r1+1)*(t.g2-t.g1+1)*(t.b2-t.b1+1)),t._volume},count:function(e){var t=this,i=t.histo;if(!t._count_set||e){var r,s,a,n=0;for(r=t.r1;r<=t.r2;r++)for(s=t.g1;s<=t.g2;s++)for(a=t.b1;a<=t.b2;a++)n+=i[m(r,s,a)]||0;t._count=n,t._count_set=!0}return t._count},copy:function(){var e=this;return new p(e.r1,e.r2,e.g1,e.g2,e.b1,e.b2,e.histo)},avg:function(e){var t=this,i=t.histo;if(!t._avg||e){var r,s,a,n,o=0,h=1<<8-g,c=0,u=0,l=0;for(s=t.r1;s<=t.r2;s++)for(a=t.g1;a<=t.g2;a++)for(n=t.b1;n<=t.b2;n++)o+=r=i[m(s,a,n)]||0,c+=r*(s+.5)*h,u+=r*(a+.5)*h,l+=r*(n+.5)*h;t._avg=o?[~~(c/o),~~(u/o),~~(l/o)]:[~~(h*(t.r1+t.r2+1)/2),~~(h*(t.g1+t.g2+1)/2),~~(h*(t.b1+t.b2+1)/2)]}return t._avg},contains:function(e){var t=this,i=e[0]>>l;return gval=e[1]>>l,bval=e[2]>>l,i>=t.r1&&i<=t.r2&&gval>=t.g1&&gval<=t.g2&&bval>=t.b1&&bval<=t.b2}},c.prototype={push:function(e){this.vboxes.push({vbox:e,color:e.avg()})},palette:function(){return this.vboxes.map(function(e){return e.color})},size:function(){return this.vboxes.size()},map:function(e){for(var t=this.vboxes,i=0;i<t.size();i++)if(t.peek(i).vbox.contains(e))return t.peek(i).color;return this.nearest(e)},nearest:function(e){for(var t,i,r,s=this.vboxes,a=0;a<s.size();a++)((i=Math.sqrt(Math.pow(e[0]-s.peek(a).color[0],2)+Math.pow(e[1]-s.peek(a).color[1],2)+Math.pow(e[2]-s.peek(a).color[2],2)))<t||void 0===t)&&(t=i,r=s.peek(a).color);return r},forcebw:function(){var e=this.vboxes;e.sort(function(e,t){return d.naturalOrder(d.sum(e.color),d.sum(t.color))});var t=e[0].color;t[0]<5&&t[1]<5&&t[2]<5&&(e[0].color=[0,0,0]);var i=e.length-1,r=e[i].color;251<r[0]&&251<r[1]&&251<r[2]&&(e[i].color=[255,255,255])}},{quantize:function(e,t){if(!e.length||t<2||256<t)return!1;var h=function(e){var t,i,r,s,a=new Array(1<<3*g);return e.forEach(function(e){i=e[0]>>l,r=e[1]>>l,s=e[2]>>l,t=m(i,r,s),a[t]=(a[t]||0)+1}),a}(e);h.forEach(function(){});var i=function(e,t){var i,r,s,a=1e6,n=0,o=1e6,h=0,c=1e6,u=0;return e.forEach(function(e){i=e[0]>>l,r=e[1]>>l,s=e[2]>>l,i<a?a=i:n<i&&(n=i),r<o?o=r:h<r&&(h=r),s<c?c=s:u<s&&(u=s)}),new p(a,n,o,h,c,u,t)}(e,h),r=new o(function(e,t){return d.naturalOrder(e.count(),t.count())});function s(e,t){for(var i,r=1,s=0;s<1e3;)if((i=e.pop()).count()){var a=u(h,i),n=a[0],o=a[1];if(!n)return;if(e.push(n),o&&(e.push(o),r++),t<=r)return;if(1e3<s++)return}else e.push(i),s++}r.push(i),s(r,.75*t);for(var a=new o(function(e,t){return d.naturalOrder(e.count()*e.volume(),t.count()*t.volume())});r.size();)a.push(r.pop());s(a,t-a.size());for(var n=new c;a.size();)n.push(a.pop());return n}});function m(e,t,i){return(e<<2*g)+(t<<g)+i}function o(e){var t=[],i=!1;function r(){t.sort(e),i=!0}return{push:function(e){t.push(e),i=!1},peek:function(e){return i||r(),void 0===e&&(e=t.length-1),t[e]},pop:function(){return i||r(),t.pop()},size:function(){return t.length},map:function(e){return t.map(e)},debug:function(){return i||r(),t}}}function p(e,t,i,r,s,a,n){var o=this;o.r1=e,o.r2=t,o.g1=i,o.g2=r,o.b1=s,o.b2=a,o.histo=n}function c(){this.vboxes=new o(function(e,t){return d.naturalOrder(e.vbox.count()*e.vbox.volume(),t.vbox.count()*t.vbox.volume())})}function u(e,c){if(c.count()){var t=c.r2-c.r1+1,i=c.g2-c.g1+1,r=c.b2-c.b1+1,s=d.max([t,i,r]);if(1==c.count())return[c.copy()];var u,a,n,o,l=0,g=[],p=[];if(s==t)for(u=c.r1;u<=c.r2;u++){for(o=0,a=c.g1;a<=c.g2;a++)for(n=c.b1;n<=c.b2;n++)o+=e[m(u,a,n)]||0;l+=o,g[u]=l}else if(s==i)for(u=c.g1;u<=c.g2;u++){for(o=0,a=c.r1;a<=c.r2;a++)for(n=c.b1;n<=c.b2;n++)o+=e[m(a,u,n)]||0;l+=o,g[u]=l}else for(u=c.b1;u<=c.b2;u++){for(o=0,a=c.r1;a<=c.r2;a++)for(n=c.g1;n<=c.g2;n++)o+=e[m(a,n,u)]||0;l+=o,g[u]=l}return g.forEach(function(e,t){p[t]=l-e}),h(s==t?"r":s==i?"g":"b")}function h(e){var t,i,r,s,a,n=e+"1",o=e+"2",h=0;for(u=c[n];u<=c[o];u++)if(g[u]>l/2){for(r=c.copy(),s=c.copy(),a=(t=u-c[n])<=(i=c[o]-u)?Math.min(c[o]-1,~~(u+i/2)):Math.max(c[n],~~(u-1-t/2));!g[a];)a++;for(h=p[a];!h&&g[a-1];)h=p[--a];return r[o]=a,s[n]=r[o]+1,[r,s]}}} true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return e}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=e:this.ColorThief=e}.call(this),function(){function f(e,t,i,r){var s=e.naturalWidth,a=e.naturalHeight;if(s+a!==!1){var n=i.width,o=i.height,h=t.getContext("2d");h.save(),function(e,t,i,r,s){switch(s){case 5:case 6:case 7:case 8:e.width=r,e.height=i;break;default:e.width=i,e.height=r}switch(s){case 2:t.translate(i,0),t.scale(-1,1);break;case 3:t.translate(i,r),t.rotate(Math.PI);break;case 4:t.translate(0,r),t.scale(1,-1);break;case 5:t.rotate(.5*Math.PI),t.scale(1,-1);break;case 6:t.rotate(.5*Math.PI),t.translate(0,-r);break;case 7:t.rotate(.5*Math.PI),t.translate(i,-r),t.scale(-1,1);break;case 8:t.rotate(-.5*Math.PI),t.translate(-i,0)}}(t,h,n,o,i.orientation),function(e){var t=e.naturalWidth;if(1048576<t*e.naturalHeight){var i=document.createElement("canvas");i.width=i.height=1;var r=i.getContext("2d");return r.drawImage(e,1-t,0),0===r.getImageData(0,0,1,1).data[3]}return!1}(e)&&(s/=2,a/=2);var c=1024,u=document.createElement("canvas");u.width=u.height=c;for(var l=u.getContext("2d"),g=r?function(e,t,i){var r=document.createElement("canvas");r.width=1,r.height=i;var s=r.getContext("2d");s.drawImage(e,0,0);for(var a=s.getImageData(0,0,1,i).data,n=0,o=i,h=i;n<h;){0===a[4*(h-1)+3]?o=h:n=h,h=o+n>>1}var c=h/i;return 0==c?1:c}(e,0,a):1,p=Math.ceil(c*n/s),f=Math.ceil(c*o/a/g),d=0,v=0;d<a;){for(var m=0,w=0;m<s;)l.clearRect(0,0,c,c),l.drawImage(e,-m,-d),h.drawImage(u,0,0,c,c,w,v,p,f),m+=c,w+=p;d+=c,v+=f}h.restore(),u=l=null}}var d=window.URL&&window.URL.createObjectURL?window.URL:window.webkitURL&&window.webkitURL.createObjectURL?window.webkitURL:null;function e(e){if(window.Blob&&e instanceof Blob){if(!d)throw Error("No createObjectURL function found to create blob url");var t=new Image;t.src=d.createObjectURL(e),this.blob=e,e=t}if(!e.naturalWidth&&!e.naturalHeight){var r=this;e.onload=e.onerror=function(){var e=r.imageLoadListeners;if(e){r.imageLoadListeners=null;for(var t=0,i=e.length;t<i;t++)e[t]()}},this.imageLoadListeners=[]}this.srcImage=e}e.prototype.render=function(e,t,i){if(this.imageLoadListeners){var r=this;this.imageLoadListeners.push(function(){r.render(e,t,i)})}else{t=t||{};var s=this.srcImage.naturalWidth,a=this.srcImage.naturalHeight,n=t.width,o=t.height,h=t.maxWidth,c=t.maxHeight,u=!this.blob||"image/jpeg"===this.blob.type;n&&!o?o=a*n/s<<0:o&&!n?n=s*o/a<<0:(n=s,o=a),h&&h<n&&(o=a*(n=h)/s<<0),c&&c<o&&(n=s*(o=c)/a<<0);var l={width:n,height:o};for(var g in t)l[g]=t[g];var p=e.tagName.toLowerCase();"img"===p?e.src=function(e,t,i){var r=document.createElement("canvas");return f(e,r,t,i),r.toDataURL("image/jpeg",t.quality||.8)}(this.srcImage,l,u):"canvas"===p&&f(this.srcImage,e,l,u),"function"==typeof this.onrender&&this.onrender(e),i&&i(),this.blob&&(this.blob=null,d.revokeObjectURL(this.srcImage.src))}}, true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return e}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=e:this.MegaPixImage=e}.call(this);

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(685);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/bower_components/ui-cropper/compile/minified/ui-cropper.css", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/bower_components/ui-cropper/compile/minified/ui-cropper.css");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "ui-cropper{width:100%;display:block}ui-cropper.fixed-height{height:100%;position:relative;overflow:hidden}ui-cropper.fixed-height canvas{display:block;position:absolute;top:50%;left:50%}ui-cropper.full-width{text-align:center}ui-cropper.full-width canvas{display:inline}ui-cropper canvas{outline:0;-webkit-tap-highlight-color:rgba(255,255,255,0)}ui-cropper .loading{width:100%;font-size:16px;font-weight:700;display:-webkit-box;display:-ms-flexbox;display:flex;display:-webkit-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-justify-content:center;color:#fff;background-color:rgba(0,0,0,.75)}ui-cropper .loading .fixed-height{height:100%;position:absolute}", ""]);

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	var CourseListModalCtrl, EventScoreCardDirective, GroupEventDetailCtrl, GroupEventEditCtrl, GroupEventListCtrl, GroupEventRankCtrl, GroupEventRegistCtrl, GroupEventService, GroupEventSubmitScoreCtrl, GroupRegisDataService, GroupUploadDataService, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(386);
	
	__webpack_require__(682);
	
	__webpack_require__(59);
	
	__webpack_require__(72);
	
	__webpack_require__(108);
	
	__webpack_require__(82);
	
	__webpack_require__(112);
	
	__webpack_require__(412);
	
	__webpack_require__(90);
	
	__webpack_require__(76);
	
	__webpack_require__(687);
	
	__webpack_require__(688);
	
	__webpack_require__(692);
	
	__webpack_require__(695);
	
	__webpack_require__(699);
	
	__webpack_require__(705);
	
	__webpack_require__(706);
	
	__webpack_require__(713);
	
	__webpack_require__(716);
	
	__webpack_require__(719);
	
	GroupEventEditCtrl = __webpack_require__(725);
	
	GroupEventRegistCtrl = __webpack_require__(726);
	
	GroupEventListCtrl = __webpack_require__(727);
	
	GroupEventDetailCtrl = __webpack_require__(728);
	
	GroupEventSubmitScoreCtrl = __webpack_require__(729);
	
	CourseListModalCtrl = __webpack_require__(730);
	
	GroupEventRankCtrl = __webpack_require__(731);
	
	GroupRegisDataService = __webpack_require__(732);
	
	GroupUploadDataService = __webpack_require__(733);
	
	GroupEventService = __webpack_require__(734);
	
	EventScoreCardDirective = __webpack_require__(735);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-common-wrapper', 'gnp-remote-api', 'gnp-form', 'gnp-flash', 'gnp-animate', 'gnp-error-handler', 'uiCropper'];
	
	angular.module('gnp-app-group-event', modules).config([
	  '$routeProvider', '$translateProvider', function($routeProvider, $translateProvider) {
	    $translateProvider.translations('en', __webpack_require__(738)).translations('ja', __webpack_require__(739));
	    return $routeProvider.when('/group-event/registration', {
	      controller: 'GroupEventRegistCtrl',
	      templateUrl: 'web/group-event/registration.jade',
	      title: '_GROUP_EVENT.TITLE_CREATE',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        groupInfo: [
	          'groupRegisDataService', '$route', '$location', function(groupRegisDataService, $route, $location) {
	            if ($route.current.params.id === void 0) {
	              return;
	            }
	            return groupRegisDataService.getGroup($route.current.params.id).then(function(data) {
	              return data;
	            }, function(error) {
	              return $location.path('/groups');
	            });
	          }
	        ]
	      }
	    }).when('/group-event/:id/edit', {
	      controller: 'GroupEventEditCtrl',
	      templateUrl: 'web/group-event/edit.jade',
	      title: '_GROUP_EVENT.TITLE_EDIT',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        detailData: [
	          'groupEventService', '$route', '$location', function(groupEventService, $route, $location) {
	            if ($route.current.params.id === void 0) {
	              return;
	            }
	            return groupEventService.getDataEventDetail($route.current.params.id).then(function(data) {
	              return data;
	            }, function(error) {
	              return $location.path('/groups');
	            });
	          }
	        ]
	      }
	    }).when('/group-event/:id/scorecards', {
	      controller: 'GroupEventSubmitScoreCtrl',
	      templateUrl: 'web/group-event/score_submit.jade',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        detailData: [
	          'groupEventService', '$route', '$location', function(groupEventService, $route, $location) {
	            if ($route.current.params.id === void 0) {
	              return;
	            }
	            return groupEventService.getDataEventDetail($route.current.params.id).then(function(data) {
	              return data;
	            }, function(error) {
	              return $location.path('/groups');
	            });
	          }
	        ]
	      }
	    }).when('/group-event/:id/ranking', {
	      controller: 'GroupEventRankCtrl',
	      templateUrl: 'web/group-event/event-rank.jade',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        detailData: [
	          'groupEventService', '$route', '$location', function(groupEventService, $route, $location) {
	            if ($route.current.params.id === void 0) {
	              return;
	            }
	            return groupEventService.getDataEventDetail($route.current.params.id).then(function(data) {
	              return data;
	            }, function(error) {
	              return $location.path('/groups');
	            });
	          }
	        ]
	      }
	    }).when('/group-event/:id', {
	      controller: 'GroupEventDetailCtrl',
	      templateUrl: 'web/group-event/detail.jade',
	      permission: {
	        signInRequired: true
	      },
	      resolve: {
	        detailData: [
	          'groupEventService', '$route', '$location', function(groupEventService, $route, $location) {
	            if ($route.current.params.id === void 0) {
	              return;
	            }
	            return groupEventService.getDataEventDetail($route.current.params.id).then(function(data) {
	              return data;
	            }, function(error) {
	              return $location.path('/groups');
	            });
	          }
	        ]
	      }
	    });
	  }
	]).factory('groupRegisDataService', GroupRegisDataService).factory('groupUploadDataService', GroupUploadDataService).factory('groupEventService', GroupEventService).controller('GroupEventEditCtrl', GroupEventEditCtrl).controller('GroupEventRegistCtrl', GroupEventRegistCtrl).controller('GroupEventListCtrl', GroupEventListCtrl).controller('GroupEventDetailCtrl', GroupEventDetailCtrl).controller('GroupEventSubmitScoreCtrl', GroupEventSubmitScoreCtrl).controller('CourseListModalCtrl', CourseListModalCtrl).controller('GroupEventRankCtrl', GroupEventRankCtrl).directive('eventRankScoreCard', EventScoreCardDirective);


/***/ }),
/* 687 */
/***/ (function(module, exports) {

	var v1="<form id=\"group-event-page\" gnp-common-wrapper-b=\"\" name=\"eventForm\" gnp-submit=\"submit(eventInfo)\" novalidate=\"\"><div id=\"top-page\" gnp-indicator=\"isSubmitting\"><div id=\"group-cover-container\"><img id=\"coverPhoto\" ng-src=\"{{ croppedCoverPhoto }}\" class=\"coverPhoto\"/><div class=\"rowContainer innerBottomShadow\"><div id=\"centered\"><span ng-if=\"!croppedCoverPhoto\" class=\"title\">{{ :: '_GROUP_EVENT.CUSTOMIZE_EVENT' | translate }}<br/>{{ :: '_GROUP_EVENT.ADD_COVER_IMAGE' | translate }}</span><div class=\"row\"><br/></div><div class=\"row\"><div class=\"col-12\"><button type=\"button\" ng-class=\"{ btnOpacity : croppedCoverPhoto }\" ng-click=\"chooseCover()\" class=\"btn btn-primary btn-lg btn-block btnSelectCover\">{{ :: '_GROUP_EVENT.SELECT_PHOTO' | translate }}<span class=\"caret\"></span></button></div></div></div></div></div><div id=\"group-content-container\"><div class=\"container-fluid\"><div class=\"d-none d-sm-block row header\"><h3 class=\"card-title\"> {{ :: '_GROUP_EVENT.CREATE_TITLE' | translate }}</h3></div><div class=\"row\"><div class=\"form-horizontal col-12\"><div class=\"form-group row\"><label class=\"col-sm-2 col-form-label\">{{ :: '_GROUP_EVENT.EVENT_NAME' | translate }}</label><div class=\"col-sm-9\"><input type=\"text\" name=\"eventName\" ng-model=\"eventInfo.name\" required=\"\" class=\"form-control\"/><div ng-show=\"eventForm.eventName.$invalid &amp;&amp; !eventForm.eventName.$pristine\" class=\"error\"><div ng-show=\"eventForm.eventName.$error.required\">{{ ::\"VALIDATION.REQUIRED\" | translate }}</div></div></div></div><div class=\"form-group rowDate row\"><label class=\"col-sm-2 col-form-label\">{{ :: '_GROUP_EVENT.PERIOD_NAME' | translate }}</label><div class=\"col-sm-9 rowDate\">{{ :: '_GROUP_EVENT.START_DATE' | translate }}<label for=\"txtStartDate\" class=\"calendar\">cal</label><input type=\"text\" name=\"startDate\" id=\"txtStartDate\" ng-model=\"startDate\" readonly=\"true\"/></div></div><div class=\"form-group row\"><label class=\"col-sm-2 col-form-label\"></label><div class=\"col-sm-9 rowDate\">{{ :: '_GROUP_EVENT.END_DATE' | translate }}<label for=\"txtEndDate\" class=\"calendar\">cal</label><input type=\"text\" name=\"endDate\" id=\"txtEndDate\" ng-model=\"endDate\" readonly=\"true\"/><div ng-show=\"eventForm.endDate.$invalid &amp;&amp; (!eventForm.endDate.$pristine || !eventForm.startDate.$pristine )\" class=\"error\"><div ng-show=\"eventForm.endDate.$error.dateValid\">{{ :: '_GROUP_EVENT.VALID_DATE' | translate }}</div></div></div></div><div class=\"form-group row\"><label class=\"col-sm-2 col-form-label\">{{ :: '_GROUP_EVENT.LOCATION' | translate }}</label><div class=\"col-sm-9\"><input type=\"text\" name=\"eventLocation\" ng-model=\"eventInfo.location\" class=\"form-control\"/></div></div><div class=\"form-group row\"><label class=\"col-sm-2 col-form-label\">{{ :: '_GROUP_EVENT.DESCRIPTION' | translate }}</label><div class=\"col-sm-9\"><textarea name=\"eventDescription\" style=\"resize:none ; height:85px\" ng-model=\"eventInfo.description\" class=\"form-control\"></textarea></div></div><div class=\"row\"><div class=\"d-none d-sm-block col-sm-6\"></div><div class=\"col-12 col-sm-6 row no-margin\"><div class=\"col-6\"><button type=\"button\" ng-click=\"buttonCancelClick()\" class=\"btn btn-primary btn-lg btn-block btnCancel\">{{ :: '_GROUP_EVENT.CANCEL' | translate }}</button></div><div class=\"col-6\"><button type=\"submit\" gnp-submitting-button=\"isSubmitting\" class=\"btn btn-primary btn-lg btn-block btnCreate\">{{ :: '_GROUP_EVENT.SAVE' | translate }}</button></div></div></div></div></div></div></div><div tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\" data-backdrop=\"static\" data-keyboard=\"false\" class=\"crop-image-modal modal fade\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header row\"><div class=\"col-3\"><button type=\"button\" ng-click=\"cancelCropModal()\" class=\"float-left\">{{ :: '_GROUP_EVENT.CROP.CANCEL' | translate }}</button></div><div class=\"col-6\"><div class=\"text-center modal-heading\">{{ :: '_GROUP_EVENT.CROP.TITLE' | translate }}</div></div><div class=\"col-3\"><button type=\"button\" ng-click=\"submitCropModal()\" class=\"float-right\">{{ :: '_GROUP_EVENT.CROP.DONE' | translate }}</button></div></div><div class=\"modal-body\"><div class=\"cropArea\"><ui-cropper image=\"coverPhoto\" result-image=\"$parent.croppedCoverPhoto\" result-blob=\"$parent.croppedCoverPhotoBlob\" area-type=\"rectangle\" result-image-size=\"{w: 970,h: 250}\" area-init-size=\"{w: 970,h: 250}\"></ui-cropper></div></div></div></div></div></div></form>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-event/registration.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"group-event-list\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-12 col-md-4 offset-md-8 btnCreateEvent\"><button ng-show=\"listEventCtrl.showCreateButton\" ng-click=\"listEventCtrl.goToCreatePage()\" class=\"btn-primary btn-lg btn-block\"><img src=\"" + __webpack_require__(689) + "\"/>{{ :: '_GROUP_EVENT.CREATE_EVENT' | translate }}</button></div></div><div class=\"row\"><div class=\"col-12 row-title\"><h3 class=\"card-title\">{{ :: '_GROUP_EVENT.EVENT_LIST' | translate }}</h3></div><div ng-repeat=\"event in listEventCtrl.lstEvents\" ng-click=\"listEventCtrl.gotoEventDetail(event.id)\" class=\"col-12 row-content\"><div class=\"imgContainer\"><img lazy-img=\"{{ event.cover_url }}\" src=\"" + __webpack_require__(690) + "\" class=\"rounded-circle\"/></div><div class=\"titleContainer\"><span class=\"name\">{{ event.name }}</span><span class=\"time\">{{ listEventCtrl.displayPeriod(event.start_date, event.end_date) }}</span><span class=\"members\"><i>{{ listEventCtrl.displayParticipants(event.participant) }}</i><i>{{ listEventCtrl.displayNoParticipants(event.non_participant) }}</i></span></div><div ng-if=\"listEventCtrl.showCreateButton\" class=\"buttonContainer\"><button ng-if=\"event.owner || listEventCtrl.groupAdmin\" ng-click=\"listEventCtrl.gotoEditEventDetail(event.id , $event)\" class=\"btn-group btn-Setting\">{{ :: '_GROUP.LIST.EDIT_GROUP' | translate }}</button><button ng-if=\"event.owner || listEventCtrl.groupAdmin\" ng-click=\"listEventCtrl.deleteEvent(event.id , $event)\" class=\"btn-group btnDelete\"><img src=\"" + __webpack_require__(691) + "\"/>{{ :: '_GROUP_EVENT.DELETE' | translate }}</button></div></div></div><div ng-show=\"listEventCtrl.hasMore()\" class=\"row loadMoreRegion\"><button ng-class=\"{ loading : listEventCtrl.isLoading }\" ng-click=\"listEventCtrl.loadMore()\" gnp-indicator=\"listEventCtrl.isLoading\" class=\"btn btn-primary btn-lg btn-loadMore\">{{:: 'SHOW_MORE' | translate }}</button></div><div ng-show=\"listEventCtrl.noResults\" class=\"row loadMoreRegion\"><h3 class=\"card-title\">{{ :: '_GROUP.NO_DATA' | translate }}</h3></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-event/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAMAAADX9CSSAAAAUVBMVEUAAAAbraz///8brawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrayipQngAAAAGnRSTlMAAAABAwcIEB9WX4CIkKWmrLPAyNDe6e7v89c0bgkAAACQSURBVCjPtZHLEoIwDEWDUgqk8giFQv7/Q02KopWOG8ezyJ2exe1MAlAobag0qtAWFwGE6JGthmU8vLGC41qjZqdh1Ac+EdQzISKxk4nu8YgepbiZjfabuZF+fPk3Dp8h+un2wfS95+n7Pu+JfvcdEa2rjC7x19F7v20yxv/8qwxD3pdl6vUUCftdlvOaF4A7QEkSvfYoMKcAAAAASUVORK5CYII="

/***/ }),
/* 690 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 691 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAZCAMAAADkFeWYAAAA/FBMVEX/b2D/////b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2D/b2ARct7XAAAAU3RSTlMAAAUGBwgLEBQdIiMsLzAxNjg5OkBIS0xOT1BRUlRXXWBlZ2pscHJzdH2Cg5CRmJmgrK6vtLW4ub2+wMTJysvM0NHT1trg4uXm5+jp6+zt8fLz9+pky+EAAAEGSURBVBgZBcHRbgxRGADgb/7/zMxuYqtlU73Q5/AAwmu7FPdcatIQbKM0JKwzc876vgFMLy7h7l01UMD55afKdH1+BwUUN9/ZXxcQAAAYXu8AAH7ntmw+r9s/X/8+OvzI6ef92cO38v54/mH/5O3D/urmy9mr28Pz249hMTcFhDZbhCpWAYoWqrDYLkaQlq1FqLIbwWhNi7CaVwGKNluELpoEoYUuVNkVkFqqQj9lN4Ci5+kkOGYXIPQ8EtRpEWDQxkpQJy1AWudKUEctwLAaK0GdHQNEMy8EfdYnEP/MjWAdsiWYeg4rQTfWBNlGneTiWXm62+wf5/4qNxeHewO7lwlAe/PLfzWCZiUFKol5AAAAAElFTkSuQmCC"

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"event-detail-page\" gnp-common-wrapper-b=\"\"><div id=\"top-page\"><div id=\"group-cover-container\"><img ng-src=\"{{ eventDetail.cover_url }}\" class=\"coverPhoto\"/><div class=\"titleRegion\"><span class=\"groupName\">{{ groupDetail.name }}</span><span class=\"eventName\">{{ eventDetail.name }}</span><span class=\"eventPirod\">{{ displayPeriod(eventDetail.start_date , eventDetail.end_date ) }}</span></div></div><div id=\"group-content-container\"><div class=\"container-fluid\"><ul ng-init=\"tab = 2\" class=\"nav nav-tabs\"><li ng-class=\"{active: tab === 1}\"><a ng-click=\"gotoTimelineTab()\">{{ :: '_GROUP.DETAIL_TABS.TIMELINE' | translate }}</a></li><li ng-class=\"{active: tab === 2}\"><a ng-click=\"gotoEventTab()\">{{ :: '_GROUP.DETAIL_TABS.EVENT' | translate }}</a></li></ul><div class=\"tab-content\"><div id=\"eventTab\"><div class=\"container-fluid\"><div class=\"row descripion\"><p>{{ eventDetail.description }}</p></div><div class=\"row partMem\"><p><span>{{ displayParticipants(eventDetail.participant) }}</span><span>{{ displayNoParticipants(eventDetail.non_participant) }}</span></p></div><div class=\"row\"><div class=\"col-6\"><button ng-click=\"gotoSubmit()\" class=\"btn-primary btn-lg btn-block btnSubmitScore\"><img src=\"" + __webpack_require__(693) + "\"/>{{ :: '_GROUP_EVENT.SELECT_SCORE_CARD' | translate }}</button></div><div class=\"col-6\"><button ng-click=\"gotoEventRank()\" class=\"btn-primary btn-lg btn-block btnViewRank\"><img src=\"" + __webpack_require__(694) + "\"/>{{ :: '_GROUP_EVENT.VIEW_RANK' | translate }}</button></div></div><div class=\"row title\"><div class=\"col-12 row-title\"><h3 class=\"card-title\">{{ :: '_GROUP_EVENT.LIST_SUBMITTED_SCORE' | translate }}</h3></div></div><div class=\"row mainContent\"><div ng-repeat=\"scoreCard in lstScoreCards\" class=\"col-12 row-content\"><div class=\"cell weatherCell\"><div class=\"span date\">{{ :: scoreCard.play_date | date:'yyyy/MM/dd'}}</div><div class=\"weather-icon icons-{{ scoreCard.weather }}\"></div></div><div class=\"cell scoreCell\"><div class=\"rounded-circle\"><div class=\"score\"><span class=\"shot\">{{ scoreCard.total_shot }}<span class=\"putt\">{{ scoreCard.total_putt == 0 ? \"\" : scoreCard.total_putt }}</span></span></div></div></div><div class=\"cell descripionCell\"><span class=\"clubName\">{{ scoreCard.club_name }}</span><span class=\"clubAddress\">{{ scoreCard.address }}</span><button ng-click=\"removeScoreCard(scoreCard.id , $index)\" class=\"btnDelete\"><img src=\"" + __webpack_require__(691) + "\"/>{{ :: '_GROUP_EVENT.DELETE' | translate }}</button></div></div></div><div ng-show=\"hasMore()\" class=\"row loadMoreRegion\"><button ng-class=\"{ loading : isLoading }\" ng-click=\"loadMore()\" gnp-indicator=\"isLoading\" class=\"btn btn-primary btn-lg btn-loadMore\">{{:: 'SHOW_MORE' | translate }}</button></div></div></div></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-event/detail.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 693 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAeCAYAAAA2Lt7lAAABeklEQVRIie3WPWsUURTG8V9CTCGoCDaiXVIaEGsbEQKCgRSW1tZ+AAs/whYWYivpREQtfUVBtBIs0ohEIim0cUUixJjHYi84DJvd2ZltFB843MucM+d/LnPuvSPJzSR7mVzrSeaTGGUzSfYwg75mOoCDZf4Al7Czb3SlopGVVGy1tpL7o1Yy27DqYdrEN6zgDuaHBXUBfMDyOEgXALyuQe75832mAqhDLuBhFdIFcAyrxY6jV56fw0scRasuWmm4Tx4nMdei8he4jcP7+BdwCp/brmCcXS35el33QSP9BwzTrzLuoFUXjdOawUZbw9S6aDnJqySn675pAJaSbJccX5KcnCZgqSSt6n0V0gVQTb5Zxq0ybiRZ7AKoJn+S5EaZX0vyrsw/JVls06aH8MzgNH2Ki9gtvu84izc4gUdt2nQXH/Ecl7Fd8/cN7oe7mG0D+IEzY2L6OM9felT8Y4A5xODX8esE7/VwvSngFq7gyASA+n38Fj+xXg/8DYOL/EhaIZR7AAAAAElFTkSuQmCC"

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAbCAMAAAA9O+1hAAAAw1BMVEX///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9ZxT1WAAAAQHRSTlMAAQMGCREWGBkbHSAmJykrMzU5PENGSVVWYWNygIaIiY2XmZ2kqausrbS1ub3BxMfP1dfa2+Hj6Orv8fP3+fr9tXBdLgAAARBJREFUGBmNwYd2gkAABMA1Yu9gBbFriqjYse//f1XgkBx5vkBm8Kr4db9/FvEPWYcuJ4t4JgUT8T4ovONVuTdsJyD1KfQhJdrDXhlo3klOIBXOdJ0LkCYk701s6dEgVR3SqULS6NmCgo6QI3lEiE4BG3pUSBm6MpBUejZo3EhaCOnQ1UGIRfLWAEoj8pKDtKBrASl3IUcluJQraSURqFOoI5C0yKsCYU5yqsCX3lPYp+FTpiTn8Bl02Ro8tR2fdjV4NJsuA74KBXtgmEuGLE1jYFOo4OnAGAcExowxRqDFGC0EUg9GeqTwY8VIK0hdRupCUhlJhfR2YoTTG0JmjDBDmM4IOsLyjJDHL2v+aQ3fNwDFkDndsURPAAAAAElFTkSuQmCC"

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div class=\"course-list-modal\"><div class=\"modal-header\"><button type=\"button\" ng-click=\"$dismiss()\" class=\"close\">&times;</button><h2 class=\"modal-title\">{{ :: '_GROUP_EVENT.FILTER_MODAL_HEADER' | translate }}</h2></div><div class=\"modal-body\"><table class=\"table table-sm\"><tbody><tr ng-repeat=\"item in filterCourseList\"><td ng-class=\"{ 'checked-table' : item.checked }\" class=\"col-12\"><label><input type=\"checkbox\" ng-checked=\"item.checked\" ng-click=\"checkCourse(item)\" class=\"custom-radio\"/><span class=\"course-name\">{{ item.name }}</span></label></td></tr></tbody></table></div><div class=\"modal-footer\"><button ng-click=\"selectCourse()\" class=\"btn-primary btn-lg btn-block\">{{ :: '_GROUP_EVENT.FILTER_MODAL_FOOTER' | translate }}</button></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("course-modal", v1)}]);
	var v2="<div id=\"event-detail-page\" gnp-common-wrapper-b=\"\"><div id=\"top-page\"><div id=\"group-cover-container\"><img ng-src=\"{{ eventDetail.cover_url }}\" class=\"coverPhoto\"/><div class=\"titleRegion\"><span class=\"groupName\">{{ groupDetail.name }}</span><span class=\"eventName\">{{ eventDetail.name }}</span><span class=\"eventPirod\">{{ displayPeriod(eventDetail.start_date , eventDetail.end_date ) }}</span></div></div><div id=\"group-content-container\"><div class=\"container-fluid tab-content submitScore\"><div class=\"row buttonRegion\"><div class=\"col-6\"><button ng-click=\"btnCancelClick()\" class=\"btn-primary btn-lg btn-block btnCancel\">{{ :: '_GROUP_EVENT.CANCEL' | translate }}</button></div><div class=\"col-6\"><button ng-class=\"{canUpload : canUpload }\" gnp-indicator=\"isSubmitScore\" ng-click=\"submitScore()\" class=\"btn-primary btn-lg btn-block btnUpload\">{{ :: '_GROUP_EVENT.SUBMIT' | translate }}</button></div></div><div class=\"row filterMenu\"><div class=\"filter-condition\"><div ng-click=\"btnOpenMenuClick()\" class=\"filter-head\"><div class=\"row condition-row\"><div class=\"col-6 condition-labels\"><span class=\"icon col-4 col-md-2\">{{ :: '_GROUP_EVENT.FILTER_PERIOD' | translate }}</span><span class=\"condition-value col-7\">{{ filterSelectedPeriod }}</span></div><div class=\"col-6 condition-labels\"><span class=\"icon col-4 col-md-2\">{{ :: '_GROUP_EVENT.FILTER_COURSE' | translate }}</span><span class=\"condition-value col-7\">{{ filterSelectedCourseResult }}</span></div></div><div class=\"row condition-row\"><div class=\"col-6 condition-labels\"><span class=\"icon col-4 col-md-2\">{{ :: '_GROUP_EVENT.FILTER_STATUS' | translate }}</span><span class=\"condition-value col-7\">{{ filterSelectedStatus }}</span></div></div><div class=\"row\"><div class=\"col-12 d-block d-sm-none\"><button class=\"btn-primary btn-lg btn-block button\"><img src=\"" + __webpack_require__(696) + "\" ng-if=\"isFilterOpen\" class=\"filter-close-icon\"/>{{ (isFilterOpen == false) ? spFilterText + '&#9660' : closeText }}</button></div><div class=\"col-12 d-none d-sm-block\"><button class=\"btn-primary btn-lg btn-block button\"><img src=\"" + __webpack_require__(696) + "\" ng-if=\"isFilterOpen\" class=\"filter-close-icon\"/>{{ (isFilterOpen == false) ? pcFilterText + '&#9660' : closeText }}</button></div></div></div><div ng-show=\"isFilterOpen\" class=\"row filter-menu\"><div class=\"row filter-menu-row\"><div class=\"col-3 col-sm-2\"><span class=\"title period\">{{ :: '_GROUP_EVENT.FILTER_PERIOD' | translate }}</span></div><div class=\"col-9 col-sm-10 menu-items period d-none d-sm-block\"><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"filterPeriodItem\" value=\"all\" ng-change=\"periodChange(filterPeriodItem)\" class=\"custom-radio\"/><span>{{ :: '_GROUP_EVENT.FILTER_PERIOD_ALL' | translate }}</span></label><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"filterPeriodItem\" value=\"threeMonth\" ng-change=\"periodChange(filterPeriodItem)\" class=\"custom-radio\"/><span>{{ :: '_GROUP_EVENT.FILTER_PERIOD_THREE_MONTH' | translate }}</span></label><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"filterPeriodItem\" value=\"sixMonth\" ng-change=\"periodChange(filterPeriodItem)\" class=\"custom-radio\"/><span>{{ :: '_GROUP_EVENT.FILTER_PERIOD_SIX_MONTH' | translate }}</span></label><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"filterPeriodItem\" value=\"year\" ng-change=\"periodChange(filterPeriodItem)\" class=\"custom-radio\"/><span>{{ currentYear }}</span></label><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"filterPeriodItem\" value=\"twoYears\" ng-change=\"periodChange(filterPeriodItem)\" class=\"custom-radio\"/><span>{{ currentYear - 1 }}</span></label></div><div class=\"col-9 col-sm-10 menu-items period d-block d-sm-none\"><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"filterPeriodItem\" value=\"all\" ng-change=\"periodChange(filterPeriodItem)\" class=\"custom-radio\"/><span>{{ :: '_GROUP_EVENT.FILTER_PERIOD_ALL' | translate }}</span></label><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"filterPeriodItem\" value=\"threeMonth\" ng-change=\"periodChange(filterPeriodItem)\" class=\"custom-radio\"/><span>{{ :: '_GROUP_EVENT.FILTER_PERIOD_THREE_MONTH' | translate }}</span></label><br/><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"filterPeriodItem\" value=\"sixMonth\" ng-change=\"periodChange(filterPeriodItem)\" class=\"custom-radio\"/><span>{{ :: '_GROUP_EVENT.FILTER_PERIOD_SIX_MONTH' | translate }}</span></label><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"filterPeriodItem\" value=\"year\" ng-change=\"periodChange(filterPeriodItem)\" class=\"custom-radio\"/><span>{{ currentYear }}</span></label><br/><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"filterPeriodItem\" value=\"twoYears\" ng-change=\"periodChange(filterPeriodItem)\" class=\"custom-radio\"/><span>{{ currentYear - 1 }}</span></label></div></div><div class=\"row filter-menu-row\"><div class=\"col-3 col-sm-2\"><span class=\"title\">{{ :: '_GROUP_EVENT.FILTER_COURSE' | translate }}</span></div><div ng-click=\"btnOpenModal()\" class=\"col-9 col-sm-10 menu-items clickable\"><div class=\"d-block d-sm-none row\"><div class=\"col-10 course-value-sp\"><span class=\"selected-course\">{{ filterSelectedCourse }}</span></div><div class=\"col-2\"><span class=\"arrow\">></span></div></div><div class=\"d-none d-sm-block row\"><div class=\"col-md-3 col-sm-3 course-button\"><span class=\"select-button\">{{ :: '_GROUP_EVENT.FILTER_SELECT_COURSE' | translate }}</span></div><div class=\"col-md-9 col-sm-9 course-value\"><span class=\"selected-course\">{{ filterSelectedCourse }}</span></div></div></div></div><div class=\"row filter-menu-row\"><div class=\"col-3 col-sm-2\"><span class=\"title\">{{ :: '_GROUP_EVENT.FILTER_STATUS' | translate }}</span></div><div class=\"col-9 col-sm-10 menu-items menu-item-statuses\"><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"filterStatusItem\" value=\"all\" ng-change=\"statusChange(filterStatusItem)\" class=\"custom-radio\"/><span>{{ :: '_GROUP_EVENT.FILTER_STATUS_ALL' | translate }}</span></label><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"filterStatusItem\" value=\"unsubmit\" ng-change=\"statusChange(filterStatusItem)\" class=\"custom-radio\"/><span>{{ :: '_GROUP_EVENT.FILTER_STATUS_NOTYET' | translate }}</span></label><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"filterStatusItem\" value=\"submitted\" ng-change=\"statusChange(filterStatusItem)\" class=\"custom-radio\"/><span>{{ :: '_GROUP_EVENT.FILTER_STATUS_DONE' | translate }}</span></label></div></div><div class=\"row\"><div class=\"col-12 button-bottom-row\"><button ng-click=\"btnFilterClick()\" class=\"btn-primary btn-lg btn-block filter-button\">{{ :: '_GROUP_EVENT.FILTER_BY_CONDITION' | translate }}</button></div></div></div></div></div><div class=\"row mainContent submitScore\"><div ng-repeat=\"scoreCard in lstScoreCards\" class=\"col-12 row-content\"><div class=\"cell weatherCell\"><div class=\"span date\">{{ :: scoreCard.play_date | date:'yyyy/MM/dd'}}</div><div class=\"weather-icon icons-{{ scoreCard.weather }}\"></div></div><div class=\"cell scoreCell\"><div ng-class=\"classForRoundIcons(scoreCard)\" class=\"icon-round\"></div><div class=\"rounded-circle\"><div class=\"score\"><span class=\"shot\">{{ scoreCard.total_shot_all_holes }}<span class=\"putt\">{{ scoreCard.total_putt_all_holes == 0 ? \"\" : scoreCard.total_putt_all_holes }}</span></span></div></div></div><div class=\"cell descripionCell\"><span class=\"clubName\">{{ scoreCard.club_name }}</span><span class=\"clubAddress\">{{ scoreCard.address }}</span><span ng-show=\"scoreCard.submitted\" class=\"submitted-text\"><img src=\"" + __webpack_require__(697) + "\"/>{{ :: '_GROUP_EVENT.SUBMITTED' | translate }}</span><button ng-if=\"scoreCard.valid\" ng-hide=\"scoreCard.submitted\" ng-class=\"{active : scoreCard.selected}\" ng-click=\"clickSubmit(scoreCard)\" class=\"btnSelectSubmit\"><img src=\"" + __webpack_require__(698) + "\"/>{{ :: '_GROUP_EVENT.SUBMIT' | translate }}</button><button ng-show=\"scoreCard.submitted\" ng-click=\"onDeleteClick(scoreCard)\" class=\"btnDelete\"><img src=\"" + __webpack_require__(691) + "\"/>{{ :: '_GROUP_EVENT.DELETE' | translate }}</button></div></div></div><div ng-show=\"hasMore()\" class=\"row loadMoreRegion\"><button ng-class=\"{ loading : isLoading }\" ng-click=\"loadMore()\" gnp-indicator=\"isLoading\" class=\"btn btn-primary btn-lg btn-loadMore\">{{:: 'SHOW_MORE' | translate }}</button></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-event/score_submit.jade", v2)}]);
	module.exports=v2;

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAABGlBMVEX///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9y/ChlAAAAXXRSTlMAAwUGCAkLDA0OERITFRYnKCktLi8wMTI0NkRFSktNT1BVVldna2xtbnh5ent9fn+DhIWGh5GTnp+kpaanqKusra+wsra3uMTOz9bX2Nvc5ufq7O3u7/P0+fr7/f7QuSakAAACXElEQVRIx62Wa0MSURCGB1BW8RKiUckGXsoLGWRrYWUB0gJKgromWPv8/7/RB1jcXQbBaj6d27PnnHdmZ47IiMVN6/Tc6fWc81PLNGSiGbtNAtbcfZhKNVCskRoLLBUA6NbzuZWFWGxhJZe3uwAUlnQi1wFce2vWPzi7ZbtAJ6cR7wAqa6MTa1WAQ/0W7Yy+f6at3CjVAL7Oj7vl/Mko0wD34CEtD1xo+AcOwX39sMNeufDepxWwP8nJ+8BQt6UOnEwOjC/Q8fxTgPb8ZGSuDYWBWkBGprAMkPLUqnijxW4pGvZY9Y3XrAxUi4M79PkVfAsyaQfSg/aqC4aI7EB9uOADUI6GiKuE17NhR0SasD1cETkOMmkHnGfD7jY0ReLQnZExTIiQmS7ExfSfK8SECZE6mGJBXnRmlJA8WFKDrKiMQkgWatKCpGjMCwecdGgqCS25hkXRmN8KIYtwLT2IicoohMSgpyPy/BdQj+qIdjBJOxCOg/uDKdfva1XVmCS0FJH7RDpSUpgs1EZdOSBENCYPlphgq4TK2GCKEQxLH+ExsWBYGqHgDxCjzBY0+7/Y/ckSV0EPRkrA8bD7HXZFxAB31Rt7GvZ5pARd8f3Ic+F0IW+roWwd+fiz4LXLXpKdOimtD5OSFKA9N0Xqu4DioxPs5fKj0/jGvxSLvylJ/cL3eXzh+zSuWF6sj1H3Qn8wWADlVaWIlwGOtG9tXAKuvemPa5nZtF3gckPff7kIwK2dzyYT0WjiSXbfvgWguPz/nj0iIsbeWXD92d40TzLTqrVu7u5uftSOXirr/wAPudv8V5QmqgAAAABJRU5ErkJggg=="

/***/ }),
/* 697 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAVCAYAAAC33pUlAAABx0lEQVRIibXVz4tOcRTH8dfMYCdRVu5KNhYW/gEWCpmFca8fNbOhjCbFKBYa5UcRZepZIJFSJIV7k58LhQWhlBUrdnenSShJIxb3eep6+t7nufPMOKt7z+ec3t/zPeee27csvWM2lsdJ0B9l6Sl8z+PkTMvXPytShUVZehwTOB1l6dH/Bouy9AiOlVwnmlWaN8egQzgZkCaiLH05Z5VFWTqOsxVyI4+TR+2wJVjTA2gvGhXyORzk356txBs8wKoZgHbjPPoC8mWM53HypwzbhFdYgYW4i6U1WDtxqQJ0FWMtUAu2GfewqBS4HLexoANoGFeEJ/o6RsugFuwZPgQS1iruO2TbcA0DAe0WduVx8rtd6Mc3bMHnQOIe7GvzxbhRAUoxEgK1YPAJO/ArENPAuubzIG5ifiDuPobzOJkOgcowiuvcH4gZUPRvDJlwHx9jax4nocMGYRSTdSEQtxgXK0BPEHcDhWBwAE+7JTbtOYbyOPlZJzgEm8Z2fOyS+wKDeZz8qHmwyq0/hSF8rdBfK4alNqgTDN5jBO1j/BYbFZ/MjKzb1n+Iw6X3d1ivuuKOVud/NqlYzKuxAV96AdWFwahiQU/1CoK/NopwjbS+pGMAAAAASUVORK5CYII="

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAVCAMAAAB8FU7dAAAAe1BMVEX////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////QYBnOAAAAKHRSTlMAAQIJCw8SFBUYGzdgZm5weHygpqerrLC5wMTJzs/Q0+Xp7fDx8/z+I6xRSwAAAGxJREFUGNO9yscOgCAQRdGxV+y9gQ35/y9UJCaiSxPv6s3JAIjsaTRAysaUtqYsS9es2LpRMHt16S3oRqoGdQm6Ii6U8CJO8TkRbGQ4yjjlfJENWCi+DzoL2V9UFS9ynRddfaLUl0oZ9OxRvwMn/A/qeZ03awAAAABJRU5ErkJggg=="

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"event-detail-page\" gnp-common-wrapper-b=\"\"><div id=\"top-page\"><div id=\"group-cover-container\"><img ng-src=\"{{ eventDetail.cover_url }}\" class=\"coverPhoto\"/></div><div id=\"group-content-container\"><div class=\"container-fluid\"><ul ng-init=\"tab = 3\" class=\"nav nav-tabs\"><li ng-class=\"{active: tab === 1}\"><a ng-click=\"gotoTimelineTab()\">{{ :: '_GROUP.DETAIL_TABS.TIMELINE' | translate }}</a></li><li ng-class=\"{active: tab === 3}\"><a ng-click=\"gotoRankTab()\">{{ :: '_GROUP.DETAIL_TABS.RANKING' | translate }}</a></li></ul><div class=\"tab-content\"><div id=\"event-rank\"><div class=\"container-fluid\"><div class=\"row event-info-detail\"><div class=\"col-12 row-content-description\"><div class=\"titleContainer\"><span class=\"group-name\">{{ groupDetail.name }}</span><span ng-class=\"{active : eventDetail.isExpand}\" class=\"event-name\">{{ eventDetail.name }}</span><span class=\"event-pirod\">{{ :: '_GROUP_EVENT.PERIOD_NAME' | translate }}: {{ displayPeriod(eventDetail.start_date, eventDetail.end_date) }}</span><div ng-class=\"{active : eventDetail.isExpand}\" class=\"block-expand\"><span class=\"event-location\">{{ :: '_GROUP_EVENT.LOCATION' | translate }}: {{ eventDetail.location }}</span><span class=\"event-participants\">{{ displayParticipants(eventDetail.participant) }} {{ displayNoParticipants(eventDetail.non_participant) }}</span><span class=\"event-description\">{{ :: '_GROUP_EVENT.DESCRIPTION' | translate }}: {{ eventDetail.description }}</span></div></div><div class=\"titleContainer show-detail\"><button ng-click=\"eventDetail.isExpand = !eventDetail.isExpand\" class=\"btn\"><span ng-if=\"eventDetail.isExpand\" class=\"view-detail\">{{ :: '_GROUP_EVENT.CLOSE_DETAIL' | translate }} &#9650;</span><span ng-if=\"!eventDetail.isExpand\" class=\"view-detail\">{{ :: '_GROUP_EVENT.VIEW_DETAIL' | translate }} &#9660;</span></button></div><div class=\"buttonContainer\"><button ng-if=\"eventDetail.owner || groupAdmin\" ng-click=\"gotoEditEventDetail()\" class=\"btn-group btn-Setting\">{{ :: '_GROUP.LIST.EDIT_GROUP' | translate }}</button></div></div></div><div class=\"row row-average-rank\"><div class=\"col-6 btn-group\"><button data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"btn-average-sort\"><div class=\"col-10 col-group\">{{ (rankingDatas | filter:{type: ranking.type}:true)[0].name }}</div><div class=\"col-md-2 col-img\"><img src=\"" + __webpack_require__(700) + "\"/></div></button><ul class=\"dropdown-menu\"><li ng-repeat=\"ranking in rankingDatas\"><a ng-click=\"chooseRanking(ranking.type)\">{{ ranking.name }}</a></li></ul></div><div class=\"col-6 btn-submit-delete\"><button ng-click=\"gotoSubmit()\" class=\"btn-primary btn-submit-delete-score\"><img src=\"" + __webpack_require__(693) + "\"/>{{ :: '_GROUP_EVENT.SUBMIT_DELETE_SCORCARD' | translate }}</button></div></div><div class=\"row mainContent\"><div ng-repeat=\"user in lstUserRank\" class=\"col-12 rowMaster\"><div class=\"col-12 row-event-rank\"><div class=\"rankingContainer\"><div class=\"list-ranking {{ displayImageRanking(user.rank) }}\">{{ user.rank }}</div></div><div ng-switch=\"user.gender\" ng-if=\"!user.avatar_url\" class=\"imgContainer\"><img ng-switch-when=\"male\" src=\"" + __webpack_require__(701) + "\" class=\"rounded-circle\"/><img ng-switch-when=\"female\" src=\"" + __webpack_require__(702) + "\" class=\"rounded-circle\"/><img ng-switch-default=\"ng-switch-default\" src=\"" + __webpack_require__(701) + "\" class=\"rounded-circle\"/></div><div ng-if=\"user.avatar_url\" class=\"imgContainer\"><div class=\"avatarContainer avatar-for-{{user.id}}\"><img ng-src=\"{{:: user.avatar_url}}\" class=\"rounded-circle avatar-image is-full\"/><span ng-if=\"handleAvatarColor(user)\" class=\"avatar-image-text\">{{ handleTextOfAvatar(user) }}</span></div></div><div class=\"titleContainer\"><div class=\"col-12 name\">{{ displayUserName(user.first_name , user.last_name) }}</div><div ng-if=\"ranking.type == 'avg_shot'\" class=\"col-12 time\">{{ ('_RANKING_GROUP.EVENT_RANK.AVG_SCORE' | translate ) + ' : ' + displayNumber(user.avg_shot) }}</div><div ng-if=\"ranking.type == 'avg_shot'\" class=\"col-12 time\">{{ ('_RANKING_GROUP.EVENT_RANK.AVG_PUTT' | translate ) + ' : ' + displayNumber(user.avg_putt ) }}</div><div ng-if=\"ranking.type == 'avg_putt'\" class=\"col-12 time\">{{ ('_RANKING_GROUP.EVENT_RANK.AVG_PUTT' | translate ) + ' : ' + displayNumber(user.avg_putt) }}</div><div ng-if=\"ranking.type == 'avg_putt'\" class=\"col-12 time\">{{ ('_RANKING_GROUP.EVENT_RANK.AVG_SCORE' | translate ) + ' : ' + displayNumber(user.avg_shot ) }}</div><div ng-if=\"ranking.type == 'rat_par_on'\" class=\"col-12 time\">{{ ('_RANKING_GROUP.EVENT_RANK.RAT_PAR_ON' | translate ) + ' : ' + displayNumber(user.rat_par_on) + '%' }}</div><div ng-if=\"ranking.type == 'rat_par_on'\" class=\"col-12 time\">{{ ('_RANKING_GROUP.EVENT_RANK.AVG_SCORE' | translate ) + ' : ' + displayNumber(user.avg_shot ) }}</div><div ng-if=\"ranking.type == 'rat_birdie'\" class=\"col-12 time\">{{ ('_RANKING_GROUP.EVENT_RANK.RAT_BIRDIE' | translate ) + ' : ' + displayNumber(user.rat_birdie) + '%' }}</div><div ng-if=\"ranking.type == 'rat_birdie'\" class=\"col-12 time\">{{ ('_RANKING_GROUP.EVENT_RANK.AVG_SCORE' | translate ) + ' : ' + displayNumber(user.avg_shot ) }}</div><div ng-if=\"ranking.type == 'rat_par'\" class=\"col-12 time\">{{ ('_RANKING_GROUP.EVENT_RANK.RAT_PAR' | translate ) + ' : ' + displayNumber(user.rat_par) + '%' }}</div><div ng-if=\"ranking.type == 'rat_par'\" class=\"col-12 time\">{{ ('_RANKING_GROUP.EVENT_RANK.AVG_SCORE' | translate ) + ' : ' + displayNumber(user.avg_shot ) }}</div></div><div class=\"buttonContainer\"><button ng-disabled=\"user.rank === '-' \" ng-click=\"gotoAnalysisEvent(eventDetail.id,user.id)\" class=\"btn-score-analysis\"><img src=\"" + __webpack_require__(703) + "\"/>{{ ('_RANKING_GROUP.EVENT_RANK.SCORE_ANALYSIS' | translate ) }}</button><button ng-click=\"user.active = !user.active\" class=\"btnExpand\"><img ng-show=\"user.active\" src=\"" + __webpack_require__(704) + "\"/>{{ user.active ? ('_RANKING_GROUP.EVENT_RANK.CLOSE' | translate ) : ('_RANKING_GROUP.EVENT_RANK.SCORE_DETAILS' | translate ) }}</button></div></div><div ng-show=\"user.active\" event-rank-score-card=\"\" scorelist=\"user.score_cards\" userid=\"user.id\" eventid=\"eventDetail.id\" class=\"col-12 rowExpand\"></div></div></div><div ng-show=\"hasMore() || isLoading\" class=\"row loadMoreRegion\"><button ng-class=\"{ loading : isLoading }\" ng-click=\"loadMore()\" gnp-indicator=\"isLoading\" class=\"btn btn-primary btn-lg btn-loadMore\">{{:: 'SHOW_MORE' | translate }}</button></div><div ng-show=\"noResults\" class=\"row loadMoreRegion\"><h3 class=\"card-title\">{{ :: '_GROUP.NO_DATA' | translate }}</h3></div></div></div></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-event/event-rank.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAASAQMAAAB/11zgAAAABlBMVEUAAAD///+l2Z/dAAAAAXRSTlMAQObYZgAAAEtJREFUCB0FwbENwjAQAMAjFGkimQ2yBp0XQ/ofzaMkGyDRpIj83HlZeFv5aGnah9KHyEgxKvWz2H+TVjdrXTzry6MO1EAkItFh4w/B/xoFE8NhMAAAAABJRU5ErkJggg=="

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAABJCAMAAABGrfvuAAAByFBMVEXE3urI4OvX6fHl8fbv9vn4+/38/f7+///////E3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urE3urF3+rG3+vH4OvI4OvJ4ezL4uzM4u3M4+3N4+3O5O7P5O7Q5e7R5u/T5+/U5/DW6PDW6PHY6fHb6/Lc7PPd6/Pe7fPh7vTj7/Xk8PXl8Pbn8vfo8vfq8/jr9Pjv9vnw9/rx9/rz+Pv0+fv2+vz3+vz4+/35/P36/P37/f38/f78/v79/v7+//////9rTv9RAAAAaXRSTlMAAAAAAAAAAAABBgcICRQVFxgaGxwiKSorLi8wMTU2Nzs8P0BBREVMTU5PUFFSU1RVV1h3fn+AgZOUl5mam5ydnp+gpaanqKm/wMHExcbHyMnKy8zN29zd3t/g4ePn6uvt7u/w8fn6+/4bG2BFAAADmUlEQVRYw62YaVtSQRSAxy1Ryn1pdSmtJLXFNNOoLLNSyn1NKbSSg0oqprilgqgIKHrR+bsxCMpy5nLHh/cbM4f3uXdm7jkzQ4gM+dX1rbpBwyRMGgZ1rfXV+UiMKgTXon7QNATRDDU9VAuaSpsnAGeiuUS5KaNKB3LoqjKUmcq6IR49ZQpMWS1GiI+xJSue6ZEBlGGokTWpG0E5jWq+KacLROjK4ZkK+0GM/kLcdGMMRBm7iZmK9CCOvjjWVDAKl2G0INp0tRcuR29mlOk1XJbGSNNTuDw14abcH5yoqVWHW6JUcjtWp7irPTfM1IbHmO1+SwjJbuao2i5Md/GItTBPwLXGUd07N3Vi3aYdGsOOCTV1hkyVqGiPIuzhqsqg6RPWuUNRdlDT5zPTHXSMKAd8rEoCJi02axLPJKEzqGUmNVZF7JSLHTP9VPtNVdiClPgmCV2iGr+pGWlfpTKs4q9HyBDS7pAzOTDTsIoUYO1uOZMbnb0CdJhAkjNJqElD6rBmKgtqqiNvEmR6SzoS9HYdZCBBIz5IxiEhqwDGyS9IyMqE3wRP38JfCwD+TMJfMHumcbwWCGYVNk4DnGoglunY3H3h9AhlXz9fyXtOj1BF8POBPOd1CVQpxgtSzS/4iisnoxrPT2LVPJif0JwptMMI8I2Tx8VheVwj0z+/7tj3+ij1efcd6/NyJg2v3jEstsPIET+0WXiiQL1DazCA1YmtJ6eV93LMVII9zz7va9m38PcFpD1mUdpO+bng1Ba7PNs5+6c5l3xFcM1Fm+7je7rFYxqH48VIUff57rAivHn5hMblZDnCVIHufZcUiPyqpTDRx/D9+PlJc8FHFeFbwPfj5FmwdeaAKuRgJmSqjTy3BIv6LlXMblD0MuoEdK2Pta5QAVYCor5M7Hw35RUxeafQ8x0hxXr4I4mY6D//mfM6dg6+pYe/RwKiowX4fhs/mxeNwqxLscg1C6NFnFN+al43mOwKRXYT9OZx7guS0lXsDsPqUeDxWNkdRnoSbkpmvx8bwLQZb537Nk1geOKPTsZNKYGG7BYjmLfkJlHaMoPxXTYLTsFNqcGm8h6A6Q3e0Ls2pgF6ys9CU3FTWqgtQ8PuxCxbsbtN9xbLvTpNRjAyDTddUV1QqmUVZ9q6se30eCUqeT3O7Q3rNLune1V6EXYFN6kiUGu0IzH5ekSrUUdEKTEx8msbWnXDBiMYDcO61oba/JiIsH/9B+ya0yx8p0/QAAAAAElFTkSuQmCC"

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 703 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAbCAMAAAD7/nnYAAAB5lBMVEUAAAAbrawcrawdrq0erq0frq0fr64gr64isK8jsK8ksK8nsbAosrEqsrIts7MutLMwtLMxtbQytbQztrU0trU2t7Y3t7Y6uLc7ubg8ubg9ubhAurlAu7pBu7pCu7pHvbxIvbxJvb1Kvr1Lvr5Mv75Ov79PwL9SwcBTwcFVwsFXw8JaxMNdxcRexcRjx8ZnyMdpychqyclsyspuy8pvy8tyzcxzzcx0zc11zc12zs53zs54z855z857z8980M980NB90NB/0dCA0dGB0tGC0tGE09KF09KF09OG1NOH1NOJ1dSK1dSL1dWM1tWN1tWN1taO1taP19aR19eT2NiV2dma29qb29uc29uf3dyh3d2i3t2j3t2m396q4OCt4eGt4uGv4uKw4+Kx4+Oy4+Oz5OO35eW45uW55ua65ua/6OjA6OjB6enC6enD6enE6urG6urH6urH6+rI6+vJ7OvL7OzP7e3P7u7R7u7R7+7S7+/U8O/W8PDY8fHZ8fHa8vLc8vLd8/Pe8/Pf8/Ph9PTi9fXj9fXk9fXl9vbm9vbn9vbo9/fp9/fq9/fq+Pjr+Pjt+fju+fnv+fnw+fnw+vnx+vry+vrz+/v0+/v1+/v2/Pz5/f36/f37/f37/v78/v79/v7+//////83Nm1zAAAAAXRSTlMAQObYZgAAAd9JREFUOMtjYICD6b6ubiDgmsNAHuhlhAIPwmpnxkVFg0BUJZJgHw/UAH9kpdOSEiCgkYFh6oSJINA/k6ETptYbuwHzp0LAlFkMdTB3hTFM1ZaUAgHxEIZuEahoEENHGxi0TkY2oEdZVg4EpGMY6tmgohEME8WgTCdkA0Q5IMAd2YA2digzENmAyVJQpiuyAXxwU5EMaOeGMoMJGyAAZbmMGkC6ARzmyWoUGCBmULFwoQnxBnCgGTCpfOHCfG1WLAYIW6lzoxvArx1VlaSKZEDMwoULS/SYsIQBr1vnwoW1ZQs7EQY0WyZ0LwSB5oVQAzQyFi6cY8+GJRCFbBoWzk/KBSqeF28kBBRjVshbuGDhwmmptvLODQsXzrVmZmRUSly4sG9hD5ZYWDi1ZuHCVBVGFqlMsK50i4BqoFlz4gwFQfI8BUBOkXHk/IUtjj5YopEpFiifpQkNxG7TlE6Qs6tLFzbBY2HhjFqgUK8XP7Z0oFMItEsfORb4dcNdFJlRo1FGLydEBFtCkkhbuLBtIQUpUXN2nZk7JUmZS0t2KOdGTijLFlEveDK0wph+iFI5lGGiIJRpx9AFs8yHwdsBDOzSGKa7QZmZDFNgzGyGPicos5hhZpAdhJnOMNUXyswCADhZ5BJQY4pFAAAAAElFTkSuQmCC"

/***/ }),
/* 704 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAw1BMVEUAAAAbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbraw75fxvAAAAQHRSTlMAAAIDBQYHCwwRJygpKzNDREVRUlNUVVZbXGZoaWprbG9wcXeJipOUmaaqq6y709TV19nb3d/g4+Tu8vP2+Pn6tiYMggAAAPpJREFUGNNVkcdWQkEAQ3MZHzYYK4iVIuiACFhAR/GR//8qF3Asd5lNTm4EQHE2nJefT8NmAYAAjl+84eVkE4a+PevVqtVab2b3Awj6Xl4FAAjt0n0QDZeH/HBUuoGKN7f5w43fC7U8DZCSJMXHXcLU53pwF0hOUsw5QtdjLVwDlJxizlGw74W+XAWkZOcoQeFSHy4AKdojSbDjUs/eBxRzHjlJUPdiUxRzjkpOgo7HankS4DVHSckXhInPVbz5BuKhJOlWXPu9KpouD/7NbCIYeHlZWUeVdunBWt2dPevsbW3XOzP7Pmwkn/5KbvyYp2iN56vVfNxa3/ENGpIk/heJusgAAAAASUVORK5CYII="

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<form id=\"group-event-page\" gnp-common-wrapper-b=\"\" name=\"eventForm\" gnp-submit=\"submit(eventInfo)\" novalidate=\"\"><div id=\"top-page\" gnp-indicator=\"isSubmitting\"><div id=\"group-cover-container\"><img id=\"coverPhoto\" ng-src=\"{{ croppedCoverPhoto }}\" class=\"coverPhoto\"/><div class=\"rowContainer innerBottomShadow\"><div id=\"centered\"><span ng-if=\"!croppedCoverPhoto\" class=\"title\">{{ :: '_GROUP_EVENT.CUSTOMIZE_EVENT' | translate }}<br/>{{ :: '_GROUP_EVENT.ADD_COVER_IMAGE' | translate }}</span><div class=\"row\"><br/></div><div class=\"row\"><div class=\"col-12\"><button type=\"button\" ng-class=\"{ btnOpacity : croppedCoverPhoto }\" ng-click=\"chooseCover()\" class=\"btn btn-primary btn-lg btn-block btnSelectCover\">{{ :: '_GROUP_EVENT.SELECT_PHOTO' | translate }}<span class=\"caret\"></span></button></div></div></div></div></div><div id=\"group-content-container\"><div class=\"container-fluid\"><div class=\"d-none d-sm-block row header\"><h3 class=\"card-title\"> {{ :: '_GROUP_EVENT.CREATE_TITLE' | translate }}</h3></div><div class=\"row\"><div class=\"form-horizontal col-12\"><div class=\"form-group\"><label class=\"col-sm-2 col-form-label\">{{ :: '_GROUP_EVENT.EVENT_NAME' | translate }}</label><div class=\"col-sm-9\"><input type=\"text\" name=\"eventName\" ng-model=\"eventInfo.name\" required=\"\" class=\"form-control\"/><div ng-show=\"eventForm.eventName.$invalid &amp;&amp; !eventForm.eventName.$pristine\" class=\"error\"><div ng-show=\"eventForm.eventName.$error.required\">{{ ::\"VALIDATION.REQUIRED\" | translate }}</div></div></div></div><div class=\"form-group rowDate\"><label class=\"col-sm-2 col-form-label\">{{ :: '_GROUP_EVENT.PERIOD_NAME' | translate }}</label><div class=\"col-sm-9 rowDate\">{{ :: '_GROUP_EVENT.START_DATE' | translate }}<label for=\"txtStartDate\" class=\"calendar\">cal</label><input type=\"text\" name=\"startDate\" id=\"txtStartDate\" ng-model=\"eventInfo.start_date\" readonly=\"true\"/></div></div><div class=\"form-group\"><label class=\"col-sm-2 col-form-label\"></label><div class=\"col-sm-9 rowDate\">{{ :: '_GROUP_EVENT.END_DATE' | translate }}<label for=\"txtEndDate\" class=\"calendar\">cal</label><input type=\"text\" name=\"endDate\" id=\"txtEndDate\" ng-model=\"eventInfo.end_date\" readonly=\"true\"/><div ng-show=\"eventForm.endDate.$invalid &amp;&amp; (!eventForm.endDate.$pristine || !eventForm.startDate.$pristine )\" class=\"error\"><div ng-show=\"eventForm.endDate.$error.dateValid\">{{ :: '_GROUP_EVENT.VALID_DATE' | translate }}</div></div></div></div><div class=\"form-group\"><label class=\"col-sm-2 col-form-label\">{{ :: '_GROUP_EVENT.LOCATION' | translate }}</label><div class=\"col-sm-9\"><input type=\"text\" name=\"eventLocation\" ng-model=\"eventInfo.location\" class=\"form-control\"/></div></div><div class=\"form-group\"><label class=\"col-sm-2 col-form-label\">{{ :: '_GROUP_EVENT.DESCRIPTION' | translate }}</label><div class=\"col-sm-9\"><textarea name=\"eventDescription\" style=\"resize:none ; height:85px\" ng-model=\"eventInfo.description\" class=\"form-control\"></textarea></div></div><div class=\"row\"><div class=\"d-none d-sm-block col-sm-6\"></div><div class=\"col-12 col-sm-6\"><div class=\"col-6\"><button type=\"button\" ng-click=\"buttonCancelClick()\" class=\"btn btn-primary btn-lg btn-block btnCancel\">{{ :: '_GROUP_EVENT.CANCEL' | translate }}</button></div><div class=\"col-6\"><button type=\"submit\" gnp-submitting-button=\"isSubmitting\" class=\"btn btn-primary btn-lg btn-block btnCreate\">{{ :: '_GROUP_EVENT.SAVE' | translate }}</button></div></div></div><div class=\"row delete-event-region\"><div class=\"d-none d-sm-block\"><div class=\"col-12 btn-region\"><button type=\"button\" ng-click=\"deleteEvent()\" class=\"btn\"><img src=\"" + __webpack_require__(691) + "\"/> {{ :: '_GROUP_EVENT.DELETE_EVENT' | translate }}</button></div></div><div class=\"d-block d-sm-none\"><div type=\"button\" ng-click=\"deleteEvent()\" class=\"col-12 mems-row\"><div class=\"cell\"><img src=\"" + __webpack_require__(691) + "\"/> {{ :: '_GROUP_EVENT.DELETE_EVENT' | translate }}</div></div></div></div></div></div></div><div ng-show=\"listEventCtrl.noResults\" class=\"row loadMoreRegion\"><h3 class=\"card-title\">{{ :: '_GROUP.NO_DATA' | translate }}</h3></div></div><div tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\" data-backdrop=\"static\" data-keyboard=\"false\" class=\"crop-image-modal modal fade\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"col-3\"><button type=\"button\" ng-click=\"cancelCropModal()\" class=\"float-left\">{{ :: '_GROUP_EVENT.CROP.CANCEL' | translate }}</button></div><div class=\"col-6\"><div class=\"text-center modal-heading\">{{ :: '_GROUP_EVENT.CROP.TITLE' | translate }}</div></div><div class=\"col-3\"><button type=\"button\" ng-click=\"submitCropModal()\" class=\"float-right\">{{ :: '_GROUP_EVENT.CROP.DONE' | translate }}</button></div></div><div class=\"modal-body\"><div class=\"cropArea\"><ui-cropper image=\"coverPhoto\" result-image=\"$parent.croppedCoverPhoto\" result-blob=\"$parent.croppedCoverPhotoBlob\" area-type=\"rectangle\" result-image-size=\"{w: 970,h: 250}\" area-init-size=\"{w: 970,h: 250}\"></ui-cropper></div></div></div></div></div></div></form>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-event/edit.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(707);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_event.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_event.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}#group-event-page{background-color:#e5e5e5}#group-event-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-event-page .btnOpacity:hover{opacity:1}#group-event-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-event-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-event-page #top-page{background-color:#e5e5e5}}#group-event-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table}#group-event-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-event-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-event-page #group-cover-container,#group-event-page #group-cover-container img.coverPhoto{height:172px}}#group-event-page #group-cover-container .container-fluid.editCover{height:100%}#group-event-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-event-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-event-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-event-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-event-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-event-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-event-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-event-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-event-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-event-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-event-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-event-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-event-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-event-page #group-cover-container #centered span.caret{margin-left:10px;display:inline-block}#group-event-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-event-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-event-page #group-content-container .row.header{padding:10px;border-bottom:2px solid;margin-bottom:20px}#group-event-page #group-content-container .form-group.rowDate{margin-bottom:5px}#group-event-page #group-content-container .col-sm-9.rowDate{padding-top:5px;color:gray}#group-event-page #group-content-container label.calendar{background-repeat:no-repeat;background-position:center;background-image:url("+__webpack_require__(712)+");margin-left:10px;margin-right:3px;background-size:15px 15px;color:transparent}#group-event-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-event-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-event-page #group-content-container .delete-event-region{margin-top:20px}#group-event-page #group-content-container .delete-event-region .mems-row{display:table;background-color:#fff;padding:10px;border-bottom:1px solid #e5e5e5}#group-event-page #group-content-container .delete-event-region .mems-row .cell{display:table-cell;vertical-align:middle;text-align:center;color:red}#group-event-page #group-content-container .delete-event-region .mems-row:first-child{margin-top:20px}#group-event-page #group-content-container .delete-event-region .btn-region{border-top:5px solid #1badac;padding:40px 20px;text-align:center}#group-event-page #group-content-container .delete-event-region .btn-region .btn{width:70%;border:1px solid red;background-color:#fff;color:red}@media (max-width:768px){#group-event-page #group-content-container .delete-event-region{margin:20px}}#group-event-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-event-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-event-page #main-main .container,#group-event-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-event-page #gnp-header .btn-section,#group-event-page #gnp-header .user{display:none}#group-event-page #gnp-footer .copyright{text-align:left;margin-top:0}}", ""]);

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA0CAMAAAAKRhAuAAABmFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////Ak9VoAAAAh3RSTlMAAQIDBAUHCAkKCwwNEBEVFhcYGRocHiAhIicpKisuLzA3ODk7PD0+QEFCR0hJSkxPUFRWWFxdX2FkZmhqbm9wcnN0dXd4f4CCh4iJi42QkpSXmJykpqeoq7Cytbi5vL7BxcjKzs/R0tTV1tfY3d7f4OHi4+Xo6err7u/w8fL09ff5+vv8/f6kI7kHAAAC30lEQVRIx6WWZ0PUQBCG3xMQPe8sFLtIUYpyShEboigceDZQmoCigidFUEQRkaqHPn/bDxswJDk34PspMztPktmZnUTy6eQYwRo7qRDaM042je8JwV8hu67Y8cjEP/iJiJWv51+qtz4+DbDeWO9V4zpA2vYCdQA8CVh5AkCdhR8F+FEYsFL4A2A0YKWkOz3r6CsAzwJv/QyAr5uh6e4SSVJO6rdnk34eDeSP/vTE/U7lSHrs2+TeLLn1+iIfSxX+Ip3dIvKOHDuSt2Wd9YdWaMDnG3HYup73GSDzvqfOuceIL3ZA8wBT9+44etR/Q5IUTS64whaSUUnSjf5Hm4H3pgDmBUC1N9WLnzwP+nTRG1INgOFLPU3YEdC6HZ7WK83KR54G9v7TSEj+vgOs9t2sKa252bfq2PfD8QkTvd4ZdxzxjnXjuhSGj30BYPq0y3dqGoAvsRB8JwBTh8wwO2ySPjQFQKedj34HWD4hSSqaZbZIknR8GeB71Mo3AXDLGHeBVnPZDECTlR8EmMv9m4vzzrlzAINWftFdKRdvqrpo44sBKJekA/H4A+BBPB6TpHIAii38eQCi0sF37g9HXIoCcN7CJwCWJV3f1rvXJC0DJCx8LcCKpKvb+KuSVgBqLfw5AGJSdOTXFr3xKibFADhn4Qu2Zenef7MzBbb6fQNIBfApgG/W+j8HmN/r4/fOAzy38o0AtBmjBbhtLtsAaLTy+QsAa2fMsXtL2hzEM2sAC/n289sOwEen0ZyDUPwRgPYQ5z9/BoDPZS5f2RwAH/LDzK8qU/iNriLHUdS1AcCvqnDzs3WzbV4mGy40JF9kHLs15Pw1pfYpFXb+Sy0ZH51pUXheZZMefLJcO+GV1zzjomea87QzXopUPnyzCCy+eVgZ9Ndl4037xHOzLbn5Cu1c5sfFzNvXDfU7VcNrM4+H+B8NbX5td6mE1PcfeJ+kfQO7xgf2S5IuDy/tAl4avizpD0N4Pxn9uj0hAAAAAElFTkSuQmCC"

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAA+CAMAAABEH1h2AAABUFBMVEX///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+/D/R5AAAAb3RSTlMAAQMGCAoMDg8TFBUWFxgcISIkJy0uLzc9QEFDRUlMTU5QUVNWWFteYmNkaGlrbHB0eHqAgYOEhomKi46QkpaXmZufoKGlpqeprbGyu76/wMHEx8nNz9DT1NXY2tzd4OTl6Orr7O7w8fT19vn6+/2iyUIzAAAC6klEQVRIx62XW0MSURCAJwFLTDTyEhiVFhlRkFFEZneyoJBMbpKrUFCEwvf/33rYXVyWdVna5o1zzseZnZkzFxFrmYumc9VmBzrNai4dnZMJZGmrhklqW0vOWE+8gqVU4p7xcLIxON8uF/P5Yrk9WGgkx/zBal092CumQn590R9KFXvqen3VBp7OqodKCb95y58oqXvZ6fPoRfXqQth6O1xQFVi03l7rAiiR87WLKADdNau9WB8g47UzjTcD0L9vQQO0IuM8E2kBjPBrfUAJjg+LoAL0TfovdoFqwElYBapAd8h+03VACTgLy4AC1I3+ywKtoNMnEWwBWUOsAUScP6kIwCD+PHUgIyIz2/uVMbK/PSMiGaCux38SULwingMcyIFHxKsASe3yhqb6Oo5kXVO/oV4fB3Z1LZpHttLUby0AcRERqQBhHQ/ZGy2k42GgIiKyBJRkUlxKwLKIbAGJcfjli2b8IbAlIjXo+e3xhW/0d3zDuL8HNZE5oCj2eAng5TAuRSAgUSBlj19R86QJTwFRSZ8xBjyQvH6GzwNwZMJDQFpygN+MLzdh84z/gq6iAfcDOalCW0z4td9g5Gd2/vxIT5lwaUNVmlA24Te6anRu2vldpAxN6QwMr+MbPT26N23xInQEyA/hSYDjlcIQf/vNzRE8D4zgTwEOF8Rn4D2vgAeWuEn5zwDlWREDH9gDYMNKeZPpAL5eEjHwK1rN7d+1MJ3JcUDep/1W+Y8nAD+B/p1RxxnC5hEA76cGdlZ54CQ2WwVOb42EjSFoPwC8uGDwk8Y3VkRmvwOnj81Ba3gyr4G3w372FYC9gIjI/CFwan4yYx6s793Rcy0jzyvqlxge7JyjdKFXl2MDrqULZ8nKyD8REZGElqwmSZVXfwGfhlLlRIn6HvBsKFG7LROeY1dFymWJdFugXbYHbpsTt62Ry8bMbVs4YVMac9USx/5/Qz4YB3b/bRxwO4y4HYVcD2Jux0DXQ+hEI/Bfgho6lSPRYioAAAAASUVORK5CYII="

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAMAAADypuvZAAABJlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG1vTxAAAAYXRSTlMAAQIDBAYHCg8QERIVGhsdIycqLDE4OUBESExNTlJTVVhaW2BiZGhrbG1uc3Z3en2AhIaIkZaXmJmcqKqrrK2wtbm9vsHCw8rLzM7T19vc3uDh4ubn6u/09fb4+fr7/P3+zKr4JAAAAXZJREFUSMfd1uszAlEYx/GNiqgoclexlHuECIkUiuSaYm2+//8/4UW7M9tOtee81O/VzjPPZ+bMcy6zitIt42sXT998PV8kxhXBjB19YkY7CQiZpQ+sqa8ImO1fbNl3NEmjs3F/c9cwvvcczEwLgNtFr6Io7vnrtprvazxVAC3hMgurTYCXkX4oAaAvWCqzGsBuP/QAkOoobQG8eXqbKYDXzobhR4CYw+pStuI6wEZvdAoQsRW9VWhO9kaXAKP2auDgeLrPHK4A3IpczgAmJFEaYFkSLQOcC7cHY6qqqokfoLWjdk8s2EFchzoC0Q9dFrSJYDYtqCaKahaEcGyoojqk0gXlnQac/+9ortBsFubkkPH6JWVQyDhVekgCpc29TEugnIlyEihroqwEipooKoGGSm1TGpIZua8MUPbJba4KoCoDheIAcUnkr0PdL3ufwplMeMCuuyB6zzvk3YZ00VdZt6CiKCpaUEQTM1rH70KkKLBCvWiYP0HBUCO4T41kAAAAAElFTkSuQmCC"

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAMAAADypuvZAAAA4VBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAzthe/AAAASnRSTlMAAQIDBAYKCxATIiUqKzAyNTY3SUpLUVNUWVpcbHN4eX+AjI+Ul6CnrrO0tri9wMTHyMzN0NLT3ODi4+Xn7vDx8/X29/j5+vv8/tMr4QMAAAGMSURBVEjH3dXZUsIwAIXhKgpVShQqiFpUduoS17qzKFDlf/8H8oIplWghuVPPVedMvk6atKll/ZCU27juQ/+64aYsvax5j8zy6K3pmFzAXILcclN8RclbcZlxw2jscBhdhe5ikx0A8NEu2ZZll9ofAAyyi8zqJQA3TlQ4NwBcri5AewCcpuMmfQrA/gIUANylv1bpO4Ag2QgACvNlAQCRiA4BpNpKgKNE1AHw1NYD6CSiZ4C82uYBnhNRCLCptpsAYSIaAWyo7QbAKBG9ANhqawO8fB+dqZxJKeUQ4EIquQAYSinlWSXz5V63aOY2nkcT7TRnqKuPujOEQebQQAghtooF8UMKxS0hhBh8Q73lJ0Hvj6PyVRhelc1Qbbq+NRO0E+3KjgE6idCJAXqK0JMBuo/QvQFqRahlgHLjqRnnTJZ89x3gfddsc+sAdcM3ogpQ/bXoGODYEB0AHBii9XM4Xzf9CFfy2yv/7IzQQ5OHpZnMoZH+UR7/EX195M+Q09c1fSd+RMfXmuHIn5pP9msWhijAfLkAAAAASUVORK5CYII="

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAAe1BMVEUAAACCgoL///+CgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoLFJdMaAAAAKHRSTlMAAAADBAcICw8QGxweMDk9PlBbXGNwcXyAmJ6orrC1uMDE2ODr8Pn8PJjrywAAAL1JREFUGNN9kNcOgzAMRUMJm5ZZRtjb//+FtVkKpep5iOUj6yYOYwoRTzoVfYqVB8LYpjOwqFiQHdp9Ijl4VDzIqbioZ7gxo4YiCIICQjyDcG9IZxj6Eiplq+KF2Rkc0xe26R+QXi+Xyc9sO1qfr0T2mU06BZOsCamkffmB/qG1y0azdkw78vKOlH35ql3zsh2ga5EOhrbku1ZF1UNdITX0lVD/h2CfLAZpY0kumrvbli4/dfP+oiE93j9wZB+GfSO/Fx4zrgAAAABJRU5ErkJggg=="

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(714);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_event_list.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_event_list.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}#group-event-list .btnCreateEvent{padding:10px}#group-event-list .btnCreateEvent button{background-color:#fff;color:#1badac;border:3px solid}#group-event-list .btnCreateEvent button img{width:22px;height:22px;margin-right:5px}#group-event-list .row-title{border-bottom:2px solid;padding:10px}#group-event-list .row-content{display:table;padding:10px;border-bottom:2px solid #ccc;table-layout:fixed}#group-event-list .row-content .imgContainer{display:table-cell;width:80px;text-align:center;vertical-align:middle}#group-event-list .row-content img.rounded-circle{width:80px;height:80px;object-fit:cover;image-orientation:from-image}#group-event-list .row-content .titleContainer{display:table-cell;vertical-align:middle;padding-left:5px}#group-event-list .row-content .titleContainer span{word-wrap:break-word;white-space:normal;overflow:hidden;text-overflow:ellipsis;margin:0;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}#group-event-list .row-content .titleContainer span.name{font-size:18px;font-weight:700}#group-event-list .row-content .titleContainer span.members,#group-event-list .row-content .titleContainer span.time{font-size:14px;color:gray}#group-event-list .row-content .titleContainer span.members{display:table}#group-event-list .row-content .titleContainer span.members i{display:table-cell;font-style:normal;padding-right:10px}@media (max-width:414px){#group-event-list .row-content .titleContainer{display:block}#group-event-list .row-content .titleContainer span{-webkit-line-clamp:1}#group-event-list .row-content .titleContainer span.members,#group-event-list .row-content .titleContainer span.time{font-size:8px}}#group-event-list .row-content .buttonContainer{display:block;position:absolute;bottom:5px;right:10px}#group-event-list .row-content .buttonContainer .btn-group{display:inline-block}#group-event-list .row-content .buttonContainer .btn-group+.btn-group{margin-left:5px}#group-event-list .row-content .buttonContainer .btn-Setting{background-image:url("+__webpack_require__(715)+");background-repeat:no-repeat;background-size:15px 15px;background-position:left;background-position-x:5px;padding-left:10px;color:#fff;background-color:#1badac;width:120px;border-radius:5px;border-color:#1badac;border-width:2px;border-style:solid;font-size:10px;text-align:center;height:25px}#group-event-list .row-content .buttonContainer .btnDelete{text-align:center;color:red;background-color:#fff;width:95px;height:25px;border-radius:5px;border-color:red;border-width:1px;border-style:solid}#group-event-list .row-content .buttonContainer .btnDelete img{display:inline-block;width:12px;margin-right:5px;margin-top:0;margin-bottom:0}@media (max-width:414px){#group-event-list .row-content .buttonContainer{bottom:2px}#group-event-list .row-content .buttonContainer .btn-Setting{width:40px;background-position:center;color:transparent}#group-event-list .row-content .buttonContainer .btnDelete{font-size:8px;width:55px}#group-event-list .row-content .buttonContainer .btnDelete img{width:7px}}#group-event-list .row-content:hover{opacity:.8;cursor:pointer}#group-event-list .row.loadMoreRegion{padding:10px;text-align:center}#group-event-list .row.loadMoreRegion .btn-loadMore{position:relative;margin:0 auto;color:#fff;width:220px;background-color:#555}#group-event-list .row.loadMoreRegion .btn-loadMore.loading{color:transparent}", ""]);

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAADFElEQVRYhb2Yz4uWVRTHP68zOuYgurCGFGRMLcSgRW5Cg3DAVVrYJheO5KohW/QPCKKG4iJo0SLGQGrRwo20mJUIjVhCtcyZ0PEHOEwqrrLSGj8uri88vnPvfZ4774xfeDf33HPu533Oee4990Gly993ztXxbuMuoXsNRsZe6zboQoC9Ehnb3G3QOrD+Gnsf8HJkfFODtQdyxhzYCHAD2JWZsyExvgJYl/E7BNx8ukZcieIbqRTyY/WI2lOxv66eUicjhd/W7+pJdWvFb6X6fce8kRhDHVRV59V31LEMTEo/qO+rEwn7HLiWWn2ALwG3CLXzPHWP8HY/aA901tgdQv6ft4apQAHJGvtmHumar47FGDpT2dZy4CLw5iI/qR+BncBspyG1XfwLHC1Y4G9gErgGPCrwOx6DApKpRB1vkIYxdUjtrfi9oO5Vf23gfyG1fgpqe03AR+pHmT+F2lKPNoDbVgI2WhNsuAaq+jtRE+urJmBL1A3qdCbQuQIoDGm+kol3S92i9lX9WurnhDbl1ae/ZTUF+xbwc0GBAxwETjeYNw1cB6ZaGt8vEroPvAg8LgQbAGZKHEr7sWuUQwH8CfxT4lAK1k1j2VrMhTbOwwdCM7m8xKEX+JZwsg8Ca4GezPzVwHZgvBBsd4M5/wFXCSfIROzVHlTvZF7vscLtYql6NRNvWt3ks6dHcoM9kwmk+nEB2Jc1sUZjfqlgQzXBZtVPa4B61S9q4qjuKAFD/aVB0HH1PcPB3fZbre43v9u39VNq/RzYvgaB2/rfUCszhstLU32YWj/VKPYBl4E3Ct++Uk0C24C/Og2pPekUiw8F4YwejVoij3FPQSoWSp/UpbKfcPtes+jP6lk9BNYTbmnA3FQ+AA4nnKeAA4TaK9Ul4APgt4T9syoU0OgTgepZdVXF/rZ62nxDeVv92tCmt/2WOXdva/yJoAr3UD2UmbMxA7Y14/euejcFZWa7aGuA0Eul1EPos5ZGbCvI92D9dN6+K6prYXJQEO6Ef0TGZ2qgyEHBwnxRjIFNdRt0IcAmImNdgz0Ba8eWbJNf1eQAAAAASUVORK5CYII="

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(717);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_event_detail.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_event_detail.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}#event-detail-page{background-color:#e5e5e5}#event-detail-page .btnOpacity{opacity:.3;transition-duration:.4s}#event-detail-page .btnOpacity:hover{opacity:1}#event-detail-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#event-detail-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#event-detail-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#event-detail-page #top-page{background-color:#e5e5e5}}#event-detail-page #group-cover-container{width:100%;height:250px;background-image:url("+__webpack_require__(718)+");background-repeat:repeat;position:relative}#event-detail-page #group-cover-container img.coverPhoto{margin:0;width:100%;height:250px;object-fit:cover;border-color:#000;image-orientation:from-image}@media (max-width:414px){#event-detail-page #group-cover-container,#event-detail-page #group-cover-container img.coverPhoto{height:172px}}#event-detail-page #group-cover-container .titleRegion{left:10px;bottom:5px;position:absolute;width:calc(100% - 10px);padding-bottom:5px;display:table-cell;vertical-align:middle;max-height:160px;padding-left:5px;overflow:hidden}#event-detail-page #group-cover-container .titleRegion span{display:block;max-width:100%;color:#fff;text-overflow:ellipsis;word-wrap:break-word;overflow:hidden;font-size:25px;max-height:40px}#event-detail-page #group-cover-container .titleRegion span.eventPirod{font-size:15px;display:table}#event-detail-page #group-cover-container .titleRegion span.eventPirod i{font-style:normal;display:table-cell}#event-detail-page #group-cover-container .titleRegion span.eventPirod i:last-child{padding-left:10px}#event-detail-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#event-detail-page #group-content-container .nav-tabs>li{width:calc(100%/2);background-color:transparent;height:40px}@media (max-width:320px){#event-detail-page #group-content-container .nav-tabs>li{font-size:10px}}#event-detail-page #group-content-container .nav-tabs>li:last-child a{margin-right:0}#event-detail-page #group-content-container .nav-tabs>li.active>a:hover,#event-detail-page #group-content-container .nav-tabs>li.active>a:focus,#event-detail-page #group-content-container .nav-tabs>li.active>a{color:#fff;border:1px solid transparent;background-color:#1badac;text-decoration:none;height:40px;margin-top:0}#event-detail-page #group-content-container .nav-tabs>li>a{background-color:#ccc;color:gray;text-align:center;height:35px;margin-top:5px;cursor:pointer}#event-detail-page #group-content-container .tab-content{border:4px solid #1badac;background-color:#fff}#event-detail-page #group-content-container .tab-content .filter-condition{background-color:#ddefee;overflow:hidden;margin:0 15px}#event-detail-page #group-content-container .tab-content .filter-condition .filter-head{cursor:pointer}#event-detail-page #group-content-container .tab-content .filter-condition .target-labels{display:table;table-layout:fixed;width:100%}#event-detail-page #group-content-container .tab-content .filter-condition .target-labels .target-label{display:table-cell}#event-detail-page #group-content-container .tab-content .filter-condition .target-labels .target-label .target-label-content{display:table}#event-detail-page #group-content-container .tab-content .filter-condition .condition-row{width:100%;margin:0 auto;text-overflow:ellipsis;word-wrap:break-word;overflow:hidden}#event-detail-page #group-content-container .tab-content .filter-condition .condition-labels{margin:10px 0;padding-left:2px;padding-right:0}#event-detail-page #group-content-container .tab-content .filter-condition .filter-close-icon{width:20px;margin-right:3px;margin-bottom:3px}#event-detail-page #group-content-container .tab-content .filter-condition span.icon{text-align:center;display:table-cell;background-color:#07a3a4;padding:5px 7px;color:#fff;border-radius:10px}#event-detail-page #group-content-container .tab-content .filter-condition span.condition-value{margin-left:5px;padding-left:0;padding-right:0;color:#07a3a4;font-weight:700;max-height:4.5em;line-height:1.5em;overflow:hidden;padding-top:4px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}#event-detail-page #group-content-container .tab-content .filter-condition .clickable{cursor:pointer}#event-detail-page #group-content-container .tab-content .filter-condition .arrow{float:right}#event-detail-page #group-content-container .tab-content .filter-condition .button{background-color:#a8d5d5;border:#a8d5d5;text-align:center;padding:10px;border-radius:0%}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu{margin:0;padding:0 6px;overflow:hidden;color:#07a3a4;font-size:1.2em}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row{border-bottom:2px solid #bbd2d5;padding:15px 0}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items{margin-top:12px}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items .period .radio-inline,#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items .period .checkbox-inline{padding-right:30px}@media (min-width:414px){#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items .radio-inline{padding:0 15px}}@media (min-width:768px){#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items .radio-inline{font-size:1.23em;padding:0 20px}}@media (min-width:992px){#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items .radio-inline{padding:0 25px}}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items .radio-inline span{padding-left:5px}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items.menu-item-statuses .radio-inline{width:30%}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items .custom-radio{display:none}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items .custom-radio+span{position:relative}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items .custom-radio+span::before{content:\"\";display:block;position:absolute;top:1px;left:-20px;width:15px;height:15px;border:2px solid #07a3a4;border-radius:50%;background:#fff}@media (min-width:768px){#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items .custom-radio+span::before{width:18px;height:18px}}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items .custom-radio+span{color:#009a9a}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items .custom-radio:checked+span::after{content:\"\";display:block;position:absolute;top:3px;left:-18px;width:11px;height:11px;background:#fff;border-radius:50%;border:2px solid #07a3a4}@media (min-width:768px){#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .menu-items .custom-radio:checked+span::after{width:14px;height:14px}}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .course-button{padding-right:0}@media (min-width:992px){#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .course-button{width:19.5%}}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .course-value{padding-left:0}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .course-value-sp{padding-right:0}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .select-button{border:2px solid #a8d5d5;text-align:center;padding:5px;color:#07a3a4;background-color:#fff;font-size:13px;white-space:pre-wrap}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-menu-row .selected-course{display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;text-overflow:ellipsis;word-wrap:break-word;overflow:hidden}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu span.title{display:block;text-align:center}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .title{color:#fff;font-weight:700;background-color:#80a6a7;padding:10px 5px;width:100%}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .button-bottom-row{margin:20px 0}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu input[type=\"radio\"]{margin-top:0}#event-detail-page #group-content-container .tab-content .filter-condition .filter-menu .filter-button{background-color:#07a3a4;border:#07a3a4;text-align:center;padding:10px;opacity:1;width:60%;margin:0 auto;-webkit-tap-highlight-color:transparent;box-shadow:none;outline:none}#event-detail-page #group-content-container .tab-content.submitScore{border:none}#event-detail-page #group-content-container .tab-content .title .row-title{border-bottom:2px solid;padding:15px}#event-detail-page #group-content-container .tab-content .row.descripion p{padding:15px;word-wrap:break-word;overflow:hidden}#event-detail-page #group-content-container .tab-content .row.partMem p{padding:5px;display:table;border:1px solid gray;color:gray;margin-left:15px}#event-detail-page #group-content-container .tab-content .row.partMem p span{display:table-cell}#event-detail-page #group-content-container .tab-content .row.partMem p span:last-child{padding-left:10px}#event-detail-page #group-content-container .tab-content .mainContent{padding-top:10px;padding-bottom:10px;margin-left:0;margin-right:0;overflow:hidden}#event-detail-page #group-content-container .tab-content .row-content{height:150px;display:table;table-layout:fixed;padding-left:0;padding-right:0;border:1px solid #1badac}#event-detail-page #group-content-container .tab-content .row-content .cell{display:table-cell}#event-detail-page #group-content-container .tab-content .row-content .weatherCell{width:135px;background-color:#1badac;text-align:center;vertical-align:middle;color:#fff;font-size:20px}#event-detail-page #group-content-container .tab-content .row-content .weatherCell .weather-icon{background-repeat:no-repeat;background-position:center;height:50px}#event-detail-page #group-content-container .tab-content .row-content .weatherCell .weather-icon.icons-cloudy{background-image:url("+__webpack_require__(370)+")}#event-detail-page #group-content-container .tab-content .row-content .weatherCell .weather-icon.icons-foggy{background-image:url("+__webpack_require__(372)+")}#event-detail-page #group-content-container .tab-content .row-content .weatherCell .weather-icon.icons-rainy{background-image:url("+__webpack_require__(374)+")}#event-detail-page #group-content-container .tab-content .row-content .weatherCell .weather-icon.icons-snowing{background-image:url("+__webpack_require__(376)+")}#event-detail-page #group-content-container .tab-content .row-content .weatherCell .weather-icon.icons-sunny{background-image:url("+__webpack_require__(378)+")}#event-detail-page #group-content-container .tab-content .row-content .scoreCell{width:175px;vertical-align:middle;text-align:center;color:#fff;position:relative}#event-detail-page #group-content-container .tab-content .row-content .scoreCell .icon-round{position:absolute;top:10px;left:10px;width:30px;height:30px;background-repeat:no-repeat;background-position:center;background-size:30px;line-height:30px}#event-detail-page #group-content-container .tab-content .row-content .scoreCell .icon-round.icons-half-nine{background-image:url("+__webpack_require__(538)+")}#event-detail-page #group-content-container .tab-content .row-content .scoreCell .icon-round.icons-extra9{background-image:url("+__webpack_require__(539)+")}#event-detail-page #group-content-container .tab-content .row-content .scoreCell .rounded-circle{width:126px;height:126px;background-color:#1badac;position:relative;margin-left:40px}#event-detail-page #group-content-container .tab-content .row-content .scoreCell .score{font-size:30px;position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;margin:auto}#event-detail-page #group-content-container .tab-content .row-content .scoreCell span.putt{font-size:20px;vertical-align:text-top;margin-left:2px}#event-detail-page #group-content-container .tab-content .row-content .descripionCell{padding-bottom:20px;padding-left:10px;padding-right:10px;vertical-align:middle}#event-detail-page #group-content-container .tab-content .row-content .descripionCell span{display:block;overflow:hidden;text-overflow:ellipsis;white-space:normal;word-wrap:break-word;max-height:40px;line-height:20px}#event-detail-page #group-content-container .tab-content .row-content .descripionCell span.clubName{font-size:18px;font-weight:700}#event-detail-page #group-content-container .tab-content .row-content .descripionCell span.clubAddress{font-size:14px}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnDelete{background-color:#fff;border:1px solid;border-radius:4px;display:-ms-flexbox;display:flex}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .submitted-text{position:absolute;bottom:5px;height:30px;color:#07a3a4;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;font-weight:700;font-size:1.2em}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .submitted-text img{width:15px;margin-right:5px}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnDelete{position:absolute;bottom:5px;right:5px;width:95px;height:30px;color:red;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnDelete img{width:15px;margin-right:5px}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnSelectSubmit,#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnSubmitted{position:absolute;bottom:5px;right:5px;width:95px;height:30px;color:#fff;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnSelectSubmit img,#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnSubmitted img{width:15px;margin-right:5px}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnSelectSubmit{background-color:#1badac;border:#1badac;opacity:.5}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnSelectSubmit.active{opacity:1}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnSubmitted{background-color:#c5c5c5;border:#c5c5c5}@media (max-width:414px){#event-detail-page #group-content-container .tab-content .row-content{height:60px}#event-detail-page #group-content-container .tab-content .row-content .weatherCell{width:60px;font-size:9px}#event-detail-page #group-content-container .tab-content .row-content .weatherCell .weather-icon{height:30px;background-size:22px}#event-detail-page #group-content-container .tab-content .row-content .scoreCell{width:85px}#event-detail-page #group-content-container .tab-content .row-content .scoreCell .icon-round{top:5px;left:5px;width:15px;height:15px;background-size:15px;line-height:15px}#event-detail-page #group-content-container .tab-content .row-content .scoreCell .rounded-circle{width:56px;height:56px;margin-left:22px}#event-detail-page #group-content-container .tab-content .row-content .scoreCell .score{font-size:15px}#event-detail-page #group-content-container .tab-content .row-content .scoreCell span.putt{font-size:9px}#event-detail-page #group-content-container .tab-content .row-content .descripionCell{padding-left:0}#event-detail-page #group-content-container .tab-content .row-content .descripionCell span{max-height:13px;line-height:12px}#event-detail-page #group-content-container .tab-content .row-content .descripionCell span.clubName{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;text-overflow:ellipsis;word-wrap:break-word;overflow:hidden;max-height:2.8em;line-height:1.4em;font-size:8px}#event-detail-page #group-content-container .tab-content .row-content .descripionCell span.clubAddress{font-size:7px}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnSelectSubmit,#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnSubmitted{height:17px;bottom:5px;font-size:8px;width:60px}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnSelectSubmit img,#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnSubmitted img{width:7px}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnDelete{bottom:5px;font-size:8px;width:55px;height:17px}#event-detail-page #group-content-container .tab-content .row-content .descripionCell .btnDelete img{width:7px}}#event-detail-page #group-content-container .tab-content .row-content+.row-content{margin-top:10px}#event-detail-page #group-content-container .tab-content .btnSubmitScore,#event-detail-page #group-content-container .tab-content .btnViewRank{background-color:#1badac;border:1px solid #1badac;font-size:16px;height:70px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}#event-detail-page #group-content-container .tab-content .btnSubmitScore img,#event-detail-page #group-content-container .tab-content .btnViewRank img{width:25px;margin-right:5px}#event-detail-page #group-content-container .tab-content .btnViewRank>img{width:40px}#event-detail-page #group-content-container .tab-content .btnCancel,#event-detail-page #group-content-container .tab-content .btnUpload{height:50px;font-size:14px}#event-detail-page #group-content-container .tab-content .btnCancel{background-color:#c5c5c5;color:#424242;border:#424242}#event-detail-page #group-content-container .tab-content .btnUpload{background-color:#1badac;border:#1badac;opacity:.5;cursor:not-allowed;pointer-events:none}#event-detail-page #group-content-container .tab-content .btnUpload.canUpload{cursor:pointer;pointer-events:all;opacity:1}#event-detail-page #group-content-container .tab-content .row.loadMoreRegion{padding:10px;text-align:center}#event-detail-page #group-content-container .tab-content .row.loadMoreRegion .btn-loadMore{position:relative;margin:0 auto;color:#fff;width:220px;background-color:#555}#event-detail-page #group-content-container .tab-content .row.loadMoreRegion .btn-loadMore.loading{color:transparent}#event-detail-page #group-content-container .tab-content .row.buttonRegion{padding-bottom:10px}#event-detail-page #group-content-container .tab-content .row.buttonRegion.sticky{position:fixed;padding-top:10px;width:100%;z-index:99;top:72px;background-color:#e5e5e5}@media (max-width:414px){#event-detail-page #group-content-container .tab-content .row.buttonRegion.sticky{top:148px}}@media (max-width:555px){#event-detail-page #group-content-container .tab-content{border:1px solid transparent}#event-detail-page #group-content-container .tab-content .btnSubmitScore,#event-detail-page #group-content-container .tab-content .btnViewRank{font-size:10px;text-align:left}#event-detail-page #group-content-container .tab-content .btnSubmitScore img,#event-detail-page #group-content-container .tab-content .btnViewRank img{width:25px}#event-detail-page #group-content-container .tab-content .btnSubmitScore>img{width:17px}#event-detail-page #group-content-container .tab-content .row.buttonRegion{background-color:#e5e5e5}}@media (max-width:991px){#event-detail-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:767px){#event-detail-page #main-main .container,#event-detail-page #main-main .container.dashboard-container{width:100%;min-width:0}#event-detail-page #gnp-header .btn-section,#event-detail-page #gnp-header .user{display:none}#event-detail-page #gnp-footer .copyright{text-align:left;margin-top:0}#event-detail-page .row-content{background-color:#fff!important}#event-detail-page .tab-content.submitScore{background-color:transparent!important}#event-detail-page .filter-condition{background-color:#fff!important}#event-detail-page .filter-condition .filter-menu{border:2px solid #07a3a4;border-top:none;font-size:1em!important}#event-detail-page .filter-condition .menu-items{margin-top:3px!important}#event-detail-page .filter-condition .menu-items.period{line-height:30px}#event-detail-page .filter-condition .menu-items.period .radio-inline,#event-detail-page .filter-condition .menu-items.period .checkbox-inline{padding-right:30px}#event-detail-page .filter-condition span.title{text-align:left!important;background-color:#fff!important;padding:3px!important;color:#07a3a4!important;font-size:.9em;white-space:nowrap}#event-detail-page .filter-condition span.title.period{line-height:100px}#event-detail-page .filter-condition span.icon{padding:3px 2px!important;font-size:.6em}#event-detail-page .filter-condition span.condition-value{-webkit-line-clamp:3!important;font-size:.6em;padding-top:2px!important}#event-detail-page .filter-condition .filter-button{width:80%!important}#event-detail-page .submitted-text{font-size:.5em!important}#event-detail-page .submitted-text img{width:10px!important}}@media (max-width:414px){#event-detail-page .avatarContainer .avatar-image-text.two-characters{font-size:12px}#event-detail-page .avatarContainer .avatar-image-text.one-character{font-size:20px}}.course-list-modal .modal-header,.course-list-modal .modal-footer{background-color:#e7e7e7}.course-list-modal .modal-title{font-size:16px;font-weight:700}.course-list-modal .modal-body tbody tr td{vertical-align:middle}.course-list-modal .modal-body tbody label{display:block}.course-list-modal .modal-body .custom-radio{display:none}.course-list-modal .modal-body .course-name{padding-left:25px;position:relative;margin-right:20px;font-size:16px;font-weight:700}.course-list-modal .modal-body .course-name::before{content:\"\";display:block;position:absolute;top:3px;left:0;width:15px;height:15px;border:1px solid #07a3a4;border-radius:4px}.course-list-modal .modal-body .custom-radio:checked{color:#07a3a4}.course-list-modal .modal-body .custom-radio:checked+.course-name::after{content:\"\";display:block;position:absolute;top:3px;left:5px;width:7px;height:12px;transform:rotate(40deg);border-bottom:2px solid #fff;border-right:2px solid #fff}.course-list-modal .modal-body .custom-radio:checked+.course-name::before{background-color:#07a3a4}.course-list-modal .modal-footer button{background-color:#3a3a3a;color:#fff;border:1px solid #3a3a3a;width:60%;margin:0 auto}@media (max-width:767px){.course-list-modal .modal-body{padding:0}.course-list-modal .modal-body .checked-table{background-color:#a0cccb}.course-list-modal .modal-body .course-name::before{border:0 solid #07a3a4}.course-list-modal .modal-body .custom-radio:checked{color:#a0cccb}.course-list-modal .modal-body .custom-radio:checked+.course-name::after{border-bottom:2px solid #000;border-right:2px solid #000}.course-list-modal .modal-body .custom-radio:checked+.course-name::before{background-color:#a0cccb}}", ""]);

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(720);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_event_rank.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_event_rank.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}#event-rank .mainContent{margin-left:-15px!important;margin-right:-15px!important}#event-rank .event-info{padding:10px 20px}@media (max-width:414px){#event-rank .event-info{padding:7px}}#event-rank .event-info-detail{padding:10px 20px}@media (max-width:414px){#event-rank .event-info-detail{padding:7px}}#event-rank .row-content-description{display:table;border:2px solid #ccc;table-layout:fixed;padding:10px}#event-rank .row-content-description .titleContainer{vertical-align:middle;padding-left:5px}#event-rank .row-content-description .titleContainer.show-detail{text-align:center}#event-rank .row-content-description .titleContainer .btn{background:0 0}#event-rank .row-content-description .titleContainer span{word-wrap:break-word;white-space:normal;overflow:hidden;text-overflow:ellipsis;margin:0;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}#event-rank .row-content-description .titleContainer span.group-name{font-size:14px;color:#ccc;margin-right:130px}@media (max-width:414px){#event-rank .row-content-description .titleContainer span.group-name{margin-right:46px}}#event-rank .row-content-description .titleContainer span.event-name{font-size:14px;-webkit-line-clamp:1;margin-right:130px}#event-rank .row-content-description .titleContainer span.event-name.active{-webkit-line-clamp:3}@media (max-width:414px){#event-rank .row-content-description .titleContainer span.event-name{margin-right:46px}}#event-rank .row-content-description .titleContainer span.view-detail{color:#ccc}#event-rank .row-content-description .titleContainer span.members,#event-rank .row-content-description .titleContainer span.time{font-size:14px;color:gray}#event-rank .row-content-description .titleContainer span.members{display:table}#event-rank .row-content-description .titleContainer span.members i{display:table-cell;font-style:normal;padding-right:10px}#event-rank .row-content-description .titleContainer .block-expand span{display:none}#event-rank .row-content-description .titleContainer .block-expand.active span{display:block}@media (max-width:414px){#event-rank .row-content-description .titleContainer{display:block}#event-rank .row-content-description .titleContainer span{-webkit-line-clamp:1}#event-rank .row-content-description .titleContainer span.members,#event-rank .row-content-description .titleContainer span.time{font-size:8px}}#event-rank .row-content-description .buttonContainer{display:block;position:absolute;top:10px;right:10px}#event-rank .row-content-description .buttonContainer .btn-group{display:inline-block}#event-rank .row-content-description .buttonContainer .btn-group+.btn-group{margin-left:5px}#event-rank .row-content-description .buttonContainer .btn-Setting{background-image:url("+__webpack_require__(715)+");background-repeat:no-repeat;background-size:15px 15px;background-position:left;background-position-x:5px;padding-left:10px;color:#fff;background-color:#1badac;width:120px;border-radius:5px;border-color:#1badac;border-width:2px;border-style:solid;font-size:10px;text-align:center;height:25px}@media (max-width:414px){#event-rank .row-content-description .buttonContainer{bottom:2px}#event-rank .row-content-description .buttonContainer .btn-Setting{width:40px;background-position:center;color:transparent}}#event-rank .row.title{border-bottom:2px solid;padding-top:10px;padding-bottom:10px}#event-rank .row.title h3{word-wrap:break-word}#event-rank .rowMaster{padding:0}#event-rank .rowExpand{background-color:#e5e5e5;padding-top:10px;padding-bottom:10px}#event-rank .row-average-rank{padding-top:10px;padding-bottom:10px;border-bottom:2px solid #ccc}#event-rank .row-average-rank .btn-submit-delete{padding-right:7px}#event-rank .row-average-rank .btn-submit-delete-score{background-color:#1badac;border:1px solid #1badac;font-size:13px;width:100%;height:45px;border-radius:6px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;padding-left:20px}#event-rank .row-average-rank .btn-submit-delete-score img{width:20px;margin-right:5px}#event-rank .row-average-rank .btn-group{background-color:#fff;height:45px;padding-right:0;padding-left:7px;color:#1badac}#event-rank .row-average-rank .btn-group .dropdown-menu{min-width:138px}#event-rank .row-average-rank .btn-group ul.dropdown-menu{top:90%;left:7px;right:7px;width:79%;padding:0;font-size:12px}#event-rank .row-average-rank .btn-group li{border:1px solid #1badac}#event-rank .row-average-rank .btn-group li a{height:45px;padding-left:13px;color:#1badac;line-height:41px;text-align:left;-ms-flex-align:left;align-items:left;-ms-flex-pack:left;justify-content:left}#event-rank .row-average-rank .btn-group li a .text{margin:15px 0 0;line-height:0;font-weight:700;font-size:12px}#event-rank .row-average-rank .btn-group li a .text .muted{padding-left:3.5em;color:darkgray}#event-rank .row-average-rank .btn-group li a:hover{background-color:#c3e3e3}#event-rank .row-average-rank .btn-group .btn-average-sort{width:100%;height:100%;background-color:#fff;border:2px solid #1badac;color:#1badac;border-radius:6px 0 0 6px;padding:0}#event-rank .row-average-rank .btn-group .btn-average-sort .col-img{width:20%;height:41px;line-height:41px;background:#1badac;float:right;padding-left:0;padding-right:0}#event-rank .row-average-rank .btn-group .btn-average-sort img{width:16px}#event-rank .row-average-rank .btn-group .btn-average-sort .col-group{width:80%;line-height:41px;text-align:left;-ms-flex-align:left;align-items:left;-ms-flex-pack:left;justify-content:left;padding-left:15px;padding-right:0}@media (max-width:414px){#event-rank .row-average-rank .btn-group{background-color:#fff;height:45px;padding-right:0;padding-left:7px;color:#1badac}#event-rank .row-average-rank .btn-group .dropdown-menu{min-width:185px}#event-rank .row-average-rank .btn-group ul.dropdown-menu{top:90%;right:15px;width:82%;padding:0;font-size:10px}#event-rank .row-average-rank .btn-group li{border:1px solid #1badac}#event-rank .row-average-rank .btn-group li a{height:45px;padding-left:5px;color:#1badac;line-height:41px;text-align:left;-ms-flex-align:left;align-items:left;-ms-flex-pack:left;justify-content:left}#event-rank .row-average-rank .btn-group .btn-average-sort{width:100%;height:100%;background-color:#fff;border:2px solid #1badac;color:#1badac;border-radius:6px 0 0 6px;padding:0}#event-rank .row-average-rank .btn-group .btn-average-sort .col-img{width:20%}#event-rank .row-average-rank .btn-group .btn-average-sort img{width:13px}#event-rank .row-average-rank .btn-group .btn-average-sort .col-group{width:80%;font-size:10px;padding-left:4px}#event-rank .row-average-rank .rankingContainer{width:40px}#event-rank .row-average-rank .list-ranking{background-size:40px;width:40px;line-height:56px;font-size:12px}#event-rank .row-average-rank .ranking-over-three{line-height:45px}#event-rank .row-average-rank .imgContainer{width:50px}#event-rank .row-average-rank img.rounded-circle{width:38px;height:38px;background-size:38px}#event-rank .row-average-rank .titleContainer .name,#event-rank .row-average-rank .titleContainer .time{font-size:12px}#event-rank .row-average-rank .buttonContainer .btn-score-analysis{width:43%;font-size:7px;height:54px}#event-rank .row-average-rank .buttonContainer .btn-score-analysis img{width:20px}#event-rank .row-average-rank .buttonContainer .btnExpand{width:35%;font-size:7px;height:54px}#event-rank .row-average-rank .buttonContainer .btnExpand img{width:14px}}@media (max-width:375px){#event-rank .row-average-rank .btn-submit-delete-score{background-color:#1badac;border:1px solid #1badac;font-size:12px;width:100%;height:45px;border-radius:6px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;padding-left:15px}#event-rank .row-average-rank .btn-submit-delete-score img{width:20px;margin-right:5px}#event-rank .row-average-rank .btn-group{background-color:#fff;height:45px;padding-right:0;color:#1badac}#event-rank .row-average-rank .btn-group .dropdown-menu{min-width:158px}#event-rank .row-average-rank .btn-group ul.dropdown-menu{top:90%;right:15px;width:82%;padding:0;font-size:10px}#event-rank .row-average-rank .btn-group .btn-average-sort .col-img{width:20%}#event-rank .row-average-rank .btn-group .btn-average-sort .col-group{width:80%;font-size:10px;padding-left:4px}}@media (max-width:320px){#event-rank .row-average-rank .titleContainer .name,#event-rank .row-average-rank .titleContainer .time{font-size:9px}#event-rank .row-average-rank .btn-submit-delete-score{background-color:#1badac;border:1px solid #1badac;font-size:9px;width:100%;height:45px;border-radius:6px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;padding-left:15px}#event-rank .row-average-rank .btn-submit-delete-score img{width:20px;margin-right:5px}#event-rank .row-average-rank .btn-group{background-color:#fff;height:45px;padding-right:0;color:#1badac}#event-rank .row-average-rank .btn-group .dropdown-menu{min-width:138px}#event-rank .row-average-rank .btn-group ul.dropdown-menu{top:90%;right:15px;width:82%;padding:0;font-size:10px}#event-rank .row-average-rank .btn-group .btn-average-sort .col-img{width:20%}#event-rank .row-average-rank .btn-group .btn-average-sort .col-group{width:80%;font-size:10px;padding-left:4px}}#event-rank .row-event-rank{display:table;padding:5px;border-bottom:2px solid #ccc;cursor:pointer;table-layout:fixed}#event-rank .row-event-rank .imgContainer{display:table-cell;width:90px;text-align:center;vertical-align:middle}#event-rank .row-event-rank .rankingContainer{display:table-cell;width:70px;text-align:center;vertical-align:middle}#event-rank .row-event-rank img.rounded-circle{width:80px;height:80px;image-orientation:from-image}#event-rank .row-event-rank .titleContainer{display:table-cell;vertical-align:middle;word-wrap:break-word;overflow:hidden}#event-rank .row-event-rank .titleContainer .name{font-size:18px;font-weight:700;padding:0}#event-rank .row-event-rank .titleContainer .time{font-size:16px;color:gray;padding:0}#event-rank .row-event-rank .buttonContainer{display:table-cell;vertical-align:middle;max-width:24%}#event-rank .row-event-rank .buttonContainer .btn-score-analysis{border-radius:4px;width:45%;height:70px;color:#1badac;border:1px solid #1badac;background-color:#fff;vertical-align:middle}#event-rank .row-event-rank .buttonContainer .btn-score-analysis img{width:34px;margin:5px auto;display:block}#event-rank .row-event-rank .buttonContainer .btnExpand{margin-left:10px;border-radius:4px;width:45%;height:70px;color:#1badac;border:1px solid #1badac;background-color:#fff;vertical-align:middle}#event-rank .row-event-rank .buttonContainer .btnExpand img{display:block;margin:5px auto}#event-rank .row-event-rank .list-ranking{width:68px;height:45px;line-height:65px;background-repeat:no-repeat;background-position:center;font-weight:700;font-size:18px;margin:0 auto}#event-rank .row-event-rank .ranking-one{color:#fff;background-image:url("+__webpack_require__(721)+")}#event-rank .row-event-rank .ranking-two{color:#fff;background-image:url("+__webpack_require__(722)+")}#event-rank .row-event-rank .ranking-three{color:#fff;background-image:url("+__webpack_require__(723)+")}#event-rank .row-event-rank .ranking-over-three{color:#000;background-image:url("+__webpack_require__(724)+");line-height:45px}@media (max-width:414px){#event-rank .row-event-rank .btn-group{background-color:#fff;height:45px;padding-right:0;padding-left:7px}#event-rank .row-event-rank .btn-group ul.dropdown-menu{top:90%;left:15px;right:15px;width:82%;padding:0;font-size:12px}#event-rank .row-event-rank .btn-group li{border:1px solid #1badac}#event-rank .row-event-rank .btn-group li a{height:45px;padding-left:13px;color:#1badac;line-height:41px;text-align:left;-ms-flex-align:left;align-items:left;-ms-flex-pack:left;justify-content:left}#event-rank .row-event-rank .btn-group .btn-average-sort{width:100%;height:100%;background-color:#fff;border:2px solid #1badac;color:#1badac;border-radius:6px 0 0 6px;padding:0}#event-rank .row-event-rank .btn-group .btn-average-sort .col-img{width:20%}#event-rank .row-event-rank .btn-group .btn-average-sort img{width:13px}#event-rank .row-event-rank .btn-group .btn-average-sort .col-group{width:80%;font-size:10px}#event-rank .row-event-rank .rankingContainer{width:40px}#event-rank .row-event-rank .list-ranking{background-size:40px;width:40px;line-height:56px;font-size:12px}#event-rank .row-event-rank .ranking-over-three{line-height:45px}#event-rank .row-event-rank .imgContainer{width:50px}#event-rank .row-event-rank img.rounded-circle{width:38px;height:38px;background-size:38px}#event-rank .row-event-rank .titleContainer .name,#event-rank .row-event-rank .titleContainer .time{font-size:12px}#event-rank .row-event-rank .buttonContainer .btn-score-analysis{width:43%;font-size:7px;height:54px}#event-rank .row-event-rank .buttonContainer .btn-score-analysis img{width:20px}#event-rank .row-event-rank .buttonContainer .btnExpand{width:35%;font-size:7px;height:54px}#event-rank .row-event-rank .buttonContainer .btnExpand img{width:14px}}@media (max-width:375px){#event-rank .row-event-rank .btn-group{background-color:#fff;height:45px;padding-right:0}#event-rank .row-event-rank .btn-group ul.dropdown-menu{top:90%;left:15px;right:15px;width:82%;padding:0;font-size:7px}#event-rank .row-event-rank .btn-group .btn-average-sort .col-img{width:20%}#event-rank .row-event-rank .btn-group .btn-average-sort .col-group{width:80%;font-size:7px}}@media (max-width:320px){#event-rank .row-event-rank .titleContainer .name,#event-rank .row-event-rank .titleContainer .time{font-size:9px}#event-rank .row-event-rank .btn-group{background-color:#fff;height:45px;padding-right:0}#event-rank .row-event-rank .btn-group ul.dropdown-menu{top:90%;left:15px;right:15px;width:82%;padding:0;font-size:7px}#event-rank .row-event-rank .btn-group .btn-average-sort .col-img{width:20%}#event-rank .row-event-rank .btn-group .btn-average-sort .col-group{width:80%;font-size:7px}}#event-rank .row-content-score{height:150px;display:table;table-layout:fixed;border:1px solid #1badac;padding-left:0;padding-right:0}#event-rank .row-content-score .cell{display:table-cell}#event-rank .row-content-score .weatherCell{width:135px;background-color:#1badac;text-align:center;vertical-align:middle;color:#fff;font-size:20px}#event-rank .row-content-score .weatherCell .weather-icon{background-repeat:no-repeat;background-position:center;height:50px}#event-rank .row-content-score .weatherCell .weather-icon.icons-cloudy{background-image:url("+__webpack_require__(370)+")}#event-rank .row-content-score .weatherCell .weather-icon.icons-foggy{background-image:url("+__webpack_require__(372)+")}#event-rank .row-content-score .weatherCell .weather-icon.icons-rainy{background-image:url("+__webpack_require__(374)+")}#event-rank .row-content-score .weatherCell .weather-icon.icons-snowing{background-image:url("+__webpack_require__(376)+")}#event-rank .row-content-score .weatherCell .weather-icon.icons-sunny{background-image:url("+__webpack_require__(378)+")}#event-rank .row-content-score .scoreCell{width:175px;vertical-align:middle;text-align:center;color:#fff;background-color:#fff;position:relative}#event-rank .row-content-score .scoreCell .icon-round{position:absolute;top:10px;left:10px;width:30px;height:30px;background-repeat:no-repeat;background-position:center;background-size:30px;line-height:30px}#event-rank .row-content-score .scoreCell .icon-round.icons-half-nine{background-image:url("+__webpack_require__(538)+")}#event-rank .row-content-score .scoreCell .icon-round.icons-extra9{background-image:url("+__webpack_require__(539)+")}#event-rank .row-content-score .scoreCell .rounded-circle{width:126px;height:126px;background-color:#1badac;position:relative;margin-left:40px}#event-rank .row-content-score .scoreCell .score{font-size:30px;position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;margin:auto}#event-rank .row-content-score .scoreCell span.putt{font-size:20px;vertical-align:text-top;margin-left:2px}#event-rank .row-content-score .descripionCell{padding-bottom:20px;vertical-align:middle;background-color:#fff;padding-left:10px;padding-right:10px}#event-rank .row-content-score .descripionCell span{display:block;overflow:hidden;text-overflow:ellipsis;white-space:normal;word-wrap:break-word;max-height:40px;line-height:20px}#event-rank .row-content-score .descripionCell span.clubName{font-size:18px;font-weight:700;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;overflow:hidden}#event-rank .row-content-score .descripionCell span.clubAddress{font-size:14px;margin:10px auto}#event-rank .row-content-score .descripionCell .buttonContainer{display:table-cell;vertical-align:middle}#event-rank .row-content-score .descripionCell .buttonContainer .btn-analysis{border-radius:4px;height:40px;color:#1badac;border:1px solid #1badac;background-color:#fff;vertical-align:middle}#event-rank .row-content-score .descripionCell .buttonContainer .btn-analysis img{width:34px;margin:5px 2px}@media (max-width:414px){#event-rank .row-content-score{height:60px}#event-rank .row-content-score .weatherCell{width:60px;font-size:9px}#event-rank .row-content-score .weatherCell .weather-icon{height:30px;background-size:22px}#event-rank .row-content-score .scoreCell{width:85px}#event-rank .row-content-score .scoreCell .icon-round{top:5px;left:5px;width:15px;height:15px;background-size:15px;line-height:15px}#event-rank .row-content-score .scoreCell .rounded-circle{width:56px;height:56px;margin-left:22px}#event-rank .row-content-score .scoreCell .score{font-size:15px}#event-rank .row-content-score .scoreCell span.putt{font-size:9px}#event-rank .row-content-score .descripionCell{padding-left:0}#event-rank .row-content-score .descripionCell span{max-height:13px;line-height:12px}#event-rank .row-content-score .descripionCell span.clubName{font-size:8px;max-height:10px;line-height:10px;margin-top:5px}#event-rank .row-content-score .descripionCell span.clubAddress{font-size:8px;margin:0;padding-bottom:5px}#event-rank .row-content-score .descripionCell .buttonContainer{display:table-cell;vertical-align:middle}#event-rank .row-content-score .descripionCell .buttonContainer .btn-analysis{border-radius:4px;height:26px;font-size:8px}}@media (max-width:360px){#event-rank .row-content-score .descripionCell .buttonContainer .btn-analysis img{width:22px}}@media (max-width:320px){#event-rank .row-content-score .scoreCell{width:68px}#event-rank .row-content-score .scoreCell .icon-round{top:5px;left:5px;width:10px;height:10px;background-size:10px;line-height:10px}#event-rank .row-content-score .scoreCell .rounded-circle{width:50px;height:50px;margin-left:14px}#event-rank .row-content-score .descripionCell .buttonContainer .btn-analysis{padding:0}#event-rank .row-content-score .descripionCell .buttonContainer .btn-analysis img{width:12px;margin:5px 2px}}#event-rank .row-content-score+.row-content-score{margin-top:10px}", ""]);

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAtCAMAAAAgNj0SAAABL1BMVEXwwAL////wwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALwwALVwKDHAAAAZHRSTlMAAAEDBgcICQsNDxASFRcdICEjJCstLi8zNjc4P0BHTVRXXV5gY2Zqb3Bxd3h9fn+FjZqcnZ6hqK6wtba4ub2/wsPGycvS09bX2Nzd3+Hi5OXm5+nq6+zt7u/w8/T1+fr7/P3+ZSqhCwAAAitJREFUSMedludawjAUhoOAIC5AVERxAA5AcAJuBBVZ4mK4WNr7vwZN2qYjhz4m51ea78ub0eQkCFmGe7fU75d23aMdtr+wZvgqEomKTxziKktK3LuEIQmJRlwYcqNBboQh7xqkIwzp/B/i3srk9vyQIa9B8pDu38tlttwYEnrCpkESMEU1SBSQkwOsPIVsyKdOfJN12elQ8nZW3VS0dy/KqL62k/V5zmXt3MNqzrba8hi16IjD0LQfsPIAKWHasIW0aW8ATscQK0MHIG1oLVGTFlcA55IsLQHSCm3YREdq8RXqbkfWdqBB0u6P0OybxU9EF7J2gSw2wNssQsE6Kf7MA77JnuzrTQLi/A/R6kG8Y13RIv64BHxxq0N8iYVi1KWcnTVijLHTrqqQKrtgMSKs0QM4QfZvd3HEsoJLu/BFTsuEdoqvifFxzuib+9Qgn2btkVRf61JBWna+GPbDdFnSRXnasH9e5Nq0DrKsOPupceoL1iRD1IJUGk/1lcplHcT+oVobSS+uGAtlh5IphtnQGNa8yYZa9WHXZ7YTnblxdVroSGC0C6dXDd33iSE9bktCsW2A+MUgfmOirosw6qZsfygCOTRB1kUg6ybI1Dc/43vKfHnd8kNumRtwnx+yz0DC/JAwA3F0eRldB3uhn/FCzoBXQYIXkgAgAV5IAHqfPPMxnsFHTpYPkgUhET5IBITM8EFm4DfbHQ/jbsTD74AHcjACssoDWdVBfgF1Vlztt7JysQAAAABJRU5ErkJggg=="

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAtCAMAAAAgNj0SAAABL1BMVEW0wsb///+0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsa0wsYSTxcMAAAAZHRSTlMAAAEDBgcICQsNDxASFRcdICEjJCstLi8zNjc4P0BHTVRXXV5gY2Zqb3Bxd3h9fn+FjZqcnZ6hqK6wtba4ub2/wsPGycvS09bX2Nzd3+Hi5OXm5+nq6+zt7u/w8/T1+fr7/P3+ZSqhCwAAAitJREFUSMedludawjAUhoOAIC5AVERxAA5AcAJuBBVZ4mK4WNr7vwZN2qYjhz4m51ea78ub0eQkCFmGe7fU75d23aMdtr+wZvgqEomKTxziKktK3LuEIQmJRlwYcqNBboQh7xqkIwzp/B/i3srk9vyQIa9B8pDu38tlttwYEnrCpkESMEU1SBSQkwOsPIVsyKdOfJN12elQ8nZW3VS0dy/KqL62k/V5zmXt3MNqzrba8hi16IjD0LQfsPIAKWHasIW0aW8ATscQK0MHIG1oLVGTFlcA55IsLQHSCm3YREdq8RXqbkfWdqBB0u6P0OybxU9EF7J2gSw2wNssQsE6Kf7MA77JnuzrTQLi/A/R6kG8Y13RIv64BHxxq0N8iYVi1KWcnTVijLHTrqqQKrtgMSKs0QM4QfZvd3HEsoJLu/BFTsuEdoqvifFxzuib+9Qgn2btkVRf61JBWna+GPbDdFnSRXnasH9e5Nq0DrKsOPupceoL1iRD1IJUGk/1lcplHcT+oVobSS+uGAtlh5IphtnQGNa8yYZa9WHXZ7YTnblxdVroSGC0C6dXDd33iSE9bktCsW2A+MUgfmOirosw6qZsfygCOTRB1kUg6ybI1Dc/43vKfHnd8kNumRtwnx+yz0DC/JAwA3F0eRldB3uhn/FCzoBXQYIXkgAgAV5IAHqfPPMxnsFHTpYPkgUhET5IBITM8EFm4DfbHQ/jbsTD74AHcjACssoDWdVBfgF1Vlztt7JysQAAAABJRU5ErkJggg=="

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAtCAMAAAAgNj0SAAABL1BMVEXall/////all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all/all8kQdGuAAAAZHRSTlMAAAEDBgcICQsNDxASFRcdICEjJCstLi8zNjc4P0BHTVRXXV5gY2Zqb3Bxd3h9fn+FjZqcnZ6hqK6wtba4ub2/wsPGycvS09bX2Nzd3+Hi5OXm5+nq6+zt7u/w8/T1+fr7/P3+ZSqhCwAAAitJREFUSMedludawjAUhoOAIC5AVERxAA5AcAJuBBVZ4mK4WNr7vwZN2qYjhz4m51ea78ub0eQkCFmGe7fU75d23aMdtr+wZvgqEomKTxziKktK3LuEIQmJRlwYcqNBboQh7xqkIwzp/B/i3srk9vyQIa9B8pDu38tlttwYEnrCpkESMEU1SBSQkwOsPIVsyKdOfJN12elQ8nZW3VS0dy/KqL62k/V5zmXt3MNqzrba8hi16IjD0LQfsPIAKWHasIW0aW8ATscQK0MHIG1oLVGTFlcA55IsLQHSCm3YREdq8RXqbkfWdqBB0u6P0OybxU9EF7J2gSw2wNssQsE6Kf7MA77JnuzrTQLi/A/R6kG8Y13RIv64BHxxq0N8iYVi1KWcnTVijLHTrqqQKrtgMSKs0QM4QfZvd3HEsoJLu/BFTsuEdoqvifFxzuib+9Qgn2btkVRf61JBWna+GPbDdFnSRXnasH9e5Nq0DrKsOPupceoL1iRD1IJUGk/1lcplHcT+oVobSS+uGAtlh5IphtnQGNa8yYZa9WHXZ7YTnblxdVroSGC0C6dXDd33iSE9bktCsW2A+MUgfmOirosw6qZsfygCOTRB1kUg6ybI1Dc/43vKfHnd8kNumRtwnx+yz0DC/JAwA3F0eRldB3uhn/FCzoBXQYIXkgAgAV5IAHqfPPMxnsFHTpYPkgUhET5IBITM8EFm4DfbHQ/jbsTD74AHcjACssoDWdVBfgF1Vlztt7JysQAAAABJRU5ErkJggg=="

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAsCAMAAAANQyXzAAABpFBMVEVCQkL///9CQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkKbBvTFAAAAi3RSTlMAAAECAwQGBwkKCwwPERITFRYZGx0eICEjJicoLjAxMjY3PT4/QUNESEpLTk9QUVRVWVpbXF1eYWJkZWZpamtucXJzdHd4gIOEhYiJioyNjpGSk5eanJ6hoqWmqKytsLGyt7m6u8DBw8bIy87Q0dPU1djb3N7i4+Tl5ufo6evu7/H09fb4+fr7/P3+9jFmLgAAAsBJREFUGBmdwflDDA0cx/H3d3YtmXVkRfZB7kWJ0ONIlLsc0eEskftm172uRUY+/7TZ2VltP9TOeL2YaccjMTc92kEtY4aT0nPm9lw6SQ2jKnm4gW2S2plbu6RtNBxOUmGEnFHtYkJTPdTTM6UJdmnUIWCEOqVuro+spb61I9fpljoJGKG7Uo7octJdAkaoqFfziG7eKxUJGKGXPzY3Dr45SxRn3ww2bv7xkoAR2tmy+r20nyj2S+9Xt+wkYFS5r6W3C4hiwVvptUuF4RvqAHqlr+uIZt1XqRfoGAIDNuh7BsZ+T6wiqlUTv8cg810bMOC8dBRWLiWOpSvhqHQeA65KI/yLEekqBlyQhkkc7CaOQ10JhqWLGNAqdaXG9Zg4Hms81SW1YkDyQdHtl54Sx1Op3y0+SGL40tklk9Il4rgkTS75Lw1GoEPSeuJYL6kDnxHolQaIZ0DqxWf0tTnQ7vUniCfR77WD09aHdMsl1Uh8jSncWxKfpVH+1aj0mcuSNgLziWc+sFHSZZpL0iCseLeFOLa8WwGDUqkZtn/TDbimgkN0TkHX4Ia+bTcgO3yMZElaQ3RrpFKSY8NZjIplklqJrlXSMsqMioWSckSXk7SQMiP0TF6a6NKenhEwQp0awj2XJor0OZch7SVgVO1r4ITuJagvcU8naNhHhQG5Dx/vHEwB96Xd1Ldbug+kDtz5+CGHAZmfkl5koSDdpL6bUgGyLyT9zGD4TslXbOKhlKe+vPSQpqJ8p8DwOQPyjXFGKlBfXjrDmHwDDhiBTbc9eammSY1T37gmm1KevNub8Bkht3kx7PG2Ut9Wbw8sbnYJGDMsJ4rl1DBqZRYRxaIM04xpx79In660MLeWK5+kL8epMqa1qWyqz2F2Tt+UytqoMmp0llR2hNkdUVnpf/4yamVOP/mlfA+z68nr15PTGabZH452yiQLLVYlAAAAAElFTkSuQmCC"

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupEventEditCtrl, moment;
	
	$ = __webpack_require__(1);
	
	__webpack_require__(503);
	
	moment = __webpack_require__(126);
	
	GroupEventEditCtrl = function($scope, $filter, $location, flash, formDialogService, formFileReaderService, detailData, groupRegisDataService, groupEventService, $ngConfirm) {
	  var checkValidDate, configDatePicker, defDirS3, groupEventInfo, isNotValidSizeFile, maxFileUploadSize, openFileDialog;
	  groupEventInfo = detailData.eventDetail;
	  if (groupEventInfo === void 0 || groupEventInfo.id === void 0) {
	    return $location.path('/groups');
	  }
	  angular.element(document.body).css('min-width', 0);
	  $scope.eventInfo = {
	    group_id: groupEventInfo.group_id,
	    id: groupEventInfo.id,
	    start_date: moment(groupEventInfo.start_date).format("'YYYY-MM-DD'T'HH:mm:ssZ'"),
	    end_date: moment(groupEventInfo.end_date).format("'YYYY-MM-DD'T'HH:mm:ssZ'"),
	    name: groupEventInfo.name,
	    location: groupEventInfo.location,
	    description: groupEventInfo.description
	  };
	  $scope.croppedCoverPhoto = groupEventInfo.cover_url;
	  $scope.groupEventInfo = groupEventInfo;
	  defDirS3 = {
	    prefixCover: 'images/group/event'
	  };
	  maxFileUploadSize = 5000000;
	  configDatePicker = {
	    singleDatePicker: true,
	    showDropdowns: true,
	    locale: {
	      format: "YYYY/MM/DD"
	    }
	  };
	  $scope.isSubmitting = false;
	  groupRegisDataService.createS3ImageURL(defDirS3.prefixCover).then(function(resp) {
	    return $scope.preDataCover = resp.data;
	  });
	  $(document).ready(function() {
	    document.body.scrollTop = document.documentElement.scrollTop = 0;
	    $('#txtStartDate').daterangepicker(configDatePicker, function(start, end) {
	      return checkValidDate();
	    });
	    return $('#txtEndDate').daterangepicker(configDatePicker, function(start, end) {
	      return checkValidDate();
	    });
	  });
	  $scope.chooseCover = function() {
	    return openFileDialog(function(file, fileLocation) {
	      return formFileReaderService.loadImageOrientation('coverPhoto', file).then(function(data) {
	        $scope.coverData = data;
	        $scope.coverPhoto = data.base64Data;
	        return $('.crop-image-modal').modal('show');
	      });
	    });
	  };
	  $scope.cancelCropModal = function() {
	    $scope.coverPhoto = '';
	    $('#coverPhoto').attr('src', '');
	    $scope.croppedCoverPhoto = $scope.groupEventInfo.cover_url;
	    $('.crop-image-modal').modal('hide');
	  };
	  $scope.submitCropModal = function() {
	    $('.crop-image-modal').modal('hide');
	  };
	  $scope.submit = function(eventInfo) {
	    var coverData, coverFile;
	    $scope.isSubmitting = true;
	    coverFile = $scope.coverPhoto != null ? $scope.croppedCoverPhotoBlob : $scope.croppedCoverPhoto;
	    coverData = {
	      coverFile: coverFile,
	      url: $scope.preDataCover.url,
	      fields: $scope.preDataCover.fields
	    };
	    return groupEventService.updateEvent(eventInfo, coverData).then(function(data) {
	      if (data === 'success') {
	        flash.success(data);
	        $scope.isSubmitting = false;
	        return $scope.gotoEventTab();
	      }
	    }, function(data) {
	      if ((data != null ? data.data.code : void 0) === 'error.name_already_taken') {
	        flash.error($filter('translate')('NAME_DUPLICATED'));
	      } else {
	        flash.error($filter('translate')('API_ERROR'));
	      }
	      return $scope.isSubmitting = false;
	    });
	  };
	  $scope.buttonCancelClick = function() {
	    return $scope.gotoEventTab();
	  };
	  $scope.gotoEventTab = function() {
	    var url;
	    url = "/group-event/" + groupEventInfo.id + "/ranking";
	    return $location.url(url);
	  };
	  $scope.deleteEvent = function() {
	    var config, errorMess, mess;
	    mess = $filter('translate')('_GROUP_EVENT.CONFIRM_MESS');
	    errorMess = $filter('translate')('_GROUP_EVENT.CANCEL');
	    config = {
	      title: '',
	      content: mess,
	      buttons: {
	        Cancel: {
	          text: $filter('translate')('_GROUP_EVENT.CANCEL')
	        },
	        OkButton: {
	          text: 'OK',
	          action: function() {
	            return groupEventService.deleteEvent(groupEventInfo.id).then(function(resp) {
	              var url_rank;
	              url_rank = "/groups/" + groupEventInfo.group_id + "#rank";
	              return $location.url(url_rank);
	            })["catch"](function(resp) {
	              return $ngConfirm(errorMess);
	            });
	          }
	        }
	      }
	    };
	    return $ngConfirm(config);
	  };
	  checkValidDate = function() {
	    var endData, startData;
	    startData = $('#txtStartDate').data('daterangepicker');
	    endData = $('#txtEndDate').data('daterangepicker');
	    if (startData === void 0 || endData === void 0) {
	      return;
	    }
	    if (startData.startDate > endData.startDate) {
	      return $scope.eventForm.endDate.$setValidity('dateValid', false);
	    } else {
	      return $scope.eventForm.endDate.$setValidity('dateValid', true);
	    }
	  };
	  isNotValidSizeFile = function(file) {
	    return file.size > maxFileUploadSize;
	  };
	  return openFileDialog = function(callback) {
	    var options;
	    options = {
	      accept: 'image/*'
	    };
	    return formDialogService._open(options, function(file, fileLocation) {
	      if (isNotValidSizeFile(file)) {
	        $ngConfirm('Image size is more than ' + maxFileUploadSize + ' bytes');
	        return;
	      }
	      return callback(file, fileLocation);
	    });
	  };
	};
	
	GroupEventEditCtrl.$inject = ['$scope', '$filter', '$location', 'flash', 'formDialogService', 'formFileReaderService', 'detailData', 'groupRegisDataService', 'groupEventService', '$ngConfirm'];
	
	module.exports = GroupEventEditCtrl;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupEventRegistCtrl, moment;
	
	$ = __webpack_require__(1);
	
	__webpack_require__(503);
	
	moment = __webpack_require__(126);
	
	GroupEventRegistCtrl = function($scope, $filter, $location, flash, formDialogService, formFileReaderService, groupInfo, groupRegisDataService, groupEventService, $ngConfirm) {
	  var checkValidDate, configDatePicker, defDirS3, isNotValidSizeFile, maxFileUploadSize, openFileDialog;
	  if (groupInfo === void 0 || groupInfo.id === void 0) {
	    return $location.path('/groups');
	  }
	  angular.element(document.body).css('min-width', 0);
	  $scope.eventInfo = {
	    group_id: groupInfo.id,
	    start_date: moment().format("'YYYY-MM-DD'T'HH:mm:ssZ'"),
	    end_date: moment().format("'YYYY-MM-DD'T'HH:mm:ssZ'")
	  };
	  defDirS3 = {
	    prefixCover: 'images/group/event'
	  };
	  maxFileUploadSize = 5000000;
	  configDatePicker = {
	    singleDatePicker: true,
	    showDropdowns: true,
	    locale: {
	      format: "YYYY/MM/DD"
	    }
	  };
	  $scope.isSubmitting = false;
	  $scope.coverPhoto = '';
	  $scope.croppedCoverPhoto = '';
	  $scope.croppedCoverPhotoBlob = '';
	  groupRegisDataService.createS3ImageURL(defDirS3.prefixCover).then(function(resp) {
	    return $scope.preDataCover = resp.data;
	  });
	  $(document).ready(function() {
	    document.body.scrollTop = document.documentElement.scrollTop = 0;
	    $('#txtStartDate').daterangepicker(configDatePicker, function(start, end) {
	      return checkValidDate();
	    });
	    return $('#txtEndDate').daterangepicker(configDatePicker, function(start, end) {
	      return checkValidDate();
	    });
	  });
	  $scope.chooseCover = function() {
	    return openFileDialog(function(file, fileLocation) {
	      return formFileReaderService.loadImageOrientation('coverPhoto', file).then(function(data) {
	        $scope.coverData = data;
	        $scope.coverPhoto = data.base64Data;
	        return $('.crop-image-modal').modal('show');
	      });
	    });
	  };
	  $scope.cancelCropModal = function() {
	    $scope.coverPhoto = '';
	    $scope.croppedCoverPhoto = '';
	    $('#coverPhoto').attr('src', '');
	    $('.crop-image-modal').modal('hide');
	  };
	  $scope.submitCropModal = function() {
	    $('.crop-image-modal').modal('hide');
	  };
	  $scope.submit = function(eventInfo) {
	    var coverData;
	    $scope.isSubmitting = true;
	    coverData = {
	      coverFile: $scope.croppedCoverPhotoBlob,
	      url: $scope.preDataCover.url,
	      fields: $scope.preDataCover.fields
	    };
	    return groupEventService.createEvent(eventInfo, coverData).then(function(resp) {
	      if (resp.data === 'success') {
	        flash.success(resp.data);
	        $scope.isSubmitting = false;
	        return $scope.gotoRankTab();
	      }
	    }, function(data) {
	      if ((data != null ? data.data.code : void 0) === 'error.name_already_taken') {
	        flash.error($filter('translate')('NAME_DUPLICATED'));
	      } else {
	        flash.error($filter('translate')('API_ERROR'));
	      }
	      return $scope.isSubmitting = false;
	    });
	  };
	  $scope.buttonCancelClick = function() {
	    return $scope.gotoRankTab();
	  };
	  $scope.gotoRankTab = function() {
	    var url;
	    url = "/groups/" + groupInfo.id + "#rank";
	    return $location.url(url);
	  };
	  checkValidDate = function() {
	    var endData, startData;
	    startData = $('#txtStartDate').data('daterangepicker');
	    endData = $('#txtEndDate').data('daterangepicker');
	    if (startData === void 0 || endData === void 0) {
	      return;
	    }
	    $scope.eventInfo.start_date = startData.startDate.format("'YYYY-MM-DD'T'HH:mm:ssZ'");
	    $scope.eventInfo.end_date = endData.startDate.endOf("day").format("'YYYY-MM-DD'T'HH:mm:ssZ'");
	    if (startData.startDate > endData.startDate) {
	      return $scope.eventForm.endDate.$setValidity('dateValid', false);
	    } else {
	      return $scope.eventForm.endDate.$setValidity('dateValid', true);
	    }
	  };
	  isNotValidSizeFile = function(file) {
	    return file.size > maxFileUploadSize;
	  };
	  return openFileDialog = function(callback) {
	    var options;
	    options = {
	      accept: 'image/*'
	    };
	    return formDialogService._open(options, function(file, fileLocation) {
	      if (isNotValidSizeFile(file)) {
	        $ngConfirm('Image size is more than ' + maxFileUploadSize + ' bytes');
	        return;
	      }
	      return callback(file, fileLocation);
	    });
	  };
	};
	
	GroupEventRegistCtrl.$inject = ['$scope', '$filter', '$location', 'flash', 'formDialogService', 'formFileReaderService', 'groupInfo', 'groupRegisDataService', 'groupEventService', '$ngConfirm'];
	
	module.exports = GroupEventRegistCtrl;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupEventListCtrl, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	$ = __webpack_require__(1);
	
	GroupEventListCtrl = function($scope, $translate, $filter, $location, groupEventService, $ngConfirm, flash) {
	  var listDetail, refreshListData;
	  listDetail = this;
	  listDetail.pageSize = 4;
	  listDetail.lstEvents = [];
	  listDetail.currentPage = 0;
	  listDetail.isLoading = false;
	  listDetail.noResults = true;
	  listDetail.totalPages = 0;
	  listDetail.showCreateButton = false;
	  listDetail.groupAdmin = false;
	  listDetail.loadMore = function() {
	    var params;
	    listDetail.isLoading = true;
	    listDetail.currentPage++;
	    params = {
	      id: $scope.groupDetail.id,
	      page: listDetail.currentPage,
	      page_size: listDetail.pageSize
	    };
	    return groupEventService.listEvent(params).then(function(data) {
	      listDetail.lstEvents = _.union(listDetail.lstEvents, data.events);
	      listDetail.totalPages = data.total_pages;
	      return listDetail.noResults = listDetail.lstEvents.length === 0;
	    })["finally"](function() {
	      return listDetail.isLoading = false;
	    });
	  };
	  listDetail.hasMore = function() {
	    return listDetail.noResults === false && listDetail.currentPage < listDetail.totalPages;
	  };
	  refreshListData = function() {
	    listDetail.lstEvents = [];
	    listDetail.currentPage = 0;
	    listDetail.isLoading = false;
	    listDetail.noResults = true;
	    listDetail.totalPages = 0;
	    return listDetail.loadMore();
	  };
	  groupEventService.checkJoinGroup($scope.groupDetail.id).then(function(data) {
	    listDetail.showCreateButton = data.joined;
	    if (data.role === "admin") {
	      return listDetail.groupAdmin = true;
	    }
	  });
	  listDetail.displayPeriod = function(startTime, endTime) {
	    var reText;
	    reText = "";
	    if (!startTime && !endTime) {
	      return reText;
	    }
	    reText = $filter('translate')('_GROUP_EVENT.PERIOD_NAME');
	    reText += ": ";
	    reText += listDetail.displayDateByLang(startTime);
	    reText += "~";
	    reText += listDetail.displayDateByLang(endTime);
	    return reText;
	  };
	  listDetail.displayDateByLang = function(time) {
	    var d, formatText;
	    if (!time) {
	      return "";
	    }
	    d = moment(time);
	    formatText = 'YYYY-MM-DD(ddd)';
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      formatText = 'LL(ddd)';
	      moment.locale('ja');
	    }
	    return d.format(formatText);
	  };
	  listDetail.displayParticipants = function(number) {
	    var reText;
	    reText = $filter('translate')('_GROUP_EVENT.PARTICIPANTS');
	    reText += ': ';
	    reText += number;
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      reText += '人';
	    }
	    return reText;
	  };
	  listDetail.displayNoParticipants = function(number) {
	    var reText;
	    reText = $filter('translate')('_GROUP_EVENT.NONPARTICIPANTS');
	    reText += ': ';
	    reText += number;
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      reText += '人';
	    }
	    return reText;
	  };
	  listDetail.goToCreatePage = function() {
	    var url;
	    url = '/group-event/registration?id=' + $scope.groupDetail.id;
	    return $location.url(url);
	  };
	  listDetail.gotoEditEventDetail = function(id, event) {
	    var url;
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    }
	    url = "/group-event/" + id + "/edit";
	    return $location.path(url);
	  };
	  listDetail.gotoEventDetail = function(id) {
	    var url;
	    if (!listDetail.showCreateButton) {
	      return;
	    }
	    url = '/group-event/' + id;
	    return $location.path(url);
	  };
	  listDetail.deleteEvent = function(id, event) {
	    var config, deleteFunc, mess;
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    }
	    mess = $filter('translate')('_GROUP_EVENT.CONFIRM_MESS');
	    deleteFunc = function() {
	      return groupEventService.deleteEvent(id).then(function(resp) {
	        return refreshListData();
	      })["catch"](function(resp) {
	        return flash.error($filter('translate')('API_ERROR'));
	      });
	    };
	    config = {
	      title: '',
	      content: mess,
	      buttons: {
	        Cancel: {
	          text: $filter('translate')('_GROUP_EVENT.CANCEL')
	        },
	        OkButton: {
	          text: 'OK',
	          action: deleteFunc
	        }
	      }
	    };
	    return $ngConfirm(config);
	  };
	  $scope.$watch('listEventCtrl.lstEvents', function() {
	    if (listDetail.currentPage <= 1) {
	      return;
	    }
	    return $("html, body").animate({
	      scrollTop: $(document).height()
	    }, "slow");
	  }, false);
	  listDetail.loadMore();
	  return listDetail;
	};
	
	GroupEventListCtrl.$inject = ['$scope', '$translate', '$filter', '$location', 'groupEventService', '$ngConfirm', 'flash'];
	
	module.exports = GroupEventListCtrl;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupEventDetailCtrl, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	$ = __webpack_require__(1);
	
	GroupEventDetailCtrl = function($scope, $translate, $filter, flash, $location, groupEventService, detailData, $ngConfirm) {
	  var pageSize, refreshListData;
	  angular.element(document.body).css('min-width', 0);
	  pageSize = 4;
	  $scope.lstScoreCards = [];
	  $scope.currentPage = 0;
	  $scope.isLoading = false;
	  $scope.noResults = true;
	  $scope.eventDetail = detailData.eventDetail;
	  $scope.groupDetail = detailData.groupDetail;
	  $scope.loadMore = function() {
	    var params;
	    $scope.isLoading = true;
	    $scope.currentPage++;
	    params = {
	      id: $scope.eventDetail.id,
	      page: $scope.currentPage,
	      page_size: pageSize,
	      submitted: true
	    };
	    return groupEventService.listScoreCardByEvent(params).then(function(data) {
	      $scope.lstScoreCards = _.union($scope.lstScoreCards, data.score_cards);
	      $scope.totalPages = data.total_pages;
	      return $scope.noResults = $scope.lstScoreCards.length === 0;
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  };
	  $scope.hasMore = function() {
	    return $scope.noResults === false && $scope.currentPage !== $scope.totalPages;
	  };
	  refreshListData = function() {
	    $scope.lstScoreCards = [];
	    $scope.currentPage = 0;
	    $scope.isLoading = false;
	    $scope.noResults = true;
	    return $scope.loadMore();
	  };
	  $scope.displayPeriod = function(startTime, endTime) {
	    var reText;
	    reText = "";
	    if (!startTime && !endTime) {
	      return reText;
	    }
	    reText = $filter('translate')('_GROUP_EVENT.PERIOD_NAME');
	    reText += ": ";
	    reText += $scope.displayDateByLang(startTime);
	    reText += "~";
	    reText += $scope.displayDateByLang(endTime);
	    return reText;
	  };
	  $scope.displayDateByLang = function(time) {
	    var d, formatText;
	    if (!time) {
	      return "";
	    }
	    d = moment(time);
	    formatText = 'YYYY-MM-DD(ddd)';
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      formatText = 'LL(ddd)';
	      moment.locale('ja');
	    }
	    return d.format(formatText);
	  };
	  $scope.displayParticipants = function(number) {
	    var reText;
	    reText = $filter('translate')('_GROUP_EVENT.PARTICIPANTS');
	    reText += ': ';
	    reText += number;
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      reText += '人';
	    }
	    return reText;
	  };
	  $scope.displayNoParticipants = function(number) {
	    var reText;
	    reText = $filter('translate')('_GROUP_EVENT.NONPARTICIPANTS');
	    reText += ': ';
	    reText += number;
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      reText += '人';
	    }
	    return reText;
	  };
	  $scope.gotoSubmit = function() {
	    return $location.path('/group-event/' + $scope.eventDetail.id + '/scorecards');
	  };
	  $scope.gotoEventRank = function() {
	    return $location.path('/group-event/' + $scope.eventDetail.id + '/ranking');
	  };
	  $scope.gotoTimelineTab = function() {
	    var url;
	    url = "/groups/" + $scope.groupDetail.id + "#timeline";
	    return $location.url(url);
	  };
	  $scope.gotoEventTab = function() {
	    var url;
	    url = "/groups/" + $scope.groupDetail.id + "#event";
	    return $location.url(url);
	  };
	  $scope.gotoRankTab = function() {
	    var url;
	    url = "/groups/" + $scope.groupDetail.id + "#rank";
	    return $location.url(url);
	  };
	  $scope.$watch('lstScoreCards', function() {
	    if ($scope.currentPage <= 1) {
	      return;
	    }
	    return $("html, body").animate({
	      scrollTop: $(document).height()
	    }, "slow");
	  }, false);
	  $scope.removeScoreCard = function(id, index) {
	    var config, deleteFunc, mess;
	    if (!id || id === '') {
	      return;
	    }
	    mess = $filter('translate')('_GROUP_EVENT.CONFIRM_MESS');
	    deleteFunc = function() {
	      var params;
	      params = {
	        group_event_id: $scope.eventDetail.id,
	        score_card_id: id
	      };
	      return groupEventService.unSubmitScoreCard(params).then(function(resp) {
	        return refreshListData();
	      })["catch"](function(resp) {
	        return flash.error($filter('translate')('API_ERROR'));
	      });
	    };
	    config = {
	      title: '',
	      content: mess,
	      buttons: {
	        Cancel: {
	          text: $filter('translate')('_GROUP_EVENT.CANCEL')
	        },
	        OkButton: {
	          text: 'OK',
	          action: deleteFunc
	        }
	      }
	    };
	    return $ngConfirm(config);
	  };
	  return $scope.loadMore();
	};
	
	GroupEventDetailCtrl.$inject = ['$scope', '$translate', '$filter', 'flash', '$location', 'groupEventService', 'detailData', '$ngConfirm'];
	
	module.exports = GroupEventDetailCtrl;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupEventSubmitScoreCtrl, _, moment,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	$ = __webpack_require__(1);
	
	GroupEventSubmitScoreCtrl = function($scope, $translate, $filter, flash, $location, groupEventService, detailData, $ngConfirm, $modal, ScoreCardAPIService) {
	  var buildCourseList, buildCoursesParam, buildStatusParam, changeFilterValues, getPeriodValue, getSelectedValue, getStatusValue, maxSelectScore, pageSize, refreshListData;
	  angular.element(document.body).css('min-width', 0);
	  pageSize = 4;
	  maxSelectScore = 15;
	  $scope.lstScoreCards = [];
	  $scope.lstUploadScore = [];
	  $scope.currentPage = 0;
	  $scope.isLoading = false;
	  $scope.noResults = true;
	  $scope.isSubmitScore = false;
	  $scope.eventDetail = detailData.eventDetail;
	  $scope.groupDetail = detailData.groupDetail;
	  $scope.isFilterOpen = false;
	  $scope.filterPeriodItem = "all";
	  $scope.filterSelectedPeriod = $filter('translate')('_GROUP_EVENT.FILTER_PERIOD_ALL');
	  $scope.filterStatusItem = "all";
	  $scope.filterSelectedStatus = $filter('translate')('_GROUP_EVENT.FILTER_STATUS_ALL');
	  $scope.filterCourseList = [
	    {
	      id: 0,
	      name: $filter('translate')('_GROUP_EVENT.FILTER_COURSE_ALL'),
	      checked: true
	    }
	  ];
	  $scope.filterSelectedCourse = $filter('translate')('_GROUP_EVENT.FILTER_COURSE_ALL');
	  $scope.filterSelectedCourseResult = $filter('translate')('_GROUP_EVENT.FILTER_COURSE_ALL');
	  $scope.filterSelectedCourseList = [];
	  $scope.pcFilterText = $filter('translate')('_GROUP_EVENT.FILTER_PC');
	  $scope.spFilterText = $filter('translate')('_GROUP_EVENT.FILTER');
	  $scope.closeText = $filter('translate')('_GROUP_EVENT.FILTER_CLOSE');
	  $(document).ready(function() {
	    var curOffset, item;
	    item = $('.row.buttonRegion')[0];
	    curOffset = item.offsetTop;
	    return window.onscroll = function() {
	      if (window.innerWidth > 768) {
	        return;
	      }
	      if (window.pageYOffset >= curOffset) {
	        return item.classList.add("sticky");
	      } else {
	        return item.classList.remove("sticky");
	      }
	    };
	  });
	  angular.element(window).bind('resize', function() {
	    if (window.innerWidth > 768) {
	      return $('.row.buttonRegion').first().removeClass('sticky');
	    }
	  });
	  buildCoursesParam = function() {
	    if (indexOf.call($scope.filterSelectedCourseList, 0) >= 0) {
	      return [];
	    } else {
	      return $scope.filterSelectedCourseList;
	    }
	  };
	  buildStatusParam = function() {
	    switch ($scope.filterStatusItem) {
	      case "submitted":
	        return "true";
	      case "unsubmit":
	        return "false";
	      default:
	        return "";
	    }
	  };
	  $scope.loadModalCourses = function() {
	    var params;
	    if ($scope.filterCourseList.length <= 1) {
	      params = {
	        id: $scope.eventDetail.id
	      };
	      return groupEventService.getCourses(params).then(function(data) {
	        return buildCourseList(data.courses);
	      });
	    }
	  };
	  buildCourseList = function(courses) {
	    var course, i, len, results;
	    results = [];
	    for (i = 0, len = courses.length; i < len; i++) {
	      course = courses[i];
	      results.push($scope.filterCourseList.push({
	        id: course.id,
	        name: course.name,
	        checked: false
	      }));
	    }
	    return results;
	  };
	  $scope.loadMore = function() {
	    var params;
	    $scope.isLoading = true;
	    $scope.currentPage++;
	    params = {
	      id: $scope.eventDetail.id,
	      page: $scope.currentPage,
	      page_size: pageSize,
	      period: $scope.filterPeriodItem,
	      submitted: buildStatusParam(),
	      'courses[]': buildCoursesParam()
	    };
	    return groupEventService.listScoreCardByEvent(params).then(function(data) {
	      $scope.lstScoreCards = _.union($scope.lstScoreCards, data.score_cards);
	      $scope.totalPages = data.total_pages;
	      return $scope.noResults = $scope.lstScoreCards.length === 0;
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  };
	  $scope.hasMore = function() {
	    return $scope.noResults === false && $scope.currentPage !== $scope.totalPages;
	  };
	  $scope.displayPeriod = function(startTime, endTime) {
	    var reText;
	    reText = "";
	    if (!startTime && !endTime) {
	      return reText;
	    }
	    reText = $filter('translate')('_GROUP_EVENT.PERIOD_NAME');
	    reText += ": ";
	    reText += $scope.displayDateByLang(startTime);
	    reText += "~";
	    reText += $scope.displayDateByLang(endTime);
	    return reText;
	  };
	  $scope.displayDateByLang = function(time) {
	    var d, formatText;
	    if (!time) {
	      return "";
	    }
	    d = moment(time);
	    formatText = 'YYYY-MM-DD(ddd)';
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      formatText = 'LL(ddd)';
	      moment.locale('ja');
	    }
	    return d.format(formatText);
	  };
	  $scope.$watch('lstScoreCards', function(newVal, oldVal) {
	    return $scope.checkSelectedScore();
	  }, true);
	  $scope.clickSubmit = function(scoreCard) {
	    if (!scoreCard.selected && $scope.lstUploadScore.length >= maxSelectScore) {
	      $ngConfirm('Limits score card uploads is 15');
	      return;
	    }
	    return scoreCard.selected = !scoreCard.selected;
	  };
	  $scope.checkSelectedScore = function() {
	    $scope.lstUploadScore = $filter('filter')($scope.lstScoreCards, {
	      selected: true
	    });
	    return $scope.canUpload = $scope.lstUploadScore.length > 0;
	  };
	  $scope.submitScore = function() {
	    var params;
	    if (!$scope.canUpload) {
	      return;
	    }
	    $scope.isSubmitScore = true;
	    params = {
	      group_event_id: $scope.eventDetail.id,
	      score_card_ids: $scope.lstUploadScore.map(function(item) {
	        return item.id;
	      })
	    };
	    return groupEventService.submitScoreCard(params).then(function(resp) {
	      return $location.path('/group-event/' + $scope.eventDetail.id + '/ranking');
	    })["catch"](function(resp) {
	      var ref;
	      if (((ref = resp.data) != null ? ref.code : void 0) === 'error.group_event_not_active') {
	        return flash.error('Event is not active');
	      } else {
	        return flash.error($filter('translate')('API_ERROR'));
	      }
	    })["finally"](function() {
	      $scope.isSubmitScore = false;
	      return ScoreCardAPIService.clearAllMembersByEventData($scope.eventDetail.id);
	    });
	  };
	  $scope.btnCancelClick = function() {
	    return $location.path('/group-event/' + $scope.eventDetail.id + '/ranking');
	  };
	  $scope.btnOpenMenuClick = function() {
	    $scope.isFilterOpen = !$scope.isFilterOpen;
	    return $scope.currentYear = new Date().getFullYear();
	  };
	  $scope.btnOpenModal = function() {
	    var modalInstance;
	    modalInstance = $modal.open({
	      templateUrl: 'course-modal',
	      controller: 'CourseListModalCtrl',
	      scope: $scope
	    });
	    return modalInstance.result.then(function(result) {
	      var checkedIdList, checkedList, course, i, len;
	      checkedList = [];
	      checkedIdList = [];
	      for (i = 0, len = result.length; i < len; i++) {
	        course = result[i];
	        if (course.checked) {
	          checkedList.push(course.name);
	          checkedIdList.push(course.id);
	        }
	      }
	      $scope.filterSelectedCourseList = checkedIdList;
	      return $scope.filterSelectedCourse = getSelectedValue(checkedList);
	    });
	  };
	  $scope.btnFilterClick = function() {
	    var params;
	    $scope.isLoading = true;
	    $scope.currentPage = 1;
	    params = {
	      id: $scope.eventDetail.id,
	      page: $scope.currentPage,
	      page_size: pageSize,
	      period: $scope.filterPeriodItem,
	      submitted: buildStatusParam(),
	      'courses[]': buildCoursesParam()
	    };
	    return groupEventService.listScoreCardByEvent(params).then(function(data) {
	      $scope.lstScoreCards = data.score_cards;
	      $scope.totalPages = data.total_pages;
	      $scope.noResults = $scope.lstScoreCards.length === 0;
	      return changeFilterValues();
	    })["finally"](function() {
	      $scope.isLoading = false;
	      return $scope.isFilterOpen = false;
	    });
	  };
	  $scope.loadMore();
	  $scope.loadModalCourses();
	  $scope.onDeleteClick = function(scoreCard) {
	    var config, errorMess, mess, params;
	    params = {
	      score_card_id: scoreCard.id,
	      group_event_id: $scope.eventDetail.id
	    };
	    mess = $filter('translate')('_GROUP_EVENT.CONFIRM_MESS');
	    errorMess = $filter('translate')('_GROUP_EVENT.CANCEL');
	    config = {
	      title: '',
	      content: mess,
	      buttons: {
	        Cancel: {
	          text: $filter('translate')('_GROUP_EVENT.CANCEL')
	        },
	        OkButton: {
	          text: 'OK',
	          action: function() {
	            return groupEventService.unSubmitScoreCard(params).then(function(resp) {
	              refreshListData();
	              return ScoreCardAPIService.clearAllMembersByEventData($scope.eventDetail.id);
	            })["catch"](function(resp) {});
	          }
	        }
	      }
	    };
	    return $ngConfirm(config);
	  };
	  refreshListData = function() {
	    $scope.lstScoreCards = [];
	    $scope.currentPage = 0;
	    $scope.isLoading = false;
	    $scope.noResults = true;
	    return $scope.loadMore();
	  };
	  $scope.$watch('lstScoreCards', function() {
	    if ($scope.currentPage <= 1) {
	      return;
	    }
	    return $("html, body").animate({
	      scrollTop: $(document).height()
	    }, "slow");
	  }, false);
	  $scope.periodChange = function(value) {
	    return $scope.filterPeriodItem = value;
	  };
	  $scope.statusChange = function(value) {
	    return $scope.filterStatusItem = value;
	  };
	  changeFilterValues = function() {
	    $scope.filterSelectedPeriod = getPeriodValue();
	    $scope.filterSelectedStatus = getStatusValue();
	    return $scope.filterSelectedCourseResult = $scope.filterSelectedCourse;
	  };
	  getPeriodValue = function() {
	    switch ($scope.filterPeriodItem) {
	      case "all":
	        return $filter('translate')('_GROUP_EVENT.FILTER_PERIOD_ALL');
	      case "year":
	        return "2018";
	      case "twoYears":
	        return "2017";
	      case "threeMonth":
	        return $filter('translate')('_GROUP_EVENT.FILTER_PERIOD_THREE_MONTH');
	      default:
	        return $filter('translate')('_GROUP_EVENT.FILTER_PERIOD_SIX_MONTH');
	    }
	  };
	  getStatusValue = function() {
	    switch ($scope.filterStatusItem) {
	      case "all":
	        return $filter('translate')('_GROUP_EVENT.FILTER_STATUS_ALL');
	      case "unsubmit":
	        return $filter('translate')('_GROUP_EVENT.FILTER_STATUS_NOTYET');
	      default:
	        return $filter('translate')('_GROUP_EVENT.FILTER_STATUS_DONE');
	    }
	  };
	  getSelectedValue = function(checkedList) {
	    var allCourse;
	    allCourse = $filter('translate')('_GROUP_EVENT.FILTER_COURSE_ALL');
	    if (checkedList.length <= 0 || indexOf.call(checkedList, allCourse) >= 0) {
	      return allCourse;
	    } else if (checkedList.length >= 2 && !(indexOf.call(checkedList, allCourse) >= 0)) {
	      return checkedList[0] + " 他";
	    } else {
	      return checkedList[0];
	    }
	  };
	  return $scope.classForRoundIcons = function(scoreCard) {
	    switch (scoreCard.round_type) {
	      case 1.5:
	        return 'icons-extra9';
	      case 0.5:
	        return 'icons-half-nine';
	      default:
	        return '';
	    }
	  };
	};
	
	GroupEventSubmitScoreCtrl.$inject = ['$scope', '$translate', '$filter', 'flash', '$location', 'groupEventService', 'detailData', '$ngConfirm', '$modal', 'ScoreCardAPIService'];
	
	module.exports = GroupEventSubmitScoreCtrl;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	var $, CourseListModalCtrl, _;
	
	_ = __webpack_require__(87);
	
	$ = __webpack_require__(1);
	
	CourseListModalCtrl = function($scope, $translate, $filter, flash, $location, groupEventService, $ngConfirm, $modalInstance) {
	  $scope.selectCourse = function() {
	    return $modalInstance.close($scope.filterCourseList);
	  };
	  return $scope.checkCourse = function(item) {
	    var course, i, j, len, len1, ref, ref1;
	    if (item.id === 0 && item.checked === false) {
	      ref = $scope.filterCourseList;
	      for (i = 0, len = ref.length; i < len; i++) {
	        course = ref[i];
	        course.checked = false;
	      }
	    }
	    if (item.id !== 0) {
	      ref1 = $scope.filterCourseList;
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        course = ref1[j];
	        if (course.id === 0 && course.checked === true) {
	          course.checked = false;
	        }
	      }
	    }
	    return item.checked = !item.checked;
	  };
	};
	
	CourseListModalCtrl.$inject = ['$scope', '$translate', '$filter', 'flash', '$location', 'groupEventService', '$ngConfirm', '$modalInstance'];
	
	module.exports = CourseListModalCtrl;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var GroupEventRankCtrl, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	GroupEventRankCtrl = function($scope, $translate, $filter, flash, $location, groupEventService, detailData) {
	  var hash, i, isExist, j, len, obj, pageSize, ref;
	  angular.element(document.body).css('min-width', 0);
	  pageSize = 4;
	  $scope.lstUserRank = [];
	  $scope.currentPage = 0;
	  $scope.groupAdmin = false;
	  $scope.eventOwner = detailData.eventDetail.owner;
	  $scope.isLoading = false;
	  $scope.noResults = true;
	  $scope.eventDetail = detailData.eventDetail;
	  $scope.groupDetail = detailData.groupDetail;
	  $scope.rankingDatas = [
	    {
	      type: 'avg_shot',
	      name: $filter('translate')('_GROUP_EVENT.AVG_SCORE_RANK')
	    }, {
	      type: 'avg_putt',
	      name: $filter('translate')('_GROUP_EVENT.AVG_PUTT_RANK')
	    }, {
	      type: 'rat_par_on',
	      name: $filter('translate')('_GROUP_EVENT.PER_ON_RATE_RANK')
	    }, {
	      type: 'rat_birdie',
	      name: $filter('translate')('_GROUP_EVENT.BIRDIE_RATE_RANK')
	    }, {
	      type: 'rat_par',
	      name: $filter('translate')('_GROUP_EVENT.PER_RATE_RANK')
	    }
	  ];
	  hash = $location.hash();
	  isExist = false;
	  ref = $scope.rankingDatas;
	  for (i = j = 0, len = ref.length; j < len; i = ++j) {
	    obj = ref[i];
	    if (obj.type === hash) {
	      isExist = true;
	      break;
	    }
	  }
	  if (!isExist) {
	    hash = 'avg_shot';
	  }
	  $scope.ranking = {
	    type: hash
	  };
	  groupEventService.checkJoinGroup($scope.groupDetail.id).then(function(data) {
	    if (data.role === "admin") {
	      return $scope.groupAdmin = true;
	    }
	  });
	  $scope.loadMore = function() {
	    var oderText, params;
	    $scope.isLoading = true;
	    $scope.currentPage++;
	    oderText = "";
	    if ($scope.ranking.type === 'avg_shot' || $scope.ranking.type === 'avg_putt') {
	      oderText = "asc";
	    } else {
	      oderText = "desc";
	    }
	    params = {
	      id: $scope.eventDetail.id,
	      page: $scope.currentPage,
	      page_size: pageSize,
	      sort: $scope.ranking.type,
	      order: oderText
	    };
	    return groupEventService.listEventRanking(params).then(function(data) {
	      $scope.lstUserRank = _.union($scope.lstUserRank, data.users);
	      $scope.totalPages = data.total_pages;
	      return $scope.noResults = $scope.lstUserRank.length === 0;
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  };
	  $scope.chooseRanking = function(ranking) {
	    var url;
	    url = "/group-event/" + $scope.eventDetail.id + "/ranking#" + ranking;
	    return $location.url(url);
	  };
	  $scope.hasMore = function() {
	    return $scope.noResults === false && $scope.currentPage !== $scope.totalPages;
	  };
	  $scope.gotoTimelineTab = function() {
	    var url;
	    url = "/groups/" + $scope.groupDetail.id + "#timeline";
	    return $location.url(url);
	  };
	  $scope.gotoEventTab = function() {
	    var url;
	    url = "/groups/" + $scope.groupDetail.id + "#event";
	    return $location.url(url);
	  };
	  $scope.gotoRankTab = function() {
	    var url;
	    url = "/groups/" + $scope.groupDetail.id + "#rank";
	    return $location.url(url);
	  };
	  $scope.gotoEditEventDetail = function() {
	    var url;
	    url = "/group-event/" + $scope.eventDetail.id + "/edit";
	    return $location.path(url);
	  };
	  $scope.gotoAnalysisEvent = function(event_id, user_id) {
	    var url;
	    url = "/analysis-event/" + event_id + "?user_id=" + user_id;
	    return $location.url(url);
	  };
	  $scope.displayImageRanking = function(number) {
	    switch (number) {
	      case 1:
	        return 'ranking-one';
	      case 2:
	        return 'ranking-two';
	      case 3:
	        return 'ranking-three';
	      default:
	        return 'ranking-over-three';
	    }
	  };
	  $scope.displayUserName = function(fName, lName) {
	    fName = fName != null ? fName : '';
	    lName = lName != null ? lName : '';
	    if (fName + lName === '') {
	      return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED');
	    }
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      return lName + " " + fName;
	    }
	    return fName + " " + lName;
	  };
	  $scope.displayPeriod = function(startTime, endTime) {
	    var reText;
	    reText = " ";
	    if (!startTime && !endTime) {
	      return reText;
	    }
	    reText += $scope.displayDateByLang(startTime);
	    reText += "~";
	    reText += $scope.displayDateByLang(endTime);
	    return reText;
	  };
	  $scope.displayDateByLang = function(time) {
	    var d, formatText;
	    if (!time) {
	      return "";
	    }
	    d = moment(time);
	    formatText = 'YYYY-MM-DD(ddd)';
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      formatText = 'LL(ddd)';
	      moment.locale('ja');
	    }
	    return d.format(formatText);
	  };
	  $scope.displayParticipants = function(number) {
	    var reText;
	    reText = $filter('translate')('_GROUP_EVENT.PARTICIPANTS');
	    reText += ': ';
	    reText += number;
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      reText += '人';
	    }
	    return reText;
	  };
	  $scope.displayNoParticipants = function(number) {
	    var reText;
	    reText = $filter('translate')('_GROUP_EVENT.NONPARTICIPANTS');
	    reText += ': ';
	    reText += number;
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      reText += '人';
	    }
	    return reText;
	  };
	  $scope.gotoSubmit = function() {
	    return $location.path('/group-event/' + $scope.eventDetail.id + '/scorecards');
	  };
	  $scope.handleTextOfAvatar = function(user) {
	    var $avatarElement;
	    $avatarElement = $(".avatar-for-" + user.id + " .avatar-image-text:not(.is-small)");
	    if (user.display_text_avatar.length === 1) {
	      $avatarElement.removeClass('two-characters');
	      $avatarElement.addClass('one-character');
	    } else {
	      $avatarElement.removeClass('one-character');
	      $avatarElement.addClass('two-characters');
	    }
	    return user.display_text_avatar;
	  };
	  $scope.handleAvatarColor = function(user) {
	    return user.avatar_url.indexOf('avatar_color') > -1;
	  };
	  $scope.displayNumber = function(number) {
	    if (!angular.isNumber(number)) {
	      return number;
	    }
	    return $filter('number')(number, 2);
	  };
	  $scope.$watch('lstUserRank', function() {
	    if ($scope.currentPage <= 1) {
	      return;
	    }
	    return $("html, body").animate({
	      scrollTop: $(document).height()
	    }, "slow");
	  }, false);
	  return $scope.loadMore();
	};
	
	GroupEventRankCtrl.$inject = ['$scope', '$translate', '$filter', 'flash', '$location', 'groupEventService', 'detailData'];
	
	module.exports = GroupEventRankCtrl;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	var GroupRegisDataService, _;
	
	_ = __webpack_require__(87);
	
	GroupRegisDataService = function($http, $q, groupUploadDataService) {
	  var tempData;
	  tempData = void 0;
	  return {
	    setTempData: function(data) {
	      return tempData = data;
	    },
	    getTempData: function() {
	      return tempData;
	    },
	    createGroup: function(group, dataCover, dataAvatar) {
	      var defer, promise;
	      defer = $q.defer();
	      promise = {
	        urlDataCover: groupUploadDataService.uploadS3(dataCover.coverFile, dataCover.url, dataCover.fields),
	        urlAvatar: groupUploadDataService.uploadS3(dataAvatar.coverFile, dataAvatar.url, dataAvatar.fields)
	      };
	      $q.all(promise).then(function(data) {
	        group.cover_path = data.urlDataCover;
	        group.avatar_path = data.urlAvatar;
	        group.public_status = group.type === '1';
	        return $http.post('/api/groups.json', group).then(function(data) {
	          return defer.resolve('success');
	        }, function(data) {
	          return defer.reject(data);
	        });
	      });
	      return defer.promise;
	    },
	    createS3ImageURL: function(data) {
	      return $http.post('/api/images.json', {
	        prefix: data
	      });
	    },
	    getGroup: function(id) {
	      var delay, url;
	      url = "/api/groups/" + id + ".json";
	      delay = $q.defer();
	      $http.get(url).then(function(resp) {
	        return delay.resolve(resp.data);
	      })["catch"](function(resp, status) {
	        return delay.reject(resp.data);
	      });
	      return delay.promise;
	    },
	    updateGroup: function(group, dataCover, dataAvatar) {
	      var defer, promise;
	      defer = $q.defer();
	      promise = {
	        urlDataCover: groupUploadDataService.uploadS3(dataCover.coverFile, dataCover.url, dataCover.fields),
	        urlAvatar: groupUploadDataService.uploadS3(dataAvatar.coverFile, dataAvatar.url, dataAvatar.fields)
	      };
	      $q.all(promise).then(function(data) {
	        if (data.urlDataCover !== '' && (data.urlDataCover + '').length > 0) {
	          group.cover_path = data.urlDataCover;
	        }
	        if (data.urlAvatar !== '' && (data.urlAvatar + '').length > 0) {
	          group.avatar_path = data.urlAvatar;
	        }
	        group.public_status = group.type === '1';
	        return $http.put("/api/groups/" + group.id + ".json", group).then(function(data) {
	          return defer.resolve('success');
	        }, function(data) {
	          return defer.reject(data);
	        });
	      });
	      return defer.promise;
	    },
	    searchGroup: function(key, pageNum, pageSize) {
	      var defer, params, url;
	      defer = $q.defer();
	      url = '/api/groups/search.json';
	      params = {
	        keyword: key,
	        page: pageNum,
	        page_size: pageSize
	      };
	      $http.get(url, {
	        params: params
	      }).then(function(resp) {
	        return defer.resolve(resp.data);
	      })["catch"](function(resp, status) {
	        return defer.reject(resp.data);
	      });
	      return defer.promise;
	    },
	    joinGroup: function(params) {
	      return $http.post('/api/group_entries.json', params);
	    },
	    groupStatus: function(groupId) {
	      var defer, params, url;
	      defer = $q.defer();
	      url = '/api/users/join_group.json';
	      params = {
	        group_id: groupId
	      };
	      $http.get(url, {
	        params: params
	      }).then(function(resp) {
	        return defer.resolve(resp.data);
	      })["catch"](function(resp, status) {
	        return defer.reject(resp.data);
	      });
	      return defer.promise;
	    }
	  };
	};
	
	GroupRegisDataService.$inject = ['$http', '$q', 'groupUploadDataService'];
	
	module.exports = GroupRegisDataService;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	var GroupUploadDataService, _;
	
	_ = __webpack_require__(87);
	
	GroupUploadDataService = function($http, $q) {
	  return {
	    uploadS3: function(file, url, data) {
	      var config, defer, fData, key, urlUpload, value;
	      defer = $q.defer();
	      if (!file || !url || !data) {
	        defer.resolve('');
	        defer.promise;
	        return;
	      }
	      urlUpload = data.key;
	      config = {
	        'headers': {
	          'enctype': 'multipart/form-data',
	          'Content-Type': void 0
	        },
	        transformRequest: angular.identity
	      };
	      fData = new FormData();
	      for (key in data) {
	        value = data[key];
	        fData.append(key, value);
	      }
	      fData.append('file', file);
	      $http.post(url, fData, config).then(function(data) {
	        return defer.resolve(urlUpload);
	      }, function(data) {
	        return defer.resolve('');
	      });
	      return defer.promise;
	    }
	  };
	};
	
	GroupUploadDataService.$inject = ['$http', '$q'];
	
	module.exports = GroupUploadDataService;


/***/ }),
/* 734 */
/***/ (function(module, exports) {

	var GroupEventService;
	
	GroupEventService = function($http, $q, groupUploadDataService, groupRegisDataService) {
	  var getEvent;
	  getEvent = function(id) {
	    var defer, url;
	    defer = $q.defer();
	    url = "/api/group_events/" + id + ".json";
	    $http.get(url).then(function(resp) {
	      return defer.resolve(resp.data);
	    });
	    return defer.promise;
	  };
	  return {
	    checkJoinGroup: function(id) {
	      var defer, url;
	      defer = $q.defer();
	      url = "/api/users/join_group.json?group_id=" + id;
	      $http.get(url).then(function(resp) {
	        return defer.resolve(resp.data);
	      });
	      return defer.promise;
	    },
	    createEvent: function(event, dataCover) {
	      var defer, promise;
	      defer = $q.defer();
	      promise = {
	        urlCover: groupUploadDataService.uploadS3(dataCover.coverFile, dataCover.url, dataCover.fields)
	      };
	      $q.all(promise).then(function(data) {
	        event.cover_path = data.urlCover;
	        return $http.post('/api/group_events.json', event).then(function(data) {
	          return defer.resolve('success');
	        }, function(data) {
	          return defer.reject(data);
	        });
	      });
	      return defer.promise;
	    },
	    updateEvent: function(event, dataCover) {
	      var defer, promise, url;
	      defer = $q.defer();
	      promise = {
	        urlCover: groupUploadDataService.uploadS3(dataCover.coverFile, dataCover.url, dataCover.fields)
	      };
	      url = "/api/group_events/" + event.id + ".json";
	      $q.all(promise).then(function(data) {
	        event.cover_path = data.urlCover;
	        return $http.put(url, event).then(function(data) {
	          return defer.resolve('success');
	        }, function(data) {
	          return defer.reject(data);
	        });
	      });
	      return defer.promise;
	    },
	    deleteEvent: function(id) {
	      var url;
	      url = "/api/group_events/" + id + ".json";
	      return $http["delete"](url);
	    },
	    listEvent: function(dParam) {
	      var defer, url;
	      defer = $q.defer();
	      url = "/api/groups/" + dParam.id + "/list_event.json";
	      $http.get(url, {
	        params: dParam
	      }).then(function(resp) {
	        return defer.resolve(resp.data);
	      });
	      return defer.promise;
	    },
	    listScoreCardByEvent: function(dParam) {
	      var defer, url;
	      defer = $q.defer();
	      url = "/api/group_events/" + dParam.id + "/list_score_card.json";
	      $http.get(url, {
	        params: dParam
	      }).then(function(resp) {
	        return defer.resolve(resp.data);
	      });
	      return defer.promise;
	    },
	    listEventRanking: function(dParam) {
	      var defer, url;
	      defer = $q.defer();
	      url = "/api/group_events/" + dParam.id + "/ranking_users.json";
	      $http.get(url, {
	        params: dParam
	      }).then(function(resp) {
	        return defer.resolve(resp.data);
	      });
	      return defer.promise;
	    },
	    getCourses: function(dParam) {
	      var defer, url;
	      defer = $q.defer();
	      url = "/api/group_events/" + dParam.id + "/courses.json";
	      $http.get(url, {
	        params: dParam
	      }).then(function(resp) {
	        return defer.resolve(resp.data);
	      });
	      return defer.promise;
	    },
	    getDataEventDetail: function(id) {
	      var defer, promise;
	      defer = $q.defer();
	      promise = {
	        eventDetail: getEvent(id)
	      };
	      $q.all(promise).then(function(data) {
	        var reData;
	        reData = {
	          eventDetail: data.eventDetail
	        };
	        return groupRegisDataService.getGroup(data.eventDetail.group_id).then(function(data) {
	          reData.groupDetail = data;
	          return defer.resolve(reData);
	        });
	      });
	      return defer.promise;
	    },
	    submitScoreCard: function(dParams) {
	      var url;
	      url = '/api/event_score_cards.json';
	      return $http.post(url, dParams);
	    },
	    unSubmitScoreCard: function(dParam) {
	      var url;
	      url = "/api/event_score_cards/score_card.json?score_card_id=" + dParam.score_card_id + "&group_event_id=" + dParam.group_event_id;
	      return $http["delete"](url, dParam);
	    }
	  };
	};
	
	GroupEventService.$inject = ['$http', '$q', 'groupUploadDataService', 'groupRegisDataService'];
	
	module.exports = GroupEventService;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	var EventScoreCardDirective, _;
	
	__webpack_require__(736);
	
	_ = __webpack_require__(87);
	
	EventScoreCardDirective = function($window, $location) {
	  return {
	    restrict: "A",
	    replace: false,
	    templateUrl: "group-event/event-score-card-directive/score-card.jade",
	    scope: {
	      datas: '=scorelist',
	      user_id: '=userid',
	      event_id: '=eventid',
	      hide_detail: '=hidedetail'
	    },
	    link: function(scope) {
	      scope.isShowDetail = false;
	      scope.gotoAnalysisScorecard = function(score_card_id) {
	        var url;
	        url = '/round-detail/' + score_card_id + '?user_id=' + scope.user_id + '&event_id=' + scope.event_id;
	        return $window.location.href = url;
	      };
	      scope.showDetail = function() {
	        return scope.isShowDetail = !scope.isShowDetail;
	      };
	      return scope.classForRoundIcons = function(scoreCard) {
	        if (!scoreCard.round_type) {
	          return;
	        }
	        switch (scoreCard.round_type) {
	          case 1.5:
	            return 'icons-extra9';
	          case 0.5:
	            return 'icons-half-nine';
	          default:
	            return '';
	        }
	      };
	    }
	  };
	};
	
	EventScoreCardDirective.$inject = ['$window', '$location'];
	
	module.exports = EventScoreCardDirective;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div ng-if=\"!hide_detail\"><div ng-repeat=\"scoreCard in datas\" class=\"col-12 row-content-score\"><div class=\"cell weatherCell\"><div class=\"span date\">{{ :: scoreCard.play_date | date:'yyyy/MM/dd'}}</div><div class=\"weather-icon icons-{{ scoreCard.weather }}\"></div></div><div class=\"cell scoreCell\"><div ng-class=\"classForRoundIcons(scoreCard)\" class=\"icon-round\"></div><div class=\"rounded-circle\"><div class=\"score\"><span class=\"shot\">{{ scoreCard.total_shot_all_holes }}<span class=\"putt\">{{ scoreCard.total_putt_all_holes == 0 ? \"\" : scoreCard.total_putt_all_holes }}</span></span></div></div></div><div class=\"cell descripionCell\"><span class=\"clubName\">{{ scoreCard.club_name }}</span><span class=\"clubAddress\">{{ scoreCard.address }}</span><div class=\"buttonContainer\"><button ng-click=\"gotoAnalysisScorecard(scoreCard.id)\" class=\"btn-analysis\"><img src=\"" + __webpack_require__(703) + "\"/>{{ :: '_GROUP_EVENT.SCORE_ANALYSIS' | translate }}</button></div></div></div></div><div ng-if=\"hide_detail\"><div ng-repeat=\"scoreCard in [datas[0]]\" class=\"col-12 row-content-score\"><div class=\"cell weatherCell\"><div class=\"span date\">{{ :: scoreCard.play_date | date:'yyyy/MM/dd'}}</div><div class=\"weather-icon icons-{{ scoreCard.weather }}\"></div></div><div class=\"cell scoreCell\"><div ng-class=\"classForRoundIcons(scoreCard)\" class=\"icon-round\"></div><div class=\"rounded-circle\"><div class=\"score\"><span class=\"shot\">{{ scoreCard.total_shot_all_holes }}<span class=\"putt\">{{ scoreCard.total_putt_all_holes == 0 ? \"\" : scoreCard.total_putt_all_holes }}</span></span></div></div></div><div class=\"cell descripionCell\"><span class=\"clubName\">{{ scoreCard.club_name }}</span><span class=\"clubAddress\">{{ scoreCard.address }}</span><div class=\"buttonContainer\"><button ng-click=\"gotoAnalysisScorecard(scoreCard.id)\" class=\"btn-analysis\"><img src=\"" + __webpack_require__(703) + "\"/>{{ :: '_GROUP_EVENT.SCORE_ANALYSIS' | translate }}</button></div></div></div><div ng-show=\"isShowDetail\" ng-repeat=\"scoreCard in datas.slice(1)\" class=\"col-12 row-content-score\"><div class=\"cell weatherCell\"><div class=\"span date\">{{ :: scoreCard.play_date | date:'yyyy/MM/dd'}}</div><div class=\"weather-icon icons-{{ scoreCard.weather }}\"></div></div><div class=\"cell scoreCell\"><div ng-class=\"classForRoundIcons(scoreCard)\" class=\"icon-round\"></div><div class=\"rounded-circle\"><div class=\"score\"><span class=\"shot\">{{ scoreCard.total_shot_all_holes }}<span class=\"putt\">{{ scoreCard.total_putt_all_holes == 0 ? \"\" : scoreCard.total_putt_all_holes }}</span></span></div></div></div><div class=\"cell descripionCell\"><span class=\"clubName\">{{ scoreCard.club_name }}</span><span class=\"clubAddress\">{{ scoreCard.address }}</span><div class=\"buttonContainer\"><button ng-click=\"gotoAnalysisScorecard(scoreCard.id)\" class=\"btn-analysis\"><img src=\"" + __webpack_require__(703) + "\"/>{{ :: '_GROUP_EVENT.SCORE_ANALYSIS' | translate }}</button></div></div></div><div ng-if=\"datas.length &gt; 1\" class=\"col-12\"><a href=\"javascript:void(0)\" ng-click=\"showDetail()\" ng-class=\"{active:isShowDetail}\" class=\"btn-show-detail\"><img src=\"" + __webpack_require__(737) + "\"/></a></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("group-event/event-score-card-directive/score-card.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAPCAMAAABdnFYbAAAAilBMVEWo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09Oo09MdQ6rCAAAALXRSTlMAAQUICgsOERImLC00OTo7PEJISUtSb4GLkpyjwMLO09Xa3ODk5eb19vv8/f6rJfW8AAAAqUlEQVQYGX3BBw6CQBQFwCcgWLCsSldcxIbsu//13J9oDAScASYK49QEQMxihmFBwRiYP8n7AUMON/I5x5Ei99Hn5xQnLEqKWqFL1RTlEnCShpbJpvjxMkOrSRyIUFNctvjaVBQ6xIebvmi1qQvhpi2tNnXxs6oodAgg1BTVGh1eZmg1yTRpaJnMQ5+qKR4UtcIAPzf8yH0M210prnuMCgqSRYB/onOErjdbMhomBiRiNwAAAABJRU5ErkJggg=="

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	module.exports = {
	  '_GROUP_EVENT': {
	    'TITLE_EDIT': 'Edit Event',
	    'TITLE_CREATE': 'Create Event',
	    'CUSTOMIZE_EVENT': 'Customizing the Event',
	    'ADD_COVER_IMAGE': 'Add Event cover image',
	    'SELECT_PHOTO': 'Select photo',
	    'UPLOAD_PHOTO': 'Upload photo',
	    'CREATE_TITLE': 'Create event',
	    'EVENT_NAME': 'Event Name',
	    'PERIOD_NAME': 'Period',
	    'START_DATE': 'Start Date',
	    'END_DATE': 'End Date',
	    'VALID_DATE': 'End date must be great than or equals to start date.',
	    'LOCATION': 'Location',
	    'DESCRIPTION': 'Description',
	    'CANCEL': 'Cancel',
	    'SAVE': 'Save',
	    'PARTICIPANTS': 'Participants',
	    'NONPARTICIPANTS': 'Non-participation',
	    'CREATE_EVENT': 'Create Event',
	    'DELETE_EVENT': 'Delete Event',
	    'EVENT_LIST': 'Event List',
	    'SELECT_SCORE_CARD': 'Select a score card to be submitted',
	    'VIEW_RANK': 'Referring to the ranking of this event.',
	    'LIST_SUBMITTED_SCORE': 'Submitted score.',
	    'DELETE': 'Delete',
	    'SUBMIT': 'Submit',
	    'SUBMITTED': 'Submitted',
	    'CONFIRM_MESS': 'Are you sure to delete?',
	    'VIEW_DETAIL': 'View detail',
	    'CLOSE_DETAIL': 'Close',
	    'AVG_SCORE_RANK': 'Average score ranking',
	    'AVG_PUTT_RANK': 'Average putt ranking',
	    'PER_ON_RATE_RANK': 'Per on Rate Ranking',
	    'BIRDIE_RATE_RANK': 'Birdie Rate Ranking',
	    'PER_RATE_RANK': 'Per Rate Ranking',
	    'SUBMIT_DELETE_SCORCARD': 'Submit / delete scorecard',
	    'OVERALL_SCORE_ANALYSIS': 'Overall score analysis',
	    'SCORE_ANALYSIS': 'Score analysis of this round',
	    'FILTER_PERIOD': 'Period',
	    'FILTER_COURSE': 'Course',
	    'FILTER_STATUS': 'Status',
	    'FILTER': 'Filter',
	    'FILTER_PC': 'Filter the display conditions',
	    'FILTER_CLOSE': 'Close',
	    'FILTER_PERIOD_ALL': 'Entire period',
	    'FILTER_PERIOD_THREE_MONTH': 'Last 3 months',
	    'FILTER_PERIOD_SIX_MONTH': 'Last 6 months',
	    'FILTER_COURSE_ALL': 'All of the courses',
	    'FILTER_STATUS_ALL': 'All',
	    'FILTER_STATUS_DONE': 'Submitted',
	    'FILTER_STATUS_NOTYET': 'Not submitted',
	    'FILTER_MODAL_HEADER': 'Select target courses',
	    'FILTER_MODAL_FOOTER': 'Done',
	    'FILTER_BY_CONDITION': 'Filter by this condition',
	    'FILTER_SELECT_COURSE': 'SELECT COURSE >',
	    'CROP': {
	      'TITLE': 'Crop',
	      'CANCEL': 'Cancel',
	      'DONE': 'Done'
	    }
	  }
	};


/***/ }),
/* 739 */
/***/ (function(module, exports) {

	module.exports = {
	  '_GROUP_EVENT': {
	    'TITLE_CREATE': 'Create Event',
	    'CUSTOMIZE_EVENT': 'イベントのカスタマイズ',
	    'ADD_COVER_IMAGE': 'ここのカバー写真を追加できます',
	    'SELECT_PHOTO': '写真を選択',
	    'UPLOAD_PHOTO': '写真をアップロード',
	    'CREATE_TITLE': 'イベントを作成',
	    'EVENT_NAME': 'イベント名',
	    'PERIOD_NAME': '期間',
	    'START_DATE': '開始日',
	    'END_DATE': '終了日',
	    'VALID_DATE': '日付指定を見直してください。',
	    'LOCATION': '場所',
	    'DESCRIPTION': '説明',
	    'CANCEL': 'キャンセル',
	    'SAVE': '保存',
	    'PARTICIPANTS': '参加',
	    'NONPARTICIPANTS': '不参加',
	    'CREATE_EVENT': '新規イベント作成',
	    'DELETE_EVENT': 'イベントを削除',
	    'EVENT_LIST': 'イベント一覧',
	    'SELECT_SCORE_CARD': '提出するスコアカードを選択',
	    'VIEW_RANK': 'このイベントのランキングを見る',
	    'LIST_SUBMITTED_SCORE': '提出済スコアカード',
	    'DELETE': '削除',
	    'SUBMIT': '提出する',
	    'SUBMITTED': '提出済み',
	    'CONFIRM_MESS': '削除してよろしいですか？',
	    'VIEW_DETAIL': '詳細を見る',
	    'CLOSE_DETAIL': '閉じる',
	    'AVG_SCORE_RANK': '平均スコアランキング',
	    'AVG_PUTT_RANK': '平均パットランキング',
	    'PER_ON_RATE_RANK': 'パーオン率ランキング',
	    'BIRDIE_RATE_RANK': 'バーディ率ランキング',
	    'PER_RATE_RANK': 'パー率ランキング',
	    'SUBMIT_DELETE_SCORCARD': 'スコアカード提出・削除',
	    'OVERALL_SCORE_ANALYSIS': '全体のスコア分析',
	    'SCORE_ANALYSIS': 'このラウンドのスコア分析',
	    'FILTER_PERIOD': '対象期間',
	    'FILTER_COURSE': '対象コース',
	    'FILTER_STATUS': 'ステータス',
	    'FILTER': '絞り込み',
	    'FILTER_PC': '表示条件を絞り込む',
	    'FILTER_CLOSE': '閉じる',
	    'FILTER_PERIOD_ALL': '全期間',
	    'FILTER_PERIOD_THREE_MONTH': '直近3ヶ月',
	    'FILTER_PERIOD_SIX_MONTH': '直近6ヶ月',
	    'FILTER_COURSE_ALL': '全コース',
	    'FILTER_STATUS_ALL': '全て',
	    'FILTER_STATUS_DONE': '提出済み',
	    'FILTER_STATUS_NOTYET': '未提出',
	    'FILTER_MODAL_HEADER': '対象コースの選択',
	    'FILTER_MODAL_FOOTER': '決定',
	    'FILTER_BY_CONDITION': 'この条件で絞り込む',
	    'FILTER_SELECT_COURSE': '  コースを選択  >   ',
	    'CROP': {
	      'TITLE': 'トリミング',
	      'CANCEL': 'キャンセル',
	      'DONE': '完了'
	    }
	  }
	};


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	var GroupRankingCtrl, GroupRankingService, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(386);
	
	__webpack_require__(59);
	
	__webpack_require__(72);
	
	__webpack_require__(108);
	
	__webpack_require__(82);
	
	__webpack_require__(112);
	
	__webpack_require__(412);
	
	__webpack_require__(90);
	
	__webpack_require__(76);
	
	__webpack_require__(741);
	
	__webpack_require__(742);
	
	GroupRankingCtrl = __webpack_require__(745);
	
	GroupRankingService = __webpack_require__(746);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-common-wrapper', 'gnp-remote-api', 'gnp-form', 'gnp-flash', 'gnp-animate', 'gnp-error-handler'];
	
	angular.module('gnp-app-group-ranking', modules).config([
	  '$routeProvider', '$translateProvider', function($routeProvider, $translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(747)).translations('ja', __webpack_require__(748));
	  }
	]).controller('GroupRankingCtrl', GroupRankingCtrl).factory('groupRankingService', GroupRankingService);


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"group-ranking-list\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-12 col-md-4 offset-md-8 btnCreateEvent\"><button ng-show=\"lstRankingCtrl.showCreateButton\" ng-click=\"lstRankingCtrl.goToCreatePage()\" class=\"btn-primary btn-lg btn-block\"><img src=\"" + __webpack_require__(689) + "\"/>{{ :: '_GROUP_EVENT.CREATE_EVENT' | translate }}</button></div></div><div class=\"row\"><div class=\"col-12 row-title\"><h3 class=\"card-title\">{{ :: '_RANKING_GROUP.JOINED_LIST' | translate }}</h3></div><div ng-repeat=\"event in lstRankingCtrl.lstEvents\" ng-click=\"lstRankingCtrl.showGroupEventRanking(event.id)\" class=\"col-12 row-content\"><div class=\"imgContainer\"><img ng-src=\"{{ event.cover_url }}\" src=\"" + __webpack_require__(690) + "\" class=\"rounded-circle\"/></div><div class=\"titleContainer\"><div class=\"col-12 name\">{{ event.name }}</div><div class=\"col-12 time\">{{ lstRankingCtrl.displayPeriod(event.start_date, event.end_date) }}<div class=\"members\"><div class=\"col-sm-3 join-group\">{{ lstRankingCtrl.displayParticipants(event.participant) }}</div><div class=\"col-sm-3 join-group\">{{ lstRankingCtrl.displayNoParticipants(event.non_participant) }}</div></div></div></div><div ng-if=\"groupStatus.joined\" class=\"rankingContainer\"><div class=\"list-ranking {{ lstRankingCtrl.displayImageRanking(event.rank) }}\">{{ event.rank == '-'? '' : event.rank}}</div></div></div></div><div ng-show=\"lstRankingCtrl.hasMore() || lstRankingCtrl.isLoading \" class=\"row loadMoreRegion\"><button ng-class=\"{ loading : lstRankingCtrl.isLoading }\" ng-click=\"lstRankingCtrl.loadMore()\" gnp-indicator=\"lstRankingCtrl.isLoading\" class=\"btn btn-primary btn-lg btn-loadMore\">{{:: 'SHOW_MORE' | translate }}</button></div><div ng-show=\"lstRankingCtrl.noResults\" class=\"row loadMoreRegion\"><h3 class=\"card-title\">{{ :: '_GROUP.NO_DATA' | translate }}</h3></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-ranking/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(743);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_ranking.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_ranking.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}#group-ranking-list .btnCreateEvent{padding:10px}#group-ranking-list .btnCreateEvent button{background-color:#fff;color:#1badac;border:3px solid}#group-ranking-list .btnCreateEvent button img{width:22px;height:22px;margin-right:5px}#group-ranking-list .row-title{border-bottom:2px solid;padding:10px}#group-ranking-list .loadMoreRegion{padding:10px;text-align:center;display:block}#group-ranking-list .loadMoreRegion .btn-loadMore{position:relative;margin:0 auto;color:#fff;width:220px;background-color:#555}#group-ranking-list .loadMoreRegion .btn-loadMore.loading{color:transparent}#group-ranking-list .row-content{display:table;padding:10px;border-bottom:2px solid #ccc;cursor:pointer;table-layout:fixed}#group-ranking-list .row-content .imgContainer{display:table-cell;width:80px;text-align:center;vertical-align:middle}#group-ranking-list .row-content .rankingContainer{display:table-cell;width:70px;text-align:center;vertical-align:middle}#group-ranking-list .row-content img.rounded-circle{width:80px;height:80px}#group-ranking-list .row-content .titleContainer{display:table-cell;vertical-align:middle;text-overflow:clip;overflow:hidden}#group-ranking-list .row-content .titleContainer .name{font-size:18px;font-weight:700}#group-ranking-list .row-content .titleContainer .join-group{padding:0}#group-ranking-list .row-content .titleContainer .members,#group-ranking-list .row-content .titleContainer .time{font-size:16px;color:gray}#group-ranking-list .row-content .list-ranking{width:68px;height:45px;line-height:65px;background-repeat:no-repeat;background-position:center;font-weight:700;font-size:18px;margin:0 auto}#group-ranking-list .row-content .ranking-one{color:#fff;background-image:url("+__webpack_require__(721)+")}#group-ranking-list .row-content .ranking-two{color:#fff;background-image:url("+__webpack_require__(722)+")}#group-ranking-list .row-content .ranking-three{color:#fff;background-image:url("+__webpack_require__(723)+")}#group-ranking-list .row-content .ranking-over-three{color:#000;background-image:url("+__webpack_require__(724)+");line-height:45px}#group-ranking-list .row-content .ranking-not-join-yet{color:#000;background-image:url("+__webpack_require__(744)+");line-height:45px}@media (max-width:414px){#group-ranking-list .row-content{padding-right:0}#group-ranking-list .row-content img.rounded-circle{width:40px;height:40px;image-orientation:from-image}#group-ranking-list .row-content .imgContainer{width:40px}#group-ranking-list .row-content .rankingContainer{width:50px}#group-ranking-list .row-content .list-ranking{width:40px;background-size:40px;font-size:12px;line-height:58px}#group-ranking-list .row-content .ranking-over-three{line-height:45px}#group-ranking-list .row-content .titleContainer .name{font-size:12px}#group-ranking-list .row-content .titleContainer .members,#group-ranking-list .row-content .titleContainer .time{font-size:10px}}@media (max-width:320px){#group-ranking-list .row-content .titleContainer .name{font-size:10px}#group-ranking-list .row-content .titleContainer .members,#group-ranking-list .row-content .titleContainer .time{font-size:7px}}", ""]);

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAsCAMAAAANQyXzAAACtVBMVEWenp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp7JIFuzAAAA5nRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiMkJSYnKCssLS4vMDEyMzQ1Njc4OTo7PD0+P0BCQ0RFRkhJSktMTU5PUFJTVVZXWFlaW1xdXl9gYWNkZmdoaWprbG1ub3BxcnN1dnd4eXp7fH1+f4CBgoSFh4iJioyNjo+QkZOUlZaXmJmam5ydnqChoqOkpaanqKmqq66xsrO0tba3ubq7vL2+wMHCw8TFx8jJysvMzc7P0NHS09TV1tfY2drd3t/h4uPk5ebn6Onq6+zt7u/w8fLz9PX2+Pn6+/z9/laA1pgAAAOxSURBVBgZ7cH/OxR2AMDxt3NnyGjcIcxG62y+rELppmZDF2HLJI42rVJDXSWtNimTbUZqWlnbpS+2nVr50jImZrO6TZKypRhqtD5/x+7oaY/1PB3XftgPe714KM35wd6h8xos5doqiuOU8cWi1RWLSNsu+cFc8LvUJsUS5aNOEC2iwWm0HAt4DWcAMSIGyBj2YupS+u0AtVADdv0pTF2eAaNYEYuRIY+pyzNgpBZqjAx5TF3ygD1gl2oH2A8kM3UeQ2uA0NJQYM2QBxYoES6wVWwFF1GCJSRNVwMgCAKuNkmwiPM5UbZsdmKZOOeMpRIb+3v6GxN5FE5uTvzv3/NSAg+YHqUAojwhpGh3QX5RoRugTNekpqYnRciQflB3xqhGvx+TQ9U8QHUzHJdNunKYX33ixNFu8TSQ0NLc1FR3YdQDabI2e3nK+mWiA5asXdv03frM5W5M8ELvbKS7C+MZ13wQI8ljMpmMF8VMTNLiyLjuh7Tkmy/6u/X1Yi0TzLuuBlsvxmUOe3Hf3BFfTL6v2Xn3VZAALVro2Ix86bjYJY7g33/n80DuUQktf1sw4otJfeWWSMZ43gqEtlVEjIzeNrl7MxBCO3O/FFXzrDAK/r2zK4n7/EdmYiQfTOCeiotg27kYGzc3V5MZCiksuPIki/uaHYAkUSXZKd4AfCJVKlXw6pGnMKrttGGcRkSBx50gJgjrDoNpIVZ4N4gtwAaRA1pDe3t7y1XhjXTJL8KfMba7xLs8t0532Z4JwodUjJmlj8HkvXxwcFEoFG4hnyiw++rHIMYpzuaCT33La0w0pzGYh5mGOTKFLf9pEhmP6qAXY7b6S1Zo0lYutcckcxmTEp6zSvtHyevZKTL4KcxdHP7o9K+eBBxQcGYvikpfzEqsPKQb0B+sLLD2qOo7vr4vO7moewYR1xTo8pHfmMOktMoxcn+rc+PLo3tydT2uhPcuUur3KRf2BWKOS+G+93f17i/c+3ESHEuTF23bXPC2E+4n60/+drmm4Zgz5kzfsC2rS/yZk7td7bj6ys9VxVVHKiqykHs7O1Z/6CBf5MMkLGy58IMGUJ4ajJv1zqZbK5YGULYDjuTDMS3mrbv2SnVs+2EbrKxr5zxb495dUenH8RL4bAec2oE5rqdvh3BR+URHVyzo40u7thueV9pxoEGTfqkxZaUhC3MCTwTjdDMCa12Wvban5Wjktzf278nj09Gvz9bW1deKjUyGbYYXRo+XZkc/g2x+xpvRxKgZk7yAf/gLRcM6NPAjlAoAAAAASUVORK5CYII="

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	var GroupRankingCtrl, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	GroupRankingCtrl = function($scope, $translate, $filter, $location, groupRankingService) {
	  var lstRanking;
	  lstRanking = this;
	  lstRanking.pageSize = 4;
	  lstRanking.lstEvents = [];
	  lstRanking.currentPage = 0;
	  lstRanking.isLoading = true;
	  lstRanking.noResults = false;
	  lstRanking.totalPages = 0;
	  lstRanking.showCreateButton = false;
	  lstRanking.loadMore = function() {
	    var params;
	    lstRanking.isLoading = true;
	    lstRanking.currentPage++;
	    params = {
	      group_id: $scope.groupDetail.id,
	      page: lstRanking.currentPage,
	      page_size: lstRanking.pageSize
	    };
	    return groupRankingService.listRanking(params).then(function(data) {
	      lstRanking.lstEvents = _.union(lstRanking.lstEvents, data.events);
	      lstRanking.totalPages = data.total_pages;
	      return lstRanking.noResults = lstRanking.lstEvents.length === 0;
	    })["finally"](function() {
	      return lstRanking.isLoading = false;
	    });
	  };
	  lstRanking.hasMore = function() {
	    return lstRanking.noResults === false && lstRanking.currentPage !== lstRanking.totalPages;
	  };
	  groupRankingService.checkJoinGroup($scope.groupDetail.id).then(function(data) {
	    return lstRanking.showCreateButton = data.joined;
	  });
	  lstRanking.displayPeriod = function(startTime, endTime) {
	    var reText;
	    reText = "";
	    if (!startTime && !endTime) {
	      return reText;
	    }
	    reText = $filter('translate')('_GROUP_EVENT.PERIOD_NAME');
	    reText += ": ";
	    reText += lstRanking.displayDateByLang(startTime);
	    reText += " ~ ";
	    reText += lstRanking.displayDateByLang(endTime);
	    return reText;
	  };
	  lstRanking.displayDateByLang = function(time) {
	    var d, formatText;
	    if (!time) {
	      return "";
	    }
	    d = moment(time);
	    formatText = 'YYYY-MM-DD (ddd)';
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      formatText = 'LL (ddd)';
	      moment.locale('ja');
	    }
	    return d.format(formatText);
	  };
	  lstRanking.displayParticipants = function(number) {
	    var reText;
	    reText = $filter('translate')('_RANKING_GROUP.PARTICIPANTS');
	    reText += ': ';
	    reText += number;
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      reText += '人';
	    }
	    return reText;
	  };
	  lstRanking.goToCreatePage = function() {
	    var url;
	    url = '/group-event/registration?id=' + $scope.groupDetail.id;
	    return $location.url(url);
	  };
	  lstRanking.displayNoParticipants = function(number) {
	    var reText;
	    reText = $filter('translate')('_RANKING_GROUP.NONPARTICIPANTS');
	    reText += ': ';
	    reText += number;
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      reText += '人';
	    }
	    return reText;
	  };
	  lstRanking.showGroupEventRanking = function(id) {
	    return $location.path('/group-event/' + id + '/ranking');
	  };
	  lstRanking.displayImageRanking = function(number) {
	    switch (number) {
	      case 1:
	        return 'ranking-one';
	      case 2:
	        return 'ranking-two';
	      case 3:
	        return 'ranking-three';
	      case "-":
	        return 'ranking-not-join-yet';
	      default:
	        return 'ranking-over-three';
	    }
	  };
	  lstRanking.loadMore();
	  return lstRanking;
	};
	
	GroupRankingCtrl.$inject = ['$scope', '$translate', '$filter', '$location', 'groupRankingService'];
	
	module.exports = GroupRankingCtrl;


/***/ }),
/* 746 */
/***/ (function(module, exports) {

	var GroupRankingService;
	
	GroupRankingService = function($http, $q) {
	  return {
	    listRanking: function(dParam) {
	      var defer, url;
	      defer = $q.defer();
	      url = "/api/groups/ranking_events/me.json";
	      $http.get(url, {
	        params: dParam
	      }).then(function(resp) {
	        return defer.resolve(resp.data);
	      });
	      return defer.promise;
	    },
	    checkJoinGroup: function(id) {
	      var defer, url;
	      defer = $q.defer();
	      url = "/api/users/join_group.json?group_id=" + id;
	      $http.get(url).then(function(resp) {
	        return defer.resolve(resp.data);
	      });
	      return defer.promise;
	    },
	    createEvent: function(event, dataCover) {
	      var defer, promise;
	      defer = $q.defer();
	      promise = {
	        urlCover: groupUploadDataService.uploadS3(dataCover.coverFile, dataCover.url, dataCover.fields)
	      };
	      $q.all(promise).then(function(data) {
	        event.cover_path = data.urlCover;
	        return $http.post('/api/group_events.json', event).then(function(data) {
	          return defer.resolve('success');
	        }, function(data) {
	          return defer.reject(data);
	        });
	      });
	      return defer.promise;
	    }
	  };
	};
	
	GroupRankingService.$inject = ['$http', '$q'];
	
	module.exports = GroupRankingService;


/***/ }),
/* 747 */
/***/ (function(module, exports) {

	module.exports = {
	  '_RANKING_GROUP': {
	    'LIST_TITLE': "Ranking of user",
	    'JOINED_LIST': 'Group list',
	    'PARTICIPANTS': 'Participants',
	    'NONPARTICIPANTS': 'Non-participation',
	    'EVENT_RANK': {
	      'RANKING_NAME': 'Ranking',
	      'AVG_SCORE': 'Average score',
	      'AVG_PUTT': 'Average putt ',
	      'RAT_PAR_ON': 'Per on Rate （% Notation）',
	      'RAT_BIRDIE': 'Birdie Rate （% Notation）',
	      'RAT_PAR': 'Per Rate （% Notation）',
	      'SCORE_DETAILS': 'Score details',
	      'CLOSE': 'Close',
	      'UNNAMED': 'Unnamed',
	      'SCORE_ANALYSIS': 'Overall score analysis'
	    }
	  }
	};


/***/ }),
/* 748 */
/***/ (function(module, exports) {

	module.exports = {
	  '_RANKING_GROUP': {
	    'LIST_TITLE': "グループ",
	    'JOINED_LIST': 'イベント一覧',
	    'PARTICIPANTS': '参加',
	    'NONPARTICIPANTS': '不参加',
	    'EVENT_RANK': {
	      'RANKING_NAME': 'ランキング',
	      'AVG_SCORE': '平均スコア',
	      'AVG_PUTT': '平均パット',
	      'RAT_PAR_ON': 'パーオン率',
	      'RAT_BIRDIE': 'バーディ率',
	      'RAT_PAR': 'パー率',
	      'SCORE_DETAILS': 'スコア詳細を見る',
	      'CLOSE': '閉じる',
	      'UNNAMED': '名称未設定',
	      'SCORE_ANALYSIS': '全体のスコア分析'
	    }
	  }
	};


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	var GroupTimelineCtrl, GroupTimelineService, TimelineCreateEventDirective, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(386);
	
	__webpack_require__(59);
	
	__webpack_require__(72);
	
	__webpack_require__(108);
	
	__webpack_require__(82);
	
	__webpack_require__(112);
	
	__webpack_require__(412);
	
	__webpack_require__(90);
	
	__webpack_require__(76);
	
	__webpack_require__(686);
	
	__webpack_require__(750);
	
	__webpack_require__(752);
	
	GroupTimelineCtrl = __webpack_require__(754);
	
	GroupTimelineService = __webpack_require__(755);
	
	TimelineCreateEventDirective = __webpack_require__(756);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-common-wrapper', 'gnp-remote-api', 'gnp-form', 'gnp-flash', 'gnp-animate', 'gnp-error-handler', 'gnp-app-group-event'];
	
	angular.module('gnp-app-group-timeline', modules).config([
	  '$routeProvider', '$translateProvider', function($routeProvider, $translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(764)).translations('ja', __webpack_require__(765));
	  }
	]).factory('GroupTimelineService', GroupTimelineService).controller('GroupTimelineCtrl', GroupTimelineCtrl).directive('timelineCreateEvent', TimelineCreateEventDirective);


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"group-timeline\"><div infinite-scroll=\"timelineCtrl.loadMore()\" infinite-scroll-disabled=\"timelineCtrl.hasMore()==false\" class=\"timeline container-fluid\"><div ng-repeat=\"timeline in timelineCtrl.lstTimelines\" class=\"row tl-container\"><timeline-create-event data=\"timeline\" submit-reaction=\"timelineCtrl.submitReaction(paramReaction)\"></timeline-create-event></div><div ng-show=\"timelineCtrl.isLoading\" class=\"row load-more-loading\"><img src=\"" + __webpack_require__(751) + "\"/></div><div ng-show=\"!timelineCtrl.isLoading &amp;&amp; timelineCtrl.noResults\" class=\"row load-more-loading\"><h3 class=\"card-title\">{{ :: '_GROUP.NO_DATA' | translate }}</h3></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-timeline/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(753);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_timeline.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_timeline.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}@keyframes rotateAnimate{100%{transform:rotate(-20deg) scale(1.2);-ms-transform:rotate(-20deg) scale(1.2);-webkit-transform:rotate(-20deg) scale(1.2)}}#group-timeline #event-rank{padding-top:10px;padding-bottom:10px}#group-timeline #event-rank .buttonContainer{display:none}#group-timeline .row.load-more-loading{text-align:center;height:50px;padding:10px;display:block}#group-timeline .row.load-more-loading img{margin:0 auto;position:relative}#group-timeline .tl-create-event{border-bottom:1px solid #e5e5e5;padding:10px 0}#group-timeline .tl-create-event .info{display:table;padding-top:10px;padding-bottom:10px;table-layout:fixed}#group-timeline .tl-create-event .info .imgContainer{display:table-cell;width:90px;text-align:center;vertical-align:middle}#group-timeline .tl-create-event .info img.rounded-circle{width:80px;height:80px}#group-timeline .tl-create-event .info .titleContainer{display:table-cell;vertical-align:middle}#group-timeline .tl-create-event .info .titleContainer span{display:block;word-wrap:break-word;white-space:normal;overflow:hidden;text-overflow:ellipsis;margin:0;word-break:break-all}#group-timeline .tl-create-event .info .titleContainer span.name{font-size:18px;font-weight:700}#group-timeline .tl-create-event .info .titleContainer span.time{font-size:14px;color:gray}@media (max-width:414px){#group-timeline .tl-create-event .info .titleContainer>span.name{font-size:14px}#group-timeline .tl-create-event .info .titleContainer>span.time{font-size:11px}#group-timeline .tl-create-event .info .imgContainer{width:60px}#group-timeline .tl-create-event .info img.rounded-circle{width:50px;height:50px;image-orientation:from-image}}#group-timeline .tl-create-event .btn-show-detail{width:37px;margin:20px auto 30px;display:block}#group-timeline .tl-create-event .btn-show-detail.active{width:30px;transform:rotate(180deg)}#group-timeline .tl-create-event .status{display:table}#group-timeline .tl-create-event .status .reaction-wrap{width:100%;text-align:center;display:table}#group-timeline .tl-create-event .status .cell{display:table-cell;vertical-align:middle;color:#587777}#group-timeline .tl-create-event .status .cell.active{color:#cecc3c}#group-timeline .tl-create-event .status .cell a{text-decoration:none;color:inherit;outline:none}#group-timeline .tl-create-event .status .cell a:hover,#group-timeline .tl-create-event .status .cell a:active{cursor:pointer;color:inherit}#group-timeline .tl-create-event .status .cell a:focus{outline:none}#group-timeline .tl-create-event .status .cell a:focus img{animation-name:rotateAnimate;animation-duration:.5s;-webkit-animation-name:rotateAnimate;-webkit-animation-duration:.5s}#group-timeline .tl-create-event .status .cell img{width:20px;height:20px;background-color:#fff}#group-timeline .tl-create-event .status .cell span{padding-left:5px}#group-timeline .tl-create-event .status .cell.padding-cell{width:90px}@media (max-width:414px){#group-timeline .tl-create-event .status .cell.padding-cell{width:50px}}", ""]);

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupTimelineCtrl, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	$ = __webpack_require__(1);
	
	GroupTimelineCtrl = function($scope, $translate, $filter, flash, $location, $ngConfirm, GroupTimelineService) {
	  var pageSize, timeLineCtrl;
	  timeLineCtrl = this;
	  pageSize = 4;
	  timeLineCtrl.lstTimelines = [];
	  timeLineCtrl.currentPage = 0;
	  timeLineCtrl.isLoading = false;
	  timeLineCtrl.noResults = true;
	  timeLineCtrl.totalPages = 0;
	  timeLineCtrl.loadMore = function() {
	    var params;
	    timeLineCtrl.isLoading = true;
	    timeLineCtrl.currentPage++;
	    params = {
	      id: $scope.groupDetail.id,
	      page: timeLineCtrl.currentPage,
	      page_size: pageSize
	    };
	    return GroupTimelineService.getTimeLines(params).then(function(data) {
	      timeLineCtrl.lstTimelines = _.union(timeLineCtrl.lstTimelines, data.timelines);
	      timeLineCtrl.totalPages = data.total_pages;
	      return timeLineCtrl.noResults = timeLineCtrl.lstTimelines.length === 0;
	    })["finally"](function() {
	      return timeLineCtrl.isLoading = false;
	    });
	  };
	  timeLineCtrl.submitReaction = function(param) {
	    return GroupTimelineService.submitReaction(param);
	  };
	  timeLineCtrl.hasMore = function() {
	    return timeLineCtrl.noResults === false && timeLineCtrl.currentPage < timeLineCtrl.totalPages;
	  };
	  timeLineCtrl.loadMore();
	  return timeLineCtrl;
	};
	
	GroupTimelineCtrl.$inject = ['$scope', '$translate', '$filter', 'flash', '$location', '$ngConfirm', 'GroupTimelineService'];
	
	module.exports = GroupTimelineCtrl;


/***/ }),
/* 755 */
/***/ (function(module, exports) {

	var GroupTimelineService;
	
	GroupTimelineService = function($http, $q) {
	  return {
	    getTimeLines: function(dParam) {
	      var defer, url;
	      defer = $q.defer();
	      url = "/api/groups/" + dParam.id + "/timeline.json";
	      $http.get(url, {
	        params: dParam
	      }).then(function(resp) {
	        return defer.resolve(resp.data);
	      });
	      return defer.promise;
	    },
	    submitReaction: function(dParam) {
	      var defer, url;
	      defer = $q.defer();
	      url = "/api/users/reaction.json";
	      $http.post(url, dParam).then(function(resp) {
	        return defer.resolve(resp.data);
	      });
	      return defer.promise;
	    }
	  };
	};
	
	GroupTimelineService.$inject = ['$http', '$q'];
	
	module.exports = GroupTimelineService;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	var $, TimelineCreateEventDirective, _, moment;
	
	__webpack_require__(757);
	
	moment = __webpack_require__(126);
	
	$ = __webpack_require__(1);
	
	_ = __webpack_require__(87);
	
	TimelineCreateEventDirective = function($filter, $translate) {
	  return {
	    restrict: "EA",
	    replace: true,
	    templateUrl: "group-timeline/timeline-create-event-directive/index.jade",
	    scope: {
	      data: '=data',
	      submit: '&submitReaction'
	    },
	    link: function(scope) {
	      var now, setCountReaction, setUserReaction;
	      now = moment();
	      scope.score_cards = scope.data.user.score_cards;
	      if (scope.data.user.score_card) {
	        scope.score_cards = _.union(scope.score_cards, [scope.data.user.score_card]);
	      }
	      scope.displayName = function(user) {
	        var fName, lName, ref, ref1;
	        fName = (ref = user.first_name) != null ? ref : '';
	        lName = (ref1 = user.last_name) != null ? ref1 : '';
	        if (fName + lName === '') {
	          return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED');
	        }
	        if (/^ja/i.test($translate.preferredLanguage())) {
	          return lName + " " + fName;
	        }
	        return fName + " " + lName;
	      };
	      scope.displayEvent = function(groupEvent) {
	        if (groupEvent.active) {
	          return "<a href='/group-event/" + groupEvent.id + "/ranking'>" + groupEvent.name + "</a>";
	        } else {
	          return groupEvent.name;
	        }
	      };
	      scope.displayYear = function(time) {
	        var displayStr, strFormat;
	        displayStr = moment(time);
	        strFormat = '';
	        if (/^ja/i.test($translate.preferredLanguage())) {
	          if (displayStr.year() !== now.year()) {
	            strFormat = 'YYYY年MM月DD日 HH:mm';
	          } else {
	            strFormat = 'MM月DD日 HH:mm';
	          }
	        } else {
	          if (displayStr.year() !== now.year()) {
	            strFormat = 'YYYY-MM-DD HH:mm';
	          } else {
	            strFormat = 'MM-DD HH:mm';
	          }
	        }
	        return displayStr.format(strFormat);
	      };
	      setUserReaction = function(type, userReaction) {
	        userReaction.good = type === 'good' ? !userReaction.good : false;
	        userReaction.awesome = type === 'awesome' ? !userReaction.awesome : false;
	        return userReaction.bad = type === 'bad' ? !userReaction.bad : false;
	      };
	      setCountReaction = function(oldReaction, newReaction, data) {
	        if (oldReaction.good !== newReaction.good) {
	          data.good += newReaction.good ? 1 : -1;
	        }
	        if (oldReaction.awesome !== newReaction.awesome) {
	          data.awesome += newReaction.awesome ? 1 : -1;
	        }
	        if (oldReaction.bad !== newReaction.bad) {
	          return data.bad += newReaction.bad ? 1 : -1;
	        }
	      };
	      scope.btnReactionPress = function(type, data) {
	        var oldReaction, param;
	        oldReaction = {
	          good: data.user_reaction.good,
	          awesome: data.user_reaction.awesome,
	          bad: data.user_reaction.bad
	        };
	        setUserReaction(type, data.user_reaction);
	        setCountReaction(oldReaction, data.user_reaction, data.reactions);
	        param = {
	          paramReaction: {
	            type: type,
	            group_timeline_id: data.id
	          }
	        };
	        return scope.submit(param);
	      };
	      scope.getPostTypeName = function(type) {
	        switch (type) {
	          case 'upload_score_card':
	            if (scope.score_cards.length > 1) {
	              return '_GROUP_TIMELINE.SUBMIT_SCORES_TITLE';
	            } else {
	              return '_GROUP_TIMELINE.SUBMIT_SCORE_TITLE';
	            }
	            break;
	          case 'create_event':
	            return '_GROUP_TIMELINE.CREATE_EVENT_TITLE';
	          case 'update_event':
	            return '_GROUP_TIMELINE.UPDATE_EVENT_TITLE';
	          case 'delete_event':
	            return '_GROUP_TIMELINE.DELETE_EVENT_TITLE';
	          default:
	            return '_GROUP_TIMELINE.CREATE_EVENT_TITLE';
	        }
	      };
	      scope.getTextOfAvatar = function() {
	        var $avatarElement;
	        $avatarElement = $(".avatar-for-" + scope.data.user.id + " .avatar-image-text:not(.is-small)");
	        if (scope.data.user.display_text_avatar.length === 1) {
	          $avatarElement.removeClass('two-characters');
	          $avatarElement.addClass('one-character');
	        } else {
	          $avatarElement.removeClass('one-character');
	          $avatarElement.addClass('two-characters');
	        }
	        return scope.data.user.display_text_avatar;
	      };
	      return scope.isAvatarColor = function() {
	        var ref;
	        return ((ref = scope.data.user.avatar_image_path) != null ? ref.indexOf('avatar_color') : void 0) > -1;
	      };
	    }
	  };
	};
	
	TimelineCreateEventDirective.$inject = ['$filter', '$translate'];
	
	module.exports = TimelineCreateEventDirective;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div class=\"col-12 tl-create-event\"><div class=\"col-12 info\"><div ng-switch=\"data.user.gender\" ng-if=\"!data.user.avatar_image_path\" class=\"imgContainer\"><img ng-switch-when=\"male\" src=\"" + __webpack_require__(701) + "\" class=\"rounded-circle\"/><img ng-switch-when=\"female\" src=\"" + __webpack_require__(702) + "\" class=\"rounded-circle\"/><img ng-switch-default=\"ng-switch-default\" src=\"" + __webpack_require__(701) + "\" class=\"rounded-circle\"/></div><div ng-if=\"data.user.avatar_image_path\" class=\"imgContainer\"><div class=\"avatarContainer avatar-for-{{data.user.id}}\"><img ng-src=\"{{::data.user.avatar_image_path}}\" class=\"rounded-circle avatar-image is-full\"/><span ng-if=\"isAvatarColor()\" class=\"avatar-image-text\">{{:: getTextOfAvatar() }}</span></div></div><div class=\"titleContainer\"><span ng-bind-html=\"getPostTypeName(data.type) | translate:{name: displayName(data.user), event: displayEvent(data.group_event), score_cards_count: score_cards.length}\" class=\"name\"></span><span class=\"time\">{{ displayYear(data.created_datetime) }}</span></div></div><div id=\"event-rank\" ng-if=\"data.type == &quot;upload_score_card&quot;\" event-rank-score-card=\"\" scorelist=\"score_cards\" hidedetail=\"true\" class=\"col-12\"></div><div class=\"col-12\"><div class=\"col-12 offset-sm-2 col-sm-8 status\"><div class=\"reaction-wrap\"><div ng-class=\"{active:data.user_reaction.good}\" class=\"cell like-container\"><a href=\"javascript:void(0)\" ng-click=\"btnReactionPress(&quot;good&quot; , data )\" tabindex=\"1\"><img ng-hide=\"data.user_reaction.good\" src=\"" + __webpack_require__(758) + "\"/><img ng-show=\"data.user_reaction.good\" src=\"" + __webpack_require__(759) + "\"/><span>{{ data.reactions.good }}</span></a></div><div ng-class=\"{active:data.user_reaction.awesome}\" class=\"cell wow-container\"><a href=\"javascript:void(0)\" ng-click=\"btnReactionPress(&quot;awesome&quot; , data )\" tabindex=\"2\"><img ng-hide=\"data.user_reaction.awesome\" src=\"" + __webpack_require__(760) + "\"/><img ng-show=\"data.user_reaction.awesome\" src=\"" + __webpack_require__(761) + "\"/><span>{{ data.reactions.awesome }}</span></a></div><div ng-class=\"{active:data.user_reaction.bad}\" class=\"cell sad-container\"><a href=\"javascript:void(0)\" ng-click=\"btnReactionPress(&quot;bad&quot; , data )\" tabindex=\"3\"><img ng-hide=\"data.user_reaction.bad\" src=\"" + __webpack_require__(762) + "\"/><img ng-show=\"data.user_reaction.bad\" src=\"" + __webpack_require__(763) + "\"/><span>{{ data.reactions.bad }}</span></a></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("group-timeline/timeline-create-event-directive/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 758 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAAM1BMVEUAAAD///9Yd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3e9ejEjAAAAEHRSTlMAABEiM0RVZneImaq7zN3uf6QJ9gAAAORJREFUKM+d08tyxCAMRNHmIZAZbO7/f20WME6csbNI71SnKAQI6ZLS9+4xrFxNBsAe77VDB9qtJmiKO8Q7rVAVKtidNkgKBuVG8+CQQrnVNKBIoUH+1B2apAi4e75qgy5JzswrBknKZmbmMOI680wPkrZ3hc37MjOzss/6xDp3WPeUYftWT7pomG0sPbtbWMAfNQ5Iz2s7hH9qGuzPWsCf1f7UF9jS/qEGR5jqKmDxl/rSMif12PKpDrZ0bMfa/NiKpRDmc4Ygacqo2+Bn6pyN3HrvLUuqr9OOcvMXZNXd3d/z/AW98BKKc+qGTwAAAABJRU5ErkJggg=="

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAANlBMVEUAAADOzDz////OzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzmBuXzAAAAEXRSTlMAAAARIjNEVWZ3iJmqu8zd7qKQ+8MAAADqSURBVCjPndNLksMgDEVRiY9AJtjc/W+2BxAn6dg96DejTlECIUT0PaXv3WNYEflQA2CP19qhA+1SEzSNO8QrrVA1VLArbZA0GJQLzYNDNZRLTQOKamiQv3WHpqoRcPf8qQ26qqoz84hBRDSbmZnDiOvOMz2IyPZcYbNfZmZWdjARObHOCqtPGbaXetIPDdBfeh59YQG/1Tgg3e/tEP6pabDfawG/V/tTH2BL+5caHGGqawGLv9SXljmpx5ZPdbClYztW8WMrlkKYzxmCiEwZdRu8p87ZyK333rKq1sdpR7n4C2rV3d2f8/wD8LgVmeJQpWAAAAAASUVORK5CYII="

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAxlBMVEVYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3erNN66AAAAQXRSTlMAAgMFCgwNDhATHB0hJCYnKistLjA4QUVLUVRcXmNpam50d4OXn6Gkp6yvvcTQ0tPb3t/h4ubs7/Hz9PX29/r7/s/nltwAAAGTSURBVDjLhVNnl4JADFwr1lPPgh0LihV7V2T+/586sg2f93zOFzbJsJlkE8Y00h3HvQAX1+mk2X+UJx40vEn5LZy0feDoWGalYlrOEfDt5Gu8tAaWzZgyY80lsC6F8eoZNyvy+kfEuuFc1f+fsa/PtvMf5fiZb2f1Pc7yjuQa++IBT7QUoRUYh+Iea6HDxq1UeNrRbJghG7WfhdINNhm/PizGjHivG4rs9uIGYxZ8qnaCJembQvDFnZiS0iUmQf88NAMjFbTnIQuJPAIjFRya8NKsgyNdnacGyt4k6ZynVEd0mAOHpz0BO5ViB5y4IAq6JDFA27vXFaF+99r8YMFlF5jCayTCMhOG+Jq4MKDCPqICvBFy/X7ujaBTEBpBgY9GaFMKJZKQuVKB14x2kEhZJsdQzNNQOygoG8WxEISFfhNqlGw1x0YQNsrmrVaPRXAFwVVjxR+LlX0tcywIYy2RPzcfGOGpCUJNTqIcGD5ysrIRxUeyZj1yfGjFHdHBajWICmc4tN/H/vvifF+978v7ef3/AAc9UwyppoSNAAAAAElFTkSuQmCC"

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAxlBMVEXOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDx9BbNcAAAAQXRSTlMAAgMFCgwNDhATHB0hJCYnKistLjA4QUVLUVRcXmNpam50d4OXn6Gkp6yvvcTQ0tPb3t/h4ubs7/Hz9PX29/r7/s/nltwAAAGTSURBVDjLhVNnl4JADFwr1lPPgh0LihV7V2T+/586sg2f93zOFzbJsJlkE8Y00h3HvQAX1+mk2X+UJx40vEn5LZy0feDoWGalYlrOEfDt5Gu8tAaWzZgyY80lsC6F8eoZNyvy+kfEuuFc1f+fsa/PtvMf5fiZb2f1Pc7yjuQa++IBT7QUoRUYh+Iea6HDxq1UeNrRbJghG7WfhdINNhm/PizGjHivG4rs9uIGYxZ8qnaCJembQvDFnZiS0iUmQf88NAMjFbTnIQuJPAIjFRya8NKsgyNdnacGyt4k6ZynVEd0mAOHpz0BO5ViB5y4IAq6JDFA27vXFaF+99r8YMFlF5jCayTCMhOG+Jq4MKDCPqICvBFy/X7ujaBTEBpBgY9GaFMKJZKQuVKB14x2kEhZJsdQzNNQOygoG8WxEISFfhNqlGw1x0YQNsrmrVaPRXAFwVVjxR+LlX0tcywIYy2RPzcfGOGpCUJNTqIcGD5ysrIRxUeyZj1yfGjFHdHBajWICmc4tN/H/vvifF+978v7ef3/AAc9UwyppoSNAAAAAElFTkSuQmCC"

/***/ }),
/* 762 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAA/FBMVEVYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3fIzA2AAAAAU3RSTlMAAgQFBgcIDQ4PEBITFxkcJSYrLS4wMjU4OTtBRUZJSktSVF1iY2doaWptcnR2eHp9foCMkZaXnqSnqLW/wcLHz9DS09Tb4urs8fLz9ff5+vz9/mS/qqYAAAGwSURBVDjLhVPpWsIwEEwptyClghxWOQSxInhxtAoiKAVsuTrv/y42oeGQfrp/us1Ovp3dmRCyjVhVG5mAOdKqMXIcKX2JbSz1s1/lUMcGppqqpNOKqk0Bux3ar8tjYFgW+a9YHgJjeVfPzmCpwv4NQbUwy27vz2DIvznJBmbuYWgMI3HMOmFgvOHRgSV7jEVkC202nw2VHeQlXkrm2UeFTafVMaT8/M11nwP666afMh1Cd/a3RJlkbroTWEUOKFqYdG8zpIxljFQxFePO8ha6tGsv6QvnKC5OUSUaNCI0GlfhQ4bhq0ZDYMWRSzFQq/h41VepBVyaI2JCYfkr0OKAFvDKEgUmAdI0jThizd1tC3NHrAjN0gAHSFRlV8AwzSUOcFuI34DBWxjAt8hbcJKV1aLEAaXFqrIlSSdxokZOorshoyebLy3SRRFyvsp5yMUWxVZN3vHiAWCrZmJdAJ/H9Y1YTO4nwKIy17VeT6snXYArNzXMHfBGCgPu+kFh3zDMcvfPsaCNr8fc6Wnu4QN2cN9y3LTXl7y5cn1g2v9t///D8Xp6ndDfjzflsTfv5/8DRulnHNZrM40AAAAASUVORK5CYII="

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAA/FBMVEXOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzkDomhAAAAU3RSTlMAAgQFBgcIDQ4PEBITFxkcJSYrLS4wMjU4OTtBRUZJSktSVF1iY2doaWptcnR2eHp9foCMkZaXnqSnqLW/wcLHz9DS09Tb4urs8fLz9ff5+vz9/mS/qqYAAAGwSURBVDjLhVPpWsIwEEwptyClghxWOQSxInhxtAoiKAVsuTrv/y42oeGQfrp/us1Ovp3dmRCyjVhVG5mAOdKqMXIcKX2JbSz1s1/lUMcGppqqpNOKqk0Bux3ar8tjYFgW+a9YHgJjeVfPzmCpwv4NQbUwy27vz2DIvznJBmbuYWgMI3HMOmFgvOHRgSV7jEVkC202nw2VHeQlXkrm2UeFTafVMaT8/M11nwP666afMh1Cd/a3RJlkbroTWEUOKFqYdG8zpIxljFQxFePO8ha6tGsv6QvnKC5OUSUaNCI0GlfhQ4bhq0ZDYMWRSzFQq/h41VepBVyaI2JCYfkr0OKAFvDKEgUmAdI0jThizd1tC3NHrAjN0gAHSFRlV8AwzSUOcFuI34DBWxjAt8hbcJKV1aLEAaXFqrIlSSdxokZOorshoyebLy3SRRFyvsp5yMUWxVZN3vHiAWCrZmJdAJ/H9Y1YTO4nwKIy17VeT6snXYArNzXMHfBGCgPu+kFh3zDMcvfPsaCNr8fc6Wnu4QN2cN9y3LTXl7y5cn1g2v9t///D8Xp6ndDfjzflsTfv5/8DRulnHNZrM40AAAAASUVORK5CYII="

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	module.exports = {
	  '_GROUP_TIMELINE': {
	    'TITLE': 'Timeline',
	    'CREATE_EVENT_TITLE': '{{name}} created Event {{event}}',
	    'UPDATE_EVENT_TITLE': '{{name}} updated Event {{event}}',
	    'DELETE_EVENT_TITLE': '{{name}} deleted Event {{event}}',
	    'SUBMIT_SCORE_TITLE': '{{name}} submitted a score to {{event}}',
	    'SUBMIT_SCORES_TITLE': '{{name}} submitted {{score_cards_count}} scores to {{event}}'
	  }
	};


/***/ }),
/* 765 */
/***/ (function(module, exports) {

	module.exports = {
	  '_GROUP_TIMELINE': {
	    'TITLE': 'Timeline',
	    'CREATE_EVENT_TITLE': '{{name}}さんが、イベント「{{event}}」を作成しました。',
	    'UPDATE_EVENT_TITLE': '{{name}}さんが、イベント「{{event}}」を更新しました。',
	    'DELETE_EVENT_TITLE': '{{name}}さんが、イベント「{{event}}」を削除しました。',
	    'SUBMIT_SCORE_TITLE': '{{name}}さんが、「{{event}}」にスコアを提出しました。',
	    'SUBMIT_SCORES_TITLE': '{{name}}さんが、イベント 「{{event}}」に {{score_cards_count}} 件のスコアを提出しました。'
	  }
	};


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	var GroupListMemRequestCtrl, GroupListMembersCtrl, GroupListMembersPmCtrl, GroupMemPermissionDirective, GroupMemberDirective, GroupMemberService, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(386);
	
	__webpack_require__(59);
	
	__webpack_require__(72);
	
	__webpack_require__(108);
	
	__webpack_require__(82);
	
	__webpack_require__(112);
	
	__webpack_require__(412);
	
	__webpack_require__(90);
	
	__webpack_require__(76);
	
	__webpack_require__(767);
	
	__webpack_require__(768);
	
	__webpack_require__(769);
	
	__webpack_require__(770);
	
	__webpack_require__(772);
	
	GroupListMemRequestCtrl = __webpack_require__(776);
	
	GroupListMembersPmCtrl = __webpack_require__(777);
	
	GroupListMembersCtrl = __webpack_require__(778);
	
	GroupMemberService = __webpack_require__(779);
	
	GroupMemPermissionDirective = __webpack_require__(780);
	
	GroupMemberDirective = __webpack_require__(782);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-common-wrapper', 'gnp-remote-api', 'gnp-form', 'gnp-flash', 'gnp-animate', 'gnp-error-handler'];
	
	angular.module('gnp-app-group-member', modules).config([
	  '$routeProvider', '$translateProvider', function($routeProvider, $translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(784)).translations('ja', __webpack_require__(785));
	  }
	]).controller('GroupListMemRequestCtrl', GroupListMemRequestCtrl).controller('GroupListMembersPmCtrl', GroupListMembersPmCtrl).controller('GroupListMembersCtrl', GroupListMembersCtrl).directive('groupMemPermission', GroupMemPermissionDirective).directive('groupMember', GroupMemberDirective).factory('GroupMemberService', GroupMemberService);


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div class=\"col-12 title\"><h3 class=\"card-title\">{{ listRequestCtrl.displayNumberRequest( numBadge ) }}</h3></div><div class=\"col-12 request-container\"><div ng-repeat=\"request in listRequestCtrl.listRequest\" class=\"col-12 row-request\"><div ng-if=\"!request.avatar_image_path\" ng-switch=\"request.gender\" class=\"cell avatar\"><img ng-switch-when=\"female\" src=\"" + __webpack_require__(702) + "\" class=\"rounded-circle\"/><img ng-switch-default=\"ng-switch-default\" src=\"" + __webpack_require__(701) + "\" class=\"rounded-circle\"/></div><div ng-if=\"request.avatar_image_path\" class=\"cell avatar\"><div class=\"avatarContainer avatar-for-{{request.id}}\"><img ng-src=\"{{::request.avatar_image_path}}\" class=\"rounded-circle avatar-image is-full\"/><span ng-if=\"isAvatarColor(request)\" class=\"avatar-image-text\">{{:: getTextOfAvatar(request) }}</span></div></div><div class=\"cell description\"><span>{{ listRequestCtrl.displayUserName(request.first_name , request.last_name) }}</span></div><div class=\"cell btn-region\"><button ng-click=\"listRequestCtrl.processRequest(request , &quot;dismissed&quot; )\" class=\"btn btn-delete\">{{ :: '_GROUP_MEMBERS.DELETE_REQUEST' | translate }}</button><button ng-click=\"listRequestCtrl.processRequest(request , &quot;approved&quot; )\" class=\"btn btn-approve\">{{ :: '_GROUP_MEMBERS.APPROVAL' | translate }}</button></div></div><div ng-show=\"listRequestCtrl.hasMore()\" class=\"col-12 loadMoreRegion\"><button ng-click=\"listRequestCtrl.loadMore()\" gnp-indicator=\"listRequestCtrl.isLoading\" class=\"btn btn-primary btn-lg btn-loadMore\">{{:: 'SHOW_MORE' | translate }}</button></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-member/list-request.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	var v1="<form ng-submit=\"listMemberCtrl.searchMember()\" class=\"col-12 col-md-10 search-container\"><div class=\"d-none d-sm-block\"><div class=\"input-group\"><input type=\"text\" ng-model=\"listMemberCtrl.keyword\" placeholder=\"{{ :: '_GROUP_MEMBERS.SEARCH_MEMBER' | translate }}\" class=\"form-control inputSearch\"/><div class=\"input-group-append\"><button class=\"btn btn-secondary btnSearch\"></button></div></div></div><div class=\"d-block d-sm-none\"><input type=\"submit\" tabindex=\"-1\" style=\"visibility: hidden;width: 0;height:  0;position:  absolute\"/><input type=\"text\" ng-model=\"listMemberCtrl.keyword\" placeholder=\"{{ :: '_GROUP_MEMBERS.SEARCH_MEMBER' | translate }}\" class=\"form-control inputSearch\"/></div></form><div class=\"col-12 header-container-wrap-content\"><div id=\"header-con-member\" class=\"col-12 header-container\"><div class=\"cell\"><h3 class=\"card-title\">{{ :: '_GROUP_MEMBERS.MEMBER' | translate }}</h3></div><div class=\"cell\"><button ng-class=\"{active : listMemberCtrl.hasChanged() }\" ng-click=\"listMemberCtrl.changeMembers()\" class=\"btn btn-block d-none d-sm-block\">{{ :: '_GROUP_MEMBERS.DONE' | translate }}</button></div></div></div><div class=\"col-12 content-container\"><group-mem-permission ng-repeat=\"item in listMemberCtrl.listMember\" data=\"item\" per-data=\"permissionData\"></group-mem-permission></div><div ng-show=\"listMemberCtrl.hasMore()\" class=\"col-12 loadMoreRegion\"><button ng-click=\"listMemberCtrl.loadMore()\" gnp-indicator=\"listMemberCtrl.isLoading\" class=\"btn btn-primary btn-lg btn-loadMore\">{{:: 'SHOW_MORE' | translate }}</button></div><div class=\"col-12 btn-done-wrap-content\"><div id=\"btn-done-member\" class=\"col-12 btn-done sticky d-block d-sm-none\"><button ng-class=\"{active : listMemberCtrl.hasChanged() }\" ng-click=\"listMemberCtrl.changeMembers()\" class=\"btn btn-block\">{{ :: '_GROUP_MEMBERS.DONE' | translate }}</button></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-member/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	var v1="<div id=\"group-detail-page\" gnp-common-wrapper-b=\"\"><div id=\"top-page\"><div id=\"group-mem-non-permission\" class=\"container-fluid\"><div class=\"row header\"><div class=\"col-12 mems-header\"><div class=\"cell\">{{ '_GROUP_INFORMATION.NUM_MEMBERS' | translate | formatString:groupInfo.members }}</div></div></div><div class=\"row content\"><group-member ng-repeat=\"item in listMember\" data=\"item\"></group-member><div ng-show=\"hasMore() || isLoading\" class=\"col-12 loadMoreRegion\"><button ng-click=\"loadMore()\" gnp-indicator=\"isLoading\" class=\"btn btn-primary btn-lg btn-loadMore\">{{:: 'SHOW_MORE' | translate }}</button></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-member/list-member.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(771);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_members_list_request.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_members_list_request.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}#list-request{padding-top:10px;padding-bottom:10px}#list-request .title{padding:0}#list-request .title h3.card-title{background-color:#1badac;color:#fff;font-size:12px;padding:5px 5px 5px 10px}#list-request .request-container{padding-top:10px;padding-bottom:10px;min-height:100px;background-color:#fff}#list-request .request-container .row-request{display:table;table-layout:fixed;padding:5px 0;border:1px solid #e5e5e5;background-color:#fff}#list-request .request-container .row-request+.row-request{margin-top:10px}#list-request .request-container .cell{display:table-cell;vertical-align:middle}#list-request .request-container .cell.avatar{width:90px;text-align:center}#list-request .request-container .cell.avatar img{width:80px;height:80px}#list-request .request-container .cell.description{font-size:14px;text-overflow:ellipsis;overflow:hidden}#list-request .request-container .cell.btn-region{padding-right:10px;max-width:100%}#list-request .request-container .cell.btn-region .btn{border:1px solid #1badac;float:right;color:#1badac;background-color:#fff}#list-request .request-container .cell.btn-region .btn+.btn{margin-right:5px}#list-request .request-container .cell.btn-region .btn-approve{background-color:#1badac;color:#fff;min-width:37px}@media (max-width:590px){#list-request .request-container .cell.btn-region .btn{font-size:10px;padding-left:3px;padding-right:3px}#list-request .request-container .cell.avatar{width:60px}#list-request .request-container .cell.avatar img{width:50px;height:50px}}@media (max-width:414px){#list-request .title{padding:10px 10px 0}#list-request .request-container{background-color:transparent;padding:0 10px}#list-request .request-container .cell.btn-region{padding-right:5px}#list-request .request-container .row-request+.row-request{margin-top:0}}@media (max-width:320px){#list-request .request-container .cell.btn-region .btn{font-size:8px}}", ""]);

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(773);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_members_list.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_members_list.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}#list-members{padding-top:10px;padding-bottom:10px}#list-members .search-container .btnSearch{height:34px;width:70px;background-repeat:no-repeat;background-position:center;background-image:url("+__webpack_require__(774)+");background-color:#1badac;background-size:20px 20px;border-color:#1badac}#list-members .search-container .inputSearch{border-color:#1badac;border-width:2px}@media (max-width:414px){#list-members .search-container .inputSearch{border:none;border-radius:17px;border-color:#1badac;border-width:1px;border-style:solid}#list-members .search-container .inputSearch::-webkit-input-placeholder{text-align:center;transition-duration:.4s;background-image:url("+__webpack_require__(775)+");background-size:15px 15px;background-position:center;background-position-x:calc(50% - 80px);background-repeat:no-repeat}#list-members .search-container input.inputSearch:focus::-webkit-input-placeholder{transform:translateX(calc(0 - (50% - 100px)))}}#list-members .header-container-wrap-content,#list-members .btn-done-wrap-content{padding:0}#list-members .header-container{display:table;margin-top:20px;color:#fff;padding:0;min-height:30px}#list-members .header-container.sticky{position:fixed;z-index:99;top:104px;width:970px}@media (max-width:970px){#list-members .header-container.sticky{width:100%}}@media (max-width:767px){#list-members .header-container.sticky{top:176px}}#list-members .header-container .cell{display:table-cell;vertical-align:middle;background-color:#1badac}#list-members .header-container h3.card-title{padding-left:15px}#list-members .header-container .cell:last-child{width:15%;padding:3px}#list-members .header-container .cell:last-child .btn{padding:3px 12px;background-color:#fff;color:#1badac;opacity:.4;pointer-events:none;cursor:default}#list-members .header-container .cell:last-child .btn.active{opacity:1;pointer-events:inherit;cursor:pointer}@media (max-width:414px){#list-members .header-container{padding-left:15px;padding-right:15px}#list-members .header-container h3.card-title{padding:5px}}#list-members .content-container{padding-top:5px}@media (max-width:590px){#list-members .content-container{padding-top:0}}#list-members .btn-done{margin-top:10px}#list-members .btn-done button.btn{color:#fff;background-color:#555;opacity:.4;pointer-events:none;cursor:default}#list-members .btn-done button.btn.active{opacity:1;pointer-events:inherit;cursor:pointer}#list-members .btn-done.sticky{position:fixed;width:100%;background-color:#e5e5e5;bottom:0;padding:10px}#group-mem-non-permission{padding-top:20px;padding-bottom:20px}#group-mem-non-permission .row.header .mems-header{background-color:#1badac;display:table;color:#fff;padding-top:5px;padding-bottom:5px;min-height:43px}#group-mem-non-permission .row.header .mems-header .cell{display:table-cell;vertical-align:middle;font-size:15px;font-weight:700}#group-mem-non-permission .row.content{padding:5px}#group-mem-non-permission .loadMoreRegion{padding:10px;text-align:center}#group-mem-non-permission .loadMoreRegion .btn-loadMore{position:relative;margin:0 auto;color:#fff;width:220px;background-color:#555}#group-mem-non-permission .loadMoreRegion .btn-loadMore.loading{color:transparent}@media (max-width:590px){#group-mem-non-permission .row{margin-left:0;margin-right:0}#group-mem-non-permission .row.content{padding:0}}#group-mem-permission-directive{padding:5px}#group-mem-permission-directive .info-table{background-color:#fff;display:table;table-layout:fixed;border:1px solid #e5e5e5;min-height:100px;width:100%}#group-mem-permission-directive .info-table .cell{display:table-cell;vertical-align:middle}#group-mem-permission-directive .info-table .cell.image-avatar{width:90px;text-align:center}#group-mem-permission-directive .info-table .cell.image-avatar img{width:80px;height:80px}#group-mem-permission-directive .info-table .cell.description{font-size:14px;text-overflow:ellipsis;overflow:hidden}#group-mem-permission-directive .info-table .cell.description .user-name{font-size:18px;font-weight:700;padding:4px}#group-mem-permission-directive .info-table .cell.description .join-date{padding-left:4px;display:table}#group-mem-permission-directive .info-table .cell.description .join-date span{display:table-cell;font-size:12px;color:gray}#group-mem-permission-directive .info-table .cell.description .join-date span.admin{padding:4px;border:1px solid;border-radius:4px;text-align:center}#group-mem-permission-directive .info-table .cell.description .join-date span.date.member{padding-left:15px}#group-mem-permission-directive .info-table .cell.check-mark{width:20px}#group-mem-permission-directive .info-table .cell.check-mark img{width:18px}#group-mem-permission-directive .info-table .cell.commbo-button{width:170px;padding:5px}#group-mem-permission-directive .info-table .cell.commbo-button .btn{background-color:#fff;border:1px solid #e5e5e5;text-align:left}#group-mem-permission-directive .info-table .cell.commbo-button .btn .caret{float:right;margin:6px 0}#group-mem-permission-directive .info-table .cell.commbo-button .btn-group,#group-mem-permission-directive .info-table .cell.commbo-button .dropdown-toggle,#group-mem-permission-directive .info-table .cell.commbo-button .dropdown-menu{width:100%}#group-mem-permission-directive .info-table .cell.commbo-button .dropdown-toggle{padding-left:20px;text-align:left}#group-mem-permission-directive .info-table .cell.commbo-button .dropdown-menu>li>a:hover,#group-mem-permission-directive .info-table .cell.commbo-button .dropdown-menu .dropdown-item:hover{background:#f1f9fd;cursor:pointer}#group-mem-permission-directive .info-table.delete{background-color:#ddd}#group-mem-permission-directive .info-table.delete .btn{background-color:#ddd!important}#group-mem-permission-directive .info-table.disable{background-color:#ddd;cursor:none;pointer-events:none}@media (max-width:590px){#group-mem-permission-directive{padding:0}#group-mem-permission-directive .info-table{min-height:80px;height:80px}#group-mem-permission-directive .info-table .cell.image-avatar{width:60px}#group-mem-permission-directive .info-table .cell.image-avatar img{width:50px;height:50px}}", ""]);

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAB/klEQVRIib2Vv2sUQRTHP/fDC6QO1tqIVbrDJmcjaGOapEtE8ieJBOyCEpMq1tpYpLhcBCEgaqMRsQseKbSIhfFjMXd4GXZ29pacX3jFvN03n337Zt5rqCTUAe4DK8At4DrQAn4Dx8Ah8AJ4OfJNJ7XI1tVvVtNndTWxT9Jix7y6VxEYa1vt1AHPq4Oa0LFeV4U3/FfjPWC1qBrAADgAToEFoAd0E9V7BmxUrfF6IoNX6s3EVy+q+4m45VzGjH5N0UF6rDYzG7TVrYLYj7lY1JVEpjno2K6o/YI97uTAz6OAP6Z/b8q6BeDNHPhTFNCfEjq299E+b8vebxI60qQOsieyWINofa3s5SahDU7qtCZ4GK3ncuC4zy7UBF+N1r9y4OPI16sJXorWX3Lgw8jXBRanhPaAG5EvrvlFGbpMrH1Dc6hymufUdwV73M5dp7ZhtMXaMjSHHDS+jqpHaiMHxjBPi9Q3NIei4F4iU9V7mQ++MJ22gQeJinwY1WxIOL1LBTWd1C7wEDgvq/HYOoZ5elnaUVupjGNHR336P+CpGiwbRlsVHRlqujMNvOwANA2jbdPQ8IfqT/W7+kZ9ZLgy49PbmgZeZwqVWWX4ZYMrw2cBrgRvl/bT+jof3WOAtejZGvBjVhnnMj9rzijjOPPdyH8y64wnM3+inqlf1bt/AS4sDKSrOeACAAAAAElFTkSuQmCC"

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAwFBMVEWsxMT///+sxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMSsxMR9HQwYAAAAP3RSTlMAAAECAwQFBgcKKC41PT5DRkdNUlNbeYeLjZCSlJebnZ6go6SlrLi9wcXHycrMz9LU1tjZ29zg4uvs8/f7/P5OZnIXAAABG0lEQVQoz3XR13LCMBSE4SPAOPRgOqEZCODQe+d//7fKhZGRE7yX+ubM7GhFRETELg12d24b17GUGV8rR3T25b+c+sZM3w5x6odwxrbJ/u3Dq1cbM99dgysAjNIiIpKZAOAEbB8BvuJ+R7F6AOu45hLASKtI0gMoaB4Aj3SgorIALc07wBOD1QqYa74D9RB3gLNmgGqIa8BF8w1ohLgLnDRvgFmIt8BUswuQMTgH0NTsAEysgD+WAHnN1h6gl9S6A1jEgj8vA+BlRUQktwSgaCzW92dadWrd7XPSYeLF9ph/0S4iYruR7hdy1sH7ojg0/Fk4XmjNz5fTtJmPqYTh8jdKmf6ODX/LL3/P2tsR/PRrFPt+iGSVaF8Pn78YL06nmeTApwAAAABJRU5ErkJggg=="

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupListMemRequestCtrl, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	$ = __webpack_require__(1);
	
	GroupListMemRequestCtrl = function($scope, $translate, $filter, $location, GroupMemberService) {
	  var listRequestCtrl, pageSize, refeshPage;
	  pageSize = 4;
	  listRequestCtrl = this;
	  listRequestCtrl.listRequest = [];
	  listRequestCtrl.currentPage = 0;
	  listRequestCtrl.isLoading = false;
	  listRequestCtrl.noResults = true;
	  listRequestCtrl.totalPages = 0;
	  listRequestCtrl.loadMore = function() {
	    var params;
	    listRequestCtrl.isLoading = true;
	    listRequestCtrl.currentPage++;
	    params = {
	      id: $scope.groupDetail.id,
	      page_size: pageSize,
	      page: listRequestCtrl.currentPage,
	      status: 'pending'
	    };
	    return GroupMemberService.listMemRequest(params).then(function(data) {
	      listRequestCtrl.listRequest = _.union(listRequestCtrl.listRequest, data.members);
	      listRequestCtrl.totalPages = data.total_pages;
	      listRequestCtrl.noResults = listRequestCtrl.listRequest.length === 0;
	      return $scope.$emit('gnp.group.request.changed', data.total);
	    })["finally"](function() {
	      return listRequestCtrl.isLoading = false;
	    });
	  };
	  refeshPage = function() {
	    listRequestCtrl.listRequest = [];
	    listRequestCtrl.currentPage = 0;
	    listRequestCtrl.isLoading = false;
	    listRequestCtrl.noResults = true;
	    listRequestCtrl.totalPages = 0;
	    return listRequestCtrl.loadMore();
	  };
	  listRequestCtrl.hasMore = function() {
	    return listRequestCtrl.noResults === false && listRequestCtrl.currentPage < listRequestCtrl.totalPages;
	  };
	  listRequestCtrl.processRequest = function(request, status) {
	    var params;
	    params = {
	      id: request.group_entry_id,
	      status: status
	    };
	    return GroupMemberService.processMemRequest(params).then(function(resp) {
	      return refeshPage();
	    });
	  };
	  listRequestCtrl.displayUserName = function(fName, lName) {
	    fName = fName != null ? fName : '';
	    lName = lName != null ? lName : '';
	    if (fName + lName === '') {
	      return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED');
	    }
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      return lName + " " + fName;
	    }
	    return fName + " " + lName;
	  };
	  listRequestCtrl.displayNumberRequest = function(number) {
	    if (number > 0) {
	      return $filter('formatString')($filter('translate')('_GROUP_MEMBERS.NUMBER_REQUEST'), number);
	    }
	    return $filter('translate')('_GROUP_MEMBERS.NO_NEW_REQUEST');
	  };
	  $scope.getTextOfAvatar = function(member) {
	    var $avatarElement;
	    $avatarElement = $(".avatar-for-" + member.id + " .avatar-image-text:not(.is-small)");
	    if (member.display_text_avatar.length === 1) {
	      $avatarElement.removeClass('two-characters');
	      $avatarElement.addClass('one-character');
	    } else {
	      $avatarElement.removeClass('one-character');
	      $avatarElement.addClass('two-characters');
	    }
	    return member.display_text_avatar;
	  };
	  $scope.isAvatarColor = function(member) {
	    var ref;
	    return ((ref = member.avatar_image_path) != null ? ref.indexOf('avatar_color') : void 0) > -1;
	  };
	  listRequestCtrl.loadMore();
	  return listRequestCtrl;
	};
	
	GroupListMemRequestCtrl.$inject = ['$scope', '$translate', '$filter', '$location', 'GroupMemberService'];
	
	module.exports = GroupListMemRequestCtrl;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupListMembersPmCtrl, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	$ = __webpack_require__(1);
	
	GroupListMembersPmCtrl = function($scope, $translate, $filter, flash, $location, $route, GroupMemberService, $ngConfirm) {
	  var checkChangedPermission, listMemberCtrl, pageSize, refeshPage;
	  pageSize = 4;
	  listMemberCtrl = this;
	  listMemberCtrl.listMember = [];
	  listMemberCtrl.listMemberChanged = [];
	  listMemberCtrl.currentPage = 0;
	  listMemberCtrl.isLoading = false;
	  listMemberCtrl.isSubmitting = false;
	  listMemberCtrl.noResults = true;
	  listMemberCtrl.totalPages = 0;
	  listMemberCtrl.keyword = "";
	  listMemberCtrl.loadMore = function() {
	    var params;
	    listMemberCtrl.isLoading = true;
	    listMemberCtrl.currentPage++;
	    params = {
	      id: $scope.groupDetail.id,
	      page_size: pageSize,
	      page: listMemberCtrl.currentPage,
	      keyword: listMemberCtrl.keyword
	    };
	    return GroupMemberService.listMembers(params).then(function(data) {
	      listMemberCtrl.listMember = _.union(listMemberCtrl.listMember, data.members);
	      listMemberCtrl.totalPages = data.total_pages;
	      return listMemberCtrl.noResults = listMemberCtrl.listMember.length === 0;
	    })["finally"](function() {
	      return listMemberCtrl.isLoading = false;
	    });
	  };
	  listMemberCtrl.hasChanged = function() {
	    return listMemberCtrl.listMemberChanged.length > 0;
	  };
	  listMemberCtrl.hasMore = function() {
	    return listMemberCtrl.noResults === false && listMemberCtrl.currentPage < listMemberCtrl.totalPages;
	  };
	  listMemberCtrl.changeMembers = function() {
	    var params;
	    if (listMemberCtrl.listMemberChanged.length < 1) {
	      return;
	    }
	    listMemberCtrl.isSubmitting = true;
	    params = {
	      id: $scope.groupDetail.id,
	      group_entries: listMemberCtrl.listMemberChanged.map(function(item) {
	        var data;
	        data = {
	          group_entry_id: item.group_entry_id,
	          role: item.newPermission
	        };
	        return data;
	      })
	    };
	    return GroupMemberService.changeMembers(params).then(function(resp) {
	      listMemberCtrl.keyword = "";
	      return $route.reload();
	    })["catch"](function(resp) {
	      var ref;
	      if (((ref = resp.data) != null ? ref.code : void 0) === 'error.group_not_admin_error') {
	        return $ngConfirm($filter('translate')('_GROUP.TOOLBAR.NOT_ALLOWED_LEAVE_GROUP'));
	      } else {
	        return flash.error($filter('translate')('API_ERROR'));
	      }
	    })["finally"](function() {
	      return listMemberCtrl.isSubmitting = false;
	    });
	  };
	  listMemberCtrl.searchMember = function() {
	    return refeshPage();
	  };
	  $scope.$watch('listMemberCtrl.listMember', function() {
	    return checkChangedPermission();
	  }, true);
	  refeshPage = function() {
	    listMemberCtrl.listMember = [];
	    listMemberCtrl.currentPage = 0;
	    listMemberCtrl.isLoading = false;
	    listMemberCtrl.noResults = true;
	    listMemberCtrl.totalPages = 0;
	    return listMemberCtrl.loadMore();
	  };
	  checkChangedPermission = function() {
	    return listMemberCtrl.listMemberChanged = $filter('filter')(listMemberCtrl.listMember, function(item) {
	      return item.newPermission && item.newPermission !== '';
	    });
	  };
	  listMemberCtrl.loadMore();
	  return listMemberCtrl;
	};
	
	GroupListMembersPmCtrl.$inject = ['$scope', '$translate', '$filter', 'flash', '$location', '$route', 'GroupMemberService', '$ngConfirm'];
	
	module.exports = GroupListMembersPmCtrl;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupListMembersCtrl, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	$ = __webpack_require__(1);
	
	GroupListMembersCtrl = function($scope, $translate, groupInfo, userInfo, GroupMemberService) {
	  var pageSize;
	  angular.element(document.body).css('min-width', 0);
	  $(document).ready(function() {
	    return document.body.scrollTop = document.documentElement.scrollTop = 0;
	  });
	  $scope.groupInfo = groupInfo;
	  $scope.userInfo = userInfo;
	  pageSize = 10;
	  $scope.listMember = [];
	  $scope.currentPage = 0;
	  $scope.isLoading = false;
	  $scope.isSubmitting = false;
	  $scope.noResults = true;
	  $scope.totalPages = 0;
	  $scope.loadMore = function() {
	    var params;
	    $scope.isLoading = true;
	    $scope.currentPage++;
	    params = {
	      id: groupInfo.id,
	      page_size: pageSize,
	      page: $scope.currentPage
	    };
	    return GroupMemberService.listMembers(params).then(function(data) {
	      $scope.listMember = _.union($scope.listMember, data.members);
	      $scope.totalPages = data.total_pages;
	      return $scope.noResults = $scope.listMember.length === 0;
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  };
	  $scope.hasMore = function() {
	    return $scope.noResults === false && $scope.currentPage < $scope.totalPages;
	  };
	  return $scope.loadMore();
	};
	
	GroupListMembersCtrl.$inject = ['$scope', '$translate', 'groupInfo', 'userInfo', 'GroupMemberService'];
	
	module.exports = GroupListMembersCtrl;


/***/ }),
/* 779 */
/***/ (function(module, exports) {

	var GroupMemberService;
	
	GroupMemberService = function($http, $q) {
	  return {
	    listMemRequest: function(dParam) {
	      var defer, url;
	      defer = $q.defer();
	      url = "/api/groups/" + dParam.id + "/list_request.json";
	      $http.get(url, {
	        params: dParam
	      }).then(function(resp) {
	        return defer.resolve(resp.data);
	      });
	      return defer.promise;
	    },
	    processMemRequest: function(dParam) {
	      var url;
	      url = "/api/group_entries/" + dParam.id + ".json";
	      return $http.put(url, dParam);
	    },
	    listMembers: function(dParam) {
	      var defer, url;
	      defer = $q.defer();
	      url = "/api/groups/" + dParam.id + "/members.json";
	      $http.get(url, {
	        params: dParam
	      }).then(function(resp) {
	        return defer.resolve(resp.data);
	      });
	      return defer.promise;
	    },
	    changeMembers: function(dParam) {
	      var url;
	      url = "/api/groups/" + dParam.id + "/update_group_entries.json";
	      return $http.post(url, dParam);
	    }
	  };
	};
	
	GroupMemberService.$inject = ['$http', '$q'];
	
	module.exports = GroupMemberService;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupMemPermissionDirective, moment;
	
	__webpack_require__(781);
	
	moment = __webpack_require__(126);
	
	$ = __webpack_require__(1);
	
	GroupMemPermissionDirective = function($filter, $translate) {
	  return {
	    restrict: "EA",
	    replace: true,
	    templateUrl: "group-member/group-mem-permission-directive/index.jade",
	    scope: {
	      data: '=data',
	      permissionData: '=perData',
	      userid: '=userId'
	    },
	    link: function(scope) {
	      scope.displayName = function(fName, lName) {
	        fName = fName != null ? fName : '';
	        lName = lName != null ? lName : '';
	        if (fName + lName === '') {
	          return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED');
	        }
	        if (/^ja/i.test($translate.preferredLanguage())) {
	          return lName + " " + fName;
	        }
	        return fName + " " + lName;
	      };
	      scope.changePermission = function(data, permission) {
	        if (data.role === permission.value) {
	          data.newPermission = '';
	          return;
	        }
	        return data.newPermission = permission.value;
	      };
	      scope.displayStatus = function(data, stage) {
	        if (stage !== "") {
	          return data.newPermission === stage;
	        }
	        return data.newPermission && data.newPermission !== 'delete' && data.newPermission !== data.role;
	      };
	      scope.getTextOfAvatar = function() {
	        var $avatarElement;
	        $avatarElement = $(".avatar-for-" + scope.data.id + " .avatar-image-text:not(.is-small)");
	        if (scope.data.display_text_avatar.length === 1) {
	          $avatarElement.removeClass('two-characters');
	          $avatarElement.addClass('one-character');
	        } else {
	          $avatarElement.removeClass('one-character');
	          $avatarElement.addClass('two-characters');
	        }
	        return scope.data.display_text_avatar;
	      };
	      return scope.isAvatarColor = function() {
	        var ref;
	        return ((ref = scope.data.avatar_image_path) != null ? ref.indexOf('avatar_color') : void 0) > -1;
	      };
	    }
	  };
	};
	
	GroupMemPermissionDirective.$inject = ['$filter', '$translate'];
	
	module.exports = GroupMemPermissionDirective;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"group-mem-permission-directive\" class=\"col-12 col-md-6\"><div ng-class=\"{ delete : displayStatus(data , &quot;delete&quot;) , disable: data.id == userid } \" class=\"info-table\"><div ng-switch=\"data.gender\" ng-if=\"!data.avatar_image_path\" class=\"cell image-avatar\"><img ng-switch-when=\"female\" src=\"" + __webpack_require__(702) + "\" class=\"rounded-circle\"/><img ng-switch-default=\"ng-switch-default\" src=\"" + __webpack_require__(701) + "\" class=\"rounded-circle\"/></div><div ng-if=\"data.avatar_image_path\" class=\"cell image-avatar\"><div class=\"avatarContainer avatar-for-{{data.id}}\"><img ng-src=\"{{::data.avatar_image_path}}\" class=\"rounded-circle avatar-image is-full\"/><span ng-if=\"isAvatarColor()\" class=\"avatar-image-text\">{{:: getTextOfAvatar() }}</span></div></div><div class=\"cell description\">{{ displayName(data.first_name ,data.last_name) }}</div><div ng-if=\"displayStatus(data , &quot;&quot;)\" class=\"cell check-mark\"><img src=\"" + __webpack_require__(697) + "\" class=\"check-mark\"/></div><div class=\"cell commbo-button\"><div class=\"btn-group\"><button data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"btn btn-block dropdown-toggle\"><span class=\"title\">{{ (permissionData | filter: { value : data.newPermission ? data.newPermission : data.role })[0].name }}</span><span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in permissionData\"><a ng-click=\"changePermission(data , item)\">{{ item.name }}</a></li></ul></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("group-member/group-mem-permission-directive/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupMemberDirective, moment;
	
	__webpack_require__(783);
	
	moment = __webpack_require__(126);
	
	$ = __webpack_require__(1);
	
	GroupMemberDirective = function($filter, $translate) {
	  return {
	    restrict: "EA",
	    replace: true,
	    templateUrl: "group-member/group-mem-directive/index.jade",
	    scope: {
	      data: '=data',
	      userid: '=userId'
	    },
	    link: function(scope) {
	      scope.displayName = function(fName, lName) {
	        fName = fName != null ? fName : '';
	        lName = lName != null ? lName : '';
	        if (fName + lName === '') {
	          return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED');
	        }
	        if (/^ja/i.test($translate.preferredLanguage())) {
	          return lName + " " + fName;
	        }
	        return fName + " " + lName;
	      };
	      scope.displayTimeAgo = function(time) {
	        var timeAgo, timeAgoMess, timeAgoText;
	        if (time === void 0) {
	          return "";
	        }
	        if (/^ja/i.test($translate.preferredLanguage())) {
	          moment.locale('ja');
	        }
	        timeAgoMess = $filter('translate')('_GROUP_MEMBERS.TIME_AGO');
	        timeAgo = moment(time);
	        timeAgoText = timeAgo.fromNow();
	        return $filter('formatString')(timeAgoMess, timeAgoText);
	      };
	      scope.getTextOfAvatar = function() {
	        var $avatarElement;
	        $avatarElement = $(".avatar-for-" + scope.data.id + " .avatar-image-text:not(.is-small)");
	        if (scope.data.display_text_avatar.length === 1) {
	          $avatarElement.removeClass('two-characters');
	          $avatarElement.addClass('one-character');
	        } else {
	          $avatarElement.removeClass('one-character');
	          $avatarElement.addClass('two-characters');
	        }
	        return scope.data.display_text_avatar;
	      };
	      return scope.isAvatarColor = function() {
	        var ref;
	        return ((ref = scope.data.avatar_image_path) != null ? ref.indexOf('avatar_color') : void 0) > -1;
	      };
	    }
	  };
	};
	
	GroupMemberDirective.$inject = ['$filter', '$translate'];
	
	module.exports = GroupMemberDirective;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"group-mem-permission-directive\" class=\"col-12 col-md-6\"><div class=\"info-table\"><div ng-switch=\"data.gender\" ng-if=\"!data.avatar_image_path\" class=\"cell image-avatar\"><img ng-switch-when=\"female\" src=\"" + __webpack_require__(702) + "\" class=\"rounded-circle\"/><img ng-switch-default=\"ng-switch-default\" src=\"" + __webpack_require__(701) + "\" class=\"rounded-circle\"/></div><div ng-if=\"data.avatar_image_path\" class=\"cell image-avatar\"><div class=\"avatarContainer avatar-for-{{data.id}}\"><img ng-src=\"{{::data.avatar_image_path}}\" class=\"rounded-circle avatar-image is-full\"/><span ng-if=\"isAvatarColor()\" class=\"avatar-image-text\">{{:: getTextOfAvatar() }}</span></div></div><div class=\"cell description\"><div class=\"col-12 user-name\">{{ displayName(data.first_name ,data.last_name) }}</div><div class=\"col-12 join-date\"><span ng-if=\"data.role==&quot;admin&quot;\" class=\"admin\">{{:: '_GROUP_INFORMATION.GROUP_ADMIN_SMALL' | translate }}</span><span ng-class=\"{member: data.role==&quot;admin&quot;}\" class=\"date\">{{ displayTimeAgo(data.joined_date) }}</span></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("group-member/group-mem-directive/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	module.exports = {
	  '_GROUP_MEMBERS': {
	    'EDIT_MEMBER': 'Edit member',
	    'REQUEST': 'Request',
	    'CLOSE': 'Close',
	    'SEARCH_MEMBER': 'Search for members',
	    'MEMBER': 'Member',
	    'GROUP_ADMIN': 'Group Administrator',
	    'DONE': 'Done',
	    'APPROVAL': 'Approval',
	    'DELETE_REQUEST': 'Delete request',
	    'NO_NEW_REQUEST': 'No new requests',
	    'NUMBER_REQUEST': '{0} requests',
	    'ADMIN': 'Administrator',
	    'DELETE_MEMBER': 'Delete members',
	    'FINISH': 'Done',
	    'TIME_AGO': 'Participated about {0}.'
	  }
	};


/***/ }),
/* 785 */
/***/ (function(module, exports) {

	module.exports = {
	  '_GROUP_MEMBERS': {
	    'EDIT_MEMBER': 'メンバーの編集',
	    'REQUEST': 'リクエスト',
	    'CLOSE': '閉じる',
	    'SEARCH_MEMBER': 'メンバーを検索',
	    'MEMBER': 'メンバー',
	    'GROUP_ADMIN': '管理者',
	    'DONE': '完了',
	    'APPROVAL': '承認',
	    'DELETE_REQUEST': 'リクエストを削除',
	    'NO_NEW_REQUEST': '新しいリクエストはありません',
	    'NUMBER_REQUEST': 'リクエスト{0}件',
	    'ADMIN': '管理者',
	    'DELETE_MEMBER': 'メンバーを削除',
	    'FINISH': '完了',
	    'TIME_AGO': '約{0}に参加しました。'
	  }
	};


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	var GroupInfoEventsCtrl, GroupInfoHeaderCtrl, GroupInfoMembersCtrl, modules;
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(386);
	
	__webpack_require__(59);
	
	__webpack_require__(72);
	
	__webpack_require__(108);
	
	__webpack_require__(82);
	
	__webpack_require__(112);
	
	__webpack_require__(412);
	
	__webpack_require__(90);
	
	__webpack_require__(76);
	
	__webpack_require__(686);
	
	__webpack_require__(787);
	
	__webpack_require__(789);
	
	__webpack_require__(790);
	
	GroupInfoHeaderCtrl = __webpack_require__(791);
	
	GroupInfoMembersCtrl = __webpack_require__(792);
	
	GroupInfoEventsCtrl = __webpack_require__(793);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-common-wrapper', 'gnp-remote-api', 'gnp-form', 'gnp-flash', 'gnp-animate', 'gnp-error-handler', 'gnp-app-group-event'];
	
	angular.module('gnp-app-group-info', modules).config([
	  '$routeProvider', '$translateProvider', function($routeProvider, $translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(794)).translations('ja', __webpack_require__(795));
	  }
	]).controller('GroupInfoHeaderCtrl', GroupInfoHeaderCtrl).controller('GroupInfoMembersCtrl', GroupInfoMembersCtrl).controller('GroupInfoEventsCtrl', GroupInfoEventsCtrl);


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"group-info-header\" class=\"col-12\"><div class=\"col-12 row-header\"><div class=\"cell avatar\"><img ng-src=\"{{ groupInfo.avatar_url }}\" class=\"avatar\"/></div><div class=\"cell description\"><div class=\"col-12 name\"><div class=\"group-name\">{{ groupInfo.name }}</div><div class=\"group-member\"><span>{{ infoHeaderCtrl.displayMember(groupInfo.members) }}</span><span>{{ infoHeaderCtrl.displayPrivacy(groupInfo.public_status) }}</span></div></div><div class=\"col-12 content\"><p>{{ groupInfo.description }}</p></div><button ng-if=\"groupStatus.role==&quot;admin&quot;\" ng-click=\"infoHeaderCtrl.editGroup()\" class=\"d-none d-sm-block btn btn-edit\">{{ :: '_GROUP_INFORMATION.EDIT_GROUP' | translate }}</button></div></div><div ng-if=\"groupStatus.role==&quot;admin&quot;\" ng-click=\"infoHeaderCtrl.editGroup()\" class=\"col-12 d-block d-sm-none row-header last\"><div class=\"cell\">{{ :: '_GROUP_INFORMATION.EDIT_GROUP' | translate }}</div><img src=\"" + __webpack_require__(788) + "\" class=\"image-arrow\"/></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-info/header.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 788 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAA3CAMAAABad7jlAAAAt1BMVEXAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMCQPCuRAAAAPHRSTlMAAQIDBAUWIyQ7T1NVVldYXl9iY2RoaWtwcXN0dnl6fH5/gYSFiouNjpCSk5WWmZ65wczq9ff5+vv8/f4otRxBAAABBklEQVQ4y52VyXLCQAxEDYEQVrM7rIGwGrMGMNv8/3dxAEuXVnVV5jqvWpqR1PK8VH63D3Oefcqxc+5YNO8/3ev4FjB9A+eqAczfgLsbUb4SwD0MoitEXIJAZkE1QiGuHUPjLkiANSLVaKUgsRHCtXGUoRItHGWgr21AIN1XjQnW+NFMRzjT35sgY6wx0ijjDxwlFmKANeqq0cdE8yGZLvFrg6toRFijrdVfZyERXARZYY1vzXSWhkThLITR65VTAhyMYdgmwJEp/LEcav95BfsH8pO0FqyarB9YR7GeZF1N5oJOFplNOt3MH4jDUI8iLkd9skeclno1dXu6L+jG8Xyys9jWewJoJoIHWzoAiQAAAABJRU5ErkJggg=="

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"group-info-members\" class=\"col-12\"><div class=\"d-block d-sm-none\"><div ng-click=\"infoMemberCtrl.goToAllMembers()\" class=\"col-12 mems-row\"><div class=\"cell\">{{ '_GROUP_INFORMATION.NUM_MEMBERS' | translate | formatString:groupInfo.members }}</div><img src=\"" + __webpack_require__(788) + "\" class=\"image-arrow\"/></div><div ng-if=\"groupStatus.role==&quot;admin&quot;\" ng-click=\"infoMemberCtrl.goToListMember()\" class=\"col-12 mems-row\"><div class=\"cell\">{{ :: '_GROUP_INFORMATION.EDIT_MEMBER' | translate }}</div><img src=\"" + __webpack_require__(788) + "\" class=\"image-arrow\"/></div></div><div gnp-indicator=\"infoMemberCtrl.isLoading\" class=\"d-none d-sm-block\"><div class=\"col-12 mems-header\"><div class=\"cell\">{{ '_GROUP_INFORMATION.NUM_MEMBERS' | translate | formatString:groupInfo.members }}</div><button ng-if=\"groupStatus.role==&quot;admin&quot;\" ng-click=\"infoMemberCtrl.goToListMember()\" class=\"btn btn-edit\">{{ :: '_GROUP_INFORMATION.EDIT_MEMBER' | translate }}</button></div><div class=\"col-12 mems-list\"><div ng-switch=\"item.gender\" ng-if=\"!item.avatar_image_path\" ng-repeat=\"item in infoMemberCtrl.lsMembers\" class=\"item image-avatar\"><img ng-switch-when=\"female\" src=\"" + __webpack_require__(702) + "\" class=\"rounded-circle\"/><img ng-switch-default=\"ng-switch-default\" src=\"" + __webpack_require__(701) + "\" class=\"rounded-circle\"/><div class=\"title\"><span class=\"text\">{{ displayUserName(item.first_name , item.last_name) }}</span></div></div><div ng-if=\"item.avatar_image_path\" ng-repeat=\"item in infoMemberCtrl.lsMembers\" class=\"item image-avatar\"><div class=\"avatarContainer avatar-for-{{item.id}}\"><img ng-src=\"{{::item.avatar_image_path}}\" class=\"rounded-circle avatar-image is-full\"/><span ng-if=\"isAvatarColor(item)\" class=\"avatar-image-text\">{{:: getTextOfAvatar(item) }}</span></div><div class=\"title\"><span class=\"text\">{{ displayUserName(item.first_name , item.last_name) }}</span></div></div></div><div class=\"col-12 header-legend\"><div class=\"cell text\">{{ :: '_GROUP_INFORMATION.GROUP_ADMIN' | translate }}</div><div class=\"cell\"><div class=\"border-line\"></div></div></div><div class=\"col-12 admin-list\"><div ng-switch=\"item.gender\" ng-if=\"!item.avatar_image_path\" ng-repeat=\"item in infoMemberCtrl.lsAdmins\" class=\"item image-avatar\"><img ng-switch-when=\"female\" src=\"" + __webpack_require__(702) + "\" class=\"rounded-circle\"/><img ng-switch-default=\"ng-switch-default\" src=\"" + __webpack_require__(701) + "\" class=\"rounded-circle\"/><div class=\"title\"><span class=\"text\">{{ displayUserName(item.first_name , item.last_name) }}</span></div></div><div ng-if=\"item.avatar_image_path\" ng-repeat=\"item in infoMemberCtrl.lsAdmins\" class=\"item image-avatar\"><div class=\"avatarContainer avatar-for-{{item.id}}\"><img ng-src=\"{{::item.avatar_image_path}}\" class=\"rounded-circle avatar-image is-full\"/><span ng-if=\"isAvatarColor(item)\" class=\"avatar-image-text\">{{:: getTextOfAvatar(item) }}</span></div><div class=\"title\"><span class=\"text\">{{ displayUserName(item.first_name , item.last_name) }}</span></div></div></div><div class=\"col-12 btn-region\"><button ng-click=\"infoMemberCtrl.goToAllMembers()\" class=\"btn\">{{ :: '_GROUP_INFORMATION.ALL_MEMBERS' | translate }}</button></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-info/members.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"group-info-events\" class=\"col-12\"><div class=\"d-block d-sm-none\"><div ng-class=\"{member: groupStatus.role != &quot;admin&quot;}\" ng-click=\"infoEventsCtrl.gotoRankTab()\" class=\"col-12 mems-row\"><div class=\"cell\">{{ :: '_GROUP_INFORMATION.EVENT' | translate }}</div><img src=\"" + __webpack_require__(788) + "\" class=\"image-arrow\"/></div></div><div gnp-indicator=\"infoEventsCtrl.isLoading\" class=\"d-none d-sm-block\"><div class=\"col-12 mems-header\"><div class=\"cell\">{{ :: '_GROUP_INFORMATION.RECENT_EVENTS' | translate }}</div></div><div id=\"group-event-list\"><div ng-repeat=\"event in infoEventsCtrl.lsEvents\" ng-click=\"gotoEventRank(event.id)\" class=\"col-12 row-content\"><div class=\"imgContainer\"><img ng-src=\"{{ event.cover_url }}\" src=\"" + __webpack_require__(690) + "\" class=\"rounded-circle\"/></div><div class=\"titleContainer\"><span class=\"name\">{{ event.name }}</span><span class=\"time\">{{ infoEventsCtrl.displayPeriod(event.start_date, event.end_date) }}</span><span class=\"members\"><i>{{ infoEventsCtrl.displayParticipants(event.participant) }}</i><i>{{ infoEventsCtrl.displayNoParticipants(event.non_participant) }}</i></span></div></div></div><div class=\"col-12 btn-region\"><button ng-click=\"infoEventsCtrl.gotoRankTab()\" class=\"btn\">{{ :: '_GROUP_INFORMATION.ALL_EVENTS' | translate }}</button></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/group-info/events.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	var GroupInfoHeaderCtrl;
	
	GroupInfoHeaderCtrl = function($scope, $location, $filter) {
	  var infoHeaderCtrl;
	  infoHeaderCtrl = this;
	  infoHeaderCtrl.displayPrivacy = function(privacy) {
	    if (privacy) {
	      return $filter('translate')('_GROUP.LIST.PUBLIC_GROUP');
	    } else {
	      return $filter('translate')('_GROUP.LIST.PRIVATE_GROUP');
	    }
	  };
	  infoHeaderCtrl.displayMember = function(member) {
	    return ($filter('translate')('_GROUP.LIST.MEMBERS')) + ': ' + member + ($filter('translate')('_GROUP.LIST.MEMBERS_EXT'));
	  };
	  infoHeaderCtrl.editGroup = function() {
	    return $location.path('/groups/' + $scope.groupInfo.id + '/edit');
	  };
	  return infoHeaderCtrl;
	};
	
	GroupInfoHeaderCtrl.$inject = ['$scope', '$location', '$filter'];
	
	module.exports = GroupInfoHeaderCtrl;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var GroupInfoMembersCtrl, _;
	
	_ = __webpack_require__(87);
	
	GroupInfoMembersCtrl = function($scope, $location, GroupMemberService, $translate, $filter) {
	  var currentPage, infoMembersCtrl, loadMembers, pageSize;
	  $scope.displayUserName = function(fName, lName) {
	    fName = fName != null ? fName : '';
	    lName = lName != null ? lName : '';
	    if (fName + lName === '') {
	      return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED');
	    }
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      return lName + " " + fName;
	    }
	    return fName + " " + lName;
	  };
	  pageSize = 15;
	  currentPage = 1;
	  infoMembersCtrl = this;
	  infoMembersCtrl.isLoading = false;
	  infoMembersCtrl.lsMembers = [];
	  infoMembersCtrl.lsAdmins = [];
	  infoMembersCtrl.goToListMember = function() {
	    return $location.path("/groups/" + $scope.groupInfo.id + "/members/list-members");
	  };
	  infoMembersCtrl.goToAllMembers = function() {
	    return $location.path("/groups/" + $scope.groupInfo.id + "/members");
	  };
	  $scope.getTextOfAvatar = function(user) {
	    var $avatarElement;
	    $avatarElement = $(".avatar-for-" + user.id + " .avatar-image-text:not(.is-small)");
	    if (user.display_text_avatar.length === 1) {
	      $avatarElement.removeClass('two-characters');
	      $avatarElement.addClass('one-character');
	    } else {
	      $avatarElement.removeClass('one-character');
	      $avatarElement.addClass('two-characters');
	    }
	    return user.display_text_avatar;
	  };
	  $scope.isAvatarColor = function(user) {
	    var ref;
	    return ((ref = user.avatar_image_path) != null ? ref.indexOf('avatar_color') : void 0) > -1;
	  };
	  loadMembers = function(type) {
	    var params;
	    params = {
	      id: $scope.groupInfo.id,
	      page_size: pageSize,
	      page: currentPage,
	      role: type != null ? type : ""
	    };
	    infoMembersCtrl.isLoading = true;
	    return GroupMemberService.listMembers(params).then(function(data) {
	      if (type === 'admin') {
	        return infoMembersCtrl.lsAdmins = _.union(infoMembersCtrl.lsAdmins, data.members);
	      } else {
	        return infoMembersCtrl.lsMembers = _.union(infoMembersCtrl.lsMembers, data.members);
	      }
	    })["finally"](function() {
	      return infoMembersCtrl.isLoading = false;
	    });
	  };
	  loadMembers('member');
	  loadMembers('admin');
	  return infoMembersCtrl;
	};
	
	GroupInfoMembersCtrl.$inject = ['$scope', '$location', 'GroupMemberService', '$translate', '$filter'];
	
	module.exports = GroupInfoMembersCtrl;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	var GroupInfoEventsCtrl, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	GroupInfoEventsCtrl = function($scope, $translate, $filter, $location, groupEventService) {
	  var currentPage, infoEventsCtrl, loadEvents, pageSize;
	  infoEventsCtrl = this;
	  pageSize = 4;
	  currentPage = 1;
	  infoEventsCtrl.lsEvents = [];
	  infoEventsCtrl.isLoading = false;
	  infoEventsCtrl.displayPeriod = function(startTime, endTime) {
	    var reText;
	    reText = "";
	    if (!startTime && !endTime) {
	      return reText;
	    }
	    reText = $filter('translate')('_GROUP_EVENT.PERIOD_NAME');
	    reText += ": ";
	    reText += infoEventsCtrl.displayDateByLang(startTime);
	    reText += "~";
	    reText += infoEventsCtrl.displayDateByLang(endTime);
	    return reText;
	  };
	  infoEventsCtrl.displayDateByLang = function(time) {
	    var d, formatText;
	    if (!time) {
	      return "";
	    }
	    d = moment(time);
	    formatText = 'YYYY-MM-DD(ddd)';
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      formatText = 'LL(ddd)';
	      moment.locale('ja');
	    }
	    return d.format(formatText);
	  };
	  infoEventsCtrl.displayParticipants = function(number) {
	    var reText;
	    reText = $filter('translate')('_GROUP_EVENT.PARTICIPANTS');
	    reText += ': ';
	    reText += number;
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      reText += '人';
	    }
	    return reText;
	  };
	  infoEventsCtrl.displayNoParticipants = function(number) {
	    var reText;
	    reText = $filter('translate')('_GROUP_EVENT.NONPARTICIPANTS');
	    reText += ': ';
	    reText += number;
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      reText += '人';
	    }
	    return reText;
	  };
	  infoEventsCtrl.gotoRankTab = function() {
	    var url;
	    url = "/groups/" + $scope.groupInfo.id + "#rank";
	    return $location.url(url);
	  };
	  $scope.gotoEventRank = function(id) {
	    var url;
	    url = "/group-event/" + id + "/ranking";
	    return $location.url(url);
	  };
	  loadEvents = function() {
	    var params;
	    params = {
	      id: $scope.groupInfo.id,
	      page: currentPage,
	      page_size: pageSize
	    };
	    return groupEventService.listEvent(params).then(function(data) {
	      return infoEventsCtrl.lsEvents = _.union(infoEventsCtrl.lsEvents, data.events);
	    })["finally"](function() {
	      return infoEventsCtrl.isLoading = false;
	    });
	  };
	  loadEvents();
	  return infoEventsCtrl;
	};
	
	GroupInfoEventsCtrl.$inject = ['$scope', '$translate', '$filter', '$location', 'groupEventService'];
	
	module.exports = GroupInfoEventsCtrl;


/***/ }),
/* 794 */
/***/ (function(module, exports) {

	module.exports = {
	  '_GROUP_INFORMATION': {
	    'TITLE': "Group",
	    'EDIT_GROUP': 'Edit group information',
	    'NUM_MEMBERS': 'Member List({0})',
	    'EDIT_MEMBER': 'Edit member',
	    'EVENT': 'Event',
	    'LEAVE_GROUP': 'Leave group',
	    'RECENT_EVENTS': 'Recent events',
	    'GROUP_ADMIN': 'Group Administrator',
	    'GROUP_ADMIN_SMALL': 'Admin',
	    'ALL_MEMBERS': 'Check all members',
	    'ALL_EVENTS': 'Check event list'
	  }
	};


/***/ }),
/* 795 */
/***/ (function(module, exports) {

	module.exports = {
	  '_GROUP_INFORMATION': {
	    'TITLE': "Group",
	    'EDIT_GROUP': 'グループ情報を編集',
	    'NUM_MEMBERS': 'メンバー({0})',
	    'EDIT_MEMBER': 'メンバー編集',
	    'EVENT': 'イベント',
	    'LEAVE_GROUP': 'グループを退会',
	    'RECENT_EVENTS': '最近のイベント',
	    'GROUP_ADMIN': '管理者',
	    'GROUP_ADMIN_SMALL': '管理者',
	    'ALL_MEMBERS': 'メンバー全員を見る',
	    'ALL_EVENTS': 'イベント一覧を見る'
	  }
	};


/***/ }),
/* 796 */
/***/ (function(module, exports) {

	var v1="<button id=\"btnCopy\" type=\"button\" data-clipboard-text=\"Copy Me!\" style=\"width : 100px ; height: 100px; position: absolute; bottom: 0; right : 0; visibility:hidden\" class=\"btn btn-secondary\"></button><div id=\"group-list-page\" gnp-common-wrapper-b=\"\"><div id=\"top-page\"><div class=\"container-fluid\"><form ng-submit=\"searchGroup(keyTemp)\" class=\"row header\"><div class=\"col-12 col-md-10\"><div class=\"d-none d-sm-block\"><div class=\"input-group\"><input type=\"text\" ng-model=\"keyTemp\" placeholder=\"{{ :: '_GROUP.LIST.SEARCH_GROUP' | translate }}\" class=\"form-control inputSearch\"/><div class=\"input-group-append\"><button class=\"btn btn-primary btnSearch\"></button></div></div></div><div class=\"d-block d-sm-none\"><input type=\"submit\" tabindex=\"-1\" style=\"visibility: hidden;width: 0;height:  0;position:  absolute\"/><input type=\"text\" ng-model=\"keyTemp\" placeholder=\"{{ :: '_GROUP.LIST.SEARCH_GROUP' | translate }}\" class=\"form-control inputSearch\"/></div></div></form><div class=\"d-block d-sm-none row\"> <div class=\"col-12\"><button ng-click=\"goCreatePage()\" class=\"btn btn-secondary btnCreGroup\">{{ :: '_GROUP.LIST.CREATE_GROUP' | translate }}</button></div></div><div class=\"row content\"><div class=\"col-12 no-padding\"><div class=\"card\"><div class=\"card-header\"><h3 class=\"card-title\">{{ :: '_GROUP.LIST.LIST_GROUP' | translate }}</h3></div><div class=\"card-body\"><div class=\"container-fluid search-results\"><div class=\"row fetchData\"><div ng-repeat=\"group in groups\" class=\"col-12 col-md-6 colData\"><div ng-click=\"gotoGroup(group.id , $event)\" class=\"innerData\"><div class=\"cell image-avatar\"><img lazy-img=\"{{ group.avatar_url }}\" class=\"avatarGroup\"/></div><div class=\"cell description\"><div class=\"title\"><b>{{ group.name }}</b></div><div class=\"subTitle\"><div class=\"d-none d-sm-block\"><span>{{ displayMember(group.members) }}</span><span>{{ displayPrivacy(group.public_status) }}</span></div><div class=\"d-block d-sm-none\">{{ displayMember(group.members) + ' ' + displayPrivacy(group.public_status) }}</div></div></div><div ng-if=\"group.admin\" class=\"cell commbo-button\"><a ng-if=\"group.pending_members &gt; 0\" ng-click=\"goToListRequest(group.id , $event)\" class=\"d-none d-sm-block btn-link\">{{ '_GROUP_MEMBERS.NUMBER_REQUEST' | translate | formatString:group.pending_members }}</a><button ng-click=\"editGroup(group.id , $event)\" class=\"btn-group btn-Setting\">{{ :: '_GROUP.LIST.EDIT_GROUP' | translate }}</button><button data-clipboard-text=\"{{ dataURL(group.id) }}\" ng-click=\"copyFunc(group.id, $event)\" class=\"btn-group btn-Copy\">{{ :: '_GROUP.LIST.COPY_GROUP' | translate }}</button><a ng-if=\"group.pending_members &gt; 0\" ng-click=\"goToListRequest(group.id , $event)\" class=\"d-block d-sm-none btn-link\">{{ '_GROUP_MEMBERS.NUMBER_REQUEST' | translate | formatString:group.pending_members }}</a></div></div></div></div><div ng-show=\"hasMore()\" class=\"row loadMoreRegion\"><button ng-class=\"{ loading : isLoading }\" ng-click=\"loadMore()\" gnp-indicator=\"isLoading\" class=\"btn btn-primary btn-lg btn-loadMore\">{{:: 'SHOW_MORE' | translate }}</button></div></div></div></div></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/groups/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	var v1="<form id=\"group-registration-page\" gnp-common-wrapper-b=\"\" name=\"groupForm\" gnp-submit=\"submit(group)\" novalidate=\"\"><div id=\"top-page\" gnp-indicator=\"isSubmitting\"><div id=\"group-cover-container\"><img id=\"coverPhoto\" ng-src=\"{{ croppedCoverPhoto }}\" class=\"coverPhoto\"/><div class=\"container-fluid editCover\"><div class=\"row innerBottomShadow\"><div class=\"col-8 col-sm-12 infoRegion\"><span class=\"titleMenu\"><b>{{ group.name }}</b><br/><span>{{ group.description }}</span></span></div><div class=\"col-4 offset-8 btnCoverRegion\"><button type=\"button\" ng-class=\"{ btnOpacity : croppedCoverPhoto }\" ng-click=\"chooseCover()\" class=\"btn btn-primary btn-lg btn-block btnSelectCover\">{{ :: '_GROUP.EDIT.CHANGE_COVER' | translate }}</button></div></div></div></div><div id=\"group-content-container\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-12 col-sm-3\"><label class=\"d-block d-sm-none\">{{ :: '_GROUP.GROUP_ICON_TITLE' | translate }}</label><div class=\"avatarContainer\"><img id=\"avatar\" ng-src=\"{{ croppedAvatarPhoto }}\" class=\"avatar\"/><button type=\"button\" ng-class=\"{ btnOpacity : croppedAvatarPhoto }\" ng-click=\"chooseAvatar()\" class=\"btn btn-primary\">{{ :: '_GROUP.EDIT.CHANGE_ICON' | translate }}</button></div></div><div class=\"col-12 col-sm-9\"><div class=\"form-group\"><label for=\"txtInputName\">{{ :: '_GROUP.GROUP_NAME' | translate }}</label><input type=\"text\" name=\"groupName\" id=\"txtInputName\" placeholder=\"{{ :: '_GROUP.GROUP_NAME' | translate }}\" ng-model=\"group.name\" required=\"\" class=\"form-control\"/><div ng-show=\"groupForm.groupName.$invalid &amp;&amp; !groupForm.groupName.$pristine\" class=\"error\"><div ng-show=\"groupForm.groupName.$error.required\">{{ ::\"VALIDATION.REQUIRED\" | translate }}</div></div></div><div class=\"form-group\"><label>{{ :: '_GROUP.ABOUT_GROUP' | translate }}</label><textarea name=\"groupDes\" ng-model=\"group.description\" style=\"resize:none ; height:85px\" placeholder=\"{{ :: '_GROUP.ABOUT_GROUP_DETAIL' | translate }}\" class=\"form-control\"></textarea></div><div class=\"form-group\"><label>{{ :: '_GROUP.PRIVACY_SETTINGS' | translate }}</label><div class=\"radio d-block d-sm-none\"><label ng-repeat=\"policy in policyDatas\" class=\"labelPrivacy\"><input type=\"radio\" name=\"groupPrivacy\" ng-model=\"group.type\" ng-value=\"policy.type\" class=\"radioPrivacy\"/><span ng-class=\"policy.image\"></span><span class=\"titleMenu\"><b>{{ policy.name }}</b><br/>{{ policy.description }}</span></label></div><div class=\"btn-group d-none d-sm-block\"><button data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"btn btn-secondary dropdown-toggle\"><span class=\"{{ (policyDatas | filter:{type: group.type })[0].image }}\"></span><span class=\"titleMenu\"><b>{{ (policyDatas | filter:{type: group.type })[0].name }}</b><br/>{{ (policyDatas | filter:{type: group.type })[0].description }}</span><span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"policy in policyDatas\"><a href=\"#\" ng-click=\"choosePolicy(policy.type)\"><span ng-class=\"policy.image\"></span><span class=\"titleMenu\"><b>{{ policy.name }}</b><br/>{{ policy.description }}</span></a></li></ul></div></div><div class=\"row\"><div class=\"d-none d-sm-block col-sm-6\"></div><div class=\"col-12 col-sm-6\"><div class=\"row no-margin\"><div class=\"col-6\"><button type=\"button\" ng-click=\"btnCancelClick()\" class=\"btn btn-primary btn-lg btn-block btnCancel\">{{ :: '_GROUP.TITLE_CANCEL' | translate }}</button></div><div class=\"col-6\"><button type=\"submit\" gnp-submitting-button=\"isSubmitting\" class=\"btn btn-primary btn-lg btn-block btnCreate\">{{ :: '_GROUP.EDIT.TITLE_SAVE' | translate }}</button></div></div></div></div></div></div></div></div><div tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\" data-backdrop=\"static\" data-keyboard=\"false\" class=\"crop-image-modal modal fade\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row no-margin\"><div class=\"col-3\"><button type=\"button\" ng-click=\"cancelCropModal()\" class=\"float-left\">{{ :: '_GROUP.CROP.CANCEL' | translate }}</button></div><div class=\"col-6\"><div class=\"text-center modal-heading\">{{ :: '_GROUP.CROP.TITLE' | translate }}</div></div><div class=\"col-3\"><button type=\"button\" ng-click=\"submitCropModal()\" class=\"float-right\">{{ :: '_GROUP.CROP.DONE' | translate }}</button></div></div><div class=\"modal-body\"><div class=\"cropArea\"><ui-cropper image=\"coverPhoto\" result-image=\"$parent.croppedCoverPhoto\" result-blob=\"$parent.croppedCoverPhotoBlob\" area-type=\"rectangle\" result-image-size=\"{w: 970,h: 250}\" area-init-size=\"{w: 970,h: 250}\" aspect-ratio=\"0\"></ui-cropper></div></div></div></div></div></div><div tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myIconModalLabel\" aria-hidden=\"true\" data-backdrop=\"static\" data-keyboard=\"false\" class=\"crop-icon-modal modal fade\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row no-margin\"><div class=\"col-3\"><button type=\"button\" ng-click=\"cancelCropIconModal()\" class=\"float-left\">{{ :: '_GROUP.CROP.CANCEL' | translate }}</button></div><div class=\"col-6\"><div class=\"text-center modal-heading\">{{ :: '_GROUP.CROP.TITLE' | translate }}</div></div><div class=\"col-3\"><button type=\"button\" ng-click=\"submitCropIconModal()\" class=\"float-right\">{{ :: '_GROUP.CROP.DONE' | translate }}</button></div></div></div><div class=\"modal-body\"><div class=\"cropArea\"><ui-cropper image=\"avatarPhoto\" result-image=\"$parent.croppedAvatarPhoto\" result-blob=\"$parent.croppedAvatarPhotoBlob\" area-type=\"rectangle\" result-image-size=\"{w: 170,h: 170}\" area-min-size=\"170\" aspect-ratio=\"0\"></ui-cropper></div></div></div></div></div></div></form>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/groups/edit.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 798 */
/***/ (function(module, exports) {

	var v1="<form id=\"group-registration-page\" gnp-common-wrapper-b=\"\" name=\"groupForm\" gnp-submit=\"submit(group)\" novalidate=\"\"><div id=\"top-page\" gnp-indicator=\"isSubmitting\"><div id=\"group-cover-container\"><img id=\"coverPhoto\" ng-src=\"{{ croppedCoverPhoto }}\" class=\"coverPhoto\"/><div class=\"rowContainer innerBottomShadow\"><div id=\"centered\"><span ng-if=\"!croppedCoverPhoto\" class=\"title\">{{ :: '_GROUP.CUSTOMIZE_GROUP' | translate }}<br/>{{ :: '_GROUP.ADD_IMAGE' | translate }}</span><div class=\"row\"><br/></div><div class=\"row\"><div class=\"col-12\"><button type=\"button\" ng-class=\"{ btnOpacity : croppedCoverPhoto }\" ng-click=\"chooseCover()\" class=\"btn btn-primary btn-lg btn-block btnSelectCover\">{{ :: '_GROUP.SELECT_PHOTO' | translate }}<span class=\"caret\"></span></button></div></div></div></div></div><div id=\"group-content-container\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-12 col-sm-3\"><label class=\"d-block d-sm-none\">{{ :: '_GROUP.GROUP_ICON_TITLE' | translate }}</label><div class=\"avatarContainer\"><img id=\"avatar\" ng-src=\"{{ croppedAvatarPhoto }}\" class=\"avatar\"/><button type=\"button\" ng-class=\"{ btnOpacity : croppedAvatarPhoto }\" ng-click=\"chooseAvatar()\" class=\"btn btn-primary\">{{ :: '_GROUP.GROUP_ICON' | translate }}</button></div></div><div class=\"col-12 col-sm-9\"><div class=\"form-group\"><label for=\"txtInputName\">{{ :: '_GROUP.GROUP_NAME' | translate }}</label><input type=\"text\" name=\"groupName\" id=\"txtInputName\" placeholder=\"{{ :: '_GROUP.GROUP_NAME' | translate }}\" ng-model=\"group.name\" required=\"\" class=\"form-control\"/><div ng-show=\"groupForm.groupName.$invalid &amp;&amp; !groupForm.groupName.$pristine\" class=\"error\"><div ng-show=\"groupForm.groupName.$error.required\">{{ ::\"VALIDATION.REQUIRED\" | translate }}</div></div></div><div class=\"form-group\"><label>{{ :: '_GROUP.ABOUT_GROUP' | translate }}</label><textarea name=\"groupDes\" ng-model=\"group.description\" style=\"resize:none ; height:85px\" placeholder=\"{{ :: '_GROUP.ABOUT_GROUP_DETAIL' | translate }}\" class=\"form-control\"></textarea></div><div class=\"form-group\"><label>{{ :: '_GROUP.PRIVACY_SETTINGS' | translate }}</label><div class=\"radio d-block d-sm-none\"><label ng-repeat=\"policy in policyDatas\" class=\"labelPrivacy\"><input type=\"radio\" name=\"groupPrivacy\" ng-model=\"group.type\" ng-value=\"policy.type\" class=\"radioPrivacy\"/><span ng-class=\"policy.image\"></span><span class=\"titleMenu\"><b>{{ policy.name }}</b><br/>{{ policy.description }}</span></label></div><div class=\"btn-group d-none d-sm-block\"><button data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"btn btn-secondary dropdown-toggle\"><span class=\"{{ (policyDatas | filter:{type: group.type })[0].image }}\"></span><span class=\"titleMenu\"><b>{{ (policyDatas | filter:{type: group.type })[0].name }}</b><br/>{{ (policyDatas | filter:{type: group.type })[0].description }}</span><span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"policy in policyDatas\"><a href=\"#\" ng-click=\"choosePolicy(policy.type)\"><span ng-class=\"policy.image\"></span><span class=\"titleMenu\"><b>{{ policy.name }}</b><br/>{{ policy.description }}</span></a></li></ul></div></div><div class=\"row\"><div class=\"d-none d-sm-block col-sm-6\"></div><div class=\"col-12 col-sm-6\"><div class=\"row no-margin\"><div class=\"col-6\"><button type=\"button\" ng-click=\"btnCancelClick()\" class=\"btn btn-primary btn-lg btn-block btnCancel\">{{ :: '_GROUP.TITLE_CANCEL' | translate }}</button></div><div class=\"col-6\"><button type=\"submit\" gnp-submitting-button=\"isSubmitting\" class=\"btn btn-primary btn-lg btn-block btnCreate\">{{ :: '_GROUP.TITLE_CREATE' | translate }}</button></div></div></div></div></div></div></div></div><div tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\" data-backdrop=\"static\" data-keyboard=\"false\" class=\"crop-image-modal modal fade\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row no-margin\"><div class=\"col-3\"><button type=\"button\" ng-click=\"cancelCropModal()\" class=\"float-left\">{{ :: '_GROUP.CROP.CANCEL' | translate }}</button></div><div class=\"col-6\"><div class=\"text-center modal-heading\">{{ :: '_GROUP.CROP.TITLE' | translate }}</div></div><div class=\"col-3\"><button type=\"button\" ng-click=\"submitCropModal()\" class=\"float-right\">{{ :: '_GROUP.CROP.DONE' | translate }}</button></div></div></div><div class=\"modal-body\"><div class=\"cropArea\"><ui-cropper image=\"coverPhoto\" result-image=\"$parent.croppedCoverPhoto\" result-blob=\"$parent.croppedCoverPhotoBlob\" area-type=\"rectangle\" result-image-size=\"{w: 970,h: 250}\" area-init-size=\"{w: 970,h: 250}\"></ui-cropper></div></div></div></div></div><div tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\" data-backdrop=\"static\" data-keyboard=\"false\" class=\"crop-icon-modal modal fade\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row no-margin\"><div class=\"col-3\"><button type=\"button\" ng-click=\"cancelCropIconModal()\" class=\"float-left\">{{ :: '_GROUP.CROP.CANCEL' | translate }}</button></div><div class=\"col-6\"><div class=\"text-center modal-heading\">{{ :: '_GROUP.CROP.TITLE' | translate }}</div></div><div class=\"col-3\"><button type=\"button\" ng-click=\"submitCropIconModal()\" class=\"float-right\">{{ :: '_GROUP.CROP.DONE' | translate }}</button></div></div></div><div class=\"modal-body\"><div class=\"cropArea\"><ui-cropper image=\"avatarPhoto\" result-image=\"$parent.croppedAvatarPhoto\" result-blob=\"$parent.croppedAvatarPhotoBlob\" area-type=\"rectangle\" result-image-size=\"{w: 170,h: 170}\" area-min-size=\"170\" aspect-ratio=\"0\"></ui-cropper></div></div></div></div></div></div></form>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/groups/registration.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	var v1="<div id=\"group-detail-page\" gnp-common-wrapper-b=\"\"><div id=\"top-page\" gnp-indicator=\"isSubmitting\"><div id=\"group-cover-container\"><img ng-src=\"{{ groupDetail.cover_url }}\" class=\"coverPhoto\"/><div class=\"titleRegion\"><h3 class=\"card-title\">{{ groupDetail.name }}<br/><span>{{ displayPrivacy(groupDetail.public_status) }}</span></h3></div></div><div id=\"group-toolbar\"><img ng-src=\"{{ groupDetail.avatar_url }}\" class=\"avatar\"/><div ng-controller=\"GroupDetailToolbarCtrl as detailCtrl\" ng-include=\"'groups/group-detail-toolbar/toolbar.jade'\" class=\"toobar\"></div></div><div id=\"group-content-container\"><div class=\"container-fluid\"><ul id=\"groupTabs\" class=\"nav nav-tabs\"><li ng-class=\"{active: tab === 1}\"><a ng-click=\"gotoTimelineTab()\">{{ :: '_GROUP.DETAIL_TABS.TIMELINE' | translate }}</a></li><li ng-class=\"{active: tab === 3}\"><a ng-click=\"gotoRankTab()\">{{ :: '_GROUP.DETAIL_TABS.RANKING' | translate }}</a></li></ul><div class=\"tab-content\"><div id=\"timelineTab\" ng-if=\"tab === 1\"><div ng-controller=\"GroupTimelineCtrl as timelineCtrl\" ng-include=\"'web/group-timeline/index.jade'\" class=\"content\"></div></div><div id=\"rankTab\" ng-if=\"tab === 3\"><div ng-controller=\"GroupRankingCtrl as lstRankingCtrl\" ng-include=\"'web/group-ranking/index.jade'\" class=\"content\"></div></div></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/groups/detail.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div class=\"container-fluid\"><ul class=\"group-detail-toolbar\"><li ng-if=\"member || admin\" class=\"menu\"><div class=\"btn-group\"><button data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"btn btn-secondary dropdown-toggle\"><img src=\"" + __webpack_require__(801) + "\"/>{{ :: '_GROUP.TOOLBAR.JOINED' | translate }}<span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a ng-click=\"leaveGroup()\">{{ :: '_GROUP.TOOLBAR.LEAVE_GROUP' | translate }}</a></li></ul></div></li><li ng-if=\"!member &amp;&amp; !admin\" class=\"menu\"><a ng-click=\"requestGroup()\" ng-class=\"{disable : requestPending}\" class=\"subMenu\"><img src=\"" + __webpack_require__(802) + "\"/><span ng-if=\"!requestPending\">{{ :: '_GROUP.TOOLBAR.REQUEST' | translate }}</span><span ng-if=\"requestPending\">{{ :: '_GROUP.TOOLBAR.IN_REQUEST' | translate }}</span></a></li><li ng-if=\"admin\" class=\"menu\"><a ng-click=\"goToListMember()\" data-badge=\"{{ numBadge }}\" class=\"subMenu g-badge\"><img src=\"" + __webpack_require__(803) + "\"/><span>{{ :: '_GROUP.TOOLBAR.EDIT_MEMBER' | translate }}</span></a></li><li ng-if=\"admin\" class=\"menu\"><a ng-click=\"copyFunc()\" class=\"subMenu\"><img src=\"" + __webpack_require__(804) + "\"/><span>{{ :: '_GROUP.TOOLBAR.INVITATION' | translate }}</span></a></li><li class=\"menu\"><a ng-click=\"gotoInfoPage()\" class=\"subMenu\"><img src=\"" + __webpack_require__(805) + "\"/><span>{{ :: '_GROUP.TOOLBAR.INFORMATION' | translate }}</span></a></li></ul></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("groups/group-detail-toolbar/toolbar.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 801 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAzFBMVEVCQkL///9CQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkKFRYcVAAAAQ3RSTlMAAAEGCAkKCxETFhcYGhscICwvMzY3PEhLT1RVWV5qc3d5fX+AgoaQmZ6gpaeprMTHyMrMz+Dh5ufo6fHy9Pb3+v3+qgK+ZwAAALlJREFUKM/N0UcSgkAQheHuMaKoYE5gQhEDKiImVLTvfyeFYkGYA/hvpup9VTOLAUiEQcsrKFo0lQX7iEygWF7R37tvuwBkSJEE/yrZvdQQSE++UTq9msiBzI6GyIMVzZEHY9oyHvQ+xzxikYXQroZ7/XGuIAqeGsL91gr2svNs/K6RSAuh4z4HvyO7pz7GAGSHJsDWNIUEgGiRMaMNSwHkTaJDDtIAbGGJwIPIf/wB2Hoqw4cL8VLwC+cLKocABJ4QAAAAAElFTkSuQmCC"

/***/ }),
/* 802 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAFVBMVEUAAAD///9CQkJCQkJCQkJCQkJCQkJxi7Q8AAAABnRSTlMAADNEd7vHZvD3AAAALklEQVQY02NgwABmCQyMgoICdOMwGwOBWzKIVGBgS4ODAFTOgLgNDFQDkDhQAADYvRnTMiqM6wAAAABJRU5ErkJggg=="

/***/ }),
/* 803 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAMAAAANmfvwAAAB7FBMVEUAAABCQkL///9CQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkKceWn/AAAAo3RSTlMAAAABAgMEBQYHCAoLDA0ODxASExQVFhcYGRscHR8gISMpKywtMDE0NTY3Oz9AQUJHSElMTU5PUFFSU1RVVlhZXF9hZGprbG5vcnZ4eXp9foCBgoOGh4mLjI6QkZKWmJmbnZ6goaOkpamqq6yxsrO0tbu+v8DBw8TGycrMzs/Q0dLV1tfY2dvc3uDh4uTl5+jp6+zt7u/w8fL09fb3+Pr7/P3+r/1QTQAAAdFJREFUOMvV0Ps/U2EcB/DnsQ0jrCasi0sjIVYpk0SMdFFJ7rlUFFKrVEhiKpeRpbOJrWNz9vlHO7fnnA3/gM8v5/t5Xu/X83rOl5CjFarkVO9KJLz45IRcDPWf+aj3qU2aExJUUheCZ/jVMjiHWMxvsDXxYg6BizGkUliTKnX6+RJKn+F5mlgucX/zNHLM9/uMclthyGMsxDuDXCowopEGuNQn0XY4HqFYLR+3jYwMRy2MFKD9JUxq6UIOI+/9TNBUDA0iQy3SpJLRPTMjeeh04ZYyJ3uXtLfcRg0jd3DtOLdxWp67cVcjmTs/0xVh21xPodXYaLCYzo/hU5K+lybMnJW+9h+4Kq0nACnjabHbfQh+7P4D915Y+vsb32SB4EB2DLENcOJZ1NdhFVcAf095jtXe/AVbVYxY+sMIfBh/PRlE8HFKZx/b0nW/0KiQIi+mrsjrMtcuwJOrLYnmrkXKJHJhe9dlYIemVuFXvm7O8UuJhGb5/jloTG4Ki6l6a0M9oaOoo3G5hy69WCNviR3ueEGNX/mTepv+Q3pQso/QGrQkXnaqmQKZX90vqDnkroIWgYQnDhA6u5xcyW5xlhJ87zuQdU7n4up8OCRzceRo5T8gypmJIn9UywAAAABJRU5ErkJggg=="

/***/ }),
/* 804 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAABYlBMVEUAAABCQkL///9CQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkLvX3oEAAAAdXRSTlMAAAABAgMEBggJCgsODxAUFRcbICQmJykrLzEzNTY3OjtBQ0tPUFFUWFxdZmxucHV4eXp7foCChIWJiouNkJecnZ6foKKoqaqsra6ytba3uLvBwsPGx8nO0dPU1tfb3+Hi4+Tn6err7O3u7/Dy9PX2+Pr7/f5FCZKKAAABP0lEQVQoz53S2TdCURTH8fYuczIWQhkKZciQIbmKlCFTGSKEIlO46v7+fw/ndtXNU9/Xz1pnr73XMRjqjkTmxZSsZLftxBWpOJLDYzR8UcJ6Qw3avwpeExHZzrChR9OV7BAvNCXh1OEYguposipRHa7BXka6fNZhGBYNY2Bmtk5qGIBNw8QHM/MW2sroxkLZuorHzMwRWMrYfP/WI8wYg0uHNF7KDBERmSM4YKckSTfYlCSfeiGvjFO/L/SKeCuvQC2nYrv/QQHwGR8QS1TOXC7gO7m/e5gFjvqqsTeNtKeFiIgGdxR5uhL786WlRm1PRwbzzLPnJmY2kCVTnKC/uPMaU9r5QpihSuTu/HuHilYlYaxG9iCoYgCjpEPj3Yv4D4bUk0mPvIphgT8nVIMueATiVqppD3MCc/gvt8C6+wWQok4q0IEVHAAAAABJRU5ErkJggg=="

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAmVBMVEVCQkL///9CQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkKBiIxSAAAAMnRSTlMAAAMGBwwODxojJSgqMTQ7VmdobYCBgpCSl5qcoKGsrbO0wMPQ1NXW2eXm6O3v+Pv8/V/QekYAAADvSURBVCjPddLtVsIwDAbgFJAB+0ArRWVTVzamODbGe/8X50q6rhwlP/P0pGlSIo5IFQ3QFCoSHJwONVDnaZrXgA5HkG2XJXwkyS6tHGCLKqYhRFxhyyCxD0xq/vQ46UEEe0gDYVtd85MSeDMggqoNe9Ad11ni/fBzBRF3WlCEjIvPjsAHg8gQkYLth1Yvm7mFBIqK2uYfXj+fyYKoC2pyCwroHOQNIbUwlcdvBylGICpLH1ypG+hLuctvoL98bNcD0657oA/mgW4ki93ptFvwSC7aG+L6DJzX3hDd2O0+3Nj/LOprWNT91d7/DP99n18m8Bz229SZgwAAAABJRU5ErkJggg=="

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	var v1="<div id=\"group-list-page\" gnp-common-wrapper-b=\"\"><div id=\"top-page\"><div class=\"container-fluid\"><form ng-submit=\"searchGroup(keyword)\" class=\"row header\"><div class=\"col-12 col-md-10\"><div class=\"d-none d-sm-block\"><div class=\"input-group\"><input type=\"text\" ng-model=\"keyword\" placeholder=\"{{ :: '_GROUP.LIST.SEARCH_GROUP' | translate }}\" class=\"form-control inputSearch\"/><div class=\"input-group-append\"><button class=\"btn btn-secondary btnSearch\"></button></div></div></div><div class=\"d-block d-sm-none\"><input type=\"submit\" tabindex=\"-1\" style=\"visibility: hidden;width: 0;height:  0;position:  absolute\"/><input type=\"text\" ng-model=\"keyword\" placeholder=\"{{ :: '_GROUP.LIST.SEARCH_GROUP' | translate }}\" class=\"form-control inputSearch\"/></div></div><div class=\"d-none d-sm-block d-sm-none d-md-block col-md-2\"><button type=\"button\" ng-click=\"backJoinList()\" class=\"btn btn-block btnReturnList\">{{ :: '_GROUP.SEARCH.JOINED_GROUP_LIST' | translate }}</button></div></form><div class=\"d-block d-sm-none row\"><div class=\"col-12\"><button ng-click=\"goCreatePage()\" class=\"btn btn-secondary btnCreGroup\">{{ :: '_GROUP.LIST.CREATE_GROUP' | translate }}</button></div></div><div class=\"row content\"><div class=\"col-12 card search-panel no-padding\"><div class=\"card-header white\"><h3 class=\"card-title\">{{ :: '_GROUP.SEARCH.SEARCH_RESULTS' | translate }}</h3></div><div class=\"card-body\"><div class=\"container-fluid search-results\"><div class=\"row fetchData\"><group-search-item ng-repeat=\"group in groups\" data=\"group\" request-group=\"requestGroup(group)\" click-detail=\"gotoGroup(group.id)\"></group-search-item></div><div ng-show=\"hasMore()\" class=\"row loadMoreRegion\"><button ng-class=\"{ loading : isLoading }\" ng-click=\"loadMore()\" gnp-indicator=\"isLoading\" class=\"btn btn-primary btn-lg btn-loadMore\">{{:: 'SHOW_MORE' | translate }}</button></div><div ng-show=\"noResults\" class=\"row loadMoreRegion\"><h3 class=\"card-title\">{{ :: '_GROUP.NO_DATA' | translate }}</h3></div></div></div></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/groups/search.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"event-detail-page\" gnp-common-wrapper-b=\"\"><div id=\"top-page\" gnp-indicator=\"isSubmitting\"><div id=\"group-cover-container\"><img ng-src=\"{{ groupDetail.cover_url }}\" class=\"coverPhoto\"/><div class=\"titleRegion\"><span class=\"groupName\">{{ groupDetail.name }}</span><span class=\"eventPirod\">{{ displayPrivacy(groupDetail.public_status) }}</span></div></div><div id=\"group-members-page\" class=\"container-fluid\"><div class=\"row member-toolbar-wrap-content\"><div id=\"member-toolbar\" class=\"col-12 member-toolbar\"><div class=\"row no-margin\"><div class=\"col-4 title\"><button class=\"btn\">{{ displayTitle() }}</button></div><div class=\"col-8 nav-g-tabs\"><button ng-click=\"goToGroup()\" class=\"btn btnClose\"><img src=\"" + __webpack_require__(704) + "\"/>{{ :: '_GROUP_MEMBERS.CLOSE' | translate }}</button><button data-badge=\"{{ numBadge }}\" ng-click=\"goToListRequest()\" class=\"btn btnRequest g-badge\">{{ :: '_GROUP_MEMBERS.REQUEST' | translate }}</button><button ng-click=\"goToListMember()\" class=\"btn btnLstMembers\">{{ :: '_GROUP_MEMBERS.EDIT_MEMBER' | translate }}</button></div></div></div></div><div ng-switch=\"curPage\" class=\"row content-page\"><div id=\"list-request\" ng-switch-when=\"list-request\" class=\"col-12\"><div ng-controller=\"GroupListMemRequestCtrl as listRequestCtrl\" ng-include=\"'web/group-member/list-request.jade'\" class=\"row\"></div></div><div id=\"list-members\" ng-switch-default=\"ng-switch-default\" class=\"col-12\"><div ng-controller=\"GroupListMembersPmCtrl as listMemberCtrl\" ng-include=\"'web/group-member/index.jade'\" gnp-indicator=\"listMemberCtrl.isSubmitting\" class=\"row\"></div></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/groups/members.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	var v1="<div id=\"group-information-page\" gnp-common-wrapper-b=\"\"><div id=\"top-page\"><div class=\"container-fluid\"><div ng-controller=\"GroupInfoHeaderCtrl as infoHeaderCtrl\" ng-include=\"'web/group-info/header.jade'\" class=\"row\"></div><div ng-controller=\"GroupInfoMembersCtrl as infoMemberCtrl\" ng-include=\"'web/group-info/members.jade'\" class=\"row\"></div><div ng-controller=\"GroupInfoEventsCtrl as infoEventsCtrl\" ng-include=\"'web/group-info/events.jade'\" class=\"row\"></div><div ng-if=\"groupStatus.joined\" class=\"row leave-group-region\"><div class=\"d-none d-sm-block col-12 no-padding\"><div class=\"btn-region\"><button ng-click=\"leaveGroup()\" class=\"btn\">{{ :: '_GROUP_INFORMATION.LEAVE_GROUP' | translate }}</button></div></div><div class=\"d-block d-sm-none col-12 no-padding\"><div ng-click=\"leaveGroup()\" class=\"mems-row\"><div class=\"cell\">{{ :: '_GROUP_INFORMATION.LEAVE_GROUP' | translate }}</div></div></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/groups/info.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(810);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_registration.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_registration.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}", ""]);

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(812);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_list.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_list.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}#group-list-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:20px auto}#group-list-page #top-page .btnCreGroup{width:100%;background-repeat:no-repeat;background-position:left;background-image:url("+__webpack_require__(813)+");background-color:#1badac;background-size:20px 20px;background-position-x:10px;padding-left:40px;text-align:left;color:#fff;border-color:#1badac}@media (max-width:970px){#group-list-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-list-page #top-page{background-color:#e5e5e5}}#group-list-page .row.header{padding-top:10px;padding-bottom:10px}#group-list-page .row.header .btnSearch{height:34px;width:70px;background-repeat:no-repeat;background-position:center;background-image:url("+__webpack_require__(774)+");background-color:#1badac;background-size:20px 20px;border-color:#1badac}#group-list-page .row.header .inputSearch{border-color:#1badac;border-width:2px;height:34px;font-size:14px}@media (max-width:414px){#group-list-page .row.header .inputSearch{border:none;border-radius:17px;border-color:#1badac;border-width:1px;border-style:solid}#group-list-page .row.header .inputSearch::-webkit-input-placeholder{text-align:center;transition-duration:.4s;background-image:url("+__webpack_require__(775)+");background-size:15px 15px;background-position:center;background-position-x:calc(50% - 60px);background-repeat:no-repeat}#group-list-page .row.header input.inputSearch:focus::-webkit-input-placeholder{transform:translateX(calc(0 - (50% - 80px)))}}#group-list-page .row.content{padding-top:10px;padding-bottom:10px}#group-list-page .row.content .card{border:none;border-radius:0;box-shadow:none}#group-list-page .row.content .card-header{border-radius:0;color:#fff;background-color:#555;padding:10px 15px;font-size:12px}#group-list-page .row.content .card-header .card-title{font-size:16px;line-height:normal}#group-list-page .row.content .row.fetchData{transition-duration:.1s}#group-list-page .row.content .row.loadMoreRegion{padding:10px;text-align:center;display:block}#group-list-page .row.content .row.loadMoreRegion .btn-loadMore{position:relative;margin:0 auto;color:#fff;width:220px;background-color:#555}#group-list-page .row.content .row.loadMoreRegion .btn-loadMore.loading{color:transparent}@media (max-width:414px){#group-list-page .row.content{margin-left:0;margin-right:0}#group-list-page .row.content .card-body,#group-list-page .row.content .container-fluid.search-results{padding:0}#group-list-page .row.content .row.fetchData{margin-left:0;margin-right:0}}#group-list-page .colData{height:140px;padding:5px}@media (max-width:414px){#group-list-page .colData{padding:0;height:100px}}#group-list-page .innerData{border:4px solid #1badac;height:130px;max-height:130px;display:table;table-layout:fixed;width:100%}#group-list-page .innerData:hover{cursor:pointer;opacity:.8}#group-list-page .innerData .cell{display:table-cell;vertical-align:middle}#group-list-page .innerData .cell.image-avatar{width:120px;text-align:center}#group-list-page .innerData .cell.image-avatar img{width:110px;height:110px;position:relative;border-radius:4px;background-repeat:no-repeat;background-image:url("+__webpack_require__(814)+");background-size:80px 80px;background-position:center;background-color:#acc4c4;object-fit:cover}#group-list-page .innerData .cell.description .title{padding:5px;height:50%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-wrap:wrap;flex-wrap:wrap;line-height:20px}#group-list-page .innerData .cell.description .title b{text-overflow:ellipsis;overflow:hidden;font-size:17px;max-width:100%;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-wrap:break-word}#group-list-page .innerData .cell.description .subTitle{padding:5px;height:50%;font-size:12px}#group-list-page .innerData .cell.description .subTitle .d-sm-block>span{display:block}#group-list-page .innerData .cell.commbo-button{width:170px;padding:5px;vertical-align:bottom}#group-list-page .innerData .cell.commbo-button .btn-link{display:block;text-align:center;color:#be4b50;margin-bottom:5px}#group-list-page .innerData .cell.commbo-button .btn-group{color:#fff;background-color:#1badac;width:100%;height:25px;border-radius:5px;border-color:#1badac;border-width:2px;border-style:solid;font-size:10px;text-align:center}#group-list-page .innerData .cell.commbo-button .btn-group+.btn-group{margin-top:5px}#group-list-page .innerData .cell.commbo-button .btn-Setting{background-image:url("+__webpack_require__(715)+");background-repeat:no-repeat;background-size:15px 15px;background-position:left;background-position-x:5px;padding-left:30px}@media (max-width:414px){#group-list-page .innerData{border:1px solid #555;border-top:none;height:100px}#group-list-page .innerData .cell.image-avatar{width:100px}#group-list-page .innerData .cell.image-avatar img{width:90px;height:90px}#group-list-page .innerData .cell.description{display:block}#group-list-page .innerData .cell.description .title>b{-webkit-line-clamp:1}#group-list-page .innerData .cell.commbo-button{display:block;position:absolute;bottom:5px;left:100px;width:calc(100% - 100px);padding:0}#group-list-page .innerData .cell.commbo-button>*{display:inline-block}#group-list-page .innerData .cell.commbo-button .d-block.d-sm-none.btn-link{display:inline-block!important}#group-list-page .innerData .cell.commbo-button .btn-group+.btn-link,#group-list-page .innerData .cell.commbo-button .btn-group+.btn-group{margin-top:0;margin-left:5px}#group-list-page .innerData .cell.commbo-button .btn-Setting{width:40px;background-position:center;color:transparent}#group-list-page .innerData .cell.commbo-button .btn-Copy{width:auto;font-size:8px}}@media (max-width:991px){#group-list-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-list-page #main-main .container,#group-list-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-list-page #gnp-header .btn-section,#group-list-page #gnp-header .user{display:none}#group-list-page #gnp-footer .copyright{text-align:left;margin-top:0}}", ""]);

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAMAAAANxBKoAAAAolBMVEX///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8braxPubh0xcSh1tWu29u74ODT6+vq9fX////FYvZXAAAALXRSTlMAAQggIyQlJiorQkdISVVrbIGCg4eIn6Kmp8bHzs/d3uDh5OXm8PHy+Pn7/P1BVUarAAABRklEQVRIx6WV63KCMBCFt4oXrLVIK1q8VZQIVsWq+/6v1oARSQp0d3p+ZZJvMpnd7DkAhrqONw1CDIOp53ShVk13gUUt3GYl2xrv0NRu3CplG8MIyxS5jd9we45VmrdN+FlgtURfhwcx1ikeFOFePSzxXuHNoXZ0SlKdtL2wk1djpl+UHFIl+ubsXpkhEmh0VVMiEh3d2jRBEo2TFLa+iPTekvQ7EmkcSfqTTK8AbCTTaMMrg3bAU6vrd65jRh8fG1fFeOCr1eVQrYtifFgz6AAEgxaADBpZd29Z717nNaHU28/rTaE9cFi95P0TWNH/4BPAiPW/rT1ndshz+cGaeeWdLol+u3uVYcbnbATOhi3nLt4J8S89fJDpsUz/BujXZcP25V+5IyvjlmdaXJZpzLy8ZfFSY5c1WZzJljm/ESg2Mudt8/AHbzY52kRI6RAAAAAASUVORK5CYII="

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(816);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_detail.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_detail.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}#group-detail-page{background-color:#e5e5e5}#group-detail-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-detail-page .btnOpacity:hover{opacity:1}#group-detail-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-detail-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-detail-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-detail-page #top-page{background-color:#e5e5e5}}#group-detail-page #group-cover-container{width:100%;height:250px;background-image:url("+__webpack_require__(718)+");background-repeat:repeat;position:relative}#group-detail-page #group-cover-container img.coverPhoto{margin:0;width:100%;height:250px;object-fit:cover;border-color:#000;image-orientation:from-image}@media (max-width:414px){#group-detail-page #group-cover-container,#group-detail-page #group-cover-container img.coverPhoto{height:172px}}#group-detail-page #group-cover-container .titleRegion{width:calc(100% - 140px - 20px);left:160px;bottom:10px;position:absolute}@media (max-width:414px){#group-detail-page #group-cover-container .titleRegion{width:calc(100% - 90px - 20px);left:110px}}#group-detail-page #group-cover-container .titleRegion h3.card-title{max-width:100%;max-height:160px;color:#fff;text-overflow:ellipsis;word-wrap:break-word;overflow:hidden;font-size:25px}#group-detail-page #group-cover-container .titleRegion h3.card-title>span{font-size:15px}#group-detail-page #group-toolbar{width:100%;height:50px;background-color:#fff;border-bottom:1px solid #e6e6e6;border-left:1px solid #e6e6e6}#group-detail-page #group-toolbar .container-fluid{padding:0}#group-detail-page #group-toolbar img.avatar{background-color:#acc4c4;background-image:url("+__webpack_require__(817)+");background-repeat:no-repeat;background-position:center;background-size:120px;width:140px;height:140px;position:absolute;margin-left:10px;margin-top:calc(25px - 140px);object-fit:cover;border:1px solid;border-radius:4px}@media (max-width:414px){#group-detail-page #group-toolbar img.avatar{width:90px;height:90px;background-size:70px;margin-top:calc(25px - 85px)}}#group-detail-page #group-toolbar .toobar{position:relative;float:right;width:calc(100% - 140px - 20px);height:100%;display:-ms-flexbox;display:flex}@media (max-width:414px){#group-detail-page #group-toolbar .toobar{width:calc(100% - 90px - 20px)}}#group-detail-page #group-toolbar ul.group-detail-toolbar{padding:0}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu{float:left;text-align:center;list-style:none;height:50px;padding:2px;border:1px solid #e6e6e6;border-right:none;border-bottom:none}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu a.subMenu{height:100%;width:100%;color:#000;background-color:transparent;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;cursor:pointer}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu a.subMenu img{width:25px;height:25px;margin-right:5px}@media (max-width:414px){#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu a.subMenu{font-size:10px;-ms-flex-direction:column;flex-direction:column}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu a.subMenu img{width:19px;height:19px;margin-right:0}}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu a.subMenu.disable{pointer-events:none;cursor:default;text-decoration:none;background-color:#e5e5e5}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu a.subMenu.disable *{opacity:.5}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu a.subMenu:hover{background-color:#e6e6e6}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu a{text-decoration:none}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu .btn-group{width:100%;height:100%}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu .btn-group ul.dropdown-menu{min-width:100%}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu .btn-group button{width:100%;height:100%;border:none;border-radius:0;padding:0;word-wrap:break-word;white-space:normal;background-color:transparent;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu .btn-group button img{width:25px;height:25px;margin-right:5px}@media (max-width:414px){#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu .btn-group button{font-size:10px;-ms-flex-direction:column;flex-direction:column}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu .btn-group button img{width:19px;height:19px;margin-right:0}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu .btn-group button .caret{position:absolute;right:4px}}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu:last-child{border-right:1px solid #e6e6e6}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu:first-child:nth-last-child(1){width:100%}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu:first-child:nth-last-child(2),#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu:first-child:nth-last-child(2)~li.menu{width:50%}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu:first-child:nth-last-child(3),#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu:first-child:nth-last-child(3)~li.menu{width:33.3333%}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu:first-child:nth-last-child(4),#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu:first-child:nth-last-child(4)~li.menu{width:25%}#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu:first-child:nth-last-child(5),#group-detail-page #group-toolbar ul.group-detail-toolbar li.menu:first-child:nth-last-child(5)~li.menu{width:20%}#group-detail-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-detail-page #group-content-container .nav-tabs{border-bottom:none}#group-detail-page #group-content-container .nav-tabs>li{width:calc(100%/2);background-color:transparent;height:40px}@media (max-width:320px){#group-detail-page #group-content-container .nav-tabs>li{font-size:10px}}#group-detail-page #group-content-container .nav-tabs>li:last-child a{margin-right:0}#group-detail-page #group-content-container .nav-tabs>li.active>a:hover,#group-detail-page #group-content-container .nav-tabs>li.active>a:focus,#group-detail-page #group-content-container .nav-tabs>li.active>a{color:#fff;border:1px solid transparent;background-color:#1badac;text-decoration:none;height:40px;margin-top:0}#group-detail-page #group-content-container .nav-tabs>li>a{background-color:#ccc;color:gray;text-align:center;height:35px;margin-top:5px;cursor:pointer;display:block}#group-detail-page #group-content-container #groupTabs.sticky{position:fixed;z-index:99;top:72px;background-color:#e5e5e5;width:940px}@media (max-width:970px){#group-detail-page #group-content-container #groupTabs.sticky{width:calc(100% - 30px)}}@media (max-width:767px){#group-detail-page #group-content-container #groupTabs.sticky{top:149px}}#group-detail-page #group-content-container .tab-content{border:4px solid #1badac;background-color:#fff}@media (max-width:414px){#group-detail-page #group-content-container .tab-content{border:1px solid transparent}}@media (max-width:991px){#group-detail-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-detail-page #main-main .container,#group-detail-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-detail-page #gnp-header .btn-section,#group-detail-page #gnp-header .user{display:none}#group-detail-page #gnp-footer .copyright{text-align:left;margin-top:0}}", ""]);

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKUAAAClCAMAAAAK9c3oAAAAzFBMVEWpwcGsxMStxMStxcWuxcWuxsavxsawx8exx8exyMiyyMizycm0ysq1ysq1y8u2y8u3zMy4zc25zc26zs67zs67z8+8z8+80NC90NC+0NC+0dG/0dG/0tLA0tLB09PC1NTD1NTE1dXF1tbG1tbG19fH19fI2NjJ2NjK2dnL2trM2trM29vN29vO3NzP3d3Q3d3Q3t7R3t7R39/S39/T4ODU4ODU4eHV4eHW4uLX4uLX4+PY4+PZ5OTa5OTa5eXb5eXb5ubc5ubd5+fe5+f3cEP0AAAFfklEQVR42u2a21biShCGLQIJG8MAMgPoyFFkyzhkVFCUo0m//zvtC0Uh6UNVEneYtaqum/4/knR11199cgJ/QfwVkEzJlEzJlEzJlEzJlEzJlEzJlEzJlEzJlEzJlEzJlEx5PJRuezxd+UL4q+m47R4lpTtcioNYDt1jo6x6QhJe9ZgoSxOhiEnpaCjbvlCG3z4Oyvyt0MZt/ggo7akwxNTOnNKeC2PM7Ywp81OBiGk+W8pbgYrbTCnbAhntDClLPpbSL2VHORHomGRGWRWEqGZF6VEovYwoTwUpTrOhHNIoh9lQLmmUyy+jdL7Vat+cVF648pXrNMyUxY63eZt+43WKCTK6JrObNEyUVS/YVwiix+4xlXJM19BTyg7fk38Ox0yplFO6hpaysZWpbBsHg1ZUyhVdQ0fZV+n090f5VEqfrqGhvFILXe0NE+Sga6gpOzqhTjqUWA0lZSXQzRBU0njjaA0VpfWsl3q2diPXVMo1XUNF2TNp9ZJnIryGgrKwMc2wKSTN6gQNBWXHLNbBD439w46ecmaeYbYz2aiULl1DTulg1Jx4m88qjoaUsoWZofU++JpGeR1HQ0p5hZlhtzmUaZTlOBpSyt+YGX7vRt9RIO/iacgo7zEz3O9G1yiUtXgaMkpUpn6IU+p+FroP9LNoomcJp3gH5hTSe5YoS2XPTOliKbvxNaKU15SUQnCKJkk0IpQXmBku9q3gJ8wvnuwkGhHKEmaGA5PPWZh/sHCSaUT2cYxLHiqpjU/zqZhUI0zZJS2Et5duyEeenVgjTGkbc4sfbTj0NAVC0Iu2NcgaJ2QjTWaducoceO/GMeuGpoqiYHDSlgWpz1CXHhpndelgska0hqzr67u60li6CZkV2xulSU3VkNTjA90MA41/l6v2J3NfCCH8+aRfzWmGEjVk3saYYJtFw7JtyzyKpiH1if5VTTBK75IDSeOE0PBOpdUdS0PhX7qSg+bUdA3DOeuOJg/z+Xz+MBl1zxzTRQ+8htILboRSy6yhJ2yNIxv6YtzSt5zRGhpfvTx8fE8YweOwrF0wLU+xnfheS7uUkBr6HoVVrjeb9bJ+zTp9ra+17juJNZLfNbgy78qDrO8aXKL8wfXPr6PMuY3uYDQadH+4in2khKq0hBDivqTS+PGm0XBzMSiLXe/1U+TV60i+rtYrvtJ9bUm+6M6hRrdIo6x5kfNA4NVCj2FEc2BGObqGjrKq8O6m+4a3/YfqDP7ZX0QVhUExq+IobfVJILj5OPnZM0GO2Qdm4UZ9dhvbmB6F9oi6eH+cmMtOkqLrHaCiLTyX5h7FeWBIfk0AgPxMxIpZHgCgaUixwTkkrSF9h3b5JWpyOGZ3SV9DXuKM+YGIHQOc/X+poawH5oUKAGdBfMrgDADM6eGw9jmgLG3N77sE4KxEglg5qDtd25KKEuGx9gHgl0gUv3R9Z7nPekK7iPFiEX1qhXdtvZiHtaWU9sb8ywucGWW2qhD24MaWUSLewiKHtB/1cQ6QW+C+rjBlHvEofwLAS3LKF1zO2+SjlJh3YAE0RArRALCQ31eIEtFiGmE7DJgOBOLcdxehLCAytRvj2pg8TlEt4aAQpvyOW5v9dCj7uFzxPUyJ6G8M00hDn38YcTHyOkyJaNZVkP0FZA+igm8LflA+m7fwXIx7gpqNJWfezJ/DlFvUihunRTlGZZVtmNK8xAeoJ46MZ9QpNQhTmiduAlhBWpSBBdA0D6NTlmNce9Hm3vJXUBYA6ulR1gEKX0C5hhSX+NvpcZ0+5Qvmgho+eqjjFZnyMVntKMsYj2TKB1OM0qccGUVjuawpU36RF8yUTMmUKfZ7/pdgSqZkSqZkSqZkSqZkSqZkSqZkSqZkSqZkSqZkSqY81vgPue1hbXu+tIMAAAAASUVORK5CYII="

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(819);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_search_item.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_search_item.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}#group-list-page .row.content .card-header.white{border-bottom:2px solid #555;background-color:#fff;color:#555}#group-list-page .btnReturnList{background-color:#555;color:#fff}#search-item{display:table;table-layout:fixed;min-height:120px;border:4px solid #1badac;padding-left:0;padding-right:0}#search-item .cell{display:table-cell}#search-item .cell.avatar{width:110px;vertical-align:top}#search-item .cell.avatar img.avatarGroup{width:100px;position:relative;border-radius:4px;height:100px;margin-top:5px;margin-left:5px;background-repeat:no-repeat;background-image:url("+__webpack_require__(814)+");background-size:80px 80px;background-position:center;background-color:#acc4c4;object-fit:cover}#search-item .cell.avatar img.avatarGroup:hover,#search-item .cell.description:hover{cursor:pointer;opacity:.8}#search-item .cell.description p{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;font-size:12px}#search-item .cell.description .group-name{width:100%;font-size:17px;font-weight:700;overflow:hidden;text-overflow:ellipsis;line-height:20px;padding-top:10px;padding-bottom:5px}#search-item .cell.description .group-member{width:100%;font-size:12px;padding-bottom:5px;color:#555;overflow:hidden;text-overflow:ellipsis}#search-item .cell.description .btnRegion{position:absolute;width:120px;height:30px;top:10px;right:5px}#search-item .cell.description .btnRegion .btnRequest{width:120px;height:30px;background-color:#1badac;border:1px solid #1badac;border-radius:4px;color:#fff}#search-item .cell.description .btnRegion .btnRequest img{width:15px}#search-item .cell.description .btnRegion .btnRequest span{margin-left:5px}#search-item .cell.description .btnRegion .btnRequest.active{pointer-events:none;cursor:default;background-color:#e5e5e5;color:#acc4c4}#search-item .cell.description .btnRegion .mbRequest{width:45px;text-align:center;top:0;bottom:0;vertical-align:middle;height:100px;color:#1badac;cursor:pointer;pointer-events:inherit}#search-item .cell.description .btnRegion .mbRequest.active{pointer-events:none;cursor:default}#search-item .cell.description .btnRegion .mbRequest button>img{width:20px}#search-item .cell.description .btnRegion .mbRequest button{background:#fff;border:none}@media (max-width:767px){#search-item .cell.description .btnRegion{top:0;height:100%;text-align:center;width:45px;right:5px}#search-item .cell.description .btnRegion .mbRequest{display:table-cell!important}}@media (max-width:414px){#search-item{border:1px solid #555;border-top:none;height:100px;min-height:100px;max-height:100px}#search-item .cell.description .group-name,#search-item .cell.description .group-member{width:calc(100% - 45px)}#search-item .cell.description .footer>p{width:calc(100% - 45px);line-height:1.4em;max-height:4.2em}#search-item .cell.avatar{width:100px}#search-item .cell.avatar img.avatarGroup{width:90px;height:90px}}@media (max-width:320px){#search-item{height:80px;min-height:80px;max-height:80px}#search-item .cell.description .group-name,#search-item .cell.description .group-member{font-size:11px}#search-item .cell.description .footer>p{font-size:9px}#search-item .cell.description .btnRegion .mbRequest{height:80px}#search-item .cell.avatar{width:80px}#search-item .cell.avatar img.avatarGroup{width:70px;height:70px;background-size:50px 50px}}#search-item+#search-item{margin-top:10px}@media (max-width:414px){#search-item+#search-item{margin-top:0}}", ""]);

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(821);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_members_detail.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_members_detail.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}#group-members-page .member-toolbar{padding:10px;background-color:#fff;border:1px solid #e5e5e5}#group-members-page .member-toolbar.sticky{position:fixed;z-index:99;top:72px;width:970px}@media (max-width:970px){#group-members-page .member-toolbar.sticky{width:100%}}@media (max-width:767px){#group-members-page .member-toolbar.sticky{top:149px}}#group-members-page .member-toolbar .title{padding-left:0}#group-members-page .member-toolbar .title .btn{font-size:22px;padding:0;pointer-events:none;border:none;background-color:#fff}#group-members-page .member-toolbar .nav-g-tabs{padding:0}#group-members-page .member-toolbar .nav-g-tabs .btn+.btn{margin-right:10px}#group-members-page .member-toolbar .nav-g-tabs .btn{color:#1badac;border:1px solid #1badac;background-color:#fff;float:right}#group-members-page .member-toolbar .nav-g-tabs .btnLstMembers,#group-members-page .member-toolbar .nav-g-tabs .btnRequest{width:35%}#group-members-page .member-toolbar .nav-g-tabs .btnClose{width:calc(30% - 20px)}#group-members-page .member-toolbar .nav-g-tabs .btnClose img{width:12px;margin-right:5px}@media (max-width:520px){#group-members-page .member-toolbar .title>.btn{font-size:15px;padding-top:3px;padding-bottom:3px}#group-members-page .member-toolbar .nav-g-tabs .btn+.btn{margin-right:5px}#group-members-page .member-toolbar .nav-g-tabs .btn{font-size:12px;padding-left:0;padding-right:0}#group-members-page .member-toolbar .nav-g-tabs .btn img{width:10px;margin-right:2px}#group-members-page .member-toolbar .nav-g-tabs .btnClose{width:calc(30% - 10px)}}@media (max-width:414px){#group-members-page .member-toolbar .title>.btn{font-size:13px}#group-members-page .member-toolbar .nav-g-tabs .btn{font-size:9px}}#group-members-page .loadMoreRegion{padding:10px;text-align:center}#group-members-page .loadMoreRegion .btn-loadMore{position:relative;margin:0 auto;color:#fff;width:220px;background-color:#555}#group-members-page .loadMoreRegion .btn-loadMore.loading{color:transparent}", ""]);

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(823);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_info.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_group_info.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, "@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{display:table}#group-registration-page #group-cover-container .rowContainer{display:table-cell}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b,#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container #centered{display:table}#group-registration-page #group-cover-container #centered span.title,#group-registration-page #group-cover-container #centered span.caret{display:inline-block}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex}#group-registration-page #group-content-container span.titleMenu{display:inline-block}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy,#group-registration-page #group-content-container span.privatePolicy{display:inline-block}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{display:table}#group-registration-page #group-cover-container .rowContainer{display:table-cell}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b,#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container #centered{display:table}#group-registration-page #group-cover-container #centered span.title,#group-registration-page #group-cover-container #centered span.caret{display:inline-block}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex}#group-registration-page #group-content-container span.titleMenu{display:inline-block}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy,#group-registration-page #group-content-container span.privatePolicy{display:inline-block}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}#group-info-header{padding:0}#group-info-header>.row-header{background-color:#fff;display:table;table-layout:fixed;min-height:150px;padding:20px 10px 10px}#group-info-header>.row-header.last{padding:10px;min-height:1px}#group-info-header>.row-header.last .cell{vertical-align:middle}#group-info-header>.row-header.last:hover{cursor:pointer;opacity:.8}#group-info-header>.row-header img.image-arrow{float:right;height:20px}#group-info-header>.row-header .cell{display:table-cell;vertical-align:top}#group-info-header>.row-header .btn-edit{position:absolute;top:20px;right:10px;color:#fff;background-color:#1badac;border:1px solid #1badac}#group-info-header>.row-header .cell.avatar{text-align:center;width:150px}#group-info-header>.row-header .cell.avatar img.avatar{background-color:#acc4c4;background-image:url("+__webpack_require__(817)+");background-repeat:no-repeat;background-position:center;background-size:120px;width:140px;height:140px;object-fit:cover;border:1px solid #e5e5e5;border-radius:4px}#group-info-header>.row-header .cell.description .content{margin-top:20px}#group-info-header>.row-header .cell.description .content p{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;font-size:12px;word-break:break-all}#group-info-header>.row-header .cell.description .group-name{width:calc(100% - 160px);font-size:20px;font-weight:700;overflow:hidden;text-overflow:ellipsis;line-height:30px;padding-top:10px;padding-bottom:5px;word-break:break-all}#group-info-header>.row-header .cell.description .group-member{font-size:12px;padding-bottom:5px;color:#555;overflow:hidden;text-overflow:ellipsis;display:table}#group-info-header>.row-header .cell.description .group-member span{display:table-cell;vertical-align:middle}#group-info-header>.row-header .cell.description .group-member span:last-child{padding-left:10px}@media (max-width:767px){#group-info-header>.row-header{border-bottom:1px solid #e5e5e5}#group-info-header>.row-header.last{display:table!important}}@media (max-width:414px){#group-info-header>.row-header .cell.avatar{width:110px}#group-info-header>.row-header .cell.avatar img.avatar{width:100px;height:100px;background-size:80px}#group-info-header>.row-header .cell.description .name,#group-info-header>.row-header .cell.description .content{padding:5px}#group-info-header>.row-header .cell.description .btn-edit{font-size:10px}#group-info-header>.row-header .cell.description .group-name{width:100%;font-size:15px;line-height:15px;padding-top:0}#group-info-header>.row-header .cell.description .content{margin-top:0}}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{display:table}#group-registration-page #group-cover-container .rowContainer{display:table-cell}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b,#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container #centered{display:table}#group-registration-page #group-cover-container #centered span.title,#group-registration-page #group-cover-container #centered span.caret{display:inline-block}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex}#group-registration-page #group-content-container span.titleMenu{display:inline-block}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy,#group-registration-page #group-content-container span.privatePolicy{display:inline-block}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}#group-info-members{padding:0}#group-info-members .mems-header{background-color:#1badac;color:#fff;padding-top:5px;padding-bottom:5px;display:inline-block}#group-info-members .mems-header .cell{display:table-cell;vertical-align:middle;font-size:15px;font-weight:700}#group-info-members .mems-header .btn-edit{float:right;color:#1badac;background-color:#fff}#group-info-members .mems-list{max-width:100%;overflow:auto;padding:20px 10px}#group-info-members .mems-list .item{display:table-cell;padding:5px;text-align:center;position:relative;vertical-align:top;width:100px;max-width:100px}#group-info-members .mems-list .item img{width:90px;height:90px}#group-info-members .mems-list .item .title{height:32px;vertical-align:middle;display:table-cell}#group-info-members .mems-list .item .title span.text{padding-top:5px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;font-size:12px;width:90px;word-break:break-all}#group-info-members .mems-list .item+.item{margin-left:7px}#group-info-members .header-legend{display:table}#group-info-members .header-legend .cell{display:table-cell;vertical-align:middle;padding:5px}#group-info-members .header-legend .cell .border-line{height:2px;width:100%;background-color:#ccc}#group-info-members .header-legend .cell.text{font-size:15px;font-weight:700;width:60px}#group-info-members .admin-list{max-width:100%;overflow:auto;padding:10px;white-space:nowrap}#group-info-members .admin-list .item{display:table-cell;padding:5px;text-align:center;position:relative;vertical-align:top;width:100px;max-width:100px}#group-info-members .admin-list .item img{width:90px;height:90px}#group-info-members .admin-list .item .title{height:32px;vertical-align:middle;display:table-cell}#group-info-members .admin-list .item .title span.text{padding-top:5px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;font-size:12px;width:90px;word-break:break-all}#group-info-members .admin-list .item+.item{margin-left:7px}#group-info-members .btn-region{padding:20px;text-align:center}#group-info-members .btn-region .btn{width:70%;border:1px solid #1badac;background-color:#fff;color:#1badac}#group-info-members .mems-row{display:table;background-color:#fff;padding:10px;border-bottom:1px solid #e5e5e5}#group-info-members .mems-row .cell{display:table-cell;vertical-align:middle}#group-info-members .mems-row img.image-arrow{float:right;height:20px}#group-info-members .mems-row:first-child{margin-top:20px}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}.span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#group-registration-page{background-color:#e5e5e5}#group-registration-page .btnOpacity{opacity:.3;transition-duration:.4s}#group-registration-page .btnOpacity:hover{opacity:1}#group-registration-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-registration-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-registration-page #top-page{background-color:#e5e5e5}}#group-registration-page #group-cover-container{width:100%;height:250px;background-color:#acc4c4;display:table;position:relative;overflow:hidden}#group-registration-page #group-cover-container .rowContainer{display:table-cell;vertical-align:middle;-ms-flex-align:center;align-items:center}#group-registration-page #group-cover-container img.coverPhoto{margin:0;position:absolute;width:100%;max-width:100%;height:250px;object-fit:cover}@media (max-width:414px){#group-registration-page #group-cover-container,#group-registration-page #group-cover-container img.coverPhoto{height:172px}}#group-registration-page #group-cover-container .container-fluid.editCover{height:100%}#group-registration-page #group-cover-container .container-fluid.editCover .row{height:100%;position:relative}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion{position:absolute;bottom:10px;max-height:80%;word-wrap:break-word}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu{color:#fff;max-height:200px;max-width:100%}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu b{font-size:26px;display:inline-block;max-width:100%;max-height:110px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .infoRegion span.titleMenu span{display:inline-block;max-width:100%;max-height:50px;overflow:hidden;text-overflow:ellipsis}#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{transition-duration:.4s;padding:10px}#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:120px;float:right;font-size:12px;padding-left:8px;padding-right:8px}@media (max-width:414px){#group-registration-page #group-cover-container .container-fluid.editCover .btnCoverRegion{position:absolute;bottom:5px}}@media (max-width:320px){#group-registration-page #group-cover-container .container-fluid.editCover .btnSelectCover{width:90px;font-size:9px}}#group-registration-page #group-cover-container button{font-size:12px;background-color:#1badac;border-color:#1badac}#group-registration-page #group-cover-container #centered{position:relative;display:table;margin:0 auto}#group-registration-page #group-cover-container #centered .row{margin-left:0;margin-right:0}#group-registration-page #group-cover-container #centered span.title{background-repeat:no-repeat;background-image:url("+__webpack_require__(708)+");color:#fff;font-size:18px;text-align:left;padding-left:70px;display:inline-block}#group-registration-page #group-cover-container #centered span.caret{margin-left:10px;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;margin-bottom:2px;display:inline-block;border-width:5px 5px 0}#group-registration-page .innerBottomShadow{box-shadow:0 -149px 150px -150px #000 inset}#group-registration-page #group-content-container{width:100%;padding-top:10px;padding-bottom:10px}#group-registration-page #group-content-container .row.groupContent{margin-left:0;margin-right:0}#group-registration-page #group-content-container .avatarContainer{width:170px;height:170px;margin:11px auto;position:relative;background-color:#acc4c4;border-radius:4px;background-image:url("+__webpack_require__(709)+");background-repeat:no-repeat;background-position:50% 25%}#group-registration-page #group-content-container .avatarContainer img.avatar{margin:0;position:relative;width:100%;height:100%;object-fit:cover}#group-registration-page #group-content-container .avatarContainer button.btn{position:relative;width:90%;background-color:#1badac;border-color:#1badac;margin-bottom:25%;margin-top:-50%;text-align:center;margin-left:0%}@media (max-width:767px){#group-registration-page #group-content-container .avatarContainer{background-position:center;margin-left:0;width:120px;height:120px}#group-registration-page #group-content-container .avatarContainer button.btn{width:150px;margin-top:86px;position:absolute;margin-bottom:0}#group-registration-page #group-content-container .avatarContainer label{margin-top:10px}}#group-registration-page #group-content-container .btn-group,#group-registration-page #group-content-container .dropdown-toggle,#group-registration-page #group-content-container .dropdown-menu{width:100%}#group-registration-page #group-content-container .dropdown-toggle{padding-left:20px;text-align:left}#group-registration-page #group-content-container .dropdown-menu>li>a:hover,#group-registration-page #group-content-container .dropdown-menu .dropdown-item:hover{background:#f1f9fd}#group-registration-page #group-content-container .radio.d-block.d-sm-none label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px;background-color:#fff;border:1px solid #ccc;border-radius:4px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy{position:relative;background:#fff;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:25px;width:25px;transition:all .15s ease-out 0s;background:#cbd1d8;border:none;color:#fff;cursor:pointer;outline:none;line-height:25px;-ms-flex:0 0 25px;flex:0 0 25px;border-radius:50%;text-align:center;margin:0 10px 0 0;font-size:15px}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked{background:#1badac}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::before{content:'✓';text-align:center}#group-registration-page #group-content-container .radio.d-block.d-sm-none input.radioPrivacy:checked::after{content:''}#group-registration-page #group-content-container span.titleMenu{display:inline-block;vertical-align:middle;padding-left:10px}@media (max-width:860px){#group-registration-page #group-content-container span.titleMenu{font-size:12px}}#group-registration-page #group-content-container span.publicPolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(710)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container span.privatePolicy{background-repeat:no-repeat;background-image:url("+__webpack_require__(711)+");background-size:30px 30px;width:40px;height:30px;display:inline-block;vertical-align:middle}#group-registration-page #group-content-container .caret{margin-top:5px;margin-right:0;float:right;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}#group-registration-page #group-content-container .btnCancel{font-size:13px;background-color:#c5c5c5;color:#424242;border-color:#424242}#group-registration-page #group-content-container .btnCreate{font-size:13px;background-color:#424242;color:#fff;border-color:#424242}#group-registration-page #group-content-container .error{color:#8a1f11}@media (max-width:991px){#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-registration-page #main-main .container,#group-registration-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-registration-page #gnp-header .btn-section,#group-registration-page #gnp-header .user{display:none}#group-registration-page #gnp-footer .copyright{text-align:left;margin-top:0}}body{min-width:0}.g-badge{position:relative}.g-badge[data-badge]:after{content:attr(data-badge);position:absolute;top:-15px;right:0;font-size:11px;background-color:red;padding-left:4px;padding-right:4px;color:#fff;min-width:22px;height:22px;border-radius:12px;line-height:22px}.g-badge[data-badge^=\"-\"]:after,.g-badge[data-badge=\"0\"]:after,.g-badge[data-badge=\"\"]:after{display:none}.modal .modal-content .modal-header{background-color:#fff;color:#70beb3;font-size:16px;height:50px}.modal .modal-content .modal-header button{color:#70beb3;font-size:16px;padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.modal .modal-content .modal-header .modal-heading{font-size:18px;font-weight:700}.modal .modal-content .modal-body .cropArea{background:#E4E4E4;overflow:hidden;margin:auto;width:auto;height:500px}.image-cropper{overflow:hidden}.image-cropper,.image-cropper img{position:relative}.cropArea{background:#E4E4E4;overflow:hidden;width:500px;height:350px}#group-info-events{padding:0}#group-info-events .mems-header{background-color:#1badac;display:table;color:#fff;padding-top:5px;padding-bottom:5px;min-height:43px}#group-info-events .mems-header .cell{display:table-cell;vertical-align:middle;font-size:15px;font-weight:700}#group-info-events .mems-row{display:table;background-color:#fff;padding:10px;border-bottom:1px solid #e5e5e5}#group-info-events .mems-row .cell{display:table-cell;vertical-align:middle}#group-info-events .mems-row img.image-arrow{float:right;height:20px}#group-info-events .mems-row:first-child{margin-top:20px}#group-info-events .mems-row:first-child.member{margin-top:0}#group-info-events .btn-region{padding:20px 20px 40px;text-align:center}#group-info-events .btn-region .btn{width:70%;border:1px solid #1badac;background-color:#fff;color:#1badac}#group-information-page #top-page{max-width:none!important;width:970px;background-color:#fff;position:relative;margin:0 auto}@media (max-width:970px){#group-information-page #top-page{width:100%;min-width:0}}@media (max-width:767px){#group-information-page #top-page{background-color:#e5e5e5}}#group-information-page .leave-group-region .mems-row{display:table;background-color:#fff;padding:10px;border-bottom:1px solid #e5e5e5}#group-information-page .leave-group-region .mems-row .cell{display:table-cell;vertical-align:middle;text-align:center;color:red}#group-information-page .leave-group-region .mems-row:first-child{margin-top:20px}#group-information-page .leave-group-region .btn-region{border-top:5px solid #1badac;padding:40px 20px;text-align:center}#group-information-page .leave-group-region .btn-region .btn{width:70%;border:1px solid red;background-color:#fff;color:red}#group-information-page .mems-row:hover{cursor:pointer;opacity:.8}@media (max-width:991px){#group-information-page #gnp-footer .copyright{text-align:left;margin-top:0}}@media (max-width:768px){#group-information-page #main-main .container,#group-information-page #main-main .container.dashboard-container{width:100%;min-width:0}#group-information-page #gnp-header .btn-section,#group-information-page #gnp-header .user{display:none}#group-information-page #gnp-footer .copyright{text-align:left;margin-top:0}}", ""]);

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupRegistrationCtrl;
	
	$ = __webpack_require__(1);
	
	GroupRegistrationCtrl = function($scope, $location, $filter, flash, formDialogService, formFileReaderService, groupDataService, groupRegisDataService, $ngConfirm) {
	  var defDirS3, isNotValidSizeFile, maxFileUploadSize, openFileDialog;
	  angular.element(document.body).css('min-width', 0);
	  maxFileUploadSize = 5000000;
	  $scope.group = {
	    type: '0'
	  };
	  defDirS3 = {
	    prefixCover: 'images/group/cover/',
	    prefixAvatar: 'images/group/avatar/'
	  };
	  $scope.isSubmitting = false;
	  $scope.policyDatas = groupDataService.getPolicyData();
	  $scope.coverPhoto = void 0;
	  $scope.croppedCoverPhoto = '';
	  $scope.avatarPhoto = void 0;
	  $scope.croppedAvatarPhoto = '';
	  $scope.croppedCoverPhotoBlob = '';
	  $scope.croppedAvatarPhotoBlob = '';
	  groupRegisDataService.createS3ImageURL(defDirS3.prefixCover).then(function(resp) {
	    return $scope.preDataCover = resp.data;
	  });
	  groupRegisDataService.createS3ImageURL(defDirS3.prefixAvatar).then(function(resp) {
	    return $scope.preDataAvatar = resp.data;
	  });
	  $scope.choosePolicy = function(policy) {
	    return $scope.group.type = policy;
	  };
	  $scope.chooseCover = function() {
	    return openFileDialog(function(file, fileLocation) {
	      return formFileReaderService.loadImageOrientation('coverPhoto', file).then(function(data) {
	        $scope.coverData = data;
	        $scope.coverPhoto = data.base64Data;
	        return $('.crop-image-modal').modal('show');
	      });
	    });
	  };
	  $scope.chooseAvatar = function() {
	    return openFileDialog(function(file, fileLocation) {
	      return formFileReaderService.loadImageOrientation('avatar', file).then(function(data) {
	        $scope.avatarData = data;
	        $scope.avatarPhoto = data.base64Data;
	        return $('.crop-icon-modal').modal('show');
	      });
	    });
	  };
	  $scope.cancelCropModal = function() {
	    $scope.coverPhoto = '';
	    $scope.croppedCoverPhoto = '';
	    $('#coverPhoto').attr('src', '');
	    $('.crop-image-modal').modal('hide');
	  };
	  $scope.submitCropModal = function() {
	    $('.crop-image-modal').modal('hide');
	  };
	  $scope.cancelCropIconModal = function() {
	    $scope.avatarPhoto = '';
	    $scope.croppedAvatarPhoto = '';
	    $('#avatar').attr('src', '');
	    $('.crop-icon-modal').modal('hide');
	  };
	  $scope.submitCropIconModal = function() {
	    $('.crop-icon-modal').modal('hide');
	  };
	  $scope.btnCancelClick = function() {
	    return $location.path('/groups');
	  };
	  $scope.submit = function(group) {
	    var avatarData, coverData;
	    $scope.isSubmitting = true;
	    coverData = {
	      coverFile: $scope.croppedCoverPhotoBlob,
	      url: $scope.preDataCover.url,
	      fields: $scope.preDataCover.fields
	    };
	    avatarData = {
	      coverFile: $scope.croppedAvatarPhotoBlob,
	      url: $scope.preDataAvatar.url,
	      fields: $scope.preDataAvatar.fields
	    };
	    return groupRegisDataService.createGroup($scope.group, coverData, avatarData).then(function(data) {
	      if (data === 'success') {
	        flash.success(data);
	        $scope.isSubmitting = false;
	        return $location.path('/groups');
	      }
	    }, function(data) {
	      if ((data != null ? data.data.code : void 0) === 'error.name_already_taken') {
	        flash.error($filter('translate')('NAME_DUPLICATED'));
	      } else {
	        flash.error($filter('translate')('API_ERROR'));
	      }
	      return $scope.isSubmitting = false;
	    });
	  };
	  isNotValidSizeFile = function(file) {
	    return file.size > maxFileUploadSize;
	  };
	  return openFileDialog = function(callback) {
	    var options;
	    options = {
	      accept: 'image/*'
	    };
	    return formDialogService._open(options, function(file, fileLocation) {
	      if (isNotValidSizeFile(file)) {
	        $ngConfirm('Image size is more than ' + maxFileUploadSize + ' bytes');
	        return;
	      }
	      return callback(file, fileLocation);
	    });
	  };
	};
	
	GroupRegistrationCtrl.$inject = ['$scope', '$location', '$filter', 'flash', 'formDialogService', 'formFileReaderService', 'groupDataService', 'groupRegisDataService', '$ngConfirm'];
	
	module.exports = GroupRegistrationCtrl;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupSearchCtrl, _;
	
	_ = __webpack_require__(87);
	
	$ = __webpack_require__(1);
	
	GroupSearchCtrl = function($scope, $location, $filter, $routeParams, groupRegisDataService, userInfo, $ngConfirm) {
	  var cachedData, createCacheData, pageSize, ref, setDataFromCache;
	  angular.element(document.body).css('min-width', 0);
	  pageSize = 4;
	  $scope.groups = [];
	  $scope.currentPage = 0;
	  $scope.isLoading = true;
	  $scope.noResults = false;
	  $scope.keyword = (ref = $routeParams.key) != null ? ref : '';
	  $scope.loadMore = function() {
	    $scope.isLoading = true;
	    $scope.currentPage++;
	    return groupRegisDataService.searchGroup($scope.keyword, $scope.currentPage, pageSize).then(function(data) {
	      $scope.groups = _.union($scope.groups, data.groups);
	      $scope.totalPages = data.total_pages;
	      return $scope.noResults = $scope.groups.length === 0;
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  };
	  $scope.hasMore = function() {
	    return $scope.noResults === false && $scope.currentPage !== $scope.totalPages;
	  };
	  $scope.searchGroup = function(keyTemp) {
	    $scope.keyword = keyTemp;
	    $scope.groups = [];
	    $scope.currentPage = 0;
	    $scope.isLoading = true;
	    $scope.noResults = false;
	    return $scope.loadMore();
	  };
	  $scope.goCreatePage = function() {
	    return $location.path('/groups/registration');
	  };
	  $scope.backJoinList = function() {
	    return $location.path('/groups');
	  };
	  $scope.gotoGroup = function(id) {
	    groupRegisDataService.setTempData(createCacheData());
	    return $location.url('/groups/' + id);
	  };
	  $scope.requestGroup = function(group) {
	    var groupId, params, userId;
	    userId = userInfo.user_id;
	    groupId = group.id;
	    if (userId === '' || groupId === '') {
	      return;
	    }
	    params = {
	      user_id: userId,
	      group_id: groupId
	    };
	    return groupRegisDataService.joinGroup(params)["finally"](function() {
	      var mess;
	      group.user_status = 'pending';
	      mess = $filter('translate')('_GROUP.TOOLBAR.REQUEST_MESS_JOIN_GROUP');
	      return $ngConfirm(mess);
	    });
	  };
	  $scope.$watch('groups', function() {
	    if ($scope.currentPage <= 1 || $scope.fromCached) {
	      $scope.fromCached = false;
	      return;
	    }
	    return $("html, body").animate({
	      scrollTop: $(document).height()
	    }, "slow");
	  }, false);
	  createCacheData = function() {
	    var cacheData;
	    cacheData = {
	      groups: $scope.groups,
	      currentPage: $scope.currentPage,
	      isLoading: $scope.isLoading,
	      noResults: $scope.noResults,
	      keyword: $scope.keyword,
	      totalPages: $scope.totalPages
	    };
	    return cacheData;
	  };
	  setDataFromCache = function(data) {
	    $scope.keyword = data.keyword;
	    $scope.groups = data.groups;
	    $scope.currentPage = data.currentPage;
	    $scope.isLoading = data.isLoading;
	    $scope.noResults = data.noResults;
	    $scope.totalPages = data.totalPages;
	    return $scope.fromCached = true;
	  };
	  cachedData = groupRegisDataService.getTempData();
	  if (cachedData) {
	    groupRegisDataService.setTempData(null);
	    setDataFromCache(cachedData);
	    return;
	  }
	  $(document).ready(function() {
	    return document.body.scrollTop = document.documentElement.scrollTop = 0;
	  });
	  return $scope.loadMore();
	};
	
	GroupSearchCtrl.$inject = ['$scope', '$location', '$filter', '$routeParams', 'groupRegisDataService', 'userInfo', '$ngConfirm'];
	
	module.exports = GroupSearchCtrl;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupEditCtrl;
	
	$ = __webpack_require__(1);
	
	GroupEditCtrl = function($scope, $location, $filter, flash, formDialogService, formFileReaderService, groupDataService, groupRegisDataService, groupInfo, groupStatus, userInfo, $ngConfirm) {
	  var defDirS3, isNotValidSizeFile, maxFileUploadSize, openFileDialog;
	  if (groupStatus.role !== 'admin') {
	    return $location.path('/groups');
	  }
	  $(document).ready(function() {
	    return document.body.scrollTop = document.documentElement.scrollTop = 0;
	  });
	  angular.element(document.body).css('min-width', 0);
	  $scope.isSubmitting = false;
	  $scope.policyDatas = groupDataService.getPolicyData();
	  maxFileUploadSize = 5000000;
	  $scope.group = groupInfo;
	  $scope.group.type = groupInfo.public_status ? '1' : '0';
	  $scope.croppedCoverPhoto = groupInfo.cover_url;
	  $scope.croppedAvatarPhoto = groupInfo.avatar_url;
	  defDirS3 = {
	    prefixCover: 'images/group/cover/',
	    prefixAvatar: 'images/group/avatar/'
	  };
	  groupRegisDataService.createS3ImageURL(defDirS3.prefixCover).then(function(resp) {
	    return $scope.preDataCover = resp.data;
	  });
	  groupRegisDataService.createS3ImageURL(defDirS3.prefixAvatar).then(function(resp) {
	    return $scope.preDataAvatar = resp.data;
	  });
	  $scope.choosePolicy = function(policy) {
	    return $scope.group.type = policy;
	  };
	  $scope.chooseCover = function() {
	    return openFileDialog(function(file, fileLocation) {
	      return formFileReaderService.loadImageOrientation('coverPhoto', file).then(function(data) {
	        $scope.coverData = data;
	        $scope.coverPhoto = data.base64Data;
	        return $('.crop-image-modal').modal('show');
	      });
	    });
	  };
	  $scope.chooseAvatar = function() {
	    return openFileDialog(function(file, fileLocation) {
	      return formFileReaderService.loadImageOrientation('avatar', file).then(function(data) {
	        $scope.avatarData = data;
	        $scope.avatarPhoto = data.base64Data;
	        return $('.crop-icon-modal').modal('show');
	      });
	    });
	  };
	  $scope.cancelCropModal = function() {
	    $scope.coverPhoto = '';
	    $('#coverPhoto').attr('src', '');
	    $scope.croppedCoverPhoto = $scope.group.cover_url;
	    $('.crop-image-modal').modal('hide');
	  };
	  $scope.submitCropModal = function() {
	    $('.crop-image-modal').modal('hide');
	  };
	  $scope.cancelCropIconModal = function() {
	    $scope.avatarPhoto = '';
	    $('#avatar').attr('src', '');
	    $scope.croppedAvatarPhoto = $scope.group.avatar_url;
	    $('.crop-icon-modal').modal('hide');
	  };
	  $scope.submitCropIconModal = function() {
	    $('.crop-icon-modal').modal('hide');
	  };
	  $scope.btnCancelClick = function() {
	    return $location.path('/groups');
	  };
	  $scope.submit = function(group) {
	    var avatarData, avatarFile, coverData, coverFile;
	    $scope.isSubmitting = true;
	    coverFile = $scope.coverPhoto != null ? $scope.croppedCoverPhotoBlob : $scope.croppedCoverPhoto;
	    avatarFile = $scope.avatarPhoto != null ? $scope.croppedAvatarPhotoBlob : $scope.croppedAvatarPhoto;
	    coverData = {
	      coverFile: coverFile,
	      url: $scope.preDataCover.url,
	      fields: $scope.preDataCover.fields
	    };
	    avatarData = {
	      coverFile: avatarFile,
	      url: $scope.preDataAvatar.url,
	      fields: $scope.preDataAvatar.fields
	    };
	    return groupRegisDataService.updateGroup($scope.group, coverData, avatarData).then(function(data) {
	      if (data === 'success') {
	        flash.success(data);
	        $scope.isSubmitting = false;
	        return $location.path('/groups');
	      }
	    }, function(data) {
	      flash.error($filter('translate')('API_ERROR'));
	      return $scope.isSubmitting = false;
	    });
	  };
	  isNotValidSizeFile = function(file) {
	    return file.size > maxFileUploadSize;
	  };
	  return openFileDialog = function(callback) {
	    var options;
	    options = {
	      accept: 'image/*'
	    };
	    return formDialogService._open(options, function(file, fileLocation) {
	      if (isNotValidSizeFile(file)) {
	        $ngConfirm('Image size is more than ' + maxFileUploadSize + ' bytes');
	        return;
	      }
	      return callback(file, fileLocation);
	    });
	  };
	};
	
	GroupEditCtrl.$inject = ['$scope', '$location', '$filter', 'flash', 'formDialogService', 'formFileReaderService', 'groupDataService', 'groupRegisDataService', 'groupInfo', 'groupStatus', 'userInfo', '$ngConfirm'];
	
	module.exports = GroupEditCtrl;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupListCtrl, ZeroClipboard, _, moment;
	
	_ = __webpack_require__(87);
	
	moment = __webpack_require__(126);
	
	$ = __webpack_require__(1);
	
	ZeroClipboard = __webpack_require__(828);
	
	GroupListCtrl = function($scope, $location, $filter, groupRegisDataService, formCopyService, userInfo, $ngConfirm) {
	  var copyCommandSupported, pageSize;
	  angular.element(document.body).css('min-width', 0);
	  copyCommandSupported = document.queryCommandSupported('copy');
	  $(document).ready(function() {
	    document.body.scrollTop = document.documentElement.scrollTop = 0;
	    if (!copyCommandSupported) {
	      ZeroClipboard.config({
	        swfPath: __webpack_require__(829)
	      });
	      $scope.client = new ZeroClipboard($('#btnCopy'));
	      return $scope.client.clip($('.btn-Copy'));
	    }
	  });
	  pageSize = 4;
	  $scope.groups = [];
	  $scope.currentPage = 0;
	  $scope.isLoading = true;
	  $scope.noResults = false;
	  $scope.keyword = "";
	  $scope.isAdmin = userInfo.admin;
	  $scope.loadMore = function() {
	    $scope.isLoading = true;
	    $scope.currentPage++;
	    return groupRegisDataService.searchGroup($scope.keyword, $scope.currentPage, pageSize).then(function(data) {
	      $scope.groups = _.union($scope.groups, data.groups);
	      $scope.totalPages = data.total_pages;
	      return $scope.noResults = $scope.groups.length === 0;
	    })["finally"](function() {
	      return $scope.isLoading = false;
	    });
	  };
	  $scope.editGroup = function(id, event) {
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    }
	    return $location.path('/groups/' + id + '/edit');
	  };
	  $scope.hasMore = function() {
	    return $scope.noResults === false && $scope.currentPage !== $scope.totalPages;
	  };
	  $scope.displayPrivacy = function(privacy) {
	    if (privacy) {
	      return $filter('translate')('_GROUP.LIST.PUBLIC_GROUP');
	    } else {
	      return $filter('translate')('_GROUP.LIST.PRIVATE_GROUP');
	    }
	  };
	  $scope.displayMember = function(member) {
	    return ($filter('translate')('_GROUP.LIST.MEMBERS')) + ': ' + member + ($filter('translate')('_GROUP.LIST.MEMBERS_EXT'));
	  };
	  $scope.searchGroup = function(keyTemp) {
	    keyTemp = keyTemp != null ? keyTemp : '';
	    return $location.url("/groups/search?key=" + keyTemp);
	  };
	  $scope.dataURL = function(id) {
	    return $location.absUrl() + '/join?id=' + id;
	  };
	  $scope.copyFunc = function(id, event) {
	    var mess;
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    }
	    if (!copyCommandSupported) {
	      $scope.client.emit();
	    } else {
	      formCopyService.copy($scope.dataURL(id));
	    }
	    mess = $filter('translate')('_GROUP.TOOLBAR.COPY_MESS_URL');
	    return $ngConfirm(mess);
	  };
	  $scope.goCreatePage = function() {
	    return $location.path('/groups/registration');
	  };
	  $scope.gotoGroup = function(id, event) {
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    }
	    return $location.path('/groups/' + id);
	  };
	  $scope.goToListRequest = function(id, event) {
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    }
	    return $location.path("/groups/" + id + "/members/list-request");
	  };
	  $scope.$watch('groups', function() {
	    if (copyCommandSupported) {
	      return;
	    }
	    return setTimeout(function() {
	      return $scope.client.clip($('.btn-Copy'));
	    }, 0);
	  }, true);
	  $scope.loadMore();
	  return $scope.$on('$destroy', function() {
	    return ZeroClipboard.destroy();
	  });
	};
	
	GroupListCtrl.$inject = ['$scope', '$location', '$filter', 'groupRegisDataService', 'formCopyService', 'userInfo', '$ngConfirm'];
	
	module.exports = GroupListCtrl;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * ZeroClipboard
	 * The ZeroClipboard library provides an easy way to copy text to the clipboard using an invisible Adobe Flash movie and a JavaScript interface.
	 * Copyright (c) 2009-2014 Jon Rohan, James M. Greene
	 * Licensed MIT
	 * http://zeroclipboard.org/
	 * v2.2.0
	 */
	(function(window, undefined) {
	  "use strict";
	  /**
	 * Store references to critically important global functions that may be
	 * overridden on certain web pages.
	 */
	  var _window = window, _document = _window.document, _navigator = _window.navigator, _setTimeout = _window.setTimeout, _clearTimeout = _window.clearTimeout, _setInterval = _window.setInterval, _clearInterval = _window.clearInterval, _getComputedStyle = _window.getComputedStyle, _encodeURIComponent = _window.encodeURIComponent, _ActiveXObject = _window.ActiveXObject, _Error = _window.Error, _parseInt = _window.Number.parseInt || _window.parseInt, _parseFloat = _window.Number.parseFloat || _window.parseFloat, _isNaN = _window.Number.isNaN || _window.isNaN, _now = _window.Date.now, _keys = _window.Object.keys, _defineProperty = _window.Object.defineProperty, _hasOwn = _window.Object.prototype.hasOwnProperty, _slice = _window.Array.prototype.slice, _unwrap = function() {
	    var unwrapper = function(el) {
	      return el;
	    };
	    if (typeof _window.wrap === "function" && typeof _window.unwrap === "function") {
	      try {
	        var div = _document.createElement("div");
	        var unwrappedDiv = _window.unwrap(div);
	        if (div.nodeType === 1 && unwrappedDiv && unwrappedDiv.nodeType === 1) {
	          unwrapper = _window.unwrap;
	        }
	      } catch (e) {}
	    }
	    return unwrapper;
	  }();
	  /**
	 * Convert an `arguments` object into an Array.
	 *
	 * @returns The arguments as an Array
	 * @private
	 */
	  var _args = function(argumentsObj) {
	    return _slice.call(argumentsObj, 0);
	  };
	  /**
	 * Shallow-copy the owned, enumerable properties of one object over to another, similar to jQuery's `$.extend`.
	 *
	 * @returns The target object, augmented
	 * @private
	 */
	  var _extend = function() {
	    var i, len, arg, prop, src, copy, args = _args(arguments), target = args[0] || {};
	    for (i = 1, len = args.length; i < len; i++) {
	      if ((arg = args[i]) != null) {
	        for (prop in arg) {
	          if (_hasOwn.call(arg, prop)) {
	            src = target[prop];
	            copy = arg[prop];
	            if (target !== copy && copy !== undefined) {
	              target[prop] = copy;
	            }
	          }
	        }
	      }
	    }
	    return target;
	  };
	  /**
	 * Return a deep copy of the source object or array.
	 *
	 * @returns Object or Array
	 * @private
	 */
	  var _deepCopy = function(source) {
	    var copy, i, len, prop;
	    if (typeof source !== "object" || source == null || typeof source.nodeType === "number") {
	      copy = source;
	    } else if (typeof source.length === "number") {
	      copy = [];
	      for (i = 0, len = source.length; i < len; i++) {
	        if (_hasOwn.call(source, i)) {
	          copy[i] = _deepCopy(source[i]);
	        }
	      }
	    } else {
	      copy = {};
	      for (prop in source) {
	        if (_hasOwn.call(source, prop)) {
	          copy[prop] = _deepCopy(source[prop]);
	        }
	      }
	    }
	    return copy;
	  };
	  /**
	 * Makes a shallow copy of `obj` (like `_extend`) but filters its properties based on a list of `keys` to keep.
	 * The inverse of `_omit`, mostly. The big difference is that these properties do NOT need to be enumerable to
	 * be kept.
	 *
	 * @returns A new filtered object.
	 * @private
	 */
	  var _pick = function(obj, keys) {
	    var newObj = {};
	    for (var i = 0, len = keys.length; i < len; i++) {
	      if (keys[i] in obj) {
	        newObj[keys[i]] = obj[keys[i]];
	      }
	    }
	    return newObj;
	  };
	  /**
	 * Makes a shallow copy of `obj` (like `_extend`) but filters its properties based on a list of `keys` to omit.
	 * The inverse of `_pick`.
	 *
	 * @returns A new filtered object.
	 * @private
	 */
	  var _omit = function(obj, keys) {
	    var newObj = {};
	    for (var prop in obj) {
	      if (keys.indexOf(prop) === -1) {
	        newObj[prop] = obj[prop];
	      }
	    }
	    return newObj;
	  };
	  /**
	 * Remove all owned, enumerable properties from an object.
	 *
	 * @returns The original object without its owned, enumerable properties.
	 * @private
	 */
	  var _deleteOwnProperties = function(obj) {
	    if (obj) {
	      for (var prop in obj) {
	        if (_hasOwn.call(obj, prop)) {
	          delete obj[prop];
	        }
	      }
	    }
	    return obj;
	  };
	  /**
	 * Determine if an element is contained within another element.
	 *
	 * @returns Boolean
	 * @private
	 */
	  var _containedBy = function(el, ancestorEl) {
	    if (el && el.nodeType === 1 && el.ownerDocument && ancestorEl && (ancestorEl.nodeType === 1 && ancestorEl.ownerDocument && ancestorEl.ownerDocument === el.ownerDocument || ancestorEl.nodeType === 9 && !ancestorEl.ownerDocument && ancestorEl === el.ownerDocument)) {
	      do {
	        if (el === ancestorEl) {
	          return true;
	        }
	        el = el.parentNode;
	      } while (el);
	    }
	    return false;
	  };
	  /**
	 * Get the URL path's parent directory.
	 *
	 * @returns String or `undefined`
	 * @private
	 */
	  var _getDirPathOfUrl = function(url) {
	    var dir;
	    if (typeof url === "string" && url) {
	      dir = url.split("#")[0].split("?")[0];
	      dir = url.slice(0, url.lastIndexOf("/") + 1);
	    }
	    return dir;
	  };
	  /**
	 * Get the current script's URL by throwing an `Error` and analyzing it.
	 *
	 * @returns String or `undefined`
	 * @private
	 */
	  var _getCurrentScriptUrlFromErrorStack = function(stack) {
	    var url, matches;
	    if (typeof stack === "string" && stack) {
	      matches = stack.match(/^(?:|[^:@]*@|.+\)@(?=http[s]?|file)|.+?\s+(?: at |@)(?:[^:\(]+ )*[\(]?)((?:http[s]?|file):\/\/[\/]?.+?\/[^:\)]*?)(?::\d+)(?::\d+)?/);
	      if (matches && matches[1]) {
	        url = matches[1];
	      } else {
	        matches = stack.match(/\)@((?:http[s]?|file):\/\/[\/]?.+?\/[^:\)]*?)(?::\d+)(?::\d+)?/);
	        if (matches && matches[1]) {
	          url = matches[1];
	        }
	      }
	    }
	    return url;
	  };
	  /**
	 * Get the current script's URL by throwing an `Error` and analyzing it.
	 *
	 * @returns String or `undefined`
	 * @private
	 */
	  var _getCurrentScriptUrlFromError = function() {
	    var url, err;
	    try {
	      throw new _Error();
	    } catch (e) {
	      err = e;
	    }
	    if (err) {
	      url = err.sourceURL || err.fileName || _getCurrentScriptUrlFromErrorStack(err.stack);
	    }
	    return url;
	  };
	  /**
	 * Get the current script's URL.
	 *
	 * @returns String or `undefined`
	 * @private
	 */
	  var _getCurrentScriptUrl = function() {
	    var jsPath, scripts, i;
	    if (_document.currentScript && (jsPath = _document.currentScript.src)) {
	      return jsPath;
	    }
	    scripts = _document.getElementsByTagName("script");
	    if (scripts.length === 1) {
	      return scripts[0].src || undefined;
	    }
	    if ("readyState" in scripts[0]) {
	      for (i = scripts.length; i--; ) {
	        if (scripts[i].readyState === "interactive" && (jsPath = scripts[i].src)) {
	          return jsPath;
	        }
	      }
	    }
	    if (_document.readyState === "loading" && (jsPath = scripts[scripts.length - 1].src)) {
	      return jsPath;
	    }
	    if (jsPath = _getCurrentScriptUrlFromError()) {
	      return jsPath;
	    }
	    return undefined;
	  };
	  /**
	 * Get the unanimous parent directory of ALL script tags.
	 * If any script tags are either (a) inline or (b) from differing parent
	 * directories, this method must return `undefined`.
	 *
	 * @returns String or `undefined`
	 * @private
	 */
	  var _getUnanimousScriptParentDir = function() {
	    var i, jsDir, jsPath, scripts = _document.getElementsByTagName("script");
	    for (i = scripts.length; i--; ) {
	      if (!(jsPath = scripts[i].src)) {
	        jsDir = null;
	        break;
	      }
	      jsPath = _getDirPathOfUrl(jsPath);
	      if (jsDir == null) {
	        jsDir = jsPath;
	      } else if (jsDir !== jsPath) {
	        jsDir = null;
	        break;
	      }
	    }
	    return jsDir || undefined;
	  };
	  /**
	 * Get the presumed location of the "ZeroClipboard.swf" file, based on the location
	 * of the executing JavaScript file (e.g. "ZeroClipboard.js", etc.).
	 *
	 * @returns String
	 * @private
	 */
	  var _getDefaultSwfPath = function() {
	    var jsDir = _getDirPathOfUrl(_getCurrentScriptUrl()) || _getUnanimousScriptParentDir() || "";
	    return jsDir + "ZeroClipboard.swf";
	  };
	  /**
	 * Keep track of if the page is framed (in an `iframe`). This can never change.
	 * @private
	 */
	  var _pageIsFramed = function() {
	    return window.opener == null && (!!window.top && window != window.top || !!window.parent && window != window.parent);
	  }();
	  /**
	 * Keep track of the state of the Flash object.
	 * @private
	 */
	  var _flashState = {
	    bridge: null,
	    version: "0.0.0",
	    pluginType: "unknown",
	    disabled: null,
	    outdated: null,
	    sandboxed: null,
	    unavailable: null,
	    degraded: null,
	    deactivated: null,
	    overdue: null,
	    ready: null
	  };
	  /**
	 * The minimum Flash Player version required to use ZeroClipboard completely.
	 * @readonly
	 * @private
	 */
	  var _minimumFlashVersion = "11.0.0";
	  /**
	 * The ZeroClipboard library version number, as reported by Flash, at the time the SWF was compiled.
	 */
	  var _zcSwfVersion;
	  /**
	 * Keep track of all event listener registrations.
	 * @private
	 */
	  var _handlers = {};
	  /**
	 * Keep track of the currently activated element.
	 * @private
	 */
	  var _currentElement;
	  /**
	 * Keep track of the element that was activated when a `copy` process started.
	 * @private
	 */
	  var _copyTarget;
	  /**
	 * Keep track of data for the pending clipboard transaction.
	 * @private
	 */
	  var _clipData = {};
	  /**
	 * Keep track of data formats for the pending clipboard transaction.
	 * @private
	 */
	  var _clipDataFormatMap = null;
	  /**
	 * Keep track of the Flash availability check timeout.
	 * @private
	 */
	  var _flashCheckTimeout = 0;
	  /**
	 * Keep track of SWF network errors interval polling.
	 * @private
	 */
	  var _swfFallbackCheckInterval = 0;
	  /**
	 * The `message` store for events
	 * @private
	 */
	  var _eventMessages = {
	    ready: "Flash communication is established",
	    error: {
	      "flash-disabled": "Flash is disabled or not installed. May also be attempting to run Flash in a sandboxed iframe, which is impossible.",
	      "flash-outdated": "Flash is too outdated to support ZeroClipboard",
	      "flash-sandboxed": "Attempting to run Flash in a sandboxed iframe, which is impossible",
	      "flash-unavailable": "Flash is unable to communicate bidirectionally with JavaScript",
	      "flash-degraded": "Flash is unable to preserve data fidelity when communicating with JavaScript",
	      "flash-deactivated": "Flash is too outdated for your browser and/or is configured as click-to-activate.\nThis may also mean that the ZeroClipboard SWF object could not be loaded, so please check your `swfPath` configuration and/or network connectivity.\nMay also be attempting to run Flash in a sandboxed iframe, which is impossible.",
	      "flash-overdue": "Flash communication was established but NOT within the acceptable time limit",
	      "version-mismatch": "ZeroClipboard JS version number does not match ZeroClipboard SWF version number",
	      "clipboard-error": "At least one error was thrown while ZeroClipboard was attempting to inject your data into the clipboard",
	      "config-mismatch": "ZeroClipboard configuration does not match Flash's reality",
	      "swf-not-found": "The ZeroClipboard SWF object could not be loaded, so please check your `swfPath` configuration and/or network connectivity"
	    }
	  };
	  /**
	 * The `name`s of `error` events that can only occur is Flash has at least
	 * been able to load the SWF successfully.
	 * @private
	 */
	  var _errorsThatOnlyOccurAfterFlashLoads = [ "flash-unavailable", "flash-degraded", "flash-overdue", "version-mismatch", "config-mismatch", "clipboard-error" ];
	  /**
	 * The `name`s of `error` events that should likely result in the `_flashState`
	 * variable's property values being updated.
	 * @private
	 */
	  var _flashStateErrorNames = [ "flash-disabled", "flash-outdated", "flash-sandboxed", "flash-unavailable", "flash-degraded", "flash-deactivated", "flash-overdue" ];
	  /**
	 * A RegExp to match the `name` property of `error` events related to Flash.
	 * @private
	 */
	  var _flashStateErrorNameMatchingRegex = new RegExp("^flash-(" + _flashStateErrorNames.map(function(errorName) {
	    return errorName.replace(/^flash-/, "");
	  }).join("|") + ")$");
	  /**
	 * A RegExp to match the `name` property of `error` events related to Flash,
	 * which is enabled.
	 * @private
	 */
	  var _flashStateEnabledErrorNameMatchingRegex = new RegExp("^flash-(" + _flashStateErrorNames.slice(1).map(function(errorName) {
	    return errorName.replace(/^flash-/, "");
	  }).join("|") + ")$");
	  /**
	 * ZeroClipboard configuration defaults for the Core module.
	 * @private
	 */
	  var _globalConfig = {
	    swfPath: _getDefaultSwfPath(),
	    trustedDomains: window.location.host ? [ window.location.host ] : [],
	    cacheBust: true,
	    forceEnhancedClipboard: false,
	    flashLoadTimeout: 3e4,
	    autoActivate: true,
	    bubbleEvents: true,
	    containerId: "global-zeroclipboard-html-bridge",
	    containerClass: "global-zeroclipboard-container",
	    swfObjectId: "global-zeroclipboard-flash-bridge",
	    hoverClass: "zeroclipboard-is-hover",
	    activeClass: "zeroclipboard-is-active",
	    forceHandCursor: false,
	    title: null,
	    zIndex: 999999999
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.config`.
	 * @private
	 */
	  var _config = function(options) {
	    if (typeof options === "object" && options !== null) {
	      for (var prop in options) {
	        if (_hasOwn.call(options, prop)) {
	          if (/^(?:forceHandCursor|title|zIndex|bubbleEvents)$/.test(prop)) {
	            _globalConfig[prop] = options[prop];
	          } else if (_flashState.bridge == null) {
	            if (prop === "containerId" || prop === "swfObjectId") {
	              if (_isValidHtml4Id(options[prop])) {
	                _globalConfig[prop] = options[prop];
	              } else {
	                throw new Error("The specified `" + prop + "` value is not valid as an HTML4 Element ID");
	              }
	            } else {
	              _globalConfig[prop] = options[prop];
	            }
	          }
	        }
	      }
	    }
	    if (typeof options === "string" && options) {
	      if (_hasOwn.call(_globalConfig, options)) {
	        return _globalConfig[options];
	      }
	      return;
	    }
	    return _deepCopy(_globalConfig);
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.state`.
	 * @private
	 */
	  var _state = function() {
	    _detectSandbox();
	    return {
	      browser: _pick(_navigator, [ "userAgent", "platform", "appName" ]),
	      flash: _omit(_flashState, [ "bridge" ]),
	      zeroclipboard: {
	        version: ZeroClipboard.version,
	        config: ZeroClipboard.config()
	      }
	    };
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.isFlashUnusable`.
	 * @private
	 */
	  var _isFlashUnusable = function() {
	    return !!(_flashState.disabled || _flashState.outdated || _flashState.sandboxed || _flashState.unavailable || _flashState.degraded || _flashState.deactivated);
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.on`.
	 * @private
	 */
	  var _on = function(eventType, listener) {
	    var i, len, events, added = {};
	    if (typeof eventType === "string" && eventType) {
	      events = eventType.toLowerCase().split(/\s+/);
	    } else if (typeof eventType === "object" && eventType && typeof listener === "undefined") {
	      for (i in eventType) {
	        if (_hasOwn.call(eventType, i) && typeof i === "string" && i && typeof eventType[i] === "function") {
	          ZeroClipboard.on(i, eventType[i]);
	        }
	      }
	    }
	    if (events && events.length) {
	      for (i = 0, len = events.length; i < len; i++) {
	        eventType = events[i].replace(/^on/, "");
	        added[eventType] = true;
	        if (!_handlers[eventType]) {
	          _handlers[eventType] = [];
	        }
	        _handlers[eventType].push(listener);
	      }
	      if (added.ready && _flashState.ready) {
	        ZeroClipboard.emit({
	          type: "ready"
	        });
	      }
	      if (added.error) {
	        for (i = 0, len = _flashStateErrorNames.length; i < len; i++) {
	          if (_flashState[_flashStateErrorNames[i].replace(/^flash-/, "")] === true) {
	            ZeroClipboard.emit({
	              type: "error",
	              name: _flashStateErrorNames[i]
	            });
	            break;
	          }
	        }
	        if (_zcSwfVersion !== undefined && ZeroClipboard.version !== _zcSwfVersion) {
	          ZeroClipboard.emit({
	            type: "error",
	            name: "version-mismatch",
	            jsVersion: ZeroClipboard.version,
	            swfVersion: _zcSwfVersion
	          });
	        }
	      }
	    }
	    return ZeroClipboard;
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.off`.
	 * @private
	 */
	  var _off = function(eventType, listener) {
	    var i, len, foundIndex, events, perEventHandlers;
	    if (arguments.length === 0) {
	      events = _keys(_handlers);
	    } else if (typeof eventType === "string" && eventType) {
	      events = eventType.split(/\s+/);
	    } else if (typeof eventType === "object" && eventType && typeof listener === "undefined") {
	      for (i in eventType) {
	        if (_hasOwn.call(eventType, i) && typeof i === "string" && i && typeof eventType[i] === "function") {
	          ZeroClipboard.off(i, eventType[i]);
	        }
	      }
	    }
	    if (events && events.length) {
	      for (i = 0, len = events.length; i < len; i++) {
	        eventType = events[i].toLowerCase().replace(/^on/, "");
	        perEventHandlers = _handlers[eventType];
	        if (perEventHandlers && perEventHandlers.length) {
	          if (listener) {
	            foundIndex = perEventHandlers.indexOf(listener);
	            while (foundIndex !== -1) {
	              perEventHandlers.splice(foundIndex, 1);
	              foundIndex = perEventHandlers.indexOf(listener, foundIndex);
	            }
	          } else {
	            perEventHandlers.length = 0;
	          }
	        }
	      }
	    }
	    return ZeroClipboard;
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.handlers`.
	 * @private
	 */
	  var _listeners = function(eventType) {
	    var copy;
	    if (typeof eventType === "string" && eventType) {
	      copy = _deepCopy(_handlers[eventType]) || null;
	    } else {
	      copy = _deepCopy(_handlers);
	    }
	    return copy;
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.emit`.
	 * @private
	 */
	  var _emit = function(event) {
	    var eventCopy, returnVal, tmp;
	    event = _createEvent(event);
	    if (!event) {
	      return;
	    }
	    if (_preprocessEvent(event)) {
	      return;
	    }
	    if (event.type === "ready" && _flashState.overdue === true) {
	      return ZeroClipboard.emit({
	        type: "error",
	        name: "flash-overdue"
	      });
	    }
	    eventCopy = _extend({}, event);
	    _dispatchCallbacks.call(this, eventCopy);
	    if (event.type === "copy") {
	      tmp = _mapClipDataToFlash(_clipData);
	      returnVal = tmp.data;
	      _clipDataFormatMap = tmp.formatMap;
	    }
	    return returnVal;
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.create`.
	 * @private
	 */
	  var _create = function() {
	    var previousState = _flashState.sandboxed;
	    _detectSandbox();
	    if (typeof _flashState.ready !== "boolean") {
	      _flashState.ready = false;
	    }
	    if (_flashState.sandboxed !== previousState && _flashState.sandboxed === true) {
	      _flashState.ready = false;
	      ZeroClipboard.emit({
	        type: "error",
	        name: "flash-sandboxed"
	      });
	    } else if (!ZeroClipboard.isFlashUnusable() && _flashState.bridge === null) {
	      var maxWait = _globalConfig.flashLoadTimeout;
	      if (typeof maxWait === "number" && maxWait >= 0) {
	        _flashCheckTimeout = _setTimeout(function() {
	          if (typeof _flashState.deactivated !== "boolean") {
	            _flashState.deactivated = true;
	          }
	          if (_flashState.deactivated === true) {
	            ZeroClipboard.emit({
	              type: "error",
	              name: "flash-deactivated"
	            });
	          }
	        }, maxWait);
	      }
	      _flashState.overdue = false;
	      _embedSwf();
	    }
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.destroy`.
	 * @private
	 */
	  var _destroy = function() {
	    ZeroClipboard.clearData();
	    ZeroClipboard.blur();
	    ZeroClipboard.emit("destroy");
	    _unembedSwf();
	    ZeroClipboard.off();
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.setData`.
	 * @private
	 */
	  var _setData = function(format, data) {
	    var dataObj;
	    if (typeof format === "object" && format && typeof data === "undefined") {
	      dataObj = format;
	      ZeroClipboard.clearData();
	    } else if (typeof format === "string" && format) {
	      dataObj = {};
	      dataObj[format] = data;
	    } else {
	      return;
	    }
	    for (var dataFormat in dataObj) {
	      if (typeof dataFormat === "string" && dataFormat && _hasOwn.call(dataObj, dataFormat) && typeof dataObj[dataFormat] === "string" && dataObj[dataFormat]) {
	        _clipData[dataFormat] = dataObj[dataFormat];
	      }
	    }
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.clearData`.
	 * @private
	 */
	  var _clearData = function(format) {
	    if (typeof format === "undefined") {
	      _deleteOwnProperties(_clipData);
	      _clipDataFormatMap = null;
	    } else if (typeof format === "string" && _hasOwn.call(_clipData, format)) {
	      delete _clipData[format];
	    }
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.getData`.
	 * @private
	 */
	  var _getData = function(format) {
	    if (typeof format === "undefined") {
	      return _deepCopy(_clipData);
	    } else if (typeof format === "string" && _hasOwn.call(_clipData, format)) {
	      return _clipData[format];
	    }
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.focus`/`ZeroClipboard.activate`.
	 * @private
	 */
	  var _focus = function(element) {
	    if (!(element && element.nodeType === 1)) {
	      return;
	    }
	    if (_currentElement) {
	      _removeClass(_currentElement, _globalConfig.activeClass);
	      if (_currentElement !== element) {
	        _removeClass(_currentElement, _globalConfig.hoverClass);
	      }
	    }
	    _currentElement = element;
	    _addClass(element, _globalConfig.hoverClass);
	    var newTitle = element.getAttribute("title") || _globalConfig.title;
	    if (typeof newTitle === "string" && newTitle) {
	      var htmlBridge = _getHtmlBridge(_flashState.bridge);
	      if (htmlBridge) {
	        htmlBridge.setAttribute("title", newTitle);
	      }
	    }
	    var useHandCursor = _globalConfig.forceHandCursor === true || _getStyle(element, "cursor") === "pointer";
	    _setHandCursor(useHandCursor);
	    _reposition();
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.blur`/`ZeroClipboard.deactivate`.
	 * @private
	 */
	  var _blur = function() {
	    var htmlBridge = _getHtmlBridge(_flashState.bridge);
	    if (htmlBridge) {
	      htmlBridge.removeAttribute("title");
	      htmlBridge.style.left = "0px";
	      htmlBridge.style.top = "-9999px";
	      htmlBridge.style.width = "1px";
	      htmlBridge.style.height = "1px";
	    }
	    if (_currentElement) {
	      _removeClass(_currentElement, _globalConfig.hoverClass);
	      _removeClass(_currentElement, _globalConfig.activeClass);
	      _currentElement = null;
	    }
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.activeElement`.
	 * @private
	 */
	  var _activeElement = function() {
	    return _currentElement || null;
	  };
	  /**
	 * Check if a value is a valid HTML4 `ID` or `Name` token.
	 * @private
	 */
	  var _isValidHtml4Id = function(id) {
	    return typeof id === "string" && id && /^[A-Za-z][A-Za-z0-9_:\-\.]*$/.test(id);
	  };
	  /**
	 * Create or update an `event` object, based on the `eventType`.
	 * @private
	 */
	  var _createEvent = function(event) {
	    var eventType;
	    if (typeof event === "string" && event) {
	      eventType = event;
	      event = {};
	    } else if (typeof event === "object" && event && typeof event.type === "string" && event.type) {
	      eventType = event.type;
	    }
	    if (!eventType) {
	      return;
	    }
	    eventType = eventType.toLowerCase();
	    if (!event.target && (/^(copy|aftercopy|_click)$/.test(eventType) || eventType === "error" && event.name === "clipboard-error")) {
	      event.target = _copyTarget;
	    }
	    _extend(event, {
	      type: eventType,
	      target: event.target || _currentElement || null,
	      relatedTarget: event.relatedTarget || null,
	      currentTarget: _flashState && _flashState.bridge || null,
	      timeStamp: event.timeStamp || _now() || null
	    });
	    var msg = _eventMessages[event.type];
	    if (event.type === "error" && event.name && msg) {
	      msg = msg[event.name];
	    }
	    if (msg) {
	      event.message = msg;
	    }
	    if (event.type === "ready") {
	      _extend(event, {
	        target: null,
	        version: _flashState.version
	      });
	    }
	    if (event.type === "error") {
	      if (_flashStateErrorNameMatchingRegex.test(event.name)) {
	        _extend(event, {
	          target: null,
	          minimumVersion: _minimumFlashVersion
	        });
	      }
	      if (_flashStateEnabledErrorNameMatchingRegex.test(event.name)) {
	        _extend(event, {
	          version: _flashState.version
	        });
	      }
	    }
	    if (event.type === "copy") {
	      event.clipboardData = {
	        setData: ZeroClipboard.setData,
	        clearData: ZeroClipboard.clearData
	      };
	    }
	    if (event.type === "aftercopy") {
	      event = _mapClipResultsFromFlash(event, _clipDataFormatMap);
	    }
	    if (event.target && !event.relatedTarget) {
	      event.relatedTarget = _getRelatedTarget(event.target);
	    }
	    return _addMouseData(event);
	  };
	  /**
	 * Get a relatedTarget from the target's `data-clipboard-target` attribute
	 * @private
	 */
	  var _getRelatedTarget = function(targetEl) {
	    var relatedTargetId = targetEl && targetEl.getAttribute && targetEl.getAttribute("data-clipboard-target");
	    return relatedTargetId ? _document.getElementById(relatedTargetId) : null;
	  };
	  /**
	 * Add element and position data to `MouseEvent` instances
	 * @private
	 */
	  var _addMouseData = function(event) {
	    if (event && /^_(?:click|mouse(?:over|out|down|up|move))$/.test(event.type)) {
	      var srcElement = event.target;
	      var fromElement = event.type === "_mouseover" && event.relatedTarget ? event.relatedTarget : undefined;
	      var toElement = event.type === "_mouseout" && event.relatedTarget ? event.relatedTarget : undefined;
	      var pos = _getElementPosition(srcElement);
	      var screenLeft = _window.screenLeft || _window.screenX || 0;
	      var screenTop = _window.screenTop || _window.screenY || 0;
	      var scrollLeft = _document.body.scrollLeft + _document.documentElement.scrollLeft;
	      var scrollTop = _document.body.scrollTop + _document.documentElement.scrollTop;
	      var pageX = pos.left + (typeof event._stageX === "number" ? event._stageX : 0);
	      var pageY = pos.top + (typeof event._stageY === "number" ? event._stageY : 0);
	      var clientX = pageX - scrollLeft;
	      var clientY = pageY - scrollTop;
	      var screenX = screenLeft + clientX;
	      var screenY = screenTop + clientY;
	      var moveX = typeof event.movementX === "number" ? event.movementX : 0;
	      var moveY = typeof event.movementY === "number" ? event.movementY : 0;
	      delete event._stageX;
	      delete event._stageY;
	      _extend(event, {
	        srcElement: srcElement,
	        fromElement: fromElement,
	        toElement: toElement,
	        screenX: screenX,
	        screenY: screenY,
	        pageX: pageX,
	        pageY: pageY,
	        clientX: clientX,
	        clientY: clientY,
	        x: clientX,
	        y: clientY,
	        movementX: moveX,
	        movementY: moveY,
	        offsetX: 0,
	        offsetY: 0,
	        layerX: 0,
	        layerY: 0
	      });
	    }
	    return event;
	  };
	  /**
	 * Determine if an event's registered handlers should be execute synchronously or asynchronously.
	 *
	 * @returns {boolean}
	 * @private
	 */
	  var _shouldPerformAsync = function(event) {
	    var eventType = event && typeof event.type === "string" && event.type || "";
	    return !/^(?:(?:before)?copy|destroy)$/.test(eventType);
	  };
	  /**
	 * Control if a callback should be executed asynchronously or not.
	 *
	 * @returns `undefined`
	 * @private
	 */
	  var _dispatchCallback = function(func, context, args, async) {
	    if (async) {
	      _setTimeout(function() {
	        func.apply(context, args);
	      }, 0);
	    } else {
	      func.apply(context, args);
	    }
	  };
	  /**
	 * Handle the actual dispatching of events to client instances.
	 *
	 * @returns `undefined`
	 * @private
	 */
	  var _dispatchCallbacks = function(event) {
	    if (!(typeof event === "object" && event && event.type)) {
	      return;
	    }
	    var async = _shouldPerformAsync(event);
	    var wildcardTypeHandlers = _handlers["*"] || [];
	    var specificTypeHandlers = _handlers[event.type] || [];
	    var handlers = wildcardTypeHandlers.concat(specificTypeHandlers);
	    if (handlers && handlers.length) {
	      var i, len, func, context, eventCopy, originalContext = this;
	      for (i = 0, len = handlers.length; i < len; i++) {
	        func = handlers[i];
	        context = originalContext;
	        if (typeof func === "string" && typeof _window[func] === "function") {
	          func = _window[func];
	        }
	        if (typeof func === "object" && func && typeof func.handleEvent === "function") {
	          context = func;
	          func = func.handleEvent;
	        }
	        if (typeof func === "function") {
	          eventCopy = _extend({}, event);
	          _dispatchCallback(func, context, [ eventCopy ], async);
	        }
	      }
	    }
	    return this;
	  };
	  /**
	 * Check an `error` event's `name` property to see if Flash has
	 * already loaded, which rules out possible `iframe` sandboxing.
	 * @private
	 */
	  var _getSandboxStatusFromErrorEvent = function(event) {
	    var isSandboxed = null;
	    if (_pageIsFramed === false || event && event.type === "error" && event.name && _errorsThatOnlyOccurAfterFlashLoads.indexOf(event.name) !== -1) {
	      isSandboxed = false;
	    }
	    return isSandboxed;
	  };
	  /**
	 * Preprocess any special behaviors, reactions, or state changes after receiving this event.
	 * Executes only once per event emitted, NOT once per client.
	 * @private
	 */
	  var _preprocessEvent = function(event) {
	    var element = event.target || _currentElement || null;
	    var sourceIsSwf = event._source === "swf";
	    delete event._source;
	    switch (event.type) {
	     case "error":
	      var isSandboxed = event.name === "flash-sandboxed" || _getSandboxStatusFromErrorEvent(event);
	      if (typeof isSandboxed === "boolean") {
	        _flashState.sandboxed = isSandboxed;
	      }
	      if (_flashStateErrorNames.indexOf(event.name) !== -1) {
	        _extend(_flashState, {
	          disabled: event.name === "flash-disabled",
	          outdated: event.name === "flash-outdated",
	          unavailable: event.name === "flash-unavailable",
	          degraded: event.name === "flash-degraded",
	          deactivated: event.name === "flash-deactivated",
	          overdue: event.name === "flash-overdue",
	          ready: false
	        });
	      } else if (event.name === "version-mismatch") {
	        _zcSwfVersion = event.swfVersion;
	        _extend(_flashState, {
	          disabled: false,
	          outdated: false,
	          unavailable: false,
	          degraded: false,
	          deactivated: false,
	          overdue: false,
	          ready: false
	        });
	      }
	      _clearTimeoutsAndPolling();
	      break;
	
	     case "ready":
	      _zcSwfVersion = event.swfVersion;
	      var wasDeactivated = _flashState.deactivated === true;
	      _extend(_flashState, {
	        disabled: false,
	        outdated: false,
	        sandboxed: false,
	        unavailable: false,
	        degraded: false,
	        deactivated: false,
	        overdue: wasDeactivated,
	        ready: !wasDeactivated
	      });
	      _clearTimeoutsAndPolling();
	      break;
	
	     case "beforecopy":
	      _copyTarget = element;
	      break;
	
	     case "copy":
	      var textContent, htmlContent, targetEl = event.relatedTarget;
	      if (!(_clipData["text/html"] || _clipData["text/plain"]) && targetEl && (htmlContent = targetEl.value || targetEl.outerHTML || targetEl.innerHTML) && (textContent = targetEl.value || targetEl.textContent || targetEl.innerText)) {
	        event.clipboardData.clearData();
	        event.clipboardData.setData("text/plain", textContent);
	        if (htmlContent !== textContent) {
	          event.clipboardData.setData("text/html", htmlContent);
	        }
	      } else if (!_clipData["text/plain"] && event.target && (textContent = event.target.getAttribute("data-clipboard-text"))) {
	        event.clipboardData.clearData();
	        event.clipboardData.setData("text/plain", textContent);
	      }
	      break;
	
	     case "aftercopy":
	      _queueEmitClipboardErrors(event);
	      ZeroClipboard.clearData();
	      if (element && element !== _safeActiveElement() && element.focus) {
	        element.focus();
	      }
	      break;
	
	     case "_mouseover":
	      ZeroClipboard.focus(element);
	      if (_globalConfig.bubbleEvents === true && sourceIsSwf) {
	        if (element && element !== event.relatedTarget && !_containedBy(event.relatedTarget, element)) {
	          _fireMouseEvent(_extend({}, event, {
	            type: "mouseenter",
	            bubbles: false,
	            cancelable: false
	          }));
	        }
	        _fireMouseEvent(_extend({}, event, {
	          type: "mouseover"
	        }));
	      }
	      break;
	
	     case "_mouseout":
	      ZeroClipboard.blur();
	      if (_globalConfig.bubbleEvents === true && sourceIsSwf) {
	        if (element && element !== event.relatedTarget && !_containedBy(event.relatedTarget, element)) {
	          _fireMouseEvent(_extend({}, event, {
	            type: "mouseleave",
	            bubbles: false,
	            cancelable: false
	          }));
	        }
	        _fireMouseEvent(_extend({}, event, {
	          type: "mouseout"
	        }));
	      }
	      break;
	
	     case "_mousedown":
	      _addClass(element, _globalConfig.activeClass);
	      if (_globalConfig.bubbleEvents === true && sourceIsSwf) {
	        _fireMouseEvent(_extend({}, event, {
	          type: event.type.slice(1)
	        }));
	      }
	      break;
	
	     case "_mouseup":
	      _removeClass(element, _globalConfig.activeClass);
	      if (_globalConfig.bubbleEvents === true && sourceIsSwf) {
	        _fireMouseEvent(_extend({}, event, {
	          type: event.type.slice(1)
	        }));
	      }
	      break;
	
	     case "_click":
	      _copyTarget = null;
	      if (_globalConfig.bubbleEvents === true && sourceIsSwf) {
	        _fireMouseEvent(_extend({}, event, {
	          type: event.type.slice(1)
	        }));
	      }
	      break;
	
	     case "_mousemove":
	      if (_globalConfig.bubbleEvents === true && sourceIsSwf) {
	        _fireMouseEvent(_extend({}, event, {
	          type: event.type.slice(1)
	        }));
	      }
	      break;
	    }
	    if (/^_(?:click|mouse(?:over|out|down|up|move))$/.test(event.type)) {
	      return true;
	    }
	  };
	  /**
	 * Check an "aftercopy" event for clipboard errors and emit a corresponding "error" event.
	 * @private
	 */
	  var _queueEmitClipboardErrors = function(aftercopyEvent) {
	    if (aftercopyEvent.errors && aftercopyEvent.errors.length > 0) {
	      var errorEvent = _deepCopy(aftercopyEvent);
	      _extend(errorEvent, {
	        type: "error",
	        name: "clipboard-error"
	      });
	      delete errorEvent.success;
	      _setTimeout(function() {
	        ZeroClipboard.emit(errorEvent);
	      }, 0);
	    }
	  };
	  /**
	 * Dispatch a synthetic MouseEvent.
	 *
	 * @returns `undefined`
	 * @private
	 */
	  var _fireMouseEvent = function(event) {
	    if (!(event && typeof event.type === "string" && event)) {
	      return;
	    }
	    var e, target = event.target || null, doc = target && target.ownerDocument || _document, defaults = {
	      view: doc.defaultView || _window,
	      canBubble: true,
	      cancelable: true,
	      detail: event.type === "click" ? 1 : 0,
	      button: typeof event.which === "number" ? event.which - 1 : typeof event.button === "number" ? event.button : doc.createEvent ? 0 : 1
	    }, args = _extend(defaults, event);
	    if (!target) {
	      return;
	    }
	    if (doc.createEvent && target.dispatchEvent) {
	      args = [ args.type, args.canBubble, args.cancelable, args.view, args.detail, args.screenX, args.screenY, args.clientX, args.clientY, args.ctrlKey, args.altKey, args.shiftKey, args.metaKey, args.button, args.relatedTarget ];
	      e = doc.createEvent("MouseEvents");
	      if (e.initMouseEvent) {
	        e.initMouseEvent.apply(e, args);
	        e._source = "js";
	        target.dispatchEvent(e);
	      }
	    }
	  };
	  /**
	 * Continuously poll the DOM until either:
	 *  (a) the fallback content becomes visible, or
	 *  (b) we receive an event from SWF (handled elsewhere)
	 *
	 * IMPORTANT:
	 * This is NOT a necessary check but it can result in significantly faster
	 * detection of bad `swfPath` configuration and/or network/server issues [in
	 * supported browsers] than waiting for the entire `flashLoadTimeout` duration
	 * to elapse before detecting that the SWF cannot be loaded. The detection
	 * duration can be anywhere from 10-30 times faster [in supported browsers] by
	 * using this approach.
	 *
	 * @returns `undefined`
	 * @private
	 */
	  var _watchForSwfFallbackContent = function() {
	    var maxWait = _globalConfig.flashLoadTimeout;
	    if (typeof maxWait === "number" && maxWait >= 0) {
	      var pollWait = Math.min(1e3, maxWait / 10);
	      var fallbackContentId = _globalConfig.swfObjectId + "_fallbackContent";
	      _swfFallbackCheckInterval = _setInterval(function() {
	        var el = _document.getElementById(fallbackContentId);
	        if (_isElementVisible(el)) {
	          _clearTimeoutsAndPolling();
	          _flashState.deactivated = null;
	          ZeroClipboard.emit({
	            type: "error",
	            name: "swf-not-found"
	          });
	        }
	      }, pollWait);
	    }
	  };
	  /**
	 * Create the HTML bridge element to embed the Flash object into.
	 * @private
	 */
	  var _createHtmlBridge = function() {
	    var container = _document.createElement("div");
	    container.id = _globalConfig.containerId;
	    container.className = _globalConfig.containerClass;
	    container.style.position = "absolute";
	    container.style.left = "0px";
	    container.style.top = "-9999px";
	    container.style.width = "1px";
	    container.style.height = "1px";
	    container.style.zIndex = "" + _getSafeZIndex(_globalConfig.zIndex);
	    return container;
	  };
	  /**
	 * Get the HTML element container that wraps the Flash bridge object/element.
	 * @private
	 */
	  var _getHtmlBridge = function(flashBridge) {
	    var htmlBridge = flashBridge && flashBridge.parentNode;
	    while (htmlBridge && htmlBridge.nodeName === "OBJECT" && htmlBridge.parentNode) {
	      htmlBridge = htmlBridge.parentNode;
	    }
	    return htmlBridge || null;
	  };
	  /**
	 * Create the SWF object.
	 *
	 * @returns The SWF object reference.
	 * @private
	 */
	  var _embedSwf = function() {
	    var len, flashBridge = _flashState.bridge, container = _getHtmlBridge(flashBridge);
	    if (!flashBridge) {
	      var allowScriptAccess = _determineScriptAccess(_window.location.host, _globalConfig);
	      var allowNetworking = allowScriptAccess === "never" ? "none" : "all";
	      var flashvars = _vars(_extend({
	        jsVersion: ZeroClipboard.version
	      }, _globalConfig));
	      var swfUrl = _globalConfig.swfPath + _cacheBust(_globalConfig.swfPath, _globalConfig);
	      container = _createHtmlBridge();
	      var divToBeReplaced = _document.createElement("div");
	      container.appendChild(divToBeReplaced);
	      _document.body.appendChild(container);
	      var tmpDiv = _document.createElement("div");
	      var usingActiveX = _flashState.pluginType === "activex";
	      tmpDiv.innerHTML = '<object id="' + _globalConfig.swfObjectId + '" name="' + _globalConfig.swfObjectId + '" ' + 'width="100%" height="100%" ' + (usingActiveX ? 'classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000"' : 'type="application/x-shockwave-flash" data="' + swfUrl + '"') + ">" + (usingActiveX ? '<param name="movie" value="' + swfUrl + '"/>' : "") + '<param name="allowScriptAccess" value="' + allowScriptAccess + '"/>' + '<param name="allowNetworking" value="' + allowNetworking + '"/>' + '<param name="menu" value="false"/>' + '<param name="wmode" value="transparent"/>' + '<param name="flashvars" value="' + flashvars + '"/>' + '<div id="' + _globalConfig.swfObjectId + '_fallbackContent">&nbsp;</div>' + "</object>";
	      flashBridge = tmpDiv.firstChild;
	      tmpDiv = null;
	      _unwrap(flashBridge).ZeroClipboard = ZeroClipboard;
	      container.replaceChild(flashBridge, divToBeReplaced);
	      _watchForSwfFallbackContent();
	    }
	    if (!flashBridge) {
	      flashBridge = _document[_globalConfig.swfObjectId];
	      if (flashBridge && (len = flashBridge.length)) {
	        flashBridge = flashBridge[len - 1];
	      }
	      if (!flashBridge && container) {
	        flashBridge = container.firstChild;
	      }
	    }
	    _flashState.bridge = flashBridge || null;
	    return flashBridge;
	  };
	  /**
	 * Destroy the SWF object.
	 * @private
	 */
	  var _unembedSwf = function() {
	    var flashBridge = _flashState.bridge;
	    if (flashBridge) {
	      var htmlBridge = _getHtmlBridge(flashBridge);
	      if (htmlBridge) {
	        if (_flashState.pluginType === "activex" && "readyState" in flashBridge) {
	          flashBridge.style.display = "none";
	          (function removeSwfFromIE() {
	            if (flashBridge.readyState === 4) {
	              for (var prop in flashBridge) {
	                if (typeof flashBridge[prop] === "function") {
	                  flashBridge[prop] = null;
	                }
	              }
	              if (flashBridge.parentNode) {
	                flashBridge.parentNode.removeChild(flashBridge);
	              }
	              if (htmlBridge.parentNode) {
	                htmlBridge.parentNode.removeChild(htmlBridge);
	              }
	            } else {
	              _setTimeout(removeSwfFromIE, 10);
	            }
	          })();
	        } else {
	          if (flashBridge.parentNode) {
	            flashBridge.parentNode.removeChild(flashBridge);
	          }
	          if (htmlBridge.parentNode) {
	            htmlBridge.parentNode.removeChild(htmlBridge);
	          }
	        }
	      }
	      _clearTimeoutsAndPolling();
	      _flashState.ready = null;
	      _flashState.bridge = null;
	      _flashState.deactivated = null;
	      _zcSwfVersion = undefined;
	    }
	  };
	  /**
	 * Map the data format names of the "clipData" to Flash-friendly names.
	 *
	 * @returns A new transformed object.
	 * @private
	 */
	  var _mapClipDataToFlash = function(clipData) {
	    var newClipData = {}, formatMap = {};
	    if (!(typeof clipData === "object" && clipData)) {
	      return;
	    }
	    for (var dataFormat in clipData) {
	      if (dataFormat && _hasOwn.call(clipData, dataFormat) && typeof clipData[dataFormat] === "string" && clipData[dataFormat]) {
	        switch (dataFormat.toLowerCase()) {
	         case "text/plain":
	         case "text":
	         case "air:text":
	         case "flash:text":
	          newClipData.text = clipData[dataFormat];
	          formatMap.text = dataFormat;
	          break;
	
	         case "text/html":
	         case "html":
	         case "air:html":
	         case "flash:html":
	          newClipData.html = clipData[dataFormat];
	          formatMap.html = dataFormat;
	          break;
	
	         case "application/rtf":
	         case "text/rtf":
	         case "rtf":
	         case "richtext":
	         case "air:rtf":
	         case "flash:rtf":
	          newClipData.rtf = clipData[dataFormat];
	          formatMap.rtf = dataFormat;
	          break;
	
	         default:
	          break;
	        }
	      }
	    }
	    return {
	      data: newClipData,
	      formatMap: formatMap
	    };
	  };
	  /**
	 * Map the data format names from Flash-friendly names back to their original "clipData" names (via a format mapping).
	 *
	 * @returns A new transformed object.
	 * @private
	 */
	  var _mapClipResultsFromFlash = function(clipResults, formatMap) {
	    if (!(typeof clipResults === "object" && clipResults && typeof formatMap === "object" && formatMap)) {
	      return clipResults;
	    }
	    var newResults = {};
	    for (var prop in clipResults) {
	      if (_hasOwn.call(clipResults, prop)) {
	        if (prop === "errors") {
	          newResults[prop] = clipResults[prop] ? clipResults[prop].slice() : [];
	          for (var i = 0, len = newResults[prop].length; i < len; i++) {
	            newResults[prop][i].format = formatMap[newResults[prop][i].format];
	          }
	        } else if (prop !== "success" && prop !== "data") {
	          newResults[prop] = clipResults[prop];
	        } else {
	          newResults[prop] = {};
	          var tmpHash = clipResults[prop];
	          for (var dataFormat in tmpHash) {
	            if (dataFormat && _hasOwn.call(tmpHash, dataFormat) && _hasOwn.call(formatMap, dataFormat)) {
	              newResults[prop][formatMap[dataFormat]] = tmpHash[dataFormat];
	            }
	          }
	        }
	      }
	    }
	    return newResults;
	  };
	  /**
	 * Will look at a path, and will create a "?noCache={time}" or "&noCache={time}"
	 * query param string to return. Does NOT append that string to the original path.
	 * This is useful because ExternalInterface often breaks when a Flash SWF is cached.
	 *
	 * @returns The `noCache` query param with necessary "?"/"&" prefix.
	 * @private
	 */
	  var _cacheBust = function(path, options) {
	    var cacheBust = options == null || options && options.cacheBust === true;
	    if (cacheBust) {
	      return (path.indexOf("?") === -1 ? "?" : "&") + "noCache=" + _now();
	    } else {
	      return "";
	    }
	  };
	  /**
	 * Creates a query string for the FlashVars param.
	 * Does NOT include the cache-busting query param.
	 *
	 * @returns FlashVars query string
	 * @private
	 */
	  var _vars = function(options) {
	    var i, len, domain, domains, str = "", trustedOriginsExpanded = [];
	    if (options.trustedDomains) {
	      if (typeof options.trustedDomains === "string") {
	        domains = [ options.trustedDomains ];
	      } else if (typeof options.trustedDomains === "object" && "length" in options.trustedDomains) {
	        domains = options.trustedDomains;
	      }
	    }
	    if (domains && domains.length) {
	      for (i = 0, len = domains.length; i < len; i++) {
	        if (_hasOwn.call(domains, i) && domains[i] && typeof domains[i] === "string") {
	          domain = _extractDomain(domains[i]);
	          if (!domain) {
	            continue;
	          }
	          if (domain === "*") {
	            trustedOriginsExpanded.length = 0;
	            trustedOriginsExpanded.push(domain);
	            break;
	          }
	          trustedOriginsExpanded.push.apply(trustedOriginsExpanded, [ domain, "//" + domain, _window.location.protocol + "//" + domain ]);
	        }
	      }
	    }
	    if (trustedOriginsExpanded.length) {
	      str += "trustedOrigins=" + _encodeURIComponent(trustedOriginsExpanded.join(","));
	    }
	    if (options.forceEnhancedClipboard === true) {
	      str += (str ? "&" : "") + "forceEnhancedClipboard=true";
	    }
	    if (typeof options.swfObjectId === "string" && options.swfObjectId) {
	      str += (str ? "&" : "") + "swfObjectId=" + _encodeURIComponent(options.swfObjectId);
	    }
	    if (typeof options.jsVersion === "string" && options.jsVersion) {
	      str += (str ? "&" : "") + "jsVersion=" + _encodeURIComponent(options.jsVersion);
	    }
	    return str;
	  };
	  /**
	 * Extract the domain (e.g. "github.com") from an origin (e.g. "https://github.com") or
	 * URL (e.g. "https://github.com/zeroclipboard/zeroclipboard/").
	 *
	 * @returns the domain
	 * @private
	 */
	  var _extractDomain = function(originOrUrl) {
	    if (originOrUrl == null || originOrUrl === "") {
	      return null;
	    }
	    originOrUrl = originOrUrl.replace(/^\s+|\s+$/g, "");
	    if (originOrUrl === "") {
	      return null;
	    }
	    var protocolIndex = originOrUrl.indexOf("//");
	    originOrUrl = protocolIndex === -1 ? originOrUrl : originOrUrl.slice(protocolIndex + 2);
	    var pathIndex = originOrUrl.indexOf("/");
	    originOrUrl = pathIndex === -1 ? originOrUrl : protocolIndex === -1 || pathIndex === 0 ? null : originOrUrl.slice(0, pathIndex);
	    if (originOrUrl && originOrUrl.slice(-4).toLowerCase() === ".swf") {
	      return null;
	    }
	    return originOrUrl || null;
	  };
	  /**
	 * Set `allowScriptAccess` based on `trustedDomains` and `window.location.host` vs. `swfPath`.
	 *
	 * @returns The appropriate script access level.
	 * @private
	 */
	  var _determineScriptAccess = function() {
	    var _extractAllDomains = function(origins) {
	      var i, len, tmp, resultsArray = [];
	      if (typeof origins === "string") {
	        origins = [ origins ];
	      }
	      if (!(typeof origins === "object" && origins && typeof origins.length === "number")) {
	        return resultsArray;
	      }
	      for (i = 0, len = origins.length; i < len; i++) {
	        if (_hasOwn.call(origins, i) && (tmp = _extractDomain(origins[i]))) {
	          if (tmp === "*") {
	            resultsArray.length = 0;
	            resultsArray.push("*");
	            break;
	          }
	          if (resultsArray.indexOf(tmp) === -1) {
	            resultsArray.push(tmp);
	          }
	        }
	      }
	      return resultsArray;
	    };
	    return function(currentDomain, configOptions) {
	      var swfDomain = _extractDomain(configOptions.swfPath);
	      if (swfDomain === null) {
	        swfDomain = currentDomain;
	      }
	      var trustedDomains = _extractAllDomains(configOptions.trustedDomains);
	      var len = trustedDomains.length;
	      if (len > 0) {
	        if (len === 1 && trustedDomains[0] === "*") {
	          return "always";
	        }
	        if (trustedDomains.indexOf(currentDomain) !== -1) {
	          if (len === 1 && currentDomain === swfDomain) {
	            return "sameDomain";
	          }
	          return "always";
	        }
	      }
	      return "never";
	    };
	  }();
	  /**
	 * Get the currently active/focused DOM element.
	 *
	 * @returns the currently active/focused element, or `null`
	 * @private
	 */
	  var _safeActiveElement = function() {
	    try {
	      return _document.activeElement;
	    } catch (err) {
	      return null;
	    }
	  };
	  /**
	 * Add a class to an element, if it doesn't already have it.
	 *
	 * @returns The element, with its new class added.
	 * @private
	 */
	  var _addClass = function(element, value) {
	    var c, cl, className, classNames = [];
	    if (typeof value === "string" && value) {
	      classNames = value.split(/\s+/);
	    }
	    if (element && element.nodeType === 1 && classNames.length > 0) {
	      if (element.classList) {
	        for (c = 0, cl = classNames.length; c < cl; c++) {
	          element.classList.add(classNames[c]);
	        }
	      } else if (element.hasOwnProperty("className")) {
	        className = " " + element.className + " ";
	        for (c = 0, cl = classNames.length; c < cl; c++) {
	          if (className.indexOf(" " + classNames[c] + " ") === -1) {
	            className += classNames[c] + " ";
	          }
	        }
	        element.className = className.replace(/^\s+|\s+$/g, "");
	      }
	    }
	    return element;
	  };
	  /**
	 * Remove a class from an element, if it has it.
	 *
	 * @returns The element, with its class removed.
	 * @private
	 */
	  var _removeClass = function(element, value) {
	    var c, cl, className, classNames = [];
	    if (typeof value === "string" && value) {
	      classNames = value.split(/\s+/);
	    }
	    if (element && element.nodeType === 1 && classNames.length > 0) {
	      if (element.classList && element.classList.length > 0) {
	        for (c = 0, cl = classNames.length; c < cl; c++) {
	          element.classList.remove(classNames[c]);
	        }
	      } else if (element.className) {
	        className = (" " + element.className + " ").replace(/[\r\n\t]/g, " ");
	        for (c = 0, cl = classNames.length; c < cl; c++) {
	          className = className.replace(" " + classNames[c] + " ", " ");
	        }
	        element.className = className.replace(/^\s+|\s+$/g, "");
	      }
	    }
	    return element;
	  };
	  /**
	 * Attempt to interpret the element's CSS styling. If `prop` is `"cursor"`,
	 * then we assume that it should be a hand ("pointer") cursor if the element
	 * is an anchor element ("a" tag).
	 *
	 * @returns The computed style property.
	 * @private
	 */
	  var _getStyle = function(el, prop) {
	    var value = _getComputedStyle(el, null).getPropertyValue(prop);
	    if (prop === "cursor") {
	      if (!value || value === "auto") {
	        if (el.nodeName === "A") {
	          return "pointer";
	        }
	      }
	    }
	    return value;
	  };
	  /**
	 * Get the absolutely positioned coordinates of a DOM element.
	 *
	 * @returns Object containing the element's position, width, and height.
	 * @private
	 */
	  var _getElementPosition = function(el) {
	    var pos = {
	      left: 0,
	      top: 0,
	      width: 0,
	      height: 0
	    };
	    if (el.getBoundingClientRect) {
	      var elRect = el.getBoundingClientRect();
	      var pageXOffset = _window.pageXOffset;
	      var pageYOffset = _window.pageYOffset;
	      var leftBorderWidth = _document.documentElement.clientLeft || 0;
	      var topBorderWidth = _document.documentElement.clientTop || 0;
	      var leftBodyOffset = 0;
	      var topBodyOffset = 0;
	      if (_getStyle(_document.body, "position") === "relative") {
	        var bodyRect = _document.body.getBoundingClientRect();
	        var htmlRect = _document.documentElement.getBoundingClientRect();
	        leftBodyOffset = bodyRect.left - htmlRect.left || 0;
	        topBodyOffset = bodyRect.top - htmlRect.top || 0;
	      }
	      pos.left = elRect.left + pageXOffset - leftBorderWidth - leftBodyOffset;
	      pos.top = elRect.top + pageYOffset - topBorderWidth - topBodyOffset;
	      pos.width = "width" in elRect ? elRect.width : elRect.right - elRect.left;
	      pos.height = "height" in elRect ? elRect.height : elRect.bottom - elRect.top;
	    }
	    return pos;
	  };
	  /**
	 * Determine is an element is visible somewhere within the document (page).
	 *
	 * @returns Boolean
	 * @private
	 */
	  var _isElementVisible = function(el) {
	    if (!el) {
	      return false;
	    }
	    var styles = _getComputedStyle(el, null);
	    var hasCssHeight = _parseFloat(styles.height) > 0;
	    var hasCssWidth = _parseFloat(styles.width) > 0;
	    var hasCssTop = _parseFloat(styles.top) >= 0;
	    var hasCssLeft = _parseFloat(styles.left) >= 0;
	    var cssKnows = hasCssHeight && hasCssWidth && hasCssTop && hasCssLeft;
	    var rect = cssKnows ? null : _getElementPosition(el);
	    var isVisible = styles.display !== "none" && styles.visibility !== "collapse" && (cssKnows || !!rect && (hasCssHeight || rect.height > 0) && (hasCssWidth || rect.width > 0) && (hasCssTop || rect.top >= 0) && (hasCssLeft || rect.left >= 0));
	    return isVisible;
	  };
	  /**
	 * Clear all existing timeouts and interval polling delegates.
	 *
	 * @returns `undefined`
	 * @private
	 */
	  var _clearTimeoutsAndPolling = function() {
	    _clearTimeout(_flashCheckTimeout);
	    _flashCheckTimeout = 0;
	    _clearInterval(_swfFallbackCheckInterval);
	    _swfFallbackCheckInterval = 0;
	  };
	  /**
	 * Reposition the Flash object to cover the currently activated element.
	 *
	 * @returns `undefined`
	 * @private
	 */
	  var _reposition = function() {
	    var htmlBridge;
	    if (_currentElement && (htmlBridge = _getHtmlBridge(_flashState.bridge))) {
	      var pos = _getElementPosition(_currentElement);
	      _extend(htmlBridge.style, {
	        width: pos.width + "px",
	        height: pos.height + "px",
	        top: pos.top + "px",
	        left: pos.left + "px",
	        zIndex: "" + _getSafeZIndex(_globalConfig.zIndex)
	      });
	    }
	  };
	  /**
	 * Sends a signal to the Flash object to display the hand cursor if `true`.
	 *
	 * @returns `undefined`
	 * @private
	 */
	  var _setHandCursor = function(enabled) {
	    if (_flashState.ready === true) {
	      if (_flashState.bridge && typeof _flashState.bridge.setHandCursor === "function") {
	        _flashState.bridge.setHandCursor(enabled);
	      } else {
	        _flashState.ready = false;
	      }
	    }
	  };
	  /**
	 * Get a safe value for `zIndex`
	 *
	 * @returns an integer, or "auto"
	 * @private
	 */
	  var _getSafeZIndex = function(val) {
	    if (/^(?:auto|inherit)$/.test(val)) {
	      return val;
	    }
	    var zIndex;
	    if (typeof val === "number" && !_isNaN(val)) {
	      zIndex = val;
	    } else if (typeof val === "string") {
	      zIndex = _getSafeZIndex(_parseInt(val, 10));
	    }
	    return typeof zIndex === "number" ? zIndex : "auto";
	  };
	  /**
	 * Attempt to detect if ZeroClipboard is executing inside of a sandboxed iframe.
	 * If it is, Flash Player cannot be used, so ZeroClipboard is dead in the water.
	 *
	 * @see {@link http://lists.w3.org/Archives/Public/public-whatwg-archive/2014Dec/0002.html}
	 * @see {@link https://github.com/zeroclipboard/zeroclipboard/issues/511}
	 * @see {@link http://zeroclipboard.org/test-iframes.html}
	 *
	 * @returns `true` (is sandboxed), `false` (is not sandboxed), or `null` (uncertain) 
	 * @private
	 */
	  var _detectSandbox = function(doNotReassessFlashSupport) {
	    var effectiveScriptOrigin, frame, frameError, previousState = _flashState.sandboxed, isSandboxed = null;
	    doNotReassessFlashSupport = doNotReassessFlashSupport === true;
	    if (_pageIsFramed === false) {
	      isSandboxed = false;
	    } else {
	      try {
	        frame = window.frameElement || null;
	      } catch (e) {
	        frameError = {
	          name: e.name,
	          message: e.message
	        };
	      }
	      if (frame && frame.nodeType === 1 && frame.nodeName === "IFRAME") {
	        try {
	          isSandboxed = frame.hasAttribute("sandbox");
	        } catch (e) {
	          isSandboxed = null;
	        }
	      } else {
	        try {
	          effectiveScriptOrigin = document.domain || null;
	        } catch (e) {
	          effectiveScriptOrigin = null;
	        }
	        if (effectiveScriptOrigin === null || frameError && frameError.name === "SecurityError" && /(^|[\s\(\[@])sandbox(es|ed|ing|[\s\.,!\)\]@]|$)/.test(frameError.message.toLowerCase())) {
	          isSandboxed = true;
	        }
	      }
	    }
	    _flashState.sandboxed = isSandboxed;
	    if (previousState !== isSandboxed && !doNotReassessFlashSupport) {
	      _detectFlashSupport(_ActiveXObject);
	    }
	    return isSandboxed;
	  };
	  /**
	 * Detect the Flash Player status, version, and plugin type.
	 *
	 * @see {@link https://code.google.com/p/doctype-mirror/wiki/ArticleDetectFlash#The_code}
	 * @see {@link http://stackoverflow.com/questions/12866060/detecting-pepper-ppapi-flash-with-javascript}
	 *
	 * @returns `undefined`
	 * @private
	 */
	  var _detectFlashSupport = function(ActiveXObject) {
	    var plugin, ax, mimeType, hasFlash = false, isActiveX = false, isPPAPI = false, flashVersion = "";
	    /**
	   * Derived from Apple's suggested sniffer.
	   * @param {String} desc e.g. "Shockwave Flash 7.0 r61"
	   * @returns {String} "7.0.61"
	   * @private
	   */
	    function parseFlashVersion(desc) {
	      var matches = desc.match(/[\d]+/g);
	      matches.length = 3;
	      return matches.join(".");
	    }
	    function isPepperFlash(flashPlayerFileName) {
	      return !!flashPlayerFileName && (flashPlayerFileName = flashPlayerFileName.toLowerCase()) && (/^(pepflashplayer\.dll|libpepflashplayer\.so|pepperflashplayer\.plugin)$/.test(flashPlayerFileName) || flashPlayerFileName.slice(-13) === "chrome.plugin");
	    }
	    function inspectPlugin(plugin) {
	      if (plugin) {
	        hasFlash = true;
	        if (plugin.version) {
	          flashVersion = parseFlashVersion(plugin.version);
	        }
	        if (!flashVersion && plugin.description) {
	          flashVersion = parseFlashVersion(plugin.description);
	        }
	        if (plugin.filename) {
	          isPPAPI = isPepperFlash(plugin.filename);
	        }
	      }
	    }
	    if (_navigator.plugins && _navigator.plugins.length) {
	      plugin = _navigator.plugins["Shockwave Flash"];
	      inspectPlugin(plugin);
	      if (_navigator.plugins["Shockwave Flash 2.0"]) {
	        hasFlash = true;
	        flashVersion = "2.0.0.11";
	      }
	    } else if (_navigator.mimeTypes && _navigator.mimeTypes.length) {
	      mimeType = _navigator.mimeTypes["application/x-shockwave-flash"];
	      plugin = mimeType && mimeType.enabledPlugin;
	      inspectPlugin(plugin);
	    } else if (typeof ActiveXObject !== "undefined") {
	      isActiveX = true;
	      try {
	        ax = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.7");
	        hasFlash = true;
	        flashVersion = parseFlashVersion(ax.GetVariable("$version"));
	      } catch (e1) {
	        try {
	          ax = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.6");
	          hasFlash = true;
	          flashVersion = "6.0.21";
	        } catch (e2) {
	          try {
	            ax = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
	            hasFlash = true;
	            flashVersion = parseFlashVersion(ax.GetVariable("$version"));
	          } catch (e3) {
	            isActiveX = false;
	          }
	        }
	      }
	    }
	    _flashState.disabled = hasFlash !== true;
	    _flashState.outdated = flashVersion && _parseFloat(flashVersion) < _parseFloat(_minimumFlashVersion);
	    _flashState.version = flashVersion || "0.0.0";
	    _flashState.pluginType = isPPAPI ? "pepper" : isActiveX ? "activex" : hasFlash ? "netscape" : "unknown";
	  };
	  /**
	 * Invoke the Flash detection algorithms immediately upon inclusion so we're not waiting later.
	 */
	  _detectFlashSupport(_ActiveXObject);
	  /**
	 * Always assess the `sandboxed` state of the page at important Flash-related moments.
	 */
	  _detectSandbox(true);
	  /**
	 * A shell constructor for `ZeroClipboard` client instances.
	 *
	 * @constructor
	 */
	  var ZeroClipboard = function() {
	    if (!(this instanceof ZeroClipboard)) {
	      return new ZeroClipboard();
	    }
	    if (typeof ZeroClipboard._createClient === "function") {
	      ZeroClipboard._createClient.apply(this, _args(arguments));
	    }
	  };
	  /**
	 * The ZeroClipboard library's version number.
	 *
	 * @static
	 * @readonly
	 * @property {string}
	 */
	  _defineProperty(ZeroClipboard, "version", {
	    value: "2.2.0",
	    writable: false,
	    configurable: true,
	    enumerable: true
	  });
	  /**
	 * Update or get a copy of the ZeroClipboard global configuration.
	 * Returns a copy of the current/updated configuration.
	 *
	 * @returns Object
	 * @static
	 */
	  ZeroClipboard.config = function() {
	    return _config.apply(this, _args(arguments));
	  };
	  /**
	 * Diagnostic method that describes the state of the browser, Flash Player, and ZeroClipboard.
	 *
	 * @returns Object
	 * @static
	 */
	  ZeroClipboard.state = function() {
	    return _state.apply(this, _args(arguments));
	  };
	  /**
	 * Check if Flash is unusable for any reason: disabled, outdated, deactivated, etc.
	 *
	 * @returns Boolean
	 * @static
	 */
	  ZeroClipboard.isFlashUnusable = function() {
	    return _isFlashUnusable.apply(this, _args(arguments));
	  };
	  /**
	 * Register an event listener.
	 *
	 * @returns `ZeroClipboard`
	 * @static
	 */
	  ZeroClipboard.on = function() {
	    return _on.apply(this, _args(arguments));
	  };
	  /**
	 * Unregister an event listener.
	 * If no `listener` function/object is provided, it will unregister all listeners for the provided `eventType`.
	 * If no `eventType` is provided, it will unregister all listeners for every event type.
	 *
	 * @returns `ZeroClipboard`
	 * @static
	 */
	  ZeroClipboard.off = function() {
	    return _off.apply(this, _args(arguments));
	  };
	  /**
	 * Retrieve event listeners for an `eventType`.
	 * If no `eventType` is provided, it will retrieve all listeners for every event type.
	 *
	 * @returns array of listeners for the `eventType`; if no `eventType`, then a map/hash object of listeners for all event types; or `null`
	 */
	  ZeroClipboard.handlers = function() {
	    return _listeners.apply(this, _args(arguments));
	  };
	  /**
	 * Event emission receiver from the Flash object, forwarding to any registered JavaScript event listeners.
	 *
	 * @returns For the "copy" event, returns the Flash-friendly "clipData" object; otherwise `undefined`.
	 * @static
	 */
	  ZeroClipboard.emit = function() {
	    return _emit.apply(this, _args(arguments));
	  };
	  /**
	 * Create and embed the Flash object.
	 *
	 * @returns The Flash object
	 * @static
	 */
	  ZeroClipboard.create = function() {
	    return _create.apply(this, _args(arguments));
	  };
	  /**
	 * Self-destruct and clean up everything, including the embedded Flash object.
	 *
	 * @returns `undefined`
	 * @static
	 */
	  ZeroClipboard.destroy = function() {
	    return _destroy.apply(this, _args(arguments));
	  };
	  /**
	 * Set the pending data for clipboard injection.
	 *
	 * @returns `undefined`
	 * @static
	 */
	  ZeroClipboard.setData = function() {
	    return _setData.apply(this, _args(arguments));
	  };
	  /**
	 * Clear the pending data for clipboard injection.
	 * If no `format` is provided, all pending data formats will be cleared.
	 *
	 * @returns `undefined`
	 * @static
	 */
	  ZeroClipboard.clearData = function() {
	    return _clearData.apply(this, _args(arguments));
	  };
	  /**
	 * Get a copy of the pending data for clipboard injection.
	 * If no `format` is provided, a copy of ALL pending data formats will be returned.
	 *
	 * @returns `String` or `Object`
	 * @static
	 */
	  ZeroClipboard.getData = function() {
	    return _getData.apply(this, _args(arguments));
	  };
	  /**
	 * Sets the current HTML object that the Flash object should overlay. This will put the global
	 * Flash object on top of the current element; depending on the setup, this may also set the
	 * pending clipboard text data as well as the Flash object's wrapping element's title attribute
	 * based on the underlying HTML element and ZeroClipboard configuration.
	 *
	 * @returns `undefined`
	 * @static
	 */
	  ZeroClipboard.focus = ZeroClipboard.activate = function() {
	    return _focus.apply(this, _args(arguments));
	  };
	  /**
	 * Un-overlays the Flash object. This will put the global Flash object off-screen; depending on
	 * the setup, this may also unset the Flash object's wrapping element's title attribute based on
	 * the underlying HTML element and ZeroClipboard configuration.
	 *
	 * @returns `undefined`
	 * @static
	 */
	  ZeroClipboard.blur = ZeroClipboard.deactivate = function() {
	    return _blur.apply(this, _args(arguments));
	  };
	  /**
	 * Returns the currently focused/"activated" HTML element that the Flash object is wrapping.
	 *
	 * @returns `HTMLElement` or `null`
	 * @static
	 */
	  ZeroClipboard.activeElement = function() {
	    return _activeElement.apply(this, _args(arguments));
	  };
	  /**
	 * Keep track of the ZeroClipboard client instance counter.
	 */
	  var _clientIdCounter = 0;
	  /**
	 * Keep track of the state of the client instances.
	 *
	 * Entry structure:
	 *   _clientMeta[client.id] = {
	 *     instance: client,
	 *     elements: [],
	 *     handlers: {}
	 *   };
	 */
	  var _clientMeta = {};
	  /**
	 * Keep track of the ZeroClipboard clipped elements counter.
	 */
	  var _elementIdCounter = 0;
	  /**
	 * Keep track of the state of the clipped element relationships to clients.
	 *
	 * Entry structure:
	 *   _elementMeta[element.zcClippingId] = [client1.id, client2.id];
	 */
	  var _elementMeta = {};
	  /**
	 * Keep track of the state of the mouse event handlers for clipped elements.
	 *
	 * Entry structure:
	 *   _mouseHandlers[element.zcClippingId] = {
	 *     mouseover:  function(event) {},
	 *     mouseout:   function(event) {},
	 *     mouseenter: function(event) {},
	 *     mouseleave: function(event) {},
	 *     mousemove:  function(event) {}
	 *   };
	 */
	  var _mouseHandlers = {};
	  /**
	 * Extending the ZeroClipboard configuration defaults for the Client module.
	 */
	  _extend(_globalConfig, {
	    autoActivate: true
	  });
	  /**
	 * The real constructor for `ZeroClipboard` client instances.
	 * @private
	 */
	  var _clientConstructor = function(elements) {
	    var client = this;
	    client.id = "" + _clientIdCounter++;
	    _clientMeta[client.id] = {
	      instance: client,
	      elements: [],
	      handlers: {}
	    };
	    if (elements) {
	      client.clip(elements);
	    }
	    ZeroClipboard.on("*", function(event) {
	      return client.emit(event);
	    });
	    ZeroClipboard.on("destroy", function() {
	      client.destroy();
	    });
	    ZeroClipboard.create();
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.Client.prototype.on`.
	 * @private
	 */
	  var _clientOn = function(eventType, listener) {
	    var i, len, events, added = {}, meta = _clientMeta[this.id], handlers = meta && meta.handlers;
	    if (!meta) {
	      throw new Error("Attempted to add new listener(s) to a destroyed ZeroClipboard client instance");
	    }
	    if (typeof eventType === "string" && eventType) {
	      events = eventType.toLowerCase().split(/\s+/);
	    } else if (typeof eventType === "object" && eventType && typeof listener === "undefined") {
	      for (i in eventType) {
	        if (_hasOwn.call(eventType, i) && typeof i === "string" && i && typeof eventType[i] === "function") {
	          this.on(i, eventType[i]);
	        }
	      }
	    }
	    if (events && events.length) {
	      for (i = 0, len = events.length; i < len; i++) {
	        eventType = events[i].replace(/^on/, "");
	        added[eventType] = true;
	        if (!handlers[eventType]) {
	          handlers[eventType] = [];
	        }
	        handlers[eventType].push(listener);
	      }
	      if (added.ready && _flashState.ready) {
	        this.emit({
	          type: "ready",
	          client: this
	        });
	      }
	      if (added.error) {
	        for (i = 0, len = _flashStateErrorNames.length; i < len; i++) {
	          if (_flashState[_flashStateErrorNames[i].replace(/^flash-/, "")]) {
	            this.emit({
	              type: "error",
	              name: _flashStateErrorNames[i],
	              client: this
	            });
	            break;
	          }
	        }
	        if (_zcSwfVersion !== undefined && ZeroClipboard.version !== _zcSwfVersion) {
	          this.emit({
	            type: "error",
	            name: "version-mismatch",
	            jsVersion: ZeroClipboard.version,
	            swfVersion: _zcSwfVersion
	          });
	        }
	      }
	    }
	    return this;
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.Client.prototype.off`.
	 * @private
	 */
	  var _clientOff = function(eventType, listener) {
	    var i, len, foundIndex, events, perEventHandlers, meta = _clientMeta[this.id], handlers = meta && meta.handlers;
	    if (!handlers) {
	      return this;
	    }
	    if (arguments.length === 0) {
	      events = _keys(handlers);
	    } else if (typeof eventType === "string" && eventType) {
	      events = eventType.split(/\s+/);
	    } else if (typeof eventType === "object" && eventType && typeof listener === "undefined") {
	      for (i in eventType) {
	        if (_hasOwn.call(eventType, i) && typeof i === "string" && i && typeof eventType[i] === "function") {
	          this.off(i, eventType[i]);
	        }
	      }
	    }
	    if (events && events.length) {
	      for (i = 0, len = events.length; i < len; i++) {
	        eventType = events[i].toLowerCase().replace(/^on/, "");
	        perEventHandlers = handlers[eventType];
	        if (perEventHandlers && perEventHandlers.length) {
	          if (listener) {
	            foundIndex = perEventHandlers.indexOf(listener);
	            while (foundIndex !== -1) {
	              perEventHandlers.splice(foundIndex, 1);
	              foundIndex = perEventHandlers.indexOf(listener, foundIndex);
	            }
	          } else {
	            perEventHandlers.length = 0;
	          }
	        }
	      }
	    }
	    return this;
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.Client.prototype.handlers`.
	 * @private
	 */
	  var _clientListeners = function(eventType) {
	    var copy = null, handlers = _clientMeta[this.id] && _clientMeta[this.id].handlers;
	    if (handlers) {
	      if (typeof eventType === "string" && eventType) {
	        copy = handlers[eventType] ? handlers[eventType].slice(0) : [];
	      } else {
	        copy = _deepCopy(handlers);
	      }
	    }
	    return copy;
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.Client.prototype.emit`.
	 * @private
	 */
	  var _clientEmit = function(event) {
	    if (_clientShouldEmit.call(this, event)) {
	      if (typeof event === "object" && event && typeof event.type === "string" && event.type) {
	        event = _extend({}, event);
	      }
	      var eventCopy = _extend({}, _createEvent(event), {
	        client: this
	      });
	      _clientDispatchCallbacks.call(this, eventCopy);
	    }
	    return this;
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.Client.prototype.clip`.
	 * @private
	 */
	  var _clientClip = function(elements) {
	    if (!_clientMeta[this.id]) {
	      throw new Error("Attempted to clip element(s) to a destroyed ZeroClipboard client instance");
	    }
	    elements = _prepClip(elements);
	    for (var i = 0; i < elements.length; i++) {
	      if (_hasOwn.call(elements, i) && elements[i] && elements[i].nodeType === 1) {
	        if (!elements[i].zcClippingId) {
	          elements[i].zcClippingId = "zcClippingId_" + _elementIdCounter++;
	          _elementMeta[elements[i].zcClippingId] = [ this.id ];
	          if (_globalConfig.autoActivate === true) {
	            _addMouseHandlers(elements[i]);
	          }
	        } else if (_elementMeta[elements[i].zcClippingId].indexOf(this.id) === -1) {
	          _elementMeta[elements[i].zcClippingId].push(this.id);
	        }
	        var clippedElements = _clientMeta[this.id] && _clientMeta[this.id].elements;
	        if (clippedElements.indexOf(elements[i]) === -1) {
	          clippedElements.push(elements[i]);
	        }
	      }
	    }
	    return this;
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.Client.prototype.unclip`.
	 * @private
	 */
	  var _clientUnclip = function(elements) {
	    var meta = _clientMeta[this.id];
	    if (!meta) {
	      return this;
	    }
	    var clippedElements = meta.elements;
	    var arrayIndex;
	    if (typeof elements === "undefined") {
	      elements = clippedElements.slice(0);
	    } else {
	      elements = _prepClip(elements);
	    }
	    for (var i = elements.length; i--; ) {
	      if (_hasOwn.call(elements, i) && elements[i] && elements[i].nodeType === 1) {
	        arrayIndex = 0;
	        while ((arrayIndex = clippedElements.indexOf(elements[i], arrayIndex)) !== -1) {
	          clippedElements.splice(arrayIndex, 1);
	        }
	        var clientIds = _elementMeta[elements[i].zcClippingId];
	        if (clientIds) {
	          arrayIndex = 0;
	          while ((arrayIndex = clientIds.indexOf(this.id, arrayIndex)) !== -1) {
	            clientIds.splice(arrayIndex, 1);
	          }
	          if (clientIds.length === 0) {
	            if (_globalConfig.autoActivate === true) {
	              _removeMouseHandlers(elements[i]);
	            }
	            delete elements[i].zcClippingId;
	          }
	        }
	      }
	    }
	    return this;
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.Client.prototype.elements`.
	 * @private
	 */
	  var _clientElements = function() {
	    var meta = _clientMeta[this.id];
	    return meta && meta.elements ? meta.elements.slice(0) : [];
	  };
	  /**
	 * The underlying implementation of `ZeroClipboard.Client.prototype.destroy`.
	 * @private
	 */
	  var _clientDestroy = function() {
	    if (!_clientMeta[this.id]) {
	      return;
	    }
	    this.unclip();
	    this.off();
	    delete _clientMeta[this.id];
	  };
	  /**
	 * Inspect an Event to see if the Client (`this`) should honor it for emission.
	 * @private
	 */
	  var _clientShouldEmit = function(event) {
	    if (!(event && event.type)) {
	      return false;
	    }
	    if (event.client && event.client !== this) {
	      return false;
	    }
	    var meta = _clientMeta[this.id];
	    var clippedEls = meta && meta.elements;
	    var hasClippedEls = !!clippedEls && clippedEls.length > 0;
	    var goodTarget = !event.target || hasClippedEls && clippedEls.indexOf(event.target) !== -1;
	    var goodRelTarget = event.relatedTarget && hasClippedEls && clippedEls.indexOf(event.relatedTarget) !== -1;
	    var goodClient = event.client && event.client === this;
	    if (!meta || !(goodTarget || goodRelTarget || goodClient)) {
	      return false;
	    }
	    return true;
	  };
	  /**
	 * Handle the actual dispatching of events to a client instance.
	 *
	 * @returns `undefined`
	 * @private
	 */
	  var _clientDispatchCallbacks = function(event) {
	    var meta = _clientMeta[this.id];
	    if (!(typeof event === "object" && event && event.type && meta)) {
	      return;
	    }
	    var async = _shouldPerformAsync(event);
	    var wildcardTypeHandlers = meta && meta.handlers["*"] || [];
	    var specificTypeHandlers = meta && meta.handlers[event.type] || [];
	    var handlers = wildcardTypeHandlers.concat(specificTypeHandlers);
	    if (handlers && handlers.length) {
	      var i, len, func, context, eventCopy, originalContext = this;
	      for (i = 0, len = handlers.length; i < len; i++) {
	        func = handlers[i];
	        context = originalContext;
	        if (typeof func === "string" && typeof _window[func] === "function") {
	          func = _window[func];
	        }
	        if (typeof func === "object" && func && typeof func.handleEvent === "function") {
	          context = func;
	          func = func.handleEvent;
	        }
	        if (typeof func === "function") {
	          eventCopy = _extend({}, event);
	          _dispatchCallback(func, context, [ eventCopy ], async);
	        }
	      }
	    }
	  };
	  /**
	 * Prepares the elements for clipping/unclipping.
	 *
	 * @returns An Array of elements.
	 * @private
	 */
	  var _prepClip = function(elements) {
	    if (typeof elements === "string") {
	      elements = [];
	    }
	    return typeof elements.length !== "number" ? [ elements ] : elements;
	  };
	  /**
	 * Add a `mouseover` handler function for a clipped element.
	 *
	 * @returns `undefined`
	 * @private
	 */
	  var _addMouseHandlers = function(element) {
	    if (!(element && element.nodeType === 1)) {
	      return;
	    }
	    var _suppressMouseEvents = function(event) {
	      if (!(event || (event = _window.event))) {
	        return;
	      }
	      if (event._source !== "js") {
	        event.stopImmediatePropagation();
	        event.preventDefault();
	      }
	      delete event._source;
	    };
	    var _elementMouseOver = function(event) {
	      if (!(event || (event = _window.event))) {
	        return;
	      }
	      _suppressMouseEvents(event);
	      ZeroClipboard.focus(element);
	    };
	    element.addEventListener("mouseover", _elementMouseOver, false);
	    element.addEventListener("mouseout", _suppressMouseEvents, false);
	    element.addEventListener("mouseenter", _suppressMouseEvents, false);
	    element.addEventListener("mouseleave", _suppressMouseEvents, false);
	    element.addEventListener("mousemove", _suppressMouseEvents, false);
	    _mouseHandlers[element.zcClippingId] = {
	      mouseover: _elementMouseOver,
	      mouseout: _suppressMouseEvents,
	      mouseenter: _suppressMouseEvents,
	      mouseleave: _suppressMouseEvents,
	      mousemove: _suppressMouseEvents
	    };
	  };
	  /**
	 * Remove a `mouseover` handler function for a clipped element.
	 *
	 * @returns `undefined`
	 * @private
	 */
	  var _removeMouseHandlers = function(element) {
	    if (!(element && element.nodeType === 1)) {
	      return;
	    }
	    var mouseHandlers = _mouseHandlers[element.zcClippingId];
	    if (!(typeof mouseHandlers === "object" && mouseHandlers)) {
	      return;
	    }
	    var key, val, mouseEvents = [ "move", "leave", "enter", "out", "over" ];
	    for (var i = 0, len = mouseEvents.length; i < len; i++) {
	      key = "mouse" + mouseEvents[i];
	      val = mouseHandlers[key];
	      if (typeof val === "function") {
	        element.removeEventListener(key, val, false);
	      }
	    }
	    delete _mouseHandlers[element.zcClippingId];
	  };
	  /**
	 * Creates a new ZeroClipboard client instance.
	 * Optionally, auto-`clip` an element or collection of elements.
	 *
	 * @constructor
	 */
	  ZeroClipboard._createClient = function() {
	    _clientConstructor.apply(this, _args(arguments));
	  };
	  /**
	 * Register an event listener to the client.
	 *
	 * @returns `this`
	 */
	  ZeroClipboard.prototype.on = function() {
	    return _clientOn.apply(this, _args(arguments));
	  };
	  /**
	 * Unregister an event handler from the client.
	 * If no `listener` function/object is provided, it will unregister all handlers for the provided `eventType`.
	 * If no `eventType` is provided, it will unregister all handlers for every event type.
	 *
	 * @returns `this`
	 */
	  ZeroClipboard.prototype.off = function() {
	    return _clientOff.apply(this, _args(arguments));
	  };
	  /**
	 * Retrieve event listeners for an `eventType` from the client.
	 * If no `eventType` is provided, it will retrieve all listeners for every event type.
	 *
	 * @returns array of listeners for the `eventType`; if no `eventType`, then a map/hash object of listeners for all event types; or `null`
	 */
	  ZeroClipboard.prototype.handlers = function() {
	    return _clientListeners.apply(this, _args(arguments));
	  };
	  /**
	 * Event emission receiver from the Flash object for this client's registered JavaScript event listeners.
	 *
	 * @returns For the "copy" event, returns the Flash-friendly "clipData" object; otherwise `undefined`.
	 */
	  ZeroClipboard.prototype.emit = function() {
	    return _clientEmit.apply(this, _args(arguments));
	  };
	  /**
	 * Register clipboard actions for new element(s) to the client.
	 *
	 * @returns `this`
	 */
	  ZeroClipboard.prototype.clip = function() {
	    return _clientClip.apply(this, _args(arguments));
	  };
	  /**
	 * Unregister the clipboard actions of previously registered element(s) on the page.
	 * If no elements are provided, ALL registered elements will be unregistered.
	 *
	 * @returns `this`
	 */
	  ZeroClipboard.prototype.unclip = function() {
	    return _clientUnclip.apply(this, _args(arguments));
	  };
	  /**
	 * Get all of the elements to which this client is clipped.
	 *
	 * @returns array of clipped elements
	 */
	  ZeroClipboard.prototype.elements = function() {
	    return _clientElements.apply(this, _args(arguments));
	  };
	  /**
	 * Self-destruct and clean up everything for a single client.
	 * This will NOT destroy the embedded Flash object.
	 *
	 * @returns `undefined`
	 */
	  ZeroClipboard.prototype.destroy = function() {
	    return _clientDestroy.apply(this, _args(arguments));
	  };
	  /**
	 * Stores the pending plain text to inject into the clipboard.
	 *
	 * @returns `this`
	 */
	  ZeroClipboard.prototype.setText = function(text) {
	    if (!_clientMeta[this.id]) {
	      throw new Error("Attempted to set pending clipboard data from a destroyed ZeroClipboard client instance");
	    }
	    ZeroClipboard.setData("text/plain", text);
	    return this;
	  };
	  /**
	 * Stores the pending HTML text to inject into the clipboard.
	 *
	 * @returns `this`
	 */
	  ZeroClipboard.prototype.setHtml = function(html) {
	    if (!_clientMeta[this.id]) {
	      throw new Error("Attempted to set pending clipboard data from a destroyed ZeroClipboard client instance");
	    }
	    ZeroClipboard.setData("text/html", html);
	    return this;
	  };
	  /**
	 * Stores the pending rich text (RTF) to inject into the clipboard.
	 *
	 * @returns `this`
	 */
	  ZeroClipboard.prototype.setRichText = function(richText) {
	    if (!_clientMeta[this.id]) {
	      throw new Error("Attempted to set pending clipboard data from a destroyed ZeroClipboard client instance");
	    }
	    ZeroClipboard.setData("application/rtf", richText);
	    return this;
	  };
	  /**
	 * Stores the pending data to inject into the clipboard.
	 *
	 * @returns `this`
	 */
	  ZeroClipboard.prototype.setData = function() {
	    if (!_clientMeta[this.id]) {
	      throw new Error("Attempted to set pending clipboard data from a destroyed ZeroClipboard client instance");
	    }
	    ZeroClipboard.setData.apply(this, _args(arguments));
	    return this;
	  };
	  /**
	 * Clears the pending data to inject into the clipboard.
	 * If no `format` is provided, all pending data formats will be cleared.
	 *
	 * @returns `this`
	 */
	  ZeroClipboard.prototype.clearData = function() {
	    if (!_clientMeta[this.id]) {
	      throw new Error("Attempted to clear pending clipboard data from a destroyed ZeroClipboard client instance");
	    }
	    ZeroClipboard.clearData.apply(this, _args(arguments));
	    return this;
	  };
	  /**
	 * Gets a copy of the pending data to inject into the clipboard.
	 * If no `format` is provided, a copy of ALL pending data formats will be returned.
	 *
	 * @returns `String` or `Object`
	 */
	  ZeroClipboard.prototype.getData = function() {
	    if (!_clientMeta[this.id]) {
	      throw new Error("Attempted to get pending clipboard data from a destroyed ZeroClipboard client instance");
	    }
	    return ZeroClipboard.getData.apply(this, _args(arguments));
	  };
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return ZeroClipboard;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === "object" && module && typeof module.exports === "object" && module.exports) {
	    module.exports = ZeroClipboard;
	  } else {
	    window.ZeroClipboard = ZeroClipboard;
	  }
	})(function() {
	  return this || window;
	}());

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a573941f02f4331f81046356ebb667eb.swf";

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupDetailCtrl, getActiveTabNumByString;
	
	$ = __webpack_require__(1);
	
	getActiveTabNumByString = function(nameTab) {
	  switch (nameTab) {
	    case '#timeline':
	      return 1;
	    case '#event':
	      return 2;
	    case '#rank':
	      return 3;
	    default:
	      return 1;
	  }
	};
	
	GroupDetailCtrl = function($rootScope, $scope, $filter, $location, $route, groupInfo, groupStatus, userInfo, groupRegisDataService) {
	  var hash;
	  angular.element(document.body).css('min-width', 0);
	  $(document).ready(function() {
	    var curOffset, item;
	    document.body.scrollTop = document.documentElement.scrollTop = 0;
	    item = $('#groupTabs')[0];
	    curOffset = item.offsetTop;
	    return window.onscroll = function() {
	      if (window.pageYOffset >= curOffset) {
	        return item.classList.add("sticky");
	      } else {
	        return item.classList.remove("sticky");
	      }
	    };
	  });
	  $scope.groupDetail = groupInfo;
	  $scope.groupStatus = groupStatus;
	  $scope.userInfo = userInfo;
	  hash = window.location.hash;
	  $scope.tab = getActiveTabNumByString(hash);
	  $scope.gotoTimelineTab = function() {
	    $("html, body").animate({
	      scrollTop: 0
	    }, 400, function() {
	      return $scope.$apply(function() {
	        return $scope.tab = 1;
	      });
	    });
	    return true;
	  };
	  $scope.gotoEventTab = function() {
	    $("html, body").animate({
	      scrollTop: 0
	    }, 400, function() {
	      return $scope.$apply(function() {
	        return $scope.tab = 2;
	      });
	    });
	    return true;
	  };
	  $scope.gotoRankTab = function() {
	    $("html, body").animate({
	      scrollTop: 0
	    }, 400, function() {
	      return $scope.$apply(function() {
	        return $scope.tab = 3;
	      });
	    });
	    return true;
	  };
	  $scope.displayPrivacy = function(privacy) {
	    if (privacy) {
	      return $filter('translate')('_GROUP.LIST.PUBLIC_GROUP');
	    } else {
	      return $filter('translate')('_GROUP.LIST.PRIVATE_GROUP');
	    }
	  };
	  return $rootScope.$on("$routeChangeStart", function(event, next, current) {
	    if (current.$$route.originalPath !== next.$$route.originalPath && next.$$route.originalPath !== '/groups/search' && next.$$route.originalPath !== '/groups/:id') {
	      return groupRegisDataService.setTempData(null);
	    }
	  });
	};
	
	GroupDetailCtrl.$inject = ['$rootScope', '$scope', '$filter', '$location', '$route', 'groupInfo', 'groupStatus', 'userInfo', 'groupRegisDataService'];
	
	module.exports = GroupDetailCtrl;


/***/ }),
/* 831 */
/***/ (function(module, exports) {

	var GroupDetailToolbarCtrl;
	
	GroupDetailToolbarCtrl = function($scope, $filter, $location, $route, $ngConfirm, groupRegisDataService, groupDetailToolbarService, GroupMemberService, formCopyService) {
	  var groupId, prepareMess, userId;
	  userId = $scope.userInfo.user_id;
	  groupId = $scope.groupDetail.id;
	  prepareMess = $filter('translate')('_GROUP.IN_PREPARE');
	  $scope.member = $scope.groupStatus.role === 'member' && $scope.groupStatus.status === 'approved';
	  $scope.admin = $scope.groupStatus.role === 'admin';
	  $scope.requestPending = $scope.groupStatus.status === 'pending';
	  $scope.requestGroup = function() {
	    var params;
	    if (userId === '' || groupId === '') {
	      return;
	    }
	    params = {
	      user_id: userId,
	      group_id: groupId
	    };
	    return groupRegisDataService.joinGroup(params)["finally"](function() {
	      var mess;
	      mess = $filter('translate')('_GROUP.TOOLBAR.REQUEST_MESS_JOIN_GROUP');
	      $ngConfirm(mess);
	      return $route.reload();
	    });
	  };
	  $scope.displayMemberRequest = function() {
	    var params;
	    params = {
	      id: groupId,
	      page_size: 1,
	      page: 1,
	      status: 'pending'
	    };
	    return GroupMemberService.listMemRequest(params).then(function(data) {
	      return $scope.numBadge = data.total;
	    });
	  };
	  $scope.goToListMember = function() {
	    return $location.path("/groups/" + groupId + "/members/list-members");
	  };
	  $scope.gotoInfoPage = function() {
	    return $location.path("/groups/" + groupId + "/information");
	  };
	  $scope.leaveGroup = function() {
	    var config, errorMess, mess, params;
	    if (userId === '' || groupId === '') {
	      return;
	    }
	    params = {
	      user_id: userId,
	      group_id: groupId
	    };
	    mess = $filter('translate')('_GROUP.TOOLBAR.CONFIRM_MESS_LEAVE_GROUP');
	    errorMess = $filter('translate')('_GROUP.TOOLBAR.NOT_ALLOWED_LEAVE_GROUP');
	    config = {
	      title: '',
	      content: mess,
	      buttons: {
	        Cancel: {
	          text: $filter('translate')('_GROUP_EVENT.CANCEL')
	        },
	        OkButton: {
	          text: 'OK',
	          action: function() {
	            return groupDetailToolbarService.leaveGroup(params).then(function(resp) {
	              return $location.path('/groups');
	            })["catch"](function(resp) {
	              return $ngConfirm(errorMess);
	            });
	          }
	        }
	      }
	    };
	    return $ngConfirm(config);
	  };
	  $scope.dataURL = function(id) {
	    var extUrl, url;
	    extUrl = "/groups/join?id=" + id;
	    return url = $location.absUrl().replace($location.url(), extUrl);
	  };
	  $scope.copyFunc = function() {
	    var mess;
	    formCopyService.copy($scope.dataURL(groupId));
	    mess = $filter('translate')('_GROUP.TOOLBAR.COPY_MESS_URL');
	    return $ngConfirm(mess);
	  };
	  return $scope.displayMemberRequest();
	};
	
	GroupDetailToolbarCtrl.$inject = ['$scope', '$filter', '$location', '$route', '$ngConfirm', 'groupRegisDataService', 'groupDetailToolbarService', 'GroupMemberService', 'formCopyService'];
	
	module.exports = GroupDetailToolbarCtrl;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupPermissionCtrl;
	
	$ = __webpack_require__(1);
	
	GroupPermissionCtrl = function($scope, $location, $routeParams, groupRegisDataService, userInfo) {
	  var params;
	  if ($routeParams.id === void 0 || $routeParams.id === '') {
	    return $location.path('/groups');
	  }
	  params = {
	    user_id: userInfo.user_id,
	    group_id: $routeParams.id,
	    status: 'approved'
	  };
	  return groupRegisDataService.joinGroup(params)["finally"](function() {
	    $location.search('id', null);
	    return $location.path('/groups');
	  });
	};
	
	GroupPermissionCtrl.$inject = ['$scope', '$location', '$routeParams', 'groupRegisDataService', 'userInfo'];
	
	module.exports = GroupPermissionCtrl;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupMembersDetailCtrl;
	
	$ = __webpack_require__(1);
	
	GroupMembersDetailCtrl = function($scope, $filter, $location, $routeParams, groupInfo, userInfo, groupStatus, GroupMemberService, groupDataService) {
	  angular.element(document.body).css('min-width', 0);
	  $(document).ready(function() {
	    var _originalSize, curOffMemTool;
	    $.fn.isInViewport = function() {
	      var elementBottom, elementTop, viewportBottom, viewportTop;
	      elementTop = $(this).offset().top;
	      elementBottom = elementTop + $(this).outerHeight();
	      viewportTop = $(window).scrollTop();
	      viewportBottom = viewportTop + $(window).height();
	      return elementBottom > viewportTop && elementTop < viewportBottom;
	    };
	    document.body.scrollTop = document.documentElement.scrollTop = 0;
	    curOffMemTool = $('#member-toolbar')[0].offsetTop;
	    _originalSize = $(window).width() + $(window).height();
	    return window.onscroll = function() {
	      var showKeyboard, y;
	      showKeyboard = $("input").is(":focus");
	      y = $(this).scrollTop();
	      if (y >= curOffMemTool && !showKeyboard) {
	        $('.member-toolbar-wrap-content').css("min-height", $('#member-toolbar').outerHeight());
	        $('#member-toolbar').addClass("sticky");
	        $('.header-container-wrap-content').css("min-height", $('#header-con-member').outerHeight());
	        $('#header-con-member').addClass("sticky");
	      } else {
	        $('#member-toolbar').removeClass("sticky");
	        $('#header-con-member').removeClass("sticky");
	      }
	      if ($('#gnp-footer').isInViewport()) {
	        $('#btn-done-member').removeClass('sticky');
	        return $('.btn-done-wrap-content').css("min-height", $('#btn-done-member').outerHeight());
	      } else {
	        return $('#btn-done-member').addClass('sticky');
	      }
	    };
	  });
	  if (groupStatus.role !== 'admin') {
	    return $location.path('/groups');
	  }
	  $scope.groupDetail = groupInfo;
	  $scope.userInfo = userInfo;
	  $scope.permissionData = groupDataService.getPermissionData();
	  $scope.curPage = $routeParams.page;
	  $scope.numBadge = 0;
	  $scope.displayPrivacy = function(privacy) {
	    if (privacy) {
	      return $filter('translate')('_GROUP.LIST.PUBLIC_GROUP');
	    } else {
	      return $filter('translate')('_GROUP.LIST.PRIVATE_GROUP');
	    }
	  };
	  $scope.displayMemberRequest = function() {
	    var params;
	    params = {
	      id: $scope.groupDetail.id,
	      page_size: 1,
	      page: 1,
	      status: 'pending'
	    };
	    return GroupMemberService.listMemRequest(params).then(function(data) {
	      return $scope.numBadge = data.total;
	    });
	  };
	  $scope.displayTitle = function() {
	    if ($routeParams.page === 'list-request') {
	      return $filter('translate')('_GROUP_MEMBERS.REQUEST');
	    }
	    return $filter('translate')('_GROUP_MEMBERS.EDIT_MEMBER');
	  };
	  $scope.goToListMember = function() {
	    return $location.path("/groups/" + $scope.groupDetail.id + "/members/list-members");
	  };
	  $scope.goToGroup = function() {
	    return $location.path("/groups/" + $scope.groupDetail.id);
	  };
	  $scope.goToListRequest = function() {
	    return $location.path("/groups/" + $scope.groupDetail.id + "/members/list-request");
	  };
	  $scope.$on('gnp.group.request.changed', function(event, data) {
	    return $scope.numBadge = data;
	  });
	  return $scope.displayMemberRequest();
	};
	
	GroupMembersDetailCtrl.$inject = ['$scope', '$filter', '$location', '$routeParams', 'groupInfo', 'userInfo', 'groupStatus', 'GroupMemberService', 'groupDataService'];
	
	module.exports = GroupMembersDetailCtrl;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupInformationCtrl;
	
	$ = __webpack_require__(1);
	
	GroupInformationCtrl = function($scope, $filter, $location, groupInfo, userInfo, groupStatus, $ngConfirm, groupDetailToolbarService) {
	  angular.element(document.body).css('min-width', 0);
	  $(document).ready(function() {
	    return document.body.scrollTop = document.documentElement.scrollTop = 0;
	  });
	  $scope.groupInfo = groupInfo;
	  $scope.userInfo = userInfo;
	  $scope.groupStatus = groupStatus;
	  return $scope.leaveGroup = function() {
	    var config, errorMess, mess, params;
	    params = {
	      user_id: userInfo.user_id,
	      group_id: groupInfo.id
	    };
	    mess = $filter('translate')('_GROUP.TOOLBAR.CONFIRM_MESS_LEAVE_GROUP');
	    errorMess = $filter('translate')('_GROUP.TOOLBAR.NOT_ALLOWED_LEAVE_GROUP');
	    config = {
	      title: '',
	      content: mess,
	      buttons: {
	        Cancel: {
	          text: $filter('translate')('_GROUP_EVENT.CANCEL')
	        },
	        OkButton: {
	          text: 'OK',
	          action: function() {
	            return groupDetailToolbarService.leaveGroup(params).then(function(resp) {
	              return $location.path('/groups');
	            })["catch"](function(resp) {
	              return $ngConfirm(errorMess);
	            });
	          }
	        }
	      }
	    };
	    return $ngConfirm(config);
	  };
	};
	
	GroupInformationCtrl.$inject = ['$scope', '$filter', '$location', 'groupInfo', 'userInfo', 'groupStatus', '$ngConfirm', 'groupDetailToolbarService'];
	
	module.exports = GroupInformationCtrl;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	var GroupDataService, _;
	
	_ = __webpack_require__(87);
	
	GroupDataService = function($filter) {
	  return {
	    getPolicyData: function() {
	      var policyDatas;
	      return policyDatas = [
	        {
	          type: '1',
	          image: 'publicPolicy',
	          name: $filter('translate')('_GROUP.PUBLIC_GROUP'),
	          description: $filter('translate')('_GROUP.PUBLIC_GROUP_DES')
	        }, {
	          type: '0',
	          image: 'privatePolicy',
	          name: $filter('translate')('_GROUP.PRIVATE_GROUP'),
	          description: $filter('translate')('_GROUP.PRIVATE_GROUP_DES')
	        }
	      ];
	    },
	    getPermissionData: function() {
	      var permissionData;
	      return permissionData = [
	        {
	          name: $filter('translate')('_GROUP_MEMBERS.ADMIN'),
	          value: 'admin'
	        }, {
	          name: $filter('translate')('_GROUP_MEMBERS.MEMBER'),
	          value: 'member'
	        }, {
	          name: $filter('translate')('_GROUP_MEMBERS.DELETE_MEMBER'),
	          value: 'delete'
	        }
	      ];
	    }
	  };
	};
	
	GroupDataService.$inject = ['$filter'];
	
	module.exports = GroupDataService;


/***/ }),
/* 836 */
/***/ (function(module, exports) {

	var GroupDetailToolbarService;
	
	GroupDetailToolbarService = function($http, $q) {
	  return {
	    leaveGroup: function(params) {
	      var url;
	      url = "/api/users/leave_group.json?user_id=" + params.user_id + "&group_id=" + params.group_id;
	      return $http["delete"](url);
	    }
	  };
	};
	
	GroupDetailToolbarService.$inject = ['$http', '$q'];
	
	module.exports = GroupDetailToolbarService;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	var $, GroupSearchItemDirective;
	
	__webpack_require__(838);
	
	$ = __webpack_require__(1);
	
	GroupSearchItemDirective = function($filter, $translate) {
	  return {
	    restrict: "EA",
	    replace: true,
	    templateUrl: "groups/group-search-item-directive/index.jade",
	    scope: {
	      data: '=data',
	      requestGroup: '&requestGroup',
	      clickDetail: '&clickDetail'
	    },
	    link: function(scope) {
	      scope.displayMember = function(member) {
	        return ($filter('translate')('_GROUP.LIST.MEMBERS')) + ': ' + member + ($filter('translate')('_GROUP.LIST.MEMBERS_EXT'));
	      };
	      return scope.displayRequest = function(member) {
	        if (member) {
	          return scope.data.user_status === 'approved';
	        }
	        return scope.data.user_status === 'approved' || scope.data.user_status === 'pending';
	      };
	    }
	  };
	};
	
	GroupSearchItemDirective.$inject = ['$filter', '$translate'];
	
	module.exports = GroupSearchItemDirective;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"search-item\" class=\"col-12\"><div class=\"cell avatar\"><img lazy-img=\"{{ data.avatar_url }}\" ng-click=\"clickDetail()\" class=\"avatarGroup\"/></div><div class=\"cell description\"><div class=\"col-10 header\"><div ng-click=\"clickDetail()\" class=\"group-name\">{{ data.name }}</div><div ng-click=\"clickDetail()\" class=\"group-member\">{{ displayMember(data.members) }}</div></div><div ng-click=\"clickDetail()\" class=\"col-12 footer\"><p>{{ data.description }}</p></div><div class=\"btnRegion\"><div class=\"d-none d-sm-block\"><button ng-class=\"{active: displayRequest() }\" ng-click=\"requestGroup()\" class=\"btnRequest\"><img ng-if=\"!displayRequest()\" src=\"" + __webpack_require__(839) + "\"/><img ng-if=\"displayRequest()\" src=\"" + __webpack_require__(840) + "\"/><span ng-switch=\"data.user_status\"><b ng-switch-when=\"approved\">{{ :: '_GROUP.SEARCH.JOINED' | translate }}</b><b ng-switch-when=\"pending\">{{ :: '_GROUP.TOOLBAR.IN_REQUEST' | translate }}</b><b ng-switch-default=\"ng-switch-default\">{{ :: '_GROUP.TOOLBAR.REQUEST' | translate }}</b></span></button></div><div ng-click=\"requestGroup()\" ng-class=\"{active: displayRequest() }\" class=\"d-block d-sm-none mbRequest\"><button><img ng-if=\"!displayRequest()\" src=\"" + __webpack_require__(841) + "\"/><img ng-if=\"displayRequest()\" src=\"" + __webpack_require__(840) + "\"/></button><br/><span ng-if=\"!displayRequest(1)\" ng-switch=\"data.user_status\"><b ng-switch-when=\"approved\">{{ :: '_GROUP.SEARCH.JOINED' | translate }}</b><b ng-switch-when=\"pending\">{{ :: '_GROUP.TOOLBAR.IN_REQUEST' | translate }}</b><b ng-switch-default=\"ng-switch-default\">{{ :: '_GROUP.TOOLBAR.REQUEST' | translate }}</b></span></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("groups/group-search-item-directive/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtBAMAAADINP+pAAAAFVBMVEUAAAD///////////////////////9Iz20EAAAABnRSTlMAABll4Pjgs5+NAAAAOElEQVQ4y2NgGAZAEATE0tLSwAyBYS+uGgoEYUBxEB2qABc3S0MGBgMuPtLiBcwVCQ0NQRMfhgAAM1VQN2hTPwAAAAAASUVORK5CYII="

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAVCAYAAAC33pUlAAABxElEQVRIibXVz4tNcRjH8dfMYCdR/gHZWFhYf4uFQmZhzPGjZjaU0aQYxUKj/CiiqLsYEilFUjiSnwuFxf2GUlas+As0CSVpxOLcW9fte+49c2c8q3Oez/P0/j7f5znP6btbr5uLZSEk/XmMp/E9C+Fs09c/J1KJ5TGewCTO5DEe+2+wPMajON7iOtmo0oJ5Bh3GqYQ0mccY562yPMYJnCuRa1kIT9phy7C2B9A+1ErkKRzi356twhs8wupZgPbgAvoS8hVMZCH8aYVtxiusxGLcx/IKrF24XAK6hvEmqAnbggdY0hK4AnewqANoBFelJ/oGxlpBTdgLfEgkrFPcd8q24zoGEtpt7M5C+N0u9OMbtuJzInEv9rf5hnGzBJRjNAVqwuATduJXIqaG9Y3nQdzCwkTcQ4xkIcykQK0wius8kIgZUPRvHPek+/gU27IQUodNwigm62IibikulYCeYbgbKAWDg3jeLbFhLzGUhfCzSnAKNoMd+Nglt47BLIQfFQ9WuvWnMYSvJfprxbBUBnWCwXuMon2M32KT4pOZlXXb+o9xpOX9HTYor7ijVfmfnVcs5jXYiC+9gKrCYEyxoKd7BcFfvFtvDWx9CvIAAAAASUVORK5CYII="

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtBAMAAADINP+pAAAAHlBMVEUAAAD////q9fXT6+u74OCu29sbraxPubh0xcSh1tX718wsAAAABnRSTlMAABll4Pjgs5+NAAAAP0lEQVQ4y2NgGAZAEAQkOzo6wQwBVHGJtLSMYSauGgoE4Wlp6SA6VAEubpaGDAwGXHy4hj9ecZHQ0BA08WEIAEXfUO87aNuhAAAAAElFTkSuQmCC"

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	module.exports = {
	  '_GROUP': {
	    'TITLE': "Group",
	    'PAGE_TITLE': "Group Registration",
	    'CREATE_GROUP': 'Create Group',
	    'CUSTOMIZE_GROUP': 'Customizing The Group',
	    'ADD_IMAGE': 'Add Image',
	    'UPLOAD_PHOTO': 'Upload Photo',
	    'SELECT_PHOTO': 'Select Photo',
	    'GROUP_ICON_TITLE': 'Group Icon',
	    'GROUP_ICON': 'Group Icon',
	    'GROUP_NAME': 'Group Name',
	    'ABOUT_GROUP': 'About This Group',
	    'ABOUT_GROUP_DETAIL': 'About This Group',
	    'PRIVACY_SETTINGS': 'Privacy Settings',
	    'PRIVATE_GROUP': 'Closed',
	    'PRIVATE_GROUP_DES': 'Only members can see.',
	    'PUBLIC_GROUP': 'Public',
	    'PUBLIC_GROUP_DES': 'Anyone can see the group.',
	    'TITLE_CANCEL': 'Cancel',
	    'TITLE_CREATE': 'Create',
	    'NO_DATA': 'No Data.',
	    'IN_PREPARE': 'Currently being prepared.',
	    'EDIT': {
	      'PAGE_TITLE': 'Group Edit',
	      'CHANGE_COVER': 'Change Image',
	      'CHANGE_ICON': 'Change Icon',
	      'TITLE_SAVE': 'Save'
	    },
	    'LIST': {
	      'PAGE_TITLE': "Group List",
	      'CREATE_GROUP': 'Create New group',
	      'SEARCH_GROUP': 'Searching group',
	      'LIST_GROUP': '参加グループ',
	      'PUBLIC_GROUP': 'Public',
	      'PRIVATE_GROUP': 'Closed',
	      'MEMBERS': 'Members',
	      'MEMBERS_EXT': '',
	      'EDIT_GROUP': 'Edit/Setting',
	      'COPY_GROUP': 'Copy the Invitation URL'
	    },
	    'TOOLBAR': {
	      'JOINED': 'Joined',
	      'LEAVE_GROUP': 'Leave Group',
	      'INFORMATION': 'Information',
	      'REQUEST': 'Request',
	      'IN_REQUEST': 'In request',
	      'INVITATION': 'Invitation',
	      'EDIT_MEMBER': 'Edit Member',
	      'NOT_ALLOWED_LEAVE_GROUP': 'You can not change because of the Group Administrator for absence.',
	      'CONFIRM_MESS_LEAVE_GROUP': 'Are you sure you want to leave this group?',
	      'REQUEST_MESS_JOIN_GROUP': 'Your request has been sent to the Group administrator.',
	      'COPY_MESS_URL': 'Copied the URL.'
	    },
	    'DETAIL_TABS': {
	      'TIMELINE': 'Timeline',
	      'EVENT': 'Event',
	      'RANKING': 'Ranking'
	    },
	    'SEARCH': {
	      'JOINED_GROUP_LIST': 'Joined group list',
	      'SEARCH_RESULTS': 'Search results',
	      'JOINED': 'Joined'
	    },
	    'CROP': {
	      'TITLE': 'Crop',
	      'CANCEL': 'Cancel',
	      'DONE': 'Done'
	    }
	  }
	};


/***/ }),
/* 843 */
/***/ (function(module, exports) {

	module.exports = {
	  '_GROUP': {
	    'TITLE': "グループ",
	    'PAGE_TITLE': "Group Registration",
	    'CREATE_GROUP': '新規グループ作成',
	    'CUSTOMIZE_GROUP': 'グループのカスタマイズ',
	    'ADD_IMAGE': 'ここのカバー写真を追加できます',
	    'UPLOAD_PHOTO': '写真をアップロード',
	    'SELECT_PHOTO': '写真を選択',
	    'GROUP_ICON_TITLE': 'グループ画像',
	    'GROUP_ICON': 'グループ画像を設定',
	    'GROUP_NAME': 'グループ名',
	    'ABOUT_GROUP': '説明',
	    'ABOUT_GROUP_DETAIL': 'グループの説明です',
	    'PRIVACY_SETTINGS': 'プライバシー設定を選択',
	    'PRIVATE_GROUP': '非公開グループ',
	    'PRIVATE_GROUP_DES': 'メンバーのみが閲覧できます。',
	    'PUBLIC_GROUP': '公開グループ',
	    'PUBLIC_GROUP_DES': '誰でもグループとそのメンバーを閲覧できます。',
	    'TITLE_CANCEL': 'キャンセル',
	    'TITLE_CREATE': '作成',
	    'NO_DATA': 'データがありません。',
	    'IN_PREPARE': '現在、準備中です。',
	    'EDIT': {
	      'PAGE_TITLE': "Group Edit",
	      'CHANGE_COVER': 'カバー写真を変更',
	      'CHANGE_ICON': 'グループ画像を変更',
	      'TITLE_SAVE': '保存'
	    },
	    'LIST': {
	      'PAGE_TITLE': "Group List",
	      'CREATE_GROUP': '新規グループ作成',
	      'SEARCH_GROUP': 'グループを検索',
	      'LIST_GROUP': '参加グループ',
	      'PUBLIC_GROUP': '公開',
	      'PRIVATE_GROUP': '非公開',
	      'MEMBERS': '参加人数',
	      'MEMBERS_EXT': '名',
	      'EDIT_GROUP': '編集・管理',
	      'COPY_GROUP': '招待URLをコピー'
	    },
	    'TOOLBAR': {
	      'JOINED': '参加済み',
	      'LEAVE_GROUP': 'このグループを退出する',
	      'INFORMATION': '情報',
	      'REQUEST': 'リクエスト',
	      'IN_REQUEST': 'リクエスト中',
	      'INVITATION': '招待',
	      'EDIT_MEMBER': 'メンバー編集',
	      'NOT_ALLOWED_LEAVE_GROUP': '管理者不在になるため、変更できません',
	      'CONFIRM_MESS_LEAVE_GROUP': 'グループを退出してよろしいですか？',
	      'REQUEST_MESS_JOIN_GROUP': 'リクエストがグループ管理者に送信されました。',
	      'COPY_MESS_URL': 'URLをコピーしました。'
	    },
	    'DETAIL_TABS': {
	      'TIMELINE': 'タイムライン',
	      'EVENT': 'イベント',
	      'RANKING': 'ランキング'
	    },
	    'SEARCH': {
	      'JOINED_GROUP_LIST': '参加グループ一覧',
	      'SEARCH_RESULTS': '検索結果',
	      'JOINED': '参加中'
	    },
	    'CROP': {
	      'TITLE': 'トリミング',
	      'CANCEL': 'キャンセル',
	      'DONE': '完了'
	    }
	  }
	};


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	var ProfileCtrl, ProfileService, modules;
	
	__webpack_require__(845);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	__webpack_require__(59);
	
	__webpack_require__(76);
	
	__webpack_require__(82);
	
	__webpack_require__(473);
	
	__webpack_require__(108);
	
	__webpack_require__(39);
	
	__webpack_require__(860);
	
	ProfileCtrl = __webpack_require__(862);
	
	ProfileService = __webpack_require__(863);
	
	modules = ['ngRoute', 'gnp-translation', 'gnp-auth', 'gnp-common-wrapper', 'gnp-analysis-charts', 'gnp-error-handler', 'gnp-analyze-access'];
	
	angular.module('gnp-app-profile', modules).config([
	  '$routeProvider', function($routeProvider) {
	    return $routeProvider.when('/profile/:user_id', {
	      templateUrl: 'web/profile/index.jade',
	      controller: 'ProfileCtrl',
	      title: '_PROFILE.TITLE',
	      resolve: {
	        userInfo: [
	          'AuthService', 'AccountService', function(AuthService, AccountService) {
	            if (AuthService.isSignedIn()) {
	              return AccountService.getUserInfo();
	            }
	          }
	        ]
	      },
	      permission: {
	        signInRequired: false
	      }
	    });
	  }
	]).config([
	  '$translateProvider', function($translateProvider) {
	    return $translateProvider.translations('en', __webpack_require__(864)).translations('ja', __webpack_require__(865));
	  }
	]).controller('ProfileCtrl', ProfileCtrl).factory('ProfileService', ProfileService);


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	var v1="<div id=\"profile-main\" gnp-common-wrapper-a=\"\"><div class=\"row no-margin\"><div class=\"col-12 col-sm-8 offset-sm-2 col-lg-4 offset-lg-4\"><div ng-if=\"isOwner\" class=\"page-title\"><img src=\"" + __webpack_require__(846) + "\"/><span>{{ :: getPageTitle() }}</span></div><div class=\"container profile-container\"><div class=\"row user-section no-margin\"><div class=\"col-5 col-sm-4 no-padding avatar-section\"><div class=\"avatarContainer avatar-for-{{user.user_id}}\"><img ng-src=\"{{::user.avatar_image_path}}\" class=\"rounded-circle profile-avatar avatar-image is-full\"/><span ng-if=\"isAvatarProfileColor()\" class=\"avatar-image-text\">{{:: getTextOfAvatarProfile() }}</span></div></div><div class=\"col-7 col-sm-8 user-info-section\"><div ng-if=\"user.public_nickname\" class=\"username\">{{ user.nickname }}</div><div ng-if=\"user.public_name\" class=\"fullname\">{{ displayUserName() }}</div><div ng-if=\"user.public_birthday\" class=\"row\"><div class=\"col-5 col-sm-4\"><div class=\"user-label\">{{ :: '_PROFILE.BIRTH_DATE' | translate }}</div></div><div class=\"col-7 col-sm-8 no-padding\"><div class=\"user-value\">{{ formatLongDate(user.birthday) }}</div></div></div><div ng-if=\"user.public_gender\" class=\"row\"><div class=\"col-5 col-sm-4\"><div class=\"user-label\">{{ :: '_PROFILE.GENDER' | translate }}</div></div><div class=\"col-7 col-sm-8 no-padding\"><div ng-if=\"user.gender\" class=\"user-value\">{{ ('_PROFILE.' + (user.gender | uppercase)) | translate }}</div></div></div><div ng-if=\"user.public_country_and_pref\" class=\"row\"><div class=\"col-5 col-sm-4\"><div class=\"user-label\">{{ :: '_PROFILE.COUNTRY' | translate }}</div></div><div class=\"col-7 col-sm-8 no-padding\"><div class=\"user-value\">{{ user.country_name + ' ' + user.prefecture_name }}</div></div></div></div></div><div ng-if=\"user.public_club_setting\" class=\"row score-section\"><div class=\"col-12 heading\"><img src=\"" + __webpack_require__(847) + "\" class=\"heading-icon\"/><span>{{ :: '_PROFILE.CLUB_SETTING' | translate }}</span></div><div class=\"col-12 margin-20\"><div class=\"clubset-name\">{{ user.clubset_name }}</div></div></div><div ng-if=\"user.public_user_ball &amp;&amp; user.ball_setting\" class=\"row score-section\"><div class=\"col-12 heading\"><img src=\"" + __webpack_require__(848) + "\" class=\"heading-icon\"/><span>{{ :: '_PROFILE.USE_BALL' | translate }}</span></div><div class=\"col-12 margin-20\"><div class=\"clubset-name\">{{ user.ball_setting.model }}</div></div></div><div ng-if=\"user.public_total_round || user.public_best_score || user.public_avg_score\" class=\"row score-section\"><div class=\"col-12 heading\"><img src=\"" + __webpack_require__(849) + "\" class=\"heading-icon\"/><span>{{ :: '_PROFILE.SCORE_THIS_YEAR' | translate }}</span></div><div class=\"col-12 margin-30\"><div class=\"row\"><div ng-if=\"user.public_total_round\" class=\"col-4 score-item\"><div class=\"score-wrap\"><img src=\"" + __webpack_require__(850) + "\"/><div class=\"score-label\">{{ :: '_PROFILE.RECENT_ROUNDS' | translate }}</div><div class=\"score-number\">{{ analysisData.cnt_score_cards_by_round_type }}</div></div></div><div ng-if=\"user.public_best_score\" class=\"col-4 score-item\"><div class=\"score-wrap\"><img src=\"" + __webpack_require__(851) + "\"/><div class=\"score-label\">{{ :: '_PROFILE.BEST_SCORE' | translate }}</div><div class=\"score-number\">{{ analysisData.best_score ? analysisData.best_score : '-' }}</div></div></div><div ng-if=\"user.public_avg_score\" class=\"col-4 score-item\"><div class=\"score-wrap\"><img src=\"" + __webpack_require__(852) + "\"/><div class=\"score-label\">{{ :: '_PROFILE.AVG_SCORE' | translate }}</div><div class=\"score-number\">{{ analysisData.avg_total_shot ? (analysisData.avg_total_shot | number:2) : '-' }}</div></div></div></div></div></div><div ng-if=\"user.public_lastest_round\" class=\"row top5-section\"><div class=\"col-12 heading\"><img src=\"" + __webpack_require__(853) + "\" class=\"heading-icon\"/><span>{{ :: '_PROFILE.LATEST_ROUNDS' | translate }}</span></div><div class=\"col-12\"><div ng-repeat=\"score_card in score_cards\" class=\"row score-card-item\"><div class=\"col-1 no-padding\"><img ng-if=\"$index == 0\" src=\"" + __webpack_require__(854) + "\"/><img ng-if=\"$index == 1\" src=\"" + __webpack_require__(855) + "\"/><img ng-if=\"$index == 2\" src=\"" + __webpack_require__(856) + "\"/><img ng-if=\"$index == 3\" src=\"" + __webpack_require__(857) + "\"/><img ng-if=\"$index == 4\" src=\"" + __webpack_require__(858) + "\"/></div><div class=\"col-9\"><div>{{ formatLongDate(score_card.play_date) }}</div><div class=\"ellipsis\">{{ score_card.club_name + ' ' + score_card.course_name }}</div></div><div class=\"col-2 text-right score\">{{ score_card.total_shot_all_holes }}</div><div class=\"clearfix\"></div></div></div></div><div ng-if=\"user.public_frequently_used_golf_course\" class=\"row top5-section\"><div class=\"col-12 heading\"><img src=\"" + __webpack_require__(853) + "\" class=\"heading-icon\"/><span>{{ :: '_PROFILE.TOP_5_HEADING' | translate }}</span></div><div class=\"col-12\"><div ng-repeat=\"course in courses\" class=\"row course-item\"><div class=\"col-1 no-padding\"><img ng-if=\"$index == 0\" src=\"" + __webpack_require__(854) + "\"/><img ng-if=\"$index == 1\" src=\"" + __webpack_require__(855) + "\"/><img ng-if=\"$index == 2\" src=\"" + __webpack_require__(856) + "\"/><img ng-if=\"$index == 3\" src=\"" + __webpack_require__(857) + "\"/><img ng-if=\"$index == 4\" src=\"" + __webpack_require__(858) + "\"/></div><div class=\"col-11\"><div class=\"ellipsis\">{{ course.club_name + ' ' + course.name }}</div></div><div class=\"clearfix\"></div></div></div></div><div ng-if=\"user.public_score_card\" class=\"row photos-section\"><div class=\"col-12 heading\"><img src=\"" + __webpack_require__(859) + "\" class=\"heading-icon\"/><span>{{ :: '_PROFILE.PHOTOS_HEADING' | translate }}</span></div><div class=\"col-12\"><div class=\"row photos-list\"><div ng-repeat=\"photo_score_card in photo_score_cards\" class=\"col-6\"><img ng-src=\" {{photo_score_card.thumb_photo_score_card_url}} \" class=\"photo-item\"/></div></div></div></div></div></div></div></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/profile/index.jade", v1)}]);
	module.exports=v1;

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAbCAMAAADIxWbRAAAAw1BMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////BhC2fAAAAQHRSTlMAAQQHCAwTFRYwODk6Oz5BQkZJSk5RUlNUVWZobG1zgIaLkpyio6SnsbK+x8rM1dbb3ODi5+jr8PH09fb6/P3+ZlR6pwAAASpJREFUOMuVlMVyAzEQRNscMzMz85ph3/9/VQ5eO1uJK1H6NBp1qboHJLngSzVHi4ONfViMmimf3iPeO+LGsRd/w0pM+Ylp4hsrOATgPu9U05FwJF3tzO8ADINuWtQCWNY/XLmP+hLAin6lSldgXfBICtQmO3s3qQUkeQpr4Fp60sp3oO2XpJLlKLNKkuRvA/ey4/MKl7wkqeHy0JAk5S9wjUtSyIJTTJKUBW6DYqw4uAFZSVLsBFZI0hDsjCTJu4L9Q3Z0DyuvJCljw1AKAy1HJ/AsWAJwdLWAsLqw9T8SfRi/ajCG/iPyb6GrM9ScqxlUXrwKzJywBmcBSee8gdyLl4ONEyYB4/dM9Zn6Na2fcT9M+2s8L1L51/kr/3uejffDeN/M9/eP/+ATrGhqfV8e47EAAAAASUVORK5CYII="

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAMAAACfvvDEAAACPVBMVEX///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9v7exRAAAAvnRSTlMAAQIDBAUGBwkKCwwODxAREhMUFRYXGBkbHB0eICEiJCUmKCkqLS4wMzU3ODk6Oz0+P0FCQ0VGR0hJSkxPUVVXWFlaW1xdX2JjZWdoaWtsbm9wcXJzdHV2d3h6fH1/gISFhoeIiouOj5CRkpSVl5iZmpucnaGipKWmqKqrrK2ur7GztLW4ubvAwcLFxsfJzM3Oz9DR0tPU1dbX2Nnb3N3e3+Dh4+Tl5ufo6err7O3u7/Dx8vP09fb3+Pr7/P3+O/lpqAAAAnZJREFUGBl9wYdDjHEAx+Hv3b0KaaKjbLKF7L2zs0chOzKy98rekb0ilD1zxqU+f5vfe3fq3q6351FT3tZJaR3SkhMstahb/rUgEZX7RnvlYuj5ehyqlrRVMzJLiVU9VTFm1hDy42Lx8oXL1x+rIOx4khw8W7EFD4+0FNG14CW2J10VxXsA26FMRbNmv8eo7q5GRRhvR6up5BMYVX79l4tR7lcz1mDcaKWw7gHgVqKatQyjUGEXgKp0udgO1PaRbSxQP0xurDLgrGyXgRK561sPZEnqA/xOVwsOAnskbQJK1JIs4Isl3QUGSj1XpsvNLWCwLOCDR1YlR+RmLbBYScBJqT9skJvhwD75gUIpB+bLTSpwURnAfCnlD8HHlX3V/skrv2IEoExdgKmSlmLkaR2MUoyP8FBdgJkyJpy6XtJOJ/hmKUYNlCsDyFODYsifN0ROPuCK2gPbJHl7e2QMqAN+xcmhB3BaCcA1SUcpkm3GN7jnlcMUYJM8AQgmqjMcV0jCoCFxctoPTJfOA7nKhly5iPsEdJLmADflh4rNxalS9tdzamIacFtSuxpgjI5grJIuU9tGDtYjYJGMIuBhfJtdv3nXX/rIOTktBj4nyOgYALZIvjSvpAd8mLUgQ416/QQKFLICY4rCVmBcUoPUp8CzeIX4bgDBiQrx7aiHXfov5SbwN1sRme+BujyF+Uf28yii52OM1WowMIBxppOcvAtqMPYqSs53jB8bO6iRb9IdbLu9ipb1Altt6dxeloyUcUWvsdUVeOSUeJiI4JtHz78SUZmjWCPKaSpQ2FbN8YwvrSVKRX6KXCVP3nm1+id8v39yWZYc/gFRx4KGN4RJ/gAAAABJRU5ErkJggg=="

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAA7CAYAAADSB2J6AAAFR0lEQVRoge2ZXYhexR2Hn7/Z2CYxprU1Nl+bmPoR+0E+WoVqWqRECoFCJf28ESFQUutFEalISS8KFbzz0i0lF9WCFqH1QlJSbG0MJkFI0hg1SaGJu9mYdE1IwOia7ebxYuY1b0/O2Z190+Vo8YHDe945M3N+v5k5/5kzBz5iqCvUf6k/Vvva1tMT6lYvsldd07amKaGu91IOtq2rGPVK9VCNie+1ra0Y9YEaAy+0rasYdb56tmJgXF3VtrZi1N/U9MJA27qKUVepFyoGzqjz29ZWjLq9phceaFtXMer3awwcUme2ra0IdZZ6tMbE+ra1FaP+ssbA1rZ1FaMuVs9VDIypK9rWVoz6+5peeKxtXcWot9cYGFE/1ba2ItQr1JdrTGxqW1sx6r01Bv6hzmhbWxHqXPVEjYk729ZWjPpojYFn2tZVjPp59b2KgVH1+ra1FaP+qaYXft22rmLUdTUGhtWr2tZWhNqnHqgxcU/b2opRf1pjYJcaU6nniukSOBnqV4FrgXOVSz+LCFuQNDXU5TkavaX+Sn0i98Lv2tZWTE00etW0m7GobW1FNEQj1QNtaysiR6NXGkxsbFtfEdZvgKnuUXsOMpErnw/8HFhLihidVeNbwHHgCLAf2Avsj4j/9GBgNbAT+ETN5a9HxI4pq8+Eem0WV/pQnQN2AS8ALwI7I+L8RAXUm4G/AgtrLj8VET+q5L8B+AawgNTQrwF/j4hTTTd4pKGLS3lH/bP6oLq6e1iYXnLuUU83lD2vLu3K/0V1W0Pe99QB9dNVD6G+Anypkv4k8BCwrOFYClxZ3+6cJfXsOeArwOca8gEMRMSmbOC7wBPAJyfIDzAE3BURh7pNjAF1X1zeBI7mY7Dr/GiuaB6XmvsCcMckIjqMATdExKB6B/A3oHRTbBBY0xleodZN8buAR4B+Uqv3Z5H9pHEKMJINvZGPo8AZUmuWMBARm0yfrF4Fbios12FLRGycyMQo6cF9g+R6KP8OAv/ORpZy0WD3+XJy1JuAceDGiDiibgB6eYMbB/oj4ngfaezOqWQYAbaTosltwIYs8LOAwIlsqGNyD/BsPt8CrJxEwJMRcSSff7sHA5CmgfXAb/tI88CNlQxXA4tJPbAr/w4Bp0gP6pKuox/4cv5dAkz2MiNpqHa4pUcTH5TtI7Vm1cRM0jL9VuDuLPA60jA5STJ0LP8eBp7vSruPNHE28YeIONz1f+5lmJjdMfEysK5y8QIpOu0GhrO4k6RWXpRNLc5HZ7gtIRmdaI9oDNhcSRuh99442THxDPBw5eJVwBrgm6TnYgkpfr9NMjVEGobDpJm4c/4m6Xl4ruGmj0XEPytpu0mzcy/shItrp+ez4A7ngV+QhtqxLO5d4DPZ0MJ8LCb1zIJ83hlydRwAbo2I0e5EdSWwrwcDI6ToNNoxcTMpwswuKHiC1Oqdlh8m9cRxUvfOyKLmdZUbBr4WEUN1lapPAT+YoomfRMTj1Yq+k9cyl8t45f8+ddlEatRr1MNTuMfTNm0mqHeZttH/F7ytblYnWwt17r1Qfamg3gG1ad32QWXXmb4b99Ir4+pu9X71mhLxlXvPMO2M7/C/e/Qd9Y/q2rpyjcsDdQHwQ+BbwGqg+t14hPTgHyTNFXuAHRFxdqriG+4/ixQ0RoGTETHWlLd4kypXOocUlk9P9iLUK+o8YBvwF1Ion0laHC6KiA3Tcc9pwUs/Oqo2zT3t7QBOQl0org3P8LGJaeVYYRrwsYlp5f/CxGBhGvDhNVFt9dMR8W5T5g+riSOk14EOr7cl5LJQ7zMtIofU2yfK+z5NsRElJ9WH0QAAAABJRU5ErkJggg=="

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAABfCAMAAAC5kuvHAAAB5lBMVEV0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR1dXV2dnZ3d3d5eXl8fHx+fn5/f3+BgYGDg4OEhISFhYWLi4uPj4+QkJCRkZGSkpKTk5OUlJSVlZWXl5ecnJyfn5+hoaGioqKkpKSlpaWmpqanp6epqamqqqqurq6vr6+wsLCzs7O4uLi6urq7u7u/v7/BwcHCwsLDw8PExMTFxcXKysrLy8vS0tLT09PW1tbZ2dna2trd3d3f39/h4eHj4+Pk5OTm5ubn5+fp6enq6urt7e3u7u7v7+/x8fHz8/P29vb39/f4+Pj6+vr7+/v8/Pz9/f3+/v7///81/EOSAAAAWHRSTlMAAQIDBQgJEhQZGhsgISMkKCktLjE6Oz9AT1BRUlN1dnd4eXp7fH2OkJGSk5SWmJmam52io6S0uLu8x8jKy8zQ0tPX2Nna4uTl5u3u7/Dx8vP09fb5+v3+7a19KAAABGpJREFUGBm1wYtDUmcYB+D34GXYhpU1skyTNB0zWDaj3CVzw0mkzbx0fpAWlWn3e1mZZvcyu6eVpfj+p+NyNPj40O/A2fOQEq20oqZx915/eyc62/17dzfWVJRqZJGyKl8QmYK+qjKN8qQ53f8gu4DbqVHuvqv6Cyv5u8pOufnB0w0V3R4HmVfi7YWqXm8JmVNc2wUzumqLyYQNfpjlLydVhfU6zNPrC0mJ4zfk5ncHKdjYgVx1bKQVuXTkTnfR8mwe5Mdjo2UUNCFfuwooK9uvyF+TjbLxwAoeysIFa7hIqlKHNfRKklhzEFY5uIYyFLXCOq1FJGqAlX4mQbkOK+kbKE1RG6zVVkSp6mC1OkqxqgtW61pF33hhPS8tcfTCen0OWtSA/8N2Mth7oCZ089X8/KubISjpsVNSFdSEn3DCkzCUVFOC5oeaUTaMQolfo7gfoebILBtmj0CJk+J+gpohXjIEJW6K0dqh5jwvOQ8lAY2IypBh4ProjQhEJ3jJCYgiN0avD0C0joiqIbo0y8xzIxBNsWEKopE5Zp69BEE1EfkgOBPlhMsQnPrKCV9PQXCZE6JnkM5HZAtCMMlJ7yE6O8MxM2ches9Jk0gX1Gg1RHNsiEB0n2PuQxRhwxwEpVQB0QIbjkM0yTGTEB1nwwIEFVQD0WtO+hSCIDTLMbMhCEKfOOk1BDW0A6IrnHQHomFOGIboDiddgaCR9iDDGMdFj0I0xgljEB2NctwYRM3UgkxDExwzAUF4hhNmwhBMcMzEEDK0UAAy75g5ehrprrLhKtKdjjLzO0jsp07IPOCY6QhS9X9gw4d+pIpMc8wDSHRSL2QuctzbY0jxmJc8QopjbznuIiT6CFIDUY6bHsai0DinGA9h0fA0x0UHIEO9kJrihOjDk0gYfM5png8i4eTDKCdMQaaPOiF1lw0LU+Mjt8ZfcoaX47dGxqcW2HAXMp0UgNQ5NukcZPZTC6TCX9iUL2HItNAeyD1jU55Bqpl2QO42m3IbUo1UA7lBNmUQUjVUgSw+sgkfIVdBq5HFYzbhMeRWky0IuWtswjVIBTUiH+QibEIEUj4iqkYWb1jZG8hVE1EZsrjHyu5Bbh0Rae2Qu8DKLkAqoFGMG3L986xovh9SbopzIosXrOgF5JwUp/khN8qKRiHl1yhhC+SGWdEwpKopyd4DqfBnVvI5DJkeOxkaIPeUlTyF1HZa5OiD9foctMQL63npm1WHYLVD31OKOlitjlIVtcFabUWUplyHlfRyEjTASg0kKm6FdVqLKcPag7DKv2tJolKHNfRKknLBGi7KwgMreCibgibkr6mAsirYhXztKqBl2DzIj8dGy9uqI3f6VlrRpg7kqmMTKXD8gdz86SAlhfU6zNPrC0lVuR9mtZWTCcW1XTCjq7aYzCnx9kJV3y8lZJ7D0w0V3R4H5ca+xY+V+LfYKXea0x1AdgG3U6M8aetdviAyBX2u9RpZQyvdvG1n877AgcM4fCCwr3nnts2lGqn4Dxvj2xnu+5ouAAAAAElFTkSuQmCC"

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAzCAYAAADciPtuAAADQElEQVRoge3ay4scVRTH8U+3yUAcR3GCiRoUTHAIJEFFRRQDShI0iJpgVqIr3QTc+A+4E/IHuHHhTndBE0F8gAsRjWjEVx4oKj4Q42MxmckImajHxelhOm2NUzXd1dMt/YWCrrrFuedX99apc+/pRkQYANZiK9ZjDqfwE65otTeqGlzTM9eqM4EDeBi7cFlb23mMdWO8UdOIXYo/Cq6vwR48hn2t+8pQecTqEvYRvsZxTONq3CRHZnIF9gZG2Ie4vYf2Kgtr9rDzduZqsluauoSdrcluaeoSdq4mu6UZTcWK/G+FzdRktzR1CZutyW5pRlOxIqsurK4kuOxUPIeP8Tm+w9/YhN24uRsH6kqpxvEUHsV2OTP+xI/4FO/hHXyCv5awMa2LZUtdwtoZk1n8jByRsnQlrB/rsfnW0VfqCh6rzkjYsDESNmyMhA0bI2HDxkjYsDESNmz0KrvfgM24HlfhGlwulx0LS48monUsLGFm8WvrOIOvcLoXDlUVdgm24U7cih2t84leOIOjsgrTyXaclA+lFGWETeIhPCCrJVeWNd5DvsDvctV9FK9abhs9IoqORkTsjYgjEXEh+seRNh+m/+O+8xHxSkTsjvT1XxqKRD0SESfq8nwZygpr50REPBgdOtqj4rV4C4flezMsbJNT8w1ZYMRiuN8hd4z29N+vnnGf3AG7gxS2CW/LkD3sbMRruK6JZ+W3p25O4Zs+9LMeh5rY34fOnpbvwo14bol7zuD1Jdoex0u4ULK/fSJivo7w1sHatog1VdD+WUSMd0S2L1tt023X7inZ33wTx6o8+hWyue33loL2SdzQcW0vnsTdrfN1uL9kf8caEXGvDB6Vt5ErcBqHpHPPyE9LEcfxAb6XW9zrZFC7BTtl/rkcgV0LQ3xwxZNs8DgYERcVJQ7ghZJPZRCZwRMywbgo8zgs/4H2ogpZ9AAQ0uetWqLyanESPBURz0fE7GrNpxLMRvo4FQUalquPTci/3e2XKct4fQ++FHN4Ey/L/HDJymmVwt+YXGDuxF24Tf0Zy28yUr6Pd+WnqVStrduK5kaZUWyxuDWwweLWwML2QBFn5Qs/g5/l9sAP+FamXifxy0od+wea15IhwX78aAAAAABJRU5ErkJggg=="

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAYAAAA6oTAqAAADuUlEQVRogd3abWgcRRzH8U8uUtSmtoKK9oVSiFaRYl7YIpK8SFXwaBWFCmpBfFdBDwRFJFRBFJ/wVXwCEc+iRDEvFHw4ETFVo2+EmkowGlNKUQQVS6sHLVoaX0zObq655HZ3kiX5wkJudv+zv192ZnfmP9NRLpdF4iL0YzMuxwach9XoRB1/4hAmsQ8jOBBLwBk549djJ+5EzwLXnjtzdOO6RPlBvIkh/JBHTClj3BXYI/yXn7WwkfnYgEfwPT7AtVkrSmtmHV7GOO6S/8km6cA2fIV3cXHaCtKY2Sa09XtSxmXhFkzg3jRB7YjqxHN4H+en15WZs/EC3sGadgIWMnMmhvGA0AyK4DZ8gQsXunA+M2cJT+PWSKLy0IO9FjDUykwn3sb1cTXlYiM+wdpWF7R6Gz2Fm/PevVwu6+3tnVU2OjqqVqtlrXIT3sJ2nGw+OZeZ7Xgw692gq6tLpVLR19d32rmxsbE8VUMZD+Hp5hPNzWwdXpOjs3d3dxscHJzTSEQeE4ZMs2h+Mk/K8fotl8sqlUrW8DSswkvYmixMPpkrsSvPHZr7xyLTj5uSBUkzu0X8stfrddVqNVZ1rdid/NEQvx47Yt1hamrKwMCA4eHhWFW2Ygv+75yNPrNTpEFjrVZTrVbV6/UY1bXD3fiS2WZyU61WTU1NxagqDTuEAenxkjBDvCpGrQUYgXNwDaHP9BehIDJbCWa2FCwkBpsJZi4tWEgMNhLMXFawkBhcglUlIR203ClhTUkYXK4EuhY7MbGUdJaETONK4O+SkDJdCdRL+LloFRH4FcdK+LFoJRGYJLzSvilYSAy+JZj5rGAhMRghmPlJyOYvV/7B55yaaQ4VpyU3H+EvTpl5ozgtudnT+KNhZsLy7DsHhAUqzM7GPLH0WnLzDE40fiTNjODDJZeTnQm8nixoHmhWcGyp1ORgWkhi/JssbDZzEA8vlaIcvGrm25JkrinA83hv0eVkZxz3z3Wio8WmhrVCYm3TIorKwh/C0vqcOa1Wk7OjuKFVUEEcxY3m0TTfTPM3Iac2EVlUFn4XcmP75rtooWnzL+gV1hKLYlxoWvMaob0ljMPC0tujEh+oJeIVIcHX1mahdhMaJ/E4rsbX2XSlYlLos7twvN2gtNmZ/UKzuwPfpYxth0O4T3iLfpo2OEuqaVrYI9AjNL8h+UYNJ4Rh/O1CqvhFYY6SmjwLTNP4eOboElawkpvnWu2mOCzkHRqb5/aKlCGKtcWqjtrM0WA1LhA+wCUcEYwciXTP0/gPdW6xO0MEIzYAAAAASUVORK5CYII="

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAMAAAANf8AYAAABqlBMVEVJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlVVVVhYWFtbW16enqGhoaSkpKenp6qqqq2trbCwsLOzs7b29vn5+fz8/P///9NiKylAAAAfnRSTlMAAQIDBAUGBwkKDg8QERITFRYYGhwfICIjJCUmJysyMzc5PD5CREZHSk5PUFNWV1hbXV9haW5yc3R9gYKGiImQkpOVl5qcnaCkpaeoqa2ur7GzuLm6u7y/wMHExsjKztHS1NXW19jZ29/g4eLj5ebo6u7v8PLz9/j5+vv8/f7WWvfeAAACI0lEQVQYGY3Bh0ITQRQF0AsqTQWJoIIFe6+I2MGKvSBgRRQFG4IiKqjJ3RgzCTH7/tkhgNmZnU04B24N67e0tcQqsESrD18anGTB9IueozGUU7nvzjQN8YH2apRQ2f6aDuOdNYiybYgRPhyA04quOKPdqENYwxOWNNoCW/MIy/jUBlPTGMuaakPQypdcgs8tKKropSU960s+m6JpuBb/naLJy8m8DE1Xsaj1Ow3eX1mkaNqFBQ9oykhRkoY31SjYSZMnc2YzedEyNHWg4CFNf0RTpJcXkRxN75ZD20yLEs0jmRGNloPQumhRolFTotFyH9oYLUo0ako0Wn6sAjbRllIaNSUabfuBDkbKikZbN3CZkfIikqPtMfCIUdKiKdomgPeM4PmiJRlSg2+MoETLMqwRjOD5IuInGbYBCbop0RQdmjFJp6QvIr5Hh3q8pVNWNEWHeBX66ZIUzffo8BHopktWNEWXfuAIHX6L5nt0OQPEEgzLiZam0w4AQwxJiZan01Q1gJMMyYmWptMVaLEZWlKi5em2HXN6aMmLlqbTUxS0/qIhLXPUApr2Yt4FGpQE0dCHBXUTDFISxKDpVizak2CAkiAGdaLoHAOUBDHgXgWKlt3kEgzWIqiqj2W9WgNT1S2W8awetsqzcZZyvRYOuycY6etxuNV1/6Tb7bWItPHaDEPivVtRUuOJ5wkGjZxeh/Jih87fHR6b/DI+OnDxWBPC/gFkvdlXaR08BgAAAABJRU5ErkJggg=="

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAMAAAANf8AYAAABrVBMVEVJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlVVVVhYWFtbW16enqGhoaSkpKenp6qqqq2trbCwsLOzs7b29vn5+fz8/P///+xwIRqAAAAf3RSTlMAAQIDBAUGBwgKCwwNDxARExQVFxkcHR4gJCUmKCkqLzAzNjc/QEFCREZKTE5QUVdZWltcXWBjZmdobG9wcnN0dnd4goOEhYeKjpKVl5iZm5yeoKOlqaqrrK25uru+w8bLzc/Q0tPU1dbf4eLj5OXm6Ovs7e/x8vP19vn6+/3+4lK0BgAAAjZJREFUGBmNwQkjVFEYBuDXjLRpXygqUqmUIpU2bVJp1UppUaG0CqnBvJcxB9f4fnPfjLGcM/cOz4Mga8pq6s43Npys3IhViVTf7RphVryn9cRarGD37a90DNzbjzx2PIwxQLyjDCEiFwcZIta8DkG2v2IeH8uRq+I78xqugevIEFcweha2qr9cUbwey+3rpy05Myep6QlaYtVYsr6XFs+XeYaWgVIsekyLNysLDC1vI8g6FKdlWpaM09KIeYW9tIxL2sxUStQ0Lb+3IqOetqQoQ3opEZmlrRlpkR7ajCiPpBFF2+BmqMN0GFFURhQdF6Da6DCiqIwoOt4BiA7SkTCKyoiiaxdwkKGMKLrOAFcZyoiiqw14xlC+iKTo+gC8Z7CE8UVN0fUH+MlgkjHrMUcx/jGYpE0zwE4whGQkmWsPRhnM9+dETTJHCfoZxkuJiM8cm9DNUFOi6IpF0M5QRhRd3UALQxlRdHUAxxnKiKLrClA8SocRRWVE0VUBoJMOI4rKiKKjLwKggQ4jisqIoqMFasMgbUbUJElfRFK0je1FWjNtCVFzycSMqBnaXiJj2xBtKVmSpGXsAOZdpm1SFvm03UdWYRdtRrJmPVp+bcGC8mHaEr6oOePRMnYMS07F6fASiQm6bmK5G1yFpwWw3OGKnkfhaIozvwdR5KgdYh4jlxCk9A1DfapEsILTfQw00FSEUEXnPjPHj2vFyK+q9QuX+dZ2NIpVKKm9/ujF6872J7fqyhDgP3qA48N3Wo69AAAAAElFTkSuQmCC"

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAYAAAA6oTAqAAAEQElEQVRogdXaa4iUVRzH8c9OV3UlCKUpw7KG7EXJDmV02YWKqNSoILY3XWChe2yUEERLr4ooozAiohJf+ULYCKIwwkhqjaxerFR0wcWCqIZKkYwW1KQXZ0afeZzbM8+ZWfvCwDznOc//nN+5/M91YNWqVXrAqShhEeajgFn8id3Y34tET4xkZxluwLVYiaWCgGb8imlsw1Z8FSMTecTMw50Yw+UYyPDtWdXfmurzN9iEN7G32wy1Kr1mzMPj+BFv4ArZhDTiIjyHn7BOaJ6ZySpmjVCK63BGNwm2YaFQUN/hHhnz12nk+Xgd7+G8LAl0ySKhyb2PxZ1+1ImYZdiB+7rLVy6uFxzFZZ1EbidmBT7DxTkzlYclgte7sV3EVmJK+FBv+kZW5uMdwfU3pZlrXiII6bi9NqJYLBofH68L27lzp8nJyW7MnYy3MYKvG0VoJOYEbMY53aSYpFwuK5fLdWHbt2/PY/I0wQldIswm6mjUzJ7GcJ4UawwNDR0TNj09ndfsUmxo9CItZkjw81FI18rMzIxKpRLD9C24LR2YFDOAV0War5XLZYODg3VhU1NTMUzXWI8FyYCkmFtxZayUetTEkpyNB5MBSTFPxkxpZGSk7rlSqZiZmYmZBKwV5oo4KubS6i8KxWJRsVisC4tcKzXOlOg7NTF3x0whXSuE8aVH3FX7UxA6/mhM66VS6ZiwyJ0/yXWqS4aCsJYotoyekXTN9FAIQcM1dX9i0ecmVuNqgpioM+JGTaxHnT/JCoKY5TGtpmsm4qjfiuWE0X5ZLIuNXHKtv4yOjhobG6t7t3r16lhJL8aCAk6PZbFRf+lDE6sxWBAWPlFI95cejfrNGCzgcCxr6ZrpY63AwQL2xbA0Ry45yf4Cfo9hqc+jfppDqmJ2xbDW51E/zW4cKuD7vJZKpdIxLrnPTewHwqC5I6+l9PKYvnf+HYRB82PBo3Wzid6UjRs3to2zZcsWMDExkVf8NoKAPfg8j6U55g98ydHa2DR3ecnNZsGbHRGzWTim+z9ypD3XtpX2Chtr4w2jt2FqaqrttGV4eFj6/HRiYgLs2tX16LAVR9xmco/sBeHY4pSsFiuVSttpfo/WOc8kH5Ie7GdB0P+Ft/BJMiDtjp8VRtPjnb/xaDowLWZWOEE+0I8c5eAB/JIOHGhyqWEtXux1jrpkA+5t9KLZqP8SXutZdrpnKx5u9rLVFGZcGH+OFz4VNvebdoFWYv7FHXglcqa64QPhgPafVpHaTS4P4xE8pjplmANexk2CB2tJpzPl9bgK3+bIVFZ+w82CC+6oILNM+79AGU/ooJRycFCojQvxbpYPs65hDuB5nCtMJaJshlSZFTzoBUJt/JXVQLcLsj14SrhmdbtQgt3U1gF8hPuFg6OHhJtNXZH3MHYWk9XfScIdl5XC3u/5wm7pQuFuwT7hBuBuYc0+Lbjblh4qC/8BcHj3gI4ddtoAAAAASUVORK5CYII="

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAMAAAANf8AYAAABm1BMVEVJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlVVVVhYWFtbW16enqGhoaSkpKenp6qqqq2trbCwsLOzs7b29vn5+fz8/P///+BpXjWAAAAeXRSTlMAAQIDBAUGCAkMDQ4PERITFBUXGRoeHyEiIyQmKSssLTIzNzg5Oz0+QUZITE5QUVVYW15fYWJkZWtxdHV4fH1+f4CBhYmLjpGWmpucn6KjpKautLe4u77Cw8bMzs/R0tTV1tzh5Obo6err7O3u7/Hy8/T19vn6+/z+HJX2dAAAAg9JREFUSMeV1llD00AUBeCTIihuqLiBG+7gVlBwwbVCUVEUXKhVcUHRoohiK82tjU01pvdn+0ApySxN5jzO7Zd0JsnMBRSxdvcmBy8m+7rXIVasY6lMnuopvEj3tUSJ7TdmScjHsT3NRMfYEimyPKFV1tA8aZK/3qb+W0+oSV7uU5CD76lpFk9J5PgCRWR5QCBHligyxXMh0p0LFr1gAuOF3gDZ8Cp0QQ4m9Kg618xdimdo2mrM345raKhOEjMkG3c14VJu64rpJ4XRLV5q5ZWZMTEL7QBwgkwMXQKAe2YmAyDxxczYO4HDZGZoABjWmbLj/FKZceCB2jg+M7OnUFkgqzb11EpS9Ssw19RwVS63I68xvldjZvblcidIbf4QlXz1AnahKA+6ruuWiKiqNrvwWf8kXLXZjDemptCCKVPzFhgxNVPAaVMzDGwqGpoeANPanyrNhwSAQTMzCgAbv6vMbyLyFMbeDwBIC8NlZuZaxakyM3vyqgHADvFGfuC9rgi36alvilcF46yRf0Lp/ure2/paqFQaRPjk5rc19vgDP8Qp/WVm9l2B2GcDh4m03lRynLI0mA4dWimKkUdW+HC8E00eS+f9bTuCTChahORiM/HziqVqKvZm9OTdUV3zcmFOLb5da9M3Sesvz8ri080tEe3byfFQE5ObPNMap+3r6r/18Onz7LPJkfOHVDP/D4AWtYw0YBeGAAAAAElFTkSuQmCC"

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAA0CAYAAAAqunDVAAAErUlEQVRogd2aTWgkRRTHfzPG1bCwZOKMG/HgEj/AiwgDfh0EYcT15CkBPejJiAcxB3GDIKIXHTzowcsKHlT8IItXD+scFMTTBlz8WoQMLCwxXyTiusTNuHkeXtX2m0r3pHume3bcPzRdVf2q6r2uf71XVd0lEWHIGAduBY4CVWAKqLnrNldmn3eAF4FP0nZQysGoG1zntUDBqRilp4DDffRxHjiWVjjJqCNGqaPom6uibzJUugqU+lA0C64AY2mFx4BHgFeB24mG/6ZCVOsNATaATWAVmATud888GzbTNFQSkRXUmCLwN6rgJrDmLq/0hrt8ehPYM3WfBj43+XuBc2k6HUNplBYdp8AasO4U+cMovR4o+k+GtkOEo1JNW3HMVa65/DJw2ikVKr0ObA+gZFZcCPLpHYyI/CoRFkWEEblKInLa6fWTiIynrVtGR8AjCxWLhgBPAHegDmMnbcUxuo2qJQk63IcGwvGMCg4LO8AHfk55HDQZv0Zd/yjjeEi/KhoT4jDB6BsEcCykH6hhaykqbwN/5a5SfzgCVHwmpB+kN+ot4P389BoI88B7PhPSD3St979GnFEHecCRR5kBliM98CbwHfBwDm1lhjfKLiTzoN/LwKPAD8DHFLdgjkUZNciOVh70O2TSzwK/o9ubQ/Hi+aLs7lkCcD84DDSBX4AnC2i/C94o68KL8H5+Z3wXuir5qoA+rsIbtWHKhuH9HiR55TIwhkU/jz3gJLrqvlJUJ/4ww9Kv6sr/zbmv74GXgB9zbncf4ugH+Y7WCvAM6uILNwji6QeDG9Vx97eBe4Av0E3fUBDn/WDwHfB5d38NuDRgW5lRFP32DhYpDkXR75rCGmXf7igdwGSGN0oYXqwqHGWTvi6NWjXprPSrAM8DHwEt4G5X/i3wKfAKen5nMQ0soiwR4AzQiGm7EcgtJshFMCebX5qT2nMxJ58T0o158+ysHIw/RaTq5CsispUgN2PanenRnpWbtw/yot/NQX4XXWZ1ApkbXfoE0enPAvA4OsIA75g6Pt0GZt3VjpHrgv2QZel3C9nWf48BzwEPoDSbdOUX0YP+s8Bn6McGiOjTRvdZPr2M0rIOLLk0wIfAKZeedgb5Zz2NiotVq6TDCrokSou6u7dNmU1Po0a10BfQQA0DmHH3FglIoh/oJ9Gi4D8JVUyZTftRWECNbQBb7qqjBs0mNZ7k/aDY8z//lutEbz5ujswRT7N6QjnQe6SKjFVNotHy7noukKmbsiY6T+9ER66COptY9DKqyG39Eurx/OTfRqmGydtYtODK2uyfW/sQGmW32EXSr44q3UQPZSbpdhRLgXzS3ItHEGBXTQy7KCKXRKQjIu9K7+Cb9frGtbHlgmhDRM64smUnUzd9LTqZOYmCtv2U2xV8w85+TojeIiLTORrV6NFPw8idTJDZEjX6wBUFwG8JA7qCBtK80KJ7TvmyWbrjzwtEbt3jlKsbUvQqwl9jTqBHwzWi/yIuoD9pdMgXLXoEUIMm0aojFUKj2sBTCbITWRq+lgjpd10g9Z9ZMTjO6IzeQzaT5X+/CYb7G0/fyEK/HQo8/84Ru1mMugy8gW4ARxW7wOv/AXnqvt/qcE//AAAAAElFTkSuQmCC"

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(861);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content);
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_profile.scss", function() {
			var newContent = require("!!/home/circleci/repo/node_modules/css-loader/index.js!/home/circleci/repo/node_modules/autoprefixer-loader/index.js?browsers=last 2 versions&cascade=false!/home/circleci/repo/node_modules/sass-loader/index.js?includePaths[]=/node_modules/compass-mixins/lib!/home/circleci/repo/ngapp/sass/web/html/_profile.scss");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	exports.push([module.id, ".span-1,.span-2,.span-3,.span-4,.span-5,.span-6,.span-7,.span-8,.span-9,.span-10,.span-11,.span-12{position:relative}.container,.no-padding{padding:0}.no-margin{margin:0}.margin-20{margin:20px 0}.mt-20{margin-top:20px}.mb-20{margin-bottom:20px}div.select-player-hdcp-title{padding:0 20px;position:relative;font-size:14px}.gnp-player-hdcp .input button{text-decoration:none;text-align:center;padding:0;width:25px;height:36px;background:0 0;border:none;font-size:14px}.gnp-player-hdcp .dots{font-size:14px}.gnp-player-hdcp .dropdown-menu.scrollable{min-width:45px;max-height:185px}.gnp-player-hdcp .dropdown-menu li a{padding:3px 10px}.placeholder{padding-left:8px!important}@media (max-width:767px){.history-row .row{margin-left:0;margin-right:0}.history-row .row .yyyymmdd{font-size:20px!important}.history-row .column-score3 .cell{width:116px}.history-row .column-score3 .cell .label{font-size:10px!important}.content-ranking .list-width .content-wrap{width:100%!important}.content-ranking .row{margin-left:0!important;margin-right:0!important}}#profile-main{background-color:#fff}#profile-main .page-title{text-align:center;margin:-4px -15px 0;background-color:#03584c;color:#fff;font-size:14px;position:fixed;width:inherit;z-index:99999;opacity:.8;padding:5px 0}#profile-main .page-title img{width:20px;margin-right:10px;margin-top:-5px}#profile-main .container.profile-container{width:100%;font-size:14px;margin-top:60px}#profile-main .container.profile-container .profile-avatar{margin-top:5px;width:100%;border:2px solid}#profile-main .container.profile-container .heading{background-color:#0fbca6;color:#fff;font-size:20px;margin:10px 0}#profile-main .container.profile-container .heading .heading-icon{width:20px;margin:-4px 10px 0 15px}#profile-main .container.profile-container .mb-20{margin-bottom:20px}#profile-main .container.profile-container .margin-30{margin:30px 0}#profile-main .container.profile-container .user-section .username{font-size:22px;word-break:break-all;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden}#profile-main .container.profile-container .user-section .fullname{font-weight:700;margin-bottom:5px;word-break:break-all;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden}#profile-main .container.profile-container .user-section .user-label{background-color:#747474;color:#fff;text-align:center;margin:3px 0;font-size:13px}#profile-main .container.profile-container .user-section .user-value{margin:3px 0}#profile-main .container.profile-container .user-section .btn-rakuten{margin:10px 0;display:block}#profile-main .container.profile-container .user-section .btn-rakuten img{width:120px}#profile-main .container.profile-container .user-section .avatarContainer .avatar-image-text.one-character{font-size:60px}#profile-main .container.profile-container .user-section .avatarContainer .avatar-image-text.two-characters{font-size:30px}#profile-main .container.profile-container .score-section img{width:30px;margin-top:-33px}#profile-main .container.profile-container .score-section .score-wrap{border:2px solid #747474;padding:5px;text-align:center}#profile-main .container.profile-container .score-section .score-wrap .score-label{font-weight:700;padding:5px;border-bottom:1px solid #747474;margin-top:-10px}#profile-main .container.profile-container .score-section .score-wrap .score-number{font-size:38px}#profile-main .container.profile-container .score-section .clubset-name{padding:0 15px}#profile-main .container.profile-container .top5-section img{width:20px;margin:-4px 10px 0 15px}#profile-main .container.profile-container .top5-section .course-item{margin-top:10px;margin-bottom:10px}#profile-main .container.profile-container .top5-section .score-card-item{margin-bottom:20px}#profile-main .container.profile-container .top5-section .score{padding-top:15px;font-size:16px}#profile-main .container.profile-container .see-more-wrap{padding:0 15px}#profile-main .container.profile-container .see-more-wrap .btn-see-more{border:1px solid #0fbca6;border-radius:10px;color:#0fbca6;background-color:#fff;width:100%;display:block;padding:5px;text-align:center}#profile-main .container.profile-container .see-more-wrap .btn-see-more img{float:right;width:15px;margin:5px}#profile-main .container.profile-container .photos-section .photo-item{width:100%;margin:15px 0}@media (max-width:414px){#profile-main .container.profile-container .page-title{font-size:22px}#profile-main .container.profile-container .score-section .score-item{padding:0 8px}#profile-main .container.profile-container .score-section .score-wrap .score-number{font-size:30px}}@media (max-width:375px){#profile-main .container.profile-container .score-section .score-item .score-label{font-size:13px}}@media (max-width:360px){#profile-main .container.profile-container .user-section .user-label{font-size:12px}#profile-main .container.profile-container .user-section .user-info-section{font-size:13px}#profile-main .container.profile-container .heading{font-size:18px}}@media (max-width:320px){#profile-main .container.profile-container .score-section .score-item{padding:0 5px}#profile-main .container.profile-container .score-section .score-item .score-label{padding:5px 0}#profile-main .container.profile-container .score-section .score-item .score-number{font-size:27px}#profile-main .container.profile-container .user-section .avatar-section{width:34%}#profile-main .container.profile-container .user-section .user-info-section{width:66%}#profile-main .container.profile-container .heading{font-size:16px}}@media (max-width:1024px){#profile-main #gnp-footer{margin-bottom:100px}}", ""]);

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	var $, IndexCtrl, _, moment;
	
	_ = __webpack_require__(87);
	
	$ = __webpack_require__(1);
	
	moment = __webpack_require__(126);
	
	IndexCtrl = function($scope, $routeParams, $filter, $translate, ProfileService, userInfo) {
	  var from, round_type, to;
	  $scope.user = void 0;
	  $scope.isOwner = ($routeParams.owner != null) && $routeParams.owner === 'true';
	  ProfileService.getSettingAccount($routeParams.user_id, $translate.preferredLanguage()).then(function(resp) {
	    $scope.user = resp.data;
	    return $scope.user.public_club_setting = false;
	  });
	  from = $routeParams.from != null ? $routeParams.from : moment().startOf('year').format('YYYY-MM-DD');
	  to = $routeParams.to != null ? $routeParams.to : moment().endOf('year').format('YYYY-MM-DD');
	  round_type = "1,0.5,1.5";
	  ProfileService.getScoreCardsAnalysis($routeParams.user_id, from, to, round_type).then(function(resp) {
	    return $scope.analysisData = resp.data;
	  });
	  ProfileService.getPhotoScoreCards($routeParams.user_id).then(function(resp) {
	    return $scope.photo_score_cards = resp.data.photo_score_cards;
	  });
	  ProfileService.getFrequentlyCourses($routeParams.user_id).then(function(resp) {
	    return $scope.courses = resp.data.courses;
	  });
	  ProfileService.getLatestRounds($routeParams.user_id).then(function(resp) {
	    return $scope.score_cards = resp.data.score_cards;
	  });
	  $scope.$watch($scope.analysisData, function() {
	    return setTimeout(function() {
	      return $(document).ready(function() {
	        var heights, maxHeight;
	        heights = $('.score-section .score-item .score-label').map(function() {
	          return $(this).height();
	        }).get();
	        maxHeight = Math.max.apply(null, heights);
	        return $('.score-section .score-item .score-label').height(maxHeight);
	      });
	    }, 3000);
	  }, true);
	  $scope.displayUserName = function() {
	    var firstName, lastName, ref, ref1, ref2, ref3;
	    firstName = (ref = (ref1 = $scope.user) != null ? ref1.first_name : void 0) != null ? ref : '';
	    lastName = (ref2 = (ref3 = $scope.user) != null ? ref3.last_name : void 0) != null ? ref2 : '';
	    if (firstName + lastName === '') {
	      return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED');
	    }
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      return lastName + " " + firstName;
	    }
	    return firstName + " " + lastName;
	  };
	  $scope.formatLongDate = function(date) {
	    if (/^ja/i.test($translate.preferredLanguage())) {
	      return moment(date).format("YYYY年MM月DD日");
	    } else {
	      return moment(date).format(moment.localeData().longDateFormat('LL'));
	    }
	  };
	  $scope.getPageTitle = function() {
	    if ($scope.isOwner) {
	      return $filter('translate')('_PROFILE.TITLE_PREVIEW');
	    }
	  };
	  $scope.getTextOfAvatarProfile = function() {
	    $(document).ready(function() {
	      var $avatarElement;
	      $avatarElement = $(".user-section .avatar-for-" + $scope.user.user_id + " .avatar-image-text");
	      if ($scope.user.display_text_avatar.length === 1) {
	        $avatarElement.removeClass('two-characters');
	        return $avatarElement.addClass('one-character');
	      } else {
	        $avatarElement.removeClass('one-character');
	        return $avatarElement.addClass('two-characters');
	      }
	    });
	    return $scope.user.display_text_avatar;
	  };
	  return $scope.isAvatarProfileColor = function() {
	    var ref, ref1;
	    return ((ref = $scope.user) != null ? (ref1 = ref.avatar_image_path) != null ? ref1.indexOf('avatar_color') : void 0 : void 0) > -1;
	  };
	};
	
	IndexCtrl.$inject = ['$scope', '$routeParams', '$filter', '$translate', 'ProfileService', 'userInfo'];
	
	module.exports = IndexCtrl;


/***/ }),
/* 863 */
/***/ (function(module, exports) {

	var ProfileService;
	
	ProfileService = function($http) {
	  return {
	    getSettingAccount: function(user_id, country_lang) {
	      if (country_lang == null) {
	        country_lang = 'en';
	      }
	      country_lang = /^ja/i.test(country_lang) || /^jp/i.test(country_lang) ? 'jp' : 'en';
	      return $http.get("/api/settings/account.json?user_id=" + user_id + "&country_lang=" + country_lang);
	    },
	    getScoreCardsAnalysis: function(user_id, from, to, round_type) {
	      return $http.get("api/users/" + user_id + "/score_cards/analysis.json?from=" + from + "&to=" + to + "&round_type=" + round_type);
	    },
	    getPhotoScoreCards: function(user_id, page_size) {
	      if (page_size == null) {
	        page_size = 4;
	      }
	      return $http.get("api/photo_score_cards.json?user_id=" + user_id + "&page_size=" + page_size + "&deleted=false&order=desc");
	    },
	    getFrequentlyCourses: function(user_id, page_size) {
	      if (page_size == null) {
	        page_size = 5;
	      }
	      return $http.get("api/courses/frequent.json?user_id=" + user_id + "&page_size=" + page_size);
	    },
	    getLatestRounds: function(user_id, page_size) {
	      if (page_size == null) {
	        page_size = 5;
	      }
	      return $http.get("api/score_cards.json?user_id=" + user_id + "&page_size=" + page_size);
	    }
	  };
	};
	
	ProfileService.$inject = ['$http'];
	
	module.exports = ProfileService;


/***/ }),
/* 864 */
/***/ (function(module, exports) {

	module.exports = {
	  '_PROFILE': {
	    'TITLE_PREVIEW': 'Profile public screen preview',
	    'TITLE': 'Profile',
	    'BIRTH_DATE': 'Birthday',
	    'GENDER': 'Gender',
	    'MALE': 'Male',
	    'FEMALE': 'Female',
	    'COUNTRY': 'Country',
	    'RECENT_ROUNDS': 'Total round count',
	    'BEST_SCORE': 'Best score',
	    'AVG_SCORE': 'Avg score',
	    'SCORE_THIS_YEAR': "This year's score",
	    'TOP_5_HEADING': 'Frequently used golf courses TOP 5',
	    'LATEST_ROUNDS': 'Recent round info',
	    'SEE_MORE': 'See more',
	    'PHOTOS_HEADING': 'Photo scorecard',
	    'CLUB_SETTING': 'Clubset',
	    'USE_BALL': 'Use ball'
	  }
	};


/***/ }),
/* 865 */
/***/ (function(module, exports) {

	module.exports = {
	  '_PROFILE': {
	    'TITLE_PREVIEW': 'プロフィール公開画面プレビュー',
	    'TITLE': 'プロフィール',
	    'BIRTH_DATE': '誕生日',
	    'GENDER': '性別',
	    'MALE': '男性',
	    'FEMALE': '女性',
	    'COUNTRY': 'お住まい',
	    'RECENT_ROUNDS': '総ラウンド数',
	    'BEST_SCORE': 'ベストスコア',
	    'AVG_SCORE': '平均スコア',
	    'SCORE_THIS_YEAR': '今年のスコア',
	    'TOP_5_HEADING': 'よく行くゴルフ場　TOP5',
	    'LATEST_ROUNDS': '最近のラウンド情報',
	    'SEE_MORE': 'もっと見る',
	    'PHOTOS_HEADING': 'フォトスコアカード',
	    'CLUB_SETTING': 'クラブセット',
	    'USE_BALL': '使用ボール'
	  }
	};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js